import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
const defaultOptions = {} as const;
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
  OCBase64Cursor: { input: string; output: string; }
  OCCountryCode2: { input: string; output: string; }
  OCDate: { input: string; output: string; }
  OCDateTime: { input: string; output: string; }
  /** A field whose value conforms to the standard internet email address format as specified in RFC822: https://www.w3.org/Protocols/rfc822/. */
  OCEmailAddress: { input: string; output: string; }
  OCJSON: { input: object | object[]; output: object | object[]; }
  OCLiquid: { input: string; output: string; }
  /** A field whose value conforms to the standard E.164 format as specified in: https://en.wikipedia.org/wiki/E.164. Basically this is +17895551234. */
  OCPhoneNumber: { input: string; output: string; }
  OCPromocode: { input: any; output: any; }
  OCReferralCode: { input: any; output: any; }
  OCTime: { input: string; output: string; }
  OCTimeZone: { input: string; output: string; }
  OCURL: { input: string; output: string; }
  OCUUID: { input: string; output: string; }
};

export enum Ach_Enrollment_Status {
  Active = 'ACTIVE',
  Expired = 'EXPIRED',
  Hold = 'HOLD',
  PendingEnrollment = 'PENDING_ENROLLMENT',
  Rejected = 'REJECTED',
  Suspended = 'SUSPENDED',
  WaitingApproval = 'WAITING_APPROVAL'
}

export enum Ach_Status {
  Active = 'ACTIVE',
  Expired = 'EXPIRED',
  Hold = 'HOLD',
  PendingEnrollment = 'PENDING_ENROLLMENT',
  Rejected = 'REJECTED',
  Suspended = 'SUSPENDED',
  WaitingApproval = 'WAITING_APPROVAL'
}

export enum Activate_Payment_Method {
  MobileApp = 'MOBILE_APP'
}

export enum Activate_Transaction_Delivery_Type {
  Curbside = 'CURBSIDE',
  Delivery = 'DELIVERY',
  Pickup = 'PICKUP'
}

export enum Activate_Transaction_Sort_By {
  CreatedAt = 'CREATED_AT'
}

export enum Activate_Transaction_Status {
  Cancelled = 'CANCELLED',
  Completed = 'COMPLETED',
  Migrated = 'MIGRATED',
  Redeemed = 'REDEEMED'
}

export enum Activity_Action {
  Received = 'RECEIVED',
  Sent = 'SENT'
}

export enum Activity_Type {
  Loyalty = 'LOYALTY',
  Mobile = 'MOBILE',
  Spmi = 'SPMI'
}

export enum Adjust_Points_Mathematical_Function {
  DecreasePointOperation = 'DECREASE_POINT_OPERATION',
  IncreasePointOperation = 'INCREASE_POINT_OPERATION'
}

export enum Aggregated_Audience_Operator {
  InAll = 'IN_ALL',
  InAny = 'IN_ANY'
}

export enum Allowed_List_Phone_Number_Time_Period {
  Custom = 'CUSTOM',
  Last_6Hours = 'LAST_6_HOURS',
  Last_24Hours = 'LAST_24_HOURS',
  LastHour = 'LAST_HOUR',
  Yesterday = 'YESTERDAY'
}

export enum Audience_Operator {
  IsEqualTo = 'IS_EQUAL_TO',
  IsGreaterThan = 'IS_GREATER_THAN',
  IsGreaterThanOrEqualTo = 'IS_GREATER_THAN_OR_EQUAL_TO',
  IsLessThan = 'IS_LESS_THAN',
  IsLessThanOrEqualTo = 'IS_LESS_THAN_OR_EQUAL_TO'
}

export enum Audience_Purchase_Time_Window {
  Last_7Days = 'LAST_7_DAYS',
  Last_14Days = 'LAST_14_DAYS',
  Last_30Days = 'LAST_30_DAYS',
  Last_60Days = 'LAST_60_DAYS',
  Last_90Days = 'LAST_90_DAYS'
}

export enum Audience_Status {
  Active = 'ACTIVE',
  Archived = 'ARCHIVED',
  Draft = 'DRAFT'
}

export enum Audience_Survey_Response_Operator {
  IsBetween = 'IS_BETWEEN',
  IsEqualTo = 'IS_EQUAL_TO',
  IsGreaterThan = 'IS_GREATER_THAN',
  IsGreaterThanOrEqualTo = 'IS_GREATER_THAN_OR_EQUAL_TO',
  IsIn = 'IS_IN',
  IsLessThan = 'IS_LESS_THAN',
  IsLessThanOrEqualTo = 'IS_LESS_THAN_OR_EQUAL_TO',
  IsNotEqualTo = 'IS_NOT_EQUAL_TO',
  IsNotIn = 'IS_NOT_IN'
}

export enum Auth_Challenge_Type {
  CustomChallenge = 'CUSTOM_CHALLENGE'
}

export enum Award_Per_Counting_Strategy {
  IndividualPurchase = 'INDIVIDUAL_PURCHASE',
  SellingUnitPurchase = 'SELLING_UNIT_PURCHASE',
  TotalPurchase = 'TOTAL_PURCHASE'
}

export enum Award_Points_Rounding_Strategy {
  Down = 'DOWN',
  HalfUp = 'HALF_UP'
}

export type AccessTokenByRefreshTokenInput = {
  accessToken: Scalars['String']['input'];
  refreshToken: Scalars['String']['input'];
};

export type AccessTokenByRefreshTokenInputType = {
  accessToken: Scalars['String']['input'];
  refreshToken: Scalars['String']['input'];
};

export type Ach = FeatureConfiguration & {
  __typename: 'Ach';
  enabled: Scalars['Boolean']['output'];
};

export type ActivateAddReward = {
  __typename: 'ActivateAddReward';
  fuelGradeReward?: Maybe<ActivateMetaFuelGradeReward>;
  loyaltyRewardId: Scalars['String']['output'];
  optionalRewardFlag?: Maybe<Scalars['Boolean']['output']>;
  rewardDiscountMethod: Conexxus_Loyalty_Discount_Method;
  rewardLimit?: Maybe<ActivateRewardLimit>;
  rewardPromptTextLong?: Maybe<Scalars['String']['output']>;
  rewardPromptTextShort?: Maybe<Scalars['String']['output']>;
  rewardReceiptDescLong?: Maybe<Scalars['String']['output']>;
  rewardReceiptDescShort?: Maybe<Scalars['String']['output']>;
  rewardTargetLineNumber: Scalars['Int']['output'];
  rewardValue: Scalars['Float']['output'];
};

export type ActivateAddRewardInput = {
  fuelGradeReward?: InputMaybe<ActivateMetaFuelGradeRewardInput>;
  loyaltyRewardId: Scalars['String']['input'];
  optionalRewardFlag?: InputMaybe<Scalars['Boolean']['input']>;
  rewardDiscountMethod: Conexxus_Loyalty_Discount_Method;
  rewardLimit?: InputMaybe<ActivateRewardLimitInput>;
  rewardPromptTextLong?: InputMaybe<Scalars['String']['input']>;
  rewardPromptTextShort?: InputMaybe<Scalars['String']['input']>;
  rewardReceiptDescLong?: InputMaybe<Scalars['String']['input']>;
  rewardReceiptDescShort?: InputMaybe<Scalars['String']['input']>;
  rewardTargetLineNumber: Scalars['Int']['input'];
  rewardValue: Scalars['Float']['input'];
};

export type ActivateCancelProcessedTransactionInput = {
  brandUuid: Scalars['ID']['input'];
  externalTransactionId?: InputMaybe<Scalars['String']['input']>;
  locationUuid?: InputMaybe<Scalars['ID']['input']>;
  loyaltySequenceId: Scalars['String']['input'];
  membershipId?: InputMaybe<Scalars['ID']['input']>;
  membershipPhone?: InputMaybe<Scalars['String']['input']>;
  siteId?: InputMaybe<Scalars['String']['input']>;
};

export type ActivateCancelRedemptionRequestInput = {
  brandUuid: Scalars['ID']['input'];
  containerUuid: Scalars['ID']['input'];
  locationUuid?: InputMaybe<Scalars['ID']['input']>;
  messageData: ActivateCancelRedemptionRequestMessageDataInput;
  messageType: Scalars['String']['input'];
  messageVersion?: InputMaybe<Scalars['String']['input']>;
  nodeId?: InputMaybe<Scalars['ID']['input']>;
  qosDetails: QosDetailsInput;
  siteId?: InputMaybe<Scalars['String']['input']>;
  typename: Scalars['String']['input'];
};

export type ActivateCancelRedemptionRequestMessageDataInput = {
  loyaltyRewardId: Array<Scalars['String']['input']>;
  loyaltySequenceId: Scalars['String']['input'];
  posSequenceId?: InputMaybe<Scalars['String']['input']>;
  storeLocationId: Scalars['String']['input'];
};

export type ActivateCancelTransactionRequestContainerInput = {
  brandUuid: Scalars['ID']['input'];
  containerUuid: Scalars['ID']['input'];
  locationUuid?: InputMaybe<Scalars['ID']['input']>;
  messageData: ActivateCancelTransactionRequestInput;
  messageType: Scalars['String']['input'];
  messageVersion?: InputMaybe<Scalars['String']['input']>;
  nodeId?: InputMaybe<Scalars['ID']['input']>;
  qosDetails: QosDetailsInput;
  siteId?: InputMaybe<Scalars['String']['input']>;
  typename: Scalars['String']['input'];
};

export type ActivateCancelTransactionRequestInput = {
  loyaltySequenceId: Scalars['String']['input'];
  posSequenceId: Scalars['String']['input'];
  /** @deprecated Replaced by siteId. */
  storeLocationId?: InputMaybe<Scalars['String']['input']>;
};

export type ActivateFinalizeRewardsRequestContainerInput = {
  brandUuid: Scalars['ID']['input'];
  containerUuid: Scalars['ID']['input'];
  locationUuid?: InputMaybe<Scalars['ID']['input']>;
  messageData: ActivateFinalizeRewardsRequestInput;
  messageType: Scalars['String']['input'];
  messageVersion?: InputMaybe<Scalars['String']['input']>;
  nodeId?: InputMaybe<Scalars['String']['input']>;
  qosDetails: QosDetailsInput;
  rawConexxusMessage?: InputMaybe<Scalars['OCJSON']['input']>;
  siteId?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<Activate_Transaction_Status>;
  typename: Scalars['String']['input'];
};

export type ActivateFinalizeRewardsRequestInput = {
  createMembershipIfDoesNotExist?: InputMaybe<Scalars['Boolean']['input']>;
  fuelPositionId?: InputMaybe<Scalars['Int']['input']>;
  kioskId?: InputMaybe<Scalars['Int']['input']>;
  loyaltyEntryMethod?: InputMaybe<Scalars['String']['input']>;
  loyaltySequenceId: Scalars['String']['input'];
  membershipPhone?: InputMaybe<Scalars['String']['input']>;
  membershipState?: InputMaybe<Membership_State>;
  membershipUuid?: InputMaybe<Scalars['ID']['input']>;
  orderAheadInfo?: InputMaybe<OrderAheadInfoInput>;
  outsideSalesFlag?: InputMaybe<Scalars['Boolean']['input']>;
  paymentInfos?: InputMaybe<Array<InputMaybe<ActivatePaymentInfoInput>>>;
  posTransactionId: Scalars['String']['input'];
  registerId?: InputMaybe<Scalars['Int']['input']>;
  reservationId?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Replaced by siteId. */
  storeLocationId?: InputMaybe<Scalars['String']['input']>;
  totalExternallyAppliedStoredValue?: InputMaybe<Scalars['Int']['input']>;
  totalTax?: InputMaybe<Scalars['Float']['input']>;
  totalTransactionAmount?: InputMaybe<Scalars['Float']['input']>;
  transactionLineItems: Array<ActivateFinalizeTransactionLineItemInput>;
  transactionTime: Scalars['String']['input'];
  vendorModelVersion?: InputMaybe<Scalars['String']['input']>;
  vendorName?: InputMaybe<Scalars['String']['input']>;
};

export type ActivateFinalizeTransactionLineItemInput = {
  actualSalesPrice?: InputMaybe<Scalars['Float']['input']>;
  allPromotions?: InputMaybe<Array<ActivateLineItemPromotionInput>>;
  description?: InputMaybe<Scalars['String']['input']>;
  entryMethod?: InputMaybe<Scalars['String']['input']>;
  fuelGradeId?: InputMaybe<Scalars['String']['input']>;
  group?: InputMaybe<Scalars['String']['input']>;
  isPrepaid?: InputMaybe<Scalars['Boolean']['input']>;
  lineNumber: Scalars['Int']['input'];
  merchandiseCode?: InputMaybe<Scalars['String']['input']>;
  paymentSystemsProductCode?: InputMaybe<Scalars['String']['input']>;
  posCode?: InputMaybe<Scalars['String']['input']>;
  promotion: Array<ActivateLineItemPromotionInput>;
  regularSellPrice?: InputMaybe<Scalars['Float']['input']>;
  salesAmount: Scalars['Float']['input'];
  salesQuantity: Scalars['Float']['input'];
  sellingUnits?: InputMaybe<Scalars['Int']['input']>;
  sku?: InputMaybe<Scalars['String']['input']>;
  upc?: InputMaybe<Scalars['String']['input']>;
};

export type ActivateFuelPriceDataInput = {
  fuelGradeId?: InputMaybe<Scalars['String']['input']>;
  priceTierCode?: InputMaybe<Scalars['Int']['input']>;
  regularSellPrice: Scalars['Float']['input'];
};

export type ActivateGetRewardsRequestContainerInput = {
  brandUuid: Scalars['ID']['input'];
  containerUuid: Scalars['ID']['input'];
  locationUuid?: InputMaybe<Scalars['ID']['input']>;
  messageData: ActivateGetRewardsRequestInput;
  messageType: Scalars['String']['input'];
  messageVersion?: InputMaybe<Scalars['String']['input']>;
  nodeId?: InputMaybe<Scalars['String']['input']>;
  qosDetails: QosDetailsInput;
  siteId?: InputMaybe<Scalars['String']['input']>;
  typename: Scalars['String']['input'];
  vendorName?: InputMaybe<Scalars['String']['input']>;
};

export type ActivateGetRewardsRequestInput = {
  createMembershipIfDoesNotExist?: InputMaybe<Scalars['Boolean']['input']>;
  fuelPriceData: Array<ActivateFuelPriceDataInput>;
  loyaltySequenceId: Scalars['String']['input'];
  membershipPhone: Scalars['String']['input'];
  membershipState?: InputMaybe<Membership_State>;
  membershipUuid?: InputMaybe<Scalars['ID']['input']>;
  posTransactionId: Scalars['String']['input'];
  requestUuid?: InputMaybe<Scalars['ID']['input']>;
  reservationId?: InputMaybe<Scalars['String']['input']>;
  source?: InputMaybe<Sign_Up_Origin>;
  /** @deprecated Replaced by siteId. */
  storeLocationId?: InputMaybe<Scalars['String']['input']>;
  transactionLineItems: Array<ActivateTransactionLineItemInput>;
  transactionTime: Scalars['String']['input'];
  useStoredValue?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ActivateGetRewardsResponse = {
  __typename: 'ActivateGetRewardsResponse';
  addRewards?: Maybe<Array<ActivateAddReward>>;
  allowMultipleTransactionDiscounts?: Maybe<Scalars['Boolean']['output']>;
  customerUuid?: Maybe<Scalars['ID']['output']>;
  expectedPromptResponseType?: Maybe<Expected_Prompt_Response_Type>;
  isValidLoyaltyId?: Maybe<Scalars['Boolean']['output']>;
  loyaltySequenceId: Scalars['String']['output'];
  memberPrompt?: Maybe<Scalars['String']['output']>;
  membership?: Maybe<ActivateRewardsMembership>;
  membershipPhoneNumber?: Maybe<Scalars['OCPhoneNumber']['output']>;
  membershipUuid?: Maybe<Scalars['ID']['output']>;
  metaPrepayFuelRewards?: Maybe<ActivateMetaPrepayFuelRewards>;
  posTransactionId: Scalars['String']['output'];
  prepayFuelRewards?: Maybe<Array<ActivateAddReward>>;
  requestUuid?: Maybe<Scalars['ID']['output']>;
  storeLocationId: Scalars['ID']['output'];
  storedValueBalance: Scalars['Int']['output'];
  validationResult?: Maybe<Get_Reward_Request_Validation_Result>;
};

export type ActivateGetRewardsResponseContainer = {
  __typename: 'ActivateGetRewardsResponseContainer';
  containerUuid: Scalars['ID']['output'];
  messageData?: Maybe<ActivateGetRewardsResponse>;
  messageType: Scalars['String']['output'];
  messageVersion?: Maybe<Scalars['String']['output']>;
  nodeId?: Maybe<Scalars['String']['output']>;
  qosDetails: QosDetails;
  typename: Scalars['String']['output'];
};

export type ActivateLineItemPromotion = {
  __typename: 'ActivateLineItemPromotion';
  offer?: Maybe<Offer>;
  promotionAmount: Scalars['Float']['output'];
  promotionReason: Scalars['String']['output'];
  promotionTitle: Scalars['String']['output'];
};

export type ActivateLineItemPromotionInput = {
  loyaltyRewardId: Scalars['String']['input'];
  promotionAmount: Scalars['Float']['input'];
  promotionReason?: InputMaybe<Scalars['String']['input']>;
};

export type ActivateLocation = {
  __typename: 'ActivateLocation';
  address1?: Maybe<Scalars['String']['output']>;
  address2?: Maybe<Scalars['String']['output']>;
  city?: Maybe<Scalars['String']['output']>;
  countryCode?: Maybe<Scalars['OCCountryCode2']['output']>;
  id: Scalars['ID']['output'];
  lat?: Maybe<Scalars['Float']['output']>;
  lon?: Maybe<Scalars['Float']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  phone?: Maybe<Scalars['OCPhoneNumber']['output']>;
  state?: Maybe<Scalars['String']['output']>;
  zipcode?: Maybe<Scalars['String']['output']>;
};

export type ActivateMetaFuelGradeReward = {
  __typename: 'ActivateMetaFuelGradeReward';
  fuelGradeId: Scalars['String']['output'];
  rewardValue: Scalars['Float']['output'];
};

export type ActivateMetaFuelGradeRewardInput = {
  fuelGradeId: Scalars['String']['input'];
  rewardValue: Scalars['Float']['input'];
};

export type ActivateMetaPrepayFuelRewards = {
  __typename: 'ActivateMetaPrepayFuelRewards';
  discountMethod: Conexxus_Loyalty_Discount_Method;
  fuelGradeReward?: Maybe<Array<ActivateMetaFuelGradeReward>>;
  loyaltyRewardId: Scalars['String']['output'];
  optionalRewardFlag?: Maybe<Scalars['Boolean']['output']>;
  rewardLimit?: Maybe<Scalars['Int']['output']>;
  rewardPromptTextLong?: Maybe<Scalars['String']['output']>;
  rewardPromptTextShort?: Maybe<Scalars['String']['output']>;
  rewardReceiptDescLong?: Maybe<Scalars['String']['output']>;
  rewardReceiptDescShort?: Maybe<Scalars['String']['output']>;
};

export type ActivatePaymentInfo = {
  __typename: 'ActivatePaymentInfo';
  amountCharged?: Maybe<Scalars['Float']['output']>;
  isoPrefix?: Maybe<Scalars['String']['output']>;
  tenderSubtype?: Maybe<Scalars['String']['output']>;
  tenderType?: Maybe<Scalars['String']['output']>;
};

export type ActivatePaymentInfoInput = {
  amountCharged?: InputMaybe<Scalars['Float']['input']>;
  entryMethod?: InputMaybe<Scalars['String']['input']>;
  isoPrefix?: InputMaybe<Scalars['String']['input']>;
  tenderSubtype?: InputMaybe<Scalars['String']['input']>;
  tenderType?: InputMaybe<Scalars['String']['input']>;
};

export type ActivateRewardLimit = {
  __typename: 'ActivateRewardLimit';
  type?: Maybe<Conexxus_Loyalty_Reward_Limit_Type>;
  value?: Maybe<Scalars['Float']['output']>;
};

export type ActivateRewardLimitInput = {
  type?: InputMaybe<Conexxus_Loyalty_Reward_Limit_Type>;
  value?: InputMaybe<Scalars['Float']['input']>;
};

export type ActivateRewardsMembership = {
  __typename: 'ActivateRewardsMembership';
  firstName?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  lastName?: Maybe<Scalars['String']['output']>;
  memberState?: Maybe<Membership_State>;
  pointsBalance?: Maybe<Scalars['Int']['output']>;
};

export type ActivateTransaction = {
  __typename: 'ActivateTransaction';
  chain: Chain;
  createdAt: Scalars['OCDateTime']['output'];
  customData?: Maybe<Scalars['OCJSON']['output']>;
  externalTransactionId?: Maybe<Scalars['String']['output']>;
  fuelPositionId?: Maybe<Scalars['Int']['output']>;
  fulfilledOffers: Array<Offer>;
  id: Scalars['ID']['output'];
  kioskId?: Maybe<Scalars['Int']['output']>;
  lineItems: Array<ActivateTransactionLineItem>;
  location?: Maybe<ActivateLocation>;
  loyaltySequenceId?: Maybe<Scalars['ID']['output']>;
  membership: Membership;
  moneyCurrencyCode?: Maybe<Scalars['String']['output']>;
  offerFulfillments?: Maybe<Array<RuleFulfillment>>;
  outsideSalesFlag?: Maybe<Scalars['Boolean']['output']>;
  partnerId?: Maybe<Scalars['String']['output']>;
  payload?: Maybe<Scalars['OCJSON']['output']>;
  paymentInfos?: Maybe<Array<ActivatePaymentInfo>>;
  /** @deprecated Use pointTransactions for earned, refunded, and spent points associated with this transaction. */
  pointChanges?: Maybe<Array<PointChange>>;
  pointTransactions?: Maybe<Array<PointChange>>;
  processedAt?: Maybe<Scalars['OCDateTime']['output']>;
  registerId?: Maybe<Scalars['Int']['output']>;
  requestId: Scalars['String']['output'];
  status?: Maybe<Activate_Transaction_Status>;
  subtotalAmount?: Maybe<Scalars['Float']['output']>;
  totalAmount?: Maybe<Scalars['Float']['output']>;
  totalAmountWithoutDiscounts?: Maybe<Scalars['Float']['output']>;
  totalDiscountAmount?: Maybe<Scalars['Float']['output']>;
  totalGallons?: Maybe<Scalars['Float']['output']>;
  totalPointsEarned: Scalars['Int']['output'];
  totalPointsRefunded: Scalars['Int']['output'];
  totalPointsSpent: Scalars['Int']['output'];
  totalTax?: Maybe<Scalars['Float']['output']>;
  transactionTimeAt?: Maybe<Scalars['OCDateTime']['output']>;
  vendorModelVersion?: Maybe<Scalars['String']['output']>;
  vendorName?: Maybe<Scalars['String']['output']>;
};

export type ActivateTransactionConnection = {
  __typename: 'ActivateTransactionConnection';
  edges: Array<ActivateTransactionEdge>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type ActivateTransactionCreateInput = {
  customerUuid?: InputMaybe<Scalars['ID']['input']>;
  externalLocationId?: InputMaybe<Scalars['ID']['input']>;
  fulfilledOfferIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  lineItems?: InputMaybe<Array<ActivateTransactionLineItemCreateInput>>;
  /** @deprecated Replaced by externalLocationId. */
  locationId?: InputMaybe<Scalars['ID']['input']>;
  membershipId?: InputMaybe<Scalars['ID']['input']>;
  moneyCurrencyCode?: InputMaybe<Scalars['String']['input']>;
  partnerId?: InputMaybe<Scalars['String']['input']>;
  requestId?: InputMaybe<Scalars['String']['input']>;
  transactionTimeAt?: InputMaybe<Scalars['OCDateTime']['input']>;
};

export type ActivateTransactionEdge = {
  __typename: 'ActivateTransactionEdge';
  cursor: Scalars['ID']['output'];
  node: ActivateTransaction;
};

export type ActivateTransactionFilter = {
  idEquals?: InputMaybe<Scalars['ID']['input']>;
  loyaltySequenceIdEquals?: InputMaybe<Scalars['ID']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  transactionCreatedAtMax?: InputMaybe<Scalars['OCDateTime']['input']>;
  transactionCreatedAtMin?: InputMaybe<Scalars['OCDateTime']['input']>;
  transactionStatusEquals?: InputMaybe<Activate_Transaction_Status>;
  transactionTimeAtMax?: InputMaybe<Scalars['OCDateTime']['input']>;
  transactionTimeAtMin?: InputMaybe<Scalars['OCDateTime']['input']>;
};

export type ActivateTransactionLineItem = {
  __typename: 'ActivateTransactionLineItem';
  actualSalesPrice?: Maybe<Scalars['Float']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  externalLineItemPromotions?: Maybe<Array<ExternalLineItemPromotion>>;
  externalPromotionData?: Maybe<Scalars['OCJSON']['output']>;
  fuelGradeId?: Maybe<Scalars['String']['output']>;
  group?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  lineItemNumber?: Maybe<Scalars['Int']['output']>;
  merchandiseCode?: Maybe<Scalars['String']['output']>;
  moneyAmount?: Maybe<Scalars['Float']['output']>;
  moneyAmountWithoutDiscounts?: Maybe<Scalars['Float']['output']>;
  promotionData?: Maybe<Scalars['OCJSON']['output']>;
  promotions?: Maybe<Array<ActivateLineItemPromotion>>;
  quantity?: Maybe<Scalars['Float']['output']>;
  regularSellPrice?: Maybe<Scalars['Float']['output']>;
  sku?: Maybe<Scalars['String']['output']>;
  upc?: Maybe<Scalars['String']['output']>;
};

export type ActivateTransactionLineItemCreateInput = {
  fuelGradeId?: InputMaybe<Scalars['String']['input']>;
  group?: InputMaybe<Scalars['String']['input']>;
  moneyAmount?: InputMaybe<Scalars['Float']['input']>;
  quantity?: InputMaybe<Scalars['Float']['input']>;
  sku?: InputMaybe<Scalars['String']['input']>;
  upc?: InputMaybe<Scalars['String']['input']>;
};

export type ActivateTransactionLineItemInput = {
  fuelGradeId?: InputMaybe<Scalars['String']['input']>;
  group?: InputMaybe<Scalars['String']['input']>;
  isPrepaid?: InputMaybe<Scalars['Boolean']['input']>;
  lineNumber: Scalars['Int']['input'];
  posCode?: InputMaybe<Scalars['String']['input']>;
  salesAmount: Scalars['Float']['input'];
  salesQuantity: Scalars['Float']['input'];
  sellingUnits?: InputMaybe<Scalars['Int']['input']>;
  sku?: InputMaybe<Scalars['String']['input']>;
  upc?: InputMaybe<Scalars['String']['input']>;
};

export type ActivateTransactionSort = {
  direction: Sort_Order;
  field: Activate_Transaction_Sort_By;
};

export type ActivateUser = {
  __typename: 'ActivateUser';
  email: Scalars['OCEmailAddress']['output'];
  id: Scalars['ID']['output'];
  name?: Maybe<Scalars['String']['output']>;
};

export type Activity = {
  __typename: 'Activity';
  action: Activity_Action;
  activityType: Activity_Type;
  createdAt: Scalars['OCDateTime']['output'];
  description: Scalars['String']['output'];
  rawMessage: Scalars['String']['output'];
};

export type ActivityFeedConnection = {
  __typename: 'ActivityFeedConnection';
  edges: Array<ActivityFeedEdge>;
  pageInfo: PageInfo;
};

export type ActivityFeedEdge = {
  __typename: 'ActivityFeedEdge';
  cursor: Scalars['OCBase64Cursor']['output'];
  node: ActivityFeedEvent;
};

export type ActivityFeedEvent = {
  __typename: 'ActivityFeedEvent';
  event: ActivityType;
  id: Scalars['ID']['output'];
  uuid: Scalars['OCUUID']['output'];
};

export type ActivityFeedFilter = {
  customerUuid: Scalars['OCUUID']['input'];
  includeLoyaltyTransactions: Scalars['Boolean']['input'];
  includeMobileTransactions: Scalars['Boolean']['input'];
  includePointChanges: Scalars['Boolean']['input'];
};

export type ActivityLogFilter = {
  activityContains?: InputMaybe<Scalars['String']['input']>;
  activityType: Activity_Type;
  excludeHeartbeats?: InputMaybe<Scalars['Boolean']['input']>;
  excludeSiteDataRequestsAndResponses?: InputMaybe<Scalars['Boolean']['input']>;
  locationId: Scalars['ID']['input'];
};

export type ActivityType = ActivateTransaction | CombinedTransaction | PointChange | Transaction;

export type AddLocationsToGroupInput = {
  locationGroupUuid: Scalars['ID']['input'];
  locationUuids: Array<Scalars['ID']['input']>;
};

export type Address = {
  __typename: 'Address';
  alias?: Maybe<Scalars['String']['output']>;
  city: Scalars['String']['output'];
  countryCode: Scalars['OCCountryCode2']['output'];
  geoLocation?: Maybe<GeoLocation>;
  state: Scalars['String']['output'];
  street1: Scalars['String']['output'];
  street2?: Maybe<Scalars['String']['output']>;
  uuid: Scalars['ID']['output'];
  zipCode: Scalars['String']['output'];
};

export type AddressInput = {
  alias?: InputMaybe<Scalars['String']['input']>;
  city: Scalars['String']['input'];
  countryCode?: InputMaybe<Scalars['OCCountryCode2']['input']>;
  geoLocation?: InputMaybe<GeoLocationInput>;
  state: Scalars['String']['input'];
  street1: Scalars['String']['input'];
  street2?: InputMaybe<Scalars['String']['input']>;
  uuid?: InputMaybe<Scalars['ID']['input']>;
  zipCode: Scalars['String']['input'];
};

export type AgeVerifyAndEaivResetResult = {
  __typename: 'AgeVerifyAndEaivResetResult';
  ageVerify?: Maybe<Scalars['Boolean']['output']>;
  eaiv?: Maybe<Scalars['Boolean']['output']>;
};

export type AllowListPhoneNumber = {
  __typename: 'AllowListPhoneNumber';
  createdAt: Scalars['OCDateTime']['output'];
  name: Scalars['String']['output'];
  phoneNumber: Scalars['OCPhoneNumber']['output'];
  reason: Scalars['String']['output'];
  updatedAt: Scalars['OCDateTime']['output'];
  uuid: Scalars['OCUUID']['output'];
};

export type AllowListPhoneNumberConnection = {
  __typename: 'AllowListPhoneNumberConnection';
  edges: Array<AllowListPhoneNumberEdge>;
  pageInfo: PageInfo;
};

export type AllowListPhoneNumberCreateInput = {
  name: Scalars['String']['input'];
  phoneNumber: Scalars['OCPhoneNumber']['input'];
  reason: Scalars['String']['input'];
};

export type AllowListPhoneNumberDateFilterInput = {
  period: Allowed_List_Phone_Number_Time_Period;
  range?: InputMaybe<DateRangeInput>;
};

export type AllowListPhoneNumberDeleteInput = {
  allowedPhoneNumberUuid: Scalars['OCUUID']['input'];
};

export type AllowListPhoneNumberEdge = {
  __typename: 'AllowListPhoneNumberEdge';
  cursor: Scalars['OCBase64Cursor']['output'];
  node: AllowListPhoneNumber;
};

export type AllowListPhoneNumberFilterInput = {
  dateFilter?: InputMaybe<AllowListPhoneNumberDateFilterInput>;
  phoneNumberContains?: InputMaybe<Array<Scalars['OCPhoneNumber']['input']>>;
  search?: InputMaybe<Scalars['String']['input']>;
};

export type AllowListPhoneNumberUpdateInput = {
  name?: InputMaybe<Scalars['String']['input']>;
  reason?: InputMaybe<Scalars['String']['input']>;
  uuid: Scalars['OCUUID']['input'];
};

export enum AppPlatform {
  Android = 'ANDROID',
  Ios = 'IOS',
  Web = 'WEB'
}

export enum ApplePayCardNetwork {
  Amex = 'AMEX',
  CartesBancaires = 'CARTES_BANCAIRES',
  ChinaUnionPay = 'CHINA_UNION_PAY',
  Discover = 'DISCOVER',
  Eftpos = 'EFTPOS',
  Electron = 'ELECTRON',
  Elo = 'ELO',
  Interac = 'INTERAC',
  Jcb = 'JCB',
  Mada = 'MADA',
  Maestro = 'MAESTRO',
  Mastercard = 'MASTERCARD',
  MasterCard = 'MASTER_CARD',
  PrivateLabel = 'PRIVATE_LABEL',
  Visa = 'VISA',
  VPay = 'V_PAY'
}

export type ApplePayConfiguration = {
  __typename: 'ApplePayConfiguration';
  allowCreditCards: Scalars['Boolean']['output'];
  allowPrepaidCards: Scalars['Boolean']['output'];
  isBillingZipCodeCollectionEnabled: Scalars['Boolean']['output'];
  merchantId: Scalars['ID']['output'];
  merchantName?: Maybe<Scalars['String']['output']>;
  supportedNetworks: Array<ApplePayCardNetwork>;
};

export type ApplePayConfigurationCreateInput = {
  allowCreditCards: Scalars['Boolean']['input'];
  allowPrepaidCards: Scalars['Boolean']['input'];
  merchantId: Scalars['String']['input'];
  merchantName?: InputMaybe<Scalars['String']['input']>;
  supportedNetworks: Array<Par_Pay_Apple_Pay_Card_Network>;
};

export type ApplePayConfigurationUpdateInput = {
  allowCreditCards: Scalars['Boolean']['input'];
  allowPrepaidCards: Scalars['Boolean']['input'];
  merchantId: Scalars['String']['input'];
  merchantName?: InputMaybe<Scalars['String']['input']>;
  supportedNetworks: Array<Par_Pay_Apple_Pay_Card_Network>;
};

export type ApplePaySession = {
  __typename: 'ApplePaySession';
  data?: Maybe<Scalars['OCJSON']['output']>;
};

export type Audience = {
  __typename: 'Audience';
  chainId: Scalars['ID']['output'];
  createdAt: Scalars['OCDateTime']['output'];
  dailyCounts: Array<AudienceDailyCount>;
  description: Scalars['String']['output'];
  draftCount?: Maybe<Scalars['Int']['output']>;
  draftCountCalculationRequestedAt?: Maybe<Scalars['OCDateTime']['output']>;
  hasBeenBackFilled?: Maybe<Scalars['Boolean']['output']>;
  lastDraftCountCalculationAt?: Maybe<Scalars['OCDateTime']['output']>;
  membershipCount: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  status: Audience_Status;
  targetingAttributes: Array<AudienceTargetingAttribute>;
  updatedAt: Scalars['OCDateTime']['output'];
  uuid: Scalars['ID']['output'];
};


export type AudienceDailyCountsArgs = {
  endDate: Scalars['OCDate']['input'];
  startDate: Scalars['OCDate']['input'];
};

export type AudienceAgeWithinTargetingAttribute = {
  __typename: 'AudienceAgeWithinTargetingAttribute';
  maximumAge?: Maybe<Scalars['Int']['output']>;
  minimumAge?: Maybe<Scalars['Int']['output']>;
};

export type AudienceAgeWithinTargetingAttributeInput = {
  maximumAge?: InputMaybe<Scalars['Int']['input']>;
  minimumAge?: InputMaybe<Scalars['Int']['input']>;
};

export type AudienceAggregatedAudiencesTargetingAttribute = {
  __typename: 'AudienceAggregatedAudiencesTargetingAttribute';
  operator?: Maybe<Aggregated_Audience_Operator>;
  target: Array<Scalars['OCUUID']['output']>;
};

export type AudienceAggregatedAudiencesTargetingAttributeInput = {
  operator?: InputMaybe<Aggregated_Audience_Operator>;
  target: Array<Scalars['OCUUID']['input']>;
};

export type AudienceBroadcastMessage = {
  __typename: 'AudienceBroadcastMessage';
  archivedAt?: Maybe<Scalars['OCDateTime']['output']>;
  audience?: Maybe<Audience>;
  audienceUuid?: Maybe<Scalars['OCUUID']['output']>;
  channelsConfig?: Maybe<ChannelsConfig>;
  createdAt: Scalars['OCDateTime']['output'];
  description?: Maybe<Scalars['String']['output']>;
  scheduleAt?: Maybe<Scalars['OCDateTime']['output']>;
  status: AudienceBroadcastMessageStatus;
  title: Scalars['String']['output'];
  updatedAt?: Maybe<Scalars['OCDateTime']['output']>;
  uuid: Scalars['OCUUID']['output'];
};

export type AudienceBroadcastMessageConnection = {
  __typename: 'AudienceBroadcastMessageConnection';
  edges: Array<AudienceBroadcastMessageEdge>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type AudienceBroadcastMessageEdge = {
  __typename: 'AudienceBroadcastMessageEdge';
  cursor: Scalars['OCUUID']['output'];
  node: AudienceBroadcastMessage;
};

export enum AudienceBroadcastMessageStatus {
  Archived = 'ARCHIVED',
  Draft = 'DRAFT',
  Failed = 'FAILED',
  Processing = 'PROCESSING',
  Scheduled = 'SCHEDULED',
  Sent = 'SENT'
}

export enum AudienceBroadcastMessageType {
  Push = 'PUSH',
  Sms = 'SMS'
}

export type AudienceBroadcastMessagesFilter = {
  audienceUuidEquals?: InputMaybe<Scalars['OCUUID']['input']>;
  messageTypeIncludes?: InputMaybe<Array<AudienceBroadcastMessageType>>;
  scheduledDateFrom?: InputMaybe<Scalars['OCDateTime']['input']>;
  scheduledDateTo?: InputMaybe<Scalars['OCDateTime']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  statusIncludes?: InputMaybe<Array<AudienceBroadcastMessageStatus>>;
  uuidEquals?: InputMaybe<Scalars['OCUUID']['input']>;
};

export type AudienceCommunicationPreferenceCriteria = {
  __typename: 'AudienceCommunicationPreferenceCriteria';
  mechanism: Communication_Preference_Mechanism;
  status: Communication_Preference_Opt_In_Status;
  subBrandUuid?: Maybe<Scalars['OCUUID']['output']>;
};

export type AudienceCommunicationPreferenceCriteriaInput = {
  mechanism: Communication_Preference_Mechanism;
  status: Communication_Preference_Opt_In_Status;
  subBrandUuid?: InputMaybe<Scalars['OCUUID']['input']>;
};

export type AudienceCommunicationPreferenceTargetingAttribute = {
  __typename: 'AudienceCommunicationPreferenceTargetingAttribute';
  criteria: Array<AudienceCommunicationPreferenceCriteria>;
};

export type AudienceCommunicationPreferenceTargetingAttributeInput = {
  criteria: Array<AudienceCommunicationPreferenceCriteriaInput>;
};

export type AudienceConnection = {
  __typename: 'AudienceConnection';
  edges: Array<AudienceEdge>;
  pageInfo: PageInfo;
};

export type AudienceCreate = {
  chainId: Scalars['ID']['input'];
  description: Scalars['String']['input'];
  name: Scalars['String']['input'];
  targetingAttributes: AudienceTargetingAttributesInput;
};

export type AudienceDailyCount = {
  __typename: 'AudienceDailyCount';
  count: Scalars['Int']['output'];
  date: Scalars['OCDate']['output'];
};

export type AudienceEdge = {
  __typename: 'AudienceEdge';
  cursor: Scalars['ID']['output'];
  node: Audience;
};

export type AudienceEventCondition = {
  __typename: 'AudienceEventCondition';
  audienceEventDateCondition?: Maybe<AudienceEventDateOneOfCondition>;
  gameUuid?: Maybe<Scalars['OCUUID']['output']>;
  loyaltyEventUuid?: Maybe<Scalars['OCUUID']['output']>;
  operator?: Maybe<Event_Targeting_Condition_Operator>;
  purchaseCondition?: Maybe<AudienceEventPurchaseCondition>;
  /** @deprecated Use audienceEventDateCondition with timeWindow option */
  timeWindow?: Maybe<Audience_Purchase_Time_Window>;
  times: Scalars['Int']['output'];
};

export type AudienceEventConditionInput = {
  audienceEventDateCondition?: InputMaybe<AudienceEventDateOneOfConditionInput>;
  gameUuid?: InputMaybe<Scalars['OCUUID']['input']>;
  loyaltyEventUuid?: InputMaybe<Scalars['OCUUID']['input']>;
  operator?: InputMaybe<Event_Targeting_Condition_Operator>;
  purchaseCondition?: InputMaybe<AudienceEventPurchaseConditionInput>;
  timeWindow?: InputMaybe<Audience_Purchase_Time_Window>;
  times: Scalars['Int']['input'];
};

export type AudienceEventDateOneOfCondition = {
  __typename: 'AudienceEventDateOneOfCondition';
  fixedDateRange?: Maybe<FixedDateRange>;
  relativeMonthBack?: Maybe<RelativeMonthsBack>;
  timeWindow?: Maybe<TimeWindow>;
};

export type AudienceEventDateOneOfConditionInput = {
  fixedDateRange?: InputMaybe<FixedDateRangeInput>;
  relativeMonthBack?: InputMaybe<RelativeMonthsBackInput>;
  timeWindow?: InputMaybe<TimeWindowInput>;
};

export type AudienceEventPurchaseCondition = {
  __typename: 'AudienceEventPurchaseCondition';
  countProductsBy: Count_Products_By;
  excludeThreshold?: Maybe<Scalars['Boolean']['output']>;
  operator: Event_Purchase_Condition_Operator;
  productGroupUuids: Array<Scalars['OCUUID']['output']>;
  purchasedLocationGroupUuids?: Maybe<Array<Scalars['OCUUID']['output']>>;
  purchasedLocationUuids?: Maybe<Array<Scalars['OCUUID']['output']>>;
  threshold: Scalars['Float']['output'];
};

export type AudienceEventPurchaseConditionInput = {
  countProductsBy: Count_Products_By;
  excludeThreshold?: InputMaybe<Scalars['Boolean']['input']>;
  operator: Event_Purchase_Condition_Operator;
  productGroupUuids: Array<Scalars['OCUUID']['input']>;
  purchasedLocationGroupUuids?: InputMaybe<Array<Scalars['OCUUID']['input']>>;
  purchasedLocationUuids?: InputMaybe<Array<Scalars['OCUUID']['input']>>;
  threshold: Scalars['Float']['input'];
};

export type AudienceExternalIdentityVerificationTargetingAttribute = {
  __typename: 'AudienceExternalIdentityVerificationTargetingAttribute';
  operator: External_Identity_Verification_Operator;
  provider: ExternalIdentityVerificationProvider;
  verificationAttributes: Array<Scalars['String']['output']>;
};

export type AudienceExternalIdentityVerificationTargetingAttributeInput = {
  operator: External_Identity_Verification_Operator;
  provider: ExternalIdentityVerificationProvider;
  verificationAttributes: Array<Scalars['String']['input']>;
};

export type AudienceFilter = {
  chainIdEquals?: InputMaybe<Scalars['ID']['input']>;
  excludeAggregatedAudiences?: InputMaybe<Scalars['Boolean']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  statusContains?: InputMaybe<Array<InputMaybe<Audience_Status>>>;
  statusEquals?: InputMaybe<Audience_Status>;
  uuidContains?: InputMaybe<Array<Scalars['ID']['input']>>;
  uuidEquals?: InputMaybe<Scalars['ID']['input']>;
  uuidNotContains?: InputMaybe<Array<Scalars['ID']['input']>>;
};

export type AudienceForMembershipFilter = {
  chainIdEquals?: InputMaybe<Scalars['ID']['input']>;
  membershipIdEquals: Scalars['ID']['input'];
  search?: InputMaybe<Scalars['String']['input']>;
  statusContains?: InputMaybe<Array<InputMaybe<Audience_Status>>>;
  statusEquals?: InputMaybe<Audience_Status>;
  uuidContains?: InputMaybe<Array<Scalars['ID']['input']>>;
  uuidEquals?: InputMaybe<Scalars['ID']['input']>;
};

export type AudienceFuelAndConvenienceProfileCriteria = {
  __typename: 'AudienceFuelAndConvenienceProfileCriteria';
  attribute: Fuel_And_Convenience_Profile_Attribute;
  operator: Fuel_And_Convenience_Profile_Operator;
  target?: Maybe<Array<Scalars['String']['output']>>;
};

export type AudienceFuelAndConvenienceProfileCriteriaInput = {
  attribute: Fuel_And_Convenience_Profile_Attribute;
  operator: Fuel_And_Convenience_Profile_Operator;
  target?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type AudienceFuelAndConvenienceProfileTargetingAttribute = {
  __typename: 'AudienceFuelAndConvenienceProfileTargetingAttribute';
  criteria: Array<AudienceFuelAndConvenienceProfileCriteria>;
};

export type AudienceFuelAndConvenienceProfileTargetingAttributeInput = {
  criteria: Array<AudienceFuelAndConvenienceProfileCriteriaInput>;
};

export type AudienceInAllEventTargetingAttribute = {
  __typename: 'AudienceInAllEventTargetingAttribute';
  conditions?: Maybe<Array<AudienceEventCondition>>;
};

export type AudienceInAllEventTargetingAttributeInput = {
  conditions?: InputMaybe<Array<AudienceEventConditionInput>>;
};

export type AudienceInAllProductInterestsTargetingAttribute = {
  __typename: 'AudienceInAllProductInterestsTargetingAttribute';
  productCategories: Array<Scalars['String']['output']>;
};

export type AudienceInAllProductInterestsTargetingAttributeInput = {
  productCategories: Array<Scalars['String']['input']>;
};

export type AudienceInAllSegmentsTargetingAttribute = {
  __typename: 'AudienceInAllSegmentsTargetingAttribute';
  segmentIds: Array<Scalars['String']['output']>;
};

export type AudienceInAllSegmentsTargetingAttributeInput = {
  segmentIds: Array<Scalars['String']['input']>;
};

export type AudienceInAnyEventTargetingAttribute = {
  __typename: 'AudienceInAnyEventTargetingAttribute';
  conditions?: Maybe<Array<AudienceEventCondition>>;
};

export type AudienceInAnyEventTargetingAttributeInput = {
  conditions?: InputMaybe<Array<AudienceEventConditionInput>>;
};

export type AudienceInAnyProductInterestsTargetingAttribute = {
  __typename: 'AudienceInAnyProductInterestsTargetingAttribute';
  productCategories: Array<Scalars['String']['output']>;
};

export type AudienceInAnyProductInterestsTargetingAttributeInput = {
  productCategories: Array<Scalars['String']['input']>;
};

export type AudienceInAnySegmentsTargetingAttribute = {
  __typename: 'AudienceInAnySegmentsTargetingAttribute';
  segmentIds: Array<Scalars['String']['output']>;
};

export type AudienceInAnySegmentsTargetingAttributeInput = {
  segmentIds: Array<Scalars['String']['input']>;
};

export type AudienceNotInAllEventTargetingAttribute = {
  __typename: 'AudienceNotInAllEventTargetingAttribute';
  conditions?: Maybe<Array<AudienceEventCondition>>;
};

export type AudienceNotInAllEventTargetingAttributeInput = {
  conditions?: InputMaybe<Array<AudienceEventConditionInput>>;
};

export type AudienceNotInAllProductInterestsTargetingAttribute = {
  __typename: 'AudienceNotInAllProductInterestsTargetingAttribute';
  productCategories: Array<Scalars['String']['output']>;
};

export type AudienceNotInAllProductInterestsTargetingAttributeInput = {
  productCategories: Array<Scalars['String']['input']>;
};

export type AudienceNotInAnyEventTargetingAttribute = {
  __typename: 'AudienceNotInAnyEventTargetingAttribute';
  conditions?: Maybe<Array<AudienceEventCondition>>;
};

export type AudienceNotInAnyEventTargetingAttributeInput = {
  conditions?: InputMaybe<Array<AudienceEventConditionInput>>;
};

export type AudienceNotInAnyProductInterestsTargetingAttribute = {
  __typename: 'AudienceNotInAnyProductInterestsTargetingAttribute';
  productCategories: Array<Scalars['String']['output']>;
};

export type AudienceNotInAnyProductInterestsTargetingAttributeInput = {
  productCategories: Array<Scalars['String']['input']>;
};

export type AudienceNotInAnySegmentsTargetingAttribute = {
  __typename: 'AudienceNotInAnySegmentsTargetingAttribute';
  segmentIds: Array<Scalars['String']['output']>;
};

export type AudienceNotInAnySegmentsTargetingAttributeInput = {
  segmentIds: Array<Scalars['String']['input']>;
};

export type AudienceOfferFulfillmentTargetingAttribute = {
  __typename: 'AudienceOfferFulfillmentTargetingAttribute';
  fulfilled: Scalars['Boolean']['output'];
  operator?: Maybe<Offer_Fulfillment_Operator>;
  targetOfferId: Scalars['ID']['output'];
  timesFulfilled?: Maybe<Scalars['Int']['output']>;
};

export type AudienceOfferFulfillmentTargetingAttributeInput = {
  fulfilled: Scalars['Boolean']['input'];
  operator?: InputMaybe<Offer_Fulfillment_Operator>;
  targetOfferId: Scalars['ID']['input'];
  timesFulfilled?: InputMaybe<Scalars['Int']['input']>;
};

export type AudiencePointBalanceTargetingAttribute = {
  __typename: 'AudiencePointBalanceTargetingAttribute';
  amount?: Maybe<Scalars['Int']['output']>;
  maxAmount?: Maybe<Scalars['Int']['output']>;
  minAmount?: Maybe<Scalars['Int']['output']>;
  operator?: Maybe<Audience_Operator>;
  target: Point_Balance_Target;
};

export type AudiencePointBalanceTargetingAttributeInput = {
  amount?: InputMaybe<Scalars['Int']['input']>;
  maxAmount?: InputMaybe<Scalars['Int']['input']>;
  minAmount?: InputMaybe<Scalars['Int']['input']>;
  operator?: InputMaybe<Audience_Operator>;
  target: Point_Balance_Target;
};

export type AudiencePurchasedAtLeastTargetingAttribute = {
  __typename: 'AudiencePurchasedAtLeastTargetingAttribute';
  countProductsBy?: Maybe<Count_Products_By>;
  endDate?: Maybe<Scalars['OCDate']['output']>;
  excludeThreshold?: Maybe<Scalars['Boolean']['output']>;
  /** @deprecated Replaced by purchasedLocationUuids. */
  locationsIds?: Maybe<Array<Scalars['String']['output']>>;
  productGroupIds?: Maybe<Array<Scalars['String']['output']>>;
  purchasedLocationGroupUuids?: Maybe<Array<Scalars['OCUUID']['output']>>;
  purchasedLocationUuids?: Maybe<Array<Scalars['OCUUID']['output']>>;
  relativeMonthsBack?: Maybe<Scalars['Int']['output']>;
  startDate?: Maybe<Scalars['OCDate']['output']>;
  targetMonth?: Maybe<Scalars['Int']['output']>;
  targetYear?: Maybe<Scalars['Int']['output']>;
  threshold?: Maybe<Scalars['Float']['output']>;
  timeWindow?: Maybe<Audience_Purchase_Time_Window>;
};

export type AudiencePurchasedAtLeastTargetingAttributeInput = {
  countProductsBy?: InputMaybe<Count_Products_By>;
  endDate?: InputMaybe<Scalars['OCDate']['input']>;
  excludeThreshold?: InputMaybe<Scalars['Boolean']['input']>;
  locationGroupUuids?: InputMaybe<Array<Scalars['OCUUID']['input']>>;
  locationsIds?: InputMaybe<Array<Scalars['String']['input']>>;
  productGroupIds?: InputMaybe<Array<Scalars['String']['input']>>;
  relativeMonthsBack?: InputMaybe<Scalars['Int']['input']>;
  startDate?: InputMaybe<Scalars['OCDate']['input']>;
  targetMonth?: InputMaybe<Scalars['Int']['input']>;
  targetYear?: InputMaybe<Scalars['Int']['input']>;
  threshold?: InputMaybe<Scalars['Float']['input']>;
  timeWindow?: InputMaybe<Audience_Purchase_Time_Window>;
};

export type AudiencePurchasedAtMostTargetingAttribute = {
  __typename: 'AudiencePurchasedAtMostTargetingAttribute';
  countProductsBy?: Maybe<Count_Products_By>;
  endDate?: Maybe<Scalars['OCDate']['output']>;
  excludeThreshold?: Maybe<Scalars['Boolean']['output']>;
  /** @deprecated Replaced by purchasedLocationUuids. */
  locationsIds?: Maybe<Array<Scalars['String']['output']>>;
  productGroupIds?: Maybe<Array<Scalars['String']['output']>>;
  purchasedLocationGroupUuids?: Maybe<Array<Scalars['OCUUID']['output']>>;
  purchasedLocationUuids?: Maybe<Array<Scalars['OCUUID']['output']>>;
  relativeMonthsBack?: Maybe<Scalars['Int']['output']>;
  startDate?: Maybe<Scalars['OCDate']['output']>;
  targetMonth?: Maybe<Scalars['Int']['output']>;
  targetYear?: Maybe<Scalars['Int']['output']>;
  threshold?: Maybe<Scalars['Float']['output']>;
  timeWindow?: Maybe<Audience_Purchase_Time_Window>;
};

export type AudiencePurchasedAtMostTargetingAttributeInput = {
  countProductsBy?: InputMaybe<Count_Products_By>;
  endDate?: InputMaybe<Scalars['OCDate']['input']>;
  excludeThreshold?: InputMaybe<Scalars['Boolean']['input']>;
  locationGroupUuids?: InputMaybe<Array<Scalars['OCUUID']['input']>>;
  locationsIds?: InputMaybe<Array<Scalars['String']['input']>>;
  productGroupIds?: InputMaybe<Array<Scalars['String']['input']>>;
  relativeMonthsBack?: InputMaybe<Scalars['Int']['input']>;
  startDate?: InputMaybe<Scalars['OCDate']['input']>;
  targetMonth?: InputMaybe<Scalars['Int']['input']>;
  targetYear?: InputMaybe<Scalars['Int']['input']>;
  threshold?: InputMaybe<Scalars['Float']['input']>;
  timeWindow?: InputMaybe<Audience_Purchase_Time_Window>;
};

export type AudienceReportExport = FeatureConfiguration & {
  __typename: 'AudienceReportExport';
  enabled: Scalars['Boolean']['output'];
};

export type AudienceRetailerNetworkSiteUsersTargetingAttribute = {
  __typename: 'AudienceRetailerNetworkSiteUsersTargetingAttribute';
  retailerNetworkOperator?: Maybe<Retailer_Network_Operator>;
  retailerNetworkUserTypes: Array<Retailer_Network_User_Type>;
  retailerNetworkUuids?: Maybe<Array<Scalars['OCUUID']['output']>>;
  userTypeOperator: Retailer_Network_User_Type_Operator;
};

export type AudienceRetailerNetworkSiteUsersTargetingAttributeInput = {
  retailerNetworkOperator?: InputMaybe<Retailer_Network_Operator>;
  retailerNetworkUserTypes: Array<Retailer_Network_User_Type>;
  retailerNetworkUuids?: InputMaybe<Array<Scalars['OCUUID']['input']>>;
  userTypeOperator: Retailer_Network_User_Type_Operator;
};

export type AudienceStoreLocationTargetingAttribute = {
  __typename: 'AudienceStoreLocationTargetingAttribute';
  locationGroupUuids?: Maybe<Array<Scalars['OCUUID']['output']>>;
  locationsIds?: Maybe<Array<Scalars['ID']['output']>>;
};

export type AudienceStoreLocationTargetingAttributeInput = {
  locationGroupUuids?: InputMaybe<Array<Scalars['OCUUID']['input']>>;
  locationsIds?: InputMaybe<Array<Scalars['ID']['input']>>;
};

export type AudienceSurveyAnswerTargetingAttribute = {
  __typename: 'AudienceSurveyAnswerTargetingAttribute';
  operator: Survey_Answer_Operator;
  surveyUuid?: Maybe<Scalars['OCUUID']['output']>;
};

export type AudienceSurveyAnswerTargetingAttributeInput = {
  operator: Survey_Answer_Operator;
  surveyUuid?: InputMaybe<Scalars['OCUUID']['input']>;
};

export type AudienceSurveyResponseTargetingAttribute = {
  __typename: 'AudienceSurveyResponseTargetingAttribute';
  locationGroupUuids?: Maybe<Array<Scalars['OCUUID']['output']>>;
  locationsUuids?: Maybe<Array<Scalars['OCUUID']['output']>>;
  maxAmount?: Maybe<Scalars['Int']['output']>;
  minAmount?: Maybe<Scalars['Int']['output']>;
  operator: Audience_Survey_Response_Operator;
  questionUuid: Scalars['OCUUID']['output'];
  selectedOptions?: Maybe<Array<Scalars['OCUUID']['output']>>;
  surveyResponse?: Maybe<Scalars['String']['output']>;
  surveyUuid: Scalars['OCUUID']['output'];
};

export type AudienceSurveyResponseTargetingAttributeInput = {
  locationGroupUuids?: InputMaybe<Array<Scalars['OCUUID']['input']>>;
  locationsUuids?: InputMaybe<Array<Scalars['OCUUID']['input']>>;
  maxAmount?: InputMaybe<Scalars['Int']['input']>;
  minAmount?: InputMaybe<Scalars['Int']['input']>;
  operator: Audience_Survey_Response_Operator;
  questionUuid: Scalars['OCUUID']['input'];
  selectedOptions?: InputMaybe<Array<Scalars['OCUUID']['input']>>;
  surveyResponse?: InputMaybe<Scalars['String']['input']>;
  surveyUuid: Scalars['OCUUID']['input'];
};

export type AudienceTargetingAttribute = AudienceAgeWithinTargetingAttribute | AudienceAggregatedAudiencesTargetingAttribute | AudienceCommunicationPreferenceTargetingAttribute | AudienceExternalIdentityVerificationTargetingAttribute | AudienceFuelAndConvenienceProfileTargetingAttribute | AudienceInAllEventTargetingAttribute | AudienceInAllProductInterestsTargetingAttribute | AudienceInAllSegmentsTargetingAttribute | AudienceInAnyEventTargetingAttribute | AudienceInAnyProductInterestsTargetingAttribute | AudienceInAnySegmentsTargetingAttribute | AudienceNotInAllEventTargetingAttribute | AudienceNotInAllProductInterestsTargetingAttribute | AudienceNotInAnyEventTargetingAttribute | AudienceNotInAnyProductInterestsTargetingAttribute | AudienceNotInAnySegmentsTargetingAttribute | AudienceOfferFulfillmentTargetingAttribute | AudiencePointBalanceTargetingAttribute | AudiencePurchasedAtLeastTargetingAttribute | AudiencePurchasedAtMostTargetingAttribute | AudienceRetailerNetworkSiteUsersTargetingAttribute | AudienceStoreLocationTargetingAttribute | AudienceSurveyAnswerTargetingAttribute | AudienceSurveyResponseTargetingAttribute | AudienceTimeSinceLastVisitTargetingAttribute | AudienceTimeSinceMembershipAcquisitionTargetingAttribute | AudienceWalletSteeringTargetingAttribute;

export type AudienceTargetingAttributesInput = {
  ageWithinTargetingAttribute?: InputMaybe<AudienceAgeWithinTargetingAttributeInput>;
  aggregatedAudienceTargetingAttribute?: InputMaybe<AudienceAggregatedAudiencesTargetingAttributeInput>;
  audienceRetailerNetworkSiteUsersTargetingAttribute?: InputMaybe<AudienceRetailerNetworkSiteUsersTargetingAttributeInput>;
  audienceSurveyAnswerTargetingAttribute?: InputMaybe<AudienceSurveyAnswerTargetingAttributeInput>;
  communicationPreferenceTargetingAttribute?: InputMaybe<AudienceCommunicationPreferenceTargetingAttributeInput>;
  externalIdentityVerificationTargetingAttribute?: InputMaybe<Array<AudienceExternalIdentityVerificationTargetingAttributeInput>>;
  fuelAndConvenienceProfileTargetingAttribute?: InputMaybe<AudienceFuelAndConvenienceProfileTargetingAttributeInput>;
  inAllEventTargetingAttribute?: InputMaybe<AudienceInAllEventTargetingAttributeInput>;
  inAllProductInterestsTargetingAttribute?: InputMaybe<AudienceInAllProductInterestsTargetingAttributeInput>;
  inAllSegmentsTargetingAttribute?: InputMaybe<AudienceInAllSegmentsTargetingAttributeInput>;
  inAnyEventTargetingAttribute?: InputMaybe<AudienceInAnyEventTargetingAttributeInput>;
  inAnyProductInterestsTargetingAttribute?: InputMaybe<AudienceInAnyProductInterestsTargetingAttributeInput>;
  inAnySegmentsTargetingAttribute?: InputMaybe<AudienceInAnySegmentsTargetingAttributeInput>;
  notInAllEventTargetingAttribute?: InputMaybe<AudienceNotInAllEventTargetingAttributeInput>;
  notInAllProductInterestsTargetingAttribute?: InputMaybe<AudienceNotInAllProductInterestsTargetingAttributeInput>;
  notInAnyEventTargetingAttribute?: InputMaybe<AudienceNotInAnyEventTargetingAttributeInput>;
  notInAnyProductInterestsTargetingAttribute?: InputMaybe<AudienceNotInAnyProductInterestsTargetingAttributeInput>;
  notInAnySegmentsTargetingAttribute?: InputMaybe<AudienceNotInAnySegmentsTargetingAttributeInput>;
  offerFulfillmentTargetingAttribute?: InputMaybe<Array<AudienceOfferFulfillmentTargetingAttributeInput>>;
  pointBalanceTargetingAttribute?: InputMaybe<AudiencePointBalanceTargetingAttributeInput>;
  purchasedAtLeastTargetingAttribute?: InputMaybe<Array<AudiencePurchasedAtLeastTargetingAttributeInput>>;
  purchasedAtMostTargetingAttribute?: InputMaybe<Array<AudiencePurchasedAtMostTargetingAttributeInput>>;
  storeLocationTargetingAttribute?: InputMaybe<AudienceStoreLocationTargetingAttributeInput>;
  surveyResponseTargetingAttribute?: InputMaybe<Array<AudienceSurveyResponseTargetingAttributeInput>>;
  timeSinceLastVisitTargetingAttribute?: InputMaybe<AudienceTimeSinceLastVisitTargetingAttributeInput>;
  timeSinceMembershipAcquisitionTargetingAttribute?: InputMaybe<AudienceTimeSinceMembershipAcquisitionTargetingAttributeInput>;
  walletSteeringTargetingAttribute?: InputMaybe<Array<AudienceWalletSteeringTargetingAttributeInput>>;
};

export type AudienceTimeSinceLastVisitTargetingAttribute = {
  __typename: 'AudienceTimeSinceLastVisitTargetingAttribute';
  amount: Scalars['Int']['output'];
  operator: Time_Since_Last_Visit_Operator;
  period: Time_Period;
};

export type AudienceTimeSinceLastVisitTargetingAttributeInput = {
  amount: Scalars['Int']['input'];
  operator: Time_Since_Last_Visit_Operator;
  period: Time_Period;
};

export type AudienceTimeSinceMembershipAcquisitionTargetingAttribute = {
  __typename: 'AudienceTimeSinceMembershipAcquisitionTargetingAttribute';
  amount: Scalars['Int']['output'];
  operator: Time_Since_Membership_Acquisition_Operator;
};

export type AudienceTimeSinceMembershipAcquisitionTargetingAttributeInput = {
  amount: Scalars['Int']['input'];
  operator: Time_Since_Membership_Acquisition_Operator;
};

export type AudienceUpdate = {
  description?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  targetingAttributes: AudienceTargetingAttributesInput;
  uuid: Scalars['ID']['input'];
};

export type AudienceWalletSteeringTargetingAttribute = {
  __typename: 'AudienceWalletSteeringTargetingAttribute';
  attribute: Wallet_Steering_Attribute;
  unitOfMeasure: Unit_Of_Measure;
  value: Scalars['Float']['output'];
  walletSteeringOperator: Wallet_Steering_Operator;
  walletUuid: Scalars['OCUUID']['output'];
};

export type AudienceWalletSteeringTargetingAttributeInput = {
  attribute: Wallet_Steering_Attribute;
  unitOfMeasure: Unit_Of_Measure;
  value: Scalars['Float']['input'];
  walletSteeringOperator: Wallet_Steering_Operator;
  walletUuid: Scalars['OCUUID']['input'];
};

export type AuthChallenge = {
  __typename: 'AuthChallenge';
  session: Scalars['String']['output'];
  type: Auth_Challenge_Type;
};

export type AuthChallengeOrAccessToken = AuthChallenge | AuthTokens;

export enum AuthMethod {
  MagicLink = 'MAGIC_LINK',
  Otp = 'OTP'
}

export type AuthPayload = {
  __typename: 'AuthPayload';
  customer?: Maybe<Customer>;
  tokens?: Maybe<Tokens>;
};

export type AuthSessionDataInput = {
  csrLoginSession?: InputMaybe<CsrLoginSessionInput>;
};

export type AuthTokens = {
  __typename: 'AuthTokens';
  tokens?: Maybe<Tokens>;
};

export type AuthorizationAction = {
  __typename: 'AuthorizationAction';
  createdAt: Scalars['OCDateTime']['output'];
  name: Scalars['String']['output'];
  uuid: Scalars['OCUUID']['output'];
};

export type AuthorizationClaim = {
  __typename: 'AuthorizationClaim';
  action?: Maybe<AuthorizationAction>;
  actionUuid: Scalars['OCUUID']['output'];
  createdAt?: Maybe<Scalars['OCDateTime']['output']>;
  deletedAt?: Maybe<Scalars['OCDateTime']['output']>;
  field?: Maybe<Scalars['String']['output']>;
  identityGroup?: Maybe<AuthorizationIdentityGroup>;
  identityGroupUuid: Scalars['OCUUID']['output'];
  scope?: Maybe<AuthorizationScope>;
  scopeUuid?: Maybe<Scalars['OCUUID']['output']>;
  subject?: Maybe<AuthorizationSubject>;
  subjectUuid: Scalars['OCUUID']['output'];
  updatedAt?: Maybe<Scalars['OCDateTime']['output']>;
  uuid?: Maybe<Scalars['OCUUID']['output']>;
};

export type AuthorizationClaimCreateInput = {
  actionUuid: Scalars['OCUUID']['input'];
  field?: InputMaybe<Scalars['String']['input']>;
  scopeUuid?: InputMaybe<Scalars['OCUUID']['input']>;
  subjectUuid: Scalars['OCUUID']['input'];
};

export type AuthorizationClaimFilterInput = {
  actionUuid?: InputMaybe<UuidFilter>;
  createdAt?: InputMaybe<TimestampFilter>;
  deletedAt?: InputMaybe<TimestampFilter>;
  identityGroup?: InputMaybe<AuthorizationIdentityGroupFilterInput>;
  includeDeleted?: InputMaybe<Scalars['Boolean']['input']>;
  scopeUuid?: InputMaybe<UuidFilter>;
  subjectUuid?: InputMaybe<UuidFilter>;
  updatedAt?: InputMaybe<TimestampFilter>;
  uuid?: InputMaybe<UuidFilter>;
};

export type AuthorizationClaimUpdateInput = {
  actionUuid?: InputMaybe<Scalars['OCUUID']['input']>;
  field?: InputMaybe<Scalars['String']['input']>;
  identityGroupUuid?: InputMaybe<Scalars['OCUUID']['input']>;
  scopeUuid?: InputMaybe<Scalars['OCUUID']['input']>;
  subjectUuid?: InputMaybe<Scalars['OCUUID']['input']>;
  uuid: Scalars['String']['input'];
};

export type AuthorizationGroupMemberManagementPermission = {
  __typename: 'AuthorizationGroupMemberManagementPermission';
  managedIdentityGroupName: Scalars['String']['output'];
  managedIdentityTypeName: Scalars['String']['output'];
  managerIdentityGroupName: Scalars['String']['output'];
  managerIdentityTypeName: Scalars['String']['output'];
};

export type AuthorizationIdentityGroup = {
  __typename: 'AuthorizationIdentityGroup';
  claimUuids?: Maybe<Array<Scalars['OCUUID']['output']>>;
  claims?: Maybe<Array<AuthorizationClaim>>;
  createdAt?: Maybe<Scalars['OCDateTime']['output']>;
  identityType: AuthorizationIdentityType;
  identityTypeUuid: Scalars['OCUUID']['output'];
  name: Scalars['String']['output'];
  uuid?: Maybe<Scalars['OCUUID']['output']>;
};

export type AuthorizationIdentityGroupAddClaimsInput = {
  claims: Array<AuthorizationClaimCreateInput>;
  uuid: Scalars['String']['input'];
};

export type AuthorizationIdentityGroupCreateInput = {
  identityTypeUuid: Scalars['OCUUID']['input'];
  name: Scalars['String']['input'];
};

export type AuthorizationIdentityGroupFilterInput = {
  createdAt?: InputMaybe<TimestampFilter>;
  deletedAt?: InputMaybe<TimestampFilter>;
  identityType?: InputMaybe<AuthorizationIdentityTypeFilterInput>;
  identityTypeUuid?: InputMaybe<UuidFilter>;
  includeDeleted?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<StringFilter>;
  updatedAt?: InputMaybe<TimestampFilter>;
  uuid?: InputMaybe<UuidFilter>;
};

export type AuthorizationIdentityGroupRemoveClaimsInput = {
  claimUuids: Array<Scalars['OCUUID']['input']>;
  uuid: Scalars['String']['input'];
};

export type AuthorizationIdentityGroupUpdateInput = {
  name?: InputMaybe<Scalars['String']['input']>;
  uuid: Scalars['String']['input'];
};

export type AuthorizationIdentityType = {
  __typename: 'AuthorizationIdentityType';
  createdAt: Scalars['OCDateTime']['output'];
  identityGroupUuids?: Maybe<Array<Scalars['OCUUID']['output']>>;
  identityGroups?: Maybe<Array<AuthorizationIdentityGroup>>;
  name: Scalars['String']['output'];
  uuid: Scalars['OCUUID']['output'];
};

export type AuthorizationIdentityTypeFilterInput = {
  createdAt?: InputMaybe<TimestampFilter>;
  includeDeleted?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<StringFilter>;
  uuid?: InputMaybe<UuidFilter>;
};

export type AuthorizationScope = {
  __typename: 'AuthorizationScope';
  createdAt: Scalars['OCDateTime']['output'];
  name: Scalars['String']['output'];
  uuid: Scalars['OCUUID']['output'];
};

export type AuthorizationSubject = {
  __typename: 'AuthorizationSubject';
  createdAt: Scalars['OCDateTime']['output'];
  name: Scalars['String']['output'];
  uuid: Scalars['OCUUID']['output'];
};

export enum AutoDecision {
  Approve = 'APPROVE',
  Decline = 'DECLINE',
  Escalate = 'ESCALATE',
  Review = 'REVIEW'
}

export type AwardBuyAndGet = {
  __typename: 'AwardBuyAndGet';
  discountThreshold: Scalars['Int']['output'];
  percentDiscount: Scalars['Int']['output'];
};

export type AwardBuyAndGetInput = {
  discountThreshold: Scalars['Int']['input'];
  percentDiscount: Scalars['Int']['input'];
};

export type AwardExternal = {
  __typename: 'AwardExternal';
  provider: ExternalAwardProvider;
};

export type AwardExternalInput = {
  provider: ExternalAwardProvider;
};

export type AwardExternalPoints = {
  __typename: 'AwardExternalPoints';
  maximum?: Maybe<Scalars['Int']['output']>;
};

export type AwardExternalPointsInput = {
  maximum?: InputMaybe<Scalars['Int']['input']>;
};

export type AwardExternalPointsOrPointsOrVouchers = AwardExternalPoints | AwardPoints | AwardVouchers;

export type AwardMoneyDiscount = {
  __typename: 'AwardMoneyDiscount';
  awardPer: Award_Per_Counting_Strategy;
  moneyAmount: Scalars['Int']['output'];
  partialDiscount: Scalars['Boolean']['output'];
};

export type AwardMoneyDiscountInput = {
  awardPer: Award_Per_Counting_Strategy;
  moneyAmount: Scalars['Int']['input'];
  partialDiscount?: InputMaybe<Scalars['Boolean']['input']>;
};

export type AwardMoneyDiscountOrPriceOverrideOrBuyAndGet = AwardBuyAndGet | AwardMoneyDiscount | AwardPriceOverride;

export type AwardPoints = {
  __typename: 'AwardPoints';
  points: Scalars['Int']['output'];
};

export type AwardPointsInput = {
  points: Scalars['Int']['input'];
};

export type AwardPointsOrVouchers = AwardPoints | AwardVouchers;

export type AwardPointsOrVouchersOrExternal = AwardExternal | AwardPoints | AwardVouchers;

export type AwardPointsPer = {
  __typename: 'AwardPointsPer';
  points: Scalars['Int']['output'];
  rounding: Award_Points_Rounding_Strategy;
};

export type AwardPointsPerInput = {
  points: Scalars['Int']['input'];
  rounding: Award_Points_Rounding_Strategy;
};

export type AwardPriceOverride = {
  __typename: 'AwardPriceOverride';
  maximumCost: Scalars['Int']['output'];
};

export type AwardPriceOverrideInput = {
  maximumCost: Scalars['Int']['input'];
};

export type AwardProductDiscount = {
  __typename: 'AwardProductDiscount';
  eligibleProductGroups: Array<ProductGroup>;
  percentDiscount: Scalars['Int']['output'];
  purchaseThreshold: Scalars['Int']['output'];
};

export type AwardProductDiscountInput = {
  eligibleProductGroupIds: Array<Scalars['ID']['input']>;
  percentDiscount: Scalars['Int']['input'];
  purchaseThreshold: Scalars['Int']['input'];
};

export type AwardRandomPrizeInput = {
  awards: Array<RandomAwardConfigInput>;
};

export type AwardTransactionMoneyDiscount = {
  __typename: 'AwardTransactionMoneyDiscount';
  moneyDiscount: Scalars['Int']['output'];
};

export type AwardTransactionMoneyDiscountInput = {
  moneyDiscount: Scalars['Int']['input'];
};

export type AwardTransactionPercentDiscount = {
  __typename: 'AwardTransactionPercentDiscount';
  percentDiscount: Scalars['Int']['output'];
};

export type AwardTransactionPercentDiscountInput = {
  percentDiscount: Scalars['Int']['input'];
};

export type AwardVouchers = {
  __typename: 'AwardVouchers';
  voucherCount: Scalars['Int']['output'];
  voucherExpirationDays?: Maybe<Scalars['Int']['output']>;
  voucheredOffer: Offer;
};

export type AwardVouchersInput = {
  voucherCount: Scalars['Int']['input'];
  voucherExpirationDays?: InputMaybe<Scalars['Int']['input']>;
  voucheredOfferId: Scalars['ID']['input'];
};

export enum Banner_Action_Type {
  Activate = 'ACTIVATE'
}

export enum Banner_Configuration_Provider {
  Allure = 'ALLURE',
  Altria = 'ALTRIA'
}

export enum Banner_Configuration_Type {
  ExternalAd = 'EXTERNAL_AD'
}

export enum Braze_Field_Category {
  Membership = 'MEMBERSHIP',
  Transaction = 'TRANSACTION'
}

export enum Breakage_Point_Rounding {
  RoundDown = 'ROUND_DOWN',
  RoundUp = 'ROUND_UP'
}

export enum Bulk_Update_Location_Result_Failure_Reason_Type {
  LocationNotFound = 'LOCATION_NOT_FOUND'
}

export enum Bulk_Update_Location_Result_Status_Type {
  Success = 'SUCCESS'
}

export type BackofficeHealth = {
  __typename: 'BackofficeHealth';
  lastBackOfficeHealthCheckAt?: Maybe<Scalars['OCDateTime']['output']>;
};

export type Banner = {
  __typename: 'Banner';
  actions?: Maybe<Array<Maybe<BannerAction>>>;
  bannerConfigurationUuid: Scalars['OCUUID']['output'];
  content: BannerContent;
  expiresAt?: Maybe<Scalars['OCDateTime']['output']>;
  externalCampaignId?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  provider?: Maybe<Banner_Configuration_Provider>;
  trackingId: Scalars['ID']['output'];
};

export type BannerAction = BannerActionActivate;

export type BannerActionActivate = {
  __typename: 'BannerActionActivate';
  expiresAt?: Maybe<Scalars['OCDateTime']['output']>;
  startsAt?: Maybe<Scalars['OCDateTime']['output']>;
  type: Banner_Action_Type;
};

export type BannerConfigurationConnection = {
  __typename: 'BannerConfigurationConnection';
  edges?: Maybe<Array<Maybe<BannerConfigurationEdge>>>;
  pageInfo: PageInfo;
};

export type BannerConfigurationEdge = {
  __typename: 'BannerConfigurationEdge';
  cursor: Scalars['OCBase64Cursor']['output'];
  node: BannerConfigurationSummary;
};

export type BannerConfigurationFilter = {
  providerEquals?: InputMaybe<Banner_Configuration_Provider>;
  titleEquals?: InputMaybe<Scalars['String']['input']>;
  typeEquals?: InputMaybe<Banner_Configuration_Type>;
  uuidEquals?: InputMaybe<Scalars['ID']['input']>;
};

export type BannerConfigurationSummary = {
  __typename: 'BannerConfigurationSummary';
  provider?: Maybe<Banner_Configuration_Provider>;
  title: Scalars['String']['output'];
  type?: Maybe<Banner_Configuration_Type>;
  uuid: Scalars['ID']['output'];
};

export type BannerContent = {
  __typename: 'BannerContent';
  imageUrl?: Maybe<Scalars['OCURL']['output']>;
  surgeonGeneralWarning?: Maybe<Scalars['String']['output']>;
  terms?: Maybe<Scalars['String']['output']>;
  title: Scalars['String']['output'];
  title2?: Maybe<Scalars['String']['output']>;
  titleMiddle?: Maybe<Scalars['String']['output']>;
};

export type BannerContext = {
  currentLocation?: InputMaybe<GeoRegionInput>;
};

export type BannerFilter = {
  bannerConfigurationUuidIncludes: Array<Scalars['OCUUID']['input']>;
};

export type BillingAddress = {
  __typename: 'BillingAddress';
  alias?: Maybe<Scalars['String']['output']>;
  city?: Maybe<Scalars['String']['output']>;
  countryCode?: Maybe<Scalars['OCCountryCode2']['output']>;
  geoLocation?: Maybe<GeoLocation>;
  state?: Maybe<Scalars['String']['output']>;
  street1?: Maybe<Scalars['String']['output']>;
  street2?: Maybe<Scalars['String']['output']>;
  uuid: Scalars['ID']['output'];
  zipCode: Scalars['String']['output'];
};

export type Brand = {
  __typename: 'Brand';
  agreements?: Maybe<Array<Maybe<BrandAgreement>>>;
  name: Scalars['String']['output'];
  preferences?: Maybe<Array<Maybe<BrandCustomerPreference>>>;
  supportedApplePayPaymentTypes?: Maybe<Array<Maybe<Payment_Instrument_Type>>>;
  supportedGoogleWalletPaymentTypes?: Maybe<Array<Maybe<Payment_Instrument_Type>>>;
  supportedPaymentTypes?: Maybe<Array<Maybe<Payment_Instrument_Type>>>;
  tenant: Tenant;
  uuid: Scalars['ID']['output'];
};

export type BrandAgreement = {
  __typename: 'BrandAgreement';
  activeAt?: Maybe<Scalars['OCDateTime']['output']>;
  name: Scalars['String']['output'];
  url?: Maybe<Scalars['OCURL']['output']>;
  uuid: Scalars['ID']['output'];
};

export type BrandCustomerPreference = {
  __typename: 'BrandCustomerPreference';
  description?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  uuid: Scalars['ID']['output'];
};

export type BrandCustomerPreferenceUpdate = {
  description?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  uuid: Scalars['ID']['input'];
};

export type BrandFilter = {
  nameContains?: InputMaybe<Scalars['String']['input']>;
  nameEquals?: InputMaybe<Scalars['String']['input']>;
  tenantContains?: InputMaybe<Scalars['String']['input']>;
  tenantEquals?: InputMaybe<Scalars['String']['input']>;
  uuidContains?: InputMaybe<Array<Scalars['ID']['input']>>;
};

export type BrazeField = {
  __typename: 'BrazeField';
  allowed: Scalars['Boolean']['output'];
  category: Braze_Field_Category;
  createdAt: Scalars['OCDateTime']['output'];
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  updatedAt: Scalars['OCDateTime']['output'];
};

export type BrazeFieldConnection = {
  __typename: 'BrazeFieldConnection';
  edges: Array<BrazeFieldEdge>;
  pageInfo: PageInfo;
};

export type BrazeFieldCreateInput = {
  allowed: Scalars['Boolean']['input'];
  category: Braze_Field_Category;
  name: Scalars['String']['input'];
};

export type BrazeFieldEdge = {
  __typename: 'BrazeFieldEdge';
  cursor: Scalars['ID']['output'];
  node: BrazeField;
};

export type BrazeFieldFilter = {
  allowed?: InputMaybe<Scalars['Boolean']['input']>;
  categoryEquals?: InputMaybe<Braze_Field_Category>;
  nameEquals?: InputMaybe<Scalars['String']['input']>;
};

export type BrazeFieldUpdateInput = {
  allowed?: InputMaybe<Scalars['Boolean']['input']>;
  category?: InputMaybe<Braze_Field_Category>;
  id: Scalars['ID']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
};

export type BulkUpdateLocationResult = BulkUpdateLocationResultFailure | BulkUpdateLocationResultSuccess;

export type BulkUpdateLocationResultFailure = {
  __typename: 'BulkUpdateLocationResultFailure';
  reason: Bulk_Update_Location_Result_Failure_Reason_Type;
};

export type BulkUpdateLocationResultSuccess = {
  __typename: 'BulkUpdateLocationResultSuccess';
  status: Bulk_Update_Location_Result_Status_Type;
};

export enum Category_Restrictions {
  Age = 'AGE',
  Eaiv = 'EAIV'
}

export enum Change_Source {
  CommandCenter = 'COMMAND_CENTER',
  EtlImport = 'ETL_IMPORT',
  Experience = 'EXPERIENCE',
  RetailerConnect = 'RETAILER_CONNECT',
  SqlUpdate = 'SQL_UPDATE'
}

export enum Command_Center_User_Status {
  Disabled = 'DISABLED',
  Enabled = 'ENABLED'
}

export enum Communication_Preference_Mechanism {
  Push = 'PUSH',
  Sms = 'SMS'
}

export enum Communication_Preference_Opt_In_Status {
  NotSet = 'NOT_SET',
  OptedIn = 'OPTED_IN',
  OptedOut = 'OPTED_OUT'
}

export enum Conexxus_Loyalty_Discount_Method {
  AmountOff = 'amountOff',
  AmountOffPpu = 'amountOffPPU',
  NewPrice = 'newPrice',
  PercentOff = 'percentOff'
}

export enum Conexxus_Loyalty_Reward_Limit_Type {
  Quantity = 'quantity',
  Volume = 'volume'
}

export enum Conexxus_Price_Tier {
  Cash = 'cash',
  Credit = 'credit',
  Debit = 'debit',
  Fleet = 'fleet',
  Loyalty = 'loyalty',
  Proprietary = 'proprietary',
  StoredValue = 'storedValue'
}

export enum Constraint_Purchase_Threshold_Counting_Attribute {
  MoneyAmount = 'MONEY_AMOUNT',
  Quantity = 'QUANTITY',
  UnitsCount = 'UNITS_COUNT'
}

export enum Count_Products_By {
  MoneyAmount = 'MONEY_AMOUNT',
  Quantity = 'QUANTITY',
  Visits = 'VISITS'
}

export enum Cpg {
  Altria = 'ALTRIA',
  Circana = 'CIRCANA',
  Msa = 'MSA'
}

export enum CpgManufacturer {
  Altria = 'ALTRIA',
  Rjr = 'RJR'
}

export type CpgManufacturerProgram = {
  __typename: 'CPGManufacturerProgram';
  id: Scalars['ID']['output'];
  manufacturer: CpgManufacturer;
  name: Scalars['String']['output'];
  status: CpgManufacturerProgramStatus;
};

export enum CpgManufacturerProgramStatus {
  Enrolled = 'ENROLLED',
  NotEnrolled = 'NOT_ENROLLED',
  PartiallyEnrolled = 'PARTIALLY_ENROLLED'
}

export type CpgSubmissionStatus = {
  __typename: 'CPGSubmissionStatus';
  cpg: Cpg;
  enabled: Scalars['Boolean']['output'];
};

export type CsrLogin = FeatureConfiguration & {
  __typename: 'CSRLogin';
  authMethod: AuthMethod;
  enabled: Scalars['Boolean']['output'];
};

export type CsrLoginSessionInput = {
  source: CsrLoginSessionSource;
  userUuid: Scalars['OCUUID']['input'];
};

export enum CsrLoginSessionSource {
  CommandCenterUser = 'COMMAND_CENTER_USER'
}

export type CsrMagicLink = {
  __typename: 'CSRMagicLink';
  url: Scalars['OCURL']['output'];
};

export type CsrMagicLinkSessionCreateInput = {
  customerIdentifier: Scalars['String']['input'];
  source: CsrLoginSessionSource;
};

export enum Customer_Request_Type {
  Complaint = 'COMPLAINT',
  Compliment = 'COMPLIMENT',
  Question = 'QUESTION'
}

export enum Customer_Status {
  Active = 'ACTIVE',
  Blacklisted = 'BLACKLISTED',
  FlaggedForReview = 'FLAGGED_FOR_REVIEW',
  Inactive = 'INACTIVE',
  SignedUp = 'SIGNED_UP',
  SignupNotCompleted = 'SIGNUP_NOT_COMPLETED',
  WaitingForVerification = 'WAITING_FOR_VERIFICATION',
  Whitelisted = 'WHITELISTED'
}

export enum Custom_Data_Mode {
  Merge = 'MERGE',
  Replace = 'REPLACE'
}

export type Campaign = {
  __typename: 'Campaign';
  category?: Maybe<Scalars['String']['output']>;
  chain: Chain;
  deleted: Scalars['Boolean']['output'];
  deletedAt?: Maybe<Scalars['OCDateTime']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  externalId?: Maybe<Scalars['ID']['output']>;
  name: Scalars['String']['output'];
  offers: OfferConnection;
  uuid: Scalars['ID']['output'];
};


export type CampaignOffersArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  filter?: InputMaybe<OfferFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<OfferSort>;
};

export type CampaignConnection = {
  __typename: 'CampaignConnection';
  edges: Array<CampaignEdge>;
  pageInfo: PageInfo;
};

export type CampaignCreateInput = {
  category?: InputMaybe<Scalars['String']['input']>;
  chainId: Scalars['ID']['input'];
  description?: InputMaybe<Scalars['String']['input']>;
  externalId?: InputMaybe<Scalars['ID']['input']>;
  name: Scalars['String']['input'];
};

export type CampaignEdge = {
  __typename: 'CampaignEdge';
  cursor: Scalars['ID']['output'];
  node: Campaign;
};

export type CampaignFilter = {
  chainIdEquals?: InputMaybe<Scalars['ID']['input']>;
  deleted?: InputMaybe<Scalars['Boolean']['input']>;
  externalIdEquals?: InputMaybe<Scalars['ID']['input']>;
  marketingContentTitleOrOfferNameContains?: InputMaybe<Scalars['String']['input']>;
  publicationStatusOffersFilter?: InputMaybe<Publication_Status_Type>;
  search?: InputMaybe<Scalars['String']['input']>;
  uuidContains?: InputMaybe<Array<Scalars['ID']['input']>>;
  uuidEquals?: InputMaybe<Scalars['ID']['input']>;
};

export type CampaignUpdateInput = {
  category?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  externalId?: InputMaybe<Scalars['ID']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  uuid: Scalars['ID']['input'];
};

export type CarWashInput = {
  amount: Scalars['Float']['input'];
  posCode: Scalars['String']['input'];
  posCodeModifier: Scalars['String']['input'];
  productCode: Scalars['String']['input'];
};

export type CarWashItem = {
  __typename: 'CarWashItem';
  additionalAttributes?: Maybe<Scalars['OCJSON']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  itemType?: Maybe<Resource_Item_Type>;
  merchandiseCode?: Maybe<Scalars['String']['output']>;
  posCode?: Maybe<Scalars['String']['output']>;
  posCodeFormat?: Maybe<Scalars['String']['output']>;
  posCodeModifier?: Maybe<Scalars['String']['output']>;
  receiptDescription?: Maybe<Scalars['String']['output']>;
  sku: Scalars['String']['output'];
  taxCode?: Maybe<Scalars['String']['output']>;
  unitOfMeasure?: Maybe<Scalars['String']['output']>;
  unitPrice?: Maybe<ItemPrice>;
  uuid: Scalars['ID']['output'];
};

export type CarWashItemConnection = {
  __typename: 'CarWashItemConnection';
  edges?: Maybe<Array<Maybe<CarWashItemEdge>>>;
  pageInfo: PageInfo;
};

export type CarWashItemCreate = {
  additionalAttributes?: InputMaybe<Scalars['OCJSON']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  itemType?: InputMaybe<Resource_Item_Type>;
  merchandiseCode?: InputMaybe<Scalars['String']['input']>;
  posCode?: InputMaybe<Scalars['String']['input']>;
  posCodeFormat?: InputMaybe<Scalars['String']['input']>;
  posCodeModifier?: InputMaybe<Scalars['String']['input']>;
  receiptDescription?: InputMaybe<Scalars['String']['input']>;
  sku?: InputMaybe<Scalars['String']['input']>;
  taxCode?: InputMaybe<Scalars['String']['input']>;
  unitOfMeasure?: InputMaybe<Scalars['String']['input']>;
  unitPrice?: InputMaybe<ItemPriceCreate>;
  uuid?: InputMaybe<Scalars['ID']['input']>;
};

export type CarWashItemEdge = {
  __typename: 'CarWashItemEdge';
  cursor: Scalars['ID']['output'];
  node?: Maybe<CarWashItem>;
};

export type Chain = {
  __typename: 'Chain';
  configuration: ChainConfiguration;
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  rollbackStackingConfig: Scalars['String']['output'];
  rollbackVoucherStackingEnabled: Scalars['Boolean']['output'];
  subBrandConfigurations?: Maybe<Array<SubBrandConfiguration>>;
};

export type ChainConfiguration = {
  __typename: 'ChainConfiguration';
  ageVerificationAvtTransactionThreshold?: Maybe<Scalars['Int']['output']>;
  ageVerificationTransactionEnabled: Scalars['Boolean']['output'];
  ageVerificationTransactionThreshold?: Maybe<Scalars['Int']['output']>;
  allowMultipleTransactionDiscounts?: Maybe<Scalars['Boolean']['output']>;
  allowedPointAdjustmentReasons: Array<PointAdjustmentReason>;
  id: Scalars['ID']['output'];
  manualPointChangeCap?: Maybe<Scalars['Int']['output']>;
  pointExpiration: PointExpiration;
  pointsStrategy: PointsStrategy;
  referralProgramConfiguration?: Maybe<ReferralProgramConfiguration>;
  referralProgramConfigurationEnabled: Scalars['Boolean']['output'];
  returnableOffersConfig: ReturnableOffersConfig;
  returnableOffersDefault: Scalars['Boolean']['output'];
};

export type ChainConnection = {
  __typename: 'ChainConnection';
  edges: Array<ChainEdge>;
  pageInfo: PageInfo;
};

export type ChainEdge = {
  __typename: 'ChainEdge';
  cursor: Scalars['ID']['output'];
  node: Chain;
};

export type ChainFilter = {
  organizationIdEquals?: InputMaybe<Scalars['ID']['input']>;
};

export type ChannelsConfig = {
  __typename: 'ChannelsConfig';
  pushNotificationConfig?: Maybe<PushNotificationConfig>;
  smsConfig?: Maybe<SmsConfig>;
};

export type ChannelsConfigInput = {
  pushNotificationConfig?: InputMaybe<PushNotificationConfigInput>;
  smsConfig?: InputMaybe<SmsConfigInput>;
};

export type ClearActivityLog = {
  activityType?: InputMaybe<Activity_Type>;
  locationId: Scalars['ID']['input'];
};

export type CombinedTransaction = {
  __typename: 'CombinedTransaction';
  loyalty?: Maybe<ActivateTransaction>;
  mobile?: Maybe<Transaction>;
  pointChange?: Maybe<PointChange>;
  startedAt: Scalars['OCDateTime']['output'];
};

export type CommandCenterAppConfig = {
  __typename: 'CommandCenterAppConfig';
  ach?: Maybe<Ach>;
  audienceReportExport: AudienceReportExport;
  csrLogin: CsrLogin;
  driveInsights?: Maybe<DriveInsights>;
  externalIdentityVerification?: Maybe<ExternalIdentityVerification>;
  externalLoyalty?: Maybe<ExternalLoyalty>;
  memberDossier?: Maybe<MemberDossier>;
  mobileTransactionFraudCheck?: Maybe<MobileTransactionFraudCheck>;
  offerEditor?: Maybe<OfferEditorConfig>;
  orderAheadConfig?: Maybe<OrderAheadConfig>;
  retailerConnectRedesignV2?: Maybe<RetailerConnectRedesignV2>;
  retailerConnectTobaccoPerformance?: Maybe<RetailerConnectTobaccoPerformance>;
  scanData?: Maybe<ScanData>;
  storedValue?: Maybe<StoredValueConfig>;
  subBrands?: Maybe<SubBrandsConfig>;
  supportedPaymentTypes?: Maybe<Array<PaymentType>>;
  touchpoint?: Maybe<Touchpoint>;
  triggeredMessages?: Maybe<TriggeredMessages>;
};

export type CommandCenterUser = {
  __typename: 'CommandCenterUser';
  email: Scalars['OCEmailAddress']['output'];
  name?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Command_Center_User_Status>;
  userRole?: Maybe<User_Role>;
  uuid: Scalars['ID']['output'];
};

export type CommandCenterUserConnection = {
  __typename: 'CommandCenterUserConnection';
  edges: Array<CommandCenterUserEdge>;
  pageInfo: PageInfo;
};

export type CommandCenterUserCreateInput = {
  email: Scalars['OCEmailAddress']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
  userRole: User_Role;
};

export type CommandCenterUserDisableInput = {
  email: Scalars['OCEmailAddress']['input'];
};

export type CommandCenterUserEdge = {
  __typename: 'CommandCenterUserEdge';
  cursor: Scalars['ID']['output'];
  node: CommandCenterUser;
};

export type CommandCenterUserEnableInput = {
  email: Scalars['OCEmailAddress']['input'];
};

export type CommandCenterUserFilterInput = {
  emailEquals?: InputMaybe<Scalars['OCEmailAddress']['input']>;
  nameEquals?: InputMaybe<Scalars['String']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  statusEquals?: InputMaybe<Command_Center_User_Status>;
};

export type CommandCenterUserInput = {
  email: Scalars['OCEmailAddress']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
};

export type CommandCenterUserUpdateInput = {
  attributes: Array<InputMaybe<UserAttributes>>;
  email: Scalars['String']['input'];
};

export type CommandOtpRequestInput = {
  identifier: Scalars['String']['input'];
  mode?: InputMaybe<Otp_Mode>;
  returnTo: Scalars['OCURL']['input'];
};

export type CommunicationPreference = {
  __typename: 'CommunicationPreference';
  emailOptIn: Scalars['Boolean']['output'];
  emailOptInAt?: Maybe<Scalars['OCDateTime']['output']>;
  emailOptOutAt?: Maybe<Scalars['OCDateTime']['output']>;
  pushOptIn: Scalars['Boolean']['output'];
  pushOptInAt?: Maybe<Scalars['OCDateTime']['output']>;
  pushOptOutAt?: Maybe<Scalars['OCDateTime']['output']>;
  smsOptIn: Scalars['Boolean']['output'];
  smsOptInAt?: Maybe<Scalars['OCDateTime']['output']>;
  smsOptOutAt?: Maybe<Scalars['OCDateTime']['output']>;
  smsOptOutReason?: Maybe<SmsOptOutReason>;
  subBrandUuid?: Maybe<Scalars['ID']['output']>;
};

export type CommunicationPreferenceUpdateInput = {
  customerUuid: Scalars['ID']['input'];
  emailOptInAt?: InputMaybe<Scalars['OCDateTime']['input']>;
  emailOptOutAt?: InputMaybe<Scalars['OCDateTime']['input']>;
  pushOptInAt?: InputMaybe<Scalars['OCDateTime']['input']>;
  pushOptOutAt?: InputMaybe<Scalars['OCDateTime']['input']>;
  smsOptInAt?: InputMaybe<Scalars['OCDateTime']['input']>;
  smsOptOutAt?: InputMaybe<Scalars['OCDateTime']['input']>;
  subBrandUuid?: InputMaybe<Scalars['ID']['input']>;
};

export enum CompletionRange {
  CustomRange = 'CUSTOM_RANGE',
  Last_6Hours = 'LAST_6_HOURS',
  Last_24Hours = 'LAST_24_HOURS',
  LastHour = 'LAST_HOUR',
  Yesterday = 'YESTERDAY'
}

export type Constraint = ConstraintDaysOfWeek | ConstraintEmailRequired | ConstraintInAudience | ConstraintInStoreOnly | ConstraintLocationInState | ConstraintOrderAheadOnly | ConstraintPaymentInstrument | ConstraintPaymentMethod | ConstraintPreAuth | ConstraintPurchasableEligibility | ConstraintPurchaseThreshold | ConstraintRequiresActivation | ConstraintRequiresTransactionVoucher | ConstraintRequiresVoucher | ConstraintRequiresVoucherAvailableForDiscount | ConstraintStoreLocation | ConstraintStoreLocationGroup | ConstraintSubBrand | ConstraintTimeOfDay;

export type ConstraintConfigurationInput = {
  daysOfWeek?: InputMaybe<ConstraintDaysOfWeekInput>;
  inAudience?: InputMaybe<ConstraintInAudienceInput>;
  isAPreAuthConstraint?: InputMaybe<Scalars['Boolean']['input']>;
  /** @deprecated Replaced by requiresTransactionVoucherConstraintWithConfiguration. */
  isARequiresTransactionVoucherConstraint?: InputMaybe<Scalars['Boolean']['input']>;
  isARequiresVoucherAvailableForDiscountConstraint?: InputMaybe<Scalars['Boolean']['input']>;
  isARequiresVoucherConstraint?: InputMaybe<Scalars['Boolean']['input']>;
  isEmailRequired?: InputMaybe<Scalars['Boolean']['input']>;
  isInStoreOnlyConstraint?: InputMaybe<Scalars['Boolean']['input']>;
  isOrderAheadOnlyConstraint?: InputMaybe<Scalars['Boolean']['input']>;
  locationInState?: InputMaybe<ConstraintLocationInStateInput>;
  paymentInstrument?: InputMaybe<ConstraintPaymentInstrumentInput>;
  paymentMethod?: InputMaybe<ConstraintPaymentMethodInput>;
  purchasableEligibility?: InputMaybe<ConstraintPurchasableEligibilityInput>;
  purchaseThreshold?: InputMaybe<ConstraintPurchaseThresholdInput>;
  requiresActivation?: InputMaybe<ConstraintRequiresActivationInput>;
  requiresTransactionVoucherConstraintWithConfiguration?: InputMaybe<ConstraintRequiresTransactionVoucherInput>;
  storeLocation?: InputMaybe<ConstraintStoreLocationInput>;
  storeLocationGroup?: InputMaybe<ConstraintStoreLocationGroupInput>;
  subBrand?: InputMaybe<ConstraintSubBrandInput>;
  timeOfDay?: InputMaybe<ConstraintTimeOfDayInput>;
};

export type ConstraintCreateInput = {
  configuration: ConstraintConfigurationInput;
  offerId: Scalars['ID']['input'];
};

export type ConstraintDaysOfWeek = {
  __typename: 'ConstraintDaysOfWeek';
  availableWeeklyOnDays: Array<Weekday>;
  id: Scalars['ID']['output'];
  startOfDayTimezone: Scalars['String']['output'];
};

export type ConstraintDaysOfWeekInput = {
  availableWeeklyOnDays: Array<Weekday>;
  startOfDayTimezone: Scalars['String']['input'];
};

export type ConstraintEmailRequired = {
  __typename: 'ConstraintEmailRequired';
  id: Scalars['ID']['output'];
};

export type ConstraintInAudience = {
  __typename: 'ConstraintInAudience';
  audienceId: Scalars['ID']['output'];
  id: Scalars['ID']['output'];
};

export type ConstraintInAudienceInput = {
  audienceId: Scalars['ID']['input'];
};

export type ConstraintInStoreOnly = {
  __typename: 'ConstraintInStoreOnly';
  id: Scalars['ID']['output'];
};

export type ConstraintLocationInState = {
  __typename: 'ConstraintLocationInState';
  id: Scalars['ID']['output'];
  states: Array<Scalars['String']['output']>;
};

export type ConstraintLocationInStateInput = {
  states: Array<Scalars['String']['input']>;
};

export type ConstraintOrderAheadOnly = {
  __typename: 'ConstraintOrderAheadOnly';
  id: Scalars['ID']['output'];
};

export type ConstraintPaymentInstrument = {
  __typename: 'ConstraintPaymentInstrument';
  evaluationMethod: Payment_Instrument_Evaluation_Method;
  id: Scalars['ID']['output'];
  paymentInstruments: Array<Payment_Instrument_Type>;
};

export type ConstraintPaymentInstrumentInput = {
  evaluationMethod: Payment_Instrument_Evaluation_Method;
  paymentInstruments: Array<Payment_Instrument_Type>;
};

export type ConstraintPaymentMethod = {
  __typename: 'ConstraintPaymentMethod';
  evaluationMethod: Payment_Method_Evaluation_Method;
  id: Scalars['ID']['output'];
  paymentMethods: Array<Activate_Payment_Method>;
};

export type ConstraintPaymentMethodInput = {
  evaluationMethod: Payment_Method_Evaluation_Method;
  paymentMethods: Array<Activate_Payment_Method>;
};

export type ConstraintPreAuth = {
  __typename: 'ConstraintPreAuth';
  id: Scalars['ID']['output'];
};

export type ConstraintPurchasableEligibility = {
  __typename: 'ConstraintPurchasableEligibility';
  id: Scalars['ID']['output'];
  ownershipCondition: Ownership_Condition;
  voucheredOffers: Array<Offer>;
};

export type ConstraintPurchasableEligibilityInput = {
  ownershipCondition: Ownership_Condition;
  voucheredOfferIds: Array<Scalars['ID']['input']>;
};

export type ConstraintPurchaseThreshold = {
  __typename: 'ConstraintPurchaseThreshold';
  countProductsBy: Constraint_Purchase_Threshold_Counting_Attribute;
  eligibleProductGroupIds: Array<Scalars['ID']['output']>;
  id: Scalars['ID']['output'];
  threshold: Scalars['Int']['output'];
};

export type ConstraintPurchaseThresholdInput = {
  countProductsBy: Constraint_Purchase_Threshold_Counting_Attribute;
  eligibleProductGroupIds: Array<Scalars['ID']['input']>;
  threshold: Scalars['Int']['input'];
};

export type ConstraintRequiresActivation = {
  __typename: 'ConstraintRequiresActivation';
  allowMultipleFulfillmentsOnActivation: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  mustFulfillWithinDays?: Maybe<Scalars['Int']['output']>;
};

export type ConstraintRequiresActivationInput = {
  allowMultipleFulfillmentsOnActivation?: InputMaybe<Scalars['Boolean']['input']>;
  mustFulfillWithinDays?: InputMaybe<Scalars['Int']['input']>;
};

export type ConstraintRequiresTransactionVoucher = {
  __typename: 'ConstraintRequiresTransactionVoucher';
  allowSingleOfferVoucherStacking?: Maybe<Scalars['Boolean']['output']>;
  breakagePointRounding?: Maybe<Breakage_Point_Rounding>;
  breakageRefund?: Maybe<Scalars['Boolean']['output']>;
  id: Scalars['ID']['output'];
};

export type ConstraintRequiresTransactionVoucherInput = {
  allowSingleOfferVoucherStacking?: InputMaybe<Scalars['Boolean']['input']>;
  breakagePointRounding?: InputMaybe<Breakage_Point_Rounding>;
  breakageRefund?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ConstraintRequiresVoucher = {
  __typename: 'ConstraintRequiresVoucher';
  id: Scalars['ID']['output'];
};

export type ConstraintRequiresVoucherAvailableForDiscount = {
  __typename: 'ConstraintRequiresVoucherAvailableForDiscount';
  id: Scalars['ID']['output'];
};

export type ConstraintStoreLocation = {
  __typename: 'ConstraintStoreLocation';
  evaluationMethod: Store_Location_Evaluation_Method;
  id: Scalars['ID']['output'];
  locations: Array<ActivateLocation>;
};

export type ConstraintStoreLocationGroup = {
  __typename: 'ConstraintStoreLocationGroup';
  id: Scalars['ID']['output'];
  locationGroups: Array<LocationGroup>;
};

export type ConstraintStoreLocationGroupInput = {
  locationGroupIds: Array<Scalars['ID']['input']>;
};

export type ConstraintStoreLocationInput = {
  evaluationMethod: Store_Location_Evaluation_Method;
  locationIds: Array<Scalars['ID']['input']>;
};

export type ConstraintSubBrand = {
  __typename: 'ConstraintSubBrand';
  id: Scalars['ID']['output'];
  subBrandUuids: Array<Scalars['ID']['output']>;
};

export type ConstraintSubBrandInput = {
  subBrandUuids: Array<Scalars['ID']['input']>;
};

export type ConstraintTimeOfDay = {
  __typename: 'ConstraintTimeOfDay';
  availableDailyEndingAtTime: Scalars['OCTime']['output'];
  availableDailyStartingAtTime: Scalars['OCTime']['output'];
  id: Scalars['ID']['output'];
  timezone: Scalars['String']['output'];
};

export type ConstraintTimeOfDayInput = {
  availableDailyEndingAtTime: Scalars['OCTime']['input'];
  availableDailyStartingAtTime: Scalars['OCTime']['input'];
  timezone: Scalars['String']['input'];
};

export type ConstraintUpdateInput = {
  configuration: ConstraintConfigurationInput;
  id: Scalars['ID']['input'];
};

export type ContactPhoneNumber = {
  __typename: 'ContactPhoneNumber';
  alias?: Maybe<Scalars['String']['output']>;
  phoneNumber: Scalars['OCPhoneNumber']['output'];
  phoneType: Phone_Type;
  uuid: Scalars['ID']['output'];
};

export type CreateAudienceBroadcastMessageInput = {
  audienceUuid?: InputMaybe<Scalars['OCUUID']['input']>;
  channelsConfig?: InputMaybe<ChannelsConfigInput>;
  description?: InputMaybe<Scalars['String']['input']>;
  scheduleAt?: InputMaybe<Scalars['OCDateTime']['input']>;
  title: Scalars['String']['input'];
};

export type CreateCsrotpSessionInput = {
  otpChannel?: InputMaybe<Otp_Channel>;
  otpPlatform: Otp_Platform;
  phoneNumber: Scalars['OCPhoneNumber']['input'];
};

export type CreateCsrotpSessionResult = {
  __typename: 'CreateCSROTPSessionResult';
  session: Scalars['String']['output'];
};

export type CreateExternalLoyaltyIdInput = {
  externalProgramId: Scalars['ID']['input'];
  identifier: Scalars['String']['input'];
  membershipId: Scalars['ID']['input'];
};

export type CreateExternalProgramInput = {
  name: Scalars['String']['input'];
};

export type CreateOtpSessionInput = {
  otpChannel?: InputMaybe<Otp_Channel>;
  otpPlatform: Otp_Platform;
  phoneNumber: Scalars['OCPhoneNumber']['input'];
};

export type CreateSiteIssueInput = {
  assignedToUserUuid?: InputMaybe<Scalars['OCUUID']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  jiraCaseId?: InputMaybe<Scalars['String']['input']>;
  siteId: Scalars['String']['input'];
  status?: InputMaybe<Site_Issue_Status>;
  title: Scalars['String']['input'];
};

export type CrvFeeCode = {
  __typename: 'CrvFeeCode';
  codeValue: Scalars['String']['output'];
  feeAmount: Scalars['Float']['output'];
};

export type Currency = {
  __typename: 'Currency';
  code?: Maybe<Scalars['String']['output']>;
  symbol?: Maybe<Scalars['String']['output']>;
};

export type CurrencyInput = {
  code?: InputMaybe<Scalars['String']['input']>;
  symbol?: InputMaybe<Scalars['String']['input']>;
};

export type CustomDataInput = {
  data: Scalars['OCJSON']['input'];
  mode?: InputMaybe<Custom_Data_Mode>;
};

export type Customer = {
  __typename: 'Customer';
  addresses?: Maybe<Array<Maybe<Address>>>;
  agreements?: Maybe<Array<Maybe<CustomerAgreement>>>;
  brands?: Maybe<Array<Maybe<Brand>>>;
  communicationPreference: CommunicationPreference;
  defaultLocation?: Maybe<Location>;
  defaultLocationId?: Maybe<Scalars['Int']['output']>;
  demographics?: Maybe<Demographics>;
  devices?: Maybe<Array<Maybe<CustomerDevice>>>;
  easyRechargeEnabled?: Maybe<Scalars['Boolean']['output']>;
  email?: Maybe<Scalars['OCEmailAddress']['output']>;
  emailVerified: Scalars['Boolean']['output'];
  externalAuthSource?: Maybe<Scalars['String']['output']>;
  hasPasscode?: Maybe<Scalars['Boolean']['output']>;
  hasPasswordSet?: Maybe<Scalars['Boolean']['output']>;
  id: Scalars['Int']['output'];
  identityProviderId?: Maybe<Scalars['ID']['output']>;
  isNewCustomer: Scalars['Boolean']['output'];
  lexisNexisId?: Maybe<Scalars['String']['output']>;
  loginHistory?: Maybe<CustomerLoginAttemptConnection>;
  loyaltyAccounts?: Maybe<Array<Maybe<LoyaltyAccount>>>;
  loyaltyWallet?: Maybe<Array<Maybe<LoyaltyInstrument>>>;
  name?: Maybe<PersonName>;
  paymentWallet?: Maybe<Array<Maybe<PaymentInstrument>>>;
  phoneNumbers?: Maybe<Array<Maybe<ContactPhoneNumber>>>;
  preferences?: Maybe<Array<Maybe<CustomerPreference>>>;
  signUpOrigin?: Maybe<Sign_Up_Origin>;
  status: Customer_Status;
  transactions?: Maybe<TransactionConnection>;
  username: Scalars['String']['output'];
  uuid: Scalars['ID']['output'];
};


export type CustomerLoginHistoryArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<CustomerLoginAttemptFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


export type CustomerTransactionsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<TransactionFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type CustomerAddressCreate = {
  alias?: InputMaybe<Scalars['String']['input']>;
  city?: InputMaybe<Scalars['String']['input']>;
  geoLocation?: InputMaybe<GeoLocationCreate>;
  state?: InputMaybe<Scalars['String']['input']>;
  street1?: InputMaybe<Scalars['String']['input']>;
  street2?: InputMaybe<Scalars['String']['input']>;
  zipCode?: InputMaybe<Scalars['String']['input']>;
};

export type CustomerAddressUpdate = {
  alias?: InputMaybe<Scalars['String']['input']>;
  city?: InputMaybe<Scalars['String']['input']>;
  geoLocation?: InputMaybe<GeoLocationUpdate>;
  state?: InputMaybe<Scalars['String']['input']>;
  street1?: InputMaybe<Scalars['String']['input']>;
  street2?: InputMaybe<Scalars['String']['input']>;
  zipCode?: InputMaybe<Scalars['String']['input']>;
};

export type CustomerAgreement = {
  __typename: 'CustomerAgreement';
  agreedAt?: Maybe<Scalars['OCDateTime']['output']>;
  brandAgreement?: Maybe<BrandAgreement>;
  name: Scalars['String']['output'];
  url?: Maybe<Scalars['OCURL']['output']>;
};

export type CustomerAgreementCreate = {
  uuid: Scalars['ID']['input'];
};

export type CustomerConnection = {
  __typename: 'CustomerConnection';
  edges?: Maybe<Array<Maybe<CustomerEdge>>>;
  pageInfo: PageInfo;
};

export type CustomerContact = {
  address?: InputMaybe<Scalars['String']['input']>;
  city?: InputMaybe<Scalars['String']['input']>;
  comment: Scalars['String']['input'];
  countryCode?: InputMaybe<Scalars['OCCountryCode2']['input']>;
  customerRequestType: Customer_Request_Type;
  email?: InputMaybe<Scalars['OCEmailAddress']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
  state?: InputMaybe<Scalars['String']['input']>;
  stationId?: InputMaybe<Scalars['String']['input']>;
};

export type CustomerCreate = {
  addresses?: InputMaybe<Array<InputMaybe<CustomerAddressCreate>>>;
  agreements?: InputMaybe<Array<InputMaybe<CustomerAgreementCreate>>>;
  brandUuid: Scalars['ID']['input'];
  chainId?: InputMaybe<Scalars['ID']['input']>;
  customMemberData?: InputMaybe<Scalars['OCJSON']['input']>;
  demographics?: InputMaybe<CustomerDemographicsCreate>;
  email?: InputMaybe<Scalars['OCEmailAddress']['input']>;
  externalAuthSource?: InputMaybe<Scalars['String']['input']>;
  identityProviderId?: InputMaybe<Scalars['ID']['input']>;
  locationUuid?: InputMaybe<Scalars['OCUUID']['input']>;
  loyaltyAccounts?: InputMaybe<Array<InputMaybe<LoyaltyAccountCreate>>>;
  memberDisplayBrand?: InputMaybe<Scalars['String']['input']>;
  membershipType?: InputMaybe<Membership_Type>;
  name?: InputMaybe<CustomerPersonNameCreate>;
  password?: InputMaybe<Scalars['String']['input']>;
  phoneNumbers?: InputMaybe<Array<InputMaybe<CustomerPhoneNumberCreate>>>;
  preferences?: InputMaybe<Array<InputMaybe<CustomerPreferenceCreate>>>;
  programMemberTermsAcceptanceAt?: InputMaybe<Scalars['OCDateTime']['input']>;
  referralCode?: InputMaybe<Scalars['String']['input']>;
  signUpOrigin?: InputMaybe<Sign_Up_Origin>;
  skipMessaging?: InputMaybe<Scalars['Boolean']['input']>;
  username: Scalars['String']['input'];
};

export type CustomerCreateVerify = {
  otp: Otp;
};

export type CustomerDemographicsCreate = {
  birthday?: InputMaybe<Scalars['OCDate']['input']>;
  customDemographics?: InputMaybe<Scalars['OCJSON']['input']>;
  gender?: InputMaybe<Scalars['String']['input']>;
  zipCode?: InputMaybe<Scalars['String']['input']>;
};

export type CustomerDemographicsUpdate = {
  birthday?: InputMaybe<Scalars['OCDate']['input']>;
  customDemographics?: InputMaybe<Scalars['OCJSON']['input']>;
  gender?: InputMaybe<Scalars['String']['input']>;
  zipCode?: InputMaybe<Scalars['String']['input']>;
};

export type CustomerDevice = {
  __typename: 'CustomerDevice';
  additionalInfo?: Maybe<Scalars['OCJSON']['output']>;
  alias: Scalars['String']['output'];
  deviceId: Scalars['String']['output'];
  deviceType: Device_Type;
  osType?: Maybe<Scalars['String']['output']>;
  osVersion?: Maybe<Scalars['String']['output']>;
  signature?: Maybe<Scalars['String']['output']>;
};

export type CustomerDeviceFilter = {
  aliasEquals?: InputMaybe<Scalars['String']['input']>;
  deviceIDEquals?: InputMaybe<Scalars['String']['input']>;
};

export type CustomerDeviceInput = {
  additionalInfo?: InputMaybe<Scalars['OCJSON']['input']>;
  alias: Scalars['String']['input'];
  deviceId: Scalars['String']['input'];
  deviceType: Device_Type;
  osType?: InputMaybe<Scalars['String']['input']>;
  osVersion?: InputMaybe<Scalars['String']['input']>;
  signature?: InputMaybe<Scalars['String']['input']>;
};

export type CustomerEdge = {
  __typename: 'CustomerEdge';
  cursor: Scalars['ID']['output'];
  node?: Maybe<CustomerSummary>;
};

export type CustomerFeedback = {
  comment?: InputMaybe<Scalars['String']['input']>;
  rating: Scalars['Int']['input'];
};

export type CustomerFilter = {
  emailEquals?: InputMaybe<Scalars['OCEmailAddress']['input']>;
  searchQuery?: InputMaybe<SearchQuery>;
  statusEquals?: InputMaybe<Customer_Status>;
  usernameEquals?: InputMaybe<Scalars['String']['input']>;
  uuidEquals?: InputMaybe<Scalars['ID']['input']>;
};

export type CustomerLoginAttempt = {
  __typename: 'CustomerLoginAttempt';
  device?: Maybe<CustomerDevice>;
  loginAt: Scalars['OCDateTime']['output'];
  loginLocation?: Maybe<GeoLocation>;
  wasSuccessful: Scalars['Boolean']['output'];
};

export type CustomerLoginAttemptConnection = {
  __typename: 'CustomerLoginAttemptConnection';
  edges?: Maybe<Array<Maybe<CustomerLoginAttemptEdge>>>;
  pageInfo: PageInfo;
};

export type CustomerLoginAttemptEdge = {
  __typename: 'CustomerLoginAttemptEdge';
  cursor: Scalars['ID']['output'];
  node?: Maybe<CustomerLoginAttempt>;
};

export type CustomerLoginAttemptFilter = {
  device?: InputMaybe<CustomerDeviceFilter>;
  loginAtMax?: InputMaybe<Scalars['OCDateTime']['input']>;
  loginAtMin?: InputMaybe<Scalars['OCDateTime']['input']>;
  loginLocation?: InputMaybe<GeoLocationFilter>;
  wasSuccessful?: InputMaybe<Scalars['Boolean']['input']>;
};

export type CustomerLoyaltyInstrumentCreate = {
  accountNumber: Scalars['String']['input'];
  alias: Scalars['String']['input'];
};

export type CustomerLoyaltyInstrumentUpdate = {
  alias: Scalars['String']['input'];
};

export type CustomerOtpRequest = {
  channel?: InputMaybe<Otp_Channel>;
  identifier: Scalars['String']['input'];
  mode?: InputMaybe<Otp_Mode>;
};

export type CustomerOtpVerify = {
  otp: Otp;
};

export type CustomerPassword = {
  password: Scalars['String']['input'];
};

export type CustomerPasswordChange = {
  newPassword: CustomerPassword;
  oldPassword: CustomerPassword;
};

export type CustomerPasswordCredentials = {
  password: CustomerPassword;
  username: CustomerUsername;
};

export type CustomerPasswordReset = {
  newPassword: CustomerPassword;
};

export type CustomerPasswordResetByOtpVerify = {
  otp: Otp;
};

export type CustomerPasswordResetPaymentInstrumentVerify = {
  expiration: PaymentInstrumentExpirationInput;
};

export type CustomerPasswordSet = {
  newPassword: CustomerPassword;
};

export type CustomerPaymentInstrumentCreate = {
  accountNumber?: InputMaybe<Scalars['String']['input']>;
  address?: InputMaybe<CustomerAddressCreate>;
  alias?: InputMaybe<Scalars['String']['input']>;
  encryptedPaymentInstrumentDetails?: InputMaybe<Scalars['String']['input']>;
  expiration?: InputMaybe<CustomerPaymentInstrumentExpirationInput>;
  name?: InputMaybe<PersonNameCreate>;
  nonce?: InputMaybe<Scalars['String']['input']>;
  paymentType?: InputMaybe<Payment_Instrument_Type>;
  setAsDefault?: InputMaybe<Scalars['Boolean']['input']>;
};

export type CustomerPaymentInstrumentCreateInput = {
  customerUuid: Scalars['ID']['input'];
  input: CustomerPaymentInstrumentCreate;
};

export type CustomerPaymentInstrumentExpirationInput = {
  expirationMonth?: InputMaybe<Scalars['String']['input']>;
  expirationYear?: InputMaybe<Scalars['String']['input']>;
};

export type CustomerPaymentInstrumentUpdate = {
  address?: InputMaybe<CustomerAddressUpdate>;
  alias?: InputMaybe<Scalars['String']['input']>;
  expiration?: InputMaybe<CustomerPaymentInstrumentExpirationInput>;
  paymentType?: InputMaybe<Payment_Instrument_Type>;
  uuid: Scalars['ID']['input'];
};

export type CustomerPaymentInstrumentUpdateInput = {
  customerUuid: Scalars['ID']['input'];
  input: CustomerPaymentInstrumentUpdate;
};

export type CustomerPaymentInstrumentVerify = {
  otp: Otp;
};

export type CustomerPaymentInstrumentVerifyInput = {
  customerUuid: Scalars['ID']['input'];
  input: CustomerPaymentInstrumentVerify;
};

export type CustomerPersonNameCreate = {
  first?: InputMaybe<Scalars['String']['input']>;
  last?: InputMaybe<Scalars['String']['input']>;
  middle?: InputMaybe<Scalars['String']['input']>;
  suffix?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type CustomerPersonNameUpdate = {
  first?: InputMaybe<Scalars['String']['input']>;
  last?: InputMaybe<Scalars['String']['input']>;
  middle?: InputMaybe<Scalars['String']['input']>;
  suffix?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type CustomerPhoneNumberCreate = {
  alias?: InputMaybe<Scalars['String']['input']>;
  phoneNumber: Scalars['OCPhoneNumber']['input'];
  phoneType: Phone_Type;
};

export type CustomerPhoneNumberUpdate = {
  alias?: InputMaybe<Scalars['String']['input']>;
  phoneNumber: Scalars['OCPhoneNumber']['input'];
  phoneType: Phone_Type;
  uuid?: InputMaybe<Scalars['ID']['input']>;
};

export type CustomerPinCode = {
  pinCode: Scalars['String']['input'];
};

export type CustomerPinCodeChange = {
  newPinCode: CustomerPinCode;
  oldPinCode: CustomerPinCode;
};

export type CustomerPinCodeCredentials = {
  pinCode: CustomerPinCode;
  username: CustomerUsername;
};

export type CustomerPinCodeSet = {
  pinCode: CustomerPinCode;
};

export type CustomerPinCodeVerify = {
  pinCode: CustomerPinCode;
};

export type CustomerPreference = {
  __typename: 'CustomerPreference';
  preference?: Maybe<BrandCustomerPreference>;
  uuid: Scalars['ID']['output'];
  value?: Maybe<PreferenceValue>;
};

export type CustomerPreferenceCreate = {
  uuid: Scalars['ID']['input'];
  value?: InputMaybe<PreferenceValueCreate>;
};

export type CustomerPreferenceUpdate = {
  preference?: InputMaybe<BrandCustomerPreferenceUpdate>;
  uuid?: InputMaybe<Scalars['ID']['input']>;
  value?: InputMaybe<PreferenceValueUpdate>;
};

export type CustomerRegistrationComplete = {
  acceptAgreement?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  defaultLocationId?: InputMaybe<Scalars['Int']['input']>;
  demographics?: InputMaybe<CustomerDemographicsCreate>;
  email?: InputMaybe<Scalars['OCEmailAddress']['input']>;
  name?: InputMaybe<CustomerPersonNameCreate>;
  preferences?: InputMaybe<Array<InputMaybe<CustomerPreferenceCreate>>>;
};

export type CustomerScanDataOverview = {
  __typename: 'CustomerScanDataOverview';
  cpgSubmissionStatus: Array<Maybe<CpgSubmissionStatus>>;
  lastSubmissionDate: Scalars['OCDate']['output'];
};

export type CustomerSummary = {
  __typename: 'CustomerSummary';
  addresses?: Maybe<Array<Maybe<Address>>>;
  agreements?: Maybe<Array<Maybe<CustomerAgreement>>>;
  defaultLocation?: Maybe<Location>;
  defaultLocationId?: Maybe<Scalars['Int']['output']>;
  demographics?: Maybe<Demographics>;
  devices?: Maybe<Array<Maybe<CustomerDevice>>>;
  email?: Maybe<Scalars['OCEmailAddress']['output']>;
  emailVerified: Scalars['Boolean']['output'];
  hasPasscode?: Maybe<Scalars['Boolean']['output']>;
  id: Scalars['Int']['output'];
  identityProviderId?: Maybe<Scalars['ID']['output']>;
  isNewCustomer?: Maybe<Scalars['Boolean']['output']>;
  loyaltyAccounts?: Maybe<Array<Maybe<LoyaltyAccount>>>;
  name?: Maybe<PersonName>;
  phoneNumbers?: Maybe<Array<Maybe<ContactPhoneNumber>>>;
  preferences?: Maybe<Array<Maybe<CustomerPreference>>>;
  status: Customer_Status;
  username: Scalars['String']['output'];
  uuid: Scalars['ID']['output'];
};

export type CustomerUpdate = {
  addresses?: InputMaybe<Array<InputMaybe<CustomerAddressUpdate>>>;
  customData?: InputMaybe<CustomDataInput>;
  demographics?: InputMaybe<CustomerDemographicsUpdate>;
  displayBrand?: InputMaybe<Scalars['String']['input']>;
  easyRechargeEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  email?: InputMaybe<Scalars['OCEmailAddress']['input']>;
  isNewCustomer?: InputMaybe<Scalars['Boolean']['input']>;
  loyaltyAccounts?: InputMaybe<Array<InputMaybe<LoyaltyAccountUpdate>>>;
  name?: InputMaybe<CustomerPersonNameUpdate>;
  phone?: InputMaybe<Scalars['OCPhoneNumber']['input']>;
  phoneNumbers?: InputMaybe<Array<InputMaybe<CustomerPhoneNumberUpdate>>>;
  preferences?: InputMaybe<Array<InputMaybe<CustomerPreferenceUpdate>>>;
  primaryAddress?: InputMaybe<MembershipPrimaryAddressInput>;
  programTermsAcceptanceAt?: InputMaybe<Scalars['OCDateTime']['input']>;
  signUpOrigin?: InputMaybe<Sign_Up_Origin>;
  username?: InputMaybe<Scalars['String']['input']>;
};

export type CustomerUpdateEaivStatusInput = {
  eaivStatus: Eaiv_Status;
  lexisNexisId?: InputMaybe<Scalars['String']['input']>;
  lexisNexisIdSource?: InputMaybe<Scalars['String']['input']>;
  lexisNexisIdentificationEventId?: InputMaybe<Scalars['String']['input']>;
  statusChangedAt: Scalars['OCDateTime']['input'];
};

export type CustomerUpdateStateInput = {
  ageVerifyAndEaivReset?: InputMaybe<Scalars['Boolean']['input']>;
  payResetThrottle?: InputMaybe<Scalars['Boolean']['input']>;
};

export type CustomerUsername = {
  username: Scalars['String']['input'];
};

export enum Device_Type {
  AlexaSkill = 'ALEXA_SKILL',
  Android = 'ANDROID',
  AndroidTablet = 'ANDROID_TABLET',
  AppServer = 'APP_SERVER',
  ConnectedCar = 'CONNECTED_CAR',
  Desktop = 'DESKTOP',
  Ipad = 'IPAD',
  Iphone = 'IPHONE',
  Pos = 'POS',
  Web = 'WEB'
}

export enum Drive_Insights_Variant {
  V1 = 'V1',
  V2 = 'V2'
}

export enum Drive_Response_Reaction {
  Bad = 'BAD',
  Good = 'GOOD'
}

export type DateRangeInput = {
  endDate: Scalars['OCDateTime']['input'];
  startDate: Scalars['OCDateTime']['input'];
};

export type DeleteExternalLoyaltyIdInput = {
  id: Scalars['ID']['input'];
};

export type DeleteExternalProgramInput = {
  id: Scalars['ID']['input'];
};

export type DeleteSiteIssueInput = {
  uuid: Scalars['OCUUID']['input'];
};

export type DeletionRequestSourceInput = {
  /** @deprecated Use X-Command-Center-User header instead. */
  commandCenterUser?: InputMaybe<CommandCenterUserInput>;
  membershipUuid?: InputMaybe<Scalars['ID']['input']>;
};

export type Demographics = {
  __typename: 'Demographics';
  birthday?: Maybe<Scalars['OCDate']['output']>;
  customDemographics?: Maybe<Scalars['OCJSON']['output']>;
  gender?: Maybe<Scalars['String']['output']>;
  zipCode?: Maybe<Scalars['String']['output']>;
};

export type DispatchBannerActionInput = {
  actionType: Banner_Action_Type;
  bannerId: Scalars['ID']['input'];
};

export type DispatchBannerActionPayload = {
  __typename: 'DispatchBannerActionPayload';
  success: Scalars['Boolean']['output'];
};

export type DisplayCategory = {
  __typename: 'DisplayCategory';
  /** @deprecated Replaced by categoryRestrictions. */
  ageRestricted?: Maybe<Scalars['Boolean']['output']>;
  bannerIds?: Maybe<Array<Scalars['ID']['output']>>;
  categoryRestrictions?: Maybe<Category_Restrictions>;
  chainId: Scalars['ID']['output'];
  createdAt: Scalars['OCDateTime']['output'];
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  offers: OfferConnection;
  rank: Scalars['Int']['output'];
  shouldLazyLoadBanners?: Maybe<Scalars['Boolean']['output']>;
};


export type DisplayCategoryOffersArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  filter?: InputMaybe<OfferFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type DisplayCategoryConnection = {
  __typename: 'DisplayCategoryConnection';
  edges: Array<DisplayCategoryEdge>;
  pageInfo: PageInfo;
};

export type DisplayCategoryCreateInput = {
  ageRestricted?: InputMaybe<Scalars['Boolean']['input']>;
  bannerIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  categoryRestrictions?: InputMaybe<Category_Restrictions>;
  chainId: Scalars['ID']['input'];
  id?: InputMaybe<Scalars['ID']['input']>;
  name: Scalars['String']['input'];
  rank?: InputMaybe<Scalars['Int']['input']>;
  shouldLazyLoadBanners?: InputMaybe<Scalars['Boolean']['input']>;
};

export type DisplayCategoryEdge = {
  __typename: 'DisplayCategoryEdge';
  cursor: Scalars['ID']['output'];
  node: DisplayCategory;
};

export type DisplayCategoryFilter = {
  chainIdEquals?: InputMaybe<Scalars['ID']['input']>;
  idEquals?: InputMaybe<Scalars['ID']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  uuidContains?: InputMaybe<Array<Scalars['ID']['input']>>;
};

export type DisplayCategoryUpdateInput = {
  ageRestricted?: InputMaybe<Scalars['Boolean']['input']>;
  bannerIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  categoryRestrictions?: InputMaybe<Category_Restrictions>;
  id: Scalars['ID']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
  rank?: InputMaybe<Scalars['Int']['input']>;
  shouldLazyLoadBanners?: InputMaybe<Scalars['Boolean']['input']>;
};

export type DonationBucket = {
  __typename: 'DonationBucket';
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
};

export type DonationBucketConnection = {
  __typename: 'DonationBucketConnection';
  edges: Array<DonationBucketEdge>;
  pageInfo: PageInfo;
};

export type DonationBucketCreateInput = {
  name: Scalars['String']['input'];
};

export type DonationBucketEdge = {
  __typename: 'DonationBucketEdge';
  cursor: Scalars['ID']['output'];
  node: DonationBucket;
};

export type DonationBucketFilter = {
  idEquals?: InputMaybe<Scalars['ID']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
};

export type DonationBucketUpdateInput = {
  id: Scalars['ID']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
};

export type DriveConversation = {
  __typename: 'DriveConversation';
  createdAt: Scalars['OCDateTime']['output'];
  id: Scalars['ID']['output'];
  prompts: Array<DrivePrompt>;
  responses: Array<DriveResponse>;
};

export type DriveConversationConnection = {
  __typename: 'DriveConversationConnection';
  edges: Array<DriveConversationEdge>;
  pageInfo: PageInfo;
};

export type DriveConversationEdge = {
  __typename: 'DriveConversationEdge';
  cursor: Scalars['OCBase64Cursor']['output'];
  node: DriveConversation;
};

export type DriveConversationFilter = {
  idEquals?: InputMaybe<Scalars['ID']['input']>;
};

export type DriveInsights = FeatureConfiguration & {
  __typename: 'DriveInsights';
  config?: Maybe<DriveInsightsConfig>;
  enabled: Scalars['Boolean']['output'];
};

export type DriveInsightsConfig = DriveInsightsConfigV1 | DriveInsightsConfigV2;

export type DriveInsightsConfigV1 = {
  __typename: 'DriveInsightsConfigV1';
  variant: Drive_Insights_Variant;
};

export type DriveInsightsConfigV2 = {
  __typename: 'DriveInsightsConfigV2';
  url: Scalars['OCURL']['output'];
  variant: Drive_Insights_Variant;
};

export type DrivePrompt = {
  __typename: 'DrivePrompt';
  content: Scalars['String']['output'];
  conversationId: Scalars['ID']['output'];
  createdAt: Scalars['OCDateTime']['output'];
  id: Scalars['ID']['output'];
};

export type DriveResponse = {
  __typename: 'DriveResponse';
  complete: Scalars['Boolean']['output'];
  content: Scalars['String']['output'];
  conversationId: Scalars['ID']['output'];
  createdAt: Scalars['OCDateTime']['output'];
  id: Scalars['ID']['output'];
  lastChunkNumber?: Maybe<Scalars['Int']['output']>;
  promptId: Scalars['ID']['output'];
  reaction?: Maybe<Drive_Response_Reaction>;
};

export type DriveResponseChunk = {
  __typename: 'DriveResponseChunk';
  chunkNumber: Scalars['Int']['output'];
  complete: Scalars['Boolean']['output'];
  content: Scalars['String']['output'];
  conversationId: Scalars['ID']['output'];
  responseId: Scalars['ID']['output'];
};

export type DriveSendPromptInput = {
  conversationId?: InputMaybe<Scalars['ID']['input']>;
  message: Scalars['String']['input'];
};

export type DriveSetReactionInput = {
  reaction?: InputMaybe<Drive_Response_Reaction>;
  responseId: Scalars['ID']['input'];
};

export enum Eaiv_Action_Type {
  AgeVerificationStart = 'AGE_VERIFICATION_START',
  AvtIdentityVerificationSubmit = 'AVT_IDENTITY_VERIFICATION_SUBMIT',
  IdentityVerificationStart = 'IDENTITY_VERIFICATION_START',
  IdentityVerificationSubmit = 'IDENTITY_VERIFICATION_SUBMIT'
}

export enum Eaiv_Additional_Prompt_Fields {
  EaivPromptForAdditionalAddress = 'EAIV_PROMPT_FOR_ADDITIONAL_ADDRESS',
  EaivPromptForSsn4 = 'EAIV_PROMPT_FOR_SSN4',
  EaivPromptForSsn4OrAdditionalAddress = 'EAIV_PROMPT_FOR_SSN4_OR_ADDITIONAL_ADDRESS'
}

export enum Eaiv_Age_Verification_Failed {
  LimitReached = 'LIMIT_REACHED',
  VerificationFailed = 'VERIFICATION_FAILED'
}

export enum Eaiv_Identity_Verification_Failed {
  LimitReached = 'LIMIT_REACHED',
  VerificationFailed = 'VERIFICATION_FAILED'
}

export enum Eaiv_Result {
  Failure = 'FAILURE',
  Success = 'SUCCESS'
}

export enum Eaiv_Status {
  AgeAndIdentityVerified = 'AGE_AND_IDENTITY_VERIFIED',
  AgeVerified = 'AGE_VERIFIED',
  IdentityVerified = 'IDENTITY_VERIFIED',
  NotAgeOrIdentityVerified = 'NOT_AGE_OR_IDENTITY_VERIFIED'
}

export enum Earning_Mechanism_Product_Counting_Attribute {
  MoneyAmount = 'MONEY_AMOUNT',
  Quantity = 'QUANTITY',
  UnitsCount = 'UNITS_COUNT'
}

export enum Earning_Mechanism_Product_Counting_Rounding_Strategy {
  Down = 'DOWN',
  HalfUp = 'HALF_UP',
  Raw = 'RAW'
}

export enum Earning_Mechanism_Typename {
  EarningMechanismExternalFulfillment = 'EarningMechanismExternalFulfillment',
  EarningMechanismLoyaltyEvent = 'EarningMechanismLoyaltyEvent',
  EarningMechanismMembershipEvent = 'EarningMechanismMembershipEvent',
  EarningMechanismPointSpend = 'EarningMechanismPointSpend',
  EarningMechanismProductDiscount = 'EarningMechanismProductDiscount',
  EarningMechanismProductPurchase = 'EarningMechanismProductPurchase',
  EarningMechanismPromocodes = 'EarningMechanismPromocodes',
  EarningMechanismSpinWheelGame = 'EarningMechanismSpinWheelGame',
  EarningMechanismStoredValueDiscount = 'EarningMechanismStoredValueDiscount',
  EarningMechanismTotalEligiblePurchase = 'EarningMechanismTotalEligiblePurchase',
  EarningMechanismTotalEligiblePurchaseOverTime = 'EarningMechanismTotalEligiblePurchaseOverTime',
  EarningMechanismTotalSpendOnTransaction = 'EarningMechanismTotalSpendOnTransaction',
  EarningMechanismTotalSpendOverTime = 'EarningMechanismTotalSpendOverTime',
  EarningMechanismTransactionDiscount = 'EarningMechanismTransactionDiscount',
  EarningMechanismVarietyDiscount = 'EarningMechanismVarietyDiscount',
  EarningMechanismVarietyPurchase = 'EarningMechanismVarietyPurchase',
  EarningMechanismVarietyPurchaseOverTime = 'EarningMechanismVarietyPurchaseOverTime',
  EarningMechanismVisits = 'EarningMechanismVisits'
}

export enum Event_Purchase_Condition_Operator {
  AtLeast = 'AT_LEAST',
  AtMost = 'AT_MOST'
}

export enum Event_Targeting_Condition_Operator {
  IsEqualTo = 'IS_EQUAL_TO',
  IsGreaterThan = 'IS_GREATER_THAN',
  IsGreaterThanOrEqualTo = 'IS_GREATER_THAN_OR_EQUAL_TO',
  IsLessThan = 'IS_LESS_THAN',
  IsLessThanOrEqualTo = 'IS_LESS_THAN_OR_EQUAL_TO'
}

export enum Event_Types {
  MembershipCreated = 'MEMBERSHIP_CREATED',
  OfferFulfillment = 'OFFER_FULFILLMENT',
  PointsBurned = 'POINTS_BURNED',
  PointsEarned = 'POINTS_EARNED',
  RedemptionCreated = 'REDEMPTION_CREATED',
  Revenue = 'REVENUE',
  TransactionCreated = 'TRANSACTION_CREATED'
}

export enum Expected_Prompt_Response_Type {
  Boolean = 'BOOLEAN',
  Integer = 'INTEGER',
  String = 'STRING'
}

export enum External_Identity_Verification_Operator {
  InAll = 'IN_ALL',
  InAny = 'IN_ANY',
  NotInAll = 'NOT_IN_ALL'
}

export enum External_Loyalty_Manual_Offers_Pulling_Job_Name {
  AltriaManualOffersImport = 'ALTRIA_MANUAL_OFFERS_IMPORT',
  AltriaManualOffersNextImport = 'ALTRIA_MANUAL_OFFERS_NEXT_IMPORT',
  RjrManualOffersImport = 'RJR_MANUAL_OFFERS_IMPORT',
  RjrManualOffersNextImport = 'RJR_MANUAL_OFFERS_NEXT_IMPORT'
}

export enum External_Loyalty_Manual_Offer_Activate_Status {
  Published = 'PUBLISHED',
  Unpublished = 'UNPUBLISHED'
}

export enum External_Loyalty_Manual_Offer_Manufacturer {
  Altria = 'ALTRIA',
  Rjr = 'RJR'
}

export enum External_Loyalty_Manual_Offer_Period {
  Current = 'CURRENT',
  Next = 'NEXT'
}

export enum External_Loyalty_Manual_Offer_Status {
  Created = 'CREATED',
  Errored = 'ERRORED',
  ManualUpdated = 'MANUAL_UPDATED',
  Outdated = 'OUTDATED',
  PendingToCreate = 'PENDING_TO_CREATE',
  Ready = 'READY'
}

export type EaivAgeVerification = {
  __typename: 'EaivAgeVerification';
  isAvailable: Scalars['Boolean']['output'];
};

export type EaivAgeVerificationAddress = {
  address1: Scalars['String']['input'];
  address2?: InputMaybe<Scalars['String']['input']>;
  city: Scalars['String']['input'];
  state: Scalars['String']['input'];
  zipCode: Scalars['String']['input'];
};

export enum EaivAgeVerificationRequestStatusType {
  Success = 'Success'
}

export type EaivAgeVerificationRequireAdditionalPrompt = {
  __typename: 'EaivAgeVerificationRequireAdditionalPrompt';
  prompt: Eaiv_Additional_Prompt_Fields;
};

export type EaivAgeVerificationResultFailed = {
  __typename: 'EaivAgeVerificationResultFailed';
  reason: Eaiv_Age_Verification_Failed;
};

export type EaivAgeVerificationStartInput = {
  /** @deprecated Use addresses object instead */
  address1?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Use addresses object instead */
  address2?: InputMaybe<Scalars['String']['input']>;
  addresses?: InputMaybe<Array<InputMaybe<EaivAgeVerificationAddress>>>;
  birthdate: Scalars['OCDate']['input'];
  /** @deprecated Use addresses object instead */
  city?: InputMaybe<Scalars['String']['input']>;
  firstName: Scalars['String']['input'];
  lastName: Scalars['String']['input'];
  phoneNumber: Scalars['String']['input'];
  ssn4?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Use addresses object instead */
  state?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Use addresses object instead */
  zipCode?: InputMaybe<Scalars['String']['input']>;
};

export type EaivAgeVerificationStartResult = EaivAgeVerificationRequireAdditionalPrompt | EaivAgeVerificationResultFailed | EaivAgeVerificationStartResultSuccess;

export type EaivAgeVerificationStartResultSuccess = {
  __typename: 'EaivAgeVerificationStartResultSuccess';
  status: EaivAgeVerificationRequestStatusType;
};

export type EaivAuditConnection = {
  __typename: 'EaivAuditConnection';
  edges: Array<EaivAuditEdge>;
  pageInfo: PageInfo;
};

export type EaivAuditEdge = {
  __typename: 'EaivAuditEdge';
  cursor: Scalars['OCBase64Cursor']['output'];
  node: EaivAuditTrail;
};

export type EaivAuditLexisNexisRequestData = {
  __typename: 'EaivAuditLexisNexisRequestData';
  lnChecks?: Maybe<Scalars['OCJSON']['output']>;
  lnConversationId?: Maybe<Scalars['String']['output']>;
  lnLexId?: Maybe<Scalars['String']['output']>;
  lnReference?: Maybe<Scalars['String']['output']>;
  lnRequestId?: Maybe<Scalars['String']['output']>;
  lnResultCode?: Maybe<Scalars['String']['output']>;
  lnTransactionInformation?: Maybe<Scalars['OCJSON']['output']>;
  lnTransactionReasonCode?: Maybe<Scalars['String']['output']>;
  lnTransactionStatus?: Maybe<Scalars['String']['output']>;
};

export type EaivAuditRequestData = EaivAuditLexisNexisRequestData;

export type EaivAuditTrail = {
  __typename: 'EaivAuditTrail';
  actionType: Eaiv_Action_Type;
  createdAt: Scalars['OCDateTime']['output'];
  customerUuid: Scalars['OCUUID']['output'];
  reasonMessage?: Maybe<Scalars['String']['output']>;
  requestData: EaivAuditRequestData;
  result: Eaiv_Result;
  updatedAt: Scalars['OCDateTime']['output'];
  uuid: Scalars['OCUUID']['output'];
};

export type EaivAuditTrailFilter = {
  actionType?: InputMaybe<Eaiv_Action_Type>;
  customerUuid?: InputMaybe<Scalars['OCUUID']['input']>;
  result?: InputMaybe<Eaiv_Result>;
};

export type EaivIdentityVerification = {
  __typename: 'EaivIdentityVerification';
  isAvailable: Scalars['Boolean']['output'];
};

export type EaivIdentityVerificationAddress = {
  address1: Scalars['String']['input'];
  address2?: InputMaybe<Scalars['String']['input']>;
  city: Scalars['String']['input'];
  state: Scalars['String']['input'];
  zipCode: Scalars['String']['input'];
};

export type EaivIdentityVerificationAnswerInput = {
  answerValue: Scalars['String']['input'];
  questionId: Scalars['String']['input'];
};

export type EaivIdentityVerificationAnswerSetInput = {
  answers: Array<EaivIdentityVerificationAnswerInput>;
  questionSetId: Scalars['String']['input'];
};

export type EaivIdentityVerificationChoiceQuestion = {
  __typename: 'EaivIdentityVerificationChoiceQuestion';
  choices: Array<EaivIdentityVerificationChoiceQuestionOption>;
  helpText?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  text: Scalars['String']['output'];
};

export type EaivIdentityVerificationChoiceQuestionOption = {
  __typename: 'EaivIdentityVerificationChoiceQuestionOption';
  id: Scalars['String']['output'];
  text: Scalars['String']['output'];
};

export type EaivIdentityVerificationQuestion = EaivIdentityVerificationChoiceQuestion;

export type EaivIdentityVerificationQuestionSet = {
  __typename: 'EaivIdentityVerificationQuestionSet';
  id: Scalars['String']['output'];
  questions: Array<EaivIdentityVerificationQuestion>;
};

export enum EaivIdentityVerificationRequestStatusType {
  Success = 'Success'
}

export type EaivIdentityVerificationRequireAdditionalPrompt = {
  __typename: 'EaivIdentityVerificationRequireAdditionalPrompt';
  prompt: Eaiv_Additional_Prompt_Fields;
};

export type EaivIdentityVerificationResultFailed = {
  __typename: 'EaivIdentityVerificationResultFailed';
  reason?: Maybe<Eaiv_Identity_Verification_Failed>;
};

export type EaivIdentityVerificationStartInput = {
  /** @deprecated Use addresses object instead */
  address1?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Use addresses object instead */
  address2?: InputMaybe<Scalars['String']['input']>;
  addresses?: InputMaybe<Array<InputMaybe<EaivIdentityVerificationAddress>>>;
  birthdate: Scalars['OCDate']['input'];
  /** @deprecated Use addresses object instead */
  city?: InputMaybe<Scalars['String']['input']>;
  firstName: Scalars['String']['input'];
  lastName: Scalars['String']['input'];
  phoneNumber: Scalars['String']['input'];
  ssn4?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Use addresses object instead */
  state?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Use addresses object instead */
  zipCode?: InputMaybe<Scalars['String']['input']>;
};

export type EaivIdentityVerificationStartResult = EaivIdentityVerificationRequireAdditionalPrompt | EaivIdentityVerificationResultFailed | EaivIdentityVerificationStartResultSuccess;

export type EaivIdentityVerificationStartResultSuccess = {
  __typename: 'EaivIdentityVerificationStartResultSuccess';
  conversationId: Scalars['String']['output'];
  questionSet: EaivIdentityVerificationQuestionSet;
};

export type EaivIdentityVerificationSubmitInput = {
  answerSet: EaivIdentityVerificationAnswerSetInput;
  conversationId: Scalars['String']['input'];
};

export type EaivIdentityVerificationSubmitResult = EaivIdentityVerificationResultFailed | EaivIdentityVerificationSubmitResultContinue | EaivIdentityVerificationSubmitResultSuccess;

export type EaivIdentityVerificationSubmitResultContinue = {
  __typename: 'EaivIdentityVerificationSubmitResultContinue';
  conversationId: Scalars['String']['output'];
  questionSet: EaivIdentityVerificationQuestionSet;
};

export type EaivIdentityVerificationSubmitResultSuccess = {
  __typename: 'EaivIdentityVerificationSubmitResultSuccess';
  status: EaivIdentityVerificationRequestStatusType;
};

export type EarningMechanism = EarningMechanismExternalFulfillment | EarningMechanismLoyaltyEvent | EarningMechanismMembershipEvent | EarningMechanismPointSpend | EarningMechanismProductDiscount | EarningMechanismProductPurchase | EarningMechanismPromocodes | EarningMechanismSpinWheelGame | EarningMechanismStoredValueDiscount | EarningMechanismTotalEligiblePurchase | EarningMechanismTotalEligiblePurchaseOverTime | EarningMechanismTotalSpendOnTransaction | EarningMechanismTotalSpendOverTime | EarningMechanismTransactionDiscount | EarningMechanismVarietyDiscount | EarningMechanismVarietyPurchase | EarningMechanismVarietyPurchaseOverTime | EarningMechanismVisits;

export type EarningMechanismConfigurationInput = {
  externalFulfillment?: InputMaybe<EarningMechanismExternalFulfillmentInput>;
  loyaltyEvent?: InputMaybe<EarningMechanismLoyaltyEventInput>;
  membershipEvent?: InputMaybe<EarningMechanismMembershipEventInput>;
  pointSpend?: InputMaybe<EarningMechanismPointSpendInput>;
  productDiscount?: InputMaybe<EarningMechanismProductDiscountInput>;
  productPurchase?: InputMaybe<EarningMechanismProductPurchaseInput>;
  promocodes?: InputMaybe<EarningMechanismPromocodesInput>;
  spinWheelGame?: InputMaybe<EarningMechanismSpinWheelGameInput>;
  storedValueDiscount?: InputMaybe<EarningMechanismStoredValueDiscountInput>;
  totalEligiblePurchase?: InputMaybe<EarningMechanismTotalEligiblePurchaseInput>;
  totalEligiblePurchaseOverTime?: InputMaybe<EarningMechanismTotalEligiblePurchaseOverTimeInput>;
  totalSpendOnTransaction?: InputMaybe<EarningMechanismTotalSpendOnTransactionInput>;
  totalSpendOverTime?: InputMaybe<EarningMechanismTotalSpendOverTimeInput>;
  transactionDiscount?: InputMaybe<EarningMechanismTransactionDiscountInput>;
  varietyDiscount?: InputMaybe<EarningMechanismVarietyDiscountInput>;
  varietyPurchase?: InputMaybe<EarningMechanismVarietyPurchaseInput>;
  varietyPurchaseOverTime?: InputMaybe<EarningMechanismVarietyPurchaseOverTimeInput>;
  visits?: InputMaybe<EarningMechanismVisitsInput>;
};

export type EarningMechanismCreateInput = {
  configuration: EarningMechanismConfigurationInput;
  offerId: Scalars['ID']['input'];
};

export type EarningMechanismExternalFulfillment = {
  __typename: 'EarningMechanismExternalFulfillment';
  award?: Maybe<AwardPointsOrVouchers>;
  disableFulfilledOfferIdsEnforcement?: Maybe<Scalars['Boolean']['output']>;
  id: Scalars['ID']['output'];
};

export type EarningMechanismExternalFulfillmentInput = {
  awardPoints?: InputMaybe<AwardPointsInput>;
  awardVouchers?: InputMaybe<AwardVouchersInput>;
  disableFulfilledOfferIdsEnforcement?: InputMaybe<Scalars['Boolean']['input']>;
};

export type EarningMechanismLoyaltyEvent = {
  __typename: 'EarningMechanismLoyaltyEvent';
  award?: Maybe<AwardExternalPointsOrPointsOrVouchers>;
  eventType: Scalars['String']['output'];
  id: Scalars['ID']['output'];
};

export type EarningMechanismLoyaltyEventInput = {
  awardExternalPoints?: InputMaybe<AwardExternalPointsInput>;
  awardPoints?: InputMaybe<AwardPointsInput>;
  awardVouchers?: InputMaybe<AwardVouchersInput>;
  eventType: Scalars['String']['input'];
};

export type EarningMechanismMembershipEvent = {
  __typename: 'EarningMechanismMembershipEvent';
  award: AwardPointsOrVouchers;
  eventType: Membership_Event_Type;
  id: Scalars['ID']['output'];
};

export type EarningMechanismMembershipEventInput = {
  awardPoints?: InputMaybe<AwardPointsInput>;
  awardVouchers?: InputMaybe<AwardVouchersInput>;
  eventType: Membership_Event_Type;
};

export type EarningMechanismPointSpend = {
  __typename: 'EarningMechanismPointSpend';
  allowedForNewMember?: Maybe<Scalars['Boolean']['output']>;
  award: AwardVouchers;
  id: Scalars['ID']['output'];
  offerIsReturnable?: Maybe<Scalars['Boolean']['output']>;
  pointCost: Scalars['Int']['output'];
};

export type EarningMechanismPointSpendInput = {
  allowedForNewMember?: InputMaybe<Scalars['Boolean']['input']>;
  awardVouchers: AwardVouchersInput;
  offerIsReturnable?: InputMaybe<Scalars['Boolean']['input']>;
  pointCost: Scalars['Int']['input'];
};

export type EarningMechanismProductCriteria = {
  __typename: 'EarningMechanismProductCriteria';
  countProductsBy: Earning_Mechanism_Product_Counting_Attribute;
  eligibleProductGroups: Array<ProductGroup>;
  id?: Maybe<Scalars['ID']['output']>;
  purchaseThreshold: Scalars['Float']['output'];
};

export type EarningMechanismProductCriteriaInput = {
  countProductsBy: Earning_Mechanism_Product_Counting_Attribute;
  eligibleProductGroupIds: Array<Scalars['ID']['input']>;
  purchaseThreshold: Scalars['Float']['input'];
};

export type EarningMechanismProductDiscount = {
  __typename: 'EarningMechanismProductDiscount';
  allowCarryOver: Scalars['Boolean']['output'];
  award: AwardMoneyDiscountOrPriceOverrideOrBuyAndGet;
  eligibleProductGroups: Array<ProductGroup>;
  id: Scalars['ID']['output'];
  purchaseThreshold: Scalars['Int']['output'];
};

export type EarningMechanismProductDiscountInput = {
  allowCarryOver?: InputMaybe<Scalars['Boolean']['input']>;
  awardBuyAndGet?: InputMaybe<AwardBuyAndGetInput>;
  awardMoneyDiscount?: InputMaybe<AwardMoneyDiscountInput>;
  awardPriceOverride?: InputMaybe<AwardPriceOverrideInput>;
  eligibleProductGroupIds: Array<Scalars['ID']['input']>;
  purchaseThreshold: Scalars['Int']['input'];
};

export type EarningMechanismProductPurchase = {
  __typename: 'EarningMechanismProductPurchase';
  award: AwardPointsOrVouchersOrExternal;
  countProductsBy: Earning_Mechanism_Product_Counting_Attribute;
  eligibleProductGroups: Array<ProductGroup>;
  id: Scalars['ID']['output'];
  purchaseThreshold: Scalars['Float']['output'];
};

export type EarningMechanismProductPurchaseInput = {
  awardExternal?: InputMaybe<AwardExternalInput>;
  awardPoints?: InputMaybe<AwardPointsInput>;
  awardVouchers?: InputMaybe<AwardVouchersInput>;
  countProductsBy: Earning_Mechanism_Product_Counting_Attribute;
  eligibleProductGroupIds: Array<Scalars['ID']['input']>;
  purchaseThreshold: Scalars['Float']['input'];
};

export type EarningMechanismPromocodes = {
  __typename: 'EarningMechanismPromocodes';
  award?: Maybe<AwardPointsOrVouchers>;
  codesType: PromocodesOfferType;
  id: Scalars['ID']['output'];
  promoCodeGroups: PromoCodeGroupConnection;
  promocodes: Array<Promocode>;
};


export type EarningMechanismPromocodesPromoCodeGroupsArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type EarningMechanismPromocodesInput = {
  awardPoints?: InputMaybe<AwardPointsInput>;
  awardVouchers?: InputMaybe<AwardVouchersInput>;
  codesType?: InputMaybe<PromocodesOfferType>;
  /** @deprecated Use promocodeBatchCreate, promocodeBatchUpdate and promocodeBatchDelete mutations instead */
  promocodes?: InputMaybe<PromocodesInput>;
};

export type EarningMechanismSpinWheelGame = {
  __typename: 'EarningMechanismSpinWheelGame';
  awards: Array<RandomAwardConfig>;
  id: Scalars['ID']['output'];
  purchasableOffer?: Maybe<Offer>;
};

export type EarningMechanismSpinWheelGameInput = {
  awardRandomPrize: AwardRandomPrizeInput;
  purchasableOfferId?: InputMaybe<Scalars['ID']['input']>;
};

export type EarningMechanismStoredValueDiscount = {
  __typename: 'EarningMechanismStoredValueDiscount';
  excludedProductGroups: Array<ProductGroup>;
  id: Scalars['ID']['output'];
  maxDiscountPerTransaction?: Maybe<Scalars['Int']['output']>;
};

export type EarningMechanismStoredValueDiscountInput = {
  excludedProductGroupIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  maxDiscountPerTransaction?: InputMaybe<Scalars['Int']['input']>;
};

export type EarningMechanismTotalEligiblePurchase = {
  __typename: 'EarningMechanismTotalEligiblePurchase';
  award: AwardPointsPer;
  countProductsBy: Earning_Mechanism_Product_Counting_Attribute;
  eligibleProductGroups: Array<ProductGroup>;
  id: Scalars['ID']['output'];
  roundCountedProducts: Earning_Mechanism_Product_Counting_Rounding_Strategy;
};

export type EarningMechanismTotalEligiblePurchaseInput = {
  awardPointsPer: AwardPointsPerInput;
  countProductsBy: Earning_Mechanism_Product_Counting_Attribute;
  eligibleProductGroupIds: Array<Scalars['ID']['input']>;
  roundCountedProducts: Earning_Mechanism_Product_Counting_Rounding_Strategy;
};

export type EarningMechanismTotalEligiblePurchaseOverTime = {
  __typename: 'EarningMechanismTotalEligiblePurchaseOverTime';
  accumulationThreshold: Scalars['Float']['output'];
  award: AwardPointsOrVouchers;
  countProductsBy: Earning_Mechanism_Product_Counting_Attribute;
  eligibleProductGroups: Array<ProductGroup>;
  hiddenUntilProgress: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  purchaseMemberProgress?: Maybe<PurchaseProgress>;
  stayVisibleWhileInProgress?: Maybe<Scalars['Boolean']['output']>;
};

export type EarningMechanismTotalEligiblePurchaseOverTimeInput = {
  accumulationThreshold: Scalars['Float']['input'];
  awardPoints?: InputMaybe<AwardPointsInput>;
  awardVouchers?: InputMaybe<AwardVouchersInput>;
  countProductsBy: Earning_Mechanism_Product_Counting_Attribute;
  eligibleProductGroupIds: Array<Scalars['ID']['input']>;
  hiddenUntilProgress?: InputMaybe<Scalars['Boolean']['input']>;
  stayVisibleWhileInProgress?: InputMaybe<Scalars['Boolean']['input']>;
};

export type EarningMechanismTotalSpendOnTransaction = {
  __typename: 'EarningMechanismTotalSpendOnTransaction';
  award: AwardPointsPer;
  id: Scalars['ID']['output'];
  ineligibleProductGroups: Array<ProductGroup>;
  roundMoneyAmount: Earning_Mechanism_Product_Counting_Rounding_Strategy;
};

export type EarningMechanismTotalSpendOnTransactionInput = {
  awardPointsPer: AwardPointsPerInput;
  ineligibleProductGroupIds: Array<Scalars['ID']['input']>;
  roundMoneyAmount: Earning_Mechanism_Product_Counting_Rounding_Strategy;
};

export type EarningMechanismTotalSpendOverTime = {
  __typename: 'EarningMechanismTotalSpendOverTime';
  accumulationThreshold: Scalars['Float']['output'];
  award: AwardPointsOrVouchers;
  id: Scalars['ID']['output'];
  ineligibleProductGroups: Array<ProductGroup>;
  purchaseMemberProgress?: Maybe<PurchaseProgress>;
  stayVisibleWhileInProgress?: Maybe<Scalars['Boolean']['output']>;
};

export type EarningMechanismTotalSpendOverTimeInput = {
  accumulationThreshold: Scalars['Float']['input'];
  awardPoints?: InputMaybe<AwardPointsInput>;
  awardVouchers?: InputMaybe<AwardVouchersInput>;
  ineligibleProductGroupIds: Array<Scalars['ID']['input']>;
  stayVisibleWhileInProgress?: InputMaybe<Scalars['Boolean']['input']>;
};

export type EarningMechanismTransactionDiscount = {
  __typename: 'EarningMechanismTransactionDiscount';
  allowMultipleFulfillmentsPerProductGroupThreshold: Scalars['Boolean']['output'];
  award: TransactionDiscountAwards;
  /** @deprecated Replaced by ineligibleProductGroups. */
  eligibleProductGroups: Array<ProductGroup>;
  id: Scalars['ID']['output'];
  ineligibleProductGroups: Array<ProductGroup>;
  purchaseAmountThreshold: Scalars['Int']['output'];
};

export type EarningMechanismTransactionDiscountInput = {
  allowMultipleFulfillmentsPerProductGroupThreshold?: InputMaybe<Scalars['Boolean']['input']>;
  awardTransactionMoneyDiscount?: InputMaybe<AwardTransactionMoneyDiscountInput>;
  awardTransactionPercentDiscount?: InputMaybe<AwardTransactionPercentDiscountInput>;
  eligibleProductGroupIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  ineligibleProductGroupIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  purchaseAmountThreshold: Scalars['Int']['input'];
};

export type EarningMechanismUpdateInput = {
  configuration: EarningMechanismConfigurationInput;
  id: Scalars['ID']['input'];
};

export type EarningMechanismVarietyDiscount = {
  __typename: 'EarningMechanismVarietyDiscount';
  award: VarietyDiscountAwards;
  id: Scalars['ID']['output'];
  purchases: Array<EarningVarietyDiscountCriteria>;
};

export type EarningMechanismVarietyDiscountInput = {
  awardPriceOverride?: InputMaybe<AwardPriceOverrideInput>;
  awardProductDiscount?: InputMaybe<AwardProductDiscountInput>;
  awardTransactionMoneyDiscount?: InputMaybe<AwardTransactionMoneyDiscountInput>;
  purchases: Array<EarningVarietyDiscountCriteriaInput>;
};

export type EarningMechanismVarietyPurchase = {
  __typename: 'EarningMechanismVarietyPurchase';
  award: AwardPointsOrVouchers;
  id: Scalars['ID']['output'];
  products: Array<EarningMechanismProductCriteria>;
};

export type EarningMechanismVarietyPurchaseInput = {
  awardPoints?: InputMaybe<AwardPointsInput>;
  awardVouchers?: InputMaybe<AwardVouchersInput>;
  products: Array<EarningMechanismProductCriteriaInput>;
};

export type EarningMechanismVarietyPurchaseOverTime = {
  __typename: 'EarningMechanismVarietyPurchaseOverTime';
  award: AwardPointsOrVouchers;
  hiddenUntilProgress: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  preventDoublePunches?: Maybe<Scalars['Boolean']['output']>;
  products: Array<EarningMechanismProductCriteria>;
  stayVisibleWhileInProgress?: Maybe<Scalars['Boolean']['output']>;
  varietyMemberProgress: Array<VarietyProgress>;
};

export type EarningMechanismVarietyPurchaseOverTimeInput = {
  awardPoints?: InputMaybe<AwardPointsInput>;
  awardVouchers?: InputMaybe<AwardVouchersInput>;
  hiddenUntilProgress?: InputMaybe<Scalars['Boolean']['input']>;
  preventDoublePunches?: InputMaybe<Scalars['Boolean']['input']>;
  products: Array<EarningMechanismProductCriteriaInput>;
  stayVisibleWhileInProgress?: InputMaybe<Scalars['Boolean']['input']>;
};

export type EarningMechanismVisits = {
  __typename: 'EarningMechanismVisits';
  award: AwardPointsOrVouchers;
  id: Scalars['ID']['output'];
  visitThreshold: Scalars['Int']['output'];
  visitsMemberProgress?: Maybe<VisitsProgress>;
};

export type EarningMechanismVisitsInput = {
  awardPoints?: InputMaybe<AwardPointsInput>;
  awardVouchers?: InputMaybe<AwardVouchersInput>;
  visitThreshold: Scalars['Int']['input'];
};

export type EarningVarietyDiscountCriteria = {
  __typename: 'EarningVarietyDiscountCriteria';
  eligibleProductGroups: Array<ProductGroup>;
  id: Scalars['ID']['output'];
  purchaseThreshold: Scalars['Int']['output'];
};

export type EarningVarietyDiscountCriteriaInput = {
  eligibleProductGroupIds: Array<Scalars['ID']['input']>;
  purchaseThreshold: Scalars['Int']['input'];
};

export type EstimatedReimbursements = {
  __typename: 'EstimatedReimbursements';
  loyaltyTotal: Scalars['Float']['output'];
  multipackTotal: Scalars['Float']['output'];
};

export enum EventTrigger {
  AudienceBroadcastMessage = 'AUDIENCE_BROADCAST_MESSAGE',
  BrokerLoyaltyTransactionFinalized = 'BROKER_LOYALTY_TRANSACTION_FINALIZED',
  CustomerCreated = 'CUSTOMER_CREATED',
  CustomerCsrAuditLog = 'CUSTOMER_CSR_AUDIT_LOG',
  CustomerDeleted = 'CUSTOMER_DELETED',
  CustomerEaivCompleted = 'CUSTOMER_EAIV_COMPLETED',
  CustomerExternalEaivCompleted = 'CUSTOMER_EXTERNAL_EAIV_COMPLETED',
  CustomerFirstActivity = 'CUSTOMER_FIRST_ACTIVITY',
  CustomerFirstOptIn = 'CUSTOMER_FIRST_OPT_IN',
  CustomerHelpRequested = 'CUSTOMER_HELP_REQUESTED',
  CustomerOptIn = 'CUSTOMER_OPT_IN',
  CustomerOptOut = 'CUSTOMER_OPT_OUT',
  CustomerUpdated = 'CUSTOMER_UPDATED',
  DeletedMembershipLogout = 'DELETED_MEMBERSHIP_LOGOUT',
  DuplicateCustomerCreationAttempt = 'DUPLICATE_CUSTOMER_CREATION_ATTEMPT',
  LoyaltyEarnSummary = 'LOYALTY_EARN_SUMMARY',
  LoyaltySessionStartInside = 'LOYALTY_SESSION_START_INSIDE',
  LoyaltySessionStartOutside = 'LOYALTY_SESSION_START_OUTSIDE',
  LoyaltyTransactionFinalized = 'LOYALTY_TRANSACTION_FINALIZED',
  LoyaltyTransactionFinalizedBroker = 'LOYALTY_TRANSACTION_FINALIZED_BROKER',
  MagicLinkRequest = 'MAGIC_LINK_REQUEST',
  ManualPointAdjustmentCreated = 'MANUAL_POINT_ADJUSTMENT_CREATED',
  MembershipOffersFulfillments = 'MEMBERSHIP_OFFERS_FULFILLMENTS',
  MembershipProductInterestsUpdated = 'MEMBERSHIP_PRODUCT_INTERESTS_UPDATED',
  MembershipStateChangeActive = 'MEMBERSHIP_STATE_CHANGE_ACTIVE',
  MembershipStateChangeNewMember = 'MEMBERSHIP_STATE_CHANGE_NEW_MEMBER',
  MembershipStateChangePaused = 'MEMBERSHIP_STATE_CHANGE_PAUSED',
  MembershipStateChangeSuspended = 'MEMBERSHIP_STATE_CHANGE_SUSPENDED',
  MembershipUpdated = 'MEMBERSHIP_UPDATED',
  MemberCommunicationOptInStatusChange = 'MEMBER_COMMUNICATION_OPT_IN_STATUS_CHANGE',
  OfferActivated = 'OFFER_ACTIVATED',
  OfferComponentsManuallyUpdated = 'OFFER_COMPONENTS_MANUALLY_UPDATED',
  OfferFulfillment = 'OFFER_FULFILLMENT',
  OfferLinkDelivery = 'OFFER_LINK_DELIVERY',
  OfferProgressChange = 'OFFER_PROGRESS_CHANGE',
  OfferVisibilityChange = 'OFFER_VISIBILITY_CHANGE',
  OfferVisibilityChangeBatch = 'OFFER_VISIBILITY_CHANGE_BATCH',
  OtpRequest = 'OTP_REQUEST',
  PointsBalanceChange = 'POINTS_BALANCE_CHANGE',
  PointExpirationNotification = 'POINT_EXPIRATION_NOTIFICATION',
  PointExpirationNotifications = 'POINT_EXPIRATION_NOTIFICATIONS',
  PushNotification = 'PUSH_NOTIFICATION',
  ReferralSenderIncentiveAward = 'REFERRAL_SENDER_INCENTIVE_AWARD',
  SmsDirectSend = 'SMS_DIRECT_SEND',
  StoredValuePurchased = 'STORED_VALUE_PURCHASED',
  SurveyAssigned = 'SURVEY_ASSIGNED',
  TransactionPhaseChange = 'TRANSACTION_PHASE_CHANGE'
}

export enum ExternalAwardProvider {
  Bybe = 'BYBE',
  Unknown = 'UNKNOWN'
}

export type ExternalIdentityAppConfig = {
  __typename: 'ExternalIdentityAppConfig';
  externalIdentityVerification?: Maybe<ExternalIdentityVerification>;
};

export type ExternalIdentityVerification = {
  __typename: 'ExternalIdentityVerification';
  enabled: Scalars['Boolean']['output'];
  provider: ExternalIdentityVerificationProvider;
};

export type ExternalIdentityVerificationAttribute = {
  __typename: 'ExternalIdentityVerificationAttribute';
  handle: Scalars['String']['output'];
  isCoreAttribute: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
};

export type ExternalIdentityVerificationAttributeFilter = {
  isCoreAttributeOnly?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ExternalIdentityVerificationAuthorizationUrlInput = {
  membershipUuid: Scalars['OCUUID']['input'];
  redirectUri?: InputMaybe<Scalars['String']['input']>;
};

export type ExternalIdentityVerificationAuthorizationUrlPayload = {
  __typename: 'ExternalIdentityVerificationAuthorizationUrlPayload';
  authorizationUrl: Scalars['OCURL']['output'];
  clientId: Scalars['String']['output'];
  grantType: Scalars['String']['output'];
  scope: Scalars['String']['output'];
  state: Scalars['String']['output'];
};

export type ExternalIdentityVerificationProfile = {
  __typename: 'ExternalIdentityVerificationProfile';
  attributes?: Maybe<Array<ExternalIdentityVerificationAttribute>>;
  completedAt: Scalars['OCDateTime']['output'];
  provider: ExternalIdentityVerificationProvider;
};


export type ExternalIdentityVerificationProfileAttributesArgs = {
  filter?: InputMaybe<ExternalIdentityVerificationAttributeFilter>;
};

export enum ExternalIdentityVerificationProvider {
  Idme = 'IDME'
}

export type ExternalLineItemPromotion = {
  __typename: 'ExternalLineItemPromotion';
  discountAmount: Scalars['Float']['output'];
  id: Scalars['ID']['output'];
  promotionReason: Scalars['String']['output'];
};

export type ExternalLoyalty = FeatureConfiguration & {
  __typename: 'ExternalLoyalty';
  enabled: Scalars['Boolean']['output'];
  externalTobaccoApiOffer: ExternalTobaccoApiOffer;
};

export type ExternalLoyaltyApiNoOp = {
  __typename: 'ExternalLoyaltyApiNoOp';
  noop?: Maybe<Scalars['Boolean']['output']>;
};

export type ExternalLoyaltyId = {
  __typename: 'ExternalLoyaltyId';
  createdAt: Scalars['OCDateTime']['output'];
  externalProgram: ExternalProgram;
  id: Scalars['ID']['output'];
  identifier: Scalars['String']['output'];
  membershipId: Scalars['ID']['output'];
  updatedAt: Scalars['OCDateTime']['output'];
};

export type ExternalLoyaltyIdFilterInput = {
  externalProgramId: Scalars['ID']['input'];
  identifier: Scalars['String']['input'];
};

export type ExternalLoyaltyManualOffer = {
  __typename: 'ExternalLoyaltyManualOffer';
  activateCampaignId?: Maybe<Scalars['String']['output']>;
  activateOfferId?: Maybe<Scalars['String']['output']>;
  activateStatus: External_Loyalty_Manual_Offer_Activate_Status;
  brand: Scalars['String']['output'];
  endDate: Scalars['OCDate']['output'];
  errorMessage?: Maybe<Scalars['String']['output']>;
  externalCampaignId: Scalars['String']['output'];
  hasError: Scalars['Boolean']['output'];
  inActivate: Scalars['Boolean']['output'];
  isArchived: Scalars['Boolean']['output'];
  manufacturer: External_Loyalty_Manual_Offer_Manufacturer;
  name: Scalars['String']['output'];
  period: External_Loyalty_Manual_Offer_Period;
  startDate: Scalars['OCDate']['output'];
  states: Array<Scalars['String']['output']>;
  status: External_Loyalty_Manual_Offer_Status;
  storeCount: Scalars['Int']['output'];
  upc: Array<ExternalLoyaltyManualOfferUpc>;
  uuid: Scalars['OCUUID']['output'];
};

export type ExternalLoyaltyManualOfferBrand = {
  __typename: 'ExternalLoyaltyManualOfferBrand';
  name: Scalars['String']['output'];
};

export type ExternalLoyaltyManualOfferBrandFilter = {
  isInActivate?: InputMaybe<Scalars['Boolean']['input']>;
  periodEquals?: InputMaybe<External_Loyalty_Manual_Offer_Period>;
  search?: InputMaybe<Scalars['String']['input']>;
};

export type ExternalLoyaltyManualOfferEdge = {
  __typename: 'ExternalLoyaltyManualOfferEdge';
  cursor: Scalars['String']['output'];
  node: ExternalLoyaltyManualOffer;
};

export type ExternalLoyaltyManualOfferFilter = {
  brandEquals?: InputMaybe<Scalars['String']['input']>;
  brandIncludes?: InputMaybe<Array<Scalars['String']['input']>>;
  endDateAtMax?: InputMaybe<Scalars['OCDate']['input']>;
  endDateAtMin?: InputMaybe<Scalars['OCDate']['input']>;
  externalCampaignIdContains?: InputMaybe<Scalars['String']['input']>;
  externalCampaignIdEquals?: InputMaybe<Scalars['String']['input']>;
  hasError?: InputMaybe<Scalars['Boolean']['input']>;
  isInActivate?: InputMaybe<Scalars['Boolean']['input']>;
  manufacturerEquals?: InputMaybe<External_Loyalty_Manual_Offer_Manufacturer>;
  nameContains?: InputMaybe<Scalars['String']['input']>;
  periodEquals?: InputMaybe<External_Loyalty_Manual_Offer_Period>;
  retailerNetworkUuidEquals?: InputMaybe<Scalars['OCUUID']['input']>;
  startDateAtMax?: InputMaybe<Scalars['OCDate']['input']>;
  startDateAtMin?: InputMaybe<Scalars['OCDate']['input']>;
  statesFilter?: InputMaybe<Array<Scalars['String']['input']>>;
  statusEquals?: InputMaybe<External_Loyalty_Manual_Offer_Status>;
  uuidEquals?: InputMaybe<Scalars['OCUUID']['input']>;
};

export type ExternalLoyaltyManualOfferLocation = {
  __typename: 'ExternalLoyaltyManualOfferLocation';
  brandSpecificLocationId?: Maybe<Scalars['String']['output']>;
  outletId: Scalars['String']['output'];
  siteAddress?: Maybe<Scalars['String']['output']>;
  siteId?: Maybe<Scalars['String']['output']>;
  siteName?: Maybe<Scalars['String']['output']>;
  uuid: Scalars['OCUUID']['output'];
};

export type ExternalLoyaltyManualOfferLocationEdge = {
  __typename: 'ExternalLoyaltyManualOfferLocationEdge';
  cursor: Scalars['String']['output'];
  node: ExternalLoyaltyManualOfferLocation;
};

export type ExternalLoyaltyManualOfferLocationFilter = {
  search?: InputMaybe<Scalars['String']['input']>;
  uuidContains?: InputMaybe<Array<Scalars['OCUUID']['input']>>;
};

export type ExternalLoyaltyManualOfferLocationsConnection = {
  __typename: 'ExternalLoyaltyManualOfferLocationsConnection';
  edges: Array<ExternalLoyaltyManualOfferLocationEdge>;
  pageInfo: PageInfo;
};

export type ExternalLoyaltyManualOfferUpc = {
  __typename: 'ExternalLoyaltyManualOfferUpc';
  productGroupId?: Maybe<Scalars['String']['output']>;
  upc: Scalars['String']['output'];
};

export type ExternalLoyaltyManualOfferUpcs = {
  __typename: 'ExternalLoyaltyManualOfferUpcs';
  externalLoyaltyUpcs: Array<ExternalLoyaltyManualOfferUpc>;
  presentOnActivateUpcs: Array<ExternalLoyaltyManualOfferUpc>;
};

export type ExternalLoyaltyManualOffersConnection = {
  __typename: 'ExternalLoyaltyManualOffersConnection';
  edges: Array<ExternalLoyaltyManualOfferEdge>;
  pageInfo: PageInfo;
};

export type ExternalLoyaltyManualOffersPullingJobStatus = {
  __typename: 'ExternalLoyaltyManualOffersPullingJobStatus';
  errorMessages: Array<Maybe<Scalars['String']['output']>>;
  jobName: External_Loyalty_Manual_Offers_Pulling_Job_Name;
  lastUpdate: Scalars['OCDate']['output'];
};

export type ExternalProgram = {
  __typename: 'ExternalProgram';
  createdAt: Scalars['OCDateTime']['output'];
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  updatedAt: Scalars['OCDateTime']['output'];
};

export type ExternalProgramFilter = {
  id?: InputMaybe<Scalars['ID']['input']>;
};

export type ExternalTobaccoApiOffer = FeatureConfiguration & {
  __typename: 'ExternalTobaccoApiOffer';
  enabled: Scalars['Boolean']['output'];
};

export enum Fuel_And_Convenience_Profile_Attribute {
  AcquisitionChannel = 'ACQUISITION_CHANNEL',
  ActiveSubBrand = 'ACTIVE_SUB_BRAND',
  AlcoholVerified = 'ALCOHOL_VERIFIED',
  AltriaVerified = 'ALTRIA_VERIFIED',
  HasAch = 'HAS_ACH',
  RestrictionVerification = 'RESTRICTION_VERIFICATION',
  RjrVerified = 'RJR_VERIFIED'
}

export enum Fuel_And_Convenience_Profile_Operator {
  IsEqualTo = 'IS_EQUAL_TO',
  IsFalse = 'IS_FALSE',
  IsGreaterThan = 'IS_GREATER_THAN',
  IsGreaterThanOrEqualTo = 'IS_GREATER_THAN_OR_EQUAL_TO',
  IsIn = 'IS_IN',
  IsLessThan = 'IS_LESS_THAN',
  IsLessThanOrEqualTo = 'IS_LESS_THAN_OR_EQUAL_TO',
  IsNotEqualTo = 'IS_NOT_EQUAL_TO',
  IsNotIn = 'IS_NOT_IN',
  IsNotNull = 'IS_NOT_NULL',
  IsNull = 'IS_NULL',
  IsTrue = 'IS_TRUE'
}

export enum Fuel_Pump_Status {
  FuelCanceled = 'FUEL_CANCELED',
  FuelEnd = 'FUEL_END',
  FuelPreAuthSubmitted = 'FUEL_PRE_AUTH_SUBMITTED',
  FuelPumpActivated = 'FUEL_PUMP_ACTIVATED',
  FuelPumpDeactivated = 'FUEL_PUMP_DEACTIVATED',
  FuelReceiptReceived = 'FUEL_RECEIPT_RECEIVED',
  FuelSecondaryIdReceived = 'FUEL_SECONDARY_ID_RECEIVED',
  FuelStart = 'FUEL_START',
  Unknown = 'UNKNOWN'
}

export enum Fuel_Type {
  Diesel = 'DIESEL',
  Electric = 'ELECTRIC',
  Gasoline = 'GASOLINE',
  NaturalGas = 'NATURAL_GAS',
  OffroadDiesel = 'OFFROAD_DIESEL',
  Propane = 'PROPANE'
}

export type FeatureConfiguration = {
  enabled: Scalars['Boolean']['output'];
};

export type FindOrCreateIdentityInput = {
  identifier: Scalars['String']['input'];
};

export type FiservClientToken = {
  __typename: 'FiservClientToken';
  algorithm: Scalars['String']['output'];
  apiKey: Scalars['String']['output'];
  baseUrl: Scalars['String']['output'];
  expiresInSeconds: Scalars['Int']['output'];
  fdCustomerId: Scalars['ID']['output'];
  issuedOn: Scalars['OCDateTime']['output'];
  oAuthToken: Scalars['String']['output'];
  publicKey: Scalars['String']['output'];
};

export type FixedDateRange = {
  __typename: 'FixedDateRange';
  endDate: Scalars['OCDate']['output'];
  startDate: Scalars['OCDate']['output'];
};

export type FixedDateRangeInput = {
  endDate: Scalars['OCDate']['input'];
  startDate: Scalars['OCDate']['input'];
};

export enum FraudCheckStatus {
  Fraudulent = 'FRAUDULENT',
  NotChecked = 'NOT_CHECKED',
  NotFraudulent = 'NOT_FRAUDULENT'
}

export enum FraudCheckStatusFilter {
  All = 'ALL',
  Fraudulent = 'FRAUDULENT',
  NotFraudulent = 'NOT_FRAUDULENT'
}

export type FuelAndConvenienceProfile = {
  __typename: 'FuelAndConvenienceProfile';
  achEnrollmentStatus?: Maybe<Ach_Enrollment_Status>;
  /** @deprecated Replaced with achEnrollmentStatus */
  achStatus?: Maybe<Ach_Status>;
  acquisitionChannel?: Maybe<Scalars['String']['output']>;
  /** @deprecated Replaced by restrictionVerification. */
  alcoholVerified?: Maybe<Scalars['Boolean']['output']>;
  /** @deprecated Replaced by restrictionVerification. */
  altriaVerified?: Maybe<Scalars['Boolean']['output']>;
  createdAt: Scalars['OCDateTime']['output'];
  externalAuthSource?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  memberDataShare?: Maybe<Scalars['Boolean']['output']>;
  pendingVerification?: Maybe<Category_Restrictions>;
  restrictionVerification?: Maybe<Category_Restrictions>;
  restrictionVerificationSource?: Maybe<Restriction_Verification_Source>;
  /** @deprecated Replaced by restrictionVerification. */
  rjrVerified?: Maybe<Scalars['Boolean']['output']>;
};

export type FuelAndConvenienceProfileCreateOrUpdateInput = {
  achEnrollmentStatus?: InputMaybe<Ach_Enrollment_Status>;
  /** @deprecated Replaced with achEnrollmentStatus */
  achStatus?: InputMaybe<Ach_Status>;
  /** @deprecated Replaced by restrictionVerification. */
  alcoholVerified?: InputMaybe<Scalars['Boolean']['input']>;
  /** @deprecated Replaced by restrictionVerification. */
  altriaVerified?: InputMaybe<Scalars['Boolean']['input']>;
  customerUuid: Scalars['ID']['input'];
  memberDataShare?: InputMaybe<Scalars['Boolean']['input']>;
  restrictionVerification?: InputMaybe<Category_Restrictions>;
  /** @deprecated Replaced by restrictionVerification. */
  rjrVerified?: InputMaybe<Scalars['Boolean']['input']>;
};

export type FuelGrade = {
  __typename: 'FuelGrade';
  fuelGradeId: Scalars['String']['output'];
};

export type FuelGradeInput = {
  fuelGradeId: Scalars['String']['input'];
};

export type FuelGradePrice = {
  __typename: 'FuelGradePrice';
  description: Scalars['String']['output'];
  unitPrice?: Maybe<FuelItemPrice>;
};

export type FuelItem = {
  __typename: 'FuelItem';
  additionalAttributes?: Maybe<Scalars['OCJSON']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  fuelGrade?: Maybe<Scalars['Float']['output']>;
  fuelType?: Maybe<Fuel_Type>;
  itemType?: Maybe<Resource_Item_Type>;
  merchandiseCode?: Maybe<Scalars['String']['output']>;
  posCode?: Maybe<Scalars['String']['output']>;
  posCodeFormat?: Maybe<Scalars['String']['output']>;
  posCodeModifier?: Maybe<Scalars['String']['output']>;
  receiptDescription?: Maybe<Scalars['String']['output']>;
  sku: Scalars['String']['output'];
  taxCode?: Maybe<Scalars['String']['output']>;
  unitOfMeasure?: Maybe<Scalars['String']['output']>;
  unitPrice?: Maybe<FuelItemPrice>;
  uuid: Scalars['ID']['output'];
};

export type FuelItemConnection = {
  __typename: 'FuelItemConnection';
  edges?: Maybe<Array<Maybe<FuelItemEdge>>>;
  pageInfo: PageInfo;
};

export type FuelItemCreate = {
  additionalAttributes?: InputMaybe<Scalars['OCJSON']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  fuelGrade?: InputMaybe<Scalars['Float']['input']>;
  fuelType?: InputMaybe<Fuel_Type>;
  itemType?: InputMaybe<Resource_Item_Type>;
  merchandiseCode?: InputMaybe<Scalars['String']['input']>;
  posCode?: InputMaybe<Scalars['String']['input']>;
  posCodeFormat?: InputMaybe<Scalars['String']['input']>;
  posCodeModifier?: InputMaybe<Scalars['String']['input']>;
  receiptDescription?: InputMaybe<Scalars['String']['input']>;
  sku?: InputMaybe<Scalars['String']['input']>;
  taxCode?: InputMaybe<Scalars['String']['input']>;
  unitOfMeasure?: InputMaybe<Scalars['String']['input']>;
  unitPrice?: InputMaybe<FuelItemPriceCreate>;
  uuid?: InputMaybe<Scalars['ID']['input']>;
};

export type FuelItemEdge = {
  __typename: 'FuelItemEdge';
  cursor: Scalars['ID']['output'];
  node?: Maybe<FuelItem>;
};

export type FuelItemPrice = {
  __typename: 'FuelItemPrice';
  cashPrice: Scalars['Float']['output'];
  creditPrice: Scalars['Float']['output'];
  displayCashPrice: Scalars['String']['output'];
  displayCreditPrice: Scalars['String']['output'];
};

export type FuelItemPriceCreate = {
  cashPrice: Scalars['Float']['input'];
  creditPrice: Scalars['Float']['input'];
  displayCashPrice: Scalars['String']['input'];
  displayCreditPrice: Scalars['String']['input'];
};

export enum FuelPriceState {
  Active = 'ACTIVE',
  Expired = 'EXPIRED'
}

export type FuelProductGroup = {
  __typename: 'FuelProductGroup';
  default: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  productGroup: ProductGroup;
  sortingRank: Scalars['Int']['output'];
  userSelectable: Scalars['Boolean']['output'];
};

export type FuelProductGroupCreateInput = {
  default?: InputMaybe<Scalars['Boolean']['input']>;
  productGroup: ProductGroupInput;
  sortingRank?: InputMaybe<Scalars['Int']['input']>;
  userSelectable?: InputMaybe<Scalars['Boolean']['input']>;
};

export type FuelProductGroupUpdateInput = {
  default?: InputMaybe<Scalars['Boolean']['input']>;
  productGroup: ProductGroupUpdateInput;
  sortingRank?: InputMaybe<Scalars['Int']['input']>;
  userSelectable?: InputMaybe<Scalars['Boolean']['input']>;
};

export type FuelReceipt = {
  __typename: 'FuelReceipt';
  carWashCode?: Maybe<Scalars['String']['output']>;
  carWashName?: Maybe<Scalars['String']['output']>;
  carWashPrice?: Maybe<Scalars['String']['output']>;
  fuelSale: Scalars['String']['output'];
  gallons: Scalars['String']['output'];
  priceG: Scalars['String']['output'];
  product: Scalars['String']['output'];
  tax: Scalars['String']['output'];
};

export enum Get_Reward_Request_Validation_Result {
  PhoneCarrierValidationFailed = 'PHONE_CARRIER_VALIDATION_FAILED',
  PhoneCountryCodeValidationFailed = 'PHONE_COUNTRY_CODE_VALIDATION_FAILED',
  PhoneTypeValidationFailed = 'PHONE_TYPE_VALIDATION_FAILED'
}

export enum Global_Offers_Filter {
  All = 'ALL',
  PerLocation = 'PER_LOCATION'
}

export enum Google_Pay_Environment {
  Production = 'PRODUCTION',
  Test = 'TEST'
}

export type GameSession = {
  __typename: 'GameSession';
  awardData?: Maybe<Scalars['OCJSON']['output']>;
  id: Scalars['ID']['output'];
  membership: Membership;
  offer: Offer;
};

export type GeneralSurvey = Survey & {
  __typename: 'GeneralSurvey';
  audienceUuid: Scalars['OCUUID']['output'];
  award?: Maybe<AwardPointsOrVouchers>;
  chainId: Scalars['OCUUID']['output'];
  configuration: GeneralSurveyConfiguration;
  createdAt: Scalars['OCDateTime']['output'];
  deletedAt?: Maybe<Scalars['OCDateTime']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  questions: Array<SurveyQuestion>;
  status: SurveyStatus;
  type: Survey_Type;
  uuid: Scalars['OCUUID']['output'];
};

export type GeneralSurveyConfiguration = {
  __typename: 'GeneralSurveyConfiguration';
  endDate?: Maybe<Scalars['OCDateTime']['output']>;
  startDate: Scalars['OCDateTime']['output'];
};

export type GeneralSurveyConfigurationInput = {
  endDate?: InputMaybe<Scalars['OCDateTime']['input']>;
  startDate: Scalars['OCDateTime']['input'];
};

export type GeneralSurveyCreateInput = {
  audienceUuid: Scalars['OCUUID']['input'];
  chainId: Scalars['String']['input'];
  configuration: GeneralSurveyConfigurationInput;
  description?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  questions: Array<GeneralSurveyQuestionInput>;
};

export type GeneralSurveyQuestionInput = {
  configuration: SurveyQuestionConfigurationInput;
  text: Scalars['String']['input'];
};

export type GeneralSurveyQuestionUpdateInput = {
  text?: InputMaybe<Scalars['String']['input']>;
  uuid: Scalars['OCUUID']['input'];
};

export type GeneralSurveyStatusUpdateInput = {
  status: SurveyStatus;
  uuid: Scalars['OCUUID']['input'];
};

export type GeneralSurveyUpdateInput = {
  audienceUuid?: InputMaybe<Scalars['OCUUID']['input']>;
  chainId?: InputMaybe<Scalars['String']['input']>;
  configuration?: InputMaybe<GeneralSurveyConfigurationInput>;
  description?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  questions?: InputMaybe<Array<GeneralSurveyQuestionInput>>;
  updatedQuestions?: InputMaybe<Array<GeneralSurveyQuestionUpdateInput>>;
  uuid: Scalars['OCUUID']['input'];
};

export type GenerateCustomerPasswordResetTokenInput = {
  identifier: Scalars['String']['input'];
};

export type GenerateSegmentUploadResponse = {
  __typename: 'GenerateSegmentUploadResponse';
  fields: Scalars['OCJSON']['output'];
  fileUuid: Scalars['OCUUID']['output'];
  signedUrl: Scalars['String']['output'];
};

export type GeoLocation = {
  __typename: 'GeoLocation';
  latitude: Scalars['Float']['output'];
  longitude: Scalars['Float']['output'];
};

export type GeoLocationCreate = {
  latitude: Scalars['Float']['input'];
  longitude: Scalars['Float']['input'];
};

export type GeoLocationFilter = {
  epicenter: GeoLocationCreate;
  radiusInMeters: Scalars['Float']['input'];
};

export type GeoLocationInput = {
  latitude: Scalars['Float']['input'];
  longitude: Scalars['Float']['input'];
};

export type GeoLocationUpdate = {
  latitude: Scalars['Float']['input'];
  longitude: Scalars['Float']['input'];
};

export type GeoRegionInput = {
  state?: InputMaybe<Scalars['String']['input']>;
  zipCode?: InputMaybe<Scalars['String']['input']>;
};

export type GetFiservClientAccessTokenInput = {
  customerUuid: Scalars['ID']['input'];
};

export type GetPaymentInstrumentInput = {
  paymentInstrumentUuid: Scalars['ID']['input'];
};

export type GetPaymentInstrumentsForCustomerInput = {
  customerUuid: Scalars['ID']['input'];
};

export type GoalProgress = {
  __typename: 'GoalProgress';
  goal: Scalars['Int']['output'];
  progress: Scalars['Int']['output'];
};

export type GoalProgressChartData = {
  __typename: 'GoalProgressChartData';
  timestamp: Scalars['OCDateTime']['output'];
  value: Scalars['Int']['output'];
};

export enum GooglePayCardNetwork {
  Amex = 'AMEX',
  Discover = 'DISCOVER',
  Electron = 'ELECTRON',
  Elo = 'ELO',
  EloDebit = 'ELO_DEBIT',
  Interac = 'INTERAC',
  Jcb = 'JCB',
  Maestro = 'MAESTRO',
  Mastercard = 'MASTERCARD',
  Visa = 'VISA'
}

export type GooglePayConfiguration = {
  __typename: 'GooglePayConfiguration';
  allowCreditCards: Scalars['Boolean']['output'];
  allowPrepaidCards: Scalars['Boolean']['output'];
  allowedCardNetworks: Array<GooglePayCardNetwork>;
  environment: Google_Pay_Environment;
  gateway: Scalars['String']['output'];
  gatewayMerchantId: Scalars['ID']['output'];
  isBillingZipCodeCollectionEnabled: Scalars['Boolean']['output'];
  merchantId: Scalars['ID']['output'];
  merchantName?: Maybe<Scalars['String']['output']>;
};

export type GooglePayConfigurationCreateInput = {
  allowCreditCards: Scalars['Boolean']['input'];
  allowPrepaidCards: Scalars['Boolean']['input'];
  allowedCardNetworks: Array<Par_Pay_Google_Pay_Card_Network>;
  environment: Google_Pay_Environment;
  gateway: Scalars['String']['input'];
  gatewayMerchantId: Scalars['String']['input'];
  merchantId: Scalars['String']['input'];
  merchantName?: InputMaybe<Scalars['String']['input']>;
};

export type GooglePayConfigurationUpdateInput = {
  allowCreditCards: Scalars['Boolean']['input'];
  allowPrepaidCards: Scalars['Boolean']['input'];
  allowedCardNetworks: Array<Par_Pay_Google_Pay_Card_Network>;
  environment: Google_Pay_Environment;
  gateway: Scalars['String']['input'];
  gatewayMerchantId: Scalars['String']['input'];
  merchantId: Scalars['String']['input'];
  merchantName?: InputMaybe<Scalars['String']['input']>;
};

export type GuestCustomerCreateInput = {
  brandUuid: Scalars['ID']['input'];
};

export type GuestSurveyAnswerSendInput = {
  fields: Array<SurveyFieldInput>;
  guestSurveyId: Scalars['String']['input'];
  questionUuid: Scalars['OCUUID']['input'];
};

export type GuestSurveyAnswerSubmitInput = {
  fields: Array<SurveyFieldInput>;
  guestSurveyId: Scalars['String']['input'];
  questionUuid: Scalars['OCUUID']['input'];
};

export type GuestSurveyAnswersSubmitInput = {
  answers: Array<SurveyQuestionAnswerInput>;
  guestSurveyId: Scalars['String']['input'];
};

export enum Hardware_Vendor {
  Comdata = 'COMDATA',
  Gilbarco = 'GILBARCO',
  Mashgin = 'MASHGIN',
  Ncr = 'NCR',
  NcrPes = 'NCR_PES',
  Stuzo = 'STUZO',
  Verifone = 'VERIFONE'
}

export type HeartlandPayloadInput = {
  terminalId: Scalars['String']['input'];
  terminalType: Scalars['String']['input'];
  unitNumber: Scalars['String']['input'];
};

export type HomeStore = {
  __typename: 'HomeStore';
  locationUuid: Scalars['ID']['output'];
};

export type HoursOfOperation = {
  __typename: 'HoursOfOperation';
  closeTime: Scalars['OCTime']['output'];
  dayOfWeek: Weekday;
  genericHoursString?: Maybe<Scalars['String']['output']>;
  openTime: Scalars['OCTime']['output'];
  /** @deprecated Removing UUID */
  uuid: Scalars['ID']['output'];
};

export type HoursOfOperationCreate = {
  closeTime: Scalars['OCTime']['input'];
  dayOfWeek: Weekday;
  genericHoursString?: InputMaybe<Scalars['String']['input']>;
  openTime: Scalars['OCTime']['input'];
};

export type HoursOfOperationGroup = {
  __typename: 'HoursOfOperationGroup';
  /** @deprecated Removing alias */
  alias?: Maybe<Scalars['String']['output']>;
  hours: Array<HoursOfOperation>;
  /** @deprecated Removing UUID */
  uuid: Scalars['ID']['output'];
};

export type HoursOfOperationGroupCreate = {
  alias?: InputMaybe<Scalars['String']['input']>;
  hours: Array<HoursOfOperationCreate>;
};

export type HoursOfOperationGroupUpdate = {
  alias?: InputMaybe<Scalars['String']['input']>;
  hours: Array<HoursOfOperationUpdate>;
  uuid?: InputMaybe<Scalars['ID']['input']>;
};

export type HoursOfOperationUpdate = {
  closeTime: Scalars['OCTime']['input'];
  dayOfWeek: Weekday;
  genericHoursString?: InputMaybe<Scalars['String']['input']>;
  openTime: Scalars['OCTime']['input'];
  uuid?: InputMaybe<Scalars['ID']['input']>;
};

export enum Inbound_Message_Class {
  Loyalty = 'LOYALTY',
  Mobile = 'MOBILE'
}

export enum Inbound_Message_Type {
  Conexxus = 'CONEXXUS',
  Rlm = 'RLM',
  Spmi = 'SPMI'
}

export enum Ineligibility_Reason {
  CompleteProfileRequired = 'COMPLETE_PROFILE_REQUIRED',
  EmailRequired = 'EMAIL_REQUIRED',
  NotEnoughPoints = 'NOT_ENOUGH_POINTS',
  PurchasableEligibilityConstraintFailed = 'PURCHASABLE_ELIGIBILITY_CONSTRAINT_FAILED',
  RequiresActivation = 'REQUIRES_ACTIVATION'
}

export enum Interval {
  Day = 'DAY',
  Hour = 'HOUR'
}

export type IncomingReferral = {
  __typename: 'IncomingReferral';
  createdAt: Scalars['OCDateTime']['output'];
  enteredCode: Scalars['String']['output'];
  receiverAwardGrantedDate?: Maybe<Scalars['OCDate']['output']>;
  referralFulfillmentSource?: Maybe<ReferralFulfillmentSource>;
  referralFulfillmentSourceId?: Maybe<Scalars['ID']['output']>;
  sender?: Maybe<Membership>;
  senderAwardGrantedDate?: Maybe<Scalars['OCDate']['output']>;
  senderId?: Maybe<Scalars['ID']['output']>;
  status: ReceiverStatus;
};

export type IsTimestampBetween = {
  maxValue: Scalars['OCDateTime']['input'];
  minValue: Scalars['OCDateTime']['input'];
};

export type ItemPrice = {
  __typename: 'ItemPrice';
  displayPrice: Scalars['String']['output'];
  price: Scalars['Float']['output'];
};

export type ItemPriceCreate = {
  displayPrice: Scalars['String']['input'];
  price: Scalars['Float']['input'];
};

export type ItemPriceInput = {
  displayPrice: Scalars['String']['input'];
  price?: InputMaybe<Scalars['Float']['input']>;
};

export enum Kiosk_Ad_Set_Status {
  Archived = 'ARCHIVED',
  Draft = 'DRAFT',
  Published = 'PUBLISHED'
}

export type Kiosk = {
  __typename: 'Kiosk';
  adSets: Array<KioskAdSet>;
  appConfig: KioskAppConfig;
  createdAt: Scalars['OCDateTime']['output'];
  defaultScreen?: Maybe<KioskDefaultScreen>;
  deviceId?: Maybe<Scalars['ID']['output']>;
  externalDisplayId: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  location?: Maybe<Location>;
  locationId: Scalars['ID']['output'];
  status: KioskStatus;
  updatedAt: Scalars['OCDateTime']['output'];
};

export type KioskAdSchedule = {
  __typename: 'KioskAdSchedule';
  days: Array<Weekday>;
  endTime: Scalars['OCTime']['output'];
  startTime: Scalars['OCTime']['output'];
};

export type KioskAdScheduleInput = {
  days: Array<Weekday>;
  endTime: Scalars['OCTime']['input'];
  startTime: Scalars['OCTime']['input'];
};

export type KioskAdSet = {
  __typename: 'KioskAdSet';
  asset?: Maybe<KioskAsset>;
  createdAt: Scalars['OCDateTime']['output'];
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  kioskIds: Array<Scalars['String']['output']>;
  kiosks: Array<Kiosk>;
  name: Scalars['String']['output'];
  offerId?: Maybe<Scalars['ID']['output']>;
  schedules: Array<KioskAdSchedule>;
  status: Kiosk_Ad_Set_Status;
  updatedAt: Scalars['OCDateTime']['output'];
};

export type KioskAdSetConnection = {
  __typename: 'KioskAdSetConnection';
  edges: Array<KioskAdSetEdge>;
  pageInfo: PageInfo;
};

export type KioskAdSetCreateInput = {
  assetId?: InputMaybe<Scalars['ID']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  kioskIds: Array<Scalars['ID']['input']>;
  name: Scalars['String']['input'];
  offerId?: InputMaybe<Scalars['ID']['input']>;
  schedules: Array<KioskAdScheduleInput>;
};

export type KioskAdSetEdge = {
  __typename: 'KioskAdSetEdge';
  cursor: Scalars['OCBase64Cursor']['output'];
  node: KioskAdSet;
};

export type KioskAdSetFilter = {
  kioskIdIncludes?: InputMaybe<Array<Scalars['OCUUID']['input']>>;
  searchTerm?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<Kiosk_Ad_Set_Status>;
};

export type KioskAdSetUpdateInput = {
  assetId?: InputMaybe<Scalars['ID']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  kioskIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  name?: InputMaybe<Scalars['String']['input']>;
  offerId?: InputMaybe<Scalars['ID']['input']>;
  schedules?: InputMaybe<Array<KioskAdScheduleInput>>;
};

export type KioskAppConfig = {
  __typename: 'KioskAppConfig';
  billboardOffersLimit?: Maybe<Scalars['Int']['output']>;
  brandUuid: Scalars['OCUUID']['output'];
  chainId: Scalars['OCUUID']['output'];
  id: Scalars['ID']['output'];
  isBillboardEnabled: Scalars['Boolean']['output'];
  isOfferDeliveryEnabled: Scalars['Boolean']['output'];
  isPointBalanceEnabled: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  privacyPolicyUrl: Scalars['OCURL']['output'];
  termsOfServiceUrl: Scalars['OCURL']['output'];
};

export type KioskAppConfigConnection = {
  __typename: 'KioskAppConfigConnection';
  edges: Array<KioskAppConfigEdge>;
  pageInfo: PageInfo;
};

export type KioskAppConfigCreateInput = {
  billboardOffersLimit?: InputMaybe<Scalars['Int']['input']>;
  brandUuid: Scalars['OCUUID']['input'];
  chainId: Scalars['OCUUID']['input'];
  isBillboardEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  isOfferDeliveryEnabled: Scalars['Boolean']['input'];
  isPointBalanceEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  name: Scalars['String']['input'];
  privacyPolicyUrl: Scalars['OCURL']['input'];
  termsOfServiceUrl: Scalars['OCURL']['input'];
};

export type KioskAppConfigEdge = {
  __typename: 'KioskAppConfigEdge';
  cursor: Scalars['OCBase64Cursor']['output'];
  node: KioskAppConfig;
};

export type KioskAppConfigFilter = {
  chainIdEquals?: InputMaybe<Scalars['OCUUID']['input']>;
};

export type KioskAppConfigUpdateInput = {
  billboardOffersLimit?: InputMaybe<Scalars['Int']['input']>;
  id: Scalars['ID']['input'];
  isBillboardEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  isOfferDeliveryEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  isPointBalanceEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  privacyPolicyUrl?: InputMaybe<Scalars['OCURL']['input']>;
  termsOfServiceUrl?: InputMaybe<Scalars['OCURL']['input']>;
};

export type KioskAsset = {
  __typename: 'KioskAsset';
  createdAt: Scalars['OCDateTime']['output'];
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  imageSet: KioskImageSet;
  name: Scalars['String']['output'];
  updatedAt: Scalars['OCDateTime']['output'];
};

export type KioskAssetConnection = {
  __typename: 'KioskAssetConnection';
  edges: Array<KioskAssetEdge>;
  pageInfo: PageInfo;
};

export type KioskAssetCreateInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  imageSet: KioskImageSetInput;
  name: Scalars['String']['input'];
};

export type KioskAssetEdge = {
  __typename: 'KioskAssetEdge';
  cursor: Scalars['OCBase64Cursor']['output'];
  node: KioskAsset;
};

export type KioskAssetFilter = {
  searchTerm?: InputMaybe<Scalars['String']['input']>;
};

export type KioskAssetUpdateInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  imageSet?: InputMaybe<KioskImageSetInput>;
  name?: InputMaybe<Scalars['String']['input']>;
};

export type KioskAssetUploadSignedUrl = {
  __typename: 'KioskAssetUploadSignedUrl';
  fields: Scalars['OCJSON']['output'];
  resourceUrl: Scalars['OCURL']['output'];
  signedUrl: Scalars['OCURL']['output'];
};

export type KioskAssetUploadSignedUrlInput = {
  aspectRatio: KioskImageAspectRatio;
  fileName: Scalars['String']['input'];
};

export type KioskConnection = {
  __typename: 'KioskConnection';
  edges: Array<KioskEdge>;
  pageInfo: PageInfo;
};

export type KioskCreateInput = {
  appConfigId: Scalars['ID']['input'];
  defaultScreenId?: InputMaybe<Scalars['ID']['input']>;
  deviceId?: InputMaybe<Scalars['ID']['input']>;
  externalDisplayId: Scalars['String']['input'];
  locationUuid: Scalars['OCUUID']['input'];
};

export type KioskDefaultScreen = {
  __typename: 'KioskDefaultScreen';
  createdAt: Scalars['OCDateTime']['output'];
  description: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  imageSet: KioskImageSet;
  kiosks: Array<Kiosk>;
  name: Scalars['String']['output'];
  updatedAt: Scalars['OCDateTime']['output'];
};

export type KioskDefaultScreenConnection = {
  __typename: 'KioskDefaultScreenConnection';
  edges: Array<KioskDefaultScreenEdge>;
  pageInfo: PageInfo;
};

export type KioskDefaultScreenCreateInput = {
  description: Scalars['String']['input'];
  imageSet: KioskImageSetInput;
  kioskIds: Array<Scalars['ID']['input']>;
  name: Scalars['String']['input'];
};

export type KioskDefaultScreenEdge = {
  __typename: 'KioskDefaultScreenEdge';
  cursor: Scalars['OCBase64Cursor']['output'];
  node: KioskDefaultScreen;
};

export type KioskDefaultScreenFilter = {
  searchTerm?: InputMaybe<Scalars['String']['input']>;
};

export type KioskDefaultScreenUpdateInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  imageSet?: InputMaybe<KioskImageSetInput>;
  kioskIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  name?: InputMaybe<Scalars['String']['input']>;
};

export type KioskDevice = {
  __typename: 'KioskDevice';
  alias?: Maybe<Scalars['String']['output']>;
  boundKiosk?: Maybe<Kiosk>;
  id: Scalars['ID']['output'];
  imei1?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  os?: Maybe<Scalars['String']['output']>;
  serial: Scalars['String']['output'];
};

export type KioskDeviceFilter = {
  search?: InputMaybe<Scalars['String']['input']>;
};

export type KioskDeviceList = {
  __typename: 'KioskDeviceList';
  items: Array<KioskDevice>;
  pageInfo: OffsetPageInfo;
};

export type KioskEdge = {
  __typename: 'KioskEdge';
  cursor: Scalars['OCBase64Cursor']['output'];
  node: Kiosk;
};

export type KioskFilter = {
  adSetUuidIncludes?: InputMaybe<Array<Scalars['OCUUID']['input']>>;
  defaultScreenUuidIncludes?: InputMaybe<Array<Scalars['OCUUID']['input']>>;
  locationUuidEquals?: InputMaybe<Scalars['OCUUID']['input']>;
  searchTerm?: InputMaybe<Scalars['String']['input']>;
  statusEquals?: InputMaybe<KioskStatus>;
};

export enum KioskImageAspectRatio {
  Landscape = 'LANDSCAPE',
  Portrait = 'PORTRAIT',
  Square = 'SQUARE'
}

export type KioskImageSet = {
  __typename: 'KioskImageSet';
  landscape: Scalars['OCURL']['output'];
  portrait: Scalars['OCURL']['output'];
  square: Scalars['OCURL']['output'];
};

export type KioskImageSetInput = {
  landscape?: InputMaybe<Scalars['OCURL']['input']>;
  portrait?: InputMaybe<Scalars['OCURL']['input']>;
  square?: InputMaybe<Scalars['OCURL']['input']>;
};

export type KioskPartialOffer = {
  __typename: 'KioskPartialOffer';
  id: Scalars['ID']['output'];
  marketingContents: Array<MarketingContent>;
};

export enum KioskStatus {
  Archived = 'ARCHIVED',
  Linked = 'LINKED',
  New = 'NEW',
  PendingLink = 'PENDING_LINK'
}

export type KioskUpdateInput = {
  appConfigId?: InputMaybe<Scalars['ID']['input']>;
  deviceId?: InputMaybe<Scalars['ID']['input']>;
  externalDisplayId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['OCUUID']['input'];
  locationUuid?: InputMaybe<Scalars['OCUUID']['input']>;
};

export enum KountCheckStatus {
  Fraudulent = 'FRAUDULENT',
  NotFraudulent = 'NOT_FRAUDULENT'
}

export type KountFraudCheckResult = {
  __typename: 'KountFraudCheckResult';
  amount: Scalars['Float']['output'];
  autoDecision: AutoDecision;
  binRange?: Maybe<Scalars['String']['output']>;
  creditCardBrand?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  last4?: Maybe<Scalars['String']['output']>;
  omniScore: Scalars['Float']['output'];
  reasonCode?: Maybe<Scalars['String']['output']>;
  ruleDescriptions?: Maybe<Array<RuleDescription>>;
  sessionId: Scalars['String']['output'];
  status: KountCheckStatus;
  transactionDate: Scalars['OCDateTime']['output'];
  transactionUuid: Scalars['OCUUID']['output'];
  triggeredRules?: Maybe<Array<RuleDescription>>;
};

export enum Limit_Time_Period {
  Day = 'DAY',
  Month = 'MONTH',
  Week = 'WEEK'
}

export enum Location_Capability {
  Loyalty = 'LOYALTY',
  Mppa = 'MPPA'
}

export enum Location_Open_Status {
  Closed = 'CLOSED',
  Open = 'OPEN',
  Unknown = 'UNKNOWN'
}

export enum Location_Resource_Status {
  Available = 'AVAILABLE',
  Inuse = 'INUSE',
  Offline = 'OFFLINE',
  Unavailable = 'UNAVAILABLE',
  Unknown = 'UNKNOWN'
}

export enum Location_Resource_Type {
  CarWash = 'CAR_WASH',
  FuelPump = 'FUEL_PUMP',
  Store = 'STORE'
}

export enum Loyalty_Event_Origin {
  ActivateInternalProcess = 'ACTIVATE_INTERNAL_PROCESS',
  CommandApi = 'COMMAND_API',
  ExperienceApi = 'EXPERIENCE_API',
  Rabbitmq = 'RABBITMQ'
}

export enum Loyalty_Instrument_Status {
  Active = 'ACTIVE',
  Inactive = 'INACTIVE'
}

export enum Loyalty_Level {
  AboveSite = 'ABOVE_SITE',
  SiteLevel = 'SITE_LEVEL'
}

export enum Loyalty_Provider_Type_Enum {
  Albertsons = 'ALBERTSONS',
  Axonet = 'AXONET',
  OpenCommerce = 'OPEN_COMMERCE'
}

export enum Loyalty_Rewards_Eligibility_Restriction_Type {
  FuelGradeIds = 'FUEL_GRADE_IDS'
}

export type Limit = LimitGlobalActivation | LimitGlobalActivationInTime | LimitGlobalAwardCount | LimitGlobalAwardCountInTime | LimitInTransactionAwardCount | LimitInTransactionProgress | LimitMembershipActivation | LimitMembershipActivationInTime | LimitMembershipAwardCount | LimitMembershipAwardCountInTime | LimitMembershipProgressInTime | LimitMembershipTransactionCount | LimitMembershipTransactionCountInTime;

export type LimitConfigurationInput = {
  globalActivation?: InputMaybe<LimitGlobalActivationInput>;
  globalActivationInTime?: InputMaybe<LimitGlobalActivationInTimeInput>;
  globalAwardCount?: InputMaybe<LimitGlobalAwardCountInput>;
  globalAwardCountInTime?: InputMaybe<LimitGlobalAwardCountInTimeInput>;
  inTransactionAwardCount?: InputMaybe<LimitInTransactionAwardCountInput>;
  inTransactionProgress?: InputMaybe<LimitInTransactionProgressInput>;
  membershipActivation?: InputMaybe<LimitMembershipActivationInput>;
  membershipActivationInTime?: InputMaybe<LimitMembershipActivationInTimeInput>;
  membershipAwardCount?: InputMaybe<LimitMembershipAwardCountInput>;
  membershipAwardCountInTime?: InputMaybe<LimitMembershipAwardCountInTimeInput>;
  membershipProgressInTime?: InputMaybe<LimitMembershipProgressInTimeInput>;
  membershipTransactionCount?: InputMaybe<LimitMembershipTransactionCountInput>;
  membershipTransactionCountInTime?: InputMaybe<LimitMembershipTransactionCountInTimeInput>;
};

export type LimitCreateInput = {
  configuration: LimitConfigurationInput;
  offerId: Scalars['ID']['input'];
};

export type LimitGlobalActivation = {
  __typename: 'LimitGlobalActivation';
  id: Scalars['ID']['output'];
  limit: Scalars['Int']['output'];
};

export type LimitGlobalActivationInTime = {
  __typename: 'LimitGlobalActivationInTime';
  id: Scalars['ID']['output'];
  limit: Scalars['Int']['output'];
  timePeriod: Limit_Time_Period;
};

export type LimitGlobalActivationInTimeInput = {
  limit: Scalars['Int']['input'];
  timePeriod: Limit_Time_Period;
};

export type LimitGlobalActivationInput = {
  limit: Scalars['Int']['input'];
};

export type LimitGlobalAwardCount = {
  __typename: 'LimitGlobalAwardCount';
  id: Scalars['ID']['output'];
  limit: Scalars['Int']['output'];
};

export type LimitGlobalAwardCountInTime = {
  __typename: 'LimitGlobalAwardCountInTime';
  id: Scalars['ID']['output'];
  limit: Scalars['Int']['output'];
  timePeriod: Limit_Time_Period;
};

export type LimitGlobalAwardCountInTimeInput = {
  limit: Scalars['Int']['input'];
  timePeriod: Limit_Time_Period;
};

export type LimitGlobalAwardCountInput = {
  limit: Scalars['Int']['input'];
};

export type LimitInTransactionAwardCount = {
  __typename: 'LimitInTransactionAwardCount';
  id: Scalars['ID']['output'];
  limit: Scalars['Int']['output'];
};

export type LimitInTransactionAwardCountInput = {
  limit: Scalars['Int']['input'];
};

export type LimitInTransactionProgress = {
  __typename: 'LimitInTransactionProgress';
  id: Scalars['ID']['output'];
  limit: Scalars['Int']['output'];
};

export type LimitInTransactionProgressInput = {
  limit: Scalars['Int']['input'];
};

export type LimitMembershipActivation = {
  __typename: 'LimitMembershipActivation';
  id: Scalars['ID']['output'];
  limit: Scalars['Int']['output'];
};

export type LimitMembershipActivationInTime = {
  __typename: 'LimitMembershipActivationInTime';
  id: Scalars['ID']['output'];
  limit: Scalars['Int']['output'];
  timePeriod: Limit_Time_Period;
};

export type LimitMembershipActivationInTimeInput = {
  limit: Scalars['Int']['input'];
  timePeriod: Limit_Time_Period;
};

export type LimitMembershipActivationInput = {
  limit: Scalars['Int']['input'];
};

export type LimitMembershipAwardCount = {
  __typename: 'LimitMembershipAwardCount';
  id: Scalars['ID']['output'];
  limit: Scalars['Int']['output'];
  membershipQuantityAvailable?: Maybe<Scalars['Int']['output']>;
};

export type LimitMembershipAwardCountInTime = {
  __typename: 'LimitMembershipAwardCountInTime';
  id: Scalars['ID']['output'];
  limit: Scalars['Int']['output'];
  membershipQuantityAvailable?: Maybe<Scalars['Int']['output']>;
  timePeriod: Limit_Time_Period;
};

export type LimitMembershipAwardCountInTimeInput = {
  limit: Scalars['Int']['input'];
  timePeriod: Limit_Time_Period;
};

export type LimitMembershipAwardCountInput = {
  limit: Scalars['Int']['input'];
};

export type LimitMembershipProgressInTime = {
  __typename: 'LimitMembershipProgressInTime';
  id: Scalars['ID']['output'];
  limit: Scalars['Int']['output'];
  membershipQuantityAvailable?: Maybe<Scalars['Int']['output']>;
  membershipQuantityFulfilled?: Maybe<Scalars['Int']['output']>;
  timePeriod: Limit_Time_Period;
};

export type LimitMembershipProgressInTimeInput = {
  limit: Scalars['Int']['input'];
  timePeriod: Limit_Time_Period;
};

export type LimitMembershipTransactionCount = {
  __typename: 'LimitMembershipTransactionCount';
  id: Scalars['ID']['output'];
  limit: Scalars['Int']['output'];
};

export type LimitMembershipTransactionCountInTime = {
  __typename: 'LimitMembershipTransactionCountInTime';
  id: Scalars['ID']['output'];
  limit: Scalars['Int']['output'];
  timePeriod: Limit_Time_Period;
};

export type LimitMembershipTransactionCountInTimeInput = {
  limit: Scalars['Int']['input'];
  timePeriod: Limit_Time_Period;
};

export type LimitMembershipTransactionCountInput = {
  limit: Scalars['Int']['input'];
};

export type LimitUpdateInput = {
  configuration: LimitConfigurationInput;
  id: Scalars['ID']['input'];
};

export type ListScanDataSftpCredentialsWithStoreDetailsFilter = {
  siteConfigurationAddressContains?: InputMaybe<Scalars['String']['input']>;
  siteConfigurationIdEquals?: InputMaybe<Scalars['String']['input']>;
  siteInfoSearch?: InputMaybe<Scalars['String']['input']>;
  siteNameEquals?: InputMaybe<Scalars['String']['input']>;
  sitePhoneNumberEquals?: InputMaybe<Scalars['String']['input']>;
};

export type Location = {
  __typename: 'Location';
  address?: Maybe<Address>;
  altriaMan?: Maybe<Scalars['String']['output']>;
  altriaMatchApiEnabled?: Maybe<Scalars['Boolean']['output']>;
  altriaPPlusApiEnabled?: Maybe<Scalars['Boolean']['output']>;
  altriaRcn?: Maybe<Scalars['String']['output']>;
  altriaSubmitterID?: Maybe<Scalars['String']['output']>;
  attributes: Array<LocationAttribute>;
  brand?: Maybe<Brand>;
  brandSpecificLocationId?: Maybe<Scalars['String']['output']>;
  brandingDetails?: Maybe<LocationBrandingDetails>;
  circanaSubmitterID?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['OCDateTime']['output'];
  /** @deprecated CRV fee data is no longer available on a per-location basis. It is now managed on a per-state basis within the Activate service. */
  crvFeeCodes?: Maybe<Array<CrvFeeCode>>;
  currency?: Maybe<Currency>;
  customerId?: Maybe<Scalars['String']['output']>;
  customerName?: Maybe<Scalars['String']['output']>;
  dealerNumber?: Maybe<Scalars['String']['output']>;
  deletedAt?: Maybe<Scalars['OCDateTime']['output']>;
  distance?: Maybe<Scalars['Float']['output']>;
  externalCustomData?: Maybe<Scalars['OCJSON']['output']>;
  fuelGradePrices: Array<FuelGradePrice>;
  fuelPriceState?: Maybe<FuelPriceState>;
  grocerLong?: Maybe<Scalars['String']['output']>;
  grocerShort?: Maybe<Scalars['String']['output']>;
  hoursOfOperationGroup?: Maybe<HoursOfOperationGroup>;
  isAvtSupported: Scalars['Boolean']['output'];
  lastChangeSource?: Maybe<Change_Source>;
  locationGroups?: Maybe<Array<LocationGroup>>;
  loyaltyProgramOffer?: Maybe<Scalars['String']['output']>;
  manuallyUpdated?: Maybe<Scalars['Boolean']['output']>;
  msaSubmitterID?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  openCommerceFeatures: Array<OpenCommerceFeature>;
  openStatus: Location_Open_Status;
  payAtPumpEnabled: Scalars['Boolean']['output'];
  paymentProviderMerchantId?: Maybe<Scalars['String']['output']>;
  phoneNumbers: Array<ContactPhoneNumber>;
  /** @deprecated Deprecated nested 'resources'. */
  resources?: Maybe<Array<Maybe<LocationResource>>>;
  retailerName?: Maybe<Scalars['String']['output']>;
  /** @deprecated Replaced by rewardPrograms. */
  rewardProgramLoyaltyProviders?: Maybe<Array<Maybe<RewardProgram>>>;
  rewardPrograms?: Maybe<Array<Maybe<RewardProgram>>>;
  rjrAccountNumber?: Maybe<Scalars['String']['output']>;
  siteSystemConfiguration: Array<SiteSystemConfiguration>;
  specialHours?: Maybe<Scalars['String']['output']>;
  storeBrand?: Maybe<Scalars['String']['output']>;
  subBrandName?: Maybe<Scalars['String']['output']>;
  subBrandUuid?: Maybe<Scalars['OCUUID']['output']>;
  timezone: Scalars['OCTimeZone']['output'];
  updatedAt?: Maybe<Scalars['OCDateTime']['output']>;
  utcOffset?: Maybe<Scalars['Int']['output']>;
  uuid: Scalars['ID']['output'];
};

export type LocationAttribute = {
  __typename: 'LocationAttribute';
  /** @deprecated Removed description, only using value and string */
  description?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  /** @deprecated Removed uuid, only using value and string */
  uuid: Scalars['ID']['output'];
  value: Scalars['String']['output'];
};

export type LocationAttributeCreate = {
  name: Scalars['String']['input'];
  value: Scalars['String']['input'];
};

export type LocationAttributeFilter = {
  /** @deprecated Not implemented */
  descriptionContains?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Not implemented */
  descriptionEquals?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Not implemented */
  nameContains?: InputMaybe<Scalars['String']['input']>;
  nameEquals?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Not implemented */
  valueContains?: InputMaybe<Scalars['String']['input']>;
  valueEquals?: InputMaybe<Scalars['String']['input']>;
};

export type LocationBrandingDetails = {
  __typename: 'LocationBrandingDetails';
  primaryColor?: Maybe<Scalars['String']['output']>;
  secondaryColor?: Maybe<Scalars['String']['output']>;
};

export type LocationBrandingDetailsInput = {
  primaryColor?: InputMaybe<Scalars['String']['input']>;
  secondaryColor?: InputMaybe<Scalars['String']['input']>;
};

export type LocationBulkSubmitterIdUpdateInput = {
  altriaSubmitterID?: InputMaybe<Scalars['String']['input']>;
  circanaSubmitterID?: InputMaybe<Scalars['String']['input']>;
  msaSubmitterID?: InputMaybe<Scalars['String']['input']>;
  uuids: Array<Scalars['OCUUID']['input']>;
};

export type LocationCheckIn = {
  geoLocation?: InputMaybe<GeoLocationCreate>;
};

export type LocationConnection = {
  __typename: 'LocationConnection';
  edges?: Maybe<Array<LocationEdge>>;
  pageInfo: PageInfo;
};

export type LocationCreate = {
  address: AddressInput;
  altriaMan?: InputMaybe<Scalars['String']['input']>;
  altriaMatchApiEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  altriaPPlusApiEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  altriaRcn?: InputMaybe<Scalars['String']['input']>;
  altriaSubmitterID?: InputMaybe<Scalars['String']['input']>;
  attributes?: InputMaybe<Array<LocationAttributeCreate>>;
  brandSpecificLocationId?: InputMaybe<Scalars['String']['input']>;
  brandUuid?: InputMaybe<Scalars['ID']['input']>;
  brandingDetails?: InputMaybe<LocationBrandingDetailsInput>;
  changeSource?: InputMaybe<Change_Source>;
  circanaSubmitterID?: InputMaybe<Scalars['String']['input']>;
  customerId?: InputMaybe<Scalars['String']['input']>;
  customerName?: InputMaybe<Scalars['String']['input']>;
  dealerNumber?: InputMaybe<Scalars['String']['input']>;
  externalCustomData?: InputMaybe<Scalars['OCJSON']['input']>;
  grocerLong?: InputMaybe<Scalars['String']['input']>;
  grocerShort?: InputMaybe<Scalars['String']['input']>;
  hoursOfOperationGroup?: InputMaybe<HoursOfOperationGroupCreate>;
  isAvtSupported?: InputMaybe<Scalars['Boolean']['input']>;
  locationGroupUuids?: InputMaybe<Array<Scalars['ID']['input']>>;
  loyaltyProgramOffer?: InputMaybe<Scalars['String']['input']>;
  msaSubmitterID?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  openCommerceFeatures?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  payAtPumpEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  paymentProviderMerchantId?: InputMaybe<Scalars['String']['input']>;
  phoneNumbers?: InputMaybe<Array<InputMaybe<Scalars['OCPhoneNumber']['input']>>>;
  resources?: InputMaybe<Array<InputMaybe<LocationResourceCreate>>>;
  retailerName?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Replaced by rewardPrograms. */
  rewardProgramLoyaltyProviders?: InputMaybe<Array<InputMaybe<RewardProgramCreate>>>;
  rewardPrograms?: InputMaybe<Array<InputMaybe<RewardProgramCreate>>>;
  rjrAccountNumber?: InputMaybe<Scalars['String']['input']>;
  siteSystemConfiguration?: InputMaybe<Array<SiteSystemConfigurationCreate>>;
  storeBrand?: InputMaybe<Scalars['String']['input']>;
  subBrandUuid?: InputMaybe<Scalars['OCUUID']['input']>;
  timezone?: InputMaybe<Scalars['OCTimeZone']['input']>;
};

export type LocationDowntimeMetric = {
  __typename: 'LocationDowntimeMetric';
  downtimeInSeconds: TimeSeriesMetric;
  locationUuid: Scalars['OCUUID']['output'];
};

export type LocationDowntimeMetricsFilter = {
  allLocations?: InputMaybe<Scalars['Boolean']['input']>;
  dateRange?: InputMaybe<DateRangeInput>;
  locations?: InputMaybe<Array<Scalars['String']['input']>>;
  timezone: Scalars['String']['input'];
};

export type LocationDowntimeMetricsOverview = {
  __typename: 'LocationDowntimeMetricsOverview';
  disconnectedStoresTimeSeriesOfLast30Days?: Maybe<Array<TimeSeriesMetric>>;
  numberOfConnectedStores: Scalars['Int']['output'];
  numberOfStores: Scalars['Int']['output'];
};

export type LocationDowntimeMetricsOverviewFilter = {
  allLocations?: InputMaybe<Scalars['Boolean']['input']>;
  locations?: InputMaybe<Array<Scalars['OCUUID']['input']>>;
  timezone: Scalars['String']['input'];
};

export type LocationEdge = {
  __typename: 'LocationEdge';
  cursor: Scalars['ID']['output'];
  node: Location;
};

export type LocationFilter = {
  addressSearch?: InputMaybe<Scalars['String']['input']>;
  aliasEquals?: InputMaybe<Scalars['String']['input']>;
  altriaRCNContains?: InputMaybe<Scalars['String']['input']>;
  altriaRCNIn?: InputMaybe<Array<Scalars['String']['input']>>;
  altriaSubmitterIDContains?: InputMaybe<Array<Scalars['String']['input']>>;
  altriaSubmitterIDEquals?: InputMaybe<Scalars['String']['input']>;
  attributes?: InputMaybe<LocationAttributeFilter>;
  brand?: InputMaybe<BrandFilter>;
  brandSpecificLocationIdContains?: InputMaybe<Scalars['String']['input']>;
  brandSpecificLocationIdEquals?: InputMaybe<Scalars['String']['input']>;
  brandSpecificLocationIdIn?: InputMaybe<Array<Scalars['String']['input']>>;
  circanaSubmitterIDContains?: InputMaybe<Array<Scalars['String']['input']>>;
  circanaSubmitterIDEquals?: InputMaybe<Scalars['String']['input']>;
  customerIdEquals?: InputMaybe<Scalars['String']['input']>;
  customerNameEquals?: InputMaybe<Scalars['String']['input']>;
  geoLocation?: InputMaybe<GeoLocationFilter>;
  geoLocationEquals?: InputMaybe<GeoLocationCreate>;
  group?: InputMaybe<LocationGroupFilter>;
  hasCpgAccountIdentifier?: InputMaybe<Scalars['Boolean']['input']>;
  isAltriaParticipant?: InputMaybe<Scalars['Boolean']['input']>;
  isDeleted?: InputMaybe<Scalars['Boolean']['input']>;
  isOnlineEquals?: InputMaybe<Scalars['Boolean']['input']>;
  isPayAtPumpEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  isWithIssues?: InputMaybe<Scalars['Boolean']['input']>;
  msaSubmitterIDContains?: InputMaybe<Array<Scalars['String']['input']>>;
  msaSubmitterIDEquals?: InputMaybe<Scalars['String']['input']>;
  openCommerceFeatures?: InputMaybe<OpenCommerceFeatureFilter>;
  phoneNumberEquals?: InputMaybe<Scalars['String']['input']>;
  radius?: InputMaybe<Scalars['Float']['input']>;
  resources?: InputMaybe<LocationResourceFilter>;
  retailerNetworkUuidNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  rjrAccountNumberContains?: InputMaybe<Scalars['String']['input']>;
  rjrAccountNumberIn?: InputMaybe<Array<Scalars['String']['input']>>;
  search?: InputMaybe<Scalars['String']['input']>;
  siteAccountSubmitterSearch?: InputMaybe<Scalars['String']['input']>;
  siteInfoSearch?: InputMaybe<Scalars['String']['input']>;
  siteNameContains?: InputMaybe<Scalars['String']['input']>;
  siteSystemConfiguration?: InputMaybe<SiteSystemConfigurationFilter>;
  streetOrUuidSearch?: InputMaybe<Scalars['String']['input']>;
  subBrandNameEquals?: InputMaybe<Scalars['String']['input']>;
  subBrandUuidEquals?: InputMaybe<Scalars['OCUUID']['input']>;
  uuidContains?: InputMaybe<Array<Scalars['ID']['input']>>;
  uuidEquals?: InputMaybe<Scalars['ID']['input']>;
};

export type LocationGroup = {
  __typename: 'LocationGroup';
  countOfLocations: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  uuid: Scalars['ID']['output'];
};

export type LocationGroupConnection = {
  __typename: 'LocationGroupConnection';
  edges?: Maybe<Array<LocationGroupEdge>>;
  pageInfo: PageInfo;
};

export type LocationGroupCreateInput = {
  locationUuids?: InputMaybe<Array<Scalars['ID']['input']>>;
  name: Scalars['String']['input'];
};

export type LocationGroupEdge = {
  __typename: 'LocationGroupEdge';
  cursor: Scalars['ID']['output'];
  node: LocationGroup;
};

export type LocationGroupFilter = {
  locationGroupEquals?: InputMaybe<Scalars['String']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  uuidContains?: InputMaybe<Array<Scalars['ID']['input']>>;
};

export type LocationGroupUpdateInput = {
  locationUuids?: InputMaybe<Array<Scalars['ID']['input']>>;
  name: Scalars['String']['input'];
  uuid: Scalars['ID']['input'];
};

export type LocationLookupDetails = {
  __typename: 'LocationLookupDetails';
  brandUuid: Scalars['OCUUID']['output'];
  hardwareVendor: Hardware_Vendor;
  identifier: Scalars['String']['output'];
  locationUuid: Scalars['OCUUID']['output'];
  loyaltyEnabled: Scalars['Boolean']['output'];
  mobileEnabled: Scalars['Boolean']['output'];
  timezone: Scalars['String']['output'];
};

export type LocationProfile = {
  __typename: 'LocationProfile';
  city?: Maybe<Scalars['String']['output']>;
  locationId?: Maybe<Scalars['ID']['output']>;
  state?: Maybe<Scalars['String']['output']>;
  zipcode?: Maybe<Scalars['String']['output']>;
};

export type LocationProfileCreateOrUpdateInput = {
  city?: InputMaybe<Scalars['String']['input']>;
  customerUuid: Scalars['ID']['input'];
  locationId?: InputMaybe<Scalars['ID']['input']>;
  state?: InputMaybe<Scalars['String']['input']>;
  zipcode?: InputMaybe<Scalars['String']['input']>;
};

export type LocationResource = {
  __typename: 'LocationResource';
  carWashItems?: Maybe<CarWashItemConnection>;
  fuelItems?: Maybe<FuelItemConnection>;
  position?: Maybe<Scalars['String']['output']>;
  resourceType: Location_Resource_Type;
  status?: Maybe<Location_Resource_Status>;
  storeItems?: Maybe<StoreItemConnection>;
  uuid: Scalars['ID']['output'];
};


export type LocationResourceCarWashItemsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<ResourceItemFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


export type LocationResourceFuelItemsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<ResourceItemFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


export type LocationResourceStoreItemsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<ResourceItemFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type LocationResourceCreate = {
  carWashItems?: InputMaybe<Array<InputMaybe<CarWashItemCreate>>>;
  fuelItems?: InputMaybe<Array<InputMaybe<FuelItemCreate>>>;
  position?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<Location_Resource_Status>;
  storeItems?: InputMaybe<Array<InputMaybe<StoreItemCreate>>>;
  type?: InputMaybe<Location_Resource_Type>;
  uuid?: InputMaybe<Scalars['ID']['input']>;
};

export type LocationResourceFilter = {
  items?: InputMaybe<ResourceItemFilter>;
  statusContains?: InputMaybe<Array<InputMaybe<Location_Resource_Status>>>;
  statusEquals?: InputMaybe<Location_Resource_Status>;
  typeContains?: InputMaybe<Array<InputMaybe<Location_Resource_Type>>>;
  typeEquals?: InputMaybe<Location_Resource_Type>;
};

export type LocationSort = {
  direction: SortOrder;
  field: LocationSortBy;
};

export enum LocationSortBy {
  LastLoyaltyConnection = 'LAST_LOYALTY_CONNECTION',
  LastMobileConnection = 'LAST_MOBILE_CONNECTION',
  SiteId = 'SITE_ID'
}

export type LocationUpdate = {
  address?: InputMaybe<AddressInput>;
  altriaMan?: InputMaybe<Scalars['String']['input']>;
  altriaMatchApiEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  altriaPPlusApiEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  altriaRcn?: InputMaybe<Scalars['String']['input']>;
  altriaSubmitterID?: InputMaybe<Scalars['String']['input']>;
  attributes?: InputMaybe<Array<LocationAttributeCreate>>;
  brandSpecificLocationId?: InputMaybe<Scalars['String']['input']>;
  brandingDetails?: InputMaybe<LocationBrandingDetailsInput>;
  changeSource?: InputMaybe<Change_Source>;
  circanaSubmitterID?: InputMaybe<Scalars['String']['input']>;
  customerId?: InputMaybe<Scalars['String']['input']>;
  customerName?: InputMaybe<Scalars['String']['input']>;
  dealerNumber?: InputMaybe<Scalars['String']['input']>;
  externalCustomData?: InputMaybe<Scalars['OCJSON']['input']>;
  grocerLong?: InputMaybe<Scalars['String']['input']>;
  grocerShort?: InputMaybe<Scalars['String']['input']>;
  hoursOfOperationGroup?: InputMaybe<HoursOfOperationGroupUpdate>;
  isAvtSupported?: InputMaybe<Scalars['Boolean']['input']>;
  locationGroupUuids?: InputMaybe<Array<Scalars['ID']['input']>>;
  loyaltyProgramOffer?: InputMaybe<Scalars['String']['input']>;
  msaSubmitterID?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  openCommerceFeatures?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  payAtPumpEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  paymentProviderMerchantId?: InputMaybe<Scalars['String']['input']>;
  phoneNumbers?: InputMaybe<Array<InputMaybe<Scalars['OCPhoneNumber']['input']>>>;
  resources?: InputMaybe<Array<InputMaybe<LocationResourceCreate>>>;
  retailerName?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Replaced by rewardPrograms. */
  rewardProgramLoyaltyProviders?: InputMaybe<Array<InputMaybe<RewardProgramUpdate>>>;
  rewardPrograms?: InputMaybe<Array<InputMaybe<RewardProgramUpdate>>>;
  rjrAccountNumber?: InputMaybe<Scalars['String']['input']>;
  siteSystemConfiguration?: InputMaybe<Array<InputMaybe<SiteSystemConfigurationUpdate>>>;
  siteSystemConfigurations?: InputMaybe<SiteSystemConfigurationInput>;
  storeBrand?: InputMaybe<Scalars['String']['input']>;
  subBrandUuid?: InputMaybe<Scalars['OCUUID']['input']>;
  timezone?: InputMaybe<Scalars['OCTimeZone']['input']>;
  uuid: Scalars['ID']['input'];
};

export type LocationsByPriceBookGroup = {
  __typename: 'LocationsByPriceBookGroup';
  locations: Array<Scalars['ID']['output']>;
  priceBookGroup: Scalars['String']['output'];
};

export type LocationsFilterInput = {
  globalOffersIncluded?: InputMaybe<Global_Offers_Filter>;
  locationGroups?: InputMaybe<Array<Scalars['String']['input']>>;
  locations?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type LoyaltyAccount = {
  __typename: 'LoyaltyAccount';
  accountNumber: Scalars['String']['output'];
  alias: Scalars['String']['output'];
  rewardProgram: RewardProgram;
  uuid: Scalars['ID']['output'];
};

export type LoyaltyAccountCreate = {
  accountNumber: Scalars['String']['input'];
  rewardProgramUuid: Scalars['ID']['input'];
};

export type LoyaltyAccountUpdate = {
  accountNumber: Scalars['String']['input'];
  rewardProgramUuid: Scalars['ID']['input'];
  uuid?: InputMaybe<Scalars['ID']['input']>;
};

export type LoyaltyEvent = {
  __typename: 'LoyaltyEvent';
  chain: Chain;
  commandCenterUserId?: Maybe<Scalars['ID']['output']>;
  createdAt: Scalars['OCDateTime']['output'];
  eventData?: Maybe<Scalars['OCJSON']['output']>;
  eventType: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  oAuthClientUuid?: Maybe<Scalars['ID']['output']>;
  origin?: Maybe<Loyalty_Event_Origin>;
  reportedRepresentative?: Maybe<Scalars['String']['output']>;
};

export type LoyaltyEventBatch = {
  __typename: 'LoyaltyEventBatch';
  loyaltyEvents: Array<LoyaltyEvent>;
};

export type LoyaltyEventBatchCreateInput = {
  chainId: Scalars['ID']['input'];
  eventsData: Array<LoyaltyEventsDataInput>;
};

export type LoyaltyEventConnection = {
  __typename: 'LoyaltyEventConnection';
  edges: Array<LoyaltyEventEdge>;
  pageInfo: PageInfo;
};

export type LoyaltyEventCreate = {
  chainId: Scalars['ID']['input'];
  customerUuid: Scalars['ID']['input'];
  eventData?: InputMaybe<Scalars['OCJSON']['input']>;
  eventType: Scalars['String']['input'];
  origin?: InputMaybe<Loyalty_Event_Origin>;
};

export type LoyaltyEventEdge = {
  __typename: 'LoyaltyEventEdge';
  cursor: Scalars['ID']['output'];
  node: LoyaltyEvent;
};

export type LoyaltyEventFilter = {
  createdAtMax?: InputMaybe<Scalars['OCDateTime']['input']>;
  createdAtMin?: InputMaybe<Scalars['OCDateTime']['input']>;
  idEquals?: InputMaybe<Scalars['ID']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
};

export type LoyaltyEventsDataInput = {
  eventData?: InputMaybe<Scalars['OCJSON']['input']>;
  eventType: Scalars['String']['input'];
  membershipId: Scalars['ID']['input'];
  origin?: InputMaybe<Loyalty_Event_Origin>;
};

export type LoyaltyHealth = {
  __typename: 'LoyaltyHealth';
  connectedToNodeId?: Maybe<Scalars['String']['output']>;
  isCurrentlyConnected: Scalars['Boolean']['output'];
  lastFinalizeRewardsRequestMessageAt?: Maybe<Scalars['OCDateTime']['output']>;
  lastFinalizeRewardsRequestMessages?: Maybe<Array<Scalars['OCJSON']['output']>>;
  lastGetRewardsRequestMessageAt?: Maybe<Scalars['OCDateTime']['output']>;
  lastGetRewardsRequestMessages?: Maybe<Array<Scalars['OCJSON']['output']>>;
  lastHeartbeatMessage?: Maybe<Scalars['OCJSON']['output']>;
  lastHeartbeatMessageAt?: Maybe<Scalars['OCDateTime']['output']>;
  lastMessageAt?: Maybe<Scalars['OCDateTime']['output']>;
};

export type LoyaltyInstrument = {
  __typename: 'LoyaltyInstrument';
  accountNumber: Scalars['String']['output'];
  alias: Scalars['String']['output'];
  status: Loyalty_Instrument_Status;
  uuid: Scalars['ID']['output'];
};

export type LoyaltyRewardsEligibilityRestriction = {
  __typename: 'LoyaltyRewardsEligibilityRestriction';
  data: Array<FuelGrade>;
  loyaltyProgramId: Scalars['String']['output'];
  type: Loyalty_Rewards_Eligibility_Restriction_Type;
  uuid: Scalars['ID']['output'];
};

export type LoyaltyRewardsEligibilityRestrictionCreateInput = {
  data: Array<FuelGradeInput>;
  loyaltyProgramId: Scalars['String']['input'];
  type: Loyalty_Rewards_Eligibility_Restriction_Type;
};

export type LoyaltyRewardsEligibilityRestrictionUpdateInput = {
  data?: InputMaybe<Array<FuelGradeInput>>;
  loyaltyProgramId?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<Loyalty_Rewards_Eligibility_Restriction_Type>;
  uuid: Scalars['ID']['input'];
};

export type LoyaltyTransactions = {
  __typename: 'LoyaltyTransactions';
  chartData: Array<GoalProgressChartData>;
  goalProgress: GoalProgress;
  perStoreAverage: Scalars['Float']['output'];
};

export type LoyaltyTransactionsBreakdown = {
  __typename: 'LoyaltyTransactionsBreakdown';
  fuelAmount: PerTransactionBreakdown;
  fuelTransactionCount: Scalars['Int']['output'];
  fuelVolume: PerTransactionBreakdown;
  merchandise: PerTransactionBreakdown;
  merchandiseTransactionCount: Scalars['Int']['output'];
  total: PerTransactionBreakdown;
};

export type LulaOrderAheadCreateSessionPayload = {
  __typename: 'LulaOrderAheadCreateSessionPayload';
  iframeUrl: Scalars['OCURL']['output'];
};

export enum Magic_Link_User_Origin {
  ActivateCommandCenter = 'ACTIVATE_COMMAND_CENTER',
  ParIntelligence = 'PAR_INTELLIGENCE',
  RetailerConnect = 'RETAILER_CONNECT',
  TransactCommandCenter = 'TRANSACT_COMMAND_CENTER'
}

export enum Membership_Event_Type {
  Active = 'ACTIVE',
  Birthday = 'BIRTHDAY',
  Created = 'CREATED'
}

export enum Membership_State {
  Active = 'ACTIVE',
  Deleted = 'DELETED',
  DeletionPlaceholder = 'DELETION_PLACEHOLDER',
  NewMember = 'NEW_MEMBER',
  Paused = 'PAUSED',
  Suspended = 'SUSPENDED'
}

export enum Membership_Type {
  Employee = 'EMPLOYEE',
  Manager = 'MANAGER',
  RcUser = 'RC_USER',
  Standard = 'STANDARD'
}

export type MagicLinkExchangePayload = {
  __typename: 'MagicLinkExchangePayload';
  tokens: Tokens;
};

export type MagicLinkExchangeSessionIdResult = {
  __typename: 'MagicLinkExchangeSessionIdResult';
  identity: UserIdentity;
  tokens: Tokens;
};

export type MagicLinkExchangeSessionIdToAuthTokenInput = {
  /** @deprecated No longer needed to distinguish between origins */
  origin?: InputMaybe<Magic_Link_User_Origin>;
  sessionId: Scalars['String']['input'];
};

export type MagicLinkRequestInput = {
  identifier: Scalars['String']['input'];
  origin?: InputMaybe<Magic_Link_User_Origin>;
};

export type MagicLinkSessionCreateInput = {
  data?: InputMaybe<AuthSessionDataInput>;
  identifier: Scalars['String']['input'];
  /** @deprecated No longer needed to distinguish between origins */
  origin?: InputMaybe<Magic_Link_User_Origin>;
};

export type MagicLinkSessionPayload = {
  __typename: 'MagicLinkSessionPayload';
  sessionId: Scalars['String']['output'];
};

export type MarketingContent = {
  __typename: 'MarketingContent';
  createdAt: Scalars['OCDateTime']['output'];
  customData?: Maybe<Scalars['OCJSON']['output']>;
  disclaimer?: Maybe<Scalars['String']['output']>;
  disclaimerUrl?: Maybe<Scalars['OCURL']['output']>;
  externalUrl?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  imageUrl?: Maybe<Scalars['OCURL']['output']>;
  locale: Scalars['String']['output'];
  longDescription?: Maybe<Scalars['String']['output']>;
  receiptContent?: Maybe<ReceiptContent>;
  shortDescription?: Maybe<Scalars['String']['output']>;
  surgeonGeneralsWarning?: Maybe<Scalars['String']['output']>;
  terms?: Maybe<Scalars['String']['output']>;
  termsUrl?: Maybe<Scalars['OCURL']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  triggeredMessageContent: OfferTriggeredMessageContent;
};

export type MarketingContentCreateInput = {
  customData?: InputMaybe<Scalars['OCJSON']['input']>;
  disclaimer?: InputMaybe<Scalars['String']['input']>;
  disclaimerUrl?: InputMaybe<Scalars['OCURL']['input']>;
  externalUrl?: InputMaybe<Scalars['String']['input']>;
  imageUrl?: InputMaybe<Scalars['OCURL']['input']>;
  locale: Scalars['String']['input'];
  longDescription?: InputMaybe<Scalars['String']['input']>;
  offerId: Scalars['ID']['input'];
  receiptContent?: InputMaybe<ReceiptContentInput>;
  shortDescription?: InputMaybe<Scalars['String']['input']>;
  surgeonGeneralsWarning?: InputMaybe<Scalars['String']['input']>;
  terms?: InputMaybe<Scalars['String']['input']>;
  termsUrl?: InputMaybe<Scalars['OCURL']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  triggeredMessageContent?: InputMaybe<OfferTriggeredMessageContentInput>;
};

export type MarketingContentUpdateInput = {
  customData?: InputMaybe<Scalars['OCJSON']['input']>;
  disclaimer?: InputMaybe<Scalars['String']['input']>;
  disclaimerUrl?: InputMaybe<Scalars['OCURL']['input']>;
  externalUrl?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  imageUrl?: InputMaybe<Scalars['OCURL']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  longDescription?: InputMaybe<Scalars['String']['input']>;
  receiptContent?: InputMaybe<ReceiptContentInput>;
  shortDescription?: InputMaybe<Scalars['String']['input']>;
  surgeonGeneralsWarning?: InputMaybe<Scalars['String']['input']>;
  terms?: InputMaybe<Scalars['String']['input']>;
  termsUrl?: InputMaybe<Scalars['OCURL']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  triggeredMessageContent?: InputMaybe<OfferTriggeredMessageContentInput>;
};

export type MemberDossier = FeatureConfiguration & {
  __typename: 'MemberDossier';
  enabled: Scalars['Boolean']['output'];
  useForSegments: Scalars['Boolean']['output'];
};

export type MemberDossierSegment = {
  __typename: 'MemberDossierSegment';
  createdAt: Scalars['OCDateTime']['output'];
  description: Scalars['String']['output'];
  membershipCount: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  segmentUploadedFiles: SegmentUploadFileConnection;
  shortCode?: Maybe<Scalars['String']['output']>;
  uuid: Scalars['OCUUID']['output'];
};


export type MemberDossierSegmentSegmentUploadedFilesArgs = {
  after?: InputMaybe<Scalars['OCBase64Cursor']['input']>;
  before?: InputMaybe<Scalars['OCBase64Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type MemberDossierSegmentAddMembershipsInput = {
  membershipUuids: Array<Scalars['OCUUID']['input']>;
  segmentUuid: Scalars['OCUUID']['input'];
};

export type MemberDossierSegmentConnection = {
  __typename: 'MemberDossierSegmentConnection';
  edges: Array<MemberDossierSegmentEdge>;
  pageInfo: PageInfo;
};

export type MemberDossierSegmentCreateInput = {
  chainId: Scalars['OCUUID']['input'];
  description: Scalars['String']['input'];
  name: Scalars['String']['input'];
  shortCode?: InputMaybe<Scalars['String']['input']>;
};

export type MemberDossierSegmentEdge = {
  __typename: 'MemberDossierSegmentEdge';
  cursor: Scalars['OCBase64Cursor']['output'];
  node: MemberDossierSegment;
};

export type MemberDossierSegmentFilterInput = {
  chainIdEquals?: InputMaybe<Scalars['OCUUID']['input']>;
  isDeleted?: InputMaybe<Scalars['Boolean']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  uuidContains?: InputMaybe<Array<Scalars['OCUUID']['input']>>;
  uuidEquals?: InputMaybe<Scalars['OCUUID']['input']>;
  uuidExcludes?: InputMaybe<Array<Scalars['OCUUID']['input']>>;
};

export type MemberDossierSegmentForMembershipFilterInput = {
  membershipUuid: Scalars['OCUUID']['input'];
  search?: InputMaybe<Scalars['String']['input']>;
};

export type MemberDossierSegmentRemoveMembershipsInput = {
  membershipUuids: Array<Scalars['OCUUID']['input']>;
  segmentUuid: Scalars['OCUUID']['input'];
};

export type MemberDossierSegmentUpdateInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  shortCode?: InputMaybe<Scalars['String']['input']>;
  uuid: Scalars['OCUUID']['input'];
};

export type Membership = {
  __typename: 'Membership';
  address: Array<MembershipAddress>;
  barcodeIdentifier: Scalars['String']['output'];
  birthdate?: Maybe<Scalars['OCDate']['output']>;
  chain: Chain;
  comments: MembershipProfileCommentConnection;
  createdAt: Scalars['OCDateTime']['output'];
  customData?: Maybe<Scalars['OCJSON']['output']>;
  customerUuid?: Maybe<Scalars['ID']['output']>;
  displayBrand?: Maybe<Scalars['String']['output']>;
  email?: Maybe<Scalars['OCEmailAddress']['output']>;
  externalIdentityVerificationProfiles?: Maybe<Array<ExternalIdentityVerificationProfile>>;
  externalLoyaltyIds: Array<ExternalLoyaltyId>;
  firstName?: Maybe<Scalars['String']['output']>;
  fuelAndConvenienceProfile?: Maybe<FuelAndConvenienceProfile>;
  homeStores?: Maybe<Array<HomeStore>>;
  id: Scalars['ID']['output'];
  incomingReferral?: Maybe<IncomingReferral>;
  lastName?: Maybe<Scalars['String']['output']>;
  lastSubBrandOffersQueriesUuid?: Maybe<Scalars['ID']['output']>;
  lifetimeMetrics: MembershipLifetimeMetrics;
  locationProfile?: Maybe<LocationProfile>;
  loyaltyEvents: LoyaltyEventConnection;
  membershipActivities: MembershipActivityConnection;
  membershipType?: Maybe<Membership_Type>;
  offerPurchases: OfferPurchaseConnection;
  offers: OfferConnection;
  phone?: Maybe<Scalars['OCPhoneNumber']['output']>;
  pointChanges: PointChangeConnection;
  pointExpirationSchedule: PointExpirationScheduleConnection;
  points: Scalars['Int']['output'];
  primaryAddress?: Maybe<MembershipAddress>;
  productInterests: Array<ProductCategory>;
  /** @deprecated Replaced by productInterests. */
  productPreferences: Array<DisplayCategory>;
  programTermsAcceptanceAt?: Maybe<Scalars['OCDateTime']['output']>;
  /** @deprecated QR codes are no longer used. Use barcodeIdentifier instead */
  qrIdentifier: Scalars['String']['output'];
  referralCode: Scalars['OCReferralCode']['output'];
  referralUrl: Scalars['OCURL']['output'];
  referrals: ReferralConnection;
  segments?: Maybe<Array<Segment>>;
  state: Membership_State;
  stateChanges: Array<MembershipState>;
  storedValueBalance?: Maybe<Scalars['Int']['output']>;
  storedValueExpirationSchedule: StoredValueExpirationScheduleConnection;
  totalAvailableRollback?: Maybe<TotalAvailableRollback>;
  transactions: ActivateTransactionConnection;
  vouchers: VoucherConnection;
};


export type MembershipCommentsArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  filter?: InputMaybe<MembershipProfileCommentFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


export type MembershipLoyaltyEventsArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  filter?: InputMaybe<LoyaltyEventFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


export type MembershipMembershipActivitiesArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  filter?: InputMaybe<MembershipActivityFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<MembershipActivitySort>;
};


export type MembershipOfferPurchasesArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


export type MembershipOffersArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  filter?: InputMaybe<OfferFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<OfferSort>;
};


export type MembershipPointChangesArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  filter?: InputMaybe<PointChangeFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<PointChangeSort>;
};


export type MembershipPointExpirationScheduleArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


export type MembershipReferralsArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  filter?: InputMaybe<ReferralFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


export type MembershipStoredValueExpirationScheduleArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


export type MembershipTotalAvailableRollbackArgs = {
  filter?: InputMaybe<TotalAvailableRollbackFilter>;
};


export type MembershipTransactionsArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  filter?: InputMaybe<ActivateTransactionFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<ActivateTransactionSort>;
};


export type MembershipVouchersArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  filter?: InputMaybe<VoucherFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<VoucherSort>;
};

export type MembershipActivity = {
  __typename: 'MembershipActivity';
  createdAt: Scalars['OCDateTime']['output'];
  event: MembershipActivityEvent;
  id: Scalars['ID']['output'];
  membership: Membership;
  type: MembershipActivityTypename;
};

export type MembershipActivityConnection = {
  __typename: 'MembershipActivityConnection';
  edges: Array<Maybe<MembershipActivityEdge>>;
  pageInfo: PageInfo;
};

export type MembershipActivityEdge = {
  __typename: 'MembershipActivityEdge';
  cursor: Scalars['ID']['output'];
  node?: Maybe<MembershipActivity>;
};

export type MembershipActivityEvent = ActivateTransaction | PointChange;

export type MembershipActivityFilter = {
  idEquals?: InputMaybe<Scalars['ID']['input']>;
  membershipActivityType?: InputMaybe<MembershipActivityTypename>;
  pointChangeSourceTypeExcludes?: InputMaybe<Array<Point_Change_Source_Type>>;
  pointChangeSourceTypeIncludes?: InputMaybe<Array<Point_Change_Source_Type>>;
  search?: InputMaybe<Scalars['String']['input']>;
  transactionCreatedAtMax?: InputMaybe<Scalars['OCDateTime']['input']>;
  transactionCreatedAtMin?: InputMaybe<Scalars['OCDateTime']['input']>;
};

export type MembershipActivitySort = {
  direction: Sort_Order;
  field: MembershipActivitySortBy;
};

export enum MembershipActivitySortBy {
  CreatedAt = 'CREATED_AT'
}

export enum MembershipActivityTypename {
  PointChange = 'POINT_CHANGE',
  Transaction = 'TRANSACTION'
}

export type MembershipAddress = {
  __typename: 'MembershipAddress';
  address1?: Maybe<Scalars['String']['output']>;
  address2?: Maybe<Scalars['String']['output']>;
  city?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['OCDateTime']['output'];
  primary: Scalars['Boolean']['output'];
  state?: Maybe<Scalars['String']['output']>;
  uuid: Scalars['ID']['output'];
  zipcode?: Maybe<Scalars['String']['output']>;
};

export type MembershipAddressCreateInput = {
  address1?: InputMaybe<Scalars['String']['input']>;
  address2?: InputMaybe<Scalars['String']['input']>;
  city?: InputMaybe<Scalars['String']['input']>;
  customerUuid?: InputMaybe<Scalars['ID']['input']>;
  membershipId?: InputMaybe<Scalars['ID']['input']>;
  primary?: InputMaybe<Scalars['Boolean']['input']>;
  state?: InputMaybe<Scalars['String']['input']>;
  zipcode?: InputMaybe<Scalars['String']['input']>;
};

export type MembershipAddressUpdateInput = {
  address1?: InputMaybe<Scalars['String']['input']>;
  address2?: InputMaybe<Scalars['String']['input']>;
  city?: InputMaybe<Scalars['String']['input']>;
  primary?: InputMaybe<Scalars['Boolean']['input']>;
  state?: InputMaybe<Scalars['String']['input']>;
  uuid: Scalars['ID']['input'];
  zipcode?: InputMaybe<Scalars['String']['input']>;
};

export type MembershipAdjustPointsInput = {
  customerUuid: Scalars['ID']['input'];
  mathematicalFunction: Adjust_Points_Mathematical_Function;
  notes?: InputMaybe<Scalars['String']['input']>;
  pointAdjustmentReasonId?: InputMaybe<Scalars['ID']['input']>;
  points: Scalars['Int']['input'];
};

export type MembershipBatch = {
  __typename: 'MembershipBatch';
  memberships: Array<Membership>;
};

export type MembershipBatchStateTransitionInput = {
  customerUuids?: InputMaybe<Array<Scalars['ID']['input']>>;
  ids?: InputMaybe<Array<Scalars['ID']['input']>>;
  state: Membership_State;
};

export type MembershipConnection = {
  __typename: 'MembershipConnection';
  edges: Array<MembershipEdge>;
  pageInfo: PageInfo;
};

export type MembershipContext = {
  restrictionVerification?: InputMaybe<Category_Restrictions>;
};

export type MembershipCreateInput = {
  acquisitionChannel?: InputMaybe<Sign_Up_Origin>;
  birthdate?: InputMaybe<Scalars['OCDate']['input']>;
  chainId: Scalars['ID']['input'];
  customData?: InputMaybe<Scalars['OCJSON']['input']>;
  displayBrand?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['OCEmailAddress']['input']>;
  externalAuthSource?: InputMaybe<Scalars['String']['input']>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  membershipType?: InputMaybe<Membership_Type>;
  phone: Scalars['OCPhoneNumber']['input'];
  programTermsAcceptanceAt?: InputMaybe<Scalars['OCDateTime']['input']>;
  referralCode?: InputMaybe<Scalars['String']['input']>;
};

export type MembershipDeleteInput = {
  deletionRequestSource?: InputMaybe<DeletionRequestSourceInput>;
  membershipUuid: Scalars['ID']['input'];
};

export type MembershipDonatePointsInput = {
  bucketId: Scalars['ID']['input'];
  membershipId: Scalars['ID']['input'];
  points: Scalars['Int']['input'];
};

export type MembershipEdge = {
  __typename: 'MembershipEdge';
  cursor: Scalars['ID']['output'];
  node: Membership;
};

export type MembershipFilter = {
  chainIdEquals?: InputMaybe<Scalars['ID']['input']>;
  createdAtMax?: InputMaybe<Scalars['OCDateTime']['input']>;
  createdAtMin?: InputMaybe<Scalars['OCDateTime']['input']>;
  emailEquals?: InputMaybe<Scalars['OCEmailAddress']['input']>;
  externalId?: InputMaybe<ExternalLoyaltyIdFilterInput>;
  idContains?: InputMaybe<Array<Scalars['ID']['input']>>;
  idEquals?: InputMaybe<Scalars['ID']['input']>;
  phoneEquals?: InputMaybe<Scalars['OCPhoneNumber']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
};

export type MembershipHomeStoresCreateOrUpdateInput = {
  customerUuid: Scalars['ID']['input'];
  locationUuids: Array<Scalars['ID']['input']>;
};

export type MembershipLifetimeMetrics = {
  __typename: 'MembershipLifetimeMetrics';
  pointsDonated?: Maybe<Scalars['Int']['output']>;
  pointsEarned: Scalars['Int']['output'];
  savingsFuelCents?: Maybe<Scalars['Int']['output']>;
  savingsLoyaltyAndFuelCents?: Maybe<Scalars['Int']['output']>;
  savingsLoyaltyCents?: Maybe<Scalars['Int']['output']>;
  savingsStoredValueCents?: Maybe<Scalars['Int']['output']>;
  storedValueEarnedCents?: Maybe<Scalars['Int']['output']>;
};

export type MembershipPointDonation = {
  __typename: 'MembershipPointDonation';
  bucket: DonationBucket;
  donationAmountCents: Scalars['Int']['output'];
  id: Scalars['ID']['output'];
  pointsSpent: Scalars['Int']['output'];
};

export type MembershipPrimaryAddressInput = {
  address1?: InputMaybe<Scalars['String']['input']>;
  address2?: InputMaybe<Scalars['String']['input']>;
  city?: InputMaybe<Scalars['String']['input']>;
  state?: InputMaybe<Scalars['String']['input']>;
  zipcode?: InputMaybe<Scalars['String']['input']>;
};

export type MembershipProfileComment = {
  __typename: 'MembershipProfileComment';
  author: CommandCenterUser;
  createdAt: Scalars['OCDateTime']['output'];
  id: Scalars['ID']['output'];
  text: Scalars['String']['output'];
};

export type MembershipProfileCommentConnection = {
  __typename: 'MembershipProfileCommentConnection';
  edges: Array<MembershipProfileCommentEdge>;
  pageInfo: PageInfo;
};

export type MembershipProfileCommentCreateInput = {
  customerUuid: Scalars['ID']['input'];
  text: Scalars['String']['input'];
};

export type MembershipProfileCommentEdge = {
  __typename: 'MembershipProfileCommentEdge';
  cursor: Scalars['ID']['output'];
  node: MembershipProfileComment;
};

export type MembershipProfileCommentFilter = {
  authorEmail?: InputMaybe<Scalars['String']['input']>;
  createdAtMax?: InputMaybe<Scalars['OCDateTime']['input']>;
  createdAtMin?: InputMaybe<Scalars['OCDateTime']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
};

export type MembershipState = {
  __typename: 'MembershipState';
  effectiveAt?: Maybe<Scalars['OCDateTime']['output']>;
  source?: Maybe<StateChangeSource>;
  sourceType?: Maybe<State_Change_Source_Type>;
  state: Membership_State;
};

export type MembershipStateTransition = {
  customerUuid?: InputMaybe<Scalars['ID']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  state: Membership_State;
};

export type MembershipTypeUpdate = {
  customerUuid?: InputMaybe<Scalars['OCUUID']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  membershipType: Membership_Type;
};

export type MembershipUpdate = {
  birthdate?: InputMaybe<Scalars['OCDate']['input']>;
  customData?: InputMaybe<CustomDataInput>;
  customerUuid?: InputMaybe<Scalars['ID']['input']>;
  displayBrand?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['OCEmailAddress']['input']>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  membershipType?: InputMaybe<Membership_Type>;
  phone?: InputMaybe<Scalars['OCPhoneNumber']['input']>;
  primaryAddress?: InputMaybe<MembershipPrimaryAddressInput>;
  programTermsAcceptanceAt?: InputMaybe<Scalars['OCDateTime']['input']>;
};

export enum MessageIntent {
  Promotional = 'PROMOTIONAL',
  Transactional = 'TRANSACTIONAL'
}

export type MetricCounts = {
  __typename: 'MetricCounts';
  eventType: Event_Types;
  subtotal: Scalars['String']['output'];
  timeSeries: MetricCountsTimeSeries;
  total: Scalars['String']['output'];
};

export type MetricCountsFilter = {
  chainIdEquals: Scalars['ID']['input'];
  dateMax: Scalars['OCDateTime']['input'];
  dateMin: Scalars['OCDateTime']['input'];
  interval: Interval;
};

export type MetricCountsTimeSeries = {
  __typename: 'MetricCountsTimeSeries';
  interval: Interval;
  values: Array<MetricCountsTimeSeriesValues>;
};

export type MetricCountsTimeSeriesValues = {
  __typename: 'MetricCountsTimeSeriesValues';
  count: Scalars['String']['output'];
  date: Scalars['OCDate']['output'];
};

export type MobileHealth = {
  __typename: 'MobileHealth';
  connectedToNodeId?: Maybe<Scalars['String']['output']>;
  isCurrentlyConnected: Scalars['Boolean']['output'];
  lastHeartbeatMessage?: Maybe<Scalars['OCJSON']['output']>;
  lastHeartbeatMessageAt?: Maybe<Scalars['OCDateTime']['output']>;
  lastMessageAt?: Maybe<Scalars['OCDateTime']['output']>;
  lastMobileAuthRequestMessageAt?: Maybe<Scalars['OCDateTime']['output']>;
  lastMobileAuthRequestMessages?: Maybe<Array<Scalars['OCJSON']['output']>>;
  lastMobileAuthResponseMessageAt?: Maybe<Scalars['OCDateTime']['output']>;
  lastMobileAuthResponseMessages?: Maybe<Array<Scalars['OCJSON']['output']>>;
  lastMobileFinalizeRequestMessageAt?: Maybe<Scalars['OCDateTime']['output']>;
  lastMobileFinalizeRequestMessages?: Maybe<Array<Scalars['OCJSON']['output']>>;
  lastMobilePumpReserveRequestMessageAt?: Maybe<Scalars['OCDateTime']['output']>;
  lastMobilePumpReserveRequestMessages?: Maybe<Array<Scalars['OCJSON']['output']>>;
  lastMobilePumpReserveResponseMessageAt?: Maybe<Scalars['OCDateTime']['output']>;
  lastMobilePumpReserveResponseMessages?: Maybe<Array<Scalars['OCJSON']['output']>>;
  lastSiteInfoRequestMessage?: Maybe<Scalars['OCJSON']['output']>;
  lastSiteInfoRequestMessageAt?: Maybe<Scalars['OCDateTime']['output']>;
};

export type MobileTransactionFraudCheck = FeatureConfiguration & {
  __typename: 'MobileTransactionFraudCheck';
  enabled: Scalars['Boolean']['output'];
  provider: MobileTransactionFraudCheckProvider;
};

export enum MobileTransactionFraudCheckProvider {
  Kount = 'KOUNT'
}

export type Mutation = {
  __typename: 'Mutation';
  activateCancelProcessedTransaction: Scalars['Boolean']['output'];
  activateCancelRedemptionRequest: Scalars['Boolean']['output'];
  activateCancelTransactionRequest: Scalars['Boolean']['output'];
  activateFinalizeRewardsRequest?: Maybe<Scalars['Boolean']['output']>;
  activateGetRewardsRequest?: Maybe<ActivateGetRewardsResponseContainer>;
  activateTransactionCreate: ActivateTransaction;
  addClaimsToAuthorizationIdentityGroup: AuthorizationIdentityGroup;
  addLocationsToGroup: LocationGroup;
  ageVerifyAndEaivReset?: Maybe<AgeVerifyAndEaivResetResult>;
  allowListPhoneNumberCreate: AllowListPhoneNumber;
  allowListPhoneNumberDelete: Scalars['Boolean']['output'];
  allowListPhoneNumberUpdate: AllowListPhoneNumber;
  archiveAudienceBroadcastMessage: AudienceBroadcastMessage;
  archiveExternalLoyaltyManualOffer: Scalars['Boolean']['output'];
  archiveKiosk: Kiosk;
  archiveKioskAdSet: KioskAdSet;
  associateLocationsWithRetailerNetworkUsers: Scalars['Boolean']['output'];
  associateRetailerNetworkLocationGroupsWithRetailerNetworkUsers: Scalars['Boolean']['output'];
  audienceActivate: Audience;
  audienceCreate: Audience;
  audienceDelete: Scalars['Boolean']['output'];
  audienceUpdate: Audience;
  brazeFieldCreate: BrazeField;
  brazeFieldUpdate: BrazeField;
  bulkUserCreate?: Maybe<Array<Maybe<OpenCommerceUser>>>;
  campaignCreate: Campaign;
  campaignDelete: Scalars['Boolean']['output'];
  campaignUpdate: Campaign;
  clearActivityLog: Scalars['Boolean']['output'];
  commandCenterUserCreate?: Maybe<CommandCenterUser>;
  commandCenterUserDisable?: Maybe<CommandCenterUser>;
  commandCenterUserEnable?: Maybe<CommandCenterUser>;
  commandCenterUserUpdate?: Maybe<CommandCenterUser>;
  configureReferralProgram: ReferralProgramConfiguration;
  constraintCreate: Constraint;
  constraintDelete: Scalars['Boolean']['output'];
  constraintUpdate: Constraint;
  createAudienceBroadcastMessage: AudienceBroadcastMessage;
  createAuthorizationIdentityGroup: AuthorizationIdentityGroup;
  createCSRCustomerMagicLink: CsrMagicLink;
  createCSROTPSession: CreateCsrotpSessionResult;
  createExternalIdentityVerificationAuthorizationUrl: ExternalIdentityVerificationAuthorizationUrlPayload;
  createExternalLoyaltyId: ExternalLoyaltyId;
  createExternalLoyaltyManualOfferInActivate: Scalars['Boolean']['output'];
  createExternalProgram: ExternalProgram;
  createKiosk: Kiosk;
  createKioskAdSet: KioskAdSet;
  createKioskAppConfig: KioskAppConfig;
  createKioskAsset: KioskAsset;
  createKioskDefaultScreen: KioskDefaultScreen;
  createOrderAheadSession: OrderAheadCreateSessionPayload;
  createSiteIssue: SiteIssue;
  customerCreate?: Maybe<Customer>;
  customerPasswordSet: Scalars['Boolean']['output'];
  customerSoftDelete: Scalars['Boolean']['output'];
  customerUpdate?: Maybe<Customer>;
  customerUpdateEaivStatus: Customer;
  customerUpdateState?: Maybe<Scalars['Boolean']['output']>;
  deleteAuthorizationIdentityGroup: Scalars['Boolean']['output'];
  deleteAuthorizationIdentityGroups: Scalars['Boolean']['output'];
  deleteExternalLoyaltyId: Scalars['ID']['output'];
  deleteExternalProgram: Scalars['ID']['output'];
  deleteKioskAdSet: Scalars['Boolean']['output'];
  deleteKioskAsset: Scalars['Boolean']['output'];
  deleteKioskDefaultScreen: Scalars['Boolean']['output'];
  deleteSiteIssue: Scalars['Boolean']['output'];
  disassociateLocationsWithRetailerNetworkUsers: Scalars['Boolean']['output'];
  disassociateRetailerNetworkLocationGroupsWithRetailerNetworkUsers: Scalars['Boolean']['output'];
  displayCategoryCreate?: Maybe<DisplayCategory>;
  displayCategoryDelete?: Maybe<Scalars['Boolean']['output']>;
  displayCategoryUpdate?: Maybe<DisplayCategory>;
  donationBucketCreate: DonationBucket;
  donationBucketDelete: Scalars['Boolean']['output'];
  donationBucketUpdate: DonationBucket;
  driveSetReaction: DriveResponse;
  driveTriggerStreamingPrompt: DriveResponse;
  eaivAgeVerificationStart: EaivAgeVerificationStartResult;
  eaivIdentityVerificationStart: EaivIdentityVerificationStartResult;
  eaivIdentityVerificationSubmit: EaivIdentityVerificationSubmitResult;
  earningMechanismCreate: EarningMechanism;
  earningMechanismDelete: Scalars['Boolean']['output'];
  earningMechanismUpdate: EarningMechanism;
  emailRetailerNetworkScanDataTobaccoSiteSubmissionsCsvReport: Scalars['Boolean']['output'];
  emailRetailerNetworkScanDataTobaccoSubmissionsCsvReport: Scalars['Boolean']['output'];
  fuelAndConvenienceProfileCreateOrUpdate: FuelAndConvenienceProfile;
  fuelProductGroupCreate: ProductGroup;
  fuelProductGroupUpdate: ProductGroup;
  generalSurveyCreate: GeneralSurvey;
  generalSurveyStatusUpdate: GeneralSurvey;
  generalSurveyUpdate: GeneralSurvey;
  generateCustomerPasswordResetToken: Scalars['String']['output'];
  generateKioskAssetUploadSignedUrl: KioskAssetUploadSignedUrl;
  generateSegmentUploadSignedUrl: GenerateSegmentUploadResponse;
  getAccessTokenByRefreshToken?: Maybe<Tokens>;
  /** @deprecated Used for WS Surveys only. Mutation will be removed after BE refactor. */
  guestSurveyAnswerSend: Scalars['Boolean']['output'];
  limitCreate: Limit;
  limitDelete: Scalars['Boolean']['output'];
  limitUpdate: Limit;
  locationBulkOperationHoursUpdate: BulkUpdateLocationResult;
  locationBulkOperationHoursUpdateForRetailerNetwork: BulkUpdateLocationResult;
  locationBulkSubmitterIdUpdate: Scalars['Boolean']['output'];
  locationCreate?: Maybe<Location>;
  locationDelete?: Maybe<Scalars['Boolean']['output']>;
  locationGroupCreate: LocationGroup;
  locationGroupDelete?: Maybe<Scalars['Boolean']['output']>;
  locationGroupUpdate: LocationGroup;
  locationProfileCreateOrUpdate?: Maybe<LocationProfile>;
  locationUpdate?: Maybe<Location>;
  loyaltyEventBatchCreate: LoyaltyEventBatch;
  loyaltyEventCreate?: Maybe<LoyaltyEvent>;
  loyaltyRewardsEligibilityRestrictionsCreate: LoyaltyRewardsEligibilityRestriction;
  loyaltyRewardsEligibilityRestrictionsUpdate: LoyaltyRewardsEligibilityRestriction;
  magicLinkExchangeRefreshTokenToAuthToken: Tokens;
  magicLinkExchangeSessionIdToAuthToken: MagicLinkExchangePayload;
  magicLinkLogout: Scalars['Boolean']['output'];
  markAudienceForCalculation: Scalars['Boolean']['output'];
  marketingContentCreate: MarketingContent;
  marketingContentDelete: Scalars['Boolean']['output'];
  marketingContentUpdate: MarketingContent;
  membershipAddressCreate: MembershipAddress;
  membershipAddressDelete: Scalars['Boolean']['output'];
  membershipAddressUpdate: MembershipAddress;
  membershipAdjustPoints?: Maybe<Membership>;
  membershipBatchStateTransition: MembershipBatch;
  membershipCreate?: Maybe<Membership>;
  membershipDelete: Scalars['Boolean']['output'];
  membershipDonatePoints: MembershipPointDonation;
  membershipHomeStoresCreateOrUpdate: Membership;
  membershipProfileCommentCreate: MembershipProfileComment;
  membershipStateTransition?: Maybe<Membership>;
  membershipTypeUpdate?: Maybe<Membership>;
  membershipUpdate?: Maybe<Membership>;
  oAuthApplicationAuthenticate: OAuthAccessToken;
  offerActivate?: Maybe<Offer>;
  offerActivityLog: Scalars['Boolean']['output'];
  offerActivityLogBatch: Scalars['Boolean']['output'];
  offerCreate: Offer;
  offerDeactivate?: Maybe<Offer>;
  offerDelete: Scalars['Boolean']['output'];
  offerDisplayCategoriesCreateOrUpdate: Offer;
  offerDisplayCategoryCreate: Offer;
  offerDisplayCategoryDelete: Scalars['Boolean']['output'];
  offerPurchaseCreate?: Maybe<Array<Maybe<OfferPurchase>>>;
  offerPurchaseReturn?: Maybe<OfferPurchase>;
  offerUpdate: Offer;
  openCommerceUserCreate: OpenCommerceUser;
  openCommerceUserUpdate: OpenCommerceUser;
  parPayAppConfigurationCreate: ParPayPaymentAppConfig;
  parPayAppConfigurationDelete: Scalars['Boolean']['output'];
  parPayAppConfigurationUpdate: ParPayPaymentAppConfig;
  parPayCorporateAccountCreate: ParPayCorporateAccount;
  parPayCorporateAccountDisable: ParPayCorporateAccount;
  parPayCorporateAccountEnable: ParPayCorporateAccount;
  parPayCorporateAccountUpdate: ParPayCorporateAccount;
  parPayMerchantAccountCreate: ParPayMerchantAccount;
  parPayMerchantAccountDisable: ParPayMerchantAccount;
  parPayMerchantAccountEnable: ParPayMerchantAccount;
  parPayMerchantAccountUpdate: ParPayMerchantAccount;
  processSegmentUpload: Scalars['Boolean']['output'];
  productCategoryCreate?: Maybe<ProductCategory>;
  productCategoryDelete?: Maybe<Scalars['Boolean']['output']>;
  productCategoryUpdate?: Maybe<ProductCategory>;
  productGroupCreate: ProductGroup;
  productGroupDelete: Scalars['Boolean']['output'];
  productGroupUpdate: ProductGroup;
  productInterestCreate: ProductInterest;
  productInterestDelete: Scalars['Boolean']['output'];
  productInterestsReplace: Membership;
  productPreferenceCreate: ProductPreference;
  productPreferenceDelete: Scalars['Boolean']['output'];
  productPreferenceReplace: Membership;
  promoCodeGroupDelete: Scalars['ID']['output'];
  promoCodesUploadProcess: PromoCodeGroup;
  promoCodesUploadSignedUrlGenerate: PromoCodesUploadUrlGenerateResponse;
  promocodeBatchCreate: Array<Promocode>;
  promocodeBatchDelete: Array<Scalars['ID']['output']>;
  promocodeBatchUpdate: Array<Promocode>;
  promocodesStatusesUpdate: Array<Promocode>;
  publishKioskAdSet: KioskAdSet;
  purchaseStoredValue: StoredValueTransaction;
  pushNotificationByTopicSend: Scalars['Boolean']['output'];
  pushNotificationDirectSend: PushNotificationDirectSendPayload;
  redeemPromocode: RedeemPromocodeResult;
  removeClaimsFromAuthorizationIdentityGroup: AuthorizationIdentityGroup;
  removeLocationFromRetailerNetwork: Scalars['Boolean']['output'];
  removeLocationGroupFromRetailerNetwork: Scalars['Boolean']['output'];
  removeLocationsFromGroup: LocationGroup;
  removeUserFromRetailerNetwork: Scalars['Boolean']['output'];
  reportAudienceStartGenerationJob: ReportGenerationJob;
  requestMagicLink: Scalars['Boolean']['output'];
  retailerNetworkCreate: RetailerNetwork;
  retailerNetworkDelete: Scalars['Boolean']['output'];
  retailerNetworkLocationGroupAddLocations: Scalars['Boolean']['output'];
  retailerNetworkLocationGroupCreate: RetailerNetworkLocationGroup;
  retailerNetworkLocationGroupDelete: Scalars['Boolean']['output'];
  retailerNetworkLocationGroupRemoveLocations: Scalars['Boolean']['output'];
  retailerNetworkLocationGroupUpdate: RetailerNetworkLocationGroup;
  retailerNetworkUpdate: RetailerNetwork;
  retailerNetworkUserCreate: RetailerNetworkUser;
  retailerNetworkUserUpdate: RetailerNetworkUser;
  scanDataGenerateSubmissionCSV: Scalars['OCURL']['output'];
  scanDataSftpCredentialsCreate: ScanDataSftpCredential;
  scanDataSftpCredentialsUpdate: ScanDataSftpCredential;
  scanDataSumbitWeeklyFile: Scalars['Boolean']['output'];
  scrubData: Scalars['Boolean']['output'];
  segmentCreate: Segment;
  segmentDelete: Scalars['Boolean']['output'];
  segmentMembershipAdd: Segment;
  segmentMembershipDelete: Scalars['Boolean']['output'];
  segmentUpdate: Segment;
  sendTestMessage: Scalars['Boolean']['output'];
  setLocationPerformanceGoal: Scalars['Boolean']['output'];
  siteDisconnect: Scalars['Boolean']['output'];
  spinWheelGameExecute?: Maybe<RandomAwardConfig>;
  steeringWalletActivate: Scalars['Boolean']['output'];
  steeringWalletArchive: Scalars['Boolean']['output'];
  steeringWalletCreate: SteeringWallet;
  steeringWalletDeactivate: Scalars['Boolean']['output'];
  steeringWalletUnarchive: Scalars['Boolean']['output'];
  steeringWalletUpdate: SteeringWallet;
  storedValueProgramCreate: StoredValueProgram;
  storedValueProgramUpdate: StoredValueProgram;
  submitReferralCodeSharedEvent: ReferralCodeSharedEvent;
  surveyAnswerSubmit: Scalars['Boolean']['output'];
  surveyAnswersSubmit: Scalars['Boolean']['output'];
  surveyDelete: Scalars['Boolean']['output'];
  surveyDeploy: SurveyDeployment;
  surveyDeploymentCancel: Scalars['Boolean']['output'];
  surveyDismiss: Scalars['Boolean']['output'];
  surveyOfferCreate: Offer;
  /** @deprecated Split into surveyOfferCreate and surveyOfferUpdate. */
  surveyOfferCreateOrUpdate?: Maybe<Offer>;
  surveyOfferDelete: Scalars['Boolean']['output'];
  surveyOfferUpdate: Offer;
  surveyViewsCreate: Scalars['Boolean']['output'];
  syncKioskMdmConfig: Kiosk;
  tempFinalizeRewardsRequest: Scalars['Boolean']['output'];
  tempGetRewardsRequest?: Maybe<TempRmqGetRewardsResponseContainer>;
  transactionCancel: Scalars['Boolean']['output'];
  transactionExternalPaymentFinalize: Transaction;
  transactionExternalPaymentStart: Transaction;
  transactionRefund?: Maybe<Transaction>;
  triggerVisibilityNotifications: Scalars['Boolean']['output'];
  unarchiveKiosk: Kiosk;
  unsetLocationPerformanceGoal: Scalars['Boolean']['output'];
  updateAudienceBroadcastMessage: AudienceBroadcastMessage;
  updateAuthorizationClaim: AuthorizationClaim;
  updateAuthorizationIdentityGroup: AuthorizationIdentityGroup;
  updateCommunicationPreference: CommunicationPreference;
  updateExternalLoyaltyId: ExternalLoyaltyId;
  updateExternalProgram: ExternalProgram;
  updateKiosk: Kiosk;
  updateKioskAdSet: KioskAdSet;
  updateKioskAppConfig: KioskAppConfig;
  updateKioskAsset: KioskAsset;
  updateKioskDefaultScreen: KioskDefaultScreen;
  updateSiteIssue: SiteIssue;
  updateSmsOptInStatusExternal: Scalars['Boolean']['output'];
  updateTriggeredMessage: TriggeredMessage;
  updateTriggeredMessageStatus: TriggeredMessage;
  userLogin?: Maybe<AuthChallengeOrAccessToken>;
  userLogout?: Maybe<Scalars['Boolean']['output']>;
  userPasswordCreate?: Maybe<AuthChallengeOrAccessToken>;
  userPasswordReset?: Maybe<AuthChallenge>;
  userVerifyLoginByOtp?: Maybe<AuthChallengeOrAccessToken>;
  userVerifyPasswordResetByOtp?: Maybe<Scalars['Boolean']['output']>;
  validateAndResetCustomerPassword: AuthTokens;
  validateScanDataSftpConnection: Scalars['Boolean']['output'];
  verifyCSROTPSession: CsrMagicLink;
  walletSteeringSurveyCreate: WalletSteeringSurvey;
  walletSteeringSurveyUpdate: WalletSteeringSurvey;
};


export type MutationActivateCancelProcessedTransactionArgs = {
  input: ActivateCancelProcessedTransactionInput;
};


export type MutationActivateCancelRedemptionRequestArgs = {
  input: ActivateCancelRedemptionRequestInput;
};


export type MutationActivateCancelTransactionRequestArgs = {
  input: ActivateCancelTransactionRequestContainerInput;
};


export type MutationActivateFinalizeRewardsRequestArgs = {
  input: ActivateFinalizeRewardsRequestContainerInput;
};


export type MutationActivateGetRewardsRequestArgs = {
  input: ActivateGetRewardsRequestContainerInput;
};


export type MutationActivateTransactionCreateArgs = {
  input: ActivateTransactionCreateInput;
};


export type MutationAddClaimsToAuthorizationIdentityGroupArgs = {
  input: AuthorizationIdentityGroupAddClaimsInput;
};


export type MutationAddLocationsToGroupArgs = {
  input: AddLocationsToGroupInput;
};


export type MutationAgeVerifyAndEaivResetArgs = {
  customerUuid: Scalars['ID']['input'];
};


export type MutationAllowListPhoneNumberCreateArgs = {
  input: AllowListPhoneNumberCreateInput;
};


export type MutationAllowListPhoneNumberDeleteArgs = {
  input: AllowListPhoneNumberDeleteInput;
};


export type MutationAllowListPhoneNumberUpdateArgs = {
  input: AllowListPhoneNumberUpdateInput;
};


export type MutationArchiveAudienceBroadcastMessageArgs = {
  id: Scalars['OCUUID']['input'];
};


export type MutationArchiveExternalLoyaltyManualOfferArgs = {
  uuid: Scalars['OCUUID']['input'];
};


export type MutationArchiveKioskArgs = {
  id: Scalars['OCUUID']['input'];
};


export type MutationArchiveKioskAdSetArgs = {
  id: Scalars['ID']['input'];
};


export type MutationAssociateLocationsWithRetailerNetworkUsersArgs = {
  locationUuids: Array<Scalars['OCUUID']['input']>;
  retailerNetworkUserUuids: Array<Scalars['OCUUID']['input']>;
  retailerNetworkUuid: Scalars['OCUUID']['input'];
};


export type MutationAssociateRetailerNetworkLocationGroupsWithRetailerNetworkUsersArgs = {
  locationGroupUuids: Array<Scalars['OCUUID']['input']>;
  retailerNetworkUserUuids: Array<Scalars['OCUUID']['input']>;
  retailerNetworkUuid: Scalars['OCUUID']['input'];
};


export type MutationAudienceActivateArgs = {
  uuid: Scalars['ID']['input'];
};


export type MutationAudienceCreateArgs = {
  input: AudienceCreate;
};


export type MutationAudienceDeleteArgs = {
  uuid: Scalars['ID']['input'];
};


export type MutationAudienceUpdateArgs = {
  input: AudienceUpdate;
};


export type MutationBrazeFieldCreateArgs = {
  input: BrazeFieldCreateInput;
};


export type MutationBrazeFieldUpdateArgs = {
  input: BrazeFieldUpdateInput;
};


export type MutationBulkUserCreateArgs = {
  input?: InputMaybe<Array<OpenCommerceUserCreateInput>>;
};


export type MutationCampaignCreateArgs = {
  input: CampaignCreateInput;
};


export type MutationCampaignDeleteArgs = {
  uuid: Scalars['ID']['input'];
};


export type MutationCampaignUpdateArgs = {
  input: CampaignUpdateInput;
};


export type MutationClearActivityLogArgs = {
  input: ClearActivityLog;
};


export type MutationCommandCenterUserCreateArgs = {
  input: CommandCenterUserCreateInput;
};


export type MutationCommandCenterUserDisableArgs = {
  input: CommandCenterUserDisableInput;
};


export type MutationCommandCenterUserEnableArgs = {
  input: CommandCenterUserEnableInput;
};


export type MutationCommandCenterUserUpdateArgs = {
  input: CommandCenterUserUpdateInput;
};


export type MutationConfigureReferralProgramArgs = {
  input: ReferralProgramConfigurationInput;
};


export type MutationConstraintCreateArgs = {
  input: ConstraintCreateInput;
};


export type MutationConstraintDeleteArgs = {
  id: Scalars['ID']['input'];
};


export type MutationConstraintUpdateArgs = {
  input: ConstraintUpdateInput;
};


export type MutationCreateAudienceBroadcastMessageArgs = {
  input: CreateAudienceBroadcastMessageInput;
};


export type MutationCreateAuthorizationIdentityGroupArgs = {
  input: AuthorizationIdentityGroupCreateInput;
};


export type MutationCreateCsrCustomerMagicLinkArgs = {
  input: CsrMagicLinkSessionCreateInput;
};


export type MutationCreateCsrotpSessionArgs = {
  input: CreateCsrotpSessionInput;
};


export type MutationCreateExternalIdentityVerificationAuthorizationUrlArgs = {
  input: ExternalIdentityVerificationAuthorizationUrlInput;
};


export type MutationCreateExternalLoyaltyIdArgs = {
  input: CreateExternalLoyaltyIdInput;
};


export type MutationCreateExternalLoyaltyManualOfferInActivateArgs = {
  uuid: Scalars['OCUUID']['input'];
};


export type MutationCreateExternalProgramArgs = {
  input: CreateExternalProgramInput;
};


export type MutationCreateKioskArgs = {
  input: KioskCreateInput;
};


export type MutationCreateKioskAdSetArgs = {
  input: KioskAdSetCreateInput;
};


export type MutationCreateKioskAppConfigArgs = {
  input: KioskAppConfigCreateInput;
};


export type MutationCreateKioskAssetArgs = {
  input: KioskAssetCreateInput;
};


export type MutationCreateKioskDefaultScreenArgs = {
  input: KioskDefaultScreenCreateInput;
};


export type MutationCreateOrderAheadSessionArgs = {
  input: OrderAheadCreateSessionInput;
};


export type MutationCreateSiteIssueArgs = {
  input: CreateSiteIssueInput;
};


export type MutationCustomerCreateArgs = {
  input: CustomerCreate;
};


export type MutationCustomerPasswordSetArgs = {
  customerUuid: Scalars['ID']['input'];
  input: CustomerPasswordSet;
};


export type MutationCustomerSoftDeleteArgs = {
  customerUuid: Scalars['ID']['input'];
};


export type MutationCustomerUpdateArgs = {
  customerUuid: Scalars['ID']['input'];
  input: CustomerUpdate;
};


export type MutationCustomerUpdateEaivStatusArgs = {
  input: CustomerUpdateEaivStatusInput;
  phoneNumber: Scalars['OCPhoneNumber']['input'];
};


export type MutationCustomerUpdateStateArgs = {
  customerUuid: Scalars['ID']['input'];
  input: CustomerUpdateStateInput;
};


export type MutationDeleteAuthorizationIdentityGroupArgs = {
  uuid: Scalars['OCUUID']['input'];
};


export type MutationDeleteAuthorizationIdentityGroupsArgs = {
  uuids: Array<Scalars['OCUUID']['input']>;
};


export type MutationDeleteExternalLoyaltyIdArgs = {
  input: DeleteExternalLoyaltyIdInput;
};


export type MutationDeleteExternalProgramArgs = {
  input: DeleteExternalProgramInput;
};


export type MutationDeleteKioskAdSetArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteKioskAssetArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteKioskDefaultScreenArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteSiteIssueArgs = {
  input: DeleteSiteIssueInput;
};


export type MutationDisassociateLocationsWithRetailerNetworkUsersArgs = {
  locationUuids: Array<Scalars['OCUUID']['input']>;
  retailerNetworkUserUuids: Array<Scalars['OCUUID']['input']>;
  retailerNetworkUuid: Scalars['OCUUID']['input'];
};


export type MutationDisassociateRetailerNetworkLocationGroupsWithRetailerNetworkUsersArgs = {
  locationGroupUuids: Array<Scalars['OCUUID']['input']>;
  retailerNetworkUserUuids: Array<Scalars['OCUUID']['input']>;
  retailerNetworkUuid: Scalars['OCUUID']['input'];
};


export type MutationDisplayCategoryCreateArgs = {
  input: DisplayCategoryCreateInput;
};


export type MutationDisplayCategoryDeleteArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDisplayCategoryUpdateArgs = {
  input: DisplayCategoryUpdateInput;
};


export type MutationDonationBucketCreateArgs = {
  input: DonationBucketCreateInput;
};


export type MutationDonationBucketDeleteArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDonationBucketUpdateArgs = {
  input: DonationBucketUpdateInput;
};


export type MutationDriveSetReactionArgs = {
  input: DriveSetReactionInput;
};


export type MutationDriveTriggerStreamingPromptArgs = {
  input: DriveSendPromptInput;
};


export type MutationEaivAgeVerificationStartArgs = {
  customerUuid: Scalars['OCUUID']['input'];
  input: EaivAgeVerificationStartInput;
};


export type MutationEaivIdentityVerificationStartArgs = {
  customerUuid: Scalars['OCUUID']['input'];
  input: EaivIdentityVerificationStartInput;
};


export type MutationEaivIdentityVerificationSubmitArgs = {
  customerUuid: Scalars['OCUUID']['input'];
  input: EaivIdentityVerificationSubmitInput;
};


export type MutationEarningMechanismCreateArgs = {
  input: EarningMechanismCreateInput;
};


export type MutationEarningMechanismDeleteArgs = {
  id: Scalars['ID']['input'];
};


export type MutationEarningMechanismUpdateArgs = {
  input: EarningMechanismUpdateInput;
};


export type MutationEmailRetailerNetworkScanDataTobaccoSiteSubmissionsCsvReportArgs = {
  emailToSendReport: Scalars['OCEmailAddress']['input'];
  filter: RetailerNetworkScanDataTobaccoSiteSubmissionFilter;
};


export type MutationEmailRetailerNetworkScanDataTobaccoSubmissionsCsvReportArgs = {
  emailToSendReport: Scalars['OCEmailAddress']['input'];
  filter: RetailerNetworkScanDataTobaccoSubmissionFilter;
};


export type MutationFuelAndConvenienceProfileCreateOrUpdateArgs = {
  input: FuelAndConvenienceProfileCreateOrUpdateInput;
};


export type MutationFuelProductGroupCreateArgs = {
  chainId: Scalars['ID']['input'];
  input: FuelProductGroupCreateInput;
};


export type MutationFuelProductGroupUpdateArgs = {
  input: FuelProductGroupUpdateInput;
  productGroupId: Scalars['ID']['input'];
};


export type MutationGeneralSurveyCreateArgs = {
  input: GeneralSurveyCreateInput;
};


export type MutationGeneralSurveyStatusUpdateArgs = {
  input: GeneralSurveyStatusUpdateInput;
};


export type MutationGeneralSurveyUpdateArgs = {
  input: GeneralSurveyUpdateInput;
};


export type MutationGenerateCustomerPasswordResetTokenArgs = {
  input: GenerateCustomerPasswordResetTokenInput;
};


export type MutationGenerateKioskAssetUploadSignedUrlArgs = {
  input: KioskAssetUploadSignedUrlInput;
};


export type MutationGenerateSegmentUploadSignedUrlArgs = {
  fileName: Scalars['String']['input'];
};


export type MutationGetAccessTokenByRefreshTokenArgs = {
  input: AccessTokenByRefreshTokenInput;
};


export type MutationGuestSurveyAnswerSendArgs = {
  input: GuestSurveyAnswerSendInput;
};


export type MutationLimitCreateArgs = {
  input: LimitCreateInput;
};


export type MutationLimitDeleteArgs = {
  id: Scalars['ID']['input'];
};


export type MutationLimitUpdateArgs = {
  input: LimitUpdateInput;
};


export type MutationLocationBulkOperationHoursUpdateArgs = {
  hoursOfOperationUpdates: Array<HoursOfOperationUpdate>;
  locationUuids: Array<Scalars['OCUUID']['input']>;
  updatedByUserUuid: Scalars['OCUUID']['input'];
};


export type MutationLocationBulkOperationHoursUpdateForRetailerNetworkArgs = {
  hoursOfOperationUpdates: Array<HoursOfOperationUpdate>;
  retailerNetworkUuid: Scalars['OCUUID']['input'];
};


export type MutationLocationBulkSubmitterIdUpdateArgs = {
  input: LocationBulkSubmitterIdUpdateInput;
};


export type MutationLocationCreateArgs = {
  input: LocationCreate;
};


export type MutationLocationDeleteArgs = {
  uuid: Scalars['ID']['input'];
};


export type MutationLocationGroupCreateArgs = {
  input: LocationGroupCreateInput;
};


export type MutationLocationGroupDeleteArgs = {
  uuid: Scalars['ID']['input'];
};


export type MutationLocationGroupUpdateArgs = {
  input: LocationGroupUpdateInput;
};


export type MutationLocationProfileCreateOrUpdateArgs = {
  input: LocationProfileCreateOrUpdateInput;
};


export type MutationLocationUpdateArgs = {
  input: LocationUpdate;
};


export type MutationLoyaltyEventBatchCreateArgs = {
  input: LoyaltyEventBatchCreateInput;
};


export type MutationLoyaltyEventCreateArgs = {
  input: LoyaltyEventCreate;
};


export type MutationLoyaltyRewardsEligibilityRestrictionsCreateArgs = {
  input: LoyaltyRewardsEligibilityRestrictionCreateInput;
};


export type MutationLoyaltyRewardsEligibilityRestrictionsUpdateArgs = {
  input: LoyaltyRewardsEligibilityRestrictionUpdateInput;
};


export type MutationMagicLinkExchangeRefreshTokenToAuthTokenArgs = {
  input: AccessTokenByRefreshTokenInput;
};


export type MutationMagicLinkExchangeSessionIdToAuthTokenArgs = {
  input: MagicLinkExchangeSessionIdToAuthTokenInput;
};


export type MutationMarkAudienceForCalculationArgs = {
  uuid: Scalars['ID']['input'];
};


export type MutationMarketingContentCreateArgs = {
  input: MarketingContentCreateInput;
};


export type MutationMarketingContentDeleteArgs = {
  id: Scalars['ID']['input'];
};


export type MutationMarketingContentUpdateArgs = {
  input: MarketingContentUpdateInput;
};


export type MutationMembershipAddressCreateArgs = {
  input: MembershipAddressCreateInput;
};


export type MutationMembershipAddressDeleteArgs = {
  uuid: Scalars['ID']['input'];
};


export type MutationMembershipAddressUpdateArgs = {
  input: MembershipAddressUpdateInput;
};


export type MutationMembershipAdjustPointsArgs = {
  input: MembershipAdjustPointsInput;
};


export type MutationMembershipBatchStateTransitionArgs = {
  input: MembershipBatchStateTransitionInput;
};


export type MutationMembershipCreateArgs = {
  input: MembershipCreateInput;
};


export type MutationMembershipDeleteArgs = {
  input: MembershipDeleteInput;
};


export type MutationMembershipDonatePointsArgs = {
  input: MembershipDonatePointsInput;
};


export type MutationMembershipHomeStoresCreateOrUpdateArgs = {
  input: MembershipHomeStoresCreateOrUpdateInput;
};


export type MutationMembershipProfileCommentCreateArgs = {
  input: MembershipProfileCommentCreateInput;
};


export type MutationMembershipStateTransitionArgs = {
  input: MembershipStateTransition;
};


export type MutationMembershipTypeUpdateArgs = {
  input: MembershipTypeUpdate;
};


export type MutationMembershipUpdateArgs = {
  input: MembershipUpdate;
};


export type MutationOAuthApplicationAuthenticateArgs = {
  credentials: OAuthCredentialsInput;
};


export type MutationOfferActivateArgs = {
  input: OfferActivateInput;
};


export type MutationOfferActivityLogArgs = {
  input: OfferActivityLogInput;
};


export type MutationOfferActivityLogBatchArgs = {
  input: Array<OfferActivityLogInput>;
};


export type MutationOfferCreateArgs = {
  input: OfferCreateInput;
};


export type MutationOfferDeactivateArgs = {
  input: OfferDeactivateInput;
};


export type MutationOfferDeleteArgs = {
  id: Scalars['ID']['input'];
};


export type MutationOfferDisplayCategoriesCreateOrUpdateArgs = {
  input: OfferDisplayCategoriesInput;
};


export type MutationOfferDisplayCategoryCreateArgs = {
  input: OfferDisplayCategoryInput;
};


export type MutationOfferDisplayCategoryDeleteArgs = {
  input: OfferDisplayCategoryInput;
};


export type MutationOfferPurchaseCreateArgs = {
  customerUuid?: InputMaybe<Scalars['ID']['input']>;
  input: OfferPurchaseCreateInput;
  membershipId?: InputMaybe<Scalars['ID']['input']>;
};


export type MutationOfferPurchaseReturnArgs = {
  customerUuid?: InputMaybe<Scalars['ID']['input']>;
  input: OfferPurchaseReturnInput;
  membershipId?: InputMaybe<Scalars['ID']['input']>;
};


export type MutationOfferUpdateArgs = {
  input: OfferUpdateInput;
};


export type MutationOpenCommerceUserCreateArgs = {
  input: OpenCommerceUserCreateInput;
};


export type MutationOpenCommerceUserUpdateArgs = {
  input: OpenCommerceUserUpdateInput;
};


export type MutationParPayAppConfigurationCreateArgs = {
  input: ParPayAppConfigurationCreateInput;
};


export type MutationParPayAppConfigurationDeleteArgs = {
  corpId: Scalars['String']['input'];
};


export type MutationParPayAppConfigurationUpdateArgs = {
  input: ParPayAppConfigurationUpdateInput;
};


export type MutationParPayCorporateAccountCreateArgs = {
  input: ParPayCorporateAccountCreateInput;
};


export type MutationParPayCorporateAccountDisableArgs = {
  uuid: Scalars['ID']['input'];
};


export type MutationParPayCorporateAccountEnableArgs = {
  uuid: Scalars['ID']['input'];
};


export type MutationParPayCorporateAccountUpdateArgs = {
  input: ParPayCorporateAccountUpdateInput;
};


export type MutationParPayMerchantAccountCreateArgs = {
  input: ParPayMerchantAccountCreateInput;
};


export type MutationParPayMerchantAccountDisableArgs = {
  uuid: Scalars['ID']['input'];
};


export type MutationParPayMerchantAccountEnableArgs = {
  uuid: Scalars['ID']['input'];
};


export type MutationParPayMerchantAccountUpdateArgs = {
  input: ParPayMerchantAccountUpdateInput;
};


export type MutationProcessSegmentUploadArgs = {
  input: ProcessSegmentUploadInput;
};


export type MutationProductCategoryCreateArgs = {
  input: ProductCategoryCreateInput;
};


export type MutationProductCategoryDeleteArgs = {
  id: Scalars['ID']['input'];
};


export type MutationProductCategoryUpdateArgs = {
  input: ProductCategoryUpdateInput;
};


export type MutationProductGroupCreateArgs = {
  chainId: Scalars['ID']['input'];
  input: ProductGroupInput;
};


export type MutationProductGroupDeleteArgs = {
  id: Scalars['ID']['input'];
};


export type MutationProductGroupUpdateArgs = {
  id: Scalars['ID']['input'];
  input: ProductGroupUpdateInput;
};


export type MutationProductInterestCreateArgs = {
  input: ProductInterestInput;
};


export type MutationProductInterestDeleteArgs = {
  input: ProductInterestInput;
};


export type MutationProductInterestsReplaceArgs = {
  input: ProductInterestsReplaceInput;
};


export type MutationProductPreferenceCreateArgs = {
  input: ProductPreferenceInput;
};


export type MutationProductPreferenceDeleteArgs = {
  input: ProductPreferenceInput;
};


export type MutationProductPreferenceReplaceArgs = {
  input: ProductPreferenceReplaceInput;
};


export type MutationPromoCodeGroupDeleteArgs = {
  id: Scalars['ID']['input'];
};


export type MutationPromoCodesUploadProcessArgs = {
  input: PromoCodesUploadProcessInput;
};


export type MutationPromoCodesUploadSignedUrlGenerateArgs = {
  fileName: Scalars['String']['input'];
};


export type MutationPromocodeBatchCreateArgs = {
  input: PromocodeBatchCreateInput;
};


export type MutationPromocodeBatchDeleteArgs = {
  ids: Array<Scalars['ID']['input']>;
};


export type MutationPromocodeBatchUpdateArgs = {
  input: Array<PromocodeUpdateInput>;
};


export type MutationPromocodesStatusesUpdateArgs = {
  input: Array<PromocodeStatusUpdateInput>;
};


export type MutationPublishKioskAdSetArgs = {
  id: Scalars['ID']['input'];
};


export type MutationPurchaseStoredValueArgs = {
  input: PurchaseStoredValueInput;
};


export type MutationPushNotificationByTopicSendArgs = {
  input: PushNotificationTopicSendInput;
};


export type MutationPushNotificationDirectSendArgs = {
  input: PushNotificationDirectSendInput;
};


export type MutationRedeemPromocodeArgs = {
  input: RedeemPromocodeInput;
};


export type MutationRemoveClaimsFromAuthorizationIdentityGroupArgs = {
  input: AuthorizationIdentityGroupRemoveClaimsInput;
};


export type MutationRemoveLocationFromRetailerNetworkArgs = {
  locationUuid: Scalars['OCUUID']['input'];
  retailerNetworkUuid: Scalars['OCUUID']['input'];
};


export type MutationRemoveLocationGroupFromRetailerNetworkArgs = {
  locationGroupUuid: Scalars['OCUUID']['input'];
  retailerNetworkUuid: Scalars['OCUUID']['input'];
};


export type MutationRemoveLocationsFromGroupArgs = {
  input: RemoveLocationsFromGroupInput;
};


export type MutationRemoveUserFromRetailerNetworkArgs = {
  retailerNetworkUuid: Scalars['OCUUID']['input'];
  userUuid: Scalars['OCUUID']['input'];
};


export type MutationReportAudienceStartGenerationJobArgs = {
  input: ReportAudienceStartGenerationJobInput;
};


export type MutationRequestMagicLinkArgs = {
  input: MagicLinkRequestInput;
};


export type MutationRetailerNetworkCreateArgs = {
  input: RetailerNetworkCreate;
};


export type MutationRetailerNetworkDeleteArgs = {
  uuid: Scalars['OCUUID']['input'];
};


export type MutationRetailerNetworkLocationGroupAddLocationsArgs = {
  locationGroupUuid: Scalars['OCUUID']['input'];
  locationUuids: Array<Scalars['OCUUID']['input']>;
  retailerNetworkUuid: Scalars['OCUUID']['input'];
};


export type MutationRetailerNetworkLocationGroupCreateArgs = {
  locationGroup: LocationGroupCreateInput;
  retailerNetworkUuid: Scalars['OCUUID']['input'];
};


export type MutationRetailerNetworkLocationGroupDeleteArgs = {
  locationGroupUuid: Scalars['OCUUID']['input'];
  retailerNetworkUuid: Scalars['OCUUID']['input'];
};


export type MutationRetailerNetworkLocationGroupRemoveLocationsArgs = {
  locationGroupUuid: Scalars['OCUUID']['input'];
  locationUuids: Array<Scalars['OCUUID']['input']>;
  retailerNetworkUuid: Scalars['OCUUID']['input'];
};


export type MutationRetailerNetworkLocationGroupUpdateArgs = {
  locationGroup: RetailerNetworkLocationGroupUpdateInput;
  retailerNetworkUuid: Scalars['OCUUID']['input'];
};


export type MutationRetailerNetworkUpdateArgs = {
  input: RetailerNetworkUpdate;
};


export type MutationRetailerNetworkUserCreateArgs = {
  input: RetailerNetworkUserCreate;
};


export type MutationRetailerNetworkUserUpdateArgs = {
  input: RetailerNetworkUserUpdate;
};


export type MutationScanDataGenerateSubmissionCsvArgs = {
  input: ScanDataGenerateSubmissionCsvInput;
};


export type MutationScanDataSftpCredentialsCreateArgs = {
  input: ScanDataSftpCredentialCreateInput;
};


export type MutationScanDataSftpCredentialsUpdateArgs = {
  input: ScanDataSftpCredentialUpdateInput;
};


export type MutationScanDataSumbitWeeklyFileArgs = {
  input: ScanDataSumbitWeeklyFileInput;
};


export type MutationScrubDataArgs = {
  input: ScrubDataInput;
};


export type MutationSegmentCreateArgs = {
  chainId: Scalars['ID']['input'];
  input: SegmentCreate;
};


export type MutationSegmentDeleteArgs = {
  id: Scalars['ID']['input'];
};


export type MutationSegmentMembershipAddArgs = {
  input: SegmentMembershipAddInput;
};


export type MutationSegmentMembershipDeleteArgs = {
  input: SegmentMembershipDeleteInput;
};


export type MutationSegmentUpdateArgs = {
  id: Scalars['ID']['input'];
  input: SegmentUpdate;
};


export type MutationSendTestMessageArgs = {
  input: SendTestMessageInput;
};


export type MutationSetLocationPerformanceGoalArgs = {
  input: SetLocationPerformanceGoal;
};


export type MutationSiteDisconnectArgs = {
  input: SiteDisconnectInput;
};


export type MutationSpinWheelGameExecuteArgs = {
  input: SpinWheelGameExecuteInput;
};


export type MutationSteeringWalletActivateArgs = {
  uuid: Scalars['OCUUID']['input'];
};


export type MutationSteeringWalletArchiveArgs = {
  uuid: Scalars['OCUUID']['input'];
};


export type MutationSteeringWalletCreateArgs = {
  input: SteeringWalletCreateInput;
};


export type MutationSteeringWalletDeactivateArgs = {
  uuid: Scalars['OCUUID']['input'];
};


export type MutationSteeringWalletUnarchiveArgs = {
  uuid: Scalars['OCUUID']['input'];
};


export type MutationSteeringWalletUpdateArgs = {
  input: SteeringWalletUpdateInput;
};


export type MutationStoredValueProgramCreateArgs = {
  input: StoredValueProgramCreateInput;
};


export type MutationStoredValueProgramUpdateArgs = {
  input: StoredValueProgramUpdateInput;
};


export type MutationSubmitReferralCodeSharedEventArgs = {
  membershipId: Scalars['ID']['input'];
};


export type MutationSurveyAnswerSubmitArgs = {
  input: SurveyAnswerSubmitInput;
};


export type MutationSurveyAnswersSubmitArgs = {
  input: SurveyAnswersSubmitInput;
};


export type MutationSurveyDeleteArgs = {
  uuid: Scalars['OCUUID']['input'];
};


export type MutationSurveyDeployArgs = {
  input: SurveyDeployInput;
};


export type MutationSurveyDeploymentCancelArgs = {
  uuid: Scalars['OCUUID']['input'];
};


export type MutationSurveyDismissArgs = {
  input: SurveyDismissInput;
};


export type MutationSurveyOfferCreateArgs = {
  input: SurveyOfferCreateInput;
};


export type MutationSurveyOfferCreateOrUpdateArgs = {
  input: SurveyOfferCreateOrUpdateInput;
};


export type MutationSurveyOfferDeleteArgs = {
  surveyUuid: Scalars['ID']['input'];
};


export type MutationSurveyOfferUpdateArgs = {
  input: SurveyOfferUpdateInput;
};


export type MutationSurveyViewsCreateArgs = {
  input: SurveyViewsCreateInput;
};


export type MutationSyncKioskMdmConfigArgs = {
  id: Scalars['OCUUID']['input'];
};


export type MutationTempFinalizeRewardsRequestArgs = {
  input: TempRmqFinalizeRewardsRequestContainerInput;
};


export type MutationTempGetRewardsRequestArgs = {
  input: TempRmqGetRewardsRequestContainerInput;
};


export type MutationTransactionCancelArgs = {
  uuid: Scalars['ID']['input'];
};


export type MutationTransactionExternalPaymentFinalizeArgs = {
  success: Scalars['Boolean']['input'];
  uuid: Scalars['ID']['input'];
};


export type MutationTransactionExternalPaymentStartArgs = {
  input: TransactionExternalPaymentStart;
};


export type MutationTransactionRefundArgs = {
  amount?: InputMaybe<Scalars['Float']['input']>;
  reasonDescription?: InputMaybe<Scalars['String']['input']>;
  refundedItems?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  uuid: Scalars['ID']['input'];
};


export type MutationTriggerVisibilityNotificationsArgs = {
  input: TriggerVisibilityNotificationsInput;
};


export type MutationUnarchiveKioskArgs = {
  id: Scalars['OCUUID']['input'];
};


export type MutationUnsetLocationPerformanceGoalArgs = {
  locationUuid: Scalars['OCUUID']['input'];
  retailerNetworkUuid: Scalars['OCUUID']['input'];
};


export type MutationUpdateAudienceBroadcastMessageArgs = {
  input: UpdateAudienceBroadcastMessageInput;
};


export type MutationUpdateAuthorizationClaimArgs = {
  input: AuthorizationClaimUpdateInput;
};


export type MutationUpdateAuthorizationIdentityGroupArgs = {
  input: AuthorizationIdentityGroupUpdateInput;
};


export type MutationUpdateCommunicationPreferenceArgs = {
  input: CommunicationPreferenceUpdateInput;
};


export type MutationUpdateExternalLoyaltyIdArgs = {
  input: UpdateExternalLoyaltyIdInput;
};


export type MutationUpdateExternalProgramArgs = {
  input: UpdateExternalProgramInput;
};


export type MutationUpdateKioskArgs = {
  input: KioskUpdateInput;
};


export type MutationUpdateKioskAdSetArgs = {
  input: KioskAdSetUpdateInput;
};


export type MutationUpdateKioskAppConfigArgs = {
  input: KioskAppConfigUpdateInput;
};


export type MutationUpdateKioskAssetArgs = {
  input: KioskAssetUpdateInput;
};


export type MutationUpdateKioskDefaultScreenArgs = {
  input: KioskDefaultScreenUpdateInput;
};


export type MutationUpdateSiteIssueArgs = {
  input: UpdateSiteIssueInput;
};


export type MutationUpdateSmsOptInStatusExternalArgs = {
  input: UpdateSmsOptInStatusExternalInput;
};


export type MutationUpdateTriggeredMessageArgs = {
  input: UpdateTriggeredMessageInput;
};


export type MutationUpdateTriggeredMessageStatusArgs = {
  input: UpdateTriggeredMessageStatusInput;
};


export type MutationUserLoginArgs = {
  input: UserLoginCredentials;
};


export type MutationUserPasswordCreateArgs = {
  newPassword: Scalars['String']['input'];
  otp: Otp;
};


export type MutationUserVerifyLoginByOtpArgs = {
  input: Otp;
};


export type MutationUserVerifyPasswordResetByOtpArgs = {
  confirmPassword: Scalars['String']['input'];
  newPassword: Scalars['String']['input'];
  otp: Otp;
};


export type MutationValidateAndResetCustomerPasswordArgs = {
  input: ValidateAndResetCustomerPasswordInput;
};


export type MutationValidateScanDataSftpConnectionArgs = {
  input: ValidateScanDataSftpConnectionInput;
};


export type MutationVerifyCsrotpSessionArgs = {
  otp: Otp;
};


export type MutationWalletSteeringSurveyCreateArgs = {
  input: WalletSteeringSurveyCreateInput;
};


export type MutationWalletSteeringSurveyUpdateArgs = {
  input: WalletSteeringSurveyUpdateInput;
};

export type NewMembers = {
  __typename: 'NewMembers';
  chartData: Array<GoalProgressChartData>;
  goalProgress: GoalProgress;
  perStoreAverage: Scalars['Float']['output'];
};

export type OAuthAccessToken = {
  __typename: 'OAuthAccessToken';
  brandUuid: Scalars['String']['output'];
  chainId: Scalars['String']['output'];
  createdAt: Scalars['Int']['output'];
  expires: Scalars['Int']['output'];
  scope: Scalars['String']['output'];
  token: Scalars['String']['output'];
};

export type OAuthCredentialsInput = {
  clientId: Scalars['String']['input'];
  clientSecret: Scalars['String']['input'];
  scope: Scalars['String']['input'];
};

export enum Offer_Activation_Status {
  Activated = 'ACTIVATED',
  DoesNotRequireActivation = 'DOES_NOT_REQUIRE_ACTIVATION',
  RequiresActivation = 'REQUIRES_ACTIVATION'
}

export enum Offer_Activity_Log_Channel_Type {
  App = 'APP',
  Email = 'EMAIL',
  Sms = 'SMS'
}

export enum Offer_Activity_Log_Type {
  Click = 'CLICK',
  Delivered = 'DELIVERED',
  Impression = 'IMPRESSION',
  Ltc = 'LTC',
  OptedOut = 'OPTED_OUT',
  Sent = 'SENT'
}

export enum Offer_Engagement_Type {
  Base = 'BASE',
  Behavioral = 'BEHAVIORAL',
  Billboard = 'BILLBOARD',
  ExternallyFulfillable = 'EXTERNALLY_FULFILLABLE',
  FuelRollback = 'FUEL_ROLLBACK',
  Game = 'GAME',
  GameVoucher = 'GAME_VOUCHER',
  Promocode = 'PROMOCODE',
  Promotional = 'PROMOTIONAL',
  PunchcardChallenge = 'PUNCHCARD_CHALLENGE',
  Purchaseable = 'PURCHASEABLE',
  StoredValue = 'STORED_VALUE',
  SurveyBehavioral = 'SURVEY_BEHAVIORAL',
  SweepstakesEntry = 'SWEEPSTAKES_ENTRY',
  SweepstakesPurchasable = 'SWEEPSTAKES_PURCHASABLE',
  SweepstakesTransactional = 'SWEEPSTAKES_TRANSACTIONAL',
  Transactional = 'TRANSACTIONAL',
  Vouchered = 'VOUCHERED'
}

export enum Offer_Fulfillment_Operator {
  IsEqualTo = 'IS_EQUAL_TO',
  IsGreaterThan = 'IS_GREATER_THAN',
  IsGreaterThanOrEqualTo = 'IS_GREATER_THAN_OR_EQUAL_TO',
  IsLessThan = 'IS_LESS_THAN',
  IsLessThanOrEqualTo = 'IS_LESS_THAN_OR_EQUAL_TO'
}

export enum Offer_Funding_Source {
  Brand = 'BRAND',
  Other = 'OTHER',
  Partner = 'PARTNER',
  Retailer = 'RETAILER'
}

export enum Offer_Presentation_Priority {
  Default = 'DEFAULT',
  Featured = 'FEATURED'
}

export enum Offer_Presentation_Type {
  Banner = 'BANNER',
  Default = 'DEFAULT',
  Hidden = 'HIDDEN'
}

export enum Offer_Purchase_Origin {
  ApiCall = 'API_CALL',
  OptionalOffer = 'OPTIONAL_OFFER'
}

export enum Offer_Sort_By {
  FulfillmentPriorityLevel = 'FULFILLMENT_PRIORITY_LEVEL'
}

export enum Offer_Visible_Status {
  /** @deprecated All audience related visibility reasons will use NOT_IN_REQUIRED_AUDIENCES going forward. */
  AgeRestricted = 'AGE_RESTRICTED',
  Discontinued = 'DISCONTINUED',
  Expired = 'EXPIRED',
  GlobalLimit = 'GLOBAL_LIMIT',
  HiddenUntilProgress = 'HIDDEN_UNTIL_PROGRESS',
  MemberLimit = 'MEMBER_LIMIT',
  /** @deprecated Do not support differences in visibility between new members and active members. */
  MemberNotActive = 'MEMBER_NOT_ACTIVE',
  MemberSuspended = 'MEMBER_SUSPENDED',
  /** @deprecated All audience related visibility reasons will use NOT_IN_REQUIRED_AUDIENCES going forward. */
  MissingRequiredSegments = 'MISSING_REQUIRED_SEGMENTS',
  NotInRequiredAudiences = 'NOT_IN_REQUIRED_AUDIENCES',
  NoVoucher = 'NO_VOUCHER',
  /** @deprecated All audience related visibility reasons will use NOT_IN_REQUIRED_AUDIENCES going forward. */
  PurchaseLimitExceeded = 'PURCHASE_LIMIT_EXCEEDED',
  /** @deprecated All audience related visibility reasons will use NOT_IN_REQUIRED_AUDIENCES going forward. */
  PurchaseLimitNotReached = 'PURCHASE_LIMIT_NOT_REACHED',
  Unpublished = 'UNPUBLISHED',
  /** @deprecated All audience related visibility reasons will use NOT_IN_REQUIRED_AUDIENCES going forward. */
  UnsatisfiedMembershipProfileAttribute = 'UNSATISFIED_MEMBERSHIP_PROFILE_ATTRIBUTE',
  Visible = 'VISIBLE'
}

export enum Open_Commerce_User_Status {
  Disabled = 'DISABLED',
  Enabled = 'ENABLED',
  WaitingForValidation = 'WAITING_FOR_VALIDATION'
}

export type Otp = {
  otp: Scalars['String']['input'];
  session: Scalars['String']['input'];
};

export type OtpPayload = {
  __typename: 'OTPPayload';
  session?: Maybe<Scalars['String']['output']>;
  sub?: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
};

export type OtpPayloadOrAuthTokens = AuthTokens | OtpPayload;

export type OtpRequest = {
  channel?: InputMaybe<Otp_Channel>;
  identifier: Scalars['String']['input'];
  mode?: InputMaybe<Otp_Mode>;
};

export enum Otp_Channel {
  Email = 'EMAIL',
  PhoneCall = 'PHONE_CALL',
  Sms = 'SMS'
}

export enum Otp_Mode {
  PasswordReset = 'PASSWORD_RESET',
  Signin = 'SIGNIN',
  Signup = 'SIGNUP',
  UpdateIdentifier = 'UPDATE_IDENTIFIER'
}

export enum Otp_Platform {
  Android = 'ANDROID',
  Iphone = 'IPHONE',
  Web = 'WEB'
}

export enum Ownership_Condition {
  DoesNotOwnAll = 'DOES_NOT_OWN_ALL',
  OwnsAll = 'OWNS_ALL',
  OwnsAny = 'OWNS_ANY',
  OwnsNone = 'OWNS_NONE'
}

export type Offer = {
  __typename: 'Offer';
  activationStatus: Offer_Activation_Status;
  ageRestricted: Scalars['Boolean']['output'];
  allowedForManualVisibilityNotifications?: Maybe<Scalars['Boolean']['output']>;
  campaign?: Maybe<Campaign>;
  category?: Maybe<Scalars['String']['output']>;
  constraints: Array<Constraint>;
  createdAt: Scalars['OCDateTime']['output'];
  customData?: Maybe<Scalars['OCJSON']['output']>;
  deleted: Scalars['Boolean']['output'];
  deletedAt?: Maybe<Scalars['OCDateTime']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  displayCategories: Array<DisplayCategory>;
  displayForOrderAhead?: Maybe<Scalars['Boolean']['output']>;
  earningMechanism?: Maybe<EarningMechanism>;
  eligible?: Maybe<Scalars['Boolean']['output']>;
  engagementType?: Maybe<Offer_Engagement_Type>;
  expireAt?: Maybe<Scalars['OCDateTime']['output']>;
  externalId?: Maybe<Scalars['ID']['output']>;
  fulfillmentCount: Scalars['Int']['output'];
  fulfillmentPriorityLevel?: Maybe<Scalars['Int']['output']>;
  fundingSource?: Maybe<Offer_Funding_Source>;
  fundingSourceName?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  ineligibilityReason?: Maybe<Ineligibility_Reason>;
  limits: Array<Limit>;
  longDescription?: Maybe<Scalars['String']['output']>;
  marketingContents: Array<MarketingContent>;
  name: Scalars['String']['output'];
  optionalAtPos?: Maybe<Scalars['Boolean']['output']>;
  presentationPriority: Offer_Presentation_Priority;
  presentationType: Offer_Presentation_Type;
  publicationStatus: Publication_Status_Type;
  publishAt?: Maybe<Scalars['OCDateTime']['output']>;
  publishedStatus: Published_Status_Type;
  scanDataConfiguration?: Maybe<ScanDataConfiguration>;
  shortDescription?: Maybe<Scalars['String']['output']>;
  stackable: Scalars['Boolean']['output'];
  trackingConfig?: Maybe<TrackingConfig>;
  triggerPreferences: TriggerPreferences;
  visibleForCommandCenterFulfillment?: Maybe<Scalars['Boolean']['output']>;
  visibleStatus?: Maybe<Offer_Visible_Status>;
  voucherCount: Scalars['Int']['output'];
  vouchers: VoucherConnection;
};


export type OfferVouchersArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  filter?: InputMaybe<VoucherFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type OfferActivateInput = {
  customerUuid?: InputMaybe<Scalars['ID']['input']>;
  membershipId?: InputMaybe<Scalars['ID']['input']>;
  offerId: Scalars['ID']['input'];
};

export type OfferActivityLogInput = {
  activateOfferId?: InputMaybe<Scalars['OCUUID']['input']>;
  activityAt: Scalars['OCDateTime']['input'];
  activityState?: InputMaybe<Scalars['String']['input']>;
  activityType: Offer_Activity_Log_Type;
  bannerConfigurationUuid?: InputMaybe<Scalars['ID']['input']>;
  channelType: Offer_Activity_Log_Channel_Type;
  externalCampaignId?: InputMaybe<Scalars['String']['input']>;
  isActivityLogIncludedInAltriaDDM?: InputMaybe<Scalars['Boolean']['input']>;
  marketingTransactionLogId?: InputMaybe<Scalars['String']['input']>;
  membershipId: Scalars['ID']['input'];
  offerId?: InputMaybe<Scalars['String']['input']>;
  trackingId?: InputMaybe<Scalars['ID']['input']>;
};

export type OfferConnection = {
  __typename: 'OfferConnection';
  edges: Array<OfferEdge>;
  pageInfo: PageInfo;
};

export type OfferCreateInput = {
  ageRestricted?: InputMaybe<Scalars['Boolean']['input']>;
  campaignUuid?: InputMaybe<Scalars['ID']['input']>;
  category?: InputMaybe<Scalars['String']['input']>;
  chainId: Scalars['ID']['input'];
  customData?: InputMaybe<Scalars['OCJSON']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  displayForOrderAhead?: InputMaybe<Scalars['Boolean']['input']>;
  engagementType: Offer_Engagement_Type;
  expireAt?: InputMaybe<Scalars['OCDateTime']['input']>;
  externalId?: InputMaybe<Scalars['ID']['input']>;
  fulfillmentPriorityLevel?: InputMaybe<Scalars['Int']['input']>;
  fundingSource?: InputMaybe<Offer_Funding_Source>;
  fundingSourceName?: InputMaybe<Scalars['String']['input']>;
  longDescription?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  optionalAtPos?: InputMaybe<Scalars['Boolean']['input']>;
  presentationPriority?: InputMaybe<Offer_Presentation_Priority>;
  presentationType?: InputMaybe<Offer_Presentation_Type>;
  publishAt?: InputMaybe<Scalars['OCDateTime']['input']>;
  scanDataConfiguration?: InputMaybe<ScanDataConfigurationInput>;
  shortDescription?: InputMaybe<Scalars['String']['input']>;
  stackable?: InputMaybe<Scalars['Boolean']['input']>;
  trackingConfig?: InputMaybe<TrackingConfigInput>;
  triggerPreferences?: InputMaybe<TriggerPreferencesInput>;
  visibleForCommandCenterFulfillment?: InputMaybe<Scalars['Boolean']['input']>;
};

export type OfferDeactivateInput = {
  customerUuid?: InputMaybe<Scalars['ID']['input']>;
  membershipId?: InputMaybe<Scalars['ID']['input']>;
  offerId: Scalars['ID']['input'];
};

export type OfferDisplayCategoriesInput = {
  displayCategoriesIds: Array<Scalars['ID']['input']>;
  offerId: Scalars['ID']['input'];
};

export type OfferDisplayCategoryInput = {
  displayCategoryId: Scalars['ID']['input'];
  offerId: Scalars['ID']['input'];
};

export type OfferEdge = {
  __typename: 'OfferEdge';
  cursor: Scalars['ID']['output'];
  node: Offer;
};

export type OfferEditorConfig = {
  __typename: 'OfferEditorConfig';
  categoryFieldVisible: Scalars['Boolean']['output'];
};

export type OfferFilter = {
  activationStatusEquals?: InputMaybe<Offer_Activation_Status>;
  campaignIdEquals?: InputMaybe<Scalars['ID']['input']>;
  categoryEquals?: InputMaybe<Scalars['String']['input']>;
  chainIdEquals?: InputMaybe<Scalars['ID']['input']>;
  deleted?: InputMaybe<Scalars['Boolean']['input']>;
  displayForInStore?: InputMaybe<Scalars['Boolean']['input']>;
  displayForOrderAhead?: InputMaybe<Scalars['Boolean']['input']>;
  earningMechanismIncludes?: InputMaybe<Array<Scalars['String']['input']>>;
  earningMechanismTypenameIncludes?: InputMaybe<Array<Earning_Mechanism_Typename>>;
  engagementTypeEquals?: InputMaybe<Offer_Engagement_Type>;
  engagementTypeIncludes?: InputMaybe<Array<InputMaybe<Offer_Engagement_Type>>>;
  externalIdEquals?: InputMaybe<Scalars['ID']['input']>;
  fundingSourceNameEquals?: InputMaybe<Scalars['String']['input']>;
  idContains?: InputMaybe<Array<Scalars['ID']['input']>>;
  idEquals?: InputMaybe<Scalars['ID']['input']>;
  isEligible?: InputMaybe<Scalars['Boolean']['input']>;
  locationsFilter?: InputMaybe<LocationsFilterInput>;
  loyaltyEventEquals?: InputMaybe<Scalars['String']['input']>;
  presentationPriorityIncludes?: InputMaybe<Array<Offer_Presentation_Priority>>;
  presentationTypeIncludes?: InputMaybe<Array<Offer_Presentation_Type>>;
  publicationStatusEquals?: InputMaybe<Publication_Status_Type>;
  publishedStatusEquals?: InputMaybe<Published_Status_Type>;
  publishedStatusIncludes?: InputMaybe<Array<Published_Status_Type>>;
  search?: InputMaybe<Scalars['String']['input']>;
  subBrandFilter?: InputMaybe<SubBrandFilterInput>;
  visibleForCommandCenterFulfillment?: InputMaybe<Scalars['Boolean']['input']>;
  visibleStatusEquals?: InputMaybe<Offer_Visible_Status>;
};

export type OfferPurchase = {
  __typename: 'OfferPurchase';
  createdAt: Scalars['OCDateTime']['output'];
  discontinued: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  origin?: Maybe<Offer_Purchase_Origin>;
  pointCost: Scalars['Int']['output'];
  purchasedWith: Offer;
  reservedUntil?: Maybe<Scalars['OCDateTime']['output']>;
  returnable: Scalars['Boolean']['output'];
  voucherGrantFor: Offer;
};

export type OfferPurchaseConnection = {
  __typename: 'OfferPurchaseConnection';
  edges: Array<OfferPurchaseEdge>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type OfferPurchaseCreateInput = {
  count?: InputMaybe<Scalars['Int']['input']>;
  offerId: Scalars['ID']['input'];
};

export type OfferPurchaseEdge = {
  __typename: 'OfferPurchaseEdge';
  cursor: Scalars['ID']['output'];
  node: OfferPurchase;
};

export type OfferPurchaseReturnInput = {
  offerId: Scalars['ID']['input'];
};

export type OfferSort = {
  direction: Sort_Order;
  field: Offer_Sort_By;
};

export type OfferTriggeredMessageContent = {
  __typename: 'OfferTriggeredMessageContent';
  fulfillmentSms?: Maybe<Scalars['String']['output']>;
  progressSms?: Maybe<Scalars['String']['output']>;
  visibilitySms?: Maybe<Scalars['String']['output']>;
};

export type OfferTriggeredMessageContentInput = {
  fulfillmentSms?: InputMaybe<Scalars['String']['input']>;
  progressSms?: InputMaybe<Scalars['String']['input']>;
  visibilitySms?: InputMaybe<Scalars['String']['input']>;
};

export type OfferUpdateInput = {
  ageRestricted?: InputMaybe<Scalars['Boolean']['input']>;
  campaignUuid?: InputMaybe<Scalars['ID']['input']>;
  category?: InputMaybe<Scalars['String']['input']>;
  customData?: InputMaybe<CustomDataInput>;
  description?: InputMaybe<Scalars['String']['input']>;
  displayForOrderAhead?: InputMaybe<Scalars['Boolean']['input']>;
  engagementType?: InputMaybe<Offer_Engagement_Type>;
  expireAt?: InputMaybe<Scalars['OCDateTime']['input']>;
  externalId?: InputMaybe<Scalars['ID']['input']>;
  fulfillmentPriorityLevel?: InputMaybe<Scalars['Int']['input']>;
  fundingSource?: InputMaybe<Offer_Funding_Source>;
  fundingSourceName?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  longDescription?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  optionalAtPos?: InputMaybe<Scalars['Boolean']['input']>;
  presentationPriority?: InputMaybe<Offer_Presentation_Priority>;
  presentationType?: InputMaybe<Offer_Presentation_Type>;
  publishAt?: InputMaybe<Scalars['OCDateTime']['input']>;
  scanDataConfiguration?: InputMaybe<ScanDataConfigurationInput>;
  shortDescription?: InputMaybe<Scalars['String']['input']>;
  stackable?: InputMaybe<Scalars['Boolean']['input']>;
  trackingConfig?: InputMaybe<TrackingConfigInput>;
  triggerPreferences?: InputMaybe<TriggerPreferencesInput>;
  visibleForCommandCenterFulfillment?: InputMaybe<Scalars['Boolean']['input']>;
};

export type OffsetPageInfo = {
  __typename: 'OffsetPageInfo';
  hasNextPage: Scalars['Boolean']['output'];
  hasPreviousPage: Scalars['Boolean']['output'];
  limit: Scalars['Int']['output'];
  offset: Scalars['Int']['output'];
  totalCount: Scalars['Int']['output'];
};

export type OloOrderAheadCreateSessionPayload = {
  __typename: 'OloOrderAheadCreateSessionPayload';
  iframeUrl: Scalars['OCURL']['output'];
};

export type OpenCommerceFeature = {
  __typename: 'OpenCommerceFeature';
  description?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  uuid: Scalars['ID']['output'];
  value?: Maybe<Scalars['String']['output']>;
};

export type OpenCommerceFeatureFilter = {
  descriptionContains?: InputMaybe<Scalars['String']['input']>;
  descriptionEquals?: InputMaybe<Scalars['String']['input']>;
  nameContains?: InputMaybe<Scalars['String']['input']>;
  nameEquals?: InputMaybe<Scalars['String']['input']>;
  valueContains?: InputMaybe<Scalars['String']['input']>;
  valueEquals?: InputMaybe<Scalars['String']['input']>;
};

export type OpenCommerceUser = {
  __typename: 'OpenCommerceUser';
  brands: Array<Brand>;
  customData?: Maybe<Scalars['OCJSON']['output']>;
  email: Scalars['OCEmailAddress']['output'];
  lastLogin?: Maybe<Scalars['OCDateTime']['output']>;
  name: PersonName;
  phoneNumber?: Maybe<Scalars['OCPhoneNumber']['output']>;
  status: Open_Commerce_User_Status;
  userRole: User_Role;
  username?: Maybe<Scalars['String']['output']>;
  uuid: Scalars['OCUUID']['output'];
};

export type OpenCommerceUserConnection = {
  __typename: 'OpenCommerceUserConnection';
  edges?: Maybe<Array<OpenCommerceUserEdge>>;
  pageInfo: PageInfo;
};

export type OpenCommerceUserCreateInput = {
  brandUuid?: InputMaybe<Array<Scalars['OCUUID']['input']>>;
  email: Scalars['OCEmailAddress']['input'];
  name: PersonNameCreate;
  phoneNumber?: InputMaybe<Scalars['OCPhoneNumber']['input']>;
  status?: InputMaybe<Open_Commerce_User_Status>;
  userRole: User_Role;
  username?: InputMaybe<Scalars['String']['input']>;
};

export type OpenCommerceUserEdge = {
  __typename: 'OpenCommerceUserEdge';
  cursor: Scalars['OCBase64Cursor']['output'];
  node: OpenCommerceUser;
};

export type OpenCommerceUserFilter = {
  emailEquals?: InputMaybe<Scalars['OCEmailAddress']['input']>;
  lastLoginAfter?: InputMaybe<Scalars['OCDateTime']['input']>;
  lastLoginBefore?: InputMaybe<Scalars['OCDateTime']['input']>;
  nameLike?: InputMaybe<Scalars['String']['input']>;
  phoneNumberEquals?: InputMaybe<Scalars['OCPhoneNumber']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  statusEquals?: InputMaybe<Open_Commerce_User_Status>;
  userRoleEquals?: InputMaybe<User_Role>;
  usernameEquals?: InputMaybe<Scalars['String']['input']>;
  uuidEquals?: InputMaybe<Scalars['OCUUID']['input']>;
};

export type OpenCommerceUserRoleMap = {
  __typename: 'OpenCommerceUserRoleMap';
  retailerNetwork: Array<Maybe<RetailerNetworkUserRoleMapEntry>>;
  user: User_Role;
};

export type OpenCommerceUserUpdateInput = {
  customData?: InputMaybe<CustomDataInput>;
  email?: InputMaybe<Scalars['OCEmailAddress']['input']>;
  name?: InputMaybe<PersonNameCreate>;
  phoneNumber?: InputMaybe<Scalars['OCPhoneNumber']['input']>;
  status?: InputMaybe<Open_Commerce_User_Status>;
  userRole?: InputMaybe<User_Role>;
  uuid: Scalars['OCUUID']['input'];
};

export type OptionSelectionCount = {
  __typename: 'OptionSelectionCount';
  count: Scalars['Int']['output'];
  optionLabel: Scalars['String']['output'];
  optionUuid: Scalars['OCUUID']['output'];
};

export type OrderAheadConfig = FeatureConfiguration & {
  __typename: 'OrderAheadConfig';
  enabled: Scalars['Boolean']['output'];
  provider: OrderAheadProvider;
  shouldShowDisplayForOrderAheadToggle: Scalars['Boolean']['output'];
};

export type OrderAheadCreateSessionInput = {
  customerUuid: Scalars['OCUUID']['input'];
  provider: OrderAheadProvider;
};

export type OrderAheadCreateSessionPayload = LulaOrderAheadCreateSessionPayload | OloOrderAheadCreateSessionPayload;

export type OrderAheadInfoInput = {
  deliveryType: Activate_Transaction_Delivery_Type;
};

export enum OrderAheadProvider {
  Lula = 'lula',
  Olo = 'olo'
}

export type OtpInput = {
  answer: Scalars['String']['input'];
  session: Scalars['String']['input'];
};

export enum Par_Pay_Apple_Pay_Card_Network {
  Amex = 'AMEX',
  CartesBancaires = 'CARTES_BANCAIRES',
  ChinaUnionPay = 'CHINA_UNION_PAY',
  Discover = 'DISCOVER',
  Eftpos = 'EFTPOS',
  Electron = 'ELECTRON',
  Elo = 'ELO',
  Interac = 'INTERAC',
  Jcb = 'JCB',
  Mada = 'MADA',
  Maestro = 'MAESTRO',
  Mastercard = 'MASTERCARD',
  MasterCard = 'MASTER_CARD',
  PrivateLabel = 'PRIVATE_LABEL',
  Visa = 'VISA',
  VPay = 'V_PAY'
}

export enum Par_Pay_Google_Pay_Card_Network {
  Amex = 'AMEX',
  Discover = 'DISCOVER',
  Electron = 'ELECTRON',
  Elo = 'ELO',
  EloDebit = 'ELO_DEBIT',
  Interac = 'INTERAC',
  Jcb = 'JCB',
  Maestro = 'MAESTRO',
  Mastercard = 'MASTERCARD',
  Visa = 'VISA'
}

export enum Par_Pay_Payment_Account_Type {
  ApplePay = 'APPLE_PAY',
  Credit = 'CREDIT',
  GooglePay = 'GOOGLE_PAY',
  Prepaid = 'PREPAID',
  Unknown = 'UNKNOWN'
}

export enum Par_Pay_Payment_Instrument_Status {
  Active = 'ACTIVE',
  Inactive = 'INACTIVE',
  Pending = 'PENDING'
}

export enum Par_Pay_Payment_Instrument_Type {
  AmazonPay = 'AMAZON_PAY',
  AmericanExpress = 'AMERICAN_EXPRESS',
  ApplePay = 'APPLE_PAY',
  ApplePayAmericanExpress = 'APPLE_PAY_AMERICAN_EXPRESS',
  ApplePayDiscover = 'APPLE_PAY_DISCOVER',
  ApplePayMastercard = 'APPLE_PAY_MASTERCARD',
  ApplePayVisa = 'APPLE_PAY_VISA',
  CartesBancaires = 'CARTES_BANCAIRES',
  CarteBlanche = 'CARTE_BLANCHE',
  ChasePay = 'CHASE_PAY',
  ChinaUnionPay = 'CHINA_UNION_PAY',
  CitiPay = 'CITI_PAY',
  Credit = 'CREDIT',
  Debit = 'DEBIT',
  DinersClub = 'DINERS_CLUB',
  Discover = 'DISCOVER',
  Eftpos = 'EFTPOS',
  Elo = 'ELO',
  Gift = 'GIFT',
  GooglePay = 'GOOGLE_PAY',
  GooglePayAmericanExpress = 'GOOGLE_PAY_AMERICAN_EXPRESS',
  GooglePayDiscover = 'GOOGLE_PAY_DISCOVER',
  GooglePayMastercard = 'GOOGLE_PAY_MASTERCARD',
  GooglePayVisa = 'GOOGLE_PAY_VISA',
  GoogleWallet = 'GOOGLE_WALLET',
  IdCredit = 'ID_CREDIT',
  Interac = 'INTERAC',
  Jcb = 'JCB',
  Laser = 'LASER',
  Maestro = 'MAESTRO',
  Mastercard = 'MASTERCARD',
  Masterpass = 'MASTERPASS',
  Paypal = 'PAYPAL',
  Prepaid = 'PREPAID',
  PrivateLabel = 'PRIVATE_LABEL',
  QuicPay = 'QUIC_PAY',
  Solo = 'SOLO',
  Suica = 'SUICA',
  Switch = 'SWITCH',
  Unknown = 'UNKNOWN',
  Venmo = 'VENMO',
  Visa = 'VISA',
  VisaCheckout = 'VISA_CHECKOUT',
  VisaVpay = 'VISA_VPAY'
}

export enum Par_Pay_Transaction_Type {
  BalanceInquiry = 'BALANCE_INQUIRY',
  CiOttBasedSaleCopy = 'CI_OTT_BASED_SALE_COPY',
  GiftCardActivate = 'GIFT_CARD_ACTIVATE',
  GiftCardIssue = 'GIFT_CARD_ISSUE',
  GiftCardRedeem = 'GIFT_CARD_REDEEM',
  GiftCardReload = 'GIFT_CARD_RELOAD',
  Preauthorization = 'PREAUTHORIZATION',
  PtrRequest = 'PTR_REQUEST',
  Refund = 'REFUND',
  Sale = 'SALE',
  Settlement = 'SETTLEMENT',
  Void = 'VOID'
}

export enum Payment_Account_Type {
  ApplePay = 'APPLE_PAY',
  Credit = 'CREDIT',
  GooglePay = 'GOOGLE_PAY',
  Prepaid = 'PREPAID',
  Unknown = 'UNKNOWN'
}

export enum Payment_Instrument_Evaluation_Method {
  Exclude = 'EXCLUDE',
  Include = 'INCLUDE'
}

export enum Payment_Instrument_Status {
  Active = 'ACTIVE',
  Inactive = 'INACTIVE',
  Pending = 'PENDING'
}

export enum Payment_Instrument_Type {
  AmazonPay = 'AMAZON_PAY',
  AmericanExpress = 'AMERICAN_EXPRESS',
  ApplePay = 'APPLE_PAY',
  ApplePayAmericanExpress = 'APPLE_PAY_AMERICAN_EXPRESS',
  ApplePayDiscover = 'APPLE_PAY_DISCOVER',
  ApplePayMastercard = 'APPLE_PAY_MASTERCARD',
  ApplePayVisa = 'APPLE_PAY_VISA',
  CartesBancaires = 'CARTES_BANCAIRES',
  CarteBlanche = 'CARTE_BLANCHE',
  ChasePay = 'CHASE_PAY',
  ChinaUnionPay = 'CHINA_UNION_PAY',
  CitiPay = 'CITI_PAY',
  Credit = 'CREDIT',
  Debit = 'DEBIT',
  DinersClub = 'DINERS_CLUB',
  Discover = 'DISCOVER',
  Eftpos = 'EFTPOS',
  Elo = 'ELO',
  Gift = 'GIFT',
  GooglePay = 'GOOGLE_PAY',
  GooglePayAmericanExpress = 'GOOGLE_PAY_AMERICAN_EXPRESS',
  GooglePayDiscover = 'GOOGLE_PAY_DISCOVER',
  GooglePayMastercard = 'GOOGLE_PAY_MASTERCARD',
  GooglePayVisa = 'GOOGLE_PAY_VISA',
  GoogleWallet = 'GOOGLE_WALLET',
  IdCredit = 'ID_CREDIT',
  Interac = 'INTERAC',
  Jcb = 'JCB',
  Laser = 'LASER',
  Maestro = 'MAESTRO',
  Mastercard = 'MASTERCARD',
  Masterpass = 'MASTERPASS',
  Paypal = 'PAYPAL',
  Prepaid = 'PREPAID',
  PrivateLabel = 'PRIVATE_LABEL',
  QuicPay = 'QUIC_PAY',
  Solo = 'SOLO',
  Suica = 'SUICA',
  Switch = 'SWITCH',
  Unknown = 'UNKNOWN',
  Venmo = 'VENMO',
  Visa = 'VISA',
  VisaCheckout = 'VISA_CHECKOUT',
  VisaVpay = 'VISA_VPAY'
}

export enum Payment_Level {
  AboveSite = 'ABOVE_SITE',
  SiteLevel = 'SITE_LEVEL'
}

export enum Payment_Method {
  Activation = 'Activation',
  Cash = 'Cash',
  CashChange = 'CashChange',
  Cheque = 'Cheque',
  Credit = 'Credit',
  Debit = 'Debit',
  Ebt = 'EBT',
  EbtFs = 'EBT_FS',
  Loyalty = 'Loyalty',
  Na = 'NA',
  Other = 'Other',
  PrePaid = 'PrePaid',
  Recharge = 'Recharge'
}

export enum Payment_Method_Evaluation_Method {
  Exclude = 'EXCLUDE',
  Include = 'INCLUDE'
}

export enum Phone_Type {
  Home = 'HOME',
  Location = 'LOCATION',
  Mobile = 'MOBILE',
  Work = 'WORK'
}

export enum Point_Balance_Target {
  Current = 'CURRENT',
  Total = 'TOTAL'
}

export enum Point_Change_Sort_By {
  CreatedAt = 'CREATED_AT'
}

export enum Point_Change_Source_Type {
  CommandCenterUser = 'COMMAND_CENTER_USER',
  Expiration = 'EXPIRATION',
  GameSession = 'GAME_SESSION',
  LoyaltyEvent = 'LOYALTY_EVENT',
  MembershipPointDonation = 'MEMBERSHIP_POINT_DONATION',
  OfferPurchase = 'OFFER_PURCHASE',
  PointChange = 'POINT_CHANGE',
  PromocodeUseRequest = 'PROMOCODE_USE_REQUEST',
  StoredValueTransaction = 'STORED_VALUE_TRANSACTION',
  Transaction = 'TRANSACTION',
  User = 'USER'
}

export enum Point_Change_Type {
  ApiPointAdjustment = 'API_POINT_ADJUSTMENT',
  BreakageReturn = 'BREAKAGE_RETURN',
  CancelRedemption = 'CANCEL_REDEMPTION',
  CancelTransaction = 'CANCEL_TRANSACTION',
  MembershipPointDonation = 'MEMBERSHIP_POINT_DONATION',
  Migration = 'MIGRATION',
  OfferPurchase = 'OFFER_PURCHASE',
  OfferPurchaseReturn = 'OFFER_PURCHASE_RETURN',
  OptVoucherPurchase = 'OPT_VOUCHER_PURCHASE',
  PointAward = 'POINT_AWARD',
  PointExpiration = 'POINT_EXPIRATION',
  ReferralPointAward = 'REFERRAL_POINT_AWARD',
  ScrubData = 'SCRUB_DATA',
  StoredValuePurchase = 'STORED_VALUE_PURCHASE',
  SweepstakeEntryPurchase = 'SWEEPSTAKE_ENTRY_PURCHASE',
  VoucherExpiration = 'VOUCHER_EXPIRATION'
}

export enum Point_Expiration_Strategy {
  ActivityBased = 'ACTIVITY_BASED',
  FirstInFirstOut = 'FIRST_IN_FIRST_OUT',
  None = 'NONE'
}

export enum Primary_Transaction_Status {
  Active = 'ACTIVE',
  Completed = 'COMPLETED',
  Failed = 'FAILED',
  Refunding = 'REFUNDING',
  Voiding = 'VOIDING'
}

export enum Product_Group_Key {
  FuelGradeId = 'FUEL_GRADE_ID',
  Group = 'GROUP',
  Sku = 'SKU',
  Upc = 'UPC'
}

export enum Publication_Status_Type {
  All = 'ALL',
  Expired = 'EXPIRED',
  Published = 'PUBLISHED',
  Unpublished = 'UNPUBLISHED'
}

export enum Published_Status_Type {
  Archived = 'ARCHIVED',
  Expired = 'EXPIRED',
  Published = 'PUBLISHED',
  Unpublished = 'UNPUBLISHED'
}

export type PageInfo = {
  __typename: 'PageInfo';
  endCursor?: Maybe<Scalars['ID']['output']>;
  hasNextPage: Scalars['Boolean']['output'];
  hasPreviousPage: Scalars['Boolean']['output'];
  startCursor?: Maybe<Scalars['ID']['output']>;
};

export type ParPayAppConfigurationCreateInput = {
  applePay?: InputMaybe<ApplePayConfigurationCreateInput>;
  corpId: Scalars['String']['input'];
  googlePay?: InputMaybe<GooglePayConfigurationCreateInput>;
  payAtPumpEnabled: Scalars['Boolean']['input'];
  payInsideEnabled: Scalars['Boolean']['input'];
  paymentWallet: WalletConfigurationCreateInput;
};

export type ParPayAppConfigurationUpdateInput = {
  applePay?: InputMaybe<ApplePayConfigurationUpdateInput>;
  corpId: Scalars['String']['input'];
  googlePay?: InputMaybe<GooglePayConfigurationUpdateInput>;
  payAtPumpEnabled: Scalars['Boolean']['input'];
  payInsideEnabled: Scalars['Boolean']['input'];
  paymentWallet: WalletConfigurationUpdateInput;
};

export type ParPayApplePayConfiguration = {
  __typename: 'ParPayApplePayConfiguration';
  allowCreditCards: Scalars['Boolean']['output'];
  allowPrepaidCards: Scalars['Boolean']['output'];
  merchantId: Scalars['ID']['output'];
  merchantName?: Maybe<Scalars['String']['output']>;
  supportedNetworks: Array<Par_Pay_Apple_Pay_Card_Network>;
};

export type ParPayApplePaySession = {
  __typename: 'ParPayApplePaySession';
  data?: Maybe<Scalars['OCJSON']['output']>;
};

export type ParPayApplePaySessionCreateInput = {
  displayName: Scalars['String']['input'];
  initiative: Scalars['String']['input'];
  initiativeContext: Scalars['String']['input'];
  merchantIdentifier: Scalars['String']['input'];
};

export type ParPayBillingAddress = {
  __typename: 'ParPayBillingAddress';
  alias?: Maybe<Scalars['String']['output']>;
  city?: Maybe<Scalars['String']['output']>;
  countryCode?: Maybe<Scalars['OCCountryCode2']['output']>;
  geoLocation?: Maybe<GeoLocation>;
  state?: Maybe<Scalars['String']['output']>;
  street1?: Maybe<Scalars['String']['output']>;
  street2?: Maybe<Scalars['String']['output']>;
  uuid: Scalars['ID']['output'];
  zipCode: Scalars['String']['output'];
};

export type ParPayCorporateAccount = {
  __typename: 'ParPayCorporateAccount';
  corpId: Scalars['String']['output'];
  createdAt?: Maybe<Scalars['OCDateTime']['output']>;
  description: Scalars['String']['output'];
  enabled: Scalars['Boolean']['output'];
  updatedAt?: Maybe<Scalars['OCDateTime']['output']>;
  uuid: Scalars['ID']['output'];
};

export type ParPayCorporateAccountCreateInput = {
  corpId: Scalars['String']['input'];
  description: Scalars['String']['input'];
  enabled?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ParPayCorporateAccountUpdateInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  enabled?: InputMaybe<Scalars['Boolean']['input']>;
  uuid: Scalars['ID']['input'];
};

export type ParPayCorporateAccountsGetFilter = {
  corpIdEquals?: InputMaybe<Scalars['String']['input']>;
  uuidEquals?: InputMaybe<Scalars['ID']['input']>;
};

export type ParPayEcommInfoResponse = {
  __typename: 'ParPayEcommInfoResponse';
  avsResult?: Maybe<Scalars['String']['output']>;
  cvvResult?: Maybe<Scalars['String']['output']>;
  merchantIdentifier?: Maybe<Scalars['String']['output']>;
  oneOrderToken?: Maybe<Scalars['String']['output']>;
  oneTimeToken?: Maybe<Scalars['String']['output']>;
  storeId?: Maybe<Scalars['String']['output']>;
  terminalId?: Maybe<Scalars['String']['output']>;
};

export type ParPayFeatureConfiguration = {
  enabled: Scalars['Boolean']['output'];
};

export type ParPayFraudScoreInfo = {
  __typename: 'ParPayFraudScoreInfo';
  decision?: Maybe<Scalars['String']['output']>;
  ecomToken?: Maybe<Scalars['String']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  firstAndLastName?: Maybe<Scalars['String']['output']>;
  origDecision?: Maybe<Scalars['String']['output']>;
  phoneNumber?: Maybe<Scalars['String']['output']>;
  postalCode?: Maybe<Scalars['String']['output']>;
  processorDecision?: Maybe<Scalars['String']['output']>;
  reasonCode?: Maybe<Scalars['String']['output']>;
  remarks?: Maybe<Scalars['String']['output']>;
  reqTypeIndicator?: Maybe<Scalars['String']['output']>;
  requestId?: Maybe<Scalars['String']['output']>;
  requestToken?: Maybe<Scalars['String']['output']>;
  rulesTripped?: Maybe<Scalars['String']['output']>;
  score?: Maybe<Scalars['String']['output']>;
  serviceIdentifier?: Maybe<Scalars['String']['output']>;
  streetAddr?: Maybe<Scalars['String']['output']>;
};

export type ParPayGooglePayConfiguration = {
  __typename: 'ParPayGooglePayConfiguration';
  allowCreditCards: Scalars['Boolean']['output'];
  allowPrepaidCards: Scalars['Boolean']['output'];
  allowedCardNetworks: Array<Par_Pay_Google_Pay_Card_Network>;
  environment: Google_Pay_Environment;
  gateway: Scalars['String']['output'];
  gatewayMerchantId: Scalars['ID']['output'];
  merchantId: Scalars['ID']['output'];
  merchantName?: Maybe<Scalars['String']['output']>;
};

export type ParPayInitiateTokenizationSessionInput = {
  corpId: Scalars['String']['input'];
  customerUuid: Scalars['ID']['input'];
};

export type ParPayInside = ParPayFeatureConfiguration & {
  __typename: 'ParPayInside';
  enabled: Scalars['Boolean']['output'];
};

export type ParPayMerchantAccount = {
  __typename: 'ParPayMerchantAccount';
  corpId: Scalars['String']['output'];
  createdAt?: Maybe<Scalars['OCDateTime']['output']>;
  defaultForTokenization: Scalars['Boolean']['output'];
  enabled: Scalars['Boolean']['output'];
  locationUuid: Scalars['String']['output'];
  merchantId: Scalars['String']['output'];
  storeId: Scalars['String']['output'];
  terminalId: Scalars['String']['output'];
  updatedAt?: Maybe<Scalars['OCDateTime']['output']>;
  uuid: Scalars['ID']['output'];
};

export type ParPayMerchantAccountCreateInput = {
  corpId: Scalars['String']['input'];
  defaultForTokenization?: InputMaybe<Scalars['Boolean']['input']>;
  enabled?: InputMaybe<Scalars['Boolean']['input']>;
  locationUuid: Scalars['ID']['input'];
  merchantId: Scalars['String']['input'];
  storeId: Scalars['String']['input'];
  terminalId: Scalars['String']['input'];
};

export type ParPayMerchantAccountUpdateInput = {
  corpId?: InputMaybe<Scalars['String']['input']>;
  defaultForTokenization?: InputMaybe<Scalars['Boolean']['input']>;
  enabled?: InputMaybe<Scalars['Boolean']['input']>;
  locationUuid?: InputMaybe<Scalars['ID']['input']>;
  storeId?: InputMaybe<Scalars['String']['input']>;
  terminalId?: InputMaybe<Scalars['String']['input']>;
  uuid: Scalars['ID']['input'];
};

export type ParPayMerchantAccountsGetFilter = {
  corpIdEquals?: InputMaybe<Scalars['String']['input']>;
  defaultForTokenizationEquals?: InputMaybe<Scalars['Boolean']['input']>;
  locationUuidEquals?: InputMaybe<Scalars['ID']['input']>;
  merchantIdEquals?: InputMaybe<Scalars['String']['input']>;
  uuidEquals?: InputMaybe<Scalars['ID']['input']>;
};

export type ParPayPayAtPump = ParPayFeatureConfiguration & {
  __typename: 'ParPayPayAtPump';
  enabled: Scalars['Boolean']['output'];
};

export type ParPayPaymentAppConfig = {
  __typename: 'ParPayPaymentAppConfig';
  applePay?: Maybe<ParPayApplePayConfiguration>;
  googlePay?: Maybe<ParPayGooglePayConfiguration>;
  payAtPump: ParPayPayAtPump;
  payInside: ParPayInside;
  paymentWallet: ParPayPaymentWalletConfiguration;
};

export type ParPayPaymentInstrument = {
  __typename: 'ParPayPaymentInstrument';
  accountNumber?: Maybe<Scalars['String']['output']>;
  accountType: Par_Pay_Payment_Account_Type;
  additionalDetails?: Maybe<Scalars['OCJSON']['output']>;
  address?: Maybe<ParPayBillingAddress>;
  alias?: Maybe<Scalars['String']['output']>;
  balance?: Maybe<Scalars['Float']['output']>;
  binRange?: Maybe<Scalars['String']['output']>;
  corpId?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['OCDateTime']['output']>;
  createdByDevice?: Maybe<CustomerDevice>;
  customerUuid: Scalars['ID']['output'];
  displayNumber?: Maybe<Scalars['String']['output']>;
  expiration?: Maybe<ParPayPaymentInstrumentExpiration>;
  isDefault?: Maybe<Scalars['Boolean']['output']>;
  last4?: Maybe<Scalars['String']['output']>;
  maskedCardNumber?: Maybe<Scalars['String']['output']>;
  paymentType?: Maybe<Par_Pay_Payment_Instrument_Type>;
  providerNickName?: Maybe<Scalars['String']['output']>;
  status: Par_Pay_Payment_Instrument_Status;
  updatedAt?: Maybe<Scalars['OCDateTime']['output']>;
  uuid: Scalars['ID']['output'];
};

export type ParPayPaymentInstrumentCreateInput = {
  accountType: Par_Pay_Payment_Account_Type;
  customerUuid: Scalars['ID']['input'];
  expiration?: InputMaybe<Scalars['String']['input']>;
  maskedCardNumber?: InputMaybe<Scalars['String']['input']>;
  oneTimeToken: Scalars['String']['input'];
  paymentType?: InputMaybe<Par_Pay_Payment_Instrument_Type>;
  setAsDefault?: InputMaybe<Scalars['Boolean']['input']>;
  tokenizationSessionId: Scalars['String']['input'];
  zipCode?: InputMaybe<Scalars['String']['input']>;
};

export type ParPayPaymentInstrumentExpiration = {
  __typename: 'ParPayPaymentInstrumentExpiration';
  expirationMonth?: Maybe<Scalars['String']['output']>;
  expirationYear?: Maybe<Scalars['String']['output']>;
};

export type ParPayPaymentInstrumentExpirationInput = {
  expirationMonth?: InputMaybe<Scalars['String']['input']>;
  expirationYear?: InputMaybe<Scalars['String']['input']>;
};

export type ParPayPaymentInstrumentSetDefaultInput = {
  customerUuid: Scalars['ID']['input'];
  paymentInstrumentUuid: Scalars['ID']['input'];
};

export type ParPayPaymentInstrumentUpdateInput = {
  alias?: InputMaybe<Scalars['String']['input']>;
  uuid: Scalars['ID']['input'];
};

export type ParPayPaymentPreAuthorizeInput = {
  amountAsCents: Scalars['Int']['input'];
  customerUuid: Scalars['ID']['input'];
  fuelingPosition?: InputMaybe<Scalars['String']['input']>;
  locationUuid: Scalars['ID']['input'];
  oneTimePaymentToken?: InputMaybe<ParPayPaymentTokenInput>;
  paymentInstrumentUuid?: InputMaybe<Scalars['ID']['input']>;
  transactionType?: InputMaybe<Transaction_Type>;
};

export type ParPayPaymentRefundInput = {
  amountAsCents: Scalars['Int']['input'];
  parPayTransactionId: Scalars['String']['input'];
  reasonDescription?: InputMaybe<Scalars['String']['input']>;
};

export type ParPayPaymentSettleInput = {
  amountAsCents: Scalars['Int']['input'];
  parPayTransactionId: Scalars['String']['input'];
};

export type ParPayPaymentTokenInput = {
  applePay?: InputMaybe<Scalars['String']['input']>;
  googlePay?: InputMaybe<Scalars['String']['input']>;
};

export type ParPayPaymentVoidInput = {
  parPayTransactionId: Scalars['String']['input'];
  reasonDescription?: InputMaybe<Scalars['String']['input']>;
};

export type ParPayPaymentWalletConfiguration = {
  __typename: 'ParPayPaymentWalletConfiguration';
  allowedAccountTypes: Array<Par_Pay_Payment_Account_Type>;
  maxInstruments: Scalars['Int']['output'];
};

export type ParPayResponse = {
  __typename: 'ParPayResponse';
  approvalCode?: Maybe<Scalars['String']['output']>;
  batchNumber?: Maybe<Scalars['String']['output']>;
  ecommInfoResponse?: Maybe<ParPayEcommInfoResponse>;
  fraudScoreInfo?: Maybe<ParPayFraudScoreInfo>;
  maskedCardNumber?: Maybe<Scalars['String']['output']>;
  paymentInstrumentUuid?: Maybe<Scalars['ID']['output']>;
  processorId?: Maybe<Scalars['String']['output']>;
  processorResponseText?: Maybe<Scalars['String']['output']>;
  rawResponse?: Maybe<Scalars['OCJSON']['output']>;
  receiptToken?: Maybe<Scalars['String']['output']>;
  referenceNumber?: Maybe<Scalars['String']['output']>;
  referralNum?: Maybe<Scalars['String']['output']>;
  responseCode?: Maybe<Scalars['String']['output']>;
  responseText?: Maybe<Scalars['String']['output']>;
  success?: Maybe<Scalars['Boolean']['output']>;
  ticketNumber?: Maybe<Scalars['String']['output']>;
  transactionId?: Maybe<Scalars['String']['output']>;
  transactionSequenceNumber?: Maybe<Scalars['String']['output']>;
  transactionToken?: Maybe<Scalars['String']['output']>;
  transactionType?: Maybe<Par_Pay_Transaction_Type>;
  transactionTypeCode?: Maybe<Scalars['String']['output']>;
};

export type ParPayTokenizationSession = {
  __typename: 'ParPayTokenizationSession';
  iframeUrl: Scalars['String']['output'];
  rawResponse: Scalars['OCJSON']['output'];
  responseCode: Scalars['String']['output'];
  responseText: Scalars['String']['output'];
  sessionId: Scalars['String']['output'];
};

export type PaymentApplePaySessionCreateInput = {
  displayName: Scalars['String']['input'];
  initiative: Scalars['String']['input'];
  initiativeContext: Scalars['String']['input'];
  merchantIdentifier: Scalars['String']['input'];
  subBrand?: InputMaybe<Scalars['String']['input']>;
};

export type PaymentAuthorizeInput = {
  amount: Scalars['Float']['input'];
  customerUuid: Scalars['ID']['input'];
  externalRequestData?: InputMaybe<Scalars['OCJSON']['input']>;
  lineItems?: InputMaybe<Array<TransactionLineItemInput>>;
  locationUuid: Scalars['ID']['input'];
  merchantId?: InputMaybe<Scalars['String']['input']>;
  oneTimePaymentToken?: InputMaybe<PaymentTokenInput>;
  paymentInstrumentId?: InputMaybe<Scalars['ID']['input']>;
  paymentProviderPayload?: InputMaybe<PaymentProviderPayloadInput>;
  transactionType?: InputMaybe<Transaction_Type>;
  transactionUuid?: InputMaybe<Scalars['ID']['input']>;
};

export type PaymentAuthorizeWithNonceInput = {
  amount: Scalars['Float']['input'];
  cardType: Payment_Instrument_Type;
  customerUuid: Scalars['ID']['input'];
  externalRequestData?: InputMaybe<Scalars['OCJSON']['input']>;
  lineItems?: InputMaybe<Array<TransactionLineItemInput>>;
  locationUuid: Scalars['ID']['input'];
  paymentMethodNonce: Scalars['String']['input'];
  transactionType?: InputMaybe<Transaction_Type>;
  transactionUuid?: InputMaybe<Scalars['ID']['input']>;
  zipCode?: InputMaybe<Scalars['String']['input']>;
};

export type PaymentInstrument = {
  __typename: 'PaymentInstrument';
  accountNumber?: Maybe<Scalars['String']['output']>;
  accountType: Payment_Account_Type;
  address?: Maybe<BillingAddress>;
  alias?: Maybe<Scalars['String']['output']>;
  balance?: Maybe<Scalars['Float']['output']>;
  binRange?: Maybe<Scalars['String']['output']>;
  createdByDevice?: Maybe<CustomerDevice>;
  displayNumber?: Maybe<Scalars['String']['output']>;
  expiration?: Maybe<PaymentInstrumentExpiration>;
  isDefault?: Maybe<Scalars['Boolean']['output']>;
  last4?: Maybe<Scalars['String']['output']>;
  paymentProviderAccount?: Maybe<PaymentProviderAccount>;
  paymentType?: Maybe<Payment_Instrument_Type>;
  providerNickName?: Maybe<Scalars['String']['output']>;
  status: Payment_Instrument_Status;
  uuid: Scalars['ID']['output'];
};

export type PaymentInstrumentCreateInput = {
  accountType: Payment_Account_Type;
  binRange?: InputMaybe<Scalars['String']['input']>;
  customerUuid: Scalars['ID']['input'];
  expiration?: InputMaybe<PaymentInstrumentExpirationInput>;
  externalRequestData?: InputMaybe<Scalars['OCJSON']['input']>;
  fiservOAuthToken?: InputMaybe<Scalars['String']['input']>;
  last4?: InputMaybe<Scalars['String']['input']>;
  merchantId?: InputMaybe<Scalars['String']['input']>;
  paymentInstrumentType: Payment_Instrument_Type;
  paymentToken: Scalars['String']['input'];
  setAsDefault?: InputMaybe<Scalars['Boolean']['input']>;
  transactionUuid?: InputMaybe<Scalars['ID']['input']>;
  zipCode?: InputMaybe<Scalars['String']['input']>;
};

export type PaymentInstrumentDeleteInput = {
  customerUuid: Scalars['ID']['input'];
  externalRequestData?: InputMaybe<Scalars['OCJSON']['input']>;
  paymentInstrumentUuid: Scalars['ID']['input'];
  transactionUuid?: InputMaybe<Scalars['ID']['input']>;
};

export type PaymentInstrumentExpiration = {
  __typename: 'PaymentInstrumentExpiration';
  expirationMonth?: Maybe<Scalars['String']['output']>;
  expirationYear?: Maybe<Scalars['String']['output']>;
};

export type PaymentInstrumentExpirationInput = {
  expirationMonth?: InputMaybe<Scalars['String']['input']>;
  expirationYear?: InputMaybe<Scalars['String']['input']>;
};

export type PaymentInstrumentOrPaymentProviderResponse = PaymentInstrument | PaymentProviderResponse;

export type PaymentInstrumentSetDefaultInput = {
  customerUuid: Scalars['ID']['input'];
  paymentInstrumentUuid: Scalars['ID']['input'];
};

export type PaymentPreAuthorizeInput = {
  amount: Scalars['Float']['input'];
  customerUuid: Scalars['ID']['input'];
  externalRequestData?: InputMaybe<Scalars['OCJSON']['input']>;
  fuelingPosition?: InputMaybe<Scalars['String']['input']>;
  lineItems?: InputMaybe<Array<TransactionLineItemInput>>;
  locationUuid: Scalars['ID']['input'];
  merchantId?: InputMaybe<Scalars['String']['input']>;
  oneTimePaymentToken?: InputMaybe<PaymentTokenInput>;
  paymentInstrumentId?: InputMaybe<Scalars['ID']['input']>;
  paymentProviderPayload?: InputMaybe<PaymentProviderPayloadInput>;
  transactionType?: InputMaybe<Transaction_Type>;
  transactionUuid?: InputMaybe<Scalars['ID']['input']>;
  zipCode?: InputMaybe<Scalars['String']['input']>;
};

export type PaymentPreAuthorizeWithNonceInput = {
  amount: Scalars['Float']['input'];
  cardType: Payment_Instrument_Type;
  customerUuid: Scalars['ID']['input'];
  externalRequestData?: InputMaybe<Scalars['OCJSON']['input']>;
  lineItems?: InputMaybe<Array<TransactionLineItemInput>>;
  locationUuid: Scalars['ID']['input'];
  merchantId?: InputMaybe<Scalars['String']['input']>;
  paymentMethodNonce: Scalars['String']['input'];
  transactionType?: InputMaybe<Transaction_Type>;
  transactionUuid?: InputMaybe<Scalars['ID']['input']>;
  zipCode?: InputMaybe<Scalars['String']['input']>;
};

export type PaymentProvider = {
  __typename: 'PaymentProvider';
  configuration?: Maybe<Scalars['OCJSON']['output']>;
  name: Scalars['String']['output'];
  uuid: Scalars['ID']['output'];
};

export type PaymentProviderAccount = {
  __typename: 'PaymentProviderAccount';
  merchantId: Scalars['String']['output'];
  paymentProvider?: Maybe<PaymentProvider>;
  uuid: Scalars['ID']['output'];
};

export type PaymentProviderAccountInput = {
  merchantId: Scalars['String']['input'];
  paymentProvider?: InputMaybe<PaymentProviderInput>;
  uuid: Scalars['ID']['input'];
};

export type PaymentProviderInput = {
  configuration?: InputMaybe<Scalars['OCJSON']['input']>;
  name: Scalars['String']['input'];
  uuid: Scalars['ID']['input'];
};

export type PaymentProviderPayloadInput = {
  heartlandPayload?: InputMaybe<HeartlandPayloadInput>;
};

export type PaymentProviderResponse = {
  __typename: 'PaymentProviderResponse';
  paymentInstrumentAlias?: Maybe<Scalars['String']['output']>;
  paymentInstrumentBinRange?: Maybe<Scalars['String']['output']>;
  paymentInstrumentSourceType?: Maybe<Payment_Instrument_Type>;
  paymentInstrumentType?: Maybe<Payment_Instrument_Type>;
  paymentInstrumentUuid?: Maybe<Scalars['ID']['output']>;
  providerAuthCode?: Maybe<Scalars['String']['output']>;
  providerResponseCode?: Maybe<Scalars['String']['output']>;
  providerResponseSubCode?: Maybe<Scalars['String']['output']>;
  providerResponseText?: Maybe<Scalars['String']['output']>;
  providerResponseType: Scalars['String']['output'];
  providerResponseUserText?: Maybe<Scalars['String']['output']>;
  providerTransactionId?: Maybe<Scalars['String']['output']>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type PaymentRefundInput = {
  amount: Scalars['Float']['input'];
  externalRequestData?: InputMaybe<Scalars['OCJSON']['input']>;
  items?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  providerTransactionId: Scalars['ID']['input'];
  reasonDescription: Scalars['String']['input'];
  transactionUuid?: InputMaybe<Scalars['ID']['input']>;
};

export type PaymentSendBatchCloseRequestInput = {
  businessDate: Scalars['OCDate']['input'];
  currencyCode?: InputMaybe<Scalars['String']['input']>;
  firmwareVersion?: InputMaybe<Scalars['String']['input']>;
  hardwareVersion?: InputMaybe<Scalars['String']['input']>;
  merchantId?: InputMaybe<Scalars['String']['input']>;
  rawMessage?: InputMaybe<Scalars['String']['input']>;
  settlementEmployee?: InputMaybe<Scalars['String']['input']>;
  settlementPasscode?: InputMaybe<Scalars['String']['input']>;
  settlementPeriodId?: InputMaybe<Scalars['ID']['input']>;
  siteId: Scalars['String']['input'];
  softwareVersion?: InputMaybe<Scalars['String']['input']>;
  terminalTotal: Scalars['String']['input'];
  timeDateStamp?: InputMaybe<Scalars['OCDateTime']['input']>;
};

export type PaymentSettleInput = {
  amount: Scalars['Float']['input'];
  externalRequestData?: InputMaybe<Scalars['OCJSON']['input']>;
  lineItems?: InputMaybe<Array<TransactionLineItemInput>>;
  providerTransactionId: Scalars['ID']['input'];
  transactionUuid?: InputMaybe<Scalars['ID']['input']>;
};

export type PaymentTokenInput = {
  applePay?: InputMaybe<Scalars['String']['input']>;
  googlePay?: InputMaybe<Scalars['String']['input']>;
};

export type PaymentType = {
  __typename: 'PaymentType';
  title?: Maybe<Scalars['String']['output']>;
  type?: Maybe<Payment_Instrument_Type>;
};

export type PaymentVoidInput = {
  externalRequestData?: InputMaybe<Scalars['OCJSON']['input']>;
  providerTransactionId: Scalars['ID']['input'];
  reasonDescription: Scalars['String']['input'];
  transactionUuid?: InputMaybe<Scalars['ID']['input']>;
};

export type PaymentWalletDeleteInput = {
  customerUuid: Scalars['ID']['input'];
  paymentInstrumentUuid: Scalars['ID']['input'];
};

export type PerTransactionBreakdown = {
  __typename: 'PerTransactionBreakdown';
  perTransactionAverage: Scalars['Float']['output'];
  total: Scalars['Int']['output'];
};

export type PersonName = {
  __typename: 'PersonName';
  first?: Maybe<Scalars['String']['output']>;
  last?: Maybe<Scalars['String']['output']>;
  middle?: Maybe<Scalars['String']['output']>;
  suffix?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
};

export type PersonNameCreate = {
  first?: InputMaybe<Scalars['String']['input']>;
  last?: InputMaybe<Scalars['String']['input']>;
  middle?: InputMaybe<Scalars['String']['input']>;
  suffix?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type PhoneNumberMetadata = {
  __typename: 'PhoneNumberMetadata';
  carrier?: Maybe<Scalars['String']['output']>;
  city?: Maybe<Scalars['String']['output']>;
  /** @deprecated Use ISO 3166 country code instead */
  country?: Maybe<Scalars['String']['output']>;
  countryCode?: Maybe<Scalars['String']['output']>;
  phoneNumber?: Maybe<Scalars['OCPhoneNumber']['output']>;
  phoneType?: Maybe<Scalars['String']['output']>;
  phoneTypeCode?: Maybe<Scalars['Int']['output']>;
  source?: Maybe<Scalars['String']['output']>;
  timezone?: Maybe<Scalars['String']['output']>;
  uuid?: Maybe<Scalars['String']['output']>;
  valid?: Maybe<Scalars['Boolean']['output']>;
  zipCode?: Maybe<Scalars['String']['output']>;
};

export type PointAdjustmentReason = {
  __typename: 'PointAdjustmentReason';
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  label: Scalars['String']['output'];
};

export type PointChange = {
  __typename: 'PointChange';
  createdAt: Scalars['OCDateTime']['output'];
  id: Scalars['ID']['output'];
  membership: Membership;
  notes?: Maybe<Scalars['String']['output']>;
  offer?: Maybe<Offer>;
  pointAdjustmentReason?: Maybe<PointAdjustmentReason>;
  quantity: Scalars['Int']['output'];
  source?: Maybe<PointChangeSource>;
  sourceType?: Maybe<Point_Change_Source_Type>;
  type?: Maybe<Point_Change_Type>;
};

export type PointChangeConnection = {
  __typename: 'PointChangeConnection';
  edges: Array<PointChangeEdge>;
  pageInfo: PageInfo;
};

export type PointChangeEdge = {
  __typename: 'PointChangeEdge';
  cursor: Scalars['ID']['output'];
  node: PointChange;
};

export type PointChangeFilter = {
  createdAtMax?: InputMaybe<Scalars['OCDateTime']['input']>;
  createdAtMin?: InputMaybe<Scalars['OCDateTime']['input']>;
  idEquals?: InputMaybe<Scalars['ID']['input']>;
  pointAdjustmentReasonId?: InputMaybe<Scalars['ID']['input']>;
  pointTransactionTypeExcludes?: InputMaybe<Array<Point_Change_Type>>;
  pointTransactionTypeIncludes?: InputMaybe<Array<Point_Change_Type>>;
  search?: InputMaybe<Scalars['String']['input']>;
  sourceType?: InputMaybe<Point_Change_Source_Type>;
};

export type PointChangeSort = {
  direction: Sort_Order;
  field: Point_Change_Sort_By;
};

export type PointChangeSource = ActivateTransaction | ActivateUser | Chain | CommandCenterUser | GameSession | LoyaltyEvent | MembershipPointDonation | OfferPurchase | PointChange | PromocodeUseRequest | StoredValueTransaction;

export type PointExpiration = {
  __typename: 'PointExpiration';
  notificationDays?: Maybe<Scalars['Int']['output']>;
  strategy: Point_Expiration_Strategy;
};

export type PointExpirationSchedule = {
  __typename: 'PointExpirationSchedule';
  date: Scalars['OCDate']['output'];
  points: Scalars['Int']['output'];
};

export type PointExpirationScheduleConnection = {
  __typename: 'PointExpirationScheduleConnection';
  edges: Array<PointExpirationScheduleEdge>;
  pageInfo: PageInfo;
};

export type PointExpirationScheduleEdge = {
  __typename: 'PointExpirationScheduleEdge';
  cursor: Scalars['ID']['output'];
  node: PointExpirationSchedule;
};

export enum PointsStrategy {
  Cents = 'CENTS',
  NotUsed = 'NOT_USED',
  Points = 'POINTS'
}

export type PreferenceValue = {
  __typename: 'PreferenceValue';
  booleanType?: Maybe<Scalars['Boolean']['output']>;
  floatType?: Maybe<Scalars['Float']['output']>;
  intType?: Maybe<Scalars['Int']['output']>;
  stringType?: Maybe<Scalars['String']['output']>;
};

export type PreferenceValueCreate = {
  booleanType?: InputMaybe<Scalars['Boolean']['input']>;
  floatType?: InputMaybe<Scalars['Float']['input']>;
  intType?: InputMaybe<Scalars['Int']['input']>;
  stringType?: InputMaybe<Scalars['String']['input']>;
};

export type PreferenceValueUpdate = {
  booleanType?: InputMaybe<Scalars['Boolean']['input']>;
  floatType?: InputMaybe<Scalars['Float']['input']>;
  intType?: InputMaybe<Scalars['Int']['input']>;
  stringType?: InputMaybe<Scalars['String']['input']>;
};

export type ProcessSegmentUploadInput = {
  fileUuid: Scalars['OCUUID']['input'];
  mode?: InputMaybe<Segment_Upload_Mode>;
  segmentUuid: Scalars['OCUUID']['input'];
};

export type ProductCategory = {
  __typename: 'ProductCategory';
  categoryRestriction?: Maybe<Category_Restrictions>;
  chainId: Scalars['ID']['output'];
  createdAt: Scalars['OCDateTime']['output'];
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  rank: Scalars['Int']['output'];
};

export type ProductCategoryConnection = {
  __typename: 'ProductCategoryConnection';
  edges: Array<ProductCategoryEdge>;
  pageInfo: PageInfo;
};

export type ProductCategoryCreateInput = {
  categoryRestriction?: InputMaybe<Category_Restrictions>;
  chainId: Scalars['ID']['input'];
  id?: InputMaybe<Scalars['ID']['input']>;
  name: Scalars['String']['input'];
  rank?: InputMaybe<Scalars['Int']['input']>;
};

export type ProductCategoryEdge = {
  __typename: 'ProductCategoryEdge';
  cursor: Scalars['ID']['output'];
  node: ProductCategory;
};

export type ProductCategoryFilter = {
  categoryRestrictionEquals?: InputMaybe<Category_Restrictions>;
  chainIdEquals?: InputMaybe<Scalars['ID']['input']>;
  idContains?: InputMaybe<Array<Scalars['ID']['input']>>;
  idEquals?: InputMaybe<Scalars['ID']['input']>;
  idExcludes?: InputMaybe<Array<Scalars['ID']['input']>>;
};

export type ProductCategoryUpdateInput = {
  categoryRestriction?: InputMaybe<Category_Restrictions>;
  id: Scalars['ID']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
  rank?: InputMaybe<Scalars['Int']['input']>;
};

export type ProductGroup = {
  __typename: 'ProductGroup';
  chain: Chain;
  createdAt: Scalars['OCDateTime']['output'];
  description?: Maybe<Scalars['String']['output']>;
  discontinued: Scalars['Boolean']['output'];
  fuelProductGroup?: Maybe<FuelProductGroup>;
  id: Scalars['ID']['output'];
  key: Product_Group_Key;
  name: Scalars['String']['output'];
  values: Array<Scalars['String']['output']>;
};

export type ProductGroupConnection = {
  __typename: 'ProductGroupConnection';
  edges: Array<ProductGroupEdge>;
  pageInfo: PageInfo;
};

export type ProductGroupEdge = {
  __typename: 'ProductGroupEdge';
  cursor: Scalars['ID']['output'];
  node: ProductGroup;
};

export type ProductGroupFilter = {
  chainIdEquals?: InputMaybe<Scalars['ID']['input']>;
  idContains?: InputMaybe<Array<Scalars['ID']['input']>>;
  idEquals?: InputMaybe<Scalars['ID']['input']>;
  idExcludes?: InputMaybe<Array<Scalars['ID']['input']>>;
  isDeleted?: InputMaybe<Scalars['Boolean']['input']>;
  keyEquals?: InputMaybe<Product_Group_Key>;
  search?: InputMaybe<Scalars['String']['input']>;
  userSelectable?: InputMaybe<Scalars['Boolean']['input']>;
  valueContains?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type ProductGroupInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  key: Product_Group_Key;
  name: Scalars['String']['input'];
  values: Array<Scalars['String']['input']>;
};

export type ProductGroupUpdateInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  key?: InputMaybe<Product_Group_Key>;
  name: Scalars['String']['input'];
  values: Array<Scalars['String']['input']>;
};

export type ProductInterest = {
  __typename: 'ProductInterest';
  membershipId: Scalars['ID']['output'];
  productCategoryId: Scalars['ID']['output'];
};

export type ProductInterestInput = {
  customerUuid: Scalars['ID']['input'];
  productCategoryId: Scalars['ID']['input'];
};

export type ProductInterestsReplaceInput = {
  customerUuid: Scalars['ID']['input'];
  productCategoryIds: Array<Scalars['ID']['input']>;
};

export type ProductPreference = {
  __typename: 'ProductPreference';
  displayCategoryId: Scalars['ID']['output'];
  membershipId: Scalars['ID']['output'];
};

export type ProductPreferenceInput = {
  customerUuid: Scalars['ID']['input'];
  displayCategoryId: Scalars['ID']['input'];
};

export type ProductPreferenceReplaceInput = {
  customerUuid: Scalars['ID']['input'];
  displayCategoryIds: Array<Scalars['ID']['input']>;
};

export type PromoCodeGroup = {
  __typename: 'PromoCodeGroup';
  codesStats: PromoCodeGroupStats;
  createdBy?: Maybe<CommandCenterUser>;
  fileName: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  offerId: Scalars['ID']['output'];
  processingStatus: PromoCodeGroupProcessingStatus;
};

export type PromoCodeGroupConnection = {
  __typename: 'PromoCodeGroupConnection';
  edges: Array<PromoCodeGroupEdge>;
  pageInfo: PageInfo;
};

export type PromoCodeGroupDownloadLinkFilter = {
  fileType: PromoCodeGroupFileType;
  promoCodeGroupId: Scalars['ID']['input'];
};

export type PromoCodeGroupEdge = {
  __typename: 'PromoCodeGroupEdge';
  cursor: Scalars['ID']['output'];
  node: PromoCodeGroup;
};

export enum PromoCodeGroupFileType {
  Original = 'ORIGINAL',
  Processed = 'PROCESSED'
}

export enum PromoCodeGroupProcessingStatus {
  Completed = 'COMPLETED',
  Failed = 'FAILED',
  InProgress = 'IN_PROGRESS',
  Pending = 'PENDING'
}

export type PromoCodeGroupStats = {
  __typename: 'PromoCodeGroupStats';
  createdCount: Scalars['Int']['output'];
  failedCount: Scalars['Int']['output'];
  totalCount: Scalars['Int']['output'];
};

export type PromoCodesUploadProcessInput = {
  offerId: Scalars['ID']['input'];
  promoCodeGroupId: Scalars['ID']['input'];
};

export type PromoCodesUploadUrlGenerateResponse = {
  __typename: 'PromoCodesUploadUrlGenerateResponse';
  fields: Scalars['OCJSON']['output'];
  promoCodeGroupId: Scalars['ID']['output'];
  signedUrl: Scalars['OCURL']['output'];
};

export type Promocode = {
  __typename: 'Promocode';
  code: Scalars['OCPromocode']['output'];
  createdBy: CommandCenterUser;
  description?: Maybe<Scalars['String']['output']>;
  endDate?: Maybe<Scalars['OCDateTime']['output']>;
  id: Scalars['ID']['output'];
  offer: Offer;
  publicationStatus: PromocodePublicationStatus;
  startDate: Scalars['OCDateTime']['output'];
  stats?: Maybe<PromocodeUsageStats>;
  status: PromocodeStatus;
};

export type PromocodeBatchCreateInput = {
  offerId: Scalars['ID']['input'];
  promocodes: Array<PromocodeCreateInput>;
};

export type PromocodeCreateInput = {
  code: Scalars['OCPromocode']['input'];
  description?: InputMaybe<Scalars['String']['input']>;
  endDate?: InputMaybe<Scalars['OCDateTime']['input']>;
  startDate: Scalars['OCDateTime']['input'];
};

export enum PromocodePublicationStatus {
  Expired = 'EXPIRED',
  NotPublished = 'NOT_PUBLISHED',
  Published = 'PUBLISHED'
}

export enum PromocodeStatus {
  Active = 'ACTIVE',
  Archived = 'ARCHIVED',
  /** @deprecated DRAFT is no longer a supported promocode status; new and existing draft promocodes are now ACTIVE. */
  Draft = 'DRAFT',
  Redeemed = 'REDEEMED'
}

export type PromocodeStatusUpdateInput = {
  promocodeId: Scalars['ID']['input'];
  status: UpdatePromocodeStatus;
};

export type PromocodeUpdateInput = {
  code?: InputMaybe<Scalars['OCPromocode']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  endDate?: InputMaybe<Scalars['OCDateTime']['input']>;
  id: Scalars['ID']['input'];
  startDate?: InputMaybe<Scalars['OCDateTime']['input']>;
};

export type PromocodeUsageStats = {
  __typename: 'PromocodeUsageStats';
  redemptions: Scalars['Int']['output'];
  totalOfferRedemptions: Scalars['Int']['output'];
};

export type PromocodeUseRequest = {
  __typename: 'PromocodeUseRequest';
  id: Scalars['ID']['output'];
  membership: Membership;
  offer: Offer;
  promocode: Scalars['OCPromocode']['output'];
};

export type PromocodesInput = {
  /** @deprecated Use promocodeBatchCreate mutation instead */
  create?: InputMaybe<Array<PromocodeCreateInput>>;
  /** @deprecated Use promocodeBatchDelete mutation instead */
  delete?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** @deprecated Use promocodeBatchUpdate mutation instead */
  update?: InputMaybe<Array<PromocodeUpdateInput>>;
};

export enum PromocodesOfferType {
  Global = 'GLOBAL',
  Individual = 'INDIVIDUAL'
}

export type PurchaseProgress = {
  __typename: 'PurchaseProgress';
  quantityPurchased: Scalars['Float']['output'];
  quantityRequired: Scalars['Float']['output'];
};

export type PurchaseStoredValueInput = {
  membershipId: Scalars['ID']['input'];
  pointsSpend: Scalars['Int']['input'];
  storedValueProgramId: Scalars['ID']['input'];
};

export type PushNotificationConfig = {
  __typename: 'PushNotificationConfig';
  enabled: Scalars['Boolean']['output'];
  template: PushNotificationTemplate;
};

export type PushNotificationConfigInput = {
  enabled: Scalars['Boolean']['input'];
  template: PushNotificationTemplateInput;
};

export type PushNotificationContent = {
  __typename: 'PushNotificationContent';
  body: Scalars['OCLiquid']['output'];
  title?: Maybe<Scalars['OCLiquid']['output']>;
};

export type PushNotificationContentInput = {
  body: Scalars['OCLiquid']['input'];
  title?: InputMaybe<Scalars['OCLiquid']['input']>;
};

export type PushNotificationData = {
  __typename: 'PushNotificationData';
  url?: Maybe<Scalars['OCURL']['output']>;
};

export type PushNotificationDataInput = {
  url?: InputMaybe<Scalars['OCURL']['input']>;
};

export type PushNotificationDirectSendInput = {
  customerUuids: Array<Scalars['ID']['input']>;
  notificationMessage?: InputMaybe<PushNotificationMessageInput>;
  subBrandCodeName?: InputMaybe<Scalars['String']['input']>;
};

export type PushNotificationDirectSendPayload = {
  __typename: 'PushNotificationDirectSendPayload';
  failureCount: Scalars['Int']['output'];
  successCount: Scalars['Int']['output'];
};

export type PushNotificationEvent = {
  __typename: 'PushNotificationEvent';
  createdAt: Scalars['OCDateTime']['output'];
  customerUuid?: Maybe<Scalars['ID']['output']>;
  deliveryId: Scalars['ID']['output'];
  eventType: PushNotificationEventType;
  occurredAt: Scalars['OCDateTime']['output'];
  platform?: Maybe<AppPlatform>;
  sourceId?: Maybe<Scalars['ID']['output']>;
  sourceType: PushNotificationSourceType;
};

export type PushNotificationEventConnection = {
  __typename: 'PushNotificationEventConnection';
  edges: Array<PushNotificationEventEdge>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type PushNotificationEventEdge = {
  __typename: 'PushNotificationEventEdge';
  cursor: Scalars['ID']['output'];
  node: PushNotificationEvent;
};

export type PushNotificationEventFilter = {
  customerUuidEquals?: InputMaybe<Scalars['ID']['input']>;
  deliveryIdEquals?: InputMaybe<Scalars['ID']['input']>;
  eventTypeIncludes?: InputMaybe<Array<PushNotificationEventType>>;
  occurredAtFrom?: InputMaybe<Scalars['OCDateTime']['input']>;
  occurredAtTo?: InputMaybe<Scalars['OCDateTime']['input']>;
  platformEquals?: InputMaybe<AppPlatform>;
  sourceIdEquals?: InputMaybe<Scalars['ID']['input']>;
  sourceTypeIncludes?: InputMaybe<Array<PushNotificationSourceType>>;
};

export type PushNotificationEventInput = {
  deliveryId: Scalars['ID']['input'];
  eventType: PushNotificationEventType;
  occurredAt: Scalars['OCDateTime']['input'];
  platform?: InputMaybe<AppPlatform>;
};

export enum PushNotificationEventType {
  Blocked = 'BLOCKED',
  LinkOpened = 'LINK_OPENED',
  Received = 'RECEIVED',
  SendFailed = 'SEND_FAILED',
  Sent = 'SENT',
  Tapped = 'TAPPED'
}

export type PushNotificationMessageInput = {
  body?: InputMaybe<Scalars['String']['input']>;
  imageUrl?: InputMaybe<Scalars['OCURL']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  url?: InputMaybe<Scalars['OCURL']['input']>;
};

export enum PushNotificationSourceType {
  AudienceBroadcast = 'AUDIENCE_BROADCAST',
  AutomationRule = 'AUTOMATION_RULE',
  ManualDirect = 'MANUAL_DIRECT',
  Test = 'TEST'
}

export type PushNotificationTemplate = {
  __typename: 'PushNotificationTemplate';
  data?: Maybe<PushNotificationData>;
  notification: PushNotificationContent;
  uuid: Scalars['OCUUID']['output'];
};

export type PushNotificationTemplateInput = {
  data?: InputMaybe<PushNotificationDataInput>;
  notification: PushNotificationContentInput;
};

export type PushNotificationTopicSendInput = {
  message: PushNotificationMessageInput;
  topic: Scalars['String']['input'];
};

export type QosDetails = {
  __typename: 'QosDetails';
  createdTimestamp: Scalars['String']['output'];
  processingTime?: Maybe<Scalars['Int']['output']>;
  receivedTimestamp?: Maybe<Scalars['String']['output']>;
  transmitTimestamp: Scalars['String']['output'];
};

export type QosDetailsInput = {
  createdTimestamp: Scalars['String']['input'];
  processingTime?: InputMaybe<Scalars['Int']['input']>;
  receivedTimestamp?: InputMaybe<Scalars['String']['input']>;
  transmitTimestamp: Scalars['String']['input'];
};

export type QualifiedEvent = QualifiedEventLoyaltyEvent | QualifiedEventTransaction;

export type QualifiedEventInput = {
  loyaltyEvent?: InputMaybe<QualifiedEventLoyaltyEventInput>;
  transaction?: InputMaybe<QualifiedEventTransactionInput>;
};

export type QualifiedEventLoyaltyEvent = {
  __typename: 'QualifiedEventLoyaltyEvent';
  loyaltyEventOffer: Offer;
};

export type QualifiedEventLoyaltyEventInput = {
  loyaltyEventOffer: Scalars['ID']['input'];
};

export type QualifiedEventTransaction = {
  __typename: 'QualifiedEventTransaction';
  countProductsBy: Constraint_Purchase_Threshold_Counting_Attribute;
  eligibleProductGroups: Array<ProductGroup>;
  purchaseThreshold: Scalars['Int']['output'];
};

export type QualifiedEventTransactionInput = {
  countProductsBy: Constraint_Purchase_Threshold_Counting_Attribute;
  eligibleProductGroups?: InputMaybe<Array<Scalars['ID']['input']>>;
  purchaseThreshold: Scalars['Int']['input'];
};

export type Query = {
  __typename: 'Query';
  activateTransactions: ActivateTransactionConnection;
  activityFeed: ActivityFeedConnection;
  allowListPhoneNumber: AllowListPhoneNumber;
  allowListPhoneNumbers: AllowListPhoneNumberConnection;
  audienceBroadcastMessages: AudienceBroadcastMessageConnection;
  audiences: AudienceConnection;
  audiencesForMembership?: Maybe<Array<Audience>>;
  audiencesForMembershipWithPagination: AudienceConnection;
  authorizationClaim?: Maybe<AuthorizationClaim>;
  authorizationClaims?: Maybe<Array<AuthorizationClaim>>;
  authorizationIdentityGroup?: Maybe<AuthorizationIdentityGroup>;
  authorizationIdentityGroups?: Maybe<Array<AuthorizationIdentityGroup>>;
  availableRewardPrograms: Array<Maybe<RewardProgram>>;
  bannerConfigurations?: Maybe<BannerConfigurationConnection>;
  banners: Array<Banner>;
  brazeFields: BrazeFieldConnection;
  campaigns: CampaignConnection;
  chains: ChainConnection;
  commandCenterAppConfig: CommandCenterAppConfig;
  commandCenterUsers?: Maybe<Array<CommandCenterUser>>;
  commandCenterUsersWithPagination: CommandCenterUserConnection;
  currentUserAbilities?: Maybe<Array<UserAbility>>;
  currentUserRetailerNetworkUsers: RetailerNetworkUserConnection;
  customer?: Maybe<Customer>;
  customerByPhoneNumber?: Maybe<Customer>;
  customerScanDataOverview: CustomerScanDataOverview;
  customers?: Maybe<CustomerConnection>;
  displayCategories?: Maybe<DisplayCategoryConnection>;
  donationBuckets: DonationBucketConnection;
  driveConversations: DriveConversationConnection;
  eaivAgeVerification: EaivAgeVerification;
  eaivAuditTrail: EaivAuditConnection;
  eaivIdentityVerification: EaivIdentityVerification;
  externalIdentityVerificationAttributes: Array<ExternalIdentityVerificationAttribute>;
  externalLoyaltyManualOffer: ExternalLoyaltyManualOffer;
  externalLoyaltyManualOfferBrands: Array<ExternalLoyaltyManualOfferBrand>;
  externalLoyaltyManualOfferLocations: ExternalLoyaltyManualOfferLocationsConnection;
  externalLoyaltyManualOfferUpcs: ExternalLoyaltyManualOfferUpcs;
  externalLoyaltyManualOffers: ExternalLoyaltyManualOffersConnection;
  externalLoyaltyManualOffersPullingJobStatuses: Array<ExternalLoyaltyManualOffersPullingJobStatus>;
  externalPrograms: Array<ExternalProgram>;
  getCommandCenterUser?: Maybe<CommandCenterUser>;
  getCommunicationPreferencesForAllSubBrands: Array<CommunicationPreference>;
  getPhoneNumberMetadata: PhoneNumberMetadata;
  getReportFileDownloadLink?: Maybe<Scalars['OCURL']['output']>;
  getScanDataSftpCredentialByUuid?: Maybe<ScanDataSftpCredential>;
  guestSurvey?: Maybe<Survey>;
  kiosk: Kiosk;
  kioskAdSet: KioskAdSet;
  kioskAdSets: KioskAdSetConnection;
  kioskAppConfig: KioskAppConfig;
  kioskAppConfigs: KioskAppConfigConnection;
  kioskAsset: KioskAsset;
  kioskAssets: KioskAssetConnection;
  kioskDefaultScreen: KioskDefaultScreen;
  kioskDefaultScreens: KioskDefaultScreenConnection;
  kioskDevices: KioskDeviceList;
  kiosks: KioskConnection;
  listScanDataSftpCredentials?: Maybe<ScanDataSftpCredentialConnection>;
  listScanDataSftpCredentialsWithStoreDetails: ScanDataSftpCredentialsWithStoreDetailsConnection;
  locationDowntimeMetrics?: Maybe<Array<LocationDowntimeMetric>>;
  locationGroups: LocationGroupConnection;
  locationOpenCommerceFeatures?: Maybe<Array<Maybe<OpenCommerceFeature>>>;
  locations: LocationConnection;
  loyaltyEvents: LoyaltyEventConnection;
  loyaltyRewardsEligibilityRestrictions: Array<LoyaltyRewardsEligibilityRestriction>;
  memberDossierSegment: MemberDossierSegment;
  membershipActivities: MembershipActivityConnection;
  memberships?: Maybe<MembershipConnection>;
  metricCounts: Array<MetricCounts>;
  offers: OfferConnection;
  openCommerceUserCurrent?: Maybe<OpenCommerceUser>;
  openCommerceUsers: OpenCommerceUserConnection;
  parPayCorporateAccountGetByCorpId: ParPayCorporateAccount;
  parPayCorporateAccountGetByUuid: ParPayCorporateAccount;
  parPayCorporateAccountsGet?: Maybe<Array<ParPayCorporateAccount>>;
  parPayGetPaymentAppConfig: ParPayPaymentAppConfig;
  parPayMerchantAccountGetByLocationUuid: ParPayMerchantAccount;
  parPayMerchantAccountGetByUuid: ParPayMerchantAccount;
  parPayMerchantAccountsGet?: Maybe<Array<ParPayMerchantAccount>>;
  pointChanges: PointChangeConnection;
  productCategories?: Maybe<ProductCategoryConnection>;
  productGroups: ProductGroupConnection;
  promoCodeGroupDownloadLink: Scalars['OCURL']['output'];
  pushNotificationEvents: PushNotificationEventConnection;
  referralProgramStatistics: ReferralProgramStatistics;
  retailerNetwork: RetailerNetwork;
  retailerNetworkCPGManufacturerPrograms: Array<CpgManufacturerProgram>;
  retailerNetworkCustomer: RetailerNetworkCustomerConnection;
  retailerNetworkLocationCities: Array<Scalars['String']['output']>;
  retailerNetworkLocationCoordinates: RetailerNetworkLocationCoordinatesConnection;
  retailerNetworkLocationDowntimeMetrics: Array<TimeSeriesMetric>;
  retailerNetworkLocationDowntimeMetricsOverview: RetailerNetworkLocationDowntimeMetricsOverview;
  retailerNetworkLocationGroups: RetailerNetworkLocationGroupConnection;
  retailerNetworkLocationGroupsForMember: RetailerNetworkLocationGroupForMemberConnection;
  retailerNetworkLocationGroupsWithPerformanceExcerpt: RetailerNetworkLocationGroupsWithPerformanceExcerptConnection;
  retailerNetworkLocationOfferMetricsOverview: RetailerNetworkOfferMetricsOverviewConnection;
  retailerNetworkLocationPosConnectionStatus: Array<RetailerNetworkLocationPosConnectionStatus>;
  retailerNetworkLocationStates: Array<Scalars['String']['output']>;
  retailerNetworkLocations: RetailerNetworkLocationConnection;
  retailerNetworkLocationsForMember: RetailerNetworkLocationForMemberConnection;
  retailerNetworkLocationsWithPerformanceExcerpt: RetailerNetworkLocationsWithPerformanceExcerptConnection;
  retailerNetworkLoyaltyMetricsOverview: RetailerNetworkLoyaltyMetricsOverview;
  retailerNetworkPerformance: RetailerNetworkPerformance;
  retailerNetworkScanDataTobaccoSiteSubmissions: RetailerNetworkScanDataTobaccoSiteSubmissionConnection;
  retailerNetworkScanDataTobaccoSubmissionsOverview: RetailerNetworkScanDataTobaccoSubmissionsOverview;
  retailerNetworkScanDataWeeklySubmissions: RetailerNetworkScanDataWeeklySubmissionConnection;
  retailerNetworkTobaccoManufacturerOfferPerformance: RetailerNetworkTobaccoManufacturerOfferPerformanceConnection;
  retailerNetworkTobaccoProgramMetricTimeSeries: Array<TimeSeriesDataPoint>;
  retailerNetworkTobaccoProgramMetricsOverview: RetailerNetworkTobaccoProgramOverview;
  retailerNetworkTobaccoProgramSitesMetric: RetailerNetworkTobaccoProgramSitesMetricConnection;
  retailerNetworkTransactionMetricsOverview?: Maybe<RetailerNetworkTransactionMetricsOverview>;
  retailerNetworkUser?: Maybe<RetailerNetworkUser>;
  retailerNetworkUsers: RetailerNetworkUserConnection;
  retailerNetworkUsersForMember: RetailerNetworkUserConnection;
  retailerNetworksForMember: RetailerNetworksForMemberConnection;
  retailerNetworksForUser: RetailerNetworkConnection;
  retailerNetworksForUsers: RetailerNetworkConnection;
  scanDataMetricsTimeSeries: ScanDataMetricsTimeSeries;
  scanDataMissingStoresDetails: ScanDataMissingStoresDetailsConnection;
  scanDataMissingStoresStoreLevelDetails: ScanDataMissingStoreStoreLevelDetailsConnection;
  scanDataReimbursementsStoreLevelDetails: ScanDataReimbursementsStoreLevelDetailsConnection;
  scanDataReportedTransactionsStoreLevelDetails: ScanDataReportedTransactionsStoreLevelDetailsConnection;
  scanDataSftpCredentialsOverview: ScanDataSftpCredentialsOverview;
  scanDataSubmissionHealthMetrics: ScanDataSubmissionHealthMetrics;
  scanDataSubmissions: ScanDataSubmissionsConnection;
  scanDataSubmittedTransactionsStoreLevelDetails: ScanDataSubmittedTransactionsStoreLevelDetailsConnection;
  scanDataWeekEndingOverview: ScanDataWeekEndingOverview;
  segmentUploadedFiles: SegmentUploadFileConnection;
  segments: SegmentConnection;
  segmentsByMembershipUuid: SegmentConnection;
  siteConnectionHistory: SiteConnectionHistoryConnection;
  siteConnectionHistorySummary: SiteConnectionHistorySummary;
  siteHealth: SiteHealthConnection;
  siteIssues: Array<SiteIssue>;
  siteMonitorActivityLog: SiteMonitorActivityConnection;
  sitesSummary?: Maybe<SitesSummary>;
  steeringWallet: SteeringWallet;
  steeringWallets: SteeringWalletConnection;
  storedValuePrograms: StoredValueProgramConnection;
  subBrands: SubBrandConnection;
  survey: Survey;
  surveyAnswers: SurveyAnswersConnection;
  surveyLocationStatistics: SurveyLocationStatisticsConnection;
  surveyMetrics: SurveyMetrics;
  surveyQuestionResponseStatistics: SurveyQuestionResponseStatistics;
  surveys: SurveyConnection;
  transactionFraudulentInfo?: Maybe<TransactionFraudCheckResult>;
  transactions: TransactionConnection;
  triggeredMessage?: Maybe<TriggeredMessage>;
  triggeredMessages: TriggeredMessageConnection;
  userCurrent?: Maybe<User>;
  usersEligibleForRetailerConnect: OpenCommerceUserConnection;
  usersLookup?: Maybe<UserConnection>;
  walletSteeringDailySnapshots: Array<Maybe<WalletSteeringDailySnapshot>>;
  walletsForMembership: WalletConnection;
};


export type QueryActivateTransactionsArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  filter?: InputMaybe<ActivateTransactionFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<ActivateTransactionSort>;
};


export type QueryActivityFeedArgs = {
  after?: InputMaybe<Scalars['OCBase64Cursor']['input']>;
  before?: InputMaybe<Scalars['OCBase64Cursor']['input']>;
  filter: ActivityFeedFilter;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryAllowListPhoneNumberArgs = {
  uuid: Scalars['OCUUID']['input'];
};


export type QueryAllowListPhoneNumbersArgs = {
  after?: InputMaybe<Scalars['OCBase64Cursor']['input']>;
  before?: InputMaybe<Scalars['OCBase64Cursor']['input']>;
  filter?: InputMaybe<AllowListPhoneNumberFilterInput>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryAudienceBroadcastMessagesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<AudienceBroadcastMessagesFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryAudiencesArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  filter?: InputMaybe<AudienceFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryAudiencesForMembershipArgs = {
  membershipId: Scalars['ID']['input'];
};


export type QueryAudiencesForMembershipWithPaginationArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  filter?: InputMaybe<AudienceForMembershipFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryAuthorizationClaimArgs = {
  filter: AuthorizationClaimFilterInput;
};


export type QueryAuthorizationClaimsArgs = {
  filter: AuthorizationClaimFilterInput;
};


export type QueryAuthorizationIdentityGroupArgs = {
  filter: AuthorizationIdentityGroupFilterInput;
};


export type QueryAuthorizationIdentityGroupsArgs = {
  filter: AuthorizationIdentityGroupFilterInput;
};


export type QueryAvailableRewardProgramsArgs = {
  filter?: InputMaybe<RewardProgramFilter>;
};


export type QueryBannerConfigurationsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<BannerConfigurationFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryBannersArgs = {
  filter: BannerFilter;
  membershipUuid: Scalars['ID']['input'];
};


export type QueryBrazeFieldsArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  filter?: InputMaybe<BrazeFieldFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryCampaignsArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  filter?: InputMaybe<CampaignFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryChainsArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  filter?: InputMaybe<ChainFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryCommandCenterUsersArgs = {
  filter?: InputMaybe<CommandCenterUserFilterInput>;
};


export type QueryCommandCenterUsersWithPaginationArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  filter?: InputMaybe<CommandCenterUserFilterInput>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryCurrentUserRetailerNetworkUsersArgs = {
  after?: InputMaybe<Scalars['OCBase64Cursor']['input']>;
  before?: InputMaybe<Scalars['OCBase64Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  retailerNetworkUuid?: InputMaybe<Scalars['OCUUID']['input']>;
  sort?: InputMaybe<RetailerNetworkUsersSort>;
};


export type QueryCustomerArgs = {
  uuid: Scalars['ID']['input'];
};


export type QueryCustomerByPhoneNumberArgs = {
  phoneNumber: Scalars['String']['input'];
};


export type QueryCustomersArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<CustomerFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryDisplayCategoriesArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  filter?: InputMaybe<DisplayCategoryFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryDonationBucketsArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  filter?: InputMaybe<DonationBucketFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryDriveConversationsArgs = {
  after?: InputMaybe<Scalars['OCBase64Cursor']['input']>;
  before?: InputMaybe<Scalars['OCBase64Cursor']['input']>;
  filter?: InputMaybe<DriveConversationFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryEaivAgeVerificationArgs = {
  customerUuid: Scalars['OCUUID']['input'];
};


export type QueryEaivAuditTrailArgs = {
  after?: InputMaybe<Scalars['OCBase64Cursor']['input']>;
  before?: InputMaybe<Scalars['OCBase64Cursor']['input']>;
  filter?: InputMaybe<EaivAuditTrailFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryEaivIdentityVerificationArgs = {
  customerUuid: Scalars['OCUUID']['input'];
};


export type QueryExternalLoyaltyManualOfferArgs = {
  uuid: Scalars['ID']['input'];
};


export type QueryExternalLoyaltyManualOfferBrandsArgs = {
  filter?: InputMaybe<ExternalLoyaltyManualOfferBrandFilter>;
};


export type QueryExternalLoyaltyManualOfferLocationsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<ExternalLoyaltyManualOfferLocationFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  manualOfferUuid: Scalars['ID']['input'];
};


export type QueryExternalLoyaltyManualOfferUpcsArgs = {
  manualOfferUuid: Scalars['ID']['input'];
};


export type QueryExternalLoyaltyManualOffersArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<ExternalLoyaltyManualOfferFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryExternalProgramsArgs = {
  filter?: InputMaybe<ExternalProgramFilter>;
};


export type QueryGetCommandCenterUserArgs = {
  email: Scalars['String']['input'];
};


export type QueryGetCommunicationPreferencesForAllSubBrandsArgs = {
  customerUuid: Scalars['OCUUID']['input'];
};


export type QueryGetPhoneNumberMetadataArgs = {
  phoneNumber: Scalars['OCPhoneNumber']['input'];
};


export type QueryGetReportFileDownloadLinkArgs = {
  reportUuid: Scalars['ID']['input'];
};


export type QueryGetScanDataSftpCredentialByUuidArgs = {
  uuid: Scalars['ID']['input'];
};


export type QueryGuestSurveyArgs = {
  guestSurveyId: Scalars['String']['input'];
};


export type QueryKioskArgs = {
  id: Scalars['OCUUID']['input'];
};


export type QueryKioskAdSetArgs = {
  id: Scalars['ID']['input'];
};


export type QueryKioskAdSetsArgs = {
  after?: InputMaybe<Scalars['OCBase64Cursor']['input']>;
  before?: InputMaybe<Scalars['OCBase64Cursor']['input']>;
  filter?: InputMaybe<KioskAdSetFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryKioskAppConfigArgs = {
  id: Scalars['ID']['input'];
};


export type QueryKioskAppConfigsArgs = {
  after?: InputMaybe<Scalars['OCBase64Cursor']['input']>;
  before?: InputMaybe<Scalars['OCBase64Cursor']['input']>;
  filter?: InputMaybe<KioskAppConfigFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryKioskAssetArgs = {
  id: Scalars['ID']['input'];
};


export type QueryKioskAssetsArgs = {
  after?: InputMaybe<Scalars['OCBase64Cursor']['input']>;
  before?: InputMaybe<Scalars['OCBase64Cursor']['input']>;
  filter?: InputMaybe<KioskAssetFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryKioskDefaultScreenArgs = {
  id: Scalars['ID']['input'];
};


export type QueryKioskDefaultScreensArgs = {
  after?: InputMaybe<Scalars['OCBase64Cursor']['input']>;
  before?: InputMaybe<Scalars['OCBase64Cursor']['input']>;
  filter?: InputMaybe<KioskDefaultScreenFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryKioskDevicesArgs = {
  filter?: InputMaybe<KioskDeviceFilter>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryKiosksArgs = {
  after?: InputMaybe<Scalars['OCBase64Cursor']['input']>;
  before?: InputMaybe<Scalars['OCBase64Cursor']['input']>;
  filter?: InputMaybe<KioskFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryListScanDataSftpCredentialsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryListScanDataSftpCredentialsWithStoreDetailsArgs = {
  after?: InputMaybe<Scalars['OCBase64Cursor']['input']>;
  before?: InputMaybe<Scalars['OCBase64Cursor']['input']>;
  cpg: Cpg;
  filter?: InputMaybe<ListScanDataSftpCredentialsWithStoreDetailsFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryLocationDowntimeMetricsArgs = {
  filter: LocationDowntimeMetricsFilter;
};


export type QueryLocationGroupsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<LocationGroupFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryLocationsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<LocationFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<LocationSort>;
};


export type QueryLoyaltyEventsArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  filter?: InputMaybe<LoyaltyEventFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryMemberDossierSegmentArgs = {
  uuid: Scalars['OCUUID']['input'];
};


export type QueryMembershipActivitiesArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  filter?: InputMaybe<MembershipActivityFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<MembershipActivitySort>;
};


export type QueryMembershipsArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  filter?: InputMaybe<MembershipFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryMetricCountsArgs = {
  filter: MetricCountsFilter;
};


export type QueryOffersArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  filter?: InputMaybe<OfferFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<OfferSort>;
};


export type QueryOpenCommerceUsersArgs = {
  after?: InputMaybe<Scalars['OCBase64Cursor']['input']>;
  before?: InputMaybe<Scalars['OCBase64Cursor']['input']>;
  filter?: InputMaybe<OpenCommerceUserFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryParPayCorporateAccountGetByCorpIdArgs = {
  corpId: Scalars['String']['input'];
};


export type QueryParPayCorporateAccountGetByUuidArgs = {
  uuid: Scalars['ID']['input'];
};


export type QueryParPayCorporateAccountsGetArgs = {
  filter: ParPayCorporateAccountsGetFilter;
};


export type QueryParPayGetPaymentAppConfigArgs = {
  corpId: Scalars['String']['input'];
};


export type QueryParPayMerchantAccountGetByLocationUuidArgs = {
  locationUuid: Scalars['ID']['input'];
};


export type QueryParPayMerchantAccountGetByUuidArgs = {
  uuid: Scalars['ID']['input'];
};


export type QueryParPayMerchantAccountsGetArgs = {
  filter: ParPayMerchantAccountsGetFilter;
};


export type QueryPointChangesArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  filter?: InputMaybe<PointChangeFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<PointChangeSort>;
};


export type QueryProductCategoriesArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  filter?: InputMaybe<ProductCategoryFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryProductGroupsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<ProductGroupFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryPromoCodeGroupDownloadLinkArgs = {
  filter: PromoCodeGroupDownloadLinkFilter;
};


export type QueryPushNotificationEventsArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  filter: PushNotificationEventFilter;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryReferralProgramStatisticsArgs = {
  filter: ReferralProgramStatisticsFilter;
};


export type QueryRetailerNetworkArgs = {
  uuid: Scalars['OCUUID']['input'];
};


export type QueryRetailerNetworkCpgManufacturerProgramsArgs = {
  filter: RetailerNetworkCpgManufacturerProgramsFilter;
};


export type QueryRetailerNetworkCustomerArgs = {
  after?: InputMaybe<Scalars['OCBase64Cursor']['input']>;
  before?: InputMaybe<Scalars['OCBase64Cursor']['input']>;
  filter: RetailerNetworkCustomerFilter;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryRetailerNetworkLocationCitiesArgs = {
  filter: RetailerNetworkLocationCitiesFilter;
};


export type QueryRetailerNetworkLocationCoordinatesArgs = {
  after?: InputMaybe<Scalars['OCBase64Cursor']['input']>;
  before?: InputMaybe<Scalars['OCBase64Cursor']['input']>;
  filter: RetailerNetworkLocationCoordinatesFilter;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryRetailerNetworkLocationDowntimeMetricsArgs = {
  filter: RetailerNetworkLocationDowntimeMetricsFilter;
};


export type QueryRetailerNetworkLocationDowntimeMetricsOverviewArgs = {
  filter: RetailerNetworkLocationDowntimeMetricsOverviewFilter;
};


export type QueryRetailerNetworkLocationGroupsArgs = {
  after?: InputMaybe<Scalars['OCBase64Cursor']['input']>;
  before?: InputMaybe<Scalars['OCBase64Cursor']['input']>;
  filter: RetailerNetworkLocationGroupFilter;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryRetailerNetworkLocationGroupsForMemberArgs = {
  after?: InputMaybe<Scalars['OCBase64Cursor']['input']>;
  before?: InputMaybe<Scalars['OCBase64Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  memberUuid: Scalars['OCUUID']['input'];
};


export type QueryRetailerNetworkLocationGroupsWithPerformanceExcerptArgs = {
  after?: InputMaybe<Scalars['OCBase64Cursor']['input']>;
  before?: InputMaybe<Scalars['OCBase64Cursor']['input']>;
  filter: RetailerNetworkLocationGroupsWithPerformanceExcerptFilter;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryRetailerNetworkLocationOfferMetricsOverviewArgs = {
  after?: InputMaybe<Scalars['OCBase64Cursor']['input']>;
  before?: InputMaybe<Scalars['OCBase64Cursor']['input']>;
  filter: RetailerNetworkOfferMetricsOverviewFilter;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<RetailerNetworkOfferMetricsOverviewSort>;
};


export type QueryRetailerNetworkLocationPosConnectionStatusArgs = {
  filter: RetailerNetworkLocationPosConnectionStatusFilter;
};


export type QueryRetailerNetworkLocationStatesArgs = {
  filter: RetailerNetworkLocationStatesFilter;
};


export type QueryRetailerNetworkLocationsArgs = {
  after?: InputMaybe<Scalars['OCBase64Cursor']['input']>;
  before?: InputMaybe<Scalars['OCBase64Cursor']['input']>;
  filter: RetailerNetworkLocationFilter;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryRetailerNetworkLocationsForMemberArgs = {
  after?: InputMaybe<Scalars['OCBase64Cursor']['input']>;
  before?: InputMaybe<Scalars['OCBase64Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  memberUuid: Scalars['OCUUID']['input'];
};


export type QueryRetailerNetworkLocationsWithPerformanceExcerptArgs = {
  after?: InputMaybe<Scalars['OCBase64Cursor']['input']>;
  before?: InputMaybe<Scalars['OCBase64Cursor']['input']>;
  filter: RetailerNetworkLocationsWithPerformanceExcerptFilter;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<RetailerNetworkPerformanceSort>;
};


export type QueryRetailerNetworkLoyaltyMetricsOverviewArgs = {
  filter: RetailerNetworkLoyaltyMetricsFilter;
};


export type QueryRetailerNetworkPerformanceArgs = {
  filter: RetailerNetworkPerformanceFilter;
};


export type QueryRetailerNetworkScanDataTobaccoSiteSubmissionsArgs = {
  after?: InputMaybe<Scalars['OCBase64Cursor']['input']>;
  before?: InputMaybe<Scalars['OCBase64Cursor']['input']>;
  filter: RetailerNetworkScanDataTobaccoSiteSubmissionFilter;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryRetailerNetworkScanDataTobaccoSubmissionsOverviewArgs = {
  filter: RetailerNetworkScanDataTobaccoSubmissionsOverviewFilter;
};


export type QueryRetailerNetworkScanDataWeeklySubmissionsArgs = {
  after?: InputMaybe<Scalars['OCBase64Cursor']['input']>;
  before?: InputMaybe<Scalars['OCBase64Cursor']['input']>;
  filter: RetailerNetworkScanDataWeeklySubmissionFilter;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryRetailerNetworkTobaccoManufacturerOfferPerformanceArgs = {
  after?: InputMaybe<Scalars['OCBase64Cursor']['input']>;
  before?: InputMaybe<Scalars['OCBase64Cursor']['input']>;
  filter: RetailerNetworkTobaccoManufacturerOfferPerformanceFilter;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryRetailerNetworkTobaccoProgramMetricTimeSeriesArgs = {
  filter: RetailerNetworkTobaccoProgramMetricTimeSeriesFilter;
  metricType: RetailerNetworkTobaccoProgramMetricType;
};


export type QueryRetailerNetworkTobaccoProgramMetricsOverviewArgs = {
  filter: RetailerNetworkTobaccoProgramOverviewFilter;
};


export type QueryRetailerNetworkTobaccoProgramSitesMetricArgs = {
  after?: InputMaybe<Scalars['OCBase64Cursor']['input']>;
  before?: InputMaybe<Scalars['OCBase64Cursor']['input']>;
  filter: RetailerNetworkTobaccoProgramSitesMetricFilter;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  metricType: RetailerNetworkTobaccoProgramMetricType;
  sort: RetailerNetworkTobaccoProgramSitesMetricSort;
};


export type QueryRetailerNetworkTransactionMetricsOverviewArgs = {
  filter: RetailerNetworkTransactionMetricsOverviewFilter;
};


export type QueryRetailerNetworkUserArgs = {
  uuid: Scalars['OCUUID']['input'];
};


export type QueryRetailerNetworkUsersArgs = {
  after?: InputMaybe<Scalars['OCBase64Cursor']['input']>;
  before?: InputMaybe<Scalars['OCBase64Cursor']['input']>;
  filter: RetailerNetworkUsersFilter;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryRetailerNetworkUsersForMemberArgs = {
  after?: InputMaybe<Scalars['OCBase64Cursor']['input']>;
  before?: InputMaybe<Scalars['OCBase64Cursor']['input']>;
  filter: RetailerNetworkUsersForMemberFilter;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryRetailerNetworksForMemberArgs = {
  after?: InputMaybe<Scalars['OCBase64Cursor']['input']>;
  before?: InputMaybe<Scalars['OCBase64Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  memberUuid: Scalars['OCUUID']['input'];
};


export type QueryRetailerNetworksForUserArgs = {
  after?: InputMaybe<Scalars['OCBase64Cursor']['input']>;
  before?: InputMaybe<Scalars['OCBase64Cursor']['input']>;
  filter: RetailersNetworksFilter;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryRetailerNetworksForUsersArgs = {
  after?: InputMaybe<Scalars['OCBase64Cursor']['input']>;
  before?: InputMaybe<Scalars['OCBase64Cursor']['input']>;
  filter: RetailersNetworksFilter;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  userUuidIncludes: Array<Scalars['OCUUID']['input']>;
};


export type QueryScanDataMetricsTimeSeriesArgs = {
  filter: ScanDataMetricsTimeSeriesFilter;
};


export type QueryScanDataMissingStoresDetailsArgs = {
  after?: InputMaybe<Scalars['OCBase64Cursor']['input']>;
  before?: InputMaybe<Scalars['OCBase64Cursor']['input']>;
  filter?: InputMaybe<ScanDataMissingStoresDetailsFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryScanDataMissingStoresStoreLevelDetailsArgs = {
  after?: InputMaybe<Scalars['OCBase64Cursor']['input']>;
  before?: InputMaybe<Scalars['OCBase64Cursor']['input']>;
  filter: ScanDataMissingStoresStoreLevelDetailsFilter;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryScanDataReimbursementsStoreLevelDetailsArgs = {
  after?: InputMaybe<Scalars['OCBase64Cursor']['input']>;
  before?: InputMaybe<Scalars['OCBase64Cursor']['input']>;
  filter: ScanDataReimbursementsStoreLevelDetailsFilter;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryScanDataReportedTransactionsStoreLevelDetailsArgs = {
  after?: InputMaybe<Scalars['OCBase64Cursor']['input']>;
  before?: InputMaybe<Scalars['OCBase64Cursor']['input']>;
  filter: ScanDataReportedTransactionsStoreLevelDetailsFilter;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryScanDataSubmissionHealthMetricsArgs = {
  filter: ScanDataSubmissionHealthMetricsFilter;
};


export type QueryScanDataSubmissionsArgs = {
  after?: InputMaybe<Scalars['OCBase64Cursor']['input']>;
  before?: InputMaybe<Scalars['OCBase64Cursor']['input']>;
  filter?: InputMaybe<ScanDataSubmissionFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryScanDataSubmittedTransactionsStoreLevelDetailsArgs = {
  after?: InputMaybe<Scalars['OCBase64Cursor']['input']>;
  before?: InputMaybe<Scalars['OCBase64Cursor']['input']>;
  filter: ScanDataSubmittedTransactionsStoreLevelDetailsFilter;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryScanDataWeekEndingOverviewArgs = {
  filter?: InputMaybe<ScanDataWeekEndingOverviewFilter>;
};


export type QuerySegmentUploadedFilesArgs = {
  after?: InputMaybe<Scalars['OCBase64Cursor']['input']>;
  before?: InputMaybe<Scalars['OCBase64Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  segmentUuid: Scalars['OCUUID']['input'];
};


export type QuerySegmentsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<SegmentFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


export type QuerySegmentsByMembershipUuidArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter: SegmentForMembershipFilter;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


export type QuerySiteConnectionHistoryArgs = {
  after?: InputMaybe<Scalars['OCBase64Cursor']['input']>;
  before?: InputMaybe<Scalars['OCBase64Cursor']['input']>;
  filter?: InputMaybe<SiteConnectionHistoryFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


export type QuerySiteConnectionHistorySummaryArgs = {
  filter?: InputMaybe<SiteConnectionHistorySummaryFilter>;
};


export type QuerySiteHealthArgs = {
  after?: InputMaybe<Scalars['OCBase64Cursor']['input']>;
  before?: InputMaybe<Scalars['OCBase64Cursor']['input']>;
  filter?: InputMaybe<SiteHealthFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


export type QuerySiteIssuesArgs = {
  filter: SiteIssueFilter;
};


export type QuerySiteMonitorActivityLogArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<ActivityLogFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


export type QuerySitesSummaryArgs = {
  filter?: InputMaybe<SitesSummaryFilter>;
};


export type QuerySteeringWalletArgs = {
  uuid: Scalars['OCUUID']['input'];
};


export type QuerySteeringWalletsArgs = {
  after?: InputMaybe<Scalars['OCBase64Cursor']['input']>;
  before?: InputMaybe<Scalars['OCBase64Cursor']['input']>;
  filter?: InputMaybe<SteeringWalletFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryStoredValueProgramsArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  filter?: InputMaybe<StoredValueProgramFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


export type QuerySubBrandsArgs = {
  after?: InputMaybe<Scalars['OCBase64Cursor']['input']>;
  before?: InputMaybe<Scalars['OCBase64Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


export type QuerySurveyArgs = {
  uuid: Scalars['OCUUID']['input'];
};


export type QuerySurveyAnswersArgs = {
  after?: InputMaybe<Scalars['OCBase64Cursor']['input']>;
  before?: InputMaybe<Scalars['OCBase64Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  memberUuid: Scalars['OCUUID']['input'];
};


export type QuerySurveyLocationStatisticsArgs = {
  after?: InputMaybe<Scalars['OCBase64Cursor']['input']>;
  before?: InputMaybe<Scalars['OCBase64Cursor']['input']>;
  filter?: InputMaybe<SurveyLocationStatisticsFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SurveyLocationStatisticsSort>;
};


export type QuerySurveyMetricsArgs = {
  filter?: InputMaybe<SurveyMetricsFilter>;
};


export type QuerySurveyQuestionResponseStatisticsArgs = {
  questionUuid: Scalars['OCUUID']['input'];
};


export type QuerySurveysArgs = {
  after?: InputMaybe<Scalars['OCBase64Cursor']['input']>;
  before?: InputMaybe<Scalars['OCBase64Cursor']['input']>;
  filter?: InputMaybe<SurveyFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryTransactionFraudulentInfoArgs = {
  transactionUuid: Scalars['OCUUID']['input'];
};


export type QueryTransactionsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<TransactionFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<TransactionSort>;
};


export type QueryTriggeredMessageArgs = {
  uuid: Scalars['OCUUID']['input'];
};


export type QueryTriggeredMessagesArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  filter?: InputMaybe<TriggeredMessagesFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryUsersEligibleForRetailerConnectArgs = {
  after?: InputMaybe<Scalars['OCBase64Cursor']['input']>;
  before?: InputMaybe<Scalars['OCBase64Cursor']['input']>;
  filter: UsersEligibleForRetailerConnectFilter;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryUsersLookupArgs = {
  after?: InputMaybe<Scalars['OCBase64Cursor']['input']>;
  before?: InputMaybe<Scalars['OCBase64Cursor']['input']>;
  filter?: InputMaybe<UserFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryWalletSteeringDailySnapshotsArgs = {
  filter: WalletSteeringStatisticsFilter;
};


export type QueryWalletsForMembershipArgs = {
  after?: InputMaybe<Scalars['OCBase64Cursor']['input']>;
  before?: InputMaybe<Scalars['OCBase64Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  membershipId: Scalars['OCUUID']['input'];
};

export enum Random_Award_Type {
  NoAward = 'NO_AWARD',
  Points = 'POINTS',
  TryAgain = 'TRY_AGAIN',
  Vouchers = 'VOUCHERS'
}

export enum Resource_Item_Type {
  CarWash = 'CAR_WASH',
  Fuel = 'FUEL',
  Lottery = 'LOTTERY',
  MiscConvenience = 'MISC_CONVENIENCE',
  Snack = 'SNACK',
  Tax = 'TAX',
  Tobacco = 'TOBACCO'
}

export enum Restriction_Verification_Source {
  AvtTransaction = 'AVT_TRANSACTION',
  LexisNexis = 'LEXIS_NEXIS',
  TobaccoTransaction = 'TOBACCO_TRANSACTION'
}

export enum Retailer_Network_Operator {
  InAll = 'IN_ALL',
  InAny = 'IN_ANY',
  NotInAll = 'NOT_IN_ALL',
  NotInAny = 'NOT_IN_ANY'
}

export enum Retailer_Network_Performance_Period {
  Last_7Days = 'LAST_7_DAYS',
  Last_30Days = 'LAST_30_DAYS',
  Last_90Days = 'LAST_90_DAYS',
  LastMonth = 'LAST_MONTH',
  ThisMonth = 'THIS_MONTH'
}

export enum Retailer_Network_Performance_Sort_By {
  TotalNewMembers = 'TOTAL_NEW_MEMBERS',
  TotalTransactions = 'TOTAL_TRANSACTIONS'
}

export enum Retailer_Network_Performance_Sort_Order {
  Asc = 'ASC',
  Desc = 'DESC'
}

export enum Retailer_Network_Tobacco_Program_Sites_Metric_Sort_By {
  Value = 'VALUE'
}

export enum Retailer_Network_Users_Sort_By {
  Role = 'ROLE'
}

export enum Retailer_Network_Users_Sort_Order {
  Asc = 'ASC',
  Desc = 'DESC'
}

export enum Retailer_Network_User_Role {
  RetailerNetworkAdmin = 'RETAILER_NETWORK_ADMIN',
  RetailerNetworkUser = 'RETAILER_NETWORK_USER',
  SiteAdmin = 'SITE_ADMIN',
  SiteUser = 'SITE_USER'
}

export enum Retailer_Network_User_Type {
  FrontLineEmployee = 'FRONT_LINE_EMPLOYEE',
  Manager = 'MANAGER'
}

export enum Retailer_Network_User_Type_Operator {
  Is = 'IS',
  IsNot = 'IS_NOT'
}

export type RandomAwardConfig = {
  __typename: 'RandomAwardConfig';
  award?: Maybe<AwardPointsOrVouchers>;
  awardType: Random_Award_Type;
  limit: Scalars['Int']['output'];
  sequenceNumber: Scalars['Int']['output'];
};

export type RandomAwardConfigInput = {
  awardPoints?: InputMaybe<AwardPointsInput>;
  awardType: Random_Award_Type;
  awardVouchers?: InputMaybe<AwardVouchersInput>;
  limit: Scalars['Int']['input'];
  sequenceNumber: Scalars['Int']['input'];
};

export type ReceiptContent = {
  __typename: 'ReceiptContent';
  longDescription?: Maybe<Scalars['String']['output']>;
  shortDescription?: Maybe<Scalars['String']['output']>;
};

export type ReceiptContentInput = {
  longDescription?: InputMaybe<Scalars['String']['input']>;
  shortDescription?: InputMaybe<Scalars['String']['input']>;
};

export type ReceiptLine = {
  __typename: 'ReceiptLine';
  lineNumber?: Maybe<Scalars['Int']['output']>;
  value?: Maybe<Scalars['String']['output']>;
};

export type ReceiverConfiguration = {
  __typename: 'ReceiverConfiguration';
  award?: Maybe<AwardPointsOrVouchers>;
  /** @deprecated Replaced by receiverInstructions in ReferralProgramMarketingContent (use the entry with subBrandUuid: null for the default). */
  instructions: Scalars['String']['output'];
};

export type ReceiverConfigurationInput = {
  awardPoints?: InputMaybe<AwardPointsInput>;
  awardVouchers?: InputMaybe<AwardVouchersInput>;
  /** @deprecated Replaced by receiverInstructions in ReferralProgramMarketingContentInput. */
  instructions?: InputMaybe<Scalars['String']['input']>;
};

export enum ReceiverStatus {
  CodeNotRecognized = 'CODE_NOT_RECOGNIZED',
  Completed = 'COMPLETED',
  PendingQualifiedEvent = 'PENDING_QUALIFIED_EVENT'
}

export type RecordPushNotificationEventsInput = {
  customerUuid: Scalars['ID']['input'];
  events: Array<PushNotificationEventInput>;
};

export type RecordPushNotificationEventsPayload = {
  __typename: 'RecordPushNotificationEventsPayload';
  failureCount: Scalars['Int']['output'];
  successCount: Scalars['Int']['output'];
};

export type RedeemPromocodeInput = {
  customerUuid: Scalars['ID']['input'];
  promocode: Scalars['String']['input'];
};

export type RedeemPromocodeResult = RedeemPromocodeResultFail | RedeemPromocodeResultSuccess;

export type RedeemPromocodeResultFail = {
  __typename: 'RedeemPromocodeResultFail';
  membershipId: Scalars['ID']['output'];
  reason?: Maybe<Scalars['String']['output']>;
};

export type RedeemPromocodeResultSuccess = {
  __typename: 'RedeemPromocodeResultSuccess';
  award?: Maybe<AwardPointsOrVouchers>;
  membershipId: Scalars['ID']['output'];
  promocode: Promocode;
};

export type Referral = {
  __typename: 'Referral';
  createdAt: Scalars['OCDateTime']['output'];
  receiver: Membership;
  receiverAwardGrantedDate?: Maybe<Scalars['OCDate']['output']>;
  receiverId: Scalars['ID']['output'];
  referralFulfillmentSource?: Maybe<ReferralFulfillmentSource>;
  referralFulfillmentSourceId?: Maybe<Scalars['ID']['output']>;
  senderAwardGrantedDate?: Maybe<Scalars['OCDate']['output']>;
  status: ReferralStatus;
};

export type ReferralCodeSharedEvent = {
  __typename: 'ReferralCodeSharedEvent';
  createdAt: Scalars['OCDateTime']['output'];
  id: Scalars['ID']['output'];
};

export type ReferralConnection = {
  __typename: 'ReferralConnection';
  edges?: Maybe<Array<ReferralEdge>>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type ReferralEdge = {
  __typename: 'ReferralEdge';
  cursor: Scalars['ID']['output'];
  node: Referral;
};

export type ReferralFilter = {
  search?: InputMaybe<Scalars['String']['input']>;
};

export enum ReferralFulfillmentSource {
  LoyaltyEvent = 'LOYALTY_EVENT',
  Transaction = 'TRANSACTION'
}

export type ReferralMetricCountsTimeSeriesValues = {
  __typename: 'ReferralMetricCountsTimeSeriesValues';
  date: Scalars['OCDate']['output'];
  newMembersReferredCount: Scalars['Float']['output'];
  uniqueCodesSharedCount: Scalars['Float']['output'];
};

export type ReferralProgramConfiguration = {
  __typename: 'ReferralProgramConfiguration';
  marketingContents: Array<ReferralProgramMarketingContent>;
  qualifiedEvent: QualifiedEvent;
  receiverConfiguration: ReceiverConfiguration;
  referralCodeManualEntryEnabled: Scalars['Boolean']['output'];
  referralProgramEnabled: Scalars['Boolean']['output'];
  senderConfiguration: SenderConfiguration;
};

export type ReferralProgramConfigurationInput = {
  chainId: Scalars['ID']['input'];
  marketingContents?: InputMaybe<Array<ReferralProgramMarketingContentInput>>;
  qualifiedEvent: QualifiedEventInput;
  receiverConfiguration: ReceiverConfigurationInput;
  senderConfiguration: SenderConfigurationInput;
};

export type ReferralProgramMarketingContent = {
  __typename: 'ReferralProgramMarketingContent';
  receiverInstructions: Scalars['String']['output'];
  senderInstructions: Scalars['String']['output'];
  smsTemplate: Scalars['String']['output'];
  subBrandUuid?: Maybe<Scalars['ID']['output']>;
};

export type ReferralProgramMarketingContentInput = {
  receiverInstructions: Scalars['String']['input'];
  senderInstructions: Scalars['String']['input'];
  smsTemplate: Scalars['String']['input'];
  subBrandUuid?: InputMaybe<Scalars['ID']['input']>;
};

export type ReferralProgramStatistics = {
  __typename: 'ReferralProgramStatistics';
  completedReferrals: Scalars['Float']['output'];
  newMembersPerReferral: Scalars['Float']['output'];
  newMembersReferred: Scalars['Float']['output'];
  receiverAwardGranted: Scalars['Float']['output'];
  receiverAwardRedeemed: Scalars['Float']['output'];
  receiverPointsGranted: Scalars['Float']['output'];
  senderAwardGranted: Scalars['Float']['output'];
  senderAwardRedeemed: Scalars['Float']['output'];
  senderPointsGranted: Scalars['Float']['output'];
  timeSeries: Array<ReferralMetricCountsTimeSeriesValues>;
  uniqueCodesShared: Scalars['Float']['output'];
};

export type ReferralProgramStatisticsFilter = {
  chainIdEquals: Scalars['ID']['input'];
};

export enum ReferralStatus {
  Completed = 'COMPLETED',
  Pending = 'PENDING'
}

export type Reimbursements = {
  __typename: 'Reimbursements';
  loyalty: Scalars['Int']['output'];
  multiUnit: Scalars['Int']['output'];
};

export type ReimbursementsTimeSeriesDataPoint = {
  __typename: 'ReimbursementsTimeSeriesDataPoint';
  date: Scalars['OCDate']['output'];
  value: Reimbursements;
};

export type RelativeMonthsBack = {
  __typename: 'RelativeMonthsBack';
  relativeMonthsBack: Scalars['Int']['output'];
};

export type RelativeMonthsBackInput = {
  relativeMonthsBack: Scalars['Int']['input'];
};

export type RemoveLocationsFromGroupInput = {
  locationGroupUuid: Scalars['ID']['input'];
  locationUuids: Array<Scalars['ID']['input']>;
};

export type ReportAudienceStartGenerationJobInput = {
  audienceUuid: Scalars['ID']['input'];
  reportType: ReportType;
  userEmails: Array<Scalars['OCEmailAddress']['input']>;
};

export type ReportGenerationJob = {
  __typename: 'ReportGenerationJob';
  status: ReportStatus;
  uuid: Scalars['ID']['output'];
};

export enum ReportStatus {
  Failed = 'FAILED',
  Pending = 'PENDING',
  Success = 'SUCCESS'
}

export enum ReportType {
  AudienceSnapshotWithoutPii = 'AUDIENCE_SNAPSHOT_WITHOUT_PII',
  AudienceSnapshotWithPii = 'AUDIENCE_SNAPSHOT_WITH_PII'
}

export type ResourceItem = CarWashItem | FuelItem | StoreItem;

export type ResourceItemFilter = {
  descriptionContains?: InputMaybe<Scalars['String']['input']>;
  descriptionEquals?: InputMaybe<Scalars['String']['input']>;
  itemTypeContains?: InputMaybe<Array<InputMaybe<Resource_Item_Type>>>;
  itemTypeEquals?: InputMaybe<Resource_Item_Type>;
  merchandiseCodeContains?: InputMaybe<Scalars['String']['input']>;
  merchandiseCodeEquals?: InputMaybe<Scalars['String']['input']>;
  posCodeContains?: InputMaybe<Scalars['String']['input']>;
  posCodeEquals?: InputMaybe<Scalars['String']['input']>;
  posCodeFormatContains?: InputMaybe<Scalars['String']['input']>;
  posCodeFormatEquals?: InputMaybe<Scalars['String']['input']>;
  posCodeModifierContains?: InputMaybe<Scalars['String']['input']>;
  posCodeModifierEquals?: InputMaybe<Scalars['String']['input']>;
  receiptDescriptionContains?: InputMaybe<Scalars['String']['input']>;
  receiptDescriptionEquals?: InputMaybe<Scalars['String']['input']>;
  skuContains?: InputMaybe<Scalars['String']['input']>;
  skuEquals?: InputMaybe<Scalars['String']['input']>;
  unitOfMeasureContains?: InputMaybe<Scalars['String']['input']>;
  unitOfMeasureEquals?: InputMaybe<Scalars['String']['input']>;
  unitPriceEquals?: InputMaybe<Scalars['Float']['input']>;
  unitPriceMax?: InputMaybe<Scalars['Float']['input']>;
  unitPriceMin?: InputMaybe<Scalars['Float']['input']>;
  uuid?: InputMaybe<Scalars['ID']['input']>;
};

export type RetailerConnectRedesignV2 = FeatureConfiguration & {
  __typename: 'RetailerConnectRedesignV2';
  enabled: Scalars['Boolean']['output'];
};

export type RetailerConnectTobaccoPerformance = FeatureConfiguration & {
  __typename: 'RetailerConnectTobaccoPerformance';
  enabled: Scalars['Boolean']['output'];
};

export type RetailerNetwork = {
  __typename: 'RetailerNetwork';
  address: Address;
  adminName: Scalars['String']['output'];
  brandUuid?: Maybe<Scalars['OCUUID']['output']>;
  customerId: Scalars['String']['output'];
  displayName: Scalars['String']['output'];
  emailAddress: Scalars['OCEmailAddress']['output'];
  monthlyPerformanceGoal: RetailerNetworkMonthlyPerformanceGoal;
  name: Scalars['String']['output'];
  numberOfLocationGroups: Scalars['Int']['output'];
  numberOfLocations: Scalars['Int']['output'];
  phoneNumber: Scalars['OCPhoneNumber']['output'];
  uuid: Scalars['OCUUID']['output'];
};

export type RetailerNetworkCpgManufacturerProgramsFilter = {
  dateFrom: Scalars['OCDate']['input'];
  dateTo: Scalars['OCDate']['input'];
  retailerNetworkUuidEquals: Scalars['OCUUID']['input'];
};

export type RetailerNetworkConnection = {
  __typename: 'RetailerNetworkConnection';
  edges?: Maybe<Array<RetailerNetworkEdge>>;
  pageInfo: PageInfo;
};

export type RetailerNetworkCreate = {
  address: AddressInput;
  adminName: Scalars['String']['input'];
  brandUuid?: InputMaybe<Scalars['OCUUID']['input']>;
  customerId: Scalars['String']['input'];
  displayName: Scalars['String']['input'];
  emailAddress: Scalars['OCEmailAddress']['input'];
  /** @deprecated Adding Location Groups this way isn't supported */
  locationGroupUuids?: InputMaybe<Array<Scalars['OCUUID']['input']>>;
  locationUuids?: InputMaybe<Array<Scalars['OCUUID']['input']>>;
  monthlyPerformanceGoal: RetailerNetworkMonthlyPerformanceGoalCreate;
  name: Scalars['String']['input'];
  phoneNumber: Scalars['OCPhoneNumber']['input'];
  retailerNetworkUsers?: InputMaybe<Array<RetailerNetworkUserCreate>>;
};

export type RetailerNetworkCustomer = {
  __typename: 'RetailerNetworkCustomer';
  id: Scalars['ID']['output'];
  name?: Maybe<Scalars['String']['output']>;
  uuid: Scalars['OCUUID']['output'];
};

export type RetailerNetworkCustomerConnection = {
  __typename: 'RetailerNetworkCustomerConnection';
  edges?: Maybe<Array<RetailerNetworkCustomerEdge>>;
  pageInfo: PageInfo;
};

export type RetailerNetworkCustomerEdge = {
  __typename: 'RetailerNetworkCustomerEdge';
  cursor: Scalars['OCBase64Cursor']['output'];
  node: RetailerNetworkCustomer;
};

export type RetailerNetworkCustomerFilter = {
  customerIdEquals?: InputMaybe<Scalars['String']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
};

export type RetailerNetworkEdge = {
  __typename: 'RetailerNetworkEdge';
  cursor: Scalars['OCBase64Cursor']['output'];
  node: RetailerNetwork;
};

export type RetailerNetworkForMember = {
  __typename: 'RetailerNetworkForMember';
  locationsCount: Scalars['Int']['output'];
  name?: Maybe<Scalars['String']['output']>;
  roles?: Maybe<Array<Retailer_Network_User_Role>>;
  uuid: Scalars['OCUUID']['output'];
};

export type RetailerNetworkForMemberEdge = {
  __typename: 'RetailerNetworkForMemberEdge';
  cursor: Scalars['OCBase64Cursor']['output'];
  node: RetailerNetworkForMember;
};

export type RetailerNetworkLocation = {
  __typename: 'RetailerNetworkLocation';
  brandingDetails?: Maybe<LocationBrandingDetails>;
  isOnline?: Maybe<Scalars['Boolean']['output']>;
  location: Location;
  monthlyPerformanceGoal?: Maybe<RetailerNetworkMonthlyPerformanceGoal>;
  retailerNetworkUuid: Scalars['OCUUID']['output'];
  userAssociationInheritedFromLocationGroup?: Maybe<Scalars['OCUUID']['output']>;
  uuid: Scalars['OCUUID']['output'];
};

export type RetailerNetworkLocationCitiesFilter = {
  retailerNetworkUuidEquals: Scalars['OCUUID']['input'];
  stateEquals: Scalars['String']['input'];
};

export type RetailerNetworkLocationConnection = {
  __typename: 'RetailerNetworkLocationConnection';
  edges?: Maybe<Array<RetailerNetworkLocationEdge>>;
  pageInfo: PageInfo;
};

export enum RetailerNetworkLocationConnectionStatus {
  Offline = 'OFFLINE',
  Online = 'ONLINE'
}

export type RetailerNetworkLocationCoordinates = {
  __typename: 'RetailerNetworkLocationCoordinates';
  geoLocation: GeoLocation;
  locationName?: Maybe<Scalars['String']['output']>;
  locationUuid: Scalars['OCUUID']['output'];
};

export type RetailerNetworkLocationCoordinatesConnection = {
  __typename: 'RetailerNetworkLocationCoordinatesConnection';
  edges?: Maybe<Array<RetailerNetworkLocationCoordinatesEdge>>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type RetailerNetworkLocationCoordinatesEdge = {
  __typename: 'RetailerNetworkLocationCoordinatesEdge';
  cursor: Scalars['OCBase64Cursor']['output'];
  node: RetailerNetworkLocationCoordinates;
};

export type RetailerNetworkLocationCoordinatesFilter = {
  cityEquals?: InputMaybe<Scalars['String']['input']>;
  retailerNetworkLocationGroupUuidIn?: InputMaybe<Array<Scalars['OCUUID']['input']>>;
  retailerNetworkLocationUuidIn?: InputMaybe<Array<Scalars['OCUUID']['input']>>;
  retailerNetworkUuidEquals: Scalars['OCUUID']['input'];
  search?: InputMaybe<Scalars['String']['input']>;
  stateEquals?: InputMaybe<Scalars['String']['input']>;
};

export type RetailerNetworkLocationDowntimeMetricsFilter = {
  dateRange?: InputMaybe<DateRangeInput>;
  locationGroups?: InputMaybe<Array<Scalars['String']['input']>>;
  locations?: InputMaybe<Array<Scalars['String']['input']>>;
  retailerNetworkUuidEquals: Scalars['OCUUID']['input'];
  timezone: Scalars['String']['input'];
};

export type RetailerNetworkLocationDowntimeMetricsOverview = {
  __typename: 'RetailerNetworkLocationDowntimeMetricsOverview';
  disconnectedStoresTimeSeriesOfLast30Days?: Maybe<Array<TimeSeriesMetric>>;
  numberOfConnectedStores: Scalars['Int']['output'];
  numberOfStores: Scalars['Int']['output'];
};

export type RetailerNetworkLocationDowntimeMetricsOverviewFilter = {
  retailerNetworkLocationGroupUuidIn?: InputMaybe<Array<Scalars['OCUUID']['input']>>;
  retailerNetworkLocationUuidIn?: InputMaybe<Array<Scalars['OCUUID']['input']>>;
  retailerNetworkUuidEquals: Scalars['OCUUID']['input'];
  timezone: Scalars['String']['input'];
};

export type RetailerNetworkLocationEdge = {
  __typename: 'RetailerNetworkLocationEdge';
  cursor: Scalars['ID']['output'];
  node: RetailerNetworkLocation;
};

export type RetailerNetworkLocationFilter = {
  cityEquals?: InputMaybe<Scalars['String']['input']>;
  connectionStatusEquals?: InputMaybe<RetailerNetworkLocationConnectionStatus>;
  hasScanDataIdsFilled?: InputMaybe<Scalars['Boolean']['input']>;
  openCommerceUserUuidEquals?: InputMaybe<Scalars['OCUUID']['input']>;
  retailerNetworkLocationGroupUuidContains?: InputMaybe<Array<Scalars['OCUUID']['input']>>;
  retailerNetworkLocationGroupUuidNotIn?: InputMaybe<Array<Scalars['OCUUID']['input']>>;
  retailerNetworkLocationUuidEquals?: InputMaybe<Scalars['OCUUID']['input']>;
  retailerNetworkUserUuidEquals?: InputMaybe<Scalars['OCUUID']['input']>;
  retailerNetworkUuidEquals: Scalars['OCUUID']['input'];
  search?: InputMaybe<Scalars['String']['input']>;
  stateEquals?: InputMaybe<Scalars['String']['input']>;
};

export type RetailerNetworkLocationForMember = {
  __typename: 'RetailerNetworkLocationForMember';
  retailerNetworkUuid: Scalars['OCUUID']['output'];
  role?: Maybe<Retailer_Network_User_Role>;
  siteId: Scalars['String']['output'];
  siteName: Scalars['String']['output'];
  userAssociationInheritedFromLocationGroup?: Maybe<Scalars['OCUUID']['output']>;
  uuid: Scalars['OCUUID']['output'];
};

export type RetailerNetworkLocationForMemberConnection = {
  __typename: 'RetailerNetworkLocationForMemberConnection';
  edges: Array<RetailerNetworkLocationForMemberEdge>;
  pageInfo: PageInfo;
};

export type RetailerNetworkLocationForMemberEdge = {
  __typename: 'RetailerNetworkLocationForMemberEdge';
  cursor: Scalars['OCBase64Cursor']['output'];
  node: RetailerNetworkLocationForMember;
};

export type RetailerNetworkLocationGroup = {
  __typename: 'RetailerNetworkLocationGroup';
  countOfLocations: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  retailerNetworkUuid: Scalars['OCUUID']['output'];
  roles?: Maybe<Array<Retailer_Network_User_Role>>;
  uuid: Scalars['OCUUID']['output'];
};

export type RetailerNetworkLocationGroupConnection = {
  __typename: 'RetailerNetworkLocationGroupConnection';
  edges: Array<RetailerNetworkLocationGroupEdge>;
  pageInfo: PageInfo;
};

export type RetailerNetworkLocationGroupEdge = {
  __typename: 'RetailerNetworkLocationGroupEdge';
  cursor: Scalars['OCBase64Cursor']['output'];
  node: RetailerNetworkLocationGroup;
};

export type RetailerNetworkLocationGroupFilter = {
  openCommerceUserUuidEquals?: InputMaybe<Scalars['OCUUID']['input']>;
  retailerNetworkLocationGroupUuidEquals?: InputMaybe<Scalars['OCUUID']['input']>;
  retailerNetworkLocationUuidEquals?: InputMaybe<Scalars['OCUUID']['input']>;
  retailerNetworkUserUuidEquals?: InputMaybe<Scalars['OCUUID']['input']>;
  retailerNetworkUuidEquals: Scalars['OCUUID']['input'];
  search?: InputMaybe<Scalars['String']['input']>;
};

export type RetailerNetworkLocationGroupForMember = {
  __typename: 'RetailerNetworkLocationGroupForMember';
  countOfLocations: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  retailerNetworkUuid: Scalars['OCUUID']['output'];
  roles?: Maybe<Array<Retailer_Network_User_Role>>;
  uuid: Scalars['OCUUID']['output'];
};

export type RetailerNetworkLocationGroupForMemberConnection = {
  __typename: 'RetailerNetworkLocationGroupForMemberConnection';
  edges: Array<RetailerNetworkLocationGroupForMemberEdge>;
  pageInfo: PageInfo;
};

export type RetailerNetworkLocationGroupForMemberEdge = {
  __typename: 'RetailerNetworkLocationGroupForMemberEdge';
  cursor: Scalars['OCBase64Cursor']['output'];
  node: RetailerNetworkLocationGroupForMember;
};

export type RetailerNetworkLocationGroupUpdateInput = {
  name: Scalars['String']['input'];
  uuid: Scalars['OCUUID']['input'];
};

export type RetailerNetworkLocationGroupWithPerformanceExcerpt = {
  __typename: 'RetailerNetworkLocationGroupWithPerformanceExcerpt';
  locationGroupUuid: Scalars['OCUUID']['output'];
  name: Scalars['String']['output'];
  newMembers: GoalProgress;
  numberOfLocations: Scalars['Int']['output'];
  transactions: GoalProgress;
  uuid: Scalars['OCUUID']['output'];
};

export type RetailerNetworkLocationGroupsWithPerformanceExcerptConnection = {
  __typename: 'RetailerNetworkLocationGroupsWithPerformanceExcerptConnection';
  edges?: Maybe<Array<RetailerNetworkLocationGroupsWithPerformanceExcerptEdge>>;
  pageInfo: PageInfo;
};

export type RetailerNetworkLocationGroupsWithPerformanceExcerptEdge = {
  __typename: 'RetailerNetworkLocationGroupsWithPerformanceExcerptEdge';
  cursor: Scalars['OCBase64Cursor']['output'];
  node: RetailerNetworkLocationGroupWithPerformanceExcerpt;
};

export type RetailerNetworkLocationGroupsWithPerformanceExcerptFilter = {
  locationGroupUuidEquals?: InputMaybe<Scalars['OCUUID']['input']>;
  periodEquals: Retailer_Network_Performance_Period;
  retailerNetworkUuidEquals: Scalars['OCUUID']['input'];
  search?: InputMaybe<Scalars['String']['input']>;
};

export type RetailerNetworkLocationPosConnectionStatus = {
  __typename: 'RetailerNetworkLocationPosConnectionStatus';
  hardwareVendor?: Maybe<Hardware_Vendor>;
  identifier?: Maybe<Scalars['String']['output']>;
  loyaltyConnectedAt?: Maybe<Scalars['OCDateTime']['output']>;
  loyaltyEnabled?: Maybe<Scalars['Boolean']['output']>;
  mobileConnectedAt?: Maybe<Scalars['OCDateTime']['output']>;
  mobileEnabled?: Maybe<Scalars['Boolean']['output']>;
  scanDataSubmittedAt?: Maybe<Scalars['OCDateTime']['output']>;
};

export type RetailerNetworkLocationPosConnectionStatusFilter = {
  locationUuidEquals: Scalars['OCUUID']['input'];
  retailerNetworkUuidEquals: Scalars['OCUUID']['input'];
};

export type RetailerNetworkLocationStatesFilter = {
  retailerNetworkUuidEquals: Scalars['OCUUID']['input'];
};

export type RetailerNetworkLocationWithPerformanceExcerpt = {
  __typename: 'RetailerNetworkLocationWithPerformanceExcerpt';
  isSpecificGoal?: Maybe<Scalars['Boolean']['output']>;
  locationUuid: Scalars['OCUUID']['output'];
  name: Scalars['String']['output'];
  newMembers: GoalProgress;
  siteId: Scalars['ID']['output'];
  transactions: GoalProgress;
  uuid: Scalars['OCUUID']['output'];
};

export type RetailerNetworkLocationsWithPerformanceExcerptConnection = {
  __typename: 'RetailerNetworkLocationsWithPerformanceExcerptConnection';
  edges?: Maybe<Array<RetailerNetworkLocationsWithPerformanceExcerptEdge>>;
  pageInfo: PageInfo;
};

export type RetailerNetworkLocationsWithPerformanceExcerptEdge = {
  __typename: 'RetailerNetworkLocationsWithPerformanceExcerptEdge';
  cursor: Scalars['OCBase64Cursor']['output'];
  node: RetailerNetworkLocationWithPerformanceExcerpt;
};

export type RetailerNetworkLocationsWithPerformanceExcerptFilter = {
  locationGroupUuidEquals?: InputMaybe<Scalars['OCUUID']['input']>;
  locationUuidEquals?: InputMaybe<Scalars['OCUUID']['input']>;
  periodEquals: Retailer_Network_Performance_Period;
  retailerNetworkUuidEquals: Scalars['OCUUID']['input'];
  search?: InputMaybe<Scalars['String']['input']>;
};

export type RetailerNetworkLoyaltyMetricsByPeriod = {
  __typename: 'RetailerNetworkLoyaltyMetricsByPeriod';
  avgFuelSalesPerTransaction: Scalars['Float']['output'];
  avgSavingPerTransaction: Scalars['Int']['output'];
  avgUnitsSalesPerStore: Scalars['Int']['output'];
  avgUnitsSold: Scalars['Float']['output'];
  avgValuePerTransaction: Scalars['Int']['output'];
  numberOfTransactions: Scalars['Int']['output'];
  offerEngagementRate: Scalars['Int']['output'];
  totalFuelSales: Scalars['Float']['output'];
  totalUnitsSales: Scalars['Float']['output'];
  unitsSold: Scalars['Float']['output'];
};

export type RetailerNetworkLoyaltyMetricsFilter = {
  dateRange?: InputMaybe<DateRangeInput>;
  locationGroups?: InputMaybe<Array<Scalars['String']['input']>>;
  locations?: InputMaybe<Array<Scalars['String']['input']>>;
  retailerNetworkUuidEquals: Scalars['OCUUID']['input'];
  timezone: Scalars['String']['input'];
};

export type RetailerNetworkLoyaltyMetricsOverview = {
  __typename: 'RetailerNetworkLoyaltyMetricsOverview';
  actualPeriodPerformance: RetailerNetworkLoyaltyMetricsByPeriod;
  loyaltyTransactionsTimeSeries?: Maybe<Array<TimeSeriesMetric>>;
  prevPeriodPerformance: RetailerNetworkLoyaltyMetricsByPeriod;
};

export type RetailerNetworkMonthlyPerformanceGoal = {
  __typename: 'RetailerNetworkMonthlyPerformanceGoal';
  membersPerStore: Scalars['Int']['output'];
  transactionsPerStore: Scalars['Int']['output'];
};

export type RetailerNetworkMonthlyPerformanceGoalCreate = {
  membersPerStore: Scalars['Int']['input'];
  transactionsPerStore: Scalars['Int']['input'];
};

export type RetailerNetworkMonthlyPerformanceGoalUpdate = {
  membersPerStore: Scalars['Int']['input'];
  transactionsPerStore: Scalars['Int']['input'];
};

export type RetailerNetworkOfferMetricsOverviewConnection = {
  __typename: 'RetailerNetworkOfferMetricsOverviewConnection';
  edges: Array<RetailerNetworkOfferMetricsOverviewEdge>;
  pageInfo: PageInfo;
};

export type RetailerNetworkOfferMetricsOverviewEdge = {
  __typename: 'RetailerNetworkOfferMetricsOverviewEdge';
  cursor: Scalars['OCBase64Cursor']['output'];
  node: RetailerNetworkOfferMetricsOverviewNode;
};

export type RetailerNetworkOfferMetricsOverviewFilter = {
  locationGroups?: InputMaybe<Array<Scalars['OCUUID']['input']>>;
  locations?: InputMaybe<Array<Scalars['OCUUID']['input']>>;
  retailerNetworkUuidEquals: Scalars['OCUUID']['input'];
  timezone: Scalars['String']['input'];
};

export type RetailerNetworkOfferMetricsOverviewNode = {
  __typename: 'RetailerNetworkOfferMetricsOverviewNode';
  averageRedemptionsPerStore: Scalars['Int']['output'];
  offerName: Scalars['String']['output'];
  offerUuid: Scalars['OCUUID']['output'];
  prevPeriodRedemptions: Scalars['Int']['output'];
  redemptions: Scalars['Int']['output'];
  uuid: Scalars['OCUUID']['output'];
};

export type RetailerNetworkOfferMetricsOverviewSort = {
  direction: SortOrder;
  field: RetailerNetworkOfferMetricsOverviewSortBy;
};

export enum RetailerNetworkOfferMetricsOverviewSortBy {
  Redemptions = 'REDEMPTIONS'
}

export type RetailerNetworkPerformance = {
  __typename: 'RetailerNetworkPerformance';
  homeStoreMembers: Scalars['Int']['output'];
  lastUpdated?: Maybe<Scalars['OCDateTime']['output']>;
  loyaltyTransactions: LoyaltyTransactions;
  loyaltyTransactionsBreakdown: LoyaltyTransactionsBreakdown;
  newMembers: NewMembers;
};

export type RetailerNetworkPerformanceFilter = {
  locationGroupUuidEquals?: InputMaybe<Scalars['OCUUID']['input']>;
  locationUuidEquals?: InputMaybe<Scalars['OCUUID']['input']>;
  periodEquals: Retailer_Network_Performance_Period;
  retailerNetworkUuidEquals: Scalars['OCUUID']['input'];
};

export type RetailerNetworkPerformanceSort = {
  direction: Retailer_Network_Performance_Sort_Order;
  field: Retailer_Network_Performance_Sort_By;
};

export type RetailerNetworkScanDataTobaccoSiteSubmissionConnection = {
  __typename: 'RetailerNetworkScanDataTobaccoSiteSubmissionConnection';
  edges?: Maybe<Array<RetailerNetworkScanDataTobaccoSubmissionEdge>>;
  pageInfo: PageInfo;
};

export type RetailerNetworkScanDataTobaccoSiteSubmissionFilter = {
  retailerNetworkUuidEquals: Scalars['OCUUID']['input'];
  search?: InputMaybe<Scalars['String']['input']>;
  submittedAtEquals: Scalars['OCDate']['input'];
};

export type RetailerNetworkScanDataTobaccoSubmission = {
  __typename: 'RetailerNetworkScanDataTobaccoSubmission';
  estimatedReimbursements: Reimbursements;
  previousEstimatedReimbursements: Reimbursements;
  previousTotalLoyaltyTransactions: Scalars['Int']['output'];
  previousTotalMultiUnitTransactions: Scalars['Int']['output'];
  siteId: Scalars['String']['output'];
  siteName: Scalars['String']['output'];
  submissions: Array<ScanDataSubmission>;
  submittedAt: Scalars['OCDate']['output'];
  totalLoyaltyTransactions: Scalars['Int']['output'];
  totalMultiUnitTransactions: Scalars['Int']['output'];
};

export type RetailerNetworkScanDataTobaccoSubmissionEdge = {
  __typename: 'RetailerNetworkScanDataTobaccoSubmissionEdge';
  cursor: Scalars['OCBase64Cursor']['output'];
  node: RetailerNetworkScanDataTobaccoSubmission;
};

export type RetailerNetworkScanDataTobaccoSubmissionFilter = {
  retailerNetworkUuidEquals: Scalars['OCUUID']['input'];
  search?: InputMaybe<Scalars['String']['input']>;
  submittedAtFromEquals?: InputMaybe<Scalars['OCDate']['input']>;
  submittedAtToEquals?: InputMaybe<Scalars['OCDate']['input']>;
};

export type RetailerNetworkScanDataTobaccoSubmissionsOverview = {
  __typename: 'RetailerNetworkScanDataTobaccoSubmissionsOverview';
  estimatedReimbursements: Reimbursements;
  estimatedReimbursementsTimeSeries: Array<Maybe<ReimbursementsTimeSeriesDataPoint>>;
  previousEstimatedReimbursements: Reimbursements;
  totalSites: Scalars['Int']['output'];
  totalSitesSubmitted: Scalars['Int']['output'];
};

export type RetailerNetworkScanDataTobaccoSubmissionsOverviewFilter = {
  retailerNetworkUuidEquals: Scalars['OCUUID']['input'];
};

export type RetailerNetworkScanDataWeeklySubmission = {
  __typename: 'RetailerNetworkScanDataWeeklySubmission';
  estimatedReimbursements: Reimbursements;
  previousEstimatedReimbursements: Reimbursements;
  status: ScanDataWeeklySubmissionStatus;
  submissions: Array<ScanDataSubmission>;
  submittedAt: Scalars['OCDate']['output'];
  totalLoyaltyTransactions: Scalars['Int']['output'];
  totalMultiUnitTransactions: Scalars['Int']['output'];
  totalSitesSubmitted: Scalars['Int']['output'];
};

export type RetailerNetworkScanDataWeeklySubmissionConnection = {
  __typename: 'RetailerNetworkScanDataWeeklySubmissionConnection';
  edges?: Maybe<Array<RetailerNetworkScanDataWeeklySubmissionEdge>>;
  pageInfo: PageInfo;
};

export type RetailerNetworkScanDataWeeklySubmissionEdge = {
  __typename: 'RetailerNetworkScanDataWeeklySubmissionEdge';
  cursor: Scalars['ID']['output'];
  node: RetailerNetworkScanDataWeeklySubmission;
};

export type RetailerNetworkScanDataWeeklySubmissionFilter = {
  retailerNetworkUuidEquals: Scalars['OCUUID']['input'];
  submittedAtFromEquals?: InputMaybe<Scalars['OCDate']['input']>;
  submittedAtToEquals?: InputMaybe<Scalars['OCDate']['input']>;
};

export type RetailerNetworkTobaccoManufacturerOfferPerformance = {
  __typename: 'RetailerNetworkTobaccoManufacturerOfferPerformance';
  estimatedReimbursements: Reimbursements;
  offerName: Scalars['String']['output'];
  previousEstimatedReimbursements: Reimbursements;
  redemptions: Scalars['Float']['output'];
  totalStores: Scalars['Int']['output'];
};

export type RetailerNetworkTobaccoManufacturerOfferPerformanceConnection = {
  __typename: 'RetailerNetworkTobaccoManufacturerOfferPerformanceConnection';
  edges: Array<RetailerNetworkTobaccoManufacturerOfferPerformanceEdge>;
  pageInfo: PageInfo;
};

export type RetailerNetworkTobaccoManufacturerOfferPerformanceEdge = {
  __typename: 'RetailerNetworkTobaccoManufacturerOfferPerformanceEdge';
  cursor: Scalars['ID']['output'];
  node: RetailerNetworkTobaccoManufacturerOfferPerformance;
};

export type RetailerNetworkTobaccoManufacturerOfferPerformanceFilter = {
  dateFromEquals: Scalars['OCDate']['input'];
  dateToEquals: Scalars['OCDate']['input'];
  manufacturerIdEquals: Scalars['String']['input'];
  offerTypeEquals: TobaccoOfferType;
  retailerNetworkUuidEquals: Scalars['OCUUID']['input'];
};

export type RetailerNetworkTobaccoProgramMembersMetric = {
  __typename: 'RetailerNetworkTobaccoProgramMembersMetric';
  retentionRate: Scalars['Int']['output'];
  totalActiveMembers: Scalars['Int']['output'];
  totalMembers: Scalars['Int']['output'];
  totalNewMembers: Scalars['Int']['output'];
};

export type RetailerNetworkTobaccoProgramMetricTimeSeriesFilter = {
  dateFrom: Scalars['OCDate']['input'];
  dateTo: Scalars['OCDate']['input'];
  retailerNetworkUuidEquals: Scalars['OCUUID']['input'];
};

export enum RetailerNetworkTobaccoProgramMetricType {
  ActiveMembers = 'ACTIVE_MEMBERS',
  LoyaltyAvgCustomerSavings = 'LOYALTY_AVG_CUSTOMER_SAVINGS',
  LoyaltyAvgMarketBasketSize = 'LOYALTY_AVG_MARKET_BASKET_SIZE',
  LoyaltyEstimatedReimbursement = 'LOYALTY_ESTIMATED_REIMBURSEMENT',
  LoyaltyTransactions = 'LOYALTY_TRANSACTIONS',
  MultiUnitAvgCustomerSavings = 'MULTI_UNIT_AVG_CUSTOMER_SAVINGS',
  MultiUnitAvgMarketBasketSize = 'MULTI_UNIT_AVG_MARKET_BASKET_SIZE',
  MultiUnitEstimatedReimbursement = 'MULTI_UNIT_ESTIMATED_REIMBURSEMENT',
  MultiUnitTransactions = 'MULTI_UNIT_TRANSACTIONS',
  NewMembers = 'NEW_MEMBERS',
  RetentionRate = 'RETENTION_RATE',
  TotalMembers = 'TOTAL_MEMBERS'
}

export type RetailerNetworkTobaccoProgramOverview = {
  __typename: 'RetailerNetworkTobaccoProgramOverview';
  performance: RetailerNetworkTobaccoProgramPerformance;
  previousPerformance: RetailerNetworkTobaccoProgramPerformance;
  tobaccoTransactionsTimeSeries: Array<TimeSeriesDataPoint>;
};

export type RetailerNetworkTobaccoProgramOverviewFilter = {
  dateFrom: Scalars['OCDate']['input'];
  dateTo: Scalars['OCDate']['input'];
  retailerNetworkUuidEquals: Scalars['OCUUID']['input'];
};

export type RetailerNetworkTobaccoProgramPerformance = {
  __typename: 'RetailerNetworkTobaccoProgramPerformance';
  loyaltyMetrics: RetailerNetworkTobaccoProgramTransactionMetric;
  memberMetrics: RetailerNetworkTobaccoProgramMembersMetric;
  multiUnitMetrics: RetailerNetworkTobaccoProgramTransactionMetric;
  totalTransactions: Scalars['Int']['output'];
};

export type RetailerNetworkTobaccoProgramSiteMetric = {
  __typename: 'RetailerNetworkTobaccoProgramSiteMetric';
  previousValue: Scalars['Float']['output'];
  rank: Scalars['Int']['output'];
  siteAddress: Scalars['String']['output'];
  siteId: Scalars['String']['output'];
  siteName: Scalars['String']['output'];
  value: Scalars['Float']['output'];
};

export type RetailerNetworkTobaccoProgramSiteMetricEdge = {
  __typename: 'RetailerNetworkTobaccoProgramSiteMetricEdge';
  cursor: Scalars['OCBase64Cursor']['output'];
  node: RetailerNetworkTobaccoProgramSiteMetric;
};

export type RetailerNetworkTobaccoProgramSitesMetricConnection = {
  __typename: 'RetailerNetworkTobaccoProgramSitesMetricConnection';
  edges: Array<RetailerNetworkTobaccoProgramSiteMetricEdge>;
  pageInfo: PageInfo;
};

export type RetailerNetworkTobaccoProgramSitesMetricFilter = {
  dateFrom: Scalars['OCDate']['input'];
  dateTo: Scalars['OCDate']['input'];
  retailerNetworkUuidEquals: Scalars['OCUUID']['input'];
  search?: InputMaybe<Scalars['String']['input']>;
  siteIdIncludes?: InputMaybe<Array<Scalars['String']['input']>>;
  siteNameIncludes?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type RetailerNetworkTobaccoProgramSitesMetricSort = {
  field: Retailer_Network_Tobacco_Program_Sites_Metric_Sort_By;
  order: Sort_Order;
};

export type RetailerNetworkTobaccoProgramTransactionMetric = {
  __typename: 'RetailerNetworkTobaccoProgramTransactionMetric';
  avgCustomerSavings: Scalars['Float']['output'];
  basketSize: Scalars['Float']['output'];
  estimatedReimbursements: Scalars['Float']['output'];
  totalTransactions: Scalars['Int']['output'];
};

export type RetailerNetworkTransactionMetricsOverview = {
  __typename: 'RetailerNetworkTransactionMetricsOverview';
  actualPerformance: RetailerNetworkTransactionMetricsOverviewData;
  loyaltyTransactionsTimeSeries?: Maybe<Array<TimeSeriesMetric>>;
  prevPerformance: RetailerNetworkTransactionMetricsOverviewData;
};

export type RetailerNetworkTransactionMetricsOverviewData = {
  __typename: 'RetailerNetworkTransactionMetricsOverviewData';
  numberOfLoyaltyTransactionsLast7Days: Scalars['Int']['output'];
  numberOfLoyaltyTransactionsLast30Days: Scalars['Int']['output'];
  numberOfLoyaltyTransactionsToday: Scalars['Int']['output'];
  numberOfLoyaltyTransactionsYesterday: Scalars['Int']['output'];
};

export type RetailerNetworkTransactionMetricsOverviewFilter = {
  locationGroups?: InputMaybe<Array<Scalars['String']['input']>>;
  locations?: InputMaybe<Array<Scalars['String']['input']>>;
  retailerNetworkUuidEquals: Scalars['OCUUID']['input'];
  timezone: Scalars['String']['input'];
};

export type RetailerNetworkUpdate = {
  address?: InputMaybe<AddressInput>;
  adminName?: InputMaybe<Scalars['String']['input']>;
  brandUuid?: InputMaybe<Scalars['OCUUID']['input']>;
  displayName?: InputMaybe<Scalars['String']['input']>;
  emailAddress?: InputMaybe<Scalars['OCEmailAddress']['input']>;
  monthlyPerformanceGoal?: InputMaybe<RetailerNetworkMonthlyPerformanceGoalUpdate>;
  name?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Adding Location Groups this way isn't supported */
  newLocationGroupUuids?: InputMaybe<Array<Scalars['OCUUID']['input']>>;
  newLocationUuids?: InputMaybe<Array<Scalars['OCUUID']['input']>>;
  newRetailerNetworkUsers?: InputMaybe<Array<RetailerNetworkUserCreate>>;
  phoneNumber?: InputMaybe<Scalars['OCPhoneNumber']['input']>;
  uuid: Scalars['OCUUID']['input'];
};

export type RetailerNetworkUser = {
  __typename: 'RetailerNetworkUser';
  createdAt: Scalars['OCDateTime']['output'];
  /** @deprecated Use openCommerceUser.email instead. This will be removed in a future release */
  emailAddress: Scalars['OCEmailAddress']['output'];
  locationGroups?: Maybe<Array<Maybe<RetailerNetworkLocationGroup>>>;
  /** @deprecated Use retailerNetworkLocations instead. This will be removed in a future release */
  locations?: Maybe<Array<Maybe<Location>>>;
  membershipUuid?: Maybe<Scalars['OCUUID']['output']>;
  /** @deprecated Use openCommerceUser.name instead. This will be removed in a future release */
  name: Scalars['String']['output'];
  openCommerceUser?: Maybe<OpenCommerceUser>;
  /** @deprecated Use openCommerceUser.phoneNumber instead. This will be removed in a future release */
  phoneNumber?: Maybe<Scalars['OCPhoneNumber']['output']>;
  retailerNetwork?: Maybe<RetailerNetwork>;
  retailerNetworkLocations: Array<Maybe<RetailerNetworkLocation>>;
  role: Retailer_Network_User_Role;
  userUuid: Scalars['OCUUID']['output'];
  uuid: Scalars['OCUUID']['output'];
};

export type RetailerNetworkUserConnection = {
  __typename: 'RetailerNetworkUserConnection';
  edges?: Maybe<Array<RetailerNetworkUserEdge>>;
  pageInfo: PageInfo;
};

export type RetailerNetworkUserCreate = {
  locationGroupUuids?: InputMaybe<Array<Scalars['OCUUID']['input']>>;
  locationUuids?: InputMaybe<Array<Scalars['OCUUID']['input']>>;
  membershipUuid?: InputMaybe<Scalars['OCUUID']['input']>;
  openCommerceUser?: InputMaybe<OpenCommerceUserCreateInput>;
  retailerNetworkUuid?: InputMaybe<Scalars['OCUUID']['input']>;
  role: Retailer_Network_User_Role;
  /** @deprecated Use openCommerceUser input instead. This will be removed in a future release */
  userUuid?: InputMaybe<Scalars['OCUUID']['input']>;
};

export type RetailerNetworkUserEdge = {
  __typename: 'RetailerNetworkUserEdge';
  cursor: Scalars['OCBase64Cursor']['output'];
  node: RetailerNetworkUser;
};

export type RetailerNetworkUserRoleMapEntry = {
  __typename: 'RetailerNetworkUserRoleMapEntry';
  locationGroupUuids: Array<Maybe<Scalars['OCUUID']['output']>>;
  locationUuids: Array<Maybe<Scalars['OCUUID']['output']>>;
  retailerNetworkUuids: Array<Maybe<Scalars['OCUUID']['output']>>;
  role: User_Role;
  uuids?: Maybe<Array<Maybe<Scalars['OCUUID']['output']>>>;
};

export type RetailerNetworkUserUpdate = {
  email?: InputMaybe<Scalars['OCEmailAddress']['input']>;
  locationGroupUuids?: InputMaybe<Array<Scalars['OCUUID']['input']>>;
  locationUuids?: InputMaybe<Array<Scalars['OCUUID']['input']>>;
  membershipUuid?: InputMaybe<Scalars['OCUUID']['input']>;
  name?: InputMaybe<PersonNameCreate>;
  phoneNumber?: InputMaybe<Scalars['OCPhoneNumber']['input']>;
  retailerNetworkUserUuid: Scalars['OCUUID']['input'];
  role?: InputMaybe<Retailer_Network_User_Role>;
};

export type RetailerNetworkUsersFilter = {
  emailEquals?: InputMaybe<Scalars['OCEmailAddress']['input']>;
  locationGroupUuidEquals?: InputMaybe<Scalars['OCUUID']['input']>;
  locationUuidEquals?: InputMaybe<Scalars['OCUUID']['input']>;
  membershipUuidEquals?: InputMaybe<Scalars['OCUUID']['input']>;
  nameLike?: InputMaybe<Scalars['String']['input']>;
  phoneNumberEquals?: InputMaybe<Scalars['OCPhoneNumber']['input']>;
  retailerNetworkUuidEquals: Scalars['OCUUID']['input'];
  roleIn?: InputMaybe<Array<Retailer_Network_User_Role>>;
  userRoleEquals?: InputMaybe<Retailer_Network_User_Role>;
  userUuidEquals?: InputMaybe<Scalars['String']['input']>;
  usernameEquals?: InputMaybe<Scalars['String']['input']>;
};

export type RetailerNetworkUsersForMemberFilter = {
  membershipUuidEquals?: InputMaybe<Scalars['OCUUID']['input']>;
};

export type RetailerNetworkUsersSort = {
  direction: Retailer_Network_Users_Sort_Order;
  field: Retailer_Network_Users_Sort_By;
};

export type RetailerNetworksForMemberConnection = {
  __typename: 'RetailerNetworksForMemberConnection';
  edges?: Maybe<Array<RetailerNetworkForMemberEdge>>;
  pageInfo: PageInfo;
};

export type RetailersNetworksFilter = {
  customerIdEquals?: InputMaybe<Scalars['String']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
};

export type RetryMatchApiDataInput = {
  chunkSize?: InputMaybe<Scalars['Int']['input']>;
  concurrency?: InputMaybe<Scalars['Int']['input']>;
  uuids?: InputMaybe<Array<Scalars['ID']['input']>>;
};

export type RetryMatchApiDataResponse = {
  __typename: 'RetryMatchApiDataResponse';
  sent: Scalars['Boolean']['output'];
  uuid: Scalars['ID']['output'];
};

export enum ReturnableOffersConfig {
  Off = 'OFF',
  On = 'ON',
  PerOffer = 'PER_OFFER'
}

export type RewardProgram = {
  __typename: 'RewardProgram';
  createdAt: Scalars['OCDateTime']['output'];
  longDescription: Scalars['String']['output'];
  programId: Scalars['String']['output'];
  shortDescription: Scalars['String']['output'];
  type: Loyalty_Provider_Type_Enum;
  updatedAt: Scalars['OCDateTime']['output'];
  uuid: Scalars['ID']['output'];
};

export type RewardProgramCreate = {
  /** @deprecated Not used. */
  loyaltyProviderUuid?: InputMaybe<Scalars['ID']['input']>;
  rewardProgramUuid: Scalars['ID']['input'];
};

export type RewardProgramFilter = {
  isDeleted?: InputMaybe<Scalars['Boolean']['input']>;
};

export type RewardProgramUpdate = {
  /** @deprecated Not used. */
  loyaltyProviderUuid?: InputMaybe<Scalars['ID']['input']>;
  rewardProgramUuid: Scalars['ID']['input'];
};

export type RuleDescription = {
  __typename: 'RuleDescription';
  description: Scalars['String']['output'];
  ruleId: Scalars['String']['output'];
};

export type RuleFulfillment = {
  __typename: 'RuleFulfillment';
  fulfilledOffer?: Maybe<Offer>;
  fulfillmentCount: Scalars['Int']['output'];
  id: Scalars['ID']['output'];
};

export enum Secondary_Transaction_Status {
  Authorized = 'AUTHORIZED',
  Authorizing = 'AUTHORIZING',
  Cancelled = 'CANCELLED',
  CancellingAuthorized = 'CANCELLING_AUTHORIZED',
  CancellingAuthorizing = 'CANCELLING_AUTHORIZING',
  CancellingPumpEnabled = 'CANCELLING_PUMP_ENABLED',
  CancellingPumpEnabling = 'CANCELLING_PUMP_ENABLING',
  CancellingPumpReserved = 'CANCELLING_PUMP_RESERVED',
  CancellingReservingPump = 'CANCELLING_RESERVING_PUMP',
  Closed = 'CLOSED',
  Fueling = 'FUELING',
  GettingReceipt = 'GETTING_RECEIPT',
  PumpEnabled = 'PUMP_ENABLED',
  PumpEnabling = 'PUMP_ENABLING',
  PumpReserved = 'PUMP_RESERVED',
  ReservingPump = 'RESERVING_PUMP',
  Settled = 'SETTLED',
  Settling = 'SETTLING',
  SiteUnavailable = 'SITE_UNAVAILABLE',
  Started = 'STARTED',
  UnableToGetReceipt = 'UNABLE_TO_GET_RECEIPT',
  WaitingForStacScan = 'WAITING_FOR_STAC_SCAN'
}

export enum Segment_Upload_File_Status {
  AudienceUpdatePending = 'AUDIENCE_UPDATE_PENDING',
  AudienceUpdating = 'AUDIENCE_UPDATING',
  Completed = 'COMPLETED',
  Failed = 'FAILED',
  Pending = 'PENDING',
  Processing = 'PROCESSING'
}

export enum Segment_Upload_Mode {
  Add = 'ADD',
  Overwrite = 'OVERWRITE',
  Remove = 'REMOVE'
}

export enum Sign_Up_Origin {
  Android = 'ANDROID',
  /** @deprecated ANDROID and IOS should be used */
  App = 'APP',
  ExternalAuth = 'EXTERNAL_AUTH',
  Imported = 'IMPORTED',
  Ios = 'IOS',
  PartnerGrocery = 'PARTNER_GROCERY',
  Pos = 'POS',
  Pump = 'PUMP',
  /** @deprecated PUMP and POS should be used */
  PumpPos = 'PUMP_POS',
  RetailerConnect = 'RETAILER_CONNECT',
  Sms = 'SMS',
  Touchpoint = 'TOUCHPOINT',
  Unknown = 'UNKNOWN',
  Web = 'WEB'
}

export enum Site_Issue_Status {
  InProgress = 'IN_PROGRESS',
  Open = 'OPEN',
  Resolved = 'RESOLVED'
}

export enum Site_System_Connection_Action {
  Connected = 'CONNECTED',
  DisconnectedBySite = 'DISCONNECTED_BY_SITE',
  ForceDisconnectedInvalidMessageFailure = 'FORCE_DISCONNECTED_INVALID_MESSAGE_FAILURE',
  ForceDisconnectedInvalidSiteIdentifier = 'FORCE_DISCONNECTED_INVALID_SITE_IDENTIFIER',
  ForceDisconnectedInvalidVendorOrProtocol = 'FORCE_DISCONNECTED_INVALID_VENDOR_OR_PROTOCOL',
  ForceDisconnectedMultipleConnectionsFromSite = 'FORCE_DISCONNECTED_MULTIPLE_CONNECTIONS_FROM_SITE',
  ForceDisconnectedSocketError = 'FORCE_DISCONNECTED_SOCKET_ERROR',
  ForceDisconnectedSocketTimeout = 'FORCE_DISCONNECTED_SOCKET_TIMEOUT',
  ForceDisconnectedWriteFailure = 'FORCE_DISCONNECTED_WRITE_FAILURE',
  ForceDisconnectedZombieDetected = 'FORCE_DISCONNECTED_ZOMBIE_DETECTED',
  ManuallyDisconnectedBySiteGateway = 'MANUALLY_DISCONNECTED_BY_SITE_GATEWAY',
  StatusUpdate = 'STATUS_UPDATE'
}

export enum Site_System_Connection_Status {
  Connected = 'CONNECTED',
  ConnectionFailure = 'CONNECTION_FAILURE',
  Disconnected = 'DISCONNECTED'
}

export enum Site_System_Details_Protocol {
  Conexxus = 'CONEXXUS',
  Rlm = 'RLM',
  Spmi = 'SPMI'
}

export enum Sort_Order {
  Asc = 'ASC',
  Desc = 'DESC'
}

export type Stac = {
  __typename: 'STAC';
  expiration?: Maybe<Scalars['OCDateTime']['output']>;
  id: Scalars['String']['output'];
};

export enum State_Change_Source_Type {
  CommandCenterUser = 'COMMAND_CENTER_USER',
  Membership = 'MEMBERSHIP',
  Transaction = 'TRANSACTION'
}

export enum Store_Location_Evaluation_Method {
  Exclude = 'EXCLUDE',
  Include = 'INCLUDE'
}

export enum Survey_Answer_Operator {
  AnswerDoesNotEqual = 'ANSWER_DOES_NOT_EQUAL',
  AnswerEqual = 'ANSWER_EQUAL',
  HasNotAnswered = 'HAS_NOT_ANSWERED'
}

export enum Survey_Location_Statistics_Sort_By {
  BottomResponse = 'BOTTOM_RESPONSE',
  TopResponse = 'TOP_RESPONSE',
  TotalResponses = 'TOTAL_RESPONSES'
}

export enum Survey_Metrics_Period {
  AllTime = 'ALL_TIME',
  Custom = 'CUSTOM',
  Last_7Days = 'LAST_7_DAYS',
  Last_30Days = 'LAST_30_DAYS'
}

export enum Survey_Type {
  General = 'GENERAL',
  Wallet = 'WALLET'
}

export type ScanData = FeatureConfiguration & {
  __typename: 'ScanData';
  enabled: Scalars['Boolean']['output'];
};

export type ScanDataConfiguration = {
  __typename: 'ScanDataConfiguration';
  description: Scalars['String']['output'];
  discountAllocation: Scalars['Int']['output'];
  fundingSource: ScanDataFundingSource;
};

export type ScanDataConfigurationInput = {
  description: Scalars['String']['input'];
  discountAllocation: Scalars['Int']['input'];
  fundingSource: ScanDataFundingSource;
};

export enum ScanDataFileStatusType {
  NotSubmitted = 'NOT_SUBMITTED',
  PartiallySubmitted = 'PARTIALLY_SUBMITTED',
  SubmissionInProgress = 'SUBMISSION_IN_PROGRESS',
  Submitted = 'SUBMITTED'
}

export enum ScanDataFundingSource {
  DigitalAcceleratorFund = 'DIGITAL_ACCELERATOR_FUND',
  OutletLoyalty = 'OUTLET_LOYALTY'
}

export type ScanDataGenerateSubmissionCsvInput = {
  fileType: ScanDataSubmissionFileType;
  submissionDate: Scalars['OCDate']['input'];
};

export type ScanDataMetricsTimeSeries = {
  __typename: 'ScanDataMetricsTimeSeries';
  missingStores: Array<TimeSeriesDataPoint>;
  reimbursements: Array<TimeSeriesDataPoint>;
  storesSubmitted: Array<TimeSeriesDataPoint>;
  submissionDate: Scalars['OCDate']['output'];
  transactionsReported: Array<TimeSeriesDataPoint>;
};

export type ScanDataMetricsTimeSeriesFilter = {
  submissionDateEquals: Scalars['OCDate']['input'];
};

export type ScanDataMissingStoreStoreLevelDetails = ScanDataStoreLevelDetails & {
  __typename: 'ScanDataMissingStoreStoreLevelDetails';
  altriaRCN?: Maybe<Scalars['String']['output']>;
  altriaSubmitterID?: Maybe<Scalars['String']['output']>;
  msaSubmitterID?: Maybe<Scalars['String']['output']>;
  rjrAccountNumber?: Maybe<Scalars['String']['output']>;
  rjrSubmitterID?: Maybe<Scalars['String']['output']>;
  siteID: Scalars['String']['output'];
  siteName: Scalars['String']['output'];
  submittedStoresStatistics?: Maybe<SubmittedStoresStatistics>;
};

export type ScanDataMissingStoreStoreLevelDetailsConnection = {
  __typename: 'ScanDataMissingStoreStoreLevelDetailsConnection';
  edges: Array<ScanDataMissingStoreStoreLevelDetailsEdge>;
  pageInfo: PageInfo;
};

export type ScanDataMissingStoreStoreLevelDetailsEdge = {
  __typename: 'ScanDataMissingStoreStoreLevelDetailsEdge';
  cursor: Scalars['OCBase64Cursor']['output'];
  node: ScanDataMissingStoreStoreLevelDetails;
};

export type ScanDataMissingStoresDetails = {
  __typename: 'ScanDataMissingStoresDetails';
  phoneNumber?: Maybe<Scalars['OCPhoneNumber']['output']>;
  siteAddress: Scalars['String']['output'];
  siteID: Scalars['String']['output'];
  siteName: Scalars['String']['output'];
};

export type ScanDataMissingStoresDetailsConnection = {
  __typename: 'ScanDataMissingStoresDetailsConnection';
  edges: Array<ScanDataMissingStoresDetailsEdge>;
  pageInfo: PageInfo;
};

export type ScanDataMissingStoresDetailsEdge = {
  __typename: 'ScanDataMissingStoresDetailsEdge';
  cursor: Scalars['ID']['output'];
  node: ScanDataMissingStoresDetails;
};

export type ScanDataMissingStoresDetailsFilter = {
  search?: InputMaybe<Scalars['String']['input']>;
  siteConfigurationAddressContains?: InputMaybe<Scalars['String']['input']>;
  siteConfigurationIdEquals?: InputMaybe<Scalars['String']['input']>;
  siteNameEquals?: InputMaybe<Scalars['String']['input']>;
};

export type ScanDataMissingStoresStoreLevelDetailsFilter = {
  siteAccountSubmitterSearch?: InputMaybe<Scalars['String']['input']>;
  submissionDateEquals: Scalars['OCDate']['input'];
};

export type ScanDataReimbursementsStoreLevelDetails = ScanDataStoreLevelDetails & {
  __typename: 'ScanDataReimbursementsStoreLevelDetails';
  altriaRCN?: Maybe<Scalars['String']['output']>;
  altriaSubmitterID?: Maybe<Scalars['String']['output']>;
  estimatedReimbursements: EstimatedReimbursements;
  msaSubmitterID?: Maybe<Scalars['String']['output']>;
  rjrAccountNumber?: Maybe<Scalars['String']['output']>;
  rjrSubmitterID?: Maybe<Scalars['String']['output']>;
  siteID: Scalars['String']['output'];
  siteName: Scalars['String']['output'];
  submittedStoresStatistics?: Maybe<SubmittedStoresStatistics>;
};

export type ScanDataReimbursementsStoreLevelDetailsConnection = {
  __typename: 'ScanDataReimbursementsStoreLevelDetailsConnection';
  edges: Array<ScanDataReimbursementsStoreLevelDetailsEdge>;
  pageInfo: PageInfo;
};

export type ScanDataReimbursementsStoreLevelDetailsEdge = {
  __typename: 'ScanDataReimbursementsStoreLevelDetailsEdge';
  cursor: Scalars['OCBase64Cursor']['output'];
  node: ScanDataReimbursementsStoreLevelDetails;
};

export type ScanDataReimbursementsStoreLevelDetailsFilter = {
  siteAccountSubmitterSearch?: InputMaybe<Scalars['String']['input']>;
  submissionDateEquals: Scalars['OCDate']['input'];
};

export type ScanDataReportedTransactionsStoreLevelDetails = ScanDataStoreLevelDetails & {
  __typename: 'ScanDataReportedTransactionsStoreLevelDetails';
  altriaRCN?: Maybe<Scalars['String']['output']>;
  altriaSubmitterID?: Maybe<Scalars['String']['output']>;
  msaSubmitterID?: Maybe<Scalars['String']['output']>;
  reportedTransactions: Scalars['Int']['output'];
  rjrAccountNumber?: Maybe<Scalars['String']['output']>;
  rjrSubmitterID?: Maybe<Scalars['String']['output']>;
  siteID: Scalars['String']['output'];
  siteName: Scalars['String']['output'];
  submittedStoresStatistics?: Maybe<SubmittedStoresStatistics>;
};

export type ScanDataReportedTransactionsStoreLevelDetailsConnection = {
  __typename: 'ScanDataReportedTransactionsStoreLevelDetailsConnection';
  edges: Array<ScanDataReportedTransactionsStoreLevelDetailsEdge>;
  pageInfo: PageInfo;
};

export type ScanDataReportedTransactionsStoreLevelDetailsEdge = {
  __typename: 'ScanDataReportedTransactionsStoreLevelDetailsEdge';
  cursor: Scalars['OCBase64Cursor']['output'];
  node: ScanDataReportedTransactionsStoreLevelDetails;
};

export type ScanDataReportedTransactionsStoreLevelDetailsFilter = {
  siteAccountSubmitterSearch?: InputMaybe<Scalars['String']['input']>;
  submissionDateEquals: Scalars['OCDate']['input'];
};

export type ScanDataSftpCredential = {
  __typename: 'ScanDataSftpCredential';
  cpg: Cpg;
  credentialStatus: ScanDataSftpCredentialStatus;
  host: Scalars['String']['output'];
  name?: Maybe<Scalars['String']['output']>;
  password: Scalars['String']['output'];
  port?: Maybe<Scalars['Int']['output']>;
  submissionStatus?: Maybe<ScanDataSftpCredentialSubmissionStatus>;
  submitterID: Scalars['String']['output'];
  username: Scalars['String']['output'];
  uuid: Scalars['OCUUID']['output'];
};

export type ScanDataSftpCredentialConnection = {
  __typename: 'ScanDataSftpCredentialConnection';
  edges: Array<ScanDataSftpCredentialEdge>;
  pageInfo: PageInfo;
};

export type ScanDataSftpCredentialCreateInput = {
  cpg: Cpg;
  credentialStatus: ScanDataSftpCredentialStatus;
  host: Scalars['String']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
  password: Scalars['String']['input'];
  port?: InputMaybe<Scalars['Int']['input']>;
  submitterID: Scalars['String']['input'];
  username: Scalars['String']['input'];
};

export type ScanDataSftpCredentialEdge = {
  __typename: 'ScanDataSftpCredentialEdge';
  cursor: Scalars['ID']['output'];
  node: ScanDataSftpCredential;
};

export enum ScanDataSftpCredentialStatus {
  ProductionSubmission = 'PRODUCTION_SUBMISSION',
  QaSubmission = 'QA_SUBMISSION'
}

export enum ScanDataSftpCredentialSubmissionStatus {
  Active = 'ACTIVE',
  NotSubmitted = 'NOT_SUBMITTED',
  Testing = 'TESTING'
}

export type ScanDataSftpCredentialUpdateInput = {
  cpg?: InputMaybe<Cpg>;
  credentialStatus: ScanDataSftpCredentialStatus;
  host?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  password?: InputMaybe<Scalars['String']['input']>;
  port?: InputMaybe<Scalars['Int']['input']>;
  submitterID?: InputMaybe<Scalars['String']['input']>;
  username?: InputMaybe<Scalars['String']['input']>;
  uuid: Scalars['OCUUID']['input'];
};

export type ScanDataSftpCredentialsOverview = {
  __typename: 'ScanDataSftpCredentialsOverview';
  totalAltria: Scalars['Int']['output'];
  totalMSA: Scalars['Int']['output'];
  totalRJR: Scalars['Int']['output'];
};

export type ScanDataSftpCredentialsStoreDetails = {
  __typename: 'ScanDataSftpCredentialsStoreDetails';
  accountIdentifier: Scalars['String']['output'];
  siteAddress: Scalars['String']['output'];
  siteId: Scalars['String']['output'];
  siteName: Scalars['String']['output'];
  sitePhoneNumber?: Maybe<Scalars['OCPhoneNumber']['output']>;
  uuid: Scalars['ID']['output'];
};

export type ScanDataSftpCredentialsWithStoreDetails = {
  __typename: 'ScanDataSftpCredentialsWithStoreDetails';
  accountIdentifier: Scalars['String']['output'];
  cpg: Cpg;
  host: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  locations?: Maybe<Array<ScanDataSftpCredentialsStoreDetails>>;
  submitterID: Scalars['String']['output'];
  username: Scalars['String']['output'];
};

export type ScanDataSftpCredentialsWithStoreDetailsConnection = {
  __typename: 'ScanDataSftpCredentialsWithStoreDetailsConnection';
  edges?: Maybe<Array<ScanDataSftpCredentialsWithStoreDetailsEdge>>;
  pageInfo: PageInfo;
};

export type ScanDataSftpCredentialsWithStoreDetailsEdge = {
  __typename: 'ScanDataSftpCredentialsWithStoreDetailsEdge';
  cursor: Scalars['ID']['output'];
  node: ScanDataSftpCredentialsWithStoreDetails;
};

export type ScanDataStoreLevelDetails = {
  altriaRCN?: Maybe<Scalars['String']['output']>;
  altriaSubmitterID?: Maybe<Scalars['String']['output']>;
  msaSubmitterID?: Maybe<Scalars['String']['output']>;
  rjrAccountNumber?: Maybe<Scalars['String']['output']>;
  rjrSubmitterID?: Maybe<Scalars['String']['output']>;
  siteID: Scalars['String']['output'];
  siteName: Scalars['String']['output'];
  submittedStoresStatistics?: Maybe<SubmittedStoresStatistics>;
};

export type ScanDataSubmission = {
  __typename: 'ScanDataSubmission';
  estimatedReimbursements: Reimbursements;
  previousEstimatedReimbursements: Reimbursements;
  status: ScanDataSubmissionStatus;
  totalLoyaltyTransactions: Scalars['Int']['output'];
  totalMultiUnitTransactions: Scalars['Int']['output'];
  type: ScanDataSubmissionType;
};

export enum ScanDataSubmissionFileType {
  MissingStores = 'MISSING_STORES',
  Reimbursements = 'REIMBURSEMENTS',
  ReportedTransactions = 'REPORTED_TRANSACTIONS',
  StoresSubmitted = 'STORES_SUBMITTED'
}

export type ScanDataSubmissionFilter = {
  fileStatusEquals?: InputMaybe<ScanDataFileStatusType>;
  submissionDateEquals: Scalars['OCDate']['input'];
};

export type ScanDataSubmissionGroupSubmissionDetails = {
  __typename: 'ScanDataSubmissionGroupSubmissionDetails';
  actionsAvailable: Scalars['Boolean']['output'];
  fileStatus: ScanDataFileStatusType;
  isResubmitted: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  storesSubmittedCount: Scalars['Int']['output'];
  totalStoresCount: Scalars['Int']['output'];
  type: ScanDataSubmissionType;
};

export type ScanDataSubmissionHealthMetrics = {
  __typename: 'ScanDataSubmissionHealthMetrics';
  estimatedReimbursements?: Maybe<EstimatedReimbursements>;
  missingStores: Array<TimeSeriesDataPoint>;
  reportLines: Array<TimeSeriesDataPoint>;
  submissionDate: Scalars['OCDate']['output'];
  totalStores: Array<TimeSeriesDataPoint>;
  weeklyReimbursementsTrends: Array<ReimbursementsTimeSeriesDataPoint>;
};

export type ScanDataSubmissionHealthMetricsFilter = {
  submissionDateEquals: Scalars['OCDate']['input'];
};

export enum ScanDataSubmissionStatus {
  NotSubmitted = 'NOT_SUBMITTED',
  PartiallySubmitted = 'PARTIALLY_SUBMITTED',
  Submitted = 'SUBMITTED'
}

export enum ScanDataSubmissionType {
  CircanaAltria = 'CIRCANA_ALTRIA',
  CircanaRjr = 'CIRCANA_RJR',
  Msa = 'MSA'
}

export type ScanDataSubmissions = {
  __typename: 'ScanDataSubmissions';
  estimatedReimbursements: Scalars['Float']['output'];
  fileStatus: ScanDataFileStatusType;
  previousTransactionsReportedCount: Scalars['Int']['output'];
  submissionDate: Scalars['OCDate']['output'];
  submissionGroupsCount: Scalars['Int']['output'];
  submissionGroupsDetails: Array<ScanDataSubmissionGroupSubmissionDetails>;
  submittedSubmissionGroupsCount: Scalars['Int']['output'];
  transactionsReportedChangePercent: Scalars['Int']['output'];
  transactionsReportedCount: Scalars['Int']['output'];
  type: ScanDataSubmissionType;
};

export type ScanDataSubmissionsConnection = {
  __typename: 'ScanDataSubmissionsConnection';
  edges: Array<ScanDataSubmissionsEdge>;
  pageInfo: PageInfo;
};

export type ScanDataSubmissionsEdge = {
  __typename: 'ScanDataSubmissionsEdge';
  cursor: Scalars['OCBase64Cursor']['output'];
  node: ScanDataSubmissions;
};

export type ScanDataSubmittedTransactionsStoreLevelDetails = ScanDataStoreLevelDetails & {
  __typename: 'ScanDataSubmittedTransactionsStoreLevelDetails';
  altriaRCN?: Maybe<Scalars['String']['output']>;
  altriaSubmitterID?: Maybe<Scalars['String']['output']>;
  msaSubmitterID?: Maybe<Scalars['String']['output']>;
  rjrAccountNumber?: Maybe<Scalars['String']['output']>;
  rjrSubmitterID?: Maybe<Scalars['String']['output']>;
  siteID: Scalars['String']['output'];
  siteName: Scalars['String']['output'];
  submittedStoresStatistics?: Maybe<SubmittedStoresStatistics>;
};

export type ScanDataSubmittedTransactionsStoreLevelDetailsConnection = {
  __typename: 'ScanDataSubmittedTransactionsStoreLevelDetailsConnection';
  edges: Array<ScanDataSubmittedTransactionsStoreLevelDetailsEdge>;
  pageInfo: PageInfo;
};

export type ScanDataSubmittedTransactionsStoreLevelDetailsEdge = {
  __typename: 'ScanDataSubmittedTransactionsStoreLevelDetailsEdge';
  cursor: Scalars['OCBase64Cursor']['output'];
  node: ScanDataSubmittedTransactionsStoreLevelDetails;
};

export type ScanDataSubmittedTransactionsStoreLevelDetailsFilter = {
  altriaRCNContains?: InputMaybe<Scalars['String']['input']>;
  altriaSubmitterIDContains?: InputMaybe<Scalars['String']['input']>;
  circanaSubmitterIDContains?: InputMaybe<Scalars['String']['input']>;
  identifierContains?: InputMaybe<Scalars['String']['input']>;
  msaSubmitterIDContains?: InputMaybe<Scalars['String']['input']>;
  rjrAccountNumberContains?: InputMaybe<Scalars['String']['input']>;
  siteAccountSubmitterSearch?: InputMaybe<Scalars['String']['input']>;
  siteNameContains?: InputMaybe<Scalars['String']['input']>;
  submissionDateEquals: Scalars['OCDate']['input'];
};

export type ScanDataSumbitWeeklyFileInput = {
  submissionDate: Scalars['OCDate']['input'];
};

export type ScanDataWeekEndingOverview = {
  __typename: 'ScanDataWeekEndingOverview';
  fileStatus: ScanDataFileStatusType;
  isResubmitted: Scalars['Boolean']['output'];
  lastTransactionLogPulledAt: Scalars['OCDateTime']['output'];
  pastWeekEndPerformance: ScanDataWeekEndingPerformance;
  weekEndPerformance: ScanDataWeekEndingPerformance;
};

export type ScanDataWeekEndingOverviewFilter = {
  weekEndingDateEquals: Scalars['OCDate']['input'];
};

export type ScanDataWeekEndingPerformance = {
  __typename: 'ScanDataWeekEndingPerformance';
  missingStores: Scalars['Int']['output'];
  reportedLines: Scalars['Int']['output'];
  storesWithTransactions: Scalars['Int']['output'];
};

export enum ScanDataWeeklySubmissionStatus {
  NotSubmitted = 'NOT_SUBMITTED',
  PartiallySubmitted = 'PARTIALLY_SUBMITTED',
  Submitted = 'SUBMITTED'
}

export type ScrubDataInput = {
  customerUuid: Scalars['String']['input'];
};

export type SearchQuery = {
  searchField: Scalars['String']['input'];
  searchString: Scalars['String']['input'];
};

export type Segment = {
  __typename: 'Segment';
  /** @deprecated Member Dossier does not support this */
  chain?: Maybe<Chain>;
  description: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  membershipCount: Scalars['Int']['output'];
  membershipSegmentCreatedAt?: Maybe<Scalars['OCDateTime']['output']>;
  /** @deprecated Member Dossier does not support this */
  memberships?: Maybe<MembershipConnection>;
  name: Scalars['String']['output'];
  shortCode?: Maybe<Scalars['String']['output']>;
};


export type SegmentMembershipsArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  filter?: InputMaybe<MembershipFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type SegmentConnection = {
  __typename: 'SegmentConnection';
  edges: Array<SegmentEdge>;
  pageInfo: PageInfo;
};

export type SegmentCreate = {
  description: Scalars['String']['input'];
  name: Scalars['String']['input'];
  shortCode?: InputMaybe<Scalars['String']['input']>;
};

export type SegmentEdge = {
  __typename: 'SegmentEdge';
  cursor: Scalars['ID']['output'];
  node: Segment;
};

export type SegmentFilter = {
  chainIdEquals?: InputMaybe<Scalars['ID']['input']>;
  idContains?: InputMaybe<Array<Scalars['ID']['input']>>;
  idEquals?: InputMaybe<Scalars['ID']['input']>;
  idExcludes?: InputMaybe<Array<Scalars['ID']['input']>>;
  isDeleted?: InputMaybe<Scalars['Boolean']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
};

export type SegmentForMembershipFilter = {
  membershipUuid: Scalars['ID']['input'];
  search?: InputMaybe<Scalars['String']['input']>;
};

export type SegmentMembershipAddInput = {
  memberships: Array<Scalars['ID']['input']>;
  segmentId: Scalars['ID']['input'];
};

export type SegmentMembershipDeleteInput = {
  memberships: Array<Scalars['ID']['input']>;
  segmentId: Scalars['ID']['input'];
};

export type SegmentUpdate = {
  description: Scalars['String']['input'];
  name: Scalars['String']['input'];
};

export type SegmentUploadFile = {
  __typename: 'SegmentUploadFile';
  createdAt: Scalars['OCDateTime']['output'];
  mode?: Maybe<Segment_Upload_Mode>;
  name: Scalars['String']['output'];
  status: Segment_Upload_File_Status;
  uuid: Scalars['OCUUID']['output'];
};

export type SegmentUploadFileConnection = {
  __typename: 'SegmentUploadFileConnection';
  edges: Array<SegmentUploadFileEdge>;
  pageInfo: PageInfo;
};

export type SegmentUploadFileEdge = {
  __typename: 'SegmentUploadFileEdge';
  cursor: Scalars['OCBase64Cursor']['output'];
  node: SegmentUploadFile;
};

export type SendTestMessageInput = {
  membershipId: Scalars['OCUUID']['input'];
  messageTemplate: TestMessageTemplateInput;
};

export type SenderConfiguration = {
  __typename: 'SenderConfiguration';
  award?: Maybe<AwardPointsOrVouchers>;
  /** @deprecated Replaced by senderInstructions in ReferralProgramMarketingContent (use the entry with subBrandUuid: null for the default). */
  instructions: Scalars['String']['output'];
  /** @deprecated Replaced by smsTemplate in ReferralProgramMarketingContent (use the entry with subBrandUuid: null for the default). */
  smsTemplate: Scalars['String']['output'];
};

export type SenderConfigurationInput = {
  awardPoints?: InputMaybe<AwardPointsInput>;
  awardVouchers?: InputMaybe<AwardVouchersInput>;
  /** @deprecated Replaced by senderInstructions in ReferralProgramMarketingContentInput. */
  instructions?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Replaced by smsTemplate in ReferralProgramMarketingContentInput. */
  smsTemplate?: InputMaybe<Scalars['String']['input']>;
};

export type SetLocationPerformanceGoal = {
  locationUuid: Scalars['OCUUID']['input'];
  loyaltyTransactionsGoal: Scalars['Int']['input'];
  newMembersGoal: Scalars['Int']['input'];
  retailerNetworkUuid: Scalars['OCUUID']['input'];
};

export type SettleBatchesInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  externalRequestData?: InputMaybe<Scalars['OCJSON']['input']>;
  transactionUuid?: InputMaybe<Scalars['ID']['input']>;
};

export type SignInUsernamePasswordUserInput = {
  identifier: Scalars['String']['input'];
  password: Scalars['String']['input'];
};

export type SignUpInput = {
  attributes?: InputMaybe<Array<InputMaybe<UserAttributes>>>;
  username: Scalars['String']['input'];
};

export type SignUpUsernamePasswordUserInput = {
  identifier: Scalars['String']['input'];
  password: Scalars['String']['input'];
};

export type Site = {
  __typename: 'Site';
  lastLoyaltyHeartbeatAt?: Maybe<Scalars['OCDateTime']['output']>;
  lastLoyaltyHeartbeatMessage?: Maybe<Scalars['OCJSON']['output']>;
  lastMobileHeartbeatAt?: Maybe<Scalars['OCDateTime']['output']>;
  lastMobileHeartbeatMessage?: Maybe<Scalars['OCJSON']['output']>;
  lastSiteInfoRequestMessage?: Maybe<Scalars['OCJSON']['output']>;
  lastSiteInfoRequestMessageAt?: Maybe<Scalars['OCDateTime']['output']>;
  siteId?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['OCDateTime']['output']>;
};

export type SiteCapabiltyFilter = {
  capability: Location_Capability;
  siteConfigurationId: Scalars['String']['input'];
};

export type SiteConnectionHistory = {
  __typename: 'SiteConnectionHistory';
  additionalInfo?: Maybe<Scalars['OCJSON']['output']>;
  connectedAt: Scalars['OCDateTime']['output'];
  connectionDurationMs?: Maybe<Scalars['Int']['output']>;
  disconnectedAt?: Maybe<Scalars['OCDateTime']['output']>;
  disconnectionAction?: Maybe<Site_System_Connection_Action>;
  hardwareVendor?: Maybe<Hardware_Vendor>;
  inboundMessageClass?: Maybe<Inbound_Message_Class>;
  inboundMessageType?: Maybe<Inbound_Message_Type>;
  messagesReceived?: Maybe<Scalars['Int']['output']>;
  messagesSent?: Maybe<Scalars['Int']['output']>;
  nodeId: Scalars['String']['output'];
  siteId: Scalars['String']['output'];
  uuid: Scalars['String']['output'];
  vendorDetails?: Maybe<Scalars['OCJSON']['output']>;
};

export type SiteConnectionHistoryConnection = {
  __typename: 'SiteConnectionHistoryConnection';
  edges?: Maybe<Array<SiteConnectionHistoryEdge>>;
  pageInfo: PageInfo;
};

export type SiteConnectionHistoryEdge = {
  __typename: 'SiteConnectionHistoryEdge';
  cursor: Scalars['OCBase64Cursor']['output'];
  node: SiteConnectionHistory;
};

export type SiteConnectionHistoryFilter = {
  connectionDurationInMillisecondsGreaterThan?: InputMaybe<Scalars['Int']['input']>;
  connectionDurationInMillisecondsLessThan?: InputMaybe<Scalars['Int']['input']>;
  connectionStatusEquals?: InputMaybe<Site_System_Connection_Status>;
  disconnectActionContains?: InputMaybe<Array<Site_System_Connection_Action>>;
  inboundMessageClassEquals?: InputMaybe<Inbound_Message_Class>;
  lastConnectDateFrom?: InputMaybe<Scalars['OCDateTime']['input']>;
  lastConnectDateTo?: InputMaybe<Scalars['OCDateTime']['input']>;
  lastDisconnectDateFrom?: InputMaybe<Scalars['OCDateTime']['input']>;
  lastDisconnectDateTo?: InputMaybe<Scalars['OCDateTime']['input']>;
  locationUuid?: InputMaybe<Scalars['OCUUID']['input']>;
  siteId?: InputMaybe<Scalars['String']['input']>;
};

export type SiteConnectionHistorySummary = {
  __typename: 'SiteConnectionHistorySummary';
  totalConnectionFailures: Scalars['Int']['output'];
  totalConnections: Scalars['Int']['output'];
  totalDisconnections: Scalars['Int']['output'];
};

export type SiteConnectionHistorySummaryFilter = {
  dateRange?: InputMaybe<DateRangeInput>;
  locationUuid?: InputMaybe<Scalars['OCUUID']['input']>;
  siteId?: InputMaybe<Scalars['String']['input']>;
};

export type SiteDisconnectInput = {
  inboundMessageClass: Inbound_Message_Class;
  siteId: Scalars['String']['input'];
};

export type SiteFilter = {
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  siteIdContains?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type SiteHealth = {
  __typename: 'SiteHealth';
  backoffice: BackofficeHealth;
  loyalty: LoyaltyHealth;
  mobile: MobileHealth;
  uuid: Scalars['String']['output'];
};

export type SiteHealthConnection = {
  __typename: 'SiteHealthConnection';
  edges?: Maybe<Array<SiteHealthEdge>>;
  pageInfo: PageInfo;
};

export type SiteHealthEdge = {
  __typename: 'SiteHealthEdge';
  cursor: Scalars['OCBase64Cursor']['output'];
  node: SiteHealth;
};

export type SiteHealthFilter = {
  locationUuid?: InputMaybe<Scalars['OCUUID']['input']>;
  siteId?: InputMaybe<Scalars['String']['input']>;
};

export type SiteIssue = {
  __typename: 'SiteIssue';
  assignedTo?: Maybe<OpenCommerceUser>;
  createdAt: Scalars['OCDateTime']['output'];
  createdBy: OpenCommerceUser;
  description?: Maybe<Scalars['String']['output']>;
  jiraCaseId?: Maybe<Scalars['String']['output']>;
  lastUpdatedBy: OpenCommerceUser;
  siteId: Scalars['String']['output'];
  status: Site_Issue_Status;
  title: Scalars['String']['output'];
  updatedAt: Scalars['OCDateTime']['output'];
  uuid: Scalars['OCUUID']['output'];
};

export type SiteIssueFilter = {
  assignedToUserUuidEquals?: InputMaybe<Scalars['OCUUID']['input']>;
  createdByUserUuidEquals?: InputMaybe<Scalars['OCUUID']['input']>;
  descriptionContains?: InputMaybe<Scalars['String']['input']>;
  siteIdContains?: InputMaybe<Scalars['String']['input']>;
  statusIn?: InputMaybe<Array<Site_Issue_Status>>;
  uuidEquals?: InputMaybe<Scalars['OCUUID']['input']>;
};

export type SiteMonitorActivity = {
  __typename: 'SiteMonitorActivity';
  action: Activity_Action;
  activityType: Activity_Type;
  createdAt: Scalars['OCDateTime']['output'];
  description: Scalars['String']['output'];
  rawMessage: Scalars['String']['output'];
  uuid: Scalars['String']['output'];
};

export type SiteMonitorActivityConnection = {
  __typename: 'SiteMonitorActivityConnection';
  edges: Array<SiteMonitorActivityEdge>;
  pageInfo: PageInfo;
};

export type SiteMonitorActivityEdge = {
  __typename: 'SiteMonitorActivityEdge';
  cursor: Scalars['ID']['output'];
  node: SiteMonitorActivity;
};

export type SiteSystemCarWashItem = {
  __typename: 'SiteSystemCarWashItem';
  description?: Maybe<Scalars['String']['output']>;
  merchandiseCode?: Maybe<Scalars['String']['output']>;
  posCode: Scalars['String']['output'];
  posCodeFormat?: Maybe<Scalars['String']['output']>;
  posCodeModifier: Scalars['String']['output'];
  productCode: Scalars['String']['output'];
  unitPrice: Scalars['Float']['output'];
};

export type SiteSystemConfiguration = {
  __typename: 'SiteSystemConfiguration';
  backOfficeEnabled: Scalars['Boolean']['output'];
  cboZone?: Maybe<Scalars['String']['output']>;
  details?: Maybe<SiteSystemDetails>;
  hardwareVendor: Hardware_Vendor;
  identifier: Scalars['String']['output'];
  ipAddress?: Maybe<Scalars['String']['output']>;
  loyaltyEnabled: Scalars['Boolean']['output'];
  loyaltyHeartbeatsOnlyEnabled?: Maybe<Scalars['Boolean']['output']>;
  mashginEnabled?: Maybe<Scalars['Boolean']['output']>;
  mobileEnabled: Scalars['Boolean']['output'];
  password?: Maybe<Scalars['String']['output']>;
  previousPassword?: Maybe<Scalars['String']['output']>;
  priceBookGroup?: Maybe<Scalars['String']['output']>;
  username?: Maybe<Scalars['String']['output']>;
  uuid: Scalars['ID']['output'];
};

export type SiteSystemConfigurationCreate = {
  backOfficeEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  hardwareVendor: Hardware_Vendor;
  identifier: Scalars['String']['input'];
  ipAddress?: InputMaybe<Scalars['String']['input']>;
  loyaltyEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  loyaltyHeartbeatsOnlyEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  mobileEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  password?: InputMaybe<Scalars['String']['input']>;
  previousPassword?: InputMaybe<Scalars['String']['input']>;
  priceBookGroup?: InputMaybe<Scalars['String']['input']>;
  username?: InputMaybe<Scalars['String']['input']>;
};

export type SiteSystemConfigurationFilter = {
  hardwareVendorEquals?: InputMaybe<Hardware_Vendor>;
  identifierContains?: InputMaybe<Scalars['String']['input']>;
  identifierEquals?: InputMaybe<Scalars['String']['input']>;
  identifierIn?: InputMaybe<Array<Scalars['String']['input']>>;
  isBackOfficeEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  isLoyaltyEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  isMobileEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  siteConfigurationIdContains?: InputMaybe<Scalars['String']['input']>;
  siteConfigurationIdEquals?: InputMaybe<Scalars['String']['input']>;
};

export type SiteSystemConfigurationInput = {
  create?: InputMaybe<Array<SiteSystemConfigurationCreate>>;
  update?: InputMaybe<Array<SiteSystemConfigurationUpdate>>;
};

export type SiteSystemConfigurationUpdate = {
  backOfficeEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  hardwareVendor?: InputMaybe<Hardware_Vendor>;
  identifier?: InputMaybe<Scalars['String']['input']>;
  ipAddress?: InputMaybe<Scalars['String']['input']>;
  loyaltyEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  loyaltyHeartbeatsOnlyEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  mobileEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  password?: InputMaybe<Scalars['String']['input']>;
  previousPassword?: InputMaybe<Scalars['String']['input']>;
  priceBookGroup?: InputMaybe<Scalars['String']['input']>;
  username?: InputMaybe<Scalars['String']['input']>;
  uuid: Scalars['ID']['input'];
};

export type SiteSystemDetails = {
  __typename: 'SiteSystemDetails';
  carWashDetails: Array<SiteSystemCarWashItem>;
  fuelConfigDetails: Array<SiteSystemFuelPumpProduct>;
  hardwareVendor?: Maybe<Hardware_Vendor>;
  isLoyaltyOnline: Scalars['Boolean']['output'];
  isMobileOnline: Scalars['Boolean']['output'];
  isOnline: Scalars['Boolean']['output'];
  lastConnection?: Maybe<Scalars['OCDateTime']['output']>;
  lastLoyaltyConnection?: Maybe<Scalars['OCDateTime']['output']>;
  lastMobileConnection?: Maybe<Scalars['OCDateTime']['output']>;
  lastSiteInfoRequestMessageAt?: Maybe<Scalars['OCDateTime']['output']>;
  latitude?: Maybe<Scalars['Float']['output']>;
  longitude?: Maybe<Scalars['Float']['output']>;
  loyaltyProtocol?: Maybe<Site_System_Details_Protocol>;
  loyaltyVersion?: Maybe<Scalars['String']['output']>;
  mobileActive?: Maybe<Scalars['Boolean']['output']>;
  mobileProtocol?: Maybe<Site_System_Details_Protocol>;
  mobileVersion?: Maybe<Scalars['String']['output']>;
  partialAuthAllowed?: Maybe<Scalars['Boolean']['output']>;
  pumpTimeout?: Maybe<Scalars['Int']['output']>;
  siteAddress?: Maybe<Scalars['String']['output']>;
  siteName?: Maybe<Scalars['String']['output']>;
  welcomeMsg?: Maybe<Scalars['String']['output']>;
};

export type SiteSystemFuelPumpProduct = {
  __typename: 'SiteSystemFuelPumpProduct';
  description?: Maybe<Scalars['String']['output']>;
  merchandiseCode?: Maybe<Scalars['String']['output']>;
  outdoorPosition?: Maybe<Scalars['String']['output']>;
  posCode: Scalars['String']['output'];
  posCodeFormat?: Maybe<Scalars['String']['output']>;
  posCodeModifier: Scalars['String']['output'];
  priceTier?: Maybe<Conexxus_Price_Tier>;
  productCode: Scalars['String']['output'];
  unitPrice: Scalars['Float']['output'];
};

export type SitesSummary = {
  __typename: 'SitesSummary';
  issues: Scalars['Int']['output'];
  loyaltyOffline: Scalars['Int']['output'];
  loyaltyOnline: Scalars['Int']['output'];
  mobileOffline: Scalars['Int']['output'];
  mobileOnline: Scalars['Int']['output'];
  offline: Scalars['Int']['output'];
  online: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type SitesSummaryFilter = {
  locationGroupUuidEquals?: InputMaybe<Scalars['ID']['input']>;
};

export type SliderResponseRange = {
  __typename: 'SliderResponseRange';
  count: Scalars['Int']['output'];
  rangeEnd: Scalars['Int']['output'];
  rangeStart: Scalars['Int']['output'];
};

export type SmsConfig = {
  __typename: 'SmsConfig';
  body: Scalars['OCLiquid']['output'];
  enabled: Scalars['Boolean']['output'];
};

export type SmsConfigInput = {
  body: Scalars['OCLiquid']['input'];
  enabled: Scalars['Boolean']['input'];
};

export enum SmsOptOutReason {
  BlockedByProvider = 'BLOCKED_BY_PROVIDER',
  ManualOptOut = 'MANUAL_OPT_OUT',
  PhoneNumberInactive = 'PHONE_NUMBER_INACTIVE'
}

export enum SortOrder {
  Asc = 'ASC',
  Desc = 'DESC'
}

export type SpinWheelGameExecuteInput = {
  customerUuid: Scalars['ID']['input'];
  offerId: Scalars['ID']['input'];
};

export type StateChangeSource = ActivateTransaction | CommandCenterUser | Membership;

export type SteeringWallet = {
  __typename: 'SteeringWallet';
  archivedAt?: Maybe<Scalars['OCDateTime']['output']>;
  chainId: Scalars['OCUUID']['output'];
  configuration: SteeringWalletConfiguration;
  createdAt: Scalars['OCDateTime']['output'];
  name: Scalars['String']['output'];
  statistics: WalletSteeringDailySnapshot;
  status: SteeringWalletStatus;
  uuid: Scalars['OCUUID']['output'];
};

export enum SteeringWalletBasis {
  Daily = 'DAILY',
  Monthly = 'MONTHLY',
  Weekly = 'WEEKLY'
}

export type SteeringWalletConfiguration = {
  __typename: 'SteeringWalletConfiguration';
  basis?: Maybe<SteeringWalletBasis>;
  productGroupId?: Maybe<Scalars['OCUUID']['output']>;
  reportingPeriod?: Maybe<SteeringWalletReportingPeriod>;
  unitOfMeasure?: Maybe<Unit_Of_Measure>;
  uuid: Scalars['OCUUID']['output'];
};

export type SteeringWalletConfigurationCreateInput = {
  basis: SteeringWalletBasis;
  productGroupId: Scalars['OCUUID']['input'];
  reportingPeriod: SteeringWalletReportingPeriod;
  unitOfMeasure: Unit_Of_Measure;
};

export type SteeringWalletConnection = {
  __typename: 'SteeringWalletConnection';
  edges: Array<SteeringWalletEdge>;
  pageInfo: PageInfo;
};

export type SteeringWalletCreateInput = {
  chainId: Scalars['OCUUID']['input'];
  configuration: SteeringWalletConfigurationCreateInput;
  name: Scalars['String']['input'];
};

export type SteeringWalletEdge = {
  __typename: 'SteeringWalletEdge';
  cursor: Scalars['OCBase64Cursor']['output'];
  node: SteeringWallet;
};

export type SteeringWalletFilter = {
  chainIdEquals?: InputMaybe<Scalars['OCUUID']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  statusEquals?: InputMaybe<SteeringWalletStatus>;
  uuidContains?: InputMaybe<Array<Scalars['OCUUID']['input']>>;
};

export enum SteeringWalletReportingPeriod {
  NinetyDays = 'NINETY_DAYS',
  ThirtyDays = 'THIRTY_DAYS'
}

export enum SteeringWalletStatus {
  Active = 'ACTIVE',
  Archived = 'ARCHIVED',
  Draft = 'DRAFT'
}

export type SteeringWalletUpdateInput = {
  name: Scalars['String']['input'];
  uuid: Scalars['OCUUID']['input'];
};

export type StoreItem = {
  __typename: 'StoreItem';
  additionalAttributes?: Maybe<Scalars['OCJSON']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  isAgeRestricted?: Maybe<Scalars['Boolean']['output']>;
  itemType?: Maybe<Resource_Item_Type>;
  merchandiseCode?: Maybe<Scalars['String']['output']>;
  posCode?: Maybe<Scalars['String']['output']>;
  posCodeFormat?: Maybe<Scalars['String']['output']>;
  posCodeModifier?: Maybe<Scalars['String']['output']>;
  receiptDescription?: Maybe<Scalars['String']['output']>;
  sku: Scalars['String']['output'];
  taxCode?: Maybe<Scalars['String']['output']>;
  unitOfMeasure?: Maybe<Scalars['String']['output']>;
  unitPrice?: Maybe<ItemPrice>;
  uuid: Scalars['ID']['output'];
};

export type StoreItemConnection = {
  __typename: 'StoreItemConnection';
  edges?: Maybe<Array<Maybe<StoreItemEdge>>>;
  pageInfo: PageInfo;
};

export type StoreItemCreate = {
  additionalAttributes?: InputMaybe<Scalars['OCJSON']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  isAgeRestricted?: InputMaybe<Scalars['Boolean']['input']>;
  itemType?: InputMaybe<Resource_Item_Type>;
  merchandiseCode?: InputMaybe<Scalars['String']['input']>;
  posCode?: InputMaybe<Scalars['String']['input']>;
  posCodeFormat?: InputMaybe<Scalars['String']['input']>;
  posCodeModifier?: InputMaybe<Scalars['String']['input']>;
  receiptDescription?: InputMaybe<Scalars['String']['input']>;
  sku?: InputMaybe<Scalars['String']['input']>;
  taxCode?: InputMaybe<Scalars['String']['input']>;
  unitOfMeasure?: InputMaybe<Scalars['String']['input']>;
  unitPrice?: InputMaybe<ItemPriceCreate>;
  uuid?: InputMaybe<Scalars['ID']['input']>;
};

export type StoreItemEdge = {
  __typename: 'StoreItemEdge';
  cursor: Scalars['ID']['output'];
  node?: Maybe<StoreItem>;
};

export type StoredValueConfig = FeatureConfiguration & {
  __typename: 'StoredValueConfig';
  enabled: Scalars['Boolean']['output'];
};

export type StoredValueExpirationSchedule = {
  __typename: 'StoredValueExpirationSchedule';
  expirationDate: Scalars['OCDate']['output'];
  storedValue: Scalars['Int']['output'];
};

export type StoredValueExpirationScheduleConnection = {
  __typename: 'StoredValueExpirationScheduleConnection';
  edges: Array<StoredValueExpirationScheduleEdge>;
  pageInfo: PageInfo;
};

export type StoredValueExpirationScheduleEdge = {
  __typename: 'StoredValueExpirationScheduleEdge';
  cursor: Scalars['ID']['output'];
  node: StoredValueExpirationSchedule;
};

export type StoredValueProgram = {
  __typename: 'StoredValueProgram';
  chainId: Scalars['ID']['output'];
  discountingOffer: Offer;
  expirationDays?: Maybe<Scalars['Int']['output']>;
  id: Scalars['ID']['output'];
  maxPointsPerConversion?: Maybe<Scalars['Int']['output']>;
  minPointsPerConversion?: Maybe<Scalars['Int']['output']>;
  moneyPerConversion: Scalars['Int']['output'];
  pointsPerConversion: Scalars['Int']['output'];
  programName: Scalars['String']['output'];
};

export type StoredValueProgramConnection = {
  __typename: 'StoredValueProgramConnection';
  edges: Array<StoredValueProgramEdge>;
  pageInfo: PageInfo;
};

export type StoredValueProgramCreateInput = {
  chainId: Scalars['ID']['input'];
  discountingOfferId: Scalars['ID']['input'];
  expirationDays?: InputMaybe<Scalars['Int']['input']>;
  maxPointsPerConversion?: InputMaybe<Scalars['Int']['input']>;
  minPointsPerConversion?: InputMaybe<Scalars['Int']['input']>;
  moneyPerConversion: Scalars['Int']['input'];
  pointsPerConversion: Scalars['Int']['input'];
  programName: Scalars['String']['input'];
};

export type StoredValueProgramEdge = {
  __typename: 'StoredValueProgramEdge';
  cursor: Scalars['ID']['output'];
  node: StoredValueProgram;
};

export type StoredValueProgramFilter = {
  chainIdEquals?: InputMaybe<Scalars['ID']['input']>;
  idEquals?: InputMaybe<Scalars['ID']['input']>;
};

export type StoredValueProgramUpdateInput = {
  chainId?: InputMaybe<Scalars['ID']['input']>;
  discountingOfferId?: InputMaybe<Scalars['ID']['input']>;
  expirationDays?: InputMaybe<Scalars['Int']['input']>;
  id: Scalars['ID']['input'];
  maxPointsPerConversion?: InputMaybe<Scalars['Int']['input']>;
  minPointsPerConversion?: InputMaybe<Scalars['Int']['input']>;
  moneyPerConversion?: InputMaybe<Scalars['Int']['input']>;
  pointsPerConversion?: InputMaybe<Scalars['Int']['input']>;
  programName?: InputMaybe<Scalars['String']['input']>;
};

export type StoredValueTransaction = {
  __typename: 'StoredValueTransaction';
  createdAt: Scalars['OCDateTime']['output'];
  id: Scalars['ID']['output'];
  membershipId: Scalars['ID']['output'];
  quantity: Scalars['Int']['output'];
  source?: Maybe<StoredValueTransactionSource>;
  sourceType?: Maybe<StoredValueTransactionSourceType>;
};

export type StoredValueTransactionSource = ActivateTransaction | PointChange;

export enum StoredValueTransactionSourceType {
  PointChange = 'POINT_CHANGE',
  Transaction = 'TRANSACTION'
}

export type StringFilter = {
  caseInsensitive?: InputMaybe<Scalars['Boolean']['input']>;
  contains?: InputMaybe<Scalars['String']['input']>;
  isEqualTo?: InputMaybe<Scalars['String']['input']>;
  isIn?: InputMaybe<Array<Scalars['String']['input']>>;
  isNotEqualTo?: InputMaybe<Scalars['String']['input']>;
  isNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull?: InputMaybe<Scalars['Boolean']['input']>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  notContains?: InputMaybe<Scalars['String']['input']>;
};

export type SubBrand = {
  __typename: 'SubBrand';
  codeName: Scalars['String']['output'];
  createdAt: Scalars['OCDateTime']['output'];
  experienceUrl?: Maybe<Scalars['OCURL']['output']>;
  name: Scalars['String']['output'];
  uuid: Scalars['OCUUID']['output'];
};

export type SubBrandConfiguration = {
  __typename: 'SubBrandConfiguration';
  referralCodeManualEntryEnabled: Scalars['Boolean']['output'];
  referralProgramEnabled: Scalars['Boolean']['output'];
  subBrandUuid: Scalars['ID']['output'];
};

export type SubBrandConnection = {
  __typename: 'SubBrandConnection';
  edges: Array<SubBrandEdge>;
  pageInfo: PageInfo;
};

export type SubBrandEdge = {
  __typename: 'SubBrandEdge';
  cursor: Scalars['OCBase64Cursor']['output'];
  node: SubBrand;
};

export type SubBrandFilter = {
  codeNameEquals?: InputMaybe<Scalars['String']['input']>;
  nameEquals?: InputMaybe<Scalars['String']['input']>;
  uuidEquals?: InputMaybe<Scalars['OCUUID']['input']>;
};

export type SubBrandFilterInput = {
  subBrandUuids: Array<Scalars['String']['input']>;
};

export type SubBrandsConfig = FeatureConfiguration & {
  __typename: 'SubBrandsConfig';
  enabled: Scalars['Boolean']['output'];
  list?: Maybe<Array<SubBrand>>;
};

export type SubmittedStoresStatistics = {
  __typename: 'SubmittedStoresStatistics';
  totalStores: Scalars['Int']['output'];
  totalSubmittedStores: Scalars['Int']['output'];
};

export type Subscription = {
  __typename: 'Subscription';
  driveSubscribeToConversation: DriveResponseChunk;
};


export type SubscriptionDriveSubscribeToConversationArgs = {
  conversationId: Scalars['ID']['input'];
};

export type Survey = {
  audienceUuid: Scalars['OCUUID']['output'];
  award?: Maybe<AwardPointsOrVouchers>;
  chainId: Scalars['OCUUID']['output'];
  createdAt: Scalars['OCDateTime']['output'];
  deletedAt?: Maybe<Scalars['OCDateTime']['output']>;
  questions: Array<SurveyQuestion>;
  status: SurveyStatus;
  uuid: Scalars['OCUUID']['output'];
};

export type SurveyAnswer = {
  __typename: 'SurveyAnswer';
  answer: Scalars['String']['output'];
  questions: Array<SurveyQuestion>;
  survey: Survey;
  uuid: Scalars['OCUUID']['output'];
};

export type SurveyAnswerInput = {
  multipleChoice?: InputMaybe<SurveyAnswerMultipleChoiceInput>;
  singleChoice?: InputMaybe<SurveyAnswerSingleChoiceInput>;
  slider?: InputMaybe<SurveyAnswerIntSliderInput>;
};

export type SurveyAnswerIntSliderInput = {
  value: Scalars['Int']['input'];
};

export type SurveyAnswerMultipleChoiceInput = {
  optionUuids: Array<Scalars['OCUUID']['input']>;
};

export type SurveyAnswerSingleChoiceInput = {
  optionUuid: Scalars['OCUUID']['input'];
};

export type SurveyAnswerSubmitInput = {
  fields: Array<SurveyFieldInput>;
  memberUuid: Scalars['OCUUID']['input'];
  questionUuid: Scalars['OCUUID']['input'];
};

export type SurveyAnswersConnection = {
  __typename: 'SurveyAnswersConnection';
  edges: Array<SurveyAnswersEdge>;
  pageInfo: PageInfo;
};

export type SurveyAnswersEdge = {
  __typename: 'SurveyAnswersEdge';
  cursor: Scalars['OCBase64Cursor']['output'];
  node: SurveyAnswer;
};

export type SurveyAnswersSubmitInput = {
  answers: Array<SurveyQuestionAnswerInput>;
  memberUuid: Scalars['OCUUID']['input'];
};

export type SurveyConnection = {
  __typename: 'SurveyConnection';
  edges: Array<SurveyEdge>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type SurveyDeployInput = {
  audienceUuid: Scalars['OCUUID']['input'];
  channel: SurveyDeploymentChannel;
  rolloutType: SurveyDeploymentRolloutType;
  surveyUuid: Scalars['OCUUID']['input'];
};

export type SurveyDeployment = {
  __typename: 'SurveyDeployment';
  configuration: SurveyDeploymentConfiguration;
  createdAt: Scalars['OCDateTime']['output'];
  status: SurveyDeploymentStatus;
  uuid: Scalars['OCUUID']['output'];
};

export enum SurveyDeploymentChannel {
  Experience = 'EXPERIENCE'
}

export type SurveyDeploymentConfiguration = {
  __typename: 'SurveyDeploymentConfiguration';
  channel?: Maybe<SurveyDeploymentChannel>;
  rolloutType?: Maybe<SurveyDeploymentRolloutType>;
};

export type SurveyDeploymentConnection = {
  __typename: 'SurveyDeploymentConnection';
  edges: Array<SurveyDeploymentEdge>;
  pageInfo: PageInfo;
};

export type SurveyDeploymentEdge = {
  __typename: 'SurveyDeploymentEdge';
  cursor: Scalars['OCBase64Cursor']['output'];
  node: SurveyDeployment;
};

export enum SurveyDeploymentRolloutType {
  AtDeployment = 'AT_DEPLOYMENT',
  OpenEnded = 'OPEN_ENDED'
}

export enum SurveyDeploymentStatus {
  Cancelled = 'CANCELLED',
  Completed = 'COMPLETED',
  Creating = 'CREATING',
  Deployed = 'DEPLOYED',
  Publishing = 'PUBLISHING'
}

export type SurveyDismissInput = {
  memberUuid: Scalars['OCUUID']['input'];
  surveyUuid: Scalars['OCUUID']['input'];
};

export type SurveyEdge = {
  __typename: 'SurveyEdge';
  cursor: Scalars['OCBase64Cursor']['output'];
  node: Survey;
};

export type SurveyEngagementCounter = {
  __typename: 'SurveyEngagementCounter';
  count: Scalars['Int']['output'];
  date: Scalars['OCDateTime']['output'];
};

export type SurveyEngagementMetrics = {
  __typename: 'SurveyEngagementMetrics';
  counters: Array<SurveyEngagementCounter>;
  dailyAverageCount: Scalars['Float']['output'];
  totalCount: Scalars['Int']['output'];
};

export type SurveyField = {
  label: Scalars['String']['output'];
  uuid: Scalars['OCUUID']['output'];
};

export type SurveyFieldInput = {
  answer: Scalars['String']['input'];
  uuid: Scalars['OCUUID']['input'];
};

export type SurveyFieldIntSlider = SurveyField & {
  __typename: 'SurveyFieldIntSlider';
  configuration: SurveyFieldIntSliderConfiguration;
  label: Scalars['String']['output'];
  uuid: Scalars['OCUUID']['output'];
};

export type SurveyFieldIntSliderConfiguration = {
  __typename: 'SurveyFieldIntSliderConfiguration';
  max: Scalars['Int']['output'];
  min: Scalars['Int']['output'];
};

export type SurveyFilter = {
  chainIdEquals?: InputMaybe<Scalars['OCUUID']['input']>;
  includeBasedOnAggregatedAudience?: InputMaybe<Scalars['Boolean']['input']>;
  includeDismissed?: InputMaybe<Scalars['Boolean']['input']>;
  memberUuidEquals?: InputMaybe<Scalars['OCUUID']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  statusEquals?: InputMaybe<SurveyStatus>;
  typeEquals?: InputMaybe<Survey_Type>;
  uuidContains?: InputMaybe<Array<Scalars['OCUUID']['input']>>;
  walletUuidEquals?: InputMaybe<Scalars['OCUUID']['input']>;
};

export type SurveyLocationStatistics = {
  __typename: 'SurveyLocationStatistics';
  bottomResponse: Scalars['String']['output'];
  bottomResponsePercentage: Scalars['Int']['output'];
  responseStatistics: SurveyQuestionResponseStatistics;
  siteId: Scalars['String']['output'];
  siteName: Scalars['String']['output'];
  surveyUuid: Scalars['OCUUID']['output'];
  topResponse: Scalars['String']['output'];
  topResponsePercentage: Scalars['Int']['output'];
  totalResponses: Scalars['Int']['output'];
};

export type SurveyLocationStatisticsConnection = {
  __typename: 'SurveyLocationStatisticsConnection';
  edges: Array<SurveyLocationStatisticsEdge>;
  pageInfo: PageInfo;
};

export type SurveyLocationStatisticsEdge = {
  __typename: 'SurveyLocationStatisticsEdge';
  cursor: Scalars['OCBase64Cursor']['output'];
  node: SurveyLocationStatistics;
};

export type SurveyLocationStatisticsFilter = {
  locationUuidContains?: InputMaybe<Array<Scalars['OCUUID']['input']>>;
  surveyUuidEquals: Scalars['OCUUID']['input'];
};

export type SurveyLocationStatisticsSort = {
  direction: Sort_Order;
  field: Survey_Location_Statistics_Sort_By;
};

export type SurveyMetrics = {
  __typename: 'SurveyMetrics';
  responses: SurveyEngagementMetrics;
  views: SurveyEngagementMetrics;
};

export type SurveyMetricsFilter = {
  dateRange?: InputMaybe<DateRangeInput>;
  locationUuidContains?: InputMaybe<Array<Scalars['OCUUID']['input']>>;
  period: Survey_Metrics_Period;
  surveyUuidEquals: Scalars['OCUUID']['input'];
};

export type SurveyOfferCreateInput = {
  awardPoints?: InputMaybe<AwardPointsInput>;
  awardVouchers?: InputMaybe<AwardVouchersInput>;
  chainId: Scalars['ID']['input'];
  surveyUuid: Scalars['ID']['input'];
};

export type SurveyOfferCreateOrUpdateInput = {
  awardPoints?: InputMaybe<AwardPointsInput>;
  awardVouchers?: InputMaybe<AwardVouchersInput>;
  chainId: Scalars['ID']['input'];
  surveyUuid: Scalars['ID']['input'];
};

export type SurveyOfferUpdateInput = {
  awardPoints?: InputMaybe<AwardPointsInput>;
  awardVouchers?: InputMaybe<AwardVouchersInput>;
  chainId: Scalars['ID']['input'];
  surveyUuid: Scalars['ID']['input'];
};

export type SurveyQuestion = {
  /** @deprecated Use the options field instead. This field will be removed in the future. */
  fields: Array<SurveyField>;
  index: Scalars['Int']['output'];
  questionText: Scalars['String']['output'];
  uuid: Scalars['OCUUID']['output'];
};

export type SurveyQuestionAnswerInput = {
  answer: SurveyAnswerInput;
  uuid: Scalars['OCUUID']['input'];
};

export type SurveyQuestionConfigurationInput = {
  multipleChoice?: InputMaybe<SurveyQuestionMultipleChoiceConfigurationInput>;
  singleChoice?: InputMaybe<SurveyQuestionSingleChoiceConfigurationInput>;
  slider?: InputMaybe<SurveyQuestionSliderConfigurationInput>;
};

export type SurveyQuestionIntSlider = SurveyQuestion & {
  __typename: 'SurveyQuestionIntSlider';
  /** @deprecated Use the options field instead. This field will be removed in the future. */
  fields: Array<SurveyField>;
  index: Scalars['Int']['output'];
  max: Scalars['Int']['output'];
  min: Scalars['Int']['output'];
  questionText: Scalars['String']['output'];
  uuid: Scalars['OCUUID']['output'];
};

export type SurveyQuestionMultipleChoice = SurveyQuestion & {
  __typename: 'SurveyQuestionMultipleChoice';
  /** @deprecated Use the options field instead. This field will be removed in the future. */
  fields: Array<SurveyField>;
  index: Scalars['Int']['output'];
  options: Array<SurveyQuestionOption>;
  questionText: Scalars['String']['output'];
  uuid: Scalars['OCUUID']['output'];
};

export type SurveyQuestionMultipleChoiceConfigurationInput = {
  options: Array<Scalars['String']['input']>;
};

export type SurveyQuestionOption = {
  __typename: 'SurveyQuestionOption';
  index: Scalars['Int']['output'];
  label: Scalars['String']['output'];
  uuid: Scalars['OCUUID']['output'];
};

export type SurveyQuestionResponseStatistics = {
  __typename: 'SurveyQuestionResponseStatistics';
  locationUuid?: Maybe<Scalars['OCUUID']['output']>;
  optionSelectionCounters: Array<OptionSelectionCount>;
  sliderResponseRanges: Array<SliderResponseRange>;
};

export type SurveyQuestionSingleChoice = SurveyQuestion & {
  __typename: 'SurveyQuestionSingleChoice';
  /** @deprecated Use the options field instead. This field will be removed in the future. */
  fields: Array<SurveyField>;
  index: Scalars['Int']['output'];
  options: Array<SurveyQuestionOption>;
  questionText: Scalars['String']['output'];
  uuid: Scalars['OCUUID']['output'];
};

export type SurveyQuestionSingleChoiceConfigurationInput = {
  options: Array<Scalars['String']['input']>;
};

export type SurveyQuestionSliderConfigurationInput = {
  max: Scalars['Int']['input'];
  min: Scalars['Int']['input'];
};

export enum SurveyStatus {
  Active = 'ACTIVE',
  Archived = 'ARCHIVED',
  Draft = 'DRAFT',
  Expired = 'EXPIRED'
}

export type SurveyViewsCreateInput = {
  memberUuid: Scalars['OCUUID']['input'];
  surveyUuids: Array<Scalars['OCUUID']['input']>;
};

export enum Temp_Rmq_Conexxus_Loyalty_Discount_Method {
  AmountOff = 'amountOff',
  AmountOffPpu = 'amountOffPPU',
  NewPrice = 'newPrice',
  PercentOff = 'percentOff'
}

export enum Temp_Rmq_Conexxus_Loyalty_Reward_Limit_Type {
  Quantity = 'quantity',
  Volume = 'volume'
}

export enum Time_Period {
  Day = 'DAY',
  Month = 'MONTH',
  Week = 'WEEK'
}

export enum Time_Since_Last_Visit_Operator {
  IsEqualTo = 'IS_EQUAL_TO',
  IsGreaterThan = 'IS_GREATER_THAN',
  IsGreaterThanOrEqualTo = 'IS_GREATER_THAN_OR_EQUAL_TO',
  IsLessThan = 'IS_LESS_THAN',
  IsLessThanOrEqualTo = 'IS_LESS_THAN_OR_EQUAL_TO'
}

export enum Time_Since_Membership_Acquisition_Operator {
  IsEqualTo = 'IS_EQUAL_TO',
  IsGreaterThan = 'IS_GREATER_THAN',
  IsGreaterThanOrEqualTo = 'IS_GREATER_THAN_OR_EQUAL_TO',
  IsLessThan = 'IS_LESS_THAN',
  IsLessThanOrEqualTo = 'IS_LESS_THAN_OR_EQUAL_TO'
}

export enum Transactions_Sort_By {
  AmountPrice = 'AMOUNT_PRICE',
  CreatedAt = 'CREATED_AT',
  PrimaryStatus = 'PRIMARY_STATUS',
  SecondaryStatus = 'SECONDARY_STATUS',
  StartedAt = 'STARTED_AT'
}

export enum Transactions_Sort_Order {
  Asc = 'ASC',
  Desc = 'DESC'
}

export enum Transaction_Event_Type {
  Auth = 'AUTH',
  FullRefund = 'FULL_REFUND',
  InvalidAction = 'INVALID_ACTION',
  PartialRefund = 'PARTIAL_REFUND',
  PreAuth = 'PRE_AUTH',
  Settled = 'SETTLED',
  Void = 'VOID'
}

export enum Transaction_Status {
  Active = 'ACTIVE',
  Blocked = 'BLOCKED',
  Canceled = 'CANCELED',
  Closed = 'CLOSED',
  CompletedFailedAuthorization = 'COMPLETED_FAILED_AUTHORIZATION',
  CompletedFailedOnReceipt = 'COMPLETED_FAILED_ON_RECEIPT',
  CompletedFailedSettlement = 'COMPLETED_FAILED_SETTLEMENT',
  CompletedFailedToEnablePump = 'COMPLETED_FAILED_TO_ENABLE_PUMP',
  CompletedFailedToReservePump = 'COMPLETED_FAILED_TO_RESERVE_PUMP',
  Expired = 'EXPIRED',
  Failed = 'FAILED',
  FullReversal = 'FULL_REVERSAL',
  FullReversalPending = 'FULL_REVERSAL_PENDING',
  Open = 'OPEN',
  PartialPayment = 'PARTIAL_PAYMENT',
  PartialRefundTransaction = 'PARTIAL_REFUND_TRANSACTION',
  Pending = 'PENDING',
  PendingRefundReceipt = 'PENDING_REFUND_RECEIPT',
  Processing = 'PROCESSING',
  ReceiptPending = 'RECEIPT_PENDING',
  RefundPending = 'REFUND_PENDING',
  RefundTransaction = 'REFUND_TRANSACTION',
  Start = 'START',
  Unclaimed = 'UNCLAIMED',
  Unknown = 'UNKNOWN',
  VoidPending = 'VOID_PENDING',
  VoidTransaction = 'VOID_TRANSACTION'
}

export enum Transaction_Type {
  AtPump = 'AT_PUMP',
  InStore = 'IN_STORE',
  KioskInStore = 'KIOSK_IN_STORE'
}

export enum Triggered_Message_Status {
  Disabled = 'DISABLED',
  Enabled = 'ENABLED'
}

export type TempRmqAddReward = {
  __typename: 'TempRMQAddReward';
  loyaltyRewardId: Scalars['String']['output'];
  rewardDiscountMethod: Temp_Rmq_Conexxus_Loyalty_Discount_Method;
  rewardLimit?: Maybe<TempRmqRewardLimit>;
  rewardReceiptDescLong?: Maybe<Scalars['String']['output']>;
  rewardReceiptDescShort?: Maybe<Scalars['String']['output']>;
  rewardTargetLineNumber: Scalars['Int']['output'];
  rewardValue: Scalars['Float']['output'];
};

export type TempRmqFinalizeRewardsRequestContainerInput = {
  brandUuid: Scalars['ID']['input'];
  containerUuid: Scalars['ID']['input'];
  locationUuid: Scalars['ID']['input'];
  messageData: TempRmqFinalizeRewardsRequestInput;
  messageType: Scalars['String']['input'];
  messageVersion?: InputMaybe<Scalars['String']['input']>;
  nodeId?: InputMaybe<Scalars['String']['input']>;
  qosDetails: TempRmqQosDetailsInput;
  typename: Scalars['String']['input'];
};

export type TempRmqFinalizeRewardsRequestInput = {
  loyaltySequenceId: Scalars['String']['input'];
  membershipPhone: Scalars['String']['input'];
  posTransactionId: Scalars['String']['input'];
  storeLocationId: Scalars['String']['input'];
  transactionLineItems: Array<TempRmqFinalizeTransactionLineItemInput>;
  transactionTime: Scalars['String']['input'];
};

export type TempRmqFinalizeTransactionLineItemInput = {
  group?: InputMaybe<Scalars['String']['input']>;
  lineNumber: Scalars['Int']['input'];
  posCode?: InputMaybe<Scalars['String']['input']>;
  promotion: Array<TempRmqLineItemPromotionInput>;
  salesAmount: Scalars['Float']['input'];
  salesQuantity: Scalars['Float']['input'];
  sku?: InputMaybe<Scalars['String']['input']>;
  upc?: InputMaybe<Scalars['String']['input']>;
};

export type TempRmqFuelPriceDataInput = {
  fuelGradeId?: InputMaybe<Scalars['String']['input']>;
  priceTierCode?: InputMaybe<Scalars['Int']['input']>;
  regularSellPrice?: InputMaybe<Scalars['Float']['input']>;
};

export type TempRmqGetRewardsRequestContainerInput = {
  brandUuid: Scalars['ID']['input'];
  containerUuid: Scalars['ID']['input'];
  locationUuid: Scalars['ID']['input'];
  messageData: TempRmqGetRewardsRequestInput;
  messageType: Scalars['String']['input'];
  messageVersion?: InputMaybe<Scalars['String']['input']>;
  nodeId?: InputMaybe<Scalars['String']['input']>;
  qosDetails: TempRmqQosDetailsInput;
  typename: Scalars['String']['input'];
};

export type TempRmqGetRewardsRequestInput = {
  fuelPriceData: Array<TempRmqFuelPriceDataInput>;
  loyaltySequenceId: Scalars['String']['input'];
  membershipPhone: Scalars['String']['input'];
  posTransactionId: Scalars['String']['input'];
  storeLocationId: Scalars['String']['input'];
  transactionLineItems: Array<TempRmqTransactionLineItemInput>;
  transactionTime: Scalars['String']['input'];
};

export type TempRmqGetRewardsResponse = {
  __typename: 'TempRMQGetRewardsResponse';
  addRewards: Array<TempRmqAddReward>;
  loyaltySequenceId: Scalars['String']['output'];
  posTransactionId: Scalars['String']['output'];
  storeLocationId: Scalars['ID']['output'];
};

export type TempRmqGetRewardsResponseContainer = {
  __typename: 'TempRMQGetRewardsResponseContainer';
  containerUuid: Scalars['ID']['output'];
  messageData?: Maybe<TempRmqGetRewardsResponse>;
  messageType: Scalars['String']['output'];
  messageVersion?: Maybe<Scalars['String']['output']>;
  nodeId?: Maybe<Scalars['String']['output']>;
  qosDetails: TempRmqQosDetails;
  typename: Scalars['String']['output'];
};

export type TempRmqLineItemPromotionInput = {
  loyaltyRewardId: Scalars['String']['input'];
  promotionAmount: Scalars['Float']['input'];
};

export type TempRmqQosDetails = {
  __typename: 'TempRMQQosDetails';
  createdTimestamp: Scalars['String']['output'];
  processingTime?: Maybe<Scalars['Int']['output']>;
  receivedTimestamp?: Maybe<Scalars['String']['output']>;
  transmitTimestamp: Scalars['String']['output'];
};

export type TempRmqQosDetailsInput = {
  createdTimestamp: Scalars['String']['input'];
  processingTime?: InputMaybe<Scalars['Int']['input']>;
  receivedTimestamp?: InputMaybe<Scalars['String']['input']>;
  transmitTimestamp: Scalars['String']['input'];
};

export type TempRmqRewardLimit = {
  __typename: 'TempRMQRewardLimit';
  type?: Maybe<Temp_Rmq_Conexxus_Loyalty_Reward_Limit_Type>;
  value?: Maybe<Scalars['Float']['output']>;
};

export type TempRmqTransactionLineItemInput = {
  fuelGradeId?: InputMaybe<Scalars['String']['input']>;
  group?: InputMaybe<Scalars['String']['input']>;
  isPrepaid?: InputMaybe<Scalars['Boolean']['input']>;
  lineNumber: Scalars['Int']['input'];
  posCode?: InputMaybe<Scalars['String']['input']>;
  salesAmount: Scalars['Float']['input'];
  salesQuantity: Scalars['Float']['input'];
  sku?: InputMaybe<Scalars['String']['input']>;
  upc?: InputMaybe<Scalars['String']['input']>;
};

export type Tenant = {
  __typename: 'Tenant';
  name: Scalars['String']['output'];
};

export type TestMessageTemplateInput = {
  pushNotificationTemplate?: InputMaybe<PushNotificationTemplateInput>;
  smsBody?: InputMaybe<Scalars['OCLiquid']['input']>;
};

export type TimeSeriesDataPoint = {
  __typename: 'TimeSeriesDataPoint';
  date: Scalars['OCDate']['output'];
  value: Scalars['Float']['output'];
};

export type TimeSeriesMetric = {
  __typename: 'TimeSeriesMetric';
  date: Scalars['OCDateTime']['output'];
  value: Scalars['Int']['output'];
};

export type TimeWindow = {
  __typename: 'TimeWindow';
  timeWindow: Audience_Purchase_Time_Window;
};

export type TimeWindowInput = {
  timeWindow: Audience_Purchase_Time_Window;
};

export type TimestampFilter = {
  isBetween?: InputMaybe<IsTimestampBetween>;
  isEqualTo?: InputMaybe<Scalars['OCDateTime']['input']>;
  isGreaterThan?: InputMaybe<Scalars['OCDateTime']['input']>;
  isGreaterThanOrEqualTo?: InputMaybe<Scalars['OCDateTime']['input']>;
  isLessThan?: InputMaybe<Scalars['OCDateTime']['input']>;
  isLessThanOrEqualTo?: InputMaybe<Scalars['OCDateTime']['input']>;
  isNotBetween?: InputMaybe<IsTimestampBetween>;
  isNotEqualTo?: InputMaybe<Scalars['OCDateTime']['input']>;
  isNotNull?: InputMaybe<Scalars['Boolean']['input']>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
};

export enum TobaccoOfferType {
  Loyalty = 'LOYALTY',
  MultiUnit = 'MULTI_UNIT'
}

export type Tokens = {
  __typename: 'Tokens';
  accessToken: Scalars['String']['output'];
  refreshToken: Scalars['String']['output'];
};

export type TotalAvailableRollback = {
  __typename: 'TotalAvailableRollback';
  fuelProductGroup?: Maybe<FuelProductGroup>;
  locationName?: Maybe<Scalars['String']['output']>;
  locationUuid?: Maybe<Scalars['ID']['output']>;
  moneyAmount: Scalars['Int']['output'];
  offers?: Maybe<Array<Offer>>;
};

export type TotalAvailableRollbackFilter = {
  subBrandId?: InputMaybe<Scalars['String']['input']>;
};

export type Touchpoint = FeatureConfiguration & {
  __typename: 'Touchpoint';
  enabled: Scalars['Boolean']['output'];
};

export type TrackingConfig = {
  __typename: 'TrackingConfig';
  isActivityLogIncludedInAltriaDDM: Scalars['Boolean']['output'];
  trackingId: Scalars['ID']['output'];
};

export type TrackingConfigInput = {
  isActivityLogIncludedInAltriaDDM: Scalars['Boolean']['input'];
  trackingId: Scalars['ID']['input'];
};

export type Transaction = {
  __typename: 'Transaction';
  additionalReceiptData?: Maybe<Scalars['OCJSON']['output']>;
  amount?: Maybe<ItemPrice>;
  authCode?: Maybe<Scalars['String']['output']>;
  brandSpecificLocationId?: Maybe<Scalars['String']['output']>;
  completedAt?: Maybe<Scalars['OCDateTime']['output']>;
  createdAt: Scalars['OCDateTime']['output'];
  currency: Currency;
  customer?: Maybe<TransactionCustomer>;
  customerUuid?: Maybe<Scalars['ID']['output']>;
  fraudCheckStatus: FraudCheckStatus;
  fuelPumpStatus?: Maybe<Fuel_Pump_Status>;
  fuelReceipt?: Maybe<FuelReceipt>;
  fuelingPosition?: Maybe<Scalars['String']['output']>;
  hardwareVendor?: Maybe<Hardware_Vendor>;
  initiationResource?: Maybe<Location_Resource_Type>;
  isPaymentProcessedExternally: Scalars['Boolean']['output'];
  items?: Maybe<Array<Maybe<TransactionItem>>>;
  lastUpdatedAt: Scalars['OCDateTime']['output'];
  location?: Maybe<Location>;
  loyaltyInstruments?: Maybe<Array<Maybe<LoyaltyInstrument>>>;
  loyaltyLevel?: Maybe<Loyalty_Level>;
  paymentEvents?: Maybe<Array<Maybe<TransactionPaymentEvent>>>;
  paymentInfo?: Maybe<Array<Maybe<TransactionPaymentInfo>>>;
  paymentInstrumentType?: Maybe<Payment_Instrument_Type>;
  paymentLevel?: Maybe<Payment_Level>;
  posTransactionNumber?: Maybe<Scalars['ID']['output']>;
  preAuthAmount?: Maybe<ItemPrice>;
  primaryStatus: Primary_Transaction_Status;
  rawReceipt?: Maybe<Scalars['String']['output']>;
  receiptLines?: Maybe<Array<Maybe<ReceiptLine>>>;
  secondaryStatus: Secondary_Transaction_Status;
  sourceId?: Maybe<Scalars['ID']['output']>;
  stac?: Maybe<Stac>;
  startedAt: Scalars['OCDateTime']['output'];
  stateChanges?: Maybe<Array<Maybe<TransactionStateChange>>>;
  /** @deprecated Use primaryStatus and secondaryStatus */
  status?: Maybe<Transaction_Status>;
  tax?: Maybe<ItemPrice>;
  transactionType: Transaction_Type;
  umti?: Maybe<Scalars['String']['output']>;
  uuid: Scalars['ID']['output'];
};

export type TransactionAppConfig = {
  __typename: 'TransactionAppConfig';
  mobileTransactionFraudCheck?: Maybe<MobileTransactionFraudCheck>;
};

export type TransactionConnection = {
  __typename: 'TransactionConnection';
  edges?: Maybe<Array<Maybe<TransactionEdge>>>;
  pageInfo: PageInfo;
};

export type TransactionCustomer = {
  __typename: 'TransactionCustomer';
  phoneNumber: Scalars['OCPhoneNumber']['output'];
  uuid: Scalars['ID']['output'];
};

export type TransactionDiscountAwards = AwardTransactionMoneyDiscount | AwardTransactionPercentDiscount;

export type TransactionEdge = {
  __typename: 'TransactionEdge';
  cursor: Scalars['ID']['output'];
  node?: Maybe<Transaction>;
};

export type TransactionExternalPaymentStart = {
  amount: ItemPriceInput;
  authCode: Scalars['String']['input'];
  carWash?: InputMaybe<CarWashInput>;
  cardType?: InputMaybe<Scalars['String']['input']>;
  currency: CurrencyInput;
  fuelingPosition: Scalars['String']['input'];
  locationUuid: Scalars['ID']['input'];
  loyaltyId?: InputMaybe<Scalars['String']['input']>;
  loyaltySequenceId?: InputMaybe<Scalars['String']['input']>;
  paymentMethod?: InputMaybe<Payment_Method>;
  posTransactionId?: InputMaybe<Scalars['String']['input']>;
  prepayFuelRewards?: InputMaybe<Array<ActivateAddRewardInput>>;
  printReceipt?: InputMaybe<Scalars['Boolean']['input']>;
  promptForCarWash?: InputMaybe<Scalars['Boolean']['input']>;
  siteId: Scalars['String']['input'];
  transactionType: Transaction_Type;
};

export type TransactionFilter = {
  amountMax?: InputMaybe<Scalars['Float']['input']>;
  amountMin?: InputMaybe<Scalars['Float']['input']>;
  authCodeContains?: InputMaybe<Scalars['String']['input']>;
  authCodeEquals?: InputMaybe<Scalars['String']['input']>;
  brandSpecificLocationIdEquals?: InputMaybe<Scalars['String']['input']>;
  cityEquals?: InputMaybe<Scalars['String']['input']>;
  completedAtMax?: InputMaybe<Scalars['OCDateTime']['input']>;
  completedAtMin?: InputMaybe<Scalars['OCDateTime']['input']>;
  completionRange?: InputMaybe<CompletionRange>;
  createdAtMax?: InputMaybe<Scalars['OCDateTime']['input']>;
  createdAtMin?: InputMaybe<Scalars['OCDateTime']['input']>;
  customerUuidEquals?: InputMaybe<Scalars['ID']['input']>;
  fraudCheckStatus?: InputMaybe<FraudCheckStatusFilter>;
  items?: InputMaybe<ResourceItemFilter>;
  lastUpdatedAtMax?: InputMaybe<Scalars['OCDateTime']['input']>;
  lastUpdatedAtMin?: InputMaybe<Scalars['OCDateTime']['input']>;
  locationUuidEquals?: InputMaybe<Scalars['ID']['input']>;
  locationUuids?: InputMaybe<Array<Scalars['OCUUID']['input']>>;
  paymentInfo?: InputMaybe<TransactionPaymentInfoFilter>;
  phoneNumber?: InputMaybe<Scalars['OCPhoneNumber']['input']>;
  primaryStatusContains?: InputMaybe<Array<InputMaybe<Primary_Transaction_Status>>>;
  primaryStatusEquals?: InputMaybe<Primary_Transaction_Status>;
  secondaryStatusContains?: InputMaybe<Array<InputMaybe<Secondary_Transaction_Status>>>;
  secondaryStatusEquals?: InputMaybe<Secondary_Transaction_Status>;
  startedAtMax?: InputMaybe<Scalars['OCDateTime']['input']>;
  startedAtMin?: InputMaybe<Scalars['OCDateTime']['input']>;
  stateEquals?: InputMaybe<Scalars['String']['input']>;
  statusContains?: InputMaybe<Array<InputMaybe<Transaction_Status>>>;
  statusEquals?: InputMaybe<Transaction_Status>;
  uuidEquals?: InputMaybe<Scalars['ID']['input']>;
};

export type TransactionFraudCheckResult = KountFraudCheckResult;

export type TransactionItem = {
  __typename: 'TransactionItem';
  amount?: Maybe<ItemPrice>;
  discountApplied?: Maybe<ItemPrice>;
  discountDescription?: Maybe<Scalars['String']['output']>;
  itemDescription?: Maybe<Scalars['String']['output']>;
  qty?: Maybe<Scalars['Float']['output']>;
  refundedAmount?: Maybe<ItemPrice>;
  resourceItem?: Maybe<ResourceItem>;
  tax?: Maybe<ItemPrice>;
};

export type TransactionLineItemInput = {
  productCode?: InputMaybe<Scalars['String']['input']>;
  productDescription?: InputMaybe<Scalars['String']['input']>;
  quantity?: InputMaybe<Scalars['Float']['input']>;
  unitPrice?: InputMaybe<Scalars['Float']['input']>;
};

export type TransactionPaymentEvent = {
  __typename: 'TransactionPaymentEvent';
  completedAt?: Maybe<Scalars['OCDateTime']['output']>;
  paymentInformation?: Maybe<Scalars['OCJSON']['output']>;
  posResponseCode?: Maybe<Scalars['String']['output']>;
  processorResponseCode?: Maybe<Scalars['String']['output']>;
  reasonDescription: Scalars['String']['output'];
  success: Scalars['Boolean']['output'];
  transactionEventType?: Maybe<Transaction_Event_Type>;
  uuid: Scalars['ID']['output'];
};

export type TransactionPaymentInfo = {
  __typename: 'TransactionPaymentInfo';
  cardCircuit?: Maybe<Scalars['String']['output']>;
  cardPANPrint?: Maybe<Scalars['String']['output']>;
  cardType?: Maybe<Scalars['String']['output']>;
  hostAuthNumber?: Maybe<Scalars['String']['output']>;
  paymentMethod?: Maybe<Payment_Method>;
  preAuthAmount?: Maybe<Scalars['Float']['output']>;
};

export type TransactionPaymentInfoFilter = {
  cardCircuitEquals?: InputMaybe<Scalars['String']['input']>;
  cardPANPrintEquals?: InputMaybe<Scalars['String']['input']>;
  cardTypeEquals?: InputMaybe<Scalars['String']['input']>;
  hostAuthNumberEquals?: InputMaybe<Scalars['String']['input']>;
  paymentMethodEquals?: InputMaybe<Payment_Method>;
};

export type TransactionPaymentTokenInput = {
  /** @deprecated Replaced by applePayPayment but remains for the older clients backward compatibility. */
  applePay?: InputMaybe<Scalars['String']['input']>;
  applePayPayment?: InputMaybe<Scalars['String']['input']>;
  googlePay?: InputMaybe<Scalars['String']['input']>;
};

export type TransactionSort = {
  direction: Transactions_Sort_Order;
  field: Transactions_Sort_By;
};

export type TransactionStateChange = {
  __typename: 'TransactionStateChange';
  primaryStatus: Primary_Transaction_Status;
  secondaryStatus: Secondary_Transaction_Status;
  updatedAt: Scalars['OCDateTime']['output'];
};

export type TriggerPreferences = {
  __typename: 'TriggerPreferences';
  triggerOnFulfillment: Scalars['Boolean']['output'];
  triggerOnProgress: Scalars['Boolean']['output'];
  triggerOnVisibility: Scalars['Boolean']['output'];
};

export type TriggerPreferencesInput = {
  triggerOnFulfillment?: InputMaybe<Scalars['Boolean']['input']>;
  triggerOnProgress?: InputMaybe<Scalars['Boolean']['input']>;
  triggerOnVisibility?: InputMaybe<Scalars['Boolean']['input']>;
};

export type TriggerVisibilityNotificationsInput = {
  offerId: Scalars['ID']['input'];
};

export type TriggeredMessage = {
  __typename: 'TriggeredMessage';
  channelsConfig?: Maybe<ChannelsConfig>;
  createdAt: Scalars['OCDateTime']['output'];
  description?: Maybe<Scalars['String']['output']>;
  lastSentAt?: Maybe<Scalars['OCDateTime']['output']>;
  messageIntent: MessageIntent;
  status: Triggered_Message_Status;
  subBrandUuid?: Maybe<Scalars['OCUUID']['output']>;
  triggerEvent: EventTrigger;
  uuid: Scalars['OCUUID']['output'];
};

export type TriggeredMessageConnection = {
  __typename: 'TriggeredMessageConnection';
  edges: Array<TriggeredMessageEdge>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type TriggeredMessageEdge = {
  __typename: 'TriggeredMessageEdge';
  cursor: Scalars['OCUUID']['output'];
  node: TriggeredMessage;
};

export type TriggeredMessages = FeatureConfiguration & {
  __typename: 'TriggeredMessages';
  enabled: Scalars['Boolean']['output'];
};

export type TriggeredMessagesFilter = {
  search?: InputMaybe<Scalars['String']['input']>;
  statusEquals?: InputMaybe<Triggered_Message_Status>;
  subBrandUuidEquals?: InputMaybe<Scalars['OCUUID']['input']>;
  triggerEventIncludes?: InputMaybe<Array<EventTrigger>>;
};

export enum Unit_Of_Measure {
  Amount = 'AMOUNT',
  Gallon = 'GALLON',
  Unit = 'UNIT'
}

export enum User_Origin {
  ActivateCommandCenter = 'ACTIVATE_COMMAND_CENTER',
  TransactCommandCenter = 'TRANSACT_COMMAND_CENTER'
}

export enum User_Role {
  Admin = 'ADMIN',
  AdminReadOnly = 'ADMIN_READ_ONLY',
  BrandAdmin = 'BRAND_ADMIN',
  BrandUser = 'BRAND_USER',
  CommandCenterUser = 'COMMAND_CENTER_USER',
  RcUser = 'RC_USER',
  RetailerNetworkAdmin = 'RETAILER_NETWORK_ADMIN',
  RetailerNetworkUser = 'RETAILER_NETWORK_USER',
  ScanDataAdmin = 'SCAN_DATA_ADMIN',
  ScanDataUser = 'SCAN_DATA_USER',
  Sitetech = 'SITETECH',
  SiteAdmin = 'SITE_ADMIN',
  SiteUser = 'SITE_USER',
  Support = 'SUPPORT'
}

export type UuidFilter = {
  isEqualTo?: InputMaybe<Scalars['String']['input']>;
  isIn?: InputMaybe<Array<Scalars['String']['input']>>;
  isNotEqualTo?: InputMaybe<Scalars['String']['input']>;
  isNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull?: InputMaybe<Scalars['Boolean']['input']>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
};

export type UpdateAudienceBroadcastMessageInput = {
  audienceUuid?: InputMaybe<Scalars['OCUUID']['input']>;
  channelsConfig?: InputMaybe<ChannelsConfigInput>;
  description?: InputMaybe<Scalars['String']['input']>;
  scheduleAt?: InputMaybe<Scalars['OCDateTime']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  uuid: Scalars['OCUUID']['input'];
};

export type UpdateExternalLoyaltyIdInput = {
  id: Scalars['ID']['input'];
  identifier: Scalars['String']['input'];
};

export type UpdateExternalProgramInput = {
  id: Scalars['ID']['input'];
  name: Scalars['String']['input'];
};

export enum UpdatePromocodeStatus {
  Active = 'ACTIVE',
  Archived = 'ARCHIVED'
}

export type UpdateSiteIssueInput = {
  assignedToUserUuid?: InputMaybe<Scalars['OCUUID']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  jiraCaseId?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<Site_Issue_Status>;
  title?: InputMaybe<Scalars['String']['input']>;
  uuid: Scalars['OCUUID']['input'];
};

export type UpdateSmsOptInStatusExternalInput = {
  optInStatus: Scalars['Boolean']['input'];
  phoneNumber: Scalars['OCPhoneNumber']['input'];
  subBrandUuid?: InputMaybe<Scalars['ID']['input']>;
  timestamp: Scalars['OCDateTime']['input'];
};

export type UpdateTriggeredMessageInput = {
  channelsConfig?: InputMaybe<ChannelsConfigInput>;
  description?: InputMaybe<Scalars['String']['input']>;
  messageIntent?: InputMaybe<MessageIntent>;
  status?: InputMaybe<Triggered_Message_Status>;
  triggeredMessageUuid: Scalars['OCUUID']['input'];
};

export type UpdateTriggeredMessageStatusInput = {
  status: Triggered_Message_Status;
  triggeredMessageUuid: Scalars['OCUUID']['input'];
};

export type UploadPresignedPostUrl = {
  __typename: 'UploadPresignedPostURL';
  fields: Scalars['OCJSON']['output'];
  url: Scalars['OCURL']['output'];
};

export type User = {
  __typename: 'User';
  brands?: Maybe<Array<Brand>>;
  email?: Maybe<Scalars['OCEmailAddress']['output']>;
  name?: Maybe<PersonName>;
  phoneNumber?: Maybe<Scalars['OCPhoneNumber']['output']>;
  userRole: User_Role;
  username: Scalars['String']['output'];
  uuid: Scalars['ID']['output'];
};

export type UserAbility = {
  __typename: 'UserAbility';
  action: Scalars['String']['output'];
  conditions?: Maybe<UserAbilityConditions>;
  fields?: Maybe<Scalars['String']['output']>;
  scope?: Maybe<Scalars['String']['output']>;
  subject: Scalars['String']['output'];
};

export type UserAbilityConditions = {
  __typename: 'UserAbilityConditions';
  uuidIn?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};

export type UserAttributes = {
  name: Scalars['String']['input'];
  value: Scalars['String']['input'];
};

export type UserConnection = {
  __typename: 'UserConnection';
  edges?: Maybe<Array<UserEdge>>;
  pageInfo: PageInfo;
};

export type UserCreate = {
  brandUuid?: InputMaybe<Array<Scalars['ID']['input']>>;
  email?: InputMaybe<Scalars['OCEmailAddress']['input']>;
  name?: InputMaybe<PersonNameCreate>;
  phoneNumber?: InputMaybe<Scalars['OCPhoneNumber']['input']>;
  userRole: User_Role;
  username: Scalars['String']['input'];
};

export type UserEdge = {
  __typename: 'UserEdge';
  cursor: Scalars['OCBase64Cursor']['output'];
  node: User;
};

export type UserFilter = {
  emailEquals?: InputMaybe<Scalars['OCEmailAddress']['input']>;
  identityProviderIdEquals?: InputMaybe<Scalars['String']['input']>;
  nameLike?: InputMaybe<Scalars['String']['input']>;
  phoneNumberEquals?: InputMaybe<Scalars['OCPhoneNumber']['input']>;
  userRoleEquals?: InputMaybe<User_Role>;
  usernameEquals?: InputMaybe<Scalars['String']['input']>;
  uuidEquals?: InputMaybe<Scalars['ID']['input']>;
};

export type UserIdentity = {
  __typename: 'UserIdentity';
  identifier: Scalars['String']['output'];
  identityId: Scalars['String']['output'];
};

export type UserLoginCredentials = {
  origin?: InputMaybe<User_Origin>;
  password?: InputMaybe<Scalars['String']['input']>;
  username?: InputMaybe<Scalars['String']['input']>;
};

export type UserLoginInput = {
  password?: InputMaybe<Scalars['String']['input']>;
  username: Scalars['String']['input'];
};

export type UserUpdate = {
  email?: InputMaybe<Scalars['OCEmailAddress']['input']>;
  name?: InputMaybe<PersonNameCreate>;
  phoneNumber?: InputMaybe<Scalars['OCPhoneNumber']['input']>;
  uuid: Scalars['ID']['input'];
};

export type UsersEligibleForRetailerConnectFilter = {
  notInRetailerNetworkUuid: Array<Scalars['OCUUID']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  userRoleContains?: InputMaybe<Array<User_Role>>;
};

export enum Vouchers_Sort_By {
  CreatedAt = 'CREATED_AT'
}

export enum Voucher_Source_Type {
  GameSession = 'GAME_SESSION',
  LoyaltyEvent = 'LOYALTY_EVENT',
  Offer = 'OFFER',
  OfferPurchase = 'OFFER_PURCHASE',
  PromocodeUseRequest = 'PROMOCODE_USE_REQUEST',
  Transaction = 'TRANSACTION'
}

export enum Voucher_State {
  Abandoned = 'ABANDONED',
  Expired = 'EXPIRED',
  Fulfilled = 'FULFILLED',
  Unfulfilled = 'UNFULFILLED'
}

export type ValidateAndResetCustomerPasswordInput = {
  identifier: Scalars['String']['input'];
  password: Scalars['String']['input'];
  resetToken: Scalars['String']['input'];
};

export type ValidateScanDataSftpConnectionInput = {
  host: Scalars['String']['input'];
  password: Scalars['String']['input'];
  port: Scalars['Int']['input'];
  username: Scalars['String']['input'];
};

export type VarietyDiscountAwards = AwardPriceOverride | AwardProductDiscount | AwardTransactionMoneyDiscount;

export type VarietyProgress = {
  __typename: 'VarietyProgress';
  productGroups: Array<ProductGroup>;
  quantityPurchased: Scalars['Float']['output'];
  quantityRequired: Scalars['Float']['output'];
};

export type VisitsProgress = {
  __typename: 'VisitsProgress';
  visits: Scalars['Int']['output'];
  visitsRequired: Scalars['Int']['output'];
};

export type Voucher = {
  __typename: 'Voucher';
  createdAt: Scalars['OCDateTime']['output'];
  deletedAt?: Maybe<Scalars['OCDateTime']['output']>;
  expireAt?: Maybe<Scalars['OCDateTime']['output']>;
  fulfilledBy?: Maybe<VoucherFulfilledBy>;
  fulfilledById?: Maybe<Scalars['String']['output']>;
  fulfilledByType?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  membership: Membership;
  offer?: Maybe<Offer>;
  reservedKey?: Maybe<Scalars['String']['output']>;
  reservedUntil?: Maybe<Scalars['OCDateTime']['output']>;
  source?: Maybe<VoucherSource>;
  sourceId?: Maybe<Scalars['String']['output']>;
  sourceType?: Maybe<Scalars['String']['output']>;
  state: Voucher_State;
  updatedAt: Scalars['OCDateTime']['output'];
};

export type VoucherConnection = {
  __typename: 'VoucherConnection';
  edges: Array<VoucherEdge>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type VoucherEdge = {
  __typename: 'VoucherEdge';
  cursor: Scalars['ID']['output'];
  node: Voucher;
};

export type VoucherFilter = {
  createdAtMax?: InputMaybe<Scalars['OCDateTime']['input']>;
  createdAtMin?: InputMaybe<Scalars['OCDateTime']['input']>;
  engagementTypeContains?: InputMaybe<Array<Offer_Engagement_Type>>;
  expiredAtMax?: InputMaybe<Scalars['OCDateTime']['input']>;
  expiredAtMin?: InputMaybe<Scalars['OCDateTime']['input']>;
  membershipUuid?: InputMaybe<Scalars['OCUUID']['input']>;
  presentationTypeContains?: InputMaybe<Array<Offer_Presentation_Type>>;
  returnable?: InputMaybe<Scalars['Boolean']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  sourceType?: InputMaybe<Voucher_Source_Type>;
  state?: InputMaybe<Voucher_State>;
  subBrandFilter?: InputMaybe<SubBrandFilterInput>;
  visibleStatusEquals?: InputMaybe<Offer_Visible_Status>;
};

export type VoucherFulfilledBy = ActivateTransaction | GameSession | LoyaltyEvent;

export type VoucherSort = {
  direction: Sort_Order;
  field: Vouchers_Sort_By;
};

export type VoucherSource = ActivateTransaction | GameSession | LoyaltyEvent | Offer | OfferPurchase | PromocodeUseRequest;

export enum Wallet_Steering_Attribute {
  Capacity = 'CAPACITY',
  Opportunity = 'OPPORTUNITY',
  PeriodOpportunity = 'PERIOD_OPPORTUNITY',
  PeriodShare = 'PERIOD_SHARE',
  Share = 'SHARE'
}

export enum Wallet_Steering_Operator {
  IsEqualTo = 'IS_EQUAL_TO',
  IsGreaterThan = 'IS_GREATER_THAN',
  IsGreaterThanOrEqualTo = 'IS_GREATER_THAN_OR_EQUAL_TO',
  IsLessThan = 'IS_LESS_THAN',
  IsLessThanOrEqualTo = 'IS_LESS_THAN_OR_EQUAL_TO'
}

export enum Weekday {
  Friday = 'FRIDAY',
  Monday = 'MONDAY',
  Saturday = 'SATURDAY',
  Sunday = 'SUNDAY',
  Thursday = 'THURSDAY',
  Tuesday = 'TUESDAY',
  Wednesday = 'WEDNESDAY'
}

export type WalletConfigurationCreateInput = {
  allowedAccountTypes: Array<Par_Pay_Payment_Account_Type>;
  maxInstruments: Scalars['Int']['input'];
};

export type WalletConfigurationUpdateInput = {
  allowedAccountTypes: Array<Par_Pay_Payment_Account_Type>;
  maxInstruments: Scalars['Int']['input'];
};

export type WalletConnection = {
  __typename: 'WalletConnection';
  edges: Array<WalletEdge>;
  pageInfo: PageInfo;
};

export type WalletEdge = {
  __typename: 'WalletEdge';
  cursor: Scalars['OCBase64Cursor']['output'];
  node: SteeringWallet;
};

export type WalletPassUrl = {
  __typename: 'WalletPassUrl';
  googlePayUrl?: Maybe<Scalars['OCURL']['output']>;
  pkPassUrl?: Maybe<Scalars['OCURL']['output']>;
};

export type WalletSteeringDailySnapshot = {
  __typename: 'WalletSteeringDailySnapshot';
  date: Scalars['OCDate']['output'];
  membershipCount?: Maybe<Scalars['Int']['output']>;
  uuid: Scalars['OCUUID']['output'];
  walletCapacity: Scalars['Float']['output'];
  walletOpportunity?: Maybe<Scalars['Float']['output']>;
  walletShare?: Maybe<Scalars['Float']['output']>;
  walletUuid: Scalars['OCUUID']['output'];
};

export type WalletSteeringStatisticsFilter = {
  endDate: Scalars['OCDate']['input'];
  startDate: Scalars['OCDate']['input'];
  walletUuid: Scalars['OCUUID']['input'];
};

export type WalletSteeringSurvey = Survey & {
  __typename: 'WalletSteeringSurvey';
  audienceUuid: Scalars['OCUUID']['output'];
  award?: Maybe<AwardPointsOrVouchers>;
  chainId: Scalars['OCUUID']['output'];
  configuration: WalletSteeringSurveyConfiguration;
  createdAt: Scalars['OCDateTime']['output'];
  deletedAt?: Maybe<Scalars['OCDateTime']['output']>;
  questions: Array<SurveyQuestion>;
  status: SurveyStatus;
  type: Survey_Type;
  uuid: Scalars['OCUUID']['output'];
};

export type WalletSteeringSurveyConfiguration = {
  __typename: 'WalletSteeringSurveyConfiguration';
  maxUnits?: Maybe<Scalars['Int']['output']>;
  minUnits?: Maybe<Scalars['Int']['output']>;
  questionText?: Maybe<Scalars['String']['output']>;
  steeringWalletUnitOfMeasure?: Maybe<Unit_Of_Measure>;
  steeringWalletUuid?: Maybe<Scalars['OCUUID']['output']>;
};

export type WalletSteeringSurveyCreateInput = {
  maxUnits: Scalars['Int']['input'];
  minUnits: Scalars['Int']['input'];
  questionText: Scalars['String']['input'];
  steeringWalletUuid: Scalars['OCUUID']['input'];
};

export type WalletSteeringSurveyUpdateInput = {
  maxUnits: Scalars['Int']['input'];
  minUnits: Scalars['Int']['input'];
  questionText: Scalars['String']['input'];
  uuid: Scalars['OCUUID']['input'];
};

export type LocationIssueFragment = { __typename: 'SiteIssue', uuid: string, siteId: string, title: string, description?: string | null, status: Site_Issue_Status, jiraCaseId?: string | null, createdAt: string, updatedAt: string, createdBy: { __typename: 'OpenCommerceUser', uuid: string, name: { __typename: 'PersonName', first?: string | null, last?: string | null } }, assignedTo?: { __typename: 'OpenCommerceUser', uuid: string, name: { __typename: 'PersonName', first?: string | null, last?: string | null } } | null };

export type UpdateLocationIssueMutationVariables = Exact<{
  input: UpdateSiteIssueInput;
}>;


export type UpdateLocationIssueMutation = { __typename: 'Mutation', updateLocationIssue: { __typename: 'SiteIssue', uuid: string, siteId: string, title: string, description?: string | null, status: Site_Issue_Status, jiraCaseId?: string | null, createdAt: string, updatedAt: string, createdBy: { __typename: 'OpenCommerceUser', uuid: string, name: { __typename: 'PersonName', first?: string | null, last?: string | null } }, assignedTo?: { __typename: 'OpenCommerceUser', uuid: string, name: { __typename: 'PersonName', first?: string | null, last?: string | null } } | null } };

export type DeleteLocationIssueMutationVariables = Exact<{
  input: DeleteSiteIssueInput;
}>;


export type DeleteLocationIssueMutation = { __typename: 'Mutation', deleteLocationIssue: boolean };

export type LocationIssuesQueryVariables = Exact<{
  filter: SiteIssueFilter;
}>;


export type LocationIssuesQuery = { __typename: 'Query', locationIssues: Array<{ __typename: 'SiteIssue', uuid: string, siteId: string, title: string, description?: string | null, status: Site_Issue_Status, jiraCaseId?: string | null, createdAt: string, updatedAt: string, createdBy: { __typename: 'OpenCommerceUser', uuid: string, name: { __typename: 'PersonName', first?: string | null, last?: string | null } }, assignedTo?: { __typename: 'OpenCommerceUser', uuid: string, name: { __typename: 'PersonName', first?: string | null, last?: string | null } } | null }> };

export type ActivateTransactionFragment = { __typename: 'ActivateTransaction', id: string, partnerId?: string | null, requestId: string, createdAt: string, transactionTimeAt?: string | null, processedAt?: string | null, loyaltySequenceId?: string | null, fuelPositionId?: number | null, moneyCurrencyCode?: string | null, subtotalAmount?: number | null, totalAmount?: number | null, totalAmountWithoutDiscounts?: number | null, totalDiscountAmount?: number | null, totalTax?: number | null, totalPointsSpent: number, totalPointsRefunded: number, totalPointsEarned: number, vendorName?: string | null, status?: Activate_Transaction_Status | null, payload?: object | object[] | null, lineItems: Array<{ __typename: 'ActivateTransactionLineItem', id: string, sku?: string | null, upc?: string | null, description?: string | null, group?: string | null, fuelGradeId?: string | null, quantity?: number | null, moneyAmount?: number | null, moneyAmountWithoutDiscounts?: number | null, regularSellPrice?: number | null, actualSalesPrice?: number | null, externalLineItemPromotions?: Array<{ __typename: 'ExternalLineItemPromotion', id: string, discountAmount: number, promotionReason: string }> | null, promotions?: Array<{ __typename: 'ActivateLineItemPromotion', promotionAmount: number, promotionReason: string, promotionTitle: string, offer?: { __typename: 'Offer', id: string, externalId?: string | null, name: string, campaign?: { __typename: 'Campaign', uuid: string } | null, marketingContents: Array<{ __typename: 'MarketingContent', id: string, title?: string | null, shortDescription?: string | null, imageUrl?: string | null }> } | null }> | null }>, location?: { __typename: 'ActivateLocation', id: string, name?: string | null, address1?: string | null, address2?: string | null, city?: string | null, state?: string | null, zipcode?: string | null } | null, offerFulfillments?: Array<{ __typename: 'RuleFulfillment', fulfillmentCount: number, id: string, fulfilledOffer?: { __typename: 'Offer', id: string, name: string, category?: string | null, publishAt?: string | null, expireAt?: string | null, externalId?: string | null, campaign?: { __typename: 'Campaign', uuid: string } | null, displayCategories: Array<{ __typename: 'DisplayCategory', id: string, name: string, rank: number, bannerIds?: Array<string> | null, categoryRestrictions?: Category_Restrictions | null, shouldLazyLoadBanners?: boolean | null }>, marketingContents: Array<{ __typename: 'MarketingContent', id: string, title?: string | null, shortDescription?: string | null, imageUrl?: string | null }> } | null }> | null, fulfilledOffers: Array<{ __typename: 'Offer', id: string, name: string, category?: string | null, publishAt?: string | null, expireAt?: string | null, externalId?: string | null, campaign?: { __typename: 'Campaign', uuid: string } | null, displayCategories: Array<{ __typename: 'DisplayCategory', id: string, name: string, rank: number, bannerIds?: Array<string> | null, categoryRestrictions?: Category_Restrictions | null, shouldLazyLoadBanners?: boolean | null }>, marketingContents: Array<{ __typename: 'MarketingContent', id: string, title?: string | null, shortDescription?: string | null, imageUrl?: string | null }> }>, membership: { __typename: 'Membership', id: string, firstName?: string | null, lastName?: string | null }, paymentInfos?: Array<{ __typename: 'ActivatePaymentInfo', amountCharged?: number | null, isoPrefix?: string | null, tenderSubtype?: string | null, tenderType?: string | null }> | null, pointChanges?: Array<{ __typename: 'PointChange', id: string, type?: Point_Change_Type | null, createdAt: string, notes?: string | null, quantity: number, offer?: { __typename: 'Offer', id: string, name: string, publishAt?: string | null, expireAt?: string | null, campaign?: { __typename: 'Campaign', uuid: string } | null, marketingContents: Array<{ __typename: 'MarketingContent', id: string, title?: string | null }> } | null, source?: { __typename: 'ActivateTransaction', id: string, createdAt: string, transactionTimeAt?: string | null, partnerId?: string | null, lineItems: Array<{ __typename: 'ActivateTransactionLineItem', id: string, sku?: string | null, upc?: string | null, group?: string | null, quantity?: number | null, moneyAmount?: number | null }>, location?: { __typename: 'ActivateLocation', id: string, name?: string | null, address1?: string | null, city?: string | null, state?: string | null } | null, fulfilledOffers: Array<{ __typename: 'Offer', id: string, name: string, marketingContents: Array<{ __typename: 'MarketingContent', id: string, title?: string | null }> }> } | { __typename: 'ActivateUser', id: string, email: string, name?: string | null } | { __typename: 'Chain' } | { __typename: 'CommandCenterUser', name?: string | null, email: string } | { __typename: 'GameSession' } | { __typename: 'LoyaltyEvent', id: string, eventType: string, eventData?: object | object[] | null } | { __typename: 'MembershipPointDonation', id: string, pointsSpent: number, donationAmountCents: number, bucket: { __typename: 'DonationBucket', id: string, name: string } } | { __typename: 'OfferPurchase', pointCost: number, voucherGrantFor: { __typename: 'Offer', id: string, name: string, publishAt?: string | null, expireAt?: string | null, marketingContents: Array<{ __typename: 'MarketingContent', id: string, title?: string | null }> } } | { __typename: 'PointChange', id: string } | { __typename: 'PromocodeUseRequest' } | { __typename: 'StoredValueTransaction' } | null, pointAdjustmentReason?: { __typename: 'PointAdjustmentReason', id: string, label: string, description?: string | null } | null, membership: { __typename: 'Membership', id: string, createdAt: string, customerUuid?: string | null, firstName?: string | null, lastName?: string | null, email?: string | null, phone?: string | null, points: number, state: Membership_State } }> | null };

export type ActivateTransactionFulfilledOfferFragment = { __typename: 'Offer', id: string, name: string, category?: string | null, publishAt?: string | null, expireAt?: string | null, externalId?: string | null, campaign?: { __typename: 'Campaign', uuid: string } | null, displayCategories: Array<{ __typename: 'DisplayCategory', id: string, name: string, rank: number, bannerIds?: Array<string> | null, categoryRestrictions?: Category_Restrictions | null, shouldLazyLoadBanners?: boolean | null }>, marketingContents: Array<{ __typename: 'MarketingContent', id: string, title?: string | null, shortDescription?: string | null, imageUrl?: string | null }> };

export type ActivateTransactionPointTransactionsQueryVariables = Exact<{
  filter?: InputMaybe<ActivateTransactionFilter>;
}>;


export type ActivateTransactionPointTransactionsQuery = { __typename: 'Query', activateTransactions: { __typename: 'ActivateTransactionConnection', edges: Array<{ __typename: 'ActivateTransactionEdge', node: { __typename: 'ActivateTransaction', id: string, pointTransactions?: Array<{ __typename: 'PointChange', id: string, type?: Point_Change_Type | null, createdAt: string, notes?: string | null, quantity: number, offer?: { __typename: 'Offer', id: string, name: string, publishAt?: string | null, expireAt?: string | null, campaign?: { __typename: 'Campaign', uuid: string } | null, marketingContents: Array<{ __typename: 'MarketingContent', id: string, title?: string | null }> } | null, source?: { __typename: 'ActivateTransaction', id: string, createdAt: string, transactionTimeAt?: string | null, partnerId?: string | null, lineItems: Array<{ __typename: 'ActivateTransactionLineItem', id: string, sku?: string | null, upc?: string | null, group?: string | null, quantity?: number | null, moneyAmount?: number | null }>, location?: { __typename: 'ActivateLocation', id: string, name?: string | null, address1?: string | null, city?: string | null, state?: string | null } | null, fulfilledOffers: Array<{ __typename: 'Offer', id: string, name: string, marketingContents: Array<{ __typename: 'MarketingContent', id: string, title?: string | null }> }> } | { __typename: 'ActivateUser', id: string, email: string, name?: string | null } | { __typename: 'Chain' } | { __typename: 'CommandCenterUser', name?: string | null, email: string } | { __typename: 'GameSession' } | { __typename: 'LoyaltyEvent', id: string, eventType: string, eventData?: object | object[] | null } | { __typename: 'MembershipPointDonation', id: string, pointsSpent: number, donationAmountCents: number, bucket: { __typename: 'DonationBucket', id: string, name: string } } | { __typename: 'OfferPurchase', pointCost: number, voucherGrantFor: { __typename: 'Offer', id: string, name: string, publishAt?: string | null, expireAt?: string | null, marketingContents: Array<{ __typename: 'MarketingContent', id: string, title?: string | null }> } } | { __typename: 'PointChange', id: string } | { __typename: 'PromocodeUseRequest' } | { __typename: 'StoredValueTransaction' } | null, pointAdjustmentReason?: { __typename: 'PointAdjustmentReason', id: string, label: string, description?: string | null } | null, membership: { __typename: 'Membership', id: string, createdAt: string, customerUuid?: string | null, firstName?: string | null, lastName?: string | null, email?: string | null, phone?: string | null, points: number, state: Membership_State } }> | null } }> } };

export type ActivateTransactionQueryVariables = Exact<{
  filter?: InputMaybe<ActivateTransactionFilter>;
}>;


export type ActivateTransactionQuery = { __typename: 'Query', activateTransactions: { __typename: 'ActivateTransactionConnection', edges: Array<{ __typename: 'ActivateTransactionEdge', cursor: string, node: { __typename: 'ActivateTransaction', id: string, partnerId?: string | null, requestId: string, createdAt: string, transactionTimeAt?: string | null, processedAt?: string | null, loyaltySequenceId?: string | null, fuelPositionId?: number | null, moneyCurrencyCode?: string | null, subtotalAmount?: number | null, totalAmount?: number | null, totalAmountWithoutDiscounts?: number | null, totalDiscountAmount?: number | null, totalTax?: number | null, totalPointsSpent: number, totalPointsRefunded: number, totalPointsEarned: number, vendorName?: string | null, status?: Activate_Transaction_Status | null, payload?: object | object[] | null, lineItems: Array<{ __typename: 'ActivateTransactionLineItem', id: string, sku?: string | null, upc?: string | null, description?: string | null, group?: string | null, fuelGradeId?: string | null, quantity?: number | null, moneyAmount?: number | null, moneyAmountWithoutDiscounts?: number | null, regularSellPrice?: number | null, actualSalesPrice?: number | null, externalLineItemPromotions?: Array<{ __typename: 'ExternalLineItemPromotion', id: string, discountAmount: number, promotionReason: string }> | null, promotions?: Array<{ __typename: 'ActivateLineItemPromotion', promotionAmount: number, promotionReason: string, promotionTitle: string, offer?: { __typename: 'Offer', id: string, externalId?: string | null, name: string, campaign?: { __typename: 'Campaign', uuid: string } | null, marketingContents: Array<{ __typename: 'MarketingContent', id: string, title?: string | null, shortDescription?: string | null, imageUrl?: string | null }> } | null }> | null }>, location?: { __typename: 'ActivateLocation', id: string, name?: string | null, address1?: string | null, address2?: string | null, city?: string | null, state?: string | null, zipcode?: string | null } | null, offerFulfillments?: Array<{ __typename: 'RuleFulfillment', fulfillmentCount: number, id: string, fulfilledOffer?: { __typename: 'Offer', id: string, name: string, category?: string | null, publishAt?: string | null, expireAt?: string | null, externalId?: string | null, campaign?: { __typename: 'Campaign', uuid: string } | null, displayCategories: Array<{ __typename: 'DisplayCategory', id: string, name: string, rank: number, bannerIds?: Array<string> | null, categoryRestrictions?: Category_Restrictions | null, shouldLazyLoadBanners?: boolean | null }>, marketingContents: Array<{ __typename: 'MarketingContent', id: string, title?: string | null, shortDescription?: string | null, imageUrl?: string | null }> } | null }> | null, fulfilledOffers: Array<{ __typename: 'Offer', id: string, name: string, category?: string | null, publishAt?: string | null, expireAt?: string | null, externalId?: string | null, campaign?: { __typename: 'Campaign', uuid: string } | null, displayCategories: Array<{ __typename: 'DisplayCategory', id: string, name: string, rank: number, bannerIds?: Array<string> | null, categoryRestrictions?: Category_Restrictions | null, shouldLazyLoadBanners?: boolean | null }>, marketingContents: Array<{ __typename: 'MarketingContent', id: string, title?: string | null, shortDescription?: string | null, imageUrl?: string | null }> }>, membership: { __typename: 'Membership', id: string, firstName?: string | null, lastName?: string | null }, paymentInfos?: Array<{ __typename: 'ActivatePaymentInfo', amountCharged?: number | null, isoPrefix?: string | null, tenderSubtype?: string | null, tenderType?: string | null }> | null, pointChanges?: Array<{ __typename: 'PointChange', id: string, type?: Point_Change_Type | null, createdAt: string, notes?: string | null, quantity: number, offer?: { __typename: 'Offer', id: string, name: string, publishAt?: string | null, expireAt?: string | null, campaign?: { __typename: 'Campaign', uuid: string } | null, marketingContents: Array<{ __typename: 'MarketingContent', id: string, title?: string | null }> } | null, source?: { __typename: 'ActivateTransaction', id: string, createdAt: string, transactionTimeAt?: string | null, partnerId?: string | null, lineItems: Array<{ __typename: 'ActivateTransactionLineItem', id: string, sku?: string | null, upc?: string | null, group?: string | null, quantity?: number | null, moneyAmount?: number | null }>, location?: { __typename: 'ActivateLocation', id: string, name?: string | null, address1?: string | null, city?: string | null, state?: string | null } | null, fulfilledOffers: Array<{ __typename: 'Offer', id: string, name: string, marketingContents: Array<{ __typename: 'MarketingContent', id: string, title?: string | null }> }> } | { __typename: 'ActivateUser', id: string, email: string, name?: string | null } | { __typename: 'Chain' } | { __typename: 'CommandCenterUser', name?: string | null, email: string } | { __typename: 'GameSession' } | { __typename: 'LoyaltyEvent', id: string, eventType: string, eventData?: object | object[] | null } | { __typename: 'MembershipPointDonation', id: string, pointsSpent: number, donationAmountCents: number, bucket: { __typename: 'DonationBucket', id: string, name: string } } | { __typename: 'OfferPurchase', pointCost: number, voucherGrantFor: { __typename: 'Offer', id: string, name: string, publishAt?: string | null, expireAt?: string | null, marketingContents: Array<{ __typename: 'MarketingContent', id: string, title?: string | null }> } } | { __typename: 'PointChange', id: string } | { __typename: 'PromocodeUseRequest' } | { __typename: 'StoredValueTransaction' } | null, pointAdjustmentReason?: { __typename: 'PointAdjustmentReason', id: string, label: string, description?: string | null } | null, membership: { __typename: 'Membership', id: string, createdAt: string, customerUuid?: string | null, firstName?: string | null, lastName?: string | null, email?: string | null, phone?: string | null, points: number, state: Membership_State } }> | null } }> } };

export type AudienceFragment = { __typename: 'Audience', uuid: string, name: string, description: string, membershipCount: number, status: Audience_Status, hasBeenBackFilled?: boolean | null, createdAt: string, updatedAt: string, draftCount?: number | null, draftCountCalculationRequestedAt?: string | null, lastDraftCountCalculationAt?: string | null, targetingAttributes: Array<{ __typename: 'AudienceAgeWithinTargetingAttribute', minimumAge?: number | null, maximumAge?: number | null } | { __typename: 'AudienceAggregatedAudiencesTargetingAttribute', combinedAudiencesOperator?: Aggregated_Audience_Operator | null, combinedAudiencesTarget: Array<string> } | { __typename: 'AudienceCommunicationPreferenceTargetingAttribute', criteria: Array<{ __typename: 'AudienceCommunicationPreferenceCriteria', mechanism: Communication_Preference_Mechanism, status: Communication_Preference_Opt_In_Status, subBrandUuid?: string | null }> } | { __typename: 'AudienceExternalIdentityVerificationTargetingAttribute', provider: ExternalIdentityVerificationProvider, verificationAttributes: Array<string>, identityVerificationOperator: External_Identity_Verification_Operator } | { __typename: 'AudienceFuelAndConvenienceProfileTargetingAttribute', criteria: Array<{ __typename: 'AudienceFuelAndConvenienceProfileCriteria', attribute: Fuel_And_Convenience_Profile_Attribute, operator: Fuel_And_Convenience_Profile_Operator, target?: Array<string> | null }> } | { __typename: 'AudienceInAllEventTargetingAttribute', conditions?: Array<{ __typename: 'AudienceEventCondition', timeWindow?: Audience_Purchase_Time_Window | null, times: number, operator?: Event_Targeting_Condition_Operator | null, loyaltyEventUuid?: string | null, gameUuid?: string | null, purchaseCondition?: { __typename: 'AudienceEventPurchaseCondition', productGroupUuids: Array<string>, purchasedLocationUuids?: Array<string> | null, purchasedLocationGroupUuids?: Array<string> | null, excludeThreshold?: boolean | null, countProductsBy: Count_Products_By, threshold: number, operator: Event_Purchase_Condition_Operator } | null, audienceEventDateCondition?: { __typename: 'AudienceEventDateOneOfCondition', fixedDateRange?: { __typename: 'FixedDateRange', startDate: string, endDate: string } | null, relativeMonthBack?: { __typename: 'RelativeMonthsBack', relativeMonthsBack: number } | null, timeWindow?: { __typename: 'TimeWindow', timeWindow: Audience_Purchase_Time_Window } | null } | null }> | null } | { __typename: 'AudienceInAllProductInterestsTargetingAttribute', productCategories: Array<string> } | { __typename: 'AudienceInAllSegmentsTargetingAttribute', segmentIds: Array<string> } | { __typename: 'AudienceInAnyEventTargetingAttribute', conditions?: Array<{ __typename: 'AudienceEventCondition', timeWindow?: Audience_Purchase_Time_Window | null, times: number, operator?: Event_Targeting_Condition_Operator | null, loyaltyEventUuid?: string | null, gameUuid?: string | null, purchaseCondition?: { __typename: 'AudienceEventPurchaseCondition', productGroupUuids: Array<string>, purchasedLocationUuids?: Array<string> | null, purchasedLocationGroupUuids?: Array<string> | null, excludeThreshold?: boolean | null, countProductsBy: Count_Products_By, threshold: number, operator: Event_Purchase_Condition_Operator } | null, audienceEventDateCondition?: { __typename: 'AudienceEventDateOneOfCondition', fixedDateRange?: { __typename: 'FixedDateRange', startDate: string, endDate: string } | null, relativeMonthBack?: { __typename: 'RelativeMonthsBack', relativeMonthsBack: number } | null, timeWindow?: { __typename: 'TimeWindow', timeWindow: Audience_Purchase_Time_Window } | null } | null }> | null } | { __typename: 'AudienceInAnyProductInterestsTargetingAttribute', productCategories: Array<string> } | { __typename: 'AudienceInAnySegmentsTargetingAttribute', segmentIds: Array<string> } | { __typename: 'AudienceNotInAllEventTargetingAttribute', conditions?: Array<{ __typename: 'AudienceEventCondition', timeWindow?: Audience_Purchase_Time_Window | null, times: number, operator?: Event_Targeting_Condition_Operator | null, loyaltyEventUuid?: string | null, gameUuid?: string | null, purchaseCondition?: { __typename: 'AudienceEventPurchaseCondition', productGroupUuids: Array<string>, purchasedLocationUuids?: Array<string> | null, purchasedLocationGroupUuids?: Array<string> | null, excludeThreshold?: boolean | null, countProductsBy: Count_Products_By, threshold: number, operator: Event_Purchase_Condition_Operator } | null, audienceEventDateCondition?: { __typename: 'AudienceEventDateOneOfCondition', fixedDateRange?: { __typename: 'FixedDateRange', startDate: string, endDate: string } | null, relativeMonthBack?: { __typename: 'RelativeMonthsBack', relativeMonthsBack: number } | null, timeWindow?: { __typename: 'TimeWindow', timeWindow: Audience_Purchase_Time_Window } | null } | null }> | null } | { __typename: 'AudienceNotInAllProductInterestsTargetingAttribute', productCategories: Array<string> } | { __typename: 'AudienceNotInAnyEventTargetingAttribute', conditions?: Array<{ __typename: 'AudienceEventCondition', timeWindow?: Audience_Purchase_Time_Window | null, times: number, operator?: Event_Targeting_Condition_Operator | null, loyaltyEventUuid?: string | null, gameUuid?: string | null, purchaseCondition?: { __typename: 'AudienceEventPurchaseCondition', productGroupUuids: Array<string>, purchasedLocationUuids?: Array<string> | null, purchasedLocationGroupUuids?: Array<string> | null, excludeThreshold?: boolean | null, countProductsBy: Count_Products_By, threshold: number, operator: Event_Purchase_Condition_Operator } | null, audienceEventDateCondition?: { __typename: 'AudienceEventDateOneOfCondition', fixedDateRange?: { __typename: 'FixedDateRange', startDate: string, endDate: string } | null, relativeMonthBack?: { __typename: 'RelativeMonthsBack', relativeMonthsBack: number } | null, timeWindow?: { __typename: 'TimeWindow', timeWindow: Audience_Purchase_Time_Window } | null } | null }> | null } | { __typename: 'AudienceNotInAnyProductInterestsTargetingAttribute', productCategories: Array<string> } | { __typename: 'AudienceNotInAnySegmentsTargetingAttribute', segmentIds: Array<string> } | { __typename: 'AudienceOfferFulfillmentTargetingAttribute', fulfilled: boolean, operator?: Offer_Fulfillment_Operator | null, timesFulfilled?: number | null, targetOfferId: string } | { __typename: 'AudiencePointBalanceTargetingAttribute', target: Point_Balance_Target, minAmount?: number | null, maxAmount?: number | null, pointBalanceAmount?: number | null, pointBalanceOperator?: Audience_Operator | null } | { __typename: 'AudiencePurchasedAtLeastTargetingAttribute', productGroupIds?: Array<string> | null, countProductsBy?: Count_Products_By | null, threshold?: number | null, excludeThreshold?: boolean | null, timeWindow?: Audience_Purchase_Time_Window | null, targetYear?: number | null, targetMonth?: number | null, startDate?: string | null, endDate?: string | null, purchasedLocationUuids?: Array<string> | null, purchasedLocationGroupUuids?: Array<string> | null, relativeMonthsBack?: number | null } | { __typename: 'AudiencePurchasedAtMostTargetingAttribute', productGroupIds?: Array<string> | null, countProductsBy?: Count_Products_By | null, threshold?: number | null, excludeThreshold?: boolean | null, timeWindow?: Audience_Purchase_Time_Window | null, targetYear?: number | null, targetMonth?: number | null, startDate?: string | null, endDate?: string | null, purchasedLocationUuids?: Array<string> | null, purchasedLocationGroupUuids?: Array<string> | null, relativeMonthsBack?: number | null } | { __typename: 'AudienceRetailerNetworkSiteUsersTargetingAttribute', retailerNetworkOperator?: Retailer_Network_Operator | null, retailerNetworkUserTypes: Array<Retailer_Network_User_Type>, retailerNetworkUuids?: Array<string> | null, userTypeOperator: Retailer_Network_User_Type_Operator } | { __typename: 'AudienceStoreLocationTargetingAttribute', locationsIds?: Array<string> | null, locationGroupUuids?: Array<string> | null } | { __typename: 'AudienceSurveyAnswerTargetingAttribute' } | { __typename: 'AudienceSurveyResponseTargetingAttribute', maxAmount?: number | null, minAmount?: number | null, questionUuid: string, selectedOptions?: Array<string> | null, surveyResponse?: string | null, surveyUuid: string, locationsUuids?: Array<string> | null, locationGroupUuids?: Array<string> | null, surveyOperator: Audience_Survey_Response_Operator } | { __typename: 'AudienceTimeSinceLastVisitTargetingAttribute', amount: number, period: Time_Period, timeSinceLastVisitOperator: Time_Since_Last_Visit_Operator } | { __typename: 'AudienceTimeSinceMembershipAcquisitionTargetingAttribute', membershipCreatedAmount: number, membershipCreatedOperator: Time_Since_Membership_Acquisition_Operator } | { __typename: 'AudienceWalletSteeringTargetingAttribute', walletUuid: string, attribute: Wallet_Steering_Attribute, walletSteeringOperator: Wallet_Steering_Operator, value: number, unitOfMeasure: Unit_Of_Measure }> };

export type AudienceBasicFragment = { __typename: 'Audience', uuid: string, name: string };

export type PartialAudienceFragment = { __typename: 'Audience', uuid: string, name: string, description: string, status: Audience_Status, hasBeenBackFilled?: boolean | null, createdAt: string, targetingAttributes: Array<{ __typename: 'AudienceAgeWithinTargetingAttribute', minimumAge?: number | null, maximumAge?: number | null } | { __typename: 'AudienceAggregatedAudiencesTargetingAttribute', combinedAudiencesOperator?: Aggregated_Audience_Operator | null, combinedAudiencesTarget: Array<string> } | { __typename: 'AudienceCommunicationPreferenceTargetingAttribute', criteria: Array<{ __typename: 'AudienceCommunicationPreferenceCriteria', mechanism: Communication_Preference_Mechanism, status: Communication_Preference_Opt_In_Status, subBrandUuid?: string | null }> } | { __typename: 'AudienceExternalIdentityVerificationTargetingAttribute', provider: ExternalIdentityVerificationProvider, verificationAttributes: Array<string>, identityVerificationOperator: External_Identity_Verification_Operator } | { __typename: 'AudienceFuelAndConvenienceProfileTargetingAttribute', criteria: Array<{ __typename: 'AudienceFuelAndConvenienceProfileCriteria', attribute: Fuel_And_Convenience_Profile_Attribute, operator: Fuel_And_Convenience_Profile_Operator, target?: Array<string> | null }> } | { __typename: 'AudienceInAllEventTargetingAttribute', conditions?: Array<{ __typename: 'AudienceEventCondition', timeWindow?: Audience_Purchase_Time_Window | null, times: number, operator?: Event_Targeting_Condition_Operator | null, loyaltyEventUuid?: string | null, gameUuid?: string | null, purchaseCondition?: { __typename: 'AudienceEventPurchaseCondition', productGroupUuids: Array<string>, purchasedLocationUuids?: Array<string> | null, purchasedLocationGroupUuids?: Array<string> | null, excludeThreshold?: boolean | null, countProductsBy: Count_Products_By, threshold: number, operator: Event_Purchase_Condition_Operator } | null, audienceEventDateCondition?: { __typename: 'AudienceEventDateOneOfCondition', fixedDateRange?: { __typename: 'FixedDateRange', startDate: string, endDate: string } | null, relativeMonthBack?: { __typename: 'RelativeMonthsBack', relativeMonthsBack: number } | null, timeWindow?: { __typename: 'TimeWindow', timeWindow: Audience_Purchase_Time_Window } | null } | null }> | null } | { __typename: 'AudienceInAllProductInterestsTargetingAttribute', productCategories: Array<string> } | { __typename: 'AudienceInAllSegmentsTargetingAttribute', segmentIds: Array<string> } | { __typename: 'AudienceInAnyEventTargetingAttribute', conditions?: Array<{ __typename: 'AudienceEventCondition', timeWindow?: Audience_Purchase_Time_Window | null, times: number, operator?: Event_Targeting_Condition_Operator | null, loyaltyEventUuid?: string | null, gameUuid?: string | null, purchaseCondition?: { __typename: 'AudienceEventPurchaseCondition', productGroupUuids: Array<string>, purchasedLocationUuids?: Array<string> | null, purchasedLocationGroupUuids?: Array<string> | null, excludeThreshold?: boolean | null, countProductsBy: Count_Products_By, threshold: number, operator: Event_Purchase_Condition_Operator } | null, audienceEventDateCondition?: { __typename: 'AudienceEventDateOneOfCondition', fixedDateRange?: { __typename: 'FixedDateRange', startDate: string, endDate: string } | null, relativeMonthBack?: { __typename: 'RelativeMonthsBack', relativeMonthsBack: number } | null, timeWindow?: { __typename: 'TimeWindow', timeWindow: Audience_Purchase_Time_Window } | null } | null }> | null } | { __typename: 'AudienceInAnyProductInterestsTargetingAttribute', productCategories: Array<string> } | { __typename: 'AudienceInAnySegmentsTargetingAttribute', segmentIds: Array<string> } | { __typename: 'AudienceNotInAllEventTargetingAttribute', conditions?: Array<{ __typename: 'AudienceEventCondition', timeWindow?: Audience_Purchase_Time_Window | null, times: number, operator?: Event_Targeting_Condition_Operator | null, loyaltyEventUuid?: string | null, gameUuid?: string | null, purchaseCondition?: { __typename: 'AudienceEventPurchaseCondition', productGroupUuids: Array<string>, purchasedLocationUuids?: Array<string> | null, purchasedLocationGroupUuids?: Array<string> | null, excludeThreshold?: boolean | null, countProductsBy: Count_Products_By, threshold: number, operator: Event_Purchase_Condition_Operator } | null, audienceEventDateCondition?: { __typename: 'AudienceEventDateOneOfCondition', fixedDateRange?: { __typename: 'FixedDateRange', startDate: string, endDate: string } | null, relativeMonthBack?: { __typename: 'RelativeMonthsBack', relativeMonthsBack: number } | null, timeWindow?: { __typename: 'TimeWindow', timeWindow: Audience_Purchase_Time_Window } | null } | null }> | null } | { __typename: 'AudienceNotInAllProductInterestsTargetingAttribute', productCategories: Array<string> } | { __typename: 'AudienceNotInAnyEventTargetingAttribute', conditions?: Array<{ __typename: 'AudienceEventCondition', timeWindow?: Audience_Purchase_Time_Window | null, times: number, operator?: Event_Targeting_Condition_Operator | null, loyaltyEventUuid?: string | null, gameUuid?: string | null, purchaseCondition?: { __typename: 'AudienceEventPurchaseCondition', productGroupUuids: Array<string>, purchasedLocationUuids?: Array<string> | null, purchasedLocationGroupUuids?: Array<string> | null, excludeThreshold?: boolean | null, countProductsBy: Count_Products_By, threshold: number, operator: Event_Purchase_Condition_Operator } | null, audienceEventDateCondition?: { __typename: 'AudienceEventDateOneOfCondition', fixedDateRange?: { __typename: 'FixedDateRange', startDate: string, endDate: string } | null, relativeMonthBack?: { __typename: 'RelativeMonthsBack', relativeMonthsBack: number } | null, timeWindow?: { __typename: 'TimeWindow', timeWindow: Audience_Purchase_Time_Window } | null } | null }> | null } | { __typename: 'AudienceNotInAnyProductInterestsTargetingAttribute', productCategories: Array<string> } | { __typename: 'AudienceNotInAnySegmentsTargetingAttribute', segmentIds: Array<string> } | { __typename: 'AudienceOfferFulfillmentTargetingAttribute', fulfilled: boolean, operator?: Offer_Fulfillment_Operator | null, timesFulfilled?: number | null, targetOfferId: string } | { __typename: 'AudiencePointBalanceTargetingAttribute', target: Point_Balance_Target, minAmount?: number | null, maxAmount?: number | null, pointBalanceAmount?: number | null, pointBalanceOperator?: Audience_Operator | null } | { __typename: 'AudiencePurchasedAtLeastTargetingAttribute', productGroupIds?: Array<string> | null, countProductsBy?: Count_Products_By | null, threshold?: number | null, excludeThreshold?: boolean | null, timeWindow?: Audience_Purchase_Time_Window | null, targetYear?: number | null, targetMonth?: number | null, startDate?: string | null, endDate?: string | null, purchasedLocationUuids?: Array<string> | null, purchasedLocationGroupUuids?: Array<string> | null, relativeMonthsBack?: number | null } | { __typename: 'AudiencePurchasedAtMostTargetingAttribute', productGroupIds?: Array<string> | null, countProductsBy?: Count_Products_By | null, threshold?: number | null, excludeThreshold?: boolean | null, timeWindow?: Audience_Purchase_Time_Window | null, targetYear?: number | null, targetMonth?: number | null, startDate?: string | null, endDate?: string | null, purchasedLocationUuids?: Array<string> | null, purchasedLocationGroupUuids?: Array<string> | null, relativeMonthsBack?: number | null } | { __typename: 'AudienceRetailerNetworkSiteUsersTargetingAttribute', retailerNetworkOperator?: Retailer_Network_Operator | null, retailerNetworkUserTypes: Array<Retailer_Network_User_Type>, retailerNetworkUuids?: Array<string> | null, userTypeOperator: Retailer_Network_User_Type_Operator } | { __typename: 'AudienceStoreLocationTargetingAttribute', locationsIds?: Array<string> | null, locationGroupUuids?: Array<string> | null } | { __typename: 'AudienceSurveyAnswerTargetingAttribute' } | { __typename: 'AudienceSurveyResponseTargetingAttribute', maxAmount?: number | null, minAmount?: number | null, questionUuid: string, selectedOptions?: Array<string> | null, surveyResponse?: string | null, surveyUuid: string, locationsUuids?: Array<string> | null, locationGroupUuids?: Array<string> | null, surveyOperator: Audience_Survey_Response_Operator } | { __typename: 'AudienceTimeSinceLastVisitTargetingAttribute', amount: number, period: Time_Period, timeSinceLastVisitOperator: Time_Since_Last_Visit_Operator } | { __typename: 'AudienceTimeSinceMembershipAcquisitionTargetingAttribute', membershipCreatedAmount: number, membershipCreatedOperator: Time_Since_Membership_Acquisition_Operator } | { __typename: 'AudienceWalletSteeringTargetingAttribute', walletUuid: string, attribute: Wallet_Steering_Attribute, walletSteeringOperator: Wallet_Steering_Operator, value: number, unitOfMeasure: Unit_Of_Measure }> };

export type AudienceSelectItemFragment = { __typename: 'Audience', uuid: string, name: string };

type AudienceTargetingAttribute_AudienceAgeWithinTargetingAttribute_Fragment = { __typename: 'AudienceAgeWithinTargetingAttribute', minimumAge?: number | null, maximumAge?: number | null };

type AudienceTargetingAttribute_AudienceAggregatedAudiencesTargetingAttribute_Fragment = { __typename: 'AudienceAggregatedAudiencesTargetingAttribute', combinedAudiencesOperator?: Aggregated_Audience_Operator | null, combinedAudiencesTarget: Array<string> };

type AudienceTargetingAttribute_AudienceCommunicationPreferenceTargetingAttribute_Fragment = { __typename: 'AudienceCommunicationPreferenceTargetingAttribute', criteria: Array<{ __typename: 'AudienceCommunicationPreferenceCriteria', mechanism: Communication_Preference_Mechanism, status: Communication_Preference_Opt_In_Status, subBrandUuid?: string | null }> };

type AudienceTargetingAttribute_AudienceExternalIdentityVerificationTargetingAttribute_Fragment = { __typename: 'AudienceExternalIdentityVerificationTargetingAttribute', provider: ExternalIdentityVerificationProvider, verificationAttributes: Array<string>, identityVerificationOperator: External_Identity_Verification_Operator };

type AudienceTargetingAttribute_AudienceFuelAndConvenienceProfileTargetingAttribute_Fragment = { __typename: 'AudienceFuelAndConvenienceProfileTargetingAttribute', criteria: Array<{ __typename: 'AudienceFuelAndConvenienceProfileCriteria', attribute: Fuel_And_Convenience_Profile_Attribute, operator: Fuel_And_Convenience_Profile_Operator, target?: Array<string> | null }> };

type AudienceTargetingAttribute_AudienceInAllEventTargetingAttribute_Fragment = { __typename: 'AudienceInAllEventTargetingAttribute', conditions?: Array<{ __typename: 'AudienceEventCondition', timeWindow?: Audience_Purchase_Time_Window | null, times: number, operator?: Event_Targeting_Condition_Operator | null, loyaltyEventUuid?: string | null, gameUuid?: string | null, purchaseCondition?: { __typename: 'AudienceEventPurchaseCondition', productGroupUuids: Array<string>, purchasedLocationUuids?: Array<string> | null, purchasedLocationGroupUuids?: Array<string> | null, excludeThreshold?: boolean | null, countProductsBy: Count_Products_By, threshold: number, operator: Event_Purchase_Condition_Operator } | null, audienceEventDateCondition?: { __typename: 'AudienceEventDateOneOfCondition', fixedDateRange?: { __typename: 'FixedDateRange', startDate: string, endDate: string } | null, relativeMonthBack?: { __typename: 'RelativeMonthsBack', relativeMonthsBack: number } | null, timeWindow?: { __typename: 'TimeWindow', timeWindow: Audience_Purchase_Time_Window } | null } | null }> | null };

type AudienceTargetingAttribute_AudienceInAllProductInterestsTargetingAttribute_Fragment = { __typename: 'AudienceInAllProductInterestsTargetingAttribute', productCategories: Array<string> };

type AudienceTargetingAttribute_AudienceInAllSegmentsTargetingAttribute_Fragment = { __typename: 'AudienceInAllSegmentsTargetingAttribute', segmentIds: Array<string> };

type AudienceTargetingAttribute_AudienceInAnyEventTargetingAttribute_Fragment = { __typename: 'AudienceInAnyEventTargetingAttribute', conditions?: Array<{ __typename: 'AudienceEventCondition', timeWindow?: Audience_Purchase_Time_Window | null, times: number, operator?: Event_Targeting_Condition_Operator | null, loyaltyEventUuid?: string | null, gameUuid?: string | null, purchaseCondition?: { __typename: 'AudienceEventPurchaseCondition', productGroupUuids: Array<string>, purchasedLocationUuids?: Array<string> | null, purchasedLocationGroupUuids?: Array<string> | null, excludeThreshold?: boolean | null, countProductsBy: Count_Products_By, threshold: number, operator: Event_Purchase_Condition_Operator } | null, audienceEventDateCondition?: { __typename: 'AudienceEventDateOneOfCondition', fixedDateRange?: { __typename: 'FixedDateRange', startDate: string, endDate: string } | null, relativeMonthBack?: { __typename: 'RelativeMonthsBack', relativeMonthsBack: number } | null, timeWindow?: { __typename: 'TimeWindow', timeWindow: Audience_Purchase_Time_Window } | null } | null }> | null };

type AudienceTargetingAttribute_AudienceInAnyProductInterestsTargetingAttribute_Fragment = { __typename: 'AudienceInAnyProductInterestsTargetingAttribute', productCategories: Array<string> };

type AudienceTargetingAttribute_AudienceInAnySegmentsTargetingAttribute_Fragment = { __typename: 'AudienceInAnySegmentsTargetingAttribute', segmentIds: Array<string> };

type AudienceTargetingAttribute_AudienceNotInAllEventTargetingAttribute_Fragment = { __typename: 'AudienceNotInAllEventTargetingAttribute', conditions?: Array<{ __typename: 'AudienceEventCondition', timeWindow?: Audience_Purchase_Time_Window | null, times: number, operator?: Event_Targeting_Condition_Operator | null, loyaltyEventUuid?: string | null, gameUuid?: string | null, purchaseCondition?: { __typename: 'AudienceEventPurchaseCondition', productGroupUuids: Array<string>, purchasedLocationUuids?: Array<string> | null, purchasedLocationGroupUuids?: Array<string> | null, excludeThreshold?: boolean | null, countProductsBy: Count_Products_By, threshold: number, operator: Event_Purchase_Condition_Operator } | null, audienceEventDateCondition?: { __typename: 'AudienceEventDateOneOfCondition', fixedDateRange?: { __typename: 'FixedDateRange', startDate: string, endDate: string } | null, relativeMonthBack?: { __typename: 'RelativeMonthsBack', relativeMonthsBack: number } | null, timeWindow?: { __typename: 'TimeWindow', timeWindow: Audience_Purchase_Time_Window } | null } | null }> | null };

type AudienceTargetingAttribute_AudienceNotInAllProductInterestsTargetingAttribute_Fragment = { __typename: 'AudienceNotInAllProductInterestsTargetingAttribute', productCategories: Array<string> };

type AudienceTargetingAttribute_AudienceNotInAnyEventTargetingAttribute_Fragment = { __typename: 'AudienceNotInAnyEventTargetingAttribute', conditions?: Array<{ __typename: 'AudienceEventCondition', timeWindow?: Audience_Purchase_Time_Window | null, times: number, operator?: Event_Targeting_Condition_Operator | null, loyaltyEventUuid?: string | null, gameUuid?: string | null, purchaseCondition?: { __typename: 'AudienceEventPurchaseCondition', productGroupUuids: Array<string>, purchasedLocationUuids?: Array<string> | null, purchasedLocationGroupUuids?: Array<string> | null, excludeThreshold?: boolean | null, countProductsBy: Count_Products_By, threshold: number, operator: Event_Purchase_Condition_Operator } | null, audienceEventDateCondition?: { __typename: 'AudienceEventDateOneOfCondition', fixedDateRange?: { __typename: 'FixedDateRange', startDate: string, endDate: string } | null, relativeMonthBack?: { __typename: 'RelativeMonthsBack', relativeMonthsBack: number } | null, timeWindow?: { __typename: 'TimeWindow', timeWindow: Audience_Purchase_Time_Window } | null } | null }> | null };

type AudienceTargetingAttribute_AudienceNotInAnyProductInterestsTargetingAttribute_Fragment = { __typename: 'AudienceNotInAnyProductInterestsTargetingAttribute', productCategories: Array<string> };

type AudienceTargetingAttribute_AudienceNotInAnySegmentsTargetingAttribute_Fragment = { __typename: 'AudienceNotInAnySegmentsTargetingAttribute', segmentIds: Array<string> };

type AudienceTargetingAttribute_AudienceOfferFulfillmentTargetingAttribute_Fragment = { __typename: 'AudienceOfferFulfillmentTargetingAttribute', fulfilled: boolean, operator?: Offer_Fulfillment_Operator | null, timesFulfilled?: number | null, targetOfferId: string };

type AudienceTargetingAttribute_AudiencePointBalanceTargetingAttribute_Fragment = { __typename: 'AudiencePointBalanceTargetingAttribute', target: Point_Balance_Target, minAmount?: number | null, maxAmount?: number | null, pointBalanceAmount?: number | null, pointBalanceOperator?: Audience_Operator | null };

type AudienceTargetingAttribute_AudiencePurchasedAtLeastTargetingAttribute_Fragment = { __typename: 'AudiencePurchasedAtLeastTargetingAttribute', productGroupIds?: Array<string> | null, countProductsBy?: Count_Products_By | null, threshold?: number | null, excludeThreshold?: boolean | null, timeWindow?: Audience_Purchase_Time_Window | null, targetYear?: number | null, targetMonth?: number | null, startDate?: string | null, endDate?: string | null, purchasedLocationUuids?: Array<string> | null, purchasedLocationGroupUuids?: Array<string> | null, relativeMonthsBack?: number | null };

type AudienceTargetingAttribute_AudiencePurchasedAtMostTargetingAttribute_Fragment = { __typename: 'AudiencePurchasedAtMostTargetingAttribute', productGroupIds?: Array<string> | null, countProductsBy?: Count_Products_By | null, threshold?: number | null, excludeThreshold?: boolean | null, timeWindow?: Audience_Purchase_Time_Window | null, targetYear?: number | null, targetMonth?: number | null, startDate?: string | null, endDate?: string | null, purchasedLocationUuids?: Array<string> | null, purchasedLocationGroupUuids?: Array<string> | null, relativeMonthsBack?: number | null };

type AudienceTargetingAttribute_AudienceRetailerNetworkSiteUsersTargetingAttribute_Fragment = { __typename: 'AudienceRetailerNetworkSiteUsersTargetingAttribute', retailerNetworkOperator?: Retailer_Network_Operator | null, retailerNetworkUserTypes: Array<Retailer_Network_User_Type>, retailerNetworkUuids?: Array<string> | null, userTypeOperator: Retailer_Network_User_Type_Operator };

type AudienceTargetingAttribute_AudienceStoreLocationTargetingAttribute_Fragment = { __typename: 'AudienceStoreLocationTargetingAttribute', locationsIds?: Array<string> | null, locationGroupUuids?: Array<string> | null };

type AudienceTargetingAttribute_AudienceSurveyAnswerTargetingAttribute_Fragment = { __typename: 'AudienceSurveyAnswerTargetingAttribute' };

type AudienceTargetingAttribute_AudienceSurveyResponseTargetingAttribute_Fragment = { __typename: 'AudienceSurveyResponseTargetingAttribute', maxAmount?: number | null, minAmount?: number | null, questionUuid: string, selectedOptions?: Array<string> | null, surveyResponse?: string | null, surveyUuid: string, locationsUuids?: Array<string> | null, locationGroupUuids?: Array<string> | null, surveyOperator: Audience_Survey_Response_Operator };

type AudienceTargetingAttribute_AudienceTimeSinceLastVisitTargetingAttribute_Fragment = { __typename: 'AudienceTimeSinceLastVisitTargetingAttribute', amount: number, period: Time_Period, timeSinceLastVisitOperator: Time_Since_Last_Visit_Operator };

type AudienceTargetingAttribute_AudienceTimeSinceMembershipAcquisitionTargetingAttribute_Fragment = { __typename: 'AudienceTimeSinceMembershipAcquisitionTargetingAttribute', membershipCreatedAmount: number, membershipCreatedOperator: Time_Since_Membership_Acquisition_Operator };

type AudienceTargetingAttribute_AudienceWalletSteeringTargetingAttribute_Fragment = { __typename: 'AudienceWalletSteeringTargetingAttribute', walletUuid: string, attribute: Wallet_Steering_Attribute, walletSteeringOperator: Wallet_Steering_Operator, value: number, unitOfMeasure: Unit_Of_Measure };

export type AudienceTargetingAttributeFragment = AudienceTargetingAttribute_AudienceAgeWithinTargetingAttribute_Fragment | AudienceTargetingAttribute_AudienceAggregatedAudiencesTargetingAttribute_Fragment | AudienceTargetingAttribute_AudienceCommunicationPreferenceTargetingAttribute_Fragment | AudienceTargetingAttribute_AudienceExternalIdentityVerificationTargetingAttribute_Fragment | AudienceTargetingAttribute_AudienceFuelAndConvenienceProfileTargetingAttribute_Fragment | AudienceTargetingAttribute_AudienceInAllEventTargetingAttribute_Fragment | AudienceTargetingAttribute_AudienceInAllProductInterestsTargetingAttribute_Fragment | AudienceTargetingAttribute_AudienceInAllSegmentsTargetingAttribute_Fragment | AudienceTargetingAttribute_AudienceInAnyEventTargetingAttribute_Fragment | AudienceTargetingAttribute_AudienceInAnyProductInterestsTargetingAttribute_Fragment | AudienceTargetingAttribute_AudienceInAnySegmentsTargetingAttribute_Fragment | AudienceTargetingAttribute_AudienceNotInAllEventTargetingAttribute_Fragment | AudienceTargetingAttribute_AudienceNotInAllProductInterestsTargetingAttribute_Fragment | AudienceTargetingAttribute_AudienceNotInAnyEventTargetingAttribute_Fragment | AudienceTargetingAttribute_AudienceNotInAnyProductInterestsTargetingAttribute_Fragment | AudienceTargetingAttribute_AudienceNotInAnySegmentsTargetingAttribute_Fragment | AudienceTargetingAttribute_AudienceOfferFulfillmentTargetingAttribute_Fragment | AudienceTargetingAttribute_AudiencePointBalanceTargetingAttribute_Fragment | AudienceTargetingAttribute_AudiencePurchasedAtLeastTargetingAttribute_Fragment | AudienceTargetingAttribute_AudiencePurchasedAtMostTargetingAttribute_Fragment | AudienceTargetingAttribute_AudienceRetailerNetworkSiteUsersTargetingAttribute_Fragment | AudienceTargetingAttribute_AudienceStoreLocationTargetingAttribute_Fragment | AudienceTargetingAttribute_AudienceSurveyAnswerTargetingAttribute_Fragment | AudienceTargetingAttribute_AudienceSurveyResponseTargetingAttribute_Fragment | AudienceTargetingAttribute_AudienceTimeSinceLastVisitTargetingAttribute_Fragment | AudienceTargetingAttribute_AudienceTimeSinceMembershipAcquisitionTargetingAttribute_Fragment | AudienceTargetingAttribute_AudienceWalletSteeringTargetingAttribute_Fragment;

export type AudiencePurchasedAtLeastTargetingAttributeFragment = { __typename: 'AudiencePurchasedAtLeastTargetingAttribute', productGroupIds?: Array<string> | null, countProductsBy?: Count_Products_By | null, threshold?: number | null, excludeThreshold?: boolean | null, timeWindow?: Audience_Purchase_Time_Window | null, targetYear?: number | null, targetMonth?: number | null, startDate?: string | null, endDate?: string | null, purchasedLocationUuids?: Array<string> | null, purchasedLocationGroupUuids?: Array<string> | null, relativeMonthsBack?: number | null };

export type AudiencePurchasedAtMostTargetingAttributeFragment = { __typename: 'AudiencePurchasedAtMostTargetingAttribute', productGroupIds?: Array<string> | null, countProductsBy?: Count_Products_By | null, threshold?: number | null, excludeThreshold?: boolean | null, timeWindow?: Audience_Purchase_Time_Window | null, targetYear?: number | null, targetMonth?: number | null, startDate?: string | null, endDate?: string | null, purchasedLocationUuids?: Array<string> | null, purchasedLocationGroupUuids?: Array<string> | null, relativeMonthsBack?: number | null };

export type AudienceInAllSegmentsTargetingAttributeFragment = { __typename: 'AudienceInAllSegmentsTargetingAttribute', segmentIds: Array<string> };

export type AudienceInAnySegmentsTargetingAttributeFragment = { __typename: 'AudienceInAnySegmentsTargetingAttribute', segmentIds: Array<string> };

export type AudienceNotInAnySegmentsTargetingAttributeFragment = { __typename: 'AudienceNotInAnySegmentsTargetingAttribute', segmentIds: Array<string> };

export type AudienceAgeWithinTargetingAttributeFragment = { __typename: 'AudienceAgeWithinTargetingAttribute', minimumAge?: number | null, maximumAge?: number | null };

export type AudienceFuelAndConvenienceProfileTargetingAttributeFragment = { __typename: 'AudienceFuelAndConvenienceProfileTargetingAttribute', criteria: Array<{ __typename: 'AudienceFuelAndConvenienceProfileCriteria', attribute: Fuel_And_Convenience_Profile_Attribute, operator: Fuel_And_Convenience_Profile_Operator, target?: Array<string> | null }> };

export type AudienceOfferFulfillmentTargetingAttributeFragment = { __typename: 'AudienceOfferFulfillmentTargetingAttribute', fulfilled: boolean, operator?: Offer_Fulfillment_Operator | null, timesFulfilled?: number | null, targetOfferId: string };

export type AudienceStoreLocationTargetingAttributeFragment = { __typename: 'AudienceStoreLocationTargetingAttribute', locationsIds?: Array<string> | null, locationGroupUuids?: Array<string> | null };

export type AudienceWalletSteeringTargetingAttributeFragment = { __typename: 'AudienceWalletSteeringTargetingAttribute', walletUuid: string, attribute: Wallet_Steering_Attribute, walletSteeringOperator: Wallet_Steering_Operator, value: number, unitOfMeasure: Unit_Of_Measure };

export type AudienceInAllProductInterestsTargetingAttributeFragment = { __typename: 'AudienceInAllProductInterestsTargetingAttribute', productCategories: Array<string> };

export type AudienceInAnyProductInterestsTargetingAttributeFragment = { __typename: 'AudienceInAnyProductInterestsTargetingAttribute', productCategories: Array<string> };

export type AudienceNotInAllProductInterestsTargetingAttributeFragment = { __typename: 'AudienceNotInAllProductInterestsTargetingAttribute', productCategories: Array<string> };

export type AudienceNotInAnyProductInterestsTargetingAttributeFragment = { __typename: 'AudienceNotInAnyProductInterestsTargetingAttribute', productCategories: Array<string> };

export type AudienceRetailerNetworkSiteUsersTargetingAttributeFragment = { __typename: 'AudienceRetailerNetworkSiteUsersTargetingAttribute', retailerNetworkOperator?: Retailer_Network_Operator | null, retailerNetworkUserTypes: Array<Retailer_Network_User_Type>, retailerNetworkUuids?: Array<string> | null, userTypeOperator: Retailer_Network_User_Type_Operator };

export type AudienceCommunicationPreferenceTargetingAttributeFragment = { __typename: 'AudienceCommunicationPreferenceTargetingAttribute', criteria: Array<{ __typename: 'AudienceCommunicationPreferenceCriteria', mechanism: Communication_Preference_Mechanism, status: Communication_Preference_Opt_In_Status, subBrandUuid?: string | null }> };

export type AudienceExternalIdentityVerificationTargetingAttributeFragment = { __typename: 'AudienceExternalIdentityVerificationTargetingAttribute', provider: ExternalIdentityVerificationProvider, verificationAttributes: Array<string>, identityVerificationOperator: External_Identity_Verification_Operator };

export type AudienceEventConditionFragment = { __typename: 'AudienceEventCondition', timeWindow?: Audience_Purchase_Time_Window | null, times: number, operator?: Event_Targeting_Condition_Operator | null, loyaltyEventUuid?: string | null, gameUuid?: string | null, purchaseCondition?: { __typename: 'AudienceEventPurchaseCondition', productGroupUuids: Array<string>, purchasedLocationUuids?: Array<string> | null, purchasedLocationGroupUuids?: Array<string> | null, excludeThreshold?: boolean | null, countProductsBy: Count_Products_By, threshold: number, operator: Event_Purchase_Condition_Operator } | null, audienceEventDateCondition?: { __typename: 'AudienceEventDateOneOfCondition', fixedDateRange?: { __typename: 'FixedDateRange', startDate: string, endDate: string } | null, relativeMonthBack?: { __typename: 'RelativeMonthsBack', relativeMonthsBack: number } | null, timeWindow?: { __typename: 'TimeWindow', timeWindow: Audience_Purchase_Time_Window } | null } | null };

export type AudienceInAllEventTargetingAttributeFragment = { __typename: 'AudienceInAllEventTargetingAttribute', conditions?: Array<{ __typename: 'AudienceEventCondition', timeWindow?: Audience_Purchase_Time_Window | null, times: number, operator?: Event_Targeting_Condition_Operator | null, loyaltyEventUuid?: string | null, gameUuid?: string | null, purchaseCondition?: { __typename: 'AudienceEventPurchaseCondition', productGroupUuids: Array<string>, purchasedLocationUuids?: Array<string> | null, purchasedLocationGroupUuids?: Array<string> | null, excludeThreshold?: boolean | null, countProductsBy: Count_Products_By, threshold: number, operator: Event_Purchase_Condition_Operator } | null, audienceEventDateCondition?: { __typename: 'AudienceEventDateOneOfCondition', fixedDateRange?: { __typename: 'FixedDateRange', startDate: string, endDate: string } | null, relativeMonthBack?: { __typename: 'RelativeMonthsBack', relativeMonthsBack: number } | null, timeWindow?: { __typename: 'TimeWindow', timeWindow: Audience_Purchase_Time_Window } | null } | null }> | null };

export type AudienceInAnyEventTargetingAttributeFragment = { __typename: 'AudienceInAnyEventTargetingAttribute', conditions?: Array<{ __typename: 'AudienceEventCondition', timeWindow?: Audience_Purchase_Time_Window | null, times: number, operator?: Event_Targeting_Condition_Operator | null, loyaltyEventUuid?: string | null, gameUuid?: string | null, purchaseCondition?: { __typename: 'AudienceEventPurchaseCondition', productGroupUuids: Array<string>, purchasedLocationUuids?: Array<string> | null, purchasedLocationGroupUuids?: Array<string> | null, excludeThreshold?: boolean | null, countProductsBy: Count_Products_By, threshold: number, operator: Event_Purchase_Condition_Operator } | null, audienceEventDateCondition?: { __typename: 'AudienceEventDateOneOfCondition', fixedDateRange?: { __typename: 'FixedDateRange', startDate: string, endDate: string } | null, relativeMonthBack?: { __typename: 'RelativeMonthsBack', relativeMonthsBack: number } | null, timeWindow?: { __typename: 'TimeWindow', timeWindow: Audience_Purchase_Time_Window } | null } | null }> | null };

export type AudienceNotInAllEventTargetingAttributeFragment = { __typename: 'AudienceNotInAllEventTargetingAttribute', conditions?: Array<{ __typename: 'AudienceEventCondition', timeWindow?: Audience_Purchase_Time_Window | null, times: number, operator?: Event_Targeting_Condition_Operator | null, loyaltyEventUuid?: string | null, gameUuid?: string | null, purchaseCondition?: { __typename: 'AudienceEventPurchaseCondition', productGroupUuids: Array<string>, purchasedLocationUuids?: Array<string> | null, purchasedLocationGroupUuids?: Array<string> | null, excludeThreshold?: boolean | null, countProductsBy: Count_Products_By, threshold: number, operator: Event_Purchase_Condition_Operator } | null, audienceEventDateCondition?: { __typename: 'AudienceEventDateOneOfCondition', fixedDateRange?: { __typename: 'FixedDateRange', startDate: string, endDate: string } | null, relativeMonthBack?: { __typename: 'RelativeMonthsBack', relativeMonthsBack: number } | null, timeWindow?: { __typename: 'TimeWindow', timeWindow: Audience_Purchase_Time_Window } | null } | null }> | null };

export type AudienceNotInAnyEventTargetingAttributeFragment = { __typename: 'AudienceNotInAnyEventTargetingAttribute', conditions?: Array<{ __typename: 'AudienceEventCondition', timeWindow?: Audience_Purchase_Time_Window | null, times: number, operator?: Event_Targeting_Condition_Operator | null, loyaltyEventUuid?: string | null, gameUuid?: string | null, purchaseCondition?: { __typename: 'AudienceEventPurchaseCondition', productGroupUuids: Array<string>, purchasedLocationUuids?: Array<string> | null, purchasedLocationGroupUuids?: Array<string> | null, excludeThreshold?: boolean | null, countProductsBy: Count_Products_By, threshold: number, operator: Event_Purchase_Condition_Operator } | null, audienceEventDateCondition?: { __typename: 'AudienceEventDateOneOfCondition', fixedDateRange?: { __typename: 'FixedDateRange', startDate: string, endDate: string } | null, relativeMonthBack?: { __typename: 'RelativeMonthsBack', relativeMonthsBack: number } | null, timeWindow?: { __typename: 'TimeWindow', timeWindow: Audience_Purchase_Time_Window } | null } | null }> | null };

export type AudienceTimeSinceLastVisitTargetingAttributeFragment = { __typename: 'AudienceTimeSinceLastVisitTargetingAttribute', amount: number, period: Time_Period, timeSinceLastVisitOperator: Time_Since_Last_Visit_Operator };

export type AudiencePointBalanceTargetingAttributeFragment = { __typename: 'AudiencePointBalanceTargetingAttribute', target: Point_Balance_Target, minAmount?: number | null, maxAmount?: number | null, pointBalanceAmount?: number | null, pointBalanceOperator?: Audience_Operator | null };

export type AudienceTimeSinceMembershipAcquisitionTargetingAttributeFragment = { __typename: 'AudienceTimeSinceMembershipAcquisitionTargetingAttribute', membershipCreatedAmount: number, membershipCreatedOperator: Time_Since_Membership_Acquisition_Operator };

export type AudienceSurveyResponseTargetingAttributeFragment = { __typename: 'AudienceSurveyResponseTargetingAttribute', maxAmount?: number | null, minAmount?: number | null, questionUuid: string, selectedOptions?: Array<string> | null, surveyResponse?: string | null, surveyUuid: string, locationsUuids?: Array<string> | null, locationGroupUuids?: Array<string> | null, surveyOperator: Audience_Survey_Response_Operator };

export type AudienceAggregatedAudienceTargetingAttributeFragment = { __typename: 'AudienceAggregatedAudiencesTargetingAttribute', combinedAudiencesOperator?: Aggregated_Audience_Operator | null, combinedAudiencesTarget: Array<string> };

export type ReportGenerationJobFragment = { __typename: 'ReportGenerationJob', uuid: string, status: ReportStatus };

export type AudienceCreateMutationVariables = Exact<{
  input: AudienceCreate;
}>;


export type AudienceCreateMutation = { __typename: 'Mutation', audienceCreate: { __typename: 'Audience', uuid: string, name: string, description: string, membershipCount: number, status: Audience_Status, hasBeenBackFilled?: boolean | null, createdAt: string, updatedAt: string, draftCount?: number | null, draftCountCalculationRequestedAt?: string | null, lastDraftCountCalculationAt?: string | null, targetingAttributes: Array<{ __typename: 'AudienceAgeWithinTargetingAttribute', minimumAge?: number | null, maximumAge?: number | null } | { __typename: 'AudienceAggregatedAudiencesTargetingAttribute', combinedAudiencesOperator?: Aggregated_Audience_Operator | null, combinedAudiencesTarget: Array<string> } | { __typename: 'AudienceCommunicationPreferenceTargetingAttribute', criteria: Array<{ __typename: 'AudienceCommunicationPreferenceCriteria', mechanism: Communication_Preference_Mechanism, status: Communication_Preference_Opt_In_Status, subBrandUuid?: string | null }> } | { __typename: 'AudienceExternalIdentityVerificationTargetingAttribute', provider: ExternalIdentityVerificationProvider, verificationAttributes: Array<string>, identityVerificationOperator: External_Identity_Verification_Operator } | { __typename: 'AudienceFuelAndConvenienceProfileTargetingAttribute', criteria: Array<{ __typename: 'AudienceFuelAndConvenienceProfileCriteria', attribute: Fuel_And_Convenience_Profile_Attribute, operator: Fuel_And_Convenience_Profile_Operator, target?: Array<string> | null }> } | { __typename: 'AudienceInAllEventTargetingAttribute', conditions?: Array<{ __typename: 'AudienceEventCondition', timeWindow?: Audience_Purchase_Time_Window | null, times: number, operator?: Event_Targeting_Condition_Operator | null, loyaltyEventUuid?: string | null, gameUuid?: string | null, purchaseCondition?: { __typename: 'AudienceEventPurchaseCondition', productGroupUuids: Array<string>, purchasedLocationUuids?: Array<string> | null, purchasedLocationGroupUuids?: Array<string> | null, excludeThreshold?: boolean | null, countProductsBy: Count_Products_By, threshold: number, operator: Event_Purchase_Condition_Operator } | null, audienceEventDateCondition?: { __typename: 'AudienceEventDateOneOfCondition', fixedDateRange?: { __typename: 'FixedDateRange', startDate: string, endDate: string } | null, relativeMonthBack?: { __typename: 'RelativeMonthsBack', relativeMonthsBack: number } | null, timeWindow?: { __typename: 'TimeWindow', timeWindow: Audience_Purchase_Time_Window } | null } | null }> | null } | { __typename: 'AudienceInAllProductInterestsTargetingAttribute', productCategories: Array<string> } | { __typename: 'AudienceInAllSegmentsTargetingAttribute', segmentIds: Array<string> } | { __typename: 'AudienceInAnyEventTargetingAttribute', conditions?: Array<{ __typename: 'AudienceEventCondition', timeWindow?: Audience_Purchase_Time_Window | null, times: number, operator?: Event_Targeting_Condition_Operator | null, loyaltyEventUuid?: string | null, gameUuid?: string | null, purchaseCondition?: { __typename: 'AudienceEventPurchaseCondition', productGroupUuids: Array<string>, purchasedLocationUuids?: Array<string> | null, purchasedLocationGroupUuids?: Array<string> | null, excludeThreshold?: boolean | null, countProductsBy: Count_Products_By, threshold: number, operator: Event_Purchase_Condition_Operator } | null, audienceEventDateCondition?: { __typename: 'AudienceEventDateOneOfCondition', fixedDateRange?: { __typename: 'FixedDateRange', startDate: string, endDate: string } | null, relativeMonthBack?: { __typename: 'RelativeMonthsBack', relativeMonthsBack: number } | null, timeWindow?: { __typename: 'TimeWindow', timeWindow: Audience_Purchase_Time_Window } | null } | null }> | null } | { __typename: 'AudienceInAnyProductInterestsTargetingAttribute', productCategories: Array<string> } | { __typename: 'AudienceInAnySegmentsTargetingAttribute', segmentIds: Array<string> } | { __typename: 'AudienceNotInAllEventTargetingAttribute', conditions?: Array<{ __typename: 'AudienceEventCondition', timeWindow?: Audience_Purchase_Time_Window | null, times: number, operator?: Event_Targeting_Condition_Operator | null, loyaltyEventUuid?: string | null, gameUuid?: string | null, purchaseCondition?: { __typename: 'AudienceEventPurchaseCondition', productGroupUuids: Array<string>, purchasedLocationUuids?: Array<string> | null, purchasedLocationGroupUuids?: Array<string> | null, excludeThreshold?: boolean | null, countProductsBy: Count_Products_By, threshold: number, operator: Event_Purchase_Condition_Operator } | null, audienceEventDateCondition?: { __typename: 'AudienceEventDateOneOfCondition', fixedDateRange?: { __typename: 'FixedDateRange', startDate: string, endDate: string } | null, relativeMonthBack?: { __typename: 'RelativeMonthsBack', relativeMonthsBack: number } | null, timeWindow?: { __typename: 'TimeWindow', timeWindow: Audience_Purchase_Time_Window } | null } | null }> | null } | { __typename: 'AudienceNotInAllProductInterestsTargetingAttribute', productCategories: Array<string> } | { __typename: 'AudienceNotInAnyEventTargetingAttribute', conditions?: Array<{ __typename: 'AudienceEventCondition', timeWindow?: Audience_Purchase_Time_Window | null, times: number, operator?: Event_Targeting_Condition_Operator | null, loyaltyEventUuid?: string | null, gameUuid?: string | null, purchaseCondition?: { __typename: 'AudienceEventPurchaseCondition', productGroupUuids: Array<string>, purchasedLocationUuids?: Array<string> | null, purchasedLocationGroupUuids?: Array<string> | null, excludeThreshold?: boolean | null, countProductsBy: Count_Products_By, threshold: number, operator: Event_Purchase_Condition_Operator } | null, audienceEventDateCondition?: { __typename: 'AudienceEventDateOneOfCondition', fixedDateRange?: { __typename: 'FixedDateRange', startDate: string, endDate: string } | null, relativeMonthBack?: { __typename: 'RelativeMonthsBack', relativeMonthsBack: number } | null, timeWindow?: { __typename: 'TimeWindow', timeWindow: Audience_Purchase_Time_Window } | null } | null }> | null } | { __typename: 'AudienceNotInAnyProductInterestsTargetingAttribute', productCategories: Array<string> } | { __typename: 'AudienceNotInAnySegmentsTargetingAttribute', segmentIds: Array<string> } | { __typename: 'AudienceOfferFulfillmentTargetingAttribute', fulfilled: boolean, operator?: Offer_Fulfillment_Operator | null, timesFulfilled?: number | null, targetOfferId: string } | { __typename: 'AudiencePointBalanceTargetingAttribute', target: Point_Balance_Target, minAmount?: number | null, maxAmount?: number | null, pointBalanceAmount?: number | null, pointBalanceOperator?: Audience_Operator | null } | { __typename: 'AudiencePurchasedAtLeastTargetingAttribute', productGroupIds?: Array<string> | null, countProductsBy?: Count_Products_By | null, threshold?: number | null, excludeThreshold?: boolean | null, timeWindow?: Audience_Purchase_Time_Window | null, targetYear?: number | null, targetMonth?: number | null, startDate?: string | null, endDate?: string | null, purchasedLocationUuids?: Array<string> | null, purchasedLocationGroupUuids?: Array<string> | null, relativeMonthsBack?: number | null } | { __typename: 'AudiencePurchasedAtMostTargetingAttribute', productGroupIds?: Array<string> | null, countProductsBy?: Count_Products_By | null, threshold?: number | null, excludeThreshold?: boolean | null, timeWindow?: Audience_Purchase_Time_Window | null, targetYear?: number | null, targetMonth?: number | null, startDate?: string | null, endDate?: string | null, purchasedLocationUuids?: Array<string> | null, purchasedLocationGroupUuids?: Array<string> | null, relativeMonthsBack?: number | null } | { __typename: 'AudienceRetailerNetworkSiteUsersTargetingAttribute', retailerNetworkOperator?: Retailer_Network_Operator | null, retailerNetworkUserTypes: Array<Retailer_Network_User_Type>, retailerNetworkUuids?: Array<string> | null, userTypeOperator: Retailer_Network_User_Type_Operator } | { __typename: 'AudienceStoreLocationTargetingAttribute', locationsIds?: Array<string> | null, locationGroupUuids?: Array<string> | null } | { __typename: 'AudienceSurveyAnswerTargetingAttribute' } | { __typename: 'AudienceSurveyResponseTargetingAttribute', maxAmount?: number | null, minAmount?: number | null, questionUuid: string, selectedOptions?: Array<string> | null, surveyResponse?: string | null, surveyUuid: string, locationsUuids?: Array<string> | null, locationGroupUuids?: Array<string> | null, surveyOperator: Audience_Survey_Response_Operator } | { __typename: 'AudienceTimeSinceLastVisitTargetingAttribute', amount: number, period: Time_Period, timeSinceLastVisitOperator: Time_Since_Last_Visit_Operator } | { __typename: 'AudienceTimeSinceMembershipAcquisitionTargetingAttribute', membershipCreatedAmount: number, membershipCreatedOperator: Time_Since_Membership_Acquisition_Operator } | { __typename: 'AudienceWalletSteeringTargetingAttribute', walletUuid: string, attribute: Wallet_Steering_Attribute, walletSteeringOperator: Wallet_Steering_Operator, value: number, unitOfMeasure: Unit_Of_Measure }> } };

export type AudienceUpdateMutationVariables = Exact<{
  input: AudienceUpdate;
}>;


export type AudienceUpdateMutation = { __typename: 'Mutation', audienceUpdate: { __typename: 'Audience', uuid: string, name: string, description: string, membershipCount: number, status: Audience_Status, hasBeenBackFilled?: boolean | null, createdAt: string, updatedAt: string, draftCount?: number | null, draftCountCalculationRequestedAt?: string | null, lastDraftCountCalculationAt?: string | null, targetingAttributes: Array<{ __typename: 'AudienceAgeWithinTargetingAttribute', minimumAge?: number | null, maximumAge?: number | null } | { __typename: 'AudienceAggregatedAudiencesTargetingAttribute', combinedAudiencesOperator?: Aggregated_Audience_Operator | null, combinedAudiencesTarget: Array<string> } | { __typename: 'AudienceCommunicationPreferenceTargetingAttribute', criteria: Array<{ __typename: 'AudienceCommunicationPreferenceCriteria', mechanism: Communication_Preference_Mechanism, status: Communication_Preference_Opt_In_Status, subBrandUuid?: string | null }> } | { __typename: 'AudienceExternalIdentityVerificationTargetingAttribute', provider: ExternalIdentityVerificationProvider, verificationAttributes: Array<string>, identityVerificationOperator: External_Identity_Verification_Operator } | { __typename: 'AudienceFuelAndConvenienceProfileTargetingAttribute', criteria: Array<{ __typename: 'AudienceFuelAndConvenienceProfileCriteria', attribute: Fuel_And_Convenience_Profile_Attribute, operator: Fuel_And_Convenience_Profile_Operator, target?: Array<string> | null }> } | { __typename: 'AudienceInAllEventTargetingAttribute', conditions?: Array<{ __typename: 'AudienceEventCondition', timeWindow?: Audience_Purchase_Time_Window | null, times: number, operator?: Event_Targeting_Condition_Operator | null, loyaltyEventUuid?: string | null, gameUuid?: string | null, purchaseCondition?: { __typename: 'AudienceEventPurchaseCondition', productGroupUuids: Array<string>, purchasedLocationUuids?: Array<string> | null, purchasedLocationGroupUuids?: Array<string> | null, excludeThreshold?: boolean | null, countProductsBy: Count_Products_By, threshold: number, operator: Event_Purchase_Condition_Operator } | null, audienceEventDateCondition?: { __typename: 'AudienceEventDateOneOfCondition', fixedDateRange?: { __typename: 'FixedDateRange', startDate: string, endDate: string } | null, relativeMonthBack?: { __typename: 'RelativeMonthsBack', relativeMonthsBack: number } | null, timeWindow?: { __typename: 'TimeWindow', timeWindow: Audience_Purchase_Time_Window } | null } | null }> | null } | { __typename: 'AudienceInAllProductInterestsTargetingAttribute', productCategories: Array<string> } | { __typename: 'AudienceInAllSegmentsTargetingAttribute', segmentIds: Array<string> } | { __typename: 'AudienceInAnyEventTargetingAttribute', conditions?: Array<{ __typename: 'AudienceEventCondition', timeWindow?: Audience_Purchase_Time_Window | null, times: number, operator?: Event_Targeting_Condition_Operator | null, loyaltyEventUuid?: string | null, gameUuid?: string | null, purchaseCondition?: { __typename: 'AudienceEventPurchaseCondition', productGroupUuids: Array<string>, purchasedLocationUuids?: Array<string> | null, purchasedLocationGroupUuids?: Array<string> | null, excludeThreshold?: boolean | null, countProductsBy: Count_Products_By, threshold: number, operator: Event_Purchase_Condition_Operator } | null, audienceEventDateCondition?: { __typename: 'AudienceEventDateOneOfCondition', fixedDateRange?: { __typename: 'FixedDateRange', startDate: string, endDate: string } | null, relativeMonthBack?: { __typename: 'RelativeMonthsBack', relativeMonthsBack: number } | null, timeWindow?: { __typename: 'TimeWindow', timeWindow: Audience_Purchase_Time_Window } | null } | null }> | null } | { __typename: 'AudienceInAnyProductInterestsTargetingAttribute', productCategories: Array<string> } | { __typename: 'AudienceInAnySegmentsTargetingAttribute', segmentIds: Array<string> } | { __typename: 'AudienceNotInAllEventTargetingAttribute', conditions?: Array<{ __typename: 'AudienceEventCondition', timeWindow?: Audience_Purchase_Time_Window | null, times: number, operator?: Event_Targeting_Condition_Operator | null, loyaltyEventUuid?: string | null, gameUuid?: string | null, purchaseCondition?: { __typename: 'AudienceEventPurchaseCondition', productGroupUuids: Array<string>, purchasedLocationUuids?: Array<string> | null, purchasedLocationGroupUuids?: Array<string> | null, excludeThreshold?: boolean | null, countProductsBy: Count_Products_By, threshold: number, operator: Event_Purchase_Condition_Operator } | null, audienceEventDateCondition?: { __typename: 'AudienceEventDateOneOfCondition', fixedDateRange?: { __typename: 'FixedDateRange', startDate: string, endDate: string } | null, relativeMonthBack?: { __typename: 'RelativeMonthsBack', relativeMonthsBack: number } | null, timeWindow?: { __typename: 'TimeWindow', timeWindow: Audience_Purchase_Time_Window } | null } | null }> | null } | { __typename: 'AudienceNotInAllProductInterestsTargetingAttribute', productCategories: Array<string> } | { __typename: 'AudienceNotInAnyEventTargetingAttribute', conditions?: Array<{ __typename: 'AudienceEventCondition', timeWindow?: Audience_Purchase_Time_Window | null, times: number, operator?: Event_Targeting_Condition_Operator | null, loyaltyEventUuid?: string | null, gameUuid?: string | null, purchaseCondition?: { __typename: 'AudienceEventPurchaseCondition', productGroupUuids: Array<string>, purchasedLocationUuids?: Array<string> | null, purchasedLocationGroupUuids?: Array<string> | null, excludeThreshold?: boolean | null, countProductsBy: Count_Products_By, threshold: number, operator: Event_Purchase_Condition_Operator } | null, audienceEventDateCondition?: { __typename: 'AudienceEventDateOneOfCondition', fixedDateRange?: { __typename: 'FixedDateRange', startDate: string, endDate: string } | null, relativeMonthBack?: { __typename: 'RelativeMonthsBack', relativeMonthsBack: number } | null, timeWindow?: { __typename: 'TimeWindow', timeWindow: Audience_Purchase_Time_Window } | null } | null }> | null } | { __typename: 'AudienceNotInAnyProductInterestsTargetingAttribute', productCategories: Array<string> } | { __typename: 'AudienceNotInAnySegmentsTargetingAttribute', segmentIds: Array<string> } | { __typename: 'AudienceOfferFulfillmentTargetingAttribute', fulfilled: boolean, operator?: Offer_Fulfillment_Operator | null, timesFulfilled?: number | null, targetOfferId: string } | { __typename: 'AudiencePointBalanceTargetingAttribute', target: Point_Balance_Target, minAmount?: number | null, maxAmount?: number | null, pointBalanceAmount?: number | null, pointBalanceOperator?: Audience_Operator | null } | { __typename: 'AudiencePurchasedAtLeastTargetingAttribute', productGroupIds?: Array<string> | null, countProductsBy?: Count_Products_By | null, threshold?: number | null, excludeThreshold?: boolean | null, timeWindow?: Audience_Purchase_Time_Window | null, targetYear?: number | null, targetMonth?: number | null, startDate?: string | null, endDate?: string | null, purchasedLocationUuids?: Array<string> | null, purchasedLocationGroupUuids?: Array<string> | null, relativeMonthsBack?: number | null } | { __typename: 'AudiencePurchasedAtMostTargetingAttribute', productGroupIds?: Array<string> | null, countProductsBy?: Count_Products_By | null, threshold?: number | null, excludeThreshold?: boolean | null, timeWindow?: Audience_Purchase_Time_Window | null, targetYear?: number | null, targetMonth?: number | null, startDate?: string | null, endDate?: string | null, purchasedLocationUuids?: Array<string> | null, purchasedLocationGroupUuids?: Array<string> | null, relativeMonthsBack?: number | null } | { __typename: 'AudienceRetailerNetworkSiteUsersTargetingAttribute', retailerNetworkOperator?: Retailer_Network_Operator | null, retailerNetworkUserTypes: Array<Retailer_Network_User_Type>, retailerNetworkUuids?: Array<string> | null, userTypeOperator: Retailer_Network_User_Type_Operator } | { __typename: 'AudienceStoreLocationTargetingAttribute', locationsIds?: Array<string> | null, locationGroupUuids?: Array<string> | null } | { __typename: 'AudienceSurveyAnswerTargetingAttribute' } | { __typename: 'AudienceSurveyResponseTargetingAttribute', maxAmount?: number | null, minAmount?: number | null, questionUuid: string, selectedOptions?: Array<string> | null, surveyResponse?: string | null, surveyUuid: string, locationsUuids?: Array<string> | null, locationGroupUuids?: Array<string> | null, surveyOperator: Audience_Survey_Response_Operator } | { __typename: 'AudienceTimeSinceLastVisitTargetingAttribute', amount: number, period: Time_Period, timeSinceLastVisitOperator: Time_Since_Last_Visit_Operator } | { __typename: 'AudienceTimeSinceMembershipAcquisitionTargetingAttribute', membershipCreatedAmount: number, membershipCreatedOperator: Time_Since_Membership_Acquisition_Operator } | { __typename: 'AudienceWalletSteeringTargetingAttribute', walletUuid: string, attribute: Wallet_Steering_Attribute, walletSteeringOperator: Wallet_Steering_Operator, value: number, unitOfMeasure: Unit_Of_Measure }> } };

export type AudienceDeleteMutationVariables = Exact<{
  uuid: Scalars['ID']['input'];
}>;


export type AudienceDeleteMutation = { __typename: 'Mutation', audienceDelete: boolean };

export type AudienceActivateMutationVariables = Exact<{
  uuid: Scalars['ID']['input'];
}>;


export type AudienceActivateMutation = { __typename: 'Mutation', audienceActivate: { __typename: 'Audience', uuid: string, name: string, description: string, membershipCount: number, status: Audience_Status, hasBeenBackFilled?: boolean | null, createdAt: string, updatedAt: string, draftCount?: number | null, draftCountCalculationRequestedAt?: string | null, lastDraftCountCalculationAt?: string | null, targetingAttributes: Array<{ __typename: 'AudienceAgeWithinTargetingAttribute', minimumAge?: number | null, maximumAge?: number | null } | { __typename: 'AudienceAggregatedAudiencesTargetingAttribute', combinedAudiencesOperator?: Aggregated_Audience_Operator | null, combinedAudiencesTarget: Array<string> } | { __typename: 'AudienceCommunicationPreferenceTargetingAttribute', criteria: Array<{ __typename: 'AudienceCommunicationPreferenceCriteria', mechanism: Communication_Preference_Mechanism, status: Communication_Preference_Opt_In_Status, subBrandUuid?: string | null }> } | { __typename: 'AudienceExternalIdentityVerificationTargetingAttribute', provider: ExternalIdentityVerificationProvider, verificationAttributes: Array<string>, identityVerificationOperator: External_Identity_Verification_Operator } | { __typename: 'AudienceFuelAndConvenienceProfileTargetingAttribute', criteria: Array<{ __typename: 'AudienceFuelAndConvenienceProfileCriteria', attribute: Fuel_And_Convenience_Profile_Attribute, operator: Fuel_And_Convenience_Profile_Operator, target?: Array<string> | null }> } | { __typename: 'AudienceInAllEventTargetingAttribute', conditions?: Array<{ __typename: 'AudienceEventCondition', timeWindow?: Audience_Purchase_Time_Window | null, times: number, operator?: Event_Targeting_Condition_Operator | null, loyaltyEventUuid?: string | null, gameUuid?: string | null, purchaseCondition?: { __typename: 'AudienceEventPurchaseCondition', productGroupUuids: Array<string>, purchasedLocationUuids?: Array<string> | null, purchasedLocationGroupUuids?: Array<string> | null, excludeThreshold?: boolean | null, countProductsBy: Count_Products_By, threshold: number, operator: Event_Purchase_Condition_Operator } | null, audienceEventDateCondition?: { __typename: 'AudienceEventDateOneOfCondition', fixedDateRange?: { __typename: 'FixedDateRange', startDate: string, endDate: string } | null, relativeMonthBack?: { __typename: 'RelativeMonthsBack', relativeMonthsBack: number } | null, timeWindow?: { __typename: 'TimeWindow', timeWindow: Audience_Purchase_Time_Window } | null } | null }> | null } | { __typename: 'AudienceInAllProductInterestsTargetingAttribute', productCategories: Array<string> } | { __typename: 'AudienceInAllSegmentsTargetingAttribute', segmentIds: Array<string> } | { __typename: 'AudienceInAnyEventTargetingAttribute', conditions?: Array<{ __typename: 'AudienceEventCondition', timeWindow?: Audience_Purchase_Time_Window | null, times: number, operator?: Event_Targeting_Condition_Operator | null, loyaltyEventUuid?: string | null, gameUuid?: string | null, purchaseCondition?: { __typename: 'AudienceEventPurchaseCondition', productGroupUuids: Array<string>, purchasedLocationUuids?: Array<string> | null, purchasedLocationGroupUuids?: Array<string> | null, excludeThreshold?: boolean | null, countProductsBy: Count_Products_By, threshold: number, operator: Event_Purchase_Condition_Operator } | null, audienceEventDateCondition?: { __typename: 'AudienceEventDateOneOfCondition', fixedDateRange?: { __typename: 'FixedDateRange', startDate: string, endDate: string } | null, relativeMonthBack?: { __typename: 'RelativeMonthsBack', relativeMonthsBack: number } | null, timeWindow?: { __typename: 'TimeWindow', timeWindow: Audience_Purchase_Time_Window } | null } | null }> | null } | { __typename: 'AudienceInAnyProductInterestsTargetingAttribute', productCategories: Array<string> } | { __typename: 'AudienceInAnySegmentsTargetingAttribute', segmentIds: Array<string> } | { __typename: 'AudienceNotInAllEventTargetingAttribute', conditions?: Array<{ __typename: 'AudienceEventCondition', timeWindow?: Audience_Purchase_Time_Window | null, times: number, operator?: Event_Targeting_Condition_Operator | null, loyaltyEventUuid?: string | null, gameUuid?: string | null, purchaseCondition?: { __typename: 'AudienceEventPurchaseCondition', productGroupUuids: Array<string>, purchasedLocationUuids?: Array<string> | null, purchasedLocationGroupUuids?: Array<string> | null, excludeThreshold?: boolean | null, countProductsBy: Count_Products_By, threshold: number, operator: Event_Purchase_Condition_Operator } | null, audienceEventDateCondition?: { __typename: 'AudienceEventDateOneOfCondition', fixedDateRange?: { __typename: 'FixedDateRange', startDate: string, endDate: string } | null, relativeMonthBack?: { __typename: 'RelativeMonthsBack', relativeMonthsBack: number } | null, timeWindow?: { __typename: 'TimeWindow', timeWindow: Audience_Purchase_Time_Window } | null } | null }> | null } | { __typename: 'AudienceNotInAllProductInterestsTargetingAttribute', productCategories: Array<string> } | { __typename: 'AudienceNotInAnyEventTargetingAttribute', conditions?: Array<{ __typename: 'AudienceEventCondition', timeWindow?: Audience_Purchase_Time_Window | null, times: number, operator?: Event_Targeting_Condition_Operator | null, loyaltyEventUuid?: string | null, gameUuid?: string | null, purchaseCondition?: { __typename: 'AudienceEventPurchaseCondition', productGroupUuids: Array<string>, purchasedLocationUuids?: Array<string> | null, purchasedLocationGroupUuids?: Array<string> | null, excludeThreshold?: boolean | null, countProductsBy: Count_Products_By, threshold: number, operator: Event_Purchase_Condition_Operator } | null, audienceEventDateCondition?: { __typename: 'AudienceEventDateOneOfCondition', fixedDateRange?: { __typename: 'FixedDateRange', startDate: string, endDate: string } | null, relativeMonthBack?: { __typename: 'RelativeMonthsBack', relativeMonthsBack: number } | null, timeWindow?: { __typename: 'TimeWindow', timeWindow: Audience_Purchase_Time_Window } | null } | null }> | null } | { __typename: 'AudienceNotInAnyProductInterestsTargetingAttribute', productCategories: Array<string> } | { __typename: 'AudienceNotInAnySegmentsTargetingAttribute', segmentIds: Array<string> } | { __typename: 'AudienceOfferFulfillmentTargetingAttribute', fulfilled: boolean, operator?: Offer_Fulfillment_Operator | null, timesFulfilled?: number | null, targetOfferId: string } | { __typename: 'AudiencePointBalanceTargetingAttribute', target: Point_Balance_Target, minAmount?: number | null, maxAmount?: number | null, pointBalanceAmount?: number | null, pointBalanceOperator?: Audience_Operator | null } | { __typename: 'AudiencePurchasedAtLeastTargetingAttribute', productGroupIds?: Array<string> | null, countProductsBy?: Count_Products_By | null, threshold?: number | null, excludeThreshold?: boolean | null, timeWindow?: Audience_Purchase_Time_Window | null, targetYear?: number | null, targetMonth?: number | null, startDate?: string | null, endDate?: string | null, purchasedLocationUuids?: Array<string> | null, purchasedLocationGroupUuids?: Array<string> | null, relativeMonthsBack?: number | null } | { __typename: 'AudiencePurchasedAtMostTargetingAttribute', productGroupIds?: Array<string> | null, countProductsBy?: Count_Products_By | null, threshold?: number | null, excludeThreshold?: boolean | null, timeWindow?: Audience_Purchase_Time_Window | null, targetYear?: number | null, targetMonth?: number | null, startDate?: string | null, endDate?: string | null, purchasedLocationUuids?: Array<string> | null, purchasedLocationGroupUuids?: Array<string> | null, relativeMonthsBack?: number | null } | { __typename: 'AudienceRetailerNetworkSiteUsersTargetingAttribute', retailerNetworkOperator?: Retailer_Network_Operator | null, retailerNetworkUserTypes: Array<Retailer_Network_User_Type>, retailerNetworkUuids?: Array<string> | null, userTypeOperator: Retailer_Network_User_Type_Operator } | { __typename: 'AudienceStoreLocationTargetingAttribute', locationsIds?: Array<string> | null, locationGroupUuids?: Array<string> | null } | { __typename: 'AudienceSurveyAnswerTargetingAttribute' } | { __typename: 'AudienceSurveyResponseTargetingAttribute', maxAmount?: number | null, minAmount?: number | null, questionUuid: string, selectedOptions?: Array<string> | null, surveyResponse?: string | null, surveyUuid: string, locationsUuids?: Array<string> | null, locationGroupUuids?: Array<string> | null, surveyOperator: Audience_Survey_Response_Operator } | { __typename: 'AudienceTimeSinceLastVisitTargetingAttribute', amount: number, period: Time_Period, timeSinceLastVisitOperator: Time_Since_Last_Visit_Operator } | { __typename: 'AudienceTimeSinceMembershipAcquisitionTargetingAttribute', membershipCreatedAmount: number, membershipCreatedOperator: Time_Since_Membership_Acquisition_Operator } | { __typename: 'AudienceWalletSteeringTargetingAttribute', walletUuid: string, attribute: Wallet_Steering_Attribute, walletSteeringOperator: Wallet_Steering_Operator, value: number, unitOfMeasure: Unit_Of_Measure }> } };

export type ReportAudienceStartGenerationJobMutationVariables = Exact<{
  input: ReportAudienceStartGenerationJobInput;
}>;


export type ReportAudienceStartGenerationJobMutation = { __typename: 'Mutation', reportAudienceStartGenerationJob: { __typename: 'ReportGenerationJob', uuid: string, status: ReportStatus } };

export type MarkAudienceForSizeCalculationMutationVariables = Exact<{
  uuid: Scalars['ID']['input'];
}>;


export type MarkAudienceForSizeCalculationMutation = { __typename: 'Mutation', markAudienceForCalculation: boolean };

export type AudienceQueryVariables = Exact<{
  filter?: InputMaybe<AudienceFilter>;
}>;


export type AudienceQuery = { __typename: 'Query', audiences: { __typename: 'AudienceConnection', edges: Array<{ __typename: 'AudienceEdge', cursor: string, node: { __typename: 'Audience', uuid: string, name: string, description: string, membershipCount: number, status: Audience_Status, hasBeenBackFilled?: boolean | null, createdAt: string, updatedAt: string, draftCount?: number | null, draftCountCalculationRequestedAt?: string | null, lastDraftCountCalculationAt?: string | null, targetingAttributes: Array<{ __typename: 'AudienceAgeWithinTargetingAttribute', minimumAge?: number | null, maximumAge?: number | null } | { __typename: 'AudienceAggregatedAudiencesTargetingAttribute', combinedAudiencesOperator?: Aggregated_Audience_Operator | null, combinedAudiencesTarget: Array<string> } | { __typename: 'AudienceCommunicationPreferenceTargetingAttribute', criteria: Array<{ __typename: 'AudienceCommunicationPreferenceCriteria', mechanism: Communication_Preference_Mechanism, status: Communication_Preference_Opt_In_Status, subBrandUuid?: string | null }> } | { __typename: 'AudienceExternalIdentityVerificationTargetingAttribute', provider: ExternalIdentityVerificationProvider, verificationAttributes: Array<string>, identityVerificationOperator: External_Identity_Verification_Operator } | { __typename: 'AudienceFuelAndConvenienceProfileTargetingAttribute', criteria: Array<{ __typename: 'AudienceFuelAndConvenienceProfileCriteria', attribute: Fuel_And_Convenience_Profile_Attribute, operator: Fuel_And_Convenience_Profile_Operator, target?: Array<string> | null }> } | { __typename: 'AudienceInAllEventTargetingAttribute', conditions?: Array<{ __typename: 'AudienceEventCondition', timeWindow?: Audience_Purchase_Time_Window | null, times: number, operator?: Event_Targeting_Condition_Operator | null, loyaltyEventUuid?: string | null, gameUuid?: string | null, purchaseCondition?: { __typename: 'AudienceEventPurchaseCondition', productGroupUuids: Array<string>, purchasedLocationUuids?: Array<string> | null, purchasedLocationGroupUuids?: Array<string> | null, excludeThreshold?: boolean | null, countProductsBy: Count_Products_By, threshold: number, operator: Event_Purchase_Condition_Operator } | null, audienceEventDateCondition?: { __typename: 'AudienceEventDateOneOfCondition', fixedDateRange?: { __typename: 'FixedDateRange', startDate: string, endDate: string } | null, relativeMonthBack?: { __typename: 'RelativeMonthsBack', relativeMonthsBack: number } | null, timeWindow?: { __typename: 'TimeWindow', timeWindow: Audience_Purchase_Time_Window } | null } | null }> | null } | { __typename: 'AudienceInAllProductInterestsTargetingAttribute', productCategories: Array<string> } | { __typename: 'AudienceInAllSegmentsTargetingAttribute', segmentIds: Array<string> } | { __typename: 'AudienceInAnyEventTargetingAttribute', conditions?: Array<{ __typename: 'AudienceEventCondition', timeWindow?: Audience_Purchase_Time_Window | null, times: number, operator?: Event_Targeting_Condition_Operator | null, loyaltyEventUuid?: string | null, gameUuid?: string | null, purchaseCondition?: { __typename: 'AudienceEventPurchaseCondition', productGroupUuids: Array<string>, purchasedLocationUuids?: Array<string> | null, purchasedLocationGroupUuids?: Array<string> | null, excludeThreshold?: boolean | null, countProductsBy: Count_Products_By, threshold: number, operator: Event_Purchase_Condition_Operator } | null, audienceEventDateCondition?: { __typename: 'AudienceEventDateOneOfCondition', fixedDateRange?: { __typename: 'FixedDateRange', startDate: string, endDate: string } | null, relativeMonthBack?: { __typename: 'RelativeMonthsBack', relativeMonthsBack: number } | null, timeWindow?: { __typename: 'TimeWindow', timeWindow: Audience_Purchase_Time_Window } | null } | null }> | null } | { __typename: 'AudienceInAnyProductInterestsTargetingAttribute', productCategories: Array<string> } | { __typename: 'AudienceInAnySegmentsTargetingAttribute', segmentIds: Array<string> } | { __typename: 'AudienceNotInAllEventTargetingAttribute', conditions?: Array<{ __typename: 'AudienceEventCondition', timeWindow?: Audience_Purchase_Time_Window | null, times: number, operator?: Event_Targeting_Condition_Operator | null, loyaltyEventUuid?: string | null, gameUuid?: string | null, purchaseCondition?: { __typename: 'AudienceEventPurchaseCondition', productGroupUuids: Array<string>, purchasedLocationUuids?: Array<string> | null, purchasedLocationGroupUuids?: Array<string> | null, excludeThreshold?: boolean | null, countProductsBy: Count_Products_By, threshold: number, operator: Event_Purchase_Condition_Operator } | null, audienceEventDateCondition?: { __typename: 'AudienceEventDateOneOfCondition', fixedDateRange?: { __typename: 'FixedDateRange', startDate: string, endDate: string } | null, relativeMonthBack?: { __typename: 'RelativeMonthsBack', relativeMonthsBack: number } | null, timeWindow?: { __typename: 'TimeWindow', timeWindow: Audience_Purchase_Time_Window } | null } | null }> | null } | { __typename: 'AudienceNotInAllProductInterestsTargetingAttribute', productCategories: Array<string> } | { __typename: 'AudienceNotInAnyEventTargetingAttribute', conditions?: Array<{ __typename: 'AudienceEventCondition', timeWindow?: Audience_Purchase_Time_Window | null, times: number, operator?: Event_Targeting_Condition_Operator | null, loyaltyEventUuid?: string | null, gameUuid?: string | null, purchaseCondition?: { __typename: 'AudienceEventPurchaseCondition', productGroupUuids: Array<string>, purchasedLocationUuids?: Array<string> | null, purchasedLocationGroupUuids?: Array<string> | null, excludeThreshold?: boolean | null, countProductsBy: Count_Products_By, threshold: number, operator: Event_Purchase_Condition_Operator } | null, audienceEventDateCondition?: { __typename: 'AudienceEventDateOneOfCondition', fixedDateRange?: { __typename: 'FixedDateRange', startDate: string, endDate: string } | null, relativeMonthBack?: { __typename: 'RelativeMonthsBack', relativeMonthsBack: number } | null, timeWindow?: { __typename: 'TimeWindow', timeWindow: Audience_Purchase_Time_Window } | null } | null }> | null } | { __typename: 'AudienceNotInAnyProductInterestsTargetingAttribute', productCategories: Array<string> } | { __typename: 'AudienceNotInAnySegmentsTargetingAttribute', segmentIds: Array<string> } | { __typename: 'AudienceOfferFulfillmentTargetingAttribute', fulfilled: boolean, operator?: Offer_Fulfillment_Operator | null, timesFulfilled?: number | null, targetOfferId: string } | { __typename: 'AudiencePointBalanceTargetingAttribute', target: Point_Balance_Target, minAmount?: number | null, maxAmount?: number | null, pointBalanceAmount?: number | null, pointBalanceOperator?: Audience_Operator | null } | { __typename: 'AudiencePurchasedAtLeastTargetingAttribute', productGroupIds?: Array<string> | null, countProductsBy?: Count_Products_By | null, threshold?: number | null, excludeThreshold?: boolean | null, timeWindow?: Audience_Purchase_Time_Window | null, targetYear?: number | null, targetMonth?: number | null, startDate?: string | null, endDate?: string | null, purchasedLocationUuids?: Array<string> | null, purchasedLocationGroupUuids?: Array<string> | null, relativeMonthsBack?: number | null } | { __typename: 'AudiencePurchasedAtMostTargetingAttribute', productGroupIds?: Array<string> | null, countProductsBy?: Count_Products_By | null, threshold?: number | null, excludeThreshold?: boolean | null, timeWindow?: Audience_Purchase_Time_Window | null, targetYear?: number | null, targetMonth?: number | null, startDate?: string | null, endDate?: string | null, purchasedLocationUuids?: Array<string> | null, purchasedLocationGroupUuids?: Array<string> | null, relativeMonthsBack?: number | null } | { __typename: 'AudienceRetailerNetworkSiteUsersTargetingAttribute', retailerNetworkOperator?: Retailer_Network_Operator | null, retailerNetworkUserTypes: Array<Retailer_Network_User_Type>, retailerNetworkUuids?: Array<string> | null, userTypeOperator: Retailer_Network_User_Type_Operator } | { __typename: 'AudienceStoreLocationTargetingAttribute', locationsIds?: Array<string> | null, locationGroupUuids?: Array<string> | null } | { __typename: 'AudienceSurveyAnswerTargetingAttribute' } | { __typename: 'AudienceSurveyResponseTargetingAttribute', maxAmount?: number | null, minAmount?: number | null, questionUuid: string, selectedOptions?: Array<string> | null, surveyResponse?: string | null, surveyUuid: string, locationsUuids?: Array<string> | null, locationGroupUuids?: Array<string> | null, surveyOperator: Audience_Survey_Response_Operator } | { __typename: 'AudienceTimeSinceLastVisitTargetingAttribute', amount: number, period: Time_Period, timeSinceLastVisitOperator: Time_Since_Last_Visit_Operator } | { __typename: 'AudienceTimeSinceMembershipAcquisitionTargetingAttribute', membershipCreatedAmount: number, membershipCreatedOperator: Time_Since_Membership_Acquisition_Operator } | { __typename: 'AudienceWalletSteeringTargetingAttribute', walletUuid: string, attribute: Wallet_Steering_Attribute, walletSteeringOperator: Wallet_Steering_Operator, value: number, unitOfMeasure: Unit_Of_Measure }> } }> } };

export type AudienceNameByUuidQueryVariables = Exact<{
  uuid: Scalars['ID']['input'];
}>;


export type AudienceNameByUuidQuery = { __typename: 'Query', audiences: { __typename: 'AudienceConnection', edges: Array<{ __typename: 'AudienceEdge', node: { __typename: 'Audience', uuid: string, name: string } }> } };

export type AudiencesQueryVariables = Exact<{
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  filter?: InputMaybe<AudienceFilter>;
}>;


export type AudiencesQuery = { __typename: 'Query', audiences: { __typename: 'AudienceConnection', pageInfo: { __typename: 'PageInfo', hasNextPage: boolean, hasPreviousPage: boolean, startCursor?: string | null, endCursor?: string | null }, edges: Array<{ __typename: 'AudienceEdge', cursor: string, node: { __typename: 'Audience', uuid: string, name: string, description: string, status: Audience_Status, hasBeenBackFilled?: boolean | null, createdAt: string, targetingAttributes: Array<{ __typename: 'AudienceAgeWithinTargetingAttribute', minimumAge?: number | null, maximumAge?: number | null } | { __typename: 'AudienceAggregatedAudiencesTargetingAttribute', combinedAudiencesOperator?: Aggregated_Audience_Operator | null, combinedAudiencesTarget: Array<string> } | { __typename: 'AudienceCommunicationPreferenceTargetingAttribute', criteria: Array<{ __typename: 'AudienceCommunicationPreferenceCriteria', mechanism: Communication_Preference_Mechanism, status: Communication_Preference_Opt_In_Status, subBrandUuid?: string | null }> } | { __typename: 'AudienceExternalIdentityVerificationTargetingAttribute', provider: ExternalIdentityVerificationProvider, verificationAttributes: Array<string>, identityVerificationOperator: External_Identity_Verification_Operator } | { __typename: 'AudienceFuelAndConvenienceProfileTargetingAttribute', criteria: Array<{ __typename: 'AudienceFuelAndConvenienceProfileCriteria', attribute: Fuel_And_Convenience_Profile_Attribute, operator: Fuel_And_Convenience_Profile_Operator, target?: Array<string> | null }> } | { __typename: 'AudienceInAllEventTargetingAttribute', conditions?: Array<{ __typename: 'AudienceEventCondition', timeWindow?: Audience_Purchase_Time_Window | null, times: number, operator?: Event_Targeting_Condition_Operator | null, loyaltyEventUuid?: string | null, gameUuid?: string | null, purchaseCondition?: { __typename: 'AudienceEventPurchaseCondition', productGroupUuids: Array<string>, purchasedLocationUuids?: Array<string> | null, purchasedLocationGroupUuids?: Array<string> | null, excludeThreshold?: boolean | null, countProductsBy: Count_Products_By, threshold: number, operator: Event_Purchase_Condition_Operator } | null, audienceEventDateCondition?: { __typename: 'AudienceEventDateOneOfCondition', fixedDateRange?: { __typename: 'FixedDateRange', startDate: string, endDate: string } | null, relativeMonthBack?: { __typename: 'RelativeMonthsBack', relativeMonthsBack: number } | null, timeWindow?: { __typename: 'TimeWindow', timeWindow: Audience_Purchase_Time_Window } | null } | null }> | null } | { __typename: 'AudienceInAllProductInterestsTargetingAttribute', productCategories: Array<string> } | { __typename: 'AudienceInAllSegmentsTargetingAttribute', segmentIds: Array<string> } | { __typename: 'AudienceInAnyEventTargetingAttribute', conditions?: Array<{ __typename: 'AudienceEventCondition', timeWindow?: Audience_Purchase_Time_Window | null, times: number, operator?: Event_Targeting_Condition_Operator | null, loyaltyEventUuid?: string | null, gameUuid?: string | null, purchaseCondition?: { __typename: 'AudienceEventPurchaseCondition', productGroupUuids: Array<string>, purchasedLocationUuids?: Array<string> | null, purchasedLocationGroupUuids?: Array<string> | null, excludeThreshold?: boolean | null, countProductsBy: Count_Products_By, threshold: number, operator: Event_Purchase_Condition_Operator } | null, audienceEventDateCondition?: { __typename: 'AudienceEventDateOneOfCondition', fixedDateRange?: { __typename: 'FixedDateRange', startDate: string, endDate: string } | null, relativeMonthBack?: { __typename: 'RelativeMonthsBack', relativeMonthsBack: number } | null, timeWindow?: { __typename: 'TimeWindow', timeWindow: Audience_Purchase_Time_Window } | null } | null }> | null } | { __typename: 'AudienceInAnyProductInterestsTargetingAttribute', productCategories: Array<string> } | { __typename: 'AudienceInAnySegmentsTargetingAttribute', segmentIds: Array<string> } | { __typename: 'AudienceNotInAllEventTargetingAttribute', conditions?: Array<{ __typename: 'AudienceEventCondition', timeWindow?: Audience_Purchase_Time_Window | null, times: number, operator?: Event_Targeting_Condition_Operator | null, loyaltyEventUuid?: string | null, gameUuid?: string | null, purchaseCondition?: { __typename: 'AudienceEventPurchaseCondition', productGroupUuids: Array<string>, purchasedLocationUuids?: Array<string> | null, purchasedLocationGroupUuids?: Array<string> | null, excludeThreshold?: boolean | null, countProductsBy: Count_Products_By, threshold: number, operator: Event_Purchase_Condition_Operator } | null, audienceEventDateCondition?: { __typename: 'AudienceEventDateOneOfCondition', fixedDateRange?: { __typename: 'FixedDateRange', startDate: string, endDate: string } | null, relativeMonthBack?: { __typename: 'RelativeMonthsBack', relativeMonthsBack: number } | null, timeWindow?: { __typename: 'TimeWindow', timeWindow: Audience_Purchase_Time_Window } | null } | null }> | null } | { __typename: 'AudienceNotInAllProductInterestsTargetingAttribute', productCategories: Array<string> } | { __typename: 'AudienceNotInAnyEventTargetingAttribute', conditions?: Array<{ __typename: 'AudienceEventCondition', timeWindow?: Audience_Purchase_Time_Window | null, times: number, operator?: Event_Targeting_Condition_Operator | null, loyaltyEventUuid?: string | null, gameUuid?: string | null, purchaseCondition?: { __typename: 'AudienceEventPurchaseCondition', productGroupUuids: Array<string>, purchasedLocationUuids?: Array<string> | null, purchasedLocationGroupUuids?: Array<string> | null, excludeThreshold?: boolean | null, countProductsBy: Count_Products_By, threshold: number, operator: Event_Purchase_Condition_Operator } | null, audienceEventDateCondition?: { __typename: 'AudienceEventDateOneOfCondition', fixedDateRange?: { __typename: 'FixedDateRange', startDate: string, endDate: string } | null, relativeMonthBack?: { __typename: 'RelativeMonthsBack', relativeMonthsBack: number } | null, timeWindow?: { __typename: 'TimeWindow', timeWindow: Audience_Purchase_Time_Window } | null } | null }> | null } | { __typename: 'AudienceNotInAnyProductInterestsTargetingAttribute', productCategories: Array<string> } | { __typename: 'AudienceNotInAnySegmentsTargetingAttribute', segmentIds: Array<string> } | { __typename: 'AudienceOfferFulfillmentTargetingAttribute', fulfilled: boolean, operator?: Offer_Fulfillment_Operator | null, timesFulfilled?: number | null, targetOfferId: string } | { __typename: 'AudiencePointBalanceTargetingAttribute', target: Point_Balance_Target, minAmount?: number | null, maxAmount?: number | null, pointBalanceAmount?: number | null, pointBalanceOperator?: Audience_Operator | null } | { __typename: 'AudiencePurchasedAtLeastTargetingAttribute', productGroupIds?: Array<string> | null, countProductsBy?: Count_Products_By | null, threshold?: number | null, excludeThreshold?: boolean | null, timeWindow?: Audience_Purchase_Time_Window | null, targetYear?: number | null, targetMonth?: number | null, startDate?: string | null, endDate?: string | null, purchasedLocationUuids?: Array<string> | null, purchasedLocationGroupUuids?: Array<string> | null, relativeMonthsBack?: number | null } | { __typename: 'AudiencePurchasedAtMostTargetingAttribute', productGroupIds?: Array<string> | null, countProductsBy?: Count_Products_By | null, threshold?: number | null, excludeThreshold?: boolean | null, timeWindow?: Audience_Purchase_Time_Window | null, targetYear?: number | null, targetMonth?: number | null, startDate?: string | null, endDate?: string | null, purchasedLocationUuids?: Array<string> | null, purchasedLocationGroupUuids?: Array<string> | null, relativeMonthsBack?: number | null } | { __typename: 'AudienceRetailerNetworkSiteUsersTargetingAttribute', retailerNetworkOperator?: Retailer_Network_Operator | null, retailerNetworkUserTypes: Array<Retailer_Network_User_Type>, retailerNetworkUuids?: Array<string> | null, userTypeOperator: Retailer_Network_User_Type_Operator } | { __typename: 'AudienceStoreLocationTargetingAttribute', locationsIds?: Array<string> | null, locationGroupUuids?: Array<string> | null } | { __typename: 'AudienceSurveyAnswerTargetingAttribute' } | { __typename: 'AudienceSurveyResponseTargetingAttribute', maxAmount?: number | null, minAmount?: number | null, questionUuid: string, selectedOptions?: Array<string> | null, surveyResponse?: string | null, surveyUuid: string, locationsUuids?: Array<string> | null, locationGroupUuids?: Array<string> | null, surveyOperator: Audience_Survey_Response_Operator } | { __typename: 'AudienceTimeSinceLastVisitTargetingAttribute', amount: number, period: Time_Period, timeSinceLastVisitOperator: Time_Since_Last_Visit_Operator } | { __typename: 'AudienceTimeSinceMembershipAcquisitionTargetingAttribute', membershipCreatedAmount: number, membershipCreatedOperator: Time_Since_Membership_Acquisition_Operator } | { __typename: 'AudienceWalletSteeringTargetingAttribute', walletUuid: string, attribute: Wallet_Steering_Attribute, walletSteeringOperator: Wallet_Steering_Operator, value: number, unitOfMeasure: Unit_Of_Measure }> } }> } };

export type AudienceSelectItemsQueryVariables = Exact<{
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  filter?: InputMaybe<AudienceFilter>;
}>;


export type AudienceSelectItemsQuery = { __typename: 'Query', audiences: { __typename: 'AudienceConnection', pageInfo: { __typename: 'PageInfo', hasNextPage: boolean, hasPreviousPage: boolean, startCursor?: string | null, endCursor?: string | null }, edges: Array<{ __typename: 'AudienceEdge', cursor: string, node: { __typename: 'Audience', uuid: string, name: string } }> } };

export type AudienceDailyCountsQueryVariables = Exact<{
  filter?: InputMaybe<AudienceFilter>;
  startDate: Scalars['OCDate']['input'];
  endDate: Scalars['OCDate']['input'];
}>;


export type AudienceDailyCountsQuery = { __typename: 'Query', audiences: { __typename: 'AudienceConnection', edges: Array<{ __typename: 'AudienceEdge', cursor: string, node: { __typename: 'Audience', uuid: string, dailyCounts: Array<{ __typename: 'AudienceDailyCount', date: string, count: number }> } }> } };

export type GetAudienceProductGroupsQueryVariables = Exact<{
  filter?: InputMaybe<ProductGroupFilter>;
}>;


export type GetAudienceProductGroupsQuery = { __typename: 'Query', productGroups: { __typename: 'ProductGroupConnection', edges: Array<{ __typename: 'ProductGroupEdge', node: { __typename: 'ProductGroup', id: string, name: string, description?: string | null, key: Product_Group_Key, values: Array<string>, fuelProductGroup?: { __typename: 'FuelProductGroup', id: string, sortingRank: number, userSelectable: boolean, default: boolean } | null } }> } };

export type GetAudienceSegmentsQueryVariables = Exact<{
  filter?: InputMaybe<SegmentFilter>;
}>;


export type GetAudienceSegmentsQuery = { __typename: 'Query', segments: { __typename: 'SegmentConnection', edges: Array<{ __typename: 'SegmentEdge', node: { __typename: 'Segment', id: string, name: string, description: string, shortCode?: string | null, membershipCount: number, uuid: string } }> } };

export type GetReportFileDownloadLinkQueryVariables = Exact<{
  reportUuid: Scalars['ID']['input'];
}>;


export type GetReportFileDownloadLinkQuery = { __typename: 'Query', getReportFileDownloadLink?: string | null };

export type MagicLinkExchangeRefreshTokenToAuthTokenMutationVariables = Exact<{
  input: AccessTokenByRefreshTokenInput;
}>;


export type MagicLinkExchangeRefreshTokenToAuthTokenMutation = { __typename: 'Mutation', magicLinkExchangeRefreshTokenToAuthToken: { __typename: 'Tokens', accessToken: string, refreshToken: string } };

export type MagicLinkExchangeSessionIdToAuthTokenMutationVariables = Exact<{
  input: MagicLinkExchangeSessionIdToAuthTokenInput;
}>;


export type MagicLinkExchangeSessionIdToAuthTokenMutation = { __typename: 'Mutation', magicLinkExchangeSessionIdToAuthToken: { __typename: 'MagicLinkExchangePayload', tokens: { __typename: 'Tokens', accessToken: string, refreshToken: string } } };

export type MagicLinkLogoutMutationVariables = Exact<{ [key: string]: never; }>;


export type MagicLinkLogoutMutation = { __typename: 'Mutation', magicLinkLogout: boolean };

export type RequestMagicLinkMutationVariables = Exact<{
  input: MagicLinkRequestInput;
}>;


export type RequestMagicLinkMutation = { __typename: 'Mutation', requestMagicLink: boolean };

export type AwardsListItemFragment = { __typename: 'Offer', id: string, name: string, deleted: boolean, publicationStatus: Publication_Status_Type, fulfillmentCount: number, marketingContents: Array<{ __typename: 'MarketingContent', id: string, locale: string, title?: string | null, shortDescription?: string | null, longDescription?: string | null, imageUrl?: string | null, terms?: string | null, termsUrl?: string | null, customData?: object | object[] | null, disclaimer?: string | null, disclaimerUrl?: string | null, externalUrl?: string | null, surgeonGeneralsWarning?: string | null, triggeredMessageContent: { __typename: 'OfferTriggeredMessageContent', fulfillmentSms?: string | null, visibilitySms?: string | null, progressSms?: string | null }, receiptContent?: { __typename: 'ReceiptContent', shortDescription?: string | null, longDescription?: string | null } | null }> };

export type AwardsListQueryVariables = Exact<{
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  filter?: InputMaybe<OfferFilter>;
}>;


export type AwardsListQuery = { __typename: 'Query', offers: { __typename: 'OfferConnection', pageInfo: { __typename: 'PageInfo', hasNextPage: boolean, hasPreviousPage: boolean, startCursor?: string | null, endCursor?: string | null }, edges: Array<{ __typename: 'OfferEdge', cursor: string, node: { __typename: 'Offer', id: string, name: string, deleted: boolean, publicationStatus: Publication_Status_Type, fulfillmentCount: number, marketingContents: Array<{ __typename: 'MarketingContent', id: string, locale: string, title?: string | null, shortDescription?: string | null, longDescription?: string | null, imageUrl?: string | null, terms?: string | null, termsUrl?: string | null, customData?: object | object[] | null, disclaimer?: string | null, disclaimerUrl?: string | null, externalUrl?: string | null, surgeonGeneralsWarning?: string | null, triggeredMessageContent: { __typename: 'OfferTriggeredMessageContent', fulfillmentSms?: string | null, visibilitySms?: string | null, progressSms?: string | null }, receiptContent?: { __typename: 'ReceiptContent', shortDescription?: string | null, longDescription?: string | null } | null }> } }> } };

export type CampaignFragment = { __typename: 'Campaign', uuid: string, name: string, description?: string | null, category?: string | null, deleted: boolean, externalId?: string | null, chain: { __typename: 'Chain', id: string, name: string, rollbackStackingConfig: string, rollbackVoucherStackingEnabled: boolean, configuration: { __typename: 'ChainConfiguration', id: string, manualPointChangeCap?: number | null, pointsStrategy: PointsStrategy, referralProgramConfigurationEnabled: boolean, allowMultipleTransactionDiscounts?: boolean | null, offerReturnStrategy: ReturnableOffersConfig, offerReturnDefaultStrategy: boolean, allowedPointAdjustmentReasons: Array<{ __typename: 'PointAdjustmentReason', id: string, label: string, description?: string | null }>, referralProgramConfiguration?: { __typename: 'ReferralProgramConfiguration', referralProgramEnabled: boolean, qualifiedEvent: { __typename: 'QualifiedEventLoyaltyEvent', loyaltyEventOffer: { __typename: 'Offer', id: string, name: string } } | { __typename: 'QualifiedEventTransaction', purchaseThreshold: number, countProductsBy: Constraint_Purchase_Threshold_Counting_Attribute, eligibleProductGroups: Array<{ __typename: 'ProductGroup', id: string, name: string, description?: string | null, key: Product_Group_Key, values: Array<string>, fuelProductGroup?: { __typename: 'FuelProductGroup', id: string, sortingRank: number, userSelectable: boolean, default: boolean } | null }> }, senderConfiguration: { __typename: 'SenderConfiguration', instructions: string, smsTemplate: string, award?: { __typename: 'AwardPoints', points: number } | { __typename: 'AwardVouchers', voucherCount: number, voucherExpirationDays?: number | null, voucheredOffer: { __typename: 'Offer', id: string, name: string, fulfillmentCount: number, engagementType?: Offer_Engagement_Type | null } } | null }, receiverConfiguration: { __typename: 'ReceiverConfiguration', instructions: string, award?: { __typename: 'AwardPoints', points: number } | { __typename: 'AwardVouchers', voucherCount: number, voucherExpirationDays?: number | null, voucheredOffer: { __typename: 'Offer', id: string, name: string, fulfillmentCount: number, engagementType?: Offer_Engagement_Type | null } } | null }, marketingContents: Array<{ __typename: 'ReferralProgramMarketingContent', subBrandUuid?: string | null, senderInstructions: string, receiverInstructions: string, smsTemplate: string }> } | null, pointExpiration: { __typename: 'PointExpiration', strategy: Point_Expiration_Strategy, notificationDays?: number | null } } } };

export type CampaignWithCampaignComponentsFragment = { __typename: 'Campaign', uuid: string, name: string, description?: string | null, category?: string | null, externalId?: string | null, deleted: boolean, offers?: { __typename: 'OfferConnection', edges: Array<{ __typename: 'OfferEdge', node: { __typename: 'Offer', id: string, name: string, description?: string | null, category?: string | null, externalId?: string | null, deleted: boolean } }> } };

export type CampaignWithCampaignComponentFragment = { __typename: 'Offer', id: string, name: string, description?: string | null, category?: string | null, externalId?: string | null, deleted: boolean };

export type CampaignComponentFragment = { __typename: 'Offer', id: string, description?: string | null, name: string, engagementType?: Offer_Engagement_Type | null, publishedStatus: Published_Status_Type, deleted: boolean, fulfillmentCount: number, voucherCount: number, marketingContents: Array<{ __typename: 'MarketingContent', id: string, locale: string, title?: string | null, shortDescription?: string | null, longDescription?: string | null, imageUrl?: string | null, terms?: string | null, termsUrl?: string | null, customData?: object | object[] | null, disclaimer?: string | null, disclaimerUrl?: string | null, externalUrl?: string | null, surgeonGeneralsWarning?: string | null, triggeredMessageContent: { __typename: 'OfferTriggeredMessageContent', fulfillmentSms?: string | null, visibilitySms?: string | null, progressSms?: string | null }, receiptContent?: { __typename: 'ReceiptContent', shortDescription?: string | null, longDescription?: string | null } | null }>, earningMechanism?: { __typename: 'EarningMechanismExternalFulfillment', id: string, externalFulfillmentAward?: { __typename: 'AwardPoints', points: number } | { __typename: 'AwardVouchers', voucherCount: number, voucherExpirationDays?: number | null, voucheredOffer: { __typename: 'Offer', id: string, name: string, fulfillmentCount: number, engagementType?: Offer_Engagement_Type | null } } | null } | { __typename: 'EarningMechanismLoyaltyEvent', id: string, loyaltyEventEventType: string, loyaltyEventAward?: { __typename: 'AwardExternalPoints', maximum?: number | null } | { __typename: 'AwardPoints', points: number } | { __typename: 'AwardVouchers', voucherCount: number, voucherExpirationDays?: number | null, voucheredOffer: { __typename: 'Offer', id: string, name: string, fulfillmentCount: number, engagementType?: Offer_Engagement_Type | null } } | null } | { __typename: 'EarningMechanismMembershipEvent', id: string, membershipEventEventType: Membership_Event_Type, membershipEventAward: { __typename: 'AwardPoints', points: number } | { __typename: 'AwardVouchers', voucherCount: number, voucherExpirationDays?: number | null, voucheredOffer: { __typename: 'Offer', id: string, name: string, fulfillmentCount: number, engagementType?: Offer_Engagement_Type | null } } } | { __typename: 'EarningMechanismPointSpend', id: string, pointCost: number, offerIsReturnable?: boolean | null, allowedForNewMember?: boolean | null, pointSpendAward: { __typename: 'AwardVouchers', voucherCount: number, voucherExpirationDays?: number | null, voucheredOffer: { __typename: 'Offer', id: string, name: string, fulfillmentCount: number, engagementType?: Offer_Engagement_Type | null } } } | { __typename: 'EarningMechanismProductDiscount', id: string, allowCarryOver: boolean, purchaseThresholdInt: number, productDiscountAward: { __typename: 'AwardBuyAndGet', discountThreshold: number, percentDiscount: number } | { __typename: 'AwardMoneyDiscount', awardPer: Award_Per_Counting_Strategy, moneyAmount: number, partialDiscount: boolean } | { __typename: 'AwardPriceOverride', maximumCost: number }, eligibleProductGroups: Array<{ __typename: 'ProductGroup', id: string, name: string }> } | { __typename: 'EarningMechanismProductPurchase', id: string, countProductsBy: Earning_Mechanism_Product_Counting_Attribute, purchaseThreshold: number, productPurchaseAward: { __typename: 'AwardExternal', provider: ExternalAwardProvider } | { __typename: 'AwardPoints', points: number } | { __typename: 'AwardVouchers', voucherCount: number, voucherExpirationDays?: number | null, voucheredOffer: { __typename: 'Offer', id: string, name: string, fulfillmentCount: number, engagementType?: Offer_Engagement_Type | null } }, eligibleProductGroups: Array<{ __typename: 'ProductGroup', id: string, name: string }> } | { __typename: 'EarningMechanismPromocodes', id: string, codesType: PromocodesOfferType, promocodes: Array<{ __typename: 'Promocode', id: string, code: any, status: PromocodeStatus, publicationStatus: PromocodePublicationStatus, description?: string | null, startDate: string, endDate?: string | null, stats?: { __typename: 'PromocodeUsageStats', redemptions: number, totalOfferRedemptions: number } | null, createdBy: { __typename: 'CommandCenterUser', email: string, name?: string | null } }>, promoCodeGroups: { __typename: 'PromoCodeGroupConnection', edges: Array<{ __typename: 'PromoCodeGroupEdge', node: { __typename: 'PromoCodeGroup', id: string, fileName: string, processingStatus: PromoCodeGroupProcessingStatus, codesStats: { __typename: 'PromoCodeGroupStats', createdCount: number, failedCount: number, totalCount: number } } }> }, award?: { __typename: 'AwardPoints', points: number } | { __typename: 'AwardVouchers', voucherCount: number, voucherExpirationDays?: number | null, voucheredOffer: { __typename: 'Offer', id: string, name: string, fulfillmentCount: number, engagementType?: Offer_Engagement_Type | null } } | null } | { __typename: 'EarningMechanismSpinWheelGame', id: string, purchasableOffer?: { __typename: 'Offer', id: string, name: string } | null, awards: Array<{ __typename: 'RandomAwardConfig', awardType: Random_Award_Type, limit: number, sequenceNumber: number, award?: { __typename: 'AwardPoints', points: number } | { __typename: 'AwardVouchers', voucherExpirationDays?: number | null, voucherCount: number, voucheredOffer: { __typename: 'Offer', id: string, name: string } } | null }> } | { __typename: 'EarningMechanismStoredValueDiscount', id: string, maxDiscountPerTransaction?: number | null, excludedProductGroups: Array<{ __typename: 'ProductGroup', id: string, name: string }> } | { __typename: 'EarningMechanismTotalEligiblePurchase', id: string, countProductsBy: Earning_Mechanism_Product_Counting_Attribute, roundCountedProducts: Earning_Mechanism_Product_Counting_Rounding_Strategy, totalEligiblePurchaseAward: { __typename: 'AwardPointsPer', points: number, rounding: Award_Points_Rounding_Strategy }, eligibleProductGroups: Array<{ __typename: 'ProductGroup', id: string, name: string }> } | { __typename: 'EarningMechanismTotalEligiblePurchaseOverTime', id: string, countProductsBy: Earning_Mechanism_Product_Counting_Attribute, accumulationThreshold: number, stayVisibleWhileInProgress?: boolean | null, hiddenUntilProgress: boolean, totalEligiblePurchaseOverTimeAward: { __typename: 'AwardPoints', points: number } | { __typename: 'AwardVouchers', voucherCount: number, voucherExpirationDays?: number | null, voucheredOffer: { __typename: 'Offer', id: string, name: string, fulfillmentCount: number, engagementType?: Offer_Engagement_Type | null } }, eligibleProductGroups: Array<{ __typename: 'ProductGroup', id: string, name: string }>, purchaseMemberProgress?: { __typename: 'PurchaseProgress', quantityPurchased: number, quantityRequired: number } | null } | { __typename: 'EarningMechanismTotalSpendOnTransaction', id: string, roundMoneyAmount: Earning_Mechanism_Product_Counting_Rounding_Strategy, totalSpendOnTransactionAward: { __typename: 'AwardPointsPer', points: number, rounding: Award_Points_Rounding_Strategy }, ineligibleProductGroups: Array<{ __typename: 'ProductGroup', id: string, name: string }> } | { __typename: 'EarningMechanismTotalSpendOverTime', id: string, accumulationThreshold: number, stayVisibleWhileInProgress?: boolean | null, totalSpendOverTimeAward: { __typename: 'AwardPoints', points: number } | { __typename: 'AwardVouchers', voucherCount: number, voucherExpirationDays?: number | null, voucheredOffer: { __typename: 'Offer', id: string, name: string, fulfillmentCount: number, engagementType?: Offer_Engagement_Type | null } }, ineligibleProductGroups: Array<{ __typename: 'ProductGroup', id: string, name: string }>, purchaseMemberProgress?: { __typename: 'PurchaseProgress', quantityPurchased: number, quantityRequired: number } | null } | { __typename: 'EarningMechanismTransactionDiscount', id: string, purchaseAmountThreshold: number, allowMultipleFulfillmentsPerProductGroupThreshold: boolean, transactionDiscountAward: { __typename: 'AwardTransactionMoneyDiscount', moneyDiscount: number } | { __typename: 'AwardTransactionPercentDiscount', percentDiscount: number }, ineligibleProductGroups: Array<{ __typename: 'ProductGroup', id: string, name: string }> } | { __typename: 'EarningMechanismVarietyDiscount', id: string, varietyDiscountAward: { __typename: 'AwardPriceOverride', maximumCost: number } | { __typename: 'AwardProductDiscount', percentDiscount: number, purchaseThreshold: number, eligibleProductGroups: Array<{ __typename: 'ProductGroup', id: string, name: string }> } | { __typename: 'AwardTransactionMoneyDiscount', moneyDiscount: number }, purchases: Array<{ __typename: 'EarningVarietyDiscountCriteria', purchaseThreshold: number, eligibleProductGroups: Array<{ __typename: 'ProductGroup', id: string, name: string }> }> } | { __typename: 'EarningMechanismVarietyPurchase', id: string, varietyPurchaseAward: { __typename: 'AwardPoints', points: number } | { __typename: 'AwardVouchers', voucherCount: number, voucherExpirationDays?: number | null, voucheredOffer: { __typename: 'Offer', id: string, name: string, fulfillmentCount: number, engagementType?: Offer_Engagement_Type | null } }, products: Array<{ __typename: 'EarningMechanismProductCriteria', id?: string | null, countProductsBy: Earning_Mechanism_Product_Counting_Attribute, purchaseThreshold: number, eligibleProductGroups: Array<{ __typename: 'ProductGroup', id: string, name: string }> }> } | { __typename: 'EarningMechanismVarietyPurchaseOverTime', id: string, preventDoublePunches?: boolean | null, stayVisibleWhileInProgress?: boolean | null, hiddenUntilProgress: boolean, varietyPurchaseOverTimeAward: { __typename: 'AwardPoints', points: number } | { __typename: 'AwardVouchers', voucherCount: number, voucherExpirationDays?: number | null, voucheredOffer: { __typename: 'Offer', id: string, name: string, fulfillmentCount: number, engagementType?: Offer_Engagement_Type | null } }, products: Array<{ __typename: 'EarningMechanismProductCriteria', id?: string | null, countProductsBy: Earning_Mechanism_Product_Counting_Attribute, purchaseThreshold: number, eligibleProductGroups: Array<{ __typename: 'ProductGroup', id: string, name: string }> }>, varietyMemberProgress: Array<{ __typename: 'VarietyProgress', quantityPurchased: number, quantityRequired: number }> } | { __typename: 'EarningMechanismVisits', id: string, visitThreshold: number, visitsAward: { __typename: 'AwardPoints', points: number } | { __typename: 'AwardVouchers', voucherCount: number, voucherExpirationDays?: number | null, voucheredOffer: { __typename: 'Offer', id: string, name: string, fulfillmentCount: number, engagementType?: Offer_Engagement_Type | null } }, visitsMemberProgress?: { __typename: 'VisitsProgress', visits: number, visitsRequired: number } | null } | null };

export type CampaignCreateMutationVariables = Exact<{
  input: CampaignCreateInput;
}>;


export type CampaignCreateMutation = { __typename: 'Mutation', campaignCreate: { __typename: 'Campaign', uuid: string, name: string, description?: string | null, category?: string | null, deleted: boolean, externalId?: string | null, chain: { __typename: 'Chain', id: string, name: string, rollbackStackingConfig: string, rollbackVoucherStackingEnabled: boolean, configuration: { __typename: 'ChainConfiguration', id: string, manualPointChangeCap?: number | null, pointsStrategy: PointsStrategy, referralProgramConfigurationEnabled: boolean, allowMultipleTransactionDiscounts?: boolean | null, offerReturnStrategy: ReturnableOffersConfig, offerReturnDefaultStrategy: boolean, allowedPointAdjustmentReasons: Array<{ __typename: 'PointAdjustmentReason', id: string, label: string, description?: string | null }>, referralProgramConfiguration?: { __typename: 'ReferralProgramConfiguration', referralProgramEnabled: boolean, qualifiedEvent: { __typename: 'QualifiedEventLoyaltyEvent', loyaltyEventOffer: { __typename: 'Offer', id: string, name: string } } | { __typename: 'QualifiedEventTransaction', purchaseThreshold: number, countProductsBy: Constraint_Purchase_Threshold_Counting_Attribute, eligibleProductGroups: Array<{ __typename: 'ProductGroup', id: string, name: string, description?: string | null, key: Product_Group_Key, values: Array<string>, fuelProductGroup?: { __typename: 'FuelProductGroup', id: string, sortingRank: number, userSelectable: boolean, default: boolean } | null }> }, senderConfiguration: { __typename: 'SenderConfiguration', instructions: string, smsTemplate: string, award?: { __typename: 'AwardPoints', points: number } | { __typename: 'AwardVouchers', voucherCount: number, voucherExpirationDays?: number | null, voucheredOffer: { __typename: 'Offer', id: string, name: string, fulfillmentCount: number, engagementType?: Offer_Engagement_Type | null } } | null }, receiverConfiguration: { __typename: 'ReceiverConfiguration', instructions: string, award?: { __typename: 'AwardPoints', points: number } | { __typename: 'AwardVouchers', voucherCount: number, voucherExpirationDays?: number | null, voucheredOffer: { __typename: 'Offer', id: string, name: string, fulfillmentCount: number, engagementType?: Offer_Engagement_Type | null } } | null }, marketingContents: Array<{ __typename: 'ReferralProgramMarketingContent', subBrandUuid?: string | null, senderInstructions: string, receiverInstructions: string, smsTemplate: string }> } | null, pointExpiration: { __typename: 'PointExpiration', strategy: Point_Expiration_Strategy, notificationDays?: number | null } } } } };

export type CampaignUpdateMutationVariables = Exact<{
  input: CampaignUpdateInput;
}>;


export type CampaignUpdateMutation = { __typename: 'Mutation', campaignUpdate: { __typename: 'Campaign', uuid: string, name: string, description?: string | null, category?: string | null, deleted: boolean, externalId?: string | null, chain: { __typename: 'Chain', id: string, name: string, rollbackStackingConfig: string, rollbackVoucherStackingEnabled: boolean, configuration: { __typename: 'ChainConfiguration', id: string, manualPointChangeCap?: number | null, pointsStrategy: PointsStrategy, referralProgramConfigurationEnabled: boolean, allowMultipleTransactionDiscounts?: boolean | null, offerReturnStrategy: ReturnableOffersConfig, offerReturnDefaultStrategy: boolean, allowedPointAdjustmentReasons: Array<{ __typename: 'PointAdjustmentReason', id: string, label: string, description?: string | null }>, referralProgramConfiguration?: { __typename: 'ReferralProgramConfiguration', referralProgramEnabled: boolean, qualifiedEvent: { __typename: 'QualifiedEventLoyaltyEvent', loyaltyEventOffer: { __typename: 'Offer', id: string, name: string } } | { __typename: 'QualifiedEventTransaction', purchaseThreshold: number, countProductsBy: Constraint_Purchase_Threshold_Counting_Attribute, eligibleProductGroups: Array<{ __typename: 'ProductGroup', id: string, name: string, description?: string | null, key: Product_Group_Key, values: Array<string>, fuelProductGroup?: { __typename: 'FuelProductGroup', id: string, sortingRank: number, userSelectable: boolean, default: boolean } | null }> }, senderConfiguration: { __typename: 'SenderConfiguration', instructions: string, smsTemplate: string, award?: { __typename: 'AwardPoints', points: number } | { __typename: 'AwardVouchers', voucherCount: number, voucherExpirationDays?: number | null, voucheredOffer: { __typename: 'Offer', id: string, name: string, fulfillmentCount: number, engagementType?: Offer_Engagement_Type | null } } | null }, receiverConfiguration: { __typename: 'ReceiverConfiguration', instructions: string, award?: { __typename: 'AwardPoints', points: number } | { __typename: 'AwardVouchers', voucherCount: number, voucherExpirationDays?: number | null, voucheredOffer: { __typename: 'Offer', id: string, name: string, fulfillmentCount: number, engagementType?: Offer_Engagement_Type | null } } | null }, marketingContents: Array<{ __typename: 'ReferralProgramMarketingContent', subBrandUuid?: string | null, senderInstructions: string, receiverInstructions: string, smsTemplate: string }> } | null, pointExpiration: { __typename: 'PointExpiration', strategy: Point_Expiration_Strategy, notificationDays?: number | null } } } } };

export type CampaignDeleteMutationVariables = Exact<{
  uuid: Scalars['ID']['input'];
}>;


export type CampaignDeleteMutation = { __typename: 'Mutation', campaignDelete: boolean };

export type CampaignQueryVariables = Exact<{
  uuid: Scalars['ID']['input'];
}>;


export type CampaignQuery = { __typename: 'Query', campaigns: { __typename: 'CampaignConnection', edges: Array<{ __typename: 'CampaignEdge', cursor: string, node: { __typename: 'Campaign', uuid: string, name: string, description?: string | null, category?: string | null, deleted: boolean, externalId?: string | null, chain: { __typename: 'Chain', id: string, name: string, rollbackStackingConfig: string, rollbackVoucherStackingEnabled: boolean, configuration: { __typename: 'ChainConfiguration', id: string, manualPointChangeCap?: number | null, pointsStrategy: PointsStrategy, referralProgramConfigurationEnabled: boolean, allowMultipleTransactionDiscounts?: boolean | null, offerReturnStrategy: ReturnableOffersConfig, offerReturnDefaultStrategy: boolean, allowedPointAdjustmentReasons: Array<{ __typename: 'PointAdjustmentReason', id: string, label: string, description?: string | null }>, referralProgramConfiguration?: { __typename: 'ReferralProgramConfiguration', referralProgramEnabled: boolean, qualifiedEvent: { __typename: 'QualifiedEventLoyaltyEvent', loyaltyEventOffer: { __typename: 'Offer', id: string, name: string } } | { __typename: 'QualifiedEventTransaction', purchaseThreshold: number, countProductsBy: Constraint_Purchase_Threshold_Counting_Attribute, eligibleProductGroups: Array<{ __typename: 'ProductGroup', id: string, name: string, description?: string | null, key: Product_Group_Key, values: Array<string>, fuelProductGroup?: { __typename: 'FuelProductGroup', id: string, sortingRank: number, userSelectable: boolean, default: boolean } | null }> }, senderConfiguration: { __typename: 'SenderConfiguration', instructions: string, smsTemplate: string, award?: { __typename: 'AwardPoints', points: number } | { __typename: 'AwardVouchers', voucherCount: number, voucherExpirationDays?: number | null, voucheredOffer: { __typename: 'Offer', id: string, name: string, fulfillmentCount: number, engagementType?: Offer_Engagement_Type | null } } | null }, receiverConfiguration: { __typename: 'ReceiverConfiguration', instructions: string, award?: { __typename: 'AwardPoints', points: number } | { __typename: 'AwardVouchers', voucherCount: number, voucherExpirationDays?: number | null, voucheredOffer: { __typename: 'Offer', id: string, name: string, fulfillmentCount: number, engagementType?: Offer_Engagement_Type | null } } | null }, marketingContents: Array<{ __typename: 'ReferralProgramMarketingContent', subBrandUuid?: string | null, senderInstructions: string, receiverInstructions: string, smsTemplate: string }> } | null, pointExpiration: { __typename: 'PointExpiration', strategy: Point_Expiration_Strategy, notificationDays?: number | null } } } } }> } };

export type CampaignsQueryVariables = Exact<{
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  filter?: InputMaybe<CampaignFilter>;
}>;


export type CampaignsQuery = { __typename: 'Query', campaigns: { __typename: 'CampaignConnection', pageInfo: { __typename: 'PageInfo', hasNextPage: boolean, hasPreviousPage: boolean, startCursor?: string | null, endCursor?: string | null }, edges: Array<{ __typename: 'CampaignEdge', cursor: string, node: { __typename: 'Campaign', uuid: string, name: string, description?: string | null, category?: string | null, deleted: boolean, externalId?: string | null, chain: { __typename: 'Chain', id: string, name: string, rollbackStackingConfig: string, rollbackVoucherStackingEnabled: boolean, configuration: { __typename: 'ChainConfiguration', id: string, manualPointChangeCap?: number | null, pointsStrategy: PointsStrategy, referralProgramConfigurationEnabled: boolean, allowMultipleTransactionDiscounts?: boolean | null, offerReturnStrategy: ReturnableOffersConfig, offerReturnDefaultStrategy: boolean, allowedPointAdjustmentReasons: Array<{ __typename: 'PointAdjustmentReason', id: string, label: string, description?: string | null }>, referralProgramConfiguration?: { __typename: 'ReferralProgramConfiguration', referralProgramEnabled: boolean, qualifiedEvent: { __typename: 'QualifiedEventLoyaltyEvent', loyaltyEventOffer: { __typename: 'Offer', id: string, name: string } } | { __typename: 'QualifiedEventTransaction', purchaseThreshold: number, countProductsBy: Constraint_Purchase_Threshold_Counting_Attribute, eligibleProductGroups: Array<{ __typename: 'ProductGroup', id: string, name: string, description?: string | null, key: Product_Group_Key, values: Array<string>, fuelProductGroup?: { __typename: 'FuelProductGroup', id: string, sortingRank: number, userSelectable: boolean, default: boolean } | null }> }, senderConfiguration: { __typename: 'SenderConfiguration', instructions: string, smsTemplate: string, award?: { __typename: 'AwardPoints', points: number } | { __typename: 'AwardVouchers', voucherCount: number, voucherExpirationDays?: number | null, voucheredOffer: { __typename: 'Offer', id: string, name: string, fulfillmentCount: number, engagementType?: Offer_Engagement_Type | null } } | null }, receiverConfiguration: { __typename: 'ReceiverConfiguration', instructions: string, award?: { __typename: 'AwardPoints', points: number } | { __typename: 'AwardVouchers', voucherCount: number, voucherExpirationDays?: number | null, voucheredOffer: { __typename: 'Offer', id: string, name: string, fulfillmentCount: number, engagementType?: Offer_Engagement_Type | null } } | null }, marketingContents: Array<{ __typename: 'ReferralProgramMarketingContent', subBrandUuid?: string | null, senderInstructions: string, receiverInstructions: string, smsTemplate: string }> } | null, pointExpiration: { __typename: 'PointExpiration', strategy: Point_Expiration_Strategy, notificationDays?: number | null } } } } }> } };

export type CampaignsWithCampaignComponentsQueryVariables = Exact<{
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  campaignFilter?: InputMaybe<CampaignFilter>;
  offerFilter?: InputMaybe<OfferFilter>;
  skipOffers: Scalars['Boolean']['input'];
}>;


export type CampaignsWithCampaignComponentsQuery = { __typename: 'Query', campaigns: { __typename: 'CampaignConnection', pageInfo: { __typename: 'PageInfo', hasNextPage: boolean, hasPreviousPage: boolean, startCursor?: string | null, endCursor?: string | null }, edges: Array<{ __typename: 'CampaignEdge', cursor: string, node: { __typename: 'Campaign', uuid: string, name: string, description?: string | null, category?: string | null, externalId?: string | null, deleted: boolean, offers?: { __typename: 'OfferConnection', edges: Array<{ __typename: 'OfferEdge', node: { __typename: 'Offer', id: string, name: string, description?: string | null, category?: string | null, externalId?: string | null, deleted: boolean } }> } } }> } };

export type CampaignComponentsQueryVariables = Exact<{
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  filter?: InputMaybe<OfferFilter>;
}>;


export type CampaignComponentsQuery = { __typename: 'Query', offers: { __typename: 'OfferConnection', pageInfo: { __typename: 'PageInfo', hasNextPage: boolean, hasPreviousPage: boolean, startCursor?: string | null, endCursor?: string | null }, edges: Array<{ __typename: 'OfferEdge', cursor: string, node: { __typename: 'Offer', id: string, description?: string | null, name: string, engagementType?: Offer_Engagement_Type | null, publishedStatus: Published_Status_Type, deleted: boolean, fulfillmentCount: number, voucherCount: number, marketingContents: Array<{ __typename: 'MarketingContent', id: string, locale: string, title?: string | null, shortDescription?: string | null, longDescription?: string | null, imageUrl?: string | null, terms?: string | null, termsUrl?: string | null, customData?: object | object[] | null, disclaimer?: string | null, disclaimerUrl?: string | null, externalUrl?: string | null, surgeonGeneralsWarning?: string | null, triggeredMessageContent: { __typename: 'OfferTriggeredMessageContent', fulfillmentSms?: string | null, visibilitySms?: string | null, progressSms?: string | null }, receiptContent?: { __typename: 'ReceiptContent', shortDescription?: string | null, longDescription?: string | null } | null }>, earningMechanism?: { __typename: 'EarningMechanismExternalFulfillment', id: string, externalFulfillmentAward?: { __typename: 'AwardPoints', points: number } | { __typename: 'AwardVouchers', voucherCount: number, voucherExpirationDays?: number | null, voucheredOffer: { __typename: 'Offer', id: string, name: string, fulfillmentCount: number, engagementType?: Offer_Engagement_Type | null } } | null } | { __typename: 'EarningMechanismLoyaltyEvent', id: string, loyaltyEventEventType: string, loyaltyEventAward?: { __typename: 'AwardExternalPoints', maximum?: number | null } | { __typename: 'AwardPoints', points: number } | { __typename: 'AwardVouchers', voucherCount: number, voucherExpirationDays?: number | null, voucheredOffer: { __typename: 'Offer', id: string, name: string, fulfillmentCount: number, engagementType?: Offer_Engagement_Type | null } } | null } | { __typename: 'EarningMechanismMembershipEvent', id: string, membershipEventEventType: Membership_Event_Type, membershipEventAward: { __typename: 'AwardPoints', points: number } | { __typename: 'AwardVouchers', voucherCount: number, voucherExpirationDays?: number | null, voucheredOffer: { __typename: 'Offer', id: string, name: string, fulfillmentCount: number, engagementType?: Offer_Engagement_Type | null } } } | { __typename: 'EarningMechanismPointSpend', id: string, pointCost: number, offerIsReturnable?: boolean | null, allowedForNewMember?: boolean | null, pointSpendAward: { __typename: 'AwardVouchers', voucherCount: number, voucherExpirationDays?: number | null, voucheredOffer: { __typename: 'Offer', id: string, name: string, fulfillmentCount: number, engagementType?: Offer_Engagement_Type | null } } } | { __typename: 'EarningMechanismProductDiscount', id: string, allowCarryOver: boolean, purchaseThresholdInt: number, productDiscountAward: { __typename: 'AwardBuyAndGet', discountThreshold: number, percentDiscount: number } | { __typename: 'AwardMoneyDiscount', awardPer: Award_Per_Counting_Strategy, moneyAmount: number, partialDiscount: boolean } | { __typename: 'AwardPriceOverride', maximumCost: number }, eligibleProductGroups: Array<{ __typename: 'ProductGroup', id: string, name: string }> } | { __typename: 'EarningMechanismProductPurchase', id: string, countProductsBy: Earning_Mechanism_Product_Counting_Attribute, purchaseThreshold: number, productPurchaseAward: { __typename: 'AwardExternal', provider: ExternalAwardProvider } | { __typename: 'AwardPoints', points: number } | { __typename: 'AwardVouchers', voucherCount: number, voucherExpirationDays?: number | null, voucheredOffer: { __typename: 'Offer', id: string, name: string, fulfillmentCount: number, engagementType?: Offer_Engagement_Type | null } }, eligibleProductGroups: Array<{ __typename: 'ProductGroup', id: string, name: string }> } | { __typename: 'EarningMechanismPromocodes', id: string, codesType: PromocodesOfferType, promocodes: Array<{ __typename: 'Promocode', id: string, code: any, status: PromocodeStatus, publicationStatus: PromocodePublicationStatus, description?: string | null, startDate: string, endDate?: string | null, stats?: { __typename: 'PromocodeUsageStats', redemptions: number, totalOfferRedemptions: number } | null, createdBy: { __typename: 'CommandCenterUser', email: string, name?: string | null } }>, promoCodeGroups: { __typename: 'PromoCodeGroupConnection', edges: Array<{ __typename: 'PromoCodeGroupEdge', node: { __typename: 'PromoCodeGroup', id: string, fileName: string, processingStatus: PromoCodeGroupProcessingStatus, codesStats: { __typename: 'PromoCodeGroupStats', createdCount: number, failedCount: number, totalCount: number } } }> }, award?: { __typename: 'AwardPoints', points: number } | { __typename: 'AwardVouchers', voucherCount: number, voucherExpirationDays?: number | null, voucheredOffer: { __typename: 'Offer', id: string, name: string, fulfillmentCount: number, engagementType?: Offer_Engagement_Type | null } } | null } | { __typename: 'EarningMechanismSpinWheelGame', id: string, purchasableOffer?: { __typename: 'Offer', id: string, name: string } | null, awards: Array<{ __typename: 'RandomAwardConfig', awardType: Random_Award_Type, limit: number, sequenceNumber: number, award?: { __typename: 'AwardPoints', points: number } | { __typename: 'AwardVouchers', voucherExpirationDays?: number | null, voucherCount: number, voucheredOffer: { __typename: 'Offer', id: string, name: string } } | null }> } | { __typename: 'EarningMechanismStoredValueDiscount', id: string, maxDiscountPerTransaction?: number | null, excludedProductGroups: Array<{ __typename: 'ProductGroup', id: string, name: string }> } | { __typename: 'EarningMechanismTotalEligiblePurchase', id: string, countProductsBy: Earning_Mechanism_Product_Counting_Attribute, roundCountedProducts: Earning_Mechanism_Product_Counting_Rounding_Strategy, totalEligiblePurchaseAward: { __typename: 'AwardPointsPer', points: number, rounding: Award_Points_Rounding_Strategy }, eligibleProductGroups: Array<{ __typename: 'ProductGroup', id: string, name: string }> } | { __typename: 'EarningMechanismTotalEligiblePurchaseOverTime', id: string, countProductsBy: Earning_Mechanism_Product_Counting_Attribute, accumulationThreshold: number, stayVisibleWhileInProgress?: boolean | null, hiddenUntilProgress: boolean, totalEligiblePurchaseOverTimeAward: { __typename: 'AwardPoints', points: number } | { __typename: 'AwardVouchers', voucherCount: number, voucherExpirationDays?: number | null, voucheredOffer: { __typename: 'Offer', id: string, name: string, fulfillmentCount: number, engagementType?: Offer_Engagement_Type | null } }, eligibleProductGroups: Array<{ __typename: 'ProductGroup', id: string, name: string }>, purchaseMemberProgress?: { __typename: 'PurchaseProgress', quantityPurchased: number, quantityRequired: number } | null } | { __typename: 'EarningMechanismTotalSpendOnTransaction', id: string, roundMoneyAmount: Earning_Mechanism_Product_Counting_Rounding_Strategy, totalSpendOnTransactionAward: { __typename: 'AwardPointsPer', points: number, rounding: Award_Points_Rounding_Strategy }, ineligibleProductGroups: Array<{ __typename: 'ProductGroup', id: string, name: string }> } | { __typename: 'EarningMechanismTotalSpendOverTime', id: string, accumulationThreshold: number, stayVisibleWhileInProgress?: boolean | null, totalSpendOverTimeAward: { __typename: 'AwardPoints', points: number } | { __typename: 'AwardVouchers', voucherCount: number, voucherExpirationDays?: number | null, voucheredOffer: { __typename: 'Offer', id: string, name: string, fulfillmentCount: number, engagementType?: Offer_Engagement_Type | null } }, ineligibleProductGroups: Array<{ __typename: 'ProductGroup', id: string, name: string }>, purchaseMemberProgress?: { __typename: 'PurchaseProgress', quantityPurchased: number, quantityRequired: number } | null } | { __typename: 'EarningMechanismTransactionDiscount', id: string, purchaseAmountThreshold: number, allowMultipleFulfillmentsPerProductGroupThreshold: boolean, transactionDiscountAward: { __typename: 'AwardTransactionMoneyDiscount', moneyDiscount: number } | { __typename: 'AwardTransactionPercentDiscount', percentDiscount: number }, ineligibleProductGroups: Array<{ __typename: 'ProductGroup', id: string, name: string }> } | { __typename: 'EarningMechanismVarietyDiscount', id: string, varietyDiscountAward: { __typename: 'AwardPriceOverride', maximumCost: number } | { __typename: 'AwardProductDiscount', percentDiscount: number, purchaseThreshold: number, eligibleProductGroups: Array<{ __typename: 'ProductGroup', id: string, name: string }> } | { __typename: 'AwardTransactionMoneyDiscount', moneyDiscount: number }, purchases: Array<{ __typename: 'EarningVarietyDiscountCriteria', purchaseThreshold: number, eligibleProductGroups: Array<{ __typename: 'ProductGroup', id: string, name: string }> }> } | { __typename: 'EarningMechanismVarietyPurchase', id: string, varietyPurchaseAward: { __typename: 'AwardPoints', points: number } | { __typename: 'AwardVouchers', voucherCount: number, voucherExpirationDays?: number | null, voucheredOffer: { __typename: 'Offer', id: string, name: string, fulfillmentCount: number, engagementType?: Offer_Engagement_Type | null } }, products: Array<{ __typename: 'EarningMechanismProductCriteria', id?: string | null, countProductsBy: Earning_Mechanism_Product_Counting_Attribute, purchaseThreshold: number, eligibleProductGroups: Array<{ __typename: 'ProductGroup', id: string, name: string }> }> } | { __typename: 'EarningMechanismVarietyPurchaseOverTime', id: string, preventDoublePunches?: boolean | null, stayVisibleWhileInProgress?: boolean | null, hiddenUntilProgress: boolean, varietyPurchaseOverTimeAward: { __typename: 'AwardPoints', points: number } | { __typename: 'AwardVouchers', voucherCount: number, voucherExpirationDays?: number | null, voucheredOffer: { __typename: 'Offer', id: string, name: string, fulfillmentCount: number, engagementType?: Offer_Engagement_Type | null } }, products: Array<{ __typename: 'EarningMechanismProductCriteria', id?: string | null, countProductsBy: Earning_Mechanism_Product_Counting_Attribute, purchaseThreshold: number, eligibleProductGroups: Array<{ __typename: 'ProductGroup', id: string, name: string }> }>, varietyMemberProgress: Array<{ __typename: 'VarietyProgress', quantityPurchased: number, quantityRequired: number }> } | { __typename: 'EarningMechanismVisits', id: string, visitThreshold: number, visitsAward: { __typename: 'AwardPoints', points: number } | { __typename: 'AwardVouchers', voucherCount: number, voucherExpirationDays?: number | null, voucheredOffer: { __typename: 'Offer', id: string, name: string, fulfillmentCount: number, engagementType?: Offer_Engagement_Type | null } }, visitsMemberProgress?: { __typename: 'VisitsProgress', visits: number, visitsRequired: number } | null } | null } }> } };

export type PointExpirationFragment = { __typename: 'PointExpiration', strategy: Point_Expiration_Strategy, notificationDays?: number | null };

export type ChainConfigurationFragment = { __typename: 'ChainConfiguration', id: string, manualPointChangeCap?: number | null, pointsStrategy: PointsStrategy, referralProgramConfigurationEnabled: boolean, allowMultipleTransactionDiscounts?: boolean | null, offerReturnStrategy: ReturnableOffersConfig, offerReturnDefaultStrategy: boolean, allowedPointAdjustmentReasons: Array<{ __typename: 'PointAdjustmentReason', id: string, label: string, description?: string | null }>, referralProgramConfiguration?: { __typename: 'ReferralProgramConfiguration', referralProgramEnabled: boolean, qualifiedEvent: { __typename: 'QualifiedEventLoyaltyEvent', loyaltyEventOffer: { __typename: 'Offer', id: string, name: string } } | { __typename: 'QualifiedEventTransaction', purchaseThreshold: number, countProductsBy: Constraint_Purchase_Threshold_Counting_Attribute, eligibleProductGroups: Array<{ __typename: 'ProductGroup', id: string, name: string, description?: string | null, key: Product_Group_Key, values: Array<string>, fuelProductGroup?: { __typename: 'FuelProductGroup', id: string, sortingRank: number, userSelectable: boolean, default: boolean } | null }> }, senderConfiguration: { __typename: 'SenderConfiguration', instructions: string, smsTemplate: string, award?: { __typename: 'AwardPoints', points: number } | { __typename: 'AwardVouchers', voucherCount: number, voucherExpirationDays?: number | null, voucheredOffer: { __typename: 'Offer', id: string, name: string, fulfillmentCount: number, engagementType?: Offer_Engagement_Type | null } } | null }, receiverConfiguration: { __typename: 'ReceiverConfiguration', instructions: string, award?: { __typename: 'AwardPoints', points: number } | { __typename: 'AwardVouchers', voucherCount: number, voucherExpirationDays?: number | null, voucheredOffer: { __typename: 'Offer', id: string, name: string, fulfillmentCount: number, engagementType?: Offer_Engagement_Type | null } } | null }, marketingContents: Array<{ __typename: 'ReferralProgramMarketingContent', subBrandUuid?: string | null, senderInstructions: string, receiverInstructions: string, smsTemplate: string }> } | null, pointExpiration: { __typename: 'PointExpiration', strategy: Point_Expiration_Strategy, notificationDays?: number | null } };

export type ChainFragment = { __typename: 'Chain', id: string, name: string, rollbackStackingConfig: string, rollbackVoucherStackingEnabled: boolean, configuration: { __typename: 'ChainConfiguration', id: string, manualPointChangeCap?: number | null, pointsStrategy: PointsStrategy, referralProgramConfigurationEnabled: boolean, allowMultipleTransactionDiscounts?: boolean | null, offerReturnStrategy: ReturnableOffersConfig, offerReturnDefaultStrategy: boolean, allowedPointAdjustmentReasons: Array<{ __typename: 'PointAdjustmentReason', id: string, label: string, description?: string | null }>, referralProgramConfiguration?: { __typename: 'ReferralProgramConfiguration', referralProgramEnabled: boolean, qualifiedEvent: { __typename: 'QualifiedEventLoyaltyEvent', loyaltyEventOffer: { __typename: 'Offer', id: string, name: string } } | { __typename: 'QualifiedEventTransaction', purchaseThreshold: number, countProductsBy: Constraint_Purchase_Threshold_Counting_Attribute, eligibleProductGroups: Array<{ __typename: 'ProductGroup', id: string, name: string, description?: string | null, key: Product_Group_Key, values: Array<string>, fuelProductGroup?: { __typename: 'FuelProductGroup', id: string, sortingRank: number, userSelectable: boolean, default: boolean } | null }> }, senderConfiguration: { __typename: 'SenderConfiguration', instructions: string, smsTemplate: string, award?: { __typename: 'AwardPoints', points: number } | { __typename: 'AwardVouchers', voucherCount: number, voucherExpirationDays?: number | null, voucheredOffer: { __typename: 'Offer', id: string, name: string, fulfillmentCount: number, engagementType?: Offer_Engagement_Type | null } } | null }, receiverConfiguration: { __typename: 'ReceiverConfiguration', instructions: string, award?: { __typename: 'AwardPoints', points: number } | { __typename: 'AwardVouchers', voucherCount: number, voucherExpirationDays?: number | null, voucheredOffer: { __typename: 'Offer', id: string, name: string, fulfillmentCount: number, engagementType?: Offer_Engagement_Type | null } } | null }, marketingContents: Array<{ __typename: 'ReferralProgramMarketingContent', subBrandUuid?: string | null, senderInstructions: string, receiverInstructions: string, smsTemplate: string }> } | null, pointExpiration: { __typename: 'PointExpiration', strategy: Point_Expiration_Strategy, notificationDays?: number | null } } };

export type ChainsQueryVariables = Exact<{
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  filter?: InputMaybe<ChainFilter>;
}>;


export type ChainsQuery = { __typename: 'Query', chains: { __typename: 'ChainConnection', pageInfo: { __typename: 'PageInfo', hasNextPage: boolean, hasPreviousPage: boolean, startCursor?: string | null, endCursor?: string | null }, edges: Array<{ __typename: 'ChainEdge', cursor: string, node: { __typename: 'Chain', id: string, name: string, rollbackStackingConfig: string, rollbackVoucherStackingEnabled: boolean, configuration: { __typename: 'ChainConfiguration', id: string, manualPointChangeCap?: number | null, pointsStrategy: PointsStrategy, referralProgramConfigurationEnabled: boolean, allowMultipleTransactionDiscounts?: boolean | null, offerReturnStrategy: ReturnableOffersConfig, offerReturnDefaultStrategy: boolean, allowedPointAdjustmentReasons: Array<{ __typename: 'PointAdjustmentReason', id: string, label: string, description?: string | null }>, referralProgramConfiguration?: { __typename: 'ReferralProgramConfiguration', referralProgramEnabled: boolean, qualifiedEvent: { __typename: 'QualifiedEventLoyaltyEvent', loyaltyEventOffer: { __typename: 'Offer', id: string, name: string } } | { __typename: 'QualifiedEventTransaction', purchaseThreshold: number, countProductsBy: Constraint_Purchase_Threshold_Counting_Attribute, eligibleProductGroups: Array<{ __typename: 'ProductGroup', id: string, name: string, description?: string | null, key: Product_Group_Key, values: Array<string>, fuelProductGroup?: { __typename: 'FuelProductGroup', id: string, sortingRank: number, userSelectable: boolean, default: boolean } | null }> }, senderConfiguration: { __typename: 'SenderConfiguration', instructions: string, smsTemplate: string, award?: { __typename: 'AwardPoints', points: number } | { __typename: 'AwardVouchers', voucherCount: number, voucherExpirationDays?: number | null, voucheredOffer: { __typename: 'Offer', id: string, name: string, fulfillmentCount: number, engagementType?: Offer_Engagement_Type | null } } | null }, receiverConfiguration: { __typename: 'ReceiverConfiguration', instructions: string, award?: { __typename: 'AwardPoints', points: number } | { __typename: 'AwardVouchers', voucherCount: number, voucherExpirationDays?: number | null, voucheredOffer: { __typename: 'Offer', id: string, name: string, fulfillmentCount: number, engagementType?: Offer_Engagement_Type | null } } | null }, marketingContents: Array<{ __typename: 'ReferralProgramMarketingContent', subBrandUuid?: string | null, senderInstructions: string, receiverInstructions: string, smsTemplate: string }> } | null, pointExpiration: { __typename: 'PointExpiration', strategy: Point_Expiration_Strategy, notificationDays?: number | null } } } }> } };

type Constraint_ConstraintDaysOfWeek_Fragment = { __typename: 'ConstraintDaysOfWeek', id: string, availableWeeklyOnDays: Array<Weekday>, startOfDayTimezone: string };

type Constraint_ConstraintEmailRequired_Fragment = { __typename: 'ConstraintEmailRequired', id: string };

type Constraint_ConstraintInAudience_Fragment = { __typename: 'ConstraintInAudience', id: string, audienceId: string };

type Constraint_ConstraintInStoreOnly_Fragment = { __typename: 'ConstraintInStoreOnly', id: string };

type Constraint_ConstraintLocationInState_Fragment = { __typename: 'ConstraintLocationInState', id: string, states: Array<string> };

type Constraint_ConstraintOrderAheadOnly_Fragment = { __typename: 'ConstraintOrderAheadOnly', id: string };

type Constraint_ConstraintPaymentInstrument_Fragment = { __typename: 'ConstraintPaymentInstrument', id: string, paymentInstruments: Array<Payment_Instrument_Type>, paymentInstrumentEvaluationMethod: Payment_Instrument_Evaluation_Method };

type Constraint_ConstraintPaymentMethod_Fragment = { __typename: 'ConstraintPaymentMethod', id: string, paymentMethods: Array<Activate_Payment_Method>, paymentEvaluationMethod: Payment_Method_Evaluation_Method };

type Constraint_ConstraintPreAuth_Fragment = { __typename: 'ConstraintPreAuth', id: string };

type Constraint_ConstraintPurchasableEligibility_Fragment = { __typename: 'ConstraintPurchasableEligibility', id: string, ownershipCondition: Ownership_Condition, voucheredOffers: Array<{ __typename: 'Offer', id: string, name: string }> };

type Constraint_ConstraintPurchaseThreshold_Fragment = { __typename: 'ConstraintPurchaseThreshold', id: string, eligibleProductGroupIds: Array<string>, countProductsBy: Constraint_Purchase_Threshold_Counting_Attribute, threshold: number };

type Constraint_ConstraintRequiresActivation_Fragment = { __typename: 'ConstraintRequiresActivation', id: string, mustFulfillWithinDays?: number | null, allowMultipleFulfillmentsOnActivation: boolean };

type Constraint_ConstraintRequiresTransactionVoucher_Fragment = { __typename: 'ConstraintRequiresTransactionVoucher', id: string, allowSingleOfferVoucherStacking?: boolean | null, breakageRefund?: boolean | null, breakagePointRounding?: Breakage_Point_Rounding | null };

type Constraint_ConstraintRequiresVoucher_Fragment = { __typename: 'ConstraintRequiresVoucher', id: string };

type Constraint_ConstraintRequiresVoucherAvailableForDiscount_Fragment = { __typename: 'ConstraintRequiresVoucherAvailableForDiscount', id: string };

type Constraint_ConstraintStoreLocation_Fragment = { __typename: 'ConstraintStoreLocation', id: string, evaluationMethod: Store_Location_Evaluation_Method, locations: Array<{ __typename: 'ActivateLocation', id: string, name?: string | null }> };

type Constraint_ConstraintStoreLocationGroup_Fragment = { __typename: 'ConstraintStoreLocationGroup', id: string, locationGroups: Array<{ __typename: 'LocationGroup', uuid: string, name: string }> };

type Constraint_ConstraintSubBrand_Fragment = { __typename: 'ConstraintSubBrand', id: string, subBrandUuids: Array<string> };

type Constraint_ConstraintTimeOfDay_Fragment = { __typename: 'ConstraintTimeOfDay', id: string, availableDailyEndingAtTime: string, availableDailyStartingAtTime: string, timezone: string };

export type ConstraintFragment = Constraint_ConstraintDaysOfWeek_Fragment | Constraint_ConstraintEmailRequired_Fragment | Constraint_ConstraintInAudience_Fragment | Constraint_ConstraintInStoreOnly_Fragment | Constraint_ConstraintLocationInState_Fragment | Constraint_ConstraintOrderAheadOnly_Fragment | Constraint_ConstraintPaymentInstrument_Fragment | Constraint_ConstraintPaymentMethod_Fragment | Constraint_ConstraintPreAuth_Fragment | Constraint_ConstraintPurchasableEligibility_Fragment | Constraint_ConstraintPurchaseThreshold_Fragment | Constraint_ConstraintRequiresActivation_Fragment | Constraint_ConstraintRequiresTransactionVoucher_Fragment | Constraint_ConstraintRequiresVoucher_Fragment | Constraint_ConstraintRequiresVoucherAvailableForDiscount_Fragment | Constraint_ConstraintStoreLocation_Fragment | Constraint_ConstraintStoreLocationGroup_Fragment | Constraint_ConstraintSubBrand_Fragment | Constraint_ConstraintTimeOfDay_Fragment;

export type ConstraintLocationInStateFragment = { __typename: 'ConstraintLocationInState', id: string, states: Array<string> };

export type ConstraintRequiresActivationFragment = { __typename: 'ConstraintRequiresActivation', id: string, mustFulfillWithinDays?: number | null, allowMultipleFulfillmentsOnActivation: boolean };

export type ConstraintInAudienceFragment = { __typename: 'ConstraintInAudience', id: string, audienceId: string };

export type ConstraintDaysOfWeekFragment = { __typename: 'ConstraintDaysOfWeek', id: string, availableWeeklyOnDays: Array<Weekday>, startOfDayTimezone: string };

export type ConstraintRequiresVoucherFragment = { __typename: 'ConstraintRequiresVoucher', id: string };

export type ConstraintRequiresVoucherAvailableForDiscountFragment = { __typename: 'ConstraintRequiresVoucherAvailableForDiscount', id: string };

export type ConstraintRequiresTransactionVoucherFragment = { __typename: 'ConstraintRequiresTransactionVoucher', id: string, allowSingleOfferVoucherStacking?: boolean | null, breakageRefund?: boolean | null, breakagePointRounding?: Breakage_Point_Rounding | null };

export type ConstraintStoreLocationFragment = { __typename: 'ConstraintStoreLocation', id: string, evaluationMethod: Store_Location_Evaluation_Method, locations: Array<{ __typename: 'ActivateLocation', id: string, name?: string | null }> };

export type ConstraintTimeOfDayFragment = { __typename: 'ConstraintTimeOfDay', id: string, availableDailyEndingAtTime: string, availableDailyStartingAtTime: string, timezone: string };

export type ConstraintPurchaseThresholdFragment = { __typename: 'ConstraintPurchaseThreshold', id: string, eligibleProductGroupIds: Array<string>, countProductsBy: Constraint_Purchase_Threshold_Counting_Attribute, threshold: number };

export type ConstraintPaymentMethodFragment = { __typename: 'ConstraintPaymentMethod', id: string, paymentMethods: Array<Activate_Payment_Method>, paymentEvaluationMethod: Payment_Method_Evaluation_Method };

export type ConstraintPreAuthFragment = { __typename: 'ConstraintPreAuth', id: string };

export type ConstraintPurchasableEligibilityFragment = { __typename: 'ConstraintPurchasableEligibility', id: string, ownershipCondition: Ownership_Condition, voucheredOffers: Array<{ __typename: 'Offer', id: string, name: string }> };

export type ConstraintStoreLocationGroupFragment = { __typename: 'ConstraintStoreLocationGroup', id: string, locationGroups: Array<{ __typename: 'LocationGroup', uuid: string, name: string }> };

export type ConstraintPaymentInstrumentFragment = { __typename: 'ConstraintPaymentInstrument', id: string, paymentInstruments: Array<Payment_Instrument_Type>, paymentInstrumentEvaluationMethod: Payment_Instrument_Evaluation_Method };

export type ConstraintSubBrandFragment = { __typename: 'ConstraintSubBrand', id: string, subBrandUuids: Array<string> };

export type ConstraintEmailRequiredFragment = { __typename: 'ConstraintEmailRequired', id: string };

export type ConstraintOrderAheadOnlyFragment = { __typename: 'ConstraintOrderAheadOnly', id: string };

export type ConstraintInStoreOnlyFragment = { __typename: 'ConstraintInStoreOnly', id: string };

export type ConstraintCreateMutationVariables = Exact<{
  input: ConstraintCreateInput;
}>;


export type ConstraintCreateMutation = { __typename: 'Mutation', constraintCreate: { __typename: 'ConstraintDaysOfWeek', id: string, availableWeeklyOnDays: Array<Weekday>, startOfDayTimezone: string } | { __typename: 'ConstraintEmailRequired', id: string } | { __typename: 'ConstraintInAudience', id: string, audienceId: string } | { __typename: 'ConstraintInStoreOnly', id: string } | { __typename: 'ConstraintLocationInState', id: string, states: Array<string> } | { __typename: 'ConstraintOrderAheadOnly', id: string } | { __typename: 'ConstraintPaymentInstrument', id: string, paymentInstruments: Array<Payment_Instrument_Type>, paymentInstrumentEvaluationMethod: Payment_Instrument_Evaluation_Method } | { __typename: 'ConstraintPaymentMethod', id: string, paymentMethods: Array<Activate_Payment_Method>, paymentEvaluationMethod: Payment_Method_Evaluation_Method } | { __typename: 'ConstraintPreAuth', id: string } | { __typename: 'ConstraintPurchasableEligibility', id: string, ownershipCondition: Ownership_Condition, voucheredOffers: Array<{ __typename: 'Offer', id: string, name: string }> } | { __typename: 'ConstraintPurchaseThreshold', id: string, eligibleProductGroupIds: Array<string>, countProductsBy: Constraint_Purchase_Threshold_Counting_Attribute, threshold: number } | { __typename: 'ConstraintRequiresActivation', id: string, mustFulfillWithinDays?: number | null, allowMultipleFulfillmentsOnActivation: boolean } | { __typename: 'ConstraintRequiresTransactionVoucher', id: string, allowSingleOfferVoucherStacking?: boolean | null, breakageRefund?: boolean | null, breakagePointRounding?: Breakage_Point_Rounding | null } | { __typename: 'ConstraintRequiresVoucher', id: string } | { __typename: 'ConstraintRequiresVoucherAvailableForDiscount', id: string } | { __typename: 'ConstraintStoreLocation', id: string, evaluationMethod: Store_Location_Evaluation_Method, locations: Array<{ __typename: 'ActivateLocation', id: string, name?: string | null }> } | { __typename: 'ConstraintStoreLocationGroup', id: string, locationGroups: Array<{ __typename: 'LocationGroup', uuid: string, name: string }> } | { __typename: 'ConstraintSubBrand', id: string, subBrandUuids: Array<string> } | { __typename: 'ConstraintTimeOfDay', id: string, availableDailyEndingAtTime: string, availableDailyStartingAtTime: string, timezone: string } };

export type ConstraintDeleteMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type ConstraintDeleteMutation = { __typename: 'Mutation', constraintDelete: boolean };

export type ConstraintUpdateMutationVariables = Exact<{
  input: ConstraintUpdateInput;
}>;


export type ConstraintUpdateMutation = { __typename: 'Mutation', constraintUpdate: { __typename: 'ConstraintDaysOfWeek', id: string, availableWeeklyOnDays: Array<Weekday>, startOfDayTimezone: string } | { __typename: 'ConstraintEmailRequired', id: string } | { __typename: 'ConstraintInAudience', id: string, audienceId: string } | { __typename: 'ConstraintInStoreOnly', id: string } | { __typename: 'ConstraintLocationInState', id: string, states: Array<string> } | { __typename: 'ConstraintOrderAheadOnly', id: string } | { __typename: 'ConstraintPaymentInstrument', id: string, paymentInstruments: Array<Payment_Instrument_Type>, paymentInstrumentEvaluationMethod: Payment_Instrument_Evaluation_Method } | { __typename: 'ConstraintPaymentMethod', id: string, paymentMethods: Array<Activate_Payment_Method>, paymentEvaluationMethod: Payment_Method_Evaluation_Method } | { __typename: 'ConstraintPreAuth', id: string } | { __typename: 'ConstraintPurchasableEligibility', id: string, ownershipCondition: Ownership_Condition, voucheredOffers: Array<{ __typename: 'Offer', id: string, name: string }> } | { __typename: 'ConstraintPurchaseThreshold', id: string, eligibleProductGroupIds: Array<string>, countProductsBy: Constraint_Purchase_Threshold_Counting_Attribute, threshold: number } | { __typename: 'ConstraintRequiresActivation', id: string, mustFulfillWithinDays?: number | null, allowMultipleFulfillmentsOnActivation: boolean } | { __typename: 'ConstraintRequiresTransactionVoucher', id: string, allowSingleOfferVoucherStacking?: boolean | null, breakageRefund?: boolean | null, breakagePointRounding?: Breakage_Point_Rounding | null } | { __typename: 'ConstraintRequiresVoucher', id: string } | { __typename: 'ConstraintRequiresVoucherAvailableForDiscount', id: string } | { __typename: 'ConstraintStoreLocation', id: string, evaluationMethod: Store_Location_Evaluation_Method, locations: Array<{ __typename: 'ActivateLocation', id: string, name?: string | null }> } | { __typename: 'ConstraintStoreLocationGroup', id: string, locationGroups: Array<{ __typename: 'LocationGroup', uuid: string, name: string }> } | { __typename: 'ConstraintSubBrand', id: string, subBrandUuids: Array<string> } | { __typename: 'ConstraintTimeOfDay', id: string, availableDailyEndingAtTime: string, availableDailyStartingAtTime: string, timezone: string } };

export type CurrentUserAbilitiesQueryVariables = Exact<{ [key: string]: never; }>;


export type CurrentUserAbilitiesQuery = { __typename: 'Query', currentUserAbilities?: Array<{ __typename: 'UserAbility', action: string, fields?: string | null, scope?: string | null, subject: string, conditions?: { __typename: 'UserAbilityConditions', uuidIn?: Array<string | null> | null } | null }> | null };

export type CustomerFragment = { __typename: 'Customer', uuid: string, communicationPreference: { __typename: 'CommunicationPreference', smsOptInAt?: string | null, smsOptOutAt?: string | null, smsOptIn: boolean, emailOptInAt?: string | null, emailOptOutAt?: string | null, emailOptIn: boolean, pushOptInAt?: string | null, pushOptOutAt?: string | null, pushOptIn: boolean, subBrandUuid?: string | null } };

export type CommunicationPreferenceFragment = { __typename: 'CommunicationPreference', smsOptInAt?: string | null, smsOptOutAt?: string | null, smsOptIn: boolean, emailOptInAt?: string | null, emailOptOutAt?: string | null, emailOptIn: boolean, pushOptInAt?: string | null, pushOptOutAt?: string | null, pushOptIn: boolean, subBrandUuid?: string | null };

export type CustomerCommunicationPreferenceUpdateMutationVariables = Exact<{
  input: CommunicationPreferenceUpdateInput;
}>;


export type CustomerCommunicationPreferenceUpdateMutation = { __typename: 'Mutation', updateCommunicationPreference: { __typename: 'CommunicationPreference', smsOptInAt?: string | null, smsOptOutAt?: string | null, smsOptIn: boolean, emailOptInAt?: string | null, emailOptOutAt?: string | null, emailOptIn: boolean, pushOptInAt?: string | null, pushOptOutAt?: string | null, pushOptIn: boolean, subBrandUuid?: string | null } };

export type CustomerQueryVariables = Exact<{
  customerUuid: Scalars['ID']['input'];
}>;


export type CustomerQuery = { __typename: 'Query', customer?: { __typename: 'Customer', uuid: string, communicationPreference: { __typename: 'CommunicationPreference', smsOptInAt?: string | null, smsOptOutAt?: string | null, smsOptIn: boolean, emailOptInAt?: string | null, emailOptOutAt?: string | null, emailOptIn: boolean, pushOptInAt?: string | null, pushOptOutAt?: string | null, pushOptIn: boolean, subBrandUuid?: string | null } } | null };

export type GetCommunicationPreferencesForAllSubBrandsQueryVariables = Exact<{
  customerUuid: Scalars['OCUUID']['input'];
}>;


export type GetCommunicationPreferencesForAllSubBrandsQuery = { __typename: 'Query', getCommunicationPreferencesForAllSubBrands: Array<{ __typename: 'CommunicationPreference', smsOptInAt?: string | null, smsOptOutAt?: string | null, smsOptIn: boolean, emailOptInAt?: string | null, emailOptOutAt?: string | null, emailOptIn: boolean, pushOptInAt?: string | null, pushOptOutAt?: string | null, pushOptIn: boolean, subBrandUuid?: string | null }> };

export type DisplayCategoryFragment = { __typename: 'DisplayCategory', id: string, name: string, rank: number, bannerIds?: Array<string> | null, categoryRestrictions?: Category_Restrictions | null, shouldLazyLoadBanners?: boolean | null };

export type DisplayCategoryCreateMutationVariables = Exact<{
  input: DisplayCategoryCreateInput;
}>;


export type DisplayCategoryCreateMutation = { __typename: 'Mutation', displayCategoryCreate?: { __typename: 'DisplayCategory', id: string, name: string, rank: number, bannerIds?: Array<string> | null, categoryRestrictions?: Category_Restrictions | null, shouldLazyLoadBanners?: boolean | null } | null };

export type DisplayCategoryUpdateMutationVariables = Exact<{
  input: DisplayCategoryUpdateInput;
}>;


export type DisplayCategoryUpdateMutation = { __typename: 'Mutation', displayCategoryUpdate?: { __typename: 'DisplayCategory', id: string, name: string, rank: number, bannerIds?: Array<string> | null, categoryRestrictions?: Category_Restrictions | null, shouldLazyLoadBanners?: boolean | null } | null };

export type DisplayCategoryDeleteMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type DisplayCategoryDeleteMutation = { __typename: 'Mutation', displayCategoryDelete?: boolean | null };

export type DisplayCategoryQueryVariables = Exact<{
  filter?: InputMaybe<DisplayCategoryFilter>;
  skipBanners: Scalars['Boolean']['input'];
}>;


export type DisplayCategoryQuery = { __typename: 'Query', displayCategories?: { __typename: 'DisplayCategoryConnection', edges: Array<{ __typename: 'DisplayCategoryEdge', cursor: string, node: { __typename: 'DisplayCategory', id: string, name: string, rank: number, bannerIds?: Array<string> | null, categoryRestrictions?: Category_Restrictions | null, shouldLazyLoadBanners?: boolean | null } }> } | null, bannerConfigurations?: { __typename: 'BannerConfigurationConnection', edges?: Array<{ __typename: 'BannerConfigurationEdge', cursor: string, node: { __typename: 'BannerConfigurationSummary', uuid: string, title: string } } | null> | null } | null };

export type DisplayCategoriesQueryVariables = Exact<{
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  filter?: InputMaybe<DisplayCategoryFilter>;
}>;


export type DisplayCategoriesQuery = { __typename: 'Query', displayCategories?: { __typename: 'DisplayCategoryConnection', pageInfo: { __typename: 'PageInfo', hasNextPage: boolean, hasPreviousPage: boolean, startCursor?: string | null, endCursor?: string | null }, edges: Array<{ __typename: 'DisplayCategoryEdge', cursor: string, node: { __typename: 'DisplayCategory', id: string, name: string, rank: number, bannerIds?: Array<string> | null, categoryRestrictions?: Category_Restrictions | null, shouldLazyLoadBanners?: boolean | null } }> } | null };

export type EaivAuditFragment = { __typename: 'EaivAuditTrail', uuid: string, actionType: Eaiv_Action_Type, result: Eaiv_Result, reasonMessage?: string | null, createdAt: string };

export type EaivAuditTrailQueryVariables = Exact<{
  customerUuid: Scalars['OCUUID']['input'];
}>;


export type EaivAuditTrailQuery = { __typename: 'Query', eaivAuditTrail: { __typename: 'EaivAuditConnection', edges: Array<{ __typename: 'EaivAuditEdge', node: { __typename: 'EaivAuditTrail', uuid: string, actionType: Eaiv_Action_Type, result: Eaiv_Result, reasonMessage?: string | null, createdAt: string } }> } };

type EarningMechanism_EarningMechanismExternalFulfillment_Fragment = { __typename: 'EarningMechanismExternalFulfillment', id: string, externalFulfillmentAward?: { __typename: 'AwardPoints', points: number } | { __typename: 'AwardVouchers', voucherCount: number, voucherExpirationDays?: number | null, voucheredOffer: { __typename: 'Offer', id: string, name: string, fulfillmentCount: number, engagementType?: Offer_Engagement_Type | null } } | null };

type EarningMechanism_EarningMechanismLoyaltyEvent_Fragment = { __typename: 'EarningMechanismLoyaltyEvent', id: string, loyaltyEventEventType: string, loyaltyEventAward?: { __typename: 'AwardExternalPoints', maximum?: number | null } | { __typename: 'AwardPoints', points: number } | { __typename: 'AwardVouchers', voucherCount: number, voucherExpirationDays?: number | null, voucheredOffer: { __typename: 'Offer', id: string, name: string, fulfillmentCount: number, engagementType?: Offer_Engagement_Type | null } } | null };

type EarningMechanism_EarningMechanismMembershipEvent_Fragment = { __typename: 'EarningMechanismMembershipEvent', id: string, membershipEventEventType: Membership_Event_Type, membershipEventAward: { __typename: 'AwardPoints', points: number } | { __typename: 'AwardVouchers', voucherCount: number, voucherExpirationDays?: number | null, voucheredOffer: { __typename: 'Offer', id: string, name: string, fulfillmentCount: number, engagementType?: Offer_Engagement_Type | null } } };

type EarningMechanism_EarningMechanismPointSpend_Fragment = { __typename: 'EarningMechanismPointSpend', id: string, pointCost: number, offerIsReturnable?: boolean | null, allowedForNewMember?: boolean | null, pointSpendAward: { __typename: 'AwardVouchers', voucherCount: number, voucherExpirationDays?: number | null, voucheredOffer: { __typename: 'Offer', id: string, name: string, fulfillmentCount: number, engagementType?: Offer_Engagement_Type | null } } };

type EarningMechanism_EarningMechanismProductDiscount_Fragment = { __typename: 'EarningMechanismProductDiscount', id: string, allowCarryOver: boolean, purchaseThresholdInt: number, productDiscountAward: { __typename: 'AwardBuyAndGet', discountThreshold: number, percentDiscount: number } | { __typename: 'AwardMoneyDiscount', awardPer: Award_Per_Counting_Strategy, moneyAmount: number, partialDiscount: boolean } | { __typename: 'AwardPriceOverride', maximumCost: number }, eligibleProductGroups: Array<{ __typename: 'ProductGroup', id: string, name: string }> };

type EarningMechanism_EarningMechanismProductPurchase_Fragment = { __typename: 'EarningMechanismProductPurchase', id: string, countProductsBy: Earning_Mechanism_Product_Counting_Attribute, purchaseThreshold: number, productPurchaseAward: { __typename: 'AwardExternal', provider: ExternalAwardProvider } | { __typename: 'AwardPoints', points: number } | { __typename: 'AwardVouchers', voucherCount: number, voucherExpirationDays?: number | null, voucheredOffer: { __typename: 'Offer', id: string, name: string, fulfillmentCount: number, engagementType?: Offer_Engagement_Type | null } }, eligibleProductGroups: Array<{ __typename: 'ProductGroup', id: string, name: string }> };

type EarningMechanism_EarningMechanismPromocodes_Fragment = { __typename: 'EarningMechanismPromocodes', id: string, codesType: PromocodesOfferType, promocodes: Array<{ __typename: 'Promocode', id: string, code: any, status: PromocodeStatus, publicationStatus: PromocodePublicationStatus, description?: string | null, startDate: string, endDate?: string | null, stats?: { __typename: 'PromocodeUsageStats', redemptions: number, totalOfferRedemptions: number } | null, createdBy: { __typename: 'CommandCenterUser', email: string, name?: string | null } }>, promoCodeGroups: { __typename: 'PromoCodeGroupConnection', edges: Array<{ __typename: 'PromoCodeGroupEdge', node: { __typename: 'PromoCodeGroup', id: string, fileName: string, processingStatus: PromoCodeGroupProcessingStatus, codesStats: { __typename: 'PromoCodeGroupStats', createdCount: number, failedCount: number, totalCount: number } } }> }, award?: { __typename: 'AwardPoints', points: number } | { __typename: 'AwardVouchers', voucherCount: number, voucherExpirationDays?: number | null, voucheredOffer: { __typename: 'Offer', id: string, name: string, fulfillmentCount: number, engagementType?: Offer_Engagement_Type | null } } | null };

type EarningMechanism_EarningMechanismSpinWheelGame_Fragment = { __typename: 'EarningMechanismSpinWheelGame', id: string, purchasableOffer?: { __typename: 'Offer', id: string, name: string } | null, awards: Array<{ __typename: 'RandomAwardConfig', awardType: Random_Award_Type, limit: number, sequenceNumber: number, award?: { __typename: 'AwardPoints', points: number } | { __typename: 'AwardVouchers', voucherExpirationDays?: number | null, voucherCount: number, voucheredOffer: { __typename: 'Offer', id: string, name: string } } | null }> };

type EarningMechanism_EarningMechanismStoredValueDiscount_Fragment = { __typename: 'EarningMechanismStoredValueDiscount', id: string, maxDiscountPerTransaction?: number | null, excludedProductGroups: Array<{ __typename: 'ProductGroup', id: string, name: string }> };

type EarningMechanism_EarningMechanismTotalEligiblePurchase_Fragment = { __typename: 'EarningMechanismTotalEligiblePurchase', id: string, countProductsBy: Earning_Mechanism_Product_Counting_Attribute, roundCountedProducts: Earning_Mechanism_Product_Counting_Rounding_Strategy, totalEligiblePurchaseAward: { __typename: 'AwardPointsPer', points: number, rounding: Award_Points_Rounding_Strategy }, eligibleProductGroups: Array<{ __typename: 'ProductGroup', id: string, name: string }> };

type EarningMechanism_EarningMechanismTotalEligiblePurchaseOverTime_Fragment = { __typename: 'EarningMechanismTotalEligiblePurchaseOverTime', id: string, countProductsBy: Earning_Mechanism_Product_Counting_Attribute, accumulationThreshold: number, stayVisibleWhileInProgress?: boolean | null, hiddenUntilProgress: boolean, totalEligiblePurchaseOverTimeAward: { __typename: 'AwardPoints', points: number } | { __typename: 'AwardVouchers', voucherCount: number, voucherExpirationDays?: number | null, voucheredOffer: { __typename: 'Offer', id: string, name: string, fulfillmentCount: number, engagementType?: Offer_Engagement_Type | null } }, eligibleProductGroups: Array<{ __typename: 'ProductGroup', id: string, name: string }>, purchaseMemberProgress?: { __typename: 'PurchaseProgress', quantityPurchased: number, quantityRequired: number } | null };

type EarningMechanism_EarningMechanismTotalSpendOnTransaction_Fragment = { __typename: 'EarningMechanismTotalSpendOnTransaction', id: string, roundMoneyAmount: Earning_Mechanism_Product_Counting_Rounding_Strategy, totalSpendOnTransactionAward: { __typename: 'AwardPointsPer', points: number, rounding: Award_Points_Rounding_Strategy }, ineligibleProductGroups: Array<{ __typename: 'ProductGroup', id: string, name: string }> };

type EarningMechanism_EarningMechanismTotalSpendOverTime_Fragment = { __typename: 'EarningMechanismTotalSpendOverTime', id: string, accumulationThreshold: number, stayVisibleWhileInProgress?: boolean | null, totalSpendOverTimeAward: { __typename: 'AwardPoints', points: number } | { __typename: 'AwardVouchers', voucherCount: number, voucherExpirationDays?: number | null, voucheredOffer: { __typename: 'Offer', id: string, name: string, fulfillmentCount: number, engagementType?: Offer_Engagement_Type | null } }, ineligibleProductGroups: Array<{ __typename: 'ProductGroup', id: string, name: string }>, purchaseMemberProgress?: { __typename: 'PurchaseProgress', quantityPurchased: number, quantityRequired: number } | null };

type EarningMechanism_EarningMechanismTransactionDiscount_Fragment = { __typename: 'EarningMechanismTransactionDiscount', id: string, purchaseAmountThreshold: number, allowMultipleFulfillmentsPerProductGroupThreshold: boolean, transactionDiscountAward: { __typename: 'AwardTransactionMoneyDiscount', moneyDiscount: number } | { __typename: 'AwardTransactionPercentDiscount', percentDiscount: number }, ineligibleProductGroups: Array<{ __typename: 'ProductGroup', id: string, name: string }> };

type EarningMechanism_EarningMechanismVarietyDiscount_Fragment = { __typename: 'EarningMechanismVarietyDiscount', id: string, varietyDiscountAward: { __typename: 'AwardPriceOverride', maximumCost: number } | { __typename: 'AwardProductDiscount', percentDiscount: number, purchaseThreshold: number, eligibleProductGroups: Array<{ __typename: 'ProductGroup', id: string, name: string }> } | { __typename: 'AwardTransactionMoneyDiscount', moneyDiscount: number }, purchases: Array<{ __typename: 'EarningVarietyDiscountCriteria', purchaseThreshold: number, eligibleProductGroups: Array<{ __typename: 'ProductGroup', id: string, name: string }> }> };

type EarningMechanism_EarningMechanismVarietyPurchase_Fragment = { __typename: 'EarningMechanismVarietyPurchase', id: string, varietyPurchaseAward: { __typename: 'AwardPoints', points: number } | { __typename: 'AwardVouchers', voucherCount: number, voucherExpirationDays?: number | null, voucheredOffer: { __typename: 'Offer', id: string, name: string, fulfillmentCount: number, engagementType?: Offer_Engagement_Type | null } }, products: Array<{ __typename: 'EarningMechanismProductCriteria', id?: string | null, countProductsBy: Earning_Mechanism_Product_Counting_Attribute, purchaseThreshold: number, eligibleProductGroups: Array<{ __typename: 'ProductGroup', id: string, name: string }> }> };

type EarningMechanism_EarningMechanismVarietyPurchaseOverTime_Fragment = { __typename: 'EarningMechanismVarietyPurchaseOverTime', id: string, preventDoublePunches?: boolean | null, stayVisibleWhileInProgress?: boolean | null, hiddenUntilProgress: boolean, varietyPurchaseOverTimeAward: { __typename: 'AwardPoints', points: number } | { __typename: 'AwardVouchers', voucherCount: number, voucherExpirationDays?: number | null, voucheredOffer: { __typename: 'Offer', id: string, name: string, fulfillmentCount: number, engagementType?: Offer_Engagement_Type | null } }, products: Array<{ __typename: 'EarningMechanismProductCriteria', id?: string | null, countProductsBy: Earning_Mechanism_Product_Counting_Attribute, purchaseThreshold: number, eligibleProductGroups: Array<{ __typename: 'ProductGroup', id: string, name: string }> }>, varietyMemberProgress: Array<{ __typename: 'VarietyProgress', quantityPurchased: number, quantityRequired: number }> };

type EarningMechanism_EarningMechanismVisits_Fragment = { __typename: 'EarningMechanismVisits', id: string, visitThreshold: number, visitsAward: { __typename: 'AwardPoints', points: number } | { __typename: 'AwardVouchers', voucherCount: number, voucherExpirationDays?: number | null, voucheredOffer: { __typename: 'Offer', id: string, name: string, fulfillmentCount: number, engagementType?: Offer_Engagement_Type | null } }, visitsMemberProgress?: { __typename: 'VisitsProgress', visits: number, visitsRequired: number } | null };

export type EarningMechanismFragment = EarningMechanism_EarningMechanismExternalFulfillment_Fragment | EarningMechanism_EarningMechanismLoyaltyEvent_Fragment | EarningMechanism_EarningMechanismMembershipEvent_Fragment | EarningMechanism_EarningMechanismPointSpend_Fragment | EarningMechanism_EarningMechanismProductDiscount_Fragment | EarningMechanism_EarningMechanismProductPurchase_Fragment | EarningMechanism_EarningMechanismPromocodes_Fragment | EarningMechanism_EarningMechanismSpinWheelGame_Fragment | EarningMechanism_EarningMechanismStoredValueDiscount_Fragment | EarningMechanism_EarningMechanismTotalEligiblePurchase_Fragment | EarningMechanism_EarningMechanismTotalEligiblePurchaseOverTime_Fragment | EarningMechanism_EarningMechanismTotalSpendOnTransaction_Fragment | EarningMechanism_EarningMechanismTotalSpendOverTime_Fragment | EarningMechanism_EarningMechanismTransactionDiscount_Fragment | EarningMechanism_EarningMechanismVarietyDiscount_Fragment | EarningMechanism_EarningMechanismVarietyPurchase_Fragment | EarningMechanism_EarningMechanismVarietyPurchaseOverTime_Fragment | EarningMechanism_EarningMechanismVisits_Fragment;

export type EarningMechanismStoredValueDiscountFragment = { __typename: 'EarningMechanismStoredValueDiscount', id: string, maxDiscountPerTransaction?: number | null, excludedProductGroups: Array<{ __typename: 'ProductGroup', id: string, name: string }> };

export type EarningMechanismTotalEligiblePurchaseFragment = { __typename: 'EarningMechanismTotalEligiblePurchase', id: string, countProductsBy: Earning_Mechanism_Product_Counting_Attribute, roundCountedProducts: Earning_Mechanism_Product_Counting_Rounding_Strategy, totalEligiblePurchaseAward: { __typename: 'AwardPointsPer', points: number, rounding: Award_Points_Rounding_Strategy }, eligibleProductGroups: Array<{ __typename: 'ProductGroup', id: string, name: string }> };

export type EarningMechanismTotalEligiblePurchaseOverTimeFragment = { __typename: 'EarningMechanismTotalEligiblePurchaseOverTime', id: string, countProductsBy: Earning_Mechanism_Product_Counting_Attribute, accumulationThreshold: number, stayVisibleWhileInProgress?: boolean | null, hiddenUntilProgress: boolean, totalEligiblePurchaseOverTimeAward: { __typename: 'AwardPoints', points: number } | { __typename: 'AwardVouchers', voucherCount: number, voucherExpirationDays?: number | null, voucheredOffer: { __typename: 'Offer', id: string, name: string, fulfillmentCount: number, engagementType?: Offer_Engagement_Type | null } }, eligibleProductGroups: Array<{ __typename: 'ProductGroup', id: string, name: string }>, purchaseMemberProgress?: { __typename: 'PurchaseProgress', quantityPurchased: number, quantityRequired: number } | null };

export type EarningMechanismExternalFulfillmentFragment = { __typename: 'EarningMechanismExternalFulfillment', id: string, externalFulfillmentAward?: { __typename: 'AwardPoints', points: number } | { __typename: 'AwardVouchers', voucherCount: number, voucherExpirationDays?: number | null, voucheredOffer: { __typename: 'Offer', id: string, name: string, fulfillmentCount: number, engagementType?: Offer_Engagement_Type | null } } | null };

export type EarningMechanismProductPurchaseFragment = { __typename: 'EarningMechanismProductPurchase', id: string, countProductsBy: Earning_Mechanism_Product_Counting_Attribute, purchaseThreshold: number, productPurchaseAward: { __typename: 'AwardExternal', provider: ExternalAwardProvider } | { __typename: 'AwardPoints', points: number } | { __typename: 'AwardVouchers', voucherCount: number, voucherExpirationDays?: number | null, voucheredOffer: { __typename: 'Offer', id: string, name: string, fulfillmentCount: number, engagementType?: Offer_Engagement_Type | null } }, eligibleProductGroups: Array<{ __typename: 'ProductGroup', id: string, name: string }> };

export type EarningMechanismTotalSpendOverTimeFragment = { __typename: 'EarningMechanismTotalSpendOverTime', id: string, accumulationThreshold: number, stayVisibleWhileInProgress?: boolean | null, totalSpendOverTimeAward: { __typename: 'AwardPoints', points: number } | { __typename: 'AwardVouchers', voucherCount: number, voucherExpirationDays?: number | null, voucheredOffer: { __typename: 'Offer', id: string, name: string, fulfillmentCount: number, engagementType?: Offer_Engagement_Type | null } }, ineligibleProductGroups: Array<{ __typename: 'ProductGroup', id: string, name: string }>, purchaseMemberProgress?: { __typename: 'PurchaseProgress', quantityPurchased: number, quantityRequired: number } | null };

export type EarningMechanismVisitsFragment = { __typename: 'EarningMechanismVisits', id: string, visitThreshold: number, visitsAward: { __typename: 'AwardPoints', points: number } | { __typename: 'AwardVouchers', voucherCount: number, voucherExpirationDays?: number | null, voucheredOffer: { __typename: 'Offer', id: string, name: string, fulfillmentCount: number, engagementType?: Offer_Engagement_Type | null } }, visitsMemberProgress?: { __typename: 'VisitsProgress', visits: number, visitsRequired: number } | null };

export type EarningMechanismLoyaltyEventFragment = { __typename: 'EarningMechanismLoyaltyEvent', id: string, loyaltyEventEventType: string, loyaltyEventAward?: { __typename: 'AwardExternalPoints', maximum?: number | null } | { __typename: 'AwardPoints', points: number } | { __typename: 'AwardVouchers', voucherCount: number, voucherExpirationDays?: number | null, voucheredOffer: { __typename: 'Offer', id: string, name: string, fulfillmentCount: number, engagementType?: Offer_Engagement_Type | null } } | null };

export type EarningMechanismMembershipEventFragment = { __typename: 'EarningMechanismMembershipEvent', id: string, membershipEventEventType: Membership_Event_Type, membershipEventAward: { __typename: 'AwardPoints', points: number } | { __typename: 'AwardVouchers', voucherCount: number, voucherExpirationDays?: number | null, voucheredOffer: { __typename: 'Offer', id: string, name: string, fulfillmentCount: number, engagementType?: Offer_Engagement_Type | null } } };

export type EarningMechanismVarietyPurchaseFragment = { __typename: 'EarningMechanismVarietyPurchase', id: string, varietyPurchaseAward: { __typename: 'AwardPoints', points: number } | { __typename: 'AwardVouchers', voucherCount: number, voucherExpirationDays?: number | null, voucheredOffer: { __typename: 'Offer', id: string, name: string, fulfillmentCount: number, engagementType?: Offer_Engagement_Type | null } }, products: Array<{ __typename: 'EarningMechanismProductCriteria', id?: string | null, countProductsBy: Earning_Mechanism_Product_Counting_Attribute, purchaseThreshold: number, eligibleProductGroups: Array<{ __typename: 'ProductGroup', id: string, name: string }> }> };

export type EarningMechanismVarietyPurchaseOverTimeFragment = { __typename: 'EarningMechanismVarietyPurchaseOverTime', id: string, preventDoublePunches?: boolean | null, stayVisibleWhileInProgress?: boolean | null, hiddenUntilProgress: boolean, varietyPurchaseOverTimeAward: { __typename: 'AwardPoints', points: number } | { __typename: 'AwardVouchers', voucherCount: number, voucherExpirationDays?: number | null, voucheredOffer: { __typename: 'Offer', id: string, name: string, fulfillmentCount: number, engagementType?: Offer_Engagement_Type | null } }, products: Array<{ __typename: 'EarningMechanismProductCriteria', id?: string | null, countProductsBy: Earning_Mechanism_Product_Counting_Attribute, purchaseThreshold: number, eligibleProductGroups: Array<{ __typename: 'ProductGroup', id: string, name: string }> }>, varietyMemberProgress: Array<{ __typename: 'VarietyProgress', quantityPurchased: number, quantityRequired: number }> };

export type EarningMechanismPointSpendFragment = { __typename: 'EarningMechanismPointSpend', id: string, pointCost: number, offerIsReturnable?: boolean | null, allowedForNewMember?: boolean | null, pointSpendAward: { __typename: 'AwardVouchers', voucherCount: number, voucherExpirationDays?: number | null, voucheredOffer: { __typename: 'Offer', id: string, name: string, fulfillmentCount: number, engagementType?: Offer_Engagement_Type | null } } };

export type EarningMechanismTransactionDiscountFragment = { __typename: 'EarningMechanismTransactionDiscount', id: string, purchaseAmountThreshold: number, allowMultipleFulfillmentsPerProductGroupThreshold: boolean, transactionDiscountAward: { __typename: 'AwardTransactionMoneyDiscount', moneyDiscount: number } | { __typename: 'AwardTransactionPercentDiscount', percentDiscount: number }, ineligibleProductGroups: Array<{ __typename: 'ProductGroup', id: string, name: string }> };

export type EarningMechanismProductDiscountFragment = { __typename: 'EarningMechanismProductDiscount', id: string, allowCarryOver: boolean, purchaseThresholdInt: number, productDiscountAward: { __typename: 'AwardBuyAndGet', discountThreshold: number, percentDiscount: number } | { __typename: 'AwardMoneyDiscount', awardPer: Award_Per_Counting_Strategy, moneyAmount: number, partialDiscount: boolean } | { __typename: 'AwardPriceOverride', maximumCost: number }, eligibleProductGroups: Array<{ __typename: 'ProductGroup', id: string, name: string }> };

export type EarningMechanismVarietyDiscountFragment = { __typename: 'EarningMechanismVarietyDiscount', id: string, varietyDiscountAward: { __typename: 'AwardPriceOverride', maximumCost: number } | { __typename: 'AwardProductDiscount', percentDiscount: number, purchaseThreshold: number, eligibleProductGroups: Array<{ __typename: 'ProductGroup', id: string, name: string }> } | { __typename: 'AwardTransactionMoneyDiscount', moneyDiscount: number }, purchases: Array<{ __typename: 'EarningVarietyDiscountCriteria', purchaseThreshold: number, eligibleProductGroups: Array<{ __typename: 'ProductGroup', id: string, name: string }> }> };

export type EarningMechanismTotalSpendOnTransactionFragment = { __typename: 'EarningMechanismTotalSpendOnTransaction', id: string, roundMoneyAmount: Earning_Mechanism_Product_Counting_Rounding_Strategy, totalSpendOnTransactionAward: { __typename: 'AwardPointsPer', points: number, rounding: Award_Points_Rounding_Strategy }, ineligibleProductGroups: Array<{ __typename: 'ProductGroup', id: string, name: string }> };

export type EarningMechanismSpinWheelGameFragment = { __typename: 'EarningMechanismSpinWheelGame', id: string, purchasableOffer?: { __typename: 'Offer', id: string, name: string } | null, awards: Array<{ __typename: 'RandomAwardConfig', awardType: Random_Award_Type, limit: number, sequenceNumber: number, award?: { __typename: 'AwardPoints', points: number } | { __typename: 'AwardVouchers', voucherExpirationDays?: number | null, voucherCount: number, voucheredOffer: { __typename: 'Offer', id: string, name: string } } | null }> };

export type EarningMechanismPromocodesFragment = { __typename: 'EarningMechanismPromocodes', id: string, codesType: PromocodesOfferType, promocodes: Array<{ __typename: 'Promocode', id: string, code: any, status: PromocodeStatus, publicationStatus: PromocodePublicationStatus, description?: string | null, startDate: string, endDate?: string | null, stats?: { __typename: 'PromocodeUsageStats', redemptions: number, totalOfferRedemptions: number } | null, createdBy: { __typename: 'CommandCenterUser', email: string, name?: string | null } }>, promoCodeGroups: { __typename: 'PromoCodeGroupConnection', edges: Array<{ __typename: 'PromoCodeGroupEdge', node: { __typename: 'PromoCodeGroup', id: string, fileName: string, processingStatus: PromoCodeGroupProcessingStatus, codesStats: { __typename: 'PromoCodeGroupStats', createdCount: number, failedCount: number, totalCount: number } } }> }, award?: { __typename: 'AwardPoints', points: number } | { __typename: 'AwardVouchers', voucherCount: number, voucherExpirationDays?: number | null, voucheredOffer: { __typename: 'Offer', id: string, name: string, fulfillmentCount: number, engagementType?: Offer_Engagement_Type | null } } | null };

export type AwardProductDiscountFragment = { __typename: 'AwardProductDiscount', percentDiscount: number, purchaseThreshold: number, eligibleProductGroups: Array<{ __typename: 'ProductGroup', id: string, name: string }> };

export type AwardMoneyDiscountFragment = { __typename: 'AwardMoneyDiscount', awardPer: Award_Per_Counting_Strategy, moneyAmount: number, partialDiscount: boolean };

export type AwardPriceOverrideFragment = { __typename: 'AwardPriceOverride', maximumCost: number };

export type AwardBuyAndGetFragment = { __typename: 'AwardBuyAndGet', discountThreshold: number, percentDiscount: number };

export type AwardTransactionMoneyDiscountFragment = { __typename: 'AwardTransactionMoneyDiscount', moneyDiscount: number };

export type AwardTransactionPercentDiscountFragment = { __typename: 'AwardTransactionPercentDiscount', percentDiscount: number };

export type AwardPointsFragment = { __typename: 'AwardPoints', points: number };

export type AwardVouchersFragment = { __typename: 'AwardVouchers', voucherCount: number, voucherExpirationDays?: number | null, voucheredOffer: { __typename: 'Offer', id: string, name: string, fulfillmentCount: number, engagementType?: Offer_Engagement_Type | null } };

export type AwardPointsPerFragment = { __typename: 'AwardPointsPer', points: number, rounding: Award_Points_Rounding_Strategy };

export type AwardExternalPointsFragment = { __typename: 'AwardExternalPoints', maximum?: number | null };

export type AwardExternalFragment = { __typename: 'AwardExternal', provider: ExternalAwardProvider };

export type EarningMechanismCreateMutationVariables = Exact<{
  input: EarningMechanismCreateInput;
}>;


export type EarningMechanismCreateMutation = { __typename: 'Mutation', earningMechanismCreate: { __typename: 'EarningMechanismExternalFulfillment', id: string, externalFulfillmentAward?: { __typename: 'AwardPoints', points: number } | { __typename: 'AwardVouchers', voucherCount: number, voucherExpirationDays?: number | null, voucheredOffer: { __typename: 'Offer', id: string, name: string, fulfillmentCount: number, engagementType?: Offer_Engagement_Type | null } } | null } | { __typename: 'EarningMechanismLoyaltyEvent', id: string, loyaltyEventEventType: string, loyaltyEventAward?: { __typename: 'AwardExternalPoints', maximum?: number | null } | { __typename: 'AwardPoints', points: number } | { __typename: 'AwardVouchers', voucherCount: number, voucherExpirationDays?: number | null, voucheredOffer: { __typename: 'Offer', id: string, name: string, fulfillmentCount: number, engagementType?: Offer_Engagement_Type | null } } | null } | { __typename: 'EarningMechanismMembershipEvent', id: string, membershipEventEventType: Membership_Event_Type, membershipEventAward: { __typename: 'AwardPoints', points: number } | { __typename: 'AwardVouchers', voucherCount: number, voucherExpirationDays?: number | null, voucheredOffer: { __typename: 'Offer', id: string, name: string, fulfillmentCount: number, engagementType?: Offer_Engagement_Type | null } } } | { __typename: 'EarningMechanismPointSpend', id: string, pointCost: number, offerIsReturnable?: boolean | null, allowedForNewMember?: boolean | null, pointSpendAward: { __typename: 'AwardVouchers', voucherCount: number, voucherExpirationDays?: number | null, voucheredOffer: { __typename: 'Offer', id: string, name: string, fulfillmentCount: number, engagementType?: Offer_Engagement_Type | null } } } | { __typename: 'EarningMechanismProductDiscount', id: string, allowCarryOver: boolean, purchaseThresholdInt: number, productDiscountAward: { __typename: 'AwardBuyAndGet', discountThreshold: number, percentDiscount: number } | { __typename: 'AwardMoneyDiscount', awardPer: Award_Per_Counting_Strategy, moneyAmount: number, partialDiscount: boolean } | { __typename: 'AwardPriceOverride', maximumCost: number }, eligibleProductGroups: Array<{ __typename: 'ProductGroup', id: string, name: string }> } | { __typename: 'EarningMechanismProductPurchase', id: string, countProductsBy: Earning_Mechanism_Product_Counting_Attribute, purchaseThreshold: number, productPurchaseAward: { __typename: 'AwardExternal', provider: ExternalAwardProvider } | { __typename: 'AwardPoints', points: number } | { __typename: 'AwardVouchers', voucherCount: number, voucherExpirationDays?: number | null, voucheredOffer: { __typename: 'Offer', id: string, name: string, fulfillmentCount: number, engagementType?: Offer_Engagement_Type | null } }, eligibleProductGroups: Array<{ __typename: 'ProductGroup', id: string, name: string }> } | { __typename: 'EarningMechanismPromocodes', id: string, codesType: PromocodesOfferType, promocodes: Array<{ __typename: 'Promocode', id: string, code: any, status: PromocodeStatus, publicationStatus: PromocodePublicationStatus, description?: string | null, startDate: string, endDate?: string | null, stats?: { __typename: 'PromocodeUsageStats', redemptions: number, totalOfferRedemptions: number } | null, createdBy: { __typename: 'CommandCenterUser', email: string, name?: string | null } }>, promoCodeGroups: { __typename: 'PromoCodeGroupConnection', edges: Array<{ __typename: 'PromoCodeGroupEdge', node: { __typename: 'PromoCodeGroup', id: string, fileName: string, processingStatus: PromoCodeGroupProcessingStatus, codesStats: { __typename: 'PromoCodeGroupStats', createdCount: number, failedCount: number, totalCount: number } } }> }, award?: { __typename: 'AwardPoints', points: number } | { __typename: 'AwardVouchers', voucherCount: number, voucherExpirationDays?: number | null, voucheredOffer: { __typename: 'Offer', id: string, name: string, fulfillmentCount: number, engagementType?: Offer_Engagement_Type | null } } | null } | { __typename: 'EarningMechanismSpinWheelGame', id: string, purchasableOffer?: { __typename: 'Offer', id: string, name: string } | null, awards: Array<{ __typename: 'RandomAwardConfig', awardType: Random_Award_Type, limit: number, sequenceNumber: number, award?: { __typename: 'AwardPoints', points: number } | { __typename: 'AwardVouchers', voucherExpirationDays?: number | null, voucherCount: number, voucheredOffer: { __typename: 'Offer', id: string, name: string } } | null }> } | { __typename: 'EarningMechanismStoredValueDiscount', id: string, maxDiscountPerTransaction?: number | null, excludedProductGroups: Array<{ __typename: 'ProductGroup', id: string, name: string }> } | { __typename: 'EarningMechanismTotalEligiblePurchase', id: string, countProductsBy: Earning_Mechanism_Product_Counting_Attribute, roundCountedProducts: Earning_Mechanism_Product_Counting_Rounding_Strategy, totalEligiblePurchaseAward: { __typename: 'AwardPointsPer', points: number, rounding: Award_Points_Rounding_Strategy }, eligibleProductGroups: Array<{ __typename: 'ProductGroup', id: string, name: string }> } | { __typename: 'EarningMechanismTotalEligiblePurchaseOverTime', id: string, countProductsBy: Earning_Mechanism_Product_Counting_Attribute, accumulationThreshold: number, stayVisibleWhileInProgress?: boolean | null, hiddenUntilProgress: boolean, totalEligiblePurchaseOverTimeAward: { __typename: 'AwardPoints', points: number } | { __typename: 'AwardVouchers', voucherCount: number, voucherExpirationDays?: number | null, voucheredOffer: { __typename: 'Offer', id: string, name: string, fulfillmentCount: number, engagementType?: Offer_Engagement_Type | null } }, eligibleProductGroups: Array<{ __typename: 'ProductGroup', id: string, name: string }>, purchaseMemberProgress?: { __typename: 'PurchaseProgress', quantityPurchased: number, quantityRequired: number } | null } | { __typename: 'EarningMechanismTotalSpendOnTransaction', id: string, roundMoneyAmount: Earning_Mechanism_Product_Counting_Rounding_Strategy, totalSpendOnTransactionAward: { __typename: 'AwardPointsPer', points: number, rounding: Award_Points_Rounding_Strategy }, ineligibleProductGroups: Array<{ __typename: 'ProductGroup', id: string, name: string }> } | { __typename: 'EarningMechanismTotalSpendOverTime', id: string, accumulationThreshold: number, stayVisibleWhileInProgress?: boolean | null, totalSpendOverTimeAward: { __typename: 'AwardPoints', points: number } | { __typename: 'AwardVouchers', voucherCount: number, voucherExpirationDays?: number | null, voucheredOffer: { __typename: 'Offer', id: string, name: string, fulfillmentCount: number, engagementType?: Offer_Engagement_Type | null } }, ineligibleProductGroups: Array<{ __typename: 'ProductGroup', id: string, name: string }>, purchaseMemberProgress?: { __typename: 'PurchaseProgress', quantityPurchased: number, quantityRequired: number } | null } | { __typename: 'EarningMechanismTransactionDiscount', id: string, purchaseAmountThreshold: number, allowMultipleFulfillmentsPerProductGroupThreshold: boolean, transactionDiscountAward: { __typename: 'AwardTransactionMoneyDiscount', moneyDiscount: number } | { __typename: 'AwardTransactionPercentDiscount', percentDiscount: number }, ineligibleProductGroups: Array<{ __typename: 'ProductGroup', id: string, name: string }> } | { __typename: 'EarningMechanismVarietyDiscount', id: string, varietyDiscountAward: { __typename: 'AwardPriceOverride', maximumCost: number } | { __typename: 'AwardProductDiscount', percentDiscount: number, purchaseThreshold: number, eligibleProductGroups: Array<{ __typename: 'ProductGroup', id: string, name: string }> } | { __typename: 'AwardTransactionMoneyDiscount', moneyDiscount: number }, purchases: Array<{ __typename: 'EarningVarietyDiscountCriteria', purchaseThreshold: number, eligibleProductGroups: Array<{ __typename: 'ProductGroup', id: string, name: string }> }> } | { __typename: 'EarningMechanismVarietyPurchase', id: string, varietyPurchaseAward: { __typename: 'AwardPoints', points: number } | { __typename: 'AwardVouchers', voucherCount: number, voucherExpirationDays?: number | null, voucheredOffer: { __typename: 'Offer', id: string, name: string, fulfillmentCount: number, engagementType?: Offer_Engagement_Type | null } }, products: Array<{ __typename: 'EarningMechanismProductCriteria', id?: string | null, countProductsBy: Earning_Mechanism_Product_Counting_Attribute, purchaseThreshold: number, eligibleProductGroups: Array<{ __typename: 'ProductGroup', id: string, name: string }> }> } | { __typename: 'EarningMechanismVarietyPurchaseOverTime', id: string, preventDoublePunches?: boolean | null, stayVisibleWhileInProgress?: boolean | null, hiddenUntilProgress: boolean, varietyPurchaseOverTimeAward: { __typename: 'AwardPoints', points: number } | { __typename: 'AwardVouchers', voucherCount: number, voucherExpirationDays?: number | null, voucheredOffer: { __typename: 'Offer', id: string, name: string, fulfillmentCount: number, engagementType?: Offer_Engagement_Type | null } }, products: Array<{ __typename: 'EarningMechanismProductCriteria', id?: string | null, countProductsBy: Earning_Mechanism_Product_Counting_Attribute, purchaseThreshold: number, eligibleProductGroups: Array<{ __typename: 'ProductGroup', id: string, name: string }> }>, varietyMemberProgress: Array<{ __typename: 'VarietyProgress', quantityPurchased: number, quantityRequired: number }> } | { __typename: 'EarningMechanismVisits', id: string, visitThreshold: number, visitsAward: { __typename: 'AwardPoints', points: number } | { __typename: 'AwardVouchers', voucherCount: number, voucherExpirationDays?: number | null, voucheredOffer: { __typename: 'Offer', id: string, name: string, fulfillmentCount: number, engagementType?: Offer_Engagement_Type | null } }, visitsMemberProgress?: { __typename: 'VisitsProgress', visits: number, visitsRequired: number } | null } };

export type EarningMechanismUpdateMutationVariables = Exact<{
  input: EarningMechanismUpdateInput;
}>;


export type EarningMechanismUpdateMutation = { __typename: 'Mutation', earningMechanismUpdate: { __typename: 'EarningMechanismExternalFulfillment', id: string, externalFulfillmentAward?: { __typename: 'AwardPoints', points: number } | { __typename: 'AwardVouchers', voucherCount: number, voucherExpirationDays?: number | null, voucheredOffer: { __typename: 'Offer', id: string, name: string, fulfillmentCount: number, engagementType?: Offer_Engagement_Type | null } } | null } | { __typename: 'EarningMechanismLoyaltyEvent', id: string, loyaltyEventEventType: string, loyaltyEventAward?: { __typename: 'AwardExternalPoints', maximum?: number | null } | { __typename: 'AwardPoints', points: number } | { __typename: 'AwardVouchers', voucherCount: number, voucherExpirationDays?: number | null, voucheredOffer: { __typename: 'Offer', id: string, name: string, fulfillmentCount: number, engagementType?: Offer_Engagement_Type | null } } | null } | { __typename: 'EarningMechanismMembershipEvent', id: string, membershipEventEventType: Membership_Event_Type, membershipEventAward: { __typename: 'AwardPoints', points: number } | { __typename: 'AwardVouchers', voucherCount: number, voucherExpirationDays?: number | null, voucheredOffer: { __typename: 'Offer', id: string, name: string, fulfillmentCount: number, engagementType?: Offer_Engagement_Type | null } } } | { __typename: 'EarningMechanismPointSpend', id: string, pointCost: number, offerIsReturnable?: boolean | null, allowedForNewMember?: boolean | null, pointSpendAward: { __typename: 'AwardVouchers', voucherCount: number, voucherExpirationDays?: number | null, voucheredOffer: { __typename: 'Offer', id: string, name: string, fulfillmentCount: number, engagementType?: Offer_Engagement_Type | null } } } | { __typename: 'EarningMechanismProductDiscount', id: string, allowCarryOver: boolean, purchaseThresholdInt: number, productDiscountAward: { __typename: 'AwardBuyAndGet', discountThreshold: number, percentDiscount: number } | { __typename: 'AwardMoneyDiscount', awardPer: Award_Per_Counting_Strategy, moneyAmount: number, partialDiscount: boolean } | { __typename: 'AwardPriceOverride', maximumCost: number }, eligibleProductGroups: Array<{ __typename: 'ProductGroup', id: string, name: string }> } | { __typename: 'EarningMechanismProductPurchase', id: string, countProductsBy: Earning_Mechanism_Product_Counting_Attribute, purchaseThreshold: number, productPurchaseAward: { __typename: 'AwardExternal', provider: ExternalAwardProvider } | { __typename: 'AwardPoints', points: number } | { __typename: 'AwardVouchers', voucherCount: number, voucherExpirationDays?: number | null, voucheredOffer: { __typename: 'Offer', id: string, name: string, fulfillmentCount: number, engagementType?: Offer_Engagement_Type | null } }, eligibleProductGroups: Array<{ __typename: 'ProductGroup', id: string, name: string }> } | { __typename: 'EarningMechanismPromocodes', id: string, codesType: PromocodesOfferType, promocodes: Array<{ __typename: 'Promocode', id: string, code: any, status: PromocodeStatus, publicationStatus: PromocodePublicationStatus, description?: string | null, startDate: string, endDate?: string | null, stats?: { __typename: 'PromocodeUsageStats', redemptions: number, totalOfferRedemptions: number } | null, createdBy: { __typename: 'CommandCenterUser', email: string, name?: string | null } }>, promoCodeGroups: { __typename: 'PromoCodeGroupConnection', edges: Array<{ __typename: 'PromoCodeGroupEdge', node: { __typename: 'PromoCodeGroup', id: string, fileName: string, processingStatus: PromoCodeGroupProcessingStatus, codesStats: { __typename: 'PromoCodeGroupStats', createdCount: number, failedCount: number, totalCount: number } } }> }, award?: { __typename: 'AwardPoints', points: number } | { __typename: 'AwardVouchers', voucherCount: number, voucherExpirationDays?: number | null, voucheredOffer: { __typename: 'Offer', id: string, name: string, fulfillmentCount: number, engagementType?: Offer_Engagement_Type | null } } | null } | { __typename: 'EarningMechanismSpinWheelGame', id: string, purchasableOffer?: { __typename: 'Offer', id: string, name: string } | null, awards: Array<{ __typename: 'RandomAwardConfig', awardType: Random_Award_Type, limit: number, sequenceNumber: number, award?: { __typename: 'AwardPoints', points: number } | { __typename: 'AwardVouchers', voucherExpirationDays?: number | null, voucherCount: number, voucheredOffer: { __typename: 'Offer', id: string, name: string } } | null }> } | { __typename: 'EarningMechanismStoredValueDiscount', id: string, maxDiscountPerTransaction?: number | null, excludedProductGroups: Array<{ __typename: 'ProductGroup', id: string, name: string }> } | { __typename: 'EarningMechanismTotalEligiblePurchase', id: string, countProductsBy: Earning_Mechanism_Product_Counting_Attribute, roundCountedProducts: Earning_Mechanism_Product_Counting_Rounding_Strategy, totalEligiblePurchaseAward: { __typename: 'AwardPointsPer', points: number, rounding: Award_Points_Rounding_Strategy }, eligibleProductGroups: Array<{ __typename: 'ProductGroup', id: string, name: string }> } | { __typename: 'EarningMechanismTotalEligiblePurchaseOverTime', id: string, countProductsBy: Earning_Mechanism_Product_Counting_Attribute, accumulationThreshold: number, stayVisibleWhileInProgress?: boolean | null, hiddenUntilProgress: boolean, totalEligiblePurchaseOverTimeAward: { __typename: 'AwardPoints', points: number } | { __typename: 'AwardVouchers', voucherCount: number, voucherExpirationDays?: number | null, voucheredOffer: { __typename: 'Offer', id: string, name: string, fulfillmentCount: number, engagementType?: Offer_Engagement_Type | null } }, eligibleProductGroups: Array<{ __typename: 'ProductGroup', id: string, name: string }>, purchaseMemberProgress?: { __typename: 'PurchaseProgress', quantityPurchased: number, quantityRequired: number } | null } | { __typename: 'EarningMechanismTotalSpendOnTransaction', id: string, roundMoneyAmount: Earning_Mechanism_Product_Counting_Rounding_Strategy, totalSpendOnTransactionAward: { __typename: 'AwardPointsPer', points: number, rounding: Award_Points_Rounding_Strategy }, ineligibleProductGroups: Array<{ __typename: 'ProductGroup', id: string, name: string }> } | { __typename: 'EarningMechanismTotalSpendOverTime', id: string, accumulationThreshold: number, stayVisibleWhileInProgress?: boolean | null, totalSpendOverTimeAward: { __typename: 'AwardPoints', points: number } | { __typename: 'AwardVouchers', voucherCount: number, voucherExpirationDays?: number | null, voucheredOffer: { __typename: 'Offer', id: string, name: string, fulfillmentCount: number, engagementType?: Offer_Engagement_Type | null } }, ineligibleProductGroups: Array<{ __typename: 'ProductGroup', id: string, name: string }>, purchaseMemberProgress?: { __typename: 'PurchaseProgress', quantityPurchased: number, quantityRequired: number } | null } | { __typename: 'EarningMechanismTransactionDiscount', id: string, purchaseAmountThreshold: number, allowMultipleFulfillmentsPerProductGroupThreshold: boolean, transactionDiscountAward: { __typename: 'AwardTransactionMoneyDiscount', moneyDiscount: number } | { __typename: 'AwardTransactionPercentDiscount', percentDiscount: number }, ineligibleProductGroups: Array<{ __typename: 'ProductGroup', id: string, name: string }> } | { __typename: 'EarningMechanismVarietyDiscount', id: string, varietyDiscountAward: { __typename: 'AwardPriceOverride', maximumCost: number } | { __typename: 'AwardProductDiscount', percentDiscount: number, purchaseThreshold: number, eligibleProductGroups: Array<{ __typename: 'ProductGroup', id: string, name: string }> } | { __typename: 'AwardTransactionMoneyDiscount', moneyDiscount: number }, purchases: Array<{ __typename: 'EarningVarietyDiscountCriteria', purchaseThreshold: number, eligibleProductGroups: Array<{ __typename: 'ProductGroup', id: string, name: string }> }> } | { __typename: 'EarningMechanismVarietyPurchase', id: string, varietyPurchaseAward: { __typename: 'AwardPoints', points: number } | { __typename: 'AwardVouchers', voucherCount: number, voucherExpirationDays?: number | null, voucheredOffer: { __typename: 'Offer', id: string, name: string, fulfillmentCount: number, engagementType?: Offer_Engagement_Type | null } }, products: Array<{ __typename: 'EarningMechanismProductCriteria', id?: string | null, countProductsBy: Earning_Mechanism_Product_Counting_Attribute, purchaseThreshold: number, eligibleProductGroups: Array<{ __typename: 'ProductGroup', id: string, name: string }> }> } | { __typename: 'EarningMechanismVarietyPurchaseOverTime', id: string, preventDoublePunches?: boolean | null, stayVisibleWhileInProgress?: boolean | null, hiddenUntilProgress: boolean, varietyPurchaseOverTimeAward: { __typename: 'AwardPoints', points: number } | { __typename: 'AwardVouchers', voucherCount: number, voucherExpirationDays?: number | null, voucheredOffer: { __typename: 'Offer', id: string, name: string, fulfillmentCount: number, engagementType?: Offer_Engagement_Type | null } }, products: Array<{ __typename: 'EarningMechanismProductCriteria', id?: string | null, countProductsBy: Earning_Mechanism_Product_Counting_Attribute, purchaseThreshold: number, eligibleProductGroups: Array<{ __typename: 'ProductGroup', id: string, name: string }> }>, varietyMemberProgress: Array<{ __typename: 'VarietyProgress', quantityPurchased: number, quantityRequired: number }> } | { __typename: 'EarningMechanismVisits', id: string, visitThreshold: number, visitsAward: { __typename: 'AwardPoints', points: number } | { __typename: 'AwardVouchers', voucherCount: number, voucherExpirationDays?: number | null, voucheredOffer: { __typename: 'Offer', id: string, name: string, fulfillmentCount: number, engagementType?: Offer_Engagement_Type | null } }, visitsMemberProgress?: { __typename: 'VisitsProgress', visits: number, visitsRequired: number } | null } };

export type EarningMechanismDeleteMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type EarningMechanismDeleteMutation = { __typename: 'Mutation', earningMechanismDelete: boolean };

export type ExternalIdentityVerificationAttributeFragment = { __typename: 'ExternalIdentityVerificationAttribute', handle: string, name: string };

export type ExternalIdentityVerificationAttributesQueryVariables = Exact<{ [key: string]: never; }>;


export type ExternalIdentityVerificationAttributesQuery = { __typename: 'Query', externalIdentityVerificationAttributes: Array<{ __typename: 'ExternalIdentityVerificationAttribute', handle: string, name: string }> };

export type BannerConfigurationFragment = { __typename: 'BannerConfigurationSummary', uuid: string, title: string };

export type BannerConfigurationsQueryVariables = Exact<{
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<BannerConfigurationFilter>;
}>;


export type BannerConfigurationsQuery = { __typename: 'Query', bannerConfigurations?: { __typename: 'BannerConfigurationConnection', edges?: Array<{ __typename: 'BannerConfigurationEdge', cursor: string, node: { __typename: 'BannerConfigurationSummary', uuid: string, title: string } } | null> | null } | null };

export type GamesListItemFragment = { __typename: 'Offer', id: string, name: string, description?: string | null, deleted: boolean, publicationStatus: Publication_Status_Type, fulfillmentCount: number, marketingContents: Array<{ __typename: 'MarketingContent', id: string, locale: string, title?: string | null, shortDescription?: string | null, longDescription?: string | null, imageUrl?: string | null, terms?: string | null, termsUrl?: string | null, customData?: object | object[] | null, disclaimer?: string | null, disclaimerUrl?: string | null, externalUrl?: string | null, surgeonGeneralsWarning?: string | null, triggeredMessageContent: { __typename: 'OfferTriggeredMessageContent', fulfillmentSms?: string | null, visibilitySms?: string | null, progressSms?: string | null }, receiptContent?: { __typename: 'ReceiptContent', shortDescription?: string | null, longDescription?: string | null } | null }> };

export type GamesListQueryVariables = Exact<{
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  filter?: InputMaybe<OfferFilter>;
}>;


export type GamesListQuery = { __typename: 'Query', offers: { __typename: 'OfferConnection', pageInfo: { __typename: 'PageInfo', hasNextPage: boolean, hasPreviousPage: boolean, startCursor?: string | null, endCursor?: string | null }, edges: Array<{ __typename: 'OfferEdge', cursor: string, node: { __typename: 'Offer', id: string, name: string, description?: string | null, deleted: boolean, publicationStatus: Publication_Status_Type, fulfillmentCount: number, marketingContents: Array<{ __typename: 'MarketingContent', id: string, locale: string, title?: string | null, shortDescription?: string | null, longDescription?: string | null, imageUrl?: string | null, terms?: string | null, termsUrl?: string | null, customData?: object | object[] | null, disclaimer?: string | null, disclaimerUrl?: string | null, externalUrl?: string | null, surgeonGeneralsWarning?: string | null, triggeredMessageContent: { __typename: 'OfferTriggeredMessageContent', fulfillmentSms?: string | null, visibilitySms?: string | null, progressSms?: string | null }, receiptContent?: { __typename: 'ReceiptContent', shortDescription?: string | null, longDescription?: string | null } | null }> } }> } };

type Limit_LimitGlobalActivation_Fragment = { __typename: 'LimitGlobalActivation', id: string, limit: number };

type Limit_LimitGlobalActivationInTime_Fragment = { __typename: 'LimitGlobalActivationInTime', id: string, limit: number, timePeriod: Limit_Time_Period };

type Limit_LimitGlobalAwardCount_Fragment = { __typename: 'LimitGlobalAwardCount', id: string, limit: number };

type Limit_LimitGlobalAwardCountInTime_Fragment = { __typename: 'LimitGlobalAwardCountInTime', id: string, limit: number, timePeriod: Limit_Time_Period };

type Limit_LimitInTransactionAwardCount_Fragment = { __typename: 'LimitInTransactionAwardCount', id: string, limit: number };

type Limit_LimitInTransactionProgress_Fragment = { __typename: 'LimitInTransactionProgress', id: string, limit: number };

type Limit_LimitMembershipActivation_Fragment = { __typename: 'LimitMembershipActivation', id: string, limit: number };

type Limit_LimitMembershipActivationInTime_Fragment = { __typename: 'LimitMembershipActivationInTime', id: string, limit: number, timePeriod: Limit_Time_Period };

type Limit_LimitMembershipAwardCount_Fragment = { __typename: 'LimitMembershipAwardCount', id: string, limit: number };

type Limit_LimitMembershipAwardCountInTime_Fragment = { __typename: 'LimitMembershipAwardCountInTime', id: string, limit: number, timePeriod: Limit_Time_Period };

type Limit_LimitMembershipProgressInTime_Fragment = { __typename: 'LimitMembershipProgressInTime', id: string, limit: number, timePeriod: Limit_Time_Period };

type Limit_LimitMembershipTransactionCount_Fragment = { __typename: 'LimitMembershipTransactionCount', id: string, limit: number };

type Limit_LimitMembershipTransactionCountInTime_Fragment = { __typename: 'LimitMembershipTransactionCountInTime', id: string, limit: number, timePeriod: Limit_Time_Period };

export type LimitFragment = Limit_LimitGlobalActivation_Fragment | Limit_LimitGlobalActivationInTime_Fragment | Limit_LimitGlobalAwardCount_Fragment | Limit_LimitGlobalAwardCountInTime_Fragment | Limit_LimitInTransactionAwardCount_Fragment | Limit_LimitInTransactionProgress_Fragment | Limit_LimitMembershipActivation_Fragment | Limit_LimitMembershipActivationInTime_Fragment | Limit_LimitMembershipAwardCount_Fragment | Limit_LimitMembershipAwardCountInTime_Fragment | Limit_LimitMembershipProgressInTime_Fragment | Limit_LimitMembershipTransactionCount_Fragment | Limit_LimitMembershipTransactionCountInTime_Fragment;

export type LimitCreateMutationVariables = Exact<{
  input: LimitCreateInput;
}>;


export type LimitCreateMutation = { __typename: 'Mutation', limitCreate: { __typename: 'LimitGlobalActivation', id: string, limit: number } | { __typename: 'LimitGlobalActivationInTime', id: string, limit: number, timePeriod: Limit_Time_Period } | { __typename: 'LimitGlobalAwardCount', id: string, limit: number } | { __typename: 'LimitGlobalAwardCountInTime', id: string, limit: number, timePeriod: Limit_Time_Period } | { __typename: 'LimitInTransactionAwardCount', id: string, limit: number } | { __typename: 'LimitInTransactionProgress', id: string, limit: number } | { __typename: 'LimitMembershipActivation', id: string, limit: number } | { __typename: 'LimitMembershipActivationInTime', id: string, limit: number, timePeriod: Limit_Time_Period } | { __typename: 'LimitMembershipAwardCount', id: string, limit: number } | { __typename: 'LimitMembershipAwardCountInTime', id: string, limit: number, timePeriod: Limit_Time_Period } | { __typename: 'LimitMembershipProgressInTime', id: string, limit: number, timePeriod: Limit_Time_Period } | { __typename: 'LimitMembershipTransactionCount', id: string, limit: number } | { __typename: 'LimitMembershipTransactionCountInTime', id: string, limit: number, timePeriod: Limit_Time_Period } };

export type LimitDeleteMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type LimitDeleteMutation = { __typename: 'Mutation', limitDelete: boolean };

export type LimitUpdateMutationVariables = Exact<{
  input: LimitUpdateInput;
}>;


export type LimitUpdateMutation = { __typename: 'Mutation', limitUpdate: { __typename: 'LimitGlobalActivation', id: string, limit: number } | { __typename: 'LimitGlobalActivationInTime', id: string, limit: number, timePeriod: Limit_Time_Period } | { __typename: 'LimitGlobalAwardCount', id: string, limit: number } | { __typename: 'LimitGlobalAwardCountInTime', id: string, limit: number, timePeriod: Limit_Time_Period } | { __typename: 'LimitInTransactionAwardCount', id: string, limit: number } | { __typename: 'LimitInTransactionProgress', id: string, limit: number } | { __typename: 'LimitMembershipActivation', id: string, limit: number } | { __typename: 'LimitMembershipActivationInTime', id: string, limit: number, timePeriod: Limit_Time_Period } | { __typename: 'LimitMembershipAwardCount', id: string, limit: number } | { __typename: 'LimitMembershipAwardCountInTime', id: string, limit: number, timePeriod: Limit_Time_Period } | { __typename: 'LimitMembershipProgressInTime', id: string, limit: number, timePeriod: Limit_Time_Period } | { __typename: 'LimitMembershipTransactionCount', id: string, limit: number } | { __typename: 'LimitMembershipTransactionCountInTime', id: string, limit: number, timePeriod: Limit_Time_Period } };

export type LocationFragment = { __typename: 'Location', uuid: string, customerName?: string | null, siteSystemConfiguration: Array<{ __typename: 'SiteSystemConfiguration', identifier: string, details?: { __typename: 'SiteSystemDetails', siteName?: string | null } | null }> };

export type LocationSelectItemFragment = { __typename: 'Location', uuid: string, siteSystemConfiguration: Array<{ __typename: 'SiteSystemConfiguration', identifier: string }> };

export type SiteManagementLocationFragment = { __typename: 'Location', uuid: string, timezone: string, name?: string | null, payAtPumpEnabled: boolean, altriaRcn?: string | null, altriaMan?: string | null, rjrAccountNumber?: string | null, brandSpecificLocationId?: string | null, locationGroups?: Array<{ __typename: 'LocationGroup', uuid: string, name: string }> | null, brand?: { __typename: 'Brand', uuid: string, name: string } | null, brandingDetails?: { __typename: 'LocationBrandingDetails', primaryColor?: string | null, secondaryColor?: string | null } | null, address?: { __typename: 'Address', uuid: string, alias?: string | null, city: string, countryCode: string, state: string, street1: string, street2?: string | null, zipCode: string, geoLocation?: { __typename: 'GeoLocation', latitude: number, longitude: number } | null } | null, attributes: Array<{ __typename: 'LocationAttribute', name: string, value: string }>, phoneNumbers: Array<{ __typename: 'ContactPhoneNumber', phoneNumber: string, phoneType: Phone_Type }>, siteSystemConfiguration: Array<{ __typename: 'SiteSystemConfiguration', uuid: string, identifier: string, hardwareVendor: Hardware_Vendor, mobileEnabled: boolean, loyaltyEnabled: boolean, loyaltyHeartbeatsOnlyEnabled?: boolean | null, details?: { __typename: 'SiteSystemDetails', siteAddress?: string | null, siteName?: string | null, latitude?: number | null, longitude?: number | null, welcomeMsg?: string | null, mobileActive?: boolean | null, mobileProtocol?: Site_System_Details_Protocol | null, mobileVersion?: string | null, loyaltyProtocol?: Site_System_Details_Protocol | null, loyaltyVersion?: string | null, partialAuthAllowed?: boolean | null, pumpTimeout?: number | null, lastConnection?: string | null, lastLoyaltyConnection?: string | null, lastMobileConnection?: string | null, isOnline: boolean, isLoyaltyOnline: boolean, isMobileOnline: boolean, hardwareVendor?: Hardware_Vendor | null, fuelConfigDetails: Array<{ __typename: 'SiteSystemFuelPumpProduct', outdoorPosition?: string | null, description?: string | null, posCode: string, posCodeModifier: string, posCodeFormat?: string | null, productCode: string, merchandiseCode?: string | null, priceTier?: Conexxus_Price_Tier | null, unitPrice: number }>, carWashDetails: Array<{ __typename: 'SiteSystemCarWashItem', description?: string | null, posCode: string, posCodeModifier: string, posCodeFormat?: string | null, productCode: string, merchandiseCode?: string | null, unitPrice: number }> } | null }>, rewardPrograms?: Array<{ __typename: 'RewardProgram', programId: string, uuid: string, type: Loyalty_Provider_Type_Enum } | null> | null };

export type SiteSystemConfigurationFragment = { __typename: 'SiteSystemConfiguration', uuid: string, identifier: string, hardwareVendor: Hardware_Vendor, mobileEnabled: boolean, loyaltyEnabled: boolean, loyaltyHeartbeatsOnlyEnabled?: boolean | null, details?: { __typename: 'SiteSystemDetails', siteAddress?: string | null, siteName?: string | null, latitude?: number | null, longitude?: number | null, welcomeMsg?: string | null, mobileActive?: boolean | null, mobileProtocol?: Site_System_Details_Protocol | null, mobileVersion?: string | null, loyaltyProtocol?: Site_System_Details_Protocol | null, loyaltyVersion?: string | null, partialAuthAllowed?: boolean | null, pumpTimeout?: number | null, lastConnection?: string | null, lastLoyaltyConnection?: string | null, lastMobileConnection?: string | null, isOnline: boolean, isLoyaltyOnline: boolean, isMobileOnline: boolean, hardwareVendor?: Hardware_Vendor | null, fuelConfigDetails: Array<{ __typename: 'SiteSystemFuelPumpProduct', outdoorPosition?: string | null, description?: string | null, posCode: string, posCodeModifier: string, posCodeFormat?: string | null, productCode: string, merchandiseCode?: string | null, priceTier?: Conexxus_Price_Tier | null, unitPrice: number }>, carWashDetails: Array<{ __typename: 'SiteSystemCarWashItem', description?: string | null, posCode: string, posCodeModifier: string, posCodeFormat?: string | null, productCode: string, merchandiseCode?: string | null, unitPrice: number }> } | null };

export type SiteSystemDetailsFragment = { __typename: 'SiteSystemDetails', siteAddress?: string | null, siteName?: string | null, latitude?: number | null, longitude?: number | null, welcomeMsg?: string | null, mobileActive?: boolean | null, mobileProtocol?: Site_System_Details_Protocol | null, mobileVersion?: string | null, loyaltyProtocol?: Site_System_Details_Protocol | null, loyaltyVersion?: string | null, partialAuthAllowed?: boolean | null, pumpTimeout?: number | null, lastConnection?: string | null, lastLoyaltyConnection?: string | null, lastMobileConnection?: string | null, isOnline: boolean, isLoyaltyOnline: boolean, isMobileOnline: boolean, hardwareVendor?: Hardware_Vendor | null, fuelConfigDetails: Array<{ __typename: 'SiteSystemFuelPumpProduct', outdoorPosition?: string | null, description?: string | null, posCode: string, posCodeModifier: string, posCodeFormat?: string | null, productCode: string, merchandiseCode?: string | null, priceTier?: Conexxus_Price_Tier | null, unitPrice: number }>, carWashDetails: Array<{ __typename: 'SiteSystemCarWashItem', description?: string | null, posCode: string, posCodeModifier: string, posCodeFormat?: string | null, productCode: string, merchandiseCode?: string | null, unitPrice: number }> };

export type SiteSystemFuelPumpProductFragment = { __typename: 'SiteSystemFuelPumpProduct', outdoorPosition?: string | null, description?: string | null, posCode: string, posCodeModifier: string, posCodeFormat?: string | null, productCode: string, merchandiseCode?: string | null, priceTier?: Conexxus_Price_Tier | null, unitPrice: number };

export type SiteSystemCarWashItemFragment = { __typename: 'SiteSystemCarWashItem', description?: string | null, posCode: string, posCodeModifier: string, posCodeFormat?: string | null, productCode: string, merchandiseCode?: string | null, unitPrice: number };

export type SitesSummaryItemFragment = { __typename: 'SitesSummary', total: number, loyaltyOffline: number, loyaltyOnline: number, mobileOffline: number, mobileOnline: number, issues: number };

export type LocationAddressFragment = { __typename: 'Address', uuid: string, alias?: string | null, city: string, countryCode: string, state: string, street1: string, street2?: string | null, zipCode: string, geoLocation?: { __typename: 'GeoLocation', latitude: number, longitude: number } | null };

export type LocationAttributeFragment = { __typename: 'LocationAttribute', name: string, value: string };

export type LocationDayScheduleFragment = { __typename: 'HoursOfOperation', dayOfWeek: Weekday, openTime: string, closeTime: string, genericHoursString?: string | null };

export type SiteManagementLocationUpdateMutationVariables = Exact<{
  locationUpdateInput: LocationUpdate;
}>;


export type SiteManagementLocationUpdateMutation = { __typename: 'Mutation', locationUpdate?: { __typename: 'Location', uuid: string, timezone: string, name?: string | null, payAtPumpEnabled: boolean, altriaRcn?: string | null, altriaMan?: string | null, rjrAccountNumber?: string | null, brandSpecificLocationId?: string | null, locationGroups?: Array<{ __typename: 'LocationGroup', uuid: string, name: string }> | null, brand?: { __typename: 'Brand', uuid: string, name: string } | null, brandingDetails?: { __typename: 'LocationBrandingDetails', primaryColor?: string | null, secondaryColor?: string | null } | null, address?: { __typename: 'Address', uuid: string, alias?: string | null, city: string, countryCode: string, state: string, street1: string, street2?: string | null, zipCode: string, geoLocation?: { __typename: 'GeoLocation', latitude: number, longitude: number } | null } | null, attributes: Array<{ __typename: 'LocationAttribute', name: string, value: string }>, phoneNumbers: Array<{ __typename: 'ContactPhoneNumber', phoneNumber: string, phoneType: Phone_Type }>, siteSystemConfiguration: Array<{ __typename: 'SiteSystemConfiguration', uuid: string, identifier: string, hardwareVendor: Hardware_Vendor, mobileEnabled: boolean, loyaltyEnabled: boolean, loyaltyHeartbeatsOnlyEnabled?: boolean | null, details?: { __typename: 'SiteSystemDetails', siteAddress?: string | null, siteName?: string | null, latitude?: number | null, longitude?: number | null, welcomeMsg?: string | null, mobileActive?: boolean | null, mobileProtocol?: Site_System_Details_Protocol | null, mobileVersion?: string | null, loyaltyProtocol?: Site_System_Details_Protocol | null, loyaltyVersion?: string | null, partialAuthAllowed?: boolean | null, pumpTimeout?: number | null, lastConnection?: string | null, lastLoyaltyConnection?: string | null, lastMobileConnection?: string | null, isOnline: boolean, isLoyaltyOnline: boolean, isMobileOnline: boolean, hardwareVendor?: Hardware_Vendor | null, fuelConfigDetails: Array<{ __typename: 'SiteSystemFuelPumpProduct', outdoorPosition?: string | null, description?: string | null, posCode: string, posCodeModifier: string, posCodeFormat?: string | null, productCode: string, merchandiseCode?: string | null, priceTier?: Conexxus_Price_Tier | null, unitPrice: number }>, carWashDetails: Array<{ __typename: 'SiteSystemCarWashItem', description?: string | null, posCode: string, posCodeModifier: string, posCodeFormat?: string | null, productCode: string, merchandiseCode?: string | null, unitPrice: number }> } | null }>, rewardPrograms?: Array<{ __typename: 'RewardProgram', programId: string, uuid: string, type: Loyalty_Provider_Type_Enum } | null> | null } | null };

export type LocationBulkOperationHoursUpdateForRetailerNetworkMutationVariables = Exact<{
  retailerNetworkUuid: Scalars['OCUUID']['input'];
  schedule: Array<HoursOfOperationUpdate> | HoursOfOperationUpdate;
}>;


export type LocationBulkOperationHoursUpdateForRetailerNetworkMutation = { __typename: 'Mutation', bulkUpdate: { __typename: 'BulkUpdateLocationResultFailure', reason: Bulk_Update_Location_Result_Failure_Reason_Type } | { __typename: 'BulkUpdateLocationResultSuccess', status: Bulk_Update_Location_Result_Status_Type } };

export type ClearActivityLogMutationVariables = Exact<{
  input: ClearActivityLog;
}>;


export type ClearActivityLogMutation = { __typename: 'Mutation', clearActivityLog: boolean };

export type LocationCreateMutationVariables = Exact<{
  locationCreateInput: LocationCreate;
}>;


export type LocationCreateMutation = { __typename: 'Mutation', locationCreate?: { __typename: 'Location', uuid: string, brandSpecificLocationId?: string | null, brand?: { __typename: 'Brand', uuid: string, name: string } | null, address?: { __typename: 'Address', countryCode: string, state: string, zipCode: string, city: string, street1: string, street2?: string | null, geoLocation?: { __typename: 'GeoLocation', latitude: number, longitude: number } | null } | null, attributes: Array<{ __typename: 'LocationAttribute', name: string, value: string }>, siteSystemConfiguration: Array<{ __typename: 'SiteSystemConfiguration', identifier: string, mobileEnabled: boolean, loyaltyEnabled: boolean, hardwareVendor: Hardware_Vendor, details?: { __typename: 'SiteSystemDetails', siteAddress?: string | null, siteName?: string | null, mobileVersion?: string | null, mobileActive?: boolean | null, partialAuthAllowed?: boolean | null, pumpTimeout?: number | null, lastConnection?: string | null, isOnline: boolean, fuelConfigDetails: Array<{ __typename: 'SiteSystemFuelPumpProduct', outdoorPosition?: string | null, description?: string | null, posCode: string, posCodeModifier: string, posCodeFormat?: string | null, productCode: string, merchandiseCode?: string | null, priceTier?: Conexxus_Price_Tier | null, unitPrice: number }>, carWashDetails: Array<{ __typename: 'SiteSystemCarWashItem', description?: string | null, posCode: string, posCodeModifier: string, posCodeFormat?: string | null, productCode: string, merchandiseCode?: string | null, unitPrice: number }> } | null }> } | null };

export type LocationsQueryVariables = Exact<{
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<LocationFilter>;
}>;


export type LocationsQuery = { __typename: 'Query', locations: { __typename: 'LocationConnection', pageInfo: { __typename: 'PageInfo', hasNextPage: boolean, hasPreviousPage: boolean, startCursor?: string | null, endCursor?: string | null }, edges?: Array<{ __typename: 'LocationEdge', cursor: string, node: { __typename: 'Location', uuid: string, customerName?: string | null, siteSystemConfiguration: Array<{ __typename: 'SiteSystemConfiguration', identifier: string, details?: { __typename: 'SiteSystemDetails', siteName?: string | null } | null }> } }> | null } };

export type GetLocationSelectItemsQueryVariables = Exact<{
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<LocationFilter>;
}>;


export type GetLocationSelectItemsQuery = { __typename: 'Query', locations: { __typename: 'LocationConnection', pageInfo: { __typename: 'PageInfo', hasNextPage: boolean, hasPreviousPage: boolean, startCursor?: string | null, endCursor?: string | null }, edges?: Array<{ __typename: 'LocationEdge', cursor: string, node: { __typename: 'Location', uuid: string, siteSystemConfiguration: Array<{ __typename: 'SiteSystemConfiguration', identifier: string }> } }> | null } };

export type SiteManagementLocationQueryVariables = Exact<{
  filter?: InputMaybe<LocationFilter>;
}>;


export type SiteManagementLocationQuery = { __typename: 'Query', locations: { __typename: 'LocationConnection', edges?: Array<{ __typename: 'LocationEdge', node: { __typename: 'Location', uuid: string, timezone: string, name?: string | null, payAtPumpEnabled: boolean, altriaRcn?: string | null, altriaMan?: string | null, rjrAccountNumber?: string | null, brandSpecificLocationId?: string | null, locationGroups?: Array<{ __typename: 'LocationGroup', uuid: string, name: string }> | null, brand?: { __typename: 'Brand', uuid: string, name: string } | null, brandingDetails?: { __typename: 'LocationBrandingDetails', primaryColor?: string | null, secondaryColor?: string | null } | null, address?: { __typename: 'Address', uuid: string, alias?: string | null, city: string, countryCode: string, state: string, street1: string, street2?: string | null, zipCode: string, geoLocation?: { __typename: 'GeoLocation', latitude: number, longitude: number } | null } | null, attributes: Array<{ __typename: 'LocationAttribute', name: string, value: string }>, phoneNumbers: Array<{ __typename: 'ContactPhoneNumber', phoneNumber: string, phoneType: Phone_Type }>, siteSystemConfiguration: Array<{ __typename: 'SiteSystemConfiguration', uuid: string, identifier: string, hardwareVendor: Hardware_Vendor, mobileEnabled: boolean, loyaltyEnabled: boolean, loyaltyHeartbeatsOnlyEnabled?: boolean | null, details?: { __typename: 'SiteSystemDetails', siteAddress?: string | null, siteName?: string | null, latitude?: number | null, longitude?: number | null, welcomeMsg?: string | null, mobileActive?: boolean | null, mobileProtocol?: Site_System_Details_Protocol | null, mobileVersion?: string | null, loyaltyProtocol?: Site_System_Details_Protocol | null, loyaltyVersion?: string | null, partialAuthAllowed?: boolean | null, pumpTimeout?: number | null, lastConnection?: string | null, lastLoyaltyConnection?: string | null, lastMobileConnection?: string | null, isOnline: boolean, isLoyaltyOnline: boolean, isMobileOnline: boolean, hardwareVendor?: Hardware_Vendor | null, fuelConfigDetails: Array<{ __typename: 'SiteSystemFuelPumpProduct', outdoorPosition?: string | null, description?: string | null, posCode: string, posCodeModifier: string, posCodeFormat?: string | null, productCode: string, merchandiseCode?: string | null, priceTier?: Conexxus_Price_Tier | null, unitPrice: number }>, carWashDetails: Array<{ __typename: 'SiteSystemCarWashItem', description?: string | null, posCode: string, posCodeModifier: string, posCodeFormat?: string | null, productCode: string, merchandiseCode?: string | null, unitPrice: number }> } | null }>, rewardPrograms?: Array<{ __typename: 'RewardProgram', programId: string, uuid: string, type: Loyalty_Provider_Type_Enum } | null> | null } }> | null } };

export type SiteManagementLocationsQueryVariables = Exact<{
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<LocationFilter>;
  sort?: InputMaybe<LocationSort>;
}>;


export type SiteManagementLocationsQuery = { __typename: 'Query', locations: { __typename: 'LocationConnection', pageInfo: { __typename: 'PageInfo', hasNextPage: boolean, hasPreviousPage: boolean, startCursor?: string | null, endCursor?: string | null }, edges?: Array<{ __typename: 'LocationEdge', cursor: string, node: { __typename: 'Location', uuid: string, timezone: string, name?: string | null, payAtPumpEnabled: boolean, altriaRcn?: string | null, altriaMan?: string | null, rjrAccountNumber?: string | null, brandSpecificLocationId?: string | null, locationGroups?: Array<{ __typename: 'LocationGroup', uuid: string, name: string }> | null, brand?: { __typename: 'Brand', uuid: string, name: string } | null, brandingDetails?: { __typename: 'LocationBrandingDetails', primaryColor?: string | null, secondaryColor?: string | null } | null, address?: { __typename: 'Address', uuid: string, alias?: string | null, city: string, countryCode: string, state: string, street1: string, street2?: string | null, zipCode: string, geoLocation?: { __typename: 'GeoLocation', latitude: number, longitude: number } | null } | null, attributes: Array<{ __typename: 'LocationAttribute', name: string, value: string }>, phoneNumbers: Array<{ __typename: 'ContactPhoneNumber', phoneNumber: string, phoneType: Phone_Type }>, siteSystemConfiguration: Array<{ __typename: 'SiteSystemConfiguration', uuid: string, identifier: string, hardwareVendor: Hardware_Vendor, mobileEnabled: boolean, loyaltyEnabled: boolean, loyaltyHeartbeatsOnlyEnabled?: boolean | null, details?: { __typename: 'SiteSystemDetails', siteAddress?: string | null, siteName?: string | null, latitude?: number | null, longitude?: number | null, welcomeMsg?: string | null, mobileActive?: boolean | null, mobileProtocol?: Site_System_Details_Protocol | null, mobileVersion?: string | null, loyaltyProtocol?: Site_System_Details_Protocol | null, loyaltyVersion?: string | null, partialAuthAllowed?: boolean | null, pumpTimeout?: number | null, lastConnection?: string | null, lastLoyaltyConnection?: string | null, lastMobileConnection?: string | null, isOnline: boolean, isLoyaltyOnline: boolean, isMobileOnline: boolean, hardwareVendor?: Hardware_Vendor | null, fuelConfigDetails: Array<{ __typename: 'SiteSystemFuelPumpProduct', outdoorPosition?: string | null, description?: string | null, posCode: string, posCodeModifier: string, posCodeFormat?: string | null, productCode: string, merchandiseCode?: string | null, priceTier?: Conexxus_Price_Tier | null, unitPrice: number }>, carWashDetails: Array<{ __typename: 'SiteSystemCarWashItem', description?: string | null, posCode: string, posCodeModifier: string, posCodeFormat?: string | null, productCode: string, merchandiseCode?: string | null, unitPrice: number }> } | null }>, rewardPrograms?: Array<{ __typename: 'RewardProgram', programId: string, uuid: string, type: Loyalty_Provider_Type_Enum } | null> | null } }> | null } };

export type SitesSummaryQueryVariables = Exact<{ [key: string]: never; }>;


export type SitesSummaryQuery = { __typename: 'Query', sitesSummary?: { __typename: 'SitesSummary', total: number, loyaltyOffline: number, loyaltyOnline: number, mobileOffline: number, mobileOnline: number, issues: number } | null };

export type LocationGroupFragment = { __typename: 'LocationGroup', uuid: string, name: string, countOfLocations: number };

export type LocationGroupCreateMutationVariables = Exact<{
  input: LocationGroupCreateInput;
}>;


export type LocationGroupCreateMutation = { __typename: 'Mutation', locationGroupCreate: { __typename: 'LocationGroup', uuid: string, name: string, countOfLocations: number } };

export type LocationGroupUpdateMutationVariables = Exact<{
  input: LocationGroupUpdateInput;
}>;


export type LocationGroupUpdateMutation = { __typename: 'Mutation', locationGroupUpdate: { __typename: 'LocationGroup', uuid: string, name: string, countOfLocations: number } };

export type LocationGroupDeleteMutationVariables = Exact<{
  uuid: Scalars['ID']['input'];
}>;


export type LocationGroupDeleteMutation = { __typename: 'Mutation', locationGroupDelete?: boolean | null };

export type AddLocationsToGroupMutationVariables = Exact<{
  input: AddLocationsToGroupInput;
}>;


export type AddLocationsToGroupMutation = { __typename: 'Mutation', addLocationsToGroup: { __typename: 'LocationGroup', uuid: string, name: string, countOfLocations: number } };

export type RemoveLocationsFromGroupMutationVariables = Exact<{
  input: RemoveLocationsFromGroupInput;
}>;


export type RemoveLocationsFromGroupMutation = { __typename: 'Mutation', removeLocationsFromGroup: { __typename: 'LocationGroup', uuid: string, name: string, countOfLocations: number } };

export type LocationGroupsQueryVariables = Exact<{
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<LocationGroupFilter>;
}>;


export type LocationGroupsQuery = { __typename: 'Query', locationGroups: { __typename: 'LocationGroupConnection', pageInfo: { __typename: 'PageInfo', hasNextPage: boolean, hasPreviousPage: boolean, startCursor?: string | null, endCursor?: string | null }, edges?: Array<{ __typename: 'LocationGroupEdge', cursor: string, node: { __typename: 'LocationGroup', uuid: string, name: string, countOfLocations: number } }> | null } };

export type LoyaltyEventsListItemFragment = { __typename: 'Offer', id: string, name: string, description?: string | null, deleted: boolean, publicationStatus: Publication_Status_Type, fulfillmentCount: number, visibleForCommandCenterFulfillment?: boolean | null, shortDescription?: string | null, earningMechanism?: { __typename: 'EarningMechanismExternalFulfillment' } | { __typename: 'EarningMechanismLoyaltyEvent', id: string, loyaltyEventEventType: string, loyaltyEventAward?: { __typename: 'AwardExternalPoints', maximum?: number | null } | { __typename: 'AwardPoints', points: number } | { __typename: 'AwardVouchers', voucherCount: number, voucherExpirationDays?: number | null, voucheredOffer: { __typename: 'Offer', id: string, name: string, fulfillmentCount: number, engagementType?: Offer_Engagement_Type | null } } | null } | { __typename: 'EarningMechanismMembershipEvent' } | { __typename: 'EarningMechanismPointSpend' } | { __typename: 'EarningMechanismProductDiscount' } | { __typename: 'EarningMechanismProductPurchase' } | { __typename: 'EarningMechanismPromocodes' } | { __typename: 'EarningMechanismSpinWheelGame' } | { __typename: 'EarningMechanismStoredValueDiscount' } | { __typename: 'EarningMechanismTotalEligiblePurchase' } | { __typename: 'EarningMechanismTotalEligiblePurchaseOverTime' } | { __typename: 'EarningMechanismTotalSpendOnTransaction' } | { __typename: 'EarningMechanismTotalSpendOverTime' } | { __typename: 'EarningMechanismTransactionDiscount' } | { __typename: 'EarningMechanismVarietyDiscount' } | { __typename: 'EarningMechanismVarietyPurchase' } | { __typename: 'EarningMechanismVarietyPurchaseOverTime' } | { __typename: 'EarningMechanismVisits' } | null, marketingContents: Array<{ __typename: 'MarketingContent', id: string, locale: string, title?: string | null, shortDescription?: string | null, longDescription?: string | null, imageUrl?: string | null, terms?: string | null, termsUrl?: string | null, customData?: object | object[] | null, disclaimer?: string | null, disclaimerUrl?: string | null, externalUrl?: string | null, surgeonGeneralsWarning?: string | null, triggeredMessageContent: { __typename: 'OfferTriggeredMessageContent', fulfillmentSms?: string | null, visibilitySms?: string | null, progressSms?: string | null }, receiptContent?: { __typename: 'ReceiptContent', shortDescription?: string | null, longDescription?: string | null } | null }> };

export type LoyaltyEventsListQueryVariables = Exact<{
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  filter?: InputMaybe<OfferFilter>;
}>;


export type LoyaltyEventsListQuery = { __typename: 'Query', offers: { __typename: 'OfferConnection', pageInfo: { __typename: 'PageInfo', hasNextPage: boolean, hasPreviousPage: boolean, startCursor?: string | null, endCursor?: string | null }, edges: Array<{ __typename: 'OfferEdge', cursor: string, node: { __typename: 'Offer', id: string, name: string, description?: string | null, deleted: boolean, publicationStatus: Publication_Status_Type, fulfillmentCount: number, visibleForCommandCenterFulfillment?: boolean | null, shortDescription?: string | null, earningMechanism?: { __typename: 'EarningMechanismExternalFulfillment' } | { __typename: 'EarningMechanismLoyaltyEvent', id: string, loyaltyEventEventType: string, loyaltyEventAward?: { __typename: 'AwardExternalPoints', maximum?: number | null } | { __typename: 'AwardPoints', points: number } | { __typename: 'AwardVouchers', voucherCount: number, voucherExpirationDays?: number | null, voucheredOffer: { __typename: 'Offer', id: string, name: string, fulfillmentCount: number, engagementType?: Offer_Engagement_Type | null } } | null } | { __typename: 'EarningMechanismMembershipEvent' } | { __typename: 'EarningMechanismPointSpend' } | { __typename: 'EarningMechanismProductDiscount' } | { __typename: 'EarningMechanismProductPurchase' } | { __typename: 'EarningMechanismPromocodes' } | { __typename: 'EarningMechanismSpinWheelGame' } | { __typename: 'EarningMechanismStoredValueDiscount' } | { __typename: 'EarningMechanismTotalEligiblePurchase' } | { __typename: 'EarningMechanismTotalEligiblePurchaseOverTime' } | { __typename: 'EarningMechanismTotalSpendOnTransaction' } | { __typename: 'EarningMechanismTotalSpendOverTime' } | { __typename: 'EarningMechanismTransactionDiscount' } | { __typename: 'EarningMechanismVarietyDiscount' } | { __typename: 'EarningMechanismVarietyPurchase' } | { __typename: 'EarningMechanismVarietyPurchaseOverTime' } | { __typename: 'EarningMechanismVisits' } | null, marketingContents: Array<{ __typename: 'MarketingContent', id: string, locale: string, title?: string | null, shortDescription?: string | null, longDescription?: string | null, imageUrl?: string | null, terms?: string | null, termsUrl?: string | null, customData?: object | object[] | null, disclaimer?: string | null, disclaimerUrl?: string | null, externalUrl?: string | null, surgeonGeneralsWarning?: string | null, triggeredMessageContent: { __typename: 'OfferTriggeredMessageContent', fulfillmentSms?: string | null, visibilitySms?: string | null, progressSms?: string | null }, receiptContent?: { __typename: 'ReceiptContent', shortDescription?: string | null, longDescription?: string | null } | null }> } }> } };

export type MarketingContentFragment = { __typename: 'MarketingContent', id: string, locale: string, title?: string | null, shortDescription?: string | null, longDescription?: string | null, imageUrl?: string | null, terms?: string | null, termsUrl?: string | null, customData?: object | object[] | null, disclaimer?: string | null, disclaimerUrl?: string | null, externalUrl?: string | null, surgeonGeneralsWarning?: string | null, triggeredMessageContent: { __typename: 'OfferTriggeredMessageContent', fulfillmentSms?: string | null, visibilitySms?: string | null, progressSms?: string | null }, receiptContent?: { __typename: 'ReceiptContent', shortDescription?: string | null, longDescription?: string | null } | null };

export type MarketingContentCreateMutationVariables = Exact<{
  input: MarketingContentCreateInput;
}>;


export type MarketingContentCreateMutation = { __typename: 'Mutation', marketingContentCreate: { __typename: 'MarketingContent', id: string, locale: string, title?: string | null, shortDescription?: string | null, longDescription?: string | null, imageUrl?: string | null, terms?: string | null, termsUrl?: string | null, customData?: object | object[] | null, disclaimer?: string | null, disclaimerUrl?: string | null, externalUrl?: string | null, surgeonGeneralsWarning?: string | null, triggeredMessageContent: { __typename: 'OfferTriggeredMessageContent', fulfillmentSms?: string | null, visibilitySms?: string | null, progressSms?: string | null }, receiptContent?: { __typename: 'ReceiptContent', shortDescription?: string | null, longDescription?: string | null } | null } };

export type MarketingContentUpdateMutationVariables = Exact<{
  input: MarketingContentUpdateInput;
}>;


export type MarketingContentUpdateMutation = { __typename: 'Mutation', marketingContentUpdate: { __typename: 'MarketingContent', id: string, locale: string, title?: string | null, shortDescription?: string | null, longDescription?: string | null, imageUrl?: string | null, terms?: string | null, termsUrl?: string | null, customData?: object | object[] | null, disclaimer?: string | null, disclaimerUrl?: string | null, externalUrl?: string | null, surgeonGeneralsWarning?: string | null, triggeredMessageContent: { __typename: 'OfferTriggeredMessageContent', fulfillmentSms?: string | null, visibilitySms?: string | null, progressSms?: string | null }, receiptContent?: { __typename: 'ReceiptContent', shortDescription?: string | null, longDescription?: string | null } | null } };

export type MembershipFragment = { __typename: 'Membership', id: string, createdAt: string, birthdate?: string | null, customData?: object | object[] | null, customerUuid?: string | null, email?: string | null, firstName?: string | null, lastName?: string | null, phone?: string | null, points: number, storedValueBalance?: number | null, state: Membership_State, membershipType?: Membership_Type | null, lastSubBrandOffersQueriesUuid?: string | null, storedValueExpirationSchedule: { __typename: 'StoredValueExpirationScheduleConnection', edges: Array<{ __typename: 'StoredValueExpirationScheduleEdge', node: { __typename: 'StoredValueExpirationSchedule', expirationDate: string, storedValue: number } }> }, homeStores?: Array<{ __typename: 'HomeStore', locationUuid: string }> | null, locationProfile?: { __typename: 'LocationProfile', city?: string | null, locationId?: string | null, state?: string | null, zipcode?: string | null } | null, fuelAndConvenienceProfile?: { __typename: 'FuelAndConvenienceProfile', id: string, achStatus?: Ach_Status | null, achEnrollmentStatus?: Ach_Enrollment_Status | null, acquisitionChannel?: string | null, restrictionVerification?: Category_Restrictions | null, restrictionVerificationSource?: Restriction_Verification_Source | null, createdAt: string } | null, stateChanges: Array<{ __typename: 'MembershipState', effectiveAt?: string | null, state: Membership_State, source?: { __typename: 'ActivateTransaction', id: string } | { __typename: 'CommandCenterUser', email: string, name?: string | null } | { __typename: 'Membership', id: string } | null }>, transactions: { __typename: 'ActivateTransactionConnection', totalCount: number }, offerPurchases: { __typename: 'OfferPurchaseConnection', totalCount: number }, primaryAddress?: { __typename: 'MembershipAddress', address1?: string | null, address2?: string | null, city?: string | null, state?: string | null, zipcode?: string | null } | null, externalIdentityVerificationProfiles?: Array<{ __typename: 'ExternalIdentityVerificationProfile', completedAt: string, provider: ExternalIdentityVerificationProvider, attributes?: Array<{ __typename: 'ExternalIdentityVerificationAttribute', name: string, handle: string }> | null }> | null, externalLoyaltyIds: Array<{ __typename: 'ExternalLoyaltyId', id: string, identifier: string, externalProgram: { __typename: 'ExternalProgram', id: string, name: string } }> };

export type MembershipItemFragment = { __typename: 'Membership', id: string, createdAt: string, customerUuid?: string | null, firstName?: string | null, lastName?: string | null, email?: string | null, phone?: string | null, points: number, state: Membership_State };

export type AudienceForMembershipFragment = { __typename: 'Audience', uuid: string, name: string, description: string, status: Audience_Status };

export type FuelAndConvenienceProfileFragment = { __typename: 'FuelAndConvenienceProfile', id: string, achStatus?: Ach_Status | null, achEnrollmentStatus?: Ach_Enrollment_Status | null, acquisitionChannel?: string | null, restrictionVerification?: Category_Restrictions | null, restrictionVerificationSource?: Restriction_Verification_Source | null, createdAt: string };

export type LoyaltyEventItemFragment = { __typename: 'LoyaltyEvent', createdAt: string, eventType: string, id: string };

export type MembershipOfferFragment = { __typename: 'Offer', id: string, name: string, description?: string | null, activationStatus: Offer_Activation_Status, visibleStatus?: Offer_Visible_Status | null, eligible?: boolean | null, engagementType?: Offer_Engagement_Type | null, voucherCount: number, fulfillmentCount: number, createdAt: string, expireAt?: string | null, campaign?: { __typename: 'Campaign', uuid: string } | null, earningMechanism?: { __typename: 'EarningMechanismExternalFulfillment', id: string, externalFulfillmentAward?: { __typename: 'AwardPoints', points: number } | { __typename: 'AwardVouchers', voucherCount: number, voucherExpirationDays?: number | null, voucheredOffer: { __typename: 'Offer', id: string, name: string, fulfillmentCount: number, engagementType?: Offer_Engagement_Type | null } } | null } | { __typename: 'EarningMechanismLoyaltyEvent', id: string, loyaltyEventEventType: string, loyaltyEventAward?: { __typename: 'AwardExternalPoints', maximum?: number | null } | { __typename: 'AwardPoints', points: number } | { __typename: 'AwardVouchers', voucherCount: number, voucherExpirationDays?: number | null, voucheredOffer: { __typename: 'Offer', id: string, name: string, fulfillmentCount: number, engagementType?: Offer_Engagement_Type | null } } | null } | { __typename: 'EarningMechanismMembershipEvent', id: string, membershipEventEventType: Membership_Event_Type, membershipEventAward: { __typename: 'AwardPoints', points: number } | { __typename: 'AwardVouchers', voucherCount: number, voucherExpirationDays?: number | null, voucheredOffer: { __typename: 'Offer', id: string, name: string, fulfillmentCount: number, engagementType?: Offer_Engagement_Type | null } } } | { __typename: 'EarningMechanismPointSpend', id: string, pointCost: number, offerIsReturnable?: boolean | null, allowedForNewMember?: boolean | null, pointSpendAward: { __typename: 'AwardVouchers', voucherCount: number, voucherExpirationDays?: number | null, voucheredOffer: { __typename: 'Offer', id: string, name: string, fulfillmentCount: number, engagementType?: Offer_Engagement_Type | null } } } | { __typename: 'EarningMechanismProductDiscount', id: string, allowCarryOver: boolean, purchaseThresholdInt: number, productDiscountAward: { __typename: 'AwardBuyAndGet', discountThreshold: number, percentDiscount: number } | { __typename: 'AwardMoneyDiscount', awardPer: Award_Per_Counting_Strategy, moneyAmount: number, partialDiscount: boolean } | { __typename: 'AwardPriceOverride', maximumCost: number }, eligibleProductGroups: Array<{ __typename: 'ProductGroup', id: string, name: string }> } | { __typename: 'EarningMechanismProductPurchase', id: string, countProductsBy: Earning_Mechanism_Product_Counting_Attribute, purchaseThreshold: number, productPurchaseAward: { __typename: 'AwardExternal', provider: ExternalAwardProvider } | { __typename: 'AwardPoints', points: number } | { __typename: 'AwardVouchers', voucherCount: number, voucherExpirationDays?: number | null, voucheredOffer: { __typename: 'Offer', id: string, name: string, fulfillmentCount: number, engagementType?: Offer_Engagement_Type | null } }, eligibleProductGroups: Array<{ __typename: 'ProductGroup', id: string, name: string }> } | { __typename: 'EarningMechanismPromocodes', id: string, codesType: PromocodesOfferType, promocodes: Array<{ __typename: 'Promocode', id: string, code: any, status: PromocodeStatus, publicationStatus: PromocodePublicationStatus, description?: string | null, startDate: string, endDate?: string | null, stats?: { __typename: 'PromocodeUsageStats', redemptions: number, totalOfferRedemptions: number } | null, createdBy: { __typename: 'CommandCenterUser', email: string, name?: string | null } }>, promoCodeGroups: { __typename: 'PromoCodeGroupConnection', edges: Array<{ __typename: 'PromoCodeGroupEdge', node: { __typename: 'PromoCodeGroup', id: string, fileName: string, processingStatus: PromoCodeGroupProcessingStatus, codesStats: { __typename: 'PromoCodeGroupStats', createdCount: number, failedCount: number, totalCount: number } } }> }, award?: { __typename: 'AwardPoints', points: number } | { __typename: 'AwardVouchers', voucherCount: number, voucherExpirationDays?: number | null, voucheredOffer: { __typename: 'Offer', id: string, name: string, fulfillmentCount: number, engagementType?: Offer_Engagement_Type | null } } | null } | { __typename: 'EarningMechanismSpinWheelGame', id: string, purchasableOffer?: { __typename: 'Offer', id: string, name: string } | null, awards: Array<{ __typename: 'RandomAwardConfig', awardType: Random_Award_Type, limit: number, sequenceNumber: number, award?: { __typename: 'AwardPoints', points: number } | { __typename: 'AwardVouchers', voucherExpirationDays?: number | null, voucherCount: number, voucheredOffer: { __typename: 'Offer', id: string, name: string } } | null }> } | { __typename: 'EarningMechanismStoredValueDiscount', id: string, maxDiscountPerTransaction?: number | null, excludedProductGroups: Array<{ __typename: 'ProductGroup', id: string, name: string }> } | { __typename: 'EarningMechanismTotalEligiblePurchase', id: string, countProductsBy: Earning_Mechanism_Product_Counting_Attribute, roundCountedProducts: Earning_Mechanism_Product_Counting_Rounding_Strategy, totalEligiblePurchaseAward: { __typename: 'AwardPointsPer', points: number, rounding: Award_Points_Rounding_Strategy }, eligibleProductGroups: Array<{ __typename: 'ProductGroup', id: string, name: string }> } | { __typename: 'EarningMechanismTotalEligiblePurchaseOverTime', id: string, countProductsBy: Earning_Mechanism_Product_Counting_Attribute, accumulationThreshold: number, stayVisibleWhileInProgress?: boolean | null, hiddenUntilProgress: boolean, totalEligiblePurchaseOverTimeAward: { __typename: 'AwardPoints', points: number } | { __typename: 'AwardVouchers', voucherCount: number, voucherExpirationDays?: number | null, voucheredOffer: { __typename: 'Offer', id: string, name: string, fulfillmentCount: number, engagementType?: Offer_Engagement_Type | null } }, eligibleProductGroups: Array<{ __typename: 'ProductGroup', id: string, name: string }>, purchaseMemberProgress?: { __typename: 'PurchaseProgress', quantityPurchased: number, quantityRequired: number } | null } | { __typename: 'EarningMechanismTotalSpendOnTransaction', id: string, roundMoneyAmount: Earning_Mechanism_Product_Counting_Rounding_Strategy, totalSpendOnTransactionAward: { __typename: 'AwardPointsPer', points: number, rounding: Award_Points_Rounding_Strategy }, ineligibleProductGroups: Array<{ __typename: 'ProductGroup', id: string, name: string }> } | { __typename: 'EarningMechanismTotalSpendOverTime', id: string, accumulationThreshold: number, stayVisibleWhileInProgress?: boolean | null, totalSpendOverTimeAward: { __typename: 'AwardPoints', points: number } | { __typename: 'AwardVouchers', voucherCount: number, voucherExpirationDays?: number | null, voucheredOffer: { __typename: 'Offer', id: string, name: string, fulfillmentCount: number, engagementType?: Offer_Engagement_Type | null } }, ineligibleProductGroups: Array<{ __typename: 'ProductGroup', id: string, name: string }>, purchaseMemberProgress?: { __typename: 'PurchaseProgress', quantityPurchased: number, quantityRequired: number } | null } | { __typename: 'EarningMechanismTransactionDiscount', id: string, purchaseAmountThreshold: number, allowMultipleFulfillmentsPerProductGroupThreshold: boolean, transactionDiscountAward: { __typename: 'AwardTransactionMoneyDiscount', moneyDiscount: number } | { __typename: 'AwardTransactionPercentDiscount', percentDiscount: number }, ineligibleProductGroups: Array<{ __typename: 'ProductGroup', id: string, name: string }> } | { __typename: 'EarningMechanismVarietyDiscount', id: string, varietyDiscountAward: { __typename: 'AwardPriceOverride', maximumCost: number } | { __typename: 'AwardProductDiscount', percentDiscount: number, purchaseThreshold: number, eligibleProductGroups: Array<{ __typename: 'ProductGroup', id: string, name: string }> } | { __typename: 'AwardTransactionMoneyDiscount', moneyDiscount: number }, purchases: Array<{ __typename: 'EarningVarietyDiscountCriteria', purchaseThreshold: number, eligibleProductGroups: Array<{ __typename: 'ProductGroup', id: string, name: string }> }> } | { __typename: 'EarningMechanismVarietyPurchase', id: string, varietyPurchaseAward: { __typename: 'AwardPoints', points: number } | { __typename: 'AwardVouchers', voucherCount: number, voucherExpirationDays?: number | null, voucheredOffer: { __typename: 'Offer', id: string, name: string, fulfillmentCount: number, engagementType?: Offer_Engagement_Type | null } }, products: Array<{ __typename: 'EarningMechanismProductCriteria', id?: string | null, countProductsBy: Earning_Mechanism_Product_Counting_Attribute, purchaseThreshold: number, eligibleProductGroups: Array<{ __typename: 'ProductGroup', id: string, name: string }> }> } | { __typename: 'EarningMechanismVarietyPurchaseOverTime', id: string, preventDoublePunches?: boolean | null, stayVisibleWhileInProgress?: boolean | null, hiddenUntilProgress: boolean, varietyPurchaseOverTimeAward: { __typename: 'AwardPoints', points: number } | { __typename: 'AwardVouchers', voucherCount: number, voucherExpirationDays?: number | null, voucheredOffer: { __typename: 'Offer', id: string, name: string, fulfillmentCount: number, engagementType?: Offer_Engagement_Type | null } }, products: Array<{ __typename: 'EarningMechanismProductCriteria', id?: string | null, countProductsBy: Earning_Mechanism_Product_Counting_Attribute, purchaseThreshold: number, eligibleProductGroups: Array<{ __typename: 'ProductGroup', id: string, name: string }> }>, varietyMemberProgress: Array<{ __typename: 'VarietyProgress', quantityPurchased: number, quantityRequired: number }> } | { __typename: 'EarningMechanismVisits', id: string, visitThreshold: number, visitsAward: { __typename: 'AwardPoints', points: number } | { __typename: 'AwardVouchers', voucherCount: number, voucherExpirationDays?: number | null, voucheredOffer: { __typename: 'Offer', id: string, name: string, fulfillmentCount: number, engagementType?: Offer_Engagement_Type | null } }, visitsMemberProgress?: { __typename: 'VisitsProgress', visits: number, visitsRequired: number } | null } | null, marketingContents: Array<{ __typename: 'MarketingContent', id: string, title?: string | null, shortDescription?: string | null, imageUrl?: string | null }> };

export type MembershipVoucherFragment = { __typename: 'Voucher', id: string, createdAt: string, expireAt?: string | null, sourceId?: string | null, sourceType?: string | null, state: Voucher_State, offer?: { __typename: 'Offer', id: string, name: string, engagementType?: Offer_Engagement_Type | null, voucherCount: number, marketingContents: Array<{ __typename: 'MarketingContent', id: string, title?: string | null, imageUrl?: string | null }> } | null, fulfilledBy?: { __typename: 'ActivateTransaction', id: string, transactionTimeAt?: string | null, location?: { __typename: 'ActivateLocation', id: string, name?: string | null } | null, lineItems: Array<{ __typename: 'ActivateTransactionLineItem', id: string, sku?: string | null, upc?: string | null, quantity?: number | null, description?: string | null, group?: string | null, moneyAmount?: number | null }> } | { __typename: 'GameSession' } | { __typename: 'LoyaltyEvent' } | null };

type MembershipVoucherFulfilledBy_ActivateTransaction_Fragment = { __typename: 'ActivateTransaction', id: string, transactionTimeAt?: string | null, location?: { __typename: 'ActivateLocation', id: string, name?: string | null } | null, lineItems: Array<{ __typename: 'ActivateTransactionLineItem', id: string, sku?: string | null, upc?: string | null, quantity?: number | null, description?: string | null, group?: string | null, moneyAmount?: number | null }> };

type MembershipVoucherFulfilledBy_GameSession_Fragment = { __typename: 'GameSession' };

type MembershipVoucherFulfilledBy_LoyaltyEvent_Fragment = { __typename: 'LoyaltyEvent' };

export type MembershipVoucherFulfilledByFragment = MembershipVoucherFulfilledBy_ActivateTransaction_Fragment | MembershipVoucherFulfilledBy_GameSession_Fragment | MembershipVoucherFulfilledBy_LoyaltyEvent_Fragment;

export type MembershipVoucherFulfilledByActivateTransactionFragment = { __typename: 'ActivateTransaction', id: string, transactionTimeAt?: string | null, location?: { __typename: 'ActivateLocation', id: string, name?: string | null } | null, lineItems: Array<{ __typename: 'ActivateTransactionLineItem', id: string, sku?: string | null, upc?: string | null, quantity?: number | null, description?: string | null, group?: string | null, moneyAmount?: number | null }> };

export type MembershipStateChangeFragment = { __typename: 'MembershipState', effectiveAt?: string | null, state: Membership_State, source?: { __typename: 'ActivateTransaction', id: string } | { __typename: 'CommandCenterUser', email: string, name?: string | null } | { __typename: 'Membership', id: string } | null };

type MembershipStateChangeSource_ActivateTransaction_Fragment = { __typename: 'ActivateTransaction', id: string };

type MembershipStateChangeSource_CommandCenterUser_Fragment = { __typename: 'CommandCenterUser', email: string, name?: string | null };

type MembershipStateChangeSource_Membership_Fragment = { __typename: 'Membership', id: string };

export type MembershipStateChangeSourceFragment = MembershipStateChangeSource_ActivateTransaction_Fragment | MembershipStateChangeSource_CommandCenterUser_Fragment | MembershipStateChangeSource_Membership_Fragment;

export type TransactionStateChangeSourceItemFragment = { __typename: 'ActivateTransaction', id: string };

export type MembershipStateChangeSourceItemFragment = { __typename: 'Membership', id: string };

export type CommandCenterUserStateChangeSourceItemFragment = { __typename: 'CommandCenterUser', email: string, name?: string | null };

export type SegmentByMembershipUuidFragment = { __typename: 'Segment', id: string, name: string, description: string, shortCode?: string | null, membershipSegmentCreatedAt?: string | null };

export type TransactionItemFragment = { __typename: 'ActivateTransaction', id: string, transactionTimeAt?: string | null, createdAt: string, partnerId?: string | null, totalAmount?: number | null, totalAmountWithoutDiscounts?: number | null, totalTax?: number | null, lineItems: Array<{ __typename: 'ActivateTransactionLineItem', id: string, moneyAmount?: number | null, quantity?: number | null }>, location?: { __typename: 'ActivateLocation', id: string, name?: string | null, address1?: string | null, city?: string | null, state?: string | null } | null };

export type PointChangeItemFragment = { __typename: 'PointChange', id: string, createdAt: string, notes?: string | null, type?: Point_Change_Type | null, quantity: number, pointAdjustmentReason?: { __typename: 'PointAdjustmentReason', id: string, label: string, description?: string | null } | null, offer?: { __typename: 'Offer', id: string, name: string, activationStatus: Offer_Activation_Status, category?: string | null, publishAt?: string | null, expireAt?: string | null, marketingContents: Array<{ __typename: 'MarketingContent', id: string, title?: string | null, shortDescription?: string | null, imageUrl?: string | null }> } | null, source?: { __typename: 'ActivateTransaction', id: string } | { __typename: 'ActivateUser', id: string } | { __typename: 'Chain' } | { __typename: 'CommandCenterUser', email: string } | { __typename: 'GameSession' } | { __typename: 'LoyaltyEvent', id: string } | { __typename: 'MembershipPointDonation' } | { __typename: 'OfferPurchase' } | { __typename: 'PointChange', id: string } | { __typename: 'PromocodeUseRequest' } | { __typename: 'StoredValueTransaction' } | null };

export type MembershipAddressFragment = { __typename: 'MembershipAddress', address1?: string | null, address2?: string | null, city?: string | null, state?: string | null, zipcode?: string | null };

export type PointAdjustmentReasonFragment = { __typename: 'PointAdjustmentReason', id: string, label: string, description?: string | null };

export type MembershipCommentFragment = { __typename: 'MembershipProfileComment', id: string, createdAt: string, text: string, author: { __typename: 'CommandCenterUser', email: string, name?: string | null } };

export type RetailerNetworkLocationForMemberFragment = { __typename: 'RetailerNetworkLocationForMember', uuid: string, role?: Retailer_Network_User_Role | null, siteId: string, siteName: string, retailerNetworkUuid: string };

export type RetailerNetworkLocationGroupForMemberFragment = { __typename: 'RetailerNetworkLocationGroupForMember', uuid: string, countOfLocations: number, name: string, roles?: Array<Retailer_Network_User_Role> | null, retailerNetworkUuid: string };

export type RetailerNetworkForMemberFragment = { __typename: 'RetailerNetworkForMember', uuid: string, name?: string | null, roles?: Array<Retailer_Network_User_Role> | null, locationsCount: number };

export type RetailerNetworkUserForMemberFragment = { __typename: 'RetailerNetworkUser', uuid: string, role: Retailer_Network_User_Role };

export type PhoneNumberMetadataFragment = { __typename: 'PhoneNumberMetadata', carrier?: string | null, countryCode?: string | null, phoneType?: string | null };

export type MembershipExternalIdentityVerificationProfileFragment = { __typename: 'ExternalIdentityVerificationProfile', completedAt: string, provider: ExternalIdentityVerificationProvider, attributes?: Array<{ __typename: 'ExternalIdentityVerificationAttribute', name: string, handle: string }> | null };

export type MembershipActivityFragment = { __typename: 'MembershipActivity', id: string, createdAt: string, type: MembershipActivityTypename, event: { __typename: 'ActivateTransaction', id: string, createdAt: string, totalAmount?: number | null, totalGallons?: number | null, totalPointsEarned: number, totalPointsRefunded: number, totalPointsSpent: number, location?: { __typename: 'ActivateLocation', id: string, name?: string | null, address1?: string | null, address2?: string | null, city?: string | null, state?: string | null, zipcode?: string | null } | null } | { __typename: 'PointChange', id: string, type?: Point_Change_Type | null, createdAt: string, notes?: string | null, sourceType?: Point_Change_Source_Type | null, quantity: number, source?: { __typename: 'ActivateTransaction', id: string, createdAt: string, transactionTimeAt?: string | null, partnerId?: string | null, lineItems: Array<{ __typename: 'ActivateTransactionLineItem', id: string, sku?: string | null, upc?: string | null, group?: string | null, quantity?: number | null, moneyAmount?: number | null }>, location?: { __typename: 'ActivateLocation', id: string, name?: string | null, address1?: string | null, city?: string | null, state?: string | null } | null, fulfilledOffers: Array<{ __typename: 'Offer', id: string, name: string, marketingContents: Array<{ __typename: 'MarketingContent', id: string, title?: string | null }> }> } | { __typename: 'ActivateUser', id: string, email: string, name?: string | null } | { __typename: 'Chain' } | { __typename: 'CommandCenterUser', name?: string | null, email: string } | { __typename: 'GameSession' } | { __typename: 'LoyaltyEvent', id: string, eventType: string, eventData?: object | object[] | null } | { __typename: 'MembershipPointDonation', id: string, pointsSpent: number, donationAmountCents: number, bucket: { __typename: 'DonationBucket', id: string, name: string } } | { __typename: 'OfferPurchase', pointCost: number, voucherGrantFor: { __typename: 'Offer', id: string, name: string, publishAt?: string | null, expireAt?: string | null, marketingContents: Array<{ __typename: 'MarketingContent', id: string, title?: string | null }> } } | { __typename: 'PointChange', id: string } | { __typename: 'PromocodeUseRequest' } | { __typename: 'StoredValueTransaction' } | null, offer?: { __typename: 'Offer', id: string, name: string, marketingContents: Array<{ __typename: 'MarketingContent', id: string, title?: string | null }> } | null } };

export type MembershipActivityActivateTransactionFragment = { __typename: 'ActivateTransaction', id: string, createdAt: string, totalAmount?: number | null, totalGallons?: number | null, totalPointsEarned: number, totalPointsRefunded: number, totalPointsSpent: number, location?: { __typename: 'ActivateLocation', id: string, name?: string | null, address1?: string | null, address2?: string | null, city?: string | null, state?: string | null, zipcode?: string | null } | null };

export type MembershipActivityPointChangeFragment = { __typename: 'PointChange', id: string, type?: Point_Change_Type | null, createdAt: string, notes?: string | null, sourceType?: Point_Change_Source_Type | null, quantity: number, source?: { __typename: 'ActivateTransaction', id: string, createdAt: string, transactionTimeAt?: string | null, partnerId?: string | null, lineItems: Array<{ __typename: 'ActivateTransactionLineItem', id: string, sku?: string | null, upc?: string | null, group?: string | null, quantity?: number | null, moneyAmount?: number | null }>, location?: { __typename: 'ActivateLocation', id: string, name?: string | null, address1?: string | null, city?: string | null, state?: string | null } | null, fulfilledOffers: Array<{ __typename: 'Offer', id: string, name: string, marketingContents: Array<{ __typename: 'MarketingContent', id: string, title?: string | null }> }> } | { __typename: 'ActivateUser', id: string, email: string, name?: string | null } | { __typename: 'Chain' } | { __typename: 'CommandCenterUser', name?: string | null, email: string } | { __typename: 'GameSession' } | { __typename: 'LoyaltyEvent', id: string, eventType: string, eventData?: object | object[] | null } | { __typename: 'MembershipPointDonation', id: string, pointsSpent: number, donationAmountCents: number, bucket: { __typename: 'DonationBucket', id: string, name: string } } | { __typename: 'OfferPurchase', pointCost: number, voucherGrantFor: { __typename: 'Offer', id: string, name: string, publishAt?: string | null, expireAt?: string | null, marketingContents: Array<{ __typename: 'MarketingContent', id: string, title?: string | null }> } } | { __typename: 'PointChange', id: string } | { __typename: 'PromocodeUseRequest' } | { __typename: 'StoredValueTransaction' } | null, offer?: { __typename: 'Offer', id: string, name: string, marketingContents: Array<{ __typename: 'MarketingContent', id: string, title?: string | null }> } | null };

export type MembershipUpdateMutationVariables = Exact<{
  input: MembershipUpdate;
}>;


export type MembershipUpdateMutation = { __typename: 'Mutation', membershipUpdate?: { __typename: 'Membership', id: string, createdAt: string, birthdate?: string | null, customData?: object | object[] | null, customerUuid?: string | null, email?: string | null, firstName?: string | null, lastName?: string | null, phone?: string | null, points: number, storedValueBalance?: number | null, state: Membership_State, membershipType?: Membership_Type | null, lastSubBrandOffersQueriesUuid?: string | null, storedValueExpirationSchedule: { __typename: 'StoredValueExpirationScheduleConnection', edges: Array<{ __typename: 'StoredValueExpirationScheduleEdge', node: { __typename: 'StoredValueExpirationSchedule', expirationDate: string, storedValue: number } }> }, homeStores?: Array<{ __typename: 'HomeStore', locationUuid: string }> | null, locationProfile?: { __typename: 'LocationProfile', city?: string | null, locationId?: string | null, state?: string | null, zipcode?: string | null } | null, fuelAndConvenienceProfile?: { __typename: 'FuelAndConvenienceProfile', id: string, achStatus?: Ach_Status | null, achEnrollmentStatus?: Ach_Enrollment_Status | null, acquisitionChannel?: string | null, restrictionVerification?: Category_Restrictions | null, restrictionVerificationSource?: Restriction_Verification_Source | null, createdAt: string } | null, stateChanges: Array<{ __typename: 'MembershipState', effectiveAt?: string | null, state: Membership_State, source?: { __typename: 'ActivateTransaction', id: string } | { __typename: 'CommandCenterUser', email: string, name?: string | null } | { __typename: 'Membership', id: string } | null }>, transactions: { __typename: 'ActivateTransactionConnection', totalCount: number }, offerPurchases: { __typename: 'OfferPurchaseConnection', totalCount: number }, primaryAddress?: { __typename: 'MembershipAddress', address1?: string | null, address2?: string | null, city?: string | null, state?: string | null, zipcode?: string | null } | null, externalIdentityVerificationProfiles?: Array<{ __typename: 'ExternalIdentityVerificationProfile', completedAt: string, provider: ExternalIdentityVerificationProvider, attributes?: Array<{ __typename: 'ExternalIdentityVerificationAttribute', name: string, handle: string }> | null }> | null, externalLoyaltyIds: Array<{ __typename: 'ExternalLoyaltyId', id: string, identifier: string, externalProgram: { __typename: 'ExternalProgram', id: string, name: string } }> } | null };

export type MembershipAdjustPointsMutationVariables = Exact<{
  input: MembershipAdjustPointsInput;
}>;


export type MembershipAdjustPointsMutation = { __typename: 'Mutation', membershipAdjustPoints?: { __typename: 'Membership', id: string, createdAt: string, birthdate?: string | null, customData?: object | object[] | null, customerUuid?: string | null, email?: string | null, firstName?: string | null, lastName?: string | null, phone?: string | null, points: number, storedValueBalance?: number | null, state: Membership_State, membershipType?: Membership_Type | null, lastSubBrandOffersQueriesUuid?: string | null, storedValueExpirationSchedule: { __typename: 'StoredValueExpirationScheduleConnection', edges: Array<{ __typename: 'StoredValueExpirationScheduleEdge', node: { __typename: 'StoredValueExpirationSchedule', expirationDate: string, storedValue: number } }> }, homeStores?: Array<{ __typename: 'HomeStore', locationUuid: string }> | null, locationProfile?: { __typename: 'LocationProfile', city?: string | null, locationId?: string | null, state?: string | null, zipcode?: string | null } | null, fuelAndConvenienceProfile?: { __typename: 'FuelAndConvenienceProfile', id: string, achStatus?: Ach_Status | null, achEnrollmentStatus?: Ach_Enrollment_Status | null, acquisitionChannel?: string | null, restrictionVerification?: Category_Restrictions | null, restrictionVerificationSource?: Restriction_Verification_Source | null, createdAt: string } | null, stateChanges: Array<{ __typename: 'MembershipState', effectiveAt?: string | null, state: Membership_State, source?: { __typename: 'ActivateTransaction', id: string } | { __typename: 'CommandCenterUser', email: string, name?: string | null } | { __typename: 'Membership', id: string } | null }>, transactions: { __typename: 'ActivateTransactionConnection', totalCount: number }, offerPurchases: { __typename: 'OfferPurchaseConnection', totalCount: number }, primaryAddress?: { __typename: 'MembershipAddress', address1?: string | null, address2?: string | null, city?: string | null, state?: string | null, zipcode?: string | null } | null, externalIdentityVerificationProfiles?: Array<{ __typename: 'ExternalIdentityVerificationProfile', completedAt: string, provider: ExternalIdentityVerificationProvider, attributes?: Array<{ __typename: 'ExternalIdentityVerificationAttribute', name: string, handle: string }> | null }> | null, externalLoyaltyIds: Array<{ __typename: 'ExternalLoyaltyId', id: string, identifier: string, externalProgram: { __typename: 'ExternalProgram', id: string, name: string } }> } | null };

export type MembershipStateTransitionMutationVariables = Exact<{
  input: MembershipStateTransition;
}>;


export type MembershipStateTransitionMutation = { __typename: 'Mutation', membershipStateTransition?: { __typename: 'Membership', id: string, createdAt: string, birthdate?: string | null, customData?: object | object[] | null, customerUuid?: string | null, email?: string | null, firstName?: string | null, lastName?: string | null, phone?: string | null, points: number, storedValueBalance?: number | null, state: Membership_State, membershipType?: Membership_Type | null, lastSubBrandOffersQueriesUuid?: string | null, storedValueExpirationSchedule: { __typename: 'StoredValueExpirationScheduleConnection', edges: Array<{ __typename: 'StoredValueExpirationScheduleEdge', node: { __typename: 'StoredValueExpirationSchedule', expirationDate: string, storedValue: number } }> }, homeStores?: Array<{ __typename: 'HomeStore', locationUuid: string }> | null, locationProfile?: { __typename: 'LocationProfile', city?: string | null, locationId?: string | null, state?: string | null, zipcode?: string | null } | null, fuelAndConvenienceProfile?: { __typename: 'FuelAndConvenienceProfile', id: string, achStatus?: Ach_Status | null, achEnrollmentStatus?: Ach_Enrollment_Status | null, acquisitionChannel?: string | null, restrictionVerification?: Category_Restrictions | null, restrictionVerificationSource?: Restriction_Verification_Source | null, createdAt: string } | null, stateChanges: Array<{ __typename: 'MembershipState', effectiveAt?: string | null, state: Membership_State, source?: { __typename: 'ActivateTransaction', id: string } | { __typename: 'CommandCenterUser', email: string, name?: string | null } | { __typename: 'Membership', id: string } | null }>, transactions: { __typename: 'ActivateTransactionConnection', totalCount: number }, offerPurchases: { __typename: 'OfferPurchaseConnection', totalCount: number }, primaryAddress?: { __typename: 'MembershipAddress', address1?: string | null, address2?: string | null, city?: string | null, state?: string | null, zipcode?: string | null } | null, externalIdentityVerificationProfiles?: Array<{ __typename: 'ExternalIdentityVerificationProfile', completedAt: string, provider: ExternalIdentityVerificationProvider, attributes?: Array<{ __typename: 'ExternalIdentityVerificationAttribute', name: string, handle: string }> | null }> | null, externalLoyaltyIds: Array<{ __typename: 'ExternalLoyaltyId', id: string, identifier: string, externalProgram: { __typename: 'ExternalProgram', id: string, name: string } }> } | null };

export type MembershipHomeStoresCreateOrUpdateMutationVariables = Exact<{
  input: MembershipHomeStoresCreateOrUpdateInput;
}>;


export type MembershipHomeStoresCreateOrUpdateMutation = { __typename: 'Mutation', membershipHomeStoresCreateOrUpdate: { __typename: 'Membership', id: string, createdAt: string, birthdate?: string | null, customData?: object | object[] | null, customerUuid?: string | null, email?: string | null, firstName?: string | null, lastName?: string | null, phone?: string | null, points: number, storedValueBalance?: number | null, state: Membership_State, membershipType?: Membership_Type | null, lastSubBrandOffersQueriesUuid?: string | null, storedValueExpirationSchedule: { __typename: 'StoredValueExpirationScheduleConnection', edges: Array<{ __typename: 'StoredValueExpirationScheduleEdge', node: { __typename: 'StoredValueExpirationSchedule', expirationDate: string, storedValue: number } }> }, homeStores?: Array<{ __typename: 'HomeStore', locationUuid: string }> | null, locationProfile?: { __typename: 'LocationProfile', city?: string | null, locationId?: string | null, state?: string | null, zipcode?: string | null } | null, fuelAndConvenienceProfile?: { __typename: 'FuelAndConvenienceProfile', id: string, achStatus?: Ach_Status | null, achEnrollmentStatus?: Ach_Enrollment_Status | null, acquisitionChannel?: string | null, restrictionVerification?: Category_Restrictions | null, restrictionVerificationSource?: Restriction_Verification_Source | null, createdAt: string } | null, stateChanges: Array<{ __typename: 'MembershipState', effectiveAt?: string | null, state: Membership_State, source?: { __typename: 'ActivateTransaction', id: string } | { __typename: 'CommandCenterUser', email: string, name?: string | null } | { __typename: 'Membership', id: string } | null }>, transactions: { __typename: 'ActivateTransactionConnection', totalCount: number }, offerPurchases: { __typename: 'OfferPurchaseConnection', totalCount: number }, primaryAddress?: { __typename: 'MembershipAddress', address1?: string | null, address2?: string | null, city?: string | null, state?: string | null, zipcode?: string | null } | null, externalIdentityVerificationProfiles?: Array<{ __typename: 'ExternalIdentityVerificationProfile', completedAt: string, provider: ExternalIdentityVerificationProvider, attributes?: Array<{ __typename: 'ExternalIdentityVerificationAttribute', name: string, handle: string }> | null }> | null, externalLoyaltyIds: Array<{ __typename: 'ExternalLoyaltyId', id: string, identifier: string, externalProgram: { __typename: 'ExternalProgram', id: string, name: string } }> } };

export type CreateMembershipCommentMutationVariables = Exact<{
  input: MembershipProfileCommentCreateInput;
}>;


export type CreateMembershipCommentMutation = { __typename: 'Mutation', membershipProfileCommentCreate: { __typename: 'MembershipProfileComment', id: string, createdAt: string, text: string, author: { __typename: 'CommandCenterUser', email: string, name?: string | null } } };

export type LoyaltyEventCreateMutationVariables = Exact<{
  input: LoyaltyEventCreate;
}>;


export type LoyaltyEventCreateMutation = { __typename: 'Mutation', event?: { __typename: 'LoyaltyEvent', eventData?: object | object[] | null, eventType: string, createdAt: string } | null };

export type DeleteMembershipScrubDataMutationVariables = Exact<{
  input: ScrubDataInput;
}>;


export type DeleteMembershipScrubDataMutation = { __typename: 'Mutation', scrubData: boolean };

export type DeleteMembershipMutationVariables = Exact<{
  input: MembershipDeleteInput;
}>;


export type DeleteMembershipMutation = { __typename: 'Mutation', membershipDelete: boolean };

export type MembershipQueryVariables = Exact<{
  filter?: InputMaybe<MembershipFilter>;
}>;


export type MembershipQuery = { __typename: 'Query', memberships?: { __typename: 'MembershipConnection', edges: Array<{ __typename: 'MembershipEdge', cursor: string, node: { __typename: 'Membership', id: string, createdAt: string, birthdate?: string | null, customData?: object | object[] | null, customerUuid?: string | null, email?: string | null, firstName?: string | null, lastName?: string | null, phone?: string | null, points: number, storedValueBalance?: number | null, state: Membership_State, membershipType?: Membership_Type | null, lastSubBrandOffersQueriesUuid?: string | null, storedValueExpirationSchedule: { __typename: 'StoredValueExpirationScheduleConnection', edges: Array<{ __typename: 'StoredValueExpirationScheduleEdge', node: { __typename: 'StoredValueExpirationSchedule', expirationDate: string, storedValue: number } }> }, homeStores?: Array<{ __typename: 'HomeStore', locationUuid: string }> | null, locationProfile?: { __typename: 'LocationProfile', city?: string | null, locationId?: string | null, state?: string | null, zipcode?: string | null } | null, fuelAndConvenienceProfile?: { __typename: 'FuelAndConvenienceProfile', id: string, achStatus?: Ach_Status | null, achEnrollmentStatus?: Ach_Enrollment_Status | null, acquisitionChannel?: string | null, restrictionVerification?: Category_Restrictions | null, restrictionVerificationSource?: Restriction_Verification_Source | null, createdAt: string } | null, stateChanges: Array<{ __typename: 'MembershipState', effectiveAt?: string | null, state: Membership_State, source?: { __typename: 'ActivateTransaction', id: string } | { __typename: 'CommandCenterUser', email: string, name?: string | null } | { __typename: 'Membership', id: string } | null }>, transactions: { __typename: 'ActivateTransactionConnection', totalCount: number }, offerPurchases: { __typename: 'OfferPurchaseConnection', totalCount: number }, primaryAddress?: { __typename: 'MembershipAddress', address1?: string | null, address2?: string | null, city?: string | null, state?: string | null, zipcode?: string | null } | null, externalIdentityVerificationProfiles?: Array<{ __typename: 'ExternalIdentityVerificationProfile', completedAt: string, provider: ExternalIdentityVerificationProvider, attributes?: Array<{ __typename: 'ExternalIdentityVerificationAttribute', name: string, handle: string }> | null }> | null, externalLoyaltyIds: Array<{ __typename: 'ExternalLoyaltyId', id: string, identifier: string, externalProgram: { __typename: 'ExternalProgram', id: string, name: string } }> } }> } | null };

export type MembershipListQueryVariables = Exact<{
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  filter?: InputMaybe<MembershipFilter>;
}>;


export type MembershipListQuery = { __typename: 'Query', memberships?: { __typename: 'MembershipConnection', pageInfo: { __typename: 'PageInfo', hasNextPage: boolean, hasPreviousPage: boolean, startCursor?: string | null, endCursor?: string | null }, edges: Array<{ __typename: 'MembershipEdge', cursor: string, node: { __typename: 'Membership', id: string, createdAt: string, customerUuid?: string | null, firstName?: string | null, lastName?: string | null, email?: string | null, phone?: string | null, points: number, state: Membership_State } }> } | null };

export type MembershipLoyaltyEventsQueryVariables = Exact<{
  membershipId: Scalars['ID']['input'];
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  filter?: InputMaybe<LoyaltyEventFilter>;
}>;


export type MembershipLoyaltyEventsQuery = { __typename: 'Query', memberships?: { __typename: 'MembershipConnection', edges: Array<{ __typename: 'MembershipEdge', node: { __typename: 'Membership', loyaltyEvents: { __typename: 'LoyaltyEventConnection', pageInfo: { __typename: 'PageInfo', hasNextPage: boolean, hasPreviousPage: boolean, startCursor?: string | null, endCursor?: string | null }, edges: Array<{ __typename: 'LoyaltyEventEdge', cursor: string, node: { __typename: 'LoyaltyEvent', createdAt: string, eventType: string, id: string } }> } } }> } | null };

export type AudiencesForMembershipQueryVariables = Exact<{
  membershipId: Scalars['ID']['input'];
}>;


export type AudiencesForMembershipQuery = { __typename: 'Query', audiencesForMembership?: Array<{ __typename: 'Audience', uuid: string, name: string, description: string, status: Audience_Status }> | null };

export type AudiencesForMembershipWithPaginationQueryVariables = Exact<{
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  filter?: InputMaybe<AudienceForMembershipFilter>;
}>;


export type AudiencesForMembershipWithPaginationQuery = { __typename: 'Query', audiencesForMembershipWithPagination: { __typename: 'AudienceConnection', pageInfo: { __typename: 'PageInfo', hasNextPage: boolean, hasPreviousPage: boolean, startCursor?: string | null, endCursor?: string | null }, edges: Array<{ __typename: 'AudienceEdge', cursor: string, node: { __typename: 'Audience', uuid: string, name: string, description: string, status: Audience_Status } }> } };

export type MembershipOffersQueryVariables = Exact<{
  membershipId: Scalars['ID']['input'];
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  filter?: InputMaybe<OfferFilter>;
}>;


export type MembershipOffersQuery = { __typename: 'Query', memberships?: { __typename: 'MembershipConnection', edges: Array<{ __typename: 'MembershipEdge', node: { __typename: 'Membership', id: string, offers: { __typename: 'OfferConnection', pageInfo: { __typename: 'PageInfo', hasNextPage: boolean, hasPreviousPage: boolean, startCursor?: string | null, endCursor?: string | null }, edges: Array<{ __typename: 'OfferEdge', cursor: string, node: { __typename: 'Offer', id: string, name: string, description?: string | null, activationStatus: Offer_Activation_Status, visibleStatus?: Offer_Visible_Status | null, eligible?: boolean | null, engagementType?: Offer_Engagement_Type | null, voucherCount: number, fulfillmentCount: number, createdAt: string, expireAt?: string | null, campaign?: { __typename: 'Campaign', uuid: string } | null, earningMechanism?: { __typename: 'EarningMechanismExternalFulfillment', id: string, externalFulfillmentAward?: { __typename: 'AwardPoints', points: number } | { __typename: 'AwardVouchers', voucherCount: number, voucherExpirationDays?: number | null, voucheredOffer: { __typename: 'Offer', id: string, name: string, fulfillmentCount: number, engagementType?: Offer_Engagement_Type | null } } | null } | { __typename: 'EarningMechanismLoyaltyEvent', id: string, loyaltyEventEventType: string, loyaltyEventAward?: { __typename: 'AwardExternalPoints', maximum?: number | null } | { __typename: 'AwardPoints', points: number } | { __typename: 'AwardVouchers', voucherCount: number, voucherExpirationDays?: number | null, voucheredOffer: { __typename: 'Offer', id: string, name: string, fulfillmentCount: number, engagementType?: Offer_Engagement_Type | null } } | null } | { __typename: 'EarningMechanismMembershipEvent', id: string, membershipEventEventType: Membership_Event_Type, membershipEventAward: { __typename: 'AwardPoints', points: number } | { __typename: 'AwardVouchers', voucherCount: number, voucherExpirationDays?: number | null, voucheredOffer: { __typename: 'Offer', id: string, name: string, fulfillmentCount: number, engagementType?: Offer_Engagement_Type | null } } } | { __typename: 'EarningMechanismPointSpend', id: string, pointCost: number, offerIsReturnable?: boolean | null, allowedForNewMember?: boolean | null, pointSpendAward: { __typename: 'AwardVouchers', voucherCount: number, voucherExpirationDays?: number | null, voucheredOffer: { __typename: 'Offer', id: string, name: string, fulfillmentCount: number, engagementType?: Offer_Engagement_Type | null } } } | { __typename: 'EarningMechanismProductDiscount', id: string, allowCarryOver: boolean, purchaseThresholdInt: number, productDiscountAward: { __typename: 'AwardBuyAndGet', discountThreshold: number, percentDiscount: number } | { __typename: 'AwardMoneyDiscount', awardPer: Award_Per_Counting_Strategy, moneyAmount: number, partialDiscount: boolean } | { __typename: 'AwardPriceOverride', maximumCost: number }, eligibleProductGroups: Array<{ __typename: 'ProductGroup', id: string, name: string }> } | { __typename: 'EarningMechanismProductPurchase', id: string, countProductsBy: Earning_Mechanism_Product_Counting_Attribute, purchaseThreshold: number, productPurchaseAward: { __typename: 'AwardExternal', provider: ExternalAwardProvider } | { __typename: 'AwardPoints', points: number } | { __typename: 'AwardVouchers', voucherCount: number, voucherExpirationDays?: number | null, voucheredOffer: { __typename: 'Offer', id: string, name: string, fulfillmentCount: number, engagementType?: Offer_Engagement_Type | null } }, eligibleProductGroups: Array<{ __typename: 'ProductGroup', id: string, name: string }> } | { __typename: 'EarningMechanismPromocodes', id: string, codesType: PromocodesOfferType, promocodes: Array<{ __typename: 'Promocode', id: string, code: any, status: PromocodeStatus, publicationStatus: PromocodePublicationStatus, description?: string | null, startDate: string, endDate?: string | null, stats?: { __typename: 'PromocodeUsageStats', redemptions: number, totalOfferRedemptions: number } | null, createdBy: { __typename: 'CommandCenterUser', email: string, name?: string | null } }>, promoCodeGroups: { __typename: 'PromoCodeGroupConnection', edges: Array<{ __typename: 'PromoCodeGroupEdge', node: { __typename: 'PromoCodeGroup', id: string, fileName: string, processingStatus: PromoCodeGroupProcessingStatus, codesStats: { __typename: 'PromoCodeGroupStats', createdCount: number, failedCount: number, totalCount: number } } }> }, award?: { __typename: 'AwardPoints', points: number } | { __typename: 'AwardVouchers', voucherCount: number, voucherExpirationDays?: number | null, voucheredOffer: { __typename: 'Offer', id: string, name: string, fulfillmentCount: number, engagementType?: Offer_Engagement_Type | null } } | null } | { __typename: 'EarningMechanismSpinWheelGame', id: string, purchasableOffer?: { __typename: 'Offer', id: string, name: string } | null, awards: Array<{ __typename: 'RandomAwardConfig', awardType: Random_Award_Type, limit: number, sequenceNumber: number, award?: { __typename: 'AwardPoints', points: number } | { __typename: 'AwardVouchers', voucherExpirationDays?: number | null, voucherCount: number, voucheredOffer: { __typename: 'Offer', id: string, name: string } } | null }> } | { __typename: 'EarningMechanismStoredValueDiscount', id: string, maxDiscountPerTransaction?: number | null, excludedProductGroups: Array<{ __typename: 'ProductGroup', id: string, name: string }> } | { __typename: 'EarningMechanismTotalEligiblePurchase', id: string, countProductsBy: Earning_Mechanism_Product_Counting_Attribute, roundCountedProducts: Earning_Mechanism_Product_Counting_Rounding_Strategy, totalEligiblePurchaseAward: { __typename: 'AwardPointsPer', points: number, rounding: Award_Points_Rounding_Strategy }, eligibleProductGroups: Array<{ __typename: 'ProductGroup', id: string, name: string }> } | { __typename: 'EarningMechanismTotalEligiblePurchaseOverTime', id: string, countProductsBy: Earning_Mechanism_Product_Counting_Attribute, accumulationThreshold: number, stayVisibleWhileInProgress?: boolean | null, hiddenUntilProgress: boolean, totalEligiblePurchaseOverTimeAward: { __typename: 'AwardPoints', points: number } | { __typename: 'AwardVouchers', voucherCount: number, voucherExpirationDays?: number | null, voucheredOffer: { __typename: 'Offer', id: string, name: string, fulfillmentCount: number, engagementType?: Offer_Engagement_Type | null } }, eligibleProductGroups: Array<{ __typename: 'ProductGroup', id: string, name: string }>, purchaseMemberProgress?: { __typename: 'PurchaseProgress', quantityPurchased: number, quantityRequired: number } | null } | { __typename: 'EarningMechanismTotalSpendOnTransaction', id: string, roundMoneyAmount: Earning_Mechanism_Product_Counting_Rounding_Strategy, totalSpendOnTransactionAward: { __typename: 'AwardPointsPer', points: number, rounding: Award_Points_Rounding_Strategy }, ineligibleProductGroups: Array<{ __typename: 'ProductGroup', id: string, name: string }> } | { __typename: 'EarningMechanismTotalSpendOverTime', id: string, accumulationThreshold: number, stayVisibleWhileInProgress?: boolean | null, totalSpendOverTimeAward: { __typename: 'AwardPoints', points: number } | { __typename: 'AwardVouchers', voucherCount: number, voucherExpirationDays?: number | null, voucheredOffer: { __typename: 'Offer', id: string, name: string, fulfillmentCount: number, engagementType?: Offer_Engagement_Type | null } }, ineligibleProductGroups: Array<{ __typename: 'ProductGroup', id: string, name: string }>, purchaseMemberProgress?: { __typename: 'PurchaseProgress', quantityPurchased: number, quantityRequired: number } | null } | { __typename: 'EarningMechanismTransactionDiscount', id: string, purchaseAmountThreshold: number, allowMultipleFulfillmentsPerProductGroupThreshold: boolean, transactionDiscountAward: { __typename: 'AwardTransactionMoneyDiscount', moneyDiscount: number } | { __typename: 'AwardTransactionPercentDiscount', percentDiscount: number }, ineligibleProductGroups: Array<{ __typename: 'ProductGroup', id: string, name: string }> } | { __typename: 'EarningMechanismVarietyDiscount', id: string, varietyDiscountAward: { __typename: 'AwardPriceOverride', maximumCost: number } | { __typename: 'AwardProductDiscount', percentDiscount: number, purchaseThreshold: number, eligibleProductGroups: Array<{ __typename: 'ProductGroup', id: string, name: string }> } | { __typename: 'AwardTransactionMoneyDiscount', moneyDiscount: number }, purchases: Array<{ __typename: 'EarningVarietyDiscountCriteria', purchaseThreshold: number, eligibleProductGroups: Array<{ __typename: 'ProductGroup', id: string, name: string }> }> } | { __typename: 'EarningMechanismVarietyPurchase', id: string, varietyPurchaseAward: { __typename: 'AwardPoints', points: number } | { __typename: 'AwardVouchers', voucherCount: number, voucherExpirationDays?: number | null, voucheredOffer: { __typename: 'Offer', id: string, name: string, fulfillmentCount: number, engagementType?: Offer_Engagement_Type | null } }, products: Array<{ __typename: 'EarningMechanismProductCriteria', id?: string | null, countProductsBy: Earning_Mechanism_Product_Counting_Attribute, purchaseThreshold: number, eligibleProductGroups: Array<{ __typename: 'ProductGroup', id: string, name: string }> }> } | { __typename: 'EarningMechanismVarietyPurchaseOverTime', id: string, preventDoublePunches?: boolean | null, stayVisibleWhileInProgress?: boolean | null, hiddenUntilProgress: boolean, varietyPurchaseOverTimeAward: { __typename: 'AwardPoints', points: number } | { __typename: 'AwardVouchers', voucherCount: number, voucherExpirationDays?: number | null, voucheredOffer: { __typename: 'Offer', id: string, name: string, fulfillmentCount: number, engagementType?: Offer_Engagement_Type | null } }, products: Array<{ __typename: 'EarningMechanismProductCriteria', id?: string | null, countProductsBy: Earning_Mechanism_Product_Counting_Attribute, purchaseThreshold: number, eligibleProductGroups: Array<{ __typename: 'ProductGroup', id: string, name: string }> }>, varietyMemberProgress: Array<{ __typename: 'VarietyProgress', quantityPurchased: number, quantityRequired: number }> } | { __typename: 'EarningMechanismVisits', id: string, visitThreshold: number, visitsAward: { __typename: 'AwardPoints', points: number } | { __typename: 'AwardVouchers', voucherCount: number, voucherExpirationDays?: number | null, voucheredOffer: { __typename: 'Offer', id: string, name: string, fulfillmentCount: number, engagementType?: Offer_Engagement_Type | null } }, visitsMemberProgress?: { __typename: 'VisitsProgress', visits: number, visitsRequired: number } | null } | null, marketingContents: Array<{ __typename: 'MarketingContent', id: string, title?: string | null, shortDescription?: string | null, imageUrl?: string | null }> } }> } } }> } | null };

export type MembershipVouchersQueryVariables = Exact<{
  membershipId: Scalars['ID']['input'];
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  filter?: InputMaybe<VoucherFilter>;
  sort?: InputMaybe<VoucherSort>;
}>;


export type MembershipVouchersQuery = { __typename: 'Query', memberships?: { __typename: 'MembershipConnection', edges: Array<{ __typename: 'MembershipEdge', node: { __typename: 'Membership', id: string, vouchers: { __typename: 'VoucherConnection', pageInfo: { __typename: 'PageInfo', hasNextPage: boolean, hasPreviousPage: boolean, startCursor?: string | null, endCursor?: string | null }, edges: Array<{ __typename: 'VoucherEdge', cursor: string, node: { __typename: 'Voucher', id: string, createdAt: string, expireAt?: string | null, sourceId?: string | null, sourceType?: string | null, state: Voucher_State, offer?: { __typename: 'Offer', id: string, name: string, engagementType?: Offer_Engagement_Type | null, voucherCount: number, marketingContents: Array<{ __typename: 'MarketingContent', id: string, title?: string | null, imageUrl?: string | null }> } | null, fulfilledBy?: { __typename: 'ActivateTransaction', id: string, transactionTimeAt?: string | null, location?: { __typename: 'ActivateLocation', id: string, name?: string | null } | null, lineItems: Array<{ __typename: 'ActivateTransactionLineItem', id: string, sku?: string | null, upc?: string | null, quantity?: number | null, description?: string | null, group?: string | null, moneyAmount?: number | null }> } | { __typename: 'GameSession' } | { __typename: 'LoyaltyEvent' } | null } }> } } }> } | null };

export type MembershipTransactionsQueryVariables = Exact<{
  membershipId: Scalars['ID']['input'];
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  filter?: InputMaybe<ActivateTransactionFilter>;
  sort?: InputMaybe<ActivateTransactionSort>;
}>;


export type MembershipTransactionsQuery = { __typename: 'Query', memberships?: { __typename: 'MembershipConnection', edges: Array<{ __typename: 'MembershipEdge', node: { __typename: 'Membership', id: string, transactions: { __typename: 'ActivateTransactionConnection', pageInfo: { __typename: 'PageInfo', hasNextPage: boolean, hasPreviousPage: boolean, startCursor?: string | null, endCursor?: string | null }, edges: Array<{ __typename: 'ActivateTransactionEdge', cursor: string, node: { __typename: 'ActivateTransaction', id: string, transactionTimeAt?: string | null, createdAt: string, partnerId?: string | null, totalAmount?: number | null, totalAmountWithoutDiscounts?: number | null, totalTax?: number | null, lineItems: Array<{ __typename: 'ActivateTransactionLineItem', id: string, moneyAmount?: number | null, quantity?: number | null }>, location?: { __typename: 'ActivateLocation', id: string, name?: string | null, address1?: string | null, city?: string | null, state?: string | null } | null } }> } } }> } | null };

export type SegmentsByMembershipUuidQueryVariables = Exact<{
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter: SegmentForMembershipFilter;
}>;


export type SegmentsByMembershipUuidQuery = { __typename: 'Query', segmentsByMembershipUuid: { __typename: 'SegmentConnection', pageInfo: { __typename: 'PageInfo', hasNextPage: boolean, hasPreviousPage: boolean, startCursor?: string | null, endCursor?: string | null }, edges: Array<{ __typename: 'SegmentEdge', cursor: string, node: { __typename: 'Segment', id: string, name: string, description: string, shortCode?: string | null, membershipSegmentCreatedAt?: string | null } }> } };

export type MembershipCommentsQueryVariables = Exact<{
  membershipId: Scalars['ID']['input'];
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  filter?: InputMaybe<MembershipProfileCommentFilter>;
}>;


export type MembershipCommentsQuery = { __typename: 'Query', memberships?: { __typename: 'MembershipConnection', edges: Array<{ __typename: 'MembershipEdge', node: { __typename: 'Membership', id: string, comments: { __typename: 'MembershipProfileCommentConnection', pageInfo: { __typename: 'PageInfo', hasNextPage: boolean, hasPreviousPage: boolean, startCursor?: string | null, endCursor?: string | null }, edges: Array<{ __typename: 'MembershipProfileCommentEdge', cursor: string, node: { __typename: 'MembershipProfileComment', id: string, createdAt: string, text: string, author: { __typename: 'CommandCenterUser', email: string, name?: string | null } } }> } } }> } | null };

export type RetailerNetworkLocationsForMemberQueryVariables = Exact<{
  first?: InputMaybe<Scalars['Int']['input']>;
  after?: InputMaybe<Scalars['OCBase64Cursor']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  before?: InputMaybe<Scalars['OCBase64Cursor']['input']>;
  memberUuid: Scalars['OCUUID']['input'];
}>;


export type RetailerNetworkLocationsForMemberQuery = { __typename: 'Query', retailerNetworkLocationsForMember: { __typename: 'RetailerNetworkLocationForMemberConnection', edges: Array<{ __typename: 'RetailerNetworkLocationForMemberEdge', node: { __typename: 'RetailerNetworkLocationForMember', uuid: string, role?: Retailer_Network_User_Role | null, siteId: string, siteName: string, retailerNetworkUuid: string } }>, pageInfo: { __typename: 'PageInfo', hasNextPage: boolean, hasPreviousPage: boolean, startCursor?: string | null, endCursor?: string | null } } };

export type RetailerNetworkLocationGroupsForMemberQueryVariables = Exact<{
  first?: InputMaybe<Scalars['Int']['input']>;
  after?: InputMaybe<Scalars['OCBase64Cursor']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  before?: InputMaybe<Scalars['OCBase64Cursor']['input']>;
  memberUuid: Scalars['OCUUID']['input'];
}>;


export type RetailerNetworkLocationGroupsForMemberQuery = { __typename: 'Query', retailerNetworkLocationGroupsForMember: { __typename: 'RetailerNetworkLocationGroupForMemberConnection', edges: Array<{ __typename: 'RetailerNetworkLocationGroupForMemberEdge', node: { __typename: 'RetailerNetworkLocationGroupForMember', uuid: string, countOfLocations: number, name: string, roles?: Array<Retailer_Network_User_Role> | null, retailerNetworkUuid: string } }>, pageInfo: { __typename: 'PageInfo', hasNextPage: boolean, hasPreviousPage: boolean, startCursor?: string | null, endCursor?: string | null } } };

export type RetailerNetworksForMemberQueryVariables = Exact<{
  first?: InputMaybe<Scalars['Int']['input']>;
  after?: InputMaybe<Scalars['OCBase64Cursor']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  before?: InputMaybe<Scalars['OCBase64Cursor']['input']>;
  memberUuid: Scalars['OCUUID']['input'];
}>;


export type RetailerNetworksForMemberQuery = { __typename: 'Query', retailerNetworksForMember: { __typename: 'RetailerNetworksForMemberConnection', edges?: Array<{ __typename: 'RetailerNetworkForMemberEdge', node: { __typename: 'RetailerNetworkForMember', uuid: string, name?: string | null, roles?: Array<Retailer_Network_User_Role> | null, locationsCount: number } }> | null, pageInfo: { __typename: 'PageInfo', hasNextPage: boolean, hasPreviousPage: boolean, startCursor?: string | null, endCursor?: string | null } } };

export type RetailerNetworkUsersForMemberQueryVariables = Exact<{
  after?: InputMaybe<Scalars['OCBase64Cursor']['input']>;
  before?: InputMaybe<Scalars['OCBase64Cursor']['input']>;
  filter: RetailerNetworkUsersForMemberFilter;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
}>;


export type RetailerNetworkUsersForMemberQuery = { __typename: 'Query', retailerNetworkUsersForMember: { __typename: 'RetailerNetworkUserConnection', pageInfo: { __typename: 'PageInfo', hasNextPage: boolean, hasPreviousPage: boolean, startCursor?: string | null, endCursor?: string | null }, edges?: Array<{ __typename: 'RetailerNetworkUserEdge', cursor: string, node: { __typename: 'RetailerNetworkUser', uuid: string, role: Retailer_Network_User_Role } }> | null } };

export type GetPhoneNumberMetadataQueryVariables = Exact<{
  phoneNumber: Scalars['OCPhoneNumber']['input'];
}>;


export type GetPhoneNumberMetadataQuery = { __typename: 'Query', getPhoneNumberMetadata: { __typename: 'PhoneNumberMetadata', carrier?: string | null, countryCode?: string | null, phoneType?: string | null } };

export type MembershipActivitiesQueryVariables = Exact<{
  membershipId: Scalars['ID']['input'];
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  filter?: InputMaybe<MembershipActivityFilter>;
}>;


export type MembershipActivitiesQuery = { __typename: 'Query', memberships?: { __typename: 'MembershipConnection', edges: Array<{ __typename: 'MembershipEdge', node: { __typename: 'Membership', id: string, membershipActivities: { __typename: 'MembershipActivityConnection', pageInfo: { __typename: 'PageInfo', hasNextPage: boolean, hasPreviousPage: boolean, startCursor?: string | null, endCursor?: string | null }, edges: Array<{ __typename: 'MembershipActivityEdge', cursor: string, node?: { __typename: 'MembershipActivity', id: string, createdAt: string, type: MembershipActivityTypename, event: { __typename: 'ActivateTransaction', id: string, createdAt: string, totalAmount?: number | null, totalGallons?: number | null, totalPointsEarned: number, totalPointsRefunded: number, totalPointsSpent: number, location?: { __typename: 'ActivateLocation', id: string, name?: string | null, address1?: string | null, address2?: string | null, city?: string | null, state?: string | null, zipcode?: string | null } | null } | { __typename: 'PointChange', id: string, type?: Point_Change_Type | null, createdAt: string, notes?: string | null, sourceType?: Point_Change_Source_Type | null, quantity: number, source?: { __typename: 'ActivateTransaction', id: string, createdAt: string, transactionTimeAt?: string | null, partnerId?: string | null, lineItems: Array<{ __typename: 'ActivateTransactionLineItem', id: string, sku?: string | null, upc?: string | null, group?: string | null, quantity?: number | null, moneyAmount?: number | null }>, location?: { __typename: 'ActivateLocation', id: string, name?: string | null, address1?: string | null, city?: string | null, state?: string | null } | null, fulfilledOffers: Array<{ __typename: 'Offer', id: string, name: string, marketingContents: Array<{ __typename: 'MarketingContent', id: string, title?: string | null }> }> } | { __typename: 'ActivateUser', id: string, email: string, name?: string | null } | { __typename: 'Chain' } | { __typename: 'CommandCenterUser', name?: string | null, email: string } | { __typename: 'GameSession' } | { __typename: 'LoyaltyEvent', id: string, eventType: string, eventData?: object | object[] | null } | { __typename: 'MembershipPointDonation', id: string, pointsSpent: number, donationAmountCents: number, bucket: { __typename: 'DonationBucket', id: string, name: string } } | { __typename: 'OfferPurchase', pointCost: number, voucherGrantFor: { __typename: 'Offer', id: string, name: string, publishAt?: string | null, expireAt?: string | null, marketingContents: Array<{ __typename: 'MarketingContent', id: string, title?: string | null }> } } | { __typename: 'PointChange', id: string } | { __typename: 'PromocodeUseRequest' } | { __typename: 'StoredValueTransaction' } | null, offer?: { __typename: 'Offer', id: string, name: string, marketingContents: Array<{ __typename: 'MarketingContent', id: string, title?: string | null }> } | null } } | null } | null> } } }> } | null };

export type MetricCountsQueryVariables = Exact<{
  filter: MetricCountsFilter;
}>;


export type MetricCountsQuery = { __typename: 'Query', metricCounts: Array<{ __typename: 'MetricCounts', eventType: Event_Types, subtotal: string, total: string, timeSeries: { __typename: 'MetricCountsTimeSeries', interval: Interval, values: Array<{ __typename: 'MetricCountsTimeSeriesValues', count: string, date: string }> } }> };

export type OfferFragment = { __typename: 'Offer', id: string, description?: string | null, name: string, engagementType?: Offer_Engagement_Type | null, category?: string | null, publicationStatus: Publication_Status_Type, createdAt: string, expireAt?: string | null, publishAt?: string | null, deleted: boolean, presentationType: Offer_Presentation_Type, presentationPriority: Offer_Presentation_Priority, fulfillmentCount: number, fulfillmentPriorityLevel?: number | null, visibleForCommandCenterFulfillment?: boolean | null, voucherCount: number, ageRestricted: boolean, customData?: object | object[] | null, externalId?: string | null, fundingSource?: Offer_Funding_Source | null, fundingSourceName?: string | null, shortDescription?: string | null, longDescription?: string | null, optionalAtPos?: boolean | null, stackable: boolean, displayForOrderAhead?: boolean | null, allowedForManualVisibilityNotifications?: boolean | null, scanDataConfiguration?: { __typename: 'ScanDataConfiguration', description: string, discountAllocation: number, fundingSource: ScanDataFundingSource } | null, trackingConfig?: { __typename: 'TrackingConfig', trackingId: string, isActivityLogIncludedInAltriaDDM: boolean } | null, campaign?: { __typename: 'Campaign', uuid: string, name: string } | null, marketingContents: Array<{ __typename: 'MarketingContent', id: string, locale: string, title?: string | null, shortDescription?: string | null, longDescription?: string | null, imageUrl?: string | null, terms?: string | null, termsUrl?: string | null, customData?: object | object[] | null, disclaimer?: string | null, disclaimerUrl?: string | null, externalUrl?: string | null, surgeonGeneralsWarning?: string | null, triggeredMessageContent: { __typename: 'OfferTriggeredMessageContent', fulfillmentSms?: string | null, visibilitySms?: string | null, progressSms?: string | null }, receiptContent?: { __typename: 'ReceiptContent', shortDescription?: string | null, longDescription?: string | null } | null }>, limits: Array<{ __typename: 'LimitGlobalActivation', id: string, limit: number } | { __typename: 'LimitGlobalActivationInTime', id: string, limit: number, timePeriod: Limit_Time_Period } | { __typename: 'LimitGlobalAwardCount', id: string, limit: number } | { __typename: 'LimitGlobalAwardCountInTime', id: string, limit: number, timePeriod: Limit_Time_Period } | { __typename: 'LimitInTransactionAwardCount', id: string, limit: number } | { __typename: 'LimitInTransactionProgress', id: string, limit: number } | { __typename: 'LimitMembershipActivation', id: string, limit: number } | { __typename: 'LimitMembershipActivationInTime', id: string, limit: number, timePeriod: Limit_Time_Period } | { __typename: 'LimitMembershipAwardCount', id: string, limit: number } | { __typename: 'LimitMembershipAwardCountInTime', id: string, limit: number, timePeriod: Limit_Time_Period } | { __typename: 'LimitMembershipProgressInTime', id: string, limit: number, timePeriod: Limit_Time_Period } | { __typename: 'LimitMembershipTransactionCount', id: string, limit: number } | { __typename: 'LimitMembershipTransactionCountInTime', id: string, limit: number, timePeriod: Limit_Time_Period }>, constraints: Array<{ __typename: 'ConstraintDaysOfWeek', id: string, availableWeeklyOnDays: Array<Weekday>, startOfDayTimezone: string } | { __typename: 'ConstraintEmailRequired', id: string } | { __typename: 'ConstraintInAudience', id: string, audienceId: string } | { __typename: 'ConstraintInStoreOnly', id: string } | { __typename: 'ConstraintLocationInState', id: string, states: Array<string> } | { __typename: 'ConstraintOrderAheadOnly', id: string } | { __typename: 'ConstraintPaymentInstrument', id: string, paymentInstruments: Array<Payment_Instrument_Type>, paymentInstrumentEvaluationMethod: Payment_Instrument_Evaluation_Method } | { __typename: 'ConstraintPaymentMethod', id: string, paymentMethods: Array<Activate_Payment_Method>, paymentEvaluationMethod: Payment_Method_Evaluation_Method } | { __typename: 'ConstraintPreAuth', id: string } | { __typename: 'ConstraintPurchasableEligibility', id: string, ownershipCondition: Ownership_Condition, voucheredOffers: Array<{ __typename: 'Offer', id: string, name: string }> } | { __typename: 'ConstraintPurchaseThreshold', id: string, eligibleProductGroupIds: Array<string>, countProductsBy: Constraint_Purchase_Threshold_Counting_Attribute, threshold: number } | { __typename: 'ConstraintRequiresActivation', id: string, mustFulfillWithinDays?: number | null, allowMultipleFulfillmentsOnActivation: boolean } | { __typename: 'ConstraintRequiresTransactionVoucher', id: string, allowSingleOfferVoucherStacking?: boolean | null, breakageRefund?: boolean | null, breakagePointRounding?: Breakage_Point_Rounding | null } | { __typename: 'ConstraintRequiresVoucher', id: string } | { __typename: 'ConstraintRequiresVoucherAvailableForDiscount', id: string } | { __typename: 'ConstraintStoreLocation', id: string, evaluationMethod: Store_Location_Evaluation_Method, locations: Array<{ __typename: 'ActivateLocation', id: string, name?: string | null }> } | { __typename: 'ConstraintStoreLocationGroup', id: string, locationGroups: Array<{ __typename: 'LocationGroup', uuid: string, name: string }> } | { __typename: 'ConstraintSubBrand', id: string, subBrandUuids: Array<string> } | { __typename: 'ConstraintTimeOfDay', id: string, availableDailyEndingAtTime: string, availableDailyStartingAtTime: string, timezone: string }>, earningMechanism?: { __typename: 'EarningMechanismExternalFulfillment', id: string, externalFulfillmentAward?: { __typename: 'AwardPoints', points: number } | { __typename: 'AwardVouchers', voucherCount: number, voucherExpirationDays?: number | null, voucheredOffer: { __typename: 'Offer', id: string, name: string, fulfillmentCount: number, engagementType?: Offer_Engagement_Type | null } } | null } | { __typename: 'EarningMechanismLoyaltyEvent', id: string, loyaltyEventEventType: string, loyaltyEventAward?: { __typename: 'AwardExternalPoints', maximum?: number | null } | { __typename: 'AwardPoints', points: number } | { __typename: 'AwardVouchers', voucherCount: number, voucherExpirationDays?: number | null, voucheredOffer: { __typename: 'Offer', id: string, name: string, fulfillmentCount: number, engagementType?: Offer_Engagement_Type | null } } | null } | { __typename: 'EarningMechanismMembershipEvent', id: string, membershipEventEventType: Membership_Event_Type, membershipEventAward: { __typename: 'AwardPoints', points: number } | { __typename: 'AwardVouchers', voucherCount: number, voucherExpirationDays?: number | null, voucheredOffer: { __typename: 'Offer', id: string, name: string, fulfillmentCount: number, engagementType?: Offer_Engagement_Type | null } } } | { __typename: 'EarningMechanismPointSpend', id: string, pointCost: number, offerIsReturnable?: boolean | null, allowedForNewMember?: boolean | null, pointSpendAward: { __typename: 'AwardVouchers', voucherCount: number, voucherExpirationDays?: number | null, voucheredOffer: { __typename: 'Offer', id: string, name: string, fulfillmentCount: number, engagementType?: Offer_Engagement_Type | null } } } | { __typename: 'EarningMechanismProductDiscount', id: string, allowCarryOver: boolean, purchaseThresholdInt: number, productDiscountAward: { __typename: 'AwardBuyAndGet', discountThreshold: number, percentDiscount: number } | { __typename: 'AwardMoneyDiscount', awardPer: Award_Per_Counting_Strategy, moneyAmount: number, partialDiscount: boolean } | { __typename: 'AwardPriceOverride', maximumCost: number }, eligibleProductGroups: Array<{ __typename: 'ProductGroup', id: string, name: string }> } | { __typename: 'EarningMechanismProductPurchase', id: string, countProductsBy: Earning_Mechanism_Product_Counting_Attribute, purchaseThreshold: number, productPurchaseAward: { __typename: 'AwardExternal', provider: ExternalAwardProvider } | { __typename: 'AwardPoints', points: number } | { __typename: 'AwardVouchers', voucherCount: number, voucherExpirationDays?: number | null, voucheredOffer: { __typename: 'Offer', id: string, name: string, fulfillmentCount: number, engagementType?: Offer_Engagement_Type | null } }, eligibleProductGroups: Array<{ __typename: 'ProductGroup', id: string, name: string }> } | { __typename: 'EarningMechanismPromocodes', id: string, codesType: PromocodesOfferType, promocodes: Array<{ __typename: 'Promocode', id: string, code: any, status: PromocodeStatus, publicationStatus: PromocodePublicationStatus, description?: string | null, startDate: string, endDate?: string | null, stats?: { __typename: 'PromocodeUsageStats', redemptions: number, totalOfferRedemptions: number } | null, createdBy: { __typename: 'CommandCenterUser', email: string, name?: string | null } }>, promoCodeGroups: { __typename: 'PromoCodeGroupConnection', edges: Array<{ __typename: 'PromoCodeGroupEdge', node: { __typename: 'PromoCodeGroup', id: string, fileName: string, processingStatus: PromoCodeGroupProcessingStatus, codesStats: { __typename: 'PromoCodeGroupStats', createdCount: number, failedCount: number, totalCount: number } } }> }, award?: { __typename: 'AwardPoints', points: number } | { __typename: 'AwardVouchers', voucherCount: number, voucherExpirationDays?: number | null, voucheredOffer: { __typename: 'Offer', id: string, name: string, fulfillmentCount: number, engagementType?: Offer_Engagement_Type | null } } | null } | { __typename: 'EarningMechanismSpinWheelGame', id: string, purchasableOffer?: { __typename: 'Offer', id: string, name: string } | null, awards: Array<{ __typename: 'RandomAwardConfig', awardType: Random_Award_Type, limit: number, sequenceNumber: number, award?: { __typename: 'AwardPoints', points: number } | { __typename: 'AwardVouchers', voucherExpirationDays?: number | null, voucherCount: number, voucheredOffer: { __typename: 'Offer', id: string, name: string } } | null }> } | { __typename: 'EarningMechanismStoredValueDiscount', id: string, maxDiscountPerTransaction?: number | null, excludedProductGroups: Array<{ __typename: 'ProductGroup', id: string, name: string }> } | { __typename: 'EarningMechanismTotalEligiblePurchase', id: string, countProductsBy: Earning_Mechanism_Product_Counting_Attribute, roundCountedProducts: Earning_Mechanism_Product_Counting_Rounding_Strategy, totalEligiblePurchaseAward: { __typename: 'AwardPointsPer', points: number, rounding: Award_Points_Rounding_Strategy }, eligibleProductGroups: Array<{ __typename: 'ProductGroup', id: string, name: string }> } | { __typename: 'EarningMechanismTotalEligiblePurchaseOverTime', id: string, countProductsBy: Earning_Mechanism_Product_Counting_Attribute, accumulationThreshold: number, stayVisibleWhileInProgress?: boolean | null, hiddenUntilProgress: boolean, totalEligiblePurchaseOverTimeAward: { __typename: 'AwardPoints', points: number } | { __typename: 'AwardVouchers', voucherCount: number, voucherExpirationDays?: number | null, voucheredOffer: { __typename: 'Offer', id: string, name: string, fulfillmentCount: number, engagementType?: Offer_Engagement_Type | null } }, eligibleProductGroups: Array<{ __typename: 'ProductGroup', id: string, name: string }>, purchaseMemberProgress?: { __typename: 'PurchaseProgress', quantityPurchased: number, quantityRequired: number } | null } | { __typename: 'EarningMechanismTotalSpendOnTransaction', id: string, roundMoneyAmount: Earning_Mechanism_Product_Counting_Rounding_Strategy, totalSpendOnTransactionAward: { __typename: 'AwardPointsPer', points: number, rounding: Award_Points_Rounding_Strategy }, ineligibleProductGroups: Array<{ __typename: 'ProductGroup', id: string, name: string }> } | { __typename: 'EarningMechanismTotalSpendOverTime', id: string, accumulationThreshold: number, stayVisibleWhileInProgress?: boolean | null, totalSpendOverTimeAward: { __typename: 'AwardPoints', points: number } | { __typename: 'AwardVouchers', voucherCount: number, voucherExpirationDays?: number | null, voucheredOffer: { __typename: 'Offer', id: string, name: string, fulfillmentCount: number, engagementType?: Offer_Engagement_Type | null } }, ineligibleProductGroups: Array<{ __typename: 'ProductGroup', id: string, name: string }>, purchaseMemberProgress?: { __typename: 'PurchaseProgress', quantityPurchased: number, quantityRequired: number } | null } | { __typename: 'EarningMechanismTransactionDiscount', id: string, purchaseAmountThreshold: number, allowMultipleFulfillmentsPerProductGroupThreshold: boolean, transactionDiscountAward: { __typename: 'AwardTransactionMoneyDiscount', moneyDiscount: number } | { __typename: 'AwardTransactionPercentDiscount', percentDiscount: number }, ineligibleProductGroups: Array<{ __typename: 'ProductGroup', id: string, name: string }> } | { __typename: 'EarningMechanismVarietyDiscount', id: string, varietyDiscountAward: { __typename: 'AwardPriceOverride', maximumCost: number } | { __typename: 'AwardProductDiscount', percentDiscount: number, purchaseThreshold: number, eligibleProductGroups: Array<{ __typename: 'ProductGroup', id: string, name: string }> } | { __typename: 'AwardTransactionMoneyDiscount', moneyDiscount: number }, purchases: Array<{ __typename: 'EarningVarietyDiscountCriteria', purchaseThreshold: number, eligibleProductGroups: Array<{ __typename: 'ProductGroup', id: string, name: string }> }> } | { __typename: 'EarningMechanismVarietyPurchase', id: string, varietyPurchaseAward: { __typename: 'AwardPoints', points: number } | { __typename: 'AwardVouchers', voucherCount: number, voucherExpirationDays?: number | null, voucheredOffer: { __typename: 'Offer', id: string, name: string, fulfillmentCount: number, engagementType?: Offer_Engagement_Type | null } }, products: Array<{ __typename: 'EarningMechanismProductCriteria', id?: string | null, countProductsBy: Earning_Mechanism_Product_Counting_Attribute, purchaseThreshold: number, eligibleProductGroups: Array<{ __typename: 'ProductGroup', id: string, name: string }> }> } | { __typename: 'EarningMechanismVarietyPurchaseOverTime', id: string, preventDoublePunches?: boolean | null, stayVisibleWhileInProgress?: boolean | null, hiddenUntilProgress: boolean, varietyPurchaseOverTimeAward: { __typename: 'AwardPoints', points: number } | { __typename: 'AwardVouchers', voucherCount: number, voucherExpirationDays?: number | null, voucheredOffer: { __typename: 'Offer', id: string, name: string, fulfillmentCount: number, engagementType?: Offer_Engagement_Type | null } }, products: Array<{ __typename: 'EarningMechanismProductCriteria', id?: string | null, countProductsBy: Earning_Mechanism_Product_Counting_Attribute, purchaseThreshold: number, eligibleProductGroups: Array<{ __typename: 'ProductGroup', id: string, name: string }> }>, varietyMemberProgress: Array<{ __typename: 'VarietyProgress', quantityPurchased: number, quantityRequired: number }> } | { __typename: 'EarningMechanismVisits', id: string, visitThreshold: number, visitsAward: { __typename: 'AwardPoints', points: number } | { __typename: 'AwardVouchers', voucherCount: number, voucherExpirationDays?: number | null, voucheredOffer: { __typename: 'Offer', id: string, name: string, fulfillmentCount: number, engagementType?: Offer_Engagement_Type | null } }, visitsMemberProgress?: { __typename: 'VisitsProgress', visits: number, visitsRequired: number } | null } | null, triggerPreferences: { __typename: 'TriggerPreferences', triggerOnFulfillment: boolean, triggerOnVisibility: boolean, triggerOnProgress: boolean }, displayCategories: Array<{ __typename: 'DisplayCategory', id: string, name: string, rank: number, bannerIds?: Array<string> | null, categoryRestrictions?: Category_Restrictions | null, shouldLazyLoadBanners?: boolean | null }> };

export type OfferWithCustomConstraintsFragment = { __typename: 'Offer', id: string, description?: string | null, name: string, engagementType?: Offer_Engagement_Type | null, category?: string | null, publicationStatus: Publication_Status_Type, createdAt: string, expireAt?: string | null, publishAt?: string | null, deleted: boolean, presentationType: Offer_Presentation_Type, presentationPriority: Offer_Presentation_Priority, fulfillmentCount: number, fulfillmentPriorityLevel?: number | null, visibleForCommandCenterFulfillment?: boolean | null, voucherCount: number, ageRestricted: boolean, customData?: object | object[] | null, externalId?: string | null, fundingSource?: Offer_Funding_Source | null, fundingSourceName?: string | null, shortDescription?: string | null, longDescription?: string | null, optionalAtPos?: boolean | null, stackable: boolean, allowedForManualVisibilityNotifications?: boolean | null, scanDataConfiguration?: { __typename: 'ScanDataConfiguration', description: string, discountAllocation: number, fundingSource: ScanDataFundingSource } | null, trackingConfig?: { __typename: 'TrackingConfig', trackingId: string, isActivityLogIncludedInAltriaDDM: boolean } | null, marketingContents: Array<{ __typename: 'MarketingContent', id: string, locale: string, title?: string | null, shortDescription?: string | null, longDescription?: string | null, imageUrl?: string | null, terms?: string | null, termsUrl?: string | null, customData?: object | object[] | null, disclaimer?: string | null, disclaimerUrl?: string | null, externalUrl?: string | null, surgeonGeneralsWarning?: string | null, triggeredMessageContent: { __typename: 'OfferTriggeredMessageContent', fulfillmentSms?: string | null, visibilitySms?: string | null, progressSms?: string | null }, receiptContent?: { __typename: 'ReceiptContent', shortDescription?: string | null, longDescription?: string | null } | null }>, limits: Array<{ __typename: 'LimitGlobalActivation', id: string, limit: number } | { __typename: 'LimitGlobalActivationInTime', id: string, limit: number, timePeriod: Limit_Time_Period } | { __typename: 'LimitGlobalAwardCount', id: string, limit: number } | { __typename: 'LimitGlobalAwardCountInTime', id: string, limit: number, timePeriod: Limit_Time_Period } | { __typename: 'LimitInTransactionAwardCount', id: string, limit: number } | { __typename: 'LimitInTransactionProgress', id: string, limit: number } | { __typename: 'LimitMembershipActivation', id: string, limit: number } | { __typename: 'LimitMembershipActivationInTime', id: string, limit: number, timePeriod: Limit_Time_Period } | { __typename: 'LimitMembershipAwardCount', id: string, limit: number } | { __typename: 'LimitMembershipAwardCountInTime', id: string, limit: number, timePeriod: Limit_Time_Period } | { __typename: 'LimitMembershipProgressInTime', id: string, limit: number, timePeriod: Limit_Time_Period } | { __typename: 'LimitMembershipTransactionCount', id: string, limit: number } | { __typename: 'LimitMembershipTransactionCountInTime', id: string, limit: number, timePeriod: Limit_Time_Period }>, constraints: Array<{ __typename: 'ConstraintDaysOfWeek', id: string, availableWeeklyOnDays: Array<Weekday>, startOfDayTimezone: string } | { __typename: 'ConstraintEmailRequired', id: string } | { __typename: 'ConstraintInAudience', id: string, audienceId: string } | { __typename: 'ConstraintInStoreOnly', id: string } | { __typename: 'ConstraintLocationInState', id: string, states: Array<string> } | { __typename: 'ConstraintOrderAheadOnly', id: string } | { __typename: 'ConstraintPaymentInstrument', id: string, paymentInstruments: Array<Payment_Instrument_Type>, paymentInstrumentEvaluationMethod: Payment_Instrument_Evaluation_Method } | { __typename: 'ConstraintPaymentMethod', id: string, paymentMethods: Array<Activate_Payment_Method>, paymentEvaluationMethod: Payment_Method_Evaluation_Method } | { __typename: 'ConstraintPreAuth', id: string } | { __typename: 'ConstraintPurchasableEligibility', id: string, ownershipCondition: Ownership_Condition, voucheredOffers: Array<{ __typename: 'Offer', id: string, name: string }> } | { __typename: 'ConstraintPurchaseThreshold', id: string, eligibleProductGroupIds: Array<string>, countProductsBy: Constraint_Purchase_Threshold_Counting_Attribute, threshold: number } | { __typename: 'ConstraintRequiresActivation', id: string, mustFulfillWithinDays?: number | null, allowMultipleFulfillmentsOnActivation: boolean } | { __typename: 'ConstraintRequiresTransactionVoucher', id: string, allowSingleOfferVoucherStacking?: boolean | null, breakageRefund?: boolean | null, breakagePointRounding?: Breakage_Point_Rounding | null } | { __typename: 'ConstraintRequiresVoucher', id: string } | { __typename: 'ConstraintRequiresVoucherAvailableForDiscount', id: string } | { __typename: 'ConstraintStoreLocation', id: string, evaluationMethod: Store_Location_Evaluation_Method, locations: Array<{ __typename: 'ActivateLocation', id: string, name?: string | null }> } | { __typename: 'ConstraintStoreLocationGroup', id: string, locationGroups: Array<{ __typename: 'LocationGroup', uuid: string, name: string }> } | { __typename: 'ConstraintSubBrand', id: string, subBrandUuids: Array<string> } | { __typename: 'ConstraintTimeOfDay', id: string, availableDailyEndingAtTime: string, availableDailyStartingAtTime: string, timezone: string }>, earningMechanism?: { __typename: 'EarningMechanismExternalFulfillment', id: string, externalFulfillmentAward?: { __typename: 'AwardPoints', points: number } | { __typename: 'AwardVouchers', voucherCount: number, voucherExpirationDays?: number | null, voucheredOffer: { __typename: 'Offer', id: string, name: string, fulfillmentCount: number, engagementType?: Offer_Engagement_Type | null } } | null } | { __typename: 'EarningMechanismLoyaltyEvent', id: string, loyaltyEventEventType: string, loyaltyEventAward?: { __typename: 'AwardExternalPoints', maximum?: number | null } | { __typename: 'AwardPoints', points: number } | { __typename: 'AwardVouchers', voucherCount: number, voucherExpirationDays?: number | null, voucheredOffer: { __typename: 'Offer', id: string, name: string, fulfillmentCount: number, engagementType?: Offer_Engagement_Type | null } } | null } | { __typename: 'EarningMechanismMembershipEvent', id: string, membershipEventEventType: Membership_Event_Type, membershipEventAward: { __typename: 'AwardPoints', points: number } | { __typename: 'AwardVouchers', voucherCount: number, voucherExpirationDays?: number | null, voucheredOffer: { __typename: 'Offer', id: string, name: string, fulfillmentCount: number, engagementType?: Offer_Engagement_Type | null } } } | { __typename: 'EarningMechanismPointSpend', id: string, pointCost: number, offerIsReturnable?: boolean | null, allowedForNewMember?: boolean | null, pointSpendAward: { __typename: 'AwardVouchers', voucherCount: number, voucherExpirationDays?: number | null, voucheredOffer: { __typename: 'Offer', id: string, name: string, fulfillmentCount: number, engagementType?: Offer_Engagement_Type | null } } } | { __typename: 'EarningMechanismProductDiscount', id: string, allowCarryOver: boolean, purchaseThresholdInt: number, productDiscountAward: { __typename: 'AwardBuyAndGet', discountThreshold: number, percentDiscount: number } | { __typename: 'AwardMoneyDiscount', awardPer: Award_Per_Counting_Strategy, moneyAmount: number, partialDiscount: boolean } | { __typename: 'AwardPriceOverride', maximumCost: number }, eligibleProductGroups: Array<{ __typename: 'ProductGroup', id: string, name: string }> } | { __typename: 'EarningMechanismProductPurchase', id: string, countProductsBy: Earning_Mechanism_Product_Counting_Attribute, purchaseThreshold: number, productPurchaseAward: { __typename: 'AwardExternal', provider: ExternalAwardProvider } | { __typename: 'AwardPoints', points: number } | { __typename: 'AwardVouchers', voucherCount: number, voucherExpirationDays?: number | null, voucheredOffer: { __typename: 'Offer', id: string, name: string, fulfillmentCount: number, engagementType?: Offer_Engagement_Type | null } }, eligibleProductGroups: Array<{ __typename: 'ProductGroup', id: string, name: string }> } | { __typename: 'EarningMechanismPromocodes', id: string, codesType: PromocodesOfferType, promocodes: Array<{ __typename: 'Promocode', id: string, code: any, status: PromocodeStatus, publicationStatus: PromocodePublicationStatus, description?: string | null, startDate: string, endDate?: string | null, stats?: { __typename: 'PromocodeUsageStats', redemptions: number, totalOfferRedemptions: number } | null, createdBy: { __typename: 'CommandCenterUser', email: string, name?: string | null } }>, promoCodeGroups: { __typename: 'PromoCodeGroupConnection', edges: Array<{ __typename: 'PromoCodeGroupEdge', node: { __typename: 'PromoCodeGroup', id: string, fileName: string, processingStatus: PromoCodeGroupProcessingStatus, codesStats: { __typename: 'PromoCodeGroupStats', createdCount: number, failedCount: number, totalCount: number } } }> }, award?: { __typename: 'AwardPoints', points: number } | { __typename: 'AwardVouchers', voucherCount: number, voucherExpirationDays?: number | null, voucheredOffer: { __typename: 'Offer', id: string, name: string, fulfillmentCount: number, engagementType?: Offer_Engagement_Type | null } } | null } | { __typename: 'EarningMechanismSpinWheelGame', id: string, purchasableOffer?: { __typename: 'Offer', id: string, name: string } | null, awards: Array<{ __typename: 'RandomAwardConfig', awardType: Random_Award_Type, limit: number, sequenceNumber: number, award?: { __typename: 'AwardPoints', points: number } | { __typename: 'AwardVouchers', voucherExpirationDays?: number | null, voucherCount: number, voucheredOffer: { __typename: 'Offer', id: string, name: string } } | null }> } | { __typename: 'EarningMechanismStoredValueDiscount', id: string, maxDiscountPerTransaction?: number | null, excludedProductGroups: Array<{ __typename: 'ProductGroup', id: string, name: string }> } | { __typename: 'EarningMechanismTotalEligiblePurchase', id: string, countProductsBy: Earning_Mechanism_Product_Counting_Attribute, roundCountedProducts: Earning_Mechanism_Product_Counting_Rounding_Strategy, totalEligiblePurchaseAward: { __typename: 'AwardPointsPer', points: number, rounding: Award_Points_Rounding_Strategy }, eligibleProductGroups: Array<{ __typename: 'ProductGroup', id: string, name: string }> } | { __typename: 'EarningMechanismTotalEligiblePurchaseOverTime', id: string, countProductsBy: Earning_Mechanism_Product_Counting_Attribute, accumulationThreshold: number, stayVisibleWhileInProgress?: boolean | null, hiddenUntilProgress: boolean, totalEligiblePurchaseOverTimeAward: { __typename: 'AwardPoints', points: number } | { __typename: 'AwardVouchers', voucherCount: number, voucherExpirationDays?: number | null, voucheredOffer: { __typename: 'Offer', id: string, name: string, fulfillmentCount: number, engagementType?: Offer_Engagement_Type | null } }, eligibleProductGroups: Array<{ __typename: 'ProductGroup', id: string, name: string }>, purchaseMemberProgress?: { __typename: 'PurchaseProgress', quantityPurchased: number, quantityRequired: number } | null } | { __typename: 'EarningMechanismTotalSpendOnTransaction', id: string, roundMoneyAmount: Earning_Mechanism_Product_Counting_Rounding_Strategy, totalSpendOnTransactionAward: { __typename: 'AwardPointsPer', points: number, rounding: Award_Points_Rounding_Strategy }, ineligibleProductGroups: Array<{ __typename: 'ProductGroup', id: string, name: string }> } | { __typename: 'EarningMechanismTotalSpendOverTime', id: string, accumulationThreshold: number, stayVisibleWhileInProgress?: boolean | null, totalSpendOverTimeAward: { __typename: 'AwardPoints', points: number } | { __typename: 'AwardVouchers', voucherCount: number, voucherExpirationDays?: number | null, voucheredOffer: { __typename: 'Offer', id: string, name: string, fulfillmentCount: number, engagementType?: Offer_Engagement_Type | null } }, ineligibleProductGroups: Array<{ __typename: 'ProductGroup', id: string, name: string }>, purchaseMemberProgress?: { __typename: 'PurchaseProgress', quantityPurchased: number, quantityRequired: number } | null } | { __typename: 'EarningMechanismTransactionDiscount', id: string, purchaseAmountThreshold: number, allowMultipleFulfillmentsPerProductGroupThreshold: boolean, transactionDiscountAward: { __typename: 'AwardTransactionMoneyDiscount', moneyDiscount: number } | { __typename: 'AwardTransactionPercentDiscount', percentDiscount: number }, ineligibleProductGroups: Array<{ __typename: 'ProductGroup', id: string, name: string }> } | { __typename: 'EarningMechanismVarietyDiscount', id: string, varietyDiscountAward: { __typename: 'AwardPriceOverride', maximumCost: number } | { __typename: 'AwardProductDiscount', percentDiscount: number, purchaseThreshold: number, eligibleProductGroups: Array<{ __typename: 'ProductGroup', id: string, name: string }> } | { __typename: 'AwardTransactionMoneyDiscount', moneyDiscount: number }, purchases: Array<{ __typename: 'EarningVarietyDiscountCriteria', purchaseThreshold: number, eligibleProductGroups: Array<{ __typename: 'ProductGroup', id: string, name: string }> }> } | { __typename: 'EarningMechanismVarietyPurchase', id: string, varietyPurchaseAward: { __typename: 'AwardPoints', points: number } | { __typename: 'AwardVouchers', voucherCount: number, voucherExpirationDays?: number | null, voucheredOffer: { __typename: 'Offer', id: string, name: string, fulfillmentCount: number, engagementType?: Offer_Engagement_Type | null } }, products: Array<{ __typename: 'EarningMechanismProductCriteria', id?: string | null, countProductsBy: Earning_Mechanism_Product_Counting_Attribute, purchaseThreshold: number, eligibleProductGroups: Array<{ __typename: 'ProductGroup', id: string, name: string }> }> } | { __typename: 'EarningMechanismVarietyPurchaseOverTime', id: string, preventDoublePunches?: boolean | null, stayVisibleWhileInProgress?: boolean | null, hiddenUntilProgress: boolean, varietyPurchaseOverTimeAward: { __typename: 'AwardPoints', points: number } | { __typename: 'AwardVouchers', voucherCount: number, voucherExpirationDays?: number | null, voucheredOffer: { __typename: 'Offer', id: string, name: string, fulfillmentCount: number, engagementType?: Offer_Engagement_Type | null } }, products: Array<{ __typename: 'EarningMechanismProductCriteria', id?: string | null, countProductsBy: Earning_Mechanism_Product_Counting_Attribute, purchaseThreshold: number, eligibleProductGroups: Array<{ __typename: 'ProductGroup', id: string, name: string }> }>, varietyMemberProgress: Array<{ __typename: 'VarietyProgress', quantityPurchased: number, quantityRequired: number }> } | { __typename: 'EarningMechanismVisits', id: string, visitThreshold: number, visitsAward: { __typename: 'AwardPoints', points: number } | { __typename: 'AwardVouchers', voucherCount: number, voucherExpirationDays?: number | null, voucheredOffer: { __typename: 'Offer', id: string, name: string, fulfillmentCount: number, engagementType?: Offer_Engagement_Type | null } }, visitsMemberProgress?: { __typename: 'VisitsProgress', visits: number, visitsRequired: number } | null } | null, triggerPreferences: { __typename: 'TriggerPreferences', triggerOnFulfillment: boolean, triggerOnVisibility: boolean, triggerOnProgress: boolean }, displayCategories: Array<{ __typename: 'DisplayCategory', id: string, name: string, rank: number, bannerIds?: Array<string> | null, categoryRestrictions?: Category_Restrictions | null, shouldLazyLoadBanners?: boolean | null }> };

export type OfferSelectItemFragment = { __typename: 'Offer', id: string, name: string, engagementType?: Offer_Engagement_Type | null };

export type OfferCreateMutationVariables = Exact<{
  input: OfferCreateInput;
}>;


export type OfferCreateMutation = { __typename: 'Mutation', offerCreate: { __typename: 'Offer', id: string, description?: string | null, name: string, engagementType?: Offer_Engagement_Type | null, category?: string | null, publicationStatus: Publication_Status_Type, createdAt: string, expireAt?: string | null, publishAt?: string | null, deleted: boolean, presentationType: Offer_Presentation_Type, presentationPriority: Offer_Presentation_Priority, fulfillmentCount: number, fulfillmentPriorityLevel?: number | null, visibleForCommandCenterFulfillment?: boolean | null, voucherCount: number, ageRestricted: boolean, customData?: object | object[] | null, externalId?: string | null, fundingSource?: Offer_Funding_Source | null, fundingSourceName?: string | null, shortDescription?: string | null, longDescription?: string | null, optionalAtPos?: boolean | null, stackable: boolean, displayForOrderAhead?: boolean | null, allowedForManualVisibilityNotifications?: boolean | null, scanDataConfiguration?: { __typename: 'ScanDataConfiguration', description: string, discountAllocation: number, fundingSource: ScanDataFundingSource } | null, trackingConfig?: { __typename: 'TrackingConfig', trackingId: string, isActivityLogIncludedInAltriaDDM: boolean } | null, campaign?: { __typename: 'Campaign', uuid: string, name: string } | null, marketingContents: Array<{ __typename: 'MarketingContent', id: string, locale: string, title?: string | null, shortDescription?: string | null, longDescription?: string | null, imageUrl?: string | null, terms?: string | null, termsUrl?: string | null, customData?: object | object[] | null, disclaimer?: string | null, disclaimerUrl?: string | null, externalUrl?: string | null, surgeonGeneralsWarning?: string | null, triggeredMessageContent: { __typename: 'OfferTriggeredMessageContent', fulfillmentSms?: string | null, visibilitySms?: string | null, progressSms?: string | null }, receiptContent?: { __typename: 'ReceiptContent', shortDescription?: string | null, longDescription?: string | null } | null }>, limits: Array<{ __typename: 'LimitGlobalActivation', id: string, limit: number } | { __typename: 'LimitGlobalActivationInTime', id: string, limit: number, timePeriod: Limit_Time_Period } | { __typename: 'LimitGlobalAwardCount', id: string, limit: number } | { __typename: 'LimitGlobalAwardCountInTime', id: string, limit: number, timePeriod: Limit_Time_Period } | { __typename: 'LimitInTransactionAwardCount', id: string, limit: number } | { __typename: 'LimitInTransactionProgress', id: string, limit: number } | { __typename: 'LimitMembershipActivation', id: string, limit: number } | { __typename: 'LimitMembershipActivationInTime', id: string, limit: number, timePeriod: Limit_Time_Period } | { __typename: 'LimitMembershipAwardCount', id: string, limit: number } | { __typename: 'LimitMembershipAwardCountInTime', id: string, limit: number, timePeriod: Limit_Time_Period } | { __typename: 'LimitMembershipProgressInTime', id: string, limit: number, timePeriod: Limit_Time_Period } | { __typename: 'LimitMembershipTransactionCount', id: string, limit: number } | { __typename: 'LimitMembershipTransactionCountInTime', id: string, limit: number, timePeriod: Limit_Time_Period }>, constraints: Array<{ __typename: 'ConstraintDaysOfWeek', id: string, availableWeeklyOnDays: Array<Weekday>, startOfDayTimezone: string } | { __typename: 'ConstraintEmailRequired', id: string } | { __typename: 'ConstraintInAudience', id: string, audienceId: string } | { __typename: 'ConstraintInStoreOnly', id: string } | { __typename: 'ConstraintLocationInState', id: string, states: Array<string> } | { __typename: 'ConstraintOrderAheadOnly', id: string } | { __typename: 'ConstraintPaymentInstrument', id: string, paymentInstruments: Array<Payment_Instrument_Type>, paymentInstrumentEvaluationMethod: Payment_Instrument_Evaluation_Method } | { __typename: 'ConstraintPaymentMethod', id: string, paymentMethods: Array<Activate_Payment_Method>, paymentEvaluationMethod: Payment_Method_Evaluation_Method } | { __typename: 'ConstraintPreAuth', id: string } | { __typename: 'ConstraintPurchasableEligibility', id: string, ownershipCondition: Ownership_Condition, voucheredOffers: Array<{ __typename: 'Offer', id: string, name: string }> } | { __typename: 'ConstraintPurchaseThreshold', id: string, eligibleProductGroupIds: Array<string>, countProductsBy: Constraint_Purchase_Threshold_Counting_Attribute, threshold: number } | { __typename: 'ConstraintRequiresActivation', id: string, mustFulfillWithinDays?: number | null, allowMultipleFulfillmentsOnActivation: boolean } | { __typename: 'ConstraintRequiresTransactionVoucher', id: string, allowSingleOfferVoucherStacking?: boolean | null, breakageRefund?: boolean | null, breakagePointRounding?: Breakage_Point_Rounding | null } | { __typename: 'ConstraintRequiresVoucher', id: string } | { __typename: 'ConstraintRequiresVoucherAvailableForDiscount', id: string } | { __typename: 'ConstraintStoreLocation', id: string, evaluationMethod: Store_Location_Evaluation_Method, locations: Array<{ __typename: 'ActivateLocation', id: string, name?: string | null }> } | { __typename: 'ConstraintStoreLocationGroup', id: string, locationGroups: Array<{ __typename: 'LocationGroup', uuid: string, name: string }> } | { __typename: 'ConstraintSubBrand', id: string, subBrandUuids: Array<string> } | { __typename: 'ConstraintTimeOfDay', id: string, availableDailyEndingAtTime: string, availableDailyStartingAtTime: string, timezone: string }>, earningMechanism?: { __typename: 'EarningMechanismExternalFulfillment', id: string, externalFulfillmentAward?: { __typename: 'AwardPoints', points: number } | { __typename: 'AwardVouchers', voucherCount: number, voucherExpirationDays?: number | null, voucheredOffer: { __typename: 'Offer', id: string, name: string, fulfillmentCount: number, engagementType?: Offer_Engagement_Type | null } } | null } | { __typename: 'EarningMechanismLoyaltyEvent', id: string, loyaltyEventEventType: string, loyaltyEventAward?: { __typename: 'AwardExternalPoints', maximum?: number | null } | { __typename: 'AwardPoints', points: number } | { __typename: 'AwardVouchers', voucherCount: number, voucherExpirationDays?: number | null, voucheredOffer: { __typename: 'Offer', id: string, name: string, fulfillmentCount: number, engagementType?: Offer_Engagement_Type | null } } | null } | { __typename: 'EarningMechanismMembershipEvent', id: string, membershipEventEventType: Membership_Event_Type, membershipEventAward: { __typename: 'AwardPoints', points: number } | { __typename: 'AwardVouchers', voucherCount: number, voucherExpirationDays?: number | null, voucheredOffer: { __typename: 'Offer', id: string, name: string, fulfillmentCount: number, engagementType?: Offer_Engagement_Type | null } } } | { __typename: 'EarningMechanismPointSpend', id: string, pointCost: number, offerIsReturnable?: boolean | null, allowedForNewMember?: boolean | null, pointSpendAward: { __typename: 'AwardVouchers', voucherCount: number, voucherExpirationDays?: number | null, voucheredOffer: { __typename: 'Offer', id: string, name: string, fulfillmentCount: number, engagementType?: Offer_Engagement_Type | null } } } | { __typename: 'EarningMechanismProductDiscount', id: string, allowCarryOver: boolean, purchaseThresholdInt: number, productDiscountAward: { __typename: 'AwardBuyAndGet', discountThreshold: number, percentDiscount: number } | { __typename: 'AwardMoneyDiscount', awardPer: Award_Per_Counting_Strategy, moneyAmount: number, partialDiscount: boolean } | { __typename: 'AwardPriceOverride', maximumCost: number }, eligibleProductGroups: Array<{ __typename: 'ProductGroup', id: string, name: string }> } | { __typename: 'EarningMechanismProductPurchase', id: string, countProductsBy: Earning_Mechanism_Product_Counting_Attribute, purchaseThreshold: number, productPurchaseAward: { __typename: 'AwardExternal', provider: ExternalAwardProvider } | { __typename: 'AwardPoints', points: number } | { __typename: 'AwardVouchers', voucherCount: number, voucherExpirationDays?: number | null, voucheredOffer: { __typename: 'Offer', id: string, name: string, fulfillmentCount: number, engagementType?: Offer_Engagement_Type | null } }, eligibleProductGroups: Array<{ __typename: 'ProductGroup', id: string, name: string }> } | { __typename: 'EarningMechanismPromocodes', id: string, codesType: PromocodesOfferType, promocodes: Array<{ __typename: 'Promocode', id: string, code: any, status: PromocodeStatus, publicationStatus: PromocodePublicationStatus, description?: string | null, startDate: string, endDate?: string | null, stats?: { __typename: 'PromocodeUsageStats', redemptions: number, totalOfferRedemptions: number } | null, createdBy: { __typename: 'CommandCenterUser', email: string, name?: string | null } }>, promoCodeGroups: { __typename: 'PromoCodeGroupConnection', edges: Array<{ __typename: 'PromoCodeGroupEdge', node: { __typename: 'PromoCodeGroup', id: string, fileName: string, processingStatus: PromoCodeGroupProcessingStatus, codesStats: { __typename: 'PromoCodeGroupStats', createdCount: number, failedCount: number, totalCount: number } } }> }, award?: { __typename: 'AwardPoints', points: number } | { __typename: 'AwardVouchers', voucherCount: number, voucherExpirationDays?: number | null, voucheredOffer: { __typename: 'Offer', id: string, name: string, fulfillmentCount: number, engagementType?: Offer_Engagement_Type | null } } | null } | { __typename: 'EarningMechanismSpinWheelGame', id: string, purchasableOffer?: { __typename: 'Offer', id: string, name: string } | null, awards: Array<{ __typename: 'RandomAwardConfig', awardType: Random_Award_Type, limit: number, sequenceNumber: number, award?: { __typename: 'AwardPoints', points: number } | { __typename: 'AwardVouchers', voucherExpirationDays?: number | null, voucherCount: number, voucheredOffer: { __typename: 'Offer', id: string, name: string } } | null }> } | { __typename: 'EarningMechanismStoredValueDiscount', id: string, maxDiscountPerTransaction?: number | null, excludedProductGroups: Array<{ __typename: 'ProductGroup', id: string, name: string }> } | { __typename: 'EarningMechanismTotalEligiblePurchase', id: string, countProductsBy: Earning_Mechanism_Product_Counting_Attribute, roundCountedProducts: Earning_Mechanism_Product_Counting_Rounding_Strategy, totalEligiblePurchaseAward: { __typename: 'AwardPointsPer', points: number, rounding: Award_Points_Rounding_Strategy }, eligibleProductGroups: Array<{ __typename: 'ProductGroup', id: string, name: string }> } | { __typename: 'EarningMechanismTotalEligiblePurchaseOverTime', id: string, countProductsBy: Earning_Mechanism_Product_Counting_Attribute, accumulationThreshold: number, stayVisibleWhileInProgress?: boolean | null, hiddenUntilProgress: boolean, totalEligiblePurchaseOverTimeAward: { __typename: 'AwardPoints', points: number } | { __typename: 'AwardVouchers', voucherCount: number, voucherExpirationDays?: number | null, voucheredOffer: { __typename: 'Offer', id: string, name: string, fulfillmentCount: number, engagementType?: Offer_Engagement_Type | null } }, eligibleProductGroups: Array<{ __typename: 'ProductGroup', id: string, name: string }>, purchaseMemberProgress?: { __typename: 'PurchaseProgress', quantityPurchased: number, quantityRequired: number } | null } | { __typename: 'EarningMechanismTotalSpendOnTransaction', id: string, roundMoneyAmount: Earning_Mechanism_Product_Counting_Rounding_Strategy, totalSpendOnTransactionAward: { __typename: 'AwardPointsPer', points: number, rounding: Award_Points_Rounding_Strategy }, ineligibleProductGroups: Array<{ __typename: 'ProductGroup', id: string, name: string }> } | { __typename: 'EarningMechanismTotalSpendOverTime', id: string, accumulationThreshold: number, stayVisibleWhileInProgress?: boolean | null, totalSpendOverTimeAward: { __typename: 'AwardPoints', points: number } | { __typename: 'AwardVouchers', voucherCount: number, voucherExpirationDays?: number | null, voucheredOffer: { __typename: 'Offer', id: string, name: string, fulfillmentCount: number, engagementType?: Offer_Engagement_Type | null } }, ineligibleProductGroups: Array<{ __typename: 'ProductGroup', id: string, name: string }>, purchaseMemberProgress?: { __typename: 'PurchaseProgress', quantityPurchased: number, quantityRequired: number } | null } | { __typename: 'EarningMechanismTransactionDiscount', id: string, purchaseAmountThreshold: number, allowMultipleFulfillmentsPerProductGroupThreshold: boolean, transactionDiscountAward: { __typename: 'AwardTransactionMoneyDiscount', moneyDiscount: number } | { __typename: 'AwardTransactionPercentDiscount', percentDiscount: number }, ineligibleProductGroups: Array<{ __typename: 'ProductGroup', id: string, name: string }> } | { __typename: 'EarningMechanismVarietyDiscount', id: string, varietyDiscountAward: { __typename: 'AwardPriceOverride', maximumCost: number } | { __typename: 'AwardProductDiscount', percentDiscount: number, purchaseThreshold: number, eligibleProductGroups: Array<{ __typename: 'ProductGroup', id: string, name: string }> } | { __typename: 'AwardTransactionMoneyDiscount', moneyDiscount: number }, purchases: Array<{ __typename: 'EarningVarietyDiscountCriteria', purchaseThreshold: number, eligibleProductGroups: Array<{ __typename: 'ProductGroup', id: string, name: string }> }> } | { __typename: 'EarningMechanismVarietyPurchase', id: string, varietyPurchaseAward: { __typename: 'AwardPoints', points: number } | { __typename: 'AwardVouchers', voucherCount: number, voucherExpirationDays?: number | null, voucheredOffer: { __typename: 'Offer', id: string, name: string, fulfillmentCount: number, engagementType?: Offer_Engagement_Type | null } }, products: Array<{ __typename: 'EarningMechanismProductCriteria', id?: string | null, countProductsBy: Earning_Mechanism_Product_Counting_Attribute, purchaseThreshold: number, eligibleProductGroups: Array<{ __typename: 'ProductGroup', id: string, name: string }> }> } | { __typename: 'EarningMechanismVarietyPurchaseOverTime', id: string, preventDoublePunches?: boolean | null, stayVisibleWhileInProgress?: boolean | null, hiddenUntilProgress: boolean, varietyPurchaseOverTimeAward: { __typename: 'AwardPoints', points: number } | { __typename: 'AwardVouchers', voucherCount: number, voucherExpirationDays?: number | null, voucheredOffer: { __typename: 'Offer', id: string, name: string, fulfillmentCount: number, engagementType?: Offer_Engagement_Type | null } }, products: Array<{ __typename: 'EarningMechanismProductCriteria', id?: string | null, countProductsBy: Earning_Mechanism_Product_Counting_Attribute, purchaseThreshold: number, eligibleProductGroups: Array<{ __typename: 'ProductGroup', id: string, name: string }> }>, varietyMemberProgress: Array<{ __typename: 'VarietyProgress', quantityPurchased: number, quantityRequired: number }> } | { __typename: 'EarningMechanismVisits', id: string, visitThreshold: number, visitsAward: { __typename: 'AwardPoints', points: number } | { __typename: 'AwardVouchers', voucherCount: number, voucherExpirationDays?: number | null, voucheredOffer: { __typename: 'Offer', id: string, name: string, fulfillmentCount: number, engagementType?: Offer_Engagement_Type | null } }, visitsMemberProgress?: { __typename: 'VisitsProgress', visits: number, visitsRequired: number } | null } | null, triggerPreferences: { __typename: 'TriggerPreferences', triggerOnFulfillment: boolean, triggerOnVisibility: boolean, triggerOnProgress: boolean }, displayCategories: Array<{ __typename: 'DisplayCategory', id: string, name: string, rank: number, bannerIds?: Array<string> | null, categoryRestrictions?: Category_Restrictions | null, shouldLazyLoadBanners?: boolean | null }> } };

export type OfferUpdateMutationVariables = Exact<{
  input: OfferUpdateInput;
}>;


export type OfferUpdateMutation = { __typename: 'Mutation', offerUpdate: { __typename: 'Offer', id: string, description?: string | null, name: string, engagementType?: Offer_Engagement_Type | null, category?: string | null, publicationStatus: Publication_Status_Type, createdAt: string, expireAt?: string | null, publishAt?: string | null, deleted: boolean, presentationType: Offer_Presentation_Type, presentationPriority: Offer_Presentation_Priority, fulfillmentCount: number, fulfillmentPriorityLevel?: number | null, visibleForCommandCenterFulfillment?: boolean | null, voucherCount: number, ageRestricted: boolean, customData?: object | object[] | null, externalId?: string | null, fundingSource?: Offer_Funding_Source | null, fundingSourceName?: string | null, shortDescription?: string | null, longDescription?: string | null, optionalAtPos?: boolean | null, stackable: boolean, displayForOrderAhead?: boolean | null, allowedForManualVisibilityNotifications?: boolean | null, scanDataConfiguration?: { __typename: 'ScanDataConfiguration', description: string, discountAllocation: number, fundingSource: ScanDataFundingSource } | null, trackingConfig?: { __typename: 'TrackingConfig', trackingId: string, isActivityLogIncludedInAltriaDDM: boolean } | null, campaign?: { __typename: 'Campaign', uuid: string, name: string } | null, marketingContents: Array<{ __typename: 'MarketingContent', id: string, locale: string, title?: string | null, shortDescription?: string | null, longDescription?: string | null, imageUrl?: string | null, terms?: string | null, termsUrl?: string | null, customData?: object | object[] | null, disclaimer?: string | null, disclaimerUrl?: string | null, externalUrl?: string | null, surgeonGeneralsWarning?: string | null, triggeredMessageContent: { __typename: 'OfferTriggeredMessageContent', fulfillmentSms?: string | null, visibilitySms?: string | null, progressSms?: string | null }, receiptContent?: { __typename: 'ReceiptContent', shortDescription?: string | null, longDescription?: string | null } | null }>, limits: Array<{ __typename: 'LimitGlobalActivation', id: string, limit: number } | { __typename: 'LimitGlobalActivationInTime', id: string, limit: number, timePeriod: Limit_Time_Period } | { __typename: 'LimitGlobalAwardCount', id: string, limit: number } | { __typename: 'LimitGlobalAwardCountInTime', id: string, limit: number, timePeriod: Limit_Time_Period } | { __typename: 'LimitInTransactionAwardCount', id: string, limit: number } | { __typename: 'LimitInTransactionProgress', id: string, limit: number } | { __typename: 'LimitMembershipActivation', id: string, limit: number } | { __typename: 'LimitMembershipActivationInTime', id: string, limit: number, timePeriod: Limit_Time_Period } | { __typename: 'LimitMembershipAwardCount', id: string, limit: number } | { __typename: 'LimitMembershipAwardCountInTime', id: string, limit: number, timePeriod: Limit_Time_Period } | { __typename: 'LimitMembershipProgressInTime', id: string, limit: number, timePeriod: Limit_Time_Period } | { __typename: 'LimitMembershipTransactionCount', id: string, limit: number } | { __typename: 'LimitMembershipTransactionCountInTime', id: string, limit: number, timePeriod: Limit_Time_Period }>, constraints: Array<{ __typename: 'ConstraintDaysOfWeek', id: string, availableWeeklyOnDays: Array<Weekday>, startOfDayTimezone: string } | { __typename: 'ConstraintEmailRequired', id: string } | { __typename: 'ConstraintInAudience', id: string, audienceId: string } | { __typename: 'ConstraintInStoreOnly', id: string } | { __typename: 'ConstraintLocationInState', id: string, states: Array<string> } | { __typename: 'ConstraintOrderAheadOnly', id: string } | { __typename: 'ConstraintPaymentInstrument', id: string, paymentInstruments: Array<Payment_Instrument_Type>, paymentInstrumentEvaluationMethod: Payment_Instrument_Evaluation_Method } | { __typename: 'ConstraintPaymentMethod', id: string, paymentMethods: Array<Activate_Payment_Method>, paymentEvaluationMethod: Payment_Method_Evaluation_Method } | { __typename: 'ConstraintPreAuth', id: string } | { __typename: 'ConstraintPurchasableEligibility', id: string, ownershipCondition: Ownership_Condition, voucheredOffers: Array<{ __typename: 'Offer', id: string, name: string }> } | { __typename: 'ConstraintPurchaseThreshold', id: string, eligibleProductGroupIds: Array<string>, countProductsBy: Constraint_Purchase_Threshold_Counting_Attribute, threshold: number } | { __typename: 'ConstraintRequiresActivation', id: string, mustFulfillWithinDays?: number | null, allowMultipleFulfillmentsOnActivation: boolean } | { __typename: 'ConstraintRequiresTransactionVoucher', id: string, allowSingleOfferVoucherStacking?: boolean | null, breakageRefund?: boolean | null, breakagePointRounding?: Breakage_Point_Rounding | null } | { __typename: 'ConstraintRequiresVoucher', id: string } | { __typename: 'ConstraintRequiresVoucherAvailableForDiscount', id: string } | { __typename: 'ConstraintStoreLocation', id: string, evaluationMethod: Store_Location_Evaluation_Method, locations: Array<{ __typename: 'ActivateLocation', id: string, name?: string | null }> } | { __typename: 'ConstraintStoreLocationGroup', id: string, locationGroups: Array<{ __typename: 'LocationGroup', uuid: string, name: string }> } | { __typename: 'ConstraintSubBrand', id: string, subBrandUuids: Array<string> } | { __typename: 'ConstraintTimeOfDay', id: string, availableDailyEndingAtTime: string, availableDailyStartingAtTime: string, timezone: string }>, earningMechanism?: { __typename: 'EarningMechanismExternalFulfillment', id: string, externalFulfillmentAward?: { __typename: 'AwardPoints', points: number } | { __typename: 'AwardVouchers', voucherCount: number, voucherExpirationDays?: number | null, voucheredOffer: { __typename: 'Offer', id: string, name: string, fulfillmentCount: number, engagementType?: Offer_Engagement_Type | null } } | null } | { __typename: 'EarningMechanismLoyaltyEvent', id: string, loyaltyEventEventType: string, loyaltyEventAward?: { __typename: 'AwardExternalPoints', maximum?: number | null } | { __typename: 'AwardPoints', points: number } | { __typename: 'AwardVouchers', voucherCount: number, voucherExpirationDays?: number | null, voucheredOffer: { __typename: 'Offer', id: string, name: string, fulfillmentCount: number, engagementType?: Offer_Engagement_Type | null } } | null } | { __typename: 'EarningMechanismMembershipEvent', id: string, membershipEventEventType: Membership_Event_Type, membershipEventAward: { __typename: 'AwardPoints', points: number } | { __typename: 'AwardVouchers', voucherCount: number, voucherExpirationDays?: number | null, voucheredOffer: { __typename: 'Offer', id: string, name: string, fulfillmentCount: number, engagementType?: Offer_Engagement_Type | null } } } | { __typename: 'EarningMechanismPointSpend', id: string, pointCost: number, offerIsReturnable?: boolean | null, allowedForNewMember?: boolean | null, pointSpendAward: { __typename: 'AwardVouchers', voucherCount: number, voucherExpirationDays?: number | null, voucheredOffer: { __typename: 'Offer', id: string, name: string, fulfillmentCount: number, engagementType?: Offer_Engagement_Type | null } } } | { __typename: 'EarningMechanismProductDiscount', id: string, allowCarryOver: boolean, purchaseThresholdInt: number, productDiscountAward: { __typename: 'AwardBuyAndGet', discountThreshold: number, percentDiscount: number } | { __typename: 'AwardMoneyDiscount', awardPer: Award_Per_Counting_Strategy, moneyAmount: number, partialDiscount: boolean } | { __typename: 'AwardPriceOverride', maximumCost: number }, eligibleProductGroups: Array<{ __typename: 'ProductGroup', id: string, name: string }> } | { __typename: 'EarningMechanismProductPurchase', id: string, countProductsBy: Earning_Mechanism_Product_Counting_Attribute, purchaseThreshold: number, productPurchaseAward: { __typename: 'AwardExternal', provider: ExternalAwardProvider } | { __typename: 'AwardPoints', points: number } | { __typename: 'AwardVouchers', voucherCount: number, voucherExpirationDays?: number | null, voucheredOffer: { __typename: 'Offer', id: string, name: string, fulfillmentCount: number, engagementType?: Offer_Engagement_Type | null } }, eligibleProductGroups: Array<{ __typename: 'ProductGroup', id: string, name: string }> } | { __typename: 'EarningMechanismPromocodes', id: string, codesType: PromocodesOfferType, promocodes: Array<{ __typename: 'Promocode', id: string, code: any, status: PromocodeStatus, publicationStatus: PromocodePublicationStatus, description?: string | null, startDate: string, endDate?: string | null, stats?: { __typename: 'PromocodeUsageStats', redemptions: number, totalOfferRedemptions: number } | null, createdBy: { __typename: 'CommandCenterUser', email: string, name?: string | null } }>, promoCodeGroups: { __typename: 'PromoCodeGroupConnection', edges: Array<{ __typename: 'PromoCodeGroupEdge', node: { __typename: 'PromoCodeGroup', id: string, fileName: string, processingStatus: PromoCodeGroupProcessingStatus, codesStats: { __typename: 'PromoCodeGroupStats', createdCount: number, failedCount: number, totalCount: number } } }> }, award?: { __typename: 'AwardPoints', points: number } | { __typename: 'AwardVouchers', voucherCount: number, voucherExpirationDays?: number | null, voucheredOffer: { __typename: 'Offer', id: string, name: string, fulfillmentCount: number, engagementType?: Offer_Engagement_Type | null } } | null } | { __typename: 'EarningMechanismSpinWheelGame', id: string, purchasableOffer?: { __typename: 'Offer', id: string, name: string } | null, awards: Array<{ __typename: 'RandomAwardConfig', awardType: Random_Award_Type, limit: number, sequenceNumber: number, award?: { __typename: 'AwardPoints', points: number } | { __typename: 'AwardVouchers', voucherExpirationDays?: number | null, voucherCount: number, voucheredOffer: { __typename: 'Offer', id: string, name: string } } | null }> } | { __typename: 'EarningMechanismStoredValueDiscount', id: string, maxDiscountPerTransaction?: number | null, excludedProductGroups: Array<{ __typename: 'ProductGroup', id: string, name: string }> } | { __typename: 'EarningMechanismTotalEligiblePurchase', id: string, countProductsBy: Earning_Mechanism_Product_Counting_Attribute, roundCountedProducts: Earning_Mechanism_Product_Counting_Rounding_Strategy, totalEligiblePurchaseAward: { __typename: 'AwardPointsPer', points: number, rounding: Award_Points_Rounding_Strategy }, eligibleProductGroups: Array<{ __typename: 'ProductGroup', id: string, name: string }> } | { __typename: 'EarningMechanismTotalEligiblePurchaseOverTime', id: string, countProductsBy: Earning_Mechanism_Product_Counting_Attribute, accumulationThreshold: number, stayVisibleWhileInProgress?: boolean | null, hiddenUntilProgress: boolean, totalEligiblePurchaseOverTimeAward: { __typename: 'AwardPoints', points: number } | { __typename: 'AwardVouchers', voucherCount: number, voucherExpirationDays?: number | null, voucheredOffer: { __typename: 'Offer', id: string, name: string, fulfillmentCount: number, engagementType?: Offer_Engagement_Type | null } }, eligibleProductGroups: Array<{ __typename: 'ProductGroup', id: string, name: string }>, purchaseMemberProgress?: { __typename: 'PurchaseProgress', quantityPurchased: number, quantityRequired: number } | null } | { __typename: 'EarningMechanismTotalSpendOnTransaction', id: string, roundMoneyAmount: Earning_Mechanism_Product_Counting_Rounding_Strategy, totalSpendOnTransactionAward: { __typename: 'AwardPointsPer', points: number, rounding: Award_Points_Rounding_Strategy }, ineligibleProductGroups: Array<{ __typename: 'ProductGroup', id: string, name: string }> } | { __typename: 'EarningMechanismTotalSpendOverTime', id: string, accumulationThreshold: number, stayVisibleWhileInProgress?: boolean | null, totalSpendOverTimeAward: { __typename: 'AwardPoints', points: number } | { __typename: 'AwardVouchers', voucherCount: number, voucherExpirationDays?: number | null, voucheredOffer: { __typename: 'Offer', id: string, name: string, fulfillmentCount: number, engagementType?: Offer_Engagement_Type | null } }, ineligibleProductGroups: Array<{ __typename: 'ProductGroup', id: string, name: string }>, purchaseMemberProgress?: { __typename: 'PurchaseProgress', quantityPurchased: number, quantityRequired: number } | null } | { __typename: 'EarningMechanismTransactionDiscount', id: string, purchaseAmountThreshold: number, allowMultipleFulfillmentsPerProductGroupThreshold: boolean, transactionDiscountAward: { __typename: 'AwardTransactionMoneyDiscount', moneyDiscount: number } | { __typename: 'AwardTransactionPercentDiscount', percentDiscount: number }, ineligibleProductGroups: Array<{ __typename: 'ProductGroup', id: string, name: string }> } | { __typename: 'EarningMechanismVarietyDiscount', id: string, varietyDiscountAward: { __typename: 'AwardPriceOverride', maximumCost: number } | { __typename: 'AwardProductDiscount', percentDiscount: number, purchaseThreshold: number, eligibleProductGroups: Array<{ __typename: 'ProductGroup', id: string, name: string }> } | { __typename: 'AwardTransactionMoneyDiscount', moneyDiscount: number }, purchases: Array<{ __typename: 'EarningVarietyDiscountCriteria', purchaseThreshold: number, eligibleProductGroups: Array<{ __typename: 'ProductGroup', id: string, name: string }> }> } | { __typename: 'EarningMechanismVarietyPurchase', id: string, varietyPurchaseAward: { __typename: 'AwardPoints', points: number } | { __typename: 'AwardVouchers', voucherCount: number, voucherExpirationDays?: number | null, voucheredOffer: { __typename: 'Offer', id: string, name: string, fulfillmentCount: number, engagementType?: Offer_Engagement_Type | null } }, products: Array<{ __typename: 'EarningMechanismProductCriteria', id?: string | null, countProductsBy: Earning_Mechanism_Product_Counting_Attribute, purchaseThreshold: number, eligibleProductGroups: Array<{ __typename: 'ProductGroup', id: string, name: string }> }> } | { __typename: 'EarningMechanismVarietyPurchaseOverTime', id: string, preventDoublePunches?: boolean | null, stayVisibleWhileInProgress?: boolean | null, hiddenUntilProgress: boolean, varietyPurchaseOverTimeAward: { __typename: 'AwardPoints', points: number } | { __typename: 'AwardVouchers', voucherCount: number, voucherExpirationDays?: number | null, voucheredOffer: { __typename: 'Offer', id: string, name: string, fulfillmentCount: number, engagementType?: Offer_Engagement_Type | null } }, products: Array<{ __typename: 'EarningMechanismProductCriteria', id?: string | null, countProductsBy: Earning_Mechanism_Product_Counting_Attribute, purchaseThreshold: number, eligibleProductGroups: Array<{ __typename: 'ProductGroup', id: string, name: string }> }>, varietyMemberProgress: Array<{ __typename: 'VarietyProgress', quantityPurchased: number, quantityRequired: number }> } | { __typename: 'EarningMechanismVisits', id: string, visitThreshold: number, visitsAward: { __typename: 'AwardPoints', points: number } | { __typename: 'AwardVouchers', voucherCount: number, voucherExpirationDays?: number | null, voucheredOffer: { __typename: 'Offer', id: string, name: string, fulfillmentCount: number, engagementType?: Offer_Engagement_Type | null } }, visitsMemberProgress?: { __typename: 'VisitsProgress', visits: number, visitsRequired: number } | null } | null, triggerPreferences: { __typename: 'TriggerPreferences', triggerOnFulfillment: boolean, triggerOnVisibility: boolean, triggerOnProgress: boolean }, displayCategories: Array<{ __typename: 'DisplayCategory', id: string, name: string, rank: number, bannerIds?: Array<string> | null, categoryRestrictions?: Category_Restrictions | null, shouldLazyLoadBanners?: boolean | null }> } };

export type OfferDeleteMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type OfferDeleteMutation = { __typename: 'Mutation', offerDelete: boolean };

export type OfferDisplayCategoriesCreateOrUpdateMutationVariables = Exact<{
  input: OfferDisplayCategoriesInput;
}>;


export type OfferDisplayCategoriesCreateOrUpdateMutation = { __typename: 'Mutation', offerDisplayCategoriesCreateOrUpdate: { __typename: 'Offer', id: string, description?: string | null, name: string, engagementType?: Offer_Engagement_Type | null, category?: string | null, publicationStatus: Publication_Status_Type, createdAt: string, expireAt?: string | null, publishAt?: string | null, deleted: boolean, presentationType: Offer_Presentation_Type, presentationPriority: Offer_Presentation_Priority, fulfillmentCount: number, fulfillmentPriorityLevel?: number | null, visibleForCommandCenterFulfillment?: boolean | null, voucherCount: number, ageRestricted: boolean, customData?: object | object[] | null, externalId?: string | null, fundingSource?: Offer_Funding_Source | null, fundingSourceName?: string | null, shortDescription?: string | null, longDescription?: string | null, optionalAtPos?: boolean | null, stackable: boolean, displayForOrderAhead?: boolean | null, allowedForManualVisibilityNotifications?: boolean | null, scanDataConfiguration?: { __typename: 'ScanDataConfiguration', description: string, discountAllocation: number, fundingSource: ScanDataFundingSource } | null, trackingConfig?: { __typename: 'TrackingConfig', trackingId: string, isActivityLogIncludedInAltriaDDM: boolean } | null, campaign?: { __typename: 'Campaign', uuid: string, name: string } | null, marketingContents: Array<{ __typename: 'MarketingContent', id: string, locale: string, title?: string | null, shortDescription?: string | null, longDescription?: string | null, imageUrl?: string | null, terms?: string | null, termsUrl?: string | null, customData?: object | object[] | null, disclaimer?: string | null, disclaimerUrl?: string | null, externalUrl?: string | null, surgeonGeneralsWarning?: string | null, triggeredMessageContent: { __typename: 'OfferTriggeredMessageContent', fulfillmentSms?: string | null, visibilitySms?: string | null, progressSms?: string | null }, receiptContent?: { __typename: 'ReceiptContent', shortDescription?: string | null, longDescription?: string | null } | null }>, limits: Array<{ __typename: 'LimitGlobalActivation', id: string, limit: number } | { __typename: 'LimitGlobalActivationInTime', id: string, limit: number, timePeriod: Limit_Time_Period } | { __typename: 'LimitGlobalAwardCount', id: string, limit: number } | { __typename: 'LimitGlobalAwardCountInTime', id: string, limit: number, timePeriod: Limit_Time_Period } | { __typename: 'LimitInTransactionAwardCount', id: string, limit: number } | { __typename: 'LimitInTransactionProgress', id: string, limit: number } | { __typename: 'LimitMembershipActivation', id: string, limit: number } | { __typename: 'LimitMembershipActivationInTime', id: string, limit: number, timePeriod: Limit_Time_Period } | { __typename: 'LimitMembershipAwardCount', id: string, limit: number } | { __typename: 'LimitMembershipAwardCountInTime', id: string, limit: number, timePeriod: Limit_Time_Period } | { __typename: 'LimitMembershipProgressInTime', id: string, limit: number, timePeriod: Limit_Time_Period } | { __typename: 'LimitMembershipTransactionCount', id: string, limit: number } | { __typename: 'LimitMembershipTransactionCountInTime', id: string, limit: number, timePeriod: Limit_Time_Period }>, constraints: Array<{ __typename: 'ConstraintDaysOfWeek', id: string, availableWeeklyOnDays: Array<Weekday>, startOfDayTimezone: string } | { __typename: 'ConstraintEmailRequired', id: string } | { __typename: 'ConstraintInAudience', id: string, audienceId: string } | { __typename: 'ConstraintInStoreOnly', id: string } | { __typename: 'ConstraintLocationInState', id: string, states: Array<string> } | { __typename: 'ConstraintOrderAheadOnly', id: string } | { __typename: 'ConstraintPaymentInstrument', id: string, paymentInstruments: Array<Payment_Instrument_Type>, paymentInstrumentEvaluationMethod: Payment_Instrument_Evaluation_Method } | { __typename: 'ConstraintPaymentMethod', id: string, paymentMethods: Array<Activate_Payment_Method>, paymentEvaluationMethod: Payment_Method_Evaluation_Method } | { __typename: 'ConstraintPreAuth', id: string } | { __typename: 'ConstraintPurchasableEligibility', id: string, ownershipCondition: Ownership_Condition, voucheredOffers: Array<{ __typename: 'Offer', id: string, name: string }> } | { __typename: 'ConstraintPurchaseThreshold', id: string, eligibleProductGroupIds: Array<string>, countProductsBy: Constraint_Purchase_Threshold_Counting_Attribute, threshold: number } | { __typename: 'ConstraintRequiresActivation', id: string, mustFulfillWithinDays?: number | null, allowMultipleFulfillmentsOnActivation: boolean } | { __typename: 'ConstraintRequiresTransactionVoucher', id: string, allowSingleOfferVoucherStacking?: boolean | null, breakageRefund?: boolean | null, breakagePointRounding?: Breakage_Point_Rounding | null } | { __typename: 'ConstraintRequiresVoucher', id: string } | { __typename: 'ConstraintRequiresVoucherAvailableForDiscount', id: string } | { __typename: 'ConstraintStoreLocation', id: string, evaluationMethod: Store_Location_Evaluation_Method, locations: Array<{ __typename: 'ActivateLocation', id: string, name?: string | null }> } | { __typename: 'ConstraintStoreLocationGroup', id: string, locationGroups: Array<{ __typename: 'LocationGroup', uuid: string, name: string }> } | { __typename: 'ConstraintSubBrand', id: string, subBrandUuids: Array<string> } | { __typename: 'ConstraintTimeOfDay', id: string, availableDailyEndingAtTime: string, availableDailyStartingAtTime: string, timezone: string }>, earningMechanism?: { __typename: 'EarningMechanismExternalFulfillment', id: string, externalFulfillmentAward?: { __typename: 'AwardPoints', points: number } | { __typename: 'AwardVouchers', voucherCount: number, voucherExpirationDays?: number | null, voucheredOffer: { __typename: 'Offer', id: string, name: string, fulfillmentCount: number, engagementType?: Offer_Engagement_Type | null } } | null } | { __typename: 'EarningMechanismLoyaltyEvent', id: string, loyaltyEventEventType: string, loyaltyEventAward?: { __typename: 'AwardExternalPoints', maximum?: number | null } | { __typename: 'AwardPoints', points: number } | { __typename: 'AwardVouchers', voucherCount: number, voucherExpirationDays?: number | null, voucheredOffer: { __typename: 'Offer', id: string, name: string, fulfillmentCount: number, engagementType?: Offer_Engagement_Type | null } } | null } | { __typename: 'EarningMechanismMembershipEvent', id: string, membershipEventEventType: Membership_Event_Type, membershipEventAward: { __typename: 'AwardPoints', points: number } | { __typename: 'AwardVouchers', voucherCount: number, voucherExpirationDays?: number | null, voucheredOffer: { __typename: 'Offer', id: string, name: string, fulfillmentCount: number, engagementType?: Offer_Engagement_Type | null } } } | { __typename: 'EarningMechanismPointSpend', id: string, pointCost: number, offerIsReturnable?: boolean | null, allowedForNewMember?: boolean | null, pointSpendAward: { __typename: 'AwardVouchers', voucherCount: number, voucherExpirationDays?: number | null, voucheredOffer: { __typename: 'Offer', id: string, name: string, fulfillmentCount: number, engagementType?: Offer_Engagement_Type | null } } } | { __typename: 'EarningMechanismProductDiscount', id: string, allowCarryOver: boolean, purchaseThresholdInt: number, productDiscountAward: { __typename: 'AwardBuyAndGet', discountThreshold: number, percentDiscount: number } | { __typename: 'AwardMoneyDiscount', awardPer: Award_Per_Counting_Strategy, moneyAmount: number, partialDiscount: boolean } | { __typename: 'AwardPriceOverride', maximumCost: number }, eligibleProductGroups: Array<{ __typename: 'ProductGroup', id: string, name: string }> } | { __typename: 'EarningMechanismProductPurchase', id: string, countProductsBy: Earning_Mechanism_Product_Counting_Attribute, purchaseThreshold: number, productPurchaseAward: { __typename: 'AwardExternal', provider: ExternalAwardProvider } | { __typename: 'AwardPoints', points: number } | { __typename: 'AwardVouchers', voucherCount: number, voucherExpirationDays?: number | null, voucheredOffer: { __typename: 'Offer', id: string, name: string, fulfillmentCount: number, engagementType?: Offer_Engagement_Type | null } }, eligibleProductGroups: Array<{ __typename: 'ProductGroup', id: string, name: string }> } | { __typename: 'EarningMechanismPromocodes', id: string, codesType: PromocodesOfferType, promocodes: Array<{ __typename: 'Promocode', id: string, code: any, status: PromocodeStatus, publicationStatus: PromocodePublicationStatus, description?: string | null, startDate: string, endDate?: string | null, stats?: { __typename: 'PromocodeUsageStats', redemptions: number, totalOfferRedemptions: number } | null, createdBy: { __typename: 'CommandCenterUser', email: string, name?: string | null } }>, promoCodeGroups: { __typename: 'PromoCodeGroupConnection', edges: Array<{ __typename: 'PromoCodeGroupEdge', node: { __typename: 'PromoCodeGroup', id: string, fileName: string, processingStatus: PromoCodeGroupProcessingStatus, codesStats: { __typename: 'PromoCodeGroupStats', createdCount: number, failedCount: number, totalCount: number } } }> }, award?: { __typename: 'AwardPoints', points: number } | { __typename: 'AwardVouchers', voucherCount: number, voucherExpirationDays?: number | null, voucheredOffer: { __typename: 'Offer', id: string, name: string, fulfillmentCount: number, engagementType?: Offer_Engagement_Type | null } } | null } | { __typename: 'EarningMechanismSpinWheelGame', id: string, purchasableOffer?: { __typename: 'Offer', id: string, name: string } | null, awards: Array<{ __typename: 'RandomAwardConfig', awardType: Random_Award_Type, limit: number, sequenceNumber: number, award?: { __typename: 'AwardPoints', points: number } | { __typename: 'AwardVouchers', voucherExpirationDays?: number | null, voucherCount: number, voucheredOffer: { __typename: 'Offer', id: string, name: string } } | null }> } | { __typename: 'EarningMechanismStoredValueDiscount', id: string, maxDiscountPerTransaction?: number | null, excludedProductGroups: Array<{ __typename: 'ProductGroup', id: string, name: string }> } | { __typename: 'EarningMechanismTotalEligiblePurchase', id: string, countProductsBy: Earning_Mechanism_Product_Counting_Attribute, roundCountedProducts: Earning_Mechanism_Product_Counting_Rounding_Strategy, totalEligiblePurchaseAward: { __typename: 'AwardPointsPer', points: number, rounding: Award_Points_Rounding_Strategy }, eligibleProductGroups: Array<{ __typename: 'ProductGroup', id: string, name: string }> } | { __typename: 'EarningMechanismTotalEligiblePurchaseOverTime', id: string, countProductsBy: Earning_Mechanism_Product_Counting_Attribute, accumulationThreshold: number, stayVisibleWhileInProgress?: boolean | null, hiddenUntilProgress: boolean, totalEligiblePurchaseOverTimeAward: { __typename: 'AwardPoints', points: number } | { __typename: 'AwardVouchers', voucherCount: number, voucherExpirationDays?: number | null, voucheredOffer: { __typename: 'Offer', id: string, name: string, fulfillmentCount: number, engagementType?: Offer_Engagement_Type | null } }, eligibleProductGroups: Array<{ __typename: 'ProductGroup', id: string, name: string }>, purchaseMemberProgress?: { __typename: 'PurchaseProgress', quantityPurchased: number, quantityRequired: number } | null } | { __typename: 'EarningMechanismTotalSpendOnTransaction', id: string, roundMoneyAmount: Earning_Mechanism_Product_Counting_Rounding_Strategy, totalSpendOnTransactionAward: { __typename: 'AwardPointsPer', points: number, rounding: Award_Points_Rounding_Strategy }, ineligibleProductGroups: Array<{ __typename: 'ProductGroup', id: string, name: string }> } | { __typename: 'EarningMechanismTotalSpendOverTime', id: string, accumulationThreshold: number, stayVisibleWhileInProgress?: boolean | null, totalSpendOverTimeAward: { __typename: 'AwardPoints', points: number } | { __typename: 'AwardVouchers', voucherCount: number, voucherExpirationDays?: number | null, voucheredOffer: { __typename: 'Offer', id: string, name: string, fulfillmentCount: number, engagementType?: Offer_Engagement_Type | null } }, ineligibleProductGroups: Array<{ __typename: 'ProductGroup', id: string, name: string }>, purchaseMemberProgress?: { __typename: 'PurchaseProgress', quantityPurchased: number, quantityRequired: number } | null } | { __typename: 'EarningMechanismTransactionDiscount', id: string, purchaseAmountThreshold: number, allowMultipleFulfillmentsPerProductGroupThreshold: boolean, transactionDiscountAward: { __typename: 'AwardTransactionMoneyDiscount', moneyDiscount: number } | { __typename: 'AwardTransactionPercentDiscount', percentDiscount: number }, ineligibleProductGroups: Array<{ __typename: 'ProductGroup', id: string, name: string }> } | { __typename: 'EarningMechanismVarietyDiscount', id: string, varietyDiscountAward: { __typename: 'AwardPriceOverride', maximumCost: number } | { __typename: 'AwardProductDiscount', percentDiscount: number, purchaseThreshold: number, eligibleProductGroups: Array<{ __typename: 'ProductGroup', id: string, name: string }> } | { __typename: 'AwardTransactionMoneyDiscount', moneyDiscount: number }, purchases: Array<{ __typename: 'EarningVarietyDiscountCriteria', purchaseThreshold: number, eligibleProductGroups: Array<{ __typename: 'ProductGroup', id: string, name: string }> }> } | { __typename: 'EarningMechanismVarietyPurchase', id: string, varietyPurchaseAward: { __typename: 'AwardPoints', points: number } | { __typename: 'AwardVouchers', voucherCount: number, voucherExpirationDays?: number | null, voucheredOffer: { __typename: 'Offer', id: string, name: string, fulfillmentCount: number, engagementType?: Offer_Engagement_Type | null } }, products: Array<{ __typename: 'EarningMechanismProductCriteria', id?: string | null, countProductsBy: Earning_Mechanism_Product_Counting_Attribute, purchaseThreshold: number, eligibleProductGroups: Array<{ __typename: 'ProductGroup', id: string, name: string }> }> } | { __typename: 'EarningMechanismVarietyPurchaseOverTime', id: string, preventDoublePunches?: boolean | null, stayVisibleWhileInProgress?: boolean | null, hiddenUntilProgress: boolean, varietyPurchaseOverTimeAward: { __typename: 'AwardPoints', points: number } | { __typename: 'AwardVouchers', voucherCount: number, voucherExpirationDays?: number | null, voucheredOffer: { __typename: 'Offer', id: string, name: string, fulfillmentCount: number, engagementType?: Offer_Engagement_Type | null } }, products: Array<{ __typename: 'EarningMechanismProductCriteria', id?: string | null, countProductsBy: Earning_Mechanism_Product_Counting_Attribute, purchaseThreshold: number, eligibleProductGroups: Array<{ __typename: 'ProductGroup', id: string, name: string }> }>, varietyMemberProgress: Array<{ __typename: 'VarietyProgress', quantityPurchased: number, quantityRequired: number }> } | { __typename: 'EarningMechanismVisits', id: string, visitThreshold: number, visitsAward: { __typename: 'AwardPoints', points: number } | { __typename: 'AwardVouchers', voucherCount: number, voucherExpirationDays?: number | null, voucheredOffer: { __typename: 'Offer', id: string, name: string, fulfillmentCount: number, engagementType?: Offer_Engagement_Type | null } }, visitsMemberProgress?: { __typename: 'VisitsProgress', visits: number, visitsRequired: number } | null } | null, triggerPreferences: { __typename: 'TriggerPreferences', triggerOnFulfillment: boolean, triggerOnVisibility: boolean, triggerOnProgress: boolean }, displayCategories: Array<{ __typename: 'DisplayCategory', id: string, name: string, rank: number, bannerIds?: Array<string> | null, categoryRestrictions?: Category_Restrictions | null, shouldLazyLoadBanners?: boolean | null }> } };

export type TriggerVisibilityNotificationsMutationVariables = Exact<{
  input: TriggerVisibilityNotificationsInput;
}>;


export type TriggerVisibilityNotificationsMutation = { __typename: 'Mutation', triggerVisibilityNotifications: boolean };

export type OfferQueryVariables = Exact<{
  filter?: InputMaybe<OfferFilter>;
}>;


export type OfferQuery = { __typename: 'Query', offers: { __typename: 'OfferConnection', edges: Array<{ __typename: 'OfferEdge', cursor: string, node: { __typename: 'Offer', id: string, description?: string | null, name: string, engagementType?: Offer_Engagement_Type | null, category?: string | null, publicationStatus: Publication_Status_Type, createdAt: string, expireAt?: string | null, publishAt?: string | null, deleted: boolean, presentationType: Offer_Presentation_Type, presentationPriority: Offer_Presentation_Priority, fulfillmentCount: number, fulfillmentPriorityLevel?: number | null, visibleForCommandCenterFulfillment?: boolean | null, voucherCount: number, ageRestricted: boolean, customData?: object | object[] | null, externalId?: string | null, fundingSource?: Offer_Funding_Source | null, fundingSourceName?: string | null, shortDescription?: string | null, longDescription?: string | null, optionalAtPos?: boolean | null, stackable: boolean, displayForOrderAhead?: boolean | null, allowedForManualVisibilityNotifications?: boolean | null, scanDataConfiguration?: { __typename: 'ScanDataConfiguration', description: string, discountAllocation: number, fundingSource: ScanDataFundingSource } | null, trackingConfig?: { __typename: 'TrackingConfig', trackingId: string, isActivityLogIncludedInAltriaDDM: boolean } | null, campaign?: { __typename: 'Campaign', uuid: string, name: string } | null, marketingContents: Array<{ __typename: 'MarketingContent', id: string, locale: string, title?: string | null, shortDescription?: string | null, longDescription?: string | null, imageUrl?: string | null, terms?: string | null, termsUrl?: string | null, customData?: object | object[] | null, disclaimer?: string | null, disclaimerUrl?: string | null, externalUrl?: string | null, surgeonGeneralsWarning?: string | null, triggeredMessageContent: { __typename: 'OfferTriggeredMessageContent', fulfillmentSms?: string | null, visibilitySms?: string | null, progressSms?: string | null }, receiptContent?: { __typename: 'ReceiptContent', shortDescription?: string | null, longDescription?: string | null } | null }>, limits: Array<{ __typename: 'LimitGlobalActivation', id: string, limit: number } | { __typename: 'LimitGlobalActivationInTime', id: string, limit: number, timePeriod: Limit_Time_Period } | { __typename: 'LimitGlobalAwardCount', id: string, limit: number } | { __typename: 'LimitGlobalAwardCountInTime', id: string, limit: number, timePeriod: Limit_Time_Period } | { __typename: 'LimitInTransactionAwardCount', id: string, limit: number } | { __typename: 'LimitInTransactionProgress', id: string, limit: number } | { __typename: 'LimitMembershipActivation', id: string, limit: number } | { __typename: 'LimitMembershipActivationInTime', id: string, limit: number, timePeriod: Limit_Time_Period } | { __typename: 'LimitMembershipAwardCount', id: string, limit: number } | { __typename: 'LimitMembershipAwardCountInTime', id: string, limit: number, timePeriod: Limit_Time_Period } | { __typename: 'LimitMembershipProgressInTime', id: string, limit: number, timePeriod: Limit_Time_Period } | { __typename: 'LimitMembershipTransactionCount', id: string, limit: number } | { __typename: 'LimitMembershipTransactionCountInTime', id: string, limit: number, timePeriod: Limit_Time_Period }>, constraints: Array<{ __typename: 'ConstraintDaysOfWeek', id: string, availableWeeklyOnDays: Array<Weekday>, startOfDayTimezone: string } | { __typename: 'ConstraintEmailRequired', id: string } | { __typename: 'ConstraintInAudience', id: string, audienceId: string } | { __typename: 'ConstraintInStoreOnly', id: string } | { __typename: 'ConstraintLocationInState', id: string, states: Array<string> } | { __typename: 'ConstraintOrderAheadOnly', id: string } | { __typename: 'ConstraintPaymentInstrument', id: string, paymentInstruments: Array<Payment_Instrument_Type>, paymentInstrumentEvaluationMethod: Payment_Instrument_Evaluation_Method } | { __typename: 'ConstraintPaymentMethod', id: string, paymentMethods: Array<Activate_Payment_Method>, paymentEvaluationMethod: Payment_Method_Evaluation_Method } | { __typename: 'ConstraintPreAuth', id: string } | { __typename: 'ConstraintPurchasableEligibility', id: string, ownershipCondition: Ownership_Condition, voucheredOffers: Array<{ __typename: 'Offer', id: string, name: string }> } | { __typename: 'ConstraintPurchaseThreshold', id: string, eligibleProductGroupIds: Array<string>, countProductsBy: Constraint_Purchase_Threshold_Counting_Attribute, threshold: number } | { __typename: 'ConstraintRequiresActivation', id: string, mustFulfillWithinDays?: number | null, allowMultipleFulfillmentsOnActivation: boolean } | { __typename: 'ConstraintRequiresTransactionVoucher', id: string, allowSingleOfferVoucherStacking?: boolean | null, breakageRefund?: boolean | null, breakagePointRounding?: Breakage_Point_Rounding | null } | { __typename: 'ConstraintRequiresVoucher', id: string } | { __typename: 'ConstraintRequiresVoucherAvailableForDiscount', id: string } | { __typename: 'ConstraintStoreLocation', id: string, evaluationMethod: Store_Location_Evaluation_Method, locations: Array<{ __typename: 'ActivateLocation', id: string, name?: string | null }> } | { __typename: 'ConstraintStoreLocationGroup', id: string, locationGroups: Array<{ __typename: 'LocationGroup', uuid: string, name: string }> } | { __typename: 'ConstraintSubBrand', id: string, subBrandUuids: Array<string> } | { __typename: 'ConstraintTimeOfDay', id: string, availableDailyEndingAtTime: string, availableDailyStartingAtTime: string, timezone: string }>, earningMechanism?: { __typename: 'EarningMechanismExternalFulfillment', id: string, externalFulfillmentAward?: { __typename: 'AwardPoints', points: number } | { __typename: 'AwardVouchers', voucherCount: number, voucherExpirationDays?: number | null, voucheredOffer: { __typename: 'Offer', id: string, name: string, fulfillmentCount: number, engagementType?: Offer_Engagement_Type | null } } | null } | { __typename: 'EarningMechanismLoyaltyEvent', id: string, loyaltyEventEventType: string, loyaltyEventAward?: { __typename: 'AwardExternalPoints', maximum?: number | null } | { __typename: 'AwardPoints', points: number } | { __typename: 'AwardVouchers', voucherCount: number, voucherExpirationDays?: number | null, voucheredOffer: { __typename: 'Offer', id: string, name: string, fulfillmentCount: number, engagementType?: Offer_Engagement_Type | null } } | null } | { __typename: 'EarningMechanismMembershipEvent', id: string, membershipEventEventType: Membership_Event_Type, membershipEventAward: { __typename: 'AwardPoints', points: number } | { __typename: 'AwardVouchers', voucherCount: number, voucherExpirationDays?: number | null, voucheredOffer: { __typename: 'Offer', id: string, name: string, fulfillmentCount: number, engagementType?: Offer_Engagement_Type | null } } } | { __typename: 'EarningMechanismPointSpend', id: string, pointCost: number, offerIsReturnable?: boolean | null, allowedForNewMember?: boolean | null, pointSpendAward: { __typename: 'AwardVouchers', voucherCount: number, voucherExpirationDays?: number | null, voucheredOffer: { __typename: 'Offer', id: string, name: string, fulfillmentCount: number, engagementType?: Offer_Engagement_Type | null } } } | { __typename: 'EarningMechanismProductDiscount', id: string, allowCarryOver: boolean, purchaseThresholdInt: number, productDiscountAward: { __typename: 'AwardBuyAndGet', discountThreshold: number, percentDiscount: number } | { __typename: 'AwardMoneyDiscount', awardPer: Award_Per_Counting_Strategy, moneyAmount: number, partialDiscount: boolean } | { __typename: 'AwardPriceOverride', maximumCost: number }, eligibleProductGroups: Array<{ __typename: 'ProductGroup', id: string, name: string }> } | { __typename: 'EarningMechanismProductPurchase', id: string, countProductsBy: Earning_Mechanism_Product_Counting_Attribute, purchaseThreshold: number, productPurchaseAward: { __typename: 'AwardExternal', provider: ExternalAwardProvider } | { __typename: 'AwardPoints', points: number } | { __typename: 'AwardVouchers', voucherCount: number, voucherExpirationDays?: number | null, voucheredOffer: { __typename: 'Offer', id: string, name: string, fulfillmentCount: number, engagementType?: Offer_Engagement_Type | null } }, eligibleProductGroups: Array<{ __typename: 'ProductGroup', id: string, name: string }> } | { __typename: 'EarningMechanismPromocodes', id: string, codesType: PromocodesOfferType, promocodes: Array<{ __typename: 'Promocode', id: string, code: any, status: PromocodeStatus, publicationStatus: PromocodePublicationStatus, description?: string | null, startDate: string, endDate?: string | null, stats?: { __typename: 'PromocodeUsageStats', redemptions: number, totalOfferRedemptions: number } | null, createdBy: { __typename: 'CommandCenterUser', email: string, name?: string | null } }>, promoCodeGroups: { __typename: 'PromoCodeGroupConnection', edges: Array<{ __typename: 'PromoCodeGroupEdge', node: { __typename: 'PromoCodeGroup', id: string, fileName: string, processingStatus: PromoCodeGroupProcessingStatus, codesStats: { __typename: 'PromoCodeGroupStats', createdCount: number, failedCount: number, totalCount: number } } }> }, award?: { __typename: 'AwardPoints', points: number } | { __typename: 'AwardVouchers', voucherCount: number, voucherExpirationDays?: number | null, voucheredOffer: { __typename: 'Offer', id: string, name: string, fulfillmentCount: number, engagementType?: Offer_Engagement_Type | null } } | null } | { __typename: 'EarningMechanismSpinWheelGame', id: string, purchasableOffer?: { __typename: 'Offer', id: string, name: string } | null, awards: Array<{ __typename: 'RandomAwardConfig', awardType: Random_Award_Type, limit: number, sequenceNumber: number, award?: { __typename: 'AwardPoints', points: number } | { __typename: 'AwardVouchers', voucherExpirationDays?: number | null, voucherCount: number, voucheredOffer: { __typename: 'Offer', id: string, name: string } } | null }> } | { __typename: 'EarningMechanismStoredValueDiscount', id: string, maxDiscountPerTransaction?: number | null, excludedProductGroups: Array<{ __typename: 'ProductGroup', id: string, name: string }> } | { __typename: 'EarningMechanismTotalEligiblePurchase', id: string, countProductsBy: Earning_Mechanism_Product_Counting_Attribute, roundCountedProducts: Earning_Mechanism_Product_Counting_Rounding_Strategy, totalEligiblePurchaseAward: { __typename: 'AwardPointsPer', points: number, rounding: Award_Points_Rounding_Strategy }, eligibleProductGroups: Array<{ __typename: 'ProductGroup', id: string, name: string }> } | { __typename: 'EarningMechanismTotalEligiblePurchaseOverTime', id: string, countProductsBy: Earning_Mechanism_Product_Counting_Attribute, accumulationThreshold: number, stayVisibleWhileInProgress?: boolean | null, hiddenUntilProgress: boolean, totalEligiblePurchaseOverTimeAward: { __typename: 'AwardPoints', points: number } | { __typename: 'AwardVouchers', voucherCount: number, voucherExpirationDays?: number | null, voucheredOffer: { __typename: 'Offer', id: string, name: string, fulfillmentCount: number, engagementType?: Offer_Engagement_Type | null } }, eligibleProductGroups: Array<{ __typename: 'ProductGroup', id: string, name: string }>, purchaseMemberProgress?: { __typename: 'PurchaseProgress', quantityPurchased: number, quantityRequired: number } | null } | { __typename: 'EarningMechanismTotalSpendOnTransaction', id: string, roundMoneyAmount: Earning_Mechanism_Product_Counting_Rounding_Strategy, totalSpendOnTransactionAward: { __typename: 'AwardPointsPer', points: number, rounding: Award_Points_Rounding_Strategy }, ineligibleProductGroups: Array<{ __typename: 'ProductGroup', id: string, name: string }> } | { __typename: 'EarningMechanismTotalSpendOverTime', id: string, accumulationThreshold: number, stayVisibleWhileInProgress?: boolean | null, totalSpendOverTimeAward: { __typename: 'AwardPoints', points: number } | { __typename: 'AwardVouchers', voucherCount: number, voucherExpirationDays?: number | null, voucheredOffer: { __typename: 'Offer', id: string, name: string, fulfillmentCount: number, engagementType?: Offer_Engagement_Type | null } }, ineligibleProductGroups: Array<{ __typename: 'ProductGroup', id: string, name: string }>, purchaseMemberProgress?: { __typename: 'PurchaseProgress', quantityPurchased: number, quantityRequired: number } | null } | { __typename: 'EarningMechanismTransactionDiscount', id: string, purchaseAmountThreshold: number, allowMultipleFulfillmentsPerProductGroupThreshold: boolean, transactionDiscountAward: { __typename: 'AwardTransactionMoneyDiscount', moneyDiscount: number } | { __typename: 'AwardTransactionPercentDiscount', percentDiscount: number }, ineligibleProductGroups: Array<{ __typename: 'ProductGroup', id: string, name: string }> } | { __typename: 'EarningMechanismVarietyDiscount', id: string, varietyDiscountAward: { __typename: 'AwardPriceOverride', maximumCost: number } | { __typename: 'AwardProductDiscount', percentDiscount: number, purchaseThreshold: number, eligibleProductGroups: Array<{ __typename: 'ProductGroup', id: string, name: string }> } | { __typename: 'AwardTransactionMoneyDiscount', moneyDiscount: number }, purchases: Array<{ __typename: 'EarningVarietyDiscountCriteria', purchaseThreshold: number, eligibleProductGroups: Array<{ __typename: 'ProductGroup', id: string, name: string }> }> } | { __typename: 'EarningMechanismVarietyPurchase', id: string, varietyPurchaseAward: { __typename: 'AwardPoints', points: number } | { __typename: 'AwardVouchers', voucherCount: number, voucherExpirationDays?: number | null, voucheredOffer: { __typename: 'Offer', id: string, name: string, fulfillmentCount: number, engagementType?: Offer_Engagement_Type | null } }, products: Array<{ __typename: 'EarningMechanismProductCriteria', id?: string | null, countProductsBy: Earning_Mechanism_Product_Counting_Attribute, purchaseThreshold: number, eligibleProductGroups: Array<{ __typename: 'ProductGroup', id: string, name: string }> }> } | { __typename: 'EarningMechanismVarietyPurchaseOverTime', id: string, preventDoublePunches?: boolean | null, stayVisibleWhileInProgress?: boolean | null, hiddenUntilProgress: boolean, varietyPurchaseOverTimeAward: { __typename: 'AwardPoints', points: number } | { __typename: 'AwardVouchers', voucherCount: number, voucherExpirationDays?: number | null, voucheredOffer: { __typename: 'Offer', id: string, name: string, fulfillmentCount: number, engagementType?: Offer_Engagement_Type | null } }, products: Array<{ __typename: 'EarningMechanismProductCriteria', id?: string | null, countProductsBy: Earning_Mechanism_Product_Counting_Attribute, purchaseThreshold: number, eligibleProductGroups: Array<{ __typename: 'ProductGroup', id: string, name: string }> }>, varietyMemberProgress: Array<{ __typename: 'VarietyProgress', quantityPurchased: number, quantityRequired: number }> } | { __typename: 'EarningMechanismVisits', id: string, visitThreshold: number, visitsAward: { __typename: 'AwardPoints', points: number } | { __typename: 'AwardVouchers', voucherCount: number, voucherExpirationDays?: number | null, voucheredOffer: { __typename: 'Offer', id: string, name: string, fulfillmentCount: number, engagementType?: Offer_Engagement_Type | null } }, visitsMemberProgress?: { __typename: 'VisitsProgress', visits: number, visitsRequired: number } | null } | null, triggerPreferences: { __typename: 'TriggerPreferences', triggerOnFulfillment: boolean, triggerOnVisibility: boolean, triggerOnProgress: boolean }, displayCategories: Array<{ __typename: 'DisplayCategory', id: string, name: string, rank: number, bannerIds?: Array<string> | null, categoryRestrictions?: Category_Restrictions | null, shouldLazyLoadBanners?: boolean | null }> } }> } };

export type OfferSelectListQueryVariables = Exact<{
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  filter?: InputMaybe<OfferFilter>;
}>;


export type OfferSelectListQuery = { __typename: 'Query', offers: { __typename: 'OfferConnection', pageInfo: { __typename: 'PageInfo', hasNextPage: boolean, hasPreviousPage: boolean, startCursor?: string | null, endCursor?: string | null }, edges: Array<{ __typename: 'OfferEdge', cursor: string, node: { __typename: 'Offer', id: string, name: string, engagementType?: Offer_Engagement_Type | null } }> } };

export type OpenCommerceUserCustomDataFragment = { __typename: 'OpenCommerceUser', customData?: object | object[] | null };

export type OpenCommerceUserFragment = { __typename: 'OpenCommerceUser', uuid: string, username?: string | null, phoneNumber?: string | null, email: string, userRole: User_Role, status: Open_Commerce_User_Status, customData?: object | object[] | null, name: { __typename: 'PersonName', first?: string | null, last?: string | null } };

export type OpenCommerceUserSelectItemFragment = { __typename: 'OpenCommerceUser', uuid: string, name: { __typename: 'PersonName', first?: string | null, last?: string | null } };

export type CurrentUserRetailerNetworkUserFragment = { __typename: 'RetailerNetworkUser', uuid: string, role: Retailer_Network_User_Role, openCommerceUser?: { __typename: 'OpenCommerceUser', uuid: string, email: string, name: { __typename: 'PersonName', first?: string | null, last?: string | null } } | null, retailerNetwork?: { __typename: 'RetailerNetwork', uuid: string } | null };

export type OpenCommerceUserCreateMutationVariables = Exact<{
  input: OpenCommerceUserCreateInput;
}>;


export type OpenCommerceUserCreateMutation = { __typename: 'Mutation', openCommerceUserCreate: { __typename: 'OpenCommerceUser', uuid: string, username?: string | null, phoneNumber?: string | null, email: string, userRole: User_Role, status: Open_Commerce_User_Status, customData?: object | object[] | null, name: { __typename: 'PersonName', first?: string | null, last?: string | null } } };

export type OpenCommerceUserUpdateMutationVariables = Exact<{
  input: OpenCommerceUserUpdateInput;
}>;


export type OpenCommerceUserUpdateMutation = { __typename: 'Mutation', openCommerceUserUpdate: { __typename: 'OpenCommerceUser', uuid: string, username?: string | null, phoneNumber?: string | null, email: string, userRole: User_Role, status: Open_Commerce_User_Status, customData?: object | object[] | null, name: { __typename: 'PersonName', first?: string | null, last?: string | null } } };

export type OpenCommerceUsersQueryVariables = Exact<{
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  after?: InputMaybe<Scalars['OCBase64Cursor']['input']>;
  before?: InputMaybe<Scalars['OCBase64Cursor']['input']>;
  filter: OpenCommerceUserFilter;
}>;


export type OpenCommerceUsersQuery = { __typename: 'Query', openCommerceUsers: { __typename: 'OpenCommerceUserConnection', pageInfo: { __typename: 'PageInfo', hasNextPage: boolean, hasPreviousPage: boolean, startCursor?: string | null, endCursor?: string | null }, edges?: Array<{ __typename: 'OpenCommerceUserEdge', cursor: string, node: { __typename: 'OpenCommerceUser', uuid: string, username?: string | null, phoneNumber?: string | null, email: string, userRole: User_Role, status: Open_Commerce_User_Status, customData?: object | object[] | null, name: { __typename: 'PersonName', first?: string | null, last?: string | null } } }> | null } };

export type GetOpenCommerceUserSelectItemsQueryVariables = Exact<{
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  after?: InputMaybe<Scalars['OCBase64Cursor']['input']>;
  before?: InputMaybe<Scalars['OCBase64Cursor']['input']>;
  filter?: InputMaybe<OpenCommerceUserFilter>;
}>;


export type GetOpenCommerceUserSelectItemsQuery = { __typename: 'Query', openCommerceUsers: { __typename: 'OpenCommerceUserConnection', pageInfo: { __typename: 'PageInfo', hasNextPage: boolean, hasPreviousPage: boolean, startCursor?: string | null, endCursor?: string | null }, edges?: Array<{ __typename: 'OpenCommerceUserEdge', cursor: string, node: { __typename: 'OpenCommerceUser', uuid: string, name: { __typename: 'PersonName', first?: string | null, last?: string | null } } }> | null } };

export type UsersEligibleForRetailerConnectQueryVariables = Exact<{
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  after?: InputMaybe<Scalars['OCBase64Cursor']['input']>;
  before?: InputMaybe<Scalars['OCBase64Cursor']['input']>;
  filter: UsersEligibleForRetailerConnectFilter;
}>;


export type UsersEligibleForRetailerConnectQuery = { __typename: 'Query', usersEligibleForRetailerConnect: { __typename: 'OpenCommerceUserConnection', pageInfo: { __typename: 'PageInfo', hasNextPage: boolean, hasPreviousPage: boolean, startCursor?: string | null, endCursor?: string | null }, edges?: Array<{ __typename: 'OpenCommerceUserEdge', cursor: string, node: { __typename: 'OpenCommerceUser', uuid: string, username?: string | null, phoneNumber?: string | null, email: string, userRole: User_Role, status: Open_Commerce_User_Status, customData?: object | object[] | null, name: { __typename: 'PersonName', first?: string | null, last?: string | null } } }> | null } };

export type OpenCommerceUserCurrentQueryVariables = Exact<{ [key: string]: never; }>;


export type OpenCommerceUserCurrentQuery = { __typename: 'Query', openCommerceUserCurrent?: { __typename: 'OpenCommerceUser', uuid: string, username?: string | null, phoneNumber?: string | null, email: string, userRole: User_Role, status: Open_Commerce_User_Status, customData?: object | object[] | null, name: { __typename: 'PersonName', first?: string | null, last?: string | null } } | null };

export type CurrentUserRetailerNetworkUsersQueryVariables = Exact<{
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  after?: InputMaybe<Scalars['OCBase64Cursor']['input']>;
  before?: InputMaybe<Scalars['OCBase64Cursor']['input']>;
  retailerNetworkUuid?: InputMaybe<Scalars['OCUUID']['input']>;
  sort?: InputMaybe<RetailerNetworkUsersSort>;
}>;


export type CurrentUserRetailerNetworkUsersQuery = { __typename: 'Query', currentUserRetailerNetworkUsers: { __typename: 'RetailerNetworkUserConnection', pageInfo: { __typename: 'PageInfo', hasNextPage: boolean, hasPreviousPage: boolean, startCursor?: string | null, endCursor?: string | null }, edges?: Array<{ __typename: 'RetailerNetworkUserEdge', cursor: string, node: { __typename: 'RetailerNetworkUser', uuid: string, role: Retailer_Network_User_Role, openCommerceUser?: { __typename: 'OpenCommerceUser', uuid: string, email: string, name: { __typename: 'PersonName', first?: string | null, last?: string | null } } | null, retailerNetwork?: { __typename: 'RetailerNetwork', uuid: string } | null } }> | null } };

export type PageInfoFragment = { __typename: 'PageInfo', hasNextPage: boolean, hasPreviousPage: boolean, startCursor?: string | null, endCursor?: string | null };

export type PointChangeFragment = { __typename: 'PointChange', id: string, type?: Point_Change_Type | null, createdAt: string, notes?: string | null, quantity: number, offer?: { __typename: 'Offer', id: string, name: string, publishAt?: string | null, expireAt?: string | null, campaign?: { __typename: 'Campaign', uuid: string } | null, marketingContents: Array<{ __typename: 'MarketingContent', id: string, title?: string | null }> } | null, source?: { __typename: 'ActivateTransaction', id: string, createdAt: string, transactionTimeAt?: string | null, partnerId?: string | null, lineItems: Array<{ __typename: 'ActivateTransactionLineItem', id: string, sku?: string | null, upc?: string | null, group?: string | null, quantity?: number | null, moneyAmount?: number | null }>, location?: { __typename: 'ActivateLocation', id: string, name?: string | null, address1?: string | null, city?: string | null, state?: string | null } | null, fulfilledOffers: Array<{ __typename: 'Offer', id: string, name: string, marketingContents: Array<{ __typename: 'MarketingContent', id: string, title?: string | null }> }> } | { __typename: 'ActivateUser', id: string, email: string, name?: string | null } | { __typename: 'Chain' } | { __typename: 'CommandCenterUser', name?: string | null, email: string } | { __typename: 'GameSession' } | { __typename: 'LoyaltyEvent', id: string, eventType: string, eventData?: object | object[] | null } | { __typename: 'MembershipPointDonation', id: string, pointsSpent: number, donationAmountCents: number, bucket: { __typename: 'DonationBucket', id: string, name: string } } | { __typename: 'OfferPurchase', pointCost: number, voucherGrantFor: { __typename: 'Offer', id: string, name: string, publishAt?: string | null, expireAt?: string | null, marketingContents: Array<{ __typename: 'MarketingContent', id: string, title?: string | null }> } } | { __typename: 'PointChange', id: string } | { __typename: 'PromocodeUseRequest' } | { __typename: 'StoredValueTransaction' } | null, pointAdjustmentReason?: { __typename: 'PointAdjustmentReason', id: string, label: string, description?: string | null } | null, membership: { __typename: 'Membership', id: string, createdAt: string, customerUuid?: string | null, firstName?: string | null, lastName?: string | null, email?: string | null, phone?: string | null, points: number, state: Membership_State } };

export type TransactionSourceFragment = { __typename: 'ActivateTransaction', id: string, createdAt: string, transactionTimeAt?: string | null, partnerId?: string | null, lineItems: Array<{ __typename: 'ActivateTransactionLineItem', id: string, sku?: string | null, upc?: string | null, group?: string | null, quantity?: number | null, moneyAmount?: number | null }>, location?: { __typename: 'ActivateLocation', id: string, name?: string | null, address1?: string | null, city?: string | null, state?: string | null } | null, fulfilledOffers: Array<{ __typename: 'Offer', id: string, name: string, marketingContents: Array<{ __typename: 'MarketingContent', id: string, title?: string | null }> }> };

export type PointChangeOfferFragment = { __typename: 'Offer', id: string, name: string, publishAt?: string | null, expireAt?: string | null, campaign?: { __typename: 'Campaign', uuid: string } | null, marketingContents: Array<{ __typename: 'MarketingContent', id: string, title?: string | null }> };

export type UserSourceFragment = { __typename: 'ActivateUser', id: string, email: string, name?: string | null };

export type LoyaltyEventSourceFragment = { __typename: 'LoyaltyEvent', id: string, eventType: string, eventData?: object | object[] | null };

export type PointChangeSourceFragment = { __typename: 'PointChange', id: string };

export type OfferPurchaseSourceFragment = { __typename: 'OfferPurchase', pointCost: number, voucherGrantFor: { __typename: 'Offer', id: string, name: string, publishAt?: string | null, expireAt?: string | null, marketingContents: Array<{ __typename: 'MarketingContent', id: string, title?: string | null }> } };

export type CommandCenterUserSourceFragment = { __typename: 'CommandCenterUser', name?: string | null, email: string };

export type MembershipPointDonationSourceFragment = { __typename: 'MembershipPointDonation', id: string, pointsSpent: number, donationAmountCents: number, bucket: { __typename: 'DonationBucket', id: string, name: string } };

export type PointChangeQueryVariables = Exact<{
  filter?: InputMaybe<PointChangeFilter>;
}>;


export type PointChangeQuery = { __typename: 'Query', pointChanges: { __typename: 'PointChangeConnection', edges: Array<{ __typename: 'PointChangeEdge', cursor: string, node: { __typename: 'PointChange', id: string, type?: Point_Change_Type | null, createdAt: string, notes?: string | null, quantity: number, offer?: { __typename: 'Offer', id: string, name: string, publishAt?: string | null, expireAt?: string | null, campaign?: { __typename: 'Campaign', uuid: string } | null, marketingContents: Array<{ __typename: 'MarketingContent', id: string, title?: string | null }> } | null, source?: { __typename: 'ActivateTransaction', id: string, createdAt: string, transactionTimeAt?: string | null, partnerId?: string | null, lineItems: Array<{ __typename: 'ActivateTransactionLineItem', id: string, sku?: string | null, upc?: string | null, group?: string | null, quantity?: number | null, moneyAmount?: number | null }>, location?: { __typename: 'ActivateLocation', id: string, name?: string | null, address1?: string | null, city?: string | null, state?: string | null } | null, fulfilledOffers: Array<{ __typename: 'Offer', id: string, name: string, marketingContents: Array<{ __typename: 'MarketingContent', id: string, title?: string | null }> }> } | { __typename: 'ActivateUser', id: string, email: string, name?: string | null } | { __typename: 'Chain' } | { __typename: 'CommandCenterUser', name?: string | null, email: string } | { __typename: 'GameSession' } | { __typename: 'LoyaltyEvent', id: string, eventType: string, eventData?: object | object[] | null } | { __typename: 'MembershipPointDonation', id: string, pointsSpent: number, donationAmountCents: number, bucket: { __typename: 'DonationBucket', id: string, name: string } } | { __typename: 'OfferPurchase', pointCost: number, voucherGrantFor: { __typename: 'Offer', id: string, name: string, publishAt?: string | null, expireAt?: string | null, marketingContents: Array<{ __typename: 'MarketingContent', id: string, title?: string | null }> } } | { __typename: 'PointChange', id: string } | { __typename: 'PromocodeUseRequest' } | { __typename: 'StoredValueTransaction' } | null, pointAdjustmentReason?: { __typename: 'PointAdjustmentReason', id: string, label: string, description?: string | null } | null, membership: { __typename: 'Membership', id: string, createdAt: string, customerUuid?: string | null, firstName?: string | null, lastName?: string | null, email?: string | null, phone?: string | null, points: number, state: Membership_State } } }> } };

export type ProductCategoryFragment = { __typename: 'ProductCategory', id: string, name: string, categoryRestriction?: Category_Restrictions | null, rank: number };

export type ProductCategoryCreateMutationVariables = Exact<{
  input: ProductCategoryCreateInput;
}>;


export type ProductCategoryCreateMutation = { __typename: 'Mutation', productCategoryCreate?: { __typename: 'ProductCategory', id: string, name: string, categoryRestriction?: Category_Restrictions | null, rank: number } | null };

export type ProductCategoryUpdateMutationVariables = Exact<{
  input: ProductCategoryUpdateInput;
}>;


export type ProductCategoryUpdateMutation = { __typename: 'Mutation', productCategoryUpdate?: { __typename: 'ProductCategory', id: string, name: string, categoryRestriction?: Category_Restrictions | null, rank: number } | null };

export type ProductCategoryDeleteMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type ProductCategoryDeleteMutation = { __typename: 'Mutation', productCategoryDelete?: boolean | null };

export type ProductCategoryQueryVariables = Exact<{
  filter?: InputMaybe<ProductCategoryFilter>;
}>;


export type ProductCategoryQuery = { __typename: 'Query', productCategories?: { __typename: 'ProductCategoryConnection', edges: Array<{ __typename: 'ProductCategoryEdge', cursor: string, node: { __typename: 'ProductCategory', id: string, name: string, categoryRestriction?: Category_Restrictions | null, rank: number } }> } | null };

export type ProductCategoriesQueryVariables = Exact<{
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  filter?: InputMaybe<ProductCategoryFilter>;
}>;


export type ProductCategoriesQuery = { __typename: 'Query', productCategories?: { __typename: 'ProductCategoryConnection', pageInfo: { __typename: 'PageInfo', hasNextPage: boolean, hasPreviousPage: boolean, startCursor?: string | null, endCursor?: string | null }, edges: Array<{ __typename: 'ProductCategoryEdge', cursor: string, node: { __typename: 'ProductCategory', id: string, name: string, categoryRestriction?: Category_Restrictions | null, rank: number } }> } | null };

export type ProductGroupFragment = { __typename: 'ProductGroup', id: string, name: string, description?: string | null, key: Product_Group_Key, values: Array<string>, fuelProductGroup?: { __typename: 'FuelProductGroup', id: string, sortingRank: number, userSelectable: boolean, default: boolean } | null };

export type ProductGroupCreateMutationVariables = Exact<{
  chainId: Scalars['ID']['input'];
  input: ProductGroupInput;
}>;


export type ProductGroupCreateMutation = { __typename: 'Mutation', productGroupCreate: { __typename: 'ProductGroup', id: string, name: string, description?: string | null, key: Product_Group_Key, values: Array<string>, fuelProductGroup?: { __typename: 'FuelProductGroup', id: string, sortingRank: number, userSelectable: boolean, default: boolean } | null } };

export type ProductGroupUpdateMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  input: ProductGroupUpdateInput;
}>;


export type ProductGroupUpdateMutation = { __typename: 'Mutation', productGroupUpdate: { __typename: 'ProductGroup', id: string, name: string, description?: string | null, key: Product_Group_Key, values: Array<string>, fuelProductGroup?: { __typename: 'FuelProductGroup', id: string, sortingRank: number, userSelectable: boolean, default: boolean } | null } };

export type ProductGroupDeleteMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type ProductGroupDeleteMutation = { __typename: 'Mutation', productGroupDelete: boolean };

export type FuelProductGroupCreateMutationVariables = Exact<{
  chainId: Scalars['ID']['input'];
  input: FuelProductGroupCreateInput;
}>;


export type FuelProductGroupCreateMutation = { __typename: 'Mutation', fuelProductGroupCreate: { __typename: 'ProductGroup', id: string, name: string, createdAt: string, description?: string | null, discontinued: boolean, key: Product_Group_Key, values: Array<string>, chain: { __typename: 'Chain', id: string, name: string }, fuelProductGroup?: { __typename: 'FuelProductGroup', id: string, sortingRank: number, userSelectable: boolean, default: boolean } | null } };

export type FuelProductGroupUpdateMutationVariables = Exact<{
  productGroupId: Scalars['ID']['input'];
  input: FuelProductGroupUpdateInput;
}>;


export type FuelProductGroupUpdateMutation = { __typename: 'Mutation', fuelProductGroupUpdate: { __typename: 'ProductGroup', id: string, name: string, createdAt: string, description?: string | null, discontinued: boolean, key: Product_Group_Key, values: Array<string>, chain: { __typename: 'Chain', id: string, name: string }, fuelProductGroup?: { __typename: 'FuelProductGroup', id: string, sortingRank: number, userSelectable: boolean, default: boolean } | null } };

export type ProductGroupQueryVariables = Exact<{
  filter?: InputMaybe<ProductGroupFilter>;
}>;


export type ProductGroupQuery = { __typename: 'Query', productGroups: { __typename: 'ProductGroupConnection', edges: Array<{ __typename: 'ProductGroupEdge', cursor: string, node: { __typename: 'ProductGroup', id: string, name: string, description?: string | null, key: Product_Group_Key, values: Array<string>, fuelProductGroup?: { __typename: 'FuelProductGroup', id: string, sortingRank: number, userSelectable: boolean, default: boolean } | null } }> } };

export type ProductGroupsQueryVariables = Exact<{
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<ProductGroupFilter>;
}>;


export type ProductGroupsQuery = { __typename: 'Query', productGroups: { __typename: 'ProductGroupConnection', pageInfo: { __typename: 'PageInfo', hasNextPage: boolean, hasPreviousPage: boolean, startCursor?: string | null, endCursor?: string | null }, edges: Array<{ __typename: 'ProductGroupEdge', cursor: string, node: { __typename: 'ProductGroup', id: string, name: string, description?: string | null, key: Product_Group_Key, values: Array<string>, fuelProductGroup?: { __typename: 'FuelProductGroup', id: string, sortingRank: number, userSelectable: boolean, default: boolean } | null } }> } };

export type SegmentFragment = { __typename: 'Segment', id: string, name: string, description: string, shortCode?: string | null, membershipCount: number, uuid: string };

export type SegmentCreateMutationVariables = Exact<{
  chainId: Scalars['ID']['input'];
  input: SegmentCreate;
}>;


export type SegmentCreateMutation = { __typename: 'Mutation', segmentCreate: { __typename: 'Segment', id: string, name: string, description: string, shortCode?: string | null, membershipCount: number, uuid: string } };

export type SegmentUpdateMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  input: SegmentUpdate;
}>;


export type SegmentUpdateMutation = { __typename: 'Mutation', segmentUpdate: { __typename: 'Segment', id: string, name: string, description: string, shortCode?: string | null, membershipCount: number, uuid: string } };

export type SegmentDeleteMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type SegmentDeleteMutation = { __typename: 'Mutation', segmentDelete: boolean };

export type SegmentMembershipAddMutationVariables = Exact<{
  input: SegmentMembershipAddInput;
}>;


export type SegmentMembershipAddMutation = { __typename: 'Mutation', segmentMembershipAdd: { __typename: 'Segment', id: string, name: string, description: string, shortCode?: string | null, membershipCount: number, uuid: string } };

export type SegmentMembershipDeleteMutationVariables = Exact<{
  input: SegmentMembershipDeleteInput;
}>;


export type SegmentMembershipDeleteMutation = { __typename: 'Mutation', segmentMembershipDelete: boolean };

export type SegmentQueryVariables = Exact<{
  filter?: InputMaybe<SegmentFilter>;
}>;


export type SegmentQuery = { __typename: 'Query', segments: { __typename: 'SegmentConnection', edges: Array<{ __typename: 'SegmentEdge', cursor: string, node: { __typename: 'Segment', id: string, name: string, description: string, shortCode?: string | null, membershipCount: number, uuid: string } }> } };

export type SegmentsQueryVariables = Exact<{
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<SegmentFilter>;
}>;


export type SegmentsQuery = { __typename: 'Query', segments: { __typename: 'SegmentConnection', pageInfo: { __typename: 'PageInfo', hasNextPage: boolean, hasPreviousPage: boolean, startCursor?: string | null, endCursor?: string | null }, edges: Array<{ __typename: 'SegmentEdge', cursor: string, node: { __typename: 'Segment', id: string, name: string, description: string, shortCode?: string | null, membershipCount: number, uuid: string } }> } };

export type SiteMonitorActivityLogItemFragment = { __typename: 'SiteMonitorActivity', uuid: string, action: Activity_Action, activityType: Activity_Type, createdAt: string, description: string, rawMessage: string };

export type SiteDisconnectMutationVariables = Exact<{
  input: SiteDisconnectInput;
}>;


export type SiteDisconnectMutation = { __typename: 'Mutation', siteDisconnect: boolean };

export type SiteMonitorActivityLogQueryVariables = Exact<{
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<ActivityLogFilter>;
}>;


export type SiteMonitorActivityLogQuery = { __typename: 'Query', siteMonitorActivityLog: { __typename: 'SiteMonitorActivityConnection', pageInfo: { __typename: 'PageInfo', hasNextPage: boolean, hasPreviousPage: boolean, startCursor?: string | null, endCursor?: string | null }, edges: Array<{ __typename: 'SiteMonitorActivityEdge', cursor: string, node: { __typename: 'SiteMonitorActivity', uuid: string, action: Activity_Action, activityType: Activity_Type, createdAt: string, description: string, rawMessage: string } }> } };

export type SteeringWalletConfigurationFragment = { __typename: 'SteeringWalletConfiguration', productGroupId?: string | null, reportingPeriod?: SteeringWalletReportingPeriod | null, basis?: SteeringWalletBasis | null, unitOfMeasure?: Unit_Of_Measure | null };

export type SteeringWalletBasicInfoFragment = { __typename: 'SteeringWallet', uuid: string, name: string, configuration: { __typename: 'SteeringWalletConfiguration', unitOfMeasure?: Unit_Of_Measure | null, basis?: SteeringWalletBasis | null } };

export type SteeringWalletFragment = { __typename: 'SteeringWallet', uuid: string, chainId: string, name: string, status: SteeringWalletStatus, configuration: { __typename: 'SteeringWalletConfiguration', productGroupId?: string | null, reportingPeriod?: SteeringWalletReportingPeriod | null, basis?: SteeringWalletBasis | null, unitOfMeasure?: Unit_Of_Measure | null }, statistics: { __typename: 'WalletSteeringDailySnapshot', walletUuid: string, walletCapacity: number, walletShare?: number | null, walletOpportunity?: number | null, membershipCount?: number | null } };

export type WalletSteeringSurveyConfigurationFragment = { __typename: 'WalletSteeringSurveyConfiguration', steeringWalletUuid?: string | null, questionText?: string | null, minUnits?: number | null, maxUnits?: number | null };

export type WalletSteeringSurveyFragment = { __typename: 'WalletSteeringSurvey', uuid: string, chainId: string, status: SurveyStatus, createdAt: string, deletedAt?: string | null, configuration: { __typename: 'WalletSteeringSurveyConfiguration', steeringWalletUuid?: string | null, questionText?: string | null, minUnits?: number | null, maxUnits?: number | null } };

type Survey_GeneralSurvey_Fragment = { __typename: 'GeneralSurvey', uuid: string, status: SurveyStatus, createdAt: string, chainId: string, award?: { __typename: 'AwardPoints', points: number } | { __typename: 'AwardVouchers', voucherCount: number, voucherExpirationDays?: number | null, voucheredOffer: { __typename: 'Offer', id: string, name: string } } | null };

type Survey_WalletSteeringSurvey_Fragment = { __typename: 'WalletSteeringSurvey', uuid: string, status: SurveyStatus, createdAt: string, chainId: string, award?: { __typename: 'AwardPoints', points: number } | { __typename: 'AwardVouchers', voucherCount: number, voucherExpirationDays?: number | null, voucheredOffer: { __typename: 'Offer', id: string, name: string } } | null };

export type SurveyFragment = Survey_GeneralSurvey_Fragment | Survey_WalletSteeringSurvey_Fragment;

export type SurveyAwardPointsFragment = { __typename: 'AwardPoints', points: number };

export type SurveyAwardVouchersFragment = { __typename: 'AwardVouchers', voucherCount: number, voucherExpirationDays?: number | null, voucheredOffer: { __typename: 'Offer', id: string, name: string } };

export type SteeringWalletCreateMutationVariables = Exact<{
  input: SteeringWalletCreateInput;
}>;


export type SteeringWalletCreateMutation = { __typename: 'Mutation', steeringWalletCreate: { __typename: 'SteeringWallet', uuid: string, chainId: string, name: string, status: SteeringWalletStatus, configuration: { __typename: 'SteeringWalletConfiguration', productGroupId?: string | null, reportingPeriod?: SteeringWalletReportingPeriod | null, basis?: SteeringWalletBasis | null, unitOfMeasure?: Unit_Of_Measure | null }, statistics: { __typename: 'WalletSteeringDailySnapshot', walletUuid: string, walletCapacity: number, walletShare?: number | null, walletOpportunity?: number | null, membershipCount?: number | null } } };

export type SteeringWalletArchiveMutationVariables = Exact<{
  uuid: Scalars['OCUUID']['input'];
}>;


export type SteeringWalletArchiveMutation = { __typename: 'Mutation', steeringWalletArchive: boolean };

export type SteeringWalletUnarchiveMutationVariables = Exact<{
  uuid: Scalars['OCUUID']['input'];
}>;


export type SteeringWalletUnarchiveMutation = { __typename: 'Mutation', steeringWalletUnarchive: boolean };

export type WalletSteeringSurveyCreateMutationVariables = Exact<{
  input: WalletSteeringSurveyCreateInput;
}>;


export type WalletSteeringSurveyCreateMutation = { __typename: 'Mutation', walletSteeringSurveyCreate: { __typename: 'WalletSteeringSurvey', uuid: string, chainId: string, status: SurveyStatus, createdAt: string, deletedAt?: string | null, configuration: { __typename: 'WalletSteeringSurveyConfiguration', steeringWalletUuid?: string | null, questionText?: string | null, minUnits?: number | null, maxUnits?: number | null } } };

export type WalletSteeringSurveyUpdateMutationVariables = Exact<{
  input: WalletSteeringSurveyUpdateInput;
}>;


export type WalletSteeringSurveyUpdateMutation = { __typename: 'Mutation', walletSteeringSurveyUpdate: { __typename: 'WalletSteeringSurvey', uuid: string, chainId: string, status: SurveyStatus, createdAt: string, deletedAt?: string | null, configuration: { __typename: 'WalletSteeringSurveyConfiguration', steeringWalletUuid?: string | null, questionText?: string | null, minUnits?: number | null, maxUnits?: number | null } } };

export type SteeringWalletUpdateMutationVariables = Exact<{
  input: SteeringWalletUpdateInput;
}>;


export type SteeringWalletUpdateMutation = { __typename: 'Mutation', steeringWalletUpdate: { __typename: 'SteeringWallet', uuid: string, chainId: string, name: string, status: SteeringWalletStatus, configuration: { __typename: 'SteeringWalletConfiguration', productGroupId?: string | null, reportingPeriod?: SteeringWalletReportingPeriod | null, basis?: SteeringWalletBasis | null, unitOfMeasure?: Unit_Of_Measure | null }, statistics: { __typename: 'WalletSteeringDailySnapshot', walletUuid: string, walletCapacity: number, walletShare?: number | null, walletOpportunity?: number | null, membershipCount?: number | null } } };

export type SteeringWalletActivateMutationVariables = Exact<{
  uuid: Scalars['OCUUID']['input'];
}>;


export type SteeringWalletActivateMutation = { __typename: 'Mutation', steeringWalletActivate: boolean };

export type SteeringWalletDeactivateMutationVariables = Exact<{
  uuid: Scalars['OCUUID']['input'];
}>;


export type SteeringWalletDeactivateMutation = { __typename: 'Mutation', steeringWalletDeactivate: boolean };

export type SurveyOfferCreateMutationVariables = Exact<{
  input: SurveyOfferCreateInput;
}>;


export type SurveyOfferCreateMutation = { __typename: 'Mutation', surveyOfferCreate: { __typename: 'Offer', id: string, description?: string | null, name: string, engagementType?: Offer_Engagement_Type | null, category?: string | null, publicationStatus: Publication_Status_Type, createdAt: string, expireAt?: string | null, publishAt?: string | null, deleted: boolean, presentationType: Offer_Presentation_Type, presentationPriority: Offer_Presentation_Priority, fulfillmentCount: number, fulfillmentPriorityLevel?: number | null, visibleForCommandCenterFulfillment?: boolean | null, voucherCount: number, ageRestricted: boolean, customData?: object | object[] | null, externalId?: string | null, fundingSource?: Offer_Funding_Source | null, fundingSourceName?: string | null, shortDescription?: string | null, longDescription?: string | null, optionalAtPos?: boolean | null, stackable: boolean, displayForOrderAhead?: boolean | null, allowedForManualVisibilityNotifications?: boolean | null, scanDataConfiguration?: { __typename: 'ScanDataConfiguration', description: string, discountAllocation: number, fundingSource: ScanDataFundingSource } | null, trackingConfig?: { __typename: 'TrackingConfig', trackingId: string, isActivityLogIncludedInAltriaDDM: boolean } | null, campaign?: { __typename: 'Campaign', uuid: string, name: string } | null, marketingContents: Array<{ __typename: 'MarketingContent', id: string, locale: string, title?: string | null, shortDescription?: string | null, longDescription?: string | null, imageUrl?: string | null, terms?: string | null, termsUrl?: string | null, customData?: object | object[] | null, disclaimer?: string | null, disclaimerUrl?: string | null, externalUrl?: string | null, surgeonGeneralsWarning?: string | null, triggeredMessageContent: { __typename: 'OfferTriggeredMessageContent', fulfillmentSms?: string | null, visibilitySms?: string | null, progressSms?: string | null }, receiptContent?: { __typename: 'ReceiptContent', shortDescription?: string | null, longDescription?: string | null } | null }>, limits: Array<{ __typename: 'LimitGlobalActivation', id: string, limit: number } | { __typename: 'LimitGlobalActivationInTime', id: string, limit: number, timePeriod: Limit_Time_Period } | { __typename: 'LimitGlobalAwardCount', id: string, limit: number } | { __typename: 'LimitGlobalAwardCountInTime', id: string, limit: number, timePeriod: Limit_Time_Period } | { __typename: 'LimitInTransactionAwardCount', id: string, limit: number } | { __typename: 'LimitInTransactionProgress', id: string, limit: number } | { __typename: 'LimitMembershipActivation', id: string, limit: number } | { __typename: 'LimitMembershipActivationInTime', id: string, limit: number, timePeriod: Limit_Time_Period } | { __typename: 'LimitMembershipAwardCount', id: string, limit: number } | { __typename: 'LimitMembershipAwardCountInTime', id: string, limit: number, timePeriod: Limit_Time_Period } | { __typename: 'LimitMembershipProgressInTime', id: string, limit: number, timePeriod: Limit_Time_Period } | { __typename: 'LimitMembershipTransactionCount', id: string, limit: number } | { __typename: 'LimitMembershipTransactionCountInTime', id: string, limit: number, timePeriod: Limit_Time_Period }>, constraints: Array<{ __typename: 'ConstraintDaysOfWeek', id: string, availableWeeklyOnDays: Array<Weekday>, startOfDayTimezone: string } | { __typename: 'ConstraintEmailRequired', id: string } | { __typename: 'ConstraintInAudience', id: string, audienceId: string } | { __typename: 'ConstraintInStoreOnly', id: string } | { __typename: 'ConstraintLocationInState', id: string, states: Array<string> } | { __typename: 'ConstraintOrderAheadOnly', id: string } | { __typename: 'ConstraintPaymentInstrument', id: string, paymentInstruments: Array<Payment_Instrument_Type>, paymentInstrumentEvaluationMethod: Payment_Instrument_Evaluation_Method } | { __typename: 'ConstraintPaymentMethod', id: string, paymentMethods: Array<Activate_Payment_Method>, paymentEvaluationMethod: Payment_Method_Evaluation_Method } | { __typename: 'ConstraintPreAuth', id: string } | { __typename: 'ConstraintPurchasableEligibility', id: string, ownershipCondition: Ownership_Condition, voucheredOffers: Array<{ __typename: 'Offer', id: string, name: string }> } | { __typename: 'ConstraintPurchaseThreshold', id: string, eligibleProductGroupIds: Array<string>, countProductsBy: Constraint_Purchase_Threshold_Counting_Attribute, threshold: number } | { __typename: 'ConstraintRequiresActivation', id: string, mustFulfillWithinDays?: number | null, allowMultipleFulfillmentsOnActivation: boolean } | { __typename: 'ConstraintRequiresTransactionVoucher', id: string, allowSingleOfferVoucherStacking?: boolean | null, breakageRefund?: boolean | null, breakagePointRounding?: Breakage_Point_Rounding | null } | { __typename: 'ConstraintRequiresVoucher', id: string } | { __typename: 'ConstraintRequiresVoucherAvailableForDiscount', id: string } | { __typename: 'ConstraintStoreLocation', id: string, evaluationMethod: Store_Location_Evaluation_Method, locations: Array<{ __typename: 'ActivateLocation', id: string, name?: string | null }> } | { __typename: 'ConstraintStoreLocationGroup', id: string, locationGroups: Array<{ __typename: 'LocationGroup', uuid: string, name: string }> } | { __typename: 'ConstraintSubBrand', id: string, subBrandUuids: Array<string> } | { __typename: 'ConstraintTimeOfDay', id: string, availableDailyEndingAtTime: string, availableDailyStartingAtTime: string, timezone: string }>, earningMechanism?: { __typename: 'EarningMechanismExternalFulfillment', id: string, externalFulfillmentAward?: { __typename: 'AwardPoints', points: number } | { __typename: 'AwardVouchers', voucherCount: number, voucherExpirationDays?: number | null, voucheredOffer: { __typename: 'Offer', id: string, name: string, fulfillmentCount: number, engagementType?: Offer_Engagement_Type | null } } | null } | { __typename: 'EarningMechanismLoyaltyEvent', id: string, loyaltyEventEventType: string, loyaltyEventAward?: { __typename: 'AwardExternalPoints', maximum?: number | null } | { __typename: 'AwardPoints', points: number } | { __typename: 'AwardVouchers', voucherCount: number, voucherExpirationDays?: number | null, voucheredOffer: { __typename: 'Offer', id: string, name: string, fulfillmentCount: number, engagementType?: Offer_Engagement_Type | null } } | null } | { __typename: 'EarningMechanismMembershipEvent', id: string, membershipEventEventType: Membership_Event_Type, membershipEventAward: { __typename: 'AwardPoints', points: number } | { __typename: 'AwardVouchers', voucherCount: number, voucherExpirationDays?: number | null, voucheredOffer: { __typename: 'Offer', id: string, name: string, fulfillmentCount: number, engagementType?: Offer_Engagement_Type | null } } } | { __typename: 'EarningMechanismPointSpend', id: string, pointCost: number, offerIsReturnable?: boolean | null, allowedForNewMember?: boolean | null, pointSpendAward: { __typename: 'AwardVouchers', voucherCount: number, voucherExpirationDays?: number | null, voucheredOffer: { __typename: 'Offer', id: string, name: string, fulfillmentCount: number, engagementType?: Offer_Engagement_Type | null } } } | { __typename: 'EarningMechanismProductDiscount', id: string, allowCarryOver: boolean, purchaseThresholdInt: number, productDiscountAward: { __typename: 'AwardBuyAndGet', discountThreshold: number, percentDiscount: number } | { __typename: 'AwardMoneyDiscount', awardPer: Award_Per_Counting_Strategy, moneyAmount: number, partialDiscount: boolean } | { __typename: 'AwardPriceOverride', maximumCost: number }, eligibleProductGroups: Array<{ __typename: 'ProductGroup', id: string, name: string }> } | { __typename: 'EarningMechanismProductPurchase', id: string, countProductsBy: Earning_Mechanism_Product_Counting_Attribute, purchaseThreshold: number, productPurchaseAward: { __typename: 'AwardExternal', provider: ExternalAwardProvider } | { __typename: 'AwardPoints', points: number } | { __typename: 'AwardVouchers', voucherCount: number, voucherExpirationDays?: number | null, voucheredOffer: { __typename: 'Offer', id: string, name: string, fulfillmentCount: number, engagementType?: Offer_Engagement_Type | null } }, eligibleProductGroups: Array<{ __typename: 'ProductGroup', id: string, name: string }> } | { __typename: 'EarningMechanismPromocodes', id: string, codesType: PromocodesOfferType, promocodes: Array<{ __typename: 'Promocode', id: string, code: any, status: PromocodeStatus, publicationStatus: PromocodePublicationStatus, description?: string | null, startDate: string, endDate?: string | null, stats?: { __typename: 'PromocodeUsageStats', redemptions: number, totalOfferRedemptions: number } | null, createdBy: { __typename: 'CommandCenterUser', email: string, name?: string | null } }>, promoCodeGroups: { __typename: 'PromoCodeGroupConnection', edges: Array<{ __typename: 'PromoCodeGroupEdge', node: { __typename: 'PromoCodeGroup', id: string, fileName: string, processingStatus: PromoCodeGroupProcessingStatus, codesStats: { __typename: 'PromoCodeGroupStats', createdCount: number, failedCount: number, totalCount: number } } }> }, award?: { __typename: 'AwardPoints', points: number } | { __typename: 'AwardVouchers', voucherCount: number, voucherExpirationDays?: number | null, voucheredOffer: { __typename: 'Offer', id: string, name: string, fulfillmentCount: number, engagementType?: Offer_Engagement_Type | null } } | null } | { __typename: 'EarningMechanismSpinWheelGame', id: string, purchasableOffer?: { __typename: 'Offer', id: string, name: string } | null, awards: Array<{ __typename: 'RandomAwardConfig', awardType: Random_Award_Type, limit: number, sequenceNumber: number, award?: { __typename: 'AwardPoints', points: number } | { __typename: 'AwardVouchers', voucherExpirationDays?: number | null, voucherCount: number, voucheredOffer: { __typename: 'Offer', id: string, name: string } } | null }> } | { __typename: 'EarningMechanismStoredValueDiscount', id: string, maxDiscountPerTransaction?: number | null, excludedProductGroups: Array<{ __typename: 'ProductGroup', id: string, name: string }> } | { __typename: 'EarningMechanismTotalEligiblePurchase', id: string, countProductsBy: Earning_Mechanism_Product_Counting_Attribute, roundCountedProducts: Earning_Mechanism_Product_Counting_Rounding_Strategy, totalEligiblePurchaseAward: { __typename: 'AwardPointsPer', points: number, rounding: Award_Points_Rounding_Strategy }, eligibleProductGroups: Array<{ __typename: 'ProductGroup', id: string, name: string }> } | { __typename: 'EarningMechanismTotalEligiblePurchaseOverTime', id: string, countProductsBy: Earning_Mechanism_Product_Counting_Attribute, accumulationThreshold: number, stayVisibleWhileInProgress?: boolean | null, hiddenUntilProgress: boolean, totalEligiblePurchaseOverTimeAward: { __typename: 'AwardPoints', points: number } | { __typename: 'AwardVouchers', voucherCount: number, voucherExpirationDays?: number | null, voucheredOffer: { __typename: 'Offer', id: string, name: string, fulfillmentCount: number, engagementType?: Offer_Engagement_Type | null } }, eligibleProductGroups: Array<{ __typename: 'ProductGroup', id: string, name: string }>, purchaseMemberProgress?: { __typename: 'PurchaseProgress', quantityPurchased: number, quantityRequired: number } | null } | { __typename: 'EarningMechanismTotalSpendOnTransaction', id: string, roundMoneyAmount: Earning_Mechanism_Product_Counting_Rounding_Strategy, totalSpendOnTransactionAward: { __typename: 'AwardPointsPer', points: number, rounding: Award_Points_Rounding_Strategy }, ineligibleProductGroups: Array<{ __typename: 'ProductGroup', id: string, name: string }> } | { __typename: 'EarningMechanismTotalSpendOverTime', id: string, accumulationThreshold: number, stayVisibleWhileInProgress?: boolean | null, totalSpendOverTimeAward: { __typename: 'AwardPoints', points: number } | { __typename: 'AwardVouchers', voucherCount: number, voucherExpirationDays?: number | null, voucheredOffer: { __typename: 'Offer', id: string, name: string, fulfillmentCount: number, engagementType?: Offer_Engagement_Type | null } }, ineligibleProductGroups: Array<{ __typename: 'ProductGroup', id: string, name: string }>, purchaseMemberProgress?: { __typename: 'PurchaseProgress', quantityPurchased: number, quantityRequired: number } | null } | { __typename: 'EarningMechanismTransactionDiscount', id: string, purchaseAmountThreshold: number, allowMultipleFulfillmentsPerProductGroupThreshold: boolean, transactionDiscountAward: { __typename: 'AwardTransactionMoneyDiscount', moneyDiscount: number } | { __typename: 'AwardTransactionPercentDiscount', percentDiscount: number }, ineligibleProductGroups: Array<{ __typename: 'ProductGroup', id: string, name: string }> } | { __typename: 'EarningMechanismVarietyDiscount', id: string, varietyDiscountAward: { __typename: 'AwardPriceOverride', maximumCost: number } | { __typename: 'AwardProductDiscount', percentDiscount: number, purchaseThreshold: number, eligibleProductGroups: Array<{ __typename: 'ProductGroup', id: string, name: string }> } | { __typename: 'AwardTransactionMoneyDiscount', moneyDiscount: number }, purchases: Array<{ __typename: 'EarningVarietyDiscountCriteria', purchaseThreshold: number, eligibleProductGroups: Array<{ __typename: 'ProductGroup', id: string, name: string }> }> } | { __typename: 'EarningMechanismVarietyPurchase', id: string, varietyPurchaseAward: { __typename: 'AwardPoints', points: number } | { __typename: 'AwardVouchers', voucherCount: number, voucherExpirationDays?: number | null, voucheredOffer: { __typename: 'Offer', id: string, name: string, fulfillmentCount: number, engagementType?: Offer_Engagement_Type | null } }, products: Array<{ __typename: 'EarningMechanismProductCriteria', id?: string | null, countProductsBy: Earning_Mechanism_Product_Counting_Attribute, purchaseThreshold: number, eligibleProductGroups: Array<{ __typename: 'ProductGroup', id: string, name: string }> }> } | { __typename: 'EarningMechanismVarietyPurchaseOverTime', id: string, preventDoublePunches?: boolean | null, stayVisibleWhileInProgress?: boolean | null, hiddenUntilProgress: boolean, varietyPurchaseOverTimeAward: { __typename: 'AwardPoints', points: number } | { __typename: 'AwardVouchers', voucherCount: number, voucherExpirationDays?: number | null, voucheredOffer: { __typename: 'Offer', id: string, name: string, fulfillmentCount: number, engagementType?: Offer_Engagement_Type | null } }, products: Array<{ __typename: 'EarningMechanismProductCriteria', id?: string | null, countProductsBy: Earning_Mechanism_Product_Counting_Attribute, purchaseThreshold: number, eligibleProductGroups: Array<{ __typename: 'ProductGroup', id: string, name: string }> }>, varietyMemberProgress: Array<{ __typename: 'VarietyProgress', quantityPurchased: number, quantityRequired: number }> } | { __typename: 'EarningMechanismVisits', id: string, visitThreshold: number, visitsAward: { __typename: 'AwardPoints', points: number } | { __typename: 'AwardVouchers', voucherCount: number, voucherExpirationDays?: number | null, voucheredOffer: { __typename: 'Offer', id: string, name: string, fulfillmentCount: number, engagementType?: Offer_Engagement_Type | null } }, visitsMemberProgress?: { __typename: 'VisitsProgress', visits: number, visitsRequired: number } | null } | null, triggerPreferences: { __typename: 'TriggerPreferences', triggerOnFulfillment: boolean, triggerOnVisibility: boolean, triggerOnProgress: boolean }, displayCategories: Array<{ __typename: 'DisplayCategory', id: string, name: string, rank: number, bannerIds?: Array<string> | null, categoryRestrictions?: Category_Restrictions | null, shouldLazyLoadBanners?: boolean | null }> } };

export type SurveyOfferUpdateMutationVariables = Exact<{
  input: SurveyOfferUpdateInput;
}>;


export type SurveyOfferUpdateMutation = { __typename: 'Mutation', surveyOfferUpdate: { __typename: 'Offer', id: string, description?: string | null, name: string, engagementType?: Offer_Engagement_Type | null, category?: string | null, publicationStatus: Publication_Status_Type, createdAt: string, expireAt?: string | null, publishAt?: string | null, deleted: boolean, presentationType: Offer_Presentation_Type, presentationPriority: Offer_Presentation_Priority, fulfillmentCount: number, fulfillmentPriorityLevel?: number | null, visibleForCommandCenterFulfillment?: boolean | null, voucherCount: number, ageRestricted: boolean, customData?: object | object[] | null, externalId?: string | null, fundingSource?: Offer_Funding_Source | null, fundingSourceName?: string | null, shortDescription?: string | null, longDescription?: string | null, optionalAtPos?: boolean | null, stackable: boolean, displayForOrderAhead?: boolean | null, allowedForManualVisibilityNotifications?: boolean | null, scanDataConfiguration?: { __typename: 'ScanDataConfiguration', description: string, discountAllocation: number, fundingSource: ScanDataFundingSource } | null, trackingConfig?: { __typename: 'TrackingConfig', trackingId: string, isActivityLogIncludedInAltriaDDM: boolean } | null, campaign?: { __typename: 'Campaign', uuid: string, name: string } | null, marketingContents: Array<{ __typename: 'MarketingContent', id: string, locale: string, title?: string | null, shortDescription?: string | null, longDescription?: string | null, imageUrl?: string | null, terms?: string | null, termsUrl?: string | null, customData?: object | object[] | null, disclaimer?: string | null, disclaimerUrl?: string | null, externalUrl?: string | null, surgeonGeneralsWarning?: string | null, triggeredMessageContent: { __typename: 'OfferTriggeredMessageContent', fulfillmentSms?: string | null, visibilitySms?: string | null, progressSms?: string | null }, receiptContent?: { __typename: 'ReceiptContent', shortDescription?: string | null, longDescription?: string | null } | null }>, limits: Array<{ __typename: 'LimitGlobalActivation', id: string, limit: number } | { __typename: 'LimitGlobalActivationInTime', id: string, limit: number, timePeriod: Limit_Time_Period } | { __typename: 'LimitGlobalAwardCount', id: string, limit: number } | { __typename: 'LimitGlobalAwardCountInTime', id: string, limit: number, timePeriod: Limit_Time_Period } | { __typename: 'LimitInTransactionAwardCount', id: string, limit: number } | { __typename: 'LimitInTransactionProgress', id: string, limit: number } | { __typename: 'LimitMembershipActivation', id: string, limit: number } | { __typename: 'LimitMembershipActivationInTime', id: string, limit: number, timePeriod: Limit_Time_Period } | { __typename: 'LimitMembershipAwardCount', id: string, limit: number } | { __typename: 'LimitMembershipAwardCountInTime', id: string, limit: number, timePeriod: Limit_Time_Period } | { __typename: 'LimitMembershipProgressInTime', id: string, limit: number, timePeriod: Limit_Time_Period } | { __typename: 'LimitMembershipTransactionCount', id: string, limit: number } | { __typename: 'LimitMembershipTransactionCountInTime', id: string, limit: number, timePeriod: Limit_Time_Period }>, constraints: Array<{ __typename: 'ConstraintDaysOfWeek', id: string, availableWeeklyOnDays: Array<Weekday>, startOfDayTimezone: string } | { __typename: 'ConstraintEmailRequired', id: string } | { __typename: 'ConstraintInAudience', id: string, audienceId: string } | { __typename: 'ConstraintInStoreOnly', id: string } | { __typename: 'ConstraintLocationInState', id: string, states: Array<string> } | { __typename: 'ConstraintOrderAheadOnly', id: string } | { __typename: 'ConstraintPaymentInstrument', id: string, paymentInstruments: Array<Payment_Instrument_Type>, paymentInstrumentEvaluationMethod: Payment_Instrument_Evaluation_Method } | { __typename: 'ConstraintPaymentMethod', id: string, paymentMethods: Array<Activate_Payment_Method>, paymentEvaluationMethod: Payment_Method_Evaluation_Method } | { __typename: 'ConstraintPreAuth', id: string } | { __typename: 'ConstraintPurchasableEligibility', id: string, ownershipCondition: Ownership_Condition, voucheredOffers: Array<{ __typename: 'Offer', id: string, name: string }> } | { __typename: 'ConstraintPurchaseThreshold', id: string, eligibleProductGroupIds: Array<string>, countProductsBy: Constraint_Purchase_Threshold_Counting_Attribute, threshold: number } | { __typename: 'ConstraintRequiresActivation', id: string, mustFulfillWithinDays?: number | null, allowMultipleFulfillmentsOnActivation: boolean } | { __typename: 'ConstraintRequiresTransactionVoucher', id: string, allowSingleOfferVoucherStacking?: boolean | null, breakageRefund?: boolean | null, breakagePointRounding?: Breakage_Point_Rounding | null } | { __typename: 'ConstraintRequiresVoucher', id: string } | { __typename: 'ConstraintRequiresVoucherAvailableForDiscount', id: string } | { __typename: 'ConstraintStoreLocation', id: string, evaluationMethod: Store_Location_Evaluation_Method, locations: Array<{ __typename: 'ActivateLocation', id: string, name?: string | null }> } | { __typename: 'ConstraintStoreLocationGroup', id: string, locationGroups: Array<{ __typename: 'LocationGroup', uuid: string, name: string }> } | { __typename: 'ConstraintSubBrand', id: string, subBrandUuids: Array<string> } | { __typename: 'ConstraintTimeOfDay', id: string, availableDailyEndingAtTime: string, availableDailyStartingAtTime: string, timezone: string }>, earningMechanism?: { __typename: 'EarningMechanismExternalFulfillment', id: string, externalFulfillmentAward?: { __typename: 'AwardPoints', points: number } | { __typename: 'AwardVouchers', voucherCount: number, voucherExpirationDays?: number | null, voucheredOffer: { __typename: 'Offer', id: string, name: string, fulfillmentCount: number, engagementType?: Offer_Engagement_Type | null } } | null } | { __typename: 'EarningMechanismLoyaltyEvent', id: string, loyaltyEventEventType: string, loyaltyEventAward?: { __typename: 'AwardExternalPoints', maximum?: number | null } | { __typename: 'AwardPoints', points: number } | { __typename: 'AwardVouchers', voucherCount: number, voucherExpirationDays?: number | null, voucheredOffer: { __typename: 'Offer', id: string, name: string, fulfillmentCount: number, engagementType?: Offer_Engagement_Type | null } } | null } | { __typename: 'EarningMechanismMembershipEvent', id: string, membershipEventEventType: Membership_Event_Type, membershipEventAward: { __typename: 'AwardPoints', points: number } | { __typename: 'AwardVouchers', voucherCount: number, voucherExpirationDays?: number | null, voucheredOffer: { __typename: 'Offer', id: string, name: string, fulfillmentCount: number, engagementType?: Offer_Engagement_Type | null } } } | { __typename: 'EarningMechanismPointSpend', id: string, pointCost: number, offerIsReturnable?: boolean | null, allowedForNewMember?: boolean | null, pointSpendAward: { __typename: 'AwardVouchers', voucherCount: number, voucherExpirationDays?: number | null, voucheredOffer: { __typename: 'Offer', id: string, name: string, fulfillmentCount: number, engagementType?: Offer_Engagement_Type | null } } } | { __typename: 'EarningMechanismProductDiscount', id: string, allowCarryOver: boolean, purchaseThresholdInt: number, productDiscountAward: { __typename: 'AwardBuyAndGet', discountThreshold: number, percentDiscount: number } | { __typename: 'AwardMoneyDiscount', awardPer: Award_Per_Counting_Strategy, moneyAmount: number, partialDiscount: boolean } | { __typename: 'AwardPriceOverride', maximumCost: number }, eligibleProductGroups: Array<{ __typename: 'ProductGroup', id: string, name: string }> } | { __typename: 'EarningMechanismProductPurchase', id: string, countProductsBy: Earning_Mechanism_Product_Counting_Attribute, purchaseThreshold: number, productPurchaseAward: { __typename: 'AwardExternal', provider: ExternalAwardProvider } | { __typename: 'AwardPoints', points: number } | { __typename: 'AwardVouchers', voucherCount: number, voucherExpirationDays?: number | null, voucheredOffer: { __typename: 'Offer', id: string, name: string, fulfillmentCount: number, engagementType?: Offer_Engagement_Type | null } }, eligibleProductGroups: Array<{ __typename: 'ProductGroup', id: string, name: string }> } | { __typename: 'EarningMechanismPromocodes', id: string, codesType: PromocodesOfferType, promocodes: Array<{ __typename: 'Promocode', id: string, code: any, status: PromocodeStatus, publicationStatus: PromocodePublicationStatus, description?: string | null, startDate: string, endDate?: string | null, stats?: { __typename: 'PromocodeUsageStats', redemptions: number, totalOfferRedemptions: number } | null, createdBy: { __typename: 'CommandCenterUser', email: string, name?: string | null } }>, promoCodeGroups: { __typename: 'PromoCodeGroupConnection', edges: Array<{ __typename: 'PromoCodeGroupEdge', node: { __typename: 'PromoCodeGroup', id: string, fileName: string, processingStatus: PromoCodeGroupProcessingStatus, codesStats: { __typename: 'PromoCodeGroupStats', createdCount: number, failedCount: number, totalCount: number } } }> }, award?: { __typename: 'AwardPoints', points: number } | { __typename: 'AwardVouchers', voucherCount: number, voucherExpirationDays?: number | null, voucheredOffer: { __typename: 'Offer', id: string, name: string, fulfillmentCount: number, engagementType?: Offer_Engagement_Type | null } } | null } | { __typename: 'EarningMechanismSpinWheelGame', id: string, purchasableOffer?: { __typename: 'Offer', id: string, name: string } | null, awards: Array<{ __typename: 'RandomAwardConfig', awardType: Random_Award_Type, limit: number, sequenceNumber: number, award?: { __typename: 'AwardPoints', points: number } | { __typename: 'AwardVouchers', voucherExpirationDays?: number | null, voucherCount: number, voucheredOffer: { __typename: 'Offer', id: string, name: string } } | null }> } | { __typename: 'EarningMechanismStoredValueDiscount', id: string, maxDiscountPerTransaction?: number | null, excludedProductGroups: Array<{ __typename: 'ProductGroup', id: string, name: string }> } | { __typename: 'EarningMechanismTotalEligiblePurchase', id: string, countProductsBy: Earning_Mechanism_Product_Counting_Attribute, roundCountedProducts: Earning_Mechanism_Product_Counting_Rounding_Strategy, totalEligiblePurchaseAward: { __typename: 'AwardPointsPer', points: number, rounding: Award_Points_Rounding_Strategy }, eligibleProductGroups: Array<{ __typename: 'ProductGroup', id: string, name: string }> } | { __typename: 'EarningMechanismTotalEligiblePurchaseOverTime', id: string, countProductsBy: Earning_Mechanism_Product_Counting_Attribute, accumulationThreshold: number, stayVisibleWhileInProgress?: boolean | null, hiddenUntilProgress: boolean, totalEligiblePurchaseOverTimeAward: { __typename: 'AwardPoints', points: number } | { __typename: 'AwardVouchers', voucherCount: number, voucherExpirationDays?: number | null, voucheredOffer: { __typename: 'Offer', id: string, name: string, fulfillmentCount: number, engagementType?: Offer_Engagement_Type | null } }, eligibleProductGroups: Array<{ __typename: 'ProductGroup', id: string, name: string }>, purchaseMemberProgress?: { __typename: 'PurchaseProgress', quantityPurchased: number, quantityRequired: number } | null } | { __typename: 'EarningMechanismTotalSpendOnTransaction', id: string, roundMoneyAmount: Earning_Mechanism_Product_Counting_Rounding_Strategy, totalSpendOnTransactionAward: { __typename: 'AwardPointsPer', points: number, rounding: Award_Points_Rounding_Strategy }, ineligibleProductGroups: Array<{ __typename: 'ProductGroup', id: string, name: string }> } | { __typename: 'EarningMechanismTotalSpendOverTime', id: string, accumulationThreshold: number, stayVisibleWhileInProgress?: boolean | null, totalSpendOverTimeAward: { __typename: 'AwardPoints', points: number } | { __typename: 'AwardVouchers', voucherCount: number, voucherExpirationDays?: number | null, voucheredOffer: { __typename: 'Offer', id: string, name: string, fulfillmentCount: number, engagementType?: Offer_Engagement_Type | null } }, ineligibleProductGroups: Array<{ __typename: 'ProductGroup', id: string, name: string }>, purchaseMemberProgress?: { __typename: 'PurchaseProgress', quantityPurchased: number, quantityRequired: number } | null } | { __typename: 'EarningMechanismTransactionDiscount', id: string, purchaseAmountThreshold: number, allowMultipleFulfillmentsPerProductGroupThreshold: boolean, transactionDiscountAward: { __typename: 'AwardTransactionMoneyDiscount', moneyDiscount: number } | { __typename: 'AwardTransactionPercentDiscount', percentDiscount: number }, ineligibleProductGroups: Array<{ __typename: 'ProductGroup', id: string, name: string }> } | { __typename: 'EarningMechanismVarietyDiscount', id: string, varietyDiscountAward: { __typename: 'AwardPriceOverride', maximumCost: number } | { __typename: 'AwardProductDiscount', percentDiscount: number, purchaseThreshold: number, eligibleProductGroups: Array<{ __typename: 'ProductGroup', id: string, name: string }> } | { __typename: 'AwardTransactionMoneyDiscount', moneyDiscount: number }, purchases: Array<{ __typename: 'EarningVarietyDiscountCriteria', purchaseThreshold: number, eligibleProductGroups: Array<{ __typename: 'ProductGroup', id: string, name: string }> }> } | { __typename: 'EarningMechanismVarietyPurchase', id: string, varietyPurchaseAward: { __typename: 'AwardPoints', points: number } | { __typename: 'AwardVouchers', voucherCount: number, voucherExpirationDays?: number | null, voucheredOffer: { __typename: 'Offer', id: string, name: string, fulfillmentCount: number, engagementType?: Offer_Engagement_Type | null } }, products: Array<{ __typename: 'EarningMechanismProductCriteria', id?: string | null, countProductsBy: Earning_Mechanism_Product_Counting_Attribute, purchaseThreshold: number, eligibleProductGroups: Array<{ __typename: 'ProductGroup', id: string, name: string }> }> } | { __typename: 'EarningMechanismVarietyPurchaseOverTime', id: string, preventDoublePunches?: boolean | null, stayVisibleWhileInProgress?: boolean | null, hiddenUntilProgress: boolean, varietyPurchaseOverTimeAward: { __typename: 'AwardPoints', points: number } | { __typename: 'AwardVouchers', voucherCount: number, voucherExpirationDays?: number | null, voucheredOffer: { __typename: 'Offer', id: string, name: string, fulfillmentCount: number, engagementType?: Offer_Engagement_Type | null } }, products: Array<{ __typename: 'EarningMechanismProductCriteria', id?: string | null, countProductsBy: Earning_Mechanism_Product_Counting_Attribute, purchaseThreshold: number, eligibleProductGroups: Array<{ __typename: 'ProductGroup', id: string, name: string }> }>, varietyMemberProgress: Array<{ __typename: 'VarietyProgress', quantityPurchased: number, quantityRequired: number }> } | { __typename: 'EarningMechanismVisits', id: string, visitThreshold: number, visitsAward: { __typename: 'AwardPoints', points: number } | { __typename: 'AwardVouchers', voucherCount: number, voucherExpirationDays?: number | null, voucheredOffer: { __typename: 'Offer', id: string, name: string, fulfillmentCount: number, engagementType?: Offer_Engagement_Type | null } }, visitsMemberProgress?: { __typename: 'VisitsProgress', visits: number, visitsRequired: number } | null } | null, triggerPreferences: { __typename: 'TriggerPreferences', triggerOnFulfillment: boolean, triggerOnVisibility: boolean, triggerOnProgress: boolean }, displayCategories: Array<{ __typename: 'DisplayCategory', id: string, name: string, rank: number, bannerIds?: Array<string> | null, categoryRestrictions?: Category_Restrictions | null, shouldLazyLoadBanners?: boolean | null }> } };

export type SurveyOfferDeleteMutationVariables = Exact<{
  surveyUuid: Scalars['ID']['input'];
}>;


export type SurveyOfferDeleteMutation = { __typename: 'Mutation', surveyOfferDelete: boolean };

export type SteeringWalletsQueryVariables = Exact<{
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  after?: InputMaybe<Scalars['OCBase64Cursor']['input']>;
  before?: InputMaybe<Scalars['OCBase64Cursor']['input']>;
  filter?: InputMaybe<SteeringWalletFilter>;
}>;


export type SteeringWalletsQuery = { __typename: 'Query', steeringWallets: { __typename: 'SteeringWalletConnection', pageInfo: { __typename: 'PageInfo', hasNextPage: boolean, hasPreviousPage: boolean, startCursor?: string | null, endCursor?: string | null }, edges: Array<{ __typename: 'SteeringWalletEdge', cursor: string, node: { __typename: 'SteeringWallet', uuid: string, chainId: string, name: string, status: SteeringWalletStatus, configuration: { __typename: 'SteeringWalletConfiguration', productGroupId?: string | null, reportingPeriod?: SteeringWalletReportingPeriod | null, basis?: SteeringWalletBasis | null, unitOfMeasure?: Unit_Of_Measure | null }, statistics: { __typename: 'WalletSteeringDailySnapshot', walletUuid: string, walletCapacity: number, walletShare?: number | null, walletOpportunity?: number | null, membershipCount?: number | null } } }> } };

export type GetBasicInfoSteeringWalletsQueryVariables = Exact<{
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  after?: InputMaybe<Scalars['OCBase64Cursor']['input']>;
  before?: InputMaybe<Scalars['OCBase64Cursor']['input']>;
  filter?: InputMaybe<SteeringWalletFilter>;
}>;


export type GetBasicInfoSteeringWalletsQuery = { __typename: 'Query', steeringWallets: { __typename: 'SteeringWalletConnection', pageInfo: { __typename: 'PageInfo', hasNextPage: boolean, hasPreviousPage: boolean, startCursor?: string | null, endCursor?: string | null }, edges: Array<{ __typename: 'SteeringWalletEdge', cursor: string, node: { __typename: 'SteeringWallet', uuid: string, name: string, configuration: { __typename: 'SteeringWalletConfiguration', unitOfMeasure?: Unit_Of_Measure | null, basis?: SteeringWalletBasis | null } } }> } };

export type SteeringWalletQueryVariables = Exact<{
  uuid: Scalars['OCUUID']['input'];
}>;


export type SteeringWalletQuery = { __typename: 'Query', steeringWallet: { __typename: 'SteeringWallet', uuid: string, chainId: string, name: string, status: SteeringWalletStatus, configuration: { __typename: 'SteeringWalletConfiguration', productGroupId?: string | null, reportingPeriod?: SteeringWalletReportingPeriod | null, basis?: SteeringWalletBasis | null, unitOfMeasure?: Unit_Of_Measure | null }, statistics: { __typename: 'WalletSteeringDailySnapshot', walletUuid: string, walletCapacity: number, walletShare?: number | null, walletOpportunity?: number | null, membershipCount?: number | null } } };

export type SurveysQueryVariables = Exact<{
  filter?: InputMaybe<SurveyFilter>;
  after?: InputMaybe<Scalars['OCBase64Cursor']['input']>;
  before?: InputMaybe<Scalars['OCBase64Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
}>;


export type SurveysQuery = { __typename: 'Query', surveys: { __typename: 'SurveyConnection', pageInfo: { __typename: 'PageInfo', hasNextPage: boolean, hasPreviousPage: boolean, startCursor?: string | null, endCursor?: string | null }, edges: Array<{ __typename: 'SurveyEdge', cursor: string, node: { __typename: 'GeneralSurvey', uuid: string, status: SurveyStatus, createdAt: string, chainId: string, award?: { __typename: 'AwardPoints', points: number } | { __typename: 'AwardVouchers', voucherCount: number, voucherExpirationDays?: number | null, voucheredOffer: { __typename: 'Offer', id: string, name: string } } | null } | { __typename: 'WalletSteeringSurvey', uuid: string, status: SurveyStatus, createdAt: string, chainId: string, configuration: { __typename: 'WalletSteeringSurveyConfiguration', steeringWalletUuid?: string | null, questionText?: string | null, minUnits?: number | null, maxUnits?: number | null }, award?: { __typename: 'AwardPoints', points: number } | { __typename: 'AwardVouchers', voucherCount: number, voucherExpirationDays?: number | null, voucheredOffer: { __typename: 'Offer', id: string, name: string } } | null } }> } };

export type WalletsForMembershipQueryVariables = Exact<{
  membershipId: Scalars['OCUUID']['input'];
  after?: InputMaybe<Scalars['OCBase64Cursor']['input']>;
  before?: InputMaybe<Scalars['OCBase64Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
}>;


export type WalletsForMembershipQuery = { __typename: 'Query', walletsForMembership: { __typename: 'WalletConnection', pageInfo: { __typename: 'PageInfo', hasNextPage: boolean, hasPreviousPage: boolean, startCursor?: string | null, endCursor?: string | null }, edges: Array<{ __typename: 'WalletEdge', cursor: string, node: { __typename: 'SteeringWallet', uuid: string, chainId: string, name: string, status: SteeringWalletStatus, configuration: { __typename: 'SteeringWalletConfiguration', productGroupId?: string | null, reportingPeriod?: SteeringWalletReportingPeriod | null, basis?: SteeringWalletBasis | null, unitOfMeasure?: Unit_Of_Measure | null }, statistics: { __typename: 'WalletSteeringDailySnapshot', walletUuid: string, walletCapacity: number, walletShare?: number | null, walletOpportunity?: number | null, membershipCount?: number | null } } }> } };

export type SubBrandFragment = { __typename: 'SubBrand', name: string, uuid: string };

export type SubBrandsQueryVariables = Exact<{ [key: string]: never; }>;


export type SubBrandsQuery = { __typename: 'Query', subBrands: { __typename: 'SubBrandConnection', edges: Array<{ __typename: 'SubBrandEdge', cursor: string, node: { __typename: 'SubBrand', name: string, uuid: string } }> } };

export type GeneralSurveyFragment = { __typename: 'GeneralSurvey', name: string, description?: string | null, audienceUuid: string, uuid: string, status: SurveyStatus, createdAt: string, chainId: string, configuration: { __typename: 'GeneralSurveyConfiguration', startDate: string, endDate?: string | null }, questions: Array<{ __typename: 'SurveyQuestionIntSlider', max: number, min: number, uuid: string, index: number, questionText: string } | { __typename: 'SurveyQuestionMultipleChoice', uuid: string, index: number, questionText: string, options: Array<{ __typename: 'SurveyQuestionOption', uuid: string, index: number, label: string }> } | { __typename: 'SurveyQuestionSingleChoice', uuid: string, index: number, questionText: string, options: Array<{ __typename: 'SurveyQuestionOption', uuid: string, index: number, label: string }> }>, award?: { __typename: 'AwardPoints', points: number } | { __typename: 'AwardVouchers', voucherCount: number, voucherExpirationDays?: number | null, voucheredOffer: { __typename: 'Offer', id: string, name: string } } | null };

type SurveyQuestion_SurveyQuestionIntSlider_Fragment = { __typename: 'SurveyQuestionIntSlider', uuid: string, index: number, questionText: string };

type SurveyQuestion_SurveyQuestionMultipleChoice_Fragment = { __typename: 'SurveyQuestionMultipleChoice', uuid: string, index: number, questionText: string };

type SurveyQuestion_SurveyQuestionSingleChoice_Fragment = { __typename: 'SurveyQuestionSingleChoice', uuid: string, index: number, questionText: string };

export type SurveyQuestionFragment = SurveyQuestion_SurveyQuestionIntSlider_Fragment | SurveyQuestion_SurveyQuestionMultipleChoice_Fragment | SurveyQuestion_SurveyQuestionSingleChoice_Fragment;

export type SurveyQuestionOptionFragment = { __typename: 'SurveyQuestionOption', uuid: string, index: number, label: string };

export type SurveyQuestionIntSliderFragment = { __typename: 'SurveyQuestionIntSlider', max: number, min: number, uuid: string, index: number, questionText: string };

export type SurveyQuestionMultipleChoiceFragment = { __typename: 'SurveyQuestionMultipleChoice', uuid: string, index: number, questionText: string, options: Array<{ __typename: 'SurveyQuestionOption', uuid: string, index: number, label: string }> };

export type SurveyQuestionSingleChoiceFragment = { __typename: 'SurveyQuestionSingleChoice', uuid: string, index: number, questionText: string, options: Array<{ __typename: 'SurveyQuestionOption', uuid: string, index: number, label: string }> };

export type SurveyLocationStatisticsFragment = { __typename: 'SurveyLocationStatistics', bottomResponse: string, bottomResponsePercentage: number, siteId: string, siteName: string, surveyUuid: string, topResponse: string, topResponsePercentage: number, totalResponses: number, responseStatistics: { __typename: 'SurveyQuestionResponseStatistics', locationUuid?: string | null, optionSelectionCounters: Array<{ __typename: 'OptionSelectionCount', count: number, optionLabel: string }>, sliderResponseRanges: Array<{ __typename: 'SliderResponseRange', count: number, rangeStart: number, rangeEnd: number }> } };

export type SurveyEngagementMetricsFragment = { __typename: 'SurveyEngagementMetrics', dailyAverageCount: number, totalCount: number, counters: Array<{ __typename: 'SurveyEngagementCounter', count: number, date: string }> };

export type SurveyMetricsFragment = { __typename: 'SurveyMetrics', responses: { __typename: 'SurveyEngagementMetrics', dailyAverageCount: number, totalCount: number }, views: { __typename: 'SurveyEngagementMetrics', dailyAverageCount: number, totalCount: number, counters: Array<{ __typename: 'SurveyEngagementCounter', count: number, date: string }> } };

export type OptionSelectionCounterFragment = { __typename: 'OptionSelectionCount', count: number, optionLabel: string };

export type SliderResponseRangeFragment = { __typename: 'SliderResponseRange', count: number, rangeStart: number, rangeEnd: number };

export type GeneralSurveyCreateMutationVariables = Exact<{
  input: GeneralSurveyCreateInput;
}>;


export type GeneralSurveyCreateMutation = { __typename: 'Mutation', generalSurveyCreate: { __typename: 'GeneralSurvey', name: string, description?: string | null, audienceUuid: string, uuid: string, status: SurveyStatus, createdAt: string, chainId: string, configuration: { __typename: 'GeneralSurveyConfiguration', startDate: string, endDate?: string | null }, questions: Array<{ __typename: 'SurveyQuestionIntSlider', max: number, min: number, uuid: string, index: number, questionText: string } | { __typename: 'SurveyQuestionMultipleChoice', uuid: string, index: number, questionText: string, options: Array<{ __typename: 'SurveyQuestionOption', uuid: string, index: number, label: string }> } | { __typename: 'SurveyQuestionSingleChoice', uuid: string, index: number, questionText: string, options: Array<{ __typename: 'SurveyQuestionOption', uuid: string, index: number, label: string }> }>, award?: { __typename: 'AwardPoints', points: number } | { __typename: 'AwardVouchers', voucherCount: number, voucherExpirationDays?: number | null, voucheredOffer: { __typename: 'Offer', id: string, name: string } } | null } };

export type GeneralSurveyUpdateMutationVariables = Exact<{
  input: GeneralSurveyUpdateInput;
}>;


export type GeneralSurveyUpdateMutation = { __typename: 'Mutation', generalSurveyUpdate: { __typename: 'GeneralSurvey', name: string, description?: string | null, audienceUuid: string, uuid: string, status: SurveyStatus, createdAt: string, chainId: string, configuration: { __typename: 'GeneralSurveyConfiguration', startDate: string, endDate?: string | null }, questions: Array<{ __typename: 'SurveyQuestionIntSlider', max: number, min: number, uuid: string, index: number, questionText: string } | { __typename: 'SurveyQuestionMultipleChoice', uuid: string, index: number, questionText: string, options: Array<{ __typename: 'SurveyQuestionOption', uuid: string, index: number, label: string }> } | { __typename: 'SurveyQuestionSingleChoice', uuid: string, index: number, questionText: string, options: Array<{ __typename: 'SurveyQuestionOption', uuid: string, index: number, label: string }> }>, award?: { __typename: 'AwardPoints', points: number } | { __typename: 'AwardVouchers', voucherCount: number, voucherExpirationDays?: number | null, voucheredOffer: { __typename: 'Offer', id: string, name: string } } | null } };

export type GeneralSurveyStatusUpdateMutationVariables = Exact<{
  input: GeneralSurveyStatusUpdateInput;
}>;


export type GeneralSurveyStatusUpdateMutation = { __typename: 'Mutation', generalSurveyStatusUpdate: { __typename: 'GeneralSurvey', name: string, description?: string | null, audienceUuid: string, uuid: string, status: SurveyStatus, createdAt: string, chainId: string, configuration: { __typename: 'GeneralSurveyConfiguration', startDate: string, endDate?: string | null }, questions: Array<{ __typename: 'SurveyQuestionIntSlider', max: number, min: number, uuid: string, index: number, questionText: string } | { __typename: 'SurveyQuestionMultipleChoice', uuid: string, index: number, questionText: string, options: Array<{ __typename: 'SurveyQuestionOption', uuid: string, index: number, label: string }> } | { __typename: 'SurveyQuestionSingleChoice', uuid: string, index: number, questionText: string, options: Array<{ __typename: 'SurveyQuestionOption', uuid: string, index: number, label: string }> }>, award?: { __typename: 'AwardPoints', points: number } | { __typename: 'AwardVouchers', voucherCount: number, voucherExpirationDays?: number | null, voucheredOffer: { __typename: 'Offer', id: string, name: string } } | null } };

export type GeneralSurveysQueryVariables = Exact<{
  filter?: InputMaybe<SurveyFilter>;
  after?: InputMaybe<Scalars['OCBase64Cursor']['input']>;
  before?: InputMaybe<Scalars['OCBase64Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
}>;


export type GeneralSurveysQuery = { __typename: 'Query', surveys: { __typename: 'SurveyConnection', pageInfo: { __typename: 'PageInfo', hasNextPage: boolean, hasPreviousPage: boolean, startCursor?: string | null, endCursor?: string | null }, edges: Array<{ __typename: 'SurveyEdge', cursor: string, node: { __typename: 'GeneralSurvey', name: string, description?: string | null, audienceUuid: string, uuid: string, status: SurveyStatus, createdAt: string, chainId: string, configuration: { __typename: 'GeneralSurveyConfiguration', startDate: string, endDate?: string | null }, questions: Array<{ __typename: 'SurveyQuestionIntSlider', max: number, min: number, uuid: string, index: number, questionText: string } | { __typename: 'SurveyQuestionMultipleChoice', uuid: string, index: number, questionText: string, options: Array<{ __typename: 'SurveyQuestionOption', uuid: string, index: number, label: string }> } | { __typename: 'SurveyQuestionSingleChoice', uuid: string, index: number, questionText: string, options: Array<{ __typename: 'SurveyQuestionOption', uuid: string, index: number, label: string }> }>, award?: { __typename: 'AwardPoints', points: number } | { __typename: 'AwardVouchers', voucherCount: number, voucherExpirationDays?: number | null, voucheredOffer: { __typename: 'Offer', id: string, name: string } } | null } | { __typename: 'WalletSteeringSurvey' } }> } };

export type GeneralSurveyQueryVariables = Exact<{
  uuid: Scalars['OCUUID']['input'];
}>;


export type GeneralSurveyQuery = { __typename: 'Query', survey: { __typename: 'GeneralSurvey', name: string, description?: string | null, audienceUuid: string, uuid: string, status: SurveyStatus, createdAt: string, chainId: string, configuration: { __typename: 'GeneralSurveyConfiguration', startDate: string, endDate?: string | null }, questions: Array<{ __typename: 'SurveyQuestionIntSlider', max: number, min: number, uuid: string, index: number, questionText: string } | { __typename: 'SurveyQuestionMultipleChoice', uuid: string, index: number, questionText: string, options: Array<{ __typename: 'SurveyQuestionOption', uuid: string, index: number, label: string }> } | { __typename: 'SurveyQuestionSingleChoice', uuid: string, index: number, questionText: string, options: Array<{ __typename: 'SurveyQuestionOption', uuid: string, index: number, label: string }> }>, award?: { __typename: 'AwardPoints', points: number } | { __typename: 'AwardVouchers', voucherCount: number, voucherExpirationDays?: number | null, voucheredOffer: { __typename: 'Offer', id: string, name: string } } | null } | { __typename: 'WalletSteeringSurvey' } };

export type SurveyQuestionResponseStatisticsQueryVariables = Exact<{
  questionUuid: Scalars['OCUUID']['input'];
}>;


export type SurveyQuestionResponseStatisticsQuery = { __typename: 'Query', surveyQuestionResponseStatistics: { __typename: 'SurveyQuestionResponseStatistics', optionSelectionCounters: Array<{ __typename: 'OptionSelectionCount', count: number, optionLabel: string }>, sliderResponseRanges: Array<{ __typename: 'SliderResponseRange', count: number, rangeStart: number, rangeEnd: number }> } };

export type SurveyLocationStatisticsQueryVariables = Exact<{
  filter?: InputMaybe<SurveyLocationStatisticsFilter>;
  after?: InputMaybe<Scalars['OCBase64Cursor']['input']>;
  before?: InputMaybe<Scalars['OCBase64Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SurveyLocationStatisticsSort>;
}>;


export type SurveyLocationStatisticsQuery = { __typename: 'Query', surveyLocationStatistics: { __typename: 'SurveyLocationStatisticsConnection', pageInfo: { __typename: 'PageInfo', hasNextPage: boolean, hasPreviousPage: boolean, startCursor?: string | null, endCursor?: string | null }, edges: Array<{ __typename: 'SurveyLocationStatisticsEdge', cursor: string, node: { __typename: 'SurveyLocationStatistics', bottomResponse: string, bottomResponsePercentage: number, siteId: string, siteName: string, surveyUuid: string, topResponse: string, topResponsePercentage: number, totalResponses: number, responseStatistics: { __typename: 'SurveyQuestionResponseStatistics', locationUuid?: string | null, optionSelectionCounters: Array<{ __typename: 'OptionSelectionCount', count: number, optionLabel: string }>, sliderResponseRanges: Array<{ __typename: 'SliderResponseRange', count: number, rangeStart: number, rangeEnd: number }> } } }> } };

export type SurveyMetricsQueryVariables = Exact<{
  filter?: InputMaybe<SurveyMetricsFilter>;
}>;


export type SurveyMetricsQuery = { __typename: 'Query', surveyMetrics: { __typename: 'SurveyMetrics', responses: { __typename: 'SurveyEngagementMetrics', dailyAverageCount: number, totalCount: number }, views: { __typename: 'SurveyEngagementMetrics', dailyAverageCount: number, totalCount: number, counters: Array<{ __typename: 'SurveyEngagementCounter', count: number, date: string }> } } };

export type TransactionFragment = { __typename: 'Transaction', uuid: string, fraudCheckStatus: FraudCheckStatus, authCode?: string | null, primaryStatus: Primary_Transaction_Status, startedAt: string, completedAt?: string | null, posTransactionNumber?: string | null, location?: { __typename: 'Location', uuid: string, brandSpecificLocationId?: string | null, address?: { __typename: 'Address', street1: string, city: string, countryCode: string, state: string, zipCode: string } | null, siteSystemConfiguration: Array<{ __typename: 'SiteSystemConfiguration', identifier: string }> } | null, amount?: { __typename: 'ItemPrice', displayPrice: string, price: number } | null, paymentInfo?: Array<{ __typename: 'TransactionPaymentInfo', cardType?: string | null, cardCircuit?: string | null, paymentMethod?: Payment_Method | null } | null> | null, customer?: { __typename: 'TransactionCustomer', phoneNumber: string } | null };

export type TransactionDetailsFragment = { __typename: 'Transaction', uuid: string, authCode?: string | null, primaryStatus: Primary_Transaction_Status, createdAt: string, startedAt: string, completedAt?: string | null, location?: { __typename: 'Location', uuid: string, brandSpecificLocationId?: string | null, address?: { __typename: 'Address', street1: string, city: string, countryCode: string, state: string, zipCode: string } | null, siteSystemConfiguration: Array<{ __typename: 'SiteSystemConfiguration', identifier: string }> } | null, amount?: { __typename: 'ItemPrice', displayPrice: string, price: number } | null, items?: Array<{ __typename: 'TransactionItem', qty?: number | null, itemDescription?: string | null, discountDescription?: string | null, amount?: { __typename: 'ItemPrice', displayPrice: string, price: number } | null, refundedAmount?: { __typename: 'ItemPrice', displayPrice: string, price: number } | null, tax?: { __typename: 'ItemPrice', displayPrice: string, price: number } | null, discountApplied?: { __typename: 'ItemPrice', displayPrice: string, price: number } | null } | null> | null, paymentInfo?: Array<{ __typename: 'TransactionPaymentInfo', cardType?: string | null, cardCircuit?: string | null, paymentMethod?: Payment_Method | null, cardPANPrint?: string | null, preAuthAmount?: number | null, hostAuthNumber?: string | null } | null> | null, stateChanges?: Array<{ __typename: 'TransactionStateChange', updatedAt: string, primaryStatus: Primary_Transaction_Status, secondaryStatus: Secondary_Transaction_Status } | null> | null, paymentEvents?: Array<{ __typename: 'TransactionPaymentEvent', completedAt?: string | null, processorResponseCode?: string | null, posResponseCode?: string | null, reasonDescription: string, transactionEventType?: Transaction_Event_Type | null } | null> | null, tax?: { __typename: 'ItemPrice', displayPrice: string, price: number } | null, fuelReceipt?: { __typename: 'FuelReceipt', product: string, gallons: string, priceG: string, fuelSale: string, tax: string, carWashCode?: string | null, carWashName?: string | null, carWashPrice?: string | null } | null };

export type KountFraudCheckResultFragment = { __typename: 'KountFraudCheckResult', id: string, transactionUuid: string, sessionId: string, status: KountCheckStatus, autoDecision: AutoDecision, omniScore: number, reasonCode?: string | null, last4?: string | null, binRange?: string | null, amount: number, transactionDate: string, creditCardBrand?: string | null, ruleDescriptions?: Array<{ __typename: 'RuleDescription', ruleId: string, description: string }> | null, triggeredRules?: Array<{ __typename: 'RuleDescription', ruleId: string, description: string }> | null };

export type TransactionStateChangeFragment = { __typename: 'TransactionStateChange', updatedAt: string, primaryStatus: Primary_Transaction_Status, secondaryStatus: Secondary_Transaction_Status };

export type TransactionPaymentEventFragment = { __typename: 'TransactionPaymentEvent', completedAt?: string | null, processorResponseCode?: string | null, posResponseCode?: string | null, reasonDescription: string, transactionEventType?: Transaction_Event_Type | null };

export type TransactionDetailsQueryVariables = Exact<{
  filter?: InputMaybe<TransactionFilter>;
}>;


export type TransactionDetailsQuery = { __typename: 'Query', transactions: { __typename: 'TransactionConnection', edges?: Array<{ __typename: 'TransactionEdge', cursor: string, node?: { __typename: 'Transaction', uuid: string, authCode?: string | null, primaryStatus: Primary_Transaction_Status, createdAt: string, startedAt: string, completedAt?: string | null, location?: { __typename: 'Location', uuid: string, brandSpecificLocationId?: string | null, address?: { __typename: 'Address', street1: string, city: string, countryCode: string, state: string, zipCode: string } | null, siteSystemConfiguration: Array<{ __typename: 'SiteSystemConfiguration', identifier: string }> } | null, amount?: { __typename: 'ItemPrice', displayPrice: string, price: number } | null, items?: Array<{ __typename: 'TransactionItem', qty?: number | null, itemDescription?: string | null, discountDescription?: string | null, amount?: { __typename: 'ItemPrice', displayPrice: string, price: number } | null, refundedAmount?: { __typename: 'ItemPrice', displayPrice: string, price: number } | null, tax?: { __typename: 'ItemPrice', displayPrice: string, price: number } | null, discountApplied?: { __typename: 'ItemPrice', displayPrice: string, price: number } | null } | null> | null, paymentInfo?: Array<{ __typename: 'TransactionPaymentInfo', cardType?: string | null, cardCircuit?: string | null, paymentMethod?: Payment_Method | null, cardPANPrint?: string | null, preAuthAmount?: number | null, hostAuthNumber?: string | null } | null> | null, stateChanges?: Array<{ __typename: 'TransactionStateChange', updatedAt: string, primaryStatus: Primary_Transaction_Status, secondaryStatus: Secondary_Transaction_Status } | null> | null, paymentEvents?: Array<{ __typename: 'TransactionPaymentEvent', completedAt?: string | null, processorResponseCode?: string | null, posResponseCode?: string | null, reasonDescription: string, transactionEventType?: Transaction_Event_Type | null } | null> | null, tax?: { __typename: 'ItemPrice', displayPrice: string, price: number } | null, fuelReceipt?: { __typename: 'FuelReceipt', product: string, gallons: string, priceG: string, fuelSale: string, tax: string, carWashCode?: string | null, carWashName?: string | null, carWashPrice?: string | null } | null } | null } | null> | null } };

export type TransactionsQueryVariables = Exact<{
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<TransactionFilter>;
}>;


export type TransactionsQuery = { __typename: 'Query', transactions: { __typename: 'TransactionConnection', pageInfo: { __typename: 'PageInfo', hasNextPage: boolean, hasPreviousPage: boolean, startCursor?: string | null, endCursor?: string | null }, edges?: Array<{ __typename: 'TransactionEdge', cursor: string, node?: { __typename: 'Transaction', uuid: string, fraudCheckStatus: FraudCheckStatus, authCode?: string | null, primaryStatus: Primary_Transaction_Status, startedAt: string, completedAt?: string | null, posTransactionNumber?: string | null, location?: { __typename: 'Location', uuid: string, brandSpecificLocationId?: string | null, address?: { __typename: 'Address', street1: string, city: string, countryCode: string, state: string, zipCode: string } | null, siteSystemConfiguration: Array<{ __typename: 'SiteSystemConfiguration', identifier: string }> } | null, amount?: { __typename: 'ItemPrice', displayPrice: string, price: number } | null, paymentInfo?: Array<{ __typename: 'TransactionPaymentInfo', cardType?: string | null, cardCircuit?: string | null, paymentMethod?: Payment_Method | null } | null> | null, customer?: { __typename: 'TransactionCustomer', phoneNumber: string } | null } | null } | null> | null } };

export type TransactionFraudulentInfoQueryVariables = Exact<{
  transactionUuid: Scalars['OCUUID']['input'];
}>;


export type TransactionFraudulentInfoQuery = { __typename: 'Query', transactionFraudulentInfo?: { __typename: 'KountFraudCheckResult', id: string, transactionUuid: string, sessionId: string, status: KountCheckStatus, autoDecision: AutoDecision, omniScore: number, reasonCode?: string | null, last4?: string | null, binRange?: string | null, amount: number, transactionDate: string, creditCardBrand?: string | null, ruleDescriptions?: Array<{ __typename: 'RuleDescription', ruleId: string, description: string }> | null, triggeredRules?: Array<{ __typename: 'RuleDescription', ruleId: string, description: string }> | null } | null };

export type SiteConnectionHistoryFragment = { __typename: 'SiteConnectionHistory', connectedAt: string, connectionDurationMs?: number | null, disconnectedAt?: string | null, disconnectionAction?: Site_System_Connection_Action | null, inboundMessageClass?: Inbound_Message_Class | null, messagesReceived?: number | null, messagesSent?: number | null, uuid: string };

export type SiteConnectionHistoryQueryVariables = Exact<{
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  after?: InputMaybe<Scalars['OCBase64Cursor']['input']>;
  before?: InputMaybe<Scalars['OCBase64Cursor']['input']>;
  filter?: InputMaybe<SiteConnectionHistoryFilter>;
}>;


export type SiteConnectionHistoryQuery = { __typename: 'Query', siteConnectionHistory: { __typename: 'SiteConnectionHistoryConnection', pageInfo: { __typename: 'PageInfo', hasNextPage: boolean, hasPreviousPage: boolean, startCursor?: string | null, endCursor?: string | null }, edges?: Array<{ __typename: 'SiteConnectionHistoryEdge', cursor: string, node: { __typename: 'SiteConnectionHistory', connectedAt: string, connectionDurationMs?: number | null, disconnectedAt?: string | null, disconnectionAction?: Site_System_Connection_Action | null, inboundMessageClass?: Inbound_Message_Class | null, messagesReceived?: number | null, messagesSent?: number | null, uuid: string } }> | null } };

export type SiteConnectionHistorySummaryQueryVariables = Exact<{
  filter?: InputMaybe<SiteConnectionHistorySummaryFilter>;
}>;


export type SiteConnectionHistorySummaryQuery = { __typename: 'Query', siteConnectionHistorySummary: { __typename: 'SiteConnectionHistorySummary', totalConnectionFailures: number, totalConnections: number, totalDisconnections: number } };

export type CommandCenterAppConfigFragment = { __typename: 'CommandCenterAppConfig', csrLogin: { __typename: 'CSRLogin', enabled: boolean, authMethod: AuthMethod }, mobileTransactionFraudCheck?: { __typename: 'MobileTransactionFraudCheck', enabled: boolean, provider: MobileTransactionFraudCheckProvider } | null, memberDossier?: { __typename: 'MemberDossier', enabled: boolean, useForSegments: boolean } | null, scanData?: { __typename: 'ScanData', enabled: boolean } | null, touchpoint?: { __typename: 'Touchpoint', enabled: boolean } | null, audienceReportExport: { __typename: 'AudienceReportExport', enabled: boolean }, supportedPaymentTypes?: Array<{ __typename: 'PaymentType', title?: string | null, type?: Payment_Instrument_Type | null }> | null, orderAheadConfig?: { __typename: 'OrderAheadConfig', enabled: boolean, provider: OrderAheadProvider, shouldShowDisplayForOrderAheadToggle: boolean } | null, externalIdentityVerification?: { __typename: 'ExternalIdentityVerification', enabled: boolean, provider: ExternalIdentityVerificationProvider } | null, ach?: { __typename: 'Ach', enabled: boolean } | null, subBrands?: { __typename: 'SubBrandsConfig', enabled: boolean, list?: Array<{ __typename: 'SubBrand', uuid: string, name: string, createdAt: string, codeName: string, experienceUrl?: string | null }> | null } | null, retailerConnectTobaccoPerformance?: { __typename: 'RetailerConnectTobaccoPerformance', enabled: boolean } | null, retailerConnectRedesignV2?: { __typename: 'RetailerConnectRedesignV2', enabled: boolean } | null, triggeredMessages?: { __typename: 'TriggeredMessages', enabled: boolean } | null, externalLoyalty?: { __typename: 'ExternalLoyalty', externalTobaccoApiOffer: { __typename: 'ExternalTobaccoApiOffer', enabled: boolean } } | null, storedValue?: { __typename: 'StoredValueConfig', enabled: boolean } | null, driveInsights?: { __typename: 'DriveInsights', enabled: boolean, config?: { __typename: 'DriveInsightsConfigV1', variant: Drive_Insights_Variant } | { __typename: 'DriveInsightsConfigV2', variant: Drive_Insights_Variant, url: string } | null } | null, offerEditor?: { __typename: 'OfferEditorConfig', categoryFieldVisible: boolean } | null };

export type GetCommandCenterAppConfigQueryVariables = Exact<{ [key: string]: never; }>;


export type GetCommandCenterAppConfigQuery = { __typename: 'Query', appConfig: { __typename: 'CommandCenterAppConfig', csrLogin: { __typename: 'CSRLogin', enabled: boolean, authMethod: AuthMethod }, mobileTransactionFraudCheck?: { __typename: 'MobileTransactionFraudCheck', enabled: boolean, provider: MobileTransactionFraudCheckProvider } | null, memberDossier?: { __typename: 'MemberDossier', enabled: boolean, useForSegments: boolean } | null, scanData?: { __typename: 'ScanData', enabled: boolean } | null, touchpoint?: { __typename: 'Touchpoint', enabled: boolean } | null, audienceReportExport: { __typename: 'AudienceReportExport', enabled: boolean }, supportedPaymentTypes?: Array<{ __typename: 'PaymentType', title?: string | null, type?: Payment_Instrument_Type | null }> | null, orderAheadConfig?: { __typename: 'OrderAheadConfig', enabled: boolean, provider: OrderAheadProvider, shouldShowDisplayForOrderAheadToggle: boolean } | null, externalIdentityVerification?: { __typename: 'ExternalIdentityVerification', enabled: boolean, provider: ExternalIdentityVerificationProvider } | null, ach?: { __typename: 'Ach', enabled: boolean } | null, subBrands?: { __typename: 'SubBrandsConfig', enabled: boolean, list?: Array<{ __typename: 'SubBrand', uuid: string, name: string, createdAt: string, codeName: string, experienceUrl?: string | null }> | null } | null, retailerConnectTobaccoPerformance?: { __typename: 'RetailerConnectTobaccoPerformance', enabled: boolean } | null, retailerConnectRedesignV2?: { __typename: 'RetailerConnectRedesignV2', enabled: boolean } | null, triggeredMessages?: { __typename: 'TriggeredMessages', enabled: boolean } | null, externalLoyalty?: { __typename: 'ExternalLoyalty', externalTobaccoApiOffer: { __typename: 'ExternalTobaccoApiOffer', enabled: boolean } } | null, storedValue?: { __typename: 'StoredValueConfig', enabled: boolean } | null, driveInsights?: { __typename: 'DriveInsights', enabled: boolean, config?: { __typename: 'DriveInsightsConfigV1', variant: Drive_Insights_Variant } | { __typename: 'DriveInsightsConfigV2', variant: Drive_Insights_Variant, url: string } | null } | null, offerEditor?: { __typename: 'OfferEditorConfig', categoryFieldVisible: boolean } | null } };

export type AllowListPhoneNumberFragment = { __typename: 'AllowListPhoneNumber', uuid: string, name: string, reason: string, createdAt: string, updatedAt: string, phoneNumber: string };

export type DeleteAllowListPhoneNumberMutationVariables = Exact<{
  input: AllowListPhoneNumberDeleteInput;
}>;


export type DeleteAllowListPhoneNumberMutation = { __typename: 'Mutation', deleteAllowListPhoneNumber: boolean };

export type CreateAllowListPhoneNumberMutationVariables = Exact<{
  input: AllowListPhoneNumberCreateInput;
}>;


export type CreateAllowListPhoneNumberMutation = { __typename: 'Mutation', createAllowListPhoneNumber: { __typename: 'AllowListPhoneNumber', uuid: string, name: string, reason: string, createdAt: string, updatedAt: string, phoneNumber: string } };

export type UpdateAllowListPhoneNumberMutationVariables = Exact<{
  input: AllowListPhoneNumberUpdateInput;
}>;


export type UpdateAllowListPhoneNumberMutation = { __typename: 'Mutation', updateAllowListPhoneNumber: { __typename: 'AllowListPhoneNumber', uuid: string, name: string, reason: string, createdAt: string, updatedAt: string, phoneNumber: string } };

export type GetAllowListPhoneNumbersQueryVariables = Exact<{
  after?: InputMaybe<Scalars['OCBase64Cursor']['input']>;
  before?: InputMaybe<Scalars['OCBase64Cursor']['input']>;
  filter?: InputMaybe<AllowListPhoneNumberFilterInput>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
}>;


export type GetAllowListPhoneNumbersQuery = { __typename: 'Query', getAllowListPhoneNumbers: { __typename: 'AllowListPhoneNumberConnection', pageInfo: { __typename: 'PageInfo', hasNextPage: boolean, hasPreviousPage: boolean, startCursor?: string | null, endCursor?: string | null }, edges: Array<{ __typename: 'AllowListPhoneNumberEdge', cursor: string, node: { __typename: 'AllowListPhoneNumber', uuid: string, name: string, reason: string, createdAt: string, updatedAt: string, phoneNumber: string } }> } };

export type CreateCsrotpSessionMutationVariables = Exact<{
  input: CreateCsrotpSessionInput;
}>;


export type CreateCsrotpSessionMutation = { __typename: 'Mutation', createCSROTPSession: { __typename: 'CreateCSROTPSessionResult', session: string } };

export type VerifyCsrotpSessionMutationVariables = Exact<{
  otp: Otp;
}>;


export type VerifyCsrotpSessionMutation = { __typename: 'Mutation', verifyCSROTPSession: { __typename: 'CSRMagicLink', url: string } };

export type CreateCsrCustomerMagicLinkMutationVariables = Exact<{
  input: CsrMagicLinkSessionCreateInput;
}>;


export type CreateCsrCustomerMagicLinkMutation = { __typename: 'Mutation', createCSRCustomerMagicLink: { __typename: 'CSRMagicLink', url: string } };

export type DrivePromptFragment = { __typename: 'DrivePrompt', id: string, content: string, conversationId: string, createdAt: string };

export type DriveResponseFragment = { __typename: 'DriveResponse', id: string, content: string, conversationId: string, createdAt: string, promptId: string, reaction?: Drive_Response_Reaction | null, complete: boolean, lastChunkNumber?: number | null };

export type DriveConversationFragment = { __typename: 'DriveConversation', id: string, createdAt: string, prompts: Array<{ __typename: 'DrivePrompt', id: string, content: string, conversationId: string, createdAt: string }>, responses: Array<{ __typename: 'DriveResponse', id: string, content: string, conversationId: string, createdAt: string, promptId: string, reaction?: Drive_Response_Reaction | null, complete: boolean, lastChunkNumber?: number | null }> };

export type DriveSetReactionMutationVariables = Exact<{
  input: DriveSetReactionInput;
}>;


export type DriveSetReactionMutation = { __typename: 'Mutation', driveSetReaction: { __typename: 'DriveResponse', id: string, content: string, conversationId: string, createdAt: string, promptId: string, reaction?: Drive_Response_Reaction | null, complete: boolean, lastChunkNumber?: number | null } };

export type DriveTriggerStreamingPromptMutationVariables = Exact<{
  input: DriveSendPromptInput;
}>;


export type DriveTriggerStreamingPromptMutation = { __typename: 'Mutation', driveTriggerStreamingPrompt: { __typename: 'DriveResponse', id: string, content: string, conversationId: string, createdAt: string, promptId: string, reaction?: Drive_Response_Reaction | null, complete: boolean, lastChunkNumber?: number | null } };

export type DriveConversationsQueryVariables = Exact<{
  after?: InputMaybe<Scalars['OCBase64Cursor']['input']>;
  before?: InputMaybe<Scalars['OCBase64Cursor']['input']>;
  filter?: InputMaybe<DriveConversationFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
}>;


export type DriveConversationsQuery = { __typename: 'Query', driveConversations: { __typename: 'DriveConversationConnection', edges: Array<{ __typename: 'DriveConversationEdge', cursor: string, node: { __typename: 'DriveConversation', id: string, createdAt: string, prompts: Array<{ __typename: 'DrivePrompt', id: string, content: string, conversationId: string, createdAt: string }>, responses: Array<{ __typename: 'DriveResponse', id: string, content: string, conversationId: string, createdAt: string, promptId: string, reaction?: Drive_Response_Reaction | null, complete: boolean, lastChunkNumber?: number | null }> } }>, pageInfo: { __typename: 'PageInfo', hasNextPage: boolean, hasPreviousPage: boolean, startCursor?: string | null, endCursor?: string | null } } };

export type DriveSubscribeToConversationSubscriptionVariables = Exact<{
  conversationId: Scalars['ID']['input'];
}>;


export type DriveSubscribeToConversationSubscription = { __typename: 'Subscription', driveSubscribeToConversation: { __typename: 'DriveResponseChunk', chunkNumber: number, complete: boolean, content: string, conversationId: string, responseId: string } };

export type MembershipReferralInfoFragment = { __typename: 'Membership', id: string, referralUrl: string, referralCode: any, referrals: { __typename: 'ReferralConnection', totalCount: number } };

export type MembershipReferralInfoQueryVariables = Exact<{
  membershipId: Scalars['ID']['input'];
}>;


export type MembershipReferralInfoQuery = { __typename: 'Query', memberships?: { __typename: 'MembershipConnection', edges: Array<{ __typename: 'MembershipEdge', cursor: string, node: { __typename: 'Membership', id: string, referralUrl: string, referralCode: any, referrals: { __typename: 'ReferralConnection', totalCount: number } } }> } | null };

export type MembershipReferralsFragment = { __typename: 'Membership', id: string, referrals: { __typename: 'ReferralConnection', pageInfo: { __typename: 'PageInfo', hasNextPage: boolean, hasPreviousPage: boolean, startCursor?: string | null, endCursor?: string | null }, edges?: Array<{ __typename: 'ReferralEdge', node: { __typename: 'Referral', createdAt: string, receiverAwardGrantedDate?: string | null, receiverId: string, referralFulfillmentSource?: ReferralFulfillmentSource | null, referralFulfillmentSourceId?: string | null, senderAwardGrantedDate?: string | null, status: ReferralStatus, receiver: { __typename: 'Membership', id: string, phone?: string | null, firstName?: string | null, lastName?: string | null } } }> | null } };

export type ReferralsConnectionFragment = { __typename: 'ReferralConnection', pageInfo: { __typename: 'PageInfo', hasNextPage: boolean, hasPreviousPage: boolean, startCursor?: string | null, endCursor?: string | null }, edges?: Array<{ __typename: 'ReferralEdge', node: { __typename: 'Referral', createdAt: string, receiverAwardGrantedDate?: string | null, receiverId: string, referralFulfillmentSource?: ReferralFulfillmentSource | null, referralFulfillmentSourceId?: string | null, senderAwardGrantedDate?: string | null, status: ReferralStatus, receiver: { __typename: 'Membership', id: string, phone?: string | null, firstName?: string | null, lastName?: string | null } } }> | null };

export type ReferralInfoFragment = { __typename: 'Referral', createdAt: string, receiverAwardGrantedDate?: string | null, receiverId: string, referralFulfillmentSource?: ReferralFulfillmentSource | null, referralFulfillmentSourceId?: string | null, senderAwardGrantedDate?: string | null, status: ReferralStatus, receiver: { __typename: 'Membership', id: string, phone?: string | null, firstName?: string | null, lastName?: string | null } };

export type MembershipReferralsQueryVariables = Exact<{
  membershipId: Scalars['ID']['input'];
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  filter?: InputMaybe<ReferralFilter>;
}>;


export type MembershipReferralsQuery = { __typename: 'Query', memberships?: { __typename: 'MembershipConnection', edges: Array<{ __typename: 'MembershipEdge', cursor: string, node: { __typename: 'Membership', id: string, referrals: { __typename: 'ReferralConnection', pageInfo: { __typename: 'PageInfo', hasNextPage: boolean, hasPreviousPage: boolean, startCursor?: string | null, endCursor?: string | null }, edges?: Array<{ __typename: 'ReferralEdge', node: { __typename: 'Referral', createdAt: string, receiverAwardGrantedDate?: string | null, receiverId: string, referralFulfillmentSource?: ReferralFulfillmentSource | null, referralFulfillmentSourceId?: string | null, senderAwardGrantedDate?: string | null, status: ReferralStatus, receiver: { __typename: 'Membership', id: string, phone?: string | null, firstName?: string | null, lastName?: string | null } } }> | null } } }> } | null };

export type ArchiveMessagingCampaignMutationVariables = Exact<{
  id: Scalars['OCUUID']['input'];
}>;


export type ArchiveMessagingCampaignMutation = { __typename: 'Mutation', archiveMessagingCampaign: { __typename: 'AudienceBroadcastMessage', uuid: string, status: AudienceBroadcastMessageStatus } };

export type CreateMessagingCampaignMutationVariables = Exact<{
  input: CreateAudienceBroadcastMessageInput;
}>;


export type CreateMessagingCampaignMutation = { __typename: 'Mutation', campaign: { __typename: 'AudienceBroadcastMessage', uuid: string, title: string, description?: string | null, audienceUuid?: string | null, scheduleAt?: string | null, status: AudienceBroadcastMessageStatus, channelsConfig?: { __typename: 'ChannelsConfig', smsConfig?: { __typename: 'SmsConfig', enabled: boolean, body: string } | null, pushNotificationConfig?: { __typename: 'PushNotificationConfig', enabled: boolean, template: { __typename: 'PushNotificationTemplate', notification: { __typename: 'PushNotificationContent', title?: string | null, body: string }, data?: { __typename: 'PushNotificationData', url?: string | null } | null } } | null } | null, audience?: { __typename: 'Audience', uuid: string, name: string, membershipCount: number } | null } };

export type MessagingCampaignDetailsFragment = { __typename: 'AudienceBroadcastMessage', uuid: string, title: string, description?: string | null, audienceUuid?: string | null, scheduleAt?: string | null, status: AudienceBroadcastMessageStatus, channelsConfig?: { __typename: 'ChannelsConfig', smsConfig?: { __typename: 'SmsConfig', enabled: boolean, body: string } | null, pushNotificationConfig?: { __typename: 'PushNotificationConfig', enabled: boolean, template: { __typename: 'PushNotificationTemplate', notification: { __typename: 'PushNotificationContent', title?: string | null, body: string }, data?: { __typename: 'PushNotificationData', url?: string | null } | null } } | null } | null, audience?: { __typename: 'Audience', uuid: string, name: string, membershipCount: number } | null };

export type MessagingCampaignDetailsQueryVariables = Exact<{
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<AudienceBroadcastMessagesFilter>;
}>;


export type MessagingCampaignDetailsQuery = { __typename: 'Query', campaign: { __typename: 'AudienceBroadcastMessageConnection', pageInfo: { __typename: 'PageInfo', hasNextPage: boolean, hasPreviousPage: boolean, startCursor?: string | null, endCursor?: string | null }, edges: Array<{ __typename: 'AudienceBroadcastMessageEdge', cursor: string, node: { __typename: 'AudienceBroadcastMessage', uuid: string, title: string, description?: string | null, audienceUuid?: string | null, scheduleAt?: string | null, status: AudienceBroadcastMessageStatus, channelsConfig?: { __typename: 'ChannelsConfig', smsConfig?: { __typename: 'SmsConfig', enabled: boolean, body: string } | null, pushNotificationConfig?: { __typename: 'PushNotificationConfig', enabled: boolean, template: { __typename: 'PushNotificationTemplate', notification: { __typename: 'PushNotificationContent', title?: string | null, body: string }, data?: { __typename: 'PushNotificationData', url?: string | null } | null } } | null } | null, audience?: { __typename: 'Audience', uuid: string, name: string, membershipCount: number } | null } }> } };

export type UpdateMessagingCampaignMutationVariables = Exact<{
  input: UpdateAudienceBroadcastMessageInput;
}>;


export type UpdateMessagingCampaignMutation = { __typename: 'Mutation', campaign: { __typename: 'AudienceBroadcastMessage', uuid: string, title: string, description?: string | null, audienceUuid?: string | null, scheduleAt?: string | null, status: AudienceBroadcastMessageStatus, channelsConfig?: { __typename: 'ChannelsConfig', smsConfig?: { __typename: 'SmsConfig', enabled: boolean, body: string } | null, pushNotificationConfig?: { __typename: 'PushNotificationConfig', enabled: boolean, template: { __typename: 'PushNotificationTemplate', notification: { __typename: 'PushNotificationContent', title?: string | null, body: string }, data?: { __typename: 'PushNotificationData', url?: string | null } | null } } | null } | null, audience?: { __typename: 'Audience', uuid: string, name: string, membershipCount: number } | null } };

export type MessagingCampaignsListItemFragment = { __typename: 'AudienceBroadcastMessage', uuid: string, title: string, description?: string | null, scheduleAt?: string | null, status: AudienceBroadcastMessageStatus, channelsConfig?: { __typename: 'ChannelsConfig', pushNotificationConfig?: { __typename: 'PushNotificationConfig', enabled: boolean } | null, smsConfig?: { __typename: 'SmsConfig', enabled: boolean } | null } | null };

export type MessagingCampaignsListQueryVariables = Exact<{
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<AudienceBroadcastMessagesFilter>;
}>;


export type MessagingCampaignsListQuery = { __typename: 'Query', messagingCampaignsList: { __typename: 'AudienceBroadcastMessageConnection', pageInfo: { __typename: 'PageInfo', hasNextPage: boolean, hasPreviousPage: boolean, startCursor?: string | null, endCursor?: string | null }, edges: Array<{ __typename: 'AudienceBroadcastMessageEdge', cursor: string, node: { __typename: 'AudienceBroadcastMessage', uuid: string, title: string, description?: string | null, scheduleAt?: string | null, status: AudienceBroadcastMessageStatus, channelsConfig?: { __typename: 'ChannelsConfig', pushNotificationConfig?: { __typename: 'PushNotificationConfig', enabled: boolean } | null, smsConfig?: { __typename: 'SmsConfig', enabled: boolean } | null } | null } }> } };

export type MessagingCampaignEngagementChannelsConfigFragment = { __typename: 'ChannelsConfig', smsConfig?: { __typename: 'SmsConfig', enabled: boolean, body: string } | null, pushNotificationConfig?: { __typename: 'PushNotificationConfig', enabled: boolean, template: { __typename: 'PushNotificationTemplate', notification: { __typename: 'PushNotificationContent', title?: string | null, body: string }, data?: { __typename: 'PushNotificationData', url?: string | null } | null } } | null };

export type SendTestMessageMutationVariables = Exact<{
  input: SendTestMessageInput;
}>;


export type SendTestMessageMutation = { __typename: 'Mutation', sendTestMessage: boolean };

export type PointExpirationScheduleFragment = { __typename: 'PointExpirationSchedule', date: string, points: number };

export type MembershipPointExpirationScheduleQueryVariables = Exact<{
  membershipId: Scalars['ID']['input'];
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
}>;


export type MembershipPointExpirationScheduleQuery = { __typename: 'Query', memberships?: { __typename: 'MembershipConnection', edges: Array<{ __typename: 'MembershipEdge', cursor: string, node: { __typename: 'Membership', id: string, pointExpirationSchedule: { __typename: 'PointExpirationScheduleConnection', pageInfo: { __typename: 'PageInfo', hasNextPage: boolean, hasPreviousPage: boolean, startCursor?: string | null, endCursor?: string | null }, edges: Array<{ __typename: 'PointExpirationScheduleEdge', node: { __typename: 'PointExpirationSchedule', date: string, points: number } }> } } }> } | null };

export type PromoCodeGroupFragment = { __typename: 'PromoCodeGroup', id: string, fileName: string, processingStatus: PromoCodeGroupProcessingStatus, codesStats: { __typename: 'PromoCodeGroupStats', createdCount: number, failedCount: number, totalCount: number } };

export type PromocodeFragment = { __typename: 'Promocode', id: string, code: any, status: PromocodeStatus, publicationStatus: PromocodePublicationStatus, description?: string | null, startDate: string, endDate?: string | null, stats?: { __typename: 'PromocodeUsageStats', redemptions: number, totalOfferRedemptions: number } | null, createdBy: { __typename: 'CommandCenterUser', email: string, name?: string | null } };

export type UpdatePromocodesStatusMutationVariables = Exact<{
  input: Array<PromocodeStatusUpdateInput> | PromocodeStatusUpdateInput;
}>;


export type UpdatePromocodesStatusMutation = { __typename: 'Mutation', result: Array<{ __typename: 'Promocode', id: string, code: any, status: PromocodeStatus, publicationStatus: PromocodePublicationStatus, description?: string | null, startDate: string, endDate?: string | null, stats?: { __typename: 'PromocodeUsageStats', redemptions: number, totalOfferRedemptions: number } | null, createdBy: { __typename: 'CommandCenterUser', email: string, name?: string | null } }> };

export type PromocodeBatchCreateMutationVariables = Exact<{
  input: PromocodeBatchCreateInput;
}>;


export type PromocodeBatchCreateMutation = { __typename: 'Mutation', promocodeBatchCreate: Array<{ __typename: 'Promocode', id: string, code: any, status: PromocodeStatus, publicationStatus: PromocodePublicationStatus, description?: string | null, startDate: string, endDate?: string | null, stats?: { __typename: 'PromocodeUsageStats', redemptions: number, totalOfferRedemptions: number } | null, createdBy: { __typename: 'CommandCenterUser', email: string, name?: string | null } }> };

export type PromocodeBatchUpdateMutationVariables = Exact<{
  input: Array<PromocodeUpdateInput> | PromocodeUpdateInput;
}>;


export type PromocodeBatchUpdateMutation = { __typename: 'Mutation', promocodeBatchUpdate: Array<{ __typename: 'Promocode', id: string, code: any, status: PromocodeStatus, publicationStatus: PromocodePublicationStatus, description?: string | null, startDate: string, endDate?: string | null, stats?: { __typename: 'PromocodeUsageStats', redemptions: number, totalOfferRedemptions: number } | null, createdBy: { __typename: 'CommandCenterUser', email: string, name?: string | null } }> };

export type PromocodeBatchDeleteMutationVariables = Exact<{
  ids: Array<Scalars['ID']['input']> | Scalars['ID']['input'];
}>;


export type PromocodeBatchDeleteMutation = { __typename: 'Mutation', promocodeBatchDelete: Array<string> };

export type PromoCodesUploadSignedUrlGenerateMutationVariables = Exact<{
  fileName: Scalars['String']['input'];
}>;


export type PromoCodesUploadSignedUrlGenerateMutation = { __typename: 'Mutation', promoCodesUploadSignedUrlGenerate: { __typename: 'PromoCodesUploadUrlGenerateResponse', signedUrl: string, fields: object | object[], promoCodeGroupId: string } };

export type PromoCodesUploadProcessMutationVariables = Exact<{
  input: PromoCodesUploadProcessInput;
}>;


export type PromoCodesUploadProcessMutation = { __typename: 'Mutation', promoCodesUploadProcess: { __typename: 'PromoCodeGroup', id: string, fileName: string, processingStatus: PromoCodeGroupProcessingStatus, codesStats: { __typename: 'PromoCodeGroupStats', createdCount: number, failedCount: number, totalCount: number } } };

export type PromoCodeGroupDeleteMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type PromoCodeGroupDeleteMutation = { __typename: 'Mutation', promoCodeGroupDelete: string };

export type PromoCodeGroupDownloadLinkQueryVariables = Exact<{
  filter: PromoCodeGroupDownloadLinkFilter;
}>;


export type PromoCodeGroupDownloadLinkQuery = { __typename: 'Query', promoCodeGroupDownloadLink: string };

export type ConfigureReferralProgramMutationVariables = Exact<{
  input: ReferralProgramConfigurationInput;
}>;


export type ConfigureReferralProgramMutation = { __typename: 'Mutation', configureReferralProgram: { __typename: 'ReferralProgramConfiguration', referralProgramEnabled: boolean, qualifiedEvent: { __typename: 'QualifiedEventLoyaltyEvent', loyaltyEventOffer: { __typename: 'Offer', id: string, name: string } } | { __typename: 'QualifiedEventTransaction', purchaseThreshold: number, countProductsBy: Constraint_Purchase_Threshold_Counting_Attribute, eligibleProductGroups: Array<{ __typename: 'ProductGroup', id: string, name: string, description?: string | null, key: Product_Group_Key, values: Array<string>, fuelProductGroup?: { __typename: 'FuelProductGroup', id: string, sortingRank: number, userSelectable: boolean, default: boolean } | null }> }, senderConfiguration: { __typename: 'SenderConfiguration', instructions: string, smsTemplate: string, award?: { __typename: 'AwardPoints', points: number } | { __typename: 'AwardVouchers', voucherCount: number, voucherExpirationDays?: number | null, voucheredOffer: { __typename: 'Offer', id: string, name: string, fulfillmentCount: number, engagementType?: Offer_Engagement_Type | null } } | null }, receiverConfiguration: { __typename: 'ReceiverConfiguration', instructions: string, award?: { __typename: 'AwardPoints', points: number } | { __typename: 'AwardVouchers', voucherCount: number, voucherExpirationDays?: number | null, voucheredOffer: { __typename: 'Offer', id: string, name: string, fulfillmentCount: number, engagementType?: Offer_Engagement_Type | null } } | null }, marketingContents: Array<{ __typename: 'ReferralProgramMarketingContent', subBrandUuid?: string | null, senderInstructions: string, receiverInstructions: string, smsTemplate: string }> } };

export type ReferralProgramMarketingContentFragment = { __typename: 'ReferralProgramMarketingContent', subBrandUuid?: string | null, senderInstructions: string, receiverInstructions: string, smsTemplate: string };

export type ReferralProgramConfigurationFragment = { __typename: 'ReferralProgramConfiguration', referralProgramEnabled: boolean, qualifiedEvent: { __typename: 'QualifiedEventLoyaltyEvent', loyaltyEventOffer: { __typename: 'Offer', id: string, name: string } } | { __typename: 'QualifiedEventTransaction', purchaseThreshold: number, countProductsBy: Constraint_Purchase_Threshold_Counting_Attribute, eligibleProductGroups: Array<{ __typename: 'ProductGroup', id: string, name: string, description?: string | null, key: Product_Group_Key, values: Array<string>, fuelProductGroup?: { __typename: 'FuelProductGroup', id: string, sortingRank: number, userSelectable: boolean, default: boolean } | null }> }, senderConfiguration: { __typename: 'SenderConfiguration', instructions: string, smsTemplate: string, award?: { __typename: 'AwardPoints', points: number } | { __typename: 'AwardVouchers', voucherCount: number, voucherExpirationDays?: number | null, voucheredOffer: { __typename: 'Offer', id: string, name: string, fulfillmentCount: number, engagementType?: Offer_Engagement_Type | null } } | null }, receiverConfiguration: { __typename: 'ReceiverConfiguration', instructions: string, award?: { __typename: 'AwardPoints', points: number } | { __typename: 'AwardVouchers', voucherCount: number, voucherExpirationDays?: number | null, voucheredOffer: { __typename: 'Offer', id: string, name: string, fulfillmentCount: number, engagementType?: Offer_Engagement_Type | null } } | null }, marketingContents: Array<{ __typename: 'ReferralProgramMarketingContent', subBrandUuid?: string | null, senderInstructions: string, receiverInstructions: string, smsTemplate: string }> };

export type SenderConfigurationFragment = { __typename: 'SenderConfiguration', instructions: string, smsTemplate: string, award?: { __typename: 'AwardPoints', points: number } | { __typename: 'AwardVouchers', voucherCount: number, voucherExpirationDays?: number | null, voucheredOffer: { __typename: 'Offer', id: string, name: string, fulfillmentCount: number, engagementType?: Offer_Engagement_Type | null } } | null };

export type ReceiverConfigurationFragment = { __typename: 'ReceiverConfiguration', instructions: string, award?: { __typename: 'AwardPoints', points: number } | { __typename: 'AwardVouchers', voucherCount: number, voucherExpirationDays?: number | null, voucheredOffer: { __typename: 'Offer', id: string, name: string, fulfillmentCount: number, engagementType?: Offer_Engagement_Type | null } } | null };

type QualifiedEvent_QualifiedEventLoyaltyEvent_Fragment = { __typename: 'QualifiedEventLoyaltyEvent', loyaltyEventOffer: { __typename: 'Offer', id: string, name: string } };

type QualifiedEvent_QualifiedEventTransaction_Fragment = { __typename: 'QualifiedEventTransaction', purchaseThreshold: number, countProductsBy: Constraint_Purchase_Threshold_Counting_Attribute, eligibleProductGroups: Array<{ __typename: 'ProductGroup', id: string, name: string, description?: string | null, key: Product_Group_Key, values: Array<string>, fuelProductGroup?: { __typename: 'FuelProductGroup', id: string, sortingRank: number, userSelectable: boolean, default: boolean } | null }> };

export type QualifiedEventFragment = QualifiedEvent_QualifiedEventLoyaltyEvent_Fragment | QualifiedEvent_QualifiedEventTransaction_Fragment;

export type QualifiedEventLoyaltyEventFragment = { __typename: 'QualifiedEventLoyaltyEvent', loyaltyEventOffer: { __typename: 'Offer', id: string, name: string } };

export type QualifiedEventTransactionFragment = { __typename: 'QualifiedEventTransaction', purchaseThreshold: number, countProductsBy: Constraint_Purchase_Threshold_Counting_Attribute, eligibleProductGroups: Array<{ __typename: 'ProductGroup', id: string, name: string, description?: string | null, key: Product_Group_Key, values: Array<string>, fuelProductGroup?: { __typename: 'FuelProductGroup', id: string, sortingRank: number, userSelectable: boolean, default: boolean } | null }> };

export type ReferralProgramStatisticsFragment = { __typename: 'ReferralProgramStatistics', uniqueCodesShared: number, newMembersReferred: number, completedReferrals: number, newMembersPerReferral: number, receiverAwardGranted: number, receiverAwardRedeemed: number, receiverPointsGranted: number, senderAwardGranted: number, senderAwardRedeemed: number, senderPointsGranted: number, timeSeries: Array<{ __typename: 'ReferralMetricCountsTimeSeriesValues', date: string, uniqueCodesSharedCount: number, newMembersReferredCount: number }> };

export type ReferralMetricCountsTimeSeriesValuesFragment = { __typename: 'ReferralMetricCountsTimeSeriesValues', date: string, uniqueCodesSharedCount: number, newMembersReferredCount: number };

export type ReferralProgramStatisticsQueryVariables = Exact<{
  chainId: Scalars['ID']['input'];
}>;


export type ReferralProgramStatisticsQuery = { __typename: 'Query', referralProgramStatistics: { __typename: 'ReferralProgramStatistics', uniqueCodesShared: number, newMembersReferred: number, completedReferrals: number, newMembersPerReferral: number, receiverAwardGranted: number, receiverAwardRedeemed: number, receiverPointsGranted: number, senderAwardGranted: number, senderAwardRedeemed: number, senderPointsGranted: number, timeSeries: Array<{ __typename: 'ReferralMetricCountsTimeSeriesValues', date: string, uniqueCodesSharedCount: number, newMembersReferredCount: number }> } };

export type RetailerNetworkLocationCoordinatesFragment = { __typename: 'RetailerNetworkLocationCoordinates', locationUuid: string, locationName?: string | null, geoLocation: { __typename: 'GeoLocation', latitude: number, longitude: number } };

export type RetailerNetworkPartialFragment = { __typename: 'RetailerNetwork', uuid: string, name: string, displayName: string, customerId: string, adminName: string, numberOfLocations: number };

export type RetailerNetworkFragment = { __typename: 'RetailerNetwork', uuid: string, name: string, displayName: string, customerId: string, adminName: string, numberOfLocations: number, phoneNumber: string, emailAddress: string, numberOfLocationGroups: number, address: { __typename: 'Address', uuid: string, alias?: string | null, street1: string, street2?: string | null, city: string, state: string, zipCode: string }, monthlyPerformanceGoal: { __typename: 'RetailerNetworkMonthlyPerformanceGoal', membersPerStore: number, transactionsPerStore: number } };

export type RetailerNetworkUserFragment = { __typename: 'RetailerNetworkUser', uuid: string, userUuid: string, name: string, emailAddress: string, phoneNumber?: string | null, role: Retailer_Network_User_Role, createdAt: string, openCommerceUser?: { __typename: 'OpenCommerceUser', uuid: string, email: string, userRole: User_Role, phoneNumber?: string | null, name: { __typename: 'PersonName', first?: string | null, last?: string | null } } | null, retailerNetworkLocations: Array<{ __typename: 'RetailerNetworkLocation', userAssociationInheritedFromLocationGroup?: string | null } | null> };

export type RetailerNetworkCustomerFragment = { __typename: 'RetailerNetworkCustomer', uuid: string, id: string, name?: string | null };

export type RetailerNetworkLocationDataFragment = { __typename: 'Location', uuid: string, name?: string | null, customerName?: string | null, customerId?: string | null, brand?: { __typename: 'Brand', uuid: string, name: string } | null, brandingDetails?: { __typename: 'LocationBrandingDetails', primaryColor?: string | null, secondaryColor?: string | null } | null, address?: { __typename: 'Address', uuid: string, alias?: string | null, city: string, countryCode: string, state: string, street1: string, street2?: string | null, zipCode: string, geoLocation?: { __typename: 'GeoLocation', latitude: number, longitude: number } | null } | null, phoneNumbers: Array<{ __typename: 'ContactPhoneNumber', phoneNumber: string, phoneType: Phone_Type }>, siteSystemConfiguration: Array<{ __typename: 'SiteSystemConfiguration', uuid: string, identifier: string, hardwareVendor: Hardware_Vendor, details?: { __typename: 'SiteSystemDetails', siteAddress?: string | null, siteName?: string | null, isOnline: boolean } | null }>, hoursOfOperationGroup?: { __typename: 'HoursOfOperationGroup', hours: Array<{ __typename: 'HoursOfOperation', dayOfWeek: Weekday, openTime: string, closeTime: string, genericHoursString?: string | null }> } | null, attributes: Array<{ __typename: 'LocationAttribute', name: string, value: string }> };

export type RetailerNetworkLocationPosConnectionStatusFragment = { __typename: 'RetailerNetworkLocationPosConnectionStatus', identifier?: string | null, hardwareVendor?: Hardware_Vendor | null, mobileEnabled?: boolean | null, mobileConnectedAt?: string | null, loyaltyEnabled?: boolean | null, loyaltyConnectedAt?: string | null, scanDataSubmittedAt?: string | null };

export type RetailerNetworkLocationFuelPricesFragment = { __typename: 'Location', fuelGradePrices: Array<{ __typename: 'FuelGradePrice', description: string, unitPrice?: { __typename: 'FuelItemPrice', displayCashPrice: string, displayCreditPrice: string } | null }> };

export type RetailerNetworkLocationFragment = { __typename: 'RetailerNetworkLocation', uuid: string, retailerNetworkUuid: string, userAssociationInheritedFromLocationGroup?: string | null, isOnline?: boolean | null, location: { __typename: 'Location', uuid: string, name?: string | null, customerName?: string | null, customerId?: string | null, brand?: { __typename: 'Brand', uuid: string, name: string } | null, brandingDetails?: { __typename: 'LocationBrandingDetails', primaryColor?: string | null, secondaryColor?: string | null } | null, address?: { __typename: 'Address', uuid: string, alias?: string | null, city: string, countryCode: string, state: string, street1: string, street2?: string | null, zipCode: string, geoLocation?: { __typename: 'GeoLocation', latitude: number, longitude: number } | null } | null, phoneNumbers: Array<{ __typename: 'ContactPhoneNumber', phoneNumber: string, phoneType: Phone_Type }>, siteSystemConfiguration: Array<{ __typename: 'SiteSystemConfiguration', uuid: string, identifier: string, hardwareVendor: Hardware_Vendor, details?: { __typename: 'SiteSystemDetails', siteAddress?: string | null, siteName?: string | null, isOnline: boolean } | null }>, hoursOfOperationGroup?: { __typename: 'HoursOfOperationGroup', hours: Array<{ __typename: 'HoursOfOperation', dayOfWeek: Weekday, openTime: string, closeTime: string, genericHoursString?: string | null }> } | null, attributes: Array<{ __typename: 'LocationAttribute', name: string, value: string }> } };

export type RetailerNetworkLocationDetailsFragment = { __typename: 'RetailerNetworkLocation', uuid: string, retailerNetworkUuid: string, userAssociationInheritedFromLocationGroup?: string | null, isOnline?: boolean | null, location: { __typename: 'Location', uuid: string, name?: string | null, customerName?: string | null, customerId?: string | null, fuelGradePrices: Array<{ __typename: 'FuelGradePrice', description: string, unitPrice?: { __typename: 'FuelItemPrice', displayCashPrice: string, displayCreditPrice: string } | null }>, brand?: { __typename: 'Brand', uuid: string, name: string } | null, brandingDetails?: { __typename: 'LocationBrandingDetails', primaryColor?: string | null, secondaryColor?: string | null } | null, address?: { __typename: 'Address', uuid: string, alias?: string | null, city: string, countryCode: string, state: string, street1: string, street2?: string | null, zipCode: string, geoLocation?: { __typename: 'GeoLocation', latitude: number, longitude: number } | null } | null, phoneNumbers: Array<{ __typename: 'ContactPhoneNumber', phoneNumber: string, phoneType: Phone_Type }>, siteSystemConfiguration: Array<{ __typename: 'SiteSystemConfiguration', uuid: string, identifier: string, hardwareVendor: Hardware_Vendor, details?: { __typename: 'SiteSystemDetails', siteAddress?: string | null, siteName?: string | null, isOnline: boolean } | null }>, hoursOfOperationGroup?: { __typename: 'HoursOfOperationGroup', hours: Array<{ __typename: 'HoursOfOperation', dayOfWeek: Weekday, openTime: string, closeTime: string, genericHoursString?: string | null }> } | null, attributes: Array<{ __typename: 'LocationAttribute', name: string, value: string }> } };

export type RetailerNetworkLocationGroupFragment = { __typename: 'RetailerNetworkLocationGroup', uuid: string, name: string, countOfLocations: number };

export type RetailerNetworkLocationWithPerformanceExcerptFragment = { __typename: 'RetailerNetworkLocationWithPerformanceExcerpt', locationUuid: string, siteId: string, name: string, isSpecificGoal?: boolean | null, newMembers: { __typename: 'GoalProgress', goal: number, progress: number }, transactions: { __typename: 'GoalProgress', goal: number, progress: number } };

export type RetailerNetworkPerformanceFragment = { __typename: 'RetailerNetworkPerformance', homeStoreMembers: number, newMembers: { __typename: 'NewMembers', perStoreAverage: number, chartData: Array<{ __typename: 'GoalProgressChartData', timestamp: string, value: number }>, goalProgress: { __typename: 'GoalProgress', goal: number, progress: number } }, loyaltyTransactions: { __typename: 'LoyaltyTransactions', perStoreAverage: number, chartData: Array<{ __typename: 'GoalProgressChartData', timestamp: string, value: number }>, goalProgress: { __typename: 'GoalProgress', goal: number, progress: number } }, loyaltyTransactionsBreakdown: { __typename: 'LoyaltyTransactionsBreakdown', fuelAmount: { __typename: 'PerTransactionBreakdown', total: number, perTransactionAverage: number }, fuelVolume: { __typename: 'PerTransactionBreakdown', total: number, perTransactionAverage: number }, merchandise: { __typename: 'PerTransactionBreakdown', total: number, perTransactionAverage: number } } };

export type GoalProgressChartDataFragment = { __typename: 'GoalProgressChartData', timestamp: string, value: number };

export type GoalProgressFragment = { __typename: 'GoalProgress', goal: number, progress: number };

export type PerTransactionBreakdownFragment = { __typename: 'PerTransactionBreakdown', total: number, perTransactionAverage: number };

export type TimeSeriesMetricFragment = { __typename: 'TimeSeriesMetric', date: string, value: number };

export type RetailerNetworkLocationDowntimeMetricsOverviewFragment = { __typename: 'RetailerNetworkLocationDowntimeMetricsOverview', numberOfStores: number, numberOfConnectedStores: number, disconnectedStoresTimeSeriesOfLast30Days?: Array<{ __typename: 'TimeSeriesMetric', date: string, value: number }> | null };

export type RetailerNetworkLocationGroupOnlineStatusFragment = { __typename: 'RetailerNetworkLocationDowntimeMetricsOverview', numberOfStores: number, numberOfConnectedStores: number };

export type RetailerNetworkTransactionMetricsOverviewDataFragment = { __typename: 'RetailerNetworkTransactionMetricsOverviewData', numberOfLoyaltyTransactionsLast7Days: number, numberOfLoyaltyTransactionsLast30Days: number, numberOfLoyaltyTransactionsToday: number, numberOfLoyaltyTransactionsYesterday: number };

export type RetailerNetworkTransactionMetricsOverviewFragment = { __typename: 'RetailerNetworkTransactionMetricsOverview', actualPerformance: { __typename: 'RetailerNetworkTransactionMetricsOverviewData', numberOfLoyaltyTransactionsLast7Days: number, numberOfLoyaltyTransactionsLast30Days: number, numberOfLoyaltyTransactionsToday: number, numberOfLoyaltyTransactionsYesterday: number }, prevPerformance: { __typename: 'RetailerNetworkTransactionMetricsOverviewData', numberOfLoyaltyTransactionsLast7Days: number, numberOfLoyaltyTransactionsLast30Days: number, numberOfLoyaltyTransactionsToday: number, numberOfLoyaltyTransactionsYesterday: number }, loyaltyTransactionsTimeSeries?: Array<{ __typename: 'TimeSeriesMetric', date: string, value: number }> | null };

export type ReimbursementsFragment = { __typename: 'Reimbursements', multiUnit: number, loyalty: number };

export type ReimbursementsTimeSeriesDataPointFragment = { __typename: 'ReimbursementsTimeSeriesDataPoint', date: string, value: { __typename: 'Reimbursements', multiUnit: number, loyalty: number } };

export type ScanDataSubmissionFragment = { __typename: 'ScanDataSubmission', type: ScanDataSubmissionType, status: ScanDataSubmissionStatus, totalLoyaltyTransactions: number, totalMultiUnitTransactions: number, estimatedReimbursements: { __typename: 'Reimbursements', multiUnit: number, loyalty: number }, previousEstimatedReimbursements: { __typename: 'Reimbursements', multiUnit: number, loyalty: number } };

export type RetailerNetworkScanDataSubmissionsFragment = { __typename: 'RetailerNetworkScanDataWeeklySubmission', submittedAt: string, status: ScanDataWeeklySubmissionStatus, totalSitesSubmitted: number, totalMultiUnitTransactions: number, totalLoyaltyTransactions: number, submissions: Array<{ __typename: 'ScanDataSubmission', type: ScanDataSubmissionType, status: ScanDataSubmissionStatus, totalLoyaltyTransactions: number, totalMultiUnitTransactions: number, estimatedReimbursements: { __typename: 'Reimbursements', multiUnit: number, loyalty: number }, previousEstimatedReimbursements: { __typename: 'Reimbursements', multiUnit: number, loyalty: number } }>, estimatedReimbursements: { __typename: 'Reimbursements', multiUnit: number, loyalty: number }, previousEstimatedReimbursements: { __typename: 'Reimbursements', multiUnit: number, loyalty: number } };

export type RetailerNetworkScanDataLatestSubmissionsFragment = { __typename: 'RetailerNetworkScanDataWeeklySubmission', submittedAt: string, status: ScanDataWeeklySubmissionStatus, totalSitesSubmitted: number, totalMultiUnitTransactions: number, totalLoyaltyTransactions: number, estimatedReimbursements: { __typename: 'Reimbursements', multiUnit: number, loyalty: number }, previousEstimatedReimbursements: { __typename: 'Reimbursements', multiUnit: number, loyalty: number } };

export type RetailerNetworkScanDataTobaccoSubmissionsOverviewFragment = { __typename: 'RetailerNetworkScanDataTobaccoSubmissionsOverview', totalSites: number, totalSitesSubmitted: number, estimatedReimbursements: { __typename: 'Reimbursements', multiUnit: number, loyalty: number }, previousEstimatedReimbursements: { __typename: 'Reimbursements', multiUnit: number, loyalty: number }, estimatedReimbursementsTimeSeries: Array<{ __typename: 'ReimbursementsTimeSeriesDataPoint', date: string, value: { __typename: 'Reimbursements', multiUnit: number, loyalty: number } } | null> };

export type RetailerNetworkScanDataTobaccoSiteSubmissionsFragment = { __typename: 'RetailerNetworkScanDataTobaccoSubmission', siteId: string, siteName: string, submittedAt: string, totalMultiUnitTransactions: number, previousTotalMultiUnitTransactions: number, totalLoyaltyTransactions: number, previousTotalLoyaltyTransactions: number, estimatedReimbursements: { __typename: 'Reimbursements', multiUnit: number, loyalty: number }, submissions: Array<{ __typename: 'ScanDataSubmission', type: ScanDataSubmissionType, status: ScanDataSubmissionStatus }> };

export type RetailerNetworkLoyaltyMetricsByPeriodFragment = { __typename: 'RetailerNetworkLoyaltyMetricsByPeriod', avgFuelSalesPerTransaction: number, avgSavingPerTransaction: number, avgUnitsSalesPerStore: number, avgUnitsSold: number, avgValuePerTransaction: number, numberOfTransactions: number, offerEngagementRate: number, totalFuelSales: number, totalUnitsSales: number, unitsSold: number };

export type RetailerNetworkLoyaltyMetricsOverviewFragment = { __typename: 'RetailerNetworkLoyaltyMetricsOverview', actualPeriodPerformance: { __typename: 'RetailerNetworkLoyaltyMetricsByPeriod', avgFuelSalesPerTransaction: number, avgSavingPerTransaction: number, avgUnitsSalesPerStore: number, avgUnitsSold: number, avgValuePerTransaction: number, numberOfTransactions: number, offerEngagementRate: number, totalFuelSales: number, totalUnitsSales: number, unitsSold: number }, prevPeriodPerformance: { __typename: 'RetailerNetworkLoyaltyMetricsByPeriod', avgFuelSalesPerTransaction: number, avgSavingPerTransaction: number, avgUnitsSalesPerStore: number, avgUnitsSold: number, avgValuePerTransaction: number, numberOfTransactions: number, offerEngagementRate: number, totalFuelSales: number, totalUnitsSales: number, unitsSold: number }, loyaltyTransactionsTimeSeries?: Array<{ __typename: 'TimeSeriesMetric', date: string, value: number }> | null };

export type RetailerNetworkLocationOfferMetricsOverviewFragment = { __typename: 'RetailerNetworkOfferMetricsOverviewNode', uuid: string, offerUuid: string, offerName: string, redemptions: number, prevPeriodRedemptions: number, averageRedemptionsPerStore: number };

export type RetailerNetworkTobaccoProgramTransactionMetricFragment = { __typename: 'RetailerNetworkTobaccoProgramTransactionMetric', totalTransactions: number, avgCustomerSavings: number, estimatedReimbursements: number, basketSize: number };

export type RetailerNetworkTobaccoProgramPerformanceFragment = { __typename: 'RetailerNetworkTobaccoProgramPerformance', totalTransactions: number, memberMetrics: { __typename: 'RetailerNetworkTobaccoProgramMembersMetric', totalMembers: number, totalNewMembers: number, totalActiveMembers: number, retentionRate: number }, loyaltyMetrics: { __typename: 'RetailerNetworkTobaccoProgramTransactionMetric', totalTransactions: number, avgCustomerSavings: number, estimatedReimbursements: number, basketSize: number }, multiUnitMetrics: { __typename: 'RetailerNetworkTobaccoProgramTransactionMetric', totalTransactions: number, avgCustomerSavings: number, estimatedReimbursements: number, basketSize: number } };

export type RetailerNetworkTobaccoProgramSiteMetricFragment = { __typename: 'RetailerNetworkTobaccoProgramSiteMetric', rank: number, siteId: string, siteAddress: string, siteName: string, value: number, previousValue: number };

export type CpgManufacturerProgramFragment = { __typename: 'CPGManufacturerProgram', id: string, manufacturer: CpgManufacturer, name: string };

export type RetailerNetworkTobaccoManufacturerOfferPerformanceFragment = { __typename: 'RetailerNetworkTobaccoManufacturerOfferPerformance', offerName: string, redemptions: number, totalStores: number, estimatedReimbursements: { __typename: 'Reimbursements', multiUnit: number, loyalty: number }, previousEstimatedReimbursements: { __typename: 'Reimbursements', multiUnit: number, loyalty: number } };

export type RetailerNetworkCreateMutationVariables = Exact<{
  input: RetailerNetworkCreate;
}>;


export type RetailerNetworkCreateMutation = { __typename: 'Mutation', retailerNetworkCreate: { __typename: 'RetailerNetwork', uuid: string, name: string, displayName: string, customerId: string, adminName: string, numberOfLocations: number, phoneNumber: string, emailAddress: string, numberOfLocationGroups: number, address: { __typename: 'Address', uuid: string, alias?: string | null, street1: string, street2?: string | null, city: string, state: string, zipCode: string }, monthlyPerformanceGoal: { __typename: 'RetailerNetworkMonthlyPerformanceGoal', membersPerStore: number, transactionsPerStore: number } } };

export type RetailerNetworkUpdateMutationVariables = Exact<{
  input: RetailerNetworkUpdate;
}>;


export type RetailerNetworkUpdateMutation = { __typename: 'Mutation', retailerNetworkUpdate: { __typename: 'RetailerNetwork', uuid: string, name: string, displayName: string, customerId: string, adminName: string, numberOfLocations: number, phoneNumber: string, emailAddress: string, numberOfLocationGroups: number, address: { __typename: 'Address', uuid: string, alias?: string | null, street1: string, street2?: string | null, city: string, state: string, zipCode: string }, monthlyPerformanceGoal: { __typename: 'RetailerNetworkMonthlyPerformanceGoal', membersPerStore: number, transactionsPerStore: number } } };

export type RetailerNetworkDeleteMutationVariables = Exact<{
  uuid: Scalars['OCUUID']['input'];
}>;


export type RetailerNetworkDeleteMutation = { __typename: 'Mutation', retailerNetworkDelete: boolean };

export type RemoveUserFromRetailerNetworkMutationVariables = Exact<{
  retailerNetworkUuid: Scalars['OCUUID']['input'];
  userUuid: Scalars['OCUUID']['input'];
}>;


export type RemoveUserFromRetailerNetworkMutation = { __typename: 'Mutation', removeUserFromRetailerNetwork: boolean };

export type RemoveLocationFromRetailerNetworkMutationVariables = Exact<{
  retailerNetworkUuid: Scalars['OCUUID']['input'];
  locationUuid: Scalars['OCUUID']['input'];
}>;


export type RemoveLocationFromRetailerNetworkMutation = { __typename: 'Mutation', removeLocationFromRetailerNetwork: boolean };

export type RetailerNetworkUserCreateMutationVariables = Exact<{
  input: RetailerNetworkUserCreate;
}>;


export type RetailerNetworkUserCreateMutation = { __typename: 'Mutation', retailerNetworkUserCreate: { __typename: 'RetailerNetworkUser', uuid: string, userUuid: string, name: string, emailAddress: string, phoneNumber?: string | null, role: Retailer_Network_User_Role, createdAt: string, openCommerceUser?: { __typename: 'OpenCommerceUser', uuid: string, email: string, userRole: User_Role, phoneNumber?: string | null, name: { __typename: 'PersonName', first?: string | null, last?: string | null } } | null, retailerNetworkLocations: Array<{ __typename: 'RetailerNetworkLocation', userAssociationInheritedFromLocationGroup?: string | null } | null> } };

export type RetailerNetworkUserUpdateMutationVariables = Exact<{
  input: RetailerNetworkUserUpdate;
}>;


export type RetailerNetworkUserUpdateMutation = { __typename: 'Mutation', retailerNetworkUserUpdate: { __typename: 'RetailerNetworkUser', uuid: string, userUuid: string, name: string, emailAddress: string, phoneNumber?: string | null, role: Retailer_Network_User_Role, createdAt: string, openCommerceUser?: { __typename: 'OpenCommerceUser', uuid: string, email: string, userRole: User_Role, phoneNumber?: string | null, name: { __typename: 'PersonName', first?: string | null, last?: string | null } } | null, retailerNetworkLocations: Array<{ __typename: 'RetailerNetworkLocation', userAssociationInheritedFromLocationGroup?: string | null } | null> } };

export type RetailerNetworkLocationGroupCreateMutationVariables = Exact<{
  retailerNetworkUuid: Scalars['OCUUID']['input'];
  locationGroup: LocationGroupCreateInput;
}>;


export type RetailerNetworkLocationGroupCreateMutation = { __typename: 'Mutation', retailerNetworkLocationGroupCreate: { __typename: 'RetailerNetworkLocationGroup', uuid: string, name: string, countOfLocations: number } };

export type RetailerNetworkLocationGroupUpdateMutationVariables = Exact<{
  retailerNetworkUuid: Scalars['OCUUID']['input'];
  locationGroup: RetailerNetworkLocationGroupUpdateInput;
}>;


export type RetailerNetworkLocationGroupUpdateMutation = { __typename: 'Mutation', retailerNetworkLocationGroupUpdate: { __typename: 'RetailerNetworkLocationGroup', uuid: string, name: string, countOfLocations: number } };

export type RetailerNetworkLocationGroupDeleteMutationVariables = Exact<{
  retailerNetworkUuid: Scalars['OCUUID']['input'];
  locationGroupUuid: Scalars['OCUUID']['input'];
}>;


export type RetailerNetworkLocationGroupDeleteMutation = { __typename: 'Mutation', retailerNetworkLocationGroupDelete: boolean };

export type RetailerNetworkLocationGroupAddLocationsMutationVariables = Exact<{
  retailerNetworkUuid: Scalars['OCUUID']['input'];
  locationGroupUuid: Scalars['OCUUID']['input'];
  locationUuids: Array<Scalars['OCUUID']['input']> | Scalars['OCUUID']['input'];
}>;


export type RetailerNetworkLocationGroupAddLocationsMutation = { __typename: 'Mutation', retailerNetworkLocationGroupAddLocations: boolean };

export type RetailerNetworkLocationGroupRemoveLocationsMutationVariables = Exact<{
  retailerNetworkUuid: Scalars['OCUUID']['input'];
  locationGroupUuid: Scalars['OCUUID']['input'];
  locationUuids: Array<Scalars['OCUUID']['input']> | Scalars['OCUUID']['input'];
}>;


export type RetailerNetworkLocationGroupRemoveLocationsMutation = { __typename: 'Mutation', retailerNetworkLocationGroupRemoveLocations: boolean };

export type AssociateLocationsWithRetailerNetworkUsersMutationVariables = Exact<{
  locationUuids: Array<Scalars['OCUUID']['input']> | Scalars['OCUUID']['input'];
  retailerNetworkUserUuids: Array<Scalars['OCUUID']['input']> | Scalars['OCUUID']['input'];
  retailerNetworkUuid: Scalars['OCUUID']['input'];
}>;


export type AssociateLocationsWithRetailerNetworkUsersMutation = { __typename: 'Mutation', associateLocationsWithRetailerNetworkUsers: boolean };

export type AssociateRetailerNetworkLocationGroupsWithRetailerNetworkUsersMutationVariables = Exact<{
  locationGroupUuids: Array<Scalars['OCUUID']['input']> | Scalars['OCUUID']['input'];
  retailerNetworkUserUuids: Array<Scalars['OCUUID']['input']> | Scalars['OCUUID']['input'];
  retailerNetworkUuid: Scalars['OCUUID']['input'];
}>;


export type AssociateRetailerNetworkLocationGroupsWithRetailerNetworkUsersMutation = { __typename: 'Mutation', associateRetailerNetworkLocationGroupsWithRetailerNetworkUsers: boolean };

export type DisassociateLocationsWithRetailerNetworkUsersMutationVariables = Exact<{
  retailerNetworkUuid: Scalars['OCUUID']['input'];
  locationUuids: Array<Scalars['OCUUID']['input']> | Scalars['OCUUID']['input'];
  retailerNetworkUserUuids: Array<Scalars['OCUUID']['input']> | Scalars['OCUUID']['input'];
}>;


export type DisassociateLocationsWithRetailerNetworkUsersMutation = { __typename: 'Mutation', disassociateLocationsWithRetailerNetworkUsers: boolean };

export type DisassociateRetailerNetworkLocationGroupsWithRetailerNetworkUsersMutationVariables = Exact<{
  locationGroupUuids: Array<Scalars['OCUUID']['input']> | Scalars['OCUUID']['input'];
  retailerNetworkUserUuids: Array<Scalars['OCUUID']['input']> | Scalars['OCUUID']['input'];
  retailerNetworkUuid: Scalars['OCUUID']['input'];
}>;


export type DisassociateRetailerNetworkLocationGroupsWithRetailerNetworkUsersMutation = { __typename: 'Mutation', disassociateRetailerNetworkLocationGroupsWithRetailerNetworkUsers: boolean };

export type SetLocationPerformanceGoalMutationVariables = Exact<{
  input: SetLocationPerformanceGoal;
}>;


export type SetLocationPerformanceGoalMutation = { __typename: 'Mutation', setLocationPerformanceGoal: boolean };

export type UnsetLocationPerformanceGoalMutationVariables = Exact<{
  locationUuid: Scalars['OCUUID']['input'];
  retailerNetworkUuid: Scalars['OCUUID']['input'];
}>;


export type UnsetLocationPerformanceGoalMutation = { __typename: 'Mutation', unsetLocationPerformanceGoal: boolean };

export type EmailRetailerNetworkScanDataTobaccoSubmissionsCsvReportMutationVariables = Exact<{
  emailToSendReport: Scalars['OCEmailAddress']['input'];
  filter: RetailerNetworkScanDataTobaccoSubmissionFilter;
}>;


export type EmailRetailerNetworkScanDataTobaccoSubmissionsCsvReportMutation = { __typename: 'Mutation', emailRetailerNetworkScanDataTobaccoSubmissionsCsvReport: boolean };

export type EmailRetailerNetworkScanDataTobaccoSiteSubmissionsCsvReportMutationVariables = Exact<{
  emailToSendReport: Scalars['OCEmailAddress']['input'];
  filter: RetailerNetworkScanDataTobaccoSiteSubmissionFilter;
}>;


export type EmailRetailerNetworkScanDataTobaccoSiteSubmissionsCsvReportMutation = { __typename: 'Mutation', emailRetailerNetworkScanDataTobaccoSiteSubmissionsCsvReport: boolean };

export type RetailerNetworksForUserQueryVariables = Exact<{
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  after?: InputMaybe<Scalars['OCBase64Cursor']['input']>;
  before?: InputMaybe<Scalars['OCBase64Cursor']['input']>;
  filter: RetailersNetworksFilter;
}>;


export type RetailerNetworksForUserQuery = { __typename: 'Query', retailerNetworksForUser: { __typename: 'RetailerNetworkConnection', pageInfo: { __typename: 'PageInfo', hasNextPage: boolean, hasPreviousPage: boolean, startCursor?: string | null, endCursor?: string | null }, edges?: Array<{ __typename: 'RetailerNetworkEdge', cursor: string, node: { __typename: 'RetailerNetwork', uuid: string, name: string, displayName: string, customerId: string, adminName: string, numberOfLocations: number } }> | null } };

export type RetailerNetworkQueryVariables = Exact<{
  uuid: Scalars['OCUUID']['input'];
}>;


export type RetailerNetworkQuery = { __typename: 'Query', retailerNetwork: { __typename: 'RetailerNetwork', uuid: string, name: string, displayName: string, customerId: string, adminName: string, numberOfLocations: number, phoneNumber: string, emailAddress: string, numberOfLocationGroups: number, address: { __typename: 'Address', uuid: string, alias?: string | null, street1: string, street2?: string | null, city: string, state: string, zipCode: string }, monthlyPerformanceGoal: { __typename: 'RetailerNetworkMonthlyPerformanceGoal', membersPerStore: number, transactionsPerStore: number } } };

export type RetailerNetworkUsersQueryVariables = Exact<{
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  after?: InputMaybe<Scalars['OCBase64Cursor']['input']>;
  before?: InputMaybe<Scalars['OCBase64Cursor']['input']>;
  filter: RetailerNetworkUsersFilter;
}>;


export type RetailerNetworkUsersQuery = { __typename: 'Query', retailerNetworkUsers: { __typename: 'RetailerNetworkUserConnection', pageInfo: { __typename: 'PageInfo', hasNextPage: boolean, hasPreviousPage: boolean, startCursor?: string | null, endCursor?: string | null }, edges?: Array<{ __typename: 'RetailerNetworkUserEdge', cursor: string, node: { __typename: 'RetailerNetworkUser', uuid: string, userUuid: string, name: string, emailAddress: string, phoneNumber?: string | null, role: Retailer_Network_User_Role, createdAt: string, openCommerceUser?: { __typename: 'OpenCommerceUser', uuid: string, email: string, userRole: User_Role, phoneNumber?: string | null, name: { __typename: 'PersonName', first?: string | null, last?: string | null } } | null, retailerNetworkLocations: Array<{ __typename: 'RetailerNetworkLocation', userAssociationInheritedFromLocationGroup?: string | null } | null> } }> | null } };

export type RetailerNetworkCustomerQueryVariables = Exact<{
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  after?: InputMaybe<Scalars['OCBase64Cursor']['input']>;
  before?: InputMaybe<Scalars['OCBase64Cursor']['input']>;
  filter: RetailerNetworkCustomerFilter;
}>;


export type RetailerNetworkCustomerQuery = { __typename: 'Query', retailerNetworkCustomer: { __typename: 'RetailerNetworkCustomerConnection', pageInfo: { __typename: 'PageInfo', hasNextPage: boolean, hasPreviousPage: boolean, startCursor?: string | null, endCursor?: string | null }, edges?: Array<{ __typename: 'RetailerNetworkCustomerEdge', cursor: string, node: { __typename: 'RetailerNetworkCustomer', uuid: string, id: string, name?: string | null } }> | null } };

export type RetailerNetworkLocationsQueryVariables = Exact<{
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  after?: InputMaybe<Scalars['OCBase64Cursor']['input']>;
  before?: InputMaybe<Scalars['OCBase64Cursor']['input']>;
  filter: RetailerNetworkLocationFilter;
}>;


export type RetailerNetworkLocationsQuery = { __typename: 'Query', retailerNetworkLocations: { __typename: 'RetailerNetworkLocationConnection', pageInfo: { __typename: 'PageInfo', hasNextPage: boolean, hasPreviousPage: boolean, startCursor?: string | null, endCursor?: string | null }, edges?: Array<{ __typename: 'RetailerNetworkLocationEdge', cursor: string, node: { __typename: 'RetailerNetworkLocation', uuid: string, retailerNetworkUuid: string, userAssociationInheritedFromLocationGroup?: string | null, isOnline?: boolean | null, location: { __typename: 'Location', uuid: string, name?: string | null, customerName?: string | null, customerId?: string | null, brand?: { __typename: 'Brand', uuid: string, name: string } | null, brandingDetails?: { __typename: 'LocationBrandingDetails', primaryColor?: string | null, secondaryColor?: string | null } | null, address?: { __typename: 'Address', uuid: string, alias?: string | null, city: string, countryCode: string, state: string, street1: string, street2?: string | null, zipCode: string, geoLocation?: { __typename: 'GeoLocation', latitude: number, longitude: number } | null } | null, phoneNumbers: Array<{ __typename: 'ContactPhoneNumber', phoneNumber: string, phoneType: Phone_Type }>, siteSystemConfiguration: Array<{ __typename: 'SiteSystemConfiguration', uuid: string, identifier: string, hardwareVendor: Hardware_Vendor, details?: { __typename: 'SiteSystemDetails', siteAddress?: string | null, siteName?: string | null, isOnline: boolean } | null }>, hoursOfOperationGroup?: { __typename: 'HoursOfOperationGroup', hours: Array<{ __typename: 'HoursOfOperation', dayOfWeek: Weekday, openTime: string, closeTime: string, genericHoursString?: string | null }> } | null, attributes: Array<{ __typename: 'LocationAttribute', name: string, value: string }> } } }> | null } };

export type RetailerNetworkLocationDetailsQueryVariables = Exact<{
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  after?: InputMaybe<Scalars['OCBase64Cursor']['input']>;
  before?: InputMaybe<Scalars['OCBase64Cursor']['input']>;
  filter: RetailerNetworkLocationFilter;
}>;


export type RetailerNetworkLocationDetailsQuery = { __typename: 'Query', retailerNetworkLocations: { __typename: 'RetailerNetworkLocationConnection', pageInfo: { __typename: 'PageInfo', hasNextPage: boolean, hasPreviousPage: boolean, startCursor?: string | null, endCursor?: string | null }, edges?: Array<{ __typename: 'RetailerNetworkLocationEdge', cursor: string, node: { __typename: 'RetailerNetworkLocation', uuid: string, retailerNetworkUuid: string, userAssociationInheritedFromLocationGroup?: string | null, isOnline?: boolean | null, location: { __typename: 'Location', uuid: string, name?: string | null, customerName?: string | null, customerId?: string | null, fuelGradePrices: Array<{ __typename: 'FuelGradePrice', description: string, unitPrice?: { __typename: 'FuelItemPrice', displayCashPrice: string, displayCreditPrice: string } | null }>, brand?: { __typename: 'Brand', uuid: string, name: string } | null, brandingDetails?: { __typename: 'LocationBrandingDetails', primaryColor?: string | null, secondaryColor?: string | null } | null, address?: { __typename: 'Address', uuid: string, alias?: string | null, city: string, countryCode: string, state: string, street1: string, street2?: string | null, zipCode: string, geoLocation?: { __typename: 'GeoLocation', latitude: number, longitude: number } | null } | null, phoneNumbers: Array<{ __typename: 'ContactPhoneNumber', phoneNumber: string, phoneType: Phone_Type }>, siteSystemConfiguration: Array<{ __typename: 'SiteSystemConfiguration', uuid: string, identifier: string, hardwareVendor: Hardware_Vendor, details?: { __typename: 'SiteSystemDetails', siteAddress?: string | null, siteName?: string | null, isOnline: boolean } | null }>, hoursOfOperationGroup?: { __typename: 'HoursOfOperationGroup', hours: Array<{ __typename: 'HoursOfOperation', dayOfWeek: Weekday, openTime: string, closeTime: string, genericHoursString?: string | null }> } | null, attributes: Array<{ __typename: 'LocationAttribute', name: string, value: string }> } } }> | null } };

export type RetailerNetworkLocationCoordinatesQueryVariables = Exact<{
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  after?: InputMaybe<Scalars['OCBase64Cursor']['input']>;
  before?: InputMaybe<Scalars['OCBase64Cursor']['input']>;
  filter: RetailerNetworkLocationCoordinatesFilter;
}>;


export type RetailerNetworkLocationCoordinatesQuery = { __typename: 'Query', retailerNetworkLocationCoordinates: { __typename: 'RetailerNetworkLocationCoordinatesConnection', totalCount: number, pageInfo: { __typename: 'PageInfo', hasNextPage: boolean, hasPreviousPage: boolean, startCursor?: string | null, endCursor?: string | null }, edges?: Array<{ __typename: 'RetailerNetworkLocationCoordinatesEdge', cursor: string, node: { __typename: 'RetailerNetworkLocationCoordinates', locationUuid: string, locationName?: string | null, geoLocation: { __typename: 'GeoLocation', latitude: number, longitude: number } } }> | null } };

export type RetailerNetworkLocationStatesQueryVariables = Exact<{
  filter: RetailerNetworkLocationStatesFilter;
}>;


export type RetailerNetworkLocationStatesQuery = { __typename: 'Query', retailerNetworkLocationStates: Array<string> };

export type RetailerNetworkLocationCitiesQueryVariables = Exact<{
  filter: RetailerNetworkLocationCitiesFilter;
}>;


export type RetailerNetworkLocationCitiesQuery = { __typename: 'Query', retailerNetworkLocationCities: Array<string> };

export type RetailerNetworkLocationPosConnectionStatusQueryVariables = Exact<{
  filter: RetailerNetworkLocationPosConnectionStatusFilter;
}>;


export type RetailerNetworkLocationPosConnectionStatusQuery = { __typename: 'Query', retailerNetworkLocationPosConnectionStatus: Array<{ __typename: 'RetailerNetworkLocationPosConnectionStatus', identifier?: string | null, hardwareVendor?: Hardware_Vendor | null, mobileEnabled?: boolean | null, mobileConnectedAt?: string | null, loyaltyEnabled?: boolean | null, loyaltyConnectedAt?: string | null, scanDataSubmittedAt?: string | null }> };

export type RetailerNetworkLocationGroupsQueryVariables = Exact<{
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  after?: InputMaybe<Scalars['OCBase64Cursor']['input']>;
  before?: InputMaybe<Scalars['OCBase64Cursor']['input']>;
  filter: RetailerNetworkLocationGroupFilter;
}>;


export type RetailerNetworkLocationGroupsQuery = { __typename: 'Query', retailerNetworkLocationGroups: { __typename: 'RetailerNetworkLocationGroupConnection', pageInfo: { __typename: 'PageInfo', hasNextPage: boolean, hasPreviousPage: boolean, startCursor?: string | null, endCursor?: string | null }, edges: Array<{ __typename: 'RetailerNetworkLocationGroupEdge', cursor: string, node: { __typename: 'RetailerNetworkLocationGroup', uuid: string, name: string, countOfLocations: number } }> } };

export type RetailerNetworkLocationsWithPerformanceExcerptQueryVariables = Exact<{
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  after?: InputMaybe<Scalars['OCBase64Cursor']['input']>;
  before?: InputMaybe<Scalars['OCBase64Cursor']['input']>;
  filter: RetailerNetworkLocationsWithPerformanceExcerptFilter;
  sort?: InputMaybe<RetailerNetworkPerformanceSort>;
}>;


export type RetailerNetworkLocationsWithPerformanceExcerptQuery = { __typename: 'Query', retailerNetworkLocationsWithPerformanceExcerpt: { __typename: 'RetailerNetworkLocationsWithPerformanceExcerptConnection', pageInfo: { __typename: 'PageInfo', hasNextPage: boolean, hasPreviousPage: boolean, startCursor?: string | null, endCursor?: string | null }, edges?: Array<{ __typename: 'RetailerNetworkLocationsWithPerformanceExcerptEdge', cursor: string, node: { __typename: 'RetailerNetworkLocationWithPerformanceExcerpt', locationUuid: string, siteId: string, name: string, isSpecificGoal?: boolean | null, newMembers: { __typename: 'GoalProgress', goal: number, progress: number }, transactions: { __typename: 'GoalProgress', goal: number, progress: number } } }> | null } };

export type RetailerNetworkPerformanceQueryVariables = Exact<{
  filter: RetailerNetworkPerformanceFilter;
}>;


export type RetailerNetworkPerformanceQuery = { __typename: 'Query', retailerNetworkPerformance: { __typename: 'RetailerNetworkPerformance', homeStoreMembers: number, newMembers: { __typename: 'NewMembers', perStoreAverage: number, chartData: Array<{ __typename: 'GoalProgressChartData', timestamp: string, value: number }>, goalProgress: { __typename: 'GoalProgress', goal: number, progress: number } }, loyaltyTransactions: { __typename: 'LoyaltyTransactions', perStoreAverage: number, chartData: Array<{ __typename: 'GoalProgressChartData', timestamp: string, value: number }>, goalProgress: { __typename: 'GoalProgress', goal: number, progress: number } }, loyaltyTransactionsBreakdown: { __typename: 'LoyaltyTransactionsBreakdown', fuelAmount: { __typename: 'PerTransactionBreakdown', total: number, perTransactionAverage: number }, fuelVolume: { __typename: 'PerTransactionBreakdown', total: number, perTransactionAverage: number }, merchandise: { __typename: 'PerTransactionBreakdown', total: number, perTransactionAverage: number } } } };

export type RetailerNetworkLocationDowntimeMetricsQueryVariables = Exact<{
  filter: RetailerNetworkLocationDowntimeMetricsFilter;
}>;


export type RetailerNetworkLocationDowntimeMetricsQuery = { __typename: 'Query', retailerNetworkLocationDowntimeMetrics: Array<{ __typename: 'TimeSeriesMetric', date: string, value: number }> };

export type RetailerNetworkLocationDowntimeMetricsOverviewQueryVariables = Exact<{
  filter: RetailerNetworkLocationDowntimeMetricsOverviewFilter;
}>;


export type RetailerNetworkLocationDowntimeMetricsOverviewQuery = { __typename: 'Query', retailerNetworkLocationDowntimeMetricsOverview: { __typename: 'RetailerNetworkLocationDowntimeMetricsOverview', numberOfStores: number, numberOfConnectedStores: number, disconnectedStoresTimeSeriesOfLast30Days?: Array<{ __typename: 'TimeSeriesMetric', date: string, value: number }> | null } };

export type RetailerNetworkLocationGroupOnlineStatusQueryVariables = Exact<{
  filter: RetailerNetworkLocationDowntimeMetricsOverviewFilter;
}>;


export type RetailerNetworkLocationGroupOnlineStatusQuery = { __typename: 'Query', retailerNetworkLocationDowntimeMetricsOverview: { __typename: 'RetailerNetworkLocationDowntimeMetricsOverview', numberOfStores: number, numberOfConnectedStores: number } };

export type RetailerNetworkTransactionMetricsOverviewQueryVariables = Exact<{
  filter: RetailerNetworkTransactionMetricsOverviewFilter;
}>;


export type RetailerNetworkTransactionMetricsOverviewQuery = { __typename: 'Query', retailerNetworkTransactionMetricsOverview?: { __typename: 'RetailerNetworkTransactionMetricsOverview', actualPerformance: { __typename: 'RetailerNetworkTransactionMetricsOverviewData', numberOfLoyaltyTransactionsLast7Days: number, numberOfLoyaltyTransactionsLast30Days: number, numberOfLoyaltyTransactionsToday: number, numberOfLoyaltyTransactionsYesterday: number }, prevPerformance: { __typename: 'RetailerNetworkTransactionMetricsOverviewData', numberOfLoyaltyTransactionsLast7Days: number, numberOfLoyaltyTransactionsLast30Days: number, numberOfLoyaltyTransactionsToday: number, numberOfLoyaltyTransactionsYesterday: number }, loyaltyTransactionsTimeSeries?: Array<{ __typename: 'TimeSeriesMetric', date: string, value: number }> | null } | null };

export type RetailerNetworkScanDataLatestSubmissionsQueryVariables = Exact<{
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  after?: InputMaybe<Scalars['OCBase64Cursor']['input']>;
  before?: InputMaybe<Scalars['OCBase64Cursor']['input']>;
  filter: RetailerNetworkScanDataWeeklySubmissionFilter;
}>;


export type RetailerNetworkScanDataLatestSubmissionsQuery = { __typename: 'Query', retailerNetworkScanDataWeeklySubmissions: { __typename: 'RetailerNetworkScanDataWeeklySubmissionConnection', edges?: Array<{ __typename: 'RetailerNetworkScanDataWeeklySubmissionEdge', node: { __typename: 'RetailerNetworkScanDataWeeklySubmission', submittedAt: string, status: ScanDataWeeklySubmissionStatus, totalSitesSubmitted: number, totalMultiUnitTransactions: number, totalLoyaltyTransactions: number, estimatedReimbursements: { __typename: 'Reimbursements', multiUnit: number, loyalty: number }, previousEstimatedReimbursements: { __typename: 'Reimbursements', multiUnit: number, loyalty: number } } }> | null } };

export type RetailerNetworkScanDataSubmissionsQueryVariables = Exact<{
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  after?: InputMaybe<Scalars['OCBase64Cursor']['input']>;
  before?: InputMaybe<Scalars['OCBase64Cursor']['input']>;
  filter: RetailerNetworkScanDataWeeklySubmissionFilter;
}>;


export type RetailerNetworkScanDataSubmissionsQuery = { __typename: 'Query', retailerNetworkScanDataWeeklySubmissions: { __typename: 'RetailerNetworkScanDataWeeklySubmissionConnection', pageInfo: { __typename: 'PageInfo', hasNextPage: boolean, hasPreviousPage: boolean, startCursor?: string | null, endCursor?: string | null }, edges?: Array<{ __typename: 'RetailerNetworkScanDataWeeklySubmissionEdge', node: { __typename: 'RetailerNetworkScanDataWeeklySubmission', submittedAt: string, status: ScanDataWeeklySubmissionStatus, totalSitesSubmitted: number, totalMultiUnitTransactions: number, totalLoyaltyTransactions: number, submissions: Array<{ __typename: 'ScanDataSubmission', type: ScanDataSubmissionType, status: ScanDataSubmissionStatus, totalLoyaltyTransactions: number, totalMultiUnitTransactions: number, estimatedReimbursements: { __typename: 'Reimbursements', multiUnit: number, loyalty: number }, previousEstimatedReimbursements: { __typename: 'Reimbursements', multiUnit: number, loyalty: number } }>, estimatedReimbursements: { __typename: 'Reimbursements', multiUnit: number, loyalty: number }, previousEstimatedReimbursements: { __typename: 'Reimbursements', multiUnit: number, loyalty: number } } }> | null } };

export type RetailerNetworkScanDataTobaccoSubmissionsOverviewQueryVariables = Exact<{
  filter: RetailerNetworkScanDataTobaccoSubmissionsOverviewFilter;
}>;


export type RetailerNetworkScanDataTobaccoSubmissionsOverviewQuery = { __typename: 'Query', retailerNetworkScanDataTobaccoSubmissionsOverview: { __typename: 'RetailerNetworkScanDataTobaccoSubmissionsOverview', totalSites: number, totalSitesSubmitted: number, estimatedReimbursements: { __typename: 'Reimbursements', multiUnit: number, loyalty: number }, previousEstimatedReimbursements: { __typename: 'Reimbursements', multiUnit: number, loyalty: number }, estimatedReimbursementsTimeSeries: Array<{ __typename: 'ReimbursementsTimeSeriesDataPoint', date: string, value: { __typename: 'Reimbursements', multiUnit: number, loyalty: number } } | null> } };

export type RetailerNetworkScanDataTobaccoSiteSubmissionsQueryVariables = Exact<{
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  after?: InputMaybe<Scalars['OCBase64Cursor']['input']>;
  before?: InputMaybe<Scalars['OCBase64Cursor']['input']>;
  filter: RetailerNetworkScanDataTobaccoSiteSubmissionFilter;
}>;


export type RetailerNetworkScanDataTobaccoSiteSubmissionsQuery = { __typename: 'Query', retailerNetworkScanDataTobaccoSiteSubmissions: { __typename: 'RetailerNetworkScanDataTobaccoSiteSubmissionConnection', pageInfo: { __typename: 'PageInfo', hasNextPage: boolean, hasPreviousPage: boolean, startCursor?: string | null, endCursor?: string | null }, edges?: Array<{ __typename: 'RetailerNetworkScanDataTobaccoSubmissionEdge', node: { __typename: 'RetailerNetworkScanDataTobaccoSubmission', siteId: string, siteName: string, submittedAt: string, totalMultiUnitTransactions: number, previousTotalMultiUnitTransactions: number, totalLoyaltyTransactions: number, previousTotalLoyaltyTransactions: number, estimatedReimbursements: { __typename: 'Reimbursements', multiUnit: number, loyalty: number }, submissions: Array<{ __typename: 'ScanDataSubmission', type: ScanDataSubmissionType, status: ScanDataSubmissionStatus }> } }> | null } };

export type RetailerNetworkLoyaltyMetricsOverviewQueryVariables = Exact<{
  filter: RetailerNetworkLoyaltyMetricsFilter;
}>;


export type RetailerNetworkLoyaltyMetricsOverviewQuery = { __typename: 'Query', retailerNetworkLoyaltyMetricsOverview: { __typename: 'RetailerNetworkLoyaltyMetricsOverview', actualPeriodPerformance: { __typename: 'RetailerNetworkLoyaltyMetricsByPeriod', avgFuelSalesPerTransaction: number, avgSavingPerTransaction: number, avgUnitsSalesPerStore: number, avgUnitsSold: number, avgValuePerTransaction: number, numberOfTransactions: number, offerEngagementRate: number, totalFuelSales: number, totalUnitsSales: number, unitsSold: number }, prevPeriodPerformance: { __typename: 'RetailerNetworkLoyaltyMetricsByPeriod', avgFuelSalesPerTransaction: number, avgSavingPerTransaction: number, avgUnitsSalesPerStore: number, avgUnitsSold: number, avgValuePerTransaction: number, numberOfTransactions: number, offerEngagementRate: number, totalFuelSales: number, totalUnitsSales: number, unitsSold: number }, loyaltyTransactionsTimeSeries?: Array<{ __typename: 'TimeSeriesMetric', date: string, value: number }> | null } };

export type RetailerNetworkLocationOfferMetricsOverviewQueryVariables = Exact<{
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  after?: InputMaybe<Scalars['OCBase64Cursor']['input']>;
  before?: InputMaybe<Scalars['OCBase64Cursor']['input']>;
  filter: RetailerNetworkOfferMetricsOverviewFilter;
  sort?: InputMaybe<RetailerNetworkOfferMetricsOverviewSort>;
}>;


export type RetailerNetworkLocationOfferMetricsOverviewQuery = { __typename: 'Query', retailerNetworkLocationOfferMetricsOverview: { __typename: 'RetailerNetworkOfferMetricsOverviewConnection', pageInfo: { __typename: 'PageInfo', hasNextPage: boolean, hasPreviousPage: boolean, startCursor?: string | null, endCursor?: string | null }, edges: Array<{ __typename: 'RetailerNetworkOfferMetricsOverviewEdge', cursor: string, node: { __typename: 'RetailerNetworkOfferMetricsOverviewNode', uuid: string, offerUuid: string, offerName: string, redemptions: number, prevPeriodRedemptions: number, averageRedemptionsPerStore: number } }> } };

export type RetailerNetworkTobaccoProgramMetricsOverviewQueryVariables = Exact<{
  filter: RetailerNetworkTobaccoProgramOverviewFilter;
}>;


export type RetailerNetworkTobaccoProgramMetricsOverviewQuery = { __typename: 'Query', retailerNetworkTobaccoProgramMetricsOverview: { __typename: 'RetailerNetworkTobaccoProgramOverview', performance: { __typename: 'RetailerNetworkTobaccoProgramPerformance', totalTransactions: number, memberMetrics: { __typename: 'RetailerNetworkTobaccoProgramMembersMetric', totalMembers: number, totalNewMembers: number, totalActiveMembers: number, retentionRate: number }, loyaltyMetrics: { __typename: 'RetailerNetworkTobaccoProgramTransactionMetric', totalTransactions: number, avgCustomerSavings: number, estimatedReimbursements: number, basketSize: number }, multiUnitMetrics: { __typename: 'RetailerNetworkTobaccoProgramTransactionMetric', totalTransactions: number, avgCustomerSavings: number, estimatedReimbursements: number, basketSize: number } }, previousPerformance: { __typename: 'RetailerNetworkTobaccoProgramPerformance', totalTransactions: number, memberMetrics: { __typename: 'RetailerNetworkTobaccoProgramMembersMetric', totalMembers: number, totalNewMembers: number, totalActiveMembers: number, retentionRate: number }, loyaltyMetrics: { __typename: 'RetailerNetworkTobaccoProgramTransactionMetric', totalTransactions: number, avgCustomerSavings: number, estimatedReimbursements: number, basketSize: number }, multiUnitMetrics: { __typename: 'RetailerNetworkTobaccoProgramTransactionMetric', totalTransactions: number, avgCustomerSavings: number, estimatedReimbursements: number, basketSize: number } }, tobaccoTransactionsTimeSeries: Array<{ __typename: 'TimeSeriesDataPoint', date: string, value: number }> } };

export type RetailerNetworkTobaccoProgramMetricTimeSeriesQueryVariables = Exact<{
  filter: RetailerNetworkTobaccoProgramMetricTimeSeriesFilter;
  metricType: RetailerNetworkTobaccoProgramMetricType;
}>;


export type RetailerNetworkTobaccoProgramMetricTimeSeriesQuery = { __typename: 'Query', retailerNetworkTobaccoProgramMetricTimeSeries: Array<{ __typename: 'TimeSeriesDataPoint', date: string, value: number }> };

export type RetailerNetworkTobaccoProgramSitesMetricQueryVariables = Exact<{
  metricType: RetailerNetworkTobaccoProgramMetricType;
  filter: RetailerNetworkTobaccoProgramSitesMetricFilter;
  sort: RetailerNetworkTobaccoProgramSitesMetricSort;
  after?: InputMaybe<Scalars['OCBase64Cursor']['input']>;
  before?: InputMaybe<Scalars['OCBase64Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
}>;


export type RetailerNetworkTobaccoProgramSitesMetricQuery = { __typename: 'Query', retailerNetworkTobaccoProgramSitesMetric: { __typename: 'RetailerNetworkTobaccoProgramSitesMetricConnection', pageInfo: { __typename: 'PageInfo', hasNextPage: boolean, hasPreviousPage: boolean, startCursor?: string | null, endCursor?: string | null }, edges: Array<{ __typename: 'RetailerNetworkTobaccoProgramSiteMetricEdge', cursor: string, node: { __typename: 'RetailerNetworkTobaccoProgramSiteMetric', rank: number, siteId: string, siteAddress: string, siteName: string, value: number, previousValue: number } }> } };

export type RetailerNetworkCpgManufacturerProgramsQueryVariables = Exact<{
  filter: RetailerNetworkCpgManufacturerProgramsFilter;
}>;


export type RetailerNetworkCpgManufacturerProgramsQuery = { __typename: 'Query', retailerNetworkCPGManufacturerPrograms: Array<{ __typename: 'CPGManufacturerProgram', id: string, manufacturer: CpgManufacturer, name: string }> };

export type RetailerNetworkTobaccoManufacturerOfferPerformanceQueryVariables = Exact<{
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  after?: InputMaybe<Scalars['OCBase64Cursor']['input']>;
  before?: InputMaybe<Scalars['OCBase64Cursor']['input']>;
  filter: RetailerNetworkTobaccoManufacturerOfferPerformanceFilter;
}>;


export type RetailerNetworkTobaccoManufacturerOfferPerformanceQuery = { __typename: 'Query', retailerNetworkTobaccoManufacturerOfferPerformance: { __typename: 'RetailerNetworkTobaccoManufacturerOfferPerformanceConnection', pageInfo: { __typename: 'PageInfo', hasNextPage: boolean, hasPreviousPage: boolean, startCursor?: string | null, endCursor?: string | null }, edges: Array<{ __typename: 'RetailerNetworkTobaccoManufacturerOfferPerformanceEdge', cursor: string, node: { __typename: 'RetailerNetworkTobaccoManufacturerOfferPerformance', offerName: string, redemptions: number, totalStores: number, estimatedReimbursements: { __typename: 'Reimbursements', multiUnit: number, loyalty: number }, previousEstimatedReimbursements: { __typename: 'Reimbursements', multiUnit: number, loyalty: number } } }> } };

export type CustomerScanDataOverviewFragment = { __typename: 'CustomerScanDataOverview', lastSubmissionDate: string, cpgSubmissionStatus: Array<{ __typename: 'CPGSubmissionStatus', cpg: Cpg, enabled: boolean } | null> };

export type ScanDataSubmissionHealthMetricsFragment = { __typename: 'ScanDataSubmissionHealthMetrics', submissionDate: string, totalStores: Array<{ __typename: 'TimeSeriesDataPoint', date: string, value: number }>, missingStores: Array<{ __typename: 'TimeSeriesDataPoint', date: string, value: number }>, reportLines: Array<{ __typename: 'TimeSeriesDataPoint', date: string, value: number }>, weeklyReimbursementsTrends: Array<{ __typename: 'ReimbursementsTimeSeriesDataPoint', date: string, value: { __typename: 'Reimbursements', multiUnit: number, loyalty: number } }>, estimatedReimbursements?: { __typename: 'EstimatedReimbursements', multipackTotal: number, loyaltyTotal: number } | null };

export type TimeSeriesDataPointFragment = { __typename: 'TimeSeriesDataPoint', date: string, value: number };

export type EstimatedReimbursementsFragment = { __typename: 'EstimatedReimbursements', multipackTotal: number, loyaltyTotal: number };

export type ScanDataSftpCredentialsOverviewFragment = { __typename: 'ScanDataSftpCredentialsOverview', totalAltria: number, totalMSA: number, totalRJR: number };

export type ScanDataWeekEndingPerformanceFragment = { __typename: 'ScanDataWeekEndingPerformance', storesWithTransactions: number, missingStores: number, reportedLines: number };

export type ScanDataWeekEndingOverviewFragment = { __typename: 'ScanDataWeekEndingOverview', fileStatus: ScanDataFileStatusType, isResubmitted: boolean, lastTransactionLogPulledAt: string, weekEndPerformance: { __typename: 'ScanDataWeekEndingPerformance', storesWithTransactions: number, missingStores: number, reportedLines: number }, pastWeekEndPerformance: { __typename: 'ScanDataWeekEndingPerformance', storesWithTransactions: number, missingStores: number, reportedLines: number } };

export type ScanDataSubmissionGroupSubmissionDetailsFragment = { __typename: 'ScanDataSubmissionGroupSubmissionDetails', actionsAvailable: boolean, fileStatus: ScanDataFileStatusType, isResubmitted: boolean, name: string, storesSubmittedCount: number, totalStoresCount: number, type: ScanDataSubmissionType };

export type ScanDataSubmissionsFragment = { __typename: 'ScanDataSubmissions', estimatedReimbursements: number, type: ScanDataSubmissionType, fileStatus: ScanDataFileStatusType, submissionDate: string, submissionGroupsCount: number, submittedSubmissionGroupsCount: number, transactionsReportedCount: number, transactionsReportedChangePercent: number, previousTransactionsReportedCount: number, submissionGroupsDetails: Array<{ __typename: 'ScanDataSubmissionGroupSubmissionDetails', actionsAvailable: boolean, fileStatus: ScanDataFileStatusType, isResubmitted: boolean, name: string, storesSubmittedCount: number, totalStoresCount: number, type: ScanDataSubmissionType }> };

export type ScanDataMetricsTimeSeriesFragment = { __typename: 'ScanDataMetricsTimeSeries', submissionDate: string, storesSubmitted: Array<{ __typename: 'TimeSeriesDataPoint', date: string, value: number }>, missingStores: Array<{ __typename: 'TimeSeriesDataPoint', date: string, value: number }>, transactionsReported: Array<{ __typename: 'TimeSeriesDataPoint', date: string, value: number }>, reimbursements: Array<{ __typename: 'TimeSeriesDataPoint', date: string, value: number }> };

type ScanDataStoreLevelDetails_ScanDataMissingStoreStoreLevelDetails_Fragment = { __typename: 'ScanDataMissingStoreStoreLevelDetails', siteID: string, siteName: string, altriaRCN?: string | null, altriaSubmitterID?: string | null, rjrAccountNumber?: string | null, rjrSubmitterID?: string | null, msaSubmitterID?: string | null };

type ScanDataStoreLevelDetails_ScanDataReimbursementsStoreLevelDetails_Fragment = { __typename: 'ScanDataReimbursementsStoreLevelDetails', siteID: string, siteName: string, altriaRCN?: string | null, altriaSubmitterID?: string | null, rjrAccountNumber?: string | null, rjrSubmitterID?: string | null, msaSubmitterID?: string | null };

type ScanDataStoreLevelDetails_ScanDataReportedTransactionsStoreLevelDetails_Fragment = { __typename: 'ScanDataReportedTransactionsStoreLevelDetails', siteID: string, siteName: string, altriaRCN?: string | null, altriaSubmitterID?: string | null, rjrAccountNumber?: string | null, rjrSubmitterID?: string | null, msaSubmitterID?: string | null };

type ScanDataStoreLevelDetails_ScanDataSubmittedTransactionsStoreLevelDetails_Fragment = { __typename: 'ScanDataSubmittedTransactionsStoreLevelDetails', siteID: string, siteName: string, altriaRCN?: string | null, altriaSubmitterID?: string | null, rjrAccountNumber?: string | null, rjrSubmitterID?: string | null, msaSubmitterID?: string | null };

export type ScanDataStoreLevelDetailsFragment = ScanDataStoreLevelDetails_ScanDataMissingStoreStoreLevelDetails_Fragment | ScanDataStoreLevelDetails_ScanDataReimbursementsStoreLevelDetails_Fragment | ScanDataStoreLevelDetails_ScanDataReportedTransactionsStoreLevelDetails_Fragment | ScanDataStoreLevelDetails_ScanDataSubmittedTransactionsStoreLevelDetails_Fragment;

export type ScanDataSubmittedTransactionsStoreLevelDetailsFragment = { __typename: 'ScanDataSubmittedTransactionsStoreLevelDetails', siteID: string, siteName: string, altriaRCN?: string | null, altriaSubmitterID?: string | null, rjrAccountNumber?: string | null, rjrSubmitterID?: string | null, msaSubmitterID?: string | null };

export type ScanDataMissingStoreStoreLevelDetailsFragment = { __typename: 'ScanDataMissingStoreStoreLevelDetails', siteID: string, siteName: string, altriaRCN?: string | null, altriaSubmitterID?: string | null, rjrAccountNumber?: string | null, rjrSubmitterID?: string | null, msaSubmitterID?: string | null };

export type ScanDataReimbursementsStoreLevelDetailsFragment = { __typename: 'ScanDataReimbursementsStoreLevelDetails', siteID: string, siteName: string, altriaRCN?: string | null, altriaSubmitterID?: string | null, rjrAccountNumber?: string | null, rjrSubmitterID?: string | null, msaSubmitterID?: string | null, estimatedReimbursements: { __typename: 'EstimatedReimbursements', multipackTotal: number, loyaltyTotal: number } };

export type ScanDataReportedTransactionsStoreLevelDetailsFragment = { __typename: 'ScanDataReportedTransactionsStoreLevelDetails', reportedTransactions: number, siteID: string, siteName: string, altriaRCN?: string | null, altriaSubmitterID?: string | null, rjrAccountNumber?: string | null, rjrSubmitterID?: string | null, msaSubmitterID?: string | null };

export type ScanDataSftpCredentialFragment = { __typename: 'ScanDataSftpCredential', cpg: Cpg, credentialStatus: ScanDataSftpCredentialStatus, host: string, name?: string | null, password: string, port?: number | null, submissionStatus?: ScanDataSftpCredentialSubmissionStatus | null, submitterID: string, username: string, uuid: string };

export type ScanDataSftpCredentialsWithStoreDetailsFragment = { __typename: 'ScanDataSftpCredentialsWithStoreDetails', id: string, accountIdentifier: string, username: string, submitterID: string, host: string, cpg: Cpg, locations?: Array<{ __typename: 'ScanDataSftpCredentialsStoreDetails', uuid: string, accountIdentifier: string, siteId: string, siteName: string, siteAddress: string, sitePhoneNumber?: string | null }> | null };

export type ScanDataMissingStoresDetailsFragment = { __typename: 'ScanDataMissingStoresDetails', siteID: string, siteName: string, siteAddress: string, phoneNumber?: string | null };

export type SubmissionGroupLocationFragment = { __typename: 'Location', uuid: string, altriaMan?: string | null, altriaRcn?: string | null, rjrAccountNumber?: string | null, address?: { __typename: 'Address', street1: string, city: string, state: string, zipCode: string, alias?: string | null } | null, siteSystemConfiguration: Array<{ __typename: 'SiteSystemConfiguration', identifier: string, details?: { __typename: 'SiteSystemDetails', siteName?: string | null } | null }>, phoneNumbers: Array<{ __typename: 'ContactPhoneNumber', phoneNumber: string }> };

export type ScanDataGenerateSubmissionCsvMutationVariables = Exact<{
  input: ScanDataGenerateSubmissionCsvInput;
}>;


export type ScanDataGenerateSubmissionCsvMutation = { __typename: 'Mutation', scanDataGenerateSubmissionCSV: string };

export type ScanDataSubmitWeeklyFileMutationVariables = Exact<{
  input: ScanDataSumbitWeeklyFileInput;
}>;


export type ScanDataSubmitWeeklyFileMutation = { __typename: 'Mutation', scanDataSumbitWeeklyFile: boolean };

export type CreateScanDataSftpCredentialsMutationVariables = Exact<{
  input: ScanDataSftpCredentialCreateInput;
}>;


export type CreateScanDataSftpCredentialsMutation = { __typename: 'Mutation', scanDataSftpCredentialsCreate: { __typename: 'ScanDataSftpCredential', cpg: Cpg, credentialStatus: ScanDataSftpCredentialStatus, host: string, name?: string | null, password: string, port?: number | null, submissionStatus?: ScanDataSftpCredentialSubmissionStatus | null, submitterID: string, username: string, uuid: string } };

export type UpdateScanDataSftpCredentialsMutationVariables = Exact<{
  input: ScanDataSftpCredentialUpdateInput;
}>;


export type UpdateScanDataSftpCredentialsMutation = { __typename: 'Mutation', scanDataSftpCredentialsUpdate: { __typename: 'ScanDataSftpCredential', cpg: Cpg, credentialStatus: ScanDataSftpCredentialStatus, host: string, name?: string | null, password: string, port?: number | null, submissionStatus?: ScanDataSftpCredentialSubmissionStatus | null, submitterID: string, username: string, uuid: string } };

export type LocationBulkSubmitterIdUpdateMutationVariables = Exact<{
  input: LocationBulkSubmitterIdUpdateInput;
}>;


export type LocationBulkSubmitterIdUpdateMutation = { __typename: 'Mutation', locationBulkSubmitterIdUpdate: boolean };

export type CustomerScanDataOverviewQueryVariables = Exact<{ [key: string]: never; }>;


export type CustomerScanDataOverviewQuery = { __typename: 'Query', customerScanDataOverview: { __typename: 'CustomerScanDataOverview', lastSubmissionDate: string, cpgSubmissionStatus: Array<{ __typename: 'CPGSubmissionStatus', cpg: Cpg, enabled: boolean } | null> } };

export type ScanDataSubmissionHealthMetricsQueryVariables = Exact<{
  filter: ScanDataSubmissionHealthMetricsFilter;
}>;


export type ScanDataSubmissionHealthMetricsQuery = { __typename: 'Query', scanDataSubmissionHealthMetrics: { __typename: 'ScanDataSubmissionHealthMetrics', submissionDate: string, totalStores: Array<{ __typename: 'TimeSeriesDataPoint', date: string, value: number }>, missingStores: Array<{ __typename: 'TimeSeriesDataPoint', date: string, value: number }>, reportLines: Array<{ __typename: 'TimeSeriesDataPoint', date: string, value: number }>, weeklyReimbursementsTrends: Array<{ __typename: 'ReimbursementsTimeSeriesDataPoint', date: string, value: { __typename: 'Reimbursements', multiUnit: number, loyalty: number } }>, estimatedReimbursements?: { __typename: 'EstimatedReimbursements', multipackTotal: number, loyaltyTotal: number } | null } };

export type GetScanDataSubmissionsQueryVariables = Exact<{
  after?: InputMaybe<Scalars['OCBase64Cursor']['input']>;
  before?: InputMaybe<Scalars['OCBase64Cursor']['input']>;
  filter?: InputMaybe<ScanDataSubmissionFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
}>;


export type GetScanDataSubmissionsQuery = { __typename: 'Query', scanDataSubmissions: { __typename: 'ScanDataSubmissionsConnection', edges: Array<{ __typename: 'ScanDataSubmissionsEdge', cursor: string, node: { __typename: 'ScanDataSubmissions', estimatedReimbursements: number, type: ScanDataSubmissionType, fileStatus: ScanDataFileStatusType, submissionDate: string, submissionGroupsCount: number, submittedSubmissionGroupsCount: number, transactionsReportedCount: number, transactionsReportedChangePercent: number, previousTransactionsReportedCount: number, submissionGroupsDetails: Array<{ __typename: 'ScanDataSubmissionGroupSubmissionDetails', actionsAvailable: boolean, fileStatus: ScanDataFileStatusType, isResubmitted: boolean, name: string, storesSubmittedCount: number, totalStoresCount: number, type: ScanDataSubmissionType }> } }>, pageInfo: { __typename: 'PageInfo', hasNextPage: boolean, hasPreviousPage: boolean, startCursor?: string | null, endCursor?: string | null } } };

export type GetScanDataSftpCredentialsOverviewQueryVariables = Exact<{ [key: string]: never; }>;


export type GetScanDataSftpCredentialsOverviewQuery = { __typename: 'Query', scanDataSftpCredentialsOverview: { __typename: 'ScanDataSftpCredentialsOverview', totalAltria: number, totalMSA: number, totalRJR: number } };

export type ScanDataWeekEndingOverviewQueryVariables = Exact<{
  filter?: InputMaybe<ScanDataWeekEndingOverviewFilter>;
}>;


export type ScanDataWeekEndingOverviewQuery = { __typename: 'Query', scanDataWeekEndingOverview: { __typename: 'ScanDataWeekEndingOverview', fileStatus: ScanDataFileStatusType, isResubmitted: boolean, lastTransactionLogPulledAt: string, weekEndPerformance: { __typename: 'ScanDataWeekEndingPerformance', storesWithTransactions: number, missingStores: number, reportedLines: number }, pastWeekEndPerformance: { __typename: 'ScanDataWeekEndingPerformance', storesWithTransactions: number, missingStores: number, reportedLines: number } } };

export type ScanDataMetricsTimeSeriesQueryVariables = Exact<{
  filter: ScanDataMetricsTimeSeriesFilter;
}>;


export type ScanDataMetricsTimeSeriesQuery = { __typename: 'Query', scanDataMetricsTimeSeries: { __typename: 'ScanDataMetricsTimeSeries', submissionDate: string, storesSubmitted: Array<{ __typename: 'TimeSeriesDataPoint', date: string, value: number }>, missingStores: Array<{ __typename: 'TimeSeriesDataPoint', date: string, value: number }>, transactionsReported: Array<{ __typename: 'TimeSeriesDataPoint', date: string, value: number }>, reimbursements: Array<{ __typename: 'TimeSeriesDataPoint', date: string, value: number }> } };

export type ScanDataSubmittedTransactionsStoreLevelDetailsQueryVariables = Exact<{
  filter: ScanDataSubmittedTransactionsStoreLevelDetailsFilter;
  first?: InputMaybe<Scalars['Int']['input']>;
  after?: InputMaybe<Scalars['OCBase64Cursor']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  before?: InputMaybe<Scalars['OCBase64Cursor']['input']>;
}>;


export type ScanDataSubmittedTransactionsStoreLevelDetailsQuery = { __typename: 'Query', scanDataSubmittedTransactionsStoreLevelDetails: { __typename: 'ScanDataSubmittedTransactionsStoreLevelDetailsConnection', pageInfo: { __typename: 'PageInfo', hasNextPage: boolean, hasPreviousPage: boolean, startCursor?: string | null, endCursor?: string | null }, edges: Array<{ __typename: 'ScanDataSubmittedTransactionsStoreLevelDetailsEdge', cursor: string, node: { __typename: 'ScanDataSubmittedTransactionsStoreLevelDetails', siteID: string, siteName: string, altriaRCN?: string | null, altriaSubmitterID?: string | null, rjrAccountNumber?: string | null, rjrSubmitterID?: string | null, msaSubmitterID?: string | null } }> } };

export type ScanDataMissingStoresStoreLevelDetailsQueryVariables = Exact<{
  filter: ScanDataMissingStoresStoreLevelDetailsFilter;
  first?: InputMaybe<Scalars['Int']['input']>;
  after?: InputMaybe<Scalars['OCBase64Cursor']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  before?: InputMaybe<Scalars['OCBase64Cursor']['input']>;
}>;


export type ScanDataMissingStoresStoreLevelDetailsQuery = { __typename: 'Query', scanDataMissingStoresStoreLevelDetails: { __typename: 'ScanDataMissingStoreStoreLevelDetailsConnection', pageInfo: { __typename: 'PageInfo', hasNextPage: boolean, hasPreviousPage: boolean, startCursor?: string | null, endCursor?: string | null }, edges: Array<{ __typename: 'ScanDataMissingStoreStoreLevelDetailsEdge', cursor: string, node: { __typename: 'ScanDataMissingStoreStoreLevelDetails', siteID: string, siteName: string, altriaRCN?: string | null, altriaSubmitterID?: string | null, rjrAccountNumber?: string | null, rjrSubmitterID?: string | null, msaSubmitterID?: string | null } }> } };

export type ScanDataReportedTransactionsStoreLevelDetailsQueryVariables = Exact<{
  filter: ScanDataReportedTransactionsStoreLevelDetailsFilter;
  first?: InputMaybe<Scalars['Int']['input']>;
  after?: InputMaybe<Scalars['OCBase64Cursor']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  before?: InputMaybe<Scalars['OCBase64Cursor']['input']>;
}>;


export type ScanDataReportedTransactionsStoreLevelDetailsQuery = { __typename: 'Query', scanDataReportedTransactionsStoreLevelDetails: { __typename: 'ScanDataReportedTransactionsStoreLevelDetailsConnection', pageInfo: { __typename: 'PageInfo', hasNextPage: boolean, hasPreviousPage: boolean, startCursor?: string | null, endCursor?: string | null }, edges: Array<{ __typename: 'ScanDataReportedTransactionsStoreLevelDetailsEdge', cursor: string, node: { __typename: 'ScanDataReportedTransactionsStoreLevelDetails', reportedTransactions: number, siteID: string, siteName: string, altriaRCN?: string | null, altriaSubmitterID?: string | null, rjrAccountNumber?: string | null, rjrSubmitterID?: string | null, msaSubmitterID?: string | null } }> } };

export type ScanDataReimbursementsStoreLevelDetailsQueryVariables = Exact<{
  filter: ScanDataReimbursementsStoreLevelDetailsFilter;
  first?: InputMaybe<Scalars['Int']['input']>;
  after?: InputMaybe<Scalars['OCBase64Cursor']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  before?: InputMaybe<Scalars['OCBase64Cursor']['input']>;
}>;


export type ScanDataReimbursementsStoreLevelDetailsQuery = { __typename: 'Query', scanDataReimbursementsStoreLevelDetails: { __typename: 'ScanDataReimbursementsStoreLevelDetailsConnection', pageInfo: { __typename: 'PageInfo', hasNextPage: boolean, hasPreviousPage: boolean, startCursor?: string | null, endCursor?: string | null }, edges: Array<{ __typename: 'ScanDataReimbursementsStoreLevelDetailsEdge', cursor: string, node: { __typename: 'ScanDataReimbursementsStoreLevelDetails', siteID: string, siteName: string, altriaRCN?: string | null, altriaSubmitterID?: string | null, rjrAccountNumber?: string | null, rjrSubmitterID?: string | null, msaSubmitterID?: string | null, estimatedReimbursements: { __typename: 'EstimatedReimbursements', multipackTotal: number, loyaltyTotal: number } } }> } };

export type GetScanDataSftpCredentialsWithStoreDetailsListQueryVariables = Exact<{
  filter?: InputMaybe<ListScanDataSftpCredentialsWithStoreDetailsFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  after?: InputMaybe<Scalars['OCBase64Cursor']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  before?: InputMaybe<Scalars['OCBase64Cursor']['input']>;
  cpg: Cpg;
}>;


export type GetScanDataSftpCredentialsWithStoreDetailsListQuery = { __typename: 'Query', listScanDataSftpCredentialsWithStoreDetails: { __typename: 'ScanDataSftpCredentialsWithStoreDetailsConnection', pageInfo: { __typename: 'PageInfo', hasNextPage: boolean, hasPreviousPage: boolean, startCursor?: string | null, endCursor?: string | null }, edges?: Array<{ __typename: 'ScanDataSftpCredentialsWithStoreDetailsEdge', cursor: string, node: { __typename: 'ScanDataSftpCredentialsWithStoreDetails', id: string, accountIdentifier: string, username: string, submitterID: string, host: string, cpg: Cpg, locations?: Array<{ __typename: 'ScanDataSftpCredentialsStoreDetails', uuid: string, accountIdentifier: string, siteId: string, siteName: string, siteAddress: string, sitePhoneNumber?: string | null }> | null } }> | null } };

export type GetScanDataMissingStoresDetailsQueryVariables = Exact<{
  filter?: InputMaybe<ScanDataMissingStoresDetailsFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  after?: InputMaybe<Scalars['OCBase64Cursor']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  before?: InputMaybe<Scalars['OCBase64Cursor']['input']>;
}>;


export type GetScanDataMissingStoresDetailsQuery = { __typename: 'Query', scanDataMissingStoresDetails: { __typename: 'ScanDataMissingStoresDetailsConnection', pageInfo: { __typename: 'PageInfo', hasNextPage: boolean, hasPreviousPage: boolean, startCursor?: string | null, endCursor?: string | null }, edges: Array<{ __typename: 'ScanDataMissingStoresDetailsEdge', cursor: string, node: { __typename: 'ScanDataMissingStoresDetails', siteID: string, siteName: string, siteAddress: string, phoneNumber?: string | null } }> } };

export type GetScanDataSftpCredentialByUuidQueryVariables = Exact<{
  uuid: Scalars['ID']['input'];
}>;


export type GetScanDataSftpCredentialByUuidQuery = { __typename: 'Query', getScanDataSftpCredentialByUuid?: { __typename: 'ScanDataSftpCredential', cpg: Cpg, credentialStatus: ScanDataSftpCredentialStatus, host: string, name?: string | null, password: string, port?: number | null, submissionStatus?: ScanDataSftpCredentialSubmissionStatus | null, submitterID: string, username: string, uuid: string } | null };

export type GetSubmissionGroupLocationsQueryVariables = Exact<{
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<LocationFilter>;
}>;


export type GetSubmissionGroupLocationsQuery = { __typename: 'Query', locations: { __typename: 'LocationConnection', pageInfo: { __typename: 'PageInfo', hasNextPage: boolean, hasPreviousPage: boolean, startCursor?: string | null, endCursor?: string | null }, edges?: Array<{ __typename: 'LocationEdge', cursor: string, node: { __typename: 'Location', uuid: string, altriaMan?: string | null, altriaRcn?: string | null, rjrAccountNumber?: string | null, address?: { __typename: 'Address', street1: string, city: string, state: string, zipCode: string, alias?: string | null } | null, siteSystemConfiguration: Array<{ __typename: 'SiteSystemConfiguration', identifier: string, details?: { __typename: 'SiteSystemDetails', siteName?: string | null } | null }>, phoneNumbers: Array<{ __typename: 'ContactPhoneNumber', phoneNumber: string }> } }> | null } };

export type SegmentUploadedFileFragment = { __typename: 'SegmentUploadFile', name: string, status: Segment_Upload_File_Status, uuid: string, mode?: Segment_Upload_Mode | null, createdAt: string };

export type GenerateSegmentUploadSignedUrlMutationVariables = Exact<{
  fileName: Scalars['String']['input'];
}>;


export type GenerateSegmentUploadSignedUrlMutation = { __typename: 'Mutation', generateSegmentUploadSignedUrl: { __typename: 'GenerateSegmentUploadResponse', fileUuid: string, signedUrl: string, fields: object | object[] } };

export type ProcessSegmentUploadMutationVariables = Exact<{
  input: ProcessSegmentUploadInput;
}>;


export type ProcessSegmentUploadMutation = { __typename: 'Mutation', processSegmentUpload: boolean };

export type GetSegmentUploadedFilesQueryVariables = Exact<{
  uuid: Scalars['OCUUID']['input'];
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  after?: InputMaybe<Scalars['OCBase64Cursor']['input']>;
  before?: InputMaybe<Scalars['OCBase64Cursor']['input']>;
}>;


export type GetSegmentUploadedFilesQuery = { __typename: 'Query', segmentUploadedFiles: { __typename: 'SegmentUploadFileConnection', pageInfo: { __typename: 'PageInfo', hasNextPage: boolean, hasPreviousPage: boolean, startCursor?: string | null, endCursor?: string | null }, edges: Array<{ __typename: 'SegmentUploadFileEdge', cursor: string, node: { __typename: 'SegmentUploadFile', name: string, status: Segment_Upload_File_Status, uuid: string, mode?: Segment_Upload_Mode | null, createdAt: string } }> } };

export type DiscountingOfferFragment = { __typename: 'Offer', id: string, expireAt?: string | null };

export type StoredValueProgramFragment = { __typename: 'StoredValueProgram', id: string, chainId: string, programName: string, pointsPerConversion: number, moneyPerConversion: number, minPointsPerConversion?: number | null, maxPointsPerConversion?: number | null, expirationDays?: number | null, discountingOffer: { __typename: 'Offer', id: string, expireAt?: string | null } };

export type StoredValueExpirationScheduleFragment = { __typename: 'StoredValueExpirationSchedule', expirationDate: string, storedValue: number };

export type StoredValueProgramCreateMutationVariables = Exact<{
  input: StoredValueProgramCreateInput;
}>;


export type StoredValueProgramCreateMutation = { __typename: 'Mutation', storedValueProgramCreate: { __typename: 'StoredValueProgram', id: string } };

export type StoredValueProgramUpdateMutationVariables = Exact<{
  input: StoredValueProgramUpdateInput;
}>;


export type StoredValueProgramUpdateMutation = { __typename: 'Mutation', storedValueProgramUpdate: { __typename: 'StoredValueProgram', id: string } };

export type StoredValueProgramsQueryVariables = Exact<{
  filter?: InputMaybe<StoredValueProgramFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  after?: InputMaybe<Scalars['ID']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
}>;


export type StoredValueProgramsQuery = { __typename: 'Query', storedValuePrograms: { __typename: 'StoredValueProgramConnection', pageInfo: { __typename: 'PageInfo', hasNextPage: boolean, hasPreviousPage: boolean, startCursor?: string | null, endCursor?: string | null }, edges: Array<{ __typename: 'StoredValueProgramEdge', cursor: string, node: { __typename: 'StoredValueProgram', id: string, chainId: string, programName: string, pointsPerConversion: number, moneyPerConversion: number, minPointsPerConversion?: number | null, maxPointsPerConversion?: number | null, expirationDays?: number | null, discountingOffer: { __typename: 'Offer', id: string, expireAt?: string | null } } }> } };

export type MembershipStoredValueExpirationScheduleQueryVariables = Exact<{
  membershipId: Scalars['ID']['input'];
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
}>;


export type MembershipStoredValueExpirationScheduleQuery = { __typename: 'Query', memberships?: { __typename: 'MembershipConnection', edges: Array<{ __typename: 'MembershipEdge', cursor: string, node: { __typename: 'Membership', id: string, storedValueExpirationSchedule: { __typename: 'StoredValueExpirationScheduleConnection', pageInfo: { __typename: 'PageInfo', hasNextPage: boolean, hasPreviousPage: boolean, startCursor?: string | null, endCursor?: string | null }, edges: Array<{ __typename: 'StoredValueExpirationScheduleEdge', cursor: string, node: { __typename: 'StoredValueExpirationSchedule', expirationDate: string, storedValue: number } }> } } }> } | null };

export type ArchiveExternalLoyaltyManualOfferMutationVariables = Exact<{
  uuid: Scalars['OCUUID']['input'];
}>;


export type ArchiveExternalLoyaltyManualOfferMutation = { __typename: 'Mutation', archiveExternalLoyaltyManualOffer: boolean };

export type CreateExternalLoyaltyManualOfferInActivateMutationVariables = Exact<{
  uuid: Scalars['OCUUID']['input'];
}>;


export type CreateExternalLoyaltyManualOfferInActivateMutation = { __typename: 'Mutation', createExternalLoyaltyManualOfferInActivate: boolean };

export type GetExternalLoyaltyManualOfferBrandsQueryVariables = Exact<{
  filter?: InputMaybe<ExternalLoyaltyManualOfferBrandFilter>;
}>;


export type GetExternalLoyaltyManualOfferBrandsQuery = { __typename: 'Query', externalLoyaltyManualOfferBrands: Array<{ __typename: 'ExternalLoyaltyManualOfferBrand', name: string }> };

export type GetExternalLoyaltyManualOfferQueryVariables = Exact<{
  uuid: Scalars['ID']['input'];
}>;


export type GetExternalLoyaltyManualOfferQuery = { __typename: 'Query', externalLoyaltyManualOffer: { __typename: 'ExternalLoyaltyManualOffer', uuid: string, period: External_Loyalty_Manual_Offer_Period, brand: string, name: string, manufacturer: External_Loyalty_Manual_Offer_Manufacturer, states: Array<string>, storeCount: number, startDate: string, endDate: string, hasError: boolean, errorMessage?: string | null, activateOfferId?: string | null, activateCampaignId?: string | null, externalCampaignId: string, inActivate: boolean, status: External_Loyalty_Manual_Offer_Status, isArchived: boolean, upc: Array<{ __typename: 'ExternalLoyaltyManualOfferUpc', upc: string, productGroupId?: string | null }> } };

export type GetExternalLoyaltyManualOfferLocationsQueryVariables = Exact<{
  manualOfferUuid: Scalars['ID']['input'];
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<ExternalLoyaltyManualOfferLocationFilter>;
}>;


export type GetExternalLoyaltyManualOfferLocationsQuery = { __typename: 'Query', externalLoyaltyManualOfferLocations: { __typename: 'ExternalLoyaltyManualOfferLocationsConnection', edges: Array<{ __typename: 'ExternalLoyaltyManualOfferLocationEdge', cursor: string, node: { __typename: 'ExternalLoyaltyManualOfferLocation', uuid: string, siteId?: string | null, siteName?: string | null, siteAddress?: string | null, outletId: string } }>, pageInfo: { __typename: 'PageInfo', hasNextPage: boolean, hasPreviousPage: boolean, startCursor?: string | null, endCursor?: string | null } } };

export type GetExternalLoyaltyManualOfferUpcsQueryVariables = Exact<{
  manualOfferUuid: Scalars['ID']['input'];
}>;


export type GetExternalLoyaltyManualOfferUpcsQuery = { __typename: 'Query', externalLoyaltyManualOfferUpcs: { __typename: 'ExternalLoyaltyManualOfferUpcs', externalLoyaltyUpcs: Array<{ __typename: 'ExternalLoyaltyManualOfferUpc', upc: string }>, presentOnActivateUpcs: Array<{ __typename: 'ExternalLoyaltyManualOfferUpc', upc: string }> } };

export type GetExternalLoyaltyManualOffersQueryVariables = Exact<{
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<ExternalLoyaltyManualOfferFilter>;
}>;


export type GetExternalLoyaltyManualOffersQuery = { __typename: 'Query', externalLoyaltyManualOffers: { __typename: 'ExternalLoyaltyManualOffersConnection', edges: Array<{ __typename: 'ExternalLoyaltyManualOfferEdge', cursor: string, node: { __typename: 'ExternalLoyaltyManualOffer', uuid: string, name: string, brand: string, manufacturer: External_Loyalty_Manual_Offer_Manufacturer, states: Array<string>, storeCount: number, startDate: string, endDate: string, inActivate: boolean, hasError: boolean, errorMessage?: string | null, status: External_Loyalty_Manual_Offer_Status, activateStatus: External_Loyalty_Manual_Offer_Activate_Status, activateCampaignId?: string | null, activateOfferId?: string | null, externalCampaignId: string, period: External_Loyalty_Manual_Offer_Period, isArchived: boolean } }>, pageInfo: { __typename: 'PageInfo', hasNextPage: boolean, hasPreviousPage: boolean, startCursor?: string | null, endCursor?: string | null } } };

export type KioskImageSetFragment = { __typename: 'KioskImageSet', landscape: string, square: string, portrait: string };

export type KioskAssetFragment = { __typename: 'KioskAsset', id: string, name: string, description?: string | null, createdAt: string, updatedAt: string, imageSet: { __typename: 'KioskImageSet', landscape: string, square: string, portrait: string } };

export type KioskAdScheduleFragment = { __typename: 'KioskAdSchedule', days: Array<Weekday>, startTime: string, endTime: string };

export type KioskFragment = { __typename: 'Kiosk', id: string, externalDisplayId: string, locationId: string, createdAt: string, updatedAt: string, location?: { __typename: 'Location', uuid: string, name?: string | null, address?: { __typename: 'Address', uuid: string, alias?: string | null, city: string, countryCode: string, state: string, street1: string, street2?: string | null, zipCode: string, geoLocation?: { __typename: 'GeoLocation', latitude: number, longitude: number } | null } | null, phoneNumbers: Array<{ __typename: 'ContactPhoneNumber', phoneNumber: string, phoneType: Phone_Type }> } | null };

export type KioskAdSetPartialFragment = { __typename: 'KioskAdSet', id: string, name: string, description?: string | null, status: Kiosk_Ad_Set_Status, offerId?: string | null, kioskIds: Array<string>, createdAt: string, updatedAt: string, asset?: { __typename: 'KioskAsset', imageSet: { __typename: 'KioskImageSet', square: string } } | null };

export type KioskAdSetFragment = { __typename: 'KioskAdSet', id: string, name: string, description?: string | null, status: Kiosk_Ad_Set_Status, offerId?: string | null, kioskIds: Array<string>, createdAt: string, updatedAt: string, asset?: { __typename: 'KioskAsset', id: string, name: string, description?: string | null, createdAt: string, updatedAt: string, imageSet: { __typename: 'KioskImageSet', landscape: string, square: string, portrait: string } } | null, kiosks: Array<{ __typename: 'Kiosk', id: string, externalDisplayId: string, locationId: string, createdAt: string, updatedAt: string, location?: { __typename: 'Location', uuid: string, name?: string | null, address?: { __typename: 'Address', uuid: string, alias?: string | null, city: string, countryCode: string, state: string, street1: string, street2?: string | null, zipCode: string, geoLocation?: { __typename: 'GeoLocation', latitude: number, longitude: number } | null } | null, phoneNumbers: Array<{ __typename: 'ContactPhoneNumber', phoneNumber: string, phoneType: Phone_Type }> } | null }>, schedules: Array<{ __typename: 'KioskAdSchedule', days: Array<Weekday>, startTime: string, endTime: string }> };

export type KioskDefaultScreenFragment = { __typename: 'KioskDefaultScreen', id: string, name: string, description: string, createdAt: string, updatedAt: string, imageSet: { __typename: 'KioskImageSet', landscape: string, square: string, portrait: string } };

export type CreateKioskAdSetMutationVariables = Exact<{
  input: KioskAdSetCreateInput;
}>;


export type CreateKioskAdSetMutation = { __typename: 'Mutation', createKioskAdSet: { __typename: 'KioskAdSet', id: string, name: string, description?: string | null, status: Kiosk_Ad_Set_Status, offerId?: string | null, kioskIds: Array<string>, createdAt: string, updatedAt: string, asset?: { __typename: 'KioskAsset', id: string, name: string, description?: string | null, createdAt: string, updatedAt: string, imageSet: { __typename: 'KioskImageSet', landscape: string, square: string, portrait: string } } | null, kiosks: Array<{ __typename: 'Kiosk', id: string, externalDisplayId: string, locationId: string, createdAt: string, updatedAt: string, location?: { __typename: 'Location', uuid: string, name?: string | null, address?: { __typename: 'Address', uuid: string, alias?: string | null, city: string, countryCode: string, state: string, street1: string, street2?: string | null, zipCode: string, geoLocation?: { __typename: 'GeoLocation', latitude: number, longitude: number } | null } | null, phoneNumbers: Array<{ __typename: 'ContactPhoneNumber', phoneNumber: string, phoneType: Phone_Type }> } | null }>, schedules: Array<{ __typename: 'KioskAdSchedule', days: Array<Weekday>, startTime: string, endTime: string }> } };

export type UpdateKioskAdSetMutationVariables = Exact<{
  input: KioskAdSetUpdateInput;
}>;


export type UpdateKioskAdSetMutation = { __typename: 'Mutation', updateKioskAdSet: { __typename: 'KioskAdSet', id: string, name: string, description?: string | null, status: Kiosk_Ad_Set_Status, offerId?: string | null, kioskIds: Array<string>, createdAt: string, updatedAt: string, asset?: { __typename: 'KioskAsset', id: string, name: string, description?: string | null, createdAt: string, updatedAt: string, imageSet: { __typename: 'KioskImageSet', landscape: string, square: string, portrait: string } } | null, kiosks: Array<{ __typename: 'Kiosk', id: string, externalDisplayId: string, locationId: string, createdAt: string, updatedAt: string, location?: { __typename: 'Location', uuid: string, name?: string | null, address?: { __typename: 'Address', uuid: string, alias?: string | null, city: string, countryCode: string, state: string, street1: string, street2?: string | null, zipCode: string, geoLocation?: { __typename: 'GeoLocation', latitude: number, longitude: number } | null } | null, phoneNumbers: Array<{ __typename: 'ContactPhoneNumber', phoneNumber: string, phoneType: Phone_Type }> } | null }>, schedules: Array<{ __typename: 'KioskAdSchedule', days: Array<Weekday>, startTime: string, endTime: string }> } };

export type DeleteKioskAdSetMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type DeleteKioskAdSetMutation = { __typename: 'Mutation', deleteKioskAdSet: boolean };

export type PublishKioskAdSetMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type PublishKioskAdSetMutation = { __typename: 'Mutation', publishKioskAdSet: { __typename: 'KioskAdSet', id: string, name: string, description?: string | null, status: Kiosk_Ad_Set_Status, offerId?: string | null, kioskIds: Array<string>, createdAt: string, updatedAt: string, asset?: { __typename: 'KioskAsset', id: string, name: string, description?: string | null, createdAt: string, updatedAt: string, imageSet: { __typename: 'KioskImageSet', landscape: string, square: string, portrait: string } } | null, kiosks: Array<{ __typename: 'Kiosk', id: string, externalDisplayId: string, locationId: string, createdAt: string, updatedAt: string, location?: { __typename: 'Location', uuid: string, name?: string | null, address?: { __typename: 'Address', uuid: string, alias?: string | null, city: string, countryCode: string, state: string, street1: string, street2?: string | null, zipCode: string, geoLocation?: { __typename: 'GeoLocation', latitude: number, longitude: number } | null } | null, phoneNumbers: Array<{ __typename: 'ContactPhoneNumber', phoneNumber: string, phoneType: Phone_Type }> } | null }>, schedules: Array<{ __typename: 'KioskAdSchedule', days: Array<Weekday>, startTime: string, endTime: string }> } };

export type ArchiveKioskAdSetMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type ArchiveKioskAdSetMutation = { __typename: 'Mutation', archiveKioskAdSet: { __typename: 'KioskAdSet', id: string, name: string, description?: string | null, status: Kiosk_Ad_Set_Status, offerId?: string | null, kioskIds: Array<string>, createdAt: string, updatedAt: string, asset?: { __typename: 'KioskAsset', id: string, name: string, description?: string | null, createdAt: string, updatedAt: string, imageSet: { __typename: 'KioskImageSet', landscape: string, square: string, portrait: string } } | null, kiosks: Array<{ __typename: 'Kiosk', id: string, externalDisplayId: string, locationId: string, createdAt: string, updatedAt: string, location?: { __typename: 'Location', uuid: string, name?: string | null, address?: { __typename: 'Address', uuid: string, alias?: string | null, city: string, countryCode: string, state: string, street1: string, street2?: string | null, zipCode: string, geoLocation?: { __typename: 'GeoLocation', latitude: number, longitude: number } | null } | null, phoneNumbers: Array<{ __typename: 'ContactPhoneNumber', phoneNumber: string, phoneType: Phone_Type }> } | null }>, schedules: Array<{ __typename: 'KioskAdSchedule', days: Array<Weekday>, startTime: string, endTime: string }> } };

export type CreateKioskAssetMutationVariables = Exact<{
  input: KioskAssetCreateInput;
}>;


export type CreateKioskAssetMutation = { __typename: 'Mutation', createKioskAsset: { __typename: 'KioskAsset', id: string, name: string, description?: string | null, createdAt: string, updatedAt: string, imageSet: { __typename: 'KioskImageSet', landscape: string, square: string, portrait: string } } };

export type UpdateKioskAssetMutationVariables = Exact<{
  input: KioskAssetUpdateInput;
}>;


export type UpdateKioskAssetMutation = { __typename: 'Mutation', updateKioskAsset: { __typename: 'KioskAsset', id: string, name: string, description?: string | null, createdAt: string, updatedAt: string, imageSet: { __typename: 'KioskImageSet', landscape: string, square: string, portrait: string } } };

export type DeleteKioskAssetMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type DeleteKioskAssetMutation = { __typename: 'Mutation', deleteKioskAsset: boolean };

export type GenerateKioskAssetUploadSignedUrlMutationVariables = Exact<{
  input: KioskAssetUploadSignedUrlInput;
}>;


export type GenerateKioskAssetUploadSignedUrlMutation = { __typename: 'Mutation', generateKioskAssetUploadSignedUrl: { __typename: 'KioskAssetUploadSignedUrl', signedUrl: string, fields: object | object[], resourceUrl: string } };

export type CreateKioskDefaultScreenMutationVariables = Exact<{
  input: KioskDefaultScreenCreateInput;
}>;


export type CreateKioskDefaultScreenMutation = { __typename: 'Mutation', createKioskDefaultScreen: { __typename: 'KioskDefaultScreen', id: string, name: string, description: string, createdAt: string, updatedAt: string, imageSet: { __typename: 'KioskImageSet', landscape: string, square: string, portrait: string } } };

export type UpdateKioskDefaultScreenMutationVariables = Exact<{
  input: KioskDefaultScreenUpdateInput;
}>;


export type UpdateKioskDefaultScreenMutation = { __typename: 'Mutation', updateKioskDefaultScreen: { __typename: 'KioskDefaultScreen', id: string, name: string, description: string, createdAt: string, updatedAt: string, imageSet: { __typename: 'KioskImageSet', landscape: string, square: string, portrait: string } } };

export type DeleteKioskDefaultScreenMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type DeleteKioskDefaultScreenMutation = { __typename: 'Mutation', deleteKioskDefaultScreen: boolean };

export type KioskAdSetsQueryVariables = Exact<{
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  after?: InputMaybe<Scalars['OCBase64Cursor']['input']>;
  before?: InputMaybe<Scalars['OCBase64Cursor']['input']>;
  filter?: InputMaybe<KioskAdSetFilter>;
}>;


export type KioskAdSetsQuery = { __typename: 'Query', kioskAdSets: { __typename: 'KioskAdSetConnection', pageInfo: { __typename: 'PageInfo', hasNextPage: boolean, hasPreviousPage: boolean, startCursor?: string | null, endCursor?: string | null }, edges: Array<{ __typename: 'KioskAdSetEdge', cursor: string, node: { __typename: 'KioskAdSet', id: string, name: string, description?: string | null, status: Kiosk_Ad_Set_Status, offerId?: string | null, kioskIds: Array<string>, createdAt: string, updatedAt: string, asset?: { __typename: 'KioskAsset', id: string, name: string, description?: string | null, createdAt: string, updatedAt: string, imageSet: { __typename: 'KioskImageSet', landscape: string, square: string, portrait: string } } | null, kiosks: Array<{ __typename: 'Kiosk', id: string, externalDisplayId: string, locationId: string, createdAt: string, updatedAt: string, location?: { __typename: 'Location', uuid: string, name?: string | null, address?: { __typename: 'Address', uuid: string, alias?: string | null, city: string, countryCode: string, state: string, street1: string, street2?: string | null, zipCode: string, geoLocation?: { __typename: 'GeoLocation', latitude: number, longitude: number } | null } | null, phoneNumbers: Array<{ __typename: 'ContactPhoneNumber', phoneNumber: string, phoneType: Phone_Type }> } | null }>, schedules: Array<{ __typename: 'KioskAdSchedule', days: Array<Weekday>, startTime: string, endTime: string }> } }> } };

export type KioskAdSetQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type KioskAdSetQuery = { __typename: 'Query', kioskAdSet: { __typename: 'KioskAdSet', id: string, name: string, description?: string | null, status: Kiosk_Ad_Set_Status, offerId?: string | null, kioskIds: Array<string>, createdAt: string, updatedAt: string, asset?: { __typename: 'KioskAsset', id: string, name: string, description?: string | null, createdAt: string, updatedAt: string, imageSet: { __typename: 'KioskImageSet', landscape: string, square: string, portrait: string } } | null, kiosks: Array<{ __typename: 'Kiosk', id: string, externalDisplayId: string, locationId: string, createdAt: string, updatedAt: string, location?: { __typename: 'Location', uuid: string, name?: string | null, address?: { __typename: 'Address', uuid: string, alias?: string | null, city: string, countryCode: string, state: string, street1: string, street2?: string | null, zipCode: string, geoLocation?: { __typename: 'GeoLocation', latitude: number, longitude: number } | null } | null, phoneNumbers: Array<{ __typename: 'ContactPhoneNumber', phoneNumber: string, phoneType: Phone_Type }> } | null }>, schedules: Array<{ __typename: 'KioskAdSchedule', days: Array<Weekday>, startTime: string, endTime: string }> } };

export type KiosksQueryVariables = Exact<{
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  after?: InputMaybe<Scalars['OCBase64Cursor']['input']>;
  before?: InputMaybe<Scalars['OCBase64Cursor']['input']>;
  filter?: InputMaybe<KioskFilter>;
}>;


export type KiosksQuery = { __typename: 'Query', kiosks: { __typename: 'KioskConnection', pageInfo: { __typename: 'PageInfo', hasNextPage: boolean, hasPreviousPage: boolean, startCursor?: string | null, endCursor?: string | null }, edges: Array<{ __typename: 'KioskEdge', cursor: string, node: { __typename: 'Kiosk', id: string, externalDisplayId: string, locationId: string, createdAt: string, updatedAt: string, location?: { __typename: 'Location', uuid: string, name?: string | null, address?: { __typename: 'Address', uuid: string, alias?: string | null, city: string, countryCode: string, state: string, street1: string, street2?: string | null, zipCode: string, geoLocation?: { __typename: 'GeoLocation', latitude: number, longitude: number } | null } | null, phoneNumbers: Array<{ __typename: 'ContactPhoneNumber', phoneNumber: string, phoneType: Phone_Type }> } | null } }> } };

export type KioskAssetsQueryVariables = Exact<{
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  after?: InputMaybe<Scalars['OCBase64Cursor']['input']>;
  before?: InputMaybe<Scalars['OCBase64Cursor']['input']>;
  filter?: InputMaybe<KioskAssetFilter>;
}>;


export type KioskAssetsQuery = { __typename: 'Query', kioskAssets: { __typename: 'KioskAssetConnection', pageInfo: { __typename: 'PageInfo', hasNextPage: boolean, hasPreviousPage: boolean, startCursor?: string | null, endCursor?: string | null }, edges: Array<{ __typename: 'KioskAssetEdge', cursor: string, node: { __typename: 'KioskAsset', id: string, name: string, description?: string | null, createdAt: string, updatedAt: string, imageSet: { __typename: 'KioskImageSet', landscape: string, square: string, portrait: string } } }> } };

export type KioskAssetQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type KioskAssetQuery = { __typename: 'Query', kioskAsset: { __typename: 'KioskAsset', id: string, name: string, description?: string | null, createdAt: string, updatedAt: string, imageSet: { __typename: 'KioskImageSet', landscape: string, square: string, portrait: string } } };

export type KioskDefaultScreensQueryVariables = Exact<{
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  after?: InputMaybe<Scalars['OCBase64Cursor']['input']>;
  before?: InputMaybe<Scalars['OCBase64Cursor']['input']>;
  filter?: InputMaybe<KioskDefaultScreenFilter>;
}>;


export type KioskDefaultScreensQuery = { __typename: 'Query', kioskDefaultScreens: { __typename: 'KioskDefaultScreenConnection', pageInfo: { __typename: 'PageInfo', hasNextPage: boolean, hasPreviousPage: boolean, startCursor?: string | null, endCursor?: string | null }, edges: Array<{ __typename: 'KioskDefaultScreenEdge', cursor: string, node: { __typename: 'KioskDefaultScreen', id: string, name: string, description: string, createdAt: string, updatedAt: string, imageSet: { __typename: 'KioskImageSet', landscape: string, square: string, portrait: string } } }> } };

export type KioskDefaultScreenQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type KioskDefaultScreenQuery = { __typename: 'Query', kioskDefaultScreen: { __typename: 'KioskDefaultScreen', id: string, name: string, description: string, createdAt: string, updatedAt: string, imageSet: { __typename: 'KioskImageSet', landscape: string, square: string, portrait: string } } };

export type UpdateTriggeredMessageMutationVariables = Exact<{
  input: UpdateTriggeredMessageInput;
}>;


export type UpdateTriggeredMessageMutation = { __typename: 'Mutation', message: { __typename: 'TriggeredMessage', uuid: string, subBrandUuid?: string | null, description?: string | null, messageIntent: MessageIntent, status: Triggered_Message_Status, channelsConfig?: { __typename: 'ChannelsConfig', smsConfig?: { __typename: 'SmsConfig', enabled: boolean, body: string } | null, pushNotificationConfig?: { __typename: 'PushNotificationConfig', enabled: boolean, template: { __typename: 'PushNotificationTemplate', notification: { __typename: 'PushNotificationContent', title?: string | null, body: string }, data?: { __typename: 'PushNotificationData', url?: string | null } | null } } | null } | null } };

export type UpdateTriggeredMessageStatusMutationVariables = Exact<{
  input: UpdateTriggeredMessageStatusInput;
}>;


export type UpdateTriggeredMessageStatusMutation = { __typename: 'Mutation', updateTriggeredMessageStatus: { __typename: 'TriggeredMessage', uuid: string, subBrandUuid?: string | null, description?: string | null, messageIntent: MessageIntent, status: Triggered_Message_Status, channelsConfig?: { __typename: 'ChannelsConfig', smsConfig?: { __typename: 'SmsConfig', enabled: boolean, body: string } | null, pushNotificationConfig?: { __typename: 'PushNotificationConfig', enabled: boolean, template: { __typename: 'PushNotificationTemplate', notification: { __typename: 'PushNotificationContent', title?: string | null, body: string }, data?: { __typename: 'PushNotificationData', url?: string | null } | null } } | null } | null } };

export type TriggeredMessageViewChannelsConfigFragment = { __typename: 'ChannelsConfig', smsConfig?: { __typename: 'SmsConfig', enabled: boolean, body: string } | null, pushNotificationConfig?: { __typename: 'PushNotificationConfig', enabled: boolean, template: { __typename: 'PushNotificationTemplate', notification: { __typename: 'PushNotificationContent', title?: string | null, body: string }, data?: { __typename: 'PushNotificationData', url?: string | null } | null } } | null };

export type TriggeredMessageViewFragment = { __typename: 'TriggeredMessage', uuid: string, subBrandUuid?: string | null, description?: string | null, messageIntent: MessageIntent, status: Triggered_Message_Status, channelsConfig?: { __typename: 'ChannelsConfig', smsConfig?: { __typename: 'SmsConfig', enabled: boolean, body: string } | null, pushNotificationConfig?: { __typename: 'PushNotificationConfig', enabled: boolean, template: { __typename: 'PushNotificationTemplate', notification: { __typename: 'PushNotificationContent', title?: string | null, body: string }, data?: { __typename: 'PushNotificationData', url?: string | null } | null } } | null } | null };

export type TriggeredMessageQueryVariables = Exact<{
  uuid: Scalars['OCUUID']['input'];
}>;


export type TriggeredMessageQuery = { __typename: 'Query', triggeredMessage?: { __typename: 'TriggeredMessage', uuid: string, subBrandUuid?: string | null, description?: string | null, messageIntent: MessageIntent, status: Triggered_Message_Status, channelsConfig?: { __typename: 'ChannelsConfig', smsConfig?: { __typename: 'SmsConfig', enabled: boolean, body: string } | null, pushNotificationConfig?: { __typename: 'PushNotificationConfig', enabled: boolean, template: { __typename: 'PushNotificationTemplate', notification: { __typename: 'PushNotificationContent', title?: string | null, body: string }, data?: { __typename: 'PushNotificationData', url?: string | null } | null } } | null } | null } | null };

export type TriggeredMessageListItemFragment = { __typename: 'TriggeredMessage', uuid: string, subBrandUuid?: string | null, description?: string | null, status: Triggered_Message_Status, channelsConfig?: { __typename: 'ChannelsConfig', pushNotificationConfig?: { __typename: 'PushNotificationConfig', enabled: boolean } | null, smsConfig?: { __typename: 'SmsConfig', enabled: boolean } | null } | null };

export type TriggeredMessagesListQueryVariables = Exact<{
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  filter?: InputMaybe<TriggeredMessagesFilter>;
}>;


export type TriggeredMessagesListQuery = { __typename: 'Query', triggeredMessagesList: { __typename: 'TriggeredMessageConnection', pageInfo: { __typename: 'PageInfo', hasNextPage: boolean, hasPreviousPage: boolean, startCursor?: string | null, endCursor?: string | null }, edges: Array<{ __typename: 'TriggeredMessageEdge', cursor: string, node: { __typename: 'TriggeredMessage', uuid: string, subBrandUuid?: string | null, description?: string | null, status: Triggered_Message_Status, channelsConfig?: { __typename: 'ChannelsConfig', pushNotificationConfig?: { __typename: 'PushNotificationConfig', enabled: boolean } | null, smsConfig?: { __typename: 'SmsConfig', enabled: boolean } | null } | null } }> } };

export const LocationIssueFragmentDoc = gql`
    fragment locationIssue on SiteIssue {
  uuid
  siteId
  title
  description
  status
  jiraCaseId
  createdBy {
    uuid
    name {
      first
      last
    }
  }
  assignedTo {
    uuid
    name {
      first
      last
    }
  }
  status
  createdAt
  updatedAt
}
    `;
export const DisplayCategoryFragmentDoc = gql`
    fragment displayCategory on DisplayCategory {
  id
  name
  rank
  bannerIds
  categoryRestrictions
  shouldLazyLoadBanners
}
    `;
export const ActivateTransactionFulfilledOfferFragmentDoc = gql`
    fragment activateTransactionFulfilledOffer on Offer {
  id
  name
  category
  campaign {
    uuid
  }
  publishAt
  expireAt
  externalId
  displayCategories {
    ...displayCategory
  }
  marketingContents {
    id
    title
    shortDescription
    imageUrl
  }
}
    ${DisplayCategoryFragmentDoc}`;
export const PointChangeOfferFragmentDoc = gql`
    fragment pointChangeOffer on Offer {
  id
  name
  publishAt
  expireAt
  campaign {
    uuid
  }
  marketingContents {
    id
    title
  }
}
    `;
export const TransactionSourceFragmentDoc = gql`
    fragment transactionSource on ActivateTransaction {
  id
  createdAt
  transactionTimeAt
  lineItems {
    id
    sku
    upc
    group
    quantity
    moneyAmount
  }
  location {
    id
    name
    address1
    city
    state
  }
  partnerId
  fulfilledOffers {
    id
    name
    marketingContents {
      id
      title
    }
  }
}
    `;
export const UserSourceFragmentDoc = gql`
    fragment userSource on ActivateUser {
  id
  email
  name
}
    `;
export const LoyaltyEventSourceFragmentDoc = gql`
    fragment loyaltyEventSource on LoyaltyEvent {
  id
  eventType
  eventData
}
    `;
export const PointChangeSourceFragmentDoc = gql`
    fragment pointChangeSource on PointChange {
  id
}
    `;
export const OfferPurchaseSourceFragmentDoc = gql`
    fragment offerPurchaseSource on OfferPurchase {
  pointCost
  voucherGrantFor {
    id
    name
    publishAt
    expireAt
    marketingContents {
      id
      title
    }
  }
}
    `;
export const CommandCenterUserSourceFragmentDoc = gql`
    fragment commandCenterUserSource on CommandCenterUser {
  name
  email
}
    `;
export const MembershipPointDonationSourceFragmentDoc = gql`
    fragment membershipPointDonationSource on MembershipPointDonation {
  id
  bucket {
    id
    name
  }
  pointsSpent
  donationAmountCents
}
    `;
export const MembershipItemFragmentDoc = gql`
    fragment membershipItem on Membership {
  id
  createdAt
  customerUuid
  firstName
  lastName
  email
  phone
  points
  state
}
    `;
export const PointChangeFragmentDoc = gql`
    fragment pointChange on PointChange {
  id
  type
  createdAt
  notes
  offer {
    ...pointChangeOffer
  }
  source {
    ... on ActivateTransaction {
      ...transactionSource
    }
    ... on ActivateUser {
      ...userSource
    }
    ... on LoyaltyEvent {
      ...loyaltyEventSource
    }
    ... on PointChange {
      ...pointChangeSource
    }
    ... on OfferPurchase {
      ...offerPurchaseSource
    }
    ... on CommandCenterUser {
      ...commandCenterUserSource
    }
    ... on MembershipPointDonation {
      ...membershipPointDonationSource
    }
  }
  quantity
  pointAdjustmentReason {
    id
    label
    description
  }
  membership {
    ...membershipItem
  }
}
    ${PointChangeOfferFragmentDoc}
${TransactionSourceFragmentDoc}
${UserSourceFragmentDoc}
${LoyaltyEventSourceFragmentDoc}
${PointChangeSourceFragmentDoc}
${OfferPurchaseSourceFragmentDoc}
${CommandCenterUserSourceFragmentDoc}
${MembershipPointDonationSourceFragmentDoc}
${MembershipItemFragmentDoc}`;
export const ActivateTransactionFragmentDoc = gql`
    fragment activateTransaction on ActivateTransaction {
  id
  partnerId
  requestId
  createdAt
  transactionTimeAt
  processedAt
  loyaltySequenceId
  lineItems {
    id
    sku
    upc
    description
    group
    fuelGradeId
    quantity
    moneyAmount
    moneyAmountWithoutDiscounts
    regularSellPrice
    actualSalesPrice
    externalLineItemPromotions {
      id
      discountAmount
      promotionReason
    }
    promotions {
      offer {
        id
        campaign {
          uuid
        }
        externalId
        name
        marketingContents {
          id
          title
          shortDescription
          imageUrl
        }
      }
      promotionAmount
      promotionReason
      promotionTitle
    }
  }
  location {
    id
    name
    address1
    address2
    city
    state
    zipcode
  }
  offerFulfillments {
    fulfilledOffer {
      ...activateTransactionFulfilledOffer
    }
    fulfillmentCount
    id
  }
  fulfilledOffers {
    ...activateTransactionFulfilledOffer
  }
  membership {
    id
    firstName
    lastName
  }
  paymentInfos {
    amountCharged
    isoPrefix
    tenderSubtype
    tenderType
  }
  fuelPositionId
  moneyCurrencyCode
  subtotalAmount
  totalAmount
  totalAmountWithoutDiscounts
  totalDiscountAmount
  totalTax
  totalPointsSpent
  totalPointsRefunded
  totalPointsEarned
  vendorName
  status
  payload
  pointChanges {
    ...pointChange
  }
}
    ${ActivateTransactionFulfilledOfferFragmentDoc}
${PointChangeFragmentDoc}`;
export const AudiencePurchasedAtLeastTargetingAttributeFragmentDoc = gql`
    fragment audiencePurchasedAtLeastTargetingAttribute on AudiencePurchasedAtLeastTargetingAttribute {
  productGroupIds
  countProductsBy
  threshold
  excludeThreshold
  timeWindow
  targetYear
  targetMonth
  startDate
  endDate
  purchasedLocationUuids
  purchasedLocationGroupUuids
  relativeMonthsBack
}
    `;
export const AudiencePurchasedAtMostTargetingAttributeFragmentDoc = gql`
    fragment audiencePurchasedAtMostTargetingAttribute on AudiencePurchasedAtMostTargetingAttribute {
  productGroupIds
  countProductsBy
  threshold
  excludeThreshold
  timeWindow
  targetYear
  targetMonth
  startDate
  endDate
  purchasedLocationUuids
  purchasedLocationGroupUuids
  relativeMonthsBack
}
    `;
export const AudienceInAllSegmentsTargetingAttributeFragmentDoc = gql`
    fragment audienceInAllSegmentsTargetingAttribute on AudienceInAllSegmentsTargetingAttribute {
  segmentIds
}
    `;
export const AudienceInAnySegmentsTargetingAttributeFragmentDoc = gql`
    fragment audienceInAnySegmentsTargetingAttribute on AudienceInAnySegmentsTargetingAttribute {
  segmentIds
}
    `;
export const AudienceNotInAnySegmentsTargetingAttributeFragmentDoc = gql`
    fragment audienceNotInAnySegmentsTargetingAttribute on AudienceNotInAnySegmentsTargetingAttribute {
  segmentIds
}
    `;
export const AudienceAgeWithinTargetingAttributeFragmentDoc = gql`
    fragment audienceAgeWithinTargetingAttribute on AudienceAgeWithinTargetingAttribute {
  minimumAge
  maximumAge
}
    `;
export const AudienceFuelAndConvenienceProfileTargetingAttributeFragmentDoc = gql`
    fragment audienceFuelAndConvenienceProfileTargetingAttribute on AudienceFuelAndConvenienceProfileTargetingAttribute {
  criteria {
    attribute
    operator
    target
  }
}
    `;
export const AudienceOfferFulfillmentTargetingAttributeFragmentDoc = gql`
    fragment audienceOfferFulfillmentTargetingAttribute on AudienceOfferFulfillmentTargetingAttribute {
  fulfilled
  operator
  timesFulfilled
  targetOfferId
}
    `;
export const AudienceStoreLocationTargetingAttributeFragmentDoc = gql`
    fragment audienceStoreLocationTargetingAttribute on AudienceStoreLocationTargetingAttribute {
  locationsIds
  locationGroupUuids
}
    `;
export const AudienceWalletSteeringTargetingAttributeFragmentDoc = gql`
    fragment audienceWalletSteeringTargetingAttribute on AudienceWalletSteeringTargetingAttribute {
  walletUuid
  attribute
  walletSteeringOperator
  value
  unitOfMeasure
}
    `;
export const AudienceInAllProductInterestsTargetingAttributeFragmentDoc = gql`
    fragment audienceInAllProductInterestsTargetingAttribute on AudienceInAllProductInterestsTargetingAttribute {
  productCategories
}
    `;
export const AudienceInAnyProductInterestsTargetingAttributeFragmentDoc = gql`
    fragment audienceInAnyProductInterestsTargetingAttribute on AudienceInAnyProductInterestsTargetingAttribute {
  productCategories
}
    `;
export const AudienceNotInAllProductInterestsTargetingAttributeFragmentDoc = gql`
    fragment audienceNotInAllProductInterestsTargetingAttribute on AudienceNotInAllProductInterestsTargetingAttribute {
  productCategories
}
    `;
export const AudienceNotInAnyProductInterestsTargetingAttributeFragmentDoc = gql`
    fragment audienceNotInAnyProductInterestsTargetingAttribute on AudienceNotInAnyProductInterestsTargetingAttribute {
  productCategories
}
    `;
export const AudienceEventConditionFragmentDoc = gql`
    fragment audienceEventCondition on AudienceEventCondition {
  timeWindow
  times
  operator
  loyaltyEventUuid
  gameUuid
  purchaseCondition {
    productGroupUuids
    purchasedLocationUuids
    purchasedLocationGroupUuids
    excludeThreshold
    countProductsBy
    threshold
    operator
  }
  audienceEventDateCondition {
    fixedDateRange {
      startDate
      endDate
    }
    relativeMonthBack {
      relativeMonthsBack
    }
    timeWindow {
      timeWindow
    }
  }
}
    `;
export const AudienceInAllEventTargetingAttributeFragmentDoc = gql`
    fragment audienceInAllEventTargetingAttribute on AudienceInAllEventTargetingAttribute {
  conditions {
    ...audienceEventCondition
  }
}
    ${AudienceEventConditionFragmentDoc}`;
export const AudienceInAnyEventTargetingAttributeFragmentDoc = gql`
    fragment audienceInAnyEventTargetingAttribute on AudienceInAnyEventTargetingAttribute {
  conditions {
    ...audienceEventCondition
  }
}
    ${AudienceEventConditionFragmentDoc}`;
export const AudienceNotInAllEventTargetingAttributeFragmentDoc = gql`
    fragment audienceNotInAllEventTargetingAttribute on AudienceNotInAllEventTargetingAttribute {
  conditions {
    ...audienceEventCondition
  }
}
    ${AudienceEventConditionFragmentDoc}`;
export const AudienceNotInAnyEventTargetingAttributeFragmentDoc = gql`
    fragment audienceNotInAnyEventTargetingAttribute on AudienceNotInAnyEventTargetingAttribute {
  conditions {
    ...audienceEventCondition
  }
}
    ${AudienceEventConditionFragmentDoc}`;
export const AudienceTimeSinceLastVisitTargetingAttributeFragmentDoc = gql`
    fragment audienceTimeSinceLastVisitTargetingAttribute on AudienceTimeSinceLastVisitTargetingAttribute {
  amount
  period
  timeSinceLastVisitOperator: operator
}
    `;
export const AudiencePointBalanceTargetingAttributeFragmentDoc = gql`
    fragment audiencePointBalanceTargetingAttribute on AudiencePointBalanceTargetingAttribute {
  pointBalanceAmount: amount
  target
  pointBalanceOperator: operator
  minAmount
  maxAmount
}
    `;
export const AudienceTimeSinceMembershipAcquisitionTargetingAttributeFragmentDoc = gql`
    fragment audienceTimeSinceMembershipAcquisitionTargetingAttribute on AudienceTimeSinceMembershipAcquisitionTargetingAttribute {
  membershipCreatedAmount: amount
  membershipCreatedOperator: operator
}
    `;
export const AudienceRetailerNetworkSiteUsersTargetingAttributeFragmentDoc = gql`
    fragment audienceRetailerNetworkSiteUsersTargetingAttribute on AudienceRetailerNetworkSiteUsersTargetingAttribute {
  retailerNetworkOperator
  retailerNetworkUserTypes
  retailerNetworkUuids
  userTypeOperator
}
    `;
export const AudienceSurveyResponseTargetingAttributeFragmentDoc = gql`
    fragment audienceSurveyResponseTargetingAttribute on AudienceSurveyResponseTargetingAttribute {
  maxAmount
  minAmount
  surveyOperator: operator
  questionUuid
  selectedOptions
  surveyResponse
  surveyUuid
  locationsUuids
  locationGroupUuids
}
    `;
export const AudienceAggregatedAudienceTargetingAttributeFragmentDoc = gql`
    fragment audienceAggregatedAudienceTargetingAttribute on AudienceAggregatedAudiencesTargetingAttribute {
  combinedAudiencesOperator: operator
  combinedAudiencesTarget: target
}
    `;
export const AudienceExternalIdentityVerificationTargetingAttributeFragmentDoc = gql`
    fragment audienceExternalIdentityVerificationTargetingAttribute on AudienceExternalIdentityVerificationTargetingAttribute {
  provider
  identityVerificationOperator: operator
  verificationAttributes
}
    `;
export const AudienceCommunicationPreferenceTargetingAttributeFragmentDoc = gql`
    fragment audienceCommunicationPreferenceTargetingAttribute on AudienceCommunicationPreferenceTargetingAttribute {
  criteria {
    mechanism
    status
    subBrandUuid
  }
}
    `;
export const AudienceTargetingAttributeFragmentDoc = gql`
    fragment audienceTargetingAttribute on AudienceTargetingAttribute {
  ...audiencePurchasedAtLeastTargetingAttribute
  ...audiencePurchasedAtMostTargetingAttribute
  ...audienceInAllSegmentsTargetingAttribute
  ...audienceInAnySegmentsTargetingAttribute
  ...audienceNotInAnySegmentsTargetingAttribute
  ...audienceAgeWithinTargetingAttribute
  ...audienceFuelAndConvenienceProfileTargetingAttribute
  ...audienceOfferFulfillmentTargetingAttribute
  ...audienceStoreLocationTargetingAttribute
  ...audienceWalletSteeringTargetingAttribute
  ...audienceInAllProductInterestsTargetingAttribute
  ...audienceInAnyProductInterestsTargetingAttribute
  ...audienceNotInAllProductInterestsTargetingAttribute
  ...audienceNotInAnyProductInterestsTargetingAttribute
  ...audienceInAllEventTargetingAttribute
  ...audienceInAnyEventTargetingAttribute
  ...audienceNotInAllEventTargetingAttribute
  ...audienceNotInAnyEventTargetingAttribute
  ...audienceTimeSinceLastVisitTargetingAttribute
  ...audiencePointBalanceTargetingAttribute
  ...audienceTimeSinceMembershipAcquisitionTargetingAttribute
  ...audienceRetailerNetworkSiteUsersTargetingAttribute
  ...audienceSurveyResponseTargetingAttribute
  ...audienceAggregatedAudienceTargetingAttribute
  ...audienceExternalIdentityVerificationTargetingAttribute
  ...audienceCommunicationPreferenceTargetingAttribute
}
    ${AudiencePurchasedAtLeastTargetingAttributeFragmentDoc}
${AudiencePurchasedAtMostTargetingAttributeFragmentDoc}
${AudienceInAllSegmentsTargetingAttributeFragmentDoc}
${AudienceInAnySegmentsTargetingAttributeFragmentDoc}
${AudienceNotInAnySegmentsTargetingAttributeFragmentDoc}
${AudienceAgeWithinTargetingAttributeFragmentDoc}
${AudienceFuelAndConvenienceProfileTargetingAttributeFragmentDoc}
${AudienceOfferFulfillmentTargetingAttributeFragmentDoc}
${AudienceStoreLocationTargetingAttributeFragmentDoc}
${AudienceWalletSteeringTargetingAttributeFragmentDoc}
${AudienceInAllProductInterestsTargetingAttributeFragmentDoc}
${AudienceInAnyProductInterestsTargetingAttributeFragmentDoc}
${AudienceNotInAllProductInterestsTargetingAttributeFragmentDoc}
${AudienceNotInAnyProductInterestsTargetingAttributeFragmentDoc}
${AudienceInAllEventTargetingAttributeFragmentDoc}
${AudienceInAnyEventTargetingAttributeFragmentDoc}
${AudienceNotInAllEventTargetingAttributeFragmentDoc}
${AudienceNotInAnyEventTargetingAttributeFragmentDoc}
${AudienceTimeSinceLastVisitTargetingAttributeFragmentDoc}
${AudiencePointBalanceTargetingAttributeFragmentDoc}
${AudienceTimeSinceMembershipAcquisitionTargetingAttributeFragmentDoc}
${AudienceRetailerNetworkSiteUsersTargetingAttributeFragmentDoc}
${AudienceSurveyResponseTargetingAttributeFragmentDoc}
${AudienceAggregatedAudienceTargetingAttributeFragmentDoc}
${AudienceExternalIdentityVerificationTargetingAttributeFragmentDoc}
${AudienceCommunicationPreferenceTargetingAttributeFragmentDoc}`;
export const AudienceFragmentDoc = gql`
    fragment audience on Audience {
  uuid
  name
  description
  membershipCount
  status
  hasBeenBackFilled
  targetingAttributes {
    ...audienceTargetingAttribute
  }
  createdAt
  updatedAt
  draftCount
  draftCountCalculationRequestedAt
  lastDraftCountCalculationAt
}
    ${AudienceTargetingAttributeFragmentDoc}`;
export const AudienceBasicFragmentDoc = gql`
    fragment AudienceBasic on Audience {
  uuid
  name
}
    `;
export const PartialAudienceFragmentDoc = gql`
    fragment partialAudience on Audience {
  uuid
  name
  description
  status
  hasBeenBackFilled
  targetingAttributes {
    ...audienceTargetingAttribute
  }
  createdAt
}
    ${AudienceTargetingAttributeFragmentDoc}`;
export const AudienceSelectItemFragmentDoc = gql`
    fragment audienceSelectItem on Audience {
  uuid
  name
}
    `;
export const ReportGenerationJobFragmentDoc = gql`
    fragment reportGenerationJob on ReportGenerationJob {
  uuid
  status
}
    `;
export const MarketingContentFragmentDoc = gql`
    fragment marketingContent on MarketingContent {
  id
  locale
  title
  shortDescription
  longDescription
  imageUrl
  terms
  termsUrl
  customData
  disclaimer
  disclaimerUrl
  triggeredMessageContent {
    fulfillmentSms
    visibilitySms
    progressSms
  }
  externalUrl
  surgeonGeneralsWarning
  receiptContent {
    shortDescription
    longDescription
  }
}
    `;
export const AwardsListItemFragmentDoc = gql`
    fragment awardsListItem on Offer {
  id
  name
  deleted
  publicationStatus
  fulfillmentCount
  marketingContents {
    ...marketingContent
  }
}
    ${MarketingContentFragmentDoc}`;
export const PointAdjustmentReasonFragmentDoc = gql`
    fragment pointAdjustmentReason on PointAdjustmentReason {
  id
  label
  description
}
    `;
export const QualifiedEventLoyaltyEventFragmentDoc = gql`
    fragment qualifiedEventLoyaltyEvent on QualifiedEventLoyaltyEvent {
  loyaltyEventOffer {
    id
    name
  }
}
    `;
export const ProductGroupFragmentDoc = gql`
    fragment productGroup on ProductGroup {
  id
  name
  description
  key
  values
  fuelProductGroup {
    id
    sortingRank
    userSelectable
    default
  }
}
    `;
export const QualifiedEventTransactionFragmentDoc = gql`
    fragment qualifiedEventTransaction on QualifiedEventTransaction {
  purchaseThreshold
  countProductsBy
  eligibleProductGroups {
    ...productGroup
  }
}
    ${ProductGroupFragmentDoc}`;
export const QualifiedEventFragmentDoc = gql`
    fragment qualifiedEvent on QualifiedEvent {
  __typename
  ...qualifiedEventLoyaltyEvent
  ...qualifiedEventTransaction
}
    ${QualifiedEventLoyaltyEventFragmentDoc}
${QualifiedEventTransactionFragmentDoc}`;
export const AwardPointsFragmentDoc = gql`
    fragment awardPoints on AwardPoints {
  points
}
    `;
export const AwardVouchersFragmentDoc = gql`
    fragment awardVouchers on AwardVouchers {
  voucherCount
  voucheredOffer {
    id
    name
    fulfillmentCount
    engagementType
  }
  voucherExpirationDays
}
    `;
export const SenderConfigurationFragmentDoc = gql`
    fragment senderConfiguration on SenderConfiguration {
  instructions
  smsTemplate
  award {
    ...awardPoints
    ...awardVouchers
  }
}
    ${AwardPointsFragmentDoc}
${AwardVouchersFragmentDoc}`;
export const ReceiverConfigurationFragmentDoc = gql`
    fragment receiverConfiguration on ReceiverConfiguration {
  instructions
  award {
    ...awardPoints
    ...awardVouchers
  }
}
    ${AwardPointsFragmentDoc}
${AwardVouchersFragmentDoc}`;
export const ReferralProgramMarketingContentFragmentDoc = gql`
    fragment referralProgramMarketingContent on ReferralProgramMarketingContent {
  subBrandUuid
  senderInstructions
  receiverInstructions
  smsTemplate
}
    `;
export const ReferralProgramConfigurationFragmentDoc = gql`
    fragment referralProgramConfiguration on ReferralProgramConfiguration {
  referralProgramEnabled
  qualifiedEvent {
    ...qualifiedEvent
  }
  senderConfiguration {
    ...senderConfiguration
  }
  receiverConfiguration {
    ...receiverConfiguration
  }
  marketingContents {
    ...referralProgramMarketingContent
  }
}
    ${QualifiedEventFragmentDoc}
${SenderConfigurationFragmentDoc}
${ReceiverConfigurationFragmentDoc}
${ReferralProgramMarketingContentFragmentDoc}`;
export const PointExpirationFragmentDoc = gql`
    fragment pointExpiration on PointExpiration {
  strategy
  notificationDays
}
    `;
export const ChainConfigurationFragmentDoc = gql`
    fragment chainConfiguration on ChainConfiguration {
  id
  manualPointChangeCap
  pointsStrategy
  allowedPointAdjustmentReasons {
    ...pointAdjustmentReason
  }
  offerReturnStrategy: returnableOffersConfig
  offerReturnDefaultStrategy: returnableOffersDefault
  referralProgramConfigurationEnabled
  referralProgramConfiguration {
    ...referralProgramConfiguration
  }
  pointExpiration {
    ...pointExpiration
  }
  allowMultipleTransactionDiscounts
}
    ${PointAdjustmentReasonFragmentDoc}
${ReferralProgramConfigurationFragmentDoc}
${PointExpirationFragmentDoc}`;
export const ChainFragmentDoc = gql`
    fragment chain on Chain {
  id
  name
  rollbackStackingConfig
  rollbackVoucherStackingEnabled
  configuration {
    ...chainConfiguration
  }
}
    ${ChainConfigurationFragmentDoc}`;
export const CampaignFragmentDoc = gql`
    fragment campaign on Campaign {
  uuid
  name
  description
  category
  deleted
  externalId
  chain {
    ...chain
  }
}
    ${ChainFragmentDoc}`;
export const CampaignWithCampaignComponentFragmentDoc = gql`
    fragment campaignWithCampaignComponent on Offer {
  id
  name
  description
  category
  externalId
  deleted
}
    `;
export const CampaignWithCampaignComponentsFragmentDoc = gql`
    fragment campaignWithCampaignComponents on Campaign {
  uuid
  name
  description
  category
  externalId
  deleted
  offers(filter: $offerFilter) @skip(if: $skipOffers) {
    edges {
      node {
        ...campaignWithCampaignComponent
      }
    }
  }
}
    ${CampaignWithCampaignComponentFragmentDoc}`;
export const AwardPointsPerFragmentDoc = gql`
    fragment awardPointsPer on AwardPointsPer {
  points
  rounding
}
    `;
export const EarningMechanismTotalEligiblePurchaseFragmentDoc = gql`
    fragment earningMechanismTotalEligiblePurchase on EarningMechanismTotalEligiblePurchase {
  id
  totalEligiblePurchaseAward: award {
    ...awardPointsPer
  }
  countProductsBy
  eligibleProductGroups {
    id
    name
  }
  roundCountedProducts
}
    ${AwardPointsPerFragmentDoc}`;
export const EarningMechanismExternalFulfillmentFragmentDoc = gql`
    fragment earningMechanismExternalFulfillment on EarningMechanismExternalFulfillment {
  id
  externalFulfillmentAward: award {
    ... on AwardPoints {
      ...awardPoints
    }
    ... on AwardVouchers {
      ...awardVouchers
    }
  }
}
    ${AwardPointsFragmentDoc}
${AwardVouchersFragmentDoc}`;
export const EarningMechanismTotalEligiblePurchaseOverTimeFragmentDoc = gql`
    fragment earningMechanismTotalEligiblePurchaseOverTime on EarningMechanismTotalEligiblePurchaseOverTime {
  id
  totalEligiblePurchaseOverTimeAward: award {
    ... on AwardPoints {
      ...awardPoints
    }
    ... on AwardVouchers {
      ...awardVouchers
    }
  }
  countProductsBy
  eligibleProductGroups {
    id
    name
  }
  accumulationThreshold
  stayVisibleWhileInProgress
  hiddenUntilProgress
  purchaseMemberProgress {
    quantityPurchased
    quantityRequired
  }
}
    ${AwardPointsFragmentDoc}
${AwardVouchersFragmentDoc}`;
export const AwardExternalFragmentDoc = gql`
    fragment awardExternal on AwardExternal {
  provider
}
    `;
export const EarningMechanismProductPurchaseFragmentDoc = gql`
    fragment earningMechanismProductPurchase on EarningMechanismProductPurchase {
  id
  productPurchaseAward: award {
    ... on AwardPoints {
      ...awardPoints
    }
    ... on AwardVouchers {
      ...awardVouchers
    }
    ... on AwardExternal {
      ...awardExternal
    }
  }
  countProductsBy
  eligibleProductGroups {
    id
    name
  }
  purchaseThreshold
}
    ${AwardPointsFragmentDoc}
${AwardVouchersFragmentDoc}
${AwardExternalFragmentDoc}`;
export const EarningMechanismTotalSpendOverTimeFragmentDoc = gql`
    fragment earningMechanismTotalSpendOverTime on EarningMechanismTotalSpendOverTime {
  id
  totalSpendOverTimeAward: award {
    ... on AwardPoints {
      ...awardPoints
    }
    ... on AwardVouchers {
      ...awardVouchers
    }
  }
  ineligibleProductGroups {
    id
    name
  }
  accumulationThreshold
  purchaseMemberProgress {
    quantityPurchased
    quantityRequired
  }
  stayVisibleWhileInProgress
}
    ${AwardPointsFragmentDoc}
${AwardVouchersFragmentDoc}`;
export const EarningMechanismVisitsFragmentDoc = gql`
    fragment earningMechanismVisits on EarningMechanismVisits {
  id
  visitsAward: award {
    ... on AwardPoints {
      ...awardPoints
    }
    ... on AwardVouchers {
      ...awardVouchers
    }
  }
  visitThreshold
  visitsMemberProgress {
    visits
    visitsRequired
  }
}
    ${AwardPointsFragmentDoc}
${AwardVouchersFragmentDoc}`;
export const AwardExternalPointsFragmentDoc = gql`
    fragment awardExternalPoints on AwardExternalPoints {
  maximum
}
    `;
export const EarningMechanismLoyaltyEventFragmentDoc = gql`
    fragment earningMechanismLoyaltyEvent on EarningMechanismLoyaltyEvent {
  id
  loyaltyEventAward: award {
    ... on AwardPoints {
      ...awardPoints
    }
    ... on AwardVouchers {
      ...awardVouchers
    }
    ... on AwardExternalPoints {
      ...awardExternalPoints
    }
  }
  loyaltyEventEventType: eventType
}
    ${AwardPointsFragmentDoc}
${AwardVouchersFragmentDoc}
${AwardExternalPointsFragmentDoc}`;
export const EarningMechanismMembershipEventFragmentDoc = gql`
    fragment earningMechanismMembershipEvent on EarningMechanismMembershipEvent {
  id
  membershipEventAward: award {
    ... on AwardPoints {
      ...awardPoints
    }
    ... on AwardVouchers {
      ...awardVouchers
    }
  }
  membershipEventEventType: eventType
}
    ${AwardPointsFragmentDoc}
${AwardVouchersFragmentDoc}`;
export const EarningMechanismVarietyPurchaseFragmentDoc = gql`
    fragment earningMechanismVarietyPurchase on EarningMechanismVarietyPurchase {
  id
  varietyPurchaseAward: award {
    ... on AwardPoints {
      ...awardPoints
    }
    ... on AwardVouchers {
      ...awardVouchers
    }
  }
  products {
    id
    countProductsBy
    eligibleProductGroups {
      id
      name
    }
    purchaseThreshold
  }
}
    ${AwardPointsFragmentDoc}
${AwardVouchersFragmentDoc}`;
export const EarningMechanismVarietyPurchaseOverTimeFragmentDoc = gql`
    fragment earningMechanismVarietyPurchaseOverTime on EarningMechanismVarietyPurchaseOverTime {
  id
  varietyPurchaseOverTimeAward: award {
    ... on AwardPoints {
      ...awardPoints
    }
    ... on AwardVouchers {
      ...awardVouchers
    }
  }
  products {
    id
    countProductsBy
    eligibleProductGroups {
      id
      name
    }
    purchaseThreshold
  }
  preventDoublePunches
  stayVisibleWhileInProgress
  hiddenUntilProgress
  varietyMemberProgress {
    quantityPurchased
    quantityRequired
  }
}
    ${AwardPointsFragmentDoc}
${AwardVouchersFragmentDoc}`;
export const EarningMechanismPointSpendFragmentDoc = gql`
    fragment earningMechanismPointSpend on EarningMechanismPointSpend {
  id
  pointSpendAward: award {
    ...awardVouchers
  }
  pointCost
  offerIsReturnable
  allowedForNewMember
}
    ${AwardVouchersFragmentDoc}`;
export const AwardTransactionMoneyDiscountFragmentDoc = gql`
    fragment AwardTransactionMoneyDiscount on AwardTransactionMoneyDiscount {
  moneyDiscount
}
    `;
export const AwardTransactionPercentDiscountFragmentDoc = gql`
    fragment AwardTransactionPercentDiscount on AwardTransactionPercentDiscount {
  percentDiscount
}
    `;
export const EarningMechanismTransactionDiscountFragmentDoc = gql`
    fragment earningMechanismTransactionDiscount on EarningMechanismTransactionDiscount {
  id
  transactionDiscountAward: award {
    ... on AwardTransactionMoneyDiscount {
      ...AwardTransactionMoneyDiscount
    }
    ... on AwardTransactionPercentDiscount {
      ...AwardTransactionPercentDiscount
    }
  }
  ineligibleProductGroups {
    id
    name
  }
  purchaseAmountThreshold
  allowMultipleFulfillmentsPerProductGroupThreshold
}
    ${AwardTransactionMoneyDiscountFragmentDoc}
${AwardTransactionPercentDiscountFragmentDoc}`;
export const AwardMoneyDiscountFragmentDoc = gql`
    fragment AwardMoneyDiscount on AwardMoneyDiscount {
  awardPer
  moneyAmount
  partialDiscount
}
    `;
export const AwardPriceOverrideFragmentDoc = gql`
    fragment AwardPriceOverride on AwardPriceOverride {
  maximumCost
}
    `;
export const AwardBuyAndGetFragmentDoc = gql`
    fragment AwardBuyAndGet on AwardBuyAndGet {
  discountThreshold
  percentDiscount
}
    `;
export const EarningMechanismProductDiscountFragmentDoc = gql`
    fragment earningMechanismProductDiscount on EarningMechanismProductDiscount {
  id
  productDiscountAward: award {
    ... on AwardMoneyDiscount {
      ...AwardMoneyDiscount
    }
    ... on AwardPriceOverride {
      ...AwardPriceOverride
    }
    ... on AwardBuyAndGet {
      ...AwardBuyAndGet
    }
  }
  eligibleProductGroups {
    id
    name
  }
  purchaseThresholdInt: purchaseThreshold
  allowCarryOver
}
    ${AwardMoneyDiscountFragmentDoc}
${AwardPriceOverrideFragmentDoc}
${AwardBuyAndGetFragmentDoc}`;
export const AwardProductDiscountFragmentDoc = gql`
    fragment AwardProductDiscount on AwardProductDiscount {
  eligibleProductGroups {
    id
    name
  }
  percentDiscount
  purchaseThreshold
}
    `;
export const EarningMechanismVarietyDiscountFragmentDoc = gql`
    fragment earningMechanismVarietyDiscount on EarningMechanismVarietyDiscount {
  id
  varietyDiscountAward: award {
    ... on AwardTransactionMoneyDiscount {
      ...AwardTransactionMoneyDiscount
    }
    ... on AwardProductDiscount {
      ...AwardProductDiscount
    }
    ... on AwardPriceOverride {
      ...AwardPriceOverride
    }
  }
  purchases {
    purchaseThreshold
    eligibleProductGroups {
      id
      name
    }
  }
}
    ${AwardTransactionMoneyDiscountFragmentDoc}
${AwardProductDiscountFragmentDoc}
${AwardPriceOverrideFragmentDoc}`;
export const EarningMechanismTotalSpendOnTransactionFragmentDoc = gql`
    fragment earningMechanismTotalSpendOnTransaction on EarningMechanismTotalSpendOnTransaction {
  id
  totalSpendOnTransactionAward: award {
    ... on AwardPointsPer {
      ...awardPointsPer
    }
  }
  ineligibleProductGroups {
    id
    name
  }
  roundMoneyAmount
}
    ${AwardPointsPerFragmentDoc}`;
export const EarningMechanismSpinWheelGameFragmentDoc = gql`
    fragment earningMechanismSpinWheelGame on EarningMechanismSpinWheelGame {
  id
  purchasableOffer {
    ... on Offer {
      id
      name
    }
  }
  awards {
    awardType
    limit
    sequenceNumber
    award {
      ... on AwardPoints {
        points
      }
      ... on AwardVouchers {
        voucherExpirationDays
        voucherCount
        voucheredOffer {
          ... on Offer {
            id
            name
          }
        }
      }
    }
  }
}
    `;
export const PromocodeFragmentDoc = gql`
    fragment promocode on Promocode {
  id
  code
  status
  publicationStatus
  description
  startDate
  endDate
  stats {
    redemptions
    totalOfferRedemptions
  }
  createdBy {
    email
    name
  }
}
    `;
export const PromoCodeGroupFragmentDoc = gql`
    fragment promoCodeGroup on PromoCodeGroup {
  id
  fileName
  processingStatus
  codesStats {
    createdCount
    failedCount
    totalCount
  }
}
    `;
export const EarningMechanismPromocodesFragmentDoc = gql`
    fragment earningMechanismPromocodes on EarningMechanismPromocodes {
  id
  codesType
  promocodes {
    ...promocode
  }
  promoCodeGroups(first: 100) {
    edges {
      node {
        ...promoCodeGroup
      }
    }
  }
  award {
    ...awardPoints
    ...awardVouchers
  }
}
    ${PromocodeFragmentDoc}
${PromoCodeGroupFragmentDoc}
${AwardPointsFragmentDoc}
${AwardVouchersFragmentDoc}`;
export const EarningMechanismStoredValueDiscountFragmentDoc = gql`
    fragment earningMechanismStoredValueDiscount on EarningMechanismStoredValueDiscount {
  id
  maxDiscountPerTransaction
  excludedProductGroups {
    id
    name
  }
}
    `;
export const EarningMechanismFragmentDoc = gql`
    fragment earningMechanism on EarningMechanism {
  ...earningMechanismTotalEligiblePurchase
  ...earningMechanismExternalFulfillment
  ...earningMechanismTotalEligiblePurchaseOverTime
  ...earningMechanismProductPurchase
  ...earningMechanismTotalSpendOverTime
  ...earningMechanismVisits
  ...earningMechanismLoyaltyEvent
  ...earningMechanismMembershipEvent
  ...earningMechanismVarietyPurchase
  ...earningMechanismVarietyPurchaseOverTime
  ...earningMechanismPointSpend
  ...earningMechanismTransactionDiscount
  ...earningMechanismProductDiscount
  ...earningMechanismVarietyDiscount
  ...earningMechanismTotalSpendOnTransaction
  ...earningMechanismSpinWheelGame
  ...earningMechanismPromocodes
  ...earningMechanismStoredValueDiscount
}
    ${EarningMechanismTotalEligiblePurchaseFragmentDoc}
${EarningMechanismExternalFulfillmentFragmentDoc}
${EarningMechanismTotalEligiblePurchaseOverTimeFragmentDoc}
${EarningMechanismProductPurchaseFragmentDoc}
${EarningMechanismTotalSpendOverTimeFragmentDoc}
${EarningMechanismVisitsFragmentDoc}
${EarningMechanismLoyaltyEventFragmentDoc}
${EarningMechanismMembershipEventFragmentDoc}
${EarningMechanismVarietyPurchaseFragmentDoc}
${EarningMechanismVarietyPurchaseOverTimeFragmentDoc}
${EarningMechanismPointSpendFragmentDoc}
${EarningMechanismTransactionDiscountFragmentDoc}
${EarningMechanismProductDiscountFragmentDoc}
${EarningMechanismVarietyDiscountFragmentDoc}
${EarningMechanismTotalSpendOnTransactionFragmentDoc}
${EarningMechanismSpinWheelGameFragmentDoc}
${EarningMechanismPromocodesFragmentDoc}
${EarningMechanismStoredValueDiscountFragmentDoc}`;
export const CampaignComponentFragmentDoc = gql`
    fragment campaignComponent on Offer {
  id
  description
  name
  engagementType
  publishedStatus
  deleted
  fulfillmentCount
  voucherCount
  marketingContents {
    ...marketingContent
  }
  earningMechanism {
    ...earningMechanism
  }
}
    ${MarketingContentFragmentDoc}
${EarningMechanismFragmentDoc}`;
export const CommunicationPreferenceFragmentDoc = gql`
    fragment communicationPreference on CommunicationPreference {
  smsOptInAt
  smsOptOutAt
  smsOptIn
  emailOptInAt
  emailOptOutAt
  emailOptIn
  pushOptInAt
  pushOptOutAt
  pushOptIn
  subBrandUuid
}
    `;
export const CustomerFragmentDoc = gql`
    fragment customer on Customer {
  uuid
  communicationPreference {
    ...communicationPreference
  }
}
    ${CommunicationPreferenceFragmentDoc}`;
export const EaivAuditFragmentDoc = gql`
    fragment EaivAudit on EaivAuditTrail {
  uuid
  actionType
  result
  reasonMessage
  createdAt
}
    `;
export const ExternalIdentityVerificationAttributeFragmentDoc = gql`
    fragment externalIdentityVerificationAttribute on ExternalIdentityVerificationAttribute {
  handle
  name
}
    `;
export const BannerConfigurationFragmentDoc = gql`
    fragment bannerConfiguration on BannerConfigurationSummary {
  uuid
  title
}
    `;
export const GamesListItemFragmentDoc = gql`
    fragment gamesListItem on Offer {
  id
  name
  description
  deleted
  publicationStatus
  fulfillmentCount
  marketingContents {
    ...marketingContent
  }
}
    ${MarketingContentFragmentDoc}`;
export const LocationFragmentDoc = gql`
    fragment location on Location {
  uuid
  customerName
  siteSystemConfiguration {
    details {
      siteName
    }
    identifier
  }
}
    `;
export const LocationSelectItemFragmentDoc = gql`
    fragment locationSelectItem on Location {
  uuid
  siteSystemConfiguration {
    identifier
  }
}
    `;
export const LocationAddressFragmentDoc = gql`
    fragment locationAddress on Address {
  uuid
  alias
  city
  countryCode
  state
  street1
  street2
  zipCode
  geoLocation {
    latitude
    longitude
  }
}
    `;
export const LocationAttributeFragmentDoc = gql`
    fragment locationAttribute on LocationAttribute {
  name
  value
}
    `;
export const SiteSystemFuelPumpProductFragmentDoc = gql`
    fragment siteSystemFuelPumpProduct on SiteSystemFuelPumpProduct {
  outdoorPosition
  description
  posCode
  posCodeModifier
  posCodeFormat
  productCode
  merchandiseCode
  priceTier
  unitPrice
}
    `;
export const SiteSystemCarWashItemFragmentDoc = gql`
    fragment siteSystemCarWashItem on SiteSystemCarWashItem {
  description
  posCode
  posCodeModifier
  posCodeFormat
  productCode
  merchandiseCode
  unitPrice
}
    `;
export const SiteSystemDetailsFragmentDoc = gql`
    fragment siteSystemDetails on SiteSystemDetails {
  siteAddress
  siteName
  latitude
  longitude
  welcomeMsg
  mobileActive
  mobileProtocol
  mobileVersion
  loyaltyProtocol
  loyaltyVersion
  partialAuthAllowed
  pumpTimeout
  lastConnection
  lastLoyaltyConnection
  lastMobileConnection
  isOnline
  isLoyaltyOnline
  isMobileOnline
  hardwareVendor
  fuelConfigDetails {
    ...siteSystemFuelPumpProduct
  }
  carWashDetails {
    ...siteSystemCarWashItem
  }
}
    ${SiteSystemFuelPumpProductFragmentDoc}
${SiteSystemCarWashItemFragmentDoc}`;
export const SiteSystemConfigurationFragmentDoc = gql`
    fragment siteSystemConfiguration on SiteSystemConfiguration {
  uuid
  identifier
  hardwareVendor
  mobileEnabled
  loyaltyEnabled
  loyaltyHeartbeatsOnlyEnabled
  details {
    ...siteSystemDetails
  }
}
    ${SiteSystemDetailsFragmentDoc}`;
export const SiteManagementLocationFragmentDoc = gql`
    fragment siteManagementLocation on Location {
  uuid
  timezone
  name
  payAtPumpEnabled
  locationGroups {
    uuid
    name
  }
  altriaRcn
  altriaMan
  rjrAccountNumber
  brandSpecificLocationId
  brand {
    uuid
    name
  }
  brandingDetails {
    primaryColor
    secondaryColor
  }
  address {
    ...locationAddress
  }
  attributes {
    ...locationAttribute
  }
  phoneNumbers {
    phoneNumber
    phoneType
  }
  siteSystemConfiguration {
    ...siteSystemConfiguration
  }
  rewardPrograms {
    programId
    uuid
    type
  }
}
    ${LocationAddressFragmentDoc}
${LocationAttributeFragmentDoc}
${SiteSystemConfigurationFragmentDoc}`;
export const SitesSummaryItemFragmentDoc = gql`
    fragment sitesSummaryItem on SitesSummary {
  total
  loyaltyOffline
  loyaltyOnline
  mobileOffline
  mobileOnline
  issues
}
    `;
export const LocationGroupFragmentDoc = gql`
    fragment locationGroup on LocationGroup {
  uuid
  name
  countOfLocations
}
    `;
export const LoyaltyEventsListItemFragmentDoc = gql`
    fragment loyaltyEventsListItem on Offer {
  id
  name
  description
  deleted
  publicationStatus
  fulfillmentCount
  visibleForCommandCenterFulfillment
  shortDescription
  earningMechanism {
    ...earningMechanismLoyaltyEvent
  }
  marketingContents {
    ...marketingContent
  }
}
    ${EarningMechanismLoyaltyEventFragmentDoc}
${MarketingContentFragmentDoc}`;
export const FuelAndConvenienceProfileFragmentDoc = gql`
    fragment fuelAndConvenienceProfile on FuelAndConvenienceProfile {
  id
  achStatus
  achEnrollmentStatus
  acquisitionChannel
  restrictionVerification
  restrictionVerificationSource
  createdAt
}
    `;
export const TransactionStateChangeSourceItemFragmentDoc = gql`
    fragment transactionStateChangeSourceItem on ActivateTransaction {
  id
}
    `;
export const MembershipStateChangeSourceItemFragmentDoc = gql`
    fragment membershipStateChangeSourceItem on Membership {
  id
}
    `;
export const CommandCenterUserStateChangeSourceItemFragmentDoc = gql`
    fragment commandCenterUserStateChangeSourceItem on CommandCenterUser {
  email
  name
}
    `;
export const MembershipStateChangeSourceFragmentDoc = gql`
    fragment membershipStateChangeSource on StateChangeSource {
  ...transactionStateChangeSourceItem
  ...membershipStateChangeSourceItem
  ...commandCenterUserStateChangeSourceItem
}
    ${TransactionStateChangeSourceItemFragmentDoc}
${MembershipStateChangeSourceItemFragmentDoc}
${CommandCenterUserStateChangeSourceItemFragmentDoc}`;
export const MembershipStateChangeFragmentDoc = gql`
    fragment membershipStateChange on MembershipState {
  effectiveAt
  state
  source {
    ...membershipStateChangeSource
  }
}
    ${MembershipStateChangeSourceFragmentDoc}`;
export const MembershipAddressFragmentDoc = gql`
    fragment membershipAddress on MembershipAddress {
  address1
  address2
  city
  state
  zipcode
}
    `;
export const MembershipExternalIdentityVerificationProfileFragmentDoc = gql`
    fragment membershipExternalIdentityVerificationProfile on ExternalIdentityVerificationProfile {
  completedAt
  provider
  attributes(filter: {isCoreAttributeOnly: true}) {
    name
    handle
  }
}
    `;
export const MembershipFragmentDoc = gql`
    fragment membership on Membership {
  id
  createdAt
  birthdate
  customData
  customerUuid
  email
  firstName
  lastName
  phone
  points
  storedValueBalance
  storedValueExpirationSchedule(first: 0) {
    edges {
      node {
        expirationDate
        storedValue
      }
    }
  }
  state
  membershipType
  lastSubBrandOffersQueriesUuid
  homeStores {
    locationUuid
  }
  locationProfile {
    city
    locationId
    state
    zipcode
  }
  fuelAndConvenienceProfile {
    ...fuelAndConvenienceProfile
  }
  stateChanges {
    ...membershipStateChange
  }
  transactions(first: 0) {
    totalCount
  }
  offerPurchases(first: 0) {
    totalCount
  }
  primaryAddress {
    ...membershipAddress
  }
  externalIdentityVerificationProfiles {
    ...membershipExternalIdentityVerificationProfile
  }
  externalLoyaltyIds {
    id
    identifier
    externalProgram {
      id
      name
    }
  }
}
    ${FuelAndConvenienceProfileFragmentDoc}
${MembershipStateChangeFragmentDoc}
${MembershipAddressFragmentDoc}
${MembershipExternalIdentityVerificationProfileFragmentDoc}`;
export const AudienceForMembershipFragmentDoc = gql`
    fragment audienceForMembership on Audience {
  uuid
  name
  description
  status
}
    `;
export const LoyaltyEventItemFragmentDoc = gql`
    fragment loyaltyEventItem on LoyaltyEvent {
  createdAt
  eventType
  id
}
    `;
export const MembershipOfferFragmentDoc = gql`
    fragment membershipOffer on Offer {
  id
  name
  description
  campaign {
    uuid
  }
  activationStatus
  visibleStatus
  eligible
  engagementType
  earningMechanism {
    ...earningMechanism
  }
  marketingContents {
    id
    title
    shortDescription
    imageUrl
  }
  voucherCount
  fulfillmentCount
  createdAt
  expireAt
}
    ${EarningMechanismFragmentDoc}`;
export const MembershipVoucherFulfilledByActivateTransactionFragmentDoc = gql`
    fragment membershipVoucherFulfilledByActivateTransaction on ActivateTransaction {
  __typename
  id
  transactionTimeAt
  location {
    id
    name
  }
  lineItems {
    id
    sku
    upc
    quantity
    description
    group
    moneyAmount
  }
}
    `;
export const MembershipVoucherFulfilledByFragmentDoc = gql`
    fragment membershipVoucherFulfilledBy on VoucherFulfilledBy {
  ...membershipVoucherFulfilledByActivateTransaction
}
    ${MembershipVoucherFulfilledByActivateTransactionFragmentDoc}`;
export const MembershipVoucherFragmentDoc = gql`
    fragment membershipVoucher on Voucher {
  id
  createdAt
  expireAt
  offer {
    id
    name
    engagementType
    marketingContents {
      id
      title
      imageUrl
    }
    voucherCount
  }
  sourceId
  sourceType
  fulfilledBy {
    ...membershipVoucherFulfilledBy
  }
  state
}
    ${MembershipVoucherFulfilledByFragmentDoc}`;
export const SegmentByMembershipUuidFragmentDoc = gql`
    fragment segmentByMembershipUuid on Segment {
  id
  name
  description
  shortCode
  membershipSegmentCreatedAt
}
    `;
export const TransactionItemFragmentDoc = gql`
    fragment transactionItem on ActivateTransaction {
  id
  transactionTimeAt
  createdAt
  lineItems {
    id
    moneyAmount
    quantity
  }
  location {
    id
    name
    address1
    city
    state
  }
  partnerId
  totalAmount
  totalAmountWithoutDiscounts
  totalTax
}
    `;
export const PointChangeItemFragmentDoc = gql`
    fragment pointChangeItem on PointChange {
  id
  createdAt
  notes
  pointAdjustmentReason {
    ...pointAdjustmentReason
  }
  offer {
    id
    name
    activationStatus
    category
    publishAt
    expireAt
    marketingContents {
      id
      title
      shortDescription
      imageUrl
    }
  }
  type
  source {
    ... on ActivateTransaction {
      id
      __typename
    }
    ... on ActivateUser {
      id
      __typename
    }
    ... on CommandCenterUser {
      __typename
      email
    }
    ... on LoyaltyEvent {
      id
      __typename
    }
    ... on PointChange {
      id
      __typename
    }
    ... on OfferPurchase {
      __typename
    }
  }
  quantity
}
    ${PointAdjustmentReasonFragmentDoc}`;
export const MembershipCommentFragmentDoc = gql`
    fragment membershipComment on MembershipProfileComment {
  id
  createdAt
  author {
    email
    name
  }
  text
}
    `;
export const RetailerNetworkLocationForMemberFragmentDoc = gql`
    fragment retailerNetworkLocationForMember on RetailerNetworkLocationForMember {
  uuid
  role
  siteId
  siteName
  retailerNetworkUuid
}
    `;
export const RetailerNetworkLocationGroupForMemberFragmentDoc = gql`
    fragment retailerNetworkLocationGroupForMember on RetailerNetworkLocationGroupForMember {
  uuid
  countOfLocations
  name
  roles
  retailerNetworkUuid
}
    `;
export const RetailerNetworkForMemberFragmentDoc = gql`
    fragment retailerNetworkForMember on RetailerNetworkForMember {
  uuid
  name
  roles
  locationsCount
}
    `;
export const RetailerNetworkUserForMemberFragmentDoc = gql`
    fragment retailerNetworkUserForMember on RetailerNetworkUser {
  uuid
  role
}
    `;
export const PhoneNumberMetadataFragmentDoc = gql`
    fragment phoneNumberMetadata on PhoneNumberMetadata {
  carrier
  countryCode
  phoneType
}
    `;
export const MembershipActivityActivateTransactionFragmentDoc = gql`
    fragment membershipActivityActivateTransaction on ActivateTransaction {
  id
  createdAt
  location {
    id
    name
    address1
    address2
    city
    state
    zipcode
  }
  totalAmount
  totalGallons
  totalPointsEarned
  totalPointsRefunded
  totalPointsSpent
}
    `;
export const MembershipActivityPointChangeFragmentDoc = gql`
    fragment membershipActivityPointChange on PointChange {
  id
  type
  createdAt
  notes
  source {
    ... on ActivateTransaction {
      ...transactionSource
    }
    ... on ActivateUser {
      ...userSource
    }
    ... on LoyaltyEvent {
      ...loyaltyEventSource
    }
    ... on PointChange {
      ...pointChangeSource
    }
    ... on OfferPurchase {
      ...offerPurchaseSource
    }
    ... on CommandCenterUser {
      ...commandCenterUserSource
    }
    ... on MembershipPointDonation {
      ...membershipPointDonationSource
    }
  }
  sourceType
  quantity
  offer {
    id
    name
    marketingContents {
      id
      title
    }
  }
}
    ${TransactionSourceFragmentDoc}
${UserSourceFragmentDoc}
${LoyaltyEventSourceFragmentDoc}
${PointChangeSourceFragmentDoc}
${OfferPurchaseSourceFragmentDoc}
${CommandCenterUserSourceFragmentDoc}
${MembershipPointDonationSourceFragmentDoc}`;
export const MembershipActivityFragmentDoc = gql`
    fragment membershipActivity on MembershipActivity {
  id
  createdAt
  type
  event {
    ... on ActivateTransaction {
      ...membershipActivityActivateTransaction
    }
    ... on PointChange {
      ...membershipActivityPointChange
    }
  }
}
    ${MembershipActivityActivateTransactionFragmentDoc}
${MembershipActivityPointChangeFragmentDoc}`;
export const LimitFragmentDoc = gql`
    fragment limit on Limit {
  ... on LimitGlobalActivation {
    id
    limit
  }
  ... on LimitGlobalActivationInTime {
    id
    limit
    timePeriod
  }
  ... on LimitMembershipActivation {
    id
    limit
  }
  ... on LimitMembershipActivationInTime {
    id
    limit
    timePeriod
  }
  ... on LimitGlobalAwardCount {
    id
    limit
  }
  ... on LimitGlobalAwardCountInTime {
    id
    limit
    timePeriod
  }
  ... on LimitMembershipAwardCount {
    id
    limit
  }
  ... on LimitMembershipAwardCountInTime {
    id
    limit
    timePeriod
  }
  ... on LimitInTransactionAwardCount {
    id
    limit
  }
  ... on LimitInTransactionProgress {
    id
    limit
  }
  ... on LimitMembershipProgressInTime {
    id
    limit
    timePeriod
  }
  ... on LimitMembershipTransactionCount {
    id
    limit
  }
  ... on LimitMembershipTransactionCountInTime {
    id
    limit
    timePeriod
  }
}
    `;
export const ConstraintLocationInStateFragmentDoc = gql`
    fragment constraintLocationInState on ConstraintLocationInState {
  id
  states
}
    `;
export const ConstraintRequiresActivationFragmentDoc = gql`
    fragment constraintRequiresActivation on ConstraintRequiresActivation {
  id
  mustFulfillWithinDays
  allowMultipleFulfillmentsOnActivation
}
    `;
export const ConstraintInAudienceFragmentDoc = gql`
    fragment constraintInAudience on ConstraintInAudience {
  id
  audienceId
}
    `;
export const ConstraintDaysOfWeekFragmentDoc = gql`
    fragment constraintDaysOfWeek on ConstraintDaysOfWeek {
  id
  availableWeeklyOnDays
  startOfDayTimezone
}
    `;
export const ConstraintRequiresVoucherFragmentDoc = gql`
    fragment constraintRequiresVoucher on ConstraintRequiresVoucher {
  id
}
    `;
export const ConstraintRequiresVoucherAvailableForDiscountFragmentDoc = gql`
    fragment constraintRequiresVoucherAvailableForDiscount on ConstraintRequiresVoucherAvailableForDiscount {
  id
}
    `;
export const ConstraintRequiresTransactionVoucherFragmentDoc = gql`
    fragment constraintRequiresTransactionVoucher on ConstraintRequiresTransactionVoucher {
  id
  allowSingleOfferVoucherStacking
  breakageRefund
  breakagePointRounding
}
    `;
export const ConstraintStoreLocationFragmentDoc = gql`
    fragment constraintStoreLocation on ConstraintStoreLocation {
  id
  locations {
    id
    name
  }
  evaluationMethod
}
    `;
export const ConstraintStoreLocationGroupFragmentDoc = gql`
    fragment constraintStoreLocationGroup on ConstraintStoreLocationGroup {
  id
  locationGroups {
    uuid
    name
  }
}
    `;
export const ConstraintTimeOfDayFragmentDoc = gql`
    fragment constraintTimeOfDay on ConstraintTimeOfDay {
  id
  availableDailyEndingAtTime
  availableDailyStartingAtTime
  timezone
}
    `;
export const ConstraintPurchaseThresholdFragmentDoc = gql`
    fragment constraintPurchaseThreshold on ConstraintPurchaseThreshold {
  id
  eligibleProductGroupIds
  countProductsBy
  threshold
}
    `;
export const ConstraintPaymentMethodFragmentDoc = gql`
    fragment constraintPaymentMethod on ConstraintPaymentMethod {
  id
  paymentEvaluationMethod: evaluationMethod
  paymentMethods
}
    `;
export const ConstraintPurchasableEligibilityFragmentDoc = gql`
    fragment constraintPurchasableEligibility on ConstraintPurchasableEligibility {
  id
  ownershipCondition
  voucheredOffers {
    id
    name
  }
}
    `;
export const ConstraintPreAuthFragmentDoc = gql`
    fragment constraintPreAuth on ConstraintPreAuth {
  id
}
    `;
export const ConstraintPaymentInstrumentFragmentDoc = gql`
    fragment constraintPaymentInstrument on ConstraintPaymentInstrument {
  id
  paymentInstrumentEvaluationMethod: evaluationMethod
  paymentInstruments
}
    `;
export const ConstraintEmailRequiredFragmentDoc = gql`
    fragment constraintEmailRequired on ConstraintEmailRequired {
  id
}
    `;
export const ConstraintSubBrandFragmentDoc = gql`
    fragment constraintSubBrand on ConstraintSubBrand {
  id
  subBrandUuids
}
    `;
export const ConstraintOrderAheadOnlyFragmentDoc = gql`
    fragment constraintOrderAheadOnly on ConstraintOrderAheadOnly {
  id
}
    `;
export const ConstraintInStoreOnlyFragmentDoc = gql`
    fragment constraintInStoreOnly on ConstraintInStoreOnly {
  id
}
    `;
export const ConstraintFragmentDoc = gql`
    fragment constraint on Constraint {
  ...constraintLocationInState
  ...constraintRequiresActivation
  ...constraintInAudience
  ...constraintDaysOfWeek
  ...constraintRequiresVoucher
  ...constraintRequiresVoucherAvailableForDiscount
  ...constraintRequiresTransactionVoucher
  ...constraintStoreLocation
  ...constraintStoreLocationGroup
  ...constraintTimeOfDay
  ...constraintPurchaseThreshold
  ...constraintPaymentMethod
  ...constraintPurchasableEligibility
  ...constraintPreAuth
  ...constraintPaymentInstrument
  ...constraintEmailRequired
  ...constraintSubBrand
  ...constraintOrderAheadOnly
  ...constraintInStoreOnly
}
    ${ConstraintLocationInStateFragmentDoc}
${ConstraintRequiresActivationFragmentDoc}
${ConstraintInAudienceFragmentDoc}
${ConstraintDaysOfWeekFragmentDoc}
${ConstraintRequiresVoucherFragmentDoc}
${ConstraintRequiresVoucherAvailableForDiscountFragmentDoc}
${ConstraintRequiresTransactionVoucherFragmentDoc}
${ConstraintStoreLocationFragmentDoc}
${ConstraintStoreLocationGroupFragmentDoc}
${ConstraintTimeOfDayFragmentDoc}
${ConstraintPurchaseThresholdFragmentDoc}
${ConstraintPaymentMethodFragmentDoc}
${ConstraintPurchasableEligibilityFragmentDoc}
${ConstraintPreAuthFragmentDoc}
${ConstraintPaymentInstrumentFragmentDoc}
${ConstraintEmailRequiredFragmentDoc}
${ConstraintSubBrandFragmentDoc}
${ConstraintOrderAheadOnlyFragmentDoc}
${ConstraintInStoreOnlyFragmentDoc}`;
export const OfferFragmentDoc = gql`
    fragment offer on Offer {
  id
  description
  name
  engagementType
  category
  publicationStatus
  createdAt
  expireAt
  publishAt
  deleted
  presentationType
  presentationPriority
  fulfillmentCount
  fulfillmentPriorityLevel
  visibleForCommandCenterFulfillment
  voucherCount
  ageRestricted
  customData
  scanDataConfiguration {
    description
    discountAllocation
    fundingSource
  }
  externalId
  fundingSource
  fundingSourceName
  trackingConfig {
    trackingId
    isActivityLogIncludedInAltriaDDM
  }
  shortDescription
  longDescription
  optionalAtPos
  stackable
  displayForOrderAhead
  allowedForManualVisibilityNotifications
  campaign {
    uuid
    name
  }
  marketingContents {
    ...marketingContent
  }
  limits {
    ...limit
  }
  constraints {
    ...constraint
  }
  earningMechanism {
    ...earningMechanism
  }
  triggerPreferences {
    triggerOnFulfillment
    triggerOnVisibility
    triggerOnProgress
  }
  displayCategories {
    ...displayCategory
  }
  displayForOrderAhead
}
    ${MarketingContentFragmentDoc}
${LimitFragmentDoc}
${ConstraintFragmentDoc}
${EarningMechanismFragmentDoc}
${DisplayCategoryFragmentDoc}`;
export const OfferWithCustomConstraintsFragmentDoc = gql`
    fragment offerWithCustomConstraints on Offer {
  id
  description
  name
  engagementType
  category
  publicationStatus
  createdAt
  expireAt
  publishAt
  deleted
  presentationType
  presentationPriority
  fulfillmentCount
  fulfillmentPriorityLevel
  visibleForCommandCenterFulfillment
  voucherCount
  ageRestricted
  customData
  scanDataConfiguration {
    description
    discountAllocation
    fundingSource
  }
  externalId
  fundingSource
  fundingSourceName
  trackingConfig {
    trackingId
    isActivityLogIncludedInAltriaDDM
  }
  shortDescription
  longDescription
  optionalAtPos
  stackable
  allowedForManualVisibilityNotifications
  marketingContents {
    ...marketingContent
  }
  limits {
    ...limit
  }
  constraints {
    ...constraintLocationInState
    ...constraintRequiresActivation
    ...constraintInAudience
    ...constraintDaysOfWeek
    ...constraintRequiresVoucher
    ...constraintRequiresVoucherAvailableForDiscount
    ...constraintRequiresTransactionVoucher
    ...constraintStoreLocation
    ...constraintStoreLocationGroup
    ...constraintTimeOfDay
    ...constraintPurchaseThreshold
    ...constraintPaymentMethod
    ...constraintPaymentInstrument
    ...constraintPreAuth
    ...constraintPurchasableEligibility
    ...constraintEmailRequired
    ...constraintSubBrand
    ...constraintOrderAheadOnly
    ...constraintInStoreOnly
  }
  earningMechanism {
    ...earningMechanism
  }
  triggerPreferences {
    triggerOnFulfillment
    triggerOnVisibility
    triggerOnProgress
  }
  displayCategories {
    ...displayCategory
  }
}
    ${MarketingContentFragmentDoc}
${LimitFragmentDoc}
${ConstraintLocationInStateFragmentDoc}
${ConstraintRequiresActivationFragmentDoc}
${ConstraintInAudienceFragmentDoc}
${ConstraintDaysOfWeekFragmentDoc}
${ConstraintRequiresVoucherFragmentDoc}
${ConstraintRequiresVoucherAvailableForDiscountFragmentDoc}
${ConstraintRequiresTransactionVoucherFragmentDoc}
${ConstraintStoreLocationFragmentDoc}
${ConstraintStoreLocationGroupFragmentDoc}
${ConstraintTimeOfDayFragmentDoc}
${ConstraintPurchaseThresholdFragmentDoc}
${ConstraintPaymentMethodFragmentDoc}
${ConstraintPaymentInstrumentFragmentDoc}
${ConstraintPreAuthFragmentDoc}
${ConstraintPurchasableEligibilityFragmentDoc}
${ConstraintEmailRequiredFragmentDoc}
${ConstraintSubBrandFragmentDoc}
${ConstraintOrderAheadOnlyFragmentDoc}
${ConstraintInStoreOnlyFragmentDoc}
${EarningMechanismFragmentDoc}
${DisplayCategoryFragmentDoc}`;
export const OfferSelectItemFragmentDoc = gql`
    fragment offerSelectItem on Offer {
  id
  name
  engagementType
}
    `;
export const OpenCommerceUserCustomDataFragmentDoc = gql`
    fragment openCommerceUserCustomData on OpenCommerceUser {
  customData
}
    `;
export const OpenCommerceUserFragmentDoc = gql`
    fragment openCommerceUser on OpenCommerceUser {
  uuid
  username
  name {
    first
    last
  }
  phoneNumber
  email
  userRole
  status
  ...openCommerceUserCustomData
}
    ${OpenCommerceUserCustomDataFragmentDoc}`;
export const OpenCommerceUserSelectItemFragmentDoc = gql`
    fragment openCommerceUserSelectItem on OpenCommerceUser {
  uuid
  name {
    first
    last
  }
}
    `;
export const CurrentUserRetailerNetworkUserFragmentDoc = gql`
    fragment currentUserRetailerNetworkUser on RetailerNetworkUser {
  uuid
  role
  openCommerceUser {
    uuid
    name {
      first
      last
    }
    email
  }
  retailerNetwork {
    uuid
  }
}
    `;
export const ProductCategoryFragmentDoc = gql`
    fragment productCategory on ProductCategory {
  id
  name
  categoryRestriction
  rank
}
    `;
export const SegmentFragmentDoc = gql`
    fragment segment on Segment {
  id
  uuid: id
  name
  description
  shortCode
  membershipCount
}
    `;
export const SiteMonitorActivityLogItemFragmentDoc = gql`
    fragment siteMonitorActivityLogItem on SiteMonitorActivity {
  uuid
  action
  activityType
  createdAt
  description
  rawMessage
}
    `;
export const SteeringWalletBasicInfoFragmentDoc = gql`
    fragment steeringWalletBasicInfo on SteeringWallet {
  uuid
  name
  configuration {
    unitOfMeasure
    basis
  }
}
    `;
export const SteeringWalletConfigurationFragmentDoc = gql`
    fragment steeringWalletConfiguration on SteeringWalletConfiguration {
  productGroupId
  reportingPeriod
  basis
  unitOfMeasure
}
    `;
export const SteeringWalletFragmentDoc = gql`
    fragment steeringWallet on SteeringWallet {
  uuid
  chainId
  name
  status
  configuration {
    ...steeringWalletConfiguration
  }
  statistics {
    walletUuid
    walletCapacity
    walletShare
    walletOpportunity
    membershipCount
  }
}
    ${SteeringWalletConfigurationFragmentDoc}`;
export const WalletSteeringSurveyConfigurationFragmentDoc = gql`
    fragment walletSteeringSurveyConfiguration on WalletSteeringSurveyConfiguration {
  steeringWalletUuid
  questionText
  minUnits
  maxUnits
}
    `;
export const WalletSteeringSurveyFragmentDoc = gql`
    fragment walletSteeringSurvey on WalletSteeringSurvey {
  uuid
  chainId
  status
  configuration {
    ...walletSteeringSurveyConfiguration
  }
  createdAt
  deletedAt
}
    ${WalletSteeringSurveyConfigurationFragmentDoc}`;
export const SubBrandFragmentDoc = gql`
    fragment subBrand on SubBrand {
  name
  uuid
}
    `;
export const SurveyQuestionFragmentDoc = gql`
    fragment surveyQuestion on SurveyQuestion {
  uuid
  index
  questionText
}
    `;
export const SurveyQuestionIntSliderFragmentDoc = gql`
    fragment surveyQuestionIntSlider on SurveyQuestionIntSlider {
  ...surveyQuestion
  max
  min
}
    ${SurveyQuestionFragmentDoc}`;
export const SurveyQuestionOptionFragmentDoc = gql`
    fragment surveyQuestionOption on SurveyQuestionOption {
  uuid
  index
  label
}
    `;
export const SurveyQuestionMultipleChoiceFragmentDoc = gql`
    fragment surveyQuestionMultipleChoice on SurveyQuestionMultipleChoice {
  ...surveyQuestion
  options {
    ...surveyQuestionOption
  }
}
    ${SurveyQuestionFragmentDoc}
${SurveyQuestionOptionFragmentDoc}`;
export const SurveyQuestionSingleChoiceFragmentDoc = gql`
    fragment surveyQuestionSingleChoice on SurveyQuestionSingleChoice {
  ...surveyQuestion
  options {
    ...surveyQuestionOption
  }
}
    ${SurveyQuestionFragmentDoc}
${SurveyQuestionOptionFragmentDoc}`;
export const SurveyAwardPointsFragmentDoc = gql`
    fragment surveyAwardPoints on AwardPoints {
  points
}
    `;
export const SurveyAwardVouchersFragmentDoc = gql`
    fragment surveyAwardVouchers on AwardVouchers {
  voucherCount
  voucheredOffer {
    id
    name
  }
  voucherExpirationDays
}
    `;
export const SurveyFragmentDoc = gql`
    fragment survey on Survey {
  uuid
  status
  createdAt
  award {
    ...surveyAwardPoints
    ...surveyAwardVouchers
  }
  chainId
}
    ${SurveyAwardPointsFragmentDoc}
${SurveyAwardVouchersFragmentDoc}`;
export const GeneralSurveyFragmentDoc = gql`
    fragment generalSurvey on GeneralSurvey {
  name
  description
  audienceUuid
  configuration {
    startDate
    endDate
  }
  questions {
    ...surveyQuestionIntSlider
    ...surveyQuestionMultipleChoice
    ...surveyQuestionSingleChoice
  }
  ...survey
}
    ${SurveyQuestionIntSliderFragmentDoc}
${SurveyQuestionMultipleChoiceFragmentDoc}
${SurveyQuestionSingleChoiceFragmentDoc}
${SurveyFragmentDoc}`;
export const OptionSelectionCounterFragmentDoc = gql`
    fragment optionSelectionCounter on OptionSelectionCount {
  count
  optionLabel
}
    `;
export const SliderResponseRangeFragmentDoc = gql`
    fragment sliderResponseRange on SliderResponseRange {
  count
  rangeStart
  rangeEnd
}
    `;
export const SurveyLocationStatisticsFragmentDoc = gql`
    fragment surveyLocationStatistics on SurveyLocationStatistics {
  bottomResponse
  bottomResponsePercentage
  siteId
  siteName
  surveyUuid
  topResponse
  topResponsePercentage
  totalResponses
  responseStatistics {
    locationUuid
    optionSelectionCounters {
      ...optionSelectionCounter
    }
    sliderResponseRanges {
      ...sliderResponseRange
    }
  }
}
    ${OptionSelectionCounterFragmentDoc}
${SliderResponseRangeFragmentDoc}`;
export const SurveyEngagementMetricsFragmentDoc = gql`
    fragment surveyEngagementMetrics on SurveyEngagementMetrics {
  dailyAverageCount
  totalCount
  counters {
    count
    date
  }
}
    `;
export const SurveyMetricsFragmentDoc = gql`
    fragment surveyMetrics on SurveyMetrics {
  responses {
    dailyAverageCount
    totalCount
  }
  views {
    ...surveyEngagementMetrics
  }
}
    ${SurveyEngagementMetricsFragmentDoc}`;
export const TransactionFragmentDoc = gql`
    fragment transaction on Transaction {
  uuid
  fraudCheckStatus
  location {
    uuid
    brandSpecificLocationId
    address {
      street1
      city
      countryCode
      state
      zipCode
    }
    siteSystemConfiguration {
      identifier
    }
  }
  authCode
  amount {
    displayPrice
    price
  }
  primaryStatus
  startedAt
  completedAt
  paymentInfo {
    cardType
    cardCircuit
    paymentMethod
  }
  posTransactionNumber
  customer {
    phoneNumber
  }
}
    `;
export const TransactionStateChangeFragmentDoc = gql`
    fragment transactionStateChange on TransactionStateChange {
  updatedAt
  primaryStatus
  secondaryStatus
}
    `;
export const TransactionPaymentEventFragmentDoc = gql`
    fragment transactionPaymentEvent on TransactionPaymentEvent {
  completedAt
  processorResponseCode
  posResponseCode
  reasonDescription
  transactionEventType
}
    `;
export const TransactionDetailsFragmentDoc = gql`
    fragment transactionDetails on Transaction {
  uuid
  location {
    uuid
    brandSpecificLocationId
    address {
      street1
      city
      countryCode
      state
      zipCode
    }
    siteSystemConfiguration {
      identifier
    }
  }
  authCode
  amount {
    displayPrice
    price
  }
  primaryStatus
  createdAt
  startedAt
  completedAt
  items {
    qty
    itemDescription
    amount {
      displayPrice
      price
    }
    refundedAmount {
      displayPrice
      price
    }
    tax {
      displayPrice
      price
    }
    discountDescription
    discountApplied {
      displayPrice
      price
    }
  }
  paymentInfo {
    cardType
    cardCircuit
    paymentMethod
    cardPANPrint
    preAuthAmount
    hostAuthNumber
  }
  stateChanges {
    ...transactionStateChange
  }
  paymentEvents {
    ...transactionPaymentEvent
  }
  tax {
    displayPrice
    price
  }
  fuelReceipt {
    product
    gallons
    priceG
    fuelSale
    tax
    carWashCode
    carWashName
    carWashPrice
  }
}
    ${TransactionStateChangeFragmentDoc}
${TransactionPaymentEventFragmentDoc}`;
export const KountFraudCheckResultFragmentDoc = gql`
    fragment kountFraudCheckResult on KountFraudCheckResult {
  id
  transactionUuid
  sessionId
  status
  autoDecision
  omniScore
  ruleDescriptions {
    ruleId
    description
  }
  reasonCode
  last4
  binRange
  amount
  transactionDate
  triggeredRules {
    ruleId
    description
  }
  creditCardBrand
}
    `;
export const SiteConnectionHistoryFragmentDoc = gql`
    fragment siteConnectionHistory on SiteConnectionHistory {
  connectedAt
  connectionDurationMs
  disconnectedAt
  disconnectionAction
  inboundMessageClass
  messagesReceived
  messagesSent
  uuid
}
    `;
export const CommandCenterAppConfigFragmentDoc = gql`
    fragment commandCenterAppConfig on CommandCenterAppConfig {
  csrLogin {
    enabled
    authMethod
  }
  mobileTransactionFraudCheck {
    enabled
    provider
  }
  memberDossier {
    enabled
    useForSegments
  }
  scanData {
    enabled
  }
  touchpoint {
    enabled
  }
  audienceReportExport {
    enabled
  }
  supportedPaymentTypes {
    title
    type
  }
  orderAheadConfig {
    enabled
    provider
    shouldShowDisplayForOrderAheadToggle
  }
  externalIdentityVerification {
    enabled
    provider
  }
  ach {
    enabled
  }
  subBrands {
    enabled
    list {
      uuid
      name
      createdAt
      codeName
      experienceUrl
    }
  }
  retailerConnectTobaccoPerformance {
    enabled
  }
  retailerConnectRedesignV2 {
    enabled
  }
  triggeredMessages {
    enabled
  }
  externalLoyalty {
    externalTobaccoApiOffer {
      enabled
    }
  }
  storedValue {
    enabled
  }
  driveInsights {
    enabled
    config {
      __typename
      ... on DriveInsightsConfigV1 {
        variant
      }
      ... on DriveInsightsConfigV2 {
        variant
        url
      }
    }
  }
  offerEditor {
    categoryFieldVisible
  }
}
    `;
export const AllowListPhoneNumberFragmentDoc = gql`
    fragment allowListPhoneNumber on AllowListPhoneNumber {
  uuid
  name
  reason
  createdAt
  updatedAt
  phoneNumber
}
    `;
export const DrivePromptFragmentDoc = gql`
    fragment DrivePrompt on DrivePrompt {
  id
  content
  conversationId
  createdAt
  __typename
}
    `;
export const DriveResponseFragmentDoc = gql`
    fragment DriveResponse on DriveResponse {
  id
  content
  conversationId
  createdAt
  promptId
  reaction
  complete
  lastChunkNumber
  __typename
}
    `;
export const DriveConversationFragmentDoc = gql`
    fragment DriveConversation on DriveConversation {
  id
  createdAt
  prompts {
    ...DrivePrompt
  }
  responses {
    ...DriveResponse
  }
  __typename
}
    ${DrivePromptFragmentDoc}
${DriveResponseFragmentDoc}`;
export const MembershipReferralInfoFragmentDoc = gql`
    fragment MembershipReferralInfo on Membership {
  id
  referralUrl
  referralCode
  referrals {
    totalCount
  }
}
    `;
export const PageInfoFragmentDoc = gql`
    fragment pageInfo on PageInfo {
  hasNextPage
  hasPreviousPage
  startCursor
  endCursor
}
    `;
export const ReferralInfoFragmentDoc = gql`
    fragment ReferralInfo on Referral {
  createdAt
  receiver {
    id
    phone
    firstName
    lastName
  }
  receiverAwardGrantedDate
  receiverId
  referralFulfillmentSource
  referralFulfillmentSourceId
  senderAwardGrantedDate
  status
}
    `;
export const ReferralsConnectionFragmentDoc = gql`
    fragment ReferralsConnection on ReferralConnection {
  pageInfo {
    ...pageInfo
  }
  edges {
    node {
      ...ReferralInfo
    }
  }
}
    ${PageInfoFragmentDoc}
${ReferralInfoFragmentDoc}`;
export const MembershipReferralsFragmentDoc = gql`
    fragment MembershipReferrals on Membership {
  id
  referrals(
    filter: $filter
    first: $first
    last: $last
    after: $after
    before: $before
  ) {
    ...ReferralsConnection
  }
}
    ${ReferralsConnectionFragmentDoc}`;
export const MessagingCampaignEngagementChannelsConfigFragmentDoc = gql`
    fragment MessagingCampaignEngagementChannelsConfig on ChannelsConfig {
  smsConfig {
    enabled
    body
  }
  pushNotificationConfig {
    enabled
    template {
      notification {
        title
        body
      }
      data {
        url
      }
    }
  }
}
    `;
export const MessagingCampaignDetailsFragmentDoc = gql`
    fragment MessagingCampaignDetails on AudienceBroadcastMessage {
  uuid
  title
  description
  channelsConfig {
    ...MessagingCampaignEngagementChannelsConfig
  }
  audience {
    uuid
    name
    membershipCount
  }
  audienceUuid
  scheduleAt
  status
}
    ${MessagingCampaignEngagementChannelsConfigFragmentDoc}`;
export const MessagingCampaignsListItemFragmentDoc = gql`
    fragment MessagingCampaignsListItem on AudienceBroadcastMessage {
  uuid
  title
  description
  channelsConfig {
    pushNotificationConfig {
      enabled
    }
    smsConfig {
      enabled
    }
  }
  scheduleAt
  status
}
    `;
export const PointExpirationScheduleFragmentDoc = gql`
    fragment PointExpirationSchedule on PointExpirationSchedule {
  date
  points
}
    `;
export const ReferralMetricCountsTimeSeriesValuesFragmentDoc = gql`
    fragment referralMetricCountsTimeSeriesValues on ReferralMetricCountsTimeSeriesValues {
  date
  uniqueCodesSharedCount
  newMembersReferredCount
}
    `;
export const ReferralProgramStatisticsFragmentDoc = gql`
    fragment referralProgramStatistics on ReferralProgramStatistics {
  uniqueCodesShared
  newMembersReferred
  completedReferrals
  newMembersPerReferral
  receiverAwardGranted
  receiverAwardRedeemed
  receiverPointsGranted
  senderAwardGranted
  senderAwardRedeemed
  senderPointsGranted
  timeSeries {
    ...referralMetricCountsTimeSeriesValues
  }
}
    ${ReferralMetricCountsTimeSeriesValuesFragmentDoc}`;
export const RetailerNetworkLocationCoordinatesFragmentDoc = gql`
    fragment retailerNetworkLocationCoordinates on RetailerNetworkLocationCoordinates {
  locationUuid
  locationName
  geoLocation {
    latitude
    longitude
  }
}
    `;
export const RetailerNetworkPartialFragmentDoc = gql`
    fragment retailerNetworkPartial on RetailerNetwork {
  uuid
  name
  displayName
  customerId
  adminName
  numberOfLocations
}
    `;
export const RetailerNetworkFragmentDoc = gql`
    fragment retailerNetwork on RetailerNetwork {
  uuid
  name
  displayName
  customerId
  adminName
  numberOfLocations
  address {
    uuid
    alias
    street1
    street2
    city
    state
    zipCode
  }
  phoneNumber
  emailAddress
  monthlyPerformanceGoal {
    membersPerStore
    transactionsPerStore
  }
  numberOfLocationGroups
}
    `;
export const RetailerNetworkUserFragmentDoc = gql`
    fragment retailerNetworkUser on RetailerNetworkUser {
  uuid
  userUuid
  name
  emailAddress
  phoneNumber
  role
  createdAt
  openCommerceUser {
    uuid
    email
    name {
      first
      last
    }
    userRole
    phoneNumber
  }
  retailerNetworkLocations {
    userAssociationInheritedFromLocationGroup
  }
}
    `;
export const RetailerNetworkCustomerFragmentDoc = gql`
    fragment retailerNetworkCustomer on RetailerNetworkCustomer {
  uuid
  id
  name
}
    `;
export const RetailerNetworkLocationPosConnectionStatusFragmentDoc = gql`
    fragment retailerNetworkLocationPosConnectionStatus on RetailerNetworkLocationPosConnectionStatus {
  identifier
  hardwareVendor
  mobileEnabled
  mobileConnectedAt
  loyaltyEnabled
  loyaltyConnectedAt
  scanDataSubmittedAt
}
    `;
export const LocationDayScheduleFragmentDoc = gql`
    fragment locationDaySchedule on HoursOfOperation {
  dayOfWeek
  openTime
  closeTime
  genericHoursString
}
    `;
export const RetailerNetworkLocationDataFragmentDoc = gql`
    fragment retailerNetworkLocationData on Location {
  uuid
  name
  customerName
  customerId
  brand {
    uuid
    name
  }
  brandingDetails {
    primaryColor
    secondaryColor
  }
  address {
    ...locationAddress
  }
  phoneNumbers {
    phoneNumber
    phoneType
  }
  siteSystemConfiguration {
    uuid
    identifier
    hardwareVendor
    details {
      siteAddress
      siteName
      isOnline
    }
  }
  hoursOfOperationGroup {
    hours {
      ...locationDaySchedule
    }
  }
  attributes {
    ...locationAttribute
  }
}
    ${LocationAddressFragmentDoc}
${LocationDayScheduleFragmentDoc}
${LocationAttributeFragmentDoc}`;
export const RetailerNetworkLocationFragmentDoc = gql`
    fragment retailerNetworkLocation on RetailerNetworkLocation {
  uuid
  retailerNetworkUuid
  userAssociationInheritedFromLocationGroup
  isOnline
  location {
    ...retailerNetworkLocationData
  }
}
    ${RetailerNetworkLocationDataFragmentDoc}`;
export const RetailerNetworkLocationFuelPricesFragmentDoc = gql`
    fragment retailerNetworkLocationFuelPrices on Location {
  fuelGradePrices {
    description
    unitPrice {
      displayCashPrice
      displayCreditPrice
    }
  }
}
    `;
export const RetailerNetworkLocationDetailsFragmentDoc = gql`
    fragment retailerNetworkLocationDetails on RetailerNetworkLocation {
  ...retailerNetworkLocation
  location {
    ...retailerNetworkLocationFuelPrices
  }
}
    ${RetailerNetworkLocationFragmentDoc}
${RetailerNetworkLocationFuelPricesFragmentDoc}`;
export const RetailerNetworkLocationGroupFragmentDoc = gql`
    fragment retailerNetworkLocationGroup on RetailerNetworkLocationGroup {
  uuid
  name
  countOfLocations
}
    `;
export const RetailerNetworkLocationWithPerformanceExcerptFragmentDoc = gql`
    fragment retailerNetworkLocationWithPerformanceExcerpt on RetailerNetworkLocationWithPerformanceExcerpt {
  locationUuid
  siteId
  name
  isSpecificGoal
  newMembers {
    goal
    progress
  }
  transactions {
    goal
    progress
  }
}
    `;
export const GoalProgressChartDataFragmentDoc = gql`
    fragment goalProgressChartData on GoalProgressChartData {
  timestamp
  value
}
    `;
export const GoalProgressFragmentDoc = gql`
    fragment goalProgress on GoalProgress {
  goal
  progress
}
    `;
export const PerTransactionBreakdownFragmentDoc = gql`
    fragment perTransactionBreakdown on PerTransactionBreakdown {
  total
  perTransactionAverage
}
    `;
export const RetailerNetworkPerformanceFragmentDoc = gql`
    fragment retailerNetworkPerformance on RetailerNetworkPerformance {
  newMembers {
    chartData {
      ...goalProgressChartData
    }
    goalProgress {
      ...goalProgress
    }
    perStoreAverage
  }
  homeStoreMembers
  loyaltyTransactions {
    chartData {
      ...goalProgressChartData
    }
    goalProgress {
      ...goalProgress
    }
    perStoreAverage
  }
  loyaltyTransactionsBreakdown {
    fuelAmount {
      ...perTransactionBreakdown
    }
    fuelVolume {
      ...perTransactionBreakdown
    }
    merchandise {
      ...perTransactionBreakdown
    }
  }
}
    ${GoalProgressChartDataFragmentDoc}
${GoalProgressFragmentDoc}
${PerTransactionBreakdownFragmentDoc}`;
export const TimeSeriesMetricFragmentDoc = gql`
    fragment timeSeriesMetric on TimeSeriesMetric {
  date
  value
}
    `;
export const RetailerNetworkLocationDowntimeMetricsOverviewFragmentDoc = gql`
    fragment retailerNetworkLocationDowntimeMetricsOverview on RetailerNetworkLocationDowntimeMetricsOverview {
  numberOfStores
  numberOfConnectedStores
  disconnectedStoresTimeSeriesOfLast30Days {
    ...timeSeriesMetric
  }
}
    ${TimeSeriesMetricFragmentDoc}`;
export const RetailerNetworkLocationGroupOnlineStatusFragmentDoc = gql`
    fragment retailerNetworkLocationGroupOnlineStatus on RetailerNetworkLocationDowntimeMetricsOverview {
  numberOfStores
  numberOfConnectedStores
}
    `;
export const RetailerNetworkTransactionMetricsOverviewDataFragmentDoc = gql`
    fragment retailerNetworkTransactionMetricsOverviewData on RetailerNetworkTransactionMetricsOverviewData {
  numberOfLoyaltyTransactionsLast7Days
  numberOfLoyaltyTransactionsLast30Days
  numberOfLoyaltyTransactionsToday
  numberOfLoyaltyTransactionsYesterday
}
    `;
export const RetailerNetworkTransactionMetricsOverviewFragmentDoc = gql`
    fragment retailerNetworkTransactionMetricsOverview on RetailerNetworkTransactionMetricsOverview {
  actualPerformance {
    ...retailerNetworkTransactionMetricsOverviewData
  }
  prevPerformance {
    ...retailerNetworkTransactionMetricsOverviewData
  }
  loyaltyTransactionsTimeSeries {
    ...timeSeriesMetric
  }
}
    ${RetailerNetworkTransactionMetricsOverviewDataFragmentDoc}
${TimeSeriesMetricFragmentDoc}`;
export const ReimbursementsFragmentDoc = gql`
    fragment Reimbursements on Reimbursements {
  multiUnit
  loyalty
}
    `;
export const ScanDataSubmissionFragmentDoc = gql`
    fragment ScanDataSubmission on ScanDataSubmission {
  type
  status
  totalLoyaltyTransactions
  totalMultiUnitTransactions
  estimatedReimbursements {
    ...Reimbursements
  }
  previousEstimatedReimbursements {
    ...Reimbursements
  }
}
    ${ReimbursementsFragmentDoc}`;
export const RetailerNetworkScanDataSubmissionsFragmentDoc = gql`
    fragment RetailerNetworkScanDataSubmissions on RetailerNetworkScanDataWeeklySubmission {
  submittedAt
  status
  totalSitesSubmitted
  totalMultiUnitTransactions
  totalLoyaltyTransactions
  submissions {
    ...ScanDataSubmission
  }
  estimatedReimbursements {
    ...Reimbursements
  }
  previousEstimatedReimbursements {
    ...Reimbursements
  }
}
    ${ScanDataSubmissionFragmentDoc}
${ReimbursementsFragmentDoc}`;
export const RetailerNetworkScanDataLatestSubmissionsFragmentDoc = gql`
    fragment RetailerNetworkScanDataLatestSubmissions on RetailerNetworkScanDataWeeklySubmission {
  submittedAt
  status
  totalSitesSubmitted
  totalMultiUnitTransactions
  totalLoyaltyTransactions
  estimatedReimbursements {
    ...Reimbursements
  }
  previousEstimatedReimbursements {
    ...Reimbursements
  }
}
    ${ReimbursementsFragmentDoc}`;
export const ReimbursementsTimeSeriesDataPointFragmentDoc = gql`
    fragment ReimbursementsTimeSeriesDataPoint on ReimbursementsTimeSeriesDataPoint {
  date
  value {
    ...Reimbursements
  }
}
    ${ReimbursementsFragmentDoc}`;
export const RetailerNetworkScanDataTobaccoSubmissionsOverviewFragmentDoc = gql`
    fragment RetailerNetworkScanDataTobaccoSubmissionsOverview on RetailerNetworkScanDataTobaccoSubmissionsOverview {
  estimatedReimbursements {
    ...Reimbursements
  }
  previousEstimatedReimbursements {
    ...Reimbursements
  }
  totalSites
  totalSitesSubmitted
  estimatedReimbursementsTimeSeries {
    ...ReimbursementsTimeSeriesDataPoint
  }
}
    ${ReimbursementsFragmentDoc}
${ReimbursementsTimeSeriesDataPointFragmentDoc}`;
export const RetailerNetworkScanDataTobaccoSiteSubmissionsFragmentDoc = gql`
    fragment RetailerNetworkScanDataTobaccoSiteSubmissions on RetailerNetworkScanDataTobaccoSubmission {
  siteId
  siteName
  submittedAt
  totalMultiUnitTransactions
  previousTotalMultiUnitTransactions
  totalLoyaltyTransactions
  previousTotalLoyaltyTransactions
  estimatedReimbursements {
    ...Reimbursements
  }
  submissions {
    type
    status
  }
}
    ${ReimbursementsFragmentDoc}`;
export const RetailerNetworkLoyaltyMetricsByPeriodFragmentDoc = gql`
    fragment retailerNetworkLoyaltyMetricsByPeriod on RetailerNetworkLoyaltyMetricsByPeriod {
  avgFuelSalesPerTransaction
  avgSavingPerTransaction
  avgUnitsSalesPerStore
  avgUnitsSold
  avgValuePerTransaction
  numberOfTransactions
  offerEngagementRate
  totalFuelSales
  totalUnitsSales
  unitsSold
}
    `;
export const RetailerNetworkLoyaltyMetricsOverviewFragmentDoc = gql`
    fragment retailerNetworkLoyaltyMetricsOverview on RetailerNetworkLoyaltyMetricsOverview {
  actualPeriodPerformance {
    ...retailerNetworkLoyaltyMetricsByPeriod
  }
  prevPeriodPerformance {
    ...retailerNetworkLoyaltyMetricsByPeriod
  }
  loyaltyTransactionsTimeSeries {
    ...timeSeriesMetric
  }
}
    ${RetailerNetworkLoyaltyMetricsByPeriodFragmentDoc}
${TimeSeriesMetricFragmentDoc}`;
export const RetailerNetworkLocationOfferMetricsOverviewFragmentDoc = gql`
    fragment retailerNetworkLocationOfferMetricsOverview on RetailerNetworkOfferMetricsOverviewNode {
  uuid
  offerUuid
  offerName
  redemptions
  prevPeriodRedemptions
  averageRedemptionsPerStore
}
    `;
export const RetailerNetworkTobaccoProgramTransactionMetricFragmentDoc = gql`
    fragment RetailerNetworkTobaccoProgramTransactionMetric on RetailerNetworkTobaccoProgramTransactionMetric {
  totalTransactions
  avgCustomerSavings
  estimatedReimbursements
  basketSize
}
    `;
export const RetailerNetworkTobaccoProgramPerformanceFragmentDoc = gql`
    fragment RetailerNetworkTobaccoProgramPerformance on RetailerNetworkTobaccoProgramPerformance {
  totalTransactions
  memberMetrics {
    totalMembers
    totalNewMembers
    totalActiveMembers
    retentionRate
  }
  loyaltyMetrics {
    ...RetailerNetworkTobaccoProgramTransactionMetric
  }
  multiUnitMetrics {
    ...RetailerNetworkTobaccoProgramTransactionMetric
  }
}
    ${RetailerNetworkTobaccoProgramTransactionMetricFragmentDoc}`;
export const RetailerNetworkTobaccoProgramSiteMetricFragmentDoc = gql`
    fragment RetailerNetworkTobaccoProgramSiteMetric on RetailerNetworkTobaccoProgramSiteMetric {
  rank
  siteId
  siteAddress
  siteName
  value
  previousValue
}
    `;
export const CpgManufacturerProgramFragmentDoc = gql`
    fragment CPGManufacturerProgram on CPGManufacturerProgram {
  id
  manufacturer
  name
}
    `;
export const RetailerNetworkTobaccoManufacturerOfferPerformanceFragmentDoc = gql`
    fragment RetailerNetworkTobaccoManufacturerOfferPerformance on RetailerNetworkTobaccoManufacturerOfferPerformance {
  offerName
  redemptions
  totalStores
  estimatedReimbursements {
    ...Reimbursements
  }
  previousEstimatedReimbursements {
    ...Reimbursements
  }
}
    ${ReimbursementsFragmentDoc}`;
export const CustomerScanDataOverviewFragmentDoc = gql`
    fragment CustomerScanDataOverview on CustomerScanDataOverview {
  cpgSubmissionStatus {
    cpg
    enabled
  }
  lastSubmissionDate
}
    `;
export const TimeSeriesDataPointFragmentDoc = gql`
    fragment TimeSeriesDataPoint on TimeSeriesDataPoint {
  date
  value
}
    `;
export const EstimatedReimbursementsFragmentDoc = gql`
    fragment EstimatedReimbursements on EstimatedReimbursements {
  multipackTotal
  loyaltyTotal
}
    `;
export const ScanDataSubmissionHealthMetricsFragmentDoc = gql`
    fragment ScanDataSubmissionHealthMetrics on ScanDataSubmissionHealthMetrics {
  totalStores {
    ...TimeSeriesDataPoint
  }
  missingStores {
    ...TimeSeriesDataPoint
  }
  reportLines {
    ...TimeSeriesDataPoint
  }
  weeklyReimbursementsTrends {
    ...ReimbursementsTimeSeriesDataPoint
  }
  estimatedReimbursements {
    ...EstimatedReimbursements
  }
  submissionDate
}
    ${TimeSeriesDataPointFragmentDoc}
${ReimbursementsTimeSeriesDataPointFragmentDoc}
${EstimatedReimbursementsFragmentDoc}`;
export const ScanDataSftpCredentialsOverviewFragmentDoc = gql`
    fragment scanDataSftpCredentialsOverview on ScanDataSftpCredentialsOverview {
  totalAltria
  totalMSA
  totalRJR
}
    `;
export const ScanDataWeekEndingPerformanceFragmentDoc = gql`
    fragment ScanDataWeekEndingPerformance on ScanDataWeekEndingPerformance {
  storesWithTransactions
  missingStores
  reportedLines
}
    `;
export const ScanDataWeekEndingOverviewFragmentDoc = gql`
    fragment ScanDataWeekEndingOverview on ScanDataWeekEndingOverview {
  weekEndPerformance {
    ...ScanDataWeekEndingPerformance
  }
  pastWeekEndPerformance {
    ...ScanDataWeekEndingPerformance
  }
  fileStatus
  isResubmitted
  lastTransactionLogPulledAt
}
    ${ScanDataWeekEndingPerformanceFragmentDoc}`;
export const ScanDataSubmissionGroupSubmissionDetailsFragmentDoc = gql`
    fragment ScanDataSubmissionGroupSubmissionDetails on ScanDataSubmissionGroupSubmissionDetails {
  actionsAvailable
  fileStatus
  isResubmitted
  name
  storesSubmittedCount
  totalStoresCount
  type
}
    `;
export const ScanDataSubmissionsFragmentDoc = gql`
    fragment ScanDataSubmissions on ScanDataSubmissions {
  estimatedReimbursements
  type
  fileStatus
  submissionDate
  submissionGroupsCount
  submittedSubmissionGroupsCount
  transactionsReportedCount
  transactionsReportedChangePercent
  previousTransactionsReportedCount
  submissionGroupsDetails {
    ...ScanDataSubmissionGroupSubmissionDetails
  }
}
    ${ScanDataSubmissionGroupSubmissionDetailsFragmentDoc}`;
export const ScanDataMetricsTimeSeriesFragmentDoc = gql`
    fragment ScanDataMetricsTimeSeries on ScanDataMetricsTimeSeries {
  storesSubmitted {
    ...TimeSeriesDataPoint
  }
  missingStores {
    ...TimeSeriesDataPoint
  }
  transactionsReported {
    ...TimeSeriesDataPoint
  }
  reimbursements {
    ...TimeSeriesDataPoint
  }
  submissionDate
}
    ${TimeSeriesDataPointFragmentDoc}`;
export const ScanDataStoreLevelDetailsFragmentDoc = gql`
    fragment ScanDataStoreLevelDetails on ScanDataStoreLevelDetails {
  siteID
  siteName
  altriaRCN
  altriaSubmitterID
  rjrAccountNumber
  rjrSubmitterID
  msaSubmitterID
}
    `;
export const ScanDataSubmittedTransactionsStoreLevelDetailsFragmentDoc = gql`
    fragment ScanDataSubmittedTransactionsStoreLevelDetails on ScanDataSubmittedTransactionsStoreLevelDetails {
  ...ScanDataStoreLevelDetails
}
    ${ScanDataStoreLevelDetailsFragmentDoc}`;
export const ScanDataMissingStoreStoreLevelDetailsFragmentDoc = gql`
    fragment ScanDataMissingStoreStoreLevelDetails on ScanDataMissingStoreStoreLevelDetails {
  ...ScanDataStoreLevelDetails
}
    ${ScanDataStoreLevelDetailsFragmentDoc}`;
export const ScanDataReimbursementsStoreLevelDetailsFragmentDoc = gql`
    fragment ScanDataReimbursementsStoreLevelDetails on ScanDataReimbursementsStoreLevelDetails {
  ...ScanDataStoreLevelDetails
  estimatedReimbursements {
    ...EstimatedReimbursements
  }
}
    ${ScanDataStoreLevelDetailsFragmentDoc}
${EstimatedReimbursementsFragmentDoc}`;
export const ScanDataReportedTransactionsStoreLevelDetailsFragmentDoc = gql`
    fragment ScanDataReportedTransactionsStoreLevelDetails on ScanDataReportedTransactionsStoreLevelDetails {
  ...ScanDataStoreLevelDetails
  reportedTransactions
}
    ${ScanDataStoreLevelDetailsFragmentDoc}`;
export const ScanDataSftpCredentialFragmentDoc = gql`
    fragment ScanDataSftpCredential on ScanDataSftpCredential {
  cpg
  credentialStatus
  host
  name
  password
  port
  submissionStatus
  submitterID
  username
  uuid
}
    `;
export const ScanDataSftpCredentialsWithStoreDetailsFragmentDoc = gql`
    fragment ScanDataSftpCredentialsWithStoreDetails on ScanDataSftpCredentialsWithStoreDetails {
  id
  accountIdentifier
  username
  submitterID
  host
  cpg
  locations {
    uuid
    accountIdentifier
    siteId
    siteName
    siteAddress
    sitePhoneNumber
  }
}
    `;
export const ScanDataMissingStoresDetailsFragmentDoc = gql`
    fragment ScanDataMissingStoresDetails on ScanDataMissingStoresDetails {
  siteID
  siteName
  siteAddress
  phoneNumber
}
    `;
export const SubmissionGroupLocationFragmentDoc = gql`
    fragment SubmissionGroupLocation on Location {
  uuid
  altriaMan
  altriaRcn
  rjrAccountNumber
  address {
    street1
    city
    state
    zipCode
    alias
  }
  siteSystemConfiguration {
    identifier
    details {
      siteName
    }
  }
  phoneNumbers {
    phoneNumber
  }
}
    `;
export const SegmentUploadedFileFragmentDoc = gql`
    fragment segmentUploadedFile on SegmentUploadFile {
  name
  status
  uuid
  mode
  createdAt
}
    `;
export const DiscountingOfferFragmentDoc = gql`
    fragment discountingOffer on Offer {
  id
  expireAt
}
    `;
export const StoredValueProgramFragmentDoc = gql`
    fragment storedValueProgram on StoredValueProgram {
  id
  chainId
  programName
  pointsPerConversion
  moneyPerConversion
  minPointsPerConversion
  maxPointsPerConversion
  expirationDays
  discountingOffer {
    ...discountingOffer
  }
}
    ${DiscountingOfferFragmentDoc}`;
export const StoredValueExpirationScheduleFragmentDoc = gql`
    fragment StoredValueExpirationSchedule on StoredValueExpirationSchedule {
  expirationDate
  storedValue
}
    `;
export const KioskAdSetPartialFragmentDoc = gql`
    fragment KioskAdSetPartial on KioskAdSet {
  id
  name
  description
  status
  offerId
  kioskIds
  asset {
    imageSet {
      square
    }
  }
  createdAt
  updatedAt
}
    `;
export const KioskImageSetFragmentDoc = gql`
    fragment KioskImageSet on KioskImageSet {
  landscape
  square
  portrait
}
    `;
export const KioskAssetFragmentDoc = gql`
    fragment KioskAsset on KioskAsset {
  id
  name
  description
  imageSet {
    ...KioskImageSet
  }
  createdAt
  updatedAt
}
    ${KioskImageSetFragmentDoc}`;
export const KioskFragmentDoc = gql`
    fragment Kiosk on Kiosk {
  id
  externalDisplayId
  locationId
  location {
    uuid
    name
    address {
      ...locationAddress
    }
    phoneNumbers {
      phoneNumber
      phoneType
    }
  }
  createdAt
  updatedAt
}
    ${LocationAddressFragmentDoc}`;
export const KioskAdScheduleFragmentDoc = gql`
    fragment KioskAdSchedule on KioskAdSchedule {
  days
  startTime
  endTime
}
    `;
export const KioskAdSetFragmentDoc = gql`
    fragment KioskAdSet on KioskAdSet {
  id
  name
  description
  status
  offerId
  kioskIds
  asset {
    ...KioskAsset
  }
  kiosks {
    ...Kiosk
  }
  schedules {
    ...KioskAdSchedule
  }
  createdAt
  updatedAt
}
    ${KioskAssetFragmentDoc}
${KioskFragmentDoc}
${KioskAdScheduleFragmentDoc}`;
export const KioskDefaultScreenFragmentDoc = gql`
    fragment KioskDefaultScreen on KioskDefaultScreen {
  id
  name
  description
  imageSet {
    ...KioskImageSet
  }
  createdAt
  updatedAt
}
    ${KioskImageSetFragmentDoc}`;
export const TriggeredMessageViewChannelsConfigFragmentDoc = gql`
    fragment TriggeredMessageViewChannelsConfig on ChannelsConfig {
  smsConfig {
    enabled
    body
  }
  pushNotificationConfig {
    enabled
    template {
      notification {
        title
        body
      }
      data {
        url
      }
    }
  }
}
    `;
export const TriggeredMessageViewFragmentDoc = gql`
    fragment TriggeredMessageView on TriggeredMessage {
  uuid
  subBrandUuid
  description
  messageIntent
  channelsConfig {
    ...TriggeredMessageViewChannelsConfig
  }
  status
}
    ${TriggeredMessageViewChannelsConfigFragmentDoc}`;
export const TriggeredMessageListItemFragmentDoc = gql`
    fragment TriggeredMessageListItem on TriggeredMessage {
  uuid
  subBrandUuid
  description
  channelsConfig {
    pushNotificationConfig {
      enabled
    }
    smsConfig {
      enabled
    }
  }
  status
}
    `;
export const UpdateLocationIssueDocument = gql`
    mutation updateLocationIssue($input: UpdateSiteIssueInput!) {
  updateLocationIssue: updateSiteIssue(input: $input) {
    ...locationIssue
  }
}
    ${LocationIssueFragmentDoc}`;
export type UpdateLocationIssueMutationFn = Apollo.MutationFunction<UpdateLocationIssueMutation, UpdateLocationIssueMutationVariables>;

/**
 * __useUpdateLocationIssueMutation__
 *
 * To run a mutation, you first call `useUpdateLocationIssueMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateLocationIssueMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateLocationIssueMutation, { data, loading, error }] = useUpdateLocationIssueMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateLocationIssueMutation(baseOptions?: Apollo.MutationHookOptions<UpdateLocationIssueMutation, UpdateLocationIssueMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateLocationIssueMutation, UpdateLocationIssueMutationVariables>(UpdateLocationIssueDocument, options);
      }
export type UpdateLocationIssueMutationHookResult = ReturnType<typeof useUpdateLocationIssueMutation>;
export type UpdateLocationIssueMutationResult = Apollo.MutationResult<UpdateLocationIssueMutation>;
export type UpdateLocationIssueMutationOptions = Apollo.BaseMutationOptions<UpdateLocationIssueMutation, UpdateLocationIssueMutationVariables>;
export const DeleteLocationIssueDocument = gql`
    mutation deleteLocationIssue($input: DeleteSiteIssueInput!) {
  deleteLocationIssue: deleteSiteIssue(input: $input)
}
    `;
export type DeleteLocationIssueMutationFn = Apollo.MutationFunction<DeleteLocationIssueMutation, DeleteLocationIssueMutationVariables>;

/**
 * __useDeleteLocationIssueMutation__
 *
 * To run a mutation, you first call `useDeleteLocationIssueMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteLocationIssueMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteLocationIssueMutation, { data, loading, error }] = useDeleteLocationIssueMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDeleteLocationIssueMutation(baseOptions?: Apollo.MutationHookOptions<DeleteLocationIssueMutation, DeleteLocationIssueMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteLocationIssueMutation, DeleteLocationIssueMutationVariables>(DeleteLocationIssueDocument, options);
      }
export type DeleteLocationIssueMutationHookResult = ReturnType<typeof useDeleteLocationIssueMutation>;
export type DeleteLocationIssueMutationResult = Apollo.MutationResult<DeleteLocationIssueMutation>;
export type DeleteLocationIssueMutationOptions = Apollo.BaseMutationOptions<DeleteLocationIssueMutation, DeleteLocationIssueMutationVariables>;
export const LocationIssuesDocument = gql`
    query locationIssues($filter: SiteIssueFilter!) {
  locationIssues: siteIssues(filter: $filter) {
    ...locationIssue
  }
}
    ${LocationIssueFragmentDoc}`;

/**
 * __useLocationIssuesQuery__
 *
 * To run a query within a React component, call `useLocationIssuesQuery` and pass it any options that fit your needs.
 * When your component renders, `useLocationIssuesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useLocationIssuesQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useLocationIssuesQuery(baseOptions: Apollo.QueryHookOptions<LocationIssuesQuery, LocationIssuesQueryVariables> & ({ variables: LocationIssuesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<LocationIssuesQuery, LocationIssuesQueryVariables>(LocationIssuesDocument, options);
      }
export function useLocationIssuesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<LocationIssuesQuery, LocationIssuesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<LocationIssuesQuery, LocationIssuesQueryVariables>(LocationIssuesDocument, options);
        }
export function useLocationIssuesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<LocationIssuesQuery, LocationIssuesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<LocationIssuesQuery, LocationIssuesQueryVariables>(LocationIssuesDocument, options);
        }
export type LocationIssuesQueryHookResult = ReturnType<typeof useLocationIssuesQuery>;
export type LocationIssuesLazyQueryHookResult = ReturnType<typeof useLocationIssuesLazyQuery>;
export type LocationIssuesSuspenseQueryHookResult = ReturnType<typeof useLocationIssuesSuspenseQuery>;
export type LocationIssuesQueryResult = Apollo.QueryResult<LocationIssuesQuery, LocationIssuesQueryVariables>;
export const ActivateTransactionPointTransactionsDocument = gql`
    query activateTransactionPointTransactions($filter: ActivateTransactionFilter) {
  activateTransactions(first: 1, filter: $filter) {
    edges {
      node {
        id
        pointTransactions {
          ...pointChange
        }
      }
    }
  }
}
    ${PointChangeFragmentDoc}`;

/**
 * __useActivateTransactionPointTransactionsQuery__
 *
 * To run a query within a React component, call `useActivateTransactionPointTransactionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useActivateTransactionPointTransactionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useActivateTransactionPointTransactionsQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useActivateTransactionPointTransactionsQuery(baseOptions?: Apollo.QueryHookOptions<ActivateTransactionPointTransactionsQuery, ActivateTransactionPointTransactionsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ActivateTransactionPointTransactionsQuery, ActivateTransactionPointTransactionsQueryVariables>(ActivateTransactionPointTransactionsDocument, options);
      }
export function useActivateTransactionPointTransactionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ActivateTransactionPointTransactionsQuery, ActivateTransactionPointTransactionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ActivateTransactionPointTransactionsQuery, ActivateTransactionPointTransactionsQueryVariables>(ActivateTransactionPointTransactionsDocument, options);
        }
export function useActivateTransactionPointTransactionsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ActivateTransactionPointTransactionsQuery, ActivateTransactionPointTransactionsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ActivateTransactionPointTransactionsQuery, ActivateTransactionPointTransactionsQueryVariables>(ActivateTransactionPointTransactionsDocument, options);
        }
export type ActivateTransactionPointTransactionsQueryHookResult = ReturnType<typeof useActivateTransactionPointTransactionsQuery>;
export type ActivateTransactionPointTransactionsLazyQueryHookResult = ReturnType<typeof useActivateTransactionPointTransactionsLazyQuery>;
export type ActivateTransactionPointTransactionsSuspenseQueryHookResult = ReturnType<typeof useActivateTransactionPointTransactionsSuspenseQuery>;
export type ActivateTransactionPointTransactionsQueryResult = Apollo.QueryResult<ActivateTransactionPointTransactionsQuery, ActivateTransactionPointTransactionsQueryVariables>;
export const ActivateTransactionDocument = gql`
    query activateTransaction($filter: ActivateTransactionFilter) {
  activateTransactions(first: 1, filter: $filter) {
    edges {
      cursor
      node {
        ...activateTransaction
      }
    }
  }
}
    ${ActivateTransactionFragmentDoc}`;

/**
 * __useActivateTransactionQuery__
 *
 * To run a query within a React component, call `useActivateTransactionQuery` and pass it any options that fit your needs.
 * When your component renders, `useActivateTransactionQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useActivateTransactionQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useActivateTransactionQuery(baseOptions?: Apollo.QueryHookOptions<ActivateTransactionQuery, ActivateTransactionQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ActivateTransactionQuery, ActivateTransactionQueryVariables>(ActivateTransactionDocument, options);
      }
export function useActivateTransactionLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ActivateTransactionQuery, ActivateTransactionQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ActivateTransactionQuery, ActivateTransactionQueryVariables>(ActivateTransactionDocument, options);
        }
export function useActivateTransactionSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ActivateTransactionQuery, ActivateTransactionQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ActivateTransactionQuery, ActivateTransactionQueryVariables>(ActivateTransactionDocument, options);
        }
export type ActivateTransactionQueryHookResult = ReturnType<typeof useActivateTransactionQuery>;
export type ActivateTransactionLazyQueryHookResult = ReturnType<typeof useActivateTransactionLazyQuery>;
export type ActivateTransactionSuspenseQueryHookResult = ReturnType<typeof useActivateTransactionSuspenseQuery>;
export type ActivateTransactionQueryResult = Apollo.QueryResult<ActivateTransactionQuery, ActivateTransactionQueryVariables>;
export const AudienceCreateDocument = gql`
    mutation audienceCreate($input: AudienceCreate!) {
  audienceCreate(input: $input) {
    ...audience
  }
}
    ${AudienceFragmentDoc}`;
export type AudienceCreateMutationFn = Apollo.MutationFunction<AudienceCreateMutation, AudienceCreateMutationVariables>;

/**
 * __useAudienceCreateMutation__
 *
 * To run a mutation, you first call `useAudienceCreateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAudienceCreateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [audienceCreateMutation, { data, loading, error }] = useAudienceCreateMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAudienceCreateMutation(baseOptions?: Apollo.MutationHookOptions<AudienceCreateMutation, AudienceCreateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AudienceCreateMutation, AudienceCreateMutationVariables>(AudienceCreateDocument, options);
      }
export type AudienceCreateMutationHookResult = ReturnType<typeof useAudienceCreateMutation>;
export type AudienceCreateMutationResult = Apollo.MutationResult<AudienceCreateMutation>;
export type AudienceCreateMutationOptions = Apollo.BaseMutationOptions<AudienceCreateMutation, AudienceCreateMutationVariables>;
export const AudienceUpdateDocument = gql`
    mutation audienceUpdate($input: AudienceUpdate!) {
  audienceUpdate(input: $input) {
    ...audience
  }
}
    ${AudienceFragmentDoc}`;
export type AudienceUpdateMutationFn = Apollo.MutationFunction<AudienceUpdateMutation, AudienceUpdateMutationVariables>;

/**
 * __useAudienceUpdateMutation__
 *
 * To run a mutation, you first call `useAudienceUpdateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAudienceUpdateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [audienceUpdateMutation, { data, loading, error }] = useAudienceUpdateMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAudienceUpdateMutation(baseOptions?: Apollo.MutationHookOptions<AudienceUpdateMutation, AudienceUpdateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AudienceUpdateMutation, AudienceUpdateMutationVariables>(AudienceUpdateDocument, options);
      }
export type AudienceUpdateMutationHookResult = ReturnType<typeof useAudienceUpdateMutation>;
export type AudienceUpdateMutationResult = Apollo.MutationResult<AudienceUpdateMutation>;
export type AudienceUpdateMutationOptions = Apollo.BaseMutationOptions<AudienceUpdateMutation, AudienceUpdateMutationVariables>;
export const AudienceDeleteDocument = gql`
    mutation audienceDelete($uuid: ID!) {
  audienceDelete(uuid: $uuid)
}
    `;
export type AudienceDeleteMutationFn = Apollo.MutationFunction<AudienceDeleteMutation, AudienceDeleteMutationVariables>;

/**
 * __useAudienceDeleteMutation__
 *
 * To run a mutation, you first call `useAudienceDeleteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAudienceDeleteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [audienceDeleteMutation, { data, loading, error }] = useAudienceDeleteMutation({
 *   variables: {
 *      uuid: // value for 'uuid'
 *   },
 * });
 */
export function useAudienceDeleteMutation(baseOptions?: Apollo.MutationHookOptions<AudienceDeleteMutation, AudienceDeleteMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AudienceDeleteMutation, AudienceDeleteMutationVariables>(AudienceDeleteDocument, options);
      }
export type AudienceDeleteMutationHookResult = ReturnType<typeof useAudienceDeleteMutation>;
export type AudienceDeleteMutationResult = Apollo.MutationResult<AudienceDeleteMutation>;
export type AudienceDeleteMutationOptions = Apollo.BaseMutationOptions<AudienceDeleteMutation, AudienceDeleteMutationVariables>;
export const AudienceActivateDocument = gql`
    mutation audienceActivate($uuid: ID!) {
  audienceActivate(uuid: $uuid) {
    ...audience
  }
}
    ${AudienceFragmentDoc}`;
export type AudienceActivateMutationFn = Apollo.MutationFunction<AudienceActivateMutation, AudienceActivateMutationVariables>;

/**
 * __useAudienceActivateMutation__
 *
 * To run a mutation, you first call `useAudienceActivateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAudienceActivateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [audienceActivateMutation, { data, loading, error }] = useAudienceActivateMutation({
 *   variables: {
 *      uuid: // value for 'uuid'
 *   },
 * });
 */
export function useAudienceActivateMutation(baseOptions?: Apollo.MutationHookOptions<AudienceActivateMutation, AudienceActivateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AudienceActivateMutation, AudienceActivateMutationVariables>(AudienceActivateDocument, options);
      }
export type AudienceActivateMutationHookResult = ReturnType<typeof useAudienceActivateMutation>;
export type AudienceActivateMutationResult = Apollo.MutationResult<AudienceActivateMutation>;
export type AudienceActivateMutationOptions = Apollo.BaseMutationOptions<AudienceActivateMutation, AudienceActivateMutationVariables>;
export const ReportAudienceStartGenerationJobDocument = gql`
    mutation reportAudienceStartGenerationJob($input: ReportAudienceStartGenerationJobInput!) {
  reportAudienceStartGenerationJob(input: $input) {
    ...reportGenerationJob
  }
}
    ${ReportGenerationJobFragmentDoc}`;
export type ReportAudienceStartGenerationJobMutationFn = Apollo.MutationFunction<ReportAudienceStartGenerationJobMutation, ReportAudienceStartGenerationJobMutationVariables>;

/**
 * __useReportAudienceStartGenerationJobMutation__
 *
 * To run a mutation, you first call `useReportAudienceStartGenerationJobMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useReportAudienceStartGenerationJobMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [reportAudienceStartGenerationJobMutation, { data, loading, error }] = useReportAudienceStartGenerationJobMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useReportAudienceStartGenerationJobMutation(baseOptions?: Apollo.MutationHookOptions<ReportAudienceStartGenerationJobMutation, ReportAudienceStartGenerationJobMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ReportAudienceStartGenerationJobMutation, ReportAudienceStartGenerationJobMutationVariables>(ReportAudienceStartGenerationJobDocument, options);
      }
export type ReportAudienceStartGenerationJobMutationHookResult = ReturnType<typeof useReportAudienceStartGenerationJobMutation>;
export type ReportAudienceStartGenerationJobMutationResult = Apollo.MutationResult<ReportAudienceStartGenerationJobMutation>;
export type ReportAudienceStartGenerationJobMutationOptions = Apollo.BaseMutationOptions<ReportAudienceStartGenerationJobMutation, ReportAudienceStartGenerationJobMutationVariables>;
export const MarkAudienceForSizeCalculationDocument = gql`
    mutation markAudienceForSizeCalculation($uuid: ID!) {
  markAudienceForCalculation(uuid: $uuid)
}
    `;
export type MarkAudienceForSizeCalculationMutationFn = Apollo.MutationFunction<MarkAudienceForSizeCalculationMutation, MarkAudienceForSizeCalculationMutationVariables>;

/**
 * __useMarkAudienceForSizeCalculationMutation__
 *
 * To run a mutation, you first call `useMarkAudienceForSizeCalculationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useMarkAudienceForSizeCalculationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [markAudienceForSizeCalculationMutation, { data, loading, error }] = useMarkAudienceForSizeCalculationMutation({
 *   variables: {
 *      uuid: // value for 'uuid'
 *   },
 * });
 */
export function useMarkAudienceForSizeCalculationMutation(baseOptions?: Apollo.MutationHookOptions<MarkAudienceForSizeCalculationMutation, MarkAudienceForSizeCalculationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<MarkAudienceForSizeCalculationMutation, MarkAudienceForSizeCalculationMutationVariables>(MarkAudienceForSizeCalculationDocument, options);
      }
export type MarkAudienceForSizeCalculationMutationHookResult = ReturnType<typeof useMarkAudienceForSizeCalculationMutation>;
export type MarkAudienceForSizeCalculationMutationResult = Apollo.MutationResult<MarkAudienceForSizeCalculationMutation>;
export type MarkAudienceForSizeCalculationMutationOptions = Apollo.BaseMutationOptions<MarkAudienceForSizeCalculationMutation, MarkAudienceForSizeCalculationMutationVariables>;
export const AudienceDocument = gql`
    query audience($filter: AudienceFilter) {
  audiences(filter: $filter) {
    edges {
      cursor
      node {
        ...audience
      }
    }
  }
}
    ${AudienceFragmentDoc}`;

/**
 * __useAudienceQuery__
 *
 * To run a query within a React component, call `useAudienceQuery` and pass it any options that fit your needs.
 * When your component renders, `useAudienceQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAudienceQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useAudienceQuery(baseOptions?: Apollo.QueryHookOptions<AudienceQuery, AudienceQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AudienceQuery, AudienceQueryVariables>(AudienceDocument, options);
      }
export function useAudienceLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AudienceQuery, AudienceQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AudienceQuery, AudienceQueryVariables>(AudienceDocument, options);
        }
export function useAudienceSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<AudienceQuery, AudienceQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<AudienceQuery, AudienceQueryVariables>(AudienceDocument, options);
        }
export type AudienceQueryHookResult = ReturnType<typeof useAudienceQuery>;
export type AudienceLazyQueryHookResult = ReturnType<typeof useAudienceLazyQuery>;
export type AudienceSuspenseQueryHookResult = ReturnType<typeof useAudienceSuspenseQuery>;
export type AudienceQueryResult = Apollo.QueryResult<AudienceQuery, AudienceQueryVariables>;
export const AudienceNameByUuidDocument = gql`
    query audienceNameByUuid($uuid: ID!) {
  audiences(filter: {uuidEquals: $uuid}) {
    edges {
      node {
        ...AudienceBasic
      }
    }
  }
}
    ${AudienceBasicFragmentDoc}`;

/**
 * __useAudienceNameByUuidQuery__
 *
 * To run a query within a React component, call `useAudienceNameByUuidQuery` and pass it any options that fit your needs.
 * When your component renders, `useAudienceNameByUuidQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAudienceNameByUuidQuery({
 *   variables: {
 *      uuid: // value for 'uuid'
 *   },
 * });
 */
export function useAudienceNameByUuidQuery(baseOptions: Apollo.QueryHookOptions<AudienceNameByUuidQuery, AudienceNameByUuidQueryVariables> & ({ variables: AudienceNameByUuidQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AudienceNameByUuidQuery, AudienceNameByUuidQueryVariables>(AudienceNameByUuidDocument, options);
      }
export function useAudienceNameByUuidLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AudienceNameByUuidQuery, AudienceNameByUuidQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AudienceNameByUuidQuery, AudienceNameByUuidQueryVariables>(AudienceNameByUuidDocument, options);
        }
export function useAudienceNameByUuidSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<AudienceNameByUuidQuery, AudienceNameByUuidQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<AudienceNameByUuidQuery, AudienceNameByUuidQueryVariables>(AudienceNameByUuidDocument, options);
        }
export type AudienceNameByUuidQueryHookResult = ReturnType<typeof useAudienceNameByUuidQuery>;
export type AudienceNameByUuidLazyQueryHookResult = ReturnType<typeof useAudienceNameByUuidLazyQuery>;
export type AudienceNameByUuidSuspenseQueryHookResult = ReturnType<typeof useAudienceNameByUuidSuspenseQuery>;
export type AudienceNameByUuidQueryResult = Apollo.QueryResult<AudienceNameByUuidQuery, AudienceNameByUuidQueryVariables>;
export const AudiencesDocument = gql`
    query audiences($first: Int, $last: Int, $after: ID, $before: ID, $filter: AudienceFilter) {
  audiences(
    first: $first
    last: $last
    after: $after
    before: $before
    filter: $filter
  ) {
    pageInfo {
      ...pageInfo
    }
    edges {
      cursor
      node {
        ...partialAudience
      }
    }
  }
}
    ${PageInfoFragmentDoc}
${PartialAudienceFragmentDoc}`;

/**
 * __useAudiencesQuery__
 *
 * To run a query within a React component, call `useAudiencesQuery` and pass it any options that fit your needs.
 * When your component renders, `useAudiencesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAudiencesQuery({
 *   variables: {
 *      first: // value for 'first'
 *      last: // value for 'last'
 *      after: // value for 'after'
 *      before: // value for 'before'
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useAudiencesQuery(baseOptions?: Apollo.QueryHookOptions<AudiencesQuery, AudiencesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AudiencesQuery, AudiencesQueryVariables>(AudiencesDocument, options);
      }
export function useAudiencesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AudiencesQuery, AudiencesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AudiencesQuery, AudiencesQueryVariables>(AudiencesDocument, options);
        }
export function useAudiencesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<AudiencesQuery, AudiencesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<AudiencesQuery, AudiencesQueryVariables>(AudiencesDocument, options);
        }
export type AudiencesQueryHookResult = ReturnType<typeof useAudiencesQuery>;
export type AudiencesLazyQueryHookResult = ReturnType<typeof useAudiencesLazyQuery>;
export type AudiencesSuspenseQueryHookResult = ReturnType<typeof useAudiencesSuspenseQuery>;
export type AudiencesQueryResult = Apollo.QueryResult<AudiencesQuery, AudiencesQueryVariables>;
export const AudienceSelectItemsDocument = gql`
    query audienceSelectItems($first: Int, $last: Int, $after: ID, $before: ID, $filter: AudienceFilter) {
  audiences(
    first: $first
    last: $last
    after: $after
    before: $before
    filter: $filter
  ) {
    pageInfo {
      ...pageInfo
    }
    edges {
      cursor
      node {
        ...audienceSelectItem
      }
    }
  }
}
    ${PageInfoFragmentDoc}
${AudienceSelectItemFragmentDoc}`;

/**
 * __useAudienceSelectItemsQuery__
 *
 * To run a query within a React component, call `useAudienceSelectItemsQuery` and pass it any options that fit your needs.
 * When your component renders, `useAudienceSelectItemsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAudienceSelectItemsQuery({
 *   variables: {
 *      first: // value for 'first'
 *      last: // value for 'last'
 *      after: // value for 'after'
 *      before: // value for 'before'
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useAudienceSelectItemsQuery(baseOptions?: Apollo.QueryHookOptions<AudienceSelectItemsQuery, AudienceSelectItemsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AudienceSelectItemsQuery, AudienceSelectItemsQueryVariables>(AudienceSelectItemsDocument, options);
      }
export function useAudienceSelectItemsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AudienceSelectItemsQuery, AudienceSelectItemsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AudienceSelectItemsQuery, AudienceSelectItemsQueryVariables>(AudienceSelectItemsDocument, options);
        }
export function useAudienceSelectItemsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<AudienceSelectItemsQuery, AudienceSelectItemsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<AudienceSelectItemsQuery, AudienceSelectItemsQueryVariables>(AudienceSelectItemsDocument, options);
        }
export type AudienceSelectItemsQueryHookResult = ReturnType<typeof useAudienceSelectItemsQuery>;
export type AudienceSelectItemsLazyQueryHookResult = ReturnType<typeof useAudienceSelectItemsLazyQuery>;
export type AudienceSelectItemsSuspenseQueryHookResult = ReturnType<typeof useAudienceSelectItemsSuspenseQuery>;
export type AudienceSelectItemsQueryResult = Apollo.QueryResult<AudienceSelectItemsQuery, AudienceSelectItemsQueryVariables>;
export const AudienceDailyCountsDocument = gql`
    query audienceDailyCounts($filter: AudienceFilter, $startDate: OCDate!, $endDate: OCDate!) {
  audiences(filter: $filter) {
    edges {
      cursor
      node {
        uuid
        dailyCounts(startDate: $startDate, endDate: $endDate) {
          date
          count
        }
      }
    }
  }
}
    `;

/**
 * __useAudienceDailyCountsQuery__
 *
 * To run a query within a React component, call `useAudienceDailyCountsQuery` and pass it any options that fit your needs.
 * When your component renders, `useAudienceDailyCountsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAudienceDailyCountsQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *      startDate: // value for 'startDate'
 *      endDate: // value for 'endDate'
 *   },
 * });
 */
export function useAudienceDailyCountsQuery(baseOptions: Apollo.QueryHookOptions<AudienceDailyCountsQuery, AudienceDailyCountsQueryVariables> & ({ variables: AudienceDailyCountsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AudienceDailyCountsQuery, AudienceDailyCountsQueryVariables>(AudienceDailyCountsDocument, options);
      }
export function useAudienceDailyCountsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AudienceDailyCountsQuery, AudienceDailyCountsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AudienceDailyCountsQuery, AudienceDailyCountsQueryVariables>(AudienceDailyCountsDocument, options);
        }
export function useAudienceDailyCountsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<AudienceDailyCountsQuery, AudienceDailyCountsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<AudienceDailyCountsQuery, AudienceDailyCountsQueryVariables>(AudienceDailyCountsDocument, options);
        }
export type AudienceDailyCountsQueryHookResult = ReturnType<typeof useAudienceDailyCountsQuery>;
export type AudienceDailyCountsLazyQueryHookResult = ReturnType<typeof useAudienceDailyCountsLazyQuery>;
export type AudienceDailyCountsSuspenseQueryHookResult = ReturnType<typeof useAudienceDailyCountsSuspenseQuery>;
export type AudienceDailyCountsQueryResult = Apollo.QueryResult<AudienceDailyCountsQuery, AudienceDailyCountsQueryVariables>;
export const GetAudienceProductGroupsDocument = gql`
    query getAudienceProductGroups($filter: ProductGroupFilter) {
  productGroups(filter: $filter) {
    edges {
      node {
        ...productGroup
      }
    }
  }
}
    ${ProductGroupFragmentDoc}`;

/**
 * __useGetAudienceProductGroupsQuery__
 *
 * To run a query within a React component, call `useGetAudienceProductGroupsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAudienceProductGroupsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAudienceProductGroupsQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useGetAudienceProductGroupsQuery(baseOptions?: Apollo.QueryHookOptions<GetAudienceProductGroupsQuery, GetAudienceProductGroupsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAudienceProductGroupsQuery, GetAudienceProductGroupsQueryVariables>(GetAudienceProductGroupsDocument, options);
      }
export function useGetAudienceProductGroupsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAudienceProductGroupsQuery, GetAudienceProductGroupsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAudienceProductGroupsQuery, GetAudienceProductGroupsQueryVariables>(GetAudienceProductGroupsDocument, options);
        }
export function useGetAudienceProductGroupsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetAudienceProductGroupsQuery, GetAudienceProductGroupsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetAudienceProductGroupsQuery, GetAudienceProductGroupsQueryVariables>(GetAudienceProductGroupsDocument, options);
        }
export type GetAudienceProductGroupsQueryHookResult = ReturnType<typeof useGetAudienceProductGroupsQuery>;
export type GetAudienceProductGroupsLazyQueryHookResult = ReturnType<typeof useGetAudienceProductGroupsLazyQuery>;
export type GetAudienceProductGroupsSuspenseQueryHookResult = ReturnType<typeof useGetAudienceProductGroupsSuspenseQuery>;
export type GetAudienceProductGroupsQueryResult = Apollo.QueryResult<GetAudienceProductGroupsQuery, GetAudienceProductGroupsQueryVariables>;
export const GetAudienceSegmentsDocument = gql`
    query getAudienceSegments($filter: SegmentFilter) {
  segments(filter: $filter) {
    edges {
      node {
        ...segment
      }
    }
  }
}
    ${SegmentFragmentDoc}`;

/**
 * __useGetAudienceSegmentsQuery__
 *
 * To run a query within a React component, call `useGetAudienceSegmentsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAudienceSegmentsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAudienceSegmentsQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useGetAudienceSegmentsQuery(baseOptions?: Apollo.QueryHookOptions<GetAudienceSegmentsQuery, GetAudienceSegmentsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAudienceSegmentsQuery, GetAudienceSegmentsQueryVariables>(GetAudienceSegmentsDocument, options);
      }
export function useGetAudienceSegmentsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAudienceSegmentsQuery, GetAudienceSegmentsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAudienceSegmentsQuery, GetAudienceSegmentsQueryVariables>(GetAudienceSegmentsDocument, options);
        }
export function useGetAudienceSegmentsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetAudienceSegmentsQuery, GetAudienceSegmentsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetAudienceSegmentsQuery, GetAudienceSegmentsQueryVariables>(GetAudienceSegmentsDocument, options);
        }
export type GetAudienceSegmentsQueryHookResult = ReturnType<typeof useGetAudienceSegmentsQuery>;
export type GetAudienceSegmentsLazyQueryHookResult = ReturnType<typeof useGetAudienceSegmentsLazyQuery>;
export type GetAudienceSegmentsSuspenseQueryHookResult = ReturnType<typeof useGetAudienceSegmentsSuspenseQuery>;
export type GetAudienceSegmentsQueryResult = Apollo.QueryResult<GetAudienceSegmentsQuery, GetAudienceSegmentsQueryVariables>;
export const GetReportFileDownloadLinkDocument = gql`
    query getReportFileDownloadLink($reportUuid: ID!) {
  getReportFileDownloadLink(reportUuid: $reportUuid)
}
    `;

/**
 * __useGetReportFileDownloadLinkQuery__
 *
 * To run a query within a React component, call `useGetReportFileDownloadLinkQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetReportFileDownloadLinkQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetReportFileDownloadLinkQuery({
 *   variables: {
 *      reportUuid: // value for 'reportUuid'
 *   },
 * });
 */
export function useGetReportFileDownloadLinkQuery(baseOptions: Apollo.QueryHookOptions<GetReportFileDownloadLinkQuery, GetReportFileDownloadLinkQueryVariables> & ({ variables: GetReportFileDownloadLinkQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetReportFileDownloadLinkQuery, GetReportFileDownloadLinkQueryVariables>(GetReportFileDownloadLinkDocument, options);
      }
export function useGetReportFileDownloadLinkLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetReportFileDownloadLinkQuery, GetReportFileDownloadLinkQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetReportFileDownloadLinkQuery, GetReportFileDownloadLinkQueryVariables>(GetReportFileDownloadLinkDocument, options);
        }
export function useGetReportFileDownloadLinkSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetReportFileDownloadLinkQuery, GetReportFileDownloadLinkQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetReportFileDownloadLinkQuery, GetReportFileDownloadLinkQueryVariables>(GetReportFileDownloadLinkDocument, options);
        }
export type GetReportFileDownloadLinkQueryHookResult = ReturnType<typeof useGetReportFileDownloadLinkQuery>;
export type GetReportFileDownloadLinkLazyQueryHookResult = ReturnType<typeof useGetReportFileDownloadLinkLazyQuery>;
export type GetReportFileDownloadLinkSuspenseQueryHookResult = ReturnType<typeof useGetReportFileDownloadLinkSuspenseQuery>;
export type GetReportFileDownloadLinkQueryResult = Apollo.QueryResult<GetReportFileDownloadLinkQuery, GetReportFileDownloadLinkQueryVariables>;
export const MagicLinkExchangeRefreshTokenToAuthTokenDocument = gql`
    mutation magicLinkExchangeRefreshTokenToAuthToken($input: AccessTokenByRefreshTokenInput!) {
  magicLinkExchangeRefreshTokenToAuthToken(input: $input) {
    accessToken
    refreshToken
  }
}
    `;
export type MagicLinkExchangeRefreshTokenToAuthTokenMutationFn = Apollo.MutationFunction<MagicLinkExchangeRefreshTokenToAuthTokenMutation, MagicLinkExchangeRefreshTokenToAuthTokenMutationVariables>;

/**
 * __useMagicLinkExchangeRefreshTokenToAuthTokenMutation__
 *
 * To run a mutation, you first call `useMagicLinkExchangeRefreshTokenToAuthTokenMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useMagicLinkExchangeRefreshTokenToAuthTokenMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [magicLinkExchangeRefreshTokenToAuthTokenMutation, { data, loading, error }] = useMagicLinkExchangeRefreshTokenToAuthTokenMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useMagicLinkExchangeRefreshTokenToAuthTokenMutation(baseOptions?: Apollo.MutationHookOptions<MagicLinkExchangeRefreshTokenToAuthTokenMutation, MagicLinkExchangeRefreshTokenToAuthTokenMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<MagicLinkExchangeRefreshTokenToAuthTokenMutation, MagicLinkExchangeRefreshTokenToAuthTokenMutationVariables>(MagicLinkExchangeRefreshTokenToAuthTokenDocument, options);
      }
export type MagicLinkExchangeRefreshTokenToAuthTokenMutationHookResult = ReturnType<typeof useMagicLinkExchangeRefreshTokenToAuthTokenMutation>;
export type MagicLinkExchangeRefreshTokenToAuthTokenMutationResult = Apollo.MutationResult<MagicLinkExchangeRefreshTokenToAuthTokenMutation>;
export type MagicLinkExchangeRefreshTokenToAuthTokenMutationOptions = Apollo.BaseMutationOptions<MagicLinkExchangeRefreshTokenToAuthTokenMutation, MagicLinkExchangeRefreshTokenToAuthTokenMutationVariables>;
export const MagicLinkExchangeSessionIdToAuthTokenDocument = gql`
    mutation magicLinkExchangeSessionIdToAuthToken($input: MagicLinkExchangeSessionIdToAuthTokenInput!) {
  magicLinkExchangeSessionIdToAuthToken(input: $input) {
    tokens {
      accessToken
      refreshToken
    }
  }
}
    `;
export type MagicLinkExchangeSessionIdToAuthTokenMutationFn = Apollo.MutationFunction<MagicLinkExchangeSessionIdToAuthTokenMutation, MagicLinkExchangeSessionIdToAuthTokenMutationVariables>;

/**
 * __useMagicLinkExchangeSessionIdToAuthTokenMutation__
 *
 * To run a mutation, you first call `useMagicLinkExchangeSessionIdToAuthTokenMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useMagicLinkExchangeSessionIdToAuthTokenMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [magicLinkExchangeSessionIdToAuthTokenMutation, { data, loading, error }] = useMagicLinkExchangeSessionIdToAuthTokenMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useMagicLinkExchangeSessionIdToAuthTokenMutation(baseOptions?: Apollo.MutationHookOptions<MagicLinkExchangeSessionIdToAuthTokenMutation, MagicLinkExchangeSessionIdToAuthTokenMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<MagicLinkExchangeSessionIdToAuthTokenMutation, MagicLinkExchangeSessionIdToAuthTokenMutationVariables>(MagicLinkExchangeSessionIdToAuthTokenDocument, options);
      }
export type MagicLinkExchangeSessionIdToAuthTokenMutationHookResult = ReturnType<typeof useMagicLinkExchangeSessionIdToAuthTokenMutation>;
export type MagicLinkExchangeSessionIdToAuthTokenMutationResult = Apollo.MutationResult<MagicLinkExchangeSessionIdToAuthTokenMutation>;
export type MagicLinkExchangeSessionIdToAuthTokenMutationOptions = Apollo.BaseMutationOptions<MagicLinkExchangeSessionIdToAuthTokenMutation, MagicLinkExchangeSessionIdToAuthTokenMutationVariables>;
export const MagicLinkLogoutDocument = gql`
    mutation magicLinkLogout {
  magicLinkLogout
}
    `;
export type MagicLinkLogoutMutationFn = Apollo.MutationFunction<MagicLinkLogoutMutation, MagicLinkLogoutMutationVariables>;

/**
 * __useMagicLinkLogoutMutation__
 *
 * To run a mutation, you first call `useMagicLinkLogoutMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useMagicLinkLogoutMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [magicLinkLogoutMutation, { data, loading, error }] = useMagicLinkLogoutMutation({
 *   variables: {
 *   },
 * });
 */
export function useMagicLinkLogoutMutation(baseOptions?: Apollo.MutationHookOptions<MagicLinkLogoutMutation, MagicLinkLogoutMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<MagicLinkLogoutMutation, MagicLinkLogoutMutationVariables>(MagicLinkLogoutDocument, options);
      }
export type MagicLinkLogoutMutationHookResult = ReturnType<typeof useMagicLinkLogoutMutation>;
export type MagicLinkLogoutMutationResult = Apollo.MutationResult<MagicLinkLogoutMutation>;
export type MagicLinkLogoutMutationOptions = Apollo.BaseMutationOptions<MagicLinkLogoutMutation, MagicLinkLogoutMutationVariables>;
export const RequestMagicLinkDocument = gql`
    mutation requestMagicLink($input: MagicLinkRequestInput!) {
  requestMagicLink(input: $input)
}
    `;
export type RequestMagicLinkMutationFn = Apollo.MutationFunction<RequestMagicLinkMutation, RequestMagicLinkMutationVariables>;

/**
 * __useRequestMagicLinkMutation__
 *
 * To run a mutation, you first call `useRequestMagicLinkMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRequestMagicLinkMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [requestMagicLinkMutation, { data, loading, error }] = useRequestMagicLinkMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useRequestMagicLinkMutation(baseOptions?: Apollo.MutationHookOptions<RequestMagicLinkMutation, RequestMagicLinkMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RequestMagicLinkMutation, RequestMagicLinkMutationVariables>(RequestMagicLinkDocument, options);
      }
export type RequestMagicLinkMutationHookResult = ReturnType<typeof useRequestMagicLinkMutation>;
export type RequestMagicLinkMutationResult = Apollo.MutationResult<RequestMagicLinkMutation>;
export type RequestMagicLinkMutationOptions = Apollo.BaseMutationOptions<RequestMagicLinkMutation, RequestMagicLinkMutationVariables>;
export const AwardsListDocument = gql`
    query awardsList($first: Int, $last: Int, $after: ID, $before: ID, $filter: OfferFilter) {
  offers(
    first: $first
    last: $last
    after: $after
    before: $before
    filter: $filter
  ) {
    pageInfo {
      ...pageInfo
    }
    edges {
      cursor
      node {
        ...awardsListItem
      }
    }
  }
}
    ${PageInfoFragmentDoc}
${AwardsListItemFragmentDoc}`;

/**
 * __useAwardsListQuery__
 *
 * To run a query within a React component, call `useAwardsListQuery` and pass it any options that fit your needs.
 * When your component renders, `useAwardsListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAwardsListQuery({
 *   variables: {
 *      first: // value for 'first'
 *      last: // value for 'last'
 *      after: // value for 'after'
 *      before: // value for 'before'
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useAwardsListQuery(baseOptions?: Apollo.QueryHookOptions<AwardsListQuery, AwardsListQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AwardsListQuery, AwardsListQueryVariables>(AwardsListDocument, options);
      }
export function useAwardsListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AwardsListQuery, AwardsListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AwardsListQuery, AwardsListQueryVariables>(AwardsListDocument, options);
        }
export function useAwardsListSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<AwardsListQuery, AwardsListQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<AwardsListQuery, AwardsListQueryVariables>(AwardsListDocument, options);
        }
export type AwardsListQueryHookResult = ReturnType<typeof useAwardsListQuery>;
export type AwardsListLazyQueryHookResult = ReturnType<typeof useAwardsListLazyQuery>;
export type AwardsListSuspenseQueryHookResult = ReturnType<typeof useAwardsListSuspenseQuery>;
export type AwardsListQueryResult = Apollo.QueryResult<AwardsListQuery, AwardsListQueryVariables>;
export const CampaignCreateDocument = gql`
    mutation campaignCreate($input: CampaignCreateInput!) {
  campaignCreate(input: $input) {
    ...campaign
  }
}
    ${CampaignFragmentDoc}`;
export type CampaignCreateMutationFn = Apollo.MutationFunction<CampaignCreateMutation, CampaignCreateMutationVariables>;

/**
 * __useCampaignCreateMutation__
 *
 * To run a mutation, you first call `useCampaignCreateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCampaignCreateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [campaignCreateMutation, { data, loading, error }] = useCampaignCreateMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCampaignCreateMutation(baseOptions?: Apollo.MutationHookOptions<CampaignCreateMutation, CampaignCreateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CampaignCreateMutation, CampaignCreateMutationVariables>(CampaignCreateDocument, options);
      }
export type CampaignCreateMutationHookResult = ReturnType<typeof useCampaignCreateMutation>;
export type CampaignCreateMutationResult = Apollo.MutationResult<CampaignCreateMutation>;
export type CampaignCreateMutationOptions = Apollo.BaseMutationOptions<CampaignCreateMutation, CampaignCreateMutationVariables>;
export const CampaignUpdateDocument = gql`
    mutation campaignUpdate($input: CampaignUpdateInput!) {
  campaignUpdate(input: $input) {
    ...campaign
  }
}
    ${CampaignFragmentDoc}`;
export type CampaignUpdateMutationFn = Apollo.MutationFunction<CampaignUpdateMutation, CampaignUpdateMutationVariables>;

/**
 * __useCampaignUpdateMutation__
 *
 * To run a mutation, you first call `useCampaignUpdateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCampaignUpdateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [campaignUpdateMutation, { data, loading, error }] = useCampaignUpdateMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCampaignUpdateMutation(baseOptions?: Apollo.MutationHookOptions<CampaignUpdateMutation, CampaignUpdateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CampaignUpdateMutation, CampaignUpdateMutationVariables>(CampaignUpdateDocument, options);
      }
export type CampaignUpdateMutationHookResult = ReturnType<typeof useCampaignUpdateMutation>;
export type CampaignUpdateMutationResult = Apollo.MutationResult<CampaignUpdateMutation>;
export type CampaignUpdateMutationOptions = Apollo.BaseMutationOptions<CampaignUpdateMutation, CampaignUpdateMutationVariables>;
export const CampaignDeleteDocument = gql`
    mutation campaignDelete($uuid: ID!) {
  campaignDelete(uuid: $uuid)
}
    `;
export type CampaignDeleteMutationFn = Apollo.MutationFunction<CampaignDeleteMutation, CampaignDeleteMutationVariables>;

/**
 * __useCampaignDeleteMutation__
 *
 * To run a mutation, you first call `useCampaignDeleteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCampaignDeleteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [campaignDeleteMutation, { data, loading, error }] = useCampaignDeleteMutation({
 *   variables: {
 *      uuid: // value for 'uuid'
 *   },
 * });
 */
export function useCampaignDeleteMutation(baseOptions?: Apollo.MutationHookOptions<CampaignDeleteMutation, CampaignDeleteMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CampaignDeleteMutation, CampaignDeleteMutationVariables>(CampaignDeleteDocument, options);
      }
export type CampaignDeleteMutationHookResult = ReturnType<typeof useCampaignDeleteMutation>;
export type CampaignDeleteMutationResult = Apollo.MutationResult<CampaignDeleteMutation>;
export type CampaignDeleteMutationOptions = Apollo.BaseMutationOptions<CampaignDeleteMutation, CampaignDeleteMutationVariables>;
export const CampaignDocument = gql`
    query campaign($uuid: ID!) {
  campaigns(filter: {uuidEquals: $uuid}) {
    edges {
      cursor
      node {
        ...campaign
      }
    }
  }
}
    ${CampaignFragmentDoc}`;

/**
 * __useCampaignQuery__
 *
 * To run a query within a React component, call `useCampaignQuery` and pass it any options that fit your needs.
 * When your component renders, `useCampaignQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCampaignQuery({
 *   variables: {
 *      uuid: // value for 'uuid'
 *   },
 * });
 */
export function useCampaignQuery(baseOptions: Apollo.QueryHookOptions<CampaignQuery, CampaignQueryVariables> & ({ variables: CampaignQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CampaignQuery, CampaignQueryVariables>(CampaignDocument, options);
      }
export function useCampaignLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CampaignQuery, CampaignQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CampaignQuery, CampaignQueryVariables>(CampaignDocument, options);
        }
export function useCampaignSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<CampaignQuery, CampaignQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<CampaignQuery, CampaignQueryVariables>(CampaignDocument, options);
        }
export type CampaignQueryHookResult = ReturnType<typeof useCampaignQuery>;
export type CampaignLazyQueryHookResult = ReturnType<typeof useCampaignLazyQuery>;
export type CampaignSuspenseQueryHookResult = ReturnType<typeof useCampaignSuspenseQuery>;
export type CampaignQueryResult = Apollo.QueryResult<CampaignQuery, CampaignQueryVariables>;
export const CampaignsDocument = gql`
    query campaigns($first: Int, $last: Int, $after: ID, $before: ID, $filter: CampaignFilter) {
  campaigns(
    first: $first
    last: $last
    after: $after
    before: $before
    filter: $filter
  ) {
    pageInfo {
      ...pageInfo
    }
    edges {
      cursor
      node {
        ...campaign
      }
    }
  }
}
    ${PageInfoFragmentDoc}
${CampaignFragmentDoc}`;

/**
 * __useCampaignsQuery__
 *
 * To run a query within a React component, call `useCampaignsQuery` and pass it any options that fit your needs.
 * When your component renders, `useCampaignsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCampaignsQuery({
 *   variables: {
 *      first: // value for 'first'
 *      last: // value for 'last'
 *      after: // value for 'after'
 *      before: // value for 'before'
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useCampaignsQuery(baseOptions?: Apollo.QueryHookOptions<CampaignsQuery, CampaignsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CampaignsQuery, CampaignsQueryVariables>(CampaignsDocument, options);
      }
export function useCampaignsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CampaignsQuery, CampaignsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CampaignsQuery, CampaignsQueryVariables>(CampaignsDocument, options);
        }
export function useCampaignsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<CampaignsQuery, CampaignsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<CampaignsQuery, CampaignsQueryVariables>(CampaignsDocument, options);
        }
export type CampaignsQueryHookResult = ReturnType<typeof useCampaignsQuery>;
export type CampaignsLazyQueryHookResult = ReturnType<typeof useCampaignsLazyQuery>;
export type CampaignsSuspenseQueryHookResult = ReturnType<typeof useCampaignsSuspenseQuery>;
export type CampaignsQueryResult = Apollo.QueryResult<CampaignsQuery, CampaignsQueryVariables>;
export const CampaignsWithCampaignComponentsDocument = gql`
    query campaignsWithCampaignComponents($first: Int, $last: Int, $after: ID, $before: ID, $campaignFilter: CampaignFilter, $offerFilter: OfferFilter, $skipOffers: Boolean!) {
  campaigns(
    first: $first
    last: $last
    after: $after
    before: $before
    filter: $campaignFilter
  ) {
    pageInfo {
      ...pageInfo
    }
    edges {
      cursor
      node {
        ...campaignWithCampaignComponents
      }
    }
  }
}
    ${PageInfoFragmentDoc}
${CampaignWithCampaignComponentsFragmentDoc}`;

/**
 * __useCampaignsWithCampaignComponentsQuery__
 *
 * To run a query within a React component, call `useCampaignsWithCampaignComponentsQuery` and pass it any options that fit your needs.
 * When your component renders, `useCampaignsWithCampaignComponentsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCampaignsWithCampaignComponentsQuery({
 *   variables: {
 *      first: // value for 'first'
 *      last: // value for 'last'
 *      after: // value for 'after'
 *      before: // value for 'before'
 *      campaignFilter: // value for 'campaignFilter'
 *      offerFilter: // value for 'offerFilter'
 *      skipOffers: // value for 'skipOffers'
 *   },
 * });
 */
export function useCampaignsWithCampaignComponentsQuery(baseOptions: Apollo.QueryHookOptions<CampaignsWithCampaignComponentsQuery, CampaignsWithCampaignComponentsQueryVariables> & ({ variables: CampaignsWithCampaignComponentsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CampaignsWithCampaignComponentsQuery, CampaignsWithCampaignComponentsQueryVariables>(CampaignsWithCampaignComponentsDocument, options);
      }
export function useCampaignsWithCampaignComponentsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CampaignsWithCampaignComponentsQuery, CampaignsWithCampaignComponentsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CampaignsWithCampaignComponentsQuery, CampaignsWithCampaignComponentsQueryVariables>(CampaignsWithCampaignComponentsDocument, options);
        }
export function useCampaignsWithCampaignComponentsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<CampaignsWithCampaignComponentsQuery, CampaignsWithCampaignComponentsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<CampaignsWithCampaignComponentsQuery, CampaignsWithCampaignComponentsQueryVariables>(CampaignsWithCampaignComponentsDocument, options);
        }
export type CampaignsWithCampaignComponentsQueryHookResult = ReturnType<typeof useCampaignsWithCampaignComponentsQuery>;
export type CampaignsWithCampaignComponentsLazyQueryHookResult = ReturnType<typeof useCampaignsWithCampaignComponentsLazyQuery>;
export type CampaignsWithCampaignComponentsSuspenseQueryHookResult = ReturnType<typeof useCampaignsWithCampaignComponentsSuspenseQuery>;
export type CampaignsWithCampaignComponentsQueryResult = Apollo.QueryResult<CampaignsWithCampaignComponentsQuery, CampaignsWithCampaignComponentsQueryVariables>;
export const CampaignComponentsDocument = gql`
    query campaignComponents($first: Int, $last: Int, $after: ID, $before: ID, $filter: OfferFilter) {
  offers(
    first: $first
    last: $last
    after: $after
    before: $before
    filter: $filter
  ) {
    pageInfo {
      ...pageInfo
    }
    edges {
      cursor
      node {
        ...campaignComponent
      }
    }
  }
}
    ${PageInfoFragmentDoc}
${CampaignComponentFragmentDoc}`;

/**
 * __useCampaignComponentsQuery__
 *
 * To run a query within a React component, call `useCampaignComponentsQuery` and pass it any options that fit your needs.
 * When your component renders, `useCampaignComponentsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCampaignComponentsQuery({
 *   variables: {
 *      first: // value for 'first'
 *      last: // value for 'last'
 *      after: // value for 'after'
 *      before: // value for 'before'
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useCampaignComponentsQuery(baseOptions?: Apollo.QueryHookOptions<CampaignComponentsQuery, CampaignComponentsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CampaignComponentsQuery, CampaignComponentsQueryVariables>(CampaignComponentsDocument, options);
      }
export function useCampaignComponentsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CampaignComponentsQuery, CampaignComponentsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CampaignComponentsQuery, CampaignComponentsQueryVariables>(CampaignComponentsDocument, options);
        }
export function useCampaignComponentsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<CampaignComponentsQuery, CampaignComponentsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<CampaignComponentsQuery, CampaignComponentsQueryVariables>(CampaignComponentsDocument, options);
        }
export type CampaignComponentsQueryHookResult = ReturnType<typeof useCampaignComponentsQuery>;
export type CampaignComponentsLazyQueryHookResult = ReturnType<typeof useCampaignComponentsLazyQuery>;
export type CampaignComponentsSuspenseQueryHookResult = ReturnType<typeof useCampaignComponentsSuspenseQuery>;
export type CampaignComponentsQueryResult = Apollo.QueryResult<CampaignComponentsQuery, CampaignComponentsQueryVariables>;
export const ChainsDocument = gql`
    query chains($first: Int, $last: Int, $after: ID, $before: ID, $filter: ChainFilter) {
  chains(
    first: $first
    last: $last
    after: $after
    before: $before
    filter: $filter
  ) {
    pageInfo {
      ...pageInfo
    }
    edges {
      cursor
      node {
        ...chain
      }
    }
  }
}
    ${PageInfoFragmentDoc}
${ChainFragmentDoc}`;

/**
 * __useChainsQuery__
 *
 * To run a query within a React component, call `useChainsQuery` and pass it any options that fit your needs.
 * When your component renders, `useChainsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useChainsQuery({
 *   variables: {
 *      first: // value for 'first'
 *      last: // value for 'last'
 *      after: // value for 'after'
 *      before: // value for 'before'
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useChainsQuery(baseOptions?: Apollo.QueryHookOptions<ChainsQuery, ChainsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ChainsQuery, ChainsQueryVariables>(ChainsDocument, options);
      }
export function useChainsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ChainsQuery, ChainsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ChainsQuery, ChainsQueryVariables>(ChainsDocument, options);
        }
export function useChainsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ChainsQuery, ChainsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ChainsQuery, ChainsQueryVariables>(ChainsDocument, options);
        }
export type ChainsQueryHookResult = ReturnType<typeof useChainsQuery>;
export type ChainsLazyQueryHookResult = ReturnType<typeof useChainsLazyQuery>;
export type ChainsSuspenseQueryHookResult = ReturnType<typeof useChainsSuspenseQuery>;
export type ChainsQueryResult = Apollo.QueryResult<ChainsQuery, ChainsQueryVariables>;
export const ConstraintCreateDocument = gql`
    mutation constraintCreate($input: ConstraintCreateInput!) {
  constraintCreate(input: $input) {
    ...constraint
  }
}
    ${ConstraintFragmentDoc}`;
export type ConstraintCreateMutationFn = Apollo.MutationFunction<ConstraintCreateMutation, ConstraintCreateMutationVariables>;

/**
 * __useConstraintCreateMutation__
 *
 * To run a mutation, you first call `useConstraintCreateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useConstraintCreateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [constraintCreateMutation, { data, loading, error }] = useConstraintCreateMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useConstraintCreateMutation(baseOptions?: Apollo.MutationHookOptions<ConstraintCreateMutation, ConstraintCreateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ConstraintCreateMutation, ConstraintCreateMutationVariables>(ConstraintCreateDocument, options);
      }
export type ConstraintCreateMutationHookResult = ReturnType<typeof useConstraintCreateMutation>;
export type ConstraintCreateMutationResult = Apollo.MutationResult<ConstraintCreateMutation>;
export type ConstraintCreateMutationOptions = Apollo.BaseMutationOptions<ConstraintCreateMutation, ConstraintCreateMutationVariables>;
export const ConstraintDeleteDocument = gql`
    mutation constraintDelete($id: ID!) {
  constraintDelete(id: $id)
}
    `;
export type ConstraintDeleteMutationFn = Apollo.MutationFunction<ConstraintDeleteMutation, ConstraintDeleteMutationVariables>;

/**
 * __useConstraintDeleteMutation__
 *
 * To run a mutation, you first call `useConstraintDeleteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useConstraintDeleteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [constraintDeleteMutation, { data, loading, error }] = useConstraintDeleteMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useConstraintDeleteMutation(baseOptions?: Apollo.MutationHookOptions<ConstraintDeleteMutation, ConstraintDeleteMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ConstraintDeleteMutation, ConstraintDeleteMutationVariables>(ConstraintDeleteDocument, options);
      }
export type ConstraintDeleteMutationHookResult = ReturnType<typeof useConstraintDeleteMutation>;
export type ConstraintDeleteMutationResult = Apollo.MutationResult<ConstraintDeleteMutation>;
export type ConstraintDeleteMutationOptions = Apollo.BaseMutationOptions<ConstraintDeleteMutation, ConstraintDeleteMutationVariables>;
export const ConstraintUpdateDocument = gql`
    mutation constraintUpdate($input: ConstraintUpdateInput!) {
  constraintUpdate(input: $input) {
    ...constraint
  }
}
    ${ConstraintFragmentDoc}`;
export type ConstraintUpdateMutationFn = Apollo.MutationFunction<ConstraintUpdateMutation, ConstraintUpdateMutationVariables>;

/**
 * __useConstraintUpdateMutation__
 *
 * To run a mutation, you first call `useConstraintUpdateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useConstraintUpdateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [constraintUpdateMutation, { data, loading, error }] = useConstraintUpdateMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useConstraintUpdateMutation(baseOptions?: Apollo.MutationHookOptions<ConstraintUpdateMutation, ConstraintUpdateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ConstraintUpdateMutation, ConstraintUpdateMutationVariables>(ConstraintUpdateDocument, options);
      }
export type ConstraintUpdateMutationHookResult = ReturnType<typeof useConstraintUpdateMutation>;
export type ConstraintUpdateMutationResult = Apollo.MutationResult<ConstraintUpdateMutation>;
export type ConstraintUpdateMutationOptions = Apollo.BaseMutationOptions<ConstraintUpdateMutation, ConstraintUpdateMutationVariables>;
export const CurrentUserAbilitiesDocument = gql`
    query currentUserAbilities {
  currentUserAbilities {
    action
    conditions {
      uuidIn
    }
    fields
    scope
    subject
  }
}
    `;

/**
 * __useCurrentUserAbilitiesQuery__
 *
 * To run a query within a React component, call `useCurrentUserAbilitiesQuery` and pass it any options that fit your needs.
 * When your component renders, `useCurrentUserAbilitiesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCurrentUserAbilitiesQuery({
 *   variables: {
 *   },
 * });
 */
export function useCurrentUserAbilitiesQuery(baseOptions?: Apollo.QueryHookOptions<CurrentUserAbilitiesQuery, CurrentUserAbilitiesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CurrentUserAbilitiesQuery, CurrentUserAbilitiesQueryVariables>(CurrentUserAbilitiesDocument, options);
      }
export function useCurrentUserAbilitiesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CurrentUserAbilitiesQuery, CurrentUserAbilitiesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CurrentUserAbilitiesQuery, CurrentUserAbilitiesQueryVariables>(CurrentUserAbilitiesDocument, options);
        }
export function useCurrentUserAbilitiesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<CurrentUserAbilitiesQuery, CurrentUserAbilitiesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<CurrentUserAbilitiesQuery, CurrentUserAbilitiesQueryVariables>(CurrentUserAbilitiesDocument, options);
        }
export type CurrentUserAbilitiesQueryHookResult = ReturnType<typeof useCurrentUserAbilitiesQuery>;
export type CurrentUserAbilitiesLazyQueryHookResult = ReturnType<typeof useCurrentUserAbilitiesLazyQuery>;
export type CurrentUserAbilitiesSuspenseQueryHookResult = ReturnType<typeof useCurrentUserAbilitiesSuspenseQuery>;
export type CurrentUserAbilitiesQueryResult = Apollo.QueryResult<CurrentUserAbilitiesQuery, CurrentUserAbilitiesQueryVariables>;
export const CustomerCommunicationPreferenceUpdateDocument = gql`
    mutation customerCommunicationPreferenceUpdate($input: CommunicationPreferenceUpdateInput!) {
  updateCommunicationPreference(input: $input) {
    ...communicationPreference
  }
}
    ${CommunicationPreferenceFragmentDoc}`;
export type CustomerCommunicationPreferenceUpdateMutationFn = Apollo.MutationFunction<CustomerCommunicationPreferenceUpdateMutation, CustomerCommunicationPreferenceUpdateMutationVariables>;

/**
 * __useCustomerCommunicationPreferenceUpdateMutation__
 *
 * To run a mutation, you first call `useCustomerCommunicationPreferenceUpdateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCustomerCommunicationPreferenceUpdateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [customerCommunicationPreferenceUpdateMutation, { data, loading, error }] = useCustomerCommunicationPreferenceUpdateMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCustomerCommunicationPreferenceUpdateMutation(baseOptions?: Apollo.MutationHookOptions<CustomerCommunicationPreferenceUpdateMutation, CustomerCommunicationPreferenceUpdateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CustomerCommunicationPreferenceUpdateMutation, CustomerCommunicationPreferenceUpdateMutationVariables>(CustomerCommunicationPreferenceUpdateDocument, options);
      }
export type CustomerCommunicationPreferenceUpdateMutationHookResult = ReturnType<typeof useCustomerCommunicationPreferenceUpdateMutation>;
export type CustomerCommunicationPreferenceUpdateMutationResult = Apollo.MutationResult<CustomerCommunicationPreferenceUpdateMutation>;
export type CustomerCommunicationPreferenceUpdateMutationOptions = Apollo.BaseMutationOptions<CustomerCommunicationPreferenceUpdateMutation, CustomerCommunicationPreferenceUpdateMutationVariables>;
export const CustomerDocument = gql`
    query customer($customerUuid: ID!) {
  customer(uuid: $customerUuid) {
    ...customer
  }
}
    ${CustomerFragmentDoc}`;

/**
 * __useCustomerQuery__
 *
 * To run a query within a React component, call `useCustomerQuery` and pass it any options that fit your needs.
 * When your component renders, `useCustomerQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCustomerQuery({
 *   variables: {
 *      customerUuid: // value for 'customerUuid'
 *   },
 * });
 */
export function useCustomerQuery(baseOptions: Apollo.QueryHookOptions<CustomerQuery, CustomerQueryVariables> & ({ variables: CustomerQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CustomerQuery, CustomerQueryVariables>(CustomerDocument, options);
      }
export function useCustomerLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CustomerQuery, CustomerQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CustomerQuery, CustomerQueryVariables>(CustomerDocument, options);
        }
export function useCustomerSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<CustomerQuery, CustomerQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<CustomerQuery, CustomerQueryVariables>(CustomerDocument, options);
        }
export type CustomerQueryHookResult = ReturnType<typeof useCustomerQuery>;
export type CustomerLazyQueryHookResult = ReturnType<typeof useCustomerLazyQuery>;
export type CustomerSuspenseQueryHookResult = ReturnType<typeof useCustomerSuspenseQuery>;
export type CustomerQueryResult = Apollo.QueryResult<CustomerQuery, CustomerQueryVariables>;
export const GetCommunicationPreferencesForAllSubBrandsDocument = gql`
    query getCommunicationPreferencesForAllSubBrands($customerUuid: OCUUID!) {
  getCommunicationPreferencesForAllSubBrands(customerUuid: $customerUuid) {
    ...communicationPreference
  }
}
    ${CommunicationPreferenceFragmentDoc}`;

/**
 * __useGetCommunicationPreferencesForAllSubBrandsQuery__
 *
 * To run a query within a React component, call `useGetCommunicationPreferencesForAllSubBrandsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCommunicationPreferencesForAllSubBrandsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCommunicationPreferencesForAllSubBrandsQuery({
 *   variables: {
 *      customerUuid: // value for 'customerUuid'
 *   },
 * });
 */
export function useGetCommunicationPreferencesForAllSubBrandsQuery(baseOptions: Apollo.QueryHookOptions<GetCommunicationPreferencesForAllSubBrandsQuery, GetCommunicationPreferencesForAllSubBrandsQueryVariables> & ({ variables: GetCommunicationPreferencesForAllSubBrandsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCommunicationPreferencesForAllSubBrandsQuery, GetCommunicationPreferencesForAllSubBrandsQueryVariables>(GetCommunicationPreferencesForAllSubBrandsDocument, options);
      }
export function useGetCommunicationPreferencesForAllSubBrandsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCommunicationPreferencesForAllSubBrandsQuery, GetCommunicationPreferencesForAllSubBrandsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCommunicationPreferencesForAllSubBrandsQuery, GetCommunicationPreferencesForAllSubBrandsQueryVariables>(GetCommunicationPreferencesForAllSubBrandsDocument, options);
        }
export function useGetCommunicationPreferencesForAllSubBrandsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetCommunicationPreferencesForAllSubBrandsQuery, GetCommunicationPreferencesForAllSubBrandsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetCommunicationPreferencesForAllSubBrandsQuery, GetCommunicationPreferencesForAllSubBrandsQueryVariables>(GetCommunicationPreferencesForAllSubBrandsDocument, options);
        }
export type GetCommunicationPreferencesForAllSubBrandsQueryHookResult = ReturnType<typeof useGetCommunicationPreferencesForAllSubBrandsQuery>;
export type GetCommunicationPreferencesForAllSubBrandsLazyQueryHookResult = ReturnType<typeof useGetCommunicationPreferencesForAllSubBrandsLazyQuery>;
export type GetCommunicationPreferencesForAllSubBrandsSuspenseQueryHookResult = ReturnType<typeof useGetCommunicationPreferencesForAllSubBrandsSuspenseQuery>;
export type GetCommunicationPreferencesForAllSubBrandsQueryResult = Apollo.QueryResult<GetCommunicationPreferencesForAllSubBrandsQuery, GetCommunicationPreferencesForAllSubBrandsQueryVariables>;
export const DisplayCategoryCreateDocument = gql`
    mutation displayCategoryCreate($input: DisplayCategoryCreateInput!) {
  displayCategoryCreate(input: $input) {
    ...displayCategory
  }
}
    ${DisplayCategoryFragmentDoc}`;
export type DisplayCategoryCreateMutationFn = Apollo.MutationFunction<DisplayCategoryCreateMutation, DisplayCategoryCreateMutationVariables>;

/**
 * __useDisplayCategoryCreateMutation__
 *
 * To run a mutation, you first call `useDisplayCategoryCreateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDisplayCategoryCreateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [displayCategoryCreateMutation, { data, loading, error }] = useDisplayCategoryCreateMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDisplayCategoryCreateMutation(baseOptions?: Apollo.MutationHookOptions<DisplayCategoryCreateMutation, DisplayCategoryCreateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DisplayCategoryCreateMutation, DisplayCategoryCreateMutationVariables>(DisplayCategoryCreateDocument, options);
      }
export type DisplayCategoryCreateMutationHookResult = ReturnType<typeof useDisplayCategoryCreateMutation>;
export type DisplayCategoryCreateMutationResult = Apollo.MutationResult<DisplayCategoryCreateMutation>;
export type DisplayCategoryCreateMutationOptions = Apollo.BaseMutationOptions<DisplayCategoryCreateMutation, DisplayCategoryCreateMutationVariables>;
export const DisplayCategoryUpdateDocument = gql`
    mutation displayCategoryUpdate($input: DisplayCategoryUpdateInput!) {
  displayCategoryUpdate(input: $input) {
    ...displayCategory
  }
}
    ${DisplayCategoryFragmentDoc}`;
export type DisplayCategoryUpdateMutationFn = Apollo.MutationFunction<DisplayCategoryUpdateMutation, DisplayCategoryUpdateMutationVariables>;

/**
 * __useDisplayCategoryUpdateMutation__
 *
 * To run a mutation, you first call `useDisplayCategoryUpdateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDisplayCategoryUpdateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [displayCategoryUpdateMutation, { data, loading, error }] = useDisplayCategoryUpdateMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDisplayCategoryUpdateMutation(baseOptions?: Apollo.MutationHookOptions<DisplayCategoryUpdateMutation, DisplayCategoryUpdateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DisplayCategoryUpdateMutation, DisplayCategoryUpdateMutationVariables>(DisplayCategoryUpdateDocument, options);
      }
export type DisplayCategoryUpdateMutationHookResult = ReturnType<typeof useDisplayCategoryUpdateMutation>;
export type DisplayCategoryUpdateMutationResult = Apollo.MutationResult<DisplayCategoryUpdateMutation>;
export type DisplayCategoryUpdateMutationOptions = Apollo.BaseMutationOptions<DisplayCategoryUpdateMutation, DisplayCategoryUpdateMutationVariables>;
export const DisplayCategoryDeleteDocument = gql`
    mutation displayCategoryDelete($id: ID!) {
  displayCategoryDelete(id: $id)
}
    `;
export type DisplayCategoryDeleteMutationFn = Apollo.MutationFunction<DisplayCategoryDeleteMutation, DisplayCategoryDeleteMutationVariables>;

/**
 * __useDisplayCategoryDeleteMutation__
 *
 * To run a mutation, you first call `useDisplayCategoryDeleteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDisplayCategoryDeleteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [displayCategoryDeleteMutation, { data, loading, error }] = useDisplayCategoryDeleteMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDisplayCategoryDeleteMutation(baseOptions?: Apollo.MutationHookOptions<DisplayCategoryDeleteMutation, DisplayCategoryDeleteMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DisplayCategoryDeleteMutation, DisplayCategoryDeleteMutationVariables>(DisplayCategoryDeleteDocument, options);
      }
export type DisplayCategoryDeleteMutationHookResult = ReturnType<typeof useDisplayCategoryDeleteMutation>;
export type DisplayCategoryDeleteMutationResult = Apollo.MutationResult<DisplayCategoryDeleteMutation>;
export type DisplayCategoryDeleteMutationOptions = Apollo.BaseMutationOptions<DisplayCategoryDeleteMutation, DisplayCategoryDeleteMutationVariables>;
export const DisplayCategoryDocument = gql`
    query displayCategory($filter: DisplayCategoryFilter, $skipBanners: Boolean!) {
  displayCategories(filter: $filter) {
    edges {
      cursor
      node {
        ...displayCategory
      }
    }
  }
  bannerConfigurations @skip(if: $skipBanners) {
    edges {
      cursor
      node {
        ...bannerConfiguration
      }
    }
  }
}
    ${DisplayCategoryFragmentDoc}
${BannerConfigurationFragmentDoc}`;

/**
 * __useDisplayCategoryQuery__
 *
 * To run a query within a React component, call `useDisplayCategoryQuery` and pass it any options that fit your needs.
 * When your component renders, `useDisplayCategoryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDisplayCategoryQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *      skipBanners: // value for 'skipBanners'
 *   },
 * });
 */
export function useDisplayCategoryQuery(baseOptions: Apollo.QueryHookOptions<DisplayCategoryQuery, DisplayCategoryQueryVariables> & ({ variables: DisplayCategoryQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<DisplayCategoryQuery, DisplayCategoryQueryVariables>(DisplayCategoryDocument, options);
      }
export function useDisplayCategoryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<DisplayCategoryQuery, DisplayCategoryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<DisplayCategoryQuery, DisplayCategoryQueryVariables>(DisplayCategoryDocument, options);
        }
export function useDisplayCategorySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<DisplayCategoryQuery, DisplayCategoryQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<DisplayCategoryQuery, DisplayCategoryQueryVariables>(DisplayCategoryDocument, options);
        }
export type DisplayCategoryQueryHookResult = ReturnType<typeof useDisplayCategoryQuery>;
export type DisplayCategoryLazyQueryHookResult = ReturnType<typeof useDisplayCategoryLazyQuery>;
export type DisplayCategorySuspenseQueryHookResult = ReturnType<typeof useDisplayCategorySuspenseQuery>;
export type DisplayCategoryQueryResult = Apollo.QueryResult<DisplayCategoryQuery, DisplayCategoryQueryVariables>;
export const DisplayCategoriesDocument = gql`
    query displayCategories($first: Int, $last: Int, $after: ID, $before: ID, $filter: DisplayCategoryFilter) {
  displayCategories(
    first: $first
    last: $last
    after: $after
    before: $before
    filter: $filter
  ) {
    pageInfo {
      ...pageInfo
    }
    edges {
      cursor
      node {
        ...displayCategory
      }
    }
  }
}
    ${PageInfoFragmentDoc}
${DisplayCategoryFragmentDoc}`;

/**
 * __useDisplayCategoriesQuery__
 *
 * To run a query within a React component, call `useDisplayCategoriesQuery` and pass it any options that fit your needs.
 * When your component renders, `useDisplayCategoriesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDisplayCategoriesQuery({
 *   variables: {
 *      first: // value for 'first'
 *      last: // value for 'last'
 *      after: // value for 'after'
 *      before: // value for 'before'
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useDisplayCategoriesQuery(baseOptions?: Apollo.QueryHookOptions<DisplayCategoriesQuery, DisplayCategoriesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<DisplayCategoriesQuery, DisplayCategoriesQueryVariables>(DisplayCategoriesDocument, options);
      }
export function useDisplayCategoriesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<DisplayCategoriesQuery, DisplayCategoriesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<DisplayCategoriesQuery, DisplayCategoriesQueryVariables>(DisplayCategoriesDocument, options);
        }
export function useDisplayCategoriesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<DisplayCategoriesQuery, DisplayCategoriesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<DisplayCategoriesQuery, DisplayCategoriesQueryVariables>(DisplayCategoriesDocument, options);
        }
export type DisplayCategoriesQueryHookResult = ReturnType<typeof useDisplayCategoriesQuery>;
export type DisplayCategoriesLazyQueryHookResult = ReturnType<typeof useDisplayCategoriesLazyQuery>;
export type DisplayCategoriesSuspenseQueryHookResult = ReturnType<typeof useDisplayCategoriesSuspenseQuery>;
export type DisplayCategoriesQueryResult = Apollo.QueryResult<DisplayCategoriesQuery, DisplayCategoriesQueryVariables>;
export const EaivAuditTrailDocument = gql`
    query eaivAuditTrail($customerUuid: OCUUID!) {
  eaivAuditTrail(filter: {customerUuid: $customerUuid}) {
    edges {
      node {
        ...EaivAudit
      }
    }
  }
}
    ${EaivAuditFragmentDoc}`;

/**
 * __useEaivAuditTrailQuery__
 *
 * To run a query within a React component, call `useEaivAuditTrailQuery` and pass it any options that fit your needs.
 * When your component renders, `useEaivAuditTrailQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEaivAuditTrailQuery({
 *   variables: {
 *      customerUuid: // value for 'customerUuid'
 *   },
 * });
 */
export function useEaivAuditTrailQuery(baseOptions: Apollo.QueryHookOptions<EaivAuditTrailQuery, EaivAuditTrailQueryVariables> & ({ variables: EaivAuditTrailQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<EaivAuditTrailQuery, EaivAuditTrailQueryVariables>(EaivAuditTrailDocument, options);
      }
export function useEaivAuditTrailLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<EaivAuditTrailQuery, EaivAuditTrailQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<EaivAuditTrailQuery, EaivAuditTrailQueryVariables>(EaivAuditTrailDocument, options);
        }
export function useEaivAuditTrailSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<EaivAuditTrailQuery, EaivAuditTrailQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<EaivAuditTrailQuery, EaivAuditTrailQueryVariables>(EaivAuditTrailDocument, options);
        }
export type EaivAuditTrailQueryHookResult = ReturnType<typeof useEaivAuditTrailQuery>;
export type EaivAuditTrailLazyQueryHookResult = ReturnType<typeof useEaivAuditTrailLazyQuery>;
export type EaivAuditTrailSuspenseQueryHookResult = ReturnType<typeof useEaivAuditTrailSuspenseQuery>;
export type EaivAuditTrailQueryResult = Apollo.QueryResult<EaivAuditTrailQuery, EaivAuditTrailQueryVariables>;
export const EarningMechanismCreateDocument = gql`
    mutation earningMechanismCreate($input: EarningMechanismCreateInput!) {
  earningMechanismCreate(input: $input) {
    ...earningMechanism
  }
}
    ${EarningMechanismFragmentDoc}`;
export type EarningMechanismCreateMutationFn = Apollo.MutationFunction<EarningMechanismCreateMutation, EarningMechanismCreateMutationVariables>;

/**
 * __useEarningMechanismCreateMutation__
 *
 * To run a mutation, you first call `useEarningMechanismCreateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEarningMechanismCreateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [earningMechanismCreateMutation, { data, loading, error }] = useEarningMechanismCreateMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useEarningMechanismCreateMutation(baseOptions?: Apollo.MutationHookOptions<EarningMechanismCreateMutation, EarningMechanismCreateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<EarningMechanismCreateMutation, EarningMechanismCreateMutationVariables>(EarningMechanismCreateDocument, options);
      }
export type EarningMechanismCreateMutationHookResult = ReturnType<typeof useEarningMechanismCreateMutation>;
export type EarningMechanismCreateMutationResult = Apollo.MutationResult<EarningMechanismCreateMutation>;
export type EarningMechanismCreateMutationOptions = Apollo.BaseMutationOptions<EarningMechanismCreateMutation, EarningMechanismCreateMutationVariables>;
export const EarningMechanismUpdateDocument = gql`
    mutation earningMechanismUpdate($input: EarningMechanismUpdateInput!) {
  earningMechanismUpdate(input: $input) {
    ...earningMechanism
  }
}
    ${EarningMechanismFragmentDoc}`;
export type EarningMechanismUpdateMutationFn = Apollo.MutationFunction<EarningMechanismUpdateMutation, EarningMechanismUpdateMutationVariables>;

/**
 * __useEarningMechanismUpdateMutation__
 *
 * To run a mutation, you first call `useEarningMechanismUpdateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEarningMechanismUpdateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [earningMechanismUpdateMutation, { data, loading, error }] = useEarningMechanismUpdateMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useEarningMechanismUpdateMutation(baseOptions?: Apollo.MutationHookOptions<EarningMechanismUpdateMutation, EarningMechanismUpdateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<EarningMechanismUpdateMutation, EarningMechanismUpdateMutationVariables>(EarningMechanismUpdateDocument, options);
      }
export type EarningMechanismUpdateMutationHookResult = ReturnType<typeof useEarningMechanismUpdateMutation>;
export type EarningMechanismUpdateMutationResult = Apollo.MutationResult<EarningMechanismUpdateMutation>;
export type EarningMechanismUpdateMutationOptions = Apollo.BaseMutationOptions<EarningMechanismUpdateMutation, EarningMechanismUpdateMutationVariables>;
export const EarningMechanismDeleteDocument = gql`
    mutation earningMechanismDelete($id: ID!) {
  earningMechanismDelete(id: $id)
}
    `;
export type EarningMechanismDeleteMutationFn = Apollo.MutationFunction<EarningMechanismDeleteMutation, EarningMechanismDeleteMutationVariables>;

/**
 * __useEarningMechanismDeleteMutation__
 *
 * To run a mutation, you first call `useEarningMechanismDeleteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEarningMechanismDeleteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [earningMechanismDeleteMutation, { data, loading, error }] = useEarningMechanismDeleteMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useEarningMechanismDeleteMutation(baseOptions?: Apollo.MutationHookOptions<EarningMechanismDeleteMutation, EarningMechanismDeleteMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<EarningMechanismDeleteMutation, EarningMechanismDeleteMutationVariables>(EarningMechanismDeleteDocument, options);
      }
export type EarningMechanismDeleteMutationHookResult = ReturnType<typeof useEarningMechanismDeleteMutation>;
export type EarningMechanismDeleteMutationResult = Apollo.MutationResult<EarningMechanismDeleteMutation>;
export type EarningMechanismDeleteMutationOptions = Apollo.BaseMutationOptions<EarningMechanismDeleteMutation, EarningMechanismDeleteMutationVariables>;
export const ExternalIdentityVerificationAttributesDocument = gql`
    query externalIdentityVerificationAttributes {
  externalIdentityVerificationAttributes {
    ...externalIdentityVerificationAttribute
  }
}
    ${ExternalIdentityVerificationAttributeFragmentDoc}`;

/**
 * __useExternalIdentityVerificationAttributesQuery__
 *
 * To run a query within a React component, call `useExternalIdentityVerificationAttributesQuery` and pass it any options that fit your needs.
 * When your component renders, `useExternalIdentityVerificationAttributesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useExternalIdentityVerificationAttributesQuery({
 *   variables: {
 *   },
 * });
 */
export function useExternalIdentityVerificationAttributesQuery(baseOptions?: Apollo.QueryHookOptions<ExternalIdentityVerificationAttributesQuery, ExternalIdentityVerificationAttributesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ExternalIdentityVerificationAttributesQuery, ExternalIdentityVerificationAttributesQueryVariables>(ExternalIdentityVerificationAttributesDocument, options);
      }
export function useExternalIdentityVerificationAttributesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ExternalIdentityVerificationAttributesQuery, ExternalIdentityVerificationAttributesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ExternalIdentityVerificationAttributesQuery, ExternalIdentityVerificationAttributesQueryVariables>(ExternalIdentityVerificationAttributesDocument, options);
        }
export function useExternalIdentityVerificationAttributesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ExternalIdentityVerificationAttributesQuery, ExternalIdentityVerificationAttributesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ExternalIdentityVerificationAttributesQuery, ExternalIdentityVerificationAttributesQueryVariables>(ExternalIdentityVerificationAttributesDocument, options);
        }
export type ExternalIdentityVerificationAttributesQueryHookResult = ReturnType<typeof useExternalIdentityVerificationAttributesQuery>;
export type ExternalIdentityVerificationAttributesLazyQueryHookResult = ReturnType<typeof useExternalIdentityVerificationAttributesLazyQuery>;
export type ExternalIdentityVerificationAttributesSuspenseQueryHookResult = ReturnType<typeof useExternalIdentityVerificationAttributesSuspenseQuery>;
export type ExternalIdentityVerificationAttributesQueryResult = Apollo.QueryResult<ExternalIdentityVerificationAttributesQuery, ExternalIdentityVerificationAttributesQueryVariables>;
export const BannerConfigurationsDocument = gql`
    query bannerConfigurations($first: Int, $last: Int, $after: String, $before: String, $filter: BannerConfigurationFilter) {
  bannerConfigurations(
    first: $first
    last: $last
    after: $after
    before: $before
    filter: $filter
  ) {
    edges {
      cursor
      node {
        ...bannerConfiguration
      }
    }
  }
}
    ${BannerConfigurationFragmentDoc}`;

/**
 * __useBannerConfigurationsQuery__
 *
 * To run a query within a React component, call `useBannerConfigurationsQuery` and pass it any options that fit your needs.
 * When your component renders, `useBannerConfigurationsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useBannerConfigurationsQuery({
 *   variables: {
 *      first: // value for 'first'
 *      last: // value for 'last'
 *      after: // value for 'after'
 *      before: // value for 'before'
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useBannerConfigurationsQuery(baseOptions?: Apollo.QueryHookOptions<BannerConfigurationsQuery, BannerConfigurationsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<BannerConfigurationsQuery, BannerConfigurationsQueryVariables>(BannerConfigurationsDocument, options);
      }
export function useBannerConfigurationsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<BannerConfigurationsQuery, BannerConfigurationsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<BannerConfigurationsQuery, BannerConfigurationsQueryVariables>(BannerConfigurationsDocument, options);
        }
export function useBannerConfigurationsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<BannerConfigurationsQuery, BannerConfigurationsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<BannerConfigurationsQuery, BannerConfigurationsQueryVariables>(BannerConfigurationsDocument, options);
        }
export type BannerConfigurationsQueryHookResult = ReturnType<typeof useBannerConfigurationsQuery>;
export type BannerConfigurationsLazyQueryHookResult = ReturnType<typeof useBannerConfigurationsLazyQuery>;
export type BannerConfigurationsSuspenseQueryHookResult = ReturnType<typeof useBannerConfigurationsSuspenseQuery>;
export type BannerConfigurationsQueryResult = Apollo.QueryResult<BannerConfigurationsQuery, BannerConfigurationsQueryVariables>;
export const GamesListDocument = gql`
    query gamesList($first: Int, $last: Int, $after: ID, $before: ID, $filter: OfferFilter) {
  offers(
    first: $first
    last: $last
    after: $after
    before: $before
    filter: $filter
  ) {
    pageInfo {
      ...pageInfo
    }
    edges {
      cursor
      node {
        ...gamesListItem
      }
    }
  }
}
    ${PageInfoFragmentDoc}
${GamesListItemFragmentDoc}`;

/**
 * __useGamesListQuery__
 *
 * To run a query within a React component, call `useGamesListQuery` and pass it any options that fit your needs.
 * When your component renders, `useGamesListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGamesListQuery({
 *   variables: {
 *      first: // value for 'first'
 *      last: // value for 'last'
 *      after: // value for 'after'
 *      before: // value for 'before'
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useGamesListQuery(baseOptions?: Apollo.QueryHookOptions<GamesListQuery, GamesListQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GamesListQuery, GamesListQueryVariables>(GamesListDocument, options);
      }
export function useGamesListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GamesListQuery, GamesListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GamesListQuery, GamesListQueryVariables>(GamesListDocument, options);
        }
export function useGamesListSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GamesListQuery, GamesListQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GamesListQuery, GamesListQueryVariables>(GamesListDocument, options);
        }
export type GamesListQueryHookResult = ReturnType<typeof useGamesListQuery>;
export type GamesListLazyQueryHookResult = ReturnType<typeof useGamesListLazyQuery>;
export type GamesListSuspenseQueryHookResult = ReturnType<typeof useGamesListSuspenseQuery>;
export type GamesListQueryResult = Apollo.QueryResult<GamesListQuery, GamesListQueryVariables>;
export const LimitCreateDocument = gql`
    mutation limitCreate($input: LimitCreateInput!) {
  limitCreate(input: $input) {
    ...limit
  }
}
    ${LimitFragmentDoc}`;
export type LimitCreateMutationFn = Apollo.MutationFunction<LimitCreateMutation, LimitCreateMutationVariables>;

/**
 * __useLimitCreateMutation__
 *
 * To run a mutation, you first call `useLimitCreateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useLimitCreateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [limitCreateMutation, { data, loading, error }] = useLimitCreateMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useLimitCreateMutation(baseOptions?: Apollo.MutationHookOptions<LimitCreateMutation, LimitCreateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<LimitCreateMutation, LimitCreateMutationVariables>(LimitCreateDocument, options);
      }
export type LimitCreateMutationHookResult = ReturnType<typeof useLimitCreateMutation>;
export type LimitCreateMutationResult = Apollo.MutationResult<LimitCreateMutation>;
export type LimitCreateMutationOptions = Apollo.BaseMutationOptions<LimitCreateMutation, LimitCreateMutationVariables>;
export const LimitDeleteDocument = gql`
    mutation limitDelete($id: ID!) {
  limitDelete(id: $id)
}
    `;
export type LimitDeleteMutationFn = Apollo.MutationFunction<LimitDeleteMutation, LimitDeleteMutationVariables>;

/**
 * __useLimitDeleteMutation__
 *
 * To run a mutation, you first call `useLimitDeleteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useLimitDeleteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [limitDeleteMutation, { data, loading, error }] = useLimitDeleteMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useLimitDeleteMutation(baseOptions?: Apollo.MutationHookOptions<LimitDeleteMutation, LimitDeleteMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<LimitDeleteMutation, LimitDeleteMutationVariables>(LimitDeleteDocument, options);
      }
export type LimitDeleteMutationHookResult = ReturnType<typeof useLimitDeleteMutation>;
export type LimitDeleteMutationResult = Apollo.MutationResult<LimitDeleteMutation>;
export type LimitDeleteMutationOptions = Apollo.BaseMutationOptions<LimitDeleteMutation, LimitDeleteMutationVariables>;
export const LimitUpdateDocument = gql`
    mutation limitUpdate($input: LimitUpdateInput!) {
  limitUpdate(input: $input) {
    ...limit
  }
}
    ${LimitFragmentDoc}`;
export type LimitUpdateMutationFn = Apollo.MutationFunction<LimitUpdateMutation, LimitUpdateMutationVariables>;

/**
 * __useLimitUpdateMutation__
 *
 * To run a mutation, you first call `useLimitUpdateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useLimitUpdateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [limitUpdateMutation, { data, loading, error }] = useLimitUpdateMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useLimitUpdateMutation(baseOptions?: Apollo.MutationHookOptions<LimitUpdateMutation, LimitUpdateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<LimitUpdateMutation, LimitUpdateMutationVariables>(LimitUpdateDocument, options);
      }
export type LimitUpdateMutationHookResult = ReturnType<typeof useLimitUpdateMutation>;
export type LimitUpdateMutationResult = Apollo.MutationResult<LimitUpdateMutation>;
export type LimitUpdateMutationOptions = Apollo.BaseMutationOptions<LimitUpdateMutation, LimitUpdateMutationVariables>;
export const SiteManagementLocationUpdateDocument = gql`
    mutation siteManagementLocationUpdate($locationUpdateInput: LocationUpdate!) {
  locationUpdate(input: $locationUpdateInput) {
    ...siteManagementLocation
  }
}
    ${SiteManagementLocationFragmentDoc}`;
export type SiteManagementLocationUpdateMutationFn = Apollo.MutationFunction<SiteManagementLocationUpdateMutation, SiteManagementLocationUpdateMutationVariables>;

/**
 * __useSiteManagementLocationUpdateMutation__
 *
 * To run a mutation, you first call `useSiteManagementLocationUpdateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSiteManagementLocationUpdateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [siteManagementLocationUpdateMutation, { data, loading, error }] = useSiteManagementLocationUpdateMutation({
 *   variables: {
 *      locationUpdateInput: // value for 'locationUpdateInput'
 *   },
 * });
 */
export function useSiteManagementLocationUpdateMutation(baseOptions?: Apollo.MutationHookOptions<SiteManagementLocationUpdateMutation, SiteManagementLocationUpdateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SiteManagementLocationUpdateMutation, SiteManagementLocationUpdateMutationVariables>(SiteManagementLocationUpdateDocument, options);
      }
export type SiteManagementLocationUpdateMutationHookResult = ReturnType<typeof useSiteManagementLocationUpdateMutation>;
export type SiteManagementLocationUpdateMutationResult = Apollo.MutationResult<SiteManagementLocationUpdateMutation>;
export type SiteManagementLocationUpdateMutationOptions = Apollo.BaseMutationOptions<SiteManagementLocationUpdateMutation, SiteManagementLocationUpdateMutationVariables>;
export const LocationBulkOperationHoursUpdateForRetailerNetworkDocument = gql`
    mutation locationBulkOperationHoursUpdateForRetailerNetwork($retailerNetworkUuid: OCUUID!, $schedule: [HoursOfOperationUpdate!]!) {
  bulkUpdate: locationBulkOperationHoursUpdateForRetailerNetwork(
    hoursOfOperationUpdates: $schedule
    retailerNetworkUuid: $retailerNetworkUuid
  ) {
    ... on BulkUpdateLocationResultSuccess {
      status
    }
    ... on BulkUpdateLocationResultFailure {
      reason
    }
  }
}
    `;
export type LocationBulkOperationHoursUpdateForRetailerNetworkMutationFn = Apollo.MutationFunction<LocationBulkOperationHoursUpdateForRetailerNetworkMutation, LocationBulkOperationHoursUpdateForRetailerNetworkMutationVariables>;

/**
 * __useLocationBulkOperationHoursUpdateForRetailerNetworkMutation__
 *
 * To run a mutation, you first call `useLocationBulkOperationHoursUpdateForRetailerNetworkMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useLocationBulkOperationHoursUpdateForRetailerNetworkMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [locationBulkOperationHoursUpdateForRetailerNetworkMutation, { data, loading, error }] = useLocationBulkOperationHoursUpdateForRetailerNetworkMutation({
 *   variables: {
 *      retailerNetworkUuid: // value for 'retailerNetworkUuid'
 *      schedule: // value for 'schedule'
 *   },
 * });
 */
export function useLocationBulkOperationHoursUpdateForRetailerNetworkMutation(baseOptions?: Apollo.MutationHookOptions<LocationBulkOperationHoursUpdateForRetailerNetworkMutation, LocationBulkOperationHoursUpdateForRetailerNetworkMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<LocationBulkOperationHoursUpdateForRetailerNetworkMutation, LocationBulkOperationHoursUpdateForRetailerNetworkMutationVariables>(LocationBulkOperationHoursUpdateForRetailerNetworkDocument, options);
      }
export type LocationBulkOperationHoursUpdateForRetailerNetworkMutationHookResult = ReturnType<typeof useLocationBulkOperationHoursUpdateForRetailerNetworkMutation>;
export type LocationBulkOperationHoursUpdateForRetailerNetworkMutationResult = Apollo.MutationResult<LocationBulkOperationHoursUpdateForRetailerNetworkMutation>;
export type LocationBulkOperationHoursUpdateForRetailerNetworkMutationOptions = Apollo.BaseMutationOptions<LocationBulkOperationHoursUpdateForRetailerNetworkMutation, LocationBulkOperationHoursUpdateForRetailerNetworkMutationVariables>;
export const ClearActivityLogDocument = gql`
    mutation clearActivityLog($input: ClearActivityLog!) {
  clearActivityLog(input: $input)
}
    `;
export type ClearActivityLogMutationFn = Apollo.MutationFunction<ClearActivityLogMutation, ClearActivityLogMutationVariables>;

/**
 * __useClearActivityLogMutation__
 *
 * To run a mutation, you first call `useClearActivityLogMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useClearActivityLogMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [clearActivityLogMutation, { data, loading, error }] = useClearActivityLogMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useClearActivityLogMutation(baseOptions?: Apollo.MutationHookOptions<ClearActivityLogMutation, ClearActivityLogMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ClearActivityLogMutation, ClearActivityLogMutationVariables>(ClearActivityLogDocument, options);
      }
export type ClearActivityLogMutationHookResult = ReturnType<typeof useClearActivityLogMutation>;
export type ClearActivityLogMutationResult = Apollo.MutationResult<ClearActivityLogMutation>;
export type ClearActivityLogMutationOptions = Apollo.BaseMutationOptions<ClearActivityLogMutation, ClearActivityLogMutationVariables>;
export const LocationCreateDocument = gql`
    mutation locationCreate($locationCreateInput: LocationCreate!) {
  locationCreate(input: $locationCreateInput) {
    uuid
    brandSpecificLocationId
    brand {
      uuid
      name
    }
    address {
      countryCode
      state
      zipCode
      city
      street1
      street2
      geoLocation {
        latitude
        longitude
      }
    }
    attributes {
      name
      value
    }
    siteSystemConfiguration {
      identifier
      mobileEnabled
      loyaltyEnabled
      hardwareVendor
      details {
        siteAddress
        siteName
        mobileVersion
        mobileActive
        partialAuthAllowed
        pumpTimeout
        lastConnection
        isOnline
        fuelConfigDetails {
          outdoorPosition
          description
          posCode
          posCodeModifier
          posCodeFormat
          productCode
          merchandiseCode
          priceTier
          unitPrice
        }
        carWashDetails {
          description
          posCode
          posCodeModifier
          posCodeFormat
          productCode
          merchandiseCode
          unitPrice
        }
      }
    }
  }
}
    `;
export type LocationCreateMutationFn = Apollo.MutationFunction<LocationCreateMutation, LocationCreateMutationVariables>;

/**
 * __useLocationCreateMutation__
 *
 * To run a mutation, you first call `useLocationCreateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useLocationCreateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [locationCreateMutation, { data, loading, error }] = useLocationCreateMutation({
 *   variables: {
 *      locationCreateInput: // value for 'locationCreateInput'
 *   },
 * });
 */
export function useLocationCreateMutation(baseOptions?: Apollo.MutationHookOptions<LocationCreateMutation, LocationCreateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<LocationCreateMutation, LocationCreateMutationVariables>(LocationCreateDocument, options);
      }
export type LocationCreateMutationHookResult = ReturnType<typeof useLocationCreateMutation>;
export type LocationCreateMutationResult = Apollo.MutationResult<LocationCreateMutation>;
export type LocationCreateMutationOptions = Apollo.BaseMutationOptions<LocationCreateMutation, LocationCreateMutationVariables>;
export const LocationsDocument = gql`
    query locations($first: Int, $last: Int, $after: String, $before: String, $filter: LocationFilter) {
  locations(
    first: $first
    last: $last
    after: $after
    before: $before
    filter: $filter
  ) {
    pageInfo {
      ...pageInfo
    }
    edges {
      cursor
      node {
        ...location
      }
    }
  }
}
    ${PageInfoFragmentDoc}
${LocationFragmentDoc}`;

/**
 * __useLocationsQuery__
 *
 * To run a query within a React component, call `useLocationsQuery` and pass it any options that fit your needs.
 * When your component renders, `useLocationsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useLocationsQuery({
 *   variables: {
 *      first: // value for 'first'
 *      last: // value for 'last'
 *      after: // value for 'after'
 *      before: // value for 'before'
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useLocationsQuery(baseOptions?: Apollo.QueryHookOptions<LocationsQuery, LocationsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<LocationsQuery, LocationsQueryVariables>(LocationsDocument, options);
      }
export function useLocationsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<LocationsQuery, LocationsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<LocationsQuery, LocationsQueryVariables>(LocationsDocument, options);
        }
export function useLocationsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<LocationsQuery, LocationsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<LocationsQuery, LocationsQueryVariables>(LocationsDocument, options);
        }
export type LocationsQueryHookResult = ReturnType<typeof useLocationsQuery>;
export type LocationsLazyQueryHookResult = ReturnType<typeof useLocationsLazyQuery>;
export type LocationsSuspenseQueryHookResult = ReturnType<typeof useLocationsSuspenseQuery>;
export type LocationsQueryResult = Apollo.QueryResult<LocationsQuery, LocationsQueryVariables>;
export const GetLocationSelectItemsDocument = gql`
    query getLocationSelectItems($first: Int, $last: Int, $after: String, $before: String, $filter: LocationFilter) {
  locations(
    first: $first
    last: $last
    after: $after
    before: $before
    filter: $filter
  ) {
    pageInfo {
      ...pageInfo
    }
    edges {
      cursor
      node {
        ...locationSelectItem
      }
    }
  }
}
    ${PageInfoFragmentDoc}
${LocationSelectItemFragmentDoc}`;

/**
 * __useGetLocationSelectItemsQuery__
 *
 * To run a query within a React component, call `useGetLocationSelectItemsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetLocationSelectItemsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetLocationSelectItemsQuery({
 *   variables: {
 *      first: // value for 'first'
 *      last: // value for 'last'
 *      after: // value for 'after'
 *      before: // value for 'before'
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useGetLocationSelectItemsQuery(baseOptions?: Apollo.QueryHookOptions<GetLocationSelectItemsQuery, GetLocationSelectItemsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetLocationSelectItemsQuery, GetLocationSelectItemsQueryVariables>(GetLocationSelectItemsDocument, options);
      }
export function useGetLocationSelectItemsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetLocationSelectItemsQuery, GetLocationSelectItemsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetLocationSelectItemsQuery, GetLocationSelectItemsQueryVariables>(GetLocationSelectItemsDocument, options);
        }
export function useGetLocationSelectItemsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetLocationSelectItemsQuery, GetLocationSelectItemsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetLocationSelectItemsQuery, GetLocationSelectItemsQueryVariables>(GetLocationSelectItemsDocument, options);
        }
export type GetLocationSelectItemsQueryHookResult = ReturnType<typeof useGetLocationSelectItemsQuery>;
export type GetLocationSelectItemsLazyQueryHookResult = ReturnType<typeof useGetLocationSelectItemsLazyQuery>;
export type GetLocationSelectItemsSuspenseQueryHookResult = ReturnType<typeof useGetLocationSelectItemsSuspenseQuery>;
export type GetLocationSelectItemsQueryResult = Apollo.QueryResult<GetLocationSelectItemsQuery, GetLocationSelectItemsQueryVariables>;
export const SiteManagementLocationDocument = gql`
    query siteManagementLocation($filter: LocationFilter) {
  locations(filter: $filter) {
    edges {
      node {
        ...siteManagementLocation
      }
    }
  }
}
    ${SiteManagementLocationFragmentDoc}`;

/**
 * __useSiteManagementLocationQuery__
 *
 * To run a query within a React component, call `useSiteManagementLocationQuery` and pass it any options that fit your needs.
 * When your component renders, `useSiteManagementLocationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSiteManagementLocationQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useSiteManagementLocationQuery(baseOptions?: Apollo.QueryHookOptions<SiteManagementLocationQuery, SiteManagementLocationQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SiteManagementLocationQuery, SiteManagementLocationQueryVariables>(SiteManagementLocationDocument, options);
      }
export function useSiteManagementLocationLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SiteManagementLocationQuery, SiteManagementLocationQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SiteManagementLocationQuery, SiteManagementLocationQueryVariables>(SiteManagementLocationDocument, options);
        }
export function useSiteManagementLocationSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<SiteManagementLocationQuery, SiteManagementLocationQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<SiteManagementLocationQuery, SiteManagementLocationQueryVariables>(SiteManagementLocationDocument, options);
        }
export type SiteManagementLocationQueryHookResult = ReturnType<typeof useSiteManagementLocationQuery>;
export type SiteManagementLocationLazyQueryHookResult = ReturnType<typeof useSiteManagementLocationLazyQuery>;
export type SiteManagementLocationSuspenseQueryHookResult = ReturnType<typeof useSiteManagementLocationSuspenseQuery>;
export type SiteManagementLocationQueryResult = Apollo.QueryResult<SiteManagementLocationQuery, SiteManagementLocationQueryVariables>;
export const SiteManagementLocationsDocument = gql`
    query siteManagementLocations($first: Int, $last: Int, $after: String, $before: String, $filter: LocationFilter, $sort: LocationSort) {
  locations(
    first: $first
    last: $last
    after: $after
    before: $before
    filter: $filter
    sort: $sort
  ) {
    pageInfo {
      ...pageInfo
    }
    edges {
      cursor
      node {
        ...siteManagementLocation
      }
    }
  }
}
    ${PageInfoFragmentDoc}
${SiteManagementLocationFragmentDoc}`;

/**
 * __useSiteManagementLocationsQuery__
 *
 * To run a query within a React component, call `useSiteManagementLocationsQuery` and pass it any options that fit your needs.
 * When your component renders, `useSiteManagementLocationsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSiteManagementLocationsQuery({
 *   variables: {
 *      first: // value for 'first'
 *      last: // value for 'last'
 *      after: // value for 'after'
 *      before: // value for 'before'
 *      filter: // value for 'filter'
 *      sort: // value for 'sort'
 *   },
 * });
 */
export function useSiteManagementLocationsQuery(baseOptions?: Apollo.QueryHookOptions<SiteManagementLocationsQuery, SiteManagementLocationsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SiteManagementLocationsQuery, SiteManagementLocationsQueryVariables>(SiteManagementLocationsDocument, options);
      }
export function useSiteManagementLocationsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SiteManagementLocationsQuery, SiteManagementLocationsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SiteManagementLocationsQuery, SiteManagementLocationsQueryVariables>(SiteManagementLocationsDocument, options);
        }
export function useSiteManagementLocationsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<SiteManagementLocationsQuery, SiteManagementLocationsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<SiteManagementLocationsQuery, SiteManagementLocationsQueryVariables>(SiteManagementLocationsDocument, options);
        }
export type SiteManagementLocationsQueryHookResult = ReturnType<typeof useSiteManagementLocationsQuery>;
export type SiteManagementLocationsLazyQueryHookResult = ReturnType<typeof useSiteManagementLocationsLazyQuery>;
export type SiteManagementLocationsSuspenseQueryHookResult = ReturnType<typeof useSiteManagementLocationsSuspenseQuery>;
export type SiteManagementLocationsQueryResult = Apollo.QueryResult<SiteManagementLocationsQuery, SiteManagementLocationsQueryVariables>;
export const SitesSummaryDocument = gql`
    query sitesSummary {
  sitesSummary {
    ...sitesSummaryItem
  }
}
    ${SitesSummaryItemFragmentDoc}`;

/**
 * __useSitesSummaryQuery__
 *
 * To run a query within a React component, call `useSitesSummaryQuery` and pass it any options that fit your needs.
 * When your component renders, `useSitesSummaryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSitesSummaryQuery({
 *   variables: {
 *   },
 * });
 */
export function useSitesSummaryQuery(baseOptions?: Apollo.QueryHookOptions<SitesSummaryQuery, SitesSummaryQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SitesSummaryQuery, SitesSummaryQueryVariables>(SitesSummaryDocument, options);
      }
export function useSitesSummaryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SitesSummaryQuery, SitesSummaryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SitesSummaryQuery, SitesSummaryQueryVariables>(SitesSummaryDocument, options);
        }
export function useSitesSummarySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<SitesSummaryQuery, SitesSummaryQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<SitesSummaryQuery, SitesSummaryQueryVariables>(SitesSummaryDocument, options);
        }
export type SitesSummaryQueryHookResult = ReturnType<typeof useSitesSummaryQuery>;
export type SitesSummaryLazyQueryHookResult = ReturnType<typeof useSitesSummaryLazyQuery>;
export type SitesSummarySuspenseQueryHookResult = ReturnType<typeof useSitesSummarySuspenseQuery>;
export type SitesSummaryQueryResult = Apollo.QueryResult<SitesSummaryQuery, SitesSummaryQueryVariables>;
export const LocationGroupCreateDocument = gql`
    mutation locationGroupCreate($input: LocationGroupCreateInput!) {
  locationGroupCreate(input: $input) {
    ...locationGroup
  }
}
    ${LocationGroupFragmentDoc}`;
export type LocationGroupCreateMutationFn = Apollo.MutationFunction<LocationGroupCreateMutation, LocationGroupCreateMutationVariables>;

/**
 * __useLocationGroupCreateMutation__
 *
 * To run a mutation, you first call `useLocationGroupCreateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useLocationGroupCreateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [locationGroupCreateMutation, { data, loading, error }] = useLocationGroupCreateMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useLocationGroupCreateMutation(baseOptions?: Apollo.MutationHookOptions<LocationGroupCreateMutation, LocationGroupCreateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<LocationGroupCreateMutation, LocationGroupCreateMutationVariables>(LocationGroupCreateDocument, options);
      }
export type LocationGroupCreateMutationHookResult = ReturnType<typeof useLocationGroupCreateMutation>;
export type LocationGroupCreateMutationResult = Apollo.MutationResult<LocationGroupCreateMutation>;
export type LocationGroupCreateMutationOptions = Apollo.BaseMutationOptions<LocationGroupCreateMutation, LocationGroupCreateMutationVariables>;
export const LocationGroupUpdateDocument = gql`
    mutation locationGroupUpdate($input: LocationGroupUpdateInput!) {
  locationGroupUpdate(input: $input) {
    ...locationGroup
  }
}
    ${LocationGroupFragmentDoc}`;
export type LocationGroupUpdateMutationFn = Apollo.MutationFunction<LocationGroupUpdateMutation, LocationGroupUpdateMutationVariables>;

/**
 * __useLocationGroupUpdateMutation__
 *
 * To run a mutation, you first call `useLocationGroupUpdateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useLocationGroupUpdateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [locationGroupUpdateMutation, { data, loading, error }] = useLocationGroupUpdateMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useLocationGroupUpdateMutation(baseOptions?: Apollo.MutationHookOptions<LocationGroupUpdateMutation, LocationGroupUpdateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<LocationGroupUpdateMutation, LocationGroupUpdateMutationVariables>(LocationGroupUpdateDocument, options);
      }
export type LocationGroupUpdateMutationHookResult = ReturnType<typeof useLocationGroupUpdateMutation>;
export type LocationGroupUpdateMutationResult = Apollo.MutationResult<LocationGroupUpdateMutation>;
export type LocationGroupUpdateMutationOptions = Apollo.BaseMutationOptions<LocationGroupUpdateMutation, LocationGroupUpdateMutationVariables>;
export const LocationGroupDeleteDocument = gql`
    mutation locationGroupDelete($uuid: ID!) {
  locationGroupDelete(uuid: $uuid)
}
    `;
export type LocationGroupDeleteMutationFn = Apollo.MutationFunction<LocationGroupDeleteMutation, LocationGroupDeleteMutationVariables>;

/**
 * __useLocationGroupDeleteMutation__
 *
 * To run a mutation, you first call `useLocationGroupDeleteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useLocationGroupDeleteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [locationGroupDeleteMutation, { data, loading, error }] = useLocationGroupDeleteMutation({
 *   variables: {
 *      uuid: // value for 'uuid'
 *   },
 * });
 */
export function useLocationGroupDeleteMutation(baseOptions?: Apollo.MutationHookOptions<LocationGroupDeleteMutation, LocationGroupDeleteMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<LocationGroupDeleteMutation, LocationGroupDeleteMutationVariables>(LocationGroupDeleteDocument, options);
      }
export type LocationGroupDeleteMutationHookResult = ReturnType<typeof useLocationGroupDeleteMutation>;
export type LocationGroupDeleteMutationResult = Apollo.MutationResult<LocationGroupDeleteMutation>;
export type LocationGroupDeleteMutationOptions = Apollo.BaseMutationOptions<LocationGroupDeleteMutation, LocationGroupDeleteMutationVariables>;
export const AddLocationsToGroupDocument = gql`
    mutation addLocationsToGroup($input: AddLocationsToGroupInput!) {
  addLocationsToGroup(input: $input) {
    ...locationGroup
  }
}
    ${LocationGroupFragmentDoc}`;
export type AddLocationsToGroupMutationFn = Apollo.MutationFunction<AddLocationsToGroupMutation, AddLocationsToGroupMutationVariables>;

/**
 * __useAddLocationsToGroupMutation__
 *
 * To run a mutation, you first call `useAddLocationsToGroupMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddLocationsToGroupMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addLocationsToGroupMutation, { data, loading, error }] = useAddLocationsToGroupMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAddLocationsToGroupMutation(baseOptions?: Apollo.MutationHookOptions<AddLocationsToGroupMutation, AddLocationsToGroupMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddLocationsToGroupMutation, AddLocationsToGroupMutationVariables>(AddLocationsToGroupDocument, options);
      }
export type AddLocationsToGroupMutationHookResult = ReturnType<typeof useAddLocationsToGroupMutation>;
export type AddLocationsToGroupMutationResult = Apollo.MutationResult<AddLocationsToGroupMutation>;
export type AddLocationsToGroupMutationOptions = Apollo.BaseMutationOptions<AddLocationsToGroupMutation, AddLocationsToGroupMutationVariables>;
export const RemoveLocationsFromGroupDocument = gql`
    mutation removeLocationsFromGroup($input: RemoveLocationsFromGroupInput!) {
  removeLocationsFromGroup(input: $input) {
    ...locationGroup
  }
}
    ${LocationGroupFragmentDoc}`;
export type RemoveLocationsFromGroupMutationFn = Apollo.MutationFunction<RemoveLocationsFromGroupMutation, RemoveLocationsFromGroupMutationVariables>;

/**
 * __useRemoveLocationsFromGroupMutation__
 *
 * To run a mutation, you first call `useRemoveLocationsFromGroupMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveLocationsFromGroupMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeLocationsFromGroupMutation, { data, loading, error }] = useRemoveLocationsFromGroupMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useRemoveLocationsFromGroupMutation(baseOptions?: Apollo.MutationHookOptions<RemoveLocationsFromGroupMutation, RemoveLocationsFromGroupMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RemoveLocationsFromGroupMutation, RemoveLocationsFromGroupMutationVariables>(RemoveLocationsFromGroupDocument, options);
      }
export type RemoveLocationsFromGroupMutationHookResult = ReturnType<typeof useRemoveLocationsFromGroupMutation>;
export type RemoveLocationsFromGroupMutationResult = Apollo.MutationResult<RemoveLocationsFromGroupMutation>;
export type RemoveLocationsFromGroupMutationOptions = Apollo.BaseMutationOptions<RemoveLocationsFromGroupMutation, RemoveLocationsFromGroupMutationVariables>;
export const LocationGroupsDocument = gql`
    query locationGroups($first: Int, $last: Int, $after: String, $before: String, $filter: LocationGroupFilter) {
  locationGroups(
    first: $first
    last: $last
    after: $after
    before: $before
    filter: $filter
  ) {
    pageInfo {
      ...pageInfo
    }
    edges {
      cursor
      node {
        ...locationGroup
      }
    }
  }
}
    ${PageInfoFragmentDoc}
${LocationGroupFragmentDoc}`;

/**
 * __useLocationGroupsQuery__
 *
 * To run a query within a React component, call `useLocationGroupsQuery` and pass it any options that fit your needs.
 * When your component renders, `useLocationGroupsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useLocationGroupsQuery({
 *   variables: {
 *      first: // value for 'first'
 *      last: // value for 'last'
 *      after: // value for 'after'
 *      before: // value for 'before'
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useLocationGroupsQuery(baseOptions?: Apollo.QueryHookOptions<LocationGroupsQuery, LocationGroupsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<LocationGroupsQuery, LocationGroupsQueryVariables>(LocationGroupsDocument, options);
      }
export function useLocationGroupsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<LocationGroupsQuery, LocationGroupsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<LocationGroupsQuery, LocationGroupsQueryVariables>(LocationGroupsDocument, options);
        }
export function useLocationGroupsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<LocationGroupsQuery, LocationGroupsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<LocationGroupsQuery, LocationGroupsQueryVariables>(LocationGroupsDocument, options);
        }
export type LocationGroupsQueryHookResult = ReturnType<typeof useLocationGroupsQuery>;
export type LocationGroupsLazyQueryHookResult = ReturnType<typeof useLocationGroupsLazyQuery>;
export type LocationGroupsSuspenseQueryHookResult = ReturnType<typeof useLocationGroupsSuspenseQuery>;
export type LocationGroupsQueryResult = Apollo.QueryResult<LocationGroupsQuery, LocationGroupsQueryVariables>;
export const LoyaltyEventsListDocument = gql`
    query loyaltyEventsList($first: Int, $last: Int, $after: ID, $before: ID, $filter: OfferFilter) {
  offers(
    first: $first
    last: $last
    after: $after
    before: $before
    filter: $filter
  ) {
    pageInfo {
      ...pageInfo
    }
    edges {
      cursor
      node {
        ...loyaltyEventsListItem
      }
    }
  }
}
    ${PageInfoFragmentDoc}
${LoyaltyEventsListItemFragmentDoc}`;

/**
 * __useLoyaltyEventsListQuery__
 *
 * To run a query within a React component, call `useLoyaltyEventsListQuery` and pass it any options that fit your needs.
 * When your component renders, `useLoyaltyEventsListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useLoyaltyEventsListQuery({
 *   variables: {
 *      first: // value for 'first'
 *      last: // value for 'last'
 *      after: // value for 'after'
 *      before: // value for 'before'
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useLoyaltyEventsListQuery(baseOptions?: Apollo.QueryHookOptions<LoyaltyEventsListQuery, LoyaltyEventsListQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<LoyaltyEventsListQuery, LoyaltyEventsListQueryVariables>(LoyaltyEventsListDocument, options);
      }
export function useLoyaltyEventsListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<LoyaltyEventsListQuery, LoyaltyEventsListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<LoyaltyEventsListQuery, LoyaltyEventsListQueryVariables>(LoyaltyEventsListDocument, options);
        }
export function useLoyaltyEventsListSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<LoyaltyEventsListQuery, LoyaltyEventsListQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<LoyaltyEventsListQuery, LoyaltyEventsListQueryVariables>(LoyaltyEventsListDocument, options);
        }
export type LoyaltyEventsListQueryHookResult = ReturnType<typeof useLoyaltyEventsListQuery>;
export type LoyaltyEventsListLazyQueryHookResult = ReturnType<typeof useLoyaltyEventsListLazyQuery>;
export type LoyaltyEventsListSuspenseQueryHookResult = ReturnType<typeof useLoyaltyEventsListSuspenseQuery>;
export type LoyaltyEventsListQueryResult = Apollo.QueryResult<LoyaltyEventsListQuery, LoyaltyEventsListQueryVariables>;
export const MarketingContentCreateDocument = gql`
    mutation marketingContentCreate($input: MarketingContentCreateInput!) {
  marketingContentCreate(input: $input) {
    ...marketingContent
  }
}
    ${MarketingContentFragmentDoc}`;
export type MarketingContentCreateMutationFn = Apollo.MutationFunction<MarketingContentCreateMutation, MarketingContentCreateMutationVariables>;

/**
 * __useMarketingContentCreateMutation__
 *
 * To run a mutation, you first call `useMarketingContentCreateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useMarketingContentCreateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [marketingContentCreateMutation, { data, loading, error }] = useMarketingContentCreateMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useMarketingContentCreateMutation(baseOptions?: Apollo.MutationHookOptions<MarketingContentCreateMutation, MarketingContentCreateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<MarketingContentCreateMutation, MarketingContentCreateMutationVariables>(MarketingContentCreateDocument, options);
      }
export type MarketingContentCreateMutationHookResult = ReturnType<typeof useMarketingContentCreateMutation>;
export type MarketingContentCreateMutationResult = Apollo.MutationResult<MarketingContentCreateMutation>;
export type MarketingContentCreateMutationOptions = Apollo.BaseMutationOptions<MarketingContentCreateMutation, MarketingContentCreateMutationVariables>;
export const MarketingContentUpdateDocument = gql`
    mutation marketingContentUpdate($input: MarketingContentUpdateInput!) {
  marketingContentUpdate(input: $input) {
    ...marketingContent
  }
}
    ${MarketingContentFragmentDoc}`;
export type MarketingContentUpdateMutationFn = Apollo.MutationFunction<MarketingContentUpdateMutation, MarketingContentUpdateMutationVariables>;

/**
 * __useMarketingContentUpdateMutation__
 *
 * To run a mutation, you first call `useMarketingContentUpdateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useMarketingContentUpdateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [marketingContentUpdateMutation, { data, loading, error }] = useMarketingContentUpdateMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useMarketingContentUpdateMutation(baseOptions?: Apollo.MutationHookOptions<MarketingContentUpdateMutation, MarketingContentUpdateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<MarketingContentUpdateMutation, MarketingContentUpdateMutationVariables>(MarketingContentUpdateDocument, options);
      }
export type MarketingContentUpdateMutationHookResult = ReturnType<typeof useMarketingContentUpdateMutation>;
export type MarketingContentUpdateMutationResult = Apollo.MutationResult<MarketingContentUpdateMutation>;
export type MarketingContentUpdateMutationOptions = Apollo.BaseMutationOptions<MarketingContentUpdateMutation, MarketingContentUpdateMutationVariables>;
export const MembershipUpdateDocument = gql`
    mutation membershipUpdate($input: MembershipUpdate!) {
  membershipUpdate(input: $input) {
    ...membership
  }
}
    ${MembershipFragmentDoc}`;
export type MembershipUpdateMutationFn = Apollo.MutationFunction<MembershipUpdateMutation, MembershipUpdateMutationVariables>;

/**
 * __useMembershipUpdateMutation__
 *
 * To run a mutation, you first call `useMembershipUpdateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useMembershipUpdateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [membershipUpdateMutation, { data, loading, error }] = useMembershipUpdateMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useMembershipUpdateMutation(baseOptions?: Apollo.MutationHookOptions<MembershipUpdateMutation, MembershipUpdateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<MembershipUpdateMutation, MembershipUpdateMutationVariables>(MembershipUpdateDocument, options);
      }
export type MembershipUpdateMutationHookResult = ReturnType<typeof useMembershipUpdateMutation>;
export type MembershipUpdateMutationResult = Apollo.MutationResult<MembershipUpdateMutation>;
export type MembershipUpdateMutationOptions = Apollo.BaseMutationOptions<MembershipUpdateMutation, MembershipUpdateMutationVariables>;
export const MembershipAdjustPointsDocument = gql`
    mutation membershipAdjustPoints($input: MembershipAdjustPointsInput!) {
  membershipAdjustPoints(input: $input) {
    ...membership
  }
}
    ${MembershipFragmentDoc}`;
export type MembershipAdjustPointsMutationFn = Apollo.MutationFunction<MembershipAdjustPointsMutation, MembershipAdjustPointsMutationVariables>;

/**
 * __useMembershipAdjustPointsMutation__
 *
 * To run a mutation, you first call `useMembershipAdjustPointsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useMembershipAdjustPointsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [membershipAdjustPointsMutation, { data, loading, error }] = useMembershipAdjustPointsMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useMembershipAdjustPointsMutation(baseOptions?: Apollo.MutationHookOptions<MembershipAdjustPointsMutation, MembershipAdjustPointsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<MembershipAdjustPointsMutation, MembershipAdjustPointsMutationVariables>(MembershipAdjustPointsDocument, options);
      }
export type MembershipAdjustPointsMutationHookResult = ReturnType<typeof useMembershipAdjustPointsMutation>;
export type MembershipAdjustPointsMutationResult = Apollo.MutationResult<MembershipAdjustPointsMutation>;
export type MembershipAdjustPointsMutationOptions = Apollo.BaseMutationOptions<MembershipAdjustPointsMutation, MembershipAdjustPointsMutationVariables>;
export const MembershipStateTransitionDocument = gql`
    mutation membershipStateTransition($input: MembershipStateTransition!) {
  membershipStateTransition(input: $input) {
    ...membership
  }
}
    ${MembershipFragmentDoc}`;
export type MembershipStateTransitionMutationFn = Apollo.MutationFunction<MembershipStateTransitionMutation, MembershipStateTransitionMutationVariables>;

/**
 * __useMembershipStateTransitionMutation__
 *
 * To run a mutation, you first call `useMembershipStateTransitionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useMembershipStateTransitionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [membershipStateTransitionMutation, { data, loading, error }] = useMembershipStateTransitionMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useMembershipStateTransitionMutation(baseOptions?: Apollo.MutationHookOptions<MembershipStateTransitionMutation, MembershipStateTransitionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<MembershipStateTransitionMutation, MembershipStateTransitionMutationVariables>(MembershipStateTransitionDocument, options);
      }
export type MembershipStateTransitionMutationHookResult = ReturnType<typeof useMembershipStateTransitionMutation>;
export type MembershipStateTransitionMutationResult = Apollo.MutationResult<MembershipStateTransitionMutation>;
export type MembershipStateTransitionMutationOptions = Apollo.BaseMutationOptions<MembershipStateTransitionMutation, MembershipStateTransitionMutationVariables>;
export const MembershipHomeStoresCreateOrUpdateDocument = gql`
    mutation membershipHomeStoresCreateOrUpdate($input: MembershipHomeStoresCreateOrUpdateInput!) {
  membershipHomeStoresCreateOrUpdate(input: $input) {
    ...membership
  }
}
    ${MembershipFragmentDoc}`;
export type MembershipHomeStoresCreateOrUpdateMutationFn = Apollo.MutationFunction<MembershipHomeStoresCreateOrUpdateMutation, MembershipHomeStoresCreateOrUpdateMutationVariables>;

/**
 * __useMembershipHomeStoresCreateOrUpdateMutation__
 *
 * To run a mutation, you first call `useMembershipHomeStoresCreateOrUpdateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useMembershipHomeStoresCreateOrUpdateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [membershipHomeStoresCreateOrUpdateMutation, { data, loading, error }] = useMembershipHomeStoresCreateOrUpdateMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useMembershipHomeStoresCreateOrUpdateMutation(baseOptions?: Apollo.MutationHookOptions<MembershipHomeStoresCreateOrUpdateMutation, MembershipHomeStoresCreateOrUpdateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<MembershipHomeStoresCreateOrUpdateMutation, MembershipHomeStoresCreateOrUpdateMutationVariables>(MembershipHomeStoresCreateOrUpdateDocument, options);
      }
export type MembershipHomeStoresCreateOrUpdateMutationHookResult = ReturnType<typeof useMembershipHomeStoresCreateOrUpdateMutation>;
export type MembershipHomeStoresCreateOrUpdateMutationResult = Apollo.MutationResult<MembershipHomeStoresCreateOrUpdateMutation>;
export type MembershipHomeStoresCreateOrUpdateMutationOptions = Apollo.BaseMutationOptions<MembershipHomeStoresCreateOrUpdateMutation, MembershipHomeStoresCreateOrUpdateMutationVariables>;
export const CreateMembershipCommentDocument = gql`
    mutation createMembershipComment($input: MembershipProfileCommentCreateInput!) {
  membershipProfileCommentCreate(input: $input) {
    ...membershipComment
  }
}
    ${MembershipCommentFragmentDoc}`;
export type CreateMembershipCommentMutationFn = Apollo.MutationFunction<CreateMembershipCommentMutation, CreateMembershipCommentMutationVariables>;

/**
 * __useCreateMembershipCommentMutation__
 *
 * To run a mutation, you first call `useCreateMembershipCommentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateMembershipCommentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createMembershipCommentMutation, { data, loading, error }] = useCreateMembershipCommentMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateMembershipCommentMutation(baseOptions?: Apollo.MutationHookOptions<CreateMembershipCommentMutation, CreateMembershipCommentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateMembershipCommentMutation, CreateMembershipCommentMutationVariables>(CreateMembershipCommentDocument, options);
      }
export type CreateMembershipCommentMutationHookResult = ReturnType<typeof useCreateMembershipCommentMutation>;
export type CreateMembershipCommentMutationResult = Apollo.MutationResult<CreateMembershipCommentMutation>;
export type CreateMembershipCommentMutationOptions = Apollo.BaseMutationOptions<CreateMembershipCommentMutation, CreateMembershipCommentMutationVariables>;
export const LoyaltyEventCreateDocument = gql`
    mutation loyaltyEventCreate($input: LoyaltyEventCreate!) {
  event: loyaltyEventCreate(input: $input) {
    eventData
    eventType
    createdAt
  }
}
    `;
export type LoyaltyEventCreateMutationFn = Apollo.MutationFunction<LoyaltyEventCreateMutation, LoyaltyEventCreateMutationVariables>;

/**
 * __useLoyaltyEventCreateMutation__
 *
 * To run a mutation, you first call `useLoyaltyEventCreateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useLoyaltyEventCreateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [loyaltyEventCreateMutation, { data, loading, error }] = useLoyaltyEventCreateMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useLoyaltyEventCreateMutation(baseOptions?: Apollo.MutationHookOptions<LoyaltyEventCreateMutation, LoyaltyEventCreateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<LoyaltyEventCreateMutation, LoyaltyEventCreateMutationVariables>(LoyaltyEventCreateDocument, options);
      }
export type LoyaltyEventCreateMutationHookResult = ReturnType<typeof useLoyaltyEventCreateMutation>;
export type LoyaltyEventCreateMutationResult = Apollo.MutationResult<LoyaltyEventCreateMutation>;
export type LoyaltyEventCreateMutationOptions = Apollo.BaseMutationOptions<LoyaltyEventCreateMutation, LoyaltyEventCreateMutationVariables>;
export const DeleteMembershipScrubDataDocument = gql`
    mutation deleteMembershipScrubData($input: ScrubDataInput!) {
  scrubData(input: $input)
}
    `;
export type DeleteMembershipScrubDataMutationFn = Apollo.MutationFunction<DeleteMembershipScrubDataMutation, DeleteMembershipScrubDataMutationVariables>;

/**
 * __useDeleteMembershipScrubDataMutation__
 *
 * To run a mutation, you first call `useDeleteMembershipScrubDataMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteMembershipScrubDataMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteMembershipScrubDataMutation, { data, loading, error }] = useDeleteMembershipScrubDataMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDeleteMembershipScrubDataMutation(baseOptions?: Apollo.MutationHookOptions<DeleteMembershipScrubDataMutation, DeleteMembershipScrubDataMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteMembershipScrubDataMutation, DeleteMembershipScrubDataMutationVariables>(DeleteMembershipScrubDataDocument, options);
      }
export type DeleteMembershipScrubDataMutationHookResult = ReturnType<typeof useDeleteMembershipScrubDataMutation>;
export type DeleteMembershipScrubDataMutationResult = Apollo.MutationResult<DeleteMembershipScrubDataMutation>;
export type DeleteMembershipScrubDataMutationOptions = Apollo.BaseMutationOptions<DeleteMembershipScrubDataMutation, DeleteMembershipScrubDataMutationVariables>;
export const DeleteMembershipDocument = gql`
    mutation deleteMembership($input: MembershipDeleteInput!) {
  membershipDelete(input: $input)
}
    `;
export type DeleteMembershipMutationFn = Apollo.MutationFunction<DeleteMembershipMutation, DeleteMembershipMutationVariables>;

/**
 * __useDeleteMembershipMutation__
 *
 * To run a mutation, you first call `useDeleteMembershipMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteMembershipMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteMembershipMutation, { data, loading, error }] = useDeleteMembershipMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDeleteMembershipMutation(baseOptions?: Apollo.MutationHookOptions<DeleteMembershipMutation, DeleteMembershipMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteMembershipMutation, DeleteMembershipMutationVariables>(DeleteMembershipDocument, options);
      }
export type DeleteMembershipMutationHookResult = ReturnType<typeof useDeleteMembershipMutation>;
export type DeleteMembershipMutationResult = Apollo.MutationResult<DeleteMembershipMutation>;
export type DeleteMembershipMutationOptions = Apollo.BaseMutationOptions<DeleteMembershipMutation, DeleteMembershipMutationVariables>;
export const MembershipDocument = gql`
    query membership($filter: MembershipFilter) {
  memberships(filter: $filter) {
    edges {
      cursor
      node {
        ...membership
      }
    }
  }
}
    ${MembershipFragmentDoc}`;

/**
 * __useMembershipQuery__
 *
 * To run a query within a React component, call `useMembershipQuery` and pass it any options that fit your needs.
 * When your component renders, `useMembershipQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMembershipQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useMembershipQuery(baseOptions?: Apollo.QueryHookOptions<MembershipQuery, MembershipQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<MembershipQuery, MembershipQueryVariables>(MembershipDocument, options);
      }
export function useMembershipLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MembershipQuery, MembershipQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<MembershipQuery, MembershipQueryVariables>(MembershipDocument, options);
        }
export function useMembershipSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<MembershipQuery, MembershipQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<MembershipQuery, MembershipQueryVariables>(MembershipDocument, options);
        }
export type MembershipQueryHookResult = ReturnType<typeof useMembershipQuery>;
export type MembershipLazyQueryHookResult = ReturnType<typeof useMembershipLazyQuery>;
export type MembershipSuspenseQueryHookResult = ReturnType<typeof useMembershipSuspenseQuery>;
export type MembershipQueryResult = Apollo.QueryResult<MembershipQuery, MembershipQueryVariables>;
export const MembershipListDocument = gql`
    query membershipList($first: Int, $last: Int, $after: ID, $before: ID, $filter: MembershipFilter) {
  memberships(
    first: $first
    last: $last
    after: $after
    before: $before
    filter: $filter
  ) {
    pageInfo {
      ...pageInfo
    }
    edges {
      cursor
      node {
        ...membershipItem
      }
    }
  }
}
    ${PageInfoFragmentDoc}
${MembershipItemFragmentDoc}`;

/**
 * __useMembershipListQuery__
 *
 * To run a query within a React component, call `useMembershipListQuery` and pass it any options that fit your needs.
 * When your component renders, `useMembershipListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMembershipListQuery({
 *   variables: {
 *      first: // value for 'first'
 *      last: // value for 'last'
 *      after: // value for 'after'
 *      before: // value for 'before'
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useMembershipListQuery(baseOptions?: Apollo.QueryHookOptions<MembershipListQuery, MembershipListQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<MembershipListQuery, MembershipListQueryVariables>(MembershipListDocument, options);
      }
export function useMembershipListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MembershipListQuery, MembershipListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<MembershipListQuery, MembershipListQueryVariables>(MembershipListDocument, options);
        }
export function useMembershipListSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<MembershipListQuery, MembershipListQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<MembershipListQuery, MembershipListQueryVariables>(MembershipListDocument, options);
        }
export type MembershipListQueryHookResult = ReturnType<typeof useMembershipListQuery>;
export type MembershipListLazyQueryHookResult = ReturnType<typeof useMembershipListLazyQuery>;
export type MembershipListSuspenseQueryHookResult = ReturnType<typeof useMembershipListSuspenseQuery>;
export type MembershipListQueryResult = Apollo.QueryResult<MembershipListQuery, MembershipListQueryVariables>;
export const MembershipLoyaltyEventsDocument = gql`
    query membershipLoyaltyEvents($membershipId: ID!, $first: Int, $last: Int, $after: ID, $before: ID, $filter: LoyaltyEventFilter) {
  memberships(first: 1, filter: {idEquals: $membershipId}) {
    edges {
      node {
        loyaltyEvents(
          first: $first
          last: $last
          after: $after
          before: $before
          filter: $filter
        ) {
          pageInfo {
            hasNextPage
            hasPreviousPage
            startCursor
            endCursor
          }
          edges {
            cursor
            node {
              ...loyaltyEventItem
            }
          }
        }
      }
    }
  }
}
    ${LoyaltyEventItemFragmentDoc}`;

/**
 * __useMembershipLoyaltyEventsQuery__
 *
 * To run a query within a React component, call `useMembershipLoyaltyEventsQuery` and pass it any options that fit your needs.
 * When your component renders, `useMembershipLoyaltyEventsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMembershipLoyaltyEventsQuery({
 *   variables: {
 *      membershipId: // value for 'membershipId'
 *      first: // value for 'first'
 *      last: // value for 'last'
 *      after: // value for 'after'
 *      before: // value for 'before'
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useMembershipLoyaltyEventsQuery(baseOptions: Apollo.QueryHookOptions<MembershipLoyaltyEventsQuery, MembershipLoyaltyEventsQueryVariables> & ({ variables: MembershipLoyaltyEventsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<MembershipLoyaltyEventsQuery, MembershipLoyaltyEventsQueryVariables>(MembershipLoyaltyEventsDocument, options);
      }
export function useMembershipLoyaltyEventsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MembershipLoyaltyEventsQuery, MembershipLoyaltyEventsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<MembershipLoyaltyEventsQuery, MembershipLoyaltyEventsQueryVariables>(MembershipLoyaltyEventsDocument, options);
        }
export function useMembershipLoyaltyEventsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<MembershipLoyaltyEventsQuery, MembershipLoyaltyEventsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<MembershipLoyaltyEventsQuery, MembershipLoyaltyEventsQueryVariables>(MembershipLoyaltyEventsDocument, options);
        }
export type MembershipLoyaltyEventsQueryHookResult = ReturnType<typeof useMembershipLoyaltyEventsQuery>;
export type MembershipLoyaltyEventsLazyQueryHookResult = ReturnType<typeof useMembershipLoyaltyEventsLazyQuery>;
export type MembershipLoyaltyEventsSuspenseQueryHookResult = ReturnType<typeof useMembershipLoyaltyEventsSuspenseQuery>;
export type MembershipLoyaltyEventsQueryResult = Apollo.QueryResult<MembershipLoyaltyEventsQuery, MembershipLoyaltyEventsQueryVariables>;
export const AudiencesForMembershipDocument = gql`
    query audiencesForMembership($membershipId: ID!) {
  audiencesForMembership(membershipId: $membershipId) {
    ...audienceForMembership
  }
}
    ${AudienceForMembershipFragmentDoc}`;

/**
 * __useAudiencesForMembershipQuery__
 *
 * To run a query within a React component, call `useAudiencesForMembershipQuery` and pass it any options that fit your needs.
 * When your component renders, `useAudiencesForMembershipQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAudiencesForMembershipQuery({
 *   variables: {
 *      membershipId: // value for 'membershipId'
 *   },
 * });
 */
export function useAudiencesForMembershipQuery(baseOptions: Apollo.QueryHookOptions<AudiencesForMembershipQuery, AudiencesForMembershipQueryVariables> & ({ variables: AudiencesForMembershipQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AudiencesForMembershipQuery, AudiencesForMembershipQueryVariables>(AudiencesForMembershipDocument, options);
      }
export function useAudiencesForMembershipLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AudiencesForMembershipQuery, AudiencesForMembershipQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AudiencesForMembershipQuery, AudiencesForMembershipQueryVariables>(AudiencesForMembershipDocument, options);
        }
export function useAudiencesForMembershipSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<AudiencesForMembershipQuery, AudiencesForMembershipQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<AudiencesForMembershipQuery, AudiencesForMembershipQueryVariables>(AudiencesForMembershipDocument, options);
        }
export type AudiencesForMembershipQueryHookResult = ReturnType<typeof useAudiencesForMembershipQuery>;
export type AudiencesForMembershipLazyQueryHookResult = ReturnType<typeof useAudiencesForMembershipLazyQuery>;
export type AudiencesForMembershipSuspenseQueryHookResult = ReturnType<typeof useAudiencesForMembershipSuspenseQuery>;
export type AudiencesForMembershipQueryResult = Apollo.QueryResult<AudiencesForMembershipQuery, AudiencesForMembershipQueryVariables>;
export const AudiencesForMembershipWithPaginationDocument = gql`
    query audiencesForMembershipWithPagination($first: Int, $last: Int, $after: ID, $before: ID, $filter: AudienceForMembershipFilter) {
  audiencesForMembershipWithPagination(
    first: $first
    last: $last
    after: $after
    before: $before
    filter: $filter
  ) {
    pageInfo {
      ...pageInfo
    }
    edges {
      cursor
      node {
        ...audienceForMembership
      }
    }
  }
}
    ${PageInfoFragmentDoc}
${AudienceForMembershipFragmentDoc}`;

/**
 * __useAudiencesForMembershipWithPaginationQuery__
 *
 * To run a query within a React component, call `useAudiencesForMembershipWithPaginationQuery` and pass it any options that fit your needs.
 * When your component renders, `useAudiencesForMembershipWithPaginationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAudiencesForMembershipWithPaginationQuery({
 *   variables: {
 *      first: // value for 'first'
 *      last: // value for 'last'
 *      after: // value for 'after'
 *      before: // value for 'before'
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useAudiencesForMembershipWithPaginationQuery(baseOptions?: Apollo.QueryHookOptions<AudiencesForMembershipWithPaginationQuery, AudiencesForMembershipWithPaginationQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AudiencesForMembershipWithPaginationQuery, AudiencesForMembershipWithPaginationQueryVariables>(AudiencesForMembershipWithPaginationDocument, options);
      }
export function useAudiencesForMembershipWithPaginationLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AudiencesForMembershipWithPaginationQuery, AudiencesForMembershipWithPaginationQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AudiencesForMembershipWithPaginationQuery, AudiencesForMembershipWithPaginationQueryVariables>(AudiencesForMembershipWithPaginationDocument, options);
        }
export function useAudiencesForMembershipWithPaginationSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<AudiencesForMembershipWithPaginationQuery, AudiencesForMembershipWithPaginationQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<AudiencesForMembershipWithPaginationQuery, AudiencesForMembershipWithPaginationQueryVariables>(AudiencesForMembershipWithPaginationDocument, options);
        }
export type AudiencesForMembershipWithPaginationQueryHookResult = ReturnType<typeof useAudiencesForMembershipWithPaginationQuery>;
export type AudiencesForMembershipWithPaginationLazyQueryHookResult = ReturnType<typeof useAudiencesForMembershipWithPaginationLazyQuery>;
export type AudiencesForMembershipWithPaginationSuspenseQueryHookResult = ReturnType<typeof useAudiencesForMembershipWithPaginationSuspenseQuery>;
export type AudiencesForMembershipWithPaginationQueryResult = Apollo.QueryResult<AudiencesForMembershipWithPaginationQuery, AudiencesForMembershipWithPaginationQueryVariables>;
export const MembershipOffersDocument = gql`
    query membershipOffers($membershipId: ID!, $first: Int, $last: Int, $after: ID, $before: ID, $filter: OfferFilter) {
  memberships(first: 1, filter: {idEquals: $membershipId}) {
    edges {
      node {
        id
        offers(
          first: $first
          last: $last
          after: $after
          before: $before
          filter: $filter
        ) {
          pageInfo {
            hasNextPage
            hasPreviousPage
            startCursor
            endCursor
          }
          edges {
            cursor
            node {
              ...membershipOffer
            }
          }
        }
      }
    }
  }
}
    ${MembershipOfferFragmentDoc}`;

/**
 * __useMembershipOffersQuery__
 *
 * To run a query within a React component, call `useMembershipOffersQuery` and pass it any options that fit your needs.
 * When your component renders, `useMembershipOffersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMembershipOffersQuery({
 *   variables: {
 *      membershipId: // value for 'membershipId'
 *      first: // value for 'first'
 *      last: // value for 'last'
 *      after: // value for 'after'
 *      before: // value for 'before'
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useMembershipOffersQuery(baseOptions: Apollo.QueryHookOptions<MembershipOffersQuery, MembershipOffersQueryVariables> & ({ variables: MembershipOffersQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<MembershipOffersQuery, MembershipOffersQueryVariables>(MembershipOffersDocument, options);
      }
export function useMembershipOffersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MembershipOffersQuery, MembershipOffersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<MembershipOffersQuery, MembershipOffersQueryVariables>(MembershipOffersDocument, options);
        }
export function useMembershipOffersSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<MembershipOffersQuery, MembershipOffersQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<MembershipOffersQuery, MembershipOffersQueryVariables>(MembershipOffersDocument, options);
        }
export type MembershipOffersQueryHookResult = ReturnType<typeof useMembershipOffersQuery>;
export type MembershipOffersLazyQueryHookResult = ReturnType<typeof useMembershipOffersLazyQuery>;
export type MembershipOffersSuspenseQueryHookResult = ReturnType<typeof useMembershipOffersSuspenseQuery>;
export type MembershipOffersQueryResult = Apollo.QueryResult<MembershipOffersQuery, MembershipOffersQueryVariables>;
export const MembershipVouchersDocument = gql`
    query membershipVouchers($membershipId: ID!, $first: Int, $last: Int, $after: ID, $before: ID, $filter: VoucherFilter, $sort: VoucherSort) {
  memberships(filter: {idEquals: $membershipId}) {
    edges {
      node {
        id
        vouchers(
          first: $first
          last: $last
          after: $after
          before: $before
          filter: $filter
          sort: $sort
        ) {
          pageInfo {
            hasNextPage
            hasPreviousPage
            startCursor
            endCursor
          }
          edges {
            cursor
            node {
              ...membershipVoucher
            }
          }
        }
      }
    }
  }
}
    ${MembershipVoucherFragmentDoc}`;

/**
 * __useMembershipVouchersQuery__
 *
 * To run a query within a React component, call `useMembershipVouchersQuery` and pass it any options that fit your needs.
 * When your component renders, `useMembershipVouchersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMembershipVouchersQuery({
 *   variables: {
 *      membershipId: // value for 'membershipId'
 *      first: // value for 'first'
 *      last: // value for 'last'
 *      after: // value for 'after'
 *      before: // value for 'before'
 *      filter: // value for 'filter'
 *      sort: // value for 'sort'
 *   },
 * });
 */
export function useMembershipVouchersQuery(baseOptions: Apollo.QueryHookOptions<MembershipVouchersQuery, MembershipVouchersQueryVariables> & ({ variables: MembershipVouchersQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<MembershipVouchersQuery, MembershipVouchersQueryVariables>(MembershipVouchersDocument, options);
      }
export function useMembershipVouchersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MembershipVouchersQuery, MembershipVouchersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<MembershipVouchersQuery, MembershipVouchersQueryVariables>(MembershipVouchersDocument, options);
        }
export function useMembershipVouchersSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<MembershipVouchersQuery, MembershipVouchersQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<MembershipVouchersQuery, MembershipVouchersQueryVariables>(MembershipVouchersDocument, options);
        }
export type MembershipVouchersQueryHookResult = ReturnType<typeof useMembershipVouchersQuery>;
export type MembershipVouchersLazyQueryHookResult = ReturnType<typeof useMembershipVouchersLazyQuery>;
export type MembershipVouchersSuspenseQueryHookResult = ReturnType<typeof useMembershipVouchersSuspenseQuery>;
export type MembershipVouchersQueryResult = Apollo.QueryResult<MembershipVouchersQuery, MembershipVouchersQueryVariables>;
export const MembershipTransactionsDocument = gql`
    query membershipTransactions($membershipId: ID!, $first: Int, $last: Int, $after: ID, $before: ID, $filter: ActivateTransactionFilter, $sort: ActivateTransactionSort) {
  memberships(first: 1, filter: {idEquals: $membershipId}) {
    edges {
      node {
        id
        transactions(
          first: $first
          last: $last
          after: $after
          before: $before
          filter: $filter
          sort: $sort
        ) {
          pageInfo {
            hasNextPage
            hasPreviousPage
            startCursor
            endCursor
          }
          edges {
            cursor
            node {
              ...transactionItem
            }
          }
        }
      }
    }
  }
}
    ${TransactionItemFragmentDoc}`;

/**
 * __useMembershipTransactionsQuery__
 *
 * To run a query within a React component, call `useMembershipTransactionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useMembershipTransactionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMembershipTransactionsQuery({
 *   variables: {
 *      membershipId: // value for 'membershipId'
 *      first: // value for 'first'
 *      last: // value for 'last'
 *      after: // value for 'after'
 *      before: // value for 'before'
 *      filter: // value for 'filter'
 *      sort: // value for 'sort'
 *   },
 * });
 */
export function useMembershipTransactionsQuery(baseOptions: Apollo.QueryHookOptions<MembershipTransactionsQuery, MembershipTransactionsQueryVariables> & ({ variables: MembershipTransactionsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<MembershipTransactionsQuery, MembershipTransactionsQueryVariables>(MembershipTransactionsDocument, options);
      }
export function useMembershipTransactionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MembershipTransactionsQuery, MembershipTransactionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<MembershipTransactionsQuery, MembershipTransactionsQueryVariables>(MembershipTransactionsDocument, options);
        }
export function useMembershipTransactionsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<MembershipTransactionsQuery, MembershipTransactionsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<MembershipTransactionsQuery, MembershipTransactionsQueryVariables>(MembershipTransactionsDocument, options);
        }
export type MembershipTransactionsQueryHookResult = ReturnType<typeof useMembershipTransactionsQuery>;
export type MembershipTransactionsLazyQueryHookResult = ReturnType<typeof useMembershipTransactionsLazyQuery>;
export type MembershipTransactionsSuspenseQueryHookResult = ReturnType<typeof useMembershipTransactionsSuspenseQuery>;
export type MembershipTransactionsQueryResult = Apollo.QueryResult<MembershipTransactionsQuery, MembershipTransactionsQueryVariables>;
export const SegmentsByMembershipUuidDocument = gql`
    query segmentsByMembershipUuid($first: Int, $last: Int, $after: String, $before: String, $filter: SegmentForMembershipFilter!) {
  segmentsByMembershipUuid(
    first: $first
    last: $last
    after: $after
    before: $before
    filter: $filter
  ) {
    pageInfo {
      ...pageInfo
    }
    edges {
      cursor
      node {
        ...segmentByMembershipUuid
      }
    }
  }
}
    ${PageInfoFragmentDoc}
${SegmentByMembershipUuidFragmentDoc}`;

/**
 * __useSegmentsByMembershipUuidQuery__
 *
 * To run a query within a React component, call `useSegmentsByMembershipUuidQuery` and pass it any options that fit your needs.
 * When your component renders, `useSegmentsByMembershipUuidQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSegmentsByMembershipUuidQuery({
 *   variables: {
 *      first: // value for 'first'
 *      last: // value for 'last'
 *      after: // value for 'after'
 *      before: // value for 'before'
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useSegmentsByMembershipUuidQuery(baseOptions: Apollo.QueryHookOptions<SegmentsByMembershipUuidQuery, SegmentsByMembershipUuidQueryVariables> & ({ variables: SegmentsByMembershipUuidQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SegmentsByMembershipUuidQuery, SegmentsByMembershipUuidQueryVariables>(SegmentsByMembershipUuidDocument, options);
      }
export function useSegmentsByMembershipUuidLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SegmentsByMembershipUuidQuery, SegmentsByMembershipUuidQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SegmentsByMembershipUuidQuery, SegmentsByMembershipUuidQueryVariables>(SegmentsByMembershipUuidDocument, options);
        }
export function useSegmentsByMembershipUuidSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<SegmentsByMembershipUuidQuery, SegmentsByMembershipUuidQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<SegmentsByMembershipUuidQuery, SegmentsByMembershipUuidQueryVariables>(SegmentsByMembershipUuidDocument, options);
        }
export type SegmentsByMembershipUuidQueryHookResult = ReturnType<typeof useSegmentsByMembershipUuidQuery>;
export type SegmentsByMembershipUuidLazyQueryHookResult = ReturnType<typeof useSegmentsByMembershipUuidLazyQuery>;
export type SegmentsByMembershipUuidSuspenseQueryHookResult = ReturnType<typeof useSegmentsByMembershipUuidSuspenseQuery>;
export type SegmentsByMembershipUuidQueryResult = Apollo.QueryResult<SegmentsByMembershipUuidQuery, SegmentsByMembershipUuidQueryVariables>;
export const MembershipCommentsDocument = gql`
    query membershipComments($membershipId: ID!, $first: Int, $last: Int, $after: ID, $before: ID, $filter: MembershipProfileCommentFilter) {
  memberships(first: 1, filter: {idEquals: $membershipId}) {
    edges {
      node {
        id
        comments(
          first: $first
          last: $last
          after: $after
          before: $before
          filter: $filter
        ) {
          pageInfo {
            hasNextPage
            hasPreviousPage
            startCursor
            endCursor
          }
          edges {
            cursor
            node {
              ...membershipComment
            }
          }
        }
      }
    }
  }
}
    ${MembershipCommentFragmentDoc}`;

/**
 * __useMembershipCommentsQuery__
 *
 * To run a query within a React component, call `useMembershipCommentsQuery` and pass it any options that fit your needs.
 * When your component renders, `useMembershipCommentsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMembershipCommentsQuery({
 *   variables: {
 *      membershipId: // value for 'membershipId'
 *      first: // value for 'first'
 *      last: // value for 'last'
 *      after: // value for 'after'
 *      before: // value for 'before'
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useMembershipCommentsQuery(baseOptions: Apollo.QueryHookOptions<MembershipCommentsQuery, MembershipCommentsQueryVariables> & ({ variables: MembershipCommentsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<MembershipCommentsQuery, MembershipCommentsQueryVariables>(MembershipCommentsDocument, options);
      }
export function useMembershipCommentsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MembershipCommentsQuery, MembershipCommentsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<MembershipCommentsQuery, MembershipCommentsQueryVariables>(MembershipCommentsDocument, options);
        }
export function useMembershipCommentsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<MembershipCommentsQuery, MembershipCommentsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<MembershipCommentsQuery, MembershipCommentsQueryVariables>(MembershipCommentsDocument, options);
        }
export type MembershipCommentsQueryHookResult = ReturnType<typeof useMembershipCommentsQuery>;
export type MembershipCommentsLazyQueryHookResult = ReturnType<typeof useMembershipCommentsLazyQuery>;
export type MembershipCommentsSuspenseQueryHookResult = ReturnType<typeof useMembershipCommentsSuspenseQuery>;
export type MembershipCommentsQueryResult = Apollo.QueryResult<MembershipCommentsQuery, MembershipCommentsQueryVariables>;
export const RetailerNetworkLocationsForMemberDocument = gql`
    query retailerNetworkLocationsForMember($first: Int, $after: OCBase64Cursor, $last: Int, $before: OCBase64Cursor, $memberUuid: OCUUID!) {
  retailerNetworkLocationsForMember(
    first: $first
    after: $after
    last: $last
    before: $before
    memberUuid: $memberUuid
  ) {
    edges {
      node {
        ...retailerNetworkLocationForMember
      }
    }
    pageInfo {
      ...pageInfo
    }
  }
}
    ${RetailerNetworkLocationForMemberFragmentDoc}
${PageInfoFragmentDoc}`;

/**
 * __useRetailerNetworkLocationsForMemberQuery__
 *
 * To run a query within a React component, call `useRetailerNetworkLocationsForMemberQuery` and pass it any options that fit your needs.
 * When your component renders, `useRetailerNetworkLocationsForMemberQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useRetailerNetworkLocationsForMemberQuery({
 *   variables: {
 *      first: // value for 'first'
 *      after: // value for 'after'
 *      last: // value for 'last'
 *      before: // value for 'before'
 *      memberUuid: // value for 'memberUuid'
 *   },
 * });
 */
export function useRetailerNetworkLocationsForMemberQuery(baseOptions: Apollo.QueryHookOptions<RetailerNetworkLocationsForMemberQuery, RetailerNetworkLocationsForMemberQueryVariables> & ({ variables: RetailerNetworkLocationsForMemberQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<RetailerNetworkLocationsForMemberQuery, RetailerNetworkLocationsForMemberQueryVariables>(RetailerNetworkLocationsForMemberDocument, options);
      }
export function useRetailerNetworkLocationsForMemberLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<RetailerNetworkLocationsForMemberQuery, RetailerNetworkLocationsForMemberQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<RetailerNetworkLocationsForMemberQuery, RetailerNetworkLocationsForMemberQueryVariables>(RetailerNetworkLocationsForMemberDocument, options);
        }
export function useRetailerNetworkLocationsForMemberSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<RetailerNetworkLocationsForMemberQuery, RetailerNetworkLocationsForMemberQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<RetailerNetworkLocationsForMemberQuery, RetailerNetworkLocationsForMemberQueryVariables>(RetailerNetworkLocationsForMemberDocument, options);
        }
export type RetailerNetworkLocationsForMemberQueryHookResult = ReturnType<typeof useRetailerNetworkLocationsForMemberQuery>;
export type RetailerNetworkLocationsForMemberLazyQueryHookResult = ReturnType<typeof useRetailerNetworkLocationsForMemberLazyQuery>;
export type RetailerNetworkLocationsForMemberSuspenseQueryHookResult = ReturnType<typeof useRetailerNetworkLocationsForMemberSuspenseQuery>;
export type RetailerNetworkLocationsForMemberQueryResult = Apollo.QueryResult<RetailerNetworkLocationsForMemberQuery, RetailerNetworkLocationsForMemberQueryVariables>;
export const RetailerNetworkLocationGroupsForMemberDocument = gql`
    query retailerNetworkLocationGroupsForMember($first: Int, $after: OCBase64Cursor, $last: Int, $before: OCBase64Cursor, $memberUuid: OCUUID!) {
  retailerNetworkLocationGroupsForMember(
    first: $first
    after: $after
    last: $last
    before: $before
    memberUuid: $memberUuid
  ) {
    edges {
      node {
        ...retailerNetworkLocationGroupForMember
      }
    }
    pageInfo {
      ...pageInfo
    }
  }
}
    ${RetailerNetworkLocationGroupForMemberFragmentDoc}
${PageInfoFragmentDoc}`;

/**
 * __useRetailerNetworkLocationGroupsForMemberQuery__
 *
 * To run a query within a React component, call `useRetailerNetworkLocationGroupsForMemberQuery` and pass it any options that fit your needs.
 * When your component renders, `useRetailerNetworkLocationGroupsForMemberQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useRetailerNetworkLocationGroupsForMemberQuery({
 *   variables: {
 *      first: // value for 'first'
 *      after: // value for 'after'
 *      last: // value for 'last'
 *      before: // value for 'before'
 *      memberUuid: // value for 'memberUuid'
 *   },
 * });
 */
export function useRetailerNetworkLocationGroupsForMemberQuery(baseOptions: Apollo.QueryHookOptions<RetailerNetworkLocationGroupsForMemberQuery, RetailerNetworkLocationGroupsForMemberQueryVariables> & ({ variables: RetailerNetworkLocationGroupsForMemberQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<RetailerNetworkLocationGroupsForMemberQuery, RetailerNetworkLocationGroupsForMemberQueryVariables>(RetailerNetworkLocationGroupsForMemberDocument, options);
      }
export function useRetailerNetworkLocationGroupsForMemberLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<RetailerNetworkLocationGroupsForMemberQuery, RetailerNetworkLocationGroupsForMemberQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<RetailerNetworkLocationGroupsForMemberQuery, RetailerNetworkLocationGroupsForMemberQueryVariables>(RetailerNetworkLocationGroupsForMemberDocument, options);
        }
export function useRetailerNetworkLocationGroupsForMemberSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<RetailerNetworkLocationGroupsForMemberQuery, RetailerNetworkLocationGroupsForMemberQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<RetailerNetworkLocationGroupsForMemberQuery, RetailerNetworkLocationGroupsForMemberQueryVariables>(RetailerNetworkLocationGroupsForMemberDocument, options);
        }
export type RetailerNetworkLocationGroupsForMemberQueryHookResult = ReturnType<typeof useRetailerNetworkLocationGroupsForMemberQuery>;
export type RetailerNetworkLocationGroupsForMemberLazyQueryHookResult = ReturnType<typeof useRetailerNetworkLocationGroupsForMemberLazyQuery>;
export type RetailerNetworkLocationGroupsForMemberSuspenseQueryHookResult = ReturnType<typeof useRetailerNetworkLocationGroupsForMemberSuspenseQuery>;
export type RetailerNetworkLocationGroupsForMemberQueryResult = Apollo.QueryResult<RetailerNetworkLocationGroupsForMemberQuery, RetailerNetworkLocationGroupsForMemberQueryVariables>;
export const RetailerNetworksForMemberDocument = gql`
    query retailerNetworksForMember($first: Int, $after: OCBase64Cursor, $last: Int, $before: OCBase64Cursor, $memberUuid: OCUUID!) {
  retailerNetworksForMember(
    first: $first
    after: $after
    last: $last
    before: $before
    memberUuid: $memberUuid
  ) {
    edges {
      node {
        ...retailerNetworkForMember
      }
    }
    pageInfo {
      ...pageInfo
    }
  }
}
    ${RetailerNetworkForMemberFragmentDoc}
${PageInfoFragmentDoc}`;

/**
 * __useRetailerNetworksForMemberQuery__
 *
 * To run a query within a React component, call `useRetailerNetworksForMemberQuery` and pass it any options that fit your needs.
 * When your component renders, `useRetailerNetworksForMemberQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useRetailerNetworksForMemberQuery({
 *   variables: {
 *      first: // value for 'first'
 *      after: // value for 'after'
 *      last: // value for 'last'
 *      before: // value for 'before'
 *      memberUuid: // value for 'memberUuid'
 *   },
 * });
 */
export function useRetailerNetworksForMemberQuery(baseOptions: Apollo.QueryHookOptions<RetailerNetworksForMemberQuery, RetailerNetworksForMemberQueryVariables> & ({ variables: RetailerNetworksForMemberQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<RetailerNetworksForMemberQuery, RetailerNetworksForMemberQueryVariables>(RetailerNetworksForMemberDocument, options);
      }
export function useRetailerNetworksForMemberLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<RetailerNetworksForMemberQuery, RetailerNetworksForMemberQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<RetailerNetworksForMemberQuery, RetailerNetworksForMemberQueryVariables>(RetailerNetworksForMemberDocument, options);
        }
export function useRetailerNetworksForMemberSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<RetailerNetworksForMemberQuery, RetailerNetworksForMemberQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<RetailerNetworksForMemberQuery, RetailerNetworksForMemberQueryVariables>(RetailerNetworksForMemberDocument, options);
        }
export type RetailerNetworksForMemberQueryHookResult = ReturnType<typeof useRetailerNetworksForMemberQuery>;
export type RetailerNetworksForMemberLazyQueryHookResult = ReturnType<typeof useRetailerNetworksForMemberLazyQuery>;
export type RetailerNetworksForMemberSuspenseQueryHookResult = ReturnType<typeof useRetailerNetworksForMemberSuspenseQuery>;
export type RetailerNetworksForMemberQueryResult = Apollo.QueryResult<RetailerNetworksForMemberQuery, RetailerNetworksForMemberQueryVariables>;
export const RetailerNetworkUsersForMemberDocument = gql`
    query retailerNetworkUsersForMember($after: OCBase64Cursor, $before: OCBase64Cursor, $filter: RetailerNetworkUsersForMemberFilter!, $first: Int, $last: Int) {
  retailerNetworkUsersForMember(
    after: $after
    before: $before
    filter: $filter
    first: $first
    last: $last
  ) {
    pageInfo {
      ...pageInfo
    }
    edges {
      cursor
      node {
        ...retailerNetworkUserForMember
      }
    }
  }
}
    ${PageInfoFragmentDoc}
${RetailerNetworkUserForMemberFragmentDoc}`;

/**
 * __useRetailerNetworkUsersForMemberQuery__
 *
 * To run a query within a React component, call `useRetailerNetworkUsersForMemberQuery` and pass it any options that fit your needs.
 * When your component renders, `useRetailerNetworkUsersForMemberQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useRetailerNetworkUsersForMemberQuery({
 *   variables: {
 *      after: // value for 'after'
 *      before: // value for 'before'
 *      filter: // value for 'filter'
 *      first: // value for 'first'
 *      last: // value for 'last'
 *   },
 * });
 */
export function useRetailerNetworkUsersForMemberQuery(baseOptions: Apollo.QueryHookOptions<RetailerNetworkUsersForMemberQuery, RetailerNetworkUsersForMemberQueryVariables> & ({ variables: RetailerNetworkUsersForMemberQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<RetailerNetworkUsersForMemberQuery, RetailerNetworkUsersForMemberQueryVariables>(RetailerNetworkUsersForMemberDocument, options);
      }
export function useRetailerNetworkUsersForMemberLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<RetailerNetworkUsersForMemberQuery, RetailerNetworkUsersForMemberQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<RetailerNetworkUsersForMemberQuery, RetailerNetworkUsersForMemberQueryVariables>(RetailerNetworkUsersForMemberDocument, options);
        }
export function useRetailerNetworkUsersForMemberSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<RetailerNetworkUsersForMemberQuery, RetailerNetworkUsersForMemberQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<RetailerNetworkUsersForMemberQuery, RetailerNetworkUsersForMemberQueryVariables>(RetailerNetworkUsersForMemberDocument, options);
        }
export type RetailerNetworkUsersForMemberQueryHookResult = ReturnType<typeof useRetailerNetworkUsersForMemberQuery>;
export type RetailerNetworkUsersForMemberLazyQueryHookResult = ReturnType<typeof useRetailerNetworkUsersForMemberLazyQuery>;
export type RetailerNetworkUsersForMemberSuspenseQueryHookResult = ReturnType<typeof useRetailerNetworkUsersForMemberSuspenseQuery>;
export type RetailerNetworkUsersForMemberQueryResult = Apollo.QueryResult<RetailerNetworkUsersForMemberQuery, RetailerNetworkUsersForMemberQueryVariables>;
export const GetPhoneNumberMetadataDocument = gql`
    query getPhoneNumberMetadata($phoneNumber: OCPhoneNumber!) {
  getPhoneNumberMetadata(phoneNumber: $phoneNumber) {
    ...phoneNumberMetadata
  }
}
    ${PhoneNumberMetadataFragmentDoc}`;

/**
 * __useGetPhoneNumberMetadataQuery__
 *
 * To run a query within a React component, call `useGetPhoneNumberMetadataQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPhoneNumberMetadataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPhoneNumberMetadataQuery({
 *   variables: {
 *      phoneNumber: // value for 'phoneNumber'
 *   },
 * });
 */
export function useGetPhoneNumberMetadataQuery(baseOptions: Apollo.QueryHookOptions<GetPhoneNumberMetadataQuery, GetPhoneNumberMetadataQueryVariables> & ({ variables: GetPhoneNumberMetadataQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetPhoneNumberMetadataQuery, GetPhoneNumberMetadataQueryVariables>(GetPhoneNumberMetadataDocument, options);
      }
export function useGetPhoneNumberMetadataLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPhoneNumberMetadataQuery, GetPhoneNumberMetadataQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetPhoneNumberMetadataQuery, GetPhoneNumberMetadataQueryVariables>(GetPhoneNumberMetadataDocument, options);
        }
export function useGetPhoneNumberMetadataSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetPhoneNumberMetadataQuery, GetPhoneNumberMetadataQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetPhoneNumberMetadataQuery, GetPhoneNumberMetadataQueryVariables>(GetPhoneNumberMetadataDocument, options);
        }
export type GetPhoneNumberMetadataQueryHookResult = ReturnType<typeof useGetPhoneNumberMetadataQuery>;
export type GetPhoneNumberMetadataLazyQueryHookResult = ReturnType<typeof useGetPhoneNumberMetadataLazyQuery>;
export type GetPhoneNumberMetadataSuspenseQueryHookResult = ReturnType<typeof useGetPhoneNumberMetadataSuspenseQuery>;
export type GetPhoneNumberMetadataQueryResult = Apollo.QueryResult<GetPhoneNumberMetadataQuery, GetPhoneNumberMetadataQueryVariables>;
export const MembershipActivitiesDocument = gql`
    query membershipActivities($membershipId: ID!, $first: Int, $last: Int, $after: ID, $before: ID, $filter: MembershipActivityFilter) {
  memberships(first: 1, filter: {idEquals: $membershipId}) {
    edges {
      node {
        id
        membershipActivities(
          first: $first
          last: $last
          after: $after
          before: $before
          filter: $filter
        ) {
          pageInfo {
            ...pageInfo
          }
          edges {
            cursor
            node {
              ...membershipActivity
            }
          }
        }
      }
    }
  }
}
    ${PageInfoFragmentDoc}
${MembershipActivityFragmentDoc}`;

/**
 * __useMembershipActivitiesQuery__
 *
 * To run a query within a React component, call `useMembershipActivitiesQuery` and pass it any options that fit your needs.
 * When your component renders, `useMembershipActivitiesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMembershipActivitiesQuery({
 *   variables: {
 *      membershipId: // value for 'membershipId'
 *      first: // value for 'first'
 *      last: // value for 'last'
 *      after: // value for 'after'
 *      before: // value for 'before'
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useMembershipActivitiesQuery(baseOptions: Apollo.QueryHookOptions<MembershipActivitiesQuery, MembershipActivitiesQueryVariables> & ({ variables: MembershipActivitiesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<MembershipActivitiesQuery, MembershipActivitiesQueryVariables>(MembershipActivitiesDocument, options);
      }
export function useMembershipActivitiesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MembershipActivitiesQuery, MembershipActivitiesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<MembershipActivitiesQuery, MembershipActivitiesQueryVariables>(MembershipActivitiesDocument, options);
        }
export function useMembershipActivitiesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<MembershipActivitiesQuery, MembershipActivitiesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<MembershipActivitiesQuery, MembershipActivitiesQueryVariables>(MembershipActivitiesDocument, options);
        }
export type MembershipActivitiesQueryHookResult = ReturnType<typeof useMembershipActivitiesQuery>;
export type MembershipActivitiesLazyQueryHookResult = ReturnType<typeof useMembershipActivitiesLazyQuery>;
export type MembershipActivitiesSuspenseQueryHookResult = ReturnType<typeof useMembershipActivitiesSuspenseQuery>;
export type MembershipActivitiesQueryResult = Apollo.QueryResult<MembershipActivitiesQuery, MembershipActivitiesQueryVariables>;
export const MetricCountsDocument = gql`
    query metricCounts($filter: MetricCountsFilter!) {
  metricCounts(filter: $filter) {
    eventType
    subtotal
    total
    timeSeries {
      interval
      values {
        count
        date
      }
    }
  }
}
    `;

/**
 * __useMetricCountsQuery__
 *
 * To run a query within a React component, call `useMetricCountsQuery` and pass it any options that fit your needs.
 * When your component renders, `useMetricCountsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMetricCountsQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useMetricCountsQuery(baseOptions: Apollo.QueryHookOptions<MetricCountsQuery, MetricCountsQueryVariables> & ({ variables: MetricCountsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<MetricCountsQuery, MetricCountsQueryVariables>(MetricCountsDocument, options);
      }
export function useMetricCountsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MetricCountsQuery, MetricCountsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<MetricCountsQuery, MetricCountsQueryVariables>(MetricCountsDocument, options);
        }
export function useMetricCountsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<MetricCountsQuery, MetricCountsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<MetricCountsQuery, MetricCountsQueryVariables>(MetricCountsDocument, options);
        }
export type MetricCountsQueryHookResult = ReturnType<typeof useMetricCountsQuery>;
export type MetricCountsLazyQueryHookResult = ReturnType<typeof useMetricCountsLazyQuery>;
export type MetricCountsSuspenseQueryHookResult = ReturnType<typeof useMetricCountsSuspenseQuery>;
export type MetricCountsQueryResult = Apollo.QueryResult<MetricCountsQuery, MetricCountsQueryVariables>;
export const OfferCreateDocument = gql`
    mutation offerCreate($input: OfferCreateInput!) {
  offerCreate(input: $input) {
    ...offer
  }
}
    ${OfferFragmentDoc}`;
export type OfferCreateMutationFn = Apollo.MutationFunction<OfferCreateMutation, OfferCreateMutationVariables>;

/**
 * __useOfferCreateMutation__
 *
 * To run a mutation, you first call `useOfferCreateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useOfferCreateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [offerCreateMutation, { data, loading, error }] = useOfferCreateMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useOfferCreateMutation(baseOptions?: Apollo.MutationHookOptions<OfferCreateMutation, OfferCreateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<OfferCreateMutation, OfferCreateMutationVariables>(OfferCreateDocument, options);
      }
export type OfferCreateMutationHookResult = ReturnType<typeof useOfferCreateMutation>;
export type OfferCreateMutationResult = Apollo.MutationResult<OfferCreateMutation>;
export type OfferCreateMutationOptions = Apollo.BaseMutationOptions<OfferCreateMutation, OfferCreateMutationVariables>;
export const OfferUpdateDocument = gql`
    mutation offerUpdate($input: OfferUpdateInput!) {
  offerUpdate(input: $input) {
    ...offer
  }
}
    ${OfferFragmentDoc}`;
export type OfferUpdateMutationFn = Apollo.MutationFunction<OfferUpdateMutation, OfferUpdateMutationVariables>;

/**
 * __useOfferUpdateMutation__
 *
 * To run a mutation, you first call `useOfferUpdateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useOfferUpdateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [offerUpdateMutation, { data, loading, error }] = useOfferUpdateMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useOfferUpdateMutation(baseOptions?: Apollo.MutationHookOptions<OfferUpdateMutation, OfferUpdateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<OfferUpdateMutation, OfferUpdateMutationVariables>(OfferUpdateDocument, options);
      }
export type OfferUpdateMutationHookResult = ReturnType<typeof useOfferUpdateMutation>;
export type OfferUpdateMutationResult = Apollo.MutationResult<OfferUpdateMutation>;
export type OfferUpdateMutationOptions = Apollo.BaseMutationOptions<OfferUpdateMutation, OfferUpdateMutationVariables>;
export const OfferDeleteDocument = gql`
    mutation offerDelete($id: ID!) {
  offerDelete(id: $id)
}
    `;
export type OfferDeleteMutationFn = Apollo.MutationFunction<OfferDeleteMutation, OfferDeleteMutationVariables>;

/**
 * __useOfferDeleteMutation__
 *
 * To run a mutation, you first call `useOfferDeleteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useOfferDeleteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [offerDeleteMutation, { data, loading, error }] = useOfferDeleteMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useOfferDeleteMutation(baseOptions?: Apollo.MutationHookOptions<OfferDeleteMutation, OfferDeleteMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<OfferDeleteMutation, OfferDeleteMutationVariables>(OfferDeleteDocument, options);
      }
export type OfferDeleteMutationHookResult = ReturnType<typeof useOfferDeleteMutation>;
export type OfferDeleteMutationResult = Apollo.MutationResult<OfferDeleteMutation>;
export type OfferDeleteMutationOptions = Apollo.BaseMutationOptions<OfferDeleteMutation, OfferDeleteMutationVariables>;
export const OfferDisplayCategoriesCreateOrUpdateDocument = gql`
    mutation offerDisplayCategoriesCreateOrUpdate($input: OfferDisplayCategoriesInput!) {
  offerDisplayCategoriesCreateOrUpdate(input: $input) {
    ...offer
  }
}
    ${OfferFragmentDoc}`;
export type OfferDisplayCategoriesCreateOrUpdateMutationFn = Apollo.MutationFunction<OfferDisplayCategoriesCreateOrUpdateMutation, OfferDisplayCategoriesCreateOrUpdateMutationVariables>;

/**
 * __useOfferDisplayCategoriesCreateOrUpdateMutation__
 *
 * To run a mutation, you first call `useOfferDisplayCategoriesCreateOrUpdateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useOfferDisplayCategoriesCreateOrUpdateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [offerDisplayCategoriesCreateOrUpdateMutation, { data, loading, error }] = useOfferDisplayCategoriesCreateOrUpdateMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useOfferDisplayCategoriesCreateOrUpdateMutation(baseOptions?: Apollo.MutationHookOptions<OfferDisplayCategoriesCreateOrUpdateMutation, OfferDisplayCategoriesCreateOrUpdateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<OfferDisplayCategoriesCreateOrUpdateMutation, OfferDisplayCategoriesCreateOrUpdateMutationVariables>(OfferDisplayCategoriesCreateOrUpdateDocument, options);
      }
export type OfferDisplayCategoriesCreateOrUpdateMutationHookResult = ReturnType<typeof useOfferDisplayCategoriesCreateOrUpdateMutation>;
export type OfferDisplayCategoriesCreateOrUpdateMutationResult = Apollo.MutationResult<OfferDisplayCategoriesCreateOrUpdateMutation>;
export type OfferDisplayCategoriesCreateOrUpdateMutationOptions = Apollo.BaseMutationOptions<OfferDisplayCategoriesCreateOrUpdateMutation, OfferDisplayCategoriesCreateOrUpdateMutationVariables>;
export const TriggerVisibilityNotificationsDocument = gql`
    mutation triggerVisibilityNotifications($input: TriggerVisibilityNotificationsInput!) {
  triggerVisibilityNotifications(input: $input)
}
    `;
export type TriggerVisibilityNotificationsMutationFn = Apollo.MutationFunction<TriggerVisibilityNotificationsMutation, TriggerVisibilityNotificationsMutationVariables>;

/**
 * __useTriggerVisibilityNotificationsMutation__
 *
 * To run a mutation, you first call `useTriggerVisibilityNotificationsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useTriggerVisibilityNotificationsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [triggerVisibilityNotificationsMutation, { data, loading, error }] = useTriggerVisibilityNotificationsMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useTriggerVisibilityNotificationsMutation(baseOptions?: Apollo.MutationHookOptions<TriggerVisibilityNotificationsMutation, TriggerVisibilityNotificationsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<TriggerVisibilityNotificationsMutation, TriggerVisibilityNotificationsMutationVariables>(TriggerVisibilityNotificationsDocument, options);
      }
export type TriggerVisibilityNotificationsMutationHookResult = ReturnType<typeof useTriggerVisibilityNotificationsMutation>;
export type TriggerVisibilityNotificationsMutationResult = Apollo.MutationResult<TriggerVisibilityNotificationsMutation>;
export type TriggerVisibilityNotificationsMutationOptions = Apollo.BaseMutationOptions<TriggerVisibilityNotificationsMutation, TriggerVisibilityNotificationsMutationVariables>;
export const OfferDocument = gql`
    query offer($filter: OfferFilter) {
  offers(filter: $filter) {
    edges {
      cursor
      node {
        ...offer
      }
    }
  }
}
    ${OfferFragmentDoc}`;

/**
 * __useOfferQuery__
 *
 * To run a query within a React component, call `useOfferQuery` and pass it any options that fit your needs.
 * When your component renders, `useOfferQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOfferQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useOfferQuery(baseOptions?: Apollo.QueryHookOptions<OfferQuery, OfferQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<OfferQuery, OfferQueryVariables>(OfferDocument, options);
      }
export function useOfferLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<OfferQuery, OfferQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<OfferQuery, OfferQueryVariables>(OfferDocument, options);
        }
export function useOfferSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<OfferQuery, OfferQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<OfferQuery, OfferQueryVariables>(OfferDocument, options);
        }
export type OfferQueryHookResult = ReturnType<typeof useOfferQuery>;
export type OfferLazyQueryHookResult = ReturnType<typeof useOfferLazyQuery>;
export type OfferSuspenseQueryHookResult = ReturnType<typeof useOfferSuspenseQuery>;
export type OfferQueryResult = Apollo.QueryResult<OfferQuery, OfferQueryVariables>;
export const OfferSelectListDocument = gql`
    query offerSelectList($first: Int, $last: Int, $after: ID, $before: ID, $filter: OfferFilter) {
  offers(
    first: $first
    last: $last
    after: $after
    before: $before
    filter: $filter
  ) {
    pageInfo {
      ...pageInfo
    }
    edges {
      cursor
      node {
        ...offerSelectItem
      }
    }
  }
}
    ${PageInfoFragmentDoc}
${OfferSelectItemFragmentDoc}`;

/**
 * __useOfferSelectListQuery__
 *
 * To run a query within a React component, call `useOfferSelectListQuery` and pass it any options that fit your needs.
 * When your component renders, `useOfferSelectListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOfferSelectListQuery({
 *   variables: {
 *      first: // value for 'first'
 *      last: // value for 'last'
 *      after: // value for 'after'
 *      before: // value for 'before'
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useOfferSelectListQuery(baseOptions?: Apollo.QueryHookOptions<OfferSelectListQuery, OfferSelectListQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<OfferSelectListQuery, OfferSelectListQueryVariables>(OfferSelectListDocument, options);
      }
export function useOfferSelectListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<OfferSelectListQuery, OfferSelectListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<OfferSelectListQuery, OfferSelectListQueryVariables>(OfferSelectListDocument, options);
        }
export function useOfferSelectListSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<OfferSelectListQuery, OfferSelectListQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<OfferSelectListQuery, OfferSelectListQueryVariables>(OfferSelectListDocument, options);
        }
export type OfferSelectListQueryHookResult = ReturnType<typeof useOfferSelectListQuery>;
export type OfferSelectListLazyQueryHookResult = ReturnType<typeof useOfferSelectListLazyQuery>;
export type OfferSelectListSuspenseQueryHookResult = ReturnType<typeof useOfferSelectListSuspenseQuery>;
export type OfferSelectListQueryResult = Apollo.QueryResult<OfferSelectListQuery, OfferSelectListQueryVariables>;
export const OpenCommerceUserCreateDocument = gql`
    mutation openCommerceUserCreate($input: OpenCommerceUserCreateInput!) {
  openCommerceUserCreate(input: $input) {
    ...openCommerceUser
  }
}
    ${OpenCommerceUserFragmentDoc}`;
export type OpenCommerceUserCreateMutationFn = Apollo.MutationFunction<OpenCommerceUserCreateMutation, OpenCommerceUserCreateMutationVariables>;

/**
 * __useOpenCommerceUserCreateMutation__
 *
 * To run a mutation, you first call `useOpenCommerceUserCreateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useOpenCommerceUserCreateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [openCommerceUserCreateMutation, { data, loading, error }] = useOpenCommerceUserCreateMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useOpenCommerceUserCreateMutation(baseOptions?: Apollo.MutationHookOptions<OpenCommerceUserCreateMutation, OpenCommerceUserCreateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<OpenCommerceUserCreateMutation, OpenCommerceUserCreateMutationVariables>(OpenCommerceUserCreateDocument, options);
      }
export type OpenCommerceUserCreateMutationHookResult = ReturnType<typeof useOpenCommerceUserCreateMutation>;
export type OpenCommerceUserCreateMutationResult = Apollo.MutationResult<OpenCommerceUserCreateMutation>;
export type OpenCommerceUserCreateMutationOptions = Apollo.BaseMutationOptions<OpenCommerceUserCreateMutation, OpenCommerceUserCreateMutationVariables>;
export const OpenCommerceUserUpdateDocument = gql`
    mutation openCommerceUserUpdate($input: OpenCommerceUserUpdateInput!) {
  openCommerceUserUpdate(input: $input) {
    ...openCommerceUser
  }
}
    ${OpenCommerceUserFragmentDoc}`;
export type OpenCommerceUserUpdateMutationFn = Apollo.MutationFunction<OpenCommerceUserUpdateMutation, OpenCommerceUserUpdateMutationVariables>;

/**
 * __useOpenCommerceUserUpdateMutation__
 *
 * To run a mutation, you first call `useOpenCommerceUserUpdateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useOpenCommerceUserUpdateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [openCommerceUserUpdateMutation, { data, loading, error }] = useOpenCommerceUserUpdateMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useOpenCommerceUserUpdateMutation(baseOptions?: Apollo.MutationHookOptions<OpenCommerceUserUpdateMutation, OpenCommerceUserUpdateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<OpenCommerceUserUpdateMutation, OpenCommerceUserUpdateMutationVariables>(OpenCommerceUserUpdateDocument, options);
      }
export type OpenCommerceUserUpdateMutationHookResult = ReturnType<typeof useOpenCommerceUserUpdateMutation>;
export type OpenCommerceUserUpdateMutationResult = Apollo.MutationResult<OpenCommerceUserUpdateMutation>;
export type OpenCommerceUserUpdateMutationOptions = Apollo.BaseMutationOptions<OpenCommerceUserUpdateMutation, OpenCommerceUserUpdateMutationVariables>;
export const OpenCommerceUsersDocument = gql`
    query openCommerceUsers($first: Int, $last: Int, $after: OCBase64Cursor, $before: OCBase64Cursor, $filter: OpenCommerceUserFilter!) {
  openCommerceUsers(
    first: $first
    last: $last
    after: $after
    before: $before
    filter: $filter
  ) {
    pageInfo {
      ...pageInfo
    }
    edges {
      cursor
      node {
        ...openCommerceUser
      }
    }
  }
}
    ${PageInfoFragmentDoc}
${OpenCommerceUserFragmentDoc}`;

/**
 * __useOpenCommerceUsersQuery__
 *
 * To run a query within a React component, call `useOpenCommerceUsersQuery` and pass it any options that fit your needs.
 * When your component renders, `useOpenCommerceUsersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOpenCommerceUsersQuery({
 *   variables: {
 *      first: // value for 'first'
 *      last: // value for 'last'
 *      after: // value for 'after'
 *      before: // value for 'before'
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useOpenCommerceUsersQuery(baseOptions: Apollo.QueryHookOptions<OpenCommerceUsersQuery, OpenCommerceUsersQueryVariables> & ({ variables: OpenCommerceUsersQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<OpenCommerceUsersQuery, OpenCommerceUsersQueryVariables>(OpenCommerceUsersDocument, options);
      }
export function useOpenCommerceUsersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<OpenCommerceUsersQuery, OpenCommerceUsersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<OpenCommerceUsersQuery, OpenCommerceUsersQueryVariables>(OpenCommerceUsersDocument, options);
        }
export function useOpenCommerceUsersSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<OpenCommerceUsersQuery, OpenCommerceUsersQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<OpenCommerceUsersQuery, OpenCommerceUsersQueryVariables>(OpenCommerceUsersDocument, options);
        }
export type OpenCommerceUsersQueryHookResult = ReturnType<typeof useOpenCommerceUsersQuery>;
export type OpenCommerceUsersLazyQueryHookResult = ReturnType<typeof useOpenCommerceUsersLazyQuery>;
export type OpenCommerceUsersSuspenseQueryHookResult = ReturnType<typeof useOpenCommerceUsersSuspenseQuery>;
export type OpenCommerceUsersQueryResult = Apollo.QueryResult<OpenCommerceUsersQuery, OpenCommerceUsersQueryVariables>;
export const GetOpenCommerceUserSelectItemsDocument = gql`
    query getOpenCommerceUserSelectItems($first: Int, $last: Int, $after: OCBase64Cursor, $before: OCBase64Cursor, $filter: OpenCommerceUserFilter) {
  openCommerceUsers(
    first: $first
    last: $last
    after: $after
    before: $before
    filter: $filter
  ) {
    pageInfo {
      ...pageInfo
    }
    edges {
      cursor
      node {
        ...openCommerceUserSelectItem
      }
    }
  }
}
    ${PageInfoFragmentDoc}
${OpenCommerceUserSelectItemFragmentDoc}`;

/**
 * __useGetOpenCommerceUserSelectItemsQuery__
 *
 * To run a query within a React component, call `useGetOpenCommerceUserSelectItemsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetOpenCommerceUserSelectItemsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetOpenCommerceUserSelectItemsQuery({
 *   variables: {
 *      first: // value for 'first'
 *      last: // value for 'last'
 *      after: // value for 'after'
 *      before: // value for 'before'
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useGetOpenCommerceUserSelectItemsQuery(baseOptions?: Apollo.QueryHookOptions<GetOpenCommerceUserSelectItemsQuery, GetOpenCommerceUserSelectItemsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetOpenCommerceUserSelectItemsQuery, GetOpenCommerceUserSelectItemsQueryVariables>(GetOpenCommerceUserSelectItemsDocument, options);
      }
export function useGetOpenCommerceUserSelectItemsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetOpenCommerceUserSelectItemsQuery, GetOpenCommerceUserSelectItemsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetOpenCommerceUserSelectItemsQuery, GetOpenCommerceUserSelectItemsQueryVariables>(GetOpenCommerceUserSelectItemsDocument, options);
        }
export function useGetOpenCommerceUserSelectItemsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetOpenCommerceUserSelectItemsQuery, GetOpenCommerceUserSelectItemsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetOpenCommerceUserSelectItemsQuery, GetOpenCommerceUserSelectItemsQueryVariables>(GetOpenCommerceUserSelectItemsDocument, options);
        }
export type GetOpenCommerceUserSelectItemsQueryHookResult = ReturnType<typeof useGetOpenCommerceUserSelectItemsQuery>;
export type GetOpenCommerceUserSelectItemsLazyQueryHookResult = ReturnType<typeof useGetOpenCommerceUserSelectItemsLazyQuery>;
export type GetOpenCommerceUserSelectItemsSuspenseQueryHookResult = ReturnType<typeof useGetOpenCommerceUserSelectItemsSuspenseQuery>;
export type GetOpenCommerceUserSelectItemsQueryResult = Apollo.QueryResult<GetOpenCommerceUserSelectItemsQuery, GetOpenCommerceUserSelectItemsQueryVariables>;
export const UsersEligibleForRetailerConnectDocument = gql`
    query usersEligibleForRetailerConnect($first: Int, $last: Int, $after: OCBase64Cursor, $before: OCBase64Cursor, $filter: UsersEligibleForRetailerConnectFilter!) {
  usersEligibleForRetailerConnect(
    first: $first
    last: $last
    after: $after
    before: $before
    filter: $filter
  ) {
    pageInfo {
      ...pageInfo
    }
    edges {
      cursor
      node {
        ...openCommerceUser
      }
    }
  }
}
    ${PageInfoFragmentDoc}
${OpenCommerceUserFragmentDoc}`;

/**
 * __useUsersEligibleForRetailerConnectQuery__
 *
 * To run a query within a React component, call `useUsersEligibleForRetailerConnectQuery` and pass it any options that fit your needs.
 * When your component renders, `useUsersEligibleForRetailerConnectQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUsersEligibleForRetailerConnectQuery({
 *   variables: {
 *      first: // value for 'first'
 *      last: // value for 'last'
 *      after: // value for 'after'
 *      before: // value for 'before'
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useUsersEligibleForRetailerConnectQuery(baseOptions: Apollo.QueryHookOptions<UsersEligibleForRetailerConnectQuery, UsersEligibleForRetailerConnectQueryVariables> & ({ variables: UsersEligibleForRetailerConnectQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<UsersEligibleForRetailerConnectQuery, UsersEligibleForRetailerConnectQueryVariables>(UsersEligibleForRetailerConnectDocument, options);
      }
export function useUsersEligibleForRetailerConnectLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<UsersEligibleForRetailerConnectQuery, UsersEligibleForRetailerConnectQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<UsersEligibleForRetailerConnectQuery, UsersEligibleForRetailerConnectQueryVariables>(UsersEligibleForRetailerConnectDocument, options);
        }
export function useUsersEligibleForRetailerConnectSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<UsersEligibleForRetailerConnectQuery, UsersEligibleForRetailerConnectQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<UsersEligibleForRetailerConnectQuery, UsersEligibleForRetailerConnectQueryVariables>(UsersEligibleForRetailerConnectDocument, options);
        }
export type UsersEligibleForRetailerConnectQueryHookResult = ReturnType<typeof useUsersEligibleForRetailerConnectQuery>;
export type UsersEligibleForRetailerConnectLazyQueryHookResult = ReturnType<typeof useUsersEligibleForRetailerConnectLazyQuery>;
export type UsersEligibleForRetailerConnectSuspenseQueryHookResult = ReturnType<typeof useUsersEligibleForRetailerConnectSuspenseQuery>;
export type UsersEligibleForRetailerConnectQueryResult = Apollo.QueryResult<UsersEligibleForRetailerConnectQuery, UsersEligibleForRetailerConnectQueryVariables>;
export const OpenCommerceUserCurrentDocument = gql`
    query openCommerceUserCurrent {
  openCommerceUserCurrent {
    ...openCommerceUser
  }
}
    ${OpenCommerceUserFragmentDoc}`;

/**
 * __useOpenCommerceUserCurrentQuery__
 *
 * To run a query within a React component, call `useOpenCommerceUserCurrentQuery` and pass it any options that fit your needs.
 * When your component renders, `useOpenCommerceUserCurrentQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOpenCommerceUserCurrentQuery({
 *   variables: {
 *   },
 * });
 */
export function useOpenCommerceUserCurrentQuery(baseOptions?: Apollo.QueryHookOptions<OpenCommerceUserCurrentQuery, OpenCommerceUserCurrentQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<OpenCommerceUserCurrentQuery, OpenCommerceUserCurrentQueryVariables>(OpenCommerceUserCurrentDocument, options);
      }
export function useOpenCommerceUserCurrentLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<OpenCommerceUserCurrentQuery, OpenCommerceUserCurrentQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<OpenCommerceUserCurrentQuery, OpenCommerceUserCurrentQueryVariables>(OpenCommerceUserCurrentDocument, options);
        }
export function useOpenCommerceUserCurrentSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<OpenCommerceUserCurrentQuery, OpenCommerceUserCurrentQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<OpenCommerceUserCurrentQuery, OpenCommerceUserCurrentQueryVariables>(OpenCommerceUserCurrentDocument, options);
        }
export type OpenCommerceUserCurrentQueryHookResult = ReturnType<typeof useOpenCommerceUserCurrentQuery>;
export type OpenCommerceUserCurrentLazyQueryHookResult = ReturnType<typeof useOpenCommerceUserCurrentLazyQuery>;
export type OpenCommerceUserCurrentSuspenseQueryHookResult = ReturnType<typeof useOpenCommerceUserCurrentSuspenseQuery>;
export type OpenCommerceUserCurrentQueryResult = Apollo.QueryResult<OpenCommerceUserCurrentQuery, OpenCommerceUserCurrentQueryVariables>;
export const CurrentUserRetailerNetworkUsersDocument = gql`
    query currentUserRetailerNetworkUsers($first: Int, $last: Int, $after: OCBase64Cursor, $before: OCBase64Cursor, $retailerNetworkUuid: OCUUID, $sort: RetailerNetworkUsersSort) {
  currentUserRetailerNetworkUsers(
    first: $first
    last: $last
    after: $after
    before: $before
    retailerNetworkUuid: $retailerNetworkUuid
    sort: $sort
  ) {
    pageInfo {
      ...pageInfo
    }
    edges {
      cursor
      node {
        ...currentUserRetailerNetworkUser
      }
    }
  }
}
    ${PageInfoFragmentDoc}
${CurrentUserRetailerNetworkUserFragmentDoc}`;

/**
 * __useCurrentUserRetailerNetworkUsersQuery__
 *
 * To run a query within a React component, call `useCurrentUserRetailerNetworkUsersQuery` and pass it any options that fit your needs.
 * When your component renders, `useCurrentUserRetailerNetworkUsersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCurrentUserRetailerNetworkUsersQuery({
 *   variables: {
 *      first: // value for 'first'
 *      last: // value for 'last'
 *      after: // value for 'after'
 *      before: // value for 'before'
 *      retailerNetworkUuid: // value for 'retailerNetworkUuid'
 *      sort: // value for 'sort'
 *   },
 * });
 */
export function useCurrentUserRetailerNetworkUsersQuery(baseOptions?: Apollo.QueryHookOptions<CurrentUserRetailerNetworkUsersQuery, CurrentUserRetailerNetworkUsersQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CurrentUserRetailerNetworkUsersQuery, CurrentUserRetailerNetworkUsersQueryVariables>(CurrentUserRetailerNetworkUsersDocument, options);
      }
export function useCurrentUserRetailerNetworkUsersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CurrentUserRetailerNetworkUsersQuery, CurrentUserRetailerNetworkUsersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CurrentUserRetailerNetworkUsersQuery, CurrentUserRetailerNetworkUsersQueryVariables>(CurrentUserRetailerNetworkUsersDocument, options);
        }
export function useCurrentUserRetailerNetworkUsersSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<CurrentUserRetailerNetworkUsersQuery, CurrentUserRetailerNetworkUsersQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<CurrentUserRetailerNetworkUsersQuery, CurrentUserRetailerNetworkUsersQueryVariables>(CurrentUserRetailerNetworkUsersDocument, options);
        }
export type CurrentUserRetailerNetworkUsersQueryHookResult = ReturnType<typeof useCurrentUserRetailerNetworkUsersQuery>;
export type CurrentUserRetailerNetworkUsersLazyQueryHookResult = ReturnType<typeof useCurrentUserRetailerNetworkUsersLazyQuery>;
export type CurrentUserRetailerNetworkUsersSuspenseQueryHookResult = ReturnType<typeof useCurrentUserRetailerNetworkUsersSuspenseQuery>;
export type CurrentUserRetailerNetworkUsersQueryResult = Apollo.QueryResult<CurrentUserRetailerNetworkUsersQuery, CurrentUserRetailerNetworkUsersQueryVariables>;
export const PointChangeDocument = gql`
    query pointChange($filter: PointChangeFilter) {
  pointChanges(first: 1, filter: $filter) {
    edges {
      cursor
      node {
        ...pointChange
      }
    }
  }
}
    ${PointChangeFragmentDoc}`;

/**
 * __usePointChangeQuery__
 *
 * To run a query within a React component, call `usePointChangeQuery` and pass it any options that fit your needs.
 * When your component renders, `usePointChangeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePointChangeQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function usePointChangeQuery(baseOptions?: Apollo.QueryHookOptions<PointChangeQuery, PointChangeQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PointChangeQuery, PointChangeQueryVariables>(PointChangeDocument, options);
      }
export function usePointChangeLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PointChangeQuery, PointChangeQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PointChangeQuery, PointChangeQueryVariables>(PointChangeDocument, options);
        }
export function usePointChangeSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<PointChangeQuery, PointChangeQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<PointChangeQuery, PointChangeQueryVariables>(PointChangeDocument, options);
        }
export type PointChangeQueryHookResult = ReturnType<typeof usePointChangeQuery>;
export type PointChangeLazyQueryHookResult = ReturnType<typeof usePointChangeLazyQuery>;
export type PointChangeSuspenseQueryHookResult = ReturnType<typeof usePointChangeSuspenseQuery>;
export type PointChangeQueryResult = Apollo.QueryResult<PointChangeQuery, PointChangeQueryVariables>;
export const ProductCategoryCreateDocument = gql`
    mutation productCategoryCreate($input: ProductCategoryCreateInput!) {
  productCategoryCreate(input: $input) {
    ...productCategory
  }
}
    ${ProductCategoryFragmentDoc}`;
export type ProductCategoryCreateMutationFn = Apollo.MutationFunction<ProductCategoryCreateMutation, ProductCategoryCreateMutationVariables>;

/**
 * __useProductCategoryCreateMutation__
 *
 * To run a mutation, you first call `useProductCategoryCreateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useProductCategoryCreateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [productCategoryCreateMutation, { data, loading, error }] = useProductCategoryCreateMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useProductCategoryCreateMutation(baseOptions?: Apollo.MutationHookOptions<ProductCategoryCreateMutation, ProductCategoryCreateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ProductCategoryCreateMutation, ProductCategoryCreateMutationVariables>(ProductCategoryCreateDocument, options);
      }
export type ProductCategoryCreateMutationHookResult = ReturnType<typeof useProductCategoryCreateMutation>;
export type ProductCategoryCreateMutationResult = Apollo.MutationResult<ProductCategoryCreateMutation>;
export type ProductCategoryCreateMutationOptions = Apollo.BaseMutationOptions<ProductCategoryCreateMutation, ProductCategoryCreateMutationVariables>;
export const ProductCategoryUpdateDocument = gql`
    mutation productCategoryUpdate($input: ProductCategoryUpdateInput!) {
  productCategoryUpdate(input: $input) {
    ...productCategory
  }
}
    ${ProductCategoryFragmentDoc}`;
export type ProductCategoryUpdateMutationFn = Apollo.MutationFunction<ProductCategoryUpdateMutation, ProductCategoryUpdateMutationVariables>;

/**
 * __useProductCategoryUpdateMutation__
 *
 * To run a mutation, you first call `useProductCategoryUpdateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useProductCategoryUpdateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [productCategoryUpdateMutation, { data, loading, error }] = useProductCategoryUpdateMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useProductCategoryUpdateMutation(baseOptions?: Apollo.MutationHookOptions<ProductCategoryUpdateMutation, ProductCategoryUpdateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ProductCategoryUpdateMutation, ProductCategoryUpdateMutationVariables>(ProductCategoryUpdateDocument, options);
      }
export type ProductCategoryUpdateMutationHookResult = ReturnType<typeof useProductCategoryUpdateMutation>;
export type ProductCategoryUpdateMutationResult = Apollo.MutationResult<ProductCategoryUpdateMutation>;
export type ProductCategoryUpdateMutationOptions = Apollo.BaseMutationOptions<ProductCategoryUpdateMutation, ProductCategoryUpdateMutationVariables>;
export const ProductCategoryDeleteDocument = gql`
    mutation productCategoryDelete($id: ID!) {
  productCategoryDelete(id: $id)
}
    `;
export type ProductCategoryDeleteMutationFn = Apollo.MutationFunction<ProductCategoryDeleteMutation, ProductCategoryDeleteMutationVariables>;

/**
 * __useProductCategoryDeleteMutation__
 *
 * To run a mutation, you first call `useProductCategoryDeleteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useProductCategoryDeleteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [productCategoryDeleteMutation, { data, loading, error }] = useProductCategoryDeleteMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useProductCategoryDeleteMutation(baseOptions?: Apollo.MutationHookOptions<ProductCategoryDeleteMutation, ProductCategoryDeleteMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ProductCategoryDeleteMutation, ProductCategoryDeleteMutationVariables>(ProductCategoryDeleteDocument, options);
      }
export type ProductCategoryDeleteMutationHookResult = ReturnType<typeof useProductCategoryDeleteMutation>;
export type ProductCategoryDeleteMutationResult = Apollo.MutationResult<ProductCategoryDeleteMutation>;
export type ProductCategoryDeleteMutationOptions = Apollo.BaseMutationOptions<ProductCategoryDeleteMutation, ProductCategoryDeleteMutationVariables>;
export const ProductCategoryDocument = gql`
    query productCategory($filter: ProductCategoryFilter) {
  productCategories(filter: $filter) {
    edges {
      cursor
      node {
        ...productCategory
      }
    }
  }
}
    ${ProductCategoryFragmentDoc}`;

/**
 * __useProductCategoryQuery__
 *
 * To run a query within a React component, call `useProductCategoryQuery` and pass it any options that fit your needs.
 * When your component renders, `useProductCategoryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProductCategoryQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useProductCategoryQuery(baseOptions?: Apollo.QueryHookOptions<ProductCategoryQuery, ProductCategoryQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ProductCategoryQuery, ProductCategoryQueryVariables>(ProductCategoryDocument, options);
      }
export function useProductCategoryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ProductCategoryQuery, ProductCategoryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ProductCategoryQuery, ProductCategoryQueryVariables>(ProductCategoryDocument, options);
        }
export function useProductCategorySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ProductCategoryQuery, ProductCategoryQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ProductCategoryQuery, ProductCategoryQueryVariables>(ProductCategoryDocument, options);
        }
export type ProductCategoryQueryHookResult = ReturnType<typeof useProductCategoryQuery>;
export type ProductCategoryLazyQueryHookResult = ReturnType<typeof useProductCategoryLazyQuery>;
export type ProductCategorySuspenseQueryHookResult = ReturnType<typeof useProductCategorySuspenseQuery>;
export type ProductCategoryQueryResult = Apollo.QueryResult<ProductCategoryQuery, ProductCategoryQueryVariables>;
export const ProductCategoriesDocument = gql`
    query productCategories($first: Int, $last: Int, $after: ID, $before: ID, $filter: ProductCategoryFilter) {
  productCategories(
    first: $first
    last: $last
    after: $after
    before: $before
    filter: $filter
  ) {
    pageInfo {
      ...pageInfo
    }
    edges {
      cursor
      node {
        ...productCategory
      }
    }
  }
}
    ${PageInfoFragmentDoc}
${ProductCategoryFragmentDoc}`;

/**
 * __useProductCategoriesQuery__
 *
 * To run a query within a React component, call `useProductCategoriesQuery` and pass it any options that fit your needs.
 * When your component renders, `useProductCategoriesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProductCategoriesQuery({
 *   variables: {
 *      first: // value for 'first'
 *      last: // value for 'last'
 *      after: // value for 'after'
 *      before: // value for 'before'
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useProductCategoriesQuery(baseOptions?: Apollo.QueryHookOptions<ProductCategoriesQuery, ProductCategoriesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ProductCategoriesQuery, ProductCategoriesQueryVariables>(ProductCategoriesDocument, options);
      }
export function useProductCategoriesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ProductCategoriesQuery, ProductCategoriesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ProductCategoriesQuery, ProductCategoriesQueryVariables>(ProductCategoriesDocument, options);
        }
export function useProductCategoriesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ProductCategoriesQuery, ProductCategoriesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ProductCategoriesQuery, ProductCategoriesQueryVariables>(ProductCategoriesDocument, options);
        }
export type ProductCategoriesQueryHookResult = ReturnType<typeof useProductCategoriesQuery>;
export type ProductCategoriesLazyQueryHookResult = ReturnType<typeof useProductCategoriesLazyQuery>;
export type ProductCategoriesSuspenseQueryHookResult = ReturnType<typeof useProductCategoriesSuspenseQuery>;
export type ProductCategoriesQueryResult = Apollo.QueryResult<ProductCategoriesQuery, ProductCategoriesQueryVariables>;
export const ProductGroupCreateDocument = gql`
    mutation productGroupCreate($chainId: ID!, $input: ProductGroupInput!) {
  productGroupCreate(chainId: $chainId, input: $input) {
    ...productGroup
  }
}
    ${ProductGroupFragmentDoc}`;
export type ProductGroupCreateMutationFn = Apollo.MutationFunction<ProductGroupCreateMutation, ProductGroupCreateMutationVariables>;

/**
 * __useProductGroupCreateMutation__
 *
 * To run a mutation, you first call `useProductGroupCreateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useProductGroupCreateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [productGroupCreateMutation, { data, loading, error }] = useProductGroupCreateMutation({
 *   variables: {
 *      chainId: // value for 'chainId'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useProductGroupCreateMutation(baseOptions?: Apollo.MutationHookOptions<ProductGroupCreateMutation, ProductGroupCreateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ProductGroupCreateMutation, ProductGroupCreateMutationVariables>(ProductGroupCreateDocument, options);
      }
export type ProductGroupCreateMutationHookResult = ReturnType<typeof useProductGroupCreateMutation>;
export type ProductGroupCreateMutationResult = Apollo.MutationResult<ProductGroupCreateMutation>;
export type ProductGroupCreateMutationOptions = Apollo.BaseMutationOptions<ProductGroupCreateMutation, ProductGroupCreateMutationVariables>;
export const ProductGroupUpdateDocument = gql`
    mutation productGroupUpdate($id: ID!, $input: ProductGroupUpdateInput!) {
  productGroupUpdate(id: $id, input: $input) {
    ...productGroup
  }
}
    ${ProductGroupFragmentDoc}`;
export type ProductGroupUpdateMutationFn = Apollo.MutationFunction<ProductGroupUpdateMutation, ProductGroupUpdateMutationVariables>;

/**
 * __useProductGroupUpdateMutation__
 *
 * To run a mutation, you first call `useProductGroupUpdateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useProductGroupUpdateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [productGroupUpdateMutation, { data, loading, error }] = useProductGroupUpdateMutation({
 *   variables: {
 *      id: // value for 'id'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useProductGroupUpdateMutation(baseOptions?: Apollo.MutationHookOptions<ProductGroupUpdateMutation, ProductGroupUpdateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ProductGroupUpdateMutation, ProductGroupUpdateMutationVariables>(ProductGroupUpdateDocument, options);
      }
export type ProductGroupUpdateMutationHookResult = ReturnType<typeof useProductGroupUpdateMutation>;
export type ProductGroupUpdateMutationResult = Apollo.MutationResult<ProductGroupUpdateMutation>;
export type ProductGroupUpdateMutationOptions = Apollo.BaseMutationOptions<ProductGroupUpdateMutation, ProductGroupUpdateMutationVariables>;
export const ProductGroupDeleteDocument = gql`
    mutation productGroupDelete($id: ID!) {
  productGroupDelete(id: $id)
}
    `;
export type ProductGroupDeleteMutationFn = Apollo.MutationFunction<ProductGroupDeleteMutation, ProductGroupDeleteMutationVariables>;

/**
 * __useProductGroupDeleteMutation__
 *
 * To run a mutation, you first call `useProductGroupDeleteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useProductGroupDeleteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [productGroupDeleteMutation, { data, loading, error }] = useProductGroupDeleteMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useProductGroupDeleteMutation(baseOptions?: Apollo.MutationHookOptions<ProductGroupDeleteMutation, ProductGroupDeleteMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ProductGroupDeleteMutation, ProductGroupDeleteMutationVariables>(ProductGroupDeleteDocument, options);
      }
export type ProductGroupDeleteMutationHookResult = ReturnType<typeof useProductGroupDeleteMutation>;
export type ProductGroupDeleteMutationResult = Apollo.MutationResult<ProductGroupDeleteMutation>;
export type ProductGroupDeleteMutationOptions = Apollo.BaseMutationOptions<ProductGroupDeleteMutation, ProductGroupDeleteMutationVariables>;
export const FuelProductGroupCreateDocument = gql`
    mutation fuelProductGroupCreate($chainId: ID!, $input: FuelProductGroupCreateInput!) {
  fuelProductGroupCreate(chainId: $chainId, input: $input) {
    id
    name
    chain {
      id
      name
    }
    fuelProductGroup {
      id
      sortingRank
      userSelectable
      default
    }
    createdAt
    description
    discontinued
    key
    values
  }
}
    `;
export type FuelProductGroupCreateMutationFn = Apollo.MutationFunction<FuelProductGroupCreateMutation, FuelProductGroupCreateMutationVariables>;

/**
 * __useFuelProductGroupCreateMutation__
 *
 * To run a mutation, you first call `useFuelProductGroupCreateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useFuelProductGroupCreateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [fuelProductGroupCreateMutation, { data, loading, error }] = useFuelProductGroupCreateMutation({
 *   variables: {
 *      chainId: // value for 'chainId'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useFuelProductGroupCreateMutation(baseOptions?: Apollo.MutationHookOptions<FuelProductGroupCreateMutation, FuelProductGroupCreateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<FuelProductGroupCreateMutation, FuelProductGroupCreateMutationVariables>(FuelProductGroupCreateDocument, options);
      }
export type FuelProductGroupCreateMutationHookResult = ReturnType<typeof useFuelProductGroupCreateMutation>;
export type FuelProductGroupCreateMutationResult = Apollo.MutationResult<FuelProductGroupCreateMutation>;
export type FuelProductGroupCreateMutationOptions = Apollo.BaseMutationOptions<FuelProductGroupCreateMutation, FuelProductGroupCreateMutationVariables>;
export const FuelProductGroupUpdateDocument = gql`
    mutation fuelProductGroupUpdate($productGroupId: ID!, $input: FuelProductGroupUpdateInput!) {
  fuelProductGroupUpdate(productGroupId: $productGroupId, input: $input) {
    id
    name
    chain {
      id
      name
    }
    fuelProductGroup {
      id
      sortingRank
      userSelectable
      default
    }
    createdAt
    description
    discontinued
    key
    values
  }
}
    `;
export type FuelProductGroupUpdateMutationFn = Apollo.MutationFunction<FuelProductGroupUpdateMutation, FuelProductGroupUpdateMutationVariables>;

/**
 * __useFuelProductGroupUpdateMutation__
 *
 * To run a mutation, you first call `useFuelProductGroupUpdateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useFuelProductGroupUpdateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [fuelProductGroupUpdateMutation, { data, loading, error }] = useFuelProductGroupUpdateMutation({
 *   variables: {
 *      productGroupId: // value for 'productGroupId'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useFuelProductGroupUpdateMutation(baseOptions?: Apollo.MutationHookOptions<FuelProductGroupUpdateMutation, FuelProductGroupUpdateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<FuelProductGroupUpdateMutation, FuelProductGroupUpdateMutationVariables>(FuelProductGroupUpdateDocument, options);
      }
export type FuelProductGroupUpdateMutationHookResult = ReturnType<typeof useFuelProductGroupUpdateMutation>;
export type FuelProductGroupUpdateMutationResult = Apollo.MutationResult<FuelProductGroupUpdateMutation>;
export type FuelProductGroupUpdateMutationOptions = Apollo.BaseMutationOptions<FuelProductGroupUpdateMutation, FuelProductGroupUpdateMutationVariables>;
export const ProductGroupDocument = gql`
    query productGroup($filter: ProductGroupFilter) {
  productGroups(filter: $filter) {
    edges {
      cursor
      node {
        ...productGroup
      }
    }
  }
}
    ${ProductGroupFragmentDoc}`;

/**
 * __useProductGroupQuery__
 *
 * To run a query within a React component, call `useProductGroupQuery` and pass it any options that fit your needs.
 * When your component renders, `useProductGroupQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProductGroupQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useProductGroupQuery(baseOptions?: Apollo.QueryHookOptions<ProductGroupQuery, ProductGroupQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ProductGroupQuery, ProductGroupQueryVariables>(ProductGroupDocument, options);
      }
export function useProductGroupLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ProductGroupQuery, ProductGroupQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ProductGroupQuery, ProductGroupQueryVariables>(ProductGroupDocument, options);
        }
export function useProductGroupSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ProductGroupQuery, ProductGroupQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ProductGroupQuery, ProductGroupQueryVariables>(ProductGroupDocument, options);
        }
export type ProductGroupQueryHookResult = ReturnType<typeof useProductGroupQuery>;
export type ProductGroupLazyQueryHookResult = ReturnType<typeof useProductGroupLazyQuery>;
export type ProductGroupSuspenseQueryHookResult = ReturnType<typeof useProductGroupSuspenseQuery>;
export type ProductGroupQueryResult = Apollo.QueryResult<ProductGroupQuery, ProductGroupQueryVariables>;
export const ProductGroupsDocument = gql`
    query productGroups($first: Int, $last: Int, $after: String, $before: String, $filter: ProductGroupFilter) {
  productGroups(
    first: $first
    last: $last
    after: $after
    before: $before
    filter: $filter
  ) {
    pageInfo {
      ...pageInfo
    }
    edges {
      cursor
      node {
        ...productGroup
      }
    }
  }
}
    ${PageInfoFragmentDoc}
${ProductGroupFragmentDoc}`;

/**
 * __useProductGroupsQuery__
 *
 * To run a query within a React component, call `useProductGroupsQuery` and pass it any options that fit your needs.
 * When your component renders, `useProductGroupsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProductGroupsQuery({
 *   variables: {
 *      first: // value for 'first'
 *      last: // value for 'last'
 *      after: // value for 'after'
 *      before: // value for 'before'
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useProductGroupsQuery(baseOptions?: Apollo.QueryHookOptions<ProductGroupsQuery, ProductGroupsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ProductGroupsQuery, ProductGroupsQueryVariables>(ProductGroupsDocument, options);
      }
export function useProductGroupsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ProductGroupsQuery, ProductGroupsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ProductGroupsQuery, ProductGroupsQueryVariables>(ProductGroupsDocument, options);
        }
export function useProductGroupsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ProductGroupsQuery, ProductGroupsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ProductGroupsQuery, ProductGroupsQueryVariables>(ProductGroupsDocument, options);
        }
export type ProductGroupsQueryHookResult = ReturnType<typeof useProductGroupsQuery>;
export type ProductGroupsLazyQueryHookResult = ReturnType<typeof useProductGroupsLazyQuery>;
export type ProductGroupsSuspenseQueryHookResult = ReturnType<typeof useProductGroupsSuspenseQuery>;
export type ProductGroupsQueryResult = Apollo.QueryResult<ProductGroupsQuery, ProductGroupsQueryVariables>;
export const SegmentCreateDocument = gql`
    mutation segmentCreate($chainId: ID!, $input: SegmentCreate!) {
  segmentCreate(chainId: $chainId, input: $input) {
    ...segment
  }
}
    ${SegmentFragmentDoc}`;
export type SegmentCreateMutationFn = Apollo.MutationFunction<SegmentCreateMutation, SegmentCreateMutationVariables>;

/**
 * __useSegmentCreateMutation__
 *
 * To run a mutation, you first call `useSegmentCreateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSegmentCreateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [segmentCreateMutation, { data, loading, error }] = useSegmentCreateMutation({
 *   variables: {
 *      chainId: // value for 'chainId'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSegmentCreateMutation(baseOptions?: Apollo.MutationHookOptions<SegmentCreateMutation, SegmentCreateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SegmentCreateMutation, SegmentCreateMutationVariables>(SegmentCreateDocument, options);
      }
export type SegmentCreateMutationHookResult = ReturnType<typeof useSegmentCreateMutation>;
export type SegmentCreateMutationResult = Apollo.MutationResult<SegmentCreateMutation>;
export type SegmentCreateMutationOptions = Apollo.BaseMutationOptions<SegmentCreateMutation, SegmentCreateMutationVariables>;
export const SegmentUpdateDocument = gql`
    mutation segmentUpdate($id: ID!, $input: SegmentUpdate!) {
  segmentUpdate(id: $id, input: $input) {
    ...segment
  }
}
    ${SegmentFragmentDoc}`;
export type SegmentUpdateMutationFn = Apollo.MutationFunction<SegmentUpdateMutation, SegmentUpdateMutationVariables>;

/**
 * __useSegmentUpdateMutation__
 *
 * To run a mutation, you first call `useSegmentUpdateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSegmentUpdateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [segmentUpdateMutation, { data, loading, error }] = useSegmentUpdateMutation({
 *   variables: {
 *      id: // value for 'id'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSegmentUpdateMutation(baseOptions?: Apollo.MutationHookOptions<SegmentUpdateMutation, SegmentUpdateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SegmentUpdateMutation, SegmentUpdateMutationVariables>(SegmentUpdateDocument, options);
      }
export type SegmentUpdateMutationHookResult = ReturnType<typeof useSegmentUpdateMutation>;
export type SegmentUpdateMutationResult = Apollo.MutationResult<SegmentUpdateMutation>;
export type SegmentUpdateMutationOptions = Apollo.BaseMutationOptions<SegmentUpdateMutation, SegmentUpdateMutationVariables>;
export const SegmentDeleteDocument = gql`
    mutation segmentDelete($id: ID!) {
  segmentDelete(id: $id)
}
    `;
export type SegmentDeleteMutationFn = Apollo.MutationFunction<SegmentDeleteMutation, SegmentDeleteMutationVariables>;

/**
 * __useSegmentDeleteMutation__
 *
 * To run a mutation, you first call `useSegmentDeleteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSegmentDeleteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [segmentDeleteMutation, { data, loading, error }] = useSegmentDeleteMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useSegmentDeleteMutation(baseOptions?: Apollo.MutationHookOptions<SegmentDeleteMutation, SegmentDeleteMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SegmentDeleteMutation, SegmentDeleteMutationVariables>(SegmentDeleteDocument, options);
      }
export type SegmentDeleteMutationHookResult = ReturnType<typeof useSegmentDeleteMutation>;
export type SegmentDeleteMutationResult = Apollo.MutationResult<SegmentDeleteMutation>;
export type SegmentDeleteMutationOptions = Apollo.BaseMutationOptions<SegmentDeleteMutation, SegmentDeleteMutationVariables>;
export const SegmentMembershipAddDocument = gql`
    mutation segmentMembershipAdd($input: SegmentMembershipAddInput!) {
  segmentMembershipAdd(input: $input) {
    ...segment
  }
}
    ${SegmentFragmentDoc}`;
export type SegmentMembershipAddMutationFn = Apollo.MutationFunction<SegmentMembershipAddMutation, SegmentMembershipAddMutationVariables>;

/**
 * __useSegmentMembershipAddMutation__
 *
 * To run a mutation, you first call `useSegmentMembershipAddMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSegmentMembershipAddMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [segmentMembershipAddMutation, { data, loading, error }] = useSegmentMembershipAddMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSegmentMembershipAddMutation(baseOptions?: Apollo.MutationHookOptions<SegmentMembershipAddMutation, SegmentMembershipAddMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SegmentMembershipAddMutation, SegmentMembershipAddMutationVariables>(SegmentMembershipAddDocument, options);
      }
export type SegmentMembershipAddMutationHookResult = ReturnType<typeof useSegmentMembershipAddMutation>;
export type SegmentMembershipAddMutationResult = Apollo.MutationResult<SegmentMembershipAddMutation>;
export type SegmentMembershipAddMutationOptions = Apollo.BaseMutationOptions<SegmentMembershipAddMutation, SegmentMembershipAddMutationVariables>;
export const SegmentMembershipDeleteDocument = gql`
    mutation segmentMembershipDelete($input: SegmentMembershipDeleteInput!) {
  segmentMembershipDelete(input: $input)
}
    `;
export type SegmentMembershipDeleteMutationFn = Apollo.MutationFunction<SegmentMembershipDeleteMutation, SegmentMembershipDeleteMutationVariables>;

/**
 * __useSegmentMembershipDeleteMutation__
 *
 * To run a mutation, you first call `useSegmentMembershipDeleteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSegmentMembershipDeleteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [segmentMembershipDeleteMutation, { data, loading, error }] = useSegmentMembershipDeleteMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSegmentMembershipDeleteMutation(baseOptions?: Apollo.MutationHookOptions<SegmentMembershipDeleteMutation, SegmentMembershipDeleteMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SegmentMembershipDeleteMutation, SegmentMembershipDeleteMutationVariables>(SegmentMembershipDeleteDocument, options);
      }
export type SegmentMembershipDeleteMutationHookResult = ReturnType<typeof useSegmentMembershipDeleteMutation>;
export type SegmentMembershipDeleteMutationResult = Apollo.MutationResult<SegmentMembershipDeleteMutation>;
export type SegmentMembershipDeleteMutationOptions = Apollo.BaseMutationOptions<SegmentMembershipDeleteMutation, SegmentMembershipDeleteMutationVariables>;
export const SegmentDocument = gql`
    query segment($filter: SegmentFilter) {
  segments(filter: $filter) {
    edges {
      cursor
      node {
        ...segment
      }
    }
  }
}
    ${SegmentFragmentDoc}`;

/**
 * __useSegmentQuery__
 *
 * To run a query within a React component, call `useSegmentQuery` and pass it any options that fit your needs.
 * When your component renders, `useSegmentQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSegmentQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useSegmentQuery(baseOptions?: Apollo.QueryHookOptions<SegmentQuery, SegmentQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SegmentQuery, SegmentQueryVariables>(SegmentDocument, options);
      }
export function useSegmentLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SegmentQuery, SegmentQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SegmentQuery, SegmentQueryVariables>(SegmentDocument, options);
        }
export function useSegmentSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<SegmentQuery, SegmentQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<SegmentQuery, SegmentQueryVariables>(SegmentDocument, options);
        }
export type SegmentQueryHookResult = ReturnType<typeof useSegmentQuery>;
export type SegmentLazyQueryHookResult = ReturnType<typeof useSegmentLazyQuery>;
export type SegmentSuspenseQueryHookResult = ReturnType<typeof useSegmentSuspenseQuery>;
export type SegmentQueryResult = Apollo.QueryResult<SegmentQuery, SegmentQueryVariables>;
export const SegmentsDocument = gql`
    query segments($first: Int, $last: Int, $after: String, $before: String, $filter: SegmentFilter) {
  segments(
    first: $first
    last: $last
    after: $after
    before: $before
    filter: $filter
  ) {
    pageInfo {
      ...pageInfo
    }
    edges {
      cursor
      node {
        ...segment
      }
    }
  }
}
    ${PageInfoFragmentDoc}
${SegmentFragmentDoc}`;

/**
 * __useSegmentsQuery__
 *
 * To run a query within a React component, call `useSegmentsQuery` and pass it any options that fit your needs.
 * When your component renders, `useSegmentsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSegmentsQuery({
 *   variables: {
 *      first: // value for 'first'
 *      last: // value for 'last'
 *      after: // value for 'after'
 *      before: // value for 'before'
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useSegmentsQuery(baseOptions?: Apollo.QueryHookOptions<SegmentsQuery, SegmentsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SegmentsQuery, SegmentsQueryVariables>(SegmentsDocument, options);
      }
export function useSegmentsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SegmentsQuery, SegmentsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SegmentsQuery, SegmentsQueryVariables>(SegmentsDocument, options);
        }
export function useSegmentsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<SegmentsQuery, SegmentsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<SegmentsQuery, SegmentsQueryVariables>(SegmentsDocument, options);
        }
export type SegmentsQueryHookResult = ReturnType<typeof useSegmentsQuery>;
export type SegmentsLazyQueryHookResult = ReturnType<typeof useSegmentsLazyQuery>;
export type SegmentsSuspenseQueryHookResult = ReturnType<typeof useSegmentsSuspenseQuery>;
export type SegmentsQueryResult = Apollo.QueryResult<SegmentsQuery, SegmentsQueryVariables>;
export const SiteDisconnectDocument = gql`
    mutation siteDisconnect($input: SiteDisconnectInput!) {
  siteDisconnect(input: $input)
}
    `;
export type SiteDisconnectMutationFn = Apollo.MutationFunction<SiteDisconnectMutation, SiteDisconnectMutationVariables>;

/**
 * __useSiteDisconnectMutation__
 *
 * To run a mutation, you first call `useSiteDisconnectMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSiteDisconnectMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [siteDisconnectMutation, { data, loading, error }] = useSiteDisconnectMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSiteDisconnectMutation(baseOptions?: Apollo.MutationHookOptions<SiteDisconnectMutation, SiteDisconnectMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SiteDisconnectMutation, SiteDisconnectMutationVariables>(SiteDisconnectDocument, options);
      }
export type SiteDisconnectMutationHookResult = ReturnType<typeof useSiteDisconnectMutation>;
export type SiteDisconnectMutationResult = Apollo.MutationResult<SiteDisconnectMutation>;
export type SiteDisconnectMutationOptions = Apollo.BaseMutationOptions<SiteDisconnectMutation, SiteDisconnectMutationVariables>;
export const SiteMonitorActivityLogDocument = gql`
    query siteMonitorActivityLog($first: Int, $last: Int, $after: String, $before: String, $filter: ActivityLogFilter) {
  siteMonitorActivityLog(
    first: $first
    last: $last
    after: $after
    before: $before
    filter: $filter
  ) {
    pageInfo {
      ...pageInfo
    }
    edges {
      cursor
      node {
        ...siteMonitorActivityLogItem
      }
    }
  }
}
    ${PageInfoFragmentDoc}
${SiteMonitorActivityLogItemFragmentDoc}`;

/**
 * __useSiteMonitorActivityLogQuery__
 *
 * To run a query within a React component, call `useSiteMonitorActivityLogQuery` and pass it any options that fit your needs.
 * When your component renders, `useSiteMonitorActivityLogQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSiteMonitorActivityLogQuery({
 *   variables: {
 *      first: // value for 'first'
 *      last: // value for 'last'
 *      after: // value for 'after'
 *      before: // value for 'before'
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useSiteMonitorActivityLogQuery(baseOptions?: Apollo.QueryHookOptions<SiteMonitorActivityLogQuery, SiteMonitorActivityLogQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SiteMonitorActivityLogQuery, SiteMonitorActivityLogQueryVariables>(SiteMonitorActivityLogDocument, options);
      }
export function useSiteMonitorActivityLogLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SiteMonitorActivityLogQuery, SiteMonitorActivityLogQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SiteMonitorActivityLogQuery, SiteMonitorActivityLogQueryVariables>(SiteMonitorActivityLogDocument, options);
        }
export function useSiteMonitorActivityLogSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<SiteMonitorActivityLogQuery, SiteMonitorActivityLogQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<SiteMonitorActivityLogQuery, SiteMonitorActivityLogQueryVariables>(SiteMonitorActivityLogDocument, options);
        }
export type SiteMonitorActivityLogQueryHookResult = ReturnType<typeof useSiteMonitorActivityLogQuery>;
export type SiteMonitorActivityLogLazyQueryHookResult = ReturnType<typeof useSiteMonitorActivityLogLazyQuery>;
export type SiteMonitorActivityLogSuspenseQueryHookResult = ReturnType<typeof useSiteMonitorActivityLogSuspenseQuery>;
export type SiteMonitorActivityLogQueryResult = Apollo.QueryResult<SiteMonitorActivityLogQuery, SiteMonitorActivityLogQueryVariables>;
export const SteeringWalletCreateDocument = gql`
    mutation steeringWalletCreate($input: SteeringWalletCreateInput!) {
  steeringWalletCreate(input: $input) {
    ...steeringWallet
  }
}
    ${SteeringWalletFragmentDoc}`;
export type SteeringWalletCreateMutationFn = Apollo.MutationFunction<SteeringWalletCreateMutation, SteeringWalletCreateMutationVariables>;

/**
 * __useSteeringWalletCreateMutation__
 *
 * To run a mutation, you first call `useSteeringWalletCreateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSteeringWalletCreateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [steeringWalletCreateMutation, { data, loading, error }] = useSteeringWalletCreateMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSteeringWalletCreateMutation(baseOptions?: Apollo.MutationHookOptions<SteeringWalletCreateMutation, SteeringWalletCreateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SteeringWalletCreateMutation, SteeringWalletCreateMutationVariables>(SteeringWalletCreateDocument, options);
      }
export type SteeringWalletCreateMutationHookResult = ReturnType<typeof useSteeringWalletCreateMutation>;
export type SteeringWalletCreateMutationResult = Apollo.MutationResult<SteeringWalletCreateMutation>;
export type SteeringWalletCreateMutationOptions = Apollo.BaseMutationOptions<SteeringWalletCreateMutation, SteeringWalletCreateMutationVariables>;
export const SteeringWalletArchiveDocument = gql`
    mutation steeringWalletArchive($uuid: OCUUID!) {
  steeringWalletArchive(uuid: $uuid)
}
    `;
export type SteeringWalletArchiveMutationFn = Apollo.MutationFunction<SteeringWalletArchiveMutation, SteeringWalletArchiveMutationVariables>;

/**
 * __useSteeringWalletArchiveMutation__
 *
 * To run a mutation, you first call `useSteeringWalletArchiveMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSteeringWalletArchiveMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [steeringWalletArchiveMutation, { data, loading, error }] = useSteeringWalletArchiveMutation({
 *   variables: {
 *      uuid: // value for 'uuid'
 *   },
 * });
 */
export function useSteeringWalletArchiveMutation(baseOptions?: Apollo.MutationHookOptions<SteeringWalletArchiveMutation, SteeringWalletArchiveMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SteeringWalletArchiveMutation, SteeringWalletArchiveMutationVariables>(SteeringWalletArchiveDocument, options);
      }
export type SteeringWalletArchiveMutationHookResult = ReturnType<typeof useSteeringWalletArchiveMutation>;
export type SteeringWalletArchiveMutationResult = Apollo.MutationResult<SteeringWalletArchiveMutation>;
export type SteeringWalletArchiveMutationOptions = Apollo.BaseMutationOptions<SteeringWalletArchiveMutation, SteeringWalletArchiveMutationVariables>;
export const SteeringWalletUnarchiveDocument = gql`
    mutation steeringWalletUnarchive($uuid: OCUUID!) {
  steeringWalletUnarchive(uuid: $uuid)
}
    `;
export type SteeringWalletUnarchiveMutationFn = Apollo.MutationFunction<SteeringWalletUnarchiveMutation, SteeringWalletUnarchiveMutationVariables>;

/**
 * __useSteeringWalletUnarchiveMutation__
 *
 * To run a mutation, you first call `useSteeringWalletUnarchiveMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSteeringWalletUnarchiveMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [steeringWalletUnarchiveMutation, { data, loading, error }] = useSteeringWalletUnarchiveMutation({
 *   variables: {
 *      uuid: // value for 'uuid'
 *   },
 * });
 */
export function useSteeringWalletUnarchiveMutation(baseOptions?: Apollo.MutationHookOptions<SteeringWalletUnarchiveMutation, SteeringWalletUnarchiveMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SteeringWalletUnarchiveMutation, SteeringWalletUnarchiveMutationVariables>(SteeringWalletUnarchiveDocument, options);
      }
export type SteeringWalletUnarchiveMutationHookResult = ReturnType<typeof useSteeringWalletUnarchiveMutation>;
export type SteeringWalletUnarchiveMutationResult = Apollo.MutationResult<SteeringWalletUnarchiveMutation>;
export type SteeringWalletUnarchiveMutationOptions = Apollo.BaseMutationOptions<SteeringWalletUnarchiveMutation, SteeringWalletUnarchiveMutationVariables>;
export const WalletSteeringSurveyCreateDocument = gql`
    mutation walletSteeringSurveyCreate($input: WalletSteeringSurveyCreateInput!) {
  walletSteeringSurveyCreate(input: $input) {
    ...walletSteeringSurvey
  }
}
    ${WalletSteeringSurveyFragmentDoc}`;
export type WalletSteeringSurveyCreateMutationFn = Apollo.MutationFunction<WalletSteeringSurveyCreateMutation, WalletSteeringSurveyCreateMutationVariables>;

/**
 * __useWalletSteeringSurveyCreateMutation__
 *
 * To run a mutation, you first call `useWalletSteeringSurveyCreateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useWalletSteeringSurveyCreateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [walletSteeringSurveyCreateMutation, { data, loading, error }] = useWalletSteeringSurveyCreateMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useWalletSteeringSurveyCreateMutation(baseOptions?: Apollo.MutationHookOptions<WalletSteeringSurveyCreateMutation, WalletSteeringSurveyCreateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<WalletSteeringSurveyCreateMutation, WalletSteeringSurveyCreateMutationVariables>(WalletSteeringSurveyCreateDocument, options);
      }
export type WalletSteeringSurveyCreateMutationHookResult = ReturnType<typeof useWalletSteeringSurveyCreateMutation>;
export type WalletSteeringSurveyCreateMutationResult = Apollo.MutationResult<WalletSteeringSurveyCreateMutation>;
export type WalletSteeringSurveyCreateMutationOptions = Apollo.BaseMutationOptions<WalletSteeringSurveyCreateMutation, WalletSteeringSurveyCreateMutationVariables>;
export const WalletSteeringSurveyUpdateDocument = gql`
    mutation walletSteeringSurveyUpdate($input: WalletSteeringSurveyUpdateInput!) {
  walletSteeringSurveyUpdate(input: $input) {
    ...walletSteeringSurvey
  }
}
    ${WalletSteeringSurveyFragmentDoc}`;
export type WalletSteeringSurveyUpdateMutationFn = Apollo.MutationFunction<WalletSteeringSurveyUpdateMutation, WalletSteeringSurveyUpdateMutationVariables>;

/**
 * __useWalletSteeringSurveyUpdateMutation__
 *
 * To run a mutation, you first call `useWalletSteeringSurveyUpdateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useWalletSteeringSurveyUpdateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [walletSteeringSurveyUpdateMutation, { data, loading, error }] = useWalletSteeringSurveyUpdateMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useWalletSteeringSurveyUpdateMutation(baseOptions?: Apollo.MutationHookOptions<WalletSteeringSurveyUpdateMutation, WalletSteeringSurveyUpdateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<WalletSteeringSurveyUpdateMutation, WalletSteeringSurveyUpdateMutationVariables>(WalletSteeringSurveyUpdateDocument, options);
      }
export type WalletSteeringSurveyUpdateMutationHookResult = ReturnType<typeof useWalletSteeringSurveyUpdateMutation>;
export type WalletSteeringSurveyUpdateMutationResult = Apollo.MutationResult<WalletSteeringSurveyUpdateMutation>;
export type WalletSteeringSurveyUpdateMutationOptions = Apollo.BaseMutationOptions<WalletSteeringSurveyUpdateMutation, WalletSteeringSurveyUpdateMutationVariables>;
export const SteeringWalletUpdateDocument = gql`
    mutation steeringWalletUpdate($input: SteeringWalletUpdateInput!) {
  steeringWalletUpdate(input: $input) {
    ...steeringWallet
  }
}
    ${SteeringWalletFragmentDoc}`;
export type SteeringWalletUpdateMutationFn = Apollo.MutationFunction<SteeringWalletUpdateMutation, SteeringWalletUpdateMutationVariables>;

/**
 * __useSteeringWalletUpdateMutation__
 *
 * To run a mutation, you first call `useSteeringWalletUpdateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSteeringWalletUpdateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [steeringWalletUpdateMutation, { data, loading, error }] = useSteeringWalletUpdateMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSteeringWalletUpdateMutation(baseOptions?: Apollo.MutationHookOptions<SteeringWalletUpdateMutation, SteeringWalletUpdateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SteeringWalletUpdateMutation, SteeringWalletUpdateMutationVariables>(SteeringWalletUpdateDocument, options);
      }
export type SteeringWalletUpdateMutationHookResult = ReturnType<typeof useSteeringWalletUpdateMutation>;
export type SteeringWalletUpdateMutationResult = Apollo.MutationResult<SteeringWalletUpdateMutation>;
export type SteeringWalletUpdateMutationOptions = Apollo.BaseMutationOptions<SteeringWalletUpdateMutation, SteeringWalletUpdateMutationVariables>;
export const SteeringWalletActivateDocument = gql`
    mutation steeringWalletActivate($uuid: OCUUID!) {
  steeringWalletActivate(uuid: $uuid)
}
    `;
export type SteeringWalletActivateMutationFn = Apollo.MutationFunction<SteeringWalletActivateMutation, SteeringWalletActivateMutationVariables>;

/**
 * __useSteeringWalletActivateMutation__
 *
 * To run a mutation, you first call `useSteeringWalletActivateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSteeringWalletActivateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [steeringWalletActivateMutation, { data, loading, error }] = useSteeringWalletActivateMutation({
 *   variables: {
 *      uuid: // value for 'uuid'
 *   },
 * });
 */
export function useSteeringWalletActivateMutation(baseOptions?: Apollo.MutationHookOptions<SteeringWalletActivateMutation, SteeringWalletActivateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SteeringWalletActivateMutation, SteeringWalletActivateMutationVariables>(SteeringWalletActivateDocument, options);
      }
export type SteeringWalletActivateMutationHookResult = ReturnType<typeof useSteeringWalletActivateMutation>;
export type SteeringWalletActivateMutationResult = Apollo.MutationResult<SteeringWalletActivateMutation>;
export type SteeringWalletActivateMutationOptions = Apollo.BaseMutationOptions<SteeringWalletActivateMutation, SteeringWalletActivateMutationVariables>;
export const SteeringWalletDeactivateDocument = gql`
    mutation steeringWalletDeactivate($uuid: OCUUID!) {
  steeringWalletDeactivate(uuid: $uuid)
}
    `;
export type SteeringWalletDeactivateMutationFn = Apollo.MutationFunction<SteeringWalletDeactivateMutation, SteeringWalletDeactivateMutationVariables>;

/**
 * __useSteeringWalletDeactivateMutation__
 *
 * To run a mutation, you first call `useSteeringWalletDeactivateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSteeringWalletDeactivateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [steeringWalletDeactivateMutation, { data, loading, error }] = useSteeringWalletDeactivateMutation({
 *   variables: {
 *      uuid: // value for 'uuid'
 *   },
 * });
 */
export function useSteeringWalletDeactivateMutation(baseOptions?: Apollo.MutationHookOptions<SteeringWalletDeactivateMutation, SteeringWalletDeactivateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SteeringWalletDeactivateMutation, SteeringWalletDeactivateMutationVariables>(SteeringWalletDeactivateDocument, options);
      }
export type SteeringWalletDeactivateMutationHookResult = ReturnType<typeof useSteeringWalletDeactivateMutation>;
export type SteeringWalletDeactivateMutationResult = Apollo.MutationResult<SteeringWalletDeactivateMutation>;
export type SteeringWalletDeactivateMutationOptions = Apollo.BaseMutationOptions<SteeringWalletDeactivateMutation, SteeringWalletDeactivateMutationVariables>;
export const SurveyOfferCreateDocument = gql`
    mutation surveyOfferCreate($input: SurveyOfferCreateInput!) {
  surveyOfferCreate(input: $input) {
    ...offer
  }
}
    ${OfferFragmentDoc}`;
export type SurveyOfferCreateMutationFn = Apollo.MutationFunction<SurveyOfferCreateMutation, SurveyOfferCreateMutationVariables>;

/**
 * __useSurveyOfferCreateMutation__
 *
 * To run a mutation, you first call `useSurveyOfferCreateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSurveyOfferCreateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [surveyOfferCreateMutation, { data, loading, error }] = useSurveyOfferCreateMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSurveyOfferCreateMutation(baseOptions?: Apollo.MutationHookOptions<SurveyOfferCreateMutation, SurveyOfferCreateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SurveyOfferCreateMutation, SurveyOfferCreateMutationVariables>(SurveyOfferCreateDocument, options);
      }
export type SurveyOfferCreateMutationHookResult = ReturnType<typeof useSurveyOfferCreateMutation>;
export type SurveyOfferCreateMutationResult = Apollo.MutationResult<SurveyOfferCreateMutation>;
export type SurveyOfferCreateMutationOptions = Apollo.BaseMutationOptions<SurveyOfferCreateMutation, SurveyOfferCreateMutationVariables>;
export const SurveyOfferUpdateDocument = gql`
    mutation surveyOfferUpdate($input: SurveyOfferUpdateInput!) {
  surveyOfferUpdate(input: $input) {
    ...offer
  }
}
    ${OfferFragmentDoc}`;
export type SurveyOfferUpdateMutationFn = Apollo.MutationFunction<SurveyOfferUpdateMutation, SurveyOfferUpdateMutationVariables>;

/**
 * __useSurveyOfferUpdateMutation__
 *
 * To run a mutation, you first call `useSurveyOfferUpdateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSurveyOfferUpdateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [surveyOfferUpdateMutation, { data, loading, error }] = useSurveyOfferUpdateMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSurveyOfferUpdateMutation(baseOptions?: Apollo.MutationHookOptions<SurveyOfferUpdateMutation, SurveyOfferUpdateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SurveyOfferUpdateMutation, SurveyOfferUpdateMutationVariables>(SurveyOfferUpdateDocument, options);
      }
export type SurveyOfferUpdateMutationHookResult = ReturnType<typeof useSurveyOfferUpdateMutation>;
export type SurveyOfferUpdateMutationResult = Apollo.MutationResult<SurveyOfferUpdateMutation>;
export type SurveyOfferUpdateMutationOptions = Apollo.BaseMutationOptions<SurveyOfferUpdateMutation, SurveyOfferUpdateMutationVariables>;
export const SurveyOfferDeleteDocument = gql`
    mutation surveyOfferDelete($surveyUuid: ID!) {
  surveyOfferDelete(surveyUuid: $surveyUuid)
}
    `;
export type SurveyOfferDeleteMutationFn = Apollo.MutationFunction<SurveyOfferDeleteMutation, SurveyOfferDeleteMutationVariables>;

/**
 * __useSurveyOfferDeleteMutation__
 *
 * To run a mutation, you first call `useSurveyOfferDeleteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSurveyOfferDeleteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [surveyOfferDeleteMutation, { data, loading, error }] = useSurveyOfferDeleteMutation({
 *   variables: {
 *      surveyUuid: // value for 'surveyUuid'
 *   },
 * });
 */
export function useSurveyOfferDeleteMutation(baseOptions?: Apollo.MutationHookOptions<SurveyOfferDeleteMutation, SurveyOfferDeleteMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SurveyOfferDeleteMutation, SurveyOfferDeleteMutationVariables>(SurveyOfferDeleteDocument, options);
      }
export type SurveyOfferDeleteMutationHookResult = ReturnType<typeof useSurveyOfferDeleteMutation>;
export type SurveyOfferDeleteMutationResult = Apollo.MutationResult<SurveyOfferDeleteMutation>;
export type SurveyOfferDeleteMutationOptions = Apollo.BaseMutationOptions<SurveyOfferDeleteMutation, SurveyOfferDeleteMutationVariables>;
export const SteeringWalletsDocument = gql`
    query steeringWallets($first: Int, $last: Int, $after: OCBase64Cursor, $before: OCBase64Cursor, $filter: SteeringWalletFilter) {
  steeringWallets(
    first: $first
    last: $last
    after: $after
    before: $before
    filter: $filter
  ) {
    pageInfo {
      ...pageInfo
    }
    edges {
      cursor
      node {
        ...steeringWallet
      }
    }
  }
}
    ${PageInfoFragmentDoc}
${SteeringWalletFragmentDoc}`;

/**
 * __useSteeringWalletsQuery__
 *
 * To run a query within a React component, call `useSteeringWalletsQuery` and pass it any options that fit your needs.
 * When your component renders, `useSteeringWalletsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSteeringWalletsQuery({
 *   variables: {
 *      first: // value for 'first'
 *      last: // value for 'last'
 *      after: // value for 'after'
 *      before: // value for 'before'
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useSteeringWalletsQuery(baseOptions?: Apollo.QueryHookOptions<SteeringWalletsQuery, SteeringWalletsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SteeringWalletsQuery, SteeringWalletsQueryVariables>(SteeringWalletsDocument, options);
      }
export function useSteeringWalletsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SteeringWalletsQuery, SteeringWalletsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SteeringWalletsQuery, SteeringWalletsQueryVariables>(SteeringWalletsDocument, options);
        }
export function useSteeringWalletsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<SteeringWalletsQuery, SteeringWalletsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<SteeringWalletsQuery, SteeringWalletsQueryVariables>(SteeringWalletsDocument, options);
        }
export type SteeringWalletsQueryHookResult = ReturnType<typeof useSteeringWalletsQuery>;
export type SteeringWalletsLazyQueryHookResult = ReturnType<typeof useSteeringWalletsLazyQuery>;
export type SteeringWalletsSuspenseQueryHookResult = ReturnType<typeof useSteeringWalletsSuspenseQuery>;
export type SteeringWalletsQueryResult = Apollo.QueryResult<SteeringWalletsQuery, SteeringWalletsQueryVariables>;
export const GetBasicInfoSteeringWalletsDocument = gql`
    query getBasicInfoSteeringWallets($first: Int, $last: Int, $after: OCBase64Cursor, $before: OCBase64Cursor, $filter: SteeringWalletFilter) {
  steeringWallets(
    first: $first
    last: $last
    after: $after
    before: $before
    filter: $filter
  ) {
    pageInfo {
      ...pageInfo
    }
    edges {
      cursor
      node {
        ...steeringWalletBasicInfo
      }
    }
  }
}
    ${PageInfoFragmentDoc}
${SteeringWalletBasicInfoFragmentDoc}`;

/**
 * __useGetBasicInfoSteeringWalletsQuery__
 *
 * To run a query within a React component, call `useGetBasicInfoSteeringWalletsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetBasicInfoSteeringWalletsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetBasicInfoSteeringWalletsQuery({
 *   variables: {
 *      first: // value for 'first'
 *      last: // value for 'last'
 *      after: // value for 'after'
 *      before: // value for 'before'
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useGetBasicInfoSteeringWalletsQuery(baseOptions?: Apollo.QueryHookOptions<GetBasicInfoSteeringWalletsQuery, GetBasicInfoSteeringWalletsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetBasicInfoSteeringWalletsQuery, GetBasicInfoSteeringWalletsQueryVariables>(GetBasicInfoSteeringWalletsDocument, options);
      }
export function useGetBasicInfoSteeringWalletsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetBasicInfoSteeringWalletsQuery, GetBasicInfoSteeringWalletsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetBasicInfoSteeringWalletsQuery, GetBasicInfoSteeringWalletsQueryVariables>(GetBasicInfoSteeringWalletsDocument, options);
        }
export function useGetBasicInfoSteeringWalletsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetBasicInfoSteeringWalletsQuery, GetBasicInfoSteeringWalletsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetBasicInfoSteeringWalletsQuery, GetBasicInfoSteeringWalletsQueryVariables>(GetBasicInfoSteeringWalletsDocument, options);
        }
export type GetBasicInfoSteeringWalletsQueryHookResult = ReturnType<typeof useGetBasicInfoSteeringWalletsQuery>;
export type GetBasicInfoSteeringWalletsLazyQueryHookResult = ReturnType<typeof useGetBasicInfoSteeringWalletsLazyQuery>;
export type GetBasicInfoSteeringWalletsSuspenseQueryHookResult = ReturnType<typeof useGetBasicInfoSteeringWalletsSuspenseQuery>;
export type GetBasicInfoSteeringWalletsQueryResult = Apollo.QueryResult<GetBasicInfoSteeringWalletsQuery, GetBasicInfoSteeringWalletsQueryVariables>;
export const SteeringWalletDocument = gql`
    query steeringWallet($uuid: OCUUID!) {
  steeringWallet(uuid: $uuid) {
    ...steeringWallet
  }
}
    ${SteeringWalletFragmentDoc}`;

/**
 * __useSteeringWalletQuery__
 *
 * To run a query within a React component, call `useSteeringWalletQuery` and pass it any options that fit your needs.
 * When your component renders, `useSteeringWalletQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSteeringWalletQuery({
 *   variables: {
 *      uuid: // value for 'uuid'
 *   },
 * });
 */
export function useSteeringWalletQuery(baseOptions: Apollo.QueryHookOptions<SteeringWalletQuery, SteeringWalletQueryVariables> & ({ variables: SteeringWalletQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SteeringWalletQuery, SteeringWalletQueryVariables>(SteeringWalletDocument, options);
      }
export function useSteeringWalletLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SteeringWalletQuery, SteeringWalletQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SteeringWalletQuery, SteeringWalletQueryVariables>(SteeringWalletDocument, options);
        }
export function useSteeringWalletSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<SteeringWalletQuery, SteeringWalletQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<SteeringWalletQuery, SteeringWalletQueryVariables>(SteeringWalletDocument, options);
        }
export type SteeringWalletQueryHookResult = ReturnType<typeof useSteeringWalletQuery>;
export type SteeringWalletLazyQueryHookResult = ReturnType<typeof useSteeringWalletLazyQuery>;
export type SteeringWalletSuspenseQueryHookResult = ReturnType<typeof useSteeringWalletSuspenseQuery>;
export type SteeringWalletQueryResult = Apollo.QueryResult<SteeringWalletQuery, SteeringWalletQueryVariables>;
export const SurveysDocument = gql`
    query surveys($filter: SurveyFilter, $after: OCBase64Cursor, $before: OCBase64Cursor, $first: Int, $last: Int) {
  surveys(
    filter: $filter
    after: $after
    before: $before
    first: $first
    last: $last
  ) {
    pageInfo {
      ...pageInfo
    }
    edges {
      cursor
      node {
        ...survey
        ... on WalletSteeringSurvey {
          configuration {
            ...walletSteeringSurveyConfiguration
          }
        }
      }
    }
  }
}
    ${PageInfoFragmentDoc}
${SurveyFragmentDoc}
${WalletSteeringSurveyConfigurationFragmentDoc}`;

/**
 * __useSurveysQuery__
 *
 * To run a query within a React component, call `useSurveysQuery` and pass it any options that fit your needs.
 * When your component renders, `useSurveysQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSurveysQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *      after: // value for 'after'
 *      before: // value for 'before'
 *      first: // value for 'first'
 *      last: // value for 'last'
 *   },
 * });
 */
export function useSurveysQuery(baseOptions?: Apollo.QueryHookOptions<SurveysQuery, SurveysQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SurveysQuery, SurveysQueryVariables>(SurveysDocument, options);
      }
export function useSurveysLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SurveysQuery, SurveysQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SurveysQuery, SurveysQueryVariables>(SurveysDocument, options);
        }
export function useSurveysSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<SurveysQuery, SurveysQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<SurveysQuery, SurveysQueryVariables>(SurveysDocument, options);
        }
export type SurveysQueryHookResult = ReturnType<typeof useSurveysQuery>;
export type SurveysLazyQueryHookResult = ReturnType<typeof useSurveysLazyQuery>;
export type SurveysSuspenseQueryHookResult = ReturnType<typeof useSurveysSuspenseQuery>;
export type SurveysQueryResult = Apollo.QueryResult<SurveysQuery, SurveysQueryVariables>;
export const WalletsForMembershipDocument = gql`
    query walletsForMembership($membershipId: OCUUID!, $after: OCBase64Cursor, $before: OCBase64Cursor, $first: Int, $last: Int) {
  walletsForMembership(
    membershipId: $membershipId
    after: $after
    before: $before
    first: $first
    last: $last
  ) {
    pageInfo {
      ...pageInfo
    }
    edges {
      cursor
      node {
        ...steeringWallet
      }
    }
  }
}
    ${PageInfoFragmentDoc}
${SteeringWalletFragmentDoc}`;

/**
 * __useWalletsForMembershipQuery__
 *
 * To run a query within a React component, call `useWalletsForMembershipQuery` and pass it any options that fit your needs.
 * When your component renders, `useWalletsForMembershipQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useWalletsForMembershipQuery({
 *   variables: {
 *      membershipId: // value for 'membershipId'
 *      after: // value for 'after'
 *      before: // value for 'before'
 *      first: // value for 'first'
 *      last: // value for 'last'
 *   },
 * });
 */
export function useWalletsForMembershipQuery(baseOptions: Apollo.QueryHookOptions<WalletsForMembershipQuery, WalletsForMembershipQueryVariables> & ({ variables: WalletsForMembershipQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<WalletsForMembershipQuery, WalletsForMembershipQueryVariables>(WalletsForMembershipDocument, options);
      }
export function useWalletsForMembershipLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<WalletsForMembershipQuery, WalletsForMembershipQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<WalletsForMembershipQuery, WalletsForMembershipQueryVariables>(WalletsForMembershipDocument, options);
        }
export function useWalletsForMembershipSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<WalletsForMembershipQuery, WalletsForMembershipQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<WalletsForMembershipQuery, WalletsForMembershipQueryVariables>(WalletsForMembershipDocument, options);
        }
export type WalletsForMembershipQueryHookResult = ReturnType<typeof useWalletsForMembershipQuery>;
export type WalletsForMembershipLazyQueryHookResult = ReturnType<typeof useWalletsForMembershipLazyQuery>;
export type WalletsForMembershipSuspenseQueryHookResult = ReturnType<typeof useWalletsForMembershipSuspenseQuery>;
export type WalletsForMembershipQueryResult = Apollo.QueryResult<WalletsForMembershipQuery, WalletsForMembershipQueryVariables>;
export const SubBrandsDocument = gql`
    query subBrands {
  subBrands {
    edges {
      cursor
      node {
        ...subBrand
      }
    }
  }
}
    ${SubBrandFragmentDoc}`;

/**
 * __useSubBrandsQuery__
 *
 * To run a query within a React component, call `useSubBrandsQuery` and pass it any options that fit your needs.
 * When your component renders, `useSubBrandsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSubBrandsQuery({
 *   variables: {
 *   },
 * });
 */
export function useSubBrandsQuery(baseOptions?: Apollo.QueryHookOptions<SubBrandsQuery, SubBrandsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SubBrandsQuery, SubBrandsQueryVariables>(SubBrandsDocument, options);
      }
export function useSubBrandsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SubBrandsQuery, SubBrandsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SubBrandsQuery, SubBrandsQueryVariables>(SubBrandsDocument, options);
        }
export function useSubBrandsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<SubBrandsQuery, SubBrandsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<SubBrandsQuery, SubBrandsQueryVariables>(SubBrandsDocument, options);
        }
export type SubBrandsQueryHookResult = ReturnType<typeof useSubBrandsQuery>;
export type SubBrandsLazyQueryHookResult = ReturnType<typeof useSubBrandsLazyQuery>;
export type SubBrandsSuspenseQueryHookResult = ReturnType<typeof useSubBrandsSuspenseQuery>;
export type SubBrandsQueryResult = Apollo.QueryResult<SubBrandsQuery, SubBrandsQueryVariables>;
export const GeneralSurveyCreateDocument = gql`
    mutation generalSurveyCreate($input: GeneralSurveyCreateInput!) {
  generalSurveyCreate(input: $input) {
    ...generalSurvey
  }
}
    ${GeneralSurveyFragmentDoc}`;
export type GeneralSurveyCreateMutationFn = Apollo.MutationFunction<GeneralSurveyCreateMutation, GeneralSurveyCreateMutationVariables>;

/**
 * __useGeneralSurveyCreateMutation__
 *
 * To run a mutation, you first call `useGeneralSurveyCreateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useGeneralSurveyCreateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [generalSurveyCreateMutation, { data, loading, error }] = useGeneralSurveyCreateMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGeneralSurveyCreateMutation(baseOptions?: Apollo.MutationHookOptions<GeneralSurveyCreateMutation, GeneralSurveyCreateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GeneralSurveyCreateMutation, GeneralSurveyCreateMutationVariables>(GeneralSurveyCreateDocument, options);
      }
export type GeneralSurveyCreateMutationHookResult = ReturnType<typeof useGeneralSurveyCreateMutation>;
export type GeneralSurveyCreateMutationResult = Apollo.MutationResult<GeneralSurveyCreateMutation>;
export type GeneralSurveyCreateMutationOptions = Apollo.BaseMutationOptions<GeneralSurveyCreateMutation, GeneralSurveyCreateMutationVariables>;
export const GeneralSurveyUpdateDocument = gql`
    mutation generalSurveyUpdate($input: GeneralSurveyUpdateInput!) {
  generalSurveyUpdate(input: $input) {
    ...generalSurvey
  }
}
    ${GeneralSurveyFragmentDoc}`;
export type GeneralSurveyUpdateMutationFn = Apollo.MutationFunction<GeneralSurveyUpdateMutation, GeneralSurveyUpdateMutationVariables>;

/**
 * __useGeneralSurveyUpdateMutation__
 *
 * To run a mutation, you first call `useGeneralSurveyUpdateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useGeneralSurveyUpdateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [generalSurveyUpdateMutation, { data, loading, error }] = useGeneralSurveyUpdateMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGeneralSurveyUpdateMutation(baseOptions?: Apollo.MutationHookOptions<GeneralSurveyUpdateMutation, GeneralSurveyUpdateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GeneralSurveyUpdateMutation, GeneralSurveyUpdateMutationVariables>(GeneralSurveyUpdateDocument, options);
      }
export type GeneralSurveyUpdateMutationHookResult = ReturnType<typeof useGeneralSurveyUpdateMutation>;
export type GeneralSurveyUpdateMutationResult = Apollo.MutationResult<GeneralSurveyUpdateMutation>;
export type GeneralSurveyUpdateMutationOptions = Apollo.BaseMutationOptions<GeneralSurveyUpdateMutation, GeneralSurveyUpdateMutationVariables>;
export const GeneralSurveyStatusUpdateDocument = gql`
    mutation generalSurveyStatusUpdate($input: GeneralSurveyStatusUpdateInput!) {
  generalSurveyStatusUpdate(input: $input) {
    ...generalSurvey
  }
}
    ${GeneralSurveyFragmentDoc}`;
export type GeneralSurveyStatusUpdateMutationFn = Apollo.MutationFunction<GeneralSurveyStatusUpdateMutation, GeneralSurveyStatusUpdateMutationVariables>;

/**
 * __useGeneralSurveyStatusUpdateMutation__
 *
 * To run a mutation, you first call `useGeneralSurveyStatusUpdateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useGeneralSurveyStatusUpdateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [generalSurveyStatusUpdateMutation, { data, loading, error }] = useGeneralSurveyStatusUpdateMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGeneralSurveyStatusUpdateMutation(baseOptions?: Apollo.MutationHookOptions<GeneralSurveyStatusUpdateMutation, GeneralSurveyStatusUpdateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GeneralSurveyStatusUpdateMutation, GeneralSurveyStatusUpdateMutationVariables>(GeneralSurveyStatusUpdateDocument, options);
      }
export type GeneralSurveyStatusUpdateMutationHookResult = ReturnType<typeof useGeneralSurveyStatusUpdateMutation>;
export type GeneralSurveyStatusUpdateMutationResult = Apollo.MutationResult<GeneralSurveyStatusUpdateMutation>;
export type GeneralSurveyStatusUpdateMutationOptions = Apollo.BaseMutationOptions<GeneralSurveyStatusUpdateMutation, GeneralSurveyStatusUpdateMutationVariables>;
export const GeneralSurveysDocument = gql`
    query generalSurveys($filter: SurveyFilter, $after: OCBase64Cursor, $before: OCBase64Cursor, $first: Int, $last: Int) {
  surveys(
    filter: $filter
    after: $after
    before: $before
    first: $first
    last: $last
  ) {
    pageInfo {
      ...pageInfo
    }
    edges {
      cursor
      node {
        ...generalSurvey
      }
    }
  }
}
    ${PageInfoFragmentDoc}
${GeneralSurveyFragmentDoc}`;

/**
 * __useGeneralSurveysQuery__
 *
 * To run a query within a React component, call `useGeneralSurveysQuery` and pass it any options that fit your needs.
 * When your component renders, `useGeneralSurveysQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGeneralSurveysQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *      after: // value for 'after'
 *      before: // value for 'before'
 *      first: // value for 'first'
 *      last: // value for 'last'
 *   },
 * });
 */
export function useGeneralSurveysQuery(baseOptions?: Apollo.QueryHookOptions<GeneralSurveysQuery, GeneralSurveysQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GeneralSurveysQuery, GeneralSurveysQueryVariables>(GeneralSurveysDocument, options);
      }
export function useGeneralSurveysLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GeneralSurveysQuery, GeneralSurveysQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GeneralSurveysQuery, GeneralSurveysQueryVariables>(GeneralSurveysDocument, options);
        }
export function useGeneralSurveysSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GeneralSurveysQuery, GeneralSurveysQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GeneralSurveysQuery, GeneralSurveysQueryVariables>(GeneralSurveysDocument, options);
        }
export type GeneralSurveysQueryHookResult = ReturnType<typeof useGeneralSurveysQuery>;
export type GeneralSurveysLazyQueryHookResult = ReturnType<typeof useGeneralSurveysLazyQuery>;
export type GeneralSurveysSuspenseQueryHookResult = ReturnType<typeof useGeneralSurveysSuspenseQuery>;
export type GeneralSurveysQueryResult = Apollo.QueryResult<GeneralSurveysQuery, GeneralSurveysQueryVariables>;
export const GeneralSurveyDocument = gql`
    query generalSurvey($uuid: OCUUID!) {
  survey(uuid: $uuid) {
    ...generalSurvey
  }
}
    ${GeneralSurveyFragmentDoc}`;

/**
 * __useGeneralSurveyQuery__
 *
 * To run a query within a React component, call `useGeneralSurveyQuery` and pass it any options that fit your needs.
 * When your component renders, `useGeneralSurveyQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGeneralSurveyQuery({
 *   variables: {
 *      uuid: // value for 'uuid'
 *   },
 * });
 */
export function useGeneralSurveyQuery(baseOptions: Apollo.QueryHookOptions<GeneralSurveyQuery, GeneralSurveyQueryVariables> & ({ variables: GeneralSurveyQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GeneralSurveyQuery, GeneralSurveyQueryVariables>(GeneralSurveyDocument, options);
      }
export function useGeneralSurveyLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GeneralSurveyQuery, GeneralSurveyQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GeneralSurveyQuery, GeneralSurveyQueryVariables>(GeneralSurveyDocument, options);
        }
export function useGeneralSurveySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GeneralSurveyQuery, GeneralSurveyQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GeneralSurveyQuery, GeneralSurveyQueryVariables>(GeneralSurveyDocument, options);
        }
export type GeneralSurveyQueryHookResult = ReturnType<typeof useGeneralSurveyQuery>;
export type GeneralSurveyLazyQueryHookResult = ReturnType<typeof useGeneralSurveyLazyQuery>;
export type GeneralSurveySuspenseQueryHookResult = ReturnType<typeof useGeneralSurveySuspenseQuery>;
export type GeneralSurveyQueryResult = Apollo.QueryResult<GeneralSurveyQuery, GeneralSurveyQueryVariables>;
export const SurveyQuestionResponseStatisticsDocument = gql`
    query surveyQuestionResponseStatistics($questionUuid: OCUUID!) {
  surveyQuestionResponseStatistics(questionUuid: $questionUuid) {
    optionSelectionCounters {
      ...optionSelectionCounter
    }
    sliderResponseRanges {
      ...sliderResponseRange
    }
  }
}
    ${OptionSelectionCounterFragmentDoc}
${SliderResponseRangeFragmentDoc}`;

/**
 * __useSurveyQuestionResponseStatisticsQuery__
 *
 * To run a query within a React component, call `useSurveyQuestionResponseStatisticsQuery` and pass it any options that fit your needs.
 * When your component renders, `useSurveyQuestionResponseStatisticsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSurveyQuestionResponseStatisticsQuery({
 *   variables: {
 *      questionUuid: // value for 'questionUuid'
 *   },
 * });
 */
export function useSurveyQuestionResponseStatisticsQuery(baseOptions: Apollo.QueryHookOptions<SurveyQuestionResponseStatisticsQuery, SurveyQuestionResponseStatisticsQueryVariables> & ({ variables: SurveyQuestionResponseStatisticsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SurveyQuestionResponseStatisticsQuery, SurveyQuestionResponseStatisticsQueryVariables>(SurveyQuestionResponseStatisticsDocument, options);
      }
export function useSurveyQuestionResponseStatisticsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SurveyQuestionResponseStatisticsQuery, SurveyQuestionResponseStatisticsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SurveyQuestionResponseStatisticsQuery, SurveyQuestionResponseStatisticsQueryVariables>(SurveyQuestionResponseStatisticsDocument, options);
        }
export function useSurveyQuestionResponseStatisticsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<SurveyQuestionResponseStatisticsQuery, SurveyQuestionResponseStatisticsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<SurveyQuestionResponseStatisticsQuery, SurveyQuestionResponseStatisticsQueryVariables>(SurveyQuestionResponseStatisticsDocument, options);
        }
export type SurveyQuestionResponseStatisticsQueryHookResult = ReturnType<typeof useSurveyQuestionResponseStatisticsQuery>;
export type SurveyQuestionResponseStatisticsLazyQueryHookResult = ReturnType<typeof useSurveyQuestionResponseStatisticsLazyQuery>;
export type SurveyQuestionResponseStatisticsSuspenseQueryHookResult = ReturnType<typeof useSurveyQuestionResponseStatisticsSuspenseQuery>;
export type SurveyQuestionResponseStatisticsQueryResult = Apollo.QueryResult<SurveyQuestionResponseStatisticsQuery, SurveyQuestionResponseStatisticsQueryVariables>;
export const SurveyLocationStatisticsDocument = gql`
    query surveyLocationStatistics($filter: SurveyLocationStatisticsFilter, $after: OCBase64Cursor, $before: OCBase64Cursor, $first: Int, $last: Int, $sort: SurveyLocationStatisticsSort) {
  surveyLocationStatistics(
    filter: $filter
    after: $after
    before: $before
    first: $first
    last: $last
    sort: $sort
  ) {
    pageInfo {
      ...pageInfo
    }
    edges {
      cursor
      node {
        ...surveyLocationStatistics
      }
    }
  }
}
    ${PageInfoFragmentDoc}
${SurveyLocationStatisticsFragmentDoc}`;

/**
 * __useSurveyLocationStatisticsQuery__
 *
 * To run a query within a React component, call `useSurveyLocationStatisticsQuery` and pass it any options that fit your needs.
 * When your component renders, `useSurveyLocationStatisticsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSurveyLocationStatisticsQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *      after: // value for 'after'
 *      before: // value for 'before'
 *      first: // value for 'first'
 *      last: // value for 'last'
 *      sort: // value for 'sort'
 *   },
 * });
 */
export function useSurveyLocationStatisticsQuery(baseOptions?: Apollo.QueryHookOptions<SurveyLocationStatisticsQuery, SurveyLocationStatisticsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SurveyLocationStatisticsQuery, SurveyLocationStatisticsQueryVariables>(SurveyLocationStatisticsDocument, options);
      }
export function useSurveyLocationStatisticsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SurveyLocationStatisticsQuery, SurveyLocationStatisticsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SurveyLocationStatisticsQuery, SurveyLocationStatisticsQueryVariables>(SurveyLocationStatisticsDocument, options);
        }
export function useSurveyLocationStatisticsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<SurveyLocationStatisticsQuery, SurveyLocationStatisticsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<SurveyLocationStatisticsQuery, SurveyLocationStatisticsQueryVariables>(SurveyLocationStatisticsDocument, options);
        }
export type SurveyLocationStatisticsQueryHookResult = ReturnType<typeof useSurveyLocationStatisticsQuery>;
export type SurveyLocationStatisticsLazyQueryHookResult = ReturnType<typeof useSurveyLocationStatisticsLazyQuery>;
export type SurveyLocationStatisticsSuspenseQueryHookResult = ReturnType<typeof useSurveyLocationStatisticsSuspenseQuery>;
export type SurveyLocationStatisticsQueryResult = Apollo.QueryResult<SurveyLocationStatisticsQuery, SurveyLocationStatisticsQueryVariables>;
export const SurveyMetricsDocument = gql`
    query surveyMetrics($filter: SurveyMetricsFilter) {
  surveyMetrics(filter: $filter) {
    ...surveyMetrics
  }
}
    ${SurveyMetricsFragmentDoc}`;

/**
 * __useSurveyMetricsQuery__
 *
 * To run a query within a React component, call `useSurveyMetricsQuery` and pass it any options that fit your needs.
 * When your component renders, `useSurveyMetricsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSurveyMetricsQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useSurveyMetricsQuery(baseOptions?: Apollo.QueryHookOptions<SurveyMetricsQuery, SurveyMetricsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SurveyMetricsQuery, SurveyMetricsQueryVariables>(SurveyMetricsDocument, options);
      }
export function useSurveyMetricsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SurveyMetricsQuery, SurveyMetricsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SurveyMetricsQuery, SurveyMetricsQueryVariables>(SurveyMetricsDocument, options);
        }
export function useSurveyMetricsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<SurveyMetricsQuery, SurveyMetricsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<SurveyMetricsQuery, SurveyMetricsQueryVariables>(SurveyMetricsDocument, options);
        }
export type SurveyMetricsQueryHookResult = ReturnType<typeof useSurveyMetricsQuery>;
export type SurveyMetricsLazyQueryHookResult = ReturnType<typeof useSurveyMetricsLazyQuery>;
export type SurveyMetricsSuspenseQueryHookResult = ReturnType<typeof useSurveyMetricsSuspenseQuery>;
export type SurveyMetricsQueryResult = Apollo.QueryResult<SurveyMetricsQuery, SurveyMetricsQueryVariables>;
export const TransactionDetailsDocument = gql`
    query transactionDetails($filter: TransactionFilter) {
  transactions(filter: $filter) {
    edges {
      cursor
      node {
        ...transactionDetails
      }
    }
  }
}
    ${TransactionDetailsFragmentDoc}`;

/**
 * __useTransactionDetailsQuery__
 *
 * To run a query within a React component, call `useTransactionDetailsQuery` and pass it any options that fit your needs.
 * When your component renders, `useTransactionDetailsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTransactionDetailsQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useTransactionDetailsQuery(baseOptions?: Apollo.QueryHookOptions<TransactionDetailsQuery, TransactionDetailsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<TransactionDetailsQuery, TransactionDetailsQueryVariables>(TransactionDetailsDocument, options);
      }
export function useTransactionDetailsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<TransactionDetailsQuery, TransactionDetailsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<TransactionDetailsQuery, TransactionDetailsQueryVariables>(TransactionDetailsDocument, options);
        }
export function useTransactionDetailsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<TransactionDetailsQuery, TransactionDetailsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<TransactionDetailsQuery, TransactionDetailsQueryVariables>(TransactionDetailsDocument, options);
        }
export type TransactionDetailsQueryHookResult = ReturnType<typeof useTransactionDetailsQuery>;
export type TransactionDetailsLazyQueryHookResult = ReturnType<typeof useTransactionDetailsLazyQuery>;
export type TransactionDetailsSuspenseQueryHookResult = ReturnType<typeof useTransactionDetailsSuspenseQuery>;
export type TransactionDetailsQueryResult = Apollo.QueryResult<TransactionDetailsQuery, TransactionDetailsQueryVariables>;
export const TransactionsDocument = gql`
    query transactions($first: Int, $last: Int, $after: String, $before: String, $filter: TransactionFilter) {
  transactions(
    first: $first
    last: $last
    after: $after
    before: $before
    filter: $filter
  ) {
    pageInfo {
      ...pageInfo
    }
    edges {
      cursor
      node {
        ...transaction
      }
    }
  }
}
    ${PageInfoFragmentDoc}
${TransactionFragmentDoc}`;

/**
 * __useTransactionsQuery__
 *
 * To run a query within a React component, call `useTransactionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useTransactionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTransactionsQuery({
 *   variables: {
 *      first: // value for 'first'
 *      last: // value for 'last'
 *      after: // value for 'after'
 *      before: // value for 'before'
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useTransactionsQuery(baseOptions?: Apollo.QueryHookOptions<TransactionsQuery, TransactionsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<TransactionsQuery, TransactionsQueryVariables>(TransactionsDocument, options);
      }
export function useTransactionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<TransactionsQuery, TransactionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<TransactionsQuery, TransactionsQueryVariables>(TransactionsDocument, options);
        }
export function useTransactionsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<TransactionsQuery, TransactionsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<TransactionsQuery, TransactionsQueryVariables>(TransactionsDocument, options);
        }
export type TransactionsQueryHookResult = ReturnType<typeof useTransactionsQuery>;
export type TransactionsLazyQueryHookResult = ReturnType<typeof useTransactionsLazyQuery>;
export type TransactionsSuspenseQueryHookResult = ReturnType<typeof useTransactionsSuspenseQuery>;
export type TransactionsQueryResult = Apollo.QueryResult<TransactionsQuery, TransactionsQueryVariables>;
export const TransactionFraudulentInfoDocument = gql`
    query transactionFraudulentInfo($transactionUuid: OCUUID!) {
  transactionFraudulentInfo(transactionUuid: $transactionUuid) {
    ... on KountFraudCheckResult {
      ...kountFraudCheckResult
    }
  }
}
    ${KountFraudCheckResultFragmentDoc}`;

/**
 * __useTransactionFraudulentInfoQuery__
 *
 * To run a query within a React component, call `useTransactionFraudulentInfoQuery` and pass it any options that fit your needs.
 * When your component renders, `useTransactionFraudulentInfoQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTransactionFraudulentInfoQuery({
 *   variables: {
 *      transactionUuid: // value for 'transactionUuid'
 *   },
 * });
 */
export function useTransactionFraudulentInfoQuery(baseOptions: Apollo.QueryHookOptions<TransactionFraudulentInfoQuery, TransactionFraudulentInfoQueryVariables> & ({ variables: TransactionFraudulentInfoQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<TransactionFraudulentInfoQuery, TransactionFraudulentInfoQueryVariables>(TransactionFraudulentInfoDocument, options);
      }
export function useTransactionFraudulentInfoLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<TransactionFraudulentInfoQuery, TransactionFraudulentInfoQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<TransactionFraudulentInfoQuery, TransactionFraudulentInfoQueryVariables>(TransactionFraudulentInfoDocument, options);
        }
export function useTransactionFraudulentInfoSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<TransactionFraudulentInfoQuery, TransactionFraudulentInfoQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<TransactionFraudulentInfoQuery, TransactionFraudulentInfoQueryVariables>(TransactionFraudulentInfoDocument, options);
        }
export type TransactionFraudulentInfoQueryHookResult = ReturnType<typeof useTransactionFraudulentInfoQuery>;
export type TransactionFraudulentInfoLazyQueryHookResult = ReturnType<typeof useTransactionFraudulentInfoLazyQuery>;
export type TransactionFraudulentInfoSuspenseQueryHookResult = ReturnType<typeof useTransactionFraudulentInfoSuspenseQuery>;
export type TransactionFraudulentInfoQueryResult = Apollo.QueryResult<TransactionFraudulentInfoQuery, TransactionFraudulentInfoQueryVariables>;
export const SiteConnectionHistoryDocument = gql`
    query siteConnectionHistory($first: Int, $last: Int, $after: OCBase64Cursor, $before: OCBase64Cursor, $filter: SiteConnectionHistoryFilter) {
  siteConnectionHistory(
    first: $first
    last: $last
    after: $after
    before: $before
    filter: $filter
  ) {
    pageInfo {
      ...pageInfo
    }
    edges {
      cursor
      node {
        ...siteConnectionHistory
      }
    }
  }
}
    ${PageInfoFragmentDoc}
${SiteConnectionHistoryFragmentDoc}`;

/**
 * __useSiteConnectionHistoryQuery__
 *
 * To run a query within a React component, call `useSiteConnectionHistoryQuery` and pass it any options that fit your needs.
 * When your component renders, `useSiteConnectionHistoryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSiteConnectionHistoryQuery({
 *   variables: {
 *      first: // value for 'first'
 *      last: // value for 'last'
 *      after: // value for 'after'
 *      before: // value for 'before'
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useSiteConnectionHistoryQuery(baseOptions?: Apollo.QueryHookOptions<SiteConnectionHistoryQuery, SiteConnectionHistoryQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SiteConnectionHistoryQuery, SiteConnectionHistoryQueryVariables>(SiteConnectionHistoryDocument, options);
      }
export function useSiteConnectionHistoryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SiteConnectionHistoryQuery, SiteConnectionHistoryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SiteConnectionHistoryQuery, SiteConnectionHistoryQueryVariables>(SiteConnectionHistoryDocument, options);
        }
export function useSiteConnectionHistorySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<SiteConnectionHistoryQuery, SiteConnectionHistoryQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<SiteConnectionHistoryQuery, SiteConnectionHistoryQueryVariables>(SiteConnectionHistoryDocument, options);
        }
export type SiteConnectionHistoryQueryHookResult = ReturnType<typeof useSiteConnectionHistoryQuery>;
export type SiteConnectionHistoryLazyQueryHookResult = ReturnType<typeof useSiteConnectionHistoryLazyQuery>;
export type SiteConnectionHistorySuspenseQueryHookResult = ReturnType<typeof useSiteConnectionHistorySuspenseQuery>;
export type SiteConnectionHistoryQueryResult = Apollo.QueryResult<SiteConnectionHistoryQuery, SiteConnectionHistoryQueryVariables>;
export const SiteConnectionHistorySummaryDocument = gql`
    query siteConnectionHistorySummary($filter: SiteConnectionHistorySummaryFilter) {
  siteConnectionHistorySummary(filter: $filter) {
    totalConnectionFailures
    totalConnections
    totalDisconnections
  }
}
    `;

/**
 * __useSiteConnectionHistorySummaryQuery__
 *
 * To run a query within a React component, call `useSiteConnectionHistorySummaryQuery` and pass it any options that fit your needs.
 * When your component renders, `useSiteConnectionHistorySummaryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSiteConnectionHistorySummaryQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useSiteConnectionHistorySummaryQuery(baseOptions?: Apollo.QueryHookOptions<SiteConnectionHistorySummaryQuery, SiteConnectionHistorySummaryQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SiteConnectionHistorySummaryQuery, SiteConnectionHistorySummaryQueryVariables>(SiteConnectionHistorySummaryDocument, options);
      }
export function useSiteConnectionHistorySummaryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SiteConnectionHistorySummaryQuery, SiteConnectionHistorySummaryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SiteConnectionHistorySummaryQuery, SiteConnectionHistorySummaryQueryVariables>(SiteConnectionHistorySummaryDocument, options);
        }
export function useSiteConnectionHistorySummarySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<SiteConnectionHistorySummaryQuery, SiteConnectionHistorySummaryQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<SiteConnectionHistorySummaryQuery, SiteConnectionHistorySummaryQueryVariables>(SiteConnectionHistorySummaryDocument, options);
        }
export type SiteConnectionHistorySummaryQueryHookResult = ReturnType<typeof useSiteConnectionHistorySummaryQuery>;
export type SiteConnectionHistorySummaryLazyQueryHookResult = ReturnType<typeof useSiteConnectionHistorySummaryLazyQuery>;
export type SiteConnectionHistorySummarySuspenseQueryHookResult = ReturnType<typeof useSiteConnectionHistorySummarySuspenseQuery>;
export type SiteConnectionHistorySummaryQueryResult = Apollo.QueryResult<SiteConnectionHistorySummaryQuery, SiteConnectionHistorySummaryQueryVariables>;
export const GetCommandCenterAppConfigDocument = gql`
    query getCommandCenterAppConfig {
  appConfig: commandCenterAppConfig {
    ...commandCenterAppConfig
  }
}
    ${CommandCenterAppConfigFragmentDoc}`;

/**
 * __useGetCommandCenterAppConfigQuery__
 *
 * To run a query within a React component, call `useGetCommandCenterAppConfigQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCommandCenterAppConfigQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCommandCenterAppConfigQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetCommandCenterAppConfigQuery(baseOptions?: Apollo.QueryHookOptions<GetCommandCenterAppConfigQuery, GetCommandCenterAppConfigQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCommandCenterAppConfigQuery, GetCommandCenterAppConfigQueryVariables>(GetCommandCenterAppConfigDocument, options);
      }
export function useGetCommandCenterAppConfigLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCommandCenterAppConfigQuery, GetCommandCenterAppConfigQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCommandCenterAppConfigQuery, GetCommandCenterAppConfigQueryVariables>(GetCommandCenterAppConfigDocument, options);
        }
export function useGetCommandCenterAppConfigSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetCommandCenterAppConfigQuery, GetCommandCenterAppConfigQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetCommandCenterAppConfigQuery, GetCommandCenterAppConfigQueryVariables>(GetCommandCenterAppConfigDocument, options);
        }
export type GetCommandCenterAppConfigQueryHookResult = ReturnType<typeof useGetCommandCenterAppConfigQuery>;
export type GetCommandCenterAppConfigLazyQueryHookResult = ReturnType<typeof useGetCommandCenterAppConfigLazyQuery>;
export type GetCommandCenterAppConfigSuspenseQueryHookResult = ReturnType<typeof useGetCommandCenterAppConfigSuspenseQuery>;
export type GetCommandCenterAppConfigQueryResult = Apollo.QueryResult<GetCommandCenterAppConfigQuery, GetCommandCenterAppConfigQueryVariables>;
export const DeleteAllowListPhoneNumberDocument = gql`
    mutation deleteAllowListPhoneNumber($input: AllowListPhoneNumberDeleteInput!) {
  deleteAllowListPhoneNumber: allowListPhoneNumberDelete(input: $input)
}
    `;
export type DeleteAllowListPhoneNumberMutationFn = Apollo.MutationFunction<DeleteAllowListPhoneNumberMutation, DeleteAllowListPhoneNumberMutationVariables>;

/**
 * __useDeleteAllowListPhoneNumberMutation__
 *
 * To run a mutation, you first call `useDeleteAllowListPhoneNumberMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteAllowListPhoneNumberMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteAllowListPhoneNumberMutation, { data, loading, error }] = useDeleteAllowListPhoneNumberMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDeleteAllowListPhoneNumberMutation(baseOptions?: Apollo.MutationHookOptions<DeleteAllowListPhoneNumberMutation, DeleteAllowListPhoneNumberMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteAllowListPhoneNumberMutation, DeleteAllowListPhoneNumberMutationVariables>(DeleteAllowListPhoneNumberDocument, options);
      }
export type DeleteAllowListPhoneNumberMutationHookResult = ReturnType<typeof useDeleteAllowListPhoneNumberMutation>;
export type DeleteAllowListPhoneNumberMutationResult = Apollo.MutationResult<DeleteAllowListPhoneNumberMutation>;
export type DeleteAllowListPhoneNumberMutationOptions = Apollo.BaseMutationOptions<DeleteAllowListPhoneNumberMutation, DeleteAllowListPhoneNumberMutationVariables>;
export const CreateAllowListPhoneNumberDocument = gql`
    mutation createAllowListPhoneNumber($input: AllowListPhoneNumberCreateInput!) {
  createAllowListPhoneNumber: allowListPhoneNumberCreate(input: $input) {
    ...allowListPhoneNumber
  }
}
    ${AllowListPhoneNumberFragmentDoc}`;
export type CreateAllowListPhoneNumberMutationFn = Apollo.MutationFunction<CreateAllowListPhoneNumberMutation, CreateAllowListPhoneNumberMutationVariables>;

/**
 * __useCreateAllowListPhoneNumberMutation__
 *
 * To run a mutation, you first call `useCreateAllowListPhoneNumberMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateAllowListPhoneNumberMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createAllowListPhoneNumberMutation, { data, loading, error }] = useCreateAllowListPhoneNumberMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateAllowListPhoneNumberMutation(baseOptions?: Apollo.MutationHookOptions<CreateAllowListPhoneNumberMutation, CreateAllowListPhoneNumberMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateAllowListPhoneNumberMutation, CreateAllowListPhoneNumberMutationVariables>(CreateAllowListPhoneNumberDocument, options);
      }
export type CreateAllowListPhoneNumberMutationHookResult = ReturnType<typeof useCreateAllowListPhoneNumberMutation>;
export type CreateAllowListPhoneNumberMutationResult = Apollo.MutationResult<CreateAllowListPhoneNumberMutation>;
export type CreateAllowListPhoneNumberMutationOptions = Apollo.BaseMutationOptions<CreateAllowListPhoneNumberMutation, CreateAllowListPhoneNumberMutationVariables>;
export const UpdateAllowListPhoneNumberDocument = gql`
    mutation updateAllowListPhoneNumber($input: AllowListPhoneNumberUpdateInput!) {
  updateAllowListPhoneNumber: allowListPhoneNumberUpdate(input: $input) {
    ...allowListPhoneNumber
  }
}
    ${AllowListPhoneNumberFragmentDoc}`;
export type UpdateAllowListPhoneNumberMutationFn = Apollo.MutationFunction<UpdateAllowListPhoneNumberMutation, UpdateAllowListPhoneNumberMutationVariables>;

/**
 * __useUpdateAllowListPhoneNumberMutation__
 *
 * To run a mutation, you first call `useUpdateAllowListPhoneNumberMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateAllowListPhoneNumberMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateAllowListPhoneNumberMutation, { data, loading, error }] = useUpdateAllowListPhoneNumberMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateAllowListPhoneNumberMutation(baseOptions?: Apollo.MutationHookOptions<UpdateAllowListPhoneNumberMutation, UpdateAllowListPhoneNumberMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateAllowListPhoneNumberMutation, UpdateAllowListPhoneNumberMutationVariables>(UpdateAllowListPhoneNumberDocument, options);
      }
export type UpdateAllowListPhoneNumberMutationHookResult = ReturnType<typeof useUpdateAllowListPhoneNumberMutation>;
export type UpdateAllowListPhoneNumberMutationResult = Apollo.MutationResult<UpdateAllowListPhoneNumberMutation>;
export type UpdateAllowListPhoneNumberMutationOptions = Apollo.BaseMutationOptions<UpdateAllowListPhoneNumberMutation, UpdateAllowListPhoneNumberMutationVariables>;
export const GetAllowListPhoneNumbersDocument = gql`
    query getAllowListPhoneNumbers($after: OCBase64Cursor, $before: OCBase64Cursor, $filter: AllowListPhoneNumberFilterInput, $first: Int, $last: Int) {
  getAllowListPhoneNumbers: allowListPhoneNumbers(
    after: $after
    before: $before
    filter: $filter
    first: $first
    last: $last
  ) {
    pageInfo {
      hasNextPage
      hasPreviousPage
      startCursor
      endCursor
    }
    edges {
      cursor
      node {
        ...allowListPhoneNumber
      }
    }
  }
}
    ${AllowListPhoneNumberFragmentDoc}`;

/**
 * __useGetAllowListPhoneNumbersQuery__
 *
 * To run a query within a React component, call `useGetAllowListPhoneNumbersQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAllowListPhoneNumbersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAllowListPhoneNumbersQuery({
 *   variables: {
 *      after: // value for 'after'
 *      before: // value for 'before'
 *      filter: // value for 'filter'
 *      first: // value for 'first'
 *      last: // value for 'last'
 *   },
 * });
 */
export function useGetAllowListPhoneNumbersQuery(baseOptions?: Apollo.QueryHookOptions<GetAllowListPhoneNumbersQuery, GetAllowListPhoneNumbersQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAllowListPhoneNumbersQuery, GetAllowListPhoneNumbersQueryVariables>(GetAllowListPhoneNumbersDocument, options);
      }
export function useGetAllowListPhoneNumbersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAllowListPhoneNumbersQuery, GetAllowListPhoneNumbersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAllowListPhoneNumbersQuery, GetAllowListPhoneNumbersQueryVariables>(GetAllowListPhoneNumbersDocument, options);
        }
export function useGetAllowListPhoneNumbersSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetAllowListPhoneNumbersQuery, GetAllowListPhoneNumbersQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetAllowListPhoneNumbersQuery, GetAllowListPhoneNumbersQueryVariables>(GetAllowListPhoneNumbersDocument, options);
        }
export type GetAllowListPhoneNumbersQueryHookResult = ReturnType<typeof useGetAllowListPhoneNumbersQuery>;
export type GetAllowListPhoneNumbersLazyQueryHookResult = ReturnType<typeof useGetAllowListPhoneNumbersLazyQuery>;
export type GetAllowListPhoneNumbersSuspenseQueryHookResult = ReturnType<typeof useGetAllowListPhoneNumbersSuspenseQuery>;
export type GetAllowListPhoneNumbersQueryResult = Apollo.QueryResult<GetAllowListPhoneNumbersQuery, GetAllowListPhoneNumbersQueryVariables>;
export const CreateCsrotpSessionDocument = gql`
    mutation createCSROTPSession($input: CreateCSROTPSessionInput!) {
  createCSROTPSession(input: $input) {
    session
  }
}
    `;
export type CreateCsrotpSessionMutationFn = Apollo.MutationFunction<CreateCsrotpSessionMutation, CreateCsrotpSessionMutationVariables>;

/**
 * __useCreateCsrotpSessionMutation__
 *
 * To run a mutation, you first call `useCreateCsrotpSessionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateCsrotpSessionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createCsrotpSessionMutation, { data, loading, error }] = useCreateCsrotpSessionMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateCsrotpSessionMutation(baseOptions?: Apollo.MutationHookOptions<CreateCsrotpSessionMutation, CreateCsrotpSessionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateCsrotpSessionMutation, CreateCsrotpSessionMutationVariables>(CreateCsrotpSessionDocument, options);
      }
export type CreateCsrotpSessionMutationHookResult = ReturnType<typeof useCreateCsrotpSessionMutation>;
export type CreateCsrotpSessionMutationResult = Apollo.MutationResult<CreateCsrotpSessionMutation>;
export type CreateCsrotpSessionMutationOptions = Apollo.BaseMutationOptions<CreateCsrotpSessionMutation, CreateCsrotpSessionMutationVariables>;
export const VerifyCsrotpSessionDocument = gql`
    mutation verifyCSROTPSession($otp: OTP!) {
  verifyCSROTPSession(otp: $otp) {
    url
  }
}
    `;
export type VerifyCsrotpSessionMutationFn = Apollo.MutationFunction<VerifyCsrotpSessionMutation, VerifyCsrotpSessionMutationVariables>;

/**
 * __useVerifyCsrotpSessionMutation__
 *
 * To run a mutation, you first call `useVerifyCsrotpSessionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useVerifyCsrotpSessionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [verifyCsrotpSessionMutation, { data, loading, error }] = useVerifyCsrotpSessionMutation({
 *   variables: {
 *      otp: // value for 'otp'
 *   },
 * });
 */
export function useVerifyCsrotpSessionMutation(baseOptions?: Apollo.MutationHookOptions<VerifyCsrotpSessionMutation, VerifyCsrotpSessionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<VerifyCsrotpSessionMutation, VerifyCsrotpSessionMutationVariables>(VerifyCsrotpSessionDocument, options);
      }
export type VerifyCsrotpSessionMutationHookResult = ReturnType<typeof useVerifyCsrotpSessionMutation>;
export type VerifyCsrotpSessionMutationResult = Apollo.MutationResult<VerifyCsrotpSessionMutation>;
export type VerifyCsrotpSessionMutationOptions = Apollo.BaseMutationOptions<VerifyCsrotpSessionMutation, VerifyCsrotpSessionMutationVariables>;
export const CreateCsrCustomerMagicLinkDocument = gql`
    mutation createCSRCustomerMagicLink($input: CSRMagicLinkSessionCreateInput!) {
  createCSRCustomerMagicLink(input: $input) {
    url
  }
}
    `;
export type CreateCsrCustomerMagicLinkMutationFn = Apollo.MutationFunction<CreateCsrCustomerMagicLinkMutation, CreateCsrCustomerMagicLinkMutationVariables>;

/**
 * __useCreateCsrCustomerMagicLinkMutation__
 *
 * To run a mutation, you first call `useCreateCsrCustomerMagicLinkMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateCsrCustomerMagicLinkMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createCsrCustomerMagicLinkMutation, { data, loading, error }] = useCreateCsrCustomerMagicLinkMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateCsrCustomerMagicLinkMutation(baseOptions?: Apollo.MutationHookOptions<CreateCsrCustomerMagicLinkMutation, CreateCsrCustomerMagicLinkMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateCsrCustomerMagicLinkMutation, CreateCsrCustomerMagicLinkMutationVariables>(CreateCsrCustomerMagicLinkDocument, options);
      }
export type CreateCsrCustomerMagicLinkMutationHookResult = ReturnType<typeof useCreateCsrCustomerMagicLinkMutation>;
export type CreateCsrCustomerMagicLinkMutationResult = Apollo.MutationResult<CreateCsrCustomerMagicLinkMutation>;
export type CreateCsrCustomerMagicLinkMutationOptions = Apollo.BaseMutationOptions<CreateCsrCustomerMagicLinkMutation, CreateCsrCustomerMagicLinkMutationVariables>;
export const DriveSetReactionDocument = gql`
    mutation driveSetReaction($input: DriveSetReactionInput!) {
  driveSetReaction(input: $input) {
    ...DriveResponse
  }
}
    ${DriveResponseFragmentDoc}`;
export type DriveSetReactionMutationFn = Apollo.MutationFunction<DriveSetReactionMutation, DriveSetReactionMutationVariables>;

/**
 * __useDriveSetReactionMutation__
 *
 * To run a mutation, you first call `useDriveSetReactionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDriveSetReactionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [driveSetReactionMutation, { data, loading, error }] = useDriveSetReactionMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDriveSetReactionMutation(baseOptions?: Apollo.MutationHookOptions<DriveSetReactionMutation, DriveSetReactionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DriveSetReactionMutation, DriveSetReactionMutationVariables>(DriveSetReactionDocument, options);
      }
export type DriveSetReactionMutationHookResult = ReturnType<typeof useDriveSetReactionMutation>;
export type DriveSetReactionMutationResult = Apollo.MutationResult<DriveSetReactionMutation>;
export type DriveSetReactionMutationOptions = Apollo.BaseMutationOptions<DriveSetReactionMutation, DriveSetReactionMutationVariables>;
export const DriveTriggerStreamingPromptDocument = gql`
    mutation driveTriggerStreamingPrompt($input: DriveSendPromptInput!) {
  driveTriggerStreamingPrompt(input: $input) {
    ...DriveResponse
  }
}
    ${DriveResponseFragmentDoc}`;
export type DriveTriggerStreamingPromptMutationFn = Apollo.MutationFunction<DriveTriggerStreamingPromptMutation, DriveTriggerStreamingPromptMutationVariables>;

/**
 * __useDriveTriggerStreamingPromptMutation__
 *
 * To run a mutation, you first call `useDriveTriggerStreamingPromptMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDriveTriggerStreamingPromptMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [driveTriggerStreamingPromptMutation, { data, loading, error }] = useDriveTriggerStreamingPromptMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDriveTriggerStreamingPromptMutation(baseOptions?: Apollo.MutationHookOptions<DriveTriggerStreamingPromptMutation, DriveTriggerStreamingPromptMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DriveTriggerStreamingPromptMutation, DriveTriggerStreamingPromptMutationVariables>(DriveTriggerStreamingPromptDocument, options);
      }
export type DriveTriggerStreamingPromptMutationHookResult = ReturnType<typeof useDriveTriggerStreamingPromptMutation>;
export type DriveTriggerStreamingPromptMutationResult = Apollo.MutationResult<DriveTriggerStreamingPromptMutation>;
export type DriveTriggerStreamingPromptMutationOptions = Apollo.BaseMutationOptions<DriveTriggerStreamingPromptMutation, DriveTriggerStreamingPromptMutationVariables>;
export const DriveConversationsDocument = gql`
    query driveConversations($after: OCBase64Cursor, $before: OCBase64Cursor, $filter: DriveConversationFilter, $first: Int, $last: Int) {
  driveConversations(
    after: $after
    before: $before
    filter: $filter
    first: $first
    last: $last
  ) {
    edges {
      cursor
      node {
        ...DriveConversation
      }
    }
    pageInfo {
      ...pageInfo
    }
  }
}
    ${DriveConversationFragmentDoc}
${PageInfoFragmentDoc}`;

/**
 * __useDriveConversationsQuery__
 *
 * To run a query within a React component, call `useDriveConversationsQuery` and pass it any options that fit your needs.
 * When your component renders, `useDriveConversationsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDriveConversationsQuery({
 *   variables: {
 *      after: // value for 'after'
 *      before: // value for 'before'
 *      filter: // value for 'filter'
 *      first: // value for 'first'
 *      last: // value for 'last'
 *   },
 * });
 */
export function useDriveConversationsQuery(baseOptions?: Apollo.QueryHookOptions<DriveConversationsQuery, DriveConversationsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<DriveConversationsQuery, DriveConversationsQueryVariables>(DriveConversationsDocument, options);
      }
export function useDriveConversationsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<DriveConversationsQuery, DriveConversationsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<DriveConversationsQuery, DriveConversationsQueryVariables>(DriveConversationsDocument, options);
        }
export function useDriveConversationsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<DriveConversationsQuery, DriveConversationsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<DriveConversationsQuery, DriveConversationsQueryVariables>(DriveConversationsDocument, options);
        }
export type DriveConversationsQueryHookResult = ReturnType<typeof useDriveConversationsQuery>;
export type DriveConversationsLazyQueryHookResult = ReturnType<typeof useDriveConversationsLazyQuery>;
export type DriveConversationsSuspenseQueryHookResult = ReturnType<typeof useDriveConversationsSuspenseQuery>;
export type DriveConversationsQueryResult = Apollo.QueryResult<DriveConversationsQuery, DriveConversationsQueryVariables>;
export const DriveSubscribeToConversationDocument = gql`
    subscription driveSubscribeToConversation($conversationId: ID!) {
  driveSubscribeToConversation(conversationId: $conversationId) {
    chunkNumber
    complete
    content
    conversationId
    responseId
  }
}
    `;

/**
 * __useDriveSubscribeToConversationSubscription__
 *
 * To run a query within a React component, call `useDriveSubscribeToConversationSubscription` and pass it any options that fit your needs.
 * When your component renders, `useDriveSubscribeToConversationSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDriveSubscribeToConversationSubscription({
 *   variables: {
 *      conversationId: // value for 'conversationId'
 *   },
 * });
 */
export function useDriveSubscribeToConversationSubscription(baseOptions: Apollo.SubscriptionHookOptions<DriveSubscribeToConversationSubscription, DriveSubscribeToConversationSubscriptionVariables> & ({ variables: DriveSubscribeToConversationSubscriptionVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<DriveSubscribeToConversationSubscription, DriveSubscribeToConversationSubscriptionVariables>(DriveSubscribeToConversationDocument, options);
      }
export type DriveSubscribeToConversationSubscriptionHookResult = ReturnType<typeof useDriveSubscribeToConversationSubscription>;
export type DriveSubscribeToConversationSubscriptionResult = Apollo.SubscriptionResult<DriveSubscribeToConversationSubscription>;
export const MembershipReferralInfoDocument = gql`
    query membershipReferralInfo($membershipId: ID!) {
  memberships(first: 1, filter: {idEquals: $membershipId}) {
    edges {
      cursor
      node {
        ...MembershipReferralInfo
      }
    }
  }
}
    ${MembershipReferralInfoFragmentDoc}`;

/**
 * __useMembershipReferralInfoQuery__
 *
 * To run a query within a React component, call `useMembershipReferralInfoQuery` and pass it any options that fit your needs.
 * When your component renders, `useMembershipReferralInfoQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMembershipReferralInfoQuery({
 *   variables: {
 *      membershipId: // value for 'membershipId'
 *   },
 * });
 */
export function useMembershipReferralInfoQuery(baseOptions: Apollo.QueryHookOptions<MembershipReferralInfoQuery, MembershipReferralInfoQueryVariables> & ({ variables: MembershipReferralInfoQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<MembershipReferralInfoQuery, MembershipReferralInfoQueryVariables>(MembershipReferralInfoDocument, options);
      }
export function useMembershipReferralInfoLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MembershipReferralInfoQuery, MembershipReferralInfoQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<MembershipReferralInfoQuery, MembershipReferralInfoQueryVariables>(MembershipReferralInfoDocument, options);
        }
export function useMembershipReferralInfoSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<MembershipReferralInfoQuery, MembershipReferralInfoQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<MembershipReferralInfoQuery, MembershipReferralInfoQueryVariables>(MembershipReferralInfoDocument, options);
        }
export type MembershipReferralInfoQueryHookResult = ReturnType<typeof useMembershipReferralInfoQuery>;
export type MembershipReferralInfoLazyQueryHookResult = ReturnType<typeof useMembershipReferralInfoLazyQuery>;
export type MembershipReferralInfoSuspenseQueryHookResult = ReturnType<typeof useMembershipReferralInfoSuspenseQuery>;
export type MembershipReferralInfoQueryResult = Apollo.QueryResult<MembershipReferralInfoQuery, MembershipReferralInfoQueryVariables>;
export const MembershipReferralsDocument = gql`
    query membershipReferrals($membershipId: ID!, $first: Int, $last: Int, $after: ID, $before: ID, $filter: ReferralFilter) {
  memberships(first: 1, filter: {idEquals: $membershipId}) {
    edges {
      cursor
      node {
        ...MembershipReferrals
      }
    }
  }
}
    ${MembershipReferralsFragmentDoc}`;

/**
 * __useMembershipReferralsQuery__
 *
 * To run a query within a React component, call `useMembershipReferralsQuery` and pass it any options that fit your needs.
 * When your component renders, `useMembershipReferralsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMembershipReferralsQuery({
 *   variables: {
 *      membershipId: // value for 'membershipId'
 *      first: // value for 'first'
 *      last: // value for 'last'
 *      after: // value for 'after'
 *      before: // value for 'before'
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useMembershipReferralsQuery(baseOptions: Apollo.QueryHookOptions<MembershipReferralsQuery, MembershipReferralsQueryVariables> & ({ variables: MembershipReferralsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<MembershipReferralsQuery, MembershipReferralsQueryVariables>(MembershipReferralsDocument, options);
      }
export function useMembershipReferralsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MembershipReferralsQuery, MembershipReferralsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<MembershipReferralsQuery, MembershipReferralsQueryVariables>(MembershipReferralsDocument, options);
        }
export function useMembershipReferralsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<MembershipReferralsQuery, MembershipReferralsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<MembershipReferralsQuery, MembershipReferralsQueryVariables>(MembershipReferralsDocument, options);
        }
export type MembershipReferralsQueryHookResult = ReturnType<typeof useMembershipReferralsQuery>;
export type MembershipReferralsLazyQueryHookResult = ReturnType<typeof useMembershipReferralsLazyQuery>;
export type MembershipReferralsSuspenseQueryHookResult = ReturnType<typeof useMembershipReferralsSuspenseQuery>;
export type MembershipReferralsQueryResult = Apollo.QueryResult<MembershipReferralsQuery, MembershipReferralsQueryVariables>;
export const ArchiveMessagingCampaignDocument = gql`
    mutation archiveMessagingCampaign($id: OCUUID!) {
  archiveMessagingCampaign: archiveAudienceBroadcastMessage(id: $id) {
    uuid
    status
  }
}
    `;
export type ArchiveMessagingCampaignMutationFn = Apollo.MutationFunction<ArchiveMessagingCampaignMutation, ArchiveMessagingCampaignMutationVariables>;

/**
 * __useArchiveMessagingCampaignMutation__
 *
 * To run a mutation, you first call `useArchiveMessagingCampaignMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useArchiveMessagingCampaignMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [archiveMessagingCampaignMutation, { data, loading, error }] = useArchiveMessagingCampaignMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useArchiveMessagingCampaignMutation(baseOptions?: Apollo.MutationHookOptions<ArchiveMessagingCampaignMutation, ArchiveMessagingCampaignMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ArchiveMessagingCampaignMutation, ArchiveMessagingCampaignMutationVariables>(ArchiveMessagingCampaignDocument, options);
      }
export type ArchiveMessagingCampaignMutationHookResult = ReturnType<typeof useArchiveMessagingCampaignMutation>;
export type ArchiveMessagingCampaignMutationResult = Apollo.MutationResult<ArchiveMessagingCampaignMutation>;
export type ArchiveMessagingCampaignMutationOptions = Apollo.BaseMutationOptions<ArchiveMessagingCampaignMutation, ArchiveMessagingCampaignMutationVariables>;
export const CreateMessagingCampaignDocument = gql`
    mutation createMessagingCampaign($input: CreateAudienceBroadcastMessageInput!) {
  campaign: createAudienceBroadcastMessage(input: $input) {
    ...MessagingCampaignDetails
  }
}
    ${MessagingCampaignDetailsFragmentDoc}`;
export type CreateMessagingCampaignMutationFn = Apollo.MutationFunction<CreateMessagingCampaignMutation, CreateMessagingCampaignMutationVariables>;

/**
 * __useCreateMessagingCampaignMutation__
 *
 * To run a mutation, you first call `useCreateMessagingCampaignMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateMessagingCampaignMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createMessagingCampaignMutation, { data, loading, error }] = useCreateMessagingCampaignMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateMessagingCampaignMutation(baseOptions?: Apollo.MutationHookOptions<CreateMessagingCampaignMutation, CreateMessagingCampaignMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateMessagingCampaignMutation, CreateMessagingCampaignMutationVariables>(CreateMessagingCampaignDocument, options);
      }
export type CreateMessagingCampaignMutationHookResult = ReturnType<typeof useCreateMessagingCampaignMutation>;
export type CreateMessagingCampaignMutationResult = Apollo.MutationResult<CreateMessagingCampaignMutation>;
export type CreateMessagingCampaignMutationOptions = Apollo.BaseMutationOptions<CreateMessagingCampaignMutation, CreateMessagingCampaignMutationVariables>;
export const MessagingCampaignDetailsDocument = gql`
    query messagingCampaignDetails($first: Int, $last: Int, $after: String, $before: String, $filter: AudienceBroadcastMessagesFilter) {
  campaign: audienceBroadcastMessages(
    first: $first
    last: $last
    after: $after
    before: $before
    filter: $filter
  ) {
    pageInfo {
      ...pageInfo
    }
    edges {
      cursor
      node {
        ...MessagingCampaignDetails
      }
    }
  }
}
    ${PageInfoFragmentDoc}
${MessagingCampaignDetailsFragmentDoc}`;

/**
 * __useMessagingCampaignDetailsQuery__
 *
 * To run a query within a React component, call `useMessagingCampaignDetailsQuery` and pass it any options that fit your needs.
 * When your component renders, `useMessagingCampaignDetailsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMessagingCampaignDetailsQuery({
 *   variables: {
 *      first: // value for 'first'
 *      last: // value for 'last'
 *      after: // value for 'after'
 *      before: // value for 'before'
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useMessagingCampaignDetailsQuery(baseOptions?: Apollo.QueryHookOptions<MessagingCampaignDetailsQuery, MessagingCampaignDetailsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<MessagingCampaignDetailsQuery, MessagingCampaignDetailsQueryVariables>(MessagingCampaignDetailsDocument, options);
      }
export function useMessagingCampaignDetailsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MessagingCampaignDetailsQuery, MessagingCampaignDetailsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<MessagingCampaignDetailsQuery, MessagingCampaignDetailsQueryVariables>(MessagingCampaignDetailsDocument, options);
        }
export function useMessagingCampaignDetailsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<MessagingCampaignDetailsQuery, MessagingCampaignDetailsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<MessagingCampaignDetailsQuery, MessagingCampaignDetailsQueryVariables>(MessagingCampaignDetailsDocument, options);
        }
export type MessagingCampaignDetailsQueryHookResult = ReturnType<typeof useMessagingCampaignDetailsQuery>;
export type MessagingCampaignDetailsLazyQueryHookResult = ReturnType<typeof useMessagingCampaignDetailsLazyQuery>;
export type MessagingCampaignDetailsSuspenseQueryHookResult = ReturnType<typeof useMessagingCampaignDetailsSuspenseQuery>;
export type MessagingCampaignDetailsQueryResult = Apollo.QueryResult<MessagingCampaignDetailsQuery, MessagingCampaignDetailsQueryVariables>;
export const UpdateMessagingCampaignDocument = gql`
    mutation updateMessagingCampaign($input: UpdateAudienceBroadcastMessageInput!) {
  campaign: updateAudienceBroadcastMessage(input: $input) {
    ...MessagingCampaignDetails
  }
}
    ${MessagingCampaignDetailsFragmentDoc}`;
export type UpdateMessagingCampaignMutationFn = Apollo.MutationFunction<UpdateMessagingCampaignMutation, UpdateMessagingCampaignMutationVariables>;

/**
 * __useUpdateMessagingCampaignMutation__
 *
 * To run a mutation, you first call `useUpdateMessagingCampaignMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateMessagingCampaignMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateMessagingCampaignMutation, { data, loading, error }] = useUpdateMessagingCampaignMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateMessagingCampaignMutation(baseOptions?: Apollo.MutationHookOptions<UpdateMessagingCampaignMutation, UpdateMessagingCampaignMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateMessagingCampaignMutation, UpdateMessagingCampaignMutationVariables>(UpdateMessagingCampaignDocument, options);
      }
export type UpdateMessagingCampaignMutationHookResult = ReturnType<typeof useUpdateMessagingCampaignMutation>;
export type UpdateMessagingCampaignMutationResult = Apollo.MutationResult<UpdateMessagingCampaignMutation>;
export type UpdateMessagingCampaignMutationOptions = Apollo.BaseMutationOptions<UpdateMessagingCampaignMutation, UpdateMessagingCampaignMutationVariables>;
export const MessagingCampaignsListDocument = gql`
    query messagingCampaignsList($first: Int, $last: Int, $after: String, $before: String, $filter: AudienceBroadcastMessagesFilter) {
  messagingCampaignsList: audienceBroadcastMessages(
    first: $first
    last: $last
    after: $after
    before: $before
    filter: $filter
  ) {
    pageInfo {
      ...pageInfo
    }
    edges {
      cursor
      node {
        ...MessagingCampaignsListItem
      }
    }
  }
}
    ${PageInfoFragmentDoc}
${MessagingCampaignsListItemFragmentDoc}`;

/**
 * __useMessagingCampaignsListQuery__
 *
 * To run a query within a React component, call `useMessagingCampaignsListQuery` and pass it any options that fit your needs.
 * When your component renders, `useMessagingCampaignsListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMessagingCampaignsListQuery({
 *   variables: {
 *      first: // value for 'first'
 *      last: // value for 'last'
 *      after: // value for 'after'
 *      before: // value for 'before'
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useMessagingCampaignsListQuery(baseOptions?: Apollo.QueryHookOptions<MessagingCampaignsListQuery, MessagingCampaignsListQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<MessagingCampaignsListQuery, MessagingCampaignsListQueryVariables>(MessagingCampaignsListDocument, options);
      }
export function useMessagingCampaignsListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MessagingCampaignsListQuery, MessagingCampaignsListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<MessagingCampaignsListQuery, MessagingCampaignsListQueryVariables>(MessagingCampaignsListDocument, options);
        }
export function useMessagingCampaignsListSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<MessagingCampaignsListQuery, MessagingCampaignsListQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<MessagingCampaignsListQuery, MessagingCampaignsListQueryVariables>(MessagingCampaignsListDocument, options);
        }
export type MessagingCampaignsListQueryHookResult = ReturnType<typeof useMessagingCampaignsListQuery>;
export type MessagingCampaignsListLazyQueryHookResult = ReturnType<typeof useMessagingCampaignsListLazyQuery>;
export type MessagingCampaignsListSuspenseQueryHookResult = ReturnType<typeof useMessagingCampaignsListSuspenseQuery>;
export type MessagingCampaignsListQueryResult = Apollo.QueryResult<MessagingCampaignsListQuery, MessagingCampaignsListQueryVariables>;
export const SendTestMessageDocument = gql`
    mutation sendTestMessage($input: SendTestMessageInput!) {
  sendTestMessage(input: $input)
}
    `;
export type SendTestMessageMutationFn = Apollo.MutationFunction<SendTestMessageMutation, SendTestMessageMutationVariables>;

/**
 * __useSendTestMessageMutation__
 *
 * To run a mutation, you first call `useSendTestMessageMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSendTestMessageMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [sendTestMessageMutation, { data, loading, error }] = useSendTestMessageMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSendTestMessageMutation(baseOptions?: Apollo.MutationHookOptions<SendTestMessageMutation, SendTestMessageMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SendTestMessageMutation, SendTestMessageMutationVariables>(SendTestMessageDocument, options);
      }
export type SendTestMessageMutationHookResult = ReturnType<typeof useSendTestMessageMutation>;
export type SendTestMessageMutationResult = Apollo.MutationResult<SendTestMessageMutation>;
export type SendTestMessageMutationOptions = Apollo.BaseMutationOptions<SendTestMessageMutation, SendTestMessageMutationVariables>;
export const MembershipPointExpirationScheduleDocument = gql`
    query membershipPointExpirationSchedule($membershipId: ID!, $first: Int, $last: Int, $after: ID, $before: ID) {
  memberships(first: 1, filter: {idEquals: $membershipId}) {
    edges {
      cursor
      node {
        id
        pointExpirationSchedule(
          first: $first
          last: $last
          after: $after
          before: $before
        ) {
          pageInfo {
            ...pageInfo
          }
          edges {
            node {
              ...PointExpirationSchedule
            }
          }
        }
      }
    }
  }
}
    ${PageInfoFragmentDoc}
${PointExpirationScheduleFragmentDoc}`;

/**
 * __useMembershipPointExpirationScheduleQuery__
 *
 * To run a query within a React component, call `useMembershipPointExpirationScheduleQuery` and pass it any options that fit your needs.
 * When your component renders, `useMembershipPointExpirationScheduleQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMembershipPointExpirationScheduleQuery({
 *   variables: {
 *      membershipId: // value for 'membershipId'
 *      first: // value for 'first'
 *      last: // value for 'last'
 *      after: // value for 'after'
 *      before: // value for 'before'
 *   },
 * });
 */
export function useMembershipPointExpirationScheduleQuery(baseOptions: Apollo.QueryHookOptions<MembershipPointExpirationScheduleQuery, MembershipPointExpirationScheduleQueryVariables> & ({ variables: MembershipPointExpirationScheduleQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<MembershipPointExpirationScheduleQuery, MembershipPointExpirationScheduleQueryVariables>(MembershipPointExpirationScheduleDocument, options);
      }
export function useMembershipPointExpirationScheduleLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MembershipPointExpirationScheduleQuery, MembershipPointExpirationScheduleQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<MembershipPointExpirationScheduleQuery, MembershipPointExpirationScheduleQueryVariables>(MembershipPointExpirationScheduleDocument, options);
        }
export function useMembershipPointExpirationScheduleSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<MembershipPointExpirationScheduleQuery, MembershipPointExpirationScheduleQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<MembershipPointExpirationScheduleQuery, MembershipPointExpirationScheduleQueryVariables>(MembershipPointExpirationScheduleDocument, options);
        }
export type MembershipPointExpirationScheduleQueryHookResult = ReturnType<typeof useMembershipPointExpirationScheduleQuery>;
export type MembershipPointExpirationScheduleLazyQueryHookResult = ReturnType<typeof useMembershipPointExpirationScheduleLazyQuery>;
export type MembershipPointExpirationScheduleSuspenseQueryHookResult = ReturnType<typeof useMembershipPointExpirationScheduleSuspenseQuery>;
export type MembershipPointExpirationScheduleQueryResult = Apollo.QueryResult<MembershipPointExpirationScheduleQuery, MembershipPointExpirationScheduleQueryVariables>;
export const UpdatePromocodesStatusDocument = gql`
    mutation updatePromocodesStatus($input: [PromocodeStatusUpdateInput!]!) {
  result: promocodesStatusesUpdate(input: $input) {
    ...promocode
  }
}
    ${PromocodeFragmentDoc}`;
export type UpdatePromocodesStatusMutationFn = Apollo.MutationFunction<UpdatePromocodesStatusMutation, UpdatePromocodesStatusMutationVariables>;

/**
 * __useUpdatePromocodesStatusMutation__
 *
 * To run a mutation, you first call `useUpdatePromocodesStatusMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdatePromocodesStatusMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updatePromocodesStatusMutation, { data, loading, error }] = useUpdatePromocodesStatusMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdatePromocodesStatusMutation(baseOptions?: Apollo.MutationHookOptions<UpdatePromocodesStatusMutation, UpdatePromocodesStatusMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdatePromocodesStatusMutation, UpdatePromocodesStatusMutationVariables>(UpdatePromocodesStatusDocument, options);
      }
export type UpdatePromocodesStatusMutationHookResult = ReturnType<typeof useUpdatePromocodesStatusMutation>;
export type UpdatePromocodesStatusMutationResult = Apollo.MutationResult<UpdatePromocodesStatusMutation>;
export type UpdatePromocodesStatusMutationOptions = Apollo.BaseMutationOptions<UpdatePromocodesStatusMutation, UpdatePromocodesStatusMutationVariables>;
export const PromocodeBatchCreateDocument = gql`
    mutation promocodeBatchCreate($input: PromocodeBatchCreateInput!) {
  promocodeBatchCreate(input: $input) {
    ...promocode
  }
}
    ${PromocodeFragmentDoc}`;
export type PromocodeBatchCreateMutationFn = Apollo.MutationFunction<PromocodeBatchCreateMutation, PromocodeBatchCreateMutationVariables>;

/**
 * __usePromocodeBatchCreateMutation__
 *
 * To run a mutation, you first call `usePromocodeBatchCreateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePromocodeBatchCreateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [promocodeBatchCreateMutation, { data, loading, error }] = usePromocodeBatchCreateMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function usePromocodeBatchCreateMutation(baseOptions?: Apollo.MutationHookOptions<PromocodeBatchCreateMutation, PromocodeBatchCreateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<PromocodeBatchCreateMutation, PromocodeBatchCreateMutationVariables>(PromocodeBatchCreateDocument, options);
      }
export type PromocodeBatchCreateMutationHookResult = ReturnType<typeof usePromocodeBatchCreateMutation>;
export type PromocodeBatchCreateMutationResult = Apollo.MutationResult<PromocodeBatchCreateMutation>;
export type PromocodeBatchCreateMutationOptions = Apollo.BaseMutationOptions<PromocodeBatchCreateMutation, PromocodeBatchCreateMutationVariables>;
export const PromocodeBatchUpdateDocument = gql`
    mutation promocodeBatchUpdate($input: [PromocodeUpdateInput!]!) {
  promocodeBatchUpdate(input: $input) {
    ...promocode
  }
}
    ${PromocodeFragmentDoc}`;
export type PromocodeBatchUpdateMutationFn = Apollo.MutationFunction<PromocodeBatchUpdateMutation, PromocodeBatchUpdateMutationVariables>;

/**
 * __usePromocodeBatchUpdateMutation__
 *
 * To run a mutation, you first call `usePromocodeBatchUpdateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePromocodeBatchUpdateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [promocodeBatchUpdateMutation, { data, loading, error }] = usePromocodeBatchUpdateMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function usePromocodeBatchUpdateMutation(baseOptions?: Apollo.MutationHookOptions<PromocodeBatchUpdateMutation, PromocodeBatchUpdateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<PromocodeBatchUpdateMutation, PromocodeBatchUpdateMutationVariables>(PromocodeBatchUpdateDocument, options);
      }
export type PromocodeBatchUpdateMutationHookResult = ReturnType<typeof usePromocodeBatchUpdateMutation>;
export type PromocodeBatchUpdateMutationResult = Apollo.MutationResult<PromocodeBatchUpdateMutation>;
export type PromocodeBatchUpdateMutationOptions = Apollo.BaseMutationOptions<PromocodeBatchUpdateMutation, PromocodeBatchUpdateMutationVariables>;
export const PromocodeBatchDeleteDocument = gql`
    mutation promocodeBatchDelete($ids: [ID!]!) {
  promocodeBatchDelete(ids: $ids)
}
    `;
export type PromocodeBatchDeleteMutationFn = Apollo.MutationFunction<PromocodeBatchDeleteMutation, PromocodeBatchDeleteMutationVariables>;

/**
 * __usePromocodeBatchDeleteMutation__
 *
 * To run a mutation, you first call `usePromocodeBatchDeleteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePromocodeBatchDeleteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [promocodeBatchDeleteMutation, { data, loading, error }] = usePromocodeBatchDeleteMutation({
 *   variables: {
 *      ids: // value for 'ids'
 *   },
 * });
 */
export function usePromocodeBatchDeleteMutation(baseOptions?: Apollo.MutationHookOptions<PromocodeBatchDeleteMutation, PromocodeBatchDeleteMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<PromocodeBatchDeleteMutation, PromocodeBatchDeleteMutationVariables>(PromocodeBatchDeleteDocument, options);
      }
export type PromocodeBatchDeleteMutationHookResult = ReturnType<typeof usePromocodeBatchDeleteMutation>;
export type PromocodeBatchDeleteMutationResult = Apollo.MutationResult<PromocodeBatchDeleteMutation>;
export type PromocodeBatchDeleteMutationOptions = Apollo.BaseMutationOptions<PromocodeBatchDeleteMutation, PromocodeBatchDeleteMutationVariables>;
export const PromoCodesUploadSignedUrlGenerateDocument = gql`
    mutation promoCodesUploadSignedUrlGenerate($fileName: String!) {
  promoCodesUploadSignedUrlGenerate(fileName: $fileName) {
    signedUrl
    fields
    promoCodeGroupId
  }
}
    `;
export type PromoCodesUploadSignedUrlGenerateMutationFn = Apollo.MutationFunction<PromoCodesUploadSignedUrlGenerateMutation, PromoCodesUploadSignedUrlGenerateMutationVariables>;

/**
 * __usePromoCodesUploadSignedUrlGenerateMutation__
 *
 * To run a mutation, you first call `usePromoCodesUploadSignedUrlGenerateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePromoCodesUploadSignedUrlGenerateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [promoCodesUploadSignedUrlGenerateMutation, { data, loading, error }] = usePromoCodesUploadSignedUrlGenerateMutation({
 *   variables: {
 *      fileName: // value for 'fileName'
 *   },
 * });
 */
export function usePromoCodesUploadSignedUrlGenerateMutation(baseOptions?: Apollo.MutationHookOptions<PromoCodesUploadSignedUrlGenerateMutation, PromoCodesUploadSignedUrlGenerateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<PromoCodesUploadSignedUrlGenerateMutation, PromoCodesUploadSignedUrlGenerateMutationVariables>(PromoCodesUploadSignedUrlGenerateDocument, options);
      }
export type PromoCodesUploadSignedUrlGenerateMutationHookResult = ReturnType<typeof usePromoCodesUploadSignedUrlGenerateMutation>;
export type PromoCodesUploadSignedUrlGenerateMutationResult = Apollo.MutationResult<PromoCodesUploadSignedUrlGenerateMutation>;
export type PromoCodesUploadSignedUrlGenerateMutationOptions = Apollo.BaseMutationOptions<PromoCodesUploadSignedUrlGenerateMutation, PromoCodesUploadSignedUrlGenerateMutationVariables>;
export const PromoCodesUploadProcessDocument = gql`
    mutation promoCodesUploadProcess($input: PromoCodesUploadProcessInput!) {
  promoCodesUploadProcess(input: $input) {
    ...promoCodeGroup
  }
}
    ${PromoCodeGroupFragmentDoc}`;
export type PromoCodesUploadProcessMutationFn = Apollo.MutationFunction<PromoCodesUploadProcessMutation, PromoCodesUploadProcessMutationVariables>;

/**
 * __usePromoCodesUploadProcessMutation__
 *
 * To run a mutation, you first call `usePromoCodesUploadProcessMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePromoCodesUploadProcessMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [promoCodesUploadProcessMutation, { data, loading, error }] = usePromoCodesUploadProcessMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function usePromoCodesUploadProcessMutation(baseOptions?: Apollo.MutationHookOptions<PromoCodesUploadProcessMutation, PromoCodesUploadProcessMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<PromoCodesUploadProcessMutation, PromoCodesUploadProcessMutationVariables>(PromoCodesUploadProcessDocument, options);
      }
export type PromoCodesUploadProcessMutationHookResult = ReturnType<typeof usePromoCodesUploadProcessMutation>;
export type PromoCodesUploadProcessMutationResult = Apollo.MutationResult<PromoCodesUploadProcessMutation>;
export type PromoCodesUploadProcessMutationOptions = Apollo.BaseMutationOptions<PromoCodesUploadProcessMutation, PromoCodesUploadProcessMutationVariables>;
export const PromoCodeGroupDeleteDocument = gql`
    mutation promoCodeGroupDelete($id: ID!) {
  promoCodeGroupDelete(id: $id)
}
    `;
export type PromoCodeGroupDeleteMutationFn = Apollo.MutationFunction<PromoCodeGroupDeleteMutation, PromoCodeGroupDeleteMutationVariables>;

/**
 * __usePromoCodeGroupDeleteMutation__
 *
 * To run a mutation, you first call `usePromoCodeGroupDeleteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePromoCodeGroupDeleteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [promoCodeGroupDeleteMutation, { data, loading, error }] = usePromoCodeGroupDeleteMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function usePromoCodeGroupDeleteMutation(baseOptions?: Apollo.MutationHookOptions<PromoCodeGroupDeleteMutation, PromoCodeGroupDeleteMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<PromoCodeGroupDeleteMutation, PromoCodeGroupDeleteMutationVariables>(PromoCodeGroupDeleteDocument, options);
      }
export type PromoCodeGroupDeleteMutationHookResult = ReturnType<typeof usePromoCodeGroupDeleteMutation>;
export type PromoCodeGroupDeleteMutationResult = Apollo.MutationResult<PromoCodeGroupDeleteMutation>;
export type PromoCodeGroupDeleteMutationOptions = Apollo.BaseMutationOptions<PromoCodeGroupDeleteMutation, PromoCodeGroupDeleteMutationVariables>;
export const PromoCodeGroupDownloadLinkDocument = gql`
    query promoCodeGroupDownloadLink($filter: PromoCodeGroupDownloadLinkFilter!) {
  promoCodeGroupDownloadLink(filter: $filter)
}
    `;

/**
 * __usePromoCodeGroupDownloadLinkQuery__
 *
 * To run a query within a React component, call `usePromoCodeGroupDownloadLinkQuery` and pass it any options that fit your needs.
 * When your component renders, `usePromoCodeGroupDownloadLinkQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePromoCodeGroupDownloadLinkQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function usePromoCodeGroupDownloadLinkQuery(baseOptions: Apollo.QueryHookOptions<PromoCodeGroupDownloadLinkQuery, PromoCodeGroupDownloadLinkQueryVariables> & ({ variables: PromoCodeGroupDownloadLinkQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PromoCodeGroupDownloadLinkQuery, PromoCodeGroupDownloadLinkQueryVariables>(PromoCodeGroupDownloadLinkDocument, options);
      }
export function usePromoCodeGroupDownloadLinkLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PromoCodeGroupDownloadLinkQuery, PromoCodeGroupDownloadLinkQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PromoCodeGroupDownloadLinkQuery, PromoCodeGroupDownloadLinkQueryVariables>(PromoCodeGroupDownloadLinkDocument, options);
        }
export function usePromoCodeGroupDownloadLinkSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<PromoCodeGroupDownloadLinkQuery, PromoCodeGroupDownloadLinkQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<PromoCodeGroupDownloadLinkQuery, PromoCodeGroupDownloadLinkQueryVariables>(PromoCodeGroupDownloadLinkDocument, options);
        }
export type PromoCodeGroupDownloadLinkQueryHookResult = ReturnType<typeof usePromoCodeGroupDownloadLinkQuery>;
export type PromoCodeGroupDownloadLinkLazyQueryHookResult = ReturnType<typeof usePromoCodeGroupDownloadLinkLazyQuery>;
export type PromoCodeGroupDownloadLinkSuspenseQueryHookResult = ReturnType<typeof usePromoCodeGroupDownloadLinkSuspenseQuery>;
export type PromoCodeGroupDownloadLinkQueryResult = Apollo.QueryResult<PromoCodeGroupDownloadLinkQuery, PromoCodeGroupDownloadLinkQueryVariables>;
export const ConfigureReferralProgramDocument = gql`
    mutation configureReferralProgram($input: ReferralProgramConfigurationInput!) {
  configureReferralProgram(input: $input) {
    ...referralProgramConfiguration
  }
}
    ${ReferralProgramConfigurationFragmentDoc}`;
export type ConfigureReferralProgramMutationFn = Apollo.MutationFunction<ConfigureReferralProgramMutation, ConfigureReferralProgramMutationVariables>;

/**
 * __useConfigureReferralProgramMutation__
 *
 * To run a mutation, you first call `useConfigureReferralProgramMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useConfigureReferralProgramMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [configureReferralProgramMutation, { data, loading, error }] = useConfigureReferralProgramMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useConfigureReferralProgramMutation(baseOptions?: Apollo.MutationHookOptions<ConfigureReferralProgramMutation, ConfigureReferralProgramMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ConfigureReferralProgramMutation, ConfigureReferralProgramMutationVariables>(ConfigureReferralProgramDocument, options);
      }
export type ConfigureReferralProgramMutationHookResult = ReturnType<typeof useConfigureReferralProgramMutation>;
export type ConfigureReferralProgramMutationResult = Apollo.MutationResult<ConfigureReferralProgramMutation>;
export type ConfigureReferralProgramMutationOptions = Apollo.BaseMutationOptions<ConfigureReferralProgramMutation, ConfigureReferralProgramMutationVariables>;
export const ReferralProgramStatisticsDocument = gql`
    query referralProgramStatistics($chainId: ID!) {
  referralProgramStatistics(filter: {chainIdEquals: $chainId}) {
    ...referralProgramStatistics
  }
}
    ${ReferralProgramStatisticsFragmentDoc}`;

/**
 * __useReferralProgramStatisticsQuery__
 *
 * To run a query within a React component, call `useReferralProgramStatisticsQuery` and pass it any options that fit your needs.
 * When your component renders, `useReferralProgramStatisticsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useReferralProgramStatisticsQuery({
 *   variables: {
 *      chainId: // value for 'chainId'
 *   },
 * });
 */
export function useReferralProgramStatisticsQuery(baseOptions: Apollo.QueryHookOptions<ReferralProgramStatisticsQuery, ReferralProgramStatisticsQueryVariables> & ({ variables: ReferralProgramStatisticsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ReferralProgramStatisticsQuery, ReferralProgramStatisticsQueryVariables>(ReferralProgramStatisticsDocument, options);
      }
export function useReferralProgramStatisticsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ReferralProgramStatisticsQuery, ReferralProgramStatisticsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ReferralProgramStatisticsQuery, ReferralProgramStatisticsQueryVariables>(ReferralProgramStatisticsDocument, options);
        }
export function useReferralProgramStatisticsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ReferralProgramStatisticsQuery, ReferralProgramStatisticsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ReferralProgramStatisticsQuery, ReferralProgramStatisticsQueryVariables>(ReferralProgramStatisticsDocument, options);
        }
export type ReferralProgramStatisticsQueryHookResult = ReturnType<typeof useReferralProgramStatisticsQuery>;
export type ReferralProgramStatisticsLazyQueryHookResult = ReturnType<typeof useReferralProgramStatisticsLazyQuery>;
export type ReferralProgramStatisticsSuspenseQueryHookResult = ReturnType<typeof useReferralProgramStatisticsSuspenseQuery>;
export type ReferralProgramStatisticsQueryResult = Apollo.QueryResult<ReferralProgramStatisticsQuery, ReferralProgramStatisticsQueryVariables>;
export const RetailerNetworkCreateDocument = gql`
    mutation retailerNetworkCreate($input: RetailerNetworkCreate!) {
  retailerNetworkCreate(input: $input) {
    ...retailerNetwork
  }
}
    ${RetailerNetworkFragmentDoc}`;
export type RetailerNetworkCreateMutationFn = Apollo.MutationFunction<RetailerNetworkCreateMutation, RetailerNetworkCreateMutationVariables>;

/**
 * __useRetailerNetworkCreateMutation__
 *
 * To run a mutation, you first call `useRetailerNetworkCreateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRetailerNetworkCreateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [retailerNetworkCreateMutation, { data, loading, error }] = useRetailerNetworkCreateMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useRetailerNetworkCreateMutation(baseOptions?: Apollo.MutationHookOptions<RetailerNetworkCreateMutation, RetailerNetworkCreateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RetailerNetworkCreateMutation, RetailerNetworkCreateMutationVariables>(RetailerNetworkCreateDocument, options);
      }
export type RetailerNetworkCreateMutationHookResult = ReturnType<typeof useRetailerNetworkCreateMutation>;
export type RetailerNetworkCreateMutationResult = Apollo.MutationResult<RetailerNetworkCreateMutation>;
export type RetailerNetworkCreateMutationOptions = Apollo.BaseMutationOptions<RetailerNetworkCreateMutation, RetailerNetworkCreateMutationVariables>;
export const RetailerNetworkUpdateDocument = gql`
    mutation retailerNetworkUpdate($input: RetailerNetworkUpdate!) {
  retailerNetworkUpdate(input: $input) {
    ...retailerNetwork
  }
}
    ${RetailerNetworkFragmentDoc}`;
export type RetailerNetworkUpdateMutationFn = Apollo.MutationFunction<RetailerNetworkUpdateMutation, RetailerNetworkUpdateMutationVariables>;

/**
 * __useRetailerNetworkUpdateMutation__
 *
 * To run a mutation, you first call `useRetailerNetworkUpdateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRetailerNetworkUpdateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [retailerNetworkUpdateMutation, { data, loading, error }] = useRetailerNetworkUpdateMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useRetailerNetworkUpdateMutation(baseOptions?: Apollo.MutationHookOptions<RetailerNetworkUpdateMutation, RetailerNetworkUpdateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RetailerNetworkUpdateMutation, RetailerNetworkUpdateMutationVariables>(RetailerNetworkUpdateDocument, options);
      }
export type RetailerNetworkUpdateMutationHookResult = ReturnType<typeof useRetailerNetworkUpdateMutation>;
export type RetailerNetworkUpdateMutationResult = Apollo.MutationResult<RetailerNetworkUpdateMutation>;
export type RetailerNetworkUpdateMutationOptions = Apollo.BaseMutationOptions<RetailerNetworkUpdateMutation, RetailerNetworkUpdateMutationVariables>;
export const RetailerNetworkDeleteDocument = gql`
    mutation retailerNetworkDelete($uuid: OCUUID!) {
  retailerNetworkDelete(uuid: $uuid)
}
    `;
export type RetailerNetworkDeleteMutationFn = Apollo.MutationFunction<RetailerNetworkDeleteMutation, RetailerNetworkDeleteMutationVariables>;

/**
 * __useRetailerNetworkDeleteMutation__
 *
 * To run a mutation, you first call `useRetailerNetworkDeleteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRetailerNetworkDeleteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [retailerNetworkDeleteMutation, { data, loading, error }] = useRetailerNetworkDeleteMutation({
 *   variables: {
 *      uuid: // value for 'uuid'
 *   },
 * });
 */
export function useRetailerNetworkDeleteMutation(baseOptions?: Apollo.MutationHookOptions<RetailerNetworkDeleteMutation, RetailerNetworkDeleteMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RetailerNetworkDeleteMutation, RetailerNetworkDeleteMutationVariables>(RetailerNetworkDeleteDocument, options);
      }
export type RetailerNetworkDeleteMutationHookResult = ReturnType<typeof useRetailerNetworkDeleteMutation>;
export type RetailerNetworkDeleteMutationResult = Apollo.MutationResult<RetailerNetworkDeleteMutation>;
export type RetailerNetworkDeleteMutationOptions = Apollo.BaseMutationOptions<RetailerNetworkDeleteMutation, RetailerNetworkDeleteMutationVariables>;
export const RemoveUserFromRetailerNetworkDocument = gql`
    mutation removeUserFromRetailerNetwork($retailerNetworkUuid: OCUUID!, $userUuid: OCUUID!) {
  removeUserFromRetailerNetwork(
    retailerNetworkUuid: $retailerNetworkUuid
    userUuid: $userUuid
  )
}
    `;
export type RemoveUserFromRetailerNetworkMutationFn = Apollo.MutationFunction<RemoveUserFromRetailerNetworkMutation, RemoveUserFromRetailerNetworkMutationVariables>;

/**
 * __useRemoveUserFromRetailerNetworkMutation__
 *
 * To run a mutation, you first call `useRemoveUserFromRetailerNetworkMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveUserFromRetailerNetworkMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeUserFromRetailerNetworkMutation, { data, loading, error }] = useRemoveUserFromRetailerNetworkMutation({
 *   variables: {
 *      retailerNetworkUuid: // value for 'retailerNetworkUuid'
 *      userUuid: // value for 'userUuid'
 *   },
 * });
 */
export function useRemoveUserFromRetailerNetworkMutation(baseOptions?: Apollo.MutationHookOptions<RemoveUserFromRetailerNetworkMutation, RemoveUserFromRetailerNetworkMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RemoveUserFromRetailerNetworkMutation, RemoveUserFromRetailerNetworkMutationVariables>(RemoveUserFromRetailerNetworkDocument, options);
      }
export type RemoveUserFromRetailerNetworkMutationHookResult = ReturnType<typeof useRemoveUserFromRetailerNetworkMutation>;
export type RemoveUserFromRetailerNetworkMutationResult = Apollo.MutationResult<RemoveUserFromRetailerNetworkMutation>;
export type RemoveUserFromRetailerNetworkMutationOptions = Apollo.BaseMutationOptions<RemoveUserFromRetailerNetworkMutation, RemoveUserFromRetailerNetworkMutationVariables>;
export const RemoveLocationFromRetailerNetworkDocument = gql`
    mutation removeLocationFromRetailerNetwork($retailerNetworkUuid: OCUUID!, $locationUuid: OCUUID!) {
  removeLocationFromRetailerNetwork(
    retailerNetworkUuid: $retailerNetworkUuid
    locationUuid: $locationUuid
  )
}
    `;
export type RemoveLocationFromRetailerNetworkMutationFn = Apollo.MutationFunction<RemoveLocationFromRetailerNetworkMutation, RemoveLocationFromRetailerNetworkMutationVariables>;

/**
 * __useRemoveLocationFromRetailerNetworkMutation__
 *
 * To run a mutation, you first call `useRemoveLocationFromRetailerNetworkMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveLocationFromRetailerNetworkMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeLocationFromRetailerNetworkMutation, { data, loading, error }] = useRemoveLocationFromRetailerNetworkMutation({
 *   variables: {
 *      retailerNetworkUuid: // value for 'retailerNetworkUuid'
 *      locationUuid: // value for 'locationUuid'
 *   },
 * });
 */
export function useRemoveLocationFromRetailerNetworkMutation(baseOptions?: Apollo.MutationHookOptions<RemoveLocationFromRetailerNetworkMutation, RemoveLocationFromRetailerNetworkMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RemoveLocationFromRetailerNetworkMutation, RemoveLocationFromRetailerNetworkMutationVariables>(RemoveLocationFromRetailerNetworkDocument, options);
      }
export type RemoveLocationFromRetailerNetworkMutationHookResult = ReturnType<typeof useRemoveLocationFromRetailerNetworkMutation>;
export type RemoveLocationFromRetailerNetworkMutationResult = Apollo.MutationResult<RemoveLocationFromRetailerNetworkMutation>;
export type RemoveLocationFromRetailerNetworkMutationOptions = Apollo.BaseMutationOptions<RemoveLocationFromRetailerNetworkMutation, RemoveLocationFromRetailerNetworkMutationVariables>;
export const RetailerNetworkUserCreateDocument = gql`
    mutation retailerNetworkUserCreate($input: RetailerNetworkUserCreate!) {
  retailerNetworkUserCreate(input: $input) {
    ...retailerNetworkUser
  }
}
    ${RetailerNetworkUserFragmentDoc}`;
export type RetailerNetworkUserCreateMutationFn = Apollo.MutationFunction<RetailerNetworkUserCreateMutation, RetailerNetworkUserCreateMutationVariables>;

/**
 * __useRetailerNetworkUserCreateMutation__
 *
 * To run a mutation, you first call `useRetailerNetworkUserCreateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRetailerNetworkUserCreateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [retailerNetworkUserCreateMutation, { data, loading, error }] = useRetailerNetworkUserCreateMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useRetailerNetworkUserCreateMutation(baseOptions?: Apollo.MutationHookOptions<RetailerNetworkUserCreateMutation, RetailerNetworkUserCreateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RetailerNetworkUserCreateMutation, RetailerNetworkUserCreateMutationVariables>(RetailerNetworkUserCreateDocument, options);
      }
export type RetailerNetworkUserCreateMutationHookResult = ReturnType<typeof useRetailerNetworkUserCreateMutation>;
export type RetailerNetworkUserCreateMutationResult = Apollo.MutationResult<RetailerNetworkUserCreateMutation>;
export type RetailerNetworkUserCreateMutationOptions = Apollo.BaseMutationOptions<RetailerNetworkUserCreateMutation, RetailerNetworkUserCreateMutationVariables>;
export const RetailerNetworkUserUpdateDocument = gql`
    mutation retailerNetworkUserUpdate($input: RetailerNetworkUserUpdate!) {
  retailerNetworkUserUpdate(input: $input) {
    ...retailerNetworkUser
  }
}
    ${RetailerNetworkUserFragmentDoc}`;
export type RetailerNetworkUserUpdateMutationFn = Apollo.MutationFunction<RetailerNetworkUserUpdateMutation, RetailerNetworkUserUpdateMutationVariables>;

/**
 * __useRetailerNetworkUserUpdateMutation__
 *
 * To run a mutation, you first call `useRetailerNetworkUserUpdateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRetailerNetworkUserUpdateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [retailerNetworkUserUpdateMutation, { data, loading, error }] = useRetailerNetworkUserUpdateMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useRetailerNetworkUserUpdateMutation(baseOptions?: Apollo.MutationHookOptions<RetailerNetworkUserUpdateMutation, RetailerNetworkUserUpdateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RetailerNetworkUserUpdateMutation, RetailerNetworkUserUpdateMutationVariables>(RetailerNetworkUserUpdateDocument, options);
      }
export type RetailerNetworkUserUpdateMutationHookResult = ReturnType<typeof useRetailerNetworkUserUpdateMutation>;
export type RetailerNetworkUserUpdateMutationResult = Apollo.MutationResult<RetailerNetworkUserUpdateMutation>;
export type RetailerNetworkUserUpdateMutationOptions = Apollo.BaseMutationOptions<RetailerNetworkUserUpdateMutation, RetailerNetworkUserUpdateMutationVariables>;
export const RetailerNetworkLocationGroupCreateDocument = gql`
    mutation retailerNetworkLocationGroupCreate($retailerNetworkUuid: OCUUID!, $locationGroup: LocationGroupCreateInput!) {
  retailerNetworkLocationGroupCreate(
    retailerNetworkUuid: $retailerNetworkUuid
    locationGroup: $locationGroup
  ) {
    ...retailerNetworkLocationGroup
  }
}
    ${RetailerNetworkLocationGroupFragmentDoc}`;
export type RetailerNetworkLocationGroupCreateMutationFn = Apollo.MutationFunction<RetailerNetworkLocationGroupCreateMutation, RetailerNetworkLocationGroupCreateMutationVariables>;

/**
 * __useRetailerNetworkLocationGroupCreateMutation__
 *
 * To run a mutation, you first call `useRetailerNetworkLocationGroupCreateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRetailerNetworkLocationGroupCreateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [retailerNetworkLocationGroupCreateMutation, { data, loading, error }] = useRetailerNetworkLocationGroupCreateMutation({
 *   variables: {
 *      retailerNetworkUuid: // value for 'retailerNetworkUuid'
 *      locationGroup: // value for 'locationGroup'
 *   },
 * });
 */
export function useRetailerNetworkLocationGroupCreateMutation(baseOptions?: Apollo.MutationHookOptions<RetailerNetworkLocationGroupCreateMutation, RetailerNetworkLocationGroupCreateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RetailerNetworkLocationGroupCreateMutation, RetailerNetworkLocationGroupCreateMutationVariables>(RetailerNetworkLocationGroupCreateDocument, options);
      }
export type RetailerNetworkLocationGroupCreateMutationHookResult = ReturnType<typeof useRetailerNetworkLocationGroupCreateMutation>;
export type RetailerNetworkLocationGroupCreateMutationResult = Apollo.MutationResult<RetailerNetworkLocationGroupCreateMutation>;
export type RetailerNetworkLocationGroupCreateMutationOptions = Apollo.BaseMutationOptions<RetailerNetworkLocationGroupCreateMutation, RetailerNetworkLocationGroupCreateMutationVariables>;
export const RetailerNetworkLocationGroupUpdateDocument = gql`
    mutation retailerNetworkLocationGroupUpdate($retailerNetworkUuid: OCUUID!, $locationGroup: RetailerNetworkLocationGroupUpdateInput!) {
  retailerNetworkLocationGroupUpdate(
    retailerNetworkUuid: $retailerNetworkUuid
    locationGroup: $locationGroup
  ) {
    ...retailerNetworkLocationGroup
  }
}
    ${RetailerNetworkLocationGroupFragmentDoc}`;
export type RetailerNetworkLocationGroupUpdateMutationFn = Apollo.MutationFunction<RetailerNetworkLocationGroupUpdateMutation, RetailerNetworkLocationGroupUpdateMutationVariables>;

/**
 * __useRetailerNetworkLocationGroupUpdateMutation__
 *
 * To run a mutation, you first call `useRetailerNetworkLocationGroupUpdateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRetailerNetworkLocationGroupUpdateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [retailerNetworkLocationGroupUpdateMutation, { data, loading, error }] = useRetailerNetworkLocationGroupUpdateMutation({
 *   variables: {
 *      retailerNetworkUuid: // value for 'retailerNetworkUuid'
 *      locationGroup: // value for 'locationGroup'
 *   },
 * });
 */
export function useRetailerNetworkLocationGroupUpdateMutation(baseOptions?: Apollo.MutationHookOptions<RetailerNetworkLocationGroupUpdateMutation, RetailerNetworkLocationGroupUpdateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RetailerNetworkLocationGroupUpdateMutation, RetailerNetworkLocationGroupUpdateMutationVariables>(RetailerNetworkLocationGroupUpdateDocument, options);
      }
export type RetailerNetworkLocationGroupUpdateMutationHookResult = ReturnType<typeof useRetailerNetworkLocationGroupUpdateMutation>;
export type RetailerNetworkLocationGroupUpdateMutationResult = Apollo.MutationResult<RetailerNetworkLocationGroupUpdateMutation>;
export type RetailerNetworkLocationGroupUpdateMutationOptions = Apollo.BaseMutationOptions<RetailerNetworkLocationGroupUpdateMutation, RetailerNetworkLocationGroupUpdateMutationVariables>;
export const RetailerNetworkLocationGroupDeleteDocument = gql`
    mutation retailerNetworkLocationGroupDelete($retailerNetworkUuid: OCUUID!, $locationGroupUuid: OCUUID!) {
  retailerNetworkLocationGroupDelete(
    retailerNetworkUuid: $retailerNetworkUuid
    locationGroupUuid: $locationGroupUuid
  )
}
    `;
export type RetailerNetworkLocationGroupDeleteMutationFn = Apollo.MutationFunction<RetailerNetworkLocationGroupDeleteMutation, RetailerNetworkLocationGroupDeleteMutationVariables>;

/**
 * __useRetailerNetworkLocationGroupDeleteMutation__
 *
 * To run a mutation, you first call `useRetailerNetworkLocationGroupDeleteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRetailerNetworkLocationGroupDeleteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [retailerNetworkLocationGroupDeleteMutation, { data, loading, error }] = useRetailerNetworkLocationGroupDeleteMutation({
 *   variables: {
 *      retailerNetworkUuid: // value for 'retailerNetworkUuid'
 *      locationGroupUuid: // value for 'locationGroupUuid'
 *   },
 * });
 */
export function useRetailerNetworkLocationGroupDeleteMutation(baseOptions?: Apollo.MutationHookOptions<RetailerNetworkLocationGroupDeleteMutation, RetailerNetworkLocationGroupDeleteMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RetailerNetworkLocationGroupDeleteMutation, RetailerNetworkLocationGroupDeleteMutationVariables>(RetailerNetworkLocationGroupDeleteDocument, options);
      }
export type RetailerNetworkLocationGroupDeleteMutationHookResult = ReturnType<typeof useRetailerNetworkLocationGroupDeleteMutation>;
export type RetailerNetworkLocationGroupDeleteMutationResult = Apollo.MutationResult<RetailerNetworkLocationGroupDeleteMutation>;
export type RetailerNetworkLocationGroupDeleteMutationOptions = Apollo.BaseMutationOptions<RetailerNetworkLocationGroupDeleteMutation, RetailerNetworkLocationGroupDeleteMutationVariables>;
export const RetailerNetworkLocationGroupAddLocationsDocument = gql`
    mutation retailerNetworkLocationGroupAddLocations($retailerNetworkUuid: OCUUID!, $locationGroupUuid: OCUUID!, $locationUuids: [OCUUID!]!) {
  retailerNetworkLocationGroupAddLocations(
    retailerNetworkUuid: $retailerNetworkUuid
    locationGroupUuid: $locationGroupUuid
    locationUuids: $locationUuids
  )
}
    `;
export type RetailerNetworkLocationGroupAddLocationsMutationFn = Apollo.MutationFunction<RetailerNetworkLocationGroupAddLocationsMutation, RetailerNetworkLocationGroupAddLocationsMutationVariables>;

/**
 * __useRetailerNetworkLocationGroupAddLocationsMutation__
 *
 * To run a mutation, you first call `useRetailerNetworkLocationGroupAddLocationsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRetailerNetworkLocationGroupAddLocationsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [retailerNetworkLocationGroupAddLocationsMutation, { data, loading, error }] = useRetailerNetworkLocationGroupAddLocationsMutation({
 *   variables: {
 *      retailerNetworkUuid: // value for 'retailerNetworkUuid'
 *      locationGroupUuid: // value for 'locationGroupUuid'
 *      locationUuids: // value for 'locationUuids'
 *   },
 * });
 */
export function useRetailerNetworkLocationGroupAddLocationsMutation(baseOptions?: Apollo.MutationHookOptions<RetailerNetworkLocationGroupAddLocationsMutation, RetailerNetworkLocationGroupAddLocationsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RetailerNetworkLocationGroupAddLocationsMutation, RetailerNetworkLocationGroupAddLocationsMutationVariables>(RetailerNetworkLocationGroupAddLocationsDocument, options);
      }
export type RetailerNetworkLocationGroupAddLocationsMutationHookResult = ReturnType<typeof useRetailerNetworkLocationGroupAddLocationsMutation>;
export type RetailerNetworkLocationGroupAddLocationsMutationResult = Apollo.MutationResult<RetailerNetworkLocationGroupAddLocationsMutation>;
export type RetailerNetworkLocationGroupAddLocationsMutationOptions = Apollo.BaseMutationOptions<RetailerNetworkLocationGroupAddLocationsMutation, RetailerNetworkLocationGroupAddLocationsMutationVariables>;
export const RetailerNetworkLocationGroupRemoveLocationsDocument = gql`
    mutation retailerNetworkLocationGroupRemoveLocations($retailerNetworkUuid: OCUUID!, $locationGroupUuid: OCUUID!, $locationUuids: [OCUUID!]!) {
  retailerNetworkLocationGroupRemoveLocations(
    retailerNetworkUuid: $retailerNetworkUuid
    locationGroupUuid: $locationGroupUuid
    locationUuids: $locationUuids
  )
}
    `;
export type RetailerNetworkLocationGroupRemoveLocationsMutationFn = Apollo.MutationFunction<RetailerNetworkLocationGroupRemoveLocationsMutation, RetailerNetworkLocationGroupRemoveLocationsMutationVariables>;

/**
 * __useRetailerNetworkLocationGroupRemoveLocationsMutation__
 *
 * To run a mutation, you first call `useRetailerNetworkLocationGroupRemoveLocationsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRetailerNetworkLocationGroupRemoveLocationsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [retailerNetworkLocationGroupRemoveLocationsMutation, { data, loading, error }] = useRetailerNetworkLocationGroupRemoveLocationsMutation({
 *   variables: {
 *      retailerNetworkUuid: // value for 'retailerNetworkUuid'
 *      locationGroupUuid: // value for 'locationGroupUuid'
 *      locationUuids: // value for 'locationUuids'
 *   },
 * });
 */
export function useRetailerNetworkLocationGroupRemoveLocationsMutation(baseOptions?: Apollo.MutationHookOptions<RetailerNetworkLocationGroupRemoveLocationsMutation, RetailerNetworkLocationGroupRemoveLocationsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RetailerNetworkLocationGroupRemoveLocationsMutation, RetailerNetworkLocationGroupRemoveLocationsMutationVariables>(RetailerNetworkLocationGroupRemoveLocationsDocument, options);
      }
export type RetailerNetworkLocationGroupRemoveLocationsMutationHookResult = ReturnType<typeof useRetailerNetworkLocationGroupRemoveLocationsMutation>;
export type RetailerNetworkLocationGroupRemoveLocationsMutationResult = Apollo.MutationResult<RetailerNetworkLocationGroupRemoveLocationsMutation>;
export type RetailerNetworkLocationGroupRemoveLocationsMutationOptions = Apollo.BaseMutationOptions<RetailerNetworkLocationGroupRemoveLocationsMutation, RetailerNetworkLocationGroupRemoveLocationsMutationVariables>;
export const AssociateLocationsWithRetailerNetworkUsersDocument = gql`
    mutation associateLocationsWithRetailerNetworkUsers($locationUuids: [OCUUID!]!, $retailerNetworkUserUuids: [OCUUID!]!, $retailerNetworkUuid: OCUUID!) {
  associateLocationsWithRetailerNetworkUsers(
    locationUuids: $locationUuids
    retailerNetworkUserUuids: $retailerNetworkUserUuids
    retailerNetworkUuid: $retailerNetworkUuid
  )
}
    `;
export type AssociateLocationsWithRetailerNetworkUsersMutationFn = Apollo.MutationFunction<AssociateLocationsWithRetailerNetworkUsersMutation, AssociateLocationsWithRetailerNetworkUsersMutationVariables>;

/**
 * __useAssociateLocationsWithRetailerNetworkUsersMutation__
 *
 * To run a mutation, you first call `useAssociateLocationsWithRetailerNetworkUsersMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAssociateLocationsWithRetailerNetworkUsersMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [associateLocationsWithRetailerNetworkUsersMutation, { data, loading, error }] = useAssociateLocationsWithRetailerNetworkUsersMutation({
 *   variables: {
 *      locationUuids: // value for 'locationUuids'
 *      retailerNetworkUserUuids: // value for 'retailerNetworkUserUuids'
 *      retailerNetworkUuid: // value for 'retailerNetworkUuid'
 *   },
 * });
 */
export function useAssociateLocationsWithRetailerNetworkUsersMutation(baseOptions?: Apollo.MutationHookOptions<AssociateLocationsWithRetailerNetworkUsersMutation, AssociateLocationsWithRetailerNetworkUsersMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AssociateLocationsWithRetailerNetworkUsersMutation, AssociateLocationsWithRetailerNetworkUsersMutationVariables>(AssociateLocationsWithRetailerNetworkUsersDocument, options);
      }
export type AssociateLocationsWithRetailerNetworkUsersMutationHookResult = ReturnType<typeof useAssociateLocationsWithRetailerNetworkUsersMutation>;
export type AssociateLocationsWithRetailerNetworkUsersMutationResult = Apollo.MutationResult<AssociateLocationsWithRetailerNetworkUsersMutation>;
export type AssociateLocationsWithRetailerNetworkUsersMutationOptions = Apollo.BaseMutationOptions<AssociateLocationsWithRetailerNetworkUsersMutation, AssociateLocationsWithRetailerNetworkUsersMutationVariables>;
export const AssociateRetailerNetworkLocationGroupsWithRetailerNetworkUsersDocument = gql`
    mutation associateRetailerNetworkLocationGroupsWithRetailerNetworkUsers($locationGroupUuids: [OCUUID!]!, $retailerNetworkUserUuids: [OCUUID!]!, $retailerNetworkUuid: OCUUID!) {
  associateRetailerNetworkLocationGroupsWithRetailerNetworkUsers(
    locationGroupUuids: $locationGroupUuids
    retailerNetworkUserUuids: $retailerNetworkUserUuids
    retailerNetworkUuid: $retailerNetworkUuid
  )
}
    `;
export type AssociateRetailerNetworkLocationGroupsWithRetailerNetworkUsersMutationFn = Apollo.MutationFunction<AssociateRetailerNetworkLocationGroupsWithRetailerNetworkUsersMutation, AssociateRetailerNetworkLocationGroupsWithRetailerNetworkUsersMutationVariables>;

/**
 * __useAssociateRetailerNetworkLocationGroupsWithRetailerNetworkUsersMutation__
 *
 * To run a mutation, you first call `useAssociateRetailerNetworkLocationGroupsWithRetailerNetworkUsersMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAssociateRetailerNetworkLocationGroupsWithRetailerNetworkUsersMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [associateRetailerNetworkLocationGroupsWithRetailerNetworkUsersMutation, { data, loading, error }] = useAssociateRetailerNetworkLocationGroupsWithRetailerNetworkUsersMutation({
 *   variables: {
 *      locationGroupUuids: // value for 'locationGroupUuids'
 *      retailerNetworkUserUuids: // value for 'retailerNetworkUserUuids'
 *      retailerNetworkUuid: // value for 'retailerNetworkUuid'
 *   },
 * });
 */
export function useAssociateRetailerNetworkLocationGroupsWithRetailerNetworkUsersMutation(baseOptions?: Apollo.MutationHookOptions<AssociateRetailerNetworkLocationGroupsWithRetailerNetworkUsersMutation, AssociateRetailerNetworkLocationGroupsWithRetailerNetworkUsersMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AssociateRetailerNetworkLocationGroupsWithRetailerNetworkUsersMutation, AssociateRetailerNetworkLocationGroupsWithRetailerNetworkUsersMutationVariables>(AssociateRetailerNetworkLocationGroupsWithRetailerNetworkUsersDocument, options);
      }
export type AssociateRetailerNetworkLocationGroupsWithRetailerNetworkUsersMutationHookResult = ReturnType<typeof useAssociateRetailerNetworkLocationGroupsWithRetailerNetworkUsersMutation>;
export type AssociateRetailerNetworkLocationGroupsWithRetailerNetworkUsersMutationResult = Apollo.MutationResult<AssociateRetailerNetworkLocationGroupsWithRetailerNetworkUsersMutation>;
export type AssociateRetailerNetworkLocationGroupsWithRetailerNetworkUsersMutationOptions = Apollo.BaseMutationOptions<AssociateRetailerNetworkLocationGroupsWithRetailerNetworkUsersMutation, AssociateRetailerNetworkLocationGroupsWithRetailerNetworkUsersMutationVariables>;
export const DisassociateLocationsWithRetailerNetworkUsersDocument = gql`
    mutation disassociateLocationsWithRetailerNetworkUsers($retailerNetworkUuid: OCUUID!, $locationUuids: [OCUUID!]!, $retailerNetworkUserUuids: [OCUUID!]!) {
  disassociateLocationsWithRetailerNetworkUsers(
    retailerNetworkUuid: $retailerNetworkUuid
    locationUuids: $locationUuids
    retailerNetworkUserUuids: $retailerNetworkUserUuids
  )
}
    `;
export type DisassociateLocationsWithRetailerNetworkUsersMutationFn = Apollo.MutationFunction<DisassociateLocationsWithRetailerNetworkUsersMutation, DisassociateLocationsWithRetailerNetworkUsersMutationVariables>;

/**
 * __useDisassociateLocationsWithRetailerNetworkUsersMutation__
 *
 * To run a mutation, you first call `useDisassociateLocationsWithRetailerNetworkUsersMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDisassociateLocationsWithRetailerNetworkUsersMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [disassociateLocationsWithRetailerNetworkUsersMutation, { data, loading, error }] = useDisassociateLocationsWithRetailerNetworkUsersMutation({
 *   variables: {
 *      retailerNetworkUuid: // value for 'retailerNetworkUuid'
 *      locationUuids: // value for 'locationUuids'
 *      retailerNetworkUserUuids: // value for 'retailerNetworkUserUuids'
 *   },
 * });
 */
export function useDisassociateLocationsWithRetailerNetworkUsersMutation(baseOptions?: Apollo.MutationHookOptions<DisassociateLocationsWithRetailerNetworkUsersMutation, DisassociateLocationsWithRetailerNetworkUsersMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DisassociateLocationsWithRetailerNetworkUsersMutation, DisassociateLocationsWithRetailerNetworkUsersMutationVariables>(DisassociateLocationsWithRetailerNetworkUsersDocument, options);
      }
export type DisassociateLocationsWithRetailerNetworkUsersMutationHookResult = ReturnType<typeof useDisassociateLocationsWithRetailerNetworkUsersMutation>;
export type DisassociateLocationsWithRetailerNetworkUsersMutationResult = Apollo.MutationResult<DisassociateLocationsWithRetailerNetworkUsersMutation>;
export type DisassociateLocationsWithRetailerNetworkUsersMutationOptions = Apollo.BaseMutationOptions<DisassociateLocationsWithRetailerNetworkUsersMutation, DisassociateLocationsWithRetailerNetworkUsersMutationVariables>;
export const DisassociateRetailerNetworkLocationGroupsWithRetailerNetworkUsersDocument = gql`
    mutation disassociateRetailerNetworkLocationGroupsWithRetailerNetworkUsers($locationGroupUuids: [OCUUID!]!, $retailerNetworkUserUuids: [OCUUID!]!, $retailerNetworkUuid: OCUUID!) {
  disassociateRetailerNetworkLocationGroupsWithRetailerNetworkUsers(
    locationGroupUuids: $locationGroupUuids
    retailerNetworkUserUuids: $retailerNetworkUserUuids
    retailerNetworkUuid: $retailerNetworkUuid
  )
}
    `;
export type DisassociateRetailerNetworkLocationGroupsWithRetailerNetworkUsersMutationFn = Apollo.MutationFunction<DisassociateRetailerNetworkLocationGroupsWithRetailerNetworkUsersMutation, DisassociateRetailerNetworkLocationGroupsWithRetailerNetworkUsersMutationVariables>;

/**
 * __useDisassociateRetailerNetworkLocationGroupsWithRetailerNetworkUsersMutation__
 *
 * To run a mutation, you first call `useDisassociateRetailerNetworkLocationGroupsWithRetailerNetworkUsersMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDisassociateRetailerNetworkLocationGroupsWithRetailerNetworkUsersMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [disassociateRetailerNetworkLocationGroupsWithRetailerNetworkUsersMutation, { data, loading, error }] = useDisassociateRetailerNetworkLocationGroupsWithRetailerNetworkUsersMutation({
 *   variables: {
 *      locationGroupUuids: // value for 'locationGroupUuids'
 *      retailerNetworkUserUuids: // value for 'retailerNetworkUserUuids'
 *      retailerNetworkUuid: // value for 'retailerNetworkUuid'
 *   },
 * });
 */
export function useDisassociateRetailerNetworkLocationGroupsWithRetailerNetworkUsersMutation(baseOptions?: Apollo.MutationHookOptions<DisassociateRetailerNetworkLocationGroupsWithRetailerNetworkUsersMutation, DisassociateRetailerNetworkLocationGroupsWithRetailerNetworkUsersMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DisassociateRetailerNetworkLocationGroupsWithRetailerNetworkUsersMutation, DisassociateRetailerNetworkLocationGroupsWithRetailerNetworkUsersMutationVariables>(DisassociateRetailerNetworkLocationGroupsWithRetailerNetworkUsersDocument, options);
      }
export type DisassociateRetailerNetworkLocationGroupsWithRetailerNetworkUsersMutationHookResult = ReturnType<typeof useDisassociateRetailerNetworkLocationGroupsWithRetailerNetworkUsersMutation>;
export type DisassociateRetailerNetworkLocationGroupsWithRetailerNetworkUsersMutationResult = Apollo.MutationResult<DisassociateRetailerNetworkLocationGroupsWithRetailerNetworkUsersMutation>;
export type DisassociateRetailerNetworkLocationGroupsWithRetailerNetworkUsersMutationOptions = Apollo.BaseMutationOptions<DisassociateRetailerNetworkLocationGroupsWithRetailerNetworkUsersMutation, DisassociateRetailerNetworkLocationGroupsWithRetailerNetworkUsersMutationVariables>;
export const SetLocationPerformanceGoalDocument = gql`
    mutation setLocationPerformanceGoal($input: SetLocationPerformanceGoal!) {
  setLocationPerformanceGoal(input: $input)
}
    `;
export type SetLocationPerformanceGoalMutationFn = Apollo.MutationFunction<SetLocationPerformanceGoalMutation, SetLocationPerformanceGoalMutationVariables>;

/**
 * __useSetLocationPerformanceGoalMutation__
 *
 * To run a mutation, you first call `useSetLocationPerformanceGoalMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetLocationPerformanceGoalMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setLocationPerformanceGoalMutation, { data, loading, error }] = useSetLocationPerformanceGoalMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSetLocationPerformanceGoalMutation(baseOptions?: Apollo.MutationHookOptions<SetLocationPerformanceGoalMutation, SetLocationPerformanceGoalMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SetLocationPerformanceGoalMutation, SetLocationPerformanceGoalMutationVariables>(SetLocationPerformanceGoalDocument, options);
      }
export type SetLocationPerformanceGoalMutationHookResult = ReturnType<typeof useSetLocationPerformanceGoalMutation>;
export type SetLocationPerformanceGoalMutationResult = Apollo.MutationResult<SetLocationPerformanceGoalMutation>;
export type SetLocationPerformanceGoalMutationOptions = Apollo.BaseMutationOptions<SetLocationPerformanceGoalMutation, SetLocationPerformanceGoalMutationVariables>;
export const UnsetLocationPerformanceGoalDocument = gql`
    mutation unsetLocationPerformanceGoal($locationUuid: OCUUID!, $retailerNetworkUuid: OCUUID!) {
  unsetLocationPerformanceGoal(
    locationUuid: $locationUuid
    retailerNetworkUuid: $retailerNetworkUuid
  )
}
    `;
export type UnsetLocationPerformanceGoalMutationFn = Apollo.MutationFunction<UnsetLocationPerformanceGoalMutation, UnsetLocationPerformanceGoalMutationVariables>;

/**
 * __useUnsetLocationPerformanceGoalMutation__
 *
 * To run a mutation, you first call `useUnsetLocationPerformanceGoalMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUnsetLocationPerformanceGoalMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [unsetLocationPerformanceGoalMutation, { data, loading, error }] = useUnsetLocationPerformanceGoalMutation({
 *   variables: {
 *      locationUuid: // value for 'locationUuid'
 *      retailerNetworkUuid: // value for 'retailerNetworkUuid'
 *   },
 * });
 */
export function useUnsetLocationPerformanceGoalMutation(baseOptions?: Apollo.MutationHookOptions<UnsetLocationPerformanceGoalMutation, UnsetLocationPerformanceGoalMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UnsetLocationPerformanceGoalMutation, UnsetLocationPerformanceGoalMutationVariables>(UnsetLocationPerformanceGoalDocument, options);
      }
export type UnsetLocationPerformanceGoalMutationHookResult = ReturnType<typeof useUnsetLocationPerformanceGoalMutation>;
export type UnsetLocationPerformanceGoalMutationResult = Apollo.MutationResult<UnsetLocationPerformanceGoalMutation>;
export type UnsetLocationPerformanceGoalMutationOptions = Apollo.BaseMutationOptions<UnsetLocationPerformanceGoalMutation, UnsetLocationPerformanceGoalMutationVariables>;
export const EmailRetailerNetworkScanDataTobaccoSubmissionsCsvReportDocument = gql`
    mutation emailRetailerNetworkScanDataTobaccoSubmissionsCsvReport($emailToSendReport: OCEmailAddress!, $filter: RetailerNetworkScanDataTobaccoSubmissionFilter!) {
  emailRetailerNetworkScanDataTobaccoSubmissionsCsvReport(
    emailToSendReport: $emailToSendReport
    filter: $filter
  )
}
    `;
export type EmailRetailerNetworkScanDataTobaccoSubmissionsCsvReportMutationFn = Apollo.MutationFunction<EmailRetailerNetworkScanDataTobaccoSubmissionsCsvReportMutation, EmailRetailerNetworkScanDataTobaccoSubmissionsCsvReportMutationVariables>;

/**
 * __useEmailRetailerNetworkScanDataTobaccoSubmissionsCsvReportMutation__
 *
 * To run a mutation, you first call `useEmailRetailerNetworkScanDataTobaccoSubmissionsCsvReportMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEmailRetailerNetworkScanDataTobaccoSubmissionsCsvReportMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [emailRetailerNetworkScanDataTobaccoSubmissionsCsvReportMutation, { data, loading, error }] = useEmailRetailerNetworkScanDataTobaccoSubmissionsCsvReportMutation({
 *   variables: {
 *      emailToSendReport: // value for 'emailToSendReport'
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useEmailRetailerNetworkScanDataTobaccoSubmissionsCsvReportMutation(baseOptions?: Apollo.MutationHookOptions<EmailRetailerNetworkScanDataTobaccoSubmissionsCsvReportMutation, EmailRetailerNetworkScanDataTobaccoSubmissionsCsvReportMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<EmailRetailerNetworkScanDataTobaccoSubmissionsCsvReportMutation, EmailRetailerNetworkScanDataTobaccoSubmissionsCsvReportMutationVariables>(EmailRetailerNetworkScanDataTobaccoSubmissionsCsvReportDocument, options);
      }
export type EmailRetailerNetworkScanDataTobaccoSubmissionsCsvReportMutationHookResult = ReturnType<typeof useEmailRetailerNetworkScanDataTobaccoSubmissionsCsvReportMutation>;
export type EmailRetailerNetworkScanDataTobaccoSubmissionsCsvReportMutationResult = Apollo.MutationResult<EmailRetailerNetworkScanDataTobaccoSubmissionsCsvReportMutation>;
export type EmailRetailerNetworkScanDataTobaccoSubmissionsCsvReportMutationOptions = Apollo.BaseMutationOptions<EmailRetailerNetworkScanDataTobaccoSubmissionsCsvReportMutation, EmailRetailerNetworkScanDataTobaccoSubmissionsCsvReportMutationVariables>;
export const EmailRetailerNetworkScanDataTobaccoSiteSubmissionsCsvReportDocument = gql`
    mutation emailRetailerNetworkScanDataTobaccoSiteSubmissionsCsvReport($emailToSendReport: OCEmailAddress!, $filter: RetailerNetworkScanDataTobaccoSiteSubmissionFilter!) {
  emailRetailerNetworkScanDataTobaccoSiteSubmissionsCsvReport(
    emailToSendReport: $emailToSendReport
    filter: $filter
  )
}
    `;
export type EmailRetailerNetworkScanDataTobaccoSiteSubmissionsCsvReportMutationFn = Apollo.MutationFunction<EmailRetailerNetworkScanDataTobaccoSiteSubmissionsCsvReportMutation, EmailRetailerNetworkScanDataTobaccoSiteSubmissionsCsvReportMutationVariables>;

/**
 * __useEmailRetailerNetworkScanDataTobaccoSiteSubmissionsCsvReportMutation__
 *
 * To run a mutation, you first call `useEmailRetailerNetworkScanDataTobaccoSiteSubmissionsCsvReportMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEmailRetailerNetworkScanDataTobaccoSiteSubmissionsCsvReportMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [emailRetailerNetworkScanDataTobaccoSiteSubmissionsCsvReportMutation, { data, loading, error }] = useEmailRetailerNetworkScanDataTobaccoSiteSubmissionsCsvReportMutation({
 *   variables: {
 *      emailToSendReport: // value for 'emailToSendReport'
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useEmailRetailerNetworkScanDataTobaccoSiteSubmissionsCsvReportMutation(baseOptions?: Apollo.MutationHookOptions<EmailRetailerNetworkScanDataTobaccoSiteSubmissionsCsvReportMutation, EmailRetailerNetworkScanDataTobaccoSiteSubmissionsCsvReportMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<EmailRetailerNetworkScanDataTobaccoSiteSubmissionsCsvReportMutation, EmailRetailerNetworkScanDataTobaccoSiteSubmissionsCsvReportMutationVariables>(EmailRetailerNetworkScanDataTobaccoSiteSubmissionsCsvReportDocument, options);
      }
export type EmailRetailerNetworkScanDataTobaccoSiteSubmissionsCsvReportMutationHookResult = ReturnType<typeof useEmailRetailerNetworkScanDataTobaccoSiteSubmissionsCsvReportMutation>;
export type EmailRetailerNetworkScanDataTobaccoSiteSubmissionsCsvReportMutationResult = Apollo.MutationResult<EmailRetailerNetworkScanDataTobaccoSiteSubmissionsCsvReportMutation>;
export type EmailRetailerNetworkScanDataTobaccoSiteSubmissionsCsvReportMutationOptions = Apollo.BaseMutationOptions<EmailRetailerNetworkScanDataTobaccoSiteSubmissionsCsvReportMutation, EmailRetailerNetworkScanDataTobaccoSiteSubmissionsCsvReportMutationVariables>;
export const RetailerNetworksForUserDocument = gql`
    query retailerNetworksForUser($first: Int, $last: Int, $after: OCBase64Cursor, $before: OCBase64Cursor, $filter: RetailersNetworksFilter!) {
  retailerNetworksForUser(
    first: $first
    last: $last
    after: $after
    before: $before
    filter: $filter
  ) {
    pageInfo {
      ...pageInfo
    }
    edges {
      cursor
      node {
        ...retailerNetworkPartial
      }
    }
  }
}
    ${PageInfoFragmentDoc}
${RetailerNetworkPartialFragmentDoc}`;

/**
 * __useRetailerNetworksForUserQuery__
 *
 * To run a query within a React component, call `useRetailerNetworksForUserQuery` and pass it any options that fit your needs.
 * When your component renders, `useRetailerNetworksForUserQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useRetailerNetworksForUserQuery({
 *   variables: {
 *      first: // value for 'first'
 *      last: // value for 'last'
 *      after: // value for 'after'
 *      before: // value for 'before'
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useRetailerNetworksForUserQuery(baseOptions: Apollo.QueryHookOptions<RetailerNetworksForUserQuery, RetailerNetworksForUserQueryVariables> & ({ variables: RetailerNetworksForUserQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<RetailerNetworksForUserQuery, RetailerNetworksForUserQueryVariables>(RetailerNetworksForUserDocument, options);
      }
export function useRetailerNetworksForUserLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<RetailerNetworksForUserQuery, RetailerNetworksForUserQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<RetailerNetworksForUserQuery, RetailerNetworksForUserQueryVariables>(RetailerNetworksForUserDocument, options);
        }
export function useRetailerNetworksForUserSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<RetailerNetworksForUserQuery, RetailerNetworksForUserQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<RetailerNetworksForUserQuery, RetailerNetworksForUserQueryVariables>(RetailerNetworksForUserDocument, options);
        }
export type RetailerNetworksForUserQueryHookResult = ReturnType<typeof useRetailerNetworksForUserQuery>;
export type RetailerNetworksForUserLazyQueryHookResult = ReturnType<typeof useRetailerNetworksForUserLazyQuery>;
export type RetailerNetworksForUserSuspenseQueryHookResult = ReturnType<typeof useRetailerNetworksForUserSuspenseQuery>;
export type RetailerNetworksForUserQueryResult = Apollo.QueryResult<RetailerNetworksForUserQuery, RetailerNetworksForUserQueryVariables>;
export const RetailerNetworkDocument = gql`
    query retailerNetwork($uuid: OCUUID!) {
  retailerNetwork(uuid: $uuid) {
    ...retailerNetwork
  }
}
    ${RetailerNetworkFragmentDoc}`;

/**
 * __useRetailerNetworkQuery__
 *
 * To run a query within a React component, call `useRetailerNetworkQuery` and pass it any options that fit your needs.
 * When your component renders, `useRetailerNetworkQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useRetailerNetworkQuery({
 *   variables: {
 *      uuid: // value for 'uuid'
 *   },
 * });
 */
export function useRetailerNetworkQuery(baseOptions: Apollo.QueryHookOptions<RetailerNetworkQuery, RetailerNetworkQueryVariables> & ({ variables: RetailerNetworkQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<RetailerNetworkQuery, RetailerNetworkQueryVariables>(RetailerNetworkDocument, options);
      }
export function useRetailerNetworkLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<RetailerNetworkQuery, RetailerNetworkQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<RetailerNetworkQuery, RetailerNetworkQueryVariables>(RetailerNetworkDocument, options);
        }
export function useRetailerNetworkSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<RetailerNetworkQuery, RetailerNetworkQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<RetailerNetworkQuery, RetailerNetworkQueryVariables>(RetailerNetworkDocument, options);
        }
export type RetailerNetworkQueryHookResult = ReturnType<typeof useRetailerNetworkQuery>;
export type RetailerNetworkLazyQueryHookResult = ReturnType<typeof useRetailerNetworkLazyQuery>;
export type RetailerNetworkSuspenseQueryHookResult = ReturnType<typeof useRetailerNetworkSuspenseQuery>;
export type RetailerNetworkQueryResult = Apollo.QueryResult<RetailerNetworkQuery, RetailerNetworkQueryVariables>;
export const RetailerNetworkUsersDocument = gql`
    query retailerNetworkUsers($first: Int, $last: Int, $after: OCBase64Cursor, $before: OCBase64Cursor, $filter: RetailerNetworkUsersFilter!) {
  retailerNetworkUsers(
    first: $first
    last: $last
    after: $after
    before: $before
    filter: $filter
  ) {
    pageInfo {
      ...pageInfo
    }
    edges {
      cursor
      node {
        ...retailerNetworkUser
      }
    }
  }
}
    ${PageInfoFragmentDoc}
${RetailerNetworkUserFragmentDoc}`;

/**
 * __useRetailerNetworkUsersQuery__
 *
 * To run a query within a React component, call `useRetailerNetworkUsersQuery` and pass it any options that fit your needs.
 * When your component renders, `useRetailerNetworkUsersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useRetailerNetworkUsersQuery({
 *   variables: {
 *      first: // value for 'first'
 *      last: // value for 'last'
 *      after: // value for 'after'
 *      before: // value for 'before'
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useRetailerNetworkUsersQuery(baseOptions: Apollo.QueryHookOptions<RetailerNetworkUsersQuery, RetailerNetworkUsersQueryVariables> & ({ variables: RetailerNetworkUsersQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<RetailerNetworkUsersQuery, RetailerNetworkUsersQueryVariables>(RetailerNetworkUsersDocument, options);
      }
export function useRetailerNetworkUsersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<RetailerNetworkUsersQuery, RetailerNetworkUsersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<RetailerNetworkUsersQuery, RetailerNetworkUsersQueryVariables>(RetailerNetworkUsersDocument, options);
        }
export function useRetailerNetworkUsersSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<RetailerNetworkUsersQuery, RetailerNetworkUsersQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<RetailerNetworkUsersQuery, RetailerNetworkUsersQueryVariables>(RetailerNetworkUsersDocument, options);
        }
export type RetailerNetworkUsersQueryHookResult = ReturnType<typeof useRetailerNetworkUsersQuery>;
export type RetailerNetworkUsersLazyQueryHookResult = ReturnType<typeof useRetailerNetworkUsersLazyQuery>;
export type RetailerNetworkUsersSuspenseQueryHookResult = ReturnType<typeof useRetailerNetworkUsersSuspenseQuery>;
export type RetailerNetworkUsersQueryResult = Apollo.QueryResult<RetailerNetworkUsersQuery, RetailerNetworkUsersQueryVariables>;
export const RetailerNetworkCustomerDocument = gql`
    query retailerNetworkCustomer($first: Int, $last: Int, $after: OCBase64Cursor, $before: OCBase64Cursor, $filter: RetailerNetworkCustomerFilter!) {
  retailerNetworkCustomer(
    first: $first
    last: $last
    after: $after
    before: $before
    filter: $filter
  ) {
    pageInfo {
      ...pageInfo
    }
    edges {
      cursor
      node {
        ...retailerNetworkCustomer
      }
    }
  }
}
    ${PageInfoFragmentDoc}
${RetailerNetworkCustomerFragmentDoc}`;

/**
 * __useRetailerNetworkCustomerQuery__
 *
 * To run a query within a React component, call `useRetailerNetworkCustomerQuery` and pass it any options that fit your needs.
 * When your component renders, `useRetailerNetworkCustomerQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useRetailerNetworkCustomerQuery({
 *   variables: {
 *      first: // value for 'first'
 *      last: // value for 'last'
 *      after: // value for 'after'
 *      before: // value for 'before'
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useRetailerNetworkCustomerQuery(baseOptions: Apollo.QueryHookOptions<RetailerNetworkCustomerQuery, RetailerNetworkCustomerQueryVariables> & ({ variables: RetailerNetworkCustomerQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<RetailerNetworkCustomerQuery, RetailerNetworkCustomerQueryVariables>(RetailerNetworkCustomerDocument, options);
      }
export function useRetailerNetworkCustomerLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<RetailerNetworkCustomerQuery, RetailerNetworkCustomerQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<RetailerNetworkCustomerQuery, RetailerNetworkCustomerQueryVariables>(RetailerNetworkCustomerDocument, options);
        }
export function useRetailerNetworkCustomerSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<RetailerNetworkCustomerQuery, RetailerNetworkCustomerQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<RetailerNetworkCustomerQuery, RetailerNetworkCustomerQueryVariables>(RetailerNetworkCustomerDocument, options);
        }
export type RetailerNetworkCustomerQueryHookResult = ReturnType<typeof useRetailerNetworkCustomerQuery>;
export type RetailerNetworkCustomerLazyQueryHookResult = ReturnType<typeof useRetailerNetworkCustomerLazyQuery>;
export type RetailerNetworkCustomerSuspenseQueryHookResult = ReturnType<typeof useRetailerNetworkCustomerSuspenseQuery>;
export type RetailerNetworkCustomerQueryResult = Apollo.QueryResult<RetailerNetworkCustomerQuery, RetailerNetworkCustomerQueryVariables>;
export const RetailerNetworkLocationsDocument = gql`
    query retailerNetworkLocations($first: Int, $last: Int, $after: OCBase64Cursor, $before: OCBase64Cursor, $filter: RetailerNetworkLocationFilter!) {
  retailerNetworkLocations(
    first: $first
    last: $last
    after: $after
    before: $before
    filter: $filter
  ) {
    pageInfo {
      ...pageInfo
    }
    edges {
      cursor
      node {
        ...retailerNetworkLocation
      }
    }
  }
}
    ${PageInfoFragmentDoc}
${RetailerNetworkLocationFragmentDoc}`;

/**
 * __useRetailerNetworkLocationsQuery__
 *
 * To run a query within a React component, call `useRetailerNetworkLocationsQuery` and pass it any options that fit your needs.
 * When your component renders, `useRetailerNetworkLocationsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useRetailerNetworkLocationsQuery({
 *   variables: {
 *      first: // value for 'first'
 *      last: // value for 'last'
 *      after: // value for 'after'
 *      before: // value for 'before'
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useRetailerNetworkLocationsQuery(baseOptions: Apollo.QueryHookOptions<RetailerNetworkLocationsQuery, RetailerNetworkLocationsQueryVariables> & ({ variables: RetailerNetworkLocationsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<RetailerNetworkLocationsQuery, RetailerNetworkLocationsQueryVariables>(RetailerNetworkLocationsDocument, options);
      }
export function useRetailerNetworkLocationsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<RetailerNetworkLocationsQuery, RetailerNetworkLocationsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<RetailerNetworkLocationsQuery, RetailerNetworkLocationsQueryVariables>(RetailerNetworkLocationsDocument, options);
        }
export function useRetailerNetworkLocationsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<RetailerNetworkLocationsQuery, RetailerNetworkLocationsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<RetailerNetworkLocationsQuery, RetailerNetworkLocationsQueryVariables>(RetailerNetworkLocationsDocument, options);
        }
export type RetailerNetworkLocationsQueryHookResult = ReturnType<typeof useRetailerNetworkLocationsQuery>;
export type RetailerNetworkLocationsLazyQueryHookResult = ReturnType<typeof useRetailerNetworkLocationsLazyQuery>;
export type RetailerNetworkLocationsSuspenseQueryHookResult = ReturnType<typeof useRetailerNetworkLocationsSuspenseQuery>;
export type RetailerNetworkLocationsQueryResult = Apollo.QueryResult<RetailerNetworkLocationsQuery, RetailerNetworkLocationsQueryVariables>;
export const RetailerNetworkLocationDetailsDocument = gql`
    query retailerNetworkLocationDetails($first: Int, $last: Int, $after: OCBase64Cursor, $before: OCBase64Cursor, $filter: RetailerNetworkLocationFilter!) {
  retailerNetworkLocations(
    first: $first
    last: $last
    after: $after
    before: $before
    filter: $filter
  ) {
    pageInfo {
      ...pageInfo
    }
    edges {
      cursor
      node {
        ...retailerNetworkLocationDetails
      }
    }
  }
}
    ${PageInfoFragmentDoc}
${RetailerNetworkLocationDetailsFragmentDoc}`;

/**
 * __useRetailerNetworkLocationDetailsQuery__
 *
 * To run a query within a React component, call `useRetailerNetworkLocationDetailsQuery` and pass it any options that fit your needs.
 * When your component renders, `useRetailerNetworkLocationDetailsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useRetailerNetworkLocationDetailsQuery({
 *   variables: {
 *      first: // value for 'first'
 *      last: // value for 'last'
 *      after: // value for 'after'
 *      before: // value for 'before'
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useRetailerNetworkLocationDetailsQuery(baseOptions: Apollo.QueryHookOptions<RetailerNetworkLocationDetailsQuery, RetailerNetworkLocationDetailsQueryVariables> & ({ variables: RetailerNetworkLocationDetailsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<RetailerNetworkLocationDetailsQuery, RetailerNetworkLocationDetailsQueryVariables>(RetailerNetworkLocationDetailsDocument, options);
      }
export function useRetailerNetworkLocationDetailsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<RetailerNetworkLocationDetailsQuery, RetailerNetworkLocationDetailsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<RetailerNetworkLocationDetailsQuery, RetailerNetworkLocationDetailsQueryVariables>(RetailerNetworkLocationDetailsDocument, options);
        }
export function useRetailerNetworkLocationDetailsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<RetailerNetworkLocationDetailsQuery, RetailerNetworkLocationDetailsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<RetailerNetworkLocationDetailsQuery, RetailerNetworkLocationDetailsQueryVariables>(RetailerNetworkLocationDetailsDocument, options);
        }
export type RetailerNetworkLocationDetailsQueryHookResult = ReturnType<typeof useRetailerNetworkLocationDetailsQuery>;
export type RetailerNetworkLocationDetailsLazyQueryHookResult = ReturnType<typeof useRetailerNetworkLocationDetailsLazyQuery>;
export type RetailerNetworkLocationDetailsSuspenseQueryHookResult = ReturnType<typeof useRetailerNetworkLocationDetailsSuspenseQuery>;
export type RetailerNetworkLocationDetailsQueryResult = Apollo.QueryResult<RetailerNetworkLocationDetailsQuery, RetailerNetworkLocationDetailsQueryVariables>;
export const RetailerNetworkLocationCoordinatesDocument = gql`
    query retailerNetworkLocationCoordinates($first: Int, $last: Int, $after: OCBase64Cursor, $before: OCBase64Cursor, $filter: RetailerNetworkLocationCoordinatesFilter!) {
  retailerNetworkLocationCoordinates(
    first: $first
    last: $last
    after: $after
    before: $before
    filter: $filter
  ) {
    pageInfo {
      ...pageInfo
    }
    totalCount
    edges {
      cursor
      node {
        ...retailerNetworkLocationCoordinates
      }
    }
  }
}
    ${PageInfoFragmentDoc}
${RetailerNetworkLocationCoordinatesFragmentDoc}`;

/**
 * __useRetailerNetworkLocationCoordinatesQuery__
 *
 * To run a query within a React component, call `useRetailerNetworkLocationCoordinatesQuery` and pass it any options that fit your needs.
 * When your component renders, `useRetailerNetworkLocationCoordinatesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useRetailerNetworkLocationCoordinatesQuery({
 *   variables: {
 *      first: // value for 'first'
 *      last: // value for 'last'
 *      after: // value for 'after'
 *      before: // value for 'before'
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useRetailerNetworkLocationCoordinatesQuery(baseOptions: Apollo.QueryHookOptions<RetailerNetworkLocationCoordinatesQuery, RetailerNetworkLocationCoordinatesQueryVariables> & ({ variables: RetailerNetworkLocationCoordinatesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<RetailerNetworkLocationCoordinatesQuery, RetailerNetworkLocationCoordinatesQueryVariables>(RetailerNetworkLocationCoordinatesDocument, options);
      }
export function useRetailerNetworkLocationCoordinatesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<RetailerNetworkLocationCoordinatesQuery, RetailerNetworkLocationCoordinatesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<RetailerNetworkLocationCoordinatesQuery, RetailerNetworkLocationCoordinatesQueryVariables>(RetailerNetworkLocationCoordinatesDocument, options);
        }
export function useRetailerNetworkLocationCoordinatesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<RetailerNetworkLocationCoordinatesQuery, RetailerNetworkLocationCoordinatesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<RetailerNetworkLocationCoordinatesQuery, RetailerNetworkLocationCoordinatesQueryVariables>(RetailerNetworkLocationCoordinatesDocument, options);
        }
export type RetailerNetworkLocationCoordinatesQueryHookResult = ReturnType<typeof useRetailerNetworkLocationCoordinatesQuery>;
export type RetailerNetworkLocationCoordinatesLazyQueryHookResult = ReturnType<typeof useRetailerNetworkLocationCoordinatesLazyQuery>;
export type RetailerNetworkLocationCoordinatesSuspenseQueryHookResult = ReturnType<typeof useRetailerNetworkLocationCoordinatesSuspenseQuery>;
export type RetailerNetworkLocationCoordinatesQueryResult = Apollo.QueryResult<RetailerNetworkLocationCoordinatesQuery, RetailerNetworkLocationCoordinatesQueryVariables>;
export const RetailerNetworkLocationStatesDocument = gql`
    query retailerNetworkLocationStates($filter: RetailerNetworkLocationStatesFilter!) {
  retailerNetworkLocationStates(filter: $filter)
}
    `;

/**
 * __useRetailerNetworkLocationStatesQuery__
 *
 * To run a query within a React component, call `useRetailerNetworkLocationStatesQuery` and pass it any options that fit your needs.
 * When your component renders, `useRetailerNetworkLocationStatesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useRetailerNetworkLocationStatesQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useRetailerNetworkLocationStatesQuery(baseOptions: Apollo.QueryHookOptions<RetailerNetworkLocationStatesQuery, RetailerNetworkLocationStatesQueryVariables> & ({ variables: RetailerNetworkLocationStatesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<RetailerNetworkLocationStatesQuery, RetailerNetworkLocationStatesQueryVariables>(RetailerNetworkLocationStatesDocument, options);
      }
export function useRetailerNetworkLocationStatesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<RetailerNetworkLocationStatesQuery, RetailerNetworkLocationStatesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<RetailerNetworkLocationStatesQuery, RetailerNetworkLocationStatesQueryVariables>(RetailerNetworkLocationStatesDocument, options);
        }
export function useRetailerNetworkLocationStatesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<RetailerNetworkLocationStatesQuery, RetailerNetworkLocationStatesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<RetailerNetworkLocationStatesQuery, RetailerNetworkLocationStatesQueryVariables>(RetailerNetworkLocationStatesDocument, options);
        }
export type RetailerNetworkLocationStatesQueryHookResult = ReturnType<typeof useRetailerNetworkLocationStatesQuery>;
export type RetailerNetworkLocationStatesLazyQueryHookResult = ReturnType<typeof useRetailerNetworkLocationStatesLazyQuery>;
export type RetailerNetworkLocationStatesSuspenseQueryHookResult = ReturnType<typeof useRetailerNetworkLocationStatesSuspenseQuery>;
export type RetailerNetworkLocationStatesQueryResult = Apollo.QueryResult<RetailerNetworkLocationStatesQuery, RetailerNetworkLocationStatesQueryVariables>;
export const RetailerNetworkLocationCitiesDocument = gql`
    query retailerNetworkLocationCities($filter: RetailerNetworkLocationCitiesFilter!) {
  retailerNetworkLocationCities(filter: $filter)
}
    `;

/**
 * __useRetailerNetworkLocationCitiesQuery__
 *
 * To run a query within a React component, call `useRetailerNetworkLocationCitiesQuery` and pass it any options that fit your needs.
 * When your component renders, `useRetailerNetworkLocationCitiesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useRetailerNetworkLocationCitiesQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useRetailerNetworkLocationCitiesQuery(baseOptions: Apollo.QueryHookOptions<RetailerNetworkLocationCitiesQuery, RetailerNetworkLocationCitiesQueryVariables> & ({ variables: RetailerNetworkLocationCitiesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<RetailerNetworkLocationCitiesQuery, RetailerNetworkLocationCitiesQueryVariables>(RetailerNetworkLocationCitiesDocument, options);
      }
export function useRetailerNetworkLocationCitiesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<RetailerNetworkLocationCitiesQuery, RetailerNetworkLocationCitiesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<RetailerNetworkLocationCitiesQuery, RetailerNetworkLocationCitiesQueryVariables>(RetailerNetworkLocationCitiesDocument, options);
        }
export function useRetailerNetworkLocationCitiesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<RetailerNetworkLocationCitiesQuery, RetailerNetworkLocationCitiesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<RetailerNetworkLocationCitiesQuery, RetailerNetworkLocationCitiesQueryVariables>(RetailerNetworkLocationCitiesDocument, options);
        }
export type RetailerNetworkLocationCitiesQueryHookResult = ReturnType<typeof useRetailerNetworkLocationCitiesQuery>;
export type RetailerNetworkLocationCitiesLazyQueryHookResult = ReturnType<typeof useRetailerNetworkLocationCitiesLazyQuery>;
export type RetailerNetworkLocationCitiesSuspenseQueryHookResult = ReturnType<typeof useRetailerNetworkLocationCitiesSuspenseQuery>;
export type RetailerNetworkLocationCitiesQueryResult = Apollo.QueryResult<RetailerNetworkLocationCitiesQuery, RetailerNetworkLocationCitiesQueryVariables>;
export const RetailerNetworkLocationPosConnectionStatusDocument = gql`
    query retailerNetworkLocationPosConnectionStatus($filter: RetailerNetworkLocationPosConnectionStatusFilter!) {
  retailerNetworkLocationPosConnectionStatus(filter: $filter) {
    ...retailerNetworkLocationPosConnectionStatus
  }
}
    ${RetailerNetworkLocationPosConnectionStatusFragmentDoc}`;

/**
 * __useRetailerNetworkLocationPosConnectionStatusQuery__
 *
 * To run a query within a React component, call `useRetailerNetworkLocationPosConnectionStatusQuery` and pass it any options that fit your needs.
 * When your component renders, `useRetailerNetworkLocationPosConnectionStatusQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useRetailerNetworkLocationPosConnectionStatusQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useRetailerNetworkLocationPosConnectionStatusQuery(baseOptions: Apollo.QueryHookOptions<RetailerNetworkLocationPosConnectionStatusQuery, RetailerNetworkLocationPosConnectionStatusQueryVariables> & ({ variables: RetailerNetworkLocationPosConnectionStatusQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<RetailerNetworkLocationPosConnectionStatusQuery, RetailerNetworkLocationPosConnectionStatusQueryVariables>(RetailerNetworkLocationPosConnectionStatusDocument, options);
      }
export function useRetailerNetworkLocationPosConnectionStatusLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<RetailerNetworkLocationPosConnectionStatusQuery, RetailerNetworkLocationPosConnectionStatusQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<RetailerNetworkLocationPosConnectionStatusQuery, RetailerNetworkLocationPosConnectionStatusQueryVariables>(RetailerNetworkLocationPosConnectionStatusDocument, options);
        }
export function useRetailerNetworkLocationPosConnectionStatusSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<RetailerNetworkLocationPosConnectionStatusQuery, RetailerNetworkLocationPosConnectionStatusQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<RetailerNetworkLocationPosConnectionStatusQuery, RetailerNetworkLocationPosConnectionStatusQueryVariables>(RetailerNetworkLocationPosConnectionStatusDocument, options);
        }
export type RetailerNetworkLocationPosConnectionStatusQueryHookResult = ReturnType<typeof useRetailerNetworkLocationPosConnectionStatusQuery>;
export type RetailerNetworkLocationPosConnectionStatusLazyQueryHookResult = ReturnType<typeof useRetailerNetworkLocationPosConnectionStatusLazyQuery>;
export type RetailerNetworkLocationPosConnectionStatusSuspenseQueryHookResult = ReturnType<typeof useRetailerNetworkLocationPosConnectionStatusSuspenseQuery>;
export type RetailerNetworkLocationPosConnectionStatusQueryResult = Apollo.QueryResult<RetailerNetworkLocationPosConnectionStatusQuery, RetailerNetworkLocationPosConnectionStatusQueryVariables>;
export const RetailerNetworkLocationGroupsDocument = gql`
    query retailerNetworkLocationGroups($first: Int, $last: Int, $after: OCBase64Cursor, $before: OCBase64Cursor, $filter: RetailerNetworkLocationGroupFilter!) {
  retailerNetworkLocationGroups(
    first: $first
    last: $last
    after: $after
    before: $before
    filter: $filter
  ) {
    pageInfo {
      ...pageInfo
    }
    edges {
      cursor
      node {
        ...retailerNetworkLocationGroup
      }
    }
  }
}
    ${PageInfoFragmentDoc}
${RetailerNetworkLocationGroupFragmentDoc}`;

/**
 * __useRetailerNetworkLocationGroupsQuery__
 *
 * To run a query within a React component, call `useRetailerNetworkLocationGroupsQuery` and pass it any options that fit your needs.
 * When your component renders, `useRetailerNetworkLocationGroupsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useRetailerNetworkLocationGroupsQuery({
 *   variables: {
 *      first: // value for 'first'
 *      last: // value for 'last'
 *      after: // value for 'after'
 *      before: // value for 'before'
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useRetailerNetworkLocationGroupsQuery(baseOptions: Apollo.QueryHookOptions<RetailerNetworkLocationGroupsQuery, RetailerNetworkLocationGroupsQueryVariables> & ({ variables: RetailerNetworkLocationGroupsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<RetailerNetworkLocationGroupsQuery, RetailerNetworkLocationGroupsQueryVariables>(RetailerNetworkLocationGroupsDocument, options);
      }
export function useRetailerNetworkLocationGroupsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<RetailerNetworkLocationGroupsQuery, RetailerNetworkLocationGroupsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<RetailerNetworkLocationGroupsQuery, RetailerNetworkLocationGroupsQueryVariables>(RetailerNetworkLocationGroupsDocument, options);
        }
export function useRetailerNetworkLocationGroupsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<RetailerNetworkLocationGroupsQuery, RetailerNetworkLocationGroupsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<RetailerNetworkLocationGroupsQuery, RetailerNetworkLocationGroupsQueryVariables>(RetailerNetworkLocationGroupsDocument, options);
        }
export type RetailerNetworkLocationGroupsQueryHookResult = ReturnType<typeof useRetailerNetworkLocationGroupsQuery>;
export type RetailerNetworkLocationGroupsLazyQueryHookResult = ReturnType<typeof useRetailerNetworkLocationGroupsLazyQuery>;
export type RetailerNetworkLocationGroupsSuspenseQueryHookResult = ReturnType<typeof useRetailerNetworkLocationGroupsSuspenseQuery>;
export type RetailerNetworkLocationGroupsQueryResult = Apollo.QueryResult<RetailerNetworkLocationGroupsQuery, RetailerNetworkLocationGroupsQueryVariables>;
export const RetailerNetworkLocationsWithPerformanceExcerptDocument = gql`
    query retailerNetworkLocationsWithPerformanceExcerpt($first: Int, $last: Int, $after: OCBase64Cursor, $before: OCBase64Cursor, $filter: RetailerNetworkLocationsWithPerformanceExcerptFilter!, $sort: RetailerNetworkPerformanceSort) {
  retailerNetworkLocationsWithPerformanceExcerpt(
    first: $first
    last: $last
    after: $after
    before: $before
    filter: $filter
    sort: $sort
  ) {
    pageInfo {
      ...pageInfo
    }
    edges {
      cursor
      node {
        ...retailerNetworkLocationWithPerformanceExcerpt
      }
    }
  }
}
    ${PageInfoFragmentDoc}
${RetailerNetworkLocationWithPerformanceExcerptFragmentDoc}`;

/**
 * __useRetailerNetworkLocationsWithPerformanceExcerptQuery__
 *
 * To run a query within a React component, call `useRetailerNetworkLocationsWithPerformanceExcerptQuery` and pass it any options that fit your needs.
 * When your component renders, `useRetailerNetworkLocationsWithPerformanceExcerptQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useRetailerNetworkLocationsWithPerformanceExcerptQuery({
 *   variables: {
 *      first: // value for 'first'
 *      last: // value for 'last'
 *      after: // value for 'after'
 *      before: // value for 'before'
 *      filter: // value for 'filter'
 *      sort: // value for 'sort'
 *   },
 * });
 */
export function useRetailerNetworkLocationsWithPerformanceExcerptQuery(baseOptions: Apollo.QueryHookOptions<RetailerNetworkLocationsWithPerformanceExcerptQuery, RetailerNetworkLocationsWithPerformanceExcerptQueryVariables> & ({ variables: RetailerNetworkLocationsWithPerformanceExcerptQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<RetailerNetworkLocationsWithPerformanceExcerptQuery, RetailerNetworkLocationsWithPerformanceExcerptQueryVariables>(RetailerNetworkLocationsWithPerformanceExcerptDocument, options);
      }
export function useRetailerNetworkLocationsWithPerformanceExcerptLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<RetailerNetworkLocationsWithPerformanceExcerptQuery, RetailerNetworkLocationsWithPerformanceExcerptQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<RetailerNetworkLocationsWithPerformanceExcerptQuery, RetailerNetworkLocationsWithPerformanceExcerptQueryVariables>(RetailerNetworkLocationsWithPerformanceExcerptDocument, options);
        }
export function useRetailerNetworkLocationsWithPerformanceExcerptSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<RetailerNetworkLocationsWithPerformanceExcerptQuery, RetailerNetworkLocationsWithPerformanceExcerptQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<RetailerNetworkLocationsWithPerformanceExcerptQuery, RetailerNetworkLocationsWithPerformanceExcerptQueryVariables>(RetailerNetworkLocationsWithPerformanceExcerptDocument, options);
        }
export type RetailerNetworkLocationsWithPerformanceExcerptQueryHookResult = ReturnType<typeof useRetailerNetworkLocationsWithPerformanceExcerptQuery>;
export type RetailerNetworkLocationsWithPerformanceExcerptLazyQueryHookResult = ReturnType<typeof useRetailerNetworkLocationsWithPerformanceExcerptLazyQuery>;
export type RetailerNetworkLocationsWithPerformanceExcerptSuspenseQueryHookResult = ReturnType<typeof useRetailerNetworkLocationsWithPerformanceExcerptSuspenseQuery>;
export type RetailerNetworkLocationsWithPerformanceExcerptQueryResult = Apollo.QueryResult<RetailerNetworkLocationsWithPerformanceExcerptQuery, RetailerNetworkLocationsWithPerformanceExcerptQueryVariables>;
export const RetailerNetworkPerformanceDocument = gql`
    query retailerNetworkPerformance($filter: RetailerNetworkPerformanceFilter!) {
  retailerNetworkPerformance(filter: $filter) {
    ...retailerNetworkPerformance
  }
}
    ${RetailerNetworkPerformanceFragmentDoc}`;

/**
 * __useRetailerNetworkPerformanceQuery__
 *
 * To run a query within a React component, call `useRetailerNetworkPerformanceQuery` and pass it any options that fit your needs.
 * When your component renders, `useRetailerNetworkPerformanceQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useRetailerNetworkPerformanceQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useRetailerNetworkPerformanceQuery(baseOptions: Apollo.QueryHookOptions<RetailerNetworkPerformanceQuery, RetailerNetworkPerformanceQueryVariables> & ({ variables: RetailerNetworkPerformanceQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<RetailerNetworkPerformanceQuery, RetailerNetworkPerformanceQueryVariables>(RetailerNetworkPerformanceDocument, options);
      }
export function useRetailerNetworkPerformanceLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<RetailerNetworkPerformanceQuery, RetailerNetworkPerformanceQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<RetailerNetworkPerformanceQuery, RetailerNetworkPerformanceQueryVariables>(RetailerNetworkPerformanceDocument, options);
        }
export function useRetailerNetworkPerformanceSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<RetailerNetworkPerformanceQuery, RetailerNetworkPerformanceQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<RetailerNetworkPerformanceQuery, RetailerNetworkPerformanceQueryVariables>(RetailerNetworkPerformanceDocument, options);
        }
export type RetailerNetworkPerformanceQueryHookResult = ReturnType<typeof useRetailerNetworkPerformanceQuery>;
export type RetailerNetworkPerformanceLazyQueryHookResult = ReturnType<typeof useRetailerNetworkPerformanceLazyQuery>;
export type RetailerNetworkPerformanceSuspenseQueryHookResult = ReturnType<typeof useRetailerNetworkPerformanceSuspenseQuery>;
export type RetailerNetworkPerformanceQueryResult = Apollo.QueryResult<RetailerNetworkPerformanceQuery, RetailerNetworkPerformanceQueryVariables>;
export const RetailerNetworkLocationDowntimeMetricsDocument = gql`
    query retailerNetworkLocationDowntimeMetrics($filter: RetailerNetworkLocationDowntimeMetricsFilter!) {
  retailerNetworkLocationDowntimeMetrics(filter: $filter) {
    ...timeSeriesMetric
  }
}
    ${TimeSeriesMetricFragmentDoc}`;

/**
 * __useRetailerNetworkLocationDowntimeMetricsQuery__
 *
 * To run a query within a React component, call `useRetailerNetworkLocationDowntimeMetricsQuery` and pass it any options that fit your needs.
 * When your component renders, `useRetailerNetworkLocationDowntimeMetricsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useRetailerNetworkLocationDowntimeMetricsQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useRetailerNetworkLocationDowntimeMetricsQuery(baseOptions: Apollo.QueryHookOptions<RetailerNetworkLocationDowntimeMetricsQuery, RetailerNetworkLocationDowntimeMetricsQueryVariables> & ({ variables: RetailerNetworkLocationDowntimeMetricsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<RetailerNetworkLocationDowntimeMetricsQuery, RetailerNetworkLocationDowntimeMetricsQueryVariables>(RetailerNetworkLocationDowntimeMetricsDocument, options);
      }
export function useRetailerNetworkLocationDowntimeMetricsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<RetailerNetworkLocationDowntimeMetricsQuery, RetailerNetworkLocationDowntimeMetricsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<RetailerNetworkLocationDowntimeMetricsQuery, RetailerNetworkLocationDowntimeMetricsQueryVariables>(RetailerNetworkLocationDowntimeMetricsDocument, options);
        }
export function useRetailerNetworkLocationDowntimeMetricsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<RetailerNetworkLocationDowntimeMetricsQuery, RetailerNetworkLocationDowntimeMetricsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<RetailerNetworkLocationDowntimeMetricsQuery, RetailerNetworkLocationDowntimeMetricsQueryVariables>(RetailerNetworkLocationDowntimeMetricsDocument, options);
        }
export type RetailerNetworkLocationDowntimeMetricsQueryHookResult = ReturnType<typeof useRetailerNetworkLocationDowntimeMetricsQuery>;
export type RetailerNetworkLocationDowntimeMetricsLazyQueryHookResult = ReturnType<typeof useRetailerNetworkLocationDowntimeMetricsLazyQuery>;
export type RetailerNetworkLocationDowntimeMetricsSuspenseQueryHookResult = ReturnType<typeof useRetailerNetworkLocationDowntimeMetricsSuspenseQuery>;
export type RetailerNetworkLocationDowntimeMetricsQueryResult = Apollo.QueryResult<RetailerNetworkLocationDowntimeMetricsQuery, RetailerNetworkLocationDowntimeMetricsQueryVariables>;
export const RetailerNetworkLocationDowntimeMetricsOverviewDocument = gql`
    query retailerNetworkLocationDowntimeMetricsOverview($filter: RetailerNetworkLocationDowntimeMetricsOverviewFilter!) {
  retailerNetworkLocationDowntimeMetricsOverview(filter: $filter) {
    ...retailerNetworkLocationDowntimeMetricsOverview
  }
}
    ${RetailerNetworkLocationDowntimeMetricsOverviewFragmentDoc}`;

/**
 * __useRetailerNetworkLocationDowntimeMetricsOverviewQuery__
 *
 * To run a query within a React component, call `useRetailerNetworkLocationDowntimeMetricsOverviewQuery` and pass it any options that fit your needs.
 * When your component renders, `useRetailerNetworkLocationDowntimeMetricsOverviewQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useRetailerNetworkLocationDowntimeMetricsOverviewQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useRetailerNetworkLocationDowntimeMetricsOverviewQuery(baseOptions: Apollo.QueryHookOptions<RetailerNetworkLocationDowntimeMetricsOverviewQuery, RetailerNetworkLocationDowntimeMetricsOverviewQueryVariables> & ({ variables: RetailerNetworkLocationDowntimeMetricsOverviewQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<RetailerNetworkLocationDowntimeMetricsOverviewQuery, RetailerNetworkLocationDowntimeMetricsOverviewQueryVariables>(RetailerNetworkLocationDowntimeMetricsOverviewDocument, options);
      }
export function useRetailerNetworkLocationDowntimeMetricsOverviewLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<RetailerNetworkLocationDowntimeMetricsOverviewQuery, RetailerNetworkLocationDowntimeMetricsOverviewQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<RetailerNetworkLocationDowntimeMetricsOverviewQuery, RetailerNetworkLocationDowntimeMetricsOverviewQueryVariables>(RetailerNetworkLocationDowntimeMetricsOverviewDocument, options);
        }
export function useRetailerNetworkLocationDowntimeMetricsOverviewSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<RetailerNetworkLocationDowntimeMetricsOverviewQuery, RetailerNetworkLocationDowntimeMetricsOverviewQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<RetailerNetworkLocationDowntimeMetricsOverviewQuery, RetailerNetworkLocationDowntimeMetricsOverviewQueryVariables>(RetailerNetworkLocationDowntimeMetricsOverviewDocument, options);
        }
export type RetailerNetworkLocationDowntimeMetricsOverviewQueryHookResult = ReturnType<typeof useRetailerNetworkLocationDowntimeMetricsOverviewQuery>;
export type RetailerNetworkLocationDowntimeMetricsOverviewLazyQueryHookResult = ReturnType<typeof useRetailerNetworkLocationDowntimeMetricsOverviewLazyQuery>;
export type RetailerNetworkLocationDowntimeMetricsOverviewSuspenseQueryHookResult = ReturnType<typeof useRetailerNetworkLocationDowntimeMetricsOverviewSuspenseQuery>;
export type RetailerNetworkLocationDowntimeMetricsOverviewQueryResult = Apollo.QueryResult<RetailerNetworkLocationDowntimeMetricsOverviewQuery, RetailerNetworkLocationDowntimeMetricsOverviewQueryVariables>;
export const RetailerNetworkLocationGroupOnlineStatusDocument = gql`
    query retailerNetworkLocationGroupOnlineStatus($filter: RetailerNetworkLocationDowntimeMetricsOverviewFilter!) {
  retailerNetworkLocationDowntimeMetricsOverview(filter: $filter) {
    ...retailerNetworkLocationGroupOnlineStatus
  }
}
    ${RetailerNetworkLocationGroupOnlineStatusFragmentDoc}`;

/**
 * __useRetailerNetworkLocationGroupOnlineStatusQuery__
 *
 * To run a query within a React component, call `useRetailerNetworkLocationGroupOnlineStatusQuery` and pass it any options that fit your needs.
 * When your component renders, `useRetailerNetworkLocationGroupOnlineStatusQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useRetailerNetworkLocationGroupOnlineStatusQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useRetailerNetworkLocationGroupOnlineStatusQuery(baseOptions: Apollo.QueryHookOptions<RetailerNetworkLocationGroupOnlineStatusQuery, RetailerNetworkLocationGroupOnlineStatusQueryVariables> & ({ variables: RetailerNetworkLocationGroupOnlineStatusQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<RetailerNetworkLocationGroupOnlineStatusQuery, RetailerNetworkLocationGroupOnlineStatusQueryVariables>(RetailerNetworkLocationGroupOnlineStatusDocument, options);
      }
export function useRetailerNetworkLocationGroupOnlineStatusLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<RetailerNetworkLocationGroupOnlineStatusQuery, RetailerNetworkLocationGroupOnlineStatusQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<RetailerNetworkLocationGroupOnlineStatusQuery, RetailerNetworkLocationGroupOnlineStatusQueryVariables>(RetailerNetworkLocationGroupOnlineStatusDocument, options);
        }
export function useRetailerNetworkLocationGroupOnlineStatusSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<RetailerNetworkLocationGroupOnlineStatusQuery, RetailerNetworkLocationGroupOnlineStatusQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<RetailerNetworkLocationGroupOnlineStatusQuery, RetailerNetworkLocationGroupOnlineStatusQueryVariables>(RetailerNetworkLocationGroupOnlineStatusDocument, options);
        }
export type RetailerNetworkLocationGroupOnlineStatusQueryHookResult = ReturnType<typeof useRetailerNetworkLocationGroupOnlineStatusQuery>;
export type RetailerNetworkLocationGroupOnlineStatusLazyQueryHookResult = ReturnType<typeof useRetailerNetworkLocationGroupOnlineStatusLazyQuery>;
export type RetailerNetworkLocationGroupOnlineStatusSuspenseQueryHookResult = ReturnType<typeof useRetailerNetworkLocationGroupOnlineStatusSuspenseQuery>;
export type RetailerNetworkLocationGroupOnlineStatusQueryResult = Apollo.QueryResult<RetailerNetworkLocationGroupOnlineStatusQuery, RetailerNetworkLocationGroupOnlineStatusQueryVariables>;
export const RetailerNetworkTransactionMetricsOverviewDocument = gql`
    query retailerNetworkTransactionMetricsOverview($filter: RetailerNetworkTransactionMetricsOverviewFilter!) {
  retailerNetworkTransactionMetricsOverview(filter: $filter) {
    ...retailerNetworkTransactionMetricsOverview
  }
}
    ${RetailerNetworkTransactionMetricsOverviewFragmentDoc}`;

/**
 * __useRetailerNetworkTransactionMetricsOverviewQuery__
 *
 * To run a query within a React component, call `useRetailerNetworkTransactionMetricsOverviewQuery` and pass it any options that fit your needs.
 * When your component renders, `useRetailerNetworkTransactionMetricsOverviewQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useRetailerNetworkTransactionMetricsOverviewQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useRetailerNetworkTransactionMetricsOverviewQuery(baseOptions: Apollo.QueryHookOptions<RetailerNetworkTransactionMetricsOverviewQuery, RetailerNetworkTransactionMetricsOverviewQueryVariables> & ({ variables: RetailerNetworkTransactionMetricsOverviewQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<RetailerNetworkTransactionMetricsOverviewQuery, RetailerNetworkTransactionMetricsOverviewQueryVariables>(RetailerNetworkTransactionMetricsOverviewDocument, options);
      }
export function useRetailerNetworkTransactionMetricsOverviewLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<RetailerNetworkTransactionMetricsOverviewQuery, RetailerNetworkTransactionMetricsOverviewQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<RetailerNetworkTransactionMetricsOverviewQuery, RetailerNetworkTransactionMetricsOverviewQueryVariables>(RetailerNetworkTransactionMetricsOverviewDocument, options);
        }
export function useRetailerNetworkTransactionMetricsOverviewSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<RetailerNetworkTransactionMetricsOverviewQuery, RetailerNetworkTransactionMetricsOverviewQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<RetailerNetworkTransactionMetricsOverviewQuery, RetailerNetworkTransactionMetricsOverviewQueryVariables>(RetailerNetworkTransactionMetricsOverviewDocument, options);
        }
export type RetailerNetworkTransactionMetricsOverviewQueryHookResult = ReturnType<typeof useRetailerNetworkTransactionMetricsOverviewQuery>;
export type RetailerNetworkTransactionMetricsOverviewLazyQueryHookResult = ReturnType<typeof useRetailerNetworkTransactionMetricsOverviewLazyQuery>;
export type RetailerNetworkTransactionMetricsOverviewSuspenseQueryHookResult = ReturnType<typeof useRetailerNetworkTransactionMetricsOverviewSuspenseQuery>;
export type RetailerNetworkTransactionMetricsOverviewQueryResult = Apollo.QueryResult<RetailerNetworkTransactionMetricsOverviewQuery, RetailerNetworkTransactionMetricsOverviewQueryVariables>;
export const RetailerNetworkScanDataLatestSubmissionsDocument = gql`
    query retailerNetworkScanDataLatestSubmissions($first: Int, $last: Int, $after: OCBase64Cursor, $before: OCBase64Cursor, $filter: RetailerNetworkScanDataWeeklySubmissionFilter!) {
  retailerNetworkScanDataWeeklySubmissions(
    first: $first
    last: $last
    after: $after
    before: $before
    filter: $filter
  ) {
    edges {
      node {
        ...RetailerNetworkScanDataLatestSubmissions
      }
    }
  }
}
    ${RetailerNetworkScanDataLatestSubmissionsFragmentDoc}`;

/**
 * __useRetailerNetworkScanDataLatestSubmissionsQuery__
 *
 * To run a query within a React component, call `useRetailerNetworkScanDataLatestSubmissionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useRetailerNetworkScanDataLatestSubmissionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useRetailerNetworkScanDataLatestSubmissionsQuery({
 *   variables: {
 *      first: // value for 'first'
 *      last: // value for 'last'
 *      after: // value for 'after'
 *      before: // value for 'before'
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useRetailerNetworkScanDataLatestSubmissionsQuery(baseOptions: Apollo.QueryHookOptions<RetailerNetworkScanDataLatestSubmissionsQuery, RetailerNetworkScanDataLatestSubmissionsQueryVariables> & ({ variables: RetailerNetworkScanDataLatestSubmissionsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<RetailerNetworkScanDataLatestSubmissionsQuery, RetailerNetworkScanDataLatestSubmissionsQueryVariables>(RetailerNetworkScanDataLatestSubmissionsDocument, options);
      }
export function useRetailerNetworkScanDataLatestSubmissionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<RetailerNetworkScanDataLatestSubmissionsQuery, RetailerNetworkScanDataLatestSubmissionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<RetailerNetworkScanDataLatestSubmissionsQuery, RetailerNetworkScanDataLatestSubmissionsQueryVariables>(RetailerNetworkScanDataLatestSubmissionsDocument, options);
        }
export function useRetailerNetworkScanDataLatestSubmissionsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<RetailerNetworkScanDataLatestSubmissionsQuery, RetailerNetworkScanDataLatestSubmissionsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<RetailerNetworkScanDataLatestSubmissionsQuery, RetailerNetworkScanDataLatestSubmissionsQueryVariables>(RetailerNetworkScanDataLatestSubmissionsDocument, options);
        }
export type RetailerNetworkScanDataLatestSubmissionsQueryHookResult = ReturnType<typeof useRetailerNetworkScanDataLatestSubmissionsQuery>;
export type RetailerNetworkScanDataLatestSubmissionsLazyQueryHookResult = ReturnType<typeof useRetailerNetworkScanDataLatestSubmissionsLazyQuery>;
export type RetailerNetworkScanDataLatestSubmissionsSuspenseQueryHookResult = ReturnType<typeof useRetailerNetworkScanDataLatestSubmissionsSuspenseQuery>;
export type RetailerNetworkScanDataLatestSubmissionsQueryResult = Apollo.QueryResult<RetailerNetworkScanDataLatestSubmissionsQuery, RetailerNetworkScanDataLatestSubmissionsQueryVariables>;
export const RetailerNetworkScanDataSubmissionsDocument = gql`
    query retailerNetworkScanDataSubmissions($first: Int, $last: Int, $after: OCBase64Cursor, $before: OCBase64Cursor, $filter: RetailerNetworkScanDataWeeklySubmissionFilter!) {
  retailerNetworkScanDataWeeklySubmissions(
    first: $first
    last: $last
    after: $after
    before: $before
    filter: $filter
  ) {
    pageInfo {
      ...pageInfo
    }
    edges {
      node {
        ...RetailerNetworkScanDataSubmissions
      }
    }
  }
}
    ${PageInfoFragmentDoc}
${RetailerNetworkScanDataSubmissionsFragmentDoc}`;

/**
 * __useRetailerNetworkScanDataSubmissionsQuery__
 *
 * To run a query within a React component, call `useRetailerNetworkScanDataSubmissionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useRetailerNetworkScanDataSubmissionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useRetailerNetworkScanDataSubmissionsQuery({
 *   variables: {
 *      first: // value for 'first'
 *      last: // value for 'last'
 *      after: // value for 'after'
 *      before: // value for 'before'
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useRetailerNetworkScanDataSubmissionsQuery(baseOptions: Apollo.QueryHookOptions<RetailerNetworkScanDataSubmissionsQuery, RetailerNetworkScanDataSubmissionsQueryVariables> & ({ variables: RetailerNetworkScanDataSubmissionsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<RetailerNetworkScanDataSubmissionsQuery, RetailerNetworkScanDataSubmissionsQueryVariables>(RetailerNetworkScanDataSubmissionsDocument, options);
      }
export function useRetailerNetworkScanDataSubmissionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<RetailerNetworkScanDataSubmissionsQuery, RetailerNetworkScanDataSubmissionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<RetailerNetworkScanDataSubmissionsQuery, RetailerNetworkScanDataSubmissionsQueryVariables>(RetailerNetworkScanDataSubmissionsDocument, options);
        }
export function useRetailerNetworkScanDataSubmissionsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<RetailerNetworkScanDataSubmissionsQuery, RetailerNetworkScanDataSubmissionsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<RetailerNetworkScanDataSubmissionsQuery, RetailerNetworkScanDataSubmissionsQueryVariables>(RetailerNetworkScanDataSubmissionsDocument, options);
        }
export type RetailerNetworkScanDataSubmissionsQueryHookResult = ReturnType<typeof useRetailerNetworkScanDataSubmissionsQuery>;
export type RetailerNetworkScanDataSubmissionsLazyQueryHookResult = ReturnType<typeof useRetailerNetworkScanDataSubmissionsLazyQuery>;
export type RetailerNetworkScanDataSubmissionsSuspenseQueryHookResult = ReturnType<typeof useRetailerNetworkScanDataSubmissionsSuspenseQuery>;
export type RetailerNetworkScanDataSubmissionsQueryResult = Apollo.QueryResult<RetailerNetworkScanDataSubmissionsQuery, RetailerNetworkScanDataSubmissionsQueryVariables>;
export const RetailerNetworkScanDataTobaccoSubmissionsOverviewDocument = gql`
    query retailerNetworkScanDataTobaccoSubmissionsOverview($filter: RetailerNetworkScanDataTobaccoSubmissionsOverviewFilter!) {
  retailerNetworkScanDataTobaccoSubmissionsOverview(filter: $filter) {
    ...RetailerNetworkScanDataTobaccoSubmissionsOverview
  }
}
    ${RetailerNetworkScanDataTobaccoSubmissionsOverviewFragmentDoc}`;

/**
 * __useRetailerNetworkScanDataTobaccoSubmissionsOverviewQuery__
 *
 * To run a query within a React component, call `useRetailerNetworkScanDataTobaccoSubmissionsOverviewQuery` and pass it any options that fit your needs.
 * When your component renders, `useRetailerNetworkScanDataTobaccoSubmissionsOverviewQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useRetailerNetworkScanDataTobaccoSubmissionsOverviewQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useRetailerNetworkScanDataTobaccoSubmissionsOverviewQuery(baseOptions: Apollo.QueryHookOptions<RetailerNetworkScanDataTobaccoSubmissionsOverviewQuery, RetailerNetworkScanDataTobaccoSubmissionsOverviewQueryVariables> & ({ variables: RetailerNetworkScanDataTobaccoSubmissionsOverviewQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<RetailerNetworkScanDataTobaccoSubmissionsOverviewQuery, RetailerNetworkScanDataTobaccoSubmissionsOverviewQueryVariables>(RetailerNetworkScanDataTobaccoSubmissionsOverviewDocument, options);
      }
export function useRetailerNetworkScanDataTobaccoSubmissionsOverviewLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<RetailerNetworkScanDataTobaccoSubmissionsOverviewQuery, RetailerNetworkScanDataTobaccoSubmissionsOverviewQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<RetailerNetworkScanDataTobaccoSubmissionsOverviewQuery, RetailerNetworkScanDataTobaccoSubmissionsOverviewQueryVariables>(RetailerNetworkScanDataTobaccoSubmissionsOverviewDocument, options);
        }
export function useRetailerNetworkScanDataTobaccoSubmissionsOverviewSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<RetailerNetworkScanDataTobaccoSubmissionsOverviewQuery, RetailerNetworkScanDataTobaccoSubmissionsOverviewQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<RetailerNetworkScanDataTobaccoSubmissionsOverviewQuery, RetailerNetworkScanDataTobaccoSubmissionsOverviewQueryVariables>(RetailerNetworkScanDataTobaccoSubmissionsOverviewDocument, options);
        }
export type RetailerNetworkScanDataTobaccoSubmissionsOverviewQueryHookResult = ReturnType<typeof useRetailerNetworkScanDataTobaccoSubmissionsOverviewQuery>;
export type RetailerNetworkScanDataTobaccoSubmissionsOverviewLazyQueryHookResult = ReturnType<typeof useRetailerNetworkScanDataTobaccoSubmissionsOverviewLazyQuery>;
export type RetailerNetworkScanDataTobaccoSubmissionsOverviewSuspenseQueryHookResult = ReturnType<typeof useRetailerNetworkScanDataTobaccoSubmissionsOverviewSuspenseQuery>;
export type RetailerNetworkScanDataTobaccoSubmissionsOverviewQueryResult = Apollo.QueryResult<RetailerNetworkScanDataTobaccoSubmissionsOverviewQuery, RetailerNetworkScanDataTobaccoSubmissionsOverviewQueryVariables>;
export const RetailerNetworkScanDataTobaccoSiteSubmissionsDocument = gql`
    query retailerNetworkScanDataTobaccoSiteSubmissions($first: Int, $last: Int, $after: OCBase64Cursor, $before: OCBase64Cursor, $filter: RetailerNetworkScanDataTobaccoSiteSubmissionFilter!) {
  retailerNetworkScanDataTobaccoSiteSubmissions(
    first: $first
    last: $last
    after: $after
    before: $before
    filter: $filter
  ) {
    pageInfo {
      ...pageInfo
    }
    edges {
      node {
        ...RetailerNetworkScanDataTobaccoSiteSubmissions
      }
    }
  }
}
    ${PageInfoFragmentDoc}
${RetailerNetworkScanDataTobaccoSiteSubmissionsFragmentDoc}`;

/**
 * __useRetailerNetworkScanDataTobaccoSiteSubmissionsQuery__
 *
 * To run a query within a React component, call `useRetailerNetworkScanDataTobaccoSiteSubmissionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useRetailerNetworkScanDataTobaccoSiteSubmissionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useRetailerNetworkScanDataTobaccoSiteSubmissionsQuery({
 *   variables: {
 *      first: // value for 'first'
 *      last: // value for 'last'
 *      after: // value for 'after'
 *      before: // value for 'before'
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useRetailerNetworkScanDataTobaccoSiteSubmissionsQuery(baseOptions: Apollo.QueryHookOptions<RetailerNetworkScanDataTobaccoSiteSubmissionsQuery, RetailerNetworkScanDataTobaccoSiteSubmissionsQueryVariables> & ({ variables: RetailerNetworkScanDataTobaccoSiteSubmissionsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<RetailerNetworkScanDataTobaccoSiteSubmissionsQuery, RetailerNetworkScanDataTobaccoSiteSubmissionsQueryVariables>(RetailerNetworkScanDataTobaccoSiteSubmissionsDocument, options);
      }
export function useRetailerNetworkScanDataTobaccoSiteSubmissionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<RetailerNetworkScanDataTobaccoSiteSubmissionsQuery, RetailerNetworkScanDataTobaccoSiteSubmissionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<RetailerNetworkScanDataTobaccoSiteSubmissionsQuery, RetailerNetworkScanDataTobaccoSiteSubmissionsQueryVariables>(RetailerNetworkScanDataTobaccoSiteSubmissionsDocument, options);
        }
export function useRetailerNetworkScanDataTobaccoSiteSubmissionsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<RetailerNetworkScanDataTobaccoSiteSubmissionsQuery, RetailerNetworkScanDataTobaccoSiteSubmissionsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<RetailerNetworkScanDataTobaccoSiteSubmissionsQuery, RetailerNetworkScanDataTobaccoSiteSubmissionsQueryVariables>(RetailerNetworkScanDataTobaccoSiteSubmissionsDocument, options);
        }
export type RetailerNetworkScanDataTobaccoSiteSubmissionsQueryHookResult = ReturnType<typeof useRetailerNetworkScanDataTobaccoSiteSubmissionsQuery>;
export type RetailerNetworkScanDataTobaccoSiteSubmissionsLazyQueryHookResult = ReturnType<typeof useRetailerNetworkScanDataTobaccoSiteSubmissionsLazyQuery>;
export type RetailerNetworkScanDataTobaccoSiteSubmissionsSuspenseQueryHookResult = ReturnType<typeof useRetailerNetworkScanDataTobaccoSiteSubmissionsSuspenseQuery>;
export type RetailerNetworkScanDataTobaccoSiteSubmissionsQueryResult = Apollo.QueryResult<RetailerNetworkScanDataTobaccoSiteSubmissionsQuery, RetailerNetworkScanDataTobaccoSiteSubmissionsQueryVariables>;
export const RetailerNetworkLoyaltyMetricsOverviewDocument = gql`
    query retailerNetworkLoyaltyMetricsOverview($filter: RetailerNetworkLoyaltyMetricsFilter!) {
  retailerNetworkLoyaltyMetricsOverview(filter: $filter) {
    ...retailerNetworkLoyaltyMetricsOverview
  }
}
    ${RetailerNetworkLoyaltyMetricsOverviewFragmentDoc}`;

/**
 * __useRetailerNetworkLoyaltyMetricsOverviewQuery__
 *
 * To run a query within a React component, call `useRetailerNetworkLoyaltyMetricsOverviewQuery` and pass it any options that fit your needs.
 * When your component renders, `useRetailerNetworkLoyaltyMetricsOverviewQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useRetailerNetworkLoyaltyMetricsOverviewQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useRetailerNetworkLoyaltyMetricsOverviewQuery(baseOptions: Apollo.QueryHookOptions<RetailerNetworkLoyaltyMetricsOverviewQuery, RetailerNetworkLoyaltyMetricsOverviewQueryVariables> & ({ variables: RetailerNetworkLoyaltyMetricsOverviewQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<RetailerNetworkLoyaltyMetricsOverviewQuery, RetailerNetworkLoyaltyMetricsOverviewQueryVariables>(RetailerNetworkLoyaltyMetricsOverviewDocument, options);
      }
export function useRetailerNetworkLoyaltyMetricsOverviewLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<RetailerNetworkLoyaltyMetricsOverviewQuery, RetailerNetworkLoyaltyMetricsOverviewQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<RetailerNetworkLoyaltyMetricsOverviewQuery, RetailerNetworkLoyaltyMetricsOverviewQueryVariables>(RetailerNetworkLoyaltyMetricsOverviewDocument, options);
        }
export function useRetailerNetworkLoyaltyMetricsOverviewSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<RetailerNetworkLoyaltyMetricsOverviewQuery, RetailerNetworkLoyaltyMetricsOverviewQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<RetailerNetworkLoyaltyMetricsOverviewQuery, RetailerNetworkLoyaltyMetricsOverviewQueryVariables>(RetailerNetworkLoyaltyMetricsOverviewDocument, options);
        }
export type RetailerNetworkLoyaltyMetricsOverviewQueryHookResult = ReturnType<typeof useRetailerNetworkLoyaltyMetricsOverviewQuery>;
export type RetailerNetworkLoyaltyMetricsOverviewLazyQueryHookResult = ReturnType<typeof useRetailerNetworkLoyaltyMetricsOverviewLazyQuery>;
export type RetailerNetworkLoyaltyMetricsOverviewSuspenseQueryHookResult = ReturnType<typeof useRetailerNetworkLoyaltyMetricsOverviewSuspenseQuery>;
export type RetailerNetworkLoyaltyMetricsOverviewQueryResult = Apollo.QueryResult<RetailerNetworkLoyaltyMetricsOverviewQuery, RetailerNetworkLoyaltyMetricsOverviewQueryVariables>;
export const RetailerNetworkLocationOfferMetricsOverviewDocument = gql`
    query retailerNetworkLocationOfferMetricsOverview($first: Int, $last: Int, $after: OCBase64Cursor, $before: OCBase64Cursor, $filter: RetailerNetworkOfferMetricsOverviewFilter!, $sort: RetailerNetworkOfferMetricsOverviewSort) {
  retailerNetworkLocationOfferMetricsOverview(
    first: $first
    last: $last
    after: $after
    before: $before
    filter: $filter
    sort: $sort
  ) {
    pageInfo {
      ...pageInfo
    }
    edges {
      cursor
      node {
        ...retailerNetworkLocationOfferMetricsOverview
      }
    }
  }
}
    ${PageInfoFragmentDoc}
${RetailerNetworkLocationOfferMetricsOverviewFragmentDoc}`;

/**
 * __useRetailerNetworkLocationOfferMetricsOverviewQuery__
 *
 * To run a query within a React component, call `useRetailerNetworkLocationOfferMetricsOverviewQuery` and pass it any options that fit your needs.
 * When your component renders, `useRetailerNetworkLocationOfferMetricsOverviewQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useRetailerNetworkLocationOfferMetricsOverviewQuery({
 *   variables: {
 *      first: // value for 'first'
 *      last: // value for 'last'
 *      after: // value for 'after'
 *      before: // value for 'before'
 *      filter: // value for 'filter'
 *      sort: // value for 'sort'
 *   },
 * });
 */
export function useRetailerNetworkLocationOfferMetricsOverviewQuery(baseOptions: Apollo.QueryHookOptions<RetailerNetworkLocationOfferMetricsOverviewQuery, RetailerNetworkLocationOfferMetricsOverviewQueryVariables> & ({ variables: RetailerNetworkLocationOfferMetricsOverviewQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<RetailerNetworkLocationOfferMetricsOverviewQuery, RetailerNetworkLocationOfferMetricsOverviewQueryVariables>(RetailerNetworkLocationOfferMetricsOverviewDocument, options);
      }
export function useRetailerNetworkLocationOfferMetricsOverviewLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<RetailerNetworkLocationOfferMetricsOverviewQuery, RetailerNetworkLocationOfferMetricsOverviewQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<RetailerNetworkLocationOfferMetricsOverviewQuery, RetailerNetworkLocationOfferMetricsOverviewQueryVariables>(RetailerNetworkLocationOfferMetricsOverviewDocument, options);
        }
export function useRetailerNetworkLocationOfferMetricsOverviewSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<RetailerNetworkLocationOfferMetricsOverviewQuery, RetailerNetworkLocationOfferMetricsOverviewQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<RetailerNetworkLocationOfferMetricsOverviewQuery, RetailerNetworkLocationOfferMetricsOverviewQueryVariables>(RetailerNetworkLocationOfferMetricsOverviewDocument, options);
        }
export type RetailerNetworkLocationOfferMetricsOverviewQueryHookResult = ReturnType<typeof useRetailerNetworkLocationOfferMetricsOverviewQuery>;
export type RetailerNetworkLocationOfferMetricsOverviewLazyQueryHookResult = ReturnType<typeof useRetailerNetworkLocationOfferMetricsOverviewLazyQuery>;
export type RetailerNetworkLocationOfferMetricsOverviewSuspenseQueryHookResult = ReturnType<typeof useRetailerNetworkLocationOfferMetricsOverviewSuspenseQuery>;
export type RetailerNetworkLocationOfferMetricsOverviewQueryResult = Apollo.QueryResult<RetailerNetworkLocationOfferMetricsOverviewQuery, RetailerNetworkLocationOfferMetricsOverviewQueryVariables>;
export const RetailerNetworkTobaccoProgramMetricsOverviewDocument = gql`
    query retailerNetworkTobaccoProgramMetricsOverview($filter: RetailerNetworkTobaccoProgramOverviewFilter!) {
  retailerNetworkTobaccoProgramMetricsOverview(filter: $filter) {
    performance {
      ...RetailerNetworkTobaccoProgramPerformance
    }
    previousPerformance {
      ...RetailerNetworkTobaccoProgramPerformance
    }
    tobaccoTransactionsTimeSeries {
      date
      value
    }
  }
}
    ${RetailerNetworkTobaccoProgramPerformanceFragmentDoc}`;

/**
 * __useRetailerNetworkTobaccoProgramMetricsOverviewQuery__
 *
 * To run a query within a React component, call `useRetailerNetworkTobaccoProgramMetricsOverviewQuery` and pass it any options that fit your needs.
 * When your component renders, `useRetailerNetworkTobaccoProgramMetricsOverviewQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useRetailerNetworkTobaccoProgramMetricsOverviewQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useRetailerNetworkTobaccoProgramMetricsOverviewQuery(baseOptions: Apollo.QueryHookOptions<RetailerNetworkTobaccoProgramMetricsOverviewQuery, RetailerNetworkTobaccoProgramMetricsOverviewQueryVariables> & ({ variables: RetailerNetworkTobaccoProgramMetricsOverviewQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<RetailerNetworkTobaccoProgramMetricsOverviewQuery, RetailerNetworkTobaccoProgramMetricsOverviewQueryVariables>(RetailerNetworkTobaccoProgramMetricsOverviewDocument, options);
      }
export function useRetailerNetworkTobaccoProgramMetricsOverviewLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<RetailerNetworkTobaccoProgramMetricsOverviewQuery, RetailerNetworkTobaccoProgramMetricsOverviewQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<RetailerNetworkTobaccoProgramMetricsOverviewQuery, RetailerNetworkTobaccoProgramMetricsOverviewQueryVariables>(RetailerNetworkTobaccoProgramMetricsOverviewDocument, options);
        }
export function useRetailerNetworkTobaccoProgramMetricsOverviewSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<RetailerNetworkTobaccoProgramMetricsOverviewQuery, RetailerNetworkTobaccoProgramMetricsOverviewQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<RetailerNetworkTobaccoProgramMetricsOverviewQuery, RetailerNetworkTobaccoProgramMetricsOverviewQueryVariables>(RetailerNetworkTobaccoProgramMetricsOverviewDocument, options);
        }
export type RetailerNetworkTobaccoProgramMetricsOverviewQueryHookResult = ReturnType<typeof useRetailerNetworkTobaccoProgramMetricsOverviewQuery>;
export type RetailerNetworkTobaccoProgramMetricsOverviewLazyQueryHookResult = ReturnType<typeof useRetailerNetworkTobaccoProgramMetricsOverviewLazyQuery>;
export type RetailerNetworkTobaccoProgramMetricsOverviewSuspenseQueryHookResult = ReturnType<typeof useRetailerNetworkTobaccoProgramMetricsOverviewSuspenseQuery>;
export type RetailerNetworkTobaccoProgramMetricsOverviewQueryResult = Apollo.QueryResult<RetailerNetworkTobaccoProgramMetricsOverviewQuery, RetailerNetworkTobaccoProgramMetricsOverviewQueryVariables>;
export const RetailerNetworkTobaccoProgramMetricTimeSeriesDocument = gql`
    query retailerNetworkTobaccoProgramMetricTimeSeries($filter: RetailerNetworkTobaccoProgramMetricTimeSeriesFilter!, $metricType: RetailerNetworkTobaccoProgramMetricType!) {
  retailerNetworkTobaccoProgramMetricTimeSeries(
    filter: $filter
    metricType: $metricType
  ) {
    date
    value
  }
}
    `;

/**
 * __useRetailerNetworkTobaccoProgramMetricTimeSeriesQuery__
 *
 * To run a query within a React component, call `useRetailerNetworkTobaccoProgramMetricTimeSeriesQuery` and pass it any options that fit your needs.
 * When your component renders, `useRetailerNetworkTobaccoProgramMetricTimeSeriesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useRetailerNetworkTobaccoProgramMetricTimeSeriesQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *      metricType: // value for 'metricType'
 *   },
 * });
 */
export function useRetailerNetworkTobaccoProgramMetricTimeSeriesQuery(baseOptions: Apollo.QueryHookOptions<RetailerNetworkTobaccoProgramMetricTimeSeriesQuery, RetailerNetworkTobaccoProgramMetricTimeSeriesQueryVariables> & ({ variables: RetailerNetworkTobaccoProgramMetricTimeSeriesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<RetailerNetworkTobaccoProgramMetricTimeSeriesQuery, RetailerNetworkTobaccoProgramMetricTimeSeriesQueryVariables>(RetailerNetworkTobaccoProgramMetricTimeSeriesDocument, options);
      }
export function useRetailerNetworkTobaccoProgramMetricTimeSeriesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<RetailerNetworkTobaccoProgramMetricTimeSeriesQuery, RetailerNetworkTobaccoProgramMetricTimeSeriesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<RetailerNetworkTobaccoProgramMetricTimeSeriesQuery, RetailerNetworkTobaccoProgramMetricTimeSeriesQueryVariables>(RetailerNetworkTobaccoProgramMetricTimeSeriesDocument, options);
        }
export function useRetailerNetworkTobaccoProgramMetricTimeSeriesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<RetailerNetworkTobaccoProgramMetricTimeSeriesQuery, RetailerNetworkTobaccoProgramMetricTimeSeriesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<RetailerNetworkTobaccoProgramMetricTimeSeriesQuery, RetailerNetworkTobaccoProgramMetricTimeSeriesQueryVariables>(RetailerNetworkTobaccoProgramMetricTimeSeriesDocument, options);
        }
export type RetailerNetworkTobaccoProgramMetricTimeSeriesQueryHookResult = ReturnType<typeof useRetailerNetworkTobaccoProgramMetricTimeSeriesQuery>;
export type RetailerNetworkTobaccoProgramMetricTimeSeriesLazyQueryHookResult = ReturnType<typeof useRetailerNetworkTobaccoProgramMetricTimeSeriesLazyQuery>;
export type RetailerNetworkTobaccoProgramMetricTimeSeriesSuspenseQueryHookResult = ReturnType<typeof useRetailerNetworkTobaccoProgramMetricTimeSeriesSuspenseQuery>;
export type RetailerNetworkTobaccoProgramMetricTimeSeriesQueryResult = Apollo.QueryResult<RetailerNetworkTobaccoProgramMetricTimeSeriesQuery, RetailerNetworkTobaccoProgramMetricTimeSeriesQueryVariables>;
export const RetailerNetworkTobaccoProgramSitesMetricDocument = gql`
    query retailerNetworkTobaccoProgramSitesMetric($metricType: RetailerNetworkTobaccoProgramMetricType!, $filter: RetailerNetworkTobaccoProgramSitesMetricFilter!, $sort: RetailerNetworkTobaccoProgramSitesMetricSort!, $after: OCBase64Cursor, $before: OCBase64Cursor, $first: Int, $last: Int) {
  retailerNetworkTobaccoProgramSitesMetric(
    metricType: $metricType
    filter: $filter
    sort: $sort
    after: $after
    before: $before
    first: $first
    last: $last
  ) {
    pageInfo {
      ...pageInfo
    }
    edges {
      cursor
      node {
        ...RetailerNetworkTobaccoProgramSiteMetric
      }
    }
  }
}
    ${PageInfoFragmentDoc}
${RetailerNetworkTobaccoProgramSiteMetricFragmentDoc}`;

/**
 * __useRetailerNetworkTobaccoProgramSitesMetricQuery__
 *
 * To run a query within a React component, call `useRetailerNetworkTobaccoProgramSitesMetricQuery` and pass it any options that fit your needs.
 * When your component renders, `useRetailerNetworkTobaccoProgramSitesMetricQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useRetailerNetworkTobaccoProgramSitesMetricQuery({
 *   variables: {
 *      metricType: // value for 'metricType'
 *      filter: // value for 'filter'
 *      sort: // value for 'sort'
 *      after: // value for 'after'
 *      before: // value for 'before'
 *      first: // value for 'first'
 *      last: // value for 'last'
 *   },
 * });
 */
export function useRetailerNetworkTobaccoProgramSitesMetricQuery(baseOptions: Apollo.QueryHookOptions<RetailerNetworkTobaccoProgramSitesMetricQuery, RetailerNetworkTobaccoProgramSitesMetricQueryVariables> & ({ variables: RetailerNetworkTobaccoProgramSitesMetricQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<RetailerNetworkTobaccoProgramSitesMetricQuery, RetailerNetworkTobaccoProgramSitesMetricQueryVariables>(RetailerNetworkTobaccoProgramSitesMetricDocument, options);
      }
export function useRetailerNetworkTobaccoProgramSitesMetricLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<RetailerNetworkTobaccoProgramSitesMetricQuery, RetailerNetworkTobaccoProgramSitesMetricQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<RetailerNetworkTobaccoProgramSitesMetricQuery, RetailerNetworkTobaccoProgramSitesMetricQueryVariables>(RetailerNetworkTobaccoProgramSitesMetricDocument, options);
        }
export function useRetailerNetworkTobaccoProgramSitesMetricSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<RetailerNetworkTobaccoProgramSitesMetricQuery, RetailerNetworkTobaccoProgramSitesMetricQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<RetailerNetworkTobaccoProgramSitesMetricQuery, RetailerNetworkTobaccoProgramSitesMetricQueryVariables>(RetailerNetworkTobaccoProgramSitesMetricDocument, options);
        }
export type RetailerNetworkTobaccoProgramSitesMetricQueryHookResult = ReturnType<typeof useRetailerNetworkTobaccoProgramSitesMetricQuery>;
export type RetailerNetworkTobaccoProgramSitesMetricLazyQueryHookResult = ReturnType<typeof useRetailerNetworkTobaccoProgramSitesMetricLazyQuery>;
export type RetailerNetworkTobaccoProgramSitesMetricSuspenseQueryHookResult = ReturnType<typeof useRetailerNetworkTobaccoProgramSitesMetricSuspenseQuery>;
export type RetailerNetworkTobaccoProgramSitesMetricQueryResult = Apollo.QueryResult<RetailerNetworkTobaccoProgramSitesMetricQuery, RetailerNetworkTobaccoProgramSitesMetricQueryVariables>;
export const RetailerNetworkCpgManufacturerProgramsDocument = gql`
    query retailerNetworkCPGManufacturerPrograms($filter: RetailerNetworkCPGManufacturerProgramsFilter!) {
  retailerNetworkCPGManufacturerPrograms(filter: $filter) {
    ...CPGManufacturerProgram
  }
}
    ${CpgManufacturerProgramFragmentDoc}`;

/**
 * __useRetailerNetworkCpgManufacturerProgramsQuery__
 *
 * To run a query within a React component, call `useRetailerNetworkCpgManufacturerProgramsQuery` and pass it any options that fit your needs.
 * When your component renders, `useRetailerNetworkCpgManufacturerProgramsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useRetailerNetworkCpgManufacturerProgramsQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useRetailerNetworkCpgManufacturerProgramsQuery(baseOptions: Apollo.QueryHookOptions<RetailerNetworkCpgManufacturerProgramsQuery, RetailerNetworkCpgManufacturerProgramsQueryVariables> & ({ variables: RetailerNetworkCpgManufacturerProgramsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<RetailerNetworkCpgManufacturerProgramsQuery, RetailerNetworkCpgManufacturerProgramsQueryVariables>(RetailerNetworkCpgManufacturerProgramsDocument, options);
      }
export function useRetailerNetworkCpgManufacturerProgramsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<RetailerNetworkCpgManufacturerProgramsQuery, RetailerNetworkCpgManufacturerProgramsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<RetailerNetworkCpgManufacturerProgramsQuery, RetailerNetworkCpgManufacturerProgramsQueryVariables>(RetailerNetworkCpgManufacturerProgramsDocument, options);
        }
export function useRetailerNetworkCpgManufacturerProgramsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<RetailerNetworkCpgManufacturerProgramsQuery, RetailerNetworkCpgManufacturerProgramsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<RetailerNetworkCpgManufacturerProgramsQuery, RetailerNetworkCpgManufacturerProgramsQueryVariables>(RetailerNetworkCpgManufacturerProgramsDocument, options);
        }
export type RetailerNetworkCpgManufacturerProgramsQueryHookResult = ReturnType<typeof useRetailerNetworkCpgManufacturerProgramsQuery>;
export type RetailerNetworkCpgManufacturerProgramsLazyQueryHookResult = ReturnType<typeof useRetailerNetworkCpgManufacturerProgramsLazyQuery>;
export type RetailerNetworkCpgManufacturerProgramsSuspenseQueryHookResult = ReturnType<typeof useRetailerNetworkCpgManufacturerProgramsSuspenseQuery>;
export type RetailerNetworkCpgManufacturerProgramsQueryResult = Apollo.QueryResult<RetailerNetworkCpgManufacturerProgramsQuery, RetailerNetworkCpgManufacturerProgramsQueryVariables>;
export const RetailerNetworkTobaccoManufacturerOfferPerformanceDocument = gql`
    query retailerNetworkTobaccoManufacturerOfferPerformance($first: Int, $last: Int, $after: OCBase64Cursor, $before: OCBase64Cursor, $filter: RetailerNetworkTobaccoManufacturerOfferPerformanceFilter!) {
  retailerNetworkTobaccoManufacturerOfferPerformance(
    first: $first
    last: $last
    after: $after
    before: $before
    filter: $filter
  ) {
    pageInfo {
      ...pageInfo
    }
    edges {
      cursor
      node {
        ...RetailerNetworkTobaccoManufacturerOfferPerformance
      }
    }
  }
}
    ${PageInfoFragmentDoc}
${RetailerNetworkTobaccoManufacturerOfferPerformanceFragmentDoc}`;

/**
 * __useRetailerNetworkTobaccoManufacturerOfferPerformanceQuery__
 *
 * To run a query within a React component, call `useRetailerNetworkTobaccoManufacturerOfferPerformanceQuery` and pass it any options that fit your needs.
 * When your component renders, `useRetailerNetworkTobaccoManufacturerOfferPerformanceQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useRetailerNetworkTobaccoManufacturerOfferPerformanceQuery({
 *   variables: {
 *      first: // value for 'first'
 *      last: // value for 'last'
 *      after: // value for 'after'
 *      before: // value for 'before'
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useRetailerNetworkTobaccoManufacturerOfferPerformanceQuery(baseOptions: Apollo.QueryHookOptions<RetailerNetworkTobaccoManufacturerOfferPerformanceQuery, RetailerNetworkTobaccoManufacturerOfferPerformanceQueryVariables> & ({ variables: RetailerNetworkTobaccoManufacturerOfferPerformanceQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<RetailerNetworkTobaccoManufacturerOfferPerformanceQuery, RetailerNetworkTobaccoManufacturerOfferPerformanceQueryVariables>(RetailerNetworkTobaccoManufacturerOfferPerformanceDocument, options);
      }
export function useRetailerNetworkTobaccoManufacturerOfferPerformanceLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<RetailerNetworkTobaccoManufacturerOfferPerformanceQuery, RetailerNetworkTobaccoManufacturerOfferPerformanceQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<RetailerNetworkTobaccoManufacturerOfferPerformanceQuery, RetailerNetworkTobaccoManufacturerOfferPerformanceQueryVariables>(RetailerNetworkTobaccoManufacturerOfferPerformanceDocument, options);
        }
export function useRetailerNetworkTobaccoManufacturerOfferPerformanceSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<RetailerNetworkTobaccoManufacturerOfferPerformanceQuery, RetailerNetworkTobaccoManufacturerOfferPerformanceQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<RetailerNetworkTobaccoManufacturerOfferPerformanceQuery, RetailerNetworkTobaccoManufacturerOfferPerformanceQueryVariables>(RetailerNetworkTobaccoManufacturerOfferPerformanceDocument, options);
        }
export type RetailerNetworkTobaccoManufacturerOfferPerformanceQueryHookResult = ReturnType<typeof useRetailerNetworkTobaccoManufacturerOfferPerformanceQuery>;
export type RetailerNetworkTobaccoManufacturerOfferPerformanceLazyQueryHookResult = ReturnType<typeof useRetailerNetworkTobaccoManufacturerOfferPerformanceLazyQuery>;
export type RetailerNetworkTobaccoManufacturerOfferPerformanceSuspenseQueryHookResult = ReturnType<typeof useRetailerNetworkTobaccoManufacturerOfferPerformanceSuspenseQuery>;
export type RetailerNetworkTobaccoManufacturerOfferPerformanceQueryResult = Apollo.QueryResult<RetailerNetworkTobaccoManufacturerOfferPerformanceQuery, RetailerNetworkTobaccoManufacturerOfferPerformanceQueryVariables>;
export const ScanDataGenerateSubmissionCsvDocument = gql`
    mutation scanDataGenerateSubmissionCSV($input: ScanDataGenerateSubmissionCSVInput!) {
  scanDataGenerateSubmissionCSV(input: $input)
}
    `;
export type ScanDataGenerateSubmissionCsvMutationFn = Apollo.MutationFunction<ScanDataGenerateSubmissionCsvMutation, ScanDataGenerateSubmissionCsvMutationVariables>;

/**
 * __useScanDataGenerateSubmissionCsvMutation__
 *
 * To run a mutation, you first call `useScanDataGenerateSubmissionCsvMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useScanDataGenerateSubmissionCsvMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [scanDataGenerateSubmissionCsvMutation, { data, loading, error }] = useScanDataGenerateSubmissionCsvMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useScanDataGenerateSubmissionCsvMutation(baseOptions?: Apollo.MutationHookOptions<ScanDataGenerateSubmissionCsvMutation, ScanDataGenerateSubmissionCsvMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ScanDataGenerateSubmissionCsvMutation, ScanDataGenerateSubmissionCsvMutationVariables>(ScanDataGenerateSubmissionCsvDocument, options);
      }
export type ScanDataGenerateSubmissionCsvMutationHookResult = ReturnType<typeof useScanDataGenerateSubmissionCsvMutation>;
export type ScanDataGenerateSubmissionCsvMutationResult = Apollo.MutationResult<ScanDataGenerateSubmissionCsvMutation>;
export type ScanDataGenerateSubmissionCsvMutationOptions = Apollo.BaseMutationOptions<ScanDataGenerateSubmissionCsvMutation, ScanDataGenerateSubmissionCsvMutationVariables>;
export const ScanDataSubmitWeeklyFileDocument = gql`
    mutation scanDataSubmitWeeklyFile($input: ScanDataSumbitWeeklyFileInput!) {
  scanDataSumbitWeeklyFile(input: $input)
}
    `;
export type ScanDataSubmitWeeklyFileMutationFn = Apollo.MutationFunction<ScanDataSubmitWeeklyFileMutation, ScanDataSubmitWeeklyFileMutationVariables>;

/**
 * __useScanDataSubmitWeeklyFileMutation__
 *
 * To run a mutation, you first call `useScanDataSubmitWeeklyFileMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useScanDataSubmitWeeklyFileMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [scanDataSubmitWeeklyFileMutation, { data, loading, error }] = useScanDataSubmitWeeklyFileMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useScanDataSubmitWeeklyFileMutation(baseOptions?: Apollo.MutationHookOptions<ScanDataSubmitWeeklyFileMutation, ScanDataSubmitWeeklyFileMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ScanDataSubmitWeeklyFileMutation, ScanDataSubmitWeeklyFileMutationVariables>(ScanDataSubmitWeeklyFileDocument, options);
      }
export type ScanDataSubmitWeeklyFileMutationHookResult = ReturnType<typeof useScanDataSubmitWeeklyFileMutation>;
export type ScanDataSubmitWeeklyFileMutationResult = Apollo.MutationResult<ScanDataSubmitWeeklyFileMutation>;
export type ScanDataSubmitWeeklyFileMutationOptions = Apollo.BaseMutationOptions<ScanDataSubmitWeeklyFileMutation, ScanDataSubmitWeeklyFileMutationVariables>;
export const CreateScanDataSftpCredentialsDocument = gql`
    mutation createScanDataSftpCredentials($input: ScanDataSftpCredentialCreateInput!) {
  scanDataSftpCredentialsCreate(input: $input) {
    ...ScanDataSftpCredential
  }
}
    ${ScanDataSftpCredentialFragmentDoc}`;
export type CreateScanDataSftpCredentialsMutationFn = Apollo.MutationFunction<CreateScanDataSftpCredentialsMutation, CreateScanDataSftpCredentialsMutationVariables>;

/**
 * __useCreateScanDataSftpCredentialsMutation__
 *
 * To run a mutation, you first call `useCreateScanDataSftpCredentialsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateScanDataSftpCredentialsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createScanDataSftpCredentialsMutation, { data, loading, error }] = useCreateScanDataSftpCredentialsMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateScanDataSftpCredentialsMutation(baseOptions?: Apollo.MutationHookOptions<CreateScanDataSftpCredentialsMutation, CreateScanDataSftpCredentialsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateScanDataSftpCredentialsMutation, CreateScanDataSftpCredentialsMutationVariables>(CreateScanDataSftpCredentialsDocument, options);
      }
export type CreateScanDataSftpCredentialsMutationHookResult = ReturnType<typeof useCreateScanDataSftpCredentialsMutation>;
export type CreateScanDataSftpCredentialsMutationResult = Apollo.MutationResult<CreateScanDataSftpCredentialsMutation>;
export type CreateScanDataSftpCredentialsMutationOptions = Apollo.BaseMutationOptions<CreateScanDataSftpCredentialsMutation, CreateScanDataSftpCredentialsMutationVariables>;
export const UpdateScanDataSftpCredentialsDocument = gql`
    mutation updateScanDataSftpCredentials($input: ScanDataSftpCredentialUpdateInput!) {
  scanDataSftpCredentialsUpdate(input: $input) {
    ...ScanDataSftpCredential
  }
}
    ${ScanDataSftpCredentialFragmentDoc}`;
export type UpdateScanDataSftpCredentialsMutationFn = Apollo.MutationFunction<UpdateScanDataSftpCredentialsMutation, UpdateScanDataSftpCredentialsMutationVariables>;

/**
 * __useUpdateScanDataSftpCredentialsMutation__
 *
 * To run a mutation, you first call `useUpdateScanDataSftpCredentialsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateScanDataSftpCredentialsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateScanDataSftpCredentialsMutation, { data, loading, error }] = useUpdateScanDataSftpCredentialsMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateScanDataSftpCredentialsMutation(baseOptions?: Apollo.MutationHookOptions<UpdateScanDataSftpCredentialsMutation, UpdateScanDataSftpCredentialsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateScanDataSftpCredentialsMutation, UpdateScanDataSftpCredentialsMutationVariables>(UpdateScanDataSftpCredentialsDocument, options);
      }
export type UpdateScanDataSftpCredentialsMutationHookResult = ReturnType<typeof useUpdateScanDataSftpCredentialsMutation>;
export type UpdateScanDataSftpCredentialsMutationResult = Apollo.MutationResult<UpdateScanDataSftpCredentialsMutation>;
export type UpdateScanDataSftpCredentialsMutationOptions = Apollo.BaseMutationOptions<UpdateScanDataSftpCredentialsMutation, UpdateScanDataSftpCredentialsMutationVariables>;
export const LocationBulkSubmitterIdUpdateDocument = gql`
    mutation locationBulkSubmitterIdUpdate($input: LocationBulkSubmitterIdUpdateInput!) {
  locationBulkSubmitterIdUpdate(input: $input)
}
    `;
export type LocationBulkSubmitterIdUpdateMutationFn = Apollo.MutationFunction<LocationBulkSubmitterIdUpdateMutation, LocationBulkSubmitterIdUpdateMutationVariables>;

/**
 * __useLocationBulkSubmitterIdUpdateMutation__
 *
 * To run a mutation, you first call `useLocationBulkSubmitterIdUpdateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useLocationBulkSubmitterIdUpdateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [locationBulkSubmitterIdUpdateMutation, { data, loading, error }] = useLocationBulkSubmitterIdUpdateMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useLocationBulkSubmitterIdUpdateMutation(baseOptions?: Apollo.MutationHookOptions<LocationBulkSubmitterIdUpdateMutation, LocationBulkSubmitterIdUpdateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<LocationBulkSubmitterIdUpdateMutation, LocationBulkSubmitterIdUpdateMutationVariables>(LocationBulkSubmitterIdUpdateDocument, options);
      }
export type LocationBulkSubmitterIdUpdateMutationHookResult = ReturnType<typeof useLocationBulkSubmitterIdUpdateMutation>;
export type LocationBulkSubmitterIdUpdateMutationResult = Apollo.MutationResult<LocationBulkSubmitterIdUpdateMutation>;
export type LocationBulkSubmitterIdUpdateMutationOptions = Apollo.BaseMutationOptions<LocationBulkSubmitterIdUpdateMutation, LocationBulkSubmitterIdUpdateMutationVariables>;
export const CustomerScanDataOverviewDocument = gql`
    query customerScanDataOverview {
  customerScanDataOverview {
    ...CustomerScanDataOverview
  }
}
    ${CustomerScanDataOverviewFragmentDoc}`;

/**
 * __useCustomerScanDataOverviewQuery__
 *
 * To run a query within a React component, call `useCustomerScanDataOverviewQuery` and pass it any options that fit your needs.
 * When your component renders, `useCustomerScanDataOverviewQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCustomerScanDataOverviewQuery({
 *   variables: {
 *   },
 * });
 */
export function useCustomerScanDataOverviewQuery(baseOptions?: Apollo.QueryHookOptions<CustomerScanDataOverviewQuery, CustomerScanDataOverviewQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CustomerScanDataOverviewQuery, CustomerScanDataOverviewQueryVariables>(CustomerScanDataOverviewDocument, options);
      }
export function useCustomerScanDataOverviewLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CustomerScanDataOverviewQuery, CustomerScanDataOverviewQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CustomerScanDataOverviewQuery, CustomerScanDataOverviewQueryVariables>(CustomerScanDataOverviewDocument, options);
        }
export function useCustomerScanDataOverviewSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<CustomerScanDataOverviewQuery, CustomerScanDataOverviewQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<CustomerScanDataOverviewQuery, CustomerScanDataOverviewQueryVariables>(CustomerScanDataOverviewDocument, options);
        }
export type CustomerScanDataOverviewQueryHookResult = ReturnType<typeof useCustomerScanDataOverviewQuery>;
export type CustomerScanDataOverviewLazyQueryHookResult = ReturnType<typeof useCustomerScanDataOverviewLazyQuery>;
export type CustomerScanDataOverviewSuspenseQueryHookResult = ReturnType<typeof useCustomerScanDataOverviewSuspenseQuery>;
export type CustomerScanDataOverviewQueryResult = Apollo.QueryResult<CustomerScanDataOverviewQuery, CustomerScanDataOverviewQueryVariables>;
export const ScanDataSubmissionHealthMetricsDocument = gql`
    query scanDataSubmissionHealthMetrics($filter: ScanDataSubmissionHealthMetricsFilter!) {
  scanDataSubmissionHealthMetrics(filter: $filter) {
    ...ScanDataSubmissionHealthMetrics
  }
}
    ${ScanDataSubmissionHealthMetricsFragmentDoc}`;

/**
 * __useScanDataSubmissionHealthMetricsQuery__
 *
 * To run a query within a React component, call `useScanDataSubmissionHealthMetricsQuery` and pass it any options that fit your needs.
 * When your component renders, `useScanDataSubmissionHealthMetricsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useScanDataSubmissionHealthMetricsQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useScanDataSubmissionHealthMetricsQuery(baseOptions: Apollo.QueryHookOptions<ScanDataSubmissionHealthMetricsQuery, ScanDataSubmissionHealthMetricsQueryVariables> & ({ variables: ScanDataSubmissionHealthMetricsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ScanDataSubmissionHealthMetricsQuery, ScanDataSubmissionHealthMetricsQueryVariables>(ScanDataSubmissionHealthMetricsDocument, options);
      }
export function useScanDataSubmissionHealthMetricsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ScanDataSubmissionHealthMetricsQuery, ScanDataSubmissionHealthMetricsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ScanDataSubmissionHealthMetricsQuery, ScanDataSubmissionHealthMetricsQueryVariables>(ScanDataSubmissionHealthMetricsDocument, options);
        }
export function useScanDataSubmissionHealthMetricsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ScanDataSubmissionHealthMetricsQuery, ScanDataSubmissionHealthMetricsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ScanDataSubmissionHealthMetricsQuery, ScanDataSubmissionHealthMetricsQueryVariables>(ScanDataSubmissionHealthMetricsDocument, options);
        }
export type ScanDataSubmissionHealthMetricsQueryHookResult = ReturnType<typeof useScanDataSubmissionHealthMetricsQuery>;
export type ScanDataSubmissionHealthMetricsLazyQueryHookResult = ReturnType<typeof useScanDataSubmissionHealthMetricsLazyQuery>;
export type ScanDataSubmissionHealthMetricsSuspenseQueryHookResult = ReturnType<typeof useScanDataSubmissionHealthMetricsSuspenseQuery>;
export type ScanDataSubmissionHealthMetricsQueryResult = Apollo.QueryResult<ScanDataSubmissionHealthMetricsQuery, ScanDataSubmissionHealthMetricsQueryVariables>;
export const GetScanDataSubmissionsDocument = gql`
    query getScanDataSubmissions($after: OCBase64Cursor, $before: OCBase64Cursor, $filter: ScanDataSubmissionFilter, $first: Int, $last: Int) {
  scanDataSubmissions(
    after: $after
    before: $before
    filter: $filter
    first: $first
    last: $last
  ) {
    edges {
      node {
        ...ScanDataSubmissions
      }
      cursor
    }
    pageInfo {
      ...pageInfo
    }
  }
}
    ${ScanDataSubmissionsFragmentDoc}
${PageInfoFragmentDoc}`;

/**
 * __useGetScanDataSubmissionsQuery__
 *
 * To run a query within a React component, call `useGetScanDataSubmissionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetScanDataSubmissionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetScanDataSubmissionsQuery({
 *   variables: {
 *      after: // value for 'after'
 *      before: // value for 'before'
 *      filter: // value for 'filter'
 *      first: // value for 'first'
 *      last: // value for 'last'
 *   },
 * });
 */
export function useGetScanDataSubmissionsQuery(baseOptions?: Apollo.QueryHookOptions<GetScanDataSubmissionsQuery, GetScanDataSubmissionsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetScanDataSubmissionsQuery, GetScanDataSubmissionsQueryVariables>(GetScanDataSubmissionsDocument, options);
      }
export function useGetScanDataSubmissionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetScanDataSubmissionsQuery, GetScanDataSubmissionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetScanDataSubmissionsQuery, GetScanDataSubmissionsQueryVariables>(GetScanDataSubmissionsDocument, options);
        }
export function useGetScanDataSubmissionsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetScanDataSubmissionsQuery, GetScanDataSubmissionsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetScanDataSubmissionsQuery, GetScanDataSubmissionsQueryVariables>(GetScanDataSubmissionsDocument, options);
        }
export type GetScanDataSubmissionsQueryHookResult = ReturnType<typeof useGetScanDataSubmissionsQuery>;
export type GetScanDataSubmissionsLazyQueryHookResult = ReturnType<typeof useGetScanDataSubmissionsLazyQuery>;
export type GetScanDataSubmissionsSuspenseQueryHookResult = ReturnType<typeof useGetScanDataSubmissionsSuspenseQuery>;
export type GetScanDataSubmissionsQueryResult = Apollo.QueryResult<GetScanDataSubmissionsQuery, GetScanDataSubmissionsQueryVariables>;
export const GetScanDataSftpCredentialsOverviewDocument = gql`
    query getScanDataSftpCredentialsOverview {
  scanDataSftpCredentialsOverview {
    ...scanDataSftpCredentialsOverview
  }
}
    ${ScanDataSftpCredentialsOverviewFragmentDoc}`;

/**
 * __useGetScanDataSftpCredentialsOverviewQuery__
 *
 * To run a query within a React component, call `useGetScanDataSftpCredentialsOverviewQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetScanDataSftpCredentialsOverviewQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetScanDataSftpCredentialsOverviewQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetScanDataSftpCredentialsOverviewQuery(baseOptions?: Apollo.QueryHookOptions<GetScanDataSftpCredentialsOverviewQuery, GetScanDataSftpCredentialsOverviewQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetScanDataSftpCredentialsOverviewQuery, GetScanDataSftpCredentialsOverviewQueryVariables>(GetScanDataSftpCredentialsOverviewDocument, options);
      }
export function useGetScanDataSftpCredentialsOverviewLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetScanDataSftpCredentialsOverviewQuery, GetScanDataSftpCredentialsOverviewQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetScanDataSftpCredentialsOverviewQuery, GetScanDataSftpCredentialsOverviewQueryVariables>(GetScanDataSftpCredentialsOverviewDocument, options);
        }
export function useGetScanDataSftpCredentialsOverviewSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetScanDataSftpCredentialsOverviewQuery, GetScanDataSftpCredentialsOverviewQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetScanDataSftpCredentialsOverviewQuery, GetScanDataSftpCredentialsOverviewQueryVariables>(GetScanDataSftpCredentialsOverviewDocument, options);
        }
export type GetScanDataSftpCredentialsOverviewQueryHookResult = ReturnType<typeof useGetScanDataSftpCredentialsOverviewQuery>;
export type GetScanDataSftpCredentialsOverviewLazyQueryHookResult = ReturnType<typeof useGetScanDataSftpCredentialsOverviewLazyQuery>;
export type GetScanDataSftpCredentialsOverviewSuspenseQueryHookResult = ReturnType<typeof useGetScanDataSftpCredentialsOverviewSuspenseQuery>;
export type GetScanDataSftpCredentialsOverviewQueryResult = Apollo.QueryResult<GetScanDataSftpCredentialsOverviewQuery, GetScanDataSftpCredentialsOverviewQueryVariables>;
export const ScanDataWeekEndingOverviewDocument = gql`
    query scanDataWeekEndingOverview($filter: ScanDataWeekEndingOverviewFilter) {
  scanDataWeekEndingOverview(filter: $filter) {
    ...ScanDataWeekEndingOverview
  }
}
    ${ScanDataWeekEndingOverviewFragmentDoc}`;

/**
 * __useScanDataWeekEndingOverviewQuery__
 *
 * To run a query within a React component, call `useScanDataWeekEndingOverviewQuery` and pass it any options that fit your needs.
 * When your component renders, `useScanDataWeekEndingOverviewQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useScanDataWeekEndingOverviewQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useScanDataWeekEndingOverviewQuery(baseOptions?: Apollo.QueryHookOptions<ScanDataWeekEndingOverviewQuery, ScanDataWeekEndingOverviewQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ScanDataWeekEndingOverviewQuery, ScanDataWeekEndingOverviewQueryVariables>(ScanDataWeekEndingOverviewDocument, options);
      }
export function useScanDataWeekEndingOverviewLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ScanDataWeekEndingOverviewQuery, ScanDataWeekEndingOverviewQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ScanDataWeekEndingOverviewQuery, ScanDataWeekEndingOverviewQueryVariables>(ScanDataWeekEndingOverviewDocument, options);
        }
export function useScanDataWeekEndingOverviewSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ScanDataWeekEndingOverviewQuery, ScanDataWeekEndingOverviewQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ScanDataWeekEndingOverviewQuery, ScanDataWeekEndingOverviewQueryVariables>(ScanDataWeekEndingOverviewDocument, options);
        }
export type ScanDataWeekEndingOverviewQueryHookResult = ReturnType<typeof useScanDataWeekEndingOverviewQuery>;
export type ScanDataWeekEndingOverviewLazyQueryHookResult = ReturnType<typeof useScanDataWeekEndingOverviewLazyQuery>;
export type ScanDataWeekEndingOverviewSuspenseQueryHookResult = ReturnType<typeof useScanDataWeekEndingOverviewSuspenseQuery>;
export type ScanDataWeekEndingOverviewQueryResult = Apollo.QueryResult<ScanDataWeekEndingOverviewQuery, ScanDataWeekEndingOverviewQueryVariables>;
export const ScanDataMetricsTimeSeriesDocument = gql`
    query scanDataMetricsTimeSeries($filter: ScanDataMetricsTimeSeriesFilter!) {
  scanDataMetricsTimeSeries(filter: $filter) {
    ...ScanDataMetricsTimeSeries
  }
}
    ${ScanDataMetricsTimeSeriesFragmentDoc}`;

/**
 * __useScanDataMetricsTimeSeriesQuery__
 *
 * To run a query within a React component, call `useScanDataMetricsTimeSeriesQuery` and pass it any options that fit your needs.
 * When your component renders, `useScanDataMetricsTimeSeriesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useScanDataMetricsTimeSeriesQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useScanDataMetricsTimeSeriesQuery(baseOptions: Apollo.QueryHookOptions<ScanDataMetricsTimeSeriesQuery, ScanDataMetricsTimeSeriesQueryVariables> & ({ variables: ScanDataMetricsTimeSeriesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ScanDataMetricsTimeSeriesQuery, ScanDataMetricsTimeSeriesQueryVariables>(ScanDataMetricsTimeSeriesDocument, options);
      }
export function useScanDataMetricsTimeSeriesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ScanDataMetricsTimeSeriesQuery, ScanDataMetricsTimeSeriesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ScanDataMetricsTimeSeriesQuery, ScanDataMetricsTimeSeriesQueryVariables>(ScanDataMetricsTimeSeriesDocument, options);
        }
export function useScanDataMetricsTimeSeriesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ScanDataMetricsTimeSeriesQuery, ScanDataMetricsTimeSeriesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ScanDataMetricsTimeSeriesQuery, ScanDataMetricsTimeSeriesQueryVariables>(ScanDataMetricsTimeSeriesDocument, options);
        }
export type ScanDataMetricsTimeSeriesQueryHookResult = ReturnType<typeof useScanDataMetricsTimeSeriesQuery>;
export type ScanDataMetricsTimeSeriesLazyQueryHookResult = ReturnType<typeof useScanDataMetricsTimeSeriesLazyQuery>;
export type ScanDataMetricsTimeSeriesSuspenseQueryHookResult = ReturnType<typeof useScanDataMetricsTimeSeriesSuspenseQuery>;
export type ScanDataMetricsTimeSeriesQueryResult = Apollo.QueryResult<ScanDataMetricsTimeSeriesQuery, ScanDataMetricsTimeSeriesQueryVariables>;
export const ScanDataSubmittedTransactionsStoreLevelDetailsDocument = gql`
    query scanDataSubmittedTransactionsStoreLevelDetails($filter: ScanDataSubmittedTransactionsStoreLevelDetailsFilter!, $first: Int, $after: OCBase64Cursor, $last: Int, $before: OCBase64Cursor) {
  scanDataSubmittedTransactionsStoreLevelDetails(
    filter: $filter
    first: $first
    last: $last
    after: $after
    before: $before
  ) {
    pageInfo {
      ...pageInfo
    }
    edges {
      cursor
      node {
        ...ScanDataSubmittedTransactionsStoreLevelDetails
      }
    }
  }
}
    ${PageInfoFragmentDoc}
${ScanDataSubmittedTransactionsStoreLevelDetailsFragmentDoc}`;

/**
 * __useScanDataSubmittedTransactionsStoreLevelDetailsQuery__
 *
 * To run a query within a React component, call `useScanDataSubmittedTransactionsStoreLevelDetailsQuery` and pass it any options that fit your needs.
 * When your component renders, `useScanDataSubmittedTransactionsStoreLevelDetailsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useScanDataSubmittedTransactionsStoreLevelDetailsQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *      first: // value for 'first'
 *      after: // value for 'after'
 *      last: // value for 'last'
 *      before: // value for 'before'
 *   },
 * });
 */
export function useScanDataSubmittedTransactionsStoreLevelDetailsQuery(baseOptions: Apollo.QueryHookOptions<ScanDataSubmittedTransactionsStoreLevelDetailsQuery, ScanDataSubmittedTransactionsStoreLevelDetailsQueryVariables> & ({ variables: ScanDataSubmittedTransactionsStoreLevelDetailsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ScanDataSubmittedTransactionsStoreLevelDetailsQuery, ScanDataSubmittedTransactionsStoreLevelDetailsQueryVariables>(ScanDataSubmittedTransactionsStoreLevelDetailsDocument, options);
      }
export function useScanDataSubmittedTransactionsStoreLevelDetailsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ScanDataSubmittedTransactionsStoreLevelDetailsQuery, ScanDataSubmittedTransactionsStoreLevelDetailsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ScanDataSubmittedTransactionsStoreLevelDetailsQuery, ScanDataSubmittedTransactionsStoreLevelDetailsQueryVariables>(ScanDataSubmittedTransactionsStoreLevelDetailsDocument, options);
        }
export function useScanDataSubmittedTransactionsStoreLevelDetailsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ScanDataSubmittedTransactionsStoreLevelDetailsQuery, ScanDataSubmittedTransactionsStoreLevelDetailsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ScanDataSubmittedTransactionsStoreLevelDetailsQuery, ScanDataSubmittedTransactionsStoreLevelDetailsQueryVariables>(ScanDataSubmittedTransactionsStoreLevelDetailsDocument, options);
        }
export type ScanDataSubmittedTransactionsStoreLevelDetailsQueryHookResult = ReturnType<typeof useScanDataSubmittedTransactionsStoreLevelDetailsQuery>;
export type ScanDataSubmittedTransactionsStoreLevelDetailsLazyQueryHookResult = ReturnType<typeof useScanDataSubmittedTransactionsStoreLevelDetailsLazyQuery>;
export type ScanDataSubmittedTransactionsStoreLevelDetailsSuspenseQueryHookResult = ReturnType<typeof useScanDataSubmittedTransactionsStoreLevelDetailsSuspenseQuery>;
export type ScanDataSubmittedTransactionsStoreLevelDetailsQueryResult = Apollo.QueryResult<ScanDataSubmittedTransactionsStoreLevelDetailsQuery, ScanDataSubmittedTransactionsStoreLevelDetailsQueryVariables>;
export const ScanDataMissingStoresStoreLevelDetailsDocument = gql`
    query scanDataMissingStoresStoreLevelDetails($filter: ScanDataMissingStoresStoreLevelDetailsFilter!, $first: Int, $after: OCBase64Cursor, $last: Int, $before: OCBase64Cursor) {
  scanDataMissingStoresStoreLevelDetails(
    filter: $filter
    first: $first
    last: $last
    after: $after
    before: $before
  ) {
    pageInfo {
      ...pageInfo
    }
    edges {
      cursor
      node {
        ...ScanDataMissingStoreStoreLevelDetails
      }
    }
  }
}
    ${PageInfoFragmentDoc}
${ScanDataMissingStoreStoreLevelDetailsFragmentDoc}`;

/**
 * __useScanDataMissingStoresStoreLevelDetailsQuery__
 *
 * To run a query within a React component, call `useScanDataMissingStoresStoreLevelDetailsQuery` and pass it any options that fit your needs.
 * When your component renders, `useScanDataMissingStoresStoreLevelDetailsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useScanDataMissingStoresStoreLevelDetailsQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *      first: // value for 'first'
 *      after: // value for 'after'
 *      last: // value for 'last'
 *      before: // value for 'before'
 *   },
 * });
 */
export function useScanDataMissingStoresStoreLevelDetailsQuery(baseOptions: Apollo.QueryHookOptions<ScanDataMissingStoresStoreLevelDetailsQuery, ScanDataMissingStoresStoreLevelDetailsQueryVariables> & ({ variables: ScanDataMissingStoresStoreLevelDetailsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ScanDataMissingStoresStoreLevelDetailsQuery, ScanDataMissingStoresStoreLevelDetailsQueryVariables>(ScanDataMissingStoresStoreLevelDetailsDocument, options);
      }
export function useScanDataMissingStoresStoreLevelDetailsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ScanDataMissingStoresStoreLevelDetailsQuery, ScanDataMissingStoresStoreLevelDetailsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ScanDataMissingStoresStoreLevelDetailsQuery, ScanDataMissingStoresStoreLevelDetailsQueryVariables>(ScanDataMissingStoresStoreLevelDetailsDocument, options);
        }
export function useScanDataMissingStoresStoreLevelDetailsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ScanDataMissingStoresStoreLevelDetailsQuery, ScanDataMissingStoresStoreLevelDetailsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ScanDataMissingStoresStoreLevelDetailsQuery, ScanDataMissingStoresStoreLevelDetailsQueryVariables>(ScanDataMissingStoresStoreLevelDetailsDocument, options);
        }
export type ScanDataMissingStoresStoreLevelDetailsQueryHookResult = ReturnType<typeof useScanDataMissingStoresStoreLevelDetailsQuery>;
export type ScanDataMissingStoresStoreLevelDetailsLazyQueryHookResult = ReturnType<typeof useScanDataMissingStoresStoreLevelDetailsLazyQuery>;
export type ScanDataMissingStoresStoreLevelDetailsSuspenseQueryHookResult = ReturnType<typeof useScanDataMissingStoresStoreLevelDetailsSuspenseQuery>;
export type ScanDataMissingStoresStoreLevelDetailsQueryResult = Apollo.QueryResult<ScanDataMissingStoresStoreLevelDetailsQuery, ScanDataMissingStoresStoreLevelDetailsQueryVariables>;
export const ScanDataReportedTransactionsStoreLevelDetailsDocument = gql`
    query scanDataReportedTransactionsStoreLevelDetails($filter: ScanDataReportedTransactionsStoreLevelDetailsFilter!, $first: Int, $after: OCBase64Cursor, $last: Int, $before: OCBase64Cursor) {
  scanDataReportedTransactionsStoreLevelDetails(
    filter: $filter
    first: $first
    last: $last
    after: $after
    before: $before
  ) {
    pageInfo {
      ...pageInfo
    }
    edges {
      cursor
      node {
        ...ScanDataReportedTransactionsStoreLevelDetails
      }
    }
  }
}
    ${PageInfoFragmentDoc}
${ScanDataReportedTransactionsStoreLevelDetailsFragmentDoc}`;

/**
 * __useScanDataReportedTransactionsStoreLevelDetailsQuery__
 *
 * To run a query within a React component, call `useScanDataReportedTransactionsStoreLevelDetailsQuery` and pass it any options that fit your needs.
 * When your component renders, `useScanDataReportedTransactionsStoreLevelDetailsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useScanDataReportedTransactionsStoreLevelDetailsQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *      first: // value for 'first'
 *      after: // value for 'after'
 *      last: // value for 'last'
 *      before: // value for 'before'
 *   },
 * });
 */
export function useScanDataReportedTransactionsStoreLevelDetailsQuery(baseOptions: Apollo.QueryHookOptions<ScanDataReportedTransactionsStoreLevelDetailsQuery, ScanDataReportedTransactionsStoreLevelDetailsQueryVariables> & ({ variables: ScanDataReportedTransactionsStoreLevelDetailsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ScanDataReportedTransactionsStoreLevelDetailsQuery, ScanDataReportedTransactionsStoreLevelDetailsQueryVariables>(ScanDataReportedTransactionsStoreLevelDetailsDocument, options);
      }
export function useScanDataReportedTransactionsStoreLevelDetailsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ScanDataReportedTransactionsStoreLevelDetailsQuery, ScanDataReportedTransactionsStoreLevelDetailsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ScanDataReportedTransactionsStoreLevelDetailsQuery, ScanDataReportedTransactionsStoreLevelDetailsQueryVariables>(ScanDataReportedTransactionsStoreLevelDetailsDocument, options);
        }
export function useScanDataReportedTransactionsStoreLevelDetailsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ScanDataReportedTransactionsStoreLevelDetailsQuery, ScanDataReportedTransactionsStoreLevelDetailsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ScanDataReportedTransactionsStoreLevelDetailsQuery, ScanDataReportedTransactionsStoreLevelDetailsQueryVariables>(ScanDataReportedTransactionsStoreLevelDetailsDocument, options);
        }
export type ScanDataReportedTransactionsStoreLevelDetailsQueryHookResult = ReturnType<typeof useScanDataReportedTransactionsStoreLevelDetailsQuery>;
export type ScanDataReportedTransactionsStoreLevelDetailsLazyQueryHookResult = ReturnType<typeof useScanDataReportedTransactionsStoreLevelDetailsLazyQuery>;
export type ScanDataReportedTransactionsStoreLevelDetailsSuspenseQueryHookResult = ReturnType<typeof useScanDataReportedTransactionsStoreLevelDetailsSuspenseQuery>;
export type ScanDataReportedTransactionsStoreLevelDetailsQueryResult = Apollo.QueryResult<ScanDataReportedTransactionsStoreLevelDetailsQuery, ScanDataReportedTransactionsStoreLevelDetailsQueryVariables>;
export const ScanDataReimbursementsStoreLevelDetailsDocument = gql`
    query scanDataReimbursementsStoreLevelDetails($filter: ScanDataReimbursementsStoreLevelDetailsFilter!, $first: Int, $after: OCBase64Cursor, $last: Int, $before: OCBase64Cursor) {
  scanDataReimbursementsStoreLevelDetails(
    filter: $filter
    first: $first
    last: $last
    after: $after
    before: $before
  ) {
    pageInfo {
      ...pageInfo
    }
    edges {
      cursor
      node {
        ...ScanDataReimbursementsStoreLevelDetails
      }
    }
  }
}
    ${PageInfoFragmentDoc}
${ScanDataReimbursementsStoreLevelDetailsFragmentDoc}`;

/**
 * __useScanDataReimbursementsStoreLevelDetailsQuery__
 *
 * To run a query within a React component, call `useScanDataReimbursementsStoreLevelDetailsQuery` and pass it any options that fit your needs.
 * When your component renders, `useScanDataReimbursementsStoreLevelDetailsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useScanDataReimbursementsStoreLevelDetailsQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *      first: // value for 'first'
 *      after: // value for 'after'
 *      last: // value for 'last'
 *      before: // value for 'before'
 *   },
 * });
 */
export function useScanDataReimbursementsStoreLevelDetailsQuery(baseOptions: Apollo.QueryHookOptions<ScanDataReimbursementsStoreLevelDetailsQuery, ScanDataReimbursementsStoreLevelDetailsQueryVariables> & ({ variables: ScanDataReimbursementsStoreLevelDetailsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ScanDataReimbursementsStoreLevelDetailsQuery, ScanDataReimbursementsStoreLevelDetailsQueryVariables>(ScanDataReimbursementsStoreLevelDetailsDocument, options);
      }
export function useScanDataReimbursementsStoreLevelDetailsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ScanDataReimbursementsStoreLevelDetailsQuery, ScanDataReimbursementsStoreLevelDetailsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ScanDataReimbursementsStoreLevelDetailsQuery, ScanDataReimbursementsStoreLevelDetailsQueryVariables>(ScanDataReimbursementsStoreLevelDetailsDocument, options);
        }
export function useScanDataReimbursementsStoreLevelDetailsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ScanDataReimbursementsStoreLevelDetailsQuery, ScanDataReimbursementsStoreLevelDetailsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ScanDataReimbursementsStoreLevelDetailsQuery, ScanDataReimbursementsStoreLevelDetailsQueryVariables>(ScanDataReimbursementsStoreLevelDetailsDocument, options);
        }
export type ScanDataReimbursementsStoreLevelDetailsQueryHookResult = ReturnType<typeof useScanDataReimbursementsStoreLevelDetailsQuery>;
export type ScanDataReimbursementsStoreLevelDetailsLazyQueryHookResult = ReturnType<typeof useScanDataReimbursementsStoreLevelDetailsLazyQuery>;
export type ScanDataReimbursementsStoreLevelDetailsSuspenseQueryHookResult = ReturnType<typeof useScanDataReimbursementsStoreLevelDetailsSuspenseQuery>;
export type ScanDataReimbursementsStoreLevelDetailsQueryResult = Apollo.QueryResult<ScanDataReimbursementsStoreLevelDetailsQuery, ScanDataReimbursementsStoreLevelDetailsQueryVariables>;
export const GetScanDataSftpCredentialsWithStoreDetailsListDocument = gql`
    query getScanDataSftpCredentialsWithStoreDetailsList($filter: ListScanDataSFTPCredentialsWithStoreDetailsFilter, $first: Int, $after: OCBase64Cursor, $last: Int, $before: OCBase64Cursor, $cpg: CPG!) {
  listScanDataSftpCredentialsWithStoreDetails(
    filter: $filter
    first: $first
    last: $last
    before: $before
    after: $after
    cpg: $cpg
  ) {
    pageInfo {
      ...pageInfo
    }
    edges {
      cursor
      node {
        ...ScanDataSftpCredentialsWithStoreDetails
      }
    }
  }
}
    ${PageInfoFragmentDoc}
${ScanDataSftpCredentialsWithStoreDetailsFragmentDoc}`;

/**
 * __useGetScanDataSftpCredentialsWithStoreDetailsListQuery__
 *
 * To run a query within a React component, call `useGetScanDataSftpCredentialsWithStoreDetailsListQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetScanDataSftpCredentialsWithStoreDetailsListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetScanDataSftpCredentialsWithStoreDetailsListQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *      first: // value for 'first'
 *      after: // value for 'after'
 *      last: // value for 'last'
 *      before: // value for 'before'
 *      cpg: // value for 'cpg'
 *   },
 * });
 */
export function useGetScanDataSftpCredentialsWithStoreDetailsListQuery(baseOptions: Apollo.QueryHookOptions<GetScanDataSftpCredentialsWithStoreDetailsListQuery, GetScanDataSftpCredentialsWithStoreDetailsListQueryVariables> & ({ variables: GetScanDataSftpCredentialsWithStoreDetailsListQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetScanDataSftpCredentialsWithStoreDetailsListQuery, GetScanDataSftpCredentialsWithStoreDetailsListQueryVariables>(GetScanDataSftpCredentialsWithStoreDetailsListDocument, options);
      }
export function useGetScanDataSftpCredentialsWithStoreDetailsListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetScanDataSftpCredentialsWithStoreDetailsListQuery, GetScanDataSftpCredentialsWithStoreDetailsListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetScanDataSftpCredentialsWithStoreDetailsListQuery, GetScanDataSftpCredentialsWithStoreDetailsListQueryVariables>(GetScanDataSftpCredentialsWithStoreDetailsListDocument, options);
        }
export function useGetScanDataSftpCredentialsWithStoreDetailsListSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetScanDataSftpCredentialsWithStoreDetailsListQuery, GetScanDataSftpCredentialsWithStoreDetailsListQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetScanDataSftpCredentialsWithStoreDetailsListQuery, GetScanDataSftpCredentialsWithStoreDetailsListQueryVariables>(GetScanDataSftpCredentialsWithStoreDetailsListDocument, options);
        }
export type GetScanDataSftpCredentialsWithStoreDetailsListQueryHookResult = ReturnType<typeof useGetScanDataSftpCredentialsWithStoreDetailsListQuery>;
export type GetScanDataSftpCredentialsWithStoreDetailsListLazyQueryHookResult = ReturnType<typeof useGetScanDataSftpCredentialsWithStoreDetailsListLazyQuery>;
export type GetScanDataSftpCredentialsWithStoreDetailsListSuspenseQueryHookResult = ReturnType<typeof useGetScanDataSftpCredentialsWithStoreDetailsListSuspenseQuery>;
export type GetScanDataSftpCredentialsWithStoreDetailsListQueryResult = Apollo.QueryResult<GetScanDataSftpCredentialsWithStoreDetailsListQuery, GetScanDataSftpCredentialsWithStoreDetailsListQueryVariables>;
export const GetScanDataMissingStoresDetailsDocument = gql`
    query getScanDataMissingStoresDetails($filter: ScanDataMissingStoresDetailsFilter, $first: Int, $after: OCBase64Cursor, $last: Int, $before: OCBase64Cursor) {
  scanDataMissingStoresDetails(
    filter: $filter
    first: $first
    last: $last
    after: $after
    before: $before
  ) {
    pageInfo {
      ...pageInfo
    }
    edges {
      cursor
      node {
        ...ScanDataMissingStoresDetails
      }
    }
  }
}
    ${PageInfoFragmentDoc}
${ScanDataMissingStoresDetailsFragmentDoc}`;

/**
 * __useGetScanDataMissingStoresDetailsQuery__
 *
 * To run a query within a React component, call `useGetScanDataMissingStoresDetailsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetScanDataMissingStoresDetailsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetScanDataMissingStoresDetailsQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *      first: // value for 'first'
 *      after: // value for 'after'
 *      last: // value for 'last'
 *      before: // value for 'before'
 *   },
 * });
 */
export function useGetScanDataMissingStoresDetailsQuery(baseOptions?: Apollo.QueryHookOptions<GetScanDataMissingStoresDetailsQuery, GetScanDataMissingStoresDetailsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetScanDataMissingStoresDetailsQuery, GetScanDataMissingStoresDetailsQueryVariables>(GetScanDataMissingStoresDetailsDocument, options);
      }
export function useGetScanDataMissingStoresDetailsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetScanDataMissingStoresDetailsQuery, GetScanDataMissingStoresDetailsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetScanDataMissingStoresDetailsQuery, GetScanDataMissingStoresDetailsQueryVariables>(GetScanDataMissingStoresDetailsDocument, options);
        }
export function useGetScanDataMissingStoresDetailsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetScanDataMissingStoresDetailsQuery, GetScanDataMissingStoresDetailsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetScanDataMissingStoresDetailsQuery, GetScanDataMissingStoresDetailsQueryVariables>(GetScanDataMissingStoresDetailsDocument, options);
        }
export type GetScanDataMissingStoresDetailsQueryHookResult = ReturnType<typeof useGetScanDataMissingStoresDetailsQuery>;
export type GetScanDataMissingStoresDetailsLazyQueryHookResult = ReturnType<typeof useGetScanDataMissingStoresDetailsLazyQuery>;
export type GetScanDataMissingStoresDetailsSuspenseQueryHookResult = ReturnType<typeof useGetScanDataMissingStoresDetailsSuspenseQuery>;
export type GetScanDataMissingStoresDetailsQueryResult = Apollo.QueryResult<GetScanDataMissingStoresDetailsQuery, GetScanDataMissingStoresDetailsQueryVariables>;
export const GetScanDataSftpCredentialByUuidDocument = gql`
    query getScanDataSftpCredentialByUuid($uuid: ID!) {
  getScanDataSftpCredentialByUuid(uuid: $uuid) {
    ...ScanDataSftpCredential
  }
}
    ${ScanDataSftpCredentialFragmentDoc}`;

/**
 * __useGetScanDataSftpCredentialByUuidQuery__
 *
 * To run a query within a React component, call `useGetScanDataSftpCredentialByUuidQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetScanDataSftpCredentialByUuidQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetScanDataSftpCredentialByUuidQuery({
 *   variables: {
 *      uuid: // value for 'uuid'
 *   },
 * });
 */
export function useGetScanDataSftpCredentialByUuidQuery(baseOptions: Apollo.QueryHookOptions<GetScanDataSftpCredentialByUuidQuery, GetScanDataSftpCredentialByUuidQueryVariables> & ({ variables: GetScanDataSftpCredentialByUuidQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetScanDataSftpCredentialByUuidQuery, GetScanDataSftpCredentialByUuidQueryVariables>(GetScanDataSftpCredentialByUuidDocument, options);
      }
export function useGetScanDataSftpCredentialByUuidLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetScanDataSftpCredentialByUuidQuery, GetScanDataSftpCredentialByUuidQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetScanDataSftpCredentialByUuidQuery, GetScanDataSftpCredentialByUuidQueryVariables>(GetScanDataSftpCredentialByUuidDocument, options);
        }
export function useGetScanDataSftpCredentialByUuidSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetScanDataSftpCredentialByUuidQuery, GetScanDataSftpCredentialByUuidQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetScanDataSftpCredentialByUuidQuery, GetScanDataSftpCredentialByUuidQueryVariables>(GetScanDataSftpCredentialByUuidDocument, options);
        }
export type GetScanDataSftpCredentialByUuidQueryHookResult = ReturnType<typeof useGetScanDataSftpCredentialByUuidQuery>;
export type GetScanDataSftpCredentialByUuidLazyQueryHookResult = ReturnType<typeof useGetScanDataSftpCredentialByUuidLazyQuery>;
export type GetScanDataSftpCredentialByUuidSuspenseQueryHookResult = ReturnType<typeof useGetScanDataSftpCredentialByUuidSuspenseQuery>;
export type GetScanDataSftpCredentialByUuidQueryResult = Apollo.QueryResult<GetScanDataSftpCredentialByUuidQuery, GetScanDataSftpCredentialByUuidQueryVariables>;
export const GetSubmissionGroupLocationsDocument = gql`
    query getSubmissionGroupLocations($first: Int, $last: Int, $after: String, $before: String, $filter: LocationFilter) {
  locations(
    first: $first
    last: $last
    after: $after
    before: $before
    filter: $filter
  ) {
    pageInfo {
      ...pageInfo
    }
    edges {
      cursor
      node {
        ...SubmissionGroupLocation
      }
    }
  }
}
    ${PageInfoFragmentDoc}
${SubmissionGroupLocationFragmentDoc}`;

/**
 * __useGetSubmissionGroupLocationsQuery__
 *
 * To run a query within a React component, call `useGetSubmissionGroupLocationsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSubmissionGroupLocationsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSubmissionGroupLocationsQuery({
 *   variables: {
 *      first: // value for 'first'
 *      last: // value for 'last'
 *      after: // value for 'after'
 *      before: // value for 'before'
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useGetSubmissionGroupLocationsQuery(baseOptions?: Apollo.QueryHookOptions<GetSubmissionGroupLocationsQuery, GetSubmissionGroupLocationsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetSubmissionGroupLocationsQuery, GetSubmissionGroupLocationsQueryVariables>(GetSubmissionGroupLocationsDocument, options);
      }
export function useGetSubmissionGroupLocationsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetSubmissionGroupLocationsQuery, GetSubmissionGroupLocationsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetSubmissionGroupLocationsQuery, GetSubmissionGroupLocationsQueryVariables>(GetSubmissionGroupLocationsDocument, options);
        }
export function useGetSubmissionGroupLocationsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetSubmissionGroupLocationsQuery, GetSubmissionGroupLocationsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetSubmissionGroupLocationsQuery, GetSubmissionGroupLocationsQueryVariables>(GetSubmissionGroupLocationsDocument, options);
        }
export type GetSubmissionGroupLocationsQueryHookResult = ReturnType<typeof useGetSubmissionGroupLocationsQuery>;
export type GetSubmissionGroupLocationsLazyQueryHookResult = ReturnType<typeof useGetSubmissionGroupLocationsLazyQuery>;
export type GetSubmissionGroupLocationsSuspenseQueryHookResult = ReturnType<typeof useGetSubmissionGroupLocationsSuspenseQuery>;
export type GetSubmissionGroupLocationsQueryResult = Apollo.QueryResult<GetSubmissionGroupLocationsQuery, GetSubmissionGroupLocationsQueryVariables>;
export const GenerateSegmentUploadSignedUrlDocument = gql`
    mutation generateSegmentUploadSignedUrl($fileName: String!) {
  generateSegmentUploadSignedUrl(fileName: $fileName) {
    fileUuid
    signedUrl
    fields
  }
}
    `;
export type GenerateSegmentUploadSignedUrlMutationFn = Apollo.MutationFunction<GenerateSegmentUploadSignedUrlMutation, GenerateSegmentUploadSignedUrlMutationVariables>;

/**
 * __useGenerateSegmentUploadSignedUrlMutation__
 *
 * To run a mutation, you first call `useGenerateSegmentUploadSignedUrlMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useGenerateSegmentUploadSignedUrlMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [generateSegmentUploadSignedUrlMutation, { data, loading, error }] = useGenerateSegmentUploadSignedUrlMutation({
 *   variables: {
 *      fileName: // value for 'fileName'
 *   },
 * });
 */
export function useGenerateSegmentUploadSignedUrlMutation(baseOptions?: Apollo.MutationHookOptions<GenerateSegmentUploadSignedUrlMutation, GenerateSegmentUploadSignedUrlMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GenerateSegmentUploadSignedUrlMutation, GenerateSegmentUploadSignedUrlMutationVariables>(GenerateSegmentUploadSignedUrlDocument, options);
      }
export type GenerateSegmentUploadSignedUrlMutationHookResult = ReturnType<typeof useGenerateSegmentUploadSignedUrlMutation>;
export type GenerateSegmentUploadSignedUrlMutationResult = Apollo.MutationResult<GenerateSegmentUploadSignedUrlMutation>;
export type GenerateSegmentUploadSignedUrlMutationOptions = Apollo.BaseMutationOptions<GenerateSegmentUploadSignedUrlMutation, GenerateSegmentUploadSignedUrlMutationVariables>;
export const ProcessSegmentUploadDocument = gql`
    mutation processSegmentUpload($input: ProcessSegmentUploadInput!) {
  processSegmentUpload(input: $input)
}
    `;
export type ProcessSegmentUploadMutationFn = Apollo.MutationFunction<ProcessSegmentUploadMutation, ProcessSegmentUploadMutationVariables>;

/**
 * __useProcessSegmentUploadMutation__
 *
 * To run a mutation, you first call `useProcessSegmentUploadMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useProcessSegmentUploadMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [processSegmentUploadMutation, { data, loading, error }] = useProcessSegmentUploadMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useProcessSegmentUploadMutation(baseOptions?: Apollo.MutationHookOptions<ProcessSegmentUploadMutation, ProcessSegmentUploadMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ProcessSegmentUploadMutation, ProcessSegmentUploadMutationVariables>(ProcessSegmentUploadDocument, options);
      }
export type ProcessSegmentUploadMutationHookResult = ReturnType<typeof useProcessSegmentUploadMutation>;
export type ProcessSegmentUploadMutationResult = Apollo.MutationResult<ProcessSegmentUploadMutation>;
export type ProcessSegmentUploadMutationOptions = Apollo.BaseMutationOptions<ProcessSegmentUploadMutation, ProcessSegmentUploadMutationVariables>;
export const GetSegmentUploadedFilesDocument = gql`
    query getSegmentUploadedFiles($uuid: OCUUID!, $first: Int, $last: Int, $after: OCBase64Cursor, $before: OCBase64Cursor) {
  segmentUploadedFiles(
    first: $first
    last: $last
    after: $after
    before: $before
    segmentUuid: $uuid
  ) {
    pageInfo {
      ...pageInfo
    }
    edges {
      cursor
      node {
        ...segmentUploadedFile
      }
    }
  }
}
    ${PageInfoFragmentDoc}
${SegmentUploadedFileFragmentDoc}`;

/**
 * __useGetSegmentUploadedFilesQuery__
 *
 * To run a query within a React component, call `useGetSegmentUploadedFilesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSegmentUploadedFilesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSegmentUploadedFilesQuery({
 *   variables: {
 *      uuid: // value for 'uuid'
 *      first: // value for 'first'
 *      last: // value for 'last'
 *      after: // value for 'after'
 *      before: // value for 'before'
 *   },
 * });
 */
export function useGetSegmentUploadedFilesQuery(baseOptions: Apollo.QueryHookOptions<GetSegmentUploadedFilesQuery, GetSegmentUploadedFilesQueryVariables> & ({ variables: GetSegmentUploadedFilesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetSegmentUploadedFilesQuery, GetSegmentUploadedFilesQueryVariables>(GetSegmentUploadedFilesDocument, options);
      }
export function useGetSegmentUploadedFilesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetSegmentUploadedFilesQuery, GetSegmentUploadedFilesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetSegmentUploadedFilesQuery, GetSegmentUploadedFilesQueryVariables>(GetSegmentUploadedFilesDocument, options);
        }
export function useGetSegmentUploadedFilesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetSegmentUploadedFilesQuery, GetSegmentUploadedFilesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetSegmentUploadedFilesQuery, GetSegmentUploadedFilesQueryVariables>(GetSegmentUploadedFilesDocument, options);
        }
export type GetSegmentUploadedFilesQueryHookResult = ReturnType<typeof useGetSegmentUploadedFilesQuery>;
export type GetSegmentUploadedFilesLazyQueryHookResult = ReturnType<typeof useGetSegmentUploadedFilesLazyQuery>;
export type GetSegmentUploadedFilesSuspenseQueryHookResult = ReturnType<typeof useGetSegmentUploadedFilesSuspenseQuery>;
export type GetSegmentUploadedFilesQueryResult = Apollo.QueryResult<GetSegmentUploadedFilesQuery, GetSegmentUploadedFilesQueryVariables>;
export const StoredValueProgramCreateDocument = gql`
    mutation storedValueProgramCreate($input: StoredValueProgramCreateInput!) {
  storedValueProgramCreate(input: $input) {
    id
  }
}
    `;
export type StoredValueProgramCreateMutationFn = Apollo.MutationFunction<StoredValueProgramCreateMutation, StoredValueProgramCreateMutationVariables>;

/**
 * __useStoredValueProgramCreateMutation__
 *
 * To run a mutation, you first call `useStoredValueProgramCreateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useStoredValueProgramCreateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [storedValueProgramCreateMutation, { data, loading, error }] = useStoredValueProgramCreateMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useStoredValueProgramCreateMutation(baseOptions?: Apollo.MutationHookOptions<StoredValueProgramCreateMutation, StoredValueProgramCreateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<StoredValueProgramCreateMutation, StoredValueProgramCreateMutationVariables>(StoredValueProgramCreateDocument, options);
      }
export type StoredValueProgramCreateMutationHookResult = ReturnType<typeof useStoredValueProgramCreateMutation>;
export type StoredValueProgramCreateMutationResult = Apollo.MutationResult<StoredValueProgramCreateMutation>;
export type StoredValueProgramCreateMutationOptions = Apollo.BaseMutationOptions<StoredValueProgramCreateMutation, StoredValueProgramCreateMutationVariables>;
export const StoredValueProgramUpdateDocument = gql`
    mutation storedValueProgramUpdate($input: StoredValueProgramUpdateInput!) {
  storedValueProgramUpdate(input: $input) {
    id
  }
}
    `;
export type StoredValueProgramUpdateMutationFn = Apollo.MutationFunction<StoredValueProgramUpdateMutation, StoredValueProgramUpdateMutationVariables>;

/**
 * __useStoredValueProgramUpdateMutation__
 *
 * To run a mutation, you first call `useStoredValueProgramUpdateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useStoredValueProgramUpdateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [storedValueProgramUpdateMutation, { data, loading, error }] = useStoredValueProgramUpdateMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useStoredValueProgramUpdateMutation(baseOptions?: Apollo.MutationHookOptions<StoredValueProgramUpdateMutation, StoredValueProgramUpdateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<StoredValueProgramUpdateMutation, StoredValueProgramUpdateMutationVariables>(StoredValueProgramUpdateDocument, options);
      }
export type StoredValueProgramUpdateMutationHookResult = ReturnType<typeof useStoredValueProgramUpdateMutation>;
export type StoredValueProgramUpdateMutationResult = Apollo.MutationResult<StoredValueProgramUpdateMutation>;
export type StoredValueProgramUpdateMutationOptions = Apollo.BaseMutationOptions<StoredValueProgramUpdateMutation, StoredValueProgramUpdateMutationVariables>;
export const StoredValueProgramsDocument = gql`
    query storedValuePrograms($filter: StoredValueProgramFilter, $first: Int, $after: ID, $last: Int, $before: ID) {
  storedValuePrograms(
    filter: $filter
    first: $first
    after: $after
    last: $last
    before: $before
  ) {
    pageInfo {
      ...pageInfo
    }
    edges {
      cursor
      node {
        ...storedValueProgram
      }
    }
  }
}
    ${PageInfoFragmentDoc}
${StoredValueProgramFragmentDoc}`;

/**
 * __useStoredValueProgramsQuery__
 *
 * To run a query within a React component, call `useStoredValueProgramsQuery` and pass it any options that fit your needs.
 * When your component renders, `useStoredValueProgramsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useStoredValueProgramsQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *      first: // value for 'first'
 *      after: // value for 'after'
 *      last: // value for 'last'
 *      before: // value for 'before'
 *   },
 * });
 */
export function useStoredValueProgramsQuery(baseOptions?: Apollo.QueryHookOptions<StoredValueProgramsQuery, StoredValueProgramsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<StoredValueProgramsQuery, StoredValueProgramsQueryVariables>(StoredValueProgramsDocument, options);
      }
export function useStoredValueProgramsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<StoredValueProgramsQuery, StoredValueProgramsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<StoredValueProgramsQuery, StoredValueProgramsQueryVariables>(StoredValueProgramsDocument, options);
        }
export function useStoredValueProgramsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<StoredValueProgramsQuery, StoredValueProgramsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<StoredValueProgramsQuery, StoredValueProgramsQueryVariables>(StoredValueProgramsDocument, options);
        }
export type StoredValueProgramsQueryHookResult = ReturnType<typeof useStoredValueProgramsQuery>;
export type StoredValueProgramsLazyQueryHookResult = ReturnType<typeof useStoredValueProgramsLazyQuery>;
export type StoredValueProgramsSuspenseQueryHookResult = ReturnType<typeof useStoredValueProgramsSuspenseQuery>;
export type StoredValueProgramsQueryResult = Apollo.QueryResult<StoredValueProgramsQuery, StoredValueProgramsQueryVariables>;
export const MembershipStoredValueExpirationScheduleDocument = gql`
    query membershipStoredValueExpirationSchedule($membershipId: ID!, $first: Int, $last: Int, $after: ID, $before: ID) {
  memberships(first: 1, filter: {idEquals: $membershipId}) {
    edges {
      cursor
      node {
        id
        storedValueExpirationSchedule(
          first: $first
          last: $last
          after: $after
          before: $before
        ) {
          pageInfo {
            ...pageInfo
          }
          edges {
            cursor
            node {
              ...StoredValueExpirationSchedule
            }
          }
        }
      }
    }
  }
}
    ${PageInfoFragmentDoc}
${StoredValueExpirationScheduleFragmentDoc}`;

/**
 * __useMembershipStoredValueExpirationScheduleQuery__
 *
 * To run a query within a React component, call `useMembershipStoredValueExpirationScheduleQuery` and pass it any options that fit your needs.
 * When your component renders, `useMembershipStoredValueExpirationScheduleQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMembershipStoredValueExpirationScheduleQuery({
 *   variables: {
 *      membershipId: // value for 'membershipId'
 *      first: // value for 'first'
 *      last: // value for 'last'
 *      after: // value for 'after'
 *      before: // value for 'before'
 *   },
 * });
 */
export function useMembershipStoredValueExpirationScheduleQuery(baseOptions: Apollo.QueryHookOptions<MembershipStoredValueExpirationScheduleQuery, MembershipStoredValueExpirationScheduleQueryVariables> & ({ variables: MembershipStoredValueExpirationScheduleQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<MembershipStoredValueExpirationScheduleQuery, MembershipStoredValueExpirationScheduleQueryVariables>(MembershipStoredValueExpirationScheduleDocument, options);
      }
export function useMembershipStoredValueExpirationScheduleLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MembershipStoredValueExpirationScheduleQuery, MembershipStoredValueExpirationScheduleQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<MembershipStoredValueExpirationScheduleQuery, MembershipStoredValueExpirationScheduleQueryVariables>(MembershipStoredValueExpirationScheduleDocument, options);
        }
export function useMembershipStoredValueExpirationScheduleSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<MembershipStoredValueExpirationScheduleQuery, MembershipStoredValueExpirationScheduleQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<MembershipStoredValueExpirationScheduleQuery, MembershipStoredValueExpirationScheduleQueryVariables>(MembershipStoredValueExpirationScheduleDocument, options);
        }
export type MembershipStoredValueExpirationScheduleQueryHookResult = ReturnType<typeof useMembershipStoredValueExpirationScheduleQuery>;
export type MembershipStoredValueExpirationScheduleLazyQueryHookResult = ReturnType<typeof useMembershipStoredValueExpirationScheduleLazyQuery>;
export type MembershipStoredValueExpirationScheduleSuspenseQueryHookResult = ReturnType<typeof useMembershipStoredValueExpirationScheduleSuspenseQuery>;
export type MembershipStoredValueExpirationScheduleQueryResult = Apollo.QueryResult<MembershipStoredValueExpirationScheduleQuery, MembershipStoredValueExpirationScheduleQueryVariables>;
export const ArchiveExternalLoyaltyManualOfferDocument = gql`
    mutation archiveExternalLoyaltyManualOffer($uuid: OCUUID!) {
  archiveExternalLoyaltyManualOffer(uuid: $uuid)
}
    `;
export type ArchiveExternalLoyaltyManualOfferMutationFn = Apollo.MutationFunction<ArchiveExternalLoyaltyManualOfferMutation, ArchiveExternalLoyaltyManualOfferMutationVariables>;

/**
 * __useArchiveExternalLoyaltyManualOfferMutation__
 *
 * To run a mutation, you first call `useArchiveExternalLoyaltyManualOfferMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useArchiveExternalLoyaltyManualOfferMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [archiveExternalLoyaltyManualOfferMutation, { data, loading, error }] = useArchiveExternalLoyaltyManualOfferMutation({
 *   variables: {
 *      uuid: // value for 'uuid'
 *   },
 * });
 */
export function useArchiveExternalLoyaltyManualOfferMutation(baseOptions?: Apollo.MutationHookOptions<ArchiveExternalLoyaltyManualOfferMutation, ArchiveExternalLoyaltyManualOfferMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ArchiveExternalLoyaltyManualOfferMutation, ArchiveExternalLoyaltyManualOfferMutationVariables>(ArchiveExternalLoyaltyManualOfferDocument, options);
      }
export type ArchiveExternalLoyaltyManualOfferMutationHookResult = ReturnType<typeof useArchiveExternalLoyaltyManualOfferMutation>;
export type ArchiveExternalLoyaltyManualOfferMutationResult = Apollo.MutationResult<ArchiveExternalLoyaltyManualOfferMutation>;
export type ArchiveExternalLoyaltyManualOfferMutationOptions = Apollo.BaseMutationOptions<ArchiveExternalLoyaltyManualOfferMutation, ArchiveExternalLoyaltyManualOfferMutationVariables>;
export const CreateExternalLoyaltyManualOfferInActivateDocument = gql`
    mutation createExternalLoyaltyManualOfferInActivate($uuid: OCUUID!) {
  createExternalLoyaltyManualOfferInActivate(uuid: $uuid)
}
    `;
export type CreateExternalLoyaltyManualOfferInActivateMutationFn = Apollo.MutationFunction<CreateExternalLoyaltyManualOfferInActivateMutation, CreateExternalLoyaltyManualOfferInActivateMutationVariables>;

/**
 * __useCreateExternalLoyaltyManualOfferInActivateMutation__
 *
 * To run a mutation, you first call `useCreateExternalLoyaltyManualOfferInActivateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateExternalLoyaltyManualOfferInActivateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createExternalLoyaltyManualOfferInActivateMutation, { data, loading, error }] = useCreateExternalLoyaltyManualOfferInActivateMutation({
 *   variables: {
 *      uuid: // value for 'uuid'
 *   },
 * });
 */
export function useCreateExternalLoyaltyManualOfferInActivateMutation(baseOptions?: Apollo.MutationHookOptions<CreateExternalLoyaltyManualOfferInActivateMutation, CreateExternalLoyaltyManualOfferInActivateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateExternalLoyaltyManualOfferInActivateMutation, CreateExternalLoyaltyManualOfferInActivateMutationVariables>(CreateExternalLoyaltyManualOfferInActivateDocument, options);
      }
export type CreateExternalLoyaltyManualOfferInActivateMutationHookResult = ReturnType<typeof useCreateExternalLoyaltyManualOfferInActivateMutation>;
export type CreateExternalLoyaltyManualOfferInActivateMutationResult = Apollo.MutationResult<CreateExternalLoyaltyManualOfferInActivateMutation>;
export type CreateExternalLoyaltyManualOfferInActivateMutationOptions = Apollo.BaseMutationOptions<CreateExternalLoyaltyManualOfferInActivateMutation, CreateExternalLoyaltyManualOfferInActivateMutationVariables>;
export const GetExternalLoyaltyManualOfferBrandsDocument = gql`
    query getExternalLoyaltyManualOfferBrands($filter: ExternalLoyaltyManualOfferBrandFilter) {
  externalLoyaltyManualOfferBrands(filter: $filter) {
    name
  }
}
    `;

/**
 * __useGetExternalLoyaltyManualOfferBrandsQuery__
 *
 * To run a query within a React component, call `useGetExternalLoyaltyManualOfferBrandsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetExternalLoyaltyManualOfferBrandsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetExternalLoyaltyManualOfferBrandsQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useGetExternalLoyaltyManualOfferBrandsQuery(baseOptions?: Apollo.QueryHookOptions<GetExternalLoyaltyManualOfferBrandsQuery, GetExternalLoyaltyManualOfferBrandsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetExternalLoyaltyManualOfferBrandsQuery, GetExternalLoyaltyManualOfferBrandsQueryVariables>(GetExternalLoyaltyManualOfferBrandsDocument, options);
      }
export function useGetExternalLoyaltyManualOfferBrandsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetExternalLoyaltyManualOfferBrandsQuery, GetExternalLoyaltyManualOfferBrandsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetExternalLoyaltyManualOfferBrandsQuery, GetExternalLoyaltyManualOfferBrandsQueryVariables>(GetExternalLoyaltyManualOfferBrandsDocument, options);
        }
export function useGetExternalLoyaltyManualOfferBrandsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetExternalLoyaltyManualOfferBrandsQuery, GetExternalLoyaltyManualOfferBrandsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetExternalLoyaltyManualOfferBrandsQuery, GetExternalLoyaltyManualOfferBrandsQueryVariables>(GetExternalLoyaltyManualOfferBrandsDocument, options);
        }
export type GetExternalLoyaltyManualOfferBrandsQueryHookResult = ReturnType<typeof useGetExternalLoyaltyManualOfferBrandsQuery>;
export type GetExternalLoyaltyManualOfferBrandsLazyQueryHookResult = ReturnType<typeof useGetExternalLoyaltyManualOfferBrandsLazyQuery>;
export type GetExternalLoyaltyManualOfferBrandsSuspenseQueryHookResult = ReturnType<typeof useGetExternalLoyaltyManualOfferBrandsSuspenseQuery>;
export type GetExternalLoyaltyManualOfferBrandsQueryResult = Apollo.QueryResult<GetExternalLoyaltyManualOfferBrandsQuery, GetExternalLoyaltyManualOfferBrandsQueryVariables>;
export const GetExternalLoyaltyManualOfferDocument = gql`
    query getExternalLoyaltyManualOffer($uuid: ID!) {
  externalLoyaltyManualOffer(uuid: $uuid) {
    uuid
    period
    brand
    name
    manufacturer
    states
    storeCount
    startDate
    endDate
    hasError
    errorMessage
    activateOfferId
    activateCampaignId
    externalCampaignId
    inActivate
    status
    isArchived
    upc {
      upc
      productGroupId
    }
  }
}
    `;

/**
 * __useGetExternalLoyaltyManualOfferQuery__
 *
 * To run a query within a React component, call `useGetExternalLoyaltyManualOfferQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetExternalLoyaltyManualOfferQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetExternalLoyaltyManualOfferQuery({
 *   variables: {
 *      uuid: // value for 'uuid'
 *   },
 * });
 */
export function useGetExternalLoyaltyManualOfferQuery(baseOptions: Apollo.QueryHookOptions<GetExternalLoyaltyManualOfferQuery, GetExternalLoyaltyManualOfferQueryVariables> & ({ variables: GetExternalLoyaltyManualOfferQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetExternalLoyaltyManualOfferQuery, GetExternalLoyaltyManualOfferQueryVariables>(GetExternalLoyaltyManualOfferDocument, options);
      }
export function useGetExternalLoyaltyManualOfferLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetExternalLoyaltyManualOfferQuery, GetExternalLoyaltyManualOfferQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetExternalLoyaltyManualOfferQuery, GetExternalLoyaltyManualOfferQueryVariables>(GetExternalLoyaltyManualOfferDocument, options);
        }
export function useGetExternalLoyaltyManualOfferSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetExternalLoyaltyManualOfferQuery, GetExternalLoyaltyManualOfferQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetExternalLoyaltyManualOfferQuery, GetExternalLoyaltyManualOfferQueryVariables>(GetExternalLoyaltyManualOfferDocument, options);
        }
export type GetExternalLoyaltyManualOfferQueryHookResult = ReturnType<typeof useGetExternalLoyaltyManualOfferQuery>;
export type GetExternalLoyaltyManualOfferLazyQueryHookResult = ReturnType<typeof useGetExternalLoyaltyManualOfferLazyQuery>;
export type GetExternalLoyaltyManualOfferSuspenseQueryHookResult = ReturnType<typeof useGetExternalLoyaltyManualOfferSuspenseQuery>;
export type GetExternalLoyaltyManualOfferQueryResult = Apollo.QueryResult<GetExternalLoyaltyManualOfferQuery, GetExternalLoyaltyManualOfferQueryVariables>;
export const GetExternalLoyaltyManualOfferLocationsDocument = gql`
    query getExternalLoyaltyManualOfferLocations($manualOfferUuid: ID!, $first: Int, $last: Int, $after: String, $before: String, $filter: ExternalLoyaltyManualOfferLocationFilter) {
  externalLoyaltyManualOfferLocations(
    manualOfferUuid: $manualOfferUuid
    first: $first
    last: $last
    after: $after
    before: $before
    filter: $filter
  ) {
    edges {
      cursor
      node {
        uuid
        siteId
        siteName
        siteAddress
        outletId
      }
    }
    pageInfo {
      ...pageInfo
    }
  }
}
    ${PageInfoFragmentDoc}`;

/**
 * __useGetExternalLoyaltyManualOfferLocationsQuery__
 *
 * To run a query within a React component, call `useGetExternalLoyaltyManualOfferLocationsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetExternalLoyaltyManualOfferLocationsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetExternalLoyaltyManualOfferLocationsQuery({
 *   variables: {
 *      manualOfferUuid: // value for 'manualOfferUuid'
 *      first: // value for 'first'
 *      last: // value for 'last'
 *      after: // value for 'after'
 *      before: // value for 'before'
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useGetExternalLoyaltyManualOfferLocationsQuery(baseOptions: Apollo.QueryHookOptions<GetExternalLoyaltyManualOfferLocationsQuery, GetExternalLoyaltyManualOfferLocationsQueryVariables> & ({ variables: GetExternalLoyaltyManualOfferLocationsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetExternalLoyaltyManualOfferLocationsQuery, GetExternalLoyaltyManualOfferLocationsQueryVariables>(GetExternalLoyaltyManualOfferLocationsDocument, options);
      }
export function useGetExternalLoyaltyManualOfferLocationsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetExternalLoyaltyManualOfferLocationsQuery, GetExternalLoyaltyManualOfferLocationsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetExternalLoyaltyManualOfferLocationsQuery, GetExternalLoyaltyManualOfferLocationsQueryVariables>(GetExternalLoyaltyManualOfferLocationsDocument, options);
        }
export function useGetExternalLoyaltyManualOfferLocationsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetExternalLoyaltyManualOfferLocationsQuery, GetExternalLoyaltyManualOfferLocationsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetExternalLoyaltyManualOfferLocationsQuery, GetExternalLoyaltyManualOfferLocationsQueryVariables>(GetExternalLoyaltyManualOfferLocationsDocument, options);
        }
export type GetExternalLoyaltyManualOfferLocationsQueryHookResult = ReturnType<typeof useGetExternalLoyaltyManualOfferLocationsQuery>;
export type GetExternalLoyaltyManualOfferLocationsLazyQueryHookResult = ReturnType<typeof useGetExternalLoyaltyManualOfferLocationsLazyQuery>;
export type GetExternalLoyaltyManualOfferLocationsSuspenseQueryHookResult = ReturnType<typeof useGetExternalLoyaltyManualOfferLocationsSuspenseQuery>;
export type GetExternalLoyaltyManualOfferLocationsQueryResult = Apollo.QueryResult<GetExternalLoyaltyManualOfferLocationsQuery, GetExternalLoyaltyManualOfferLocationsQueryVariables>;
export const GetExternalLoyaltyManualOfferUpcsDocument = gql`
    query getExternalLoyaltyManualOfferUpcs($manualOfferUuid: ID!) {
  externalLoyaltyManualOfferUpcs(manualOfferUuid: $manualOfferUuid) {
    externalLoyaltyUpcs {
      upc
    }
    presentOnActivateUpcs {
      upc
    }
  }
}
    `;

/**
 * __useGetExternalLoyaltyManualOfferUpcsQuery__
 *
 * To run a query within a React component, call `useGetExternalLoyaltyManualOfferUpcsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetExternalLoyaltyManualOfferUpcsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetExternalLoyaltyManualOfferUpcsQuery({
 *   variables: {
 *      manualOfferUuid: // value for 'manualOfferUuid'
 *   },
 * });
 */
export function useGetExternalLoyaltyManualOfferUpcsQuery(baseOptions: Apollo.QueryHookOptions<GetExternalLoyaltyManualOfferUpcsQuery, GetExternalLoyaltyManualOfferUpcsQueryVariables> & ({ variables: GetExternalLoyaltyManualOfferUpcsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetExternalLoyaltyManualOfferUpcsQuery, GetExternalLoyaltyManualOfferUpcsQueryVariables>(GetExternalLoyaltyManualOfferUpcsDocument, options);
      }
export function useGetExternalLoyaltyManualOfferUpcsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetExternalLoyaltyManualOfferUpcsQuery, GetExternalLoyaltyManualOfferUpcsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetExternalLoyaltyManualOfferUpcsQuery, GetExternalLoyaltyManualOfferUpcsQueryVariables>(GetExternalLoyaltyManualOfferUpcsDocument, options);
        }
export function useGetExternalLoyaltyManualOfferUpcsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetExternalLoyaltyManualOfferUpcsQuery, GetExternalLoyaltyManualOfferUpcsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetExternalLoyaltyManualOfferUpcsQuery, GetExternalLoyaltyManualOfferUpcsQueryVariables>(GetExternalLoyaltyManualOfferUpcsDocument, options);
        }
export type GetExternalLoyaltyManualOfferUpcsQueryHookResult = ReturnType<typeof useGetExternalLoyaltyManualOfferUpcsQuery>;
export type GetExternalLoyaltyManualOfferUpcsLazyQueryHookResult = ReturnType<typeof useGetExternalLoyaltyManualOfferUpcsLazyQuery>;
export type GetExternalLoyaltyManualOfferUpcsSuspenseQueryHookResult = ReturnType<typeof useGetExternalLoyaltyManualOfferUpcsSuspenseQuery>;
export type GetExternalLoyaltyManualOfferUpcsQueryResult = Apollo.QueryResult<GetExternalLoyaltyManualOfferUpcsQuery, GetExternalLoyaltyManualOfferUpcsQueryVariables>;
export const GetExternalLoyaltyManualOffersDocument = gql`
    query getExternalLoyaltyManualOffers($first: Int, $last: Int, $after: String, $before: String, $filter: ExternalLoyaltyManualOfferFilter) {
  externalLoyaltyManualOffers(
    first: $first
    last: $last
    after: $after
    before: $before
    filter: $filter
  ) {
    edges {
      cursor
      node {
        uuid
        name
        brand
        manufacturer
        states
        storeCount
        startDate
        endDate
        inActivate
        hasError
        errorMessage
        status
        activateStatus
        activateCampaignId
        activateOfferId
        externalCampaignId
        period
        isArchived
      }
    }
    pageInfo {
      ...pageInfo
    }
  }
}
    ${PageInfoFragmentDoc}`;

/**
 * __useGetExternalLoyaltyManualOffersQuery__
 *
 * To run a query within a React component, call `useGetExternalLoyaltyManualOffersQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetExternalLoyaltyManualOffersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetExternalLoyaltyManualOffersQuery({
 *   variables: {
 *      first: // value for 'first'
 *      last: // value for 'last'
 *      after: // value for 'after'
 *      before: // value for 'before'
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useGetExternalLoyaltyManualOffersQuery(baseOptions?: Apollo.QueryHookOptions<GetExternalLoyaltyManualOffersQuery, GetExternalLoyaltyManualOffersQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetExternalLoyaltyManualOffersQuery, GetExternalLoyaltyManualOffersQueryVariables>(GetExternalLoyaltyManualOffersDocument, options);
      }
export function useGetExternalLoyaltyManualOffersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetExternalLoyaltyManualOffersQuery, GetExternalLoyaltyManualOffersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetExternalLoyaltyManualOffersQuery, GetExternalLoyaltyManualOffersQueryVariables>(GetExternalLoyaltyManualOffersDocument, options);
        }
export function useGetExternalLoyaltyManualOffersSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetExternalLoyaltyManualOffersQuery, GetExternalLoyaltyManualOffersQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetExternalLoyaltyManualOffersQuery, GetExternalLoyaltyManualOffersQueryVariables>(GetExternalLoyaltyManualOffersDocument, options);
        }
export type GetExternalLoyaltyManualOffersQueryHookResult = ReturnType<typeof useGetExternalLoyaltyManualOffersQuery>;
export type GetExternalLoyaltyManualOffersLazyQueryHookResult = ReturnType<typeof useGetExternalLoyaltyManualOffersLazyQuery>;
export type GetExternalLoyaltyManualOffersSuspenseQueryHookResult = ReturnType<typeof useGetExternalLoyaltyManualOffersSuspenseQuery>;
export type GetExternalLoyaltyManualOffersQueryResult = Apollo.QueryResult<GetExternalLoyaltyManualOffersQuery, GetExternalLoyaltyManualOffersQueryVariables>;
export const CreateKioskAdSetDocument = gql`
    mutation createKioskAdSet($input: KioskAdSetCreateInput!) {
  createKioskAdSet(input: $input) {
    ...KioskAdSet
  }
}
    ${KioskAdSetFragmentDoc}`;
export type CreateKioskAdSetMutationFn = Apollo.MutationFunction<CreateKioskAdSetMutation, CreateKioskAdSetMutationVariables>;

/**
 * __useCreateKioskAdSetMutation__
 *
 * To run a mutation, you first call `useCreateKioskAdSetMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateKioskAdSetMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createKioskAdSetMutation, { data, loading, error }] = useCreateKioskAdSetMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateKioskAdSetMutation(baseOptions?: Apollo.MutationHookOptions<CreateKioskAdSetMutation, CreateKioskAdSetMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateKioskAdSetMutation, CreateKioskAdSetMutationVariables>(CreateKioskAdSetDocument, options);
      }
export type CreateKioskAdSetMutationHookResult = ReturnType<typeof useCreateKioskAdSetMutation>;
export type CreateKioskAdSetMutationResult = Apollo.MutationResult<CreateKioskAdSetMutation>;
export type CreateKioskAdSetMutationOptions = Apollo.BaseMutationOptions<CreateKioskAdSetMutation, CreateKioskAdSetMutationVariables>;
export const UpdateKioskAdSetDocument = gql`
    mutation updateKioskAdSet($input: KioskAdSetUpdateInput!) {
  updateKioskAdSet(input: $input) {
    ...KioskAdSet
  }
}
    ${KioskAdSetFragmentDoc}`;
export type UpdateKioskAdSetMutationFn = Apollo.MutationFunction<UpdateKioskAdSetMutation, UpdateKioskAdSetMutationVariables>;

/**
 * __useUpdateKioskAdSetMutation__
 *
 * To run a mutation, you first call `useUpdateKioskAdSetMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateKioskAdSetMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateKioskAdSetMutation, { data, loading, error }] = useUpdateKioskAdSetMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateKioskAdSetMutation(baseOptions?: Apollo.MutationHookOptions<UpdateKioskAdSetMutation, UpdateKioskAdSetMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateKioskAdSetMutation, UpdateKioskAdSetMutationVariables>(UpdateKioskAdSetDocument, options);
      }
export type UpdateKioskAdSetMutationHookResult = ReturnType<typeof useUpdateKioskAdSetMutation>;
export type UpdateKioskAdSetMutationResult = Apollo.MutationResult<UpdateKioskAdSetMutation>;
export type UpdateKioskAdSetMutationOptions = Apollo.BaseMutationOptions<UpdateKioskAdSetMutation, UpdateKioskAdSetMutationVariables>;
export const DeleteKioskAdSetDocument = gql`
    mutation deleteKioskAdSet($id: ID!) {
  deleteKioskAdSet(id: $id)
}
    `;
export type DeleteKioskAdSetMutationFn = Apollo.MutationFunction<DeleteKioskAdSetMutation, DeleteKioskAdSetMutationVariables>;

/**
 * __useDeleteKioskAdSetMutation__
 *
 * To run a mutation, you first call `useDeleteKioskAdSetMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteKioskAdSetMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteKioskAdSetMutation, { data, loading, error }] = useDeleteKioskAdSetMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteKioskAdSetMutation(baseOptions?: Apollo.MutationHookOptions<DeleteKioskAdSetMutation, DeleteKioskAdSetMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteKioskAdSetMutation, DeleteKioskAdSetMutationVariables>(DeleteKioskAdSetDocument, options);
      }
export type DeleteKioskAdSetMutationHookResult = ReturnType<typeof useDeleteKioskAdSetMutation>;
export type DeleteKioskAdSetMutationResult = Apollo.MutationResult<DeleteKioskAdSetMutation>;
export type DeleteKioskAdSetMutationOptions = Apollo.BaseMutationOptions<DeleteKioskAdSetMutation, DeleteKioskAdSetMutationVariables>;
export const PublishKioskAdSetDocument = gql`
    mutation publishKioskAdSet($id: ID!) {
  publishKioskAdSet(id: $id) {
    ...KioskAdSet
  }
}
    ${KioskAdSetFragmentDoc}`;
export type PublishKioskAdSetMutationFn = Apollo.MutationFunction<PublishKioskAdSetMutation, PublishKioskAdSetMutationVariables>;

/**
 * __usePublishKioskAdSetMutation__
 *
 * To run a mutation, you first call `usePublishKioskAdSetMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePublishKioskAdSetMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [publishKioskAdSetMutation, { data, loading, error }] = usePublishKioskAdSetMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function usePublishKioskAdSetMutation(baseOptions?: Apollo.MutationHookOptions<PublishKioskAdSetMutation, PublishKioskAdSetMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<PublishKioskAdSetMutation, PublishKioskAdSetMutationVariables>(PublishKioskAdSetDocument, options);
      }
export type PublishKioskAdSetMutationHookResult = ReturnType<typeof usePublishKioskAdSetMutation>;
export type PublishKioskAdSetMutationResult = Apollo.MutationResult<PublishKioskAdSetMutation>;
export type PublishKioskAdSetMutationOptions = Apollo.BaseMutationOptions<PublishKioskAdSetMutation, PublishKioskAdSetMutationVariables>;
export const ArchiveKioskAdSetDocument = gql`
    mutation archiveKioskAdSet($id: ID!) {
  archiveKioskAdSet(id: $id) {
    ...KioskAdSet
  }
}
    ${KioskAdSetFragmentDoc}`;
export type ArchiveKioskAdSetMutationFn = Apollo.MutationFunction<ArchiveKioskAdSetMutation, ArchiveKioskAdSetMutationVariables>;

/**
 * __useArchiveKioskAdSetMutation__
 *
 * To run a mutation, you first call `useArchiveKioskAdSetMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useArchiveKioskAdSetMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [archiveKioskAdSetMutation, { data, loading, error }] = useArchiveKioskAdSetMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useArchiveKioskAdSetMutation(baseOptions?: Apollo.MutationHookOptions<ArchiveKioskAdSetMutation, ArchiveKioskAdSetMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ArchiveKioskAdSetMutation, ArchiveKioskAdSetMutationVariables>(ArchiveKioskAdSetDocument, options);
      }
export type ArchiveKioskAdSetMutationHookResult = ReturnType<typeof useArchiveKioskAdSetMutation>;
export type ArchiveKioskAdSetMutationResult = Apollo.MutationResult<ArchiveKioskAdSetMutation>;
export type ArchiveKioskAdSetMutationOptions = Apollo.BaseMutationOptions<ArchiveKioskAdSetMutation, ArchiveKioskAdSetMutationVariables>;
export const CreateKioskAssetDocument = gql`
    mutation createKioskAsset($input: KioskAssetCreateInput!) {
  createKioskAsset(input: $input) {
    ...KioskAsset
  }
}
    ${KioskAssetFragmentDoc}`;
export type CreateKioskAssetMutationFn = Apollo.MutationFunction<CreateKioskAssetMutation, CreateKioskAssetMutationVariables>;

/**
 * __useCreateKioskAssetMutation__
 *
 * To run a mutation, you first call `useCreateKioskAssetMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateKioskAssetMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createKioskAssetMutation, { data, loading, error }] = useCreateKioskAssetMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateKioskAssetMutation(baseOptions?: Apollo.MutationHookOptions<CreateKioskAssetMutation, CreateKioskAssetMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateKioskAssetMutation, CreateKioskAssetMutationVariables>(CreateKioskAssetDocument, options);
      }
export type CreateKioskAssetMutationHookResult = ReturnType<typeof useCreateKioskAssetMutation>;
export type CreateKioskAssetMutationResult = Apollo.MutationResult<CreateKioskAssetMutation>;
export type CreateKioskAssetMutationOptions = Apollo.BaseMutationOptions<CreateKioskAssetMutation, CreateKioskAssetMutationVariables>;
export const UpdateKioskAssetDocument = gql`
    mutation updateKioskAsset($input: KioskAssetUpdateInput!) {
  updateKioskAsset(input: $input) {
    ...KioskAsset
  }
}
    ${KioskAssetFragmentDoc}`;
export type UpdateKioskAssetMutationFn = Apollo.MutationFunction<UpdateKioskAssetMutation, UpdateKioskAssetMutationVariables>;

/**
 * __useUpdateKioskAssetMutation__
 *
 * To run a mutation, you first call `useUpdateKioskAssetMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateKioskAssetMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateKioskAssetMutation, { data, loading, error }] = useUpdateKioskAssetMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateKioskAssetMutation(baseOptions?: Apollo.MutationHookOptions<UpdateKioskAssetMutation, UpdateKioskAssetMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateKioskAssetMutation, UpdateKioskAssetMutationVariables>(UpdateKioskAssetDocument, options);
      }
export type UpdateKioskAssetMutationHookResult = ReturnType<typeof useUpdateKioskAssetMutation>;
export type UpdateKioskAssetMutationResult = Apollo.MutationResult<UpdateKioskAssetMutation>;
export type UpdateKioskAssetMutationOptions = Apollo.BaseMutationOptions<UpdateKioskAssetMutation, UpdateKioskAssetMutationVariables>;
export const DeleteKioskAssetDocument = gql`
    mutation deleteKioskAsset($id: ID!) {
  deleteKioskAsset(id: $id)
}
    `;
export type DeleteKioskAssetMutationFn = Apollo.MutationFunction<DeleteKioskAssetMutation, DeleteKioskAssetMutationVariables>;

/**
 * __useDeleteKioskAssetMutation__
 *
 * To run a mutation, you first call `useDeleteKioskAssetMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteKioskAssetMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteKioskAssetMutation, { data, loading, error }] = useDeleteKioskAssetMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteKioskAssetMutation(baseOptions?: Apollo.MutationHookOptions<DeleteKioskAssetMutation, DeleteKioskAssetMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteKioskAssetMutation, DeleteKioskAssetMutationVariables>(DeleteKioskAssetDocument, options);
      }
export type DeleteKioskAssetMutationHookResult = ReturnType<typeof useDeleteKioskAssetMutation>;
export type DeleteKioskAssetMutationResult = Apollo.MutationResult<DeleteKioskAssetMutation>;
export type DeleteKioskAssetMutationOptions = Apollo.BaseMutationOptions<DeleteKioskAssetMutation, DeleteKioskAssetMutationVariables>;
export const GenerateKioskAssetUploadSignedUrlDocument = gql`
    mutation generateKioskAssetUploadSignedUrl($input: KioskAssetUploadSignedUrlInput!) {
  generateKioskAssetUploadSignedUrl(input: $input) {
    signedUrl
    fields
    resourceUrl
  }
}
    `;
export type GenerateKioskAssetUploadSignedUrlMutationFn = Apollo.MutationFunction<GenerateKioskAssetUploadSignedUrlMutation, GenerateKioskAssetUploadSignedUrlMutationVariables>;

/**
 * __useGenerateKioskAssetUploadSignedUrlMutation__
 *
 * To run a mutation, you first call `useGenerateKioskAssetUploadSignedUrlMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useGenerateKioskAssetUploadSignedUrlMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [generateKioskAssetUploadSignedUrlMutation, { data, loading, error }] = useGenerateKioskAssetUploadSignedUrlMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGenerateKioskAssetUploadSignedUrlMutation(baseOptions?: Apollo.MutationHookOptions<GenerateKioskAssetUploadSignedUrlMutation, GenerateKioskAssetUploadSignedUrlMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GenerateKioskAssetUploadSignedUrlMutation, GenerateKioskAssetUploadSignedUrlMutationVariables>(GenerateKioskAssetUploadSignedUrlDocument, options);
      }
export type GenerateKioskAssetUploadSignedUrlMutationHookResult = ReturnType<typeof useGenerateKioskAssetUploadSignedUrlMutation>;
export type GenerateKioskAssetUploadSignedUrlMutationResult = Apollo.MutationResult<GenerateKioskAssetUploadSignedUrlMutation>;
export type GenerateKioskAssetUploadSignedUrlMutationOptions = Apollo.BaseMutationOptions<GenerateKioskAssetUploadSignedUrlMutation, GenerateKioskAssetUploadSignedUrlMutationVariables>;
export const CreateKioskDefaultScreenDocument = gql`
    mutation createKioskDefaultScreen($input: KioskDefaultScreenCreateInput!) {
  createKioskDefaultScreen(input: $input) {
    ...KioskDefaultScreen
  }
}
    ${KioskDefaultScreenFragmentDoc}`;
export type CreateKioskDefaultScreenMutationFn = Apollo.MutationFunction<CreateKioskDefaultScreenMutation, CreateKioskDefaultScreenMutationVariables>;

/**
 * __useCreateKioskDefaultScreenMutation__
 *
 * To run a mutation, you first call `useCreateKioskDefaultScreenMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateKioskDefaultScreenMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createKioskDefaultScreenMutation, { data, loading, error }] = useCreateKioskDefaultScreenMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateKioskDefaultScreenMutation(baseOptions?: Apollo.MutationHookOptions<CreateKioskDefaultScreenMutation, CreateKioskDefaultScreenMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateKioskDefaultScreenMutation, CreateKioskDefaultScreenMutationVariables>(CreateKioskDefaultScreenDocument, options);
      }
export type CreateKioskDefaultScreenMutationHookResult = ReturnType<typeof useCreateKioskDefaultScreenMutation>;
export type CreateKioskDefaultScreenMutationResult = Apollo.MutationResult<CreateKioskDefaultScreenMutation>;
export type CreateKioskDefaultScreenMutationOptions = Apollo.BaseMutationOptions<CreateKioskDefaultScreenMutation, CreateKioskDefaultScreenMutationVariables>;
export const UpdateKioskDefaultScreenDocument = gql`
    mutation updateKioskDefaultScreen($input: KioskDefaultScreenUpdateInput!) {
  updateKioskDefaultScreen(input: $input) {
    ...KioskDefaultScreen
  }
}
    ${KioskDefaultScreenFragmentDoc}`;
export type UpdateKioskDefaultScreenMutationFn = Apollo.MutationFunction<UpdateKioskDefaultScreenMutation, UpdateKioskDefaultScreenMutationVariables>;

/**
 * __useUpdateKioskDefaultScreenMutation__
 *
 * To run a mutation, you first call `useUpdateKioskDefaultScreenMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateKioskDefaultScreenMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateKioskDefaultScreenMutation, { data, loading, error }] = useUpdateKioskDefaultScreenMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateKioskDefaultScreenMutation(baseOptions?: Apollo.MutationHookOptions<UpdateKioskDefaultScreenMutation, UpdateKioskDefaultScreenMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateKioskDefaultScreenMutation, UpdateKioskDefaultScreenMutationVariables>(UpdateKioskDefaultScreenDocument, options);
      }
export type UpdateKioskDefaultScreenMutationHookResult = ReturnType<typeof useUpdateKioskDefaultScreenMutation>;
export type UpdateKioskDefaultScreenMutationResult = Apollo.MutationResult<UpdateKioskDefaultScreenMutation>;
export type UpdateKioskDefaultScreenMutationOptions = Apollo.BaseMutationOptions<UpdateKioskDefaultScreenMutation, UpdateKioskDefaultScreenMutationVariables>;
export const DeleteKioskDefaultScreenDocument = gql`
    mutation deleteKioskDefaultScreen($id: ID!) {
  deleteKioskDefaultScreen(id: $id)
}
    `;
export type DeleteKioskDefaultScreenMutationFn = Apollo.MutationFunction<DeleteKioskDefaultScreenMutation, DeleteKioskDefaultScreenMutationVariables>;

/**
 * __useDeleteKioskDefaultScreenMutation__
 *
 * To run a mutation, you first call `useDeleteKioskDefaultScreenMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteKioskDefaultScreenMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteKioskDefaultScreenMutation, { data, loading, error }] = useDeleteKioskDefaultScreenMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteKioskDefaultScreenMutation(baseOptions?: Apollo.MutationHookOptions<DeleteKioskDefaultScreenMutation, DeleteKioskDefaultScreenMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteKioskDefaultScreenMutation, DeleteKioskDefaultScreenMutationVariables>(DeleteKioskDefaultScreenDocument, options);
      }
export type DeleteKioskDefaultScreenMutationHookResult = ReturnType<typeof useDeleteKioskDefaultScreenMutation>;
export type DeleteKioskDefaultScreenMutationResult = Apollo.MutationResult<DeleteKioskDefaultScreenMutation>;
export type DeleteKioskDefaultScreenMutationOptions = Apollo.BaseMutationOptions<DeleteKioskDefaultScreenMutation, DeleteKioskDefaultScreenMutationVariables>;
export const KioskAdSetsDocument = gql`
    query kioskAdSets($first: Int, $last: Int, $after: OCBase64Cursor, $before: OCBase64Cursor, $filter: KioskAdSetFilter) {
  kioskAdSets(
    first: $first
    last: $last
    after: $after
    before: $before
    filter: $filter
  ) {
    pageInfo {
      ...pageInfo
    }
    edges {
      cursor
      node {
        ...KioskAdSet
      }
    }
  }
}
    ${PageInfoFragmentDoc}
${KioskAdSetFragmentDoc}`;

/**
 * __useKioskAdSetsQuery__
 *
 * To run a query within a React component, call `useKioskAdSetsQuery` and pass it any options that fit your needs.
 * When your component renders, `useKioskAdSetsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useKioskAdSetsQuery({
 *   variables: {
 *      first: // value for 'first'
 *      last: // value for 'last'
 *      after: // value for 'after'
 *      before: // value for 'before'
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useKioskAdSetsQuery(baseOptions?: Apollo.QueryHookOptions<KioskAdSetsQuery, KioskAdSetsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<KioskAdSetsQuery, KioskAdSetsQueryVariables>(KioskAdSetsDocument, options);
      }
export function useKioskAdSetsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<KioskAdSetsQuery, KioskAdSetsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<KioskAdSetsQuery, KioskAdSetsQueryVariables>(KioskAdSetsDocument, options);
        }
export function useKioskAdSetsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<KioskAdSetsQuery, KioskAdSetsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<KioskAdSetsQuery, KioskAdSetsQueryVariables>(KioskAdSetsDocument, options);
        }
export type KioskAdSetsQueryHookResult = ReturnType<typeof useKioskAdSetsQuery>;
export type KioskAdSetsLazyQueryHookResult = ReturnType<typeof useKioskAdSetsLazyQuery>;
export type KioskAdSetsSuspenseQueryHookResult = ReturnType<typeof useKioskAdSetsSuspenseQuery>;
export type KioskAdSetsQueryResult = Apollo.QueryResult<KioskAdSetsQuery, KioskAdSetsQueryVariables>;
export const KioskAdSetDocument = gql`
    query kioskAdSet($id: ID!) {
  kioskAdSet(id: $id) {
    ...KioskAdSet
  }
}
    ${KioskAdSetFragmentDoc}`;

/**
 * __useKioskAdSetQuery__
 *
 * To run a query within a React component, call `useKioskAdSetQuery` and pass it any options that fit your needs.
 * When your component renders, `useKioskAdSetQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useKioskAdSetQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useKioskAdSetQuery(baseOptions: Apollo.QueryHookOptions<KioskAdSetQuery, KioskAdSetQueryVariables> & ({ variables: KioskAdSetQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<KioskAdSetQuery, KioskAdSetQueryVariables>(KioskAdSetDocument, options);
      }
export function useKioskAdSetLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<KioskAdSetQuery, KioskAdSetQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<KioskAdSetQuery, KioskAdSetQueryVariables>(KioskAdSetDocument, options);
        }
export function useKioskAdSetSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<KioskAdSetQuery, KioskAdSetQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<KioskAdSetQuery, KioskAdSetQueryVariables>(KioskAdSetDocument, options);
        }
export type KioskAdSetQueryHookResult = ReturnType<typeof useKioskAdSetQuery>;
export type KioskAdSetLazyQueryHookResult = ReturnType<typeof useKioskAdSetLazyQuery>;
export type KioskAdSetSuspenseQueryHookResult = ReturnType<typeof useKioskAdSetSuspenseQuery>;
export type KioskAdSetQueryResult = Apollo.QueryResult<KioskAdSetQuery, KioskAdSetQueryVariables>;
export const KiosksDocument = gql`
    query kiosks($first: Int, $last: Int, $after: OCBase64Cursor, $before: OCBase64Cursor, $filter: KioskFilter) {
  kiosks(
    first: $first
    last: $last
    after: $after
    before: $before
    filter: $filter
  ) {
    pageInfo {
      ...pageInfo
    }
    edges {
      cursor
      node {
        ...Kiosk
      }
    }
  }
}
    ${PageInfoFragmentDoc}
${KioskFragmentDoc}`;

/**
 * __useKiosksQuery__
 *
 * To run a query within a React component, call `useKiosksQuery` and pass it any options that fit your needs.
 * When your component renders, `useKiosksQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useKiosksQuery({
 *   variables: {
 *      first: // value for 'first'
 *      last: // value for 'last'
 *      after: // value for 'after'
 *      before: // value for 'before'
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useKiosksQuery(baseOptions?: Apollo.QueryHookOptions<KiosksQuery, KiosksQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<KiosksQuery, KiosksQueryVariables>(KiosksDocument, options);
      }
export function useKiosksLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<KiosksQuery, KiosksQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<KiosksQuery, KiosksQueryVariables>(KiosksDocument, options);
        }
export function useKiosksSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<KiosksQuery, KiosksQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<KiosksQuery, KiosksQueryVariables>(KiosksDocument, options);
        }
export type KiosksQueryHookResult = ReturnType<typeof useKiosksQuery>;
export type KiosksLazyQueryHookResult = ReturnType<typeof useKiosksLazyQuery>;
export type KiosksSuspenseQueryHookResult = ReturnType<typeof useKiosksSuspenseQuery>;
export type KiosksQueryResult = Apollo.QueryResult<KiosksQuery, KiosksQueryVariables>;
export const KioskAssetsDocument = gql`
    query kioskAssets($first: Int, $last: Int, $after: OCBase64Cursor, $before: OCBase64Cursor, $filter: KioskAssetFilter) {
  kioskAssets(
    first: $first
    last: $last
    after: $after
    before: $before
    filter: $filter
  ) {
    pageInfo {
      ...pageInfo
    }
    edges {
      cursor
      node {
        ...KioskAsset
      }
    }
  }
}
    ${PageInfoFragmentDoc}
${KioskAssetFragmentDoc}`;

/**
 * __useKioskAssetsQuery__
 *
 * To run a query within a React component, call `useKioskAssetsQuery` and pass it any options that fit your needs.
 * When your component renders, `useKioskAssetsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useKioskAssetsQuery({
 *   variables: {
 *      first: // value for 'first'
 *      last: // value for 'last'
 *      after: // value for 'after'
 *      before: // value for 'before'
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useKioskAssetsQuery(baseOptions?: Apollo.QueryHookOptions<KioskAssetsQuery, KioskAssetsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<KioskAssetsQuery, KioskAssetsQueryVariables>(KioskAssetsDocument, options);
      }
export function useKioskAssetsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<KioskAssetsQuery, KioskAssetsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<KioskAssetsQuery, KioskAssetsQueryVariables>(KioskAssetsDocument, options);
        }
export function useKioskAssetsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<KioskAssetsQuery, KioskAssetsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<KioskAssetsQuery, KioskAssetsQueryVariables>(KioskAssetsDocument, options);
        }
export type KioskAssetsQueryHookResult = ReturnType<typeof useKioskAssetsQuery>;
export type KioskAssetsLazyQueryHookResult = ReturnType<typeof useKioskAssetsLazyQuery>;
export type KioskAssetsSuspenseQueryHookResult = ReturnType<typeof useKioskAssetsSuspenseQuery>;
export type KioskAssetsQueryResult = Apollo.QueryResult<KioskAssetsQuery, KioskAssetsQueryVariables>;
export const KioskAssetDocument = gql`
    query kioskAsset($id: ID!) {
  kioskAsset(id: $id) {
    ...KioskAsset
  }
}
    ${KioskAssetFragmentDoc}`;

/**
 * __useKioskAssetQuery__
 *
 * To run a query within a React component, call `useKioskAssetQuery` and pass it any options that fit your needs.
 * When your component renders, `useKioskAssetQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useKioskAssetQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useKioskAssetQuery(baseOptions: Apollo.QueryHookOptions<KioskAssetQuery, KioskAssetQueryVariables> & ({ variables: KioskAssetQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<KioskAssetQuery, KioskAssetQueryVariables>(KioskAssetDocument, options);
      }
export function useKioskAssetLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<KioskAssetQuery, KioskAssetQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<KioskAssetQuery, KioskAssetQueryVariables>(KioskAssetDocument, options);
        }
export function useKioskAssetSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<KioskAssetQuery, KioskAssetQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<KioskAssetQuery, KioskAssetQueryVariables>(KioskAssetDocument, options);
        }
export type KioskAssetQueryHookResult = ReturnType<typeof useKioskAssetQuery>;
export type KioskAssetLazyQueryHookResult = ReturnType<typeof useKioskAssetLazyQuery>;
export type KioskAssetSuspenseQueryHookResult = ReturnType<typeof useKioskAssetSuspenseQuery>;
export type KioskAssetQueryResult = Apollo.QueryResult<KioskAssetQuery, KioskAssetQueryVariables>;
export const KioskDefaultScreensDocument = gql`
    query kioskDefaultScreens($first: Int, $last: Int, $after: OCBase64Cursor, $before: OCBase64Cursor, $filter: KioskDefaultScreenFilter) {
  kioskDefaultScreens(
    first: $first
    last: $last
    after: $after
    before: $before
    filter: $filter
  ) {
    pageInfo {
      ...pageInfo
    }
    edges {
      cursor
      node {
        ...KioskDefaultScreen
      }
    }
  }
}
    ${PageInfoFragmentDoc}
${KioskDefaultScreenFragmentDoc}`;

/**
 * __useKioskDefaultScreensQuery__
 *
 * To run a query within a React component, call `useKioskDefaultScreensQuery` and pass it any options that fit your needs.
 * When your component renders, `useKioskDefaultScreensQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useKioskDefaultScreensQuery({
 *   variables: {
 *      first: // value for 'first'
 *      last: // value for 'last'
 *      after: // value for 'after'
 *      before: // value for 'before'
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useKioskDefaultScreensQuery(baseOptions?: Apollo.QueryHookOptions<KioskDefaultScreensQuery, KioskDefaultScreensQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<KioskDefaultScreensQuery, KioskDefaultScreensQueryVariables>(KioskDefaultScreensDocument, options);
      }
export function useKioskDefaultScreensLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<KioskDefaultScreensQuery, KioskDefaultScreensQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<KioskDefaultScreensQuery, KioskDefaultScreensQueryVariables>(KioskDefaultScreensDocument, options);
        }
export function useKioskDefaultScreensSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<KioskDefaultScreensQuery, KioskDefaultScreensQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<KioskDefaultScreensQuery, KioskDefaultScreensQueryVariables>(KioskDefaultScreensDocument, options);
        }
export type KioskDefaultScreensQueryHookResult = ReturnType<typeof useKioskDefaultScreensQuery>;
export type KioskDefaultScreensLazyQueryHookResult = ReturnType<typeof useKioskDefaultScreensLazyQuery>;
export type KioskDefaultScreensSuspenseQueryHookResult = ReturnType<typeof useKioskDefaultScreensSuspenseQuery>;
export type KioskDefaultScreensQueryResult = Apollo.QueryResult<KioskDefaultScreensQuery, KioskDefaultScreensQueryVariables>;
export const KioskDefaultScreenDocument = gql`
    query kioskDefaultScreen($id: ID!) {
  kioskDefaultScreen(id: $id) {
    ...KioskDefaultScreen
  }
}
    ${KioskDefaultScreenFragmentDoc}`;

/**
 * __useKioskDefaultScreenQuery__
 *
 * To run a query within a React component, call `useKioskDefaultScreenQuery` and pass it any options that fit your needs.
 * When your component renders, `useKioskDefaultScreenQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useKioskDefaultScreenQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useKioskDefaultScreenQuery(baseOptions: Apollo.QueryHookOptions<KioskDefaultScreenQuery, KioskDefaultScreenQueryVariables> & ({ variables: KioskDefaultScreenQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<KioskDefaultScreenQuery, KioskDefaultScreenQueryVariables>(KioskDefaultScreenDocument, options);
      }
export function useKioskDefaultScreenLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<KioskDefaultScreenQuery, KioskDefaultScreenQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<KioskDefaultScreenQuery, KioskDefaultScreenQueryVariables>(KioskDefaultScreenDocument, options);
        }
export function useKioskDefaultScreenSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<KioskDefaultScreenQuery, KioskDefaultScreenQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<KioskDefaultScreenQuery, KioskDefaultScreenQueryVariables>(KioskDefaultScreenDocument, options);
        }
export type KioskDefaultScreenQueryHookResult = ReturnType<typeof useKioskDefaultScreenQuery>;
export type KioskDefaultScreenLazyQueryHookResult = ReturnType<typeof useKioskDefaultScreenLazyQuery>;
export type KioskDefaultScreenSuspenseQueryHookResult = ReturnType<typeof useKioskDefaultScreenSuspenseQuery>;
export type KioskDefaultScreenQueryResult = Apollo.QueryResult<KioskDefaultScreenQuery, KioskDefaultScreenQueryVariables>;
export const UpdateTriggeredMessageDocument = gql`
    mutation updateTriggeredMessage($input: UpdateTriggeredMessageInput!) {
  message: updateTriggeredMessage(input: $input) {
    ...TriggeredMessageView
  }
}
    ${TriggeredMessageViewFragmentDoc}`;
export type UpdateTriggeredMessageMutationFn = Apollo.MutationFunction<UpdateTriggeredMessageMutation, UpdateTriggeredMessageMutationVariables>;

/**
 * __useUpdateTriggeredMessageMutation__
 *
 * To run a mutation, you first call `useUpdateTriggeredMessageMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateTriggeredMessageMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateTriggeredMessageMutation, { data, loading, error }] = useUpdateTriggeredMessageMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateTriggeredMessageMutation(baseOptions?: Apollo.MutationHookOptions<UpdateTriggeredMessageMutation, UpdateTriggeredMessageMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateTriggeredMessageMutation, UpdateTriggeredMessageMutationVariables>(UpdateTriggeredMessageDocument, options);
      }
export type UpdateTriggeredMessageMutationHookResult = ReturnType<typeof useUpdateTriggeredMessageMutation>;
export type UpdateTriggeredMessageMutationResult = Apollo.MutationResult<UpdateTriggeredMessageMutation>;
export type UpdateTriggeredMessageMutationOptions = Apollo.BaseMutationOptions<UpdateTriggeredMessageMutation, UpdateTriggeredMessageMutationVariables>;
export const UpdateTriggeredMessageStatusDocument = gql`
    mutation updateTriggeredMessageStatus($input: UpdateTriggeredMessageStatusInput!) {
  updateTriggeredMessageStatus(input: $input) {
    ...TriggeredMessageView
  }
}
    ${TriggeredMessageViewFragmentDoc}`;
export type UpdateTriggeredMessageStatusMutationFn = Apollo.MutationFunction<UpdateTriggeredMessageStatusMutation, UpdateTriggeredMessageStatusMutationVariables>;

/**
 * __useUpdateTriggeredMessageStatusMutation__
 *
 * To run a mutation, you first call `useUpdateTriggeredMessageStatusMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateTriggeredMessageStatusMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateTriggeredMessageStatusMutation, { data, loading, error }] = useUpdateTriggeredMessageStatusMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateTriggeredMessageStatusMutation(baseOptions?: Apollo.MutationHookOptions<UpdateTriggeredMessageStatusMutation, UpdateTriggeredMessageStatusMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateTriggeredMessageStatusMutation, UpdateTriggeredMessageStatusMutationVariables>(UpdateTriggeredMessageStatusDocument, options);
      }
export type UpdateTriggeredMessageStatusMutationHookResult = ReturnType<typeof useUpdateTriggeredMessageStatusMutation>;
export type UpdateTriggeredMessageStatusMutationResult = Apollo.MutationResult<UpdateTriggeredMessageStatusMutation>;
export type UpdateTriggeredMessageStatusMutationOptions = Apollo.BaseMutationOptions<UpdateTriggeredMessageStatusMutation, UpdateTriggeredMessageStatusMutationVariables>;
export const TriggeredMessageDocument = gql`
    query triggeredMessage($uuid: OCUUID!) {
  triggeredMessage: triggeredMessage(uuid: $uuid) {
    ...TriggeredMessageView
  }
}
    ${TriggeredMessageViewFragmentDoc}`;

/**
 * __useTriggeredMessageQuery__
 *
 * To run a query within a React component, call `useTriggeredMessageQuery` and pass it any options that fit your needs.
 * When your component renders, `useTriggeredMessageQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTriggeredMessageQuery({
 *   variables: {
 *      uuid: // value for 'uuid'
 *   },
 * });
 */
export function useTriggeredMessageQuery(baseOptions: Apollo.QueryHookOptions<TriggeredMessageQuery, TriggeredMessageQueryVariables> & ({ variables: TriggeredMessageQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<TriggeredMessageQuery, TriggeredMessageQueryVariables>(TriggeredMessageDocument, options);
      }
export function useTriggeredMessageLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<TriggeredMessageQuery, TriggeredMessageQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<TriggeredMessageQuery, TriggeredMessageQueryVariables>(TriggeredMessageDocument, options);
        }
export function useTriggeredMessageSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<TriggeredMessageQuery, TriggeredMessageQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<TriggeredMessageQuery, TriggeredMessageQueryVariables>(TriggeredMessageDocument, options);
        }
export type TriggeredMessageQueryHookResult = ReturnType<typeof useTriggeredMessageQuery>;
export type TriggeredMessageLazyQueryHookResult = ReturnType<typeof useTriggeredMessageLazyQuery>;
export type TriggeredMessageSuspenseQueryHookResult = ReturnType<typeof useTriggeredMessageSuspenseQuery>;
export type TriggeredMessageQueryResult = Apollo.QueryResult<TriggeredMessageQuery, TriggeredMessageQueryVariables>;
export const TriggeredMessagesListDocument = gql`
    query triggeredMessagesList($first: Int, $last: Int, $after: ID, $before: ID, $filter: TriggeredMessagesFilter) {
  triggeredMessagesList: triggeredMessages(
    first: $first
    last: $last
    after: $after
    before: $before
    filter: $filter
  ) {
    pageInfo {
      ...pageInfo
    }
    edges {
      cursor
      node {
        ...TriggeredMessageListItem
      }
    }
  }
}
    ${PageInfoFragmentDoc}
${TriggeredMessageListItemFragmentDoc}`;

/**
 * __useTriggeredMessagesListQuery__
 *
 * To run a query within a React component, call `useTriggeredMessagesListQuery` and pass it any options that fit your needs.
 * When your component renders, `useTriggeredMessagesListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTriggeredMessagesListQuery({
 *   variables: {
 *      first: // value for 'first'
 *      last: // value for 'last'
 *      after: // value for 'after'
 *      before: // value for 'before'
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useTriggeredMessagesListQuery(baseOptions?: Apollo.QueryHookOptions<TriggeredMessagesListQuery, TriggeredMessagesListQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<TriggeredMessagesListQuery, TriggeredMessagesListQueryVariables>(TriggeredMessagesListDocument, options);
      }
export function useTriggeredMessagesListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<TriggeredMessagesListQuery, TriggeredMessagesListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<TriggeredMessagesListQuery, TriggeredMessagesListQueryVariables>(TriggeredMessagesListDocument, options);
        }
export function useTriggeredMessagesListSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<TriggeredMessagesListQuery, TriggeredMessagesListQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<TriggeredMessagesListQuery, TriggeredMessagesListQueryVariables>(TriggeredMessagesListDocument, options);
        }
export type TriggeredMessagesListQueryHookResult = ReturnType<typeof useTriggeredMessagesListQuery>;
export type TriggeredMessagesListLazyQueryHookResult = ReturnType<typeof useTriggeredMessagesListLazyQuery>;
export type TriggeredMessagesListSuspenseQueryHookResult = ReturnType<typeof useTriggeredMessagesListSuspenseQuery>;
export type TriggeredMessagesListQueryResult = Apollo.QueryResult<TriggeredMessagesListQuery, TriggeredMessagesListQueryVariables>;